/*! For license information please see shui.min.js.LICENSE.txt */
var ShuiEnvironment;!function(){"use strict";var e={d:function(t,o){for(var i in o)e.o(o,i)&&!e.o(t,i)&&Object.defineProperty(t,i,{enumerable:!0,get:o[i]})},o:function(e,t){return Object.prototype.hasOwnProperty.call(e,t)}},t={};!function(){e.d(t,{ShuiEnvironmentLegacy:function(){return ur}});const o="undefined"!=typeof window&&null!=window.customElements&&void 0!==window.customElements.polyfillWrapFlushCallback,i=(e,t,o=null)=>{for(;t!==o;){const o=t.nextSibling;e.removeChild(t),t=o}},r=`{{lit-${String(Math.random()).slice(2)}}}`,s=`\x3c!--${r}--\x3e`,n=new RegExp(`${r}|${s}`),a="$lit$";class c{constructor(e,t){this.parts=[],this.element=t;const o=[],i=[],s=document.createTreeWalker(t.content,133,null,!1);let c=0,h=-1,u=0;const{strings:m,values:{length:f}}=e;for(;u<f;){const e=s.nextNode();if(null!==e){if(h++,1===e.nodeType){if(e.hasAttributes()){const t=e.attributes,{length:o}=t;let i=0;for(let e=0;e<o;e++)l(t[e].name,a)&&i++;for(;i-- >0;){const t=m[u],o=p.exec(t)[2],i=o.toLowerCase()+a,r=e.getAttribute(i);e.removeAttribute(i);const s=r.split(n);this.parts.push({type:"attribute",index:h,name:o,strings:s}),u+=s.length-1}}"TEMPLATE"===e.tagName&&(i.push(e),s.currentNode=e.content)}else if(3===e.nodeType){const t=e.data;if(t.indexOf(r)>=0){const i=e.parentNode,r=t.split(n),s=r.length-1;for(let t=0;t<s;t++){let o,s=r[t];if(""===s)o=d();else{const e=p.exec(s);null!==e&&l(e[2],a)&&(s=s.slice(0,e.index)+e[1]+e[2].slice(0,-a.length)+e[3]),o=document.createTextNode(s)}i.insertBefore(o,e),this.parts.push({type:"node",index:++h})}""===r[s]?(i.insertBefore(d(),e),o.push(e)):e.data=r[s],u+=s}}else if(8===e.nodeType)if(e.data===r){const t=e.parentNode;null!==e.previousSibling&&h!==c||(h++,t.insertBefore(d(),e)),c=h,this.parts.push({type:"node",index:h}),null===e.nextSibling?e.data="":(o.push(e),h--),u++}else{let t=-1;for(;-1!==(t=e.data.indexOf(r,t+1));)this.parts.push({type:"node",index:-1}),u++}}else s.currentNode=i.pop()}for(const e of o)e.parentNode.removeChild(e)}}const l=(e,t)=>{const o=e.length-t.length;return o>=0&&e.slice(o)===t},h=e=>-1!==e.index,d=()=>document.createComment(""),p=/([ \x09\x0a\x0c\x0d])([^\0-\x1F\x7F-\x9F "'>=/]+)([ \x09\x0a\x0c\x0d]*=[ \x09\x0a\x0c\x0d]*(?:[^ \x09\x0a\x0c\x0d"'`<>=]*|"[^"]*|'[^']*))$/;function u(e,t){const{element:{content:o},parts:i}=e,r=document.createTreeWalker(o,133,null,!1);let s=f(i),n=i[s],a=-1,c=0;const l=[];let h=null;for(;r.nextNode();){a++;const e=r.currentNode;for(e.previousSibling===h&&(h=null),t.has(e)&&(l.push(e),null===h&&(h=e)),null!==h&&c++;void 0!==n&&n.index===a;)n.index=null!==h?-1:n.index-c,s=f(i,s),n=i[s]}l.forEach((e=>e.parentNode.removeChild(e)))}const m=e=>{let t=11===e.nodeType?0:1;const o=document.createTreeWalker(e,133,null,!1);for(;o.nextNode();)t++;return t},f=(e,t=-1)=>{for(let o=t+1;o<e.length;o++){const t=e[o];if(h(t))return o}return-1},g=new WeakMap,b=e=>(...t)=>{const o=e(...t);return g.set(o,!0),o},v=e=>"function"==typeof e&&g.has(e),y={},w={};class x{constructor(e,t,o){this.__parts=[],this.template=e,this.processor=t,this.options=o}update(e){let t=0;for(const o of this.__parts)void 0!==o&&o.setValue(e[t]),t++;for(const e of this.__parts)void 0!==e&&e.commit()}_clone(){const e=o?this.template.element.content.cloneNode(!0):document.importNode(this.template.element.content,!0),t=[],i=this.template.parts,r=document.createTreeWalker(e,133,null,!1);let s,n=0,a=0,c=r.nextNode();for(;n<i.length;)if(s=i[n],h(s)){for(;a<s.index;)a++,"TEMPLATE"===c.nodeName&&(t.push(c),r.currentNode=c.content),null===(c=r.nextNode())&&(r.currentNode=t.pop(),c=r.nextNode());if("node"===s.type){const e=this.processor.handleTextExpression(this.options);e.insertAfterNode(c.previousSibling),this.__parts.push(e)}else this.__parts.push(...this.processor.handleAttributeExpressions(c,s.name,s.strings,this.options));n++}else this.__parts.push(void 0),n++;return o&&(document.adoptNode(e),customElements.upgrade(e)),e}}const _=window.trustedTypes&&trustedTypes.createPolicy("lit-html",{createHTML:e=>e}),k=` ${r} `;class C{constructor(e,t,o,i){this.strings=e,this.values=t,this.type=o,this.processor=i}getHTML(){const e=this.strings.length-1;let t="",o=!1;for(let i=0;i<e;i++){const e=this.strings[i],n=e.lastIndexOf("\x3c!--");o=(n>-1||o)&&-1===e.indexOf("--\x3e",n+1);const c=p.exec(e);t+=null===c?e+(o?k:s):e.substr(0,c.index)+c[1]+c[2]+a+c[3]+r}return t+=this.strings[e],t}getTemplateElement(){const e=document.createElement("template");let t=this.getHTML();return void 0!==_&&(t=_.createHTML(t)),e.innerHTML=t,e}}class E extends C{getHTML(){return`<svg>${super.getHTML()}</svg>`}getTemplateElement(){const e=super.getTemplateElement(),t=e.content,o=t.firstChild;return t.removeChild(o),((e,t,o=null,i=null)=>{for(;t!==o;){const o=t.nextSibling;e.insertBefore(t,i),t=o}})(t,o.firstChild),e}}const z=e=>null===e||!("object"==typeof e||"function"==typeof e),A=e=>Array.isArray(e)||!(!e||!e[Symbol.iterator]);class S{constructor(e,t,o){this.dirty=!0,this.element=e,this.name=t,this.strings=o,this.parts=[];for(let e=0;e<o.length-1;e++)this.parts[e]=this._createPart()}_createPart(){return new M(this)}_getValue(){const e=this.strings,t=e.length-1,o=this.parts;if(1===t&&""===e[0]&&""===e[1]){const e=o[0].value;if("symbol"==typeof e)return String(e);if("string"==typeof e||!A(e))return e}let i="";for(let r=0;r<t;r++){i+=e[r];const t=o[r];if(void 0!==t){const e=t.value;if(z(e)||!A(e))i+="string"==typeof e?e:String(e);else for(const t of e)i+="string"==typeof t?t:String(t)}}return i+=e[t],i}commit(){this.dirty&&(this.dirty=!1,this.element.setAttribute(this.name,this._getValue()))}}class M{constructor(e){this.value=void 0,this.committer=e}setValue(e){e===y||z(e)&&e===this.value||(this.value=e,v(e)||(this.committer.dirty=!0))}commit(){for(;v(this.value);){const e=this.value;this.value=y,e(this)}this.value!==y&&this.committer.commit()}}class D{constructor(e){this.value=void 0,this.__pendingValue=void 0,this.options=e}appendInto(e){this.startNode=e.appendChild(d()),this.endNode=e.appendChild(d())}insertAfterNode(e){this.startNode=e,this.endNode=e.nextSibling}appendIntoPart(e){e.__insert(this.startNode=d()),e.__insert(this.endNode=d())}insertAfterPart(e){e.__insert(this.startNode=d()),this.endNode=e.endNode,e.endNode=this.startNode}setValue(e){this.__pendingValue=e}commit(){if(null===this.startNode.parentNode)return;for(;v(this.__pendingValue);){const e=this.__pendingValue;this.__pendingValue=y,e(this)}const e=this.__pendingValue;e!==y&&(z(e)?e!==this.value&&this.__commitText(e):e instanceof C?this.__commitTemplateResult(e):e instanceof Node?this.__commitNode(e):A(e)?this.__commitIterable(e):e===w?(this.value=w,this.clear()):this.__commitText(e))}__insert(e){this.endNode.parentNode.insertBefore(e,this.endNode)}__commitNode(e){this.value!==e&&(this.clear(),this.__insert(e),this.value=e)}__commitText(e){const t=this.startNode.nextSibling,o="string"==typeof(e=null==e?"":e)?e:String(e);t===this.endNode.previousSibling&&3===t.nodeType?t.data=o:this.__commitNode(document.createTextNode(o)),this.value=e}__commitTemplateResult(e){const t=this.options.templateFactory(e);if(this.value instanceof x&&this.value.template===t)this.value.update(e.values);else{const o=new x(t,e.processor,this.options),i=o._clone();o.update(e.values),this.__commitNode(i),this.value=o}}__commitIterable(e){Array.isArray(this.value)||(this.value=[],this.clear());const t=this.value;let o,i=0;for(const r of e)o=t[i],void 0===o&&(o=new D(this.options),t.push(o),0===i?o.appendIntoPart(this):o.insertAfterPart(t[i-1])),o.setValue(r),o.commit(),i++;i<t.length&&(t.length=i,this.clear(o&&o.endNode))}clear(e=this.startNode){i(this.startNode.parentNode,e.nextSibling,this.endNode)}}class B{constructor(e,t,o){if(this.value=void 0,this.__pendingValue=void 0,2!==o.length||""!==o[0]||""!==o[1])throw new Error("Boolean attributes can only contain a single expression");this.element=e,this.name=t,this.strings=o}setValue(e){this.__pendingValue=e}commit(){for(;v(this.__pendingValue);){const e=this.__pendingValue;this.__pendingValue=y,e(this)}if(this.__pendingValue===y)return;const e=!!this.__pendingValue;this.value!==e&&(e?this.element.setAttribute(this.name,""):this.element.removeAttribute(this.name),this.value=e),this.__pendingValue=y}}class T extends S{constructor(e,t,o){super(e,t,o),this.single=2===o.length&&""===o[0]&&""===o[1]}_createPart(){return new R(this)}_getValue(){return this.single?this.parts[0].value:super._getValue()}commit(){this.dirty&&(this.dirty=!1,this.element[this.name]=this._getValue())}}class R extends M{}let L=!1;(()=>{try{const e={get capture(){return L=!0,!1}};window.addEventListener("test",e,e),window.removeEventListener("test",e,e)}catch(e){}})();class P{constructor(e,t,o){this.value=void 0,this.__pendingValue=void 0,this.element=e,this.eventName=t,this.eventContext=o,this.__boundHandleEvent=e=>this.handleEvent(e)}setValue(e){this.__pendingValue=e}commit(){for(;v(this.__pendingValue);){const e=this.__pendingValue;this.__pendingValue=y,e(this)}if(this.__pendingValue===y)return;const e=this.__pendingValue,t=this.value,o=null==e||null!=t&&(e.capture!==t.capture||e.once!==t.once||e.passive!==t.passive),i=null!=e&&(null==t||o);o&&this.element.removeEventListener(this.eventName,this.__boundHandleEvent,this.__options),i&&(this.__options=O(e),this.element.addEventListener(this.eventName,this.__boundHandleEvent,this.__options)),this.value=e,this.__pendingValue=y}handleEvent(e){"function"==typeof this.value?this.value.call(this.eventContext||this.element,e):this.value.handleEvent(e)}}const O=e=>e&&(L?{capture:e.capture,passive:e.passive,once:e.once}:e.capture);function N(e){let t=F.get(e.type);void 0===t&&(t={stringsArray:new WeakMap,keyString:new Map},F.set(e.type,t));let o=t.stringsArray.get(e.strings);if(void 0!==o)return o;const i=e.strings.join(r);return o=t.keyString.get(i),void 0===o&&(o=new c(e,e.getTemplateElement()),t.keyString.set(i,o)),t.stringsArray.set(e.strings,o),o}const F=new Map,$=new WeakMap,I=new class{handleAttributeExpressions(e,t,o,i){const r=t[0];return"."===r?new T(e,t.slice(1),o).parts:"@"===r?[new P(e,t.slice(1),i.eventContext)]:"?"===r?[new B(e,t.slice(1),o)]:new S(e,t,o).parts}handleTextExpression(e){return new D(e)}};"undefined"!=typeof window&&(window.litHtmlVersions||(window.litHtmlVersions=[])).push("1.4.1");const V=(e,...t)=>new C(e,t,"html",I),H=(e,...t)=>new E(e,t,"svg",I),W=(e,t)=>`${e}--${t}`;let q=!0;void 0===window.ShadyCSS?q=!1:void 0===window.ShadyCSS.prepareTemplateDom&&(console.warn("Incompatible ShadyCSS version detected. Please update to at least @webcomponents/webcomponentsjs@2.0.2 and @webcomponents/shadycss@1.3.1."),q=!1);const Y=e=>t=>{const o=W(t.type,e);let i=F.get(o);void 0===i&&(i={stringsArray:new WeakMap,keyString:new Map},F.set(o,i));let s=i.stringsArray.get(t.strings);if(void 0!==s)return s;const n=t.strings.join(r);if(s=i.keyString.get(n),void 0===s){const o=t.getTemplateElement();q&&window.ShadyCSS.prepareTemplateDom(o,e),s=new c(t,o),i.keyString.set(n,s)}return i.stringsArray.set(t.strings,s),s},j=["html","svg"],U=new Set;window.JSCompiler_renameProperty=(e,t)=>e;const Z={toAttribute(e,t){switch(t){case Boolean:return e?"":null;case Object:case Array:return null==e?e:JSON.stringify(e)}return e},fromAttribute(e,t){switch(t){case Boolean:return null!==e;case Number:return null===e?null:Number(e);case Object:case Array:return JSON.parse(e)}return e}},K=(e,t)=>t!==e&&(t==t||e==e),G={attribute:!0,type:String,converter:Z,reflect:!1,hasChanged:K};class X extends HTMLElement{constructor(){super(),this.initialize()}static get observedAttributes(){this.finalize();const e=[];return this._classProperties.forEach(((t,o)=>{const i=this._attributeNameForProperty(o,t);void 0!==i&&(this._attributeToPropertyMap.set(i,o),e.push(i))})),e}static _ensureClassProperties(){if(!this.hasOwnProperty(JSCompiler_renameProperty("_classProperties",this))){this._classProperties=new Map;const e=Object.getPrototypeOf(this)._classProperties;void 0!==e&&e.forEach(((e,t)=>this._classProperties.set(t,e)))}}static createProperty(e,t=G){if(this._ensureClassProperties(),this._classProperties.set(e,t),t.noAccessor||this.prototype.hasOwnProperty(e))return;const o="symbol"==typeof e?Symbol():`__${e}`,i=this.getPropertyDescriptor(e,o,t);void 0!==i&&Object.defineProperty(this.prototype,e,i)}static getPropertyDescriptor(e,t,o){return{get(){return this[t]},set(i){const r=this[e];this[t]=i,this.requestUpdateInternal(e,r,o)},configurable:!0,enumerable:!0}}static getPropertyOptions(e){return this._classProperties&&this._classProperties.get(e)||G}static finalize(){const e=Object.getPrototypeOf(this);if(e.hasOwnProperty("finalized")||e.finalize(),this.finalized=!0,this._ensureClassProperties(),this._attributeToPropertyMap=new Map,this.hasOwnProperty(JSCompiler_renameProperty("properties",this))){const e=this.properties,t=[...Object.getOwnPropertyNames(e),..."function"==typeof Object.getOwnPropertySymbols?Object.getOwnPropertySymbols(e):[]];for(const o of t)this.createProperty(o,e[o])}}static _attributeNameForProperty(e,t){const o=t.attribute;return!1===o?void 0:"string"==typeof o?o:"string"==typeof e?e.toLowerCase():void 0}static _valueHasChanged(e,t,o=K){return o(e,t)}static _propertyValueFromAttribute(e,t){const o=t.type,i=t.converter||Z,r="function"==typeof i?i:i.fromAttribute;return r?r(e,o):e}static _propertyValueToAttribute(e,t){if(void 0===t.reflect)return;const o=t.type,i=t.converter;return(i&&i.toAttribute||Z.toAttribute)(e,o)}initialize(){this._updateState=0,this._updatePromise=new Promise((e=>this._enableUpdatingResolver=e)),this._changedProperties=new Map,this._saveInstanceProperties(),this.requestUpdateInternal()}_saveInstanceProperties(){this.constructor._classProperties.forEach(((e,t)=>{if(this.hasOwnProperty(t)){const e=this[t];delete this[t],this._instanceProperties||(this._instanceProperties=new Map),this._instanceProperties.set(t,e)}}))}_applyInstanceProperties(){this._instanceProperties.forEach(((e,t)=>this[t]=e)),this._instanceProperties=void 0}connectedCallback(){this.enableUpdating()}enableUpdating(){void 0!==this._enableUpdatingResolver&&(this._enableUpdatingResolver(),this._enableUpdatingResolver=void 0)}disconnectedCallback(){}attributeChangedCallback(e,t,o){t!==o&&this._attributeToProperty(e,o)}_propertyToAttribute(e,t,o=G){const i=this.constructor,r=i._attributeNameForProperty(e,o);if(void 0!==r){const e=i._propertyValueToAttribute(t,o);if(void 0===e)return;this._updateState=8|this._updateState,null==e?this.removeAttribute(r):this.setAttribute(r,e),this._updateState=-9&this._updateState}}_attributeToProperty(e,t){if(8&this._updateState)return;const o=this.constructor,i=o._attributeToPropertyMap.get(e);if(void 0!==i){const e=o.getPropertyOptions(i);this._updateState=16|this._updateState,this[i]=o._propertyValueFromAttribute(t,e),this._updateState=-17&this._updateState}}requestUpdateInternal(e,t,o){let i=!0;if(void 0!==e){const r=this.constructor;o=o||r.getPropertyOptions(e),r._valueHasChanged(this[e],t,o.hasChanged)?(this._changedProperties.has(e)||this._changedProperties.set(e,t),!0!==o.reflect||16&this._updateState||(void 0===this._reflectingProperties&&(this._reflectingProperties=new Map),this._reflectingProperties.set(e,o))):i=!1}!this._hasRequestedUpdate&&i&&(this._updatePromise=this._enqueueUpdate())}requestUpdate(e,t){return this.requestUpdateInternal(e,t),this.updateComplete}async _enqueueUpdate(){this._updateState=4|this._updateState;try{await this._updatePromise}catch(e){}const e=this.performUpdate();return null!=e&&await e,!this._hasRequestedUpdate}get _hasRequestedUpdate(){return 4&this._updateState}get hasUpdated(){return 1&this._updateState}performUpdate(){if(!this._hasRequestedUpdate)return;this._instanceProperties&&this._applyInstanceProperties();let e=!1;const t=this._changedProperties;try{e=this.shouldUpdate(t),e?this.update(t):this._markUpdated()}catch(t){throw e=!1,this._markUpdated(),t}e&&(1&this._updateState||(this._updateState=1|this._updateState,this.firstUpdated(t)),this.updated(t))}_markUpdated(){this._changedProperties=new Map,this._updateState=-5&this._updateState}get updateComplete(){return this._getUpdateComplete()}_getUpdateComplete(){return this.getUpdateComplete()}getUpdateComplete(){return this._updatePromise}shouldUpdate(e){return!0}update(e){void 0!==this._reflectingProperties&&this._reflectingProperties.size>0&&(this._reflectingProperties.forEach(((e,t)=>this._propertyToAttribute(t,this[t],e))),this._reflectingProperties=void 0),this._markUpdated()}updated(e){}firstUpdated(e){}}X.finalized=!0;const J=Element.prototype;J.msMatchesSelector||J.webkitMatchesSelector;const Q=window.ShadowRoot&&(void 0===window.ShadyCSS||window.ShadyCSS.nativeShadow)&&"adoptedStyleSheets"in Document.prototype&&"replace"in CSSStyleSheet.prototype,ee=Symbol();class te{constructor(e,t){if(t!==ee)throw new Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");this.cssText=e}get styleSheet(){return void 0===this._styleSheet&&(Q?(this._styleSheet=new CSSStyleSheet,this._styleSheet.replaceSync(this.cssText)):this._styleSheet=null),this._styleSheet}toString(){return this.cssText}}const oe=e=>new te(String(e),ee),ie=(e,...t)=>{const o=t.reduce(((t,o,i)=>t+(e=>{if(e instanceof te)return e.cssText;if("number"==typeof e)return e;throw new Error(`Value passed to 'css' function must be a 'css' function result: ${e}. Use 'unsafeCSS' to pass non-literal values, but\n            take care to ensure page security.`)})(o)+e[i+1]),e[0]);return new te(o,ee)};(window.litElementVersions||(window.litElementVersions=[])).push("2.5.1");const re={};class se extends X{static getStyles(){return this.styles}static _getUniqueStyles(){if(this.hasOwnProperty(JSCompiler_renameProperty("_styles",this)))return;const e=this.getStyles();if(Array.isArray(e)){const t=(e,o)=>e.reduceRight(((e,o)=>Array.isArray(o)?t(o,e):(e.add(o),e)),o),o=t(e,new Set),i=[];o.forEach((e=>i.unshift(e))),this._styles=i}else this._styles=void 0===e?[]:[e];this._styles=this._styles.map((e=>{if(e instanceof CSSStyleSheet&&!Q){const t=Array.prototype.slice.call(e.cssRules).reduce(((e,t)=>e+t.cssText),"");return oe(t)}return e}))}initialize(){super.initialize(),this.constructor._getUniqueStyles(),this.renderRoot=this.createRenderRoot(),window.ShadowRoot&&this.renderRoot instanceof window.ShadowRoot&&this.adoptStyles()}createRenderRoot(){return this.attachShadow(this.constructor.shadowRootOptions)}adoptStyles(){const e=this.constructor._styles;0!==e.length&&(void 0===window.ShadyCSS||window.ShadyCSS.nativeShadow?Q?this.renderRoot.adoptedStyleSheets=e.map((e=>e instanceof CSSStyleSheet?e:e.styleSheet)):this._needsShimAdoptedStyleSheets=!0:window.ShadyCSS.ScopingShim.prepareAdoptedCssText(e.map((e=>e.cssText)),this.localName))}connectedCallback(){super.connectedCallback(),this.hasUpdated&&void 0!==window.ShadyCSS&&window.ShadyCSS.styleElement(this)}update(e){const t=this.render();super.update(e),t!==re&&this.constructor.render(t,this.renderRoot,{scopeName:this.localName,eventContext:this}),this._needsShimAdoptedStyleSheets&&(this._needsShimAdoptedStyleSheets=!1,this.constructor._styles.forEach((e=>{const t=document.createElement("style");t.textContent=e.cssText,this.renderRoot.appendChild(t)})))}render(){return re}}se.finalized=!0,se.render=(e,t,o)=>{if(!o||"object"!=typeof o||!o.scopeName)throw new Error("The `scopeName` option is required.");const r=o.scopeName,s=$.has(t),n=q&&11===t.nodeType&&!!t.host,a=n&&!U.has(r),c=a?document.createDocumentFragment():t;if(((e,t,o)=>{let r=$.get(t);void 0===r&&(i(t,t.firstChild),$.set(t,r=new D(Object.assign({templateFactory:N},o))),r.appendInto(t)),r.setValue(e),r.commit()})(e,c,Object.assign({templateFactory:Y(r)},o)),a){const e=$.get(c);$.delete(c);((e,t,o)=>{U.add(e);const i=o?o.element:document.createElement("template"),r=t.querySelectorAll("style"),{length:s}=r;if(0===s)return void window.ShadyCSS.prepareTemplateStyles(i,e);const n=document.createElement("style");for(let e=0;e<s;e++){const t=r[e];t.parentNode.removeChild(t),n.textContent+=t.textContent}(e=>{j.forEach((t=>{const o=F.get(W(t,e));void 0!==o&&o.keyString.forEach((e=>{const{element:{content:t}}=e,o=new Set;Array.from(t.querySelectorAll("style")).forEach((e=>{o.add(e)})),u(e,o)}))}))})(e);const a=i.content;o?function(e,t,o=null){const{element:{content:i},parts:r}=e;if(null==o)return void i.appendChild(t);const s=document.createTreeWalker(i,133,null,!1);let n=f(r),a=0,c=-1;for(;s.nextNode();)for(c++,s.currentNode===o&&(a=m(t),o.parentNode.insertBefore(t,o));-1!==n&&r[n].index===c;){if(a>0){for(;-1!==n;)r[n].index+=a,n=f(r,n);return}n=f(r,n)}}(o,n,a.firstChild):a.insertBefore(n,a.firstChild),window.ShadyCSS.prepareTemplateStyles(i,e);const c=a.querySelector("style");if(window.ShadyCSS.nativeShadow&&null!==c)t.insertBefore(c.cloneNode(!0),t.firstChild);else if(o){a.insertBefore(n,a.firstChild);const e=new Set;e.add(n),u(o,e)}})(r,c,e.value instanceof x?e.value.template:void 0),i(t,t.firstChild),t.appendChild(c),$.set(t,e)}!s&&n&&window.ShadyCSS.styleElement(t.host)},se.shadowRootOptions={mode:"open"};const ne=document.createElement("template"),ae=ie`
  ::-webkit-scrollbar {
    height: 0.5rem;
    width: 0.5rem;
    visibility: hidden;
  }

  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgba(var(--ui-1), var(--opacity-6));
    border-radius: 0.5rem;
  }

  ::-webkit-scrollbar-thumb:active,
  ::-webkit-scrollbar-thumb:hover {
    background-color: rgba(var(--ui-1), var(--opacity-4))
  }

  ::-webkit-scrollbar-track {
    background-color: rgba(var(--ui-1), var(--opacity-7));
    border-radius: 0.5rem;
  }

  *:active::-webkit-scrollbar-track:active {
    width: 1rem;
  }

  sh-nav-bar::-webkit-scrollbar {
    width: 0 !important;
    height: 0 !important;
    background-color: transparent !important;
    box-shadow: 0rem !important;
  }

  *[hidden] {
    display: none !important;
  }

  /* Firefox scrollbar */

  * {
    scrollbar-color:  rgba(var(--ui-1), var(--opacity-6)) rgba(var(--ui-1), var(--opacity-7));
    scrollbar-width: thin;
  }
  *:hover, *:active {
    scrollbar-color:  rgba(var(--ui-1), var(--opacity-4)) rgba(var(--ui-1), var(--opacity-7));
    scrollbar-width: thin
  }

  /* hr spacer */

  hr {
    border: none;
    -webkit-margin-before: 0.5rem;
    -webkit-margin-after: 0.5rem;
  }
`;ne.innerHTML=`<dom-module id="shared-styles">\n  <template>\n    <style>\n      ${ae}\n    </style>\n  </template>\n</dom-module>`,document.head.appendChild(ne.content),function(e,t){void 0===t&&(t={});var o=t.insertAt;if("undefined"!=typeof document){var i=document.head||document.getElementsByTagName("head")[0],r=document.createElement("style");r.type="text/css","top"===o&&i.firstChild?i.insertBefore(r,i.firstChild):i.appendChild(r),r.styleSheet?r.styleSheet.cssText=e:r.appendChild(document.createTextNode(e))}}('@charset "UTF-8";\n::-webkit-scrollbar {\n  height: 0.5rem;\n  width: 0.5rem;\n  visibility: hidden;\n}\n\n::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: rgba(var(--ui-1), var(--opacity-6));\n  border-radius: 0.5rem;\n}\n\n::-webkit-scrollbar-thumb:active,\n::-webkit-scrollbar-thumb:hover {\n  background-color: rgba(var(--ui-1), var(--opacity-4));\n}\n\n::-webkit-scrollbar-track {\n  background-color: rgba(var(--ui-1), var(--opacity-7));\n  border-radius: 0.5rem;\n}\n\n*:active::-webkit-scrollbar-track:active {\n  width: 1rem;\n}\n\nsh-nav-bar::-webkit-scrollbar {\n  width: 0 !important;\n  height: 0 !important;\n  background-color: transparent !important;\n  box-shadow: 0rem !important;\n}\n\n*[hidden] {\n  display: none !important;\n}\n\n/* Firefox scrollbar */\n* {\n  scrollbar-color: rgba(var(--ui-1), var(--opacity-6)) rgba(var(--ui-1), var(--opacity-7));\n  scrollbar-width: thin;\n}\n\n*:hover,\n*:active {\n  scrollbar-color: rgba(var(--ui-1), var(--opacity-4)) rgba(var(--ui-1), var(--opacity-7));\n  scrollbar-width: thin;\n}\n\n/* hr spacer */\nhr {\n  border: none;\n  -webkit-margin-before: 0.5rem;\n  -webkit-margin-after: 0.5rem;\n}\n\n/* THEMES */\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-button-button-height=2rem] - height of the button\n   */\n  --sh-button-button-height: 2rem;\n  /* \n   * @cssprop [--sh-button-width-size-s=6rem] - width of the button s\n   */\n  --sh-button-width-size-s: 6rem;\n  /* \n   * @cssprop [--sh-button-width-size-m=9.5rem] - width of the button m\n   */\n  --sh-button-width-size-m: 9.5rem;\n  /* \n   * @cssprop [--sh-button-width-size-l=11.5rem] - width of the button l\n   */\n  --sh-button-width-size-l: 11.5rem;\n  /* \n   * @cssprop [--sh-button-label-line-height=1.5rem] - line height of the label\n   */\n  --sh-button-label-line-height: 1.5rem;\n  /* \n   * @cssprop [--sh-button-button-border-radius=1rem] - border radius of the button\n   */\n  --sh-button-button-border-radius: 1rem;\n  /* \n   * @cssprop [--sh-button-button-padding=0.25rem 1rem] - padding of the button\n   */\n  --sh-button-button-padding: 0.25rem 1rem;\n  /* \n   * @cssprop [--sh-button-icon-width=3rem] - width of the icon button\n   */\n  --sh-button-icon-width: 3rem;\n  /* \n   * @cssprop [--sh-button-icon-height=3rem] - height of the icon button\n   */\n  --sh-button-icon-height: 3rem;\n  /* \n   * @cssprop [--sh-button-icon-size=2rem] - size of the icon\n   */\n  --sh-button-icon-size: 2rem;\n  /* \n   * @cssprop [--sh-button-icon-padding=0.5rem] - padding of the icon\n   */\n  --sh-button-icon-padding: 0.5rem;\n  /* \n   * @cssprop [--sh-button-padding-right-left=2rem] - left right padding of the button\n   */\n  --sh-button-padding-right-left: 2rem;\n  /* \n   * @cssprop [--sh-button-tooltip-height=1.5rem] - line height and height of the tooltip\n   */\n  --sh-button-tooltip-height: 1.5rem;\n  /* \n   * @cssprop [--sh-button-tooltip-max-width=15rem] - max width of the tooltip\n   */\n  --sh-button-tooltip-max-width: 15rem;\n  /* \n   * @cssprop [--sh-button-tooltip-top-margin=0rem] - margin-top for the tooltip\n   */\n  --sh-button-tooltip-top-margin: 0rem;\n  /* \n   * @cssprop [--sh-button-tooltip-margin=0.25rem] - margin for the tooltip\n   */\n  --sh-button-tooltip-margin: 0.25rem;\n  /* \n   * @cssprop [--sh-button-tooltip-margin-top=-1.5rem] - margin for tooltip top placement\n   */\n  --sh-button-tooltip-margin-top: -1.5rem;\n  /* \n   * @cssprop [--sh-button-tooltip-hover-margin-top=-1.75rem] - margin for tooltip top placement on hover\n   */\n  --sh-button-tooltip-hover-margin-top: -1.75rem;\n  /* \n   * @cssprop [--sh-button-tertiary-border-thickness=0.0625rem] - border thickness of a tertiary button\n   */\n  --sh-button-tertiary-border-thickness: 0.0625rem;\n  /* \n   * @cssprop [--sh-button-flex-shrink-icon=unset] - flex-shrink of an icon button\n   */\n  --sh-button-flex-shrink-icon: unset;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-empty-state-icon-size=4rem] - Size of the empty state icon\n   */\n  --sh-empty-state-icon-size: 4rem;\n  /* \n   * @cssprop [--sh-empty-state-text-width=24rem] - Width of the empty state text\n   */\n  --sh-empty-state-text-width: 24rem;\n  /* \n   * @cssprop [--sh-empty-state-text-max-width=calc(100% - 4rem)] - Maximum width of the empty state text \n   */\n  --sh-empty-state-text-max-width: calc(100% - 4rem);\n  /* \n   * @cssprop [--sh-empty-state-margin=1rem] - Top margin for the footer slot & Bottom margin of the icon \n   */\n  --sh-empty-state-margin: 1rem;\n  /* \n   * @cssprop [--sh-empty-state-thickness=0.125rem] - Border thickness of the dotted line when drag and drop is set\n   */\n  --sh-empty-state-thickness: 0.125rem;\n  /* \n   * @cssprop [--sh-empty-state-left-margin=0.5rem] - left margin of the non first footer slot elements\n   */\n  --sh-empty-state-left-margin: 0.5rem;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-icon-size-xs=1rem] - size of icon\n   */\n  --sh-icon-size-xs: 1rem;\n  /* \n   * @cssprop [--sh-icon-size-s=1.5rem] - size of icon\n   */\n  --sh-icon-size-s: 1.5rem;\n  /* \n   * @cssprop [--sh-icon-size-m=2rem] - size of icon\n   */\n  --sh-icon-size-m: 2rem;\n  /* \n   * @cssprop [--sh-icon-size-l=3rem] - size of icon\n   */\n  --sh-icon-size-l: 3rem;\n  /* \n   * @cssprop [--sh-icon-font-size-xs=1rem] - size of icon image\n   */\n  --sh-icon-font-size-xs: 1rem;\n  /* \n   * @cssprop [--sh-icon-font-size-s=1.5rem] - size of icon image\n   */\n  --sh-icon-font-size-s: 1.5rem;\n  /* \n   * @cssprop [--sh-icon-font-size-m=2rem] - size of icon image\n   */\n  --sh-icon-font-size-m: 2rem;\n  /* \n   * @cssprop [--sh-icon-font-size-l=3rem] - size of icon image\n   */\n  --sh-icon-font-size-l: 3rem;\n  /* \n   * @cssprop [--sh-icon-badge-left=calc(100% - 0.25rem)] - left position the badg will be centered around\n   */\n  --sh-icon-badge-left: calc(100% - 0.25rem);\n  /* \n   * @cssprop [--sh-icon-badge-bottom=calc(100% - 0.25rem)] - bottom position the badg will be centered around\n   */\n  --sh-icon-badge-bottom: calc(100% - 0.25rem);\n}\n\n/* icon scale by default === font size */\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-badge-font-size=0.625rem] - font size for badge\n   */\n  --sh-badge-font-size: 0.625rem;\n  /* \n   * @cssprop [--sh-badge-min-width=1rem] - min width of badge\n   */\n  --sh-badge-min-width: 1rem;\n  /* \n   * @cssprop [--sh-badge-max-width=4rem] - max width of badge\n   */\n  --sh-badge-max-width: 4rem;\n  /* \n   * @cssprop [--sh-badge-height=1rem] - height of badge\n   */\n  --sh-badge-height: 1rem;\n  /* \n   * @cssprop [--sh-badge-line-height=0.5rem] - line height of badge\n   */\n  --sh-badge-line-height: 0.5rem;\n  /* \n   * @cssprop [--sh-badge-no-label-size=0.5rem] - size of empty badge in case no label is set\n   */\n  --sh-badge-no-label-size: 0.5rem;\n  /* \n   * @cssprop [--sh-badge-padding=0.25rem 0.25rem] - padding for text labels\n   */\n  --sh-badge-padding: 0.25rem 0.25rem;\n  /* \n   * @cssprop [--sh-badge-icon-font-size=1.5rem] - applied to interllay used icon as --sh-icon-font-size-xs\n   */\n  --sh-badge-icon-font-size: 1.5rem;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-tag-container-height=2rem] - height of container\n   */\n  --sh-tag-container-height: 2rem;\n  /* \n   * @cssprop [--sh-tag-wrapper-border=0.0625rem] - border of tag wrapper\n   */\n  --sh-tag-wrapper-border: 0.0625rem;\n  /* \n   * @cssprop [--sh-tag-padding=0 0.5rem] - left and right padding of tag\n   */\n  --sh-tag-padding: 0 0.5rem;\n  /* \n   * @cssprop [--sh-tag-label-line-height=2rem] - line height of tag label\n   */\n  --sh-tag-label-line-height: 2rem;\n  /* \n   * @cssprop [--sh-tag-icon-padding=0.5rem] - padding of the icon\n   */\n  --sh-tag-icon-padding: 0.5rem;\n  /* \n   * @cssprop [--sh-tag-border-radius=0.125rem] - border radius\n   */\n  --sh-tag-border-radius: 0.125rem;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-text-super-header-line-height=2rem] - line height of super header text\n   */\n  --sh-text-super-header-line-height: 2rem;\n  /* \n   * @cssprop [--sh-text-header-line-height=1.5rem] - line height of header text\n   */\n  --sh-text-header-line-height: 1.5rem;\n  /* \n   * @cssprop [--sh-text-title1-line-height=1.25rem] - line height of title1 text\n   */\n  --sh-text-title1-line-height: 1.25rem;\n  /* \n   * @cssprop [--sh-text-title2-line-height=1rem] - line height of title2 text\n   */\n  --sh-text-title2-line-height: 1rem;\n  /* \n   * @cssprop [--sh-text-body1-line-height=1.25rem] - line height of body1 text\n   */\n  --sh-text-body1-line-height: 1.25rem;\n  /* \n   * @cssprop [--sh-text-body2-line-height=1rem] - line height of body2 text\n   */\n  --sh-text-body2-line-height: 1rem;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-toggle-height=1.25rem] - toggle height\n   */\n  --sh-toggle-height: 1.25rem;\n  /* \n   * @cssprop [--sh-toggle-border-radius=0.625rem] - border radius\n   */\n  --sh-toggle-border-radius: 0.625rem;\n  /* \n   * @cssprop [--sh-toggle-border-width=0.125rem] - border width\n   */\n  --sh-toggle-border-width: 0.125rem;\n  /* \n   * @cssprop [--sh-toggle-circle-dimension=0.875rem] - toggle circle width and height\n   */\n  --sh-toggle-circle-dimension: 0.875rem;\n  /* \n   * @cssprop [--sh-toggle-width=2.5rem] - toggle width\n   */\n  --sh-toggle-width: 2.5rem;\n  /* \n   * @cssprop [--sh-toggle-margin=0.125rem 0.625rem 0.125rem 0.125rem] - toggle margin\n   */\n  --sh-toggle-margin: 0.125rem 0.625rem 0.125rem 0.125rem;\n  /* \n   * @cssprop [--sh-toggle-circle-top=0.0625rem] - toggle circle top\n   */\n  --sh-toggle-circle-top: 0.0625rem;\n  /* \n   * @cssprop [--sh-toggle-circle-left=0.0625rem] - toggle circle left\n   */\n  --sh-toggle-circle-left: 0.0625rem;\n  /* \n   * @cssprop [--sh-toggle-active-left=1.25rem] - toggle circle left\n   */\n  --sh-toggle-active-left: 1.25rem;\n  /* \n   * @cssprop [--sh-toggle-line-height=1.5rem] - toggle line height\n   */\n  --sh-toggle-line-height: 1.5rem;\n  /* \n   * @cssprop [--sh-toggle-label-line-height=1.5rem] - label line height\n   */\n  --sh-toggle-label-line-height: 1.5rem;\n  /* \n   * @cssprop [--sh-toggle-label-padding=0rem] - label padding\n   */\n  --sh-toggle-label-padding: 0rem;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-checkbox-inner-width=1rem] - checkbox width\n   */\n  --sh-checkbox-inner-width: 1rem;\n  /* \n   * @cssprop [--sh-checkbox-inner-height=1rem] - checkbox height\n   */\n  --sh-checkbox-inner-height: 1rem;\n  /* \n   * @cssprop [--sh-checkbox-outer-width=1.5rem] - checkbox outer width\n   */\n  --sh-checkbox-outer-width: 1.5rem;\n  /* \n   * @cssprop [--sh-checkbox-outer-height=1.5rem] - checkbox outer height\n   */\n  --sh-checkbox-outer-height: 1.5rem;\n  /* \n   * @cssprop [--sh-checkbox-tick-line-height=0.875rem] - checkbox tick line height\n   */\n  --sh-checkbox-tick-line-height: 0.875rem;\n  /* \n   * @cssprop [--sh-checkbox-tick-font-size=0.875rem] - tick font size\n   */\n  --sh-checkbox-tick-font-size: 0.875rem;\n  /* \n   * @cssprop [--sh-checkbox-border-width=0.125rem] - checkbox border width\n   */\n  --sh-checkbox-border-width: 0.125rem;\n  /* \n   * @cssprop [--sh-checkbox-border-radius=0.125rem] - checkbox border radius\n   */\n  --sh-checkbox-border-radius: 0.125rem;\n  /* \n   * @cssprop [--sh-checkbox-label-line-height=1.25rem] - checkbox label line height\n   */\n  --sh-checkbox-label-line-height: 1.25rem;\n  /* \n   * @cssprop [--sh-checkbox-margin-right=0.5rem] - checkbox margin right\n   */\n  --sh-checkbox-margin-right: 0.5rem;\n  /* \n   * @cssprop [--sh-checkbox-margin-around-checkbox=0.25rem] - margin around checkbox\n   */\n  --sh-checkbox-margin-around-checkbox: 0.25rem;\n  /* \n   * @cssprop [--sh-checkbox-text-indent=-0.0625rem] - tick text indent\n   */\n  --sh-checkbox-text-indent: -0.0625rem;\n  /* \n   * @cssprop [--sh-checkbox-outline-offset=-0.125rem] - outline ofset\n   */\n  --sh-checkbox-outline-offset: -0.125rem;\n  /* \n   * @cssprop [--sh-checkbox-label-width=2rem] - label width\n   */\n  --sh-checkbox-label-width: 2rem;\n  /* \n   * @cssprop [--sh-checkbox-padding=0rem] - checkbox top and bottom padding\n   */\n  --sh-checkbox-padding: 0rem;\n  /* \n   * @cssprop [--sh-checkbox-label-padding=0rem] - label padding\n   */\n  --sh-checkbox-label-padding: 0rem;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-radio-button-container-margin=0] - margin of the container(XL)\n   */\n  --sh-radio-button-container-margin: 0;\n  /* \n   * @cssprop [--sh-radio-button-label-line-height=1.25rem] - line height of the label\n   */\n  --sh-radio-button-label-line-height: 1.25rem;\n  /* \n   * @cssprop [--sh-radio-button-label-padding=0.25rem] - left padding of the label\n   */\n  --sh-radio-button-label-padding: 0.25rem;\n  /* \n   * @cssprop [--sh-radio-button-label-margin=0.375rem 0] - top and bottom margins of the label\n   */\n  --sh-radio-button-label-margin: 0.375rem 0;\n  /* \n   * @cssprop [--sh-radio-button-width=2rem] - width of the radio-button\n   */\n  --sh-radio-button-width: 2rem;\n  /* \n   * @cssprop [--sh-radio-button-height=2rem] - height of radio-button\n   */\n  --sh-radio-button-height: 2rem;\n  /* \n   * @cssprop [--sh-radio-button-pseudo-width=1rem] - width of the pseudo radio-button\n   */\n  --sh-radio-button-pseudo-width: 1rem;\n  /* \n   * @cssprop [--sh-radio-button-pseudo-height=1rem] - height of the pseudo radio-button\n   */\n  --sh-radio-button-pseudo-height: 1rem;\n  /* \n   * @cssprop [--sh-radio-button-pseudo-margin=0.5rem] - margin of the pseudo radio-button\n   */\n  --sh-radio-button-pseudo-margin: 0.5rem;\n  /* \n   * @cssprop [--sh-radio-button-pseudo-border-width=0.125rem] - border-width of the pseudo radio-button\n   */\n  --sh-radio-button-pseudo-border-width: 0.125rem;\n  /* \n   * @cssprop [--sh-radio-button-pseudo-border-width-active=0.3125rem] - border-width of the pseudo radio-button when active\n   */\n  --sh-radio-button-pseudo-border-width-active: 0.3125rem;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-radio-group-margin=0] - margin for the radio-button\n   */\n  --sh-radio-group-margin: 0;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-breadcrumb-item-item-height=1.5rem] - height of breadcrumb item\n   */\n  --sh-breadcrumb-item-item-height: 1.5rem;\n  /* \n   * @cssprop [--sh-breadcrumb-item-item-max-width=10rem] - max width of breadcrumb item\n   */\n  --sh-breadcrumb-item-item-max-width: 10rem;\n  /* \n   * @cssprop [--sh-breadcrumb-item-item-line-height=1.25rem] - line height of breadcrumb item\n   */\n  --sh-breadcrumb-item-item-line-height: 1.25rem;\n  /* \n   * @cssprop [--sh-breadcrumb-item-item-icon-margin=-0.25rem 0] - icon margin of breadcrumb\n   */\n  --sh-breadcrumb-item-item-icon-margin: -0.25rem 0;\n  /* \n   * @cssprop [--sh-breadcrumb-item-item-icon-width=2rem] - icon max width\n   */\n  --sh-breadcrumb-item-item-icon-width: 2rem;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-input-text-label-left=0.5rem] - left of the input label\n   */\n  --sh-input-text-label-left: 0.5rem;\n  /* \n   * @cssprop [--sh-input-text-empty-label-top=0.5rem] - top of the input label when no value\n   */\n  --sh-input-text-empty-label-top: 0.5rem;\n  /* \n   * @cssprop [--sh-input-text-empty-label-line-height=1.5rem] - line-height of the input label when no value\n   */\n  --sh-input-text-empty-label-line-height: 1.5rem;\n  /* \n   * @cssprop [--sh-input-text-empty-padding=0.5rem 0 0.4375rem 0.5rem] - padding of the input-text when no value\n   */\n  --sh-input-text-empty-padding: 0.5rem 0 0.4375rem 0.5rem;\n  /* \n   * @cssprop [--sh-input-text-height=2.4375rem] - height of the input-text\n   */\n  --sh-input-text-height: 2.4375rem;\n  /* \n   * @cssprop [--sh-input-text-padding=1.25rem 0 0.1875rem 0.5rem] - padding of the input-text with value\n   */\n  --sh-input-text-padding: 1.25rem 0 0.1875rem 0.5rem;\n  /* \n   * @cssprop [--sh-input-text-label-top=0.25rem] - top of the input label with value\n   */\n  --sh-input-text-label-top: 0.25rem;\n  /* \n   * @cssprop [--sh-input-text-label-line-height=1rem] - line-height of the input label with value\n   */\n  --sh-input-text-label-line-height: 1rem;\n  /* \n   * @cssprop [--sh-input-text-empty-no-border-padding-bottom=0.5rem] - padding-bottom of the input when no border\n   */\n  --sh-input-text-empty-no-border-padding-bottom: 0.5rem;\n  /* \n   * @cssprop [--sh-input-text-no-border-padding-bottom=0.25rem] - padding-bottom of the input with value when no border\n   */\n  --sh-input-text-no-border-padding-bottom: 0.25rem;\n  /* \n   * @cssprop [--sh-input-text-no-border-condensed-padding-bottom=0.25rem] - padding-bottom of the condensed input when no border\n   */\n  --sh-input-text-no-border-condensed-padding-bottom: 0.25rem;\n  /* \n   * @cssprop [--sh-input-text-icon-left-margin=0.5rem] - margin-left of the icon\n   */\n  --sh-input-text-icon-left-margin: 0.5rem;\n  /* \n   * @cssprop [--sh-input-text-icon-wrapper-right-padding=0.5rem] - right-padding of the icon-wrapper\n   */\n  --sh-input-text-icon-wrapper-right-padding: 0.5rem;\n  /* \n   * @cssprop [--sh-input-text-icon-size=1.5rem] - size of the icon\n   */\n  --sh-input-text-icon-size: 1.5rem;\n  /* \n   * @cssprop [--sh-input-text-icon-wrapper-margin=0rem] - margin-bottom of the icon\n   */\n  --sh-input-text-icon-wrapper-margin: 0rem;\n  /* \n   * @cssprop [--sh-input-text-helper-text-padding=0.25rem 0.5rem 0] - padding of the helper-text\n   */\n  --sh-input-text-helper-text-padding: 0.25rem 0.5rem 0;\n  /* \n   * @cssprop [--sh-input-text-condensed-label-top=0.25rem] - top of the condensed label\n   */\n  --sh-input-text-condensed-label-top: 0.25rem;\n  /* \n   * @cssprop [--sh-input-text-condensed-padding=0.25rem 0 0.1875rem 0.5rem] - padding of the condensed input\n   */\n  --sh-input-text-condensed-padding: 0.25rem 0 0.1875rem 0.5rem;\n  /* \n   * @cssprop [--sh-input-text-condensed-height=1.9375rem] - height of the condensed input\n   */\n  --sh-input-text-condensed-height: 1.9375rem;\n  /* \n   * @cssprop [--sh-input-text-textarea-label-height=1.5rem] - height of the textarea label\n   */\n  --sh-input-text-textarea-label-height: 1.5rem;\n  /* \n   * @cssprop [--sh-input-text-textarea-label-padding=0.25rem 0 0.25rem 0.5rem] - padding of the textarea label\n   */\n  --sh-input-text-textarea-label-padding: 0.25rem 0 0.25rem 0.5rem;\n  /* \n   * @cssprop [--sh-input-text-textarea-padding=0 0.5rem 0.3125rem] - padding of the textarea\n   */\n  --sh-input-text-textarea-padding: 0 0.5rem 0.3125rem;\n  /* \n   * @cssprop [--sh-input-text-textarea-line-height=1.0625rem] - line-height of the textarea\n   */\n  --sh-input-text-textarea-line-height: 1.0625rem;\n  /* \n   * @cssprop [--sh-input-text-textarea-empty-label-line-height=1.25rem] - line-height of the empty textarea (without value)\n   */\n  --sh-input-text-textarea-empty-label-line-height: 1.25rem;\n  /* \n   * @cssprop [--sh-input-text-condensed-textarea-top=0.25rem] - top of the icon-wrapper and label of condensed textarea\n   */\n  --sh-input-text-condensed-textarea-top: 0.25rem;\n  /* \n   * @cssprop [--sh-input-text-condensed-textarea-padding=0.25rem 0 0.3125rem 0.5rem] - padding of the div of condensed textarea\n   */\n  --sh-input-text-condensed-textarea-padding: 0.25rem 0 0.3125rem 0.5rem;\n  /* \n   * @cssprop [--sh-input-text-textarea-label-line-height=1rem] - line-height of the label of textarea with value\n   */\n  --sh-input-text-textarea-label-line-height: 1rem;\n  /* \n   * @cssprop [--sh-input-text-condensed-textarea-icon-top=0.25rem] - top of the icon of condensed textarea with value\n   */\n  --sh-input-text-condensed-textarea-icon-top: 0.25rem;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-spinner-width-s=2rem] - spinner width of s size\n   */\n  --sh-spinner-width-s: 2rem;\n  /* \n   * @cssprop [--sh-spinner-height-s=2rem] - spinner height of s size\n   */\n  --sh-spinner-height-s: 2rem;\n  /* \n   * @cssprop [--sh-spinner-width-m=3rem] - spinner width of m size\n   */\n  --sh-spinner-width-m: 3rem;\n  /* \n   * @cssprop [--sh-spinner-height-m=3rem] - spinner height of m size\n   */\n  --sh-spinner-height-m: 3rem;\n  /* \n   * @cssprop [--sh-spinner-border-width=0.25rem] - border width of s size\n   */\n  --sh-spinner-border-width: 0.25rem;\n  /* \n   * @cssprop [--sh-spinner-label-height=1rem] - label height\n   */\n  --sh-spinner-label-height: 1rem;\n  /* \n   * @cssprop [--sh-spinner-label-line-height=1.125rem] - label line height\n   */\n  --sh-spinner-label-line-height: 1.125rem;\n  /* \n   * @cssprop [--sh-spinner-margin-top=0.5rem] - label margin top\n   */\n  --sh-spinner-margin-top: 0.5rem;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-divider-thickness=0.0625rem] - width / height of the  vertical & horizontal divider\n   */\n  --sh-divider-thickness: 0.0625rem;\n  /* \n   * @cssprop [--sh-divider-horizontal-s=0.5rem 0] - spacing s for the horizontal divider\n   */\n  --sh-divider-horizontal-s: 0.5rem 0;\n  /* \n   * @cssprop [--sh-divider-horizontal-m=1rem 0] - spacing m for the horizontal divider\n   */\n  --sh-divider-horizontal-m: 1rem 0;\n  /* \n   * @cssprop [--sh-divider-horizontal-l=1.5rem 0] - spacing l for the horizontal divider\n   */\n  --sh-divider-horizontal-l: 1.5rem 0;\n  /* \n   * @cssprop [--sh-divider-horizontal-xl=3rem 0] - spacing xl for the horizontal divider\n   */\n  --sh-divider-horizontal-xl: 3rem 0;\n  /* \n   * @cssprop [--sh-divider-vertical-s=0 0.5rem] - spacing s for the vertical divider\n   */\n  --sh-divider-vertical-s: 0 0.5rem;\n  /* \n   * @cssprop [--sh-divider-vertical-m=0 1rem] - spacing m for the vertical divider\n   */\n  --sh-divider-vertical-m: 0 1rem;\n  /* \n   * @cssprop [--sh-divider-vertical-l=0 1.5rem] - spacing l for the vertical divider\n   */\n  --sh-divider-vertical-l: 0 1.5rem;\n  /* \n   * @cssprop [--sh-divider-vertical-xl=0 3rem] - spacing xl for the vertical divider\n   */\n  --sh-divider-vertical-xl: 0 3rem;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-tooltip-max-content-width=25rem] - maximum width of the tooltip\n   */\n  --sh-tooltip-max-content-width: 25rem;\n  /* \n   * @cssprop [--sh-tooltip-content-padding=0.25rem 0.5rem] - padding for the tooltip\n   */\n  --sh-tooltip-content-padding: 0.25rem 0.5rem;\n  /* \n   * @cssprop [--sh-tooltip-label-line-height=1rem] - line height of the tooltip label\n   */\n  --sh-tooltip-label-line-height: 1rem;\n  /* \n   * @cssprop [--sh-tooltip-padding-title=0.5rem] - padding for the tooltip with title\n   */\n  --sh-tooltip-padding-title: 0.5rem;\n  /* \n   * @cssprop [--sh-tooltip-title-line-height=1rem] - line height of the tooltip title\n   */\n  --sh-tooltip-title-line-height: 1rem;\n  /* \n   * @cssprop [--sh-tooltip-margin-value=0.5rem] - margin value of the tooltip title and error icon\n   */\n  --sh-tooltip-margin-value: 0.5rem;\n  /* \n   * @cssprop [--sh-tooltip-content-border-radius=0.125rem] - border-radius of the tooltip\n   */\n  --sh-tooltip-content-border-radius: 0.125rem;\n  /* \n   * @cssprop [--sh-tooltip-margin-top-value=0rem] - margin top for the tooltip\n   */\n  --sh-tooltip-margin-top-value: 0rem;\n}\n\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-switch-item-width=5.5rem] - switch item width\n   */\n  --sh-switch-item-width: 5.5rem;\n  /* \n   * @cssprop [--sh-switch-item-height=2.5rem] - switch height\n   */\n  --sh-switch-item-height: 2.5rem;\n  /* \n   * @cssprop [--sh-switch-item-padding=0.75rem] - switch item padding\n   */\n  --sh-switch-item-padding: 0.75rem;\n  /* \n   * @cssprop [--sh-switch-item-label-alignment=center] - label alignment\n   */\n  --sh-switch-item-label-alignment: center;\n  /* \n   * @cssprop [--sh-switch-item-border-radius=1.25rem] - switch  border radius\n   */\n  --sh-switch-item-border-radius: 1.25rem;\n  /* \n   * @cssprop [--sh-switch-item-condensed-height=2rem] - switch  item condensed height\n   */\n  --sh-switch-item-condensed-height: 2rem;\n  /* \n   * @cssprop [--sh-switch-item-condensed-border-radius=1rem] - switch  item condensed height\n   */\n  --sh-switch-item-condensed-border-radius: 1rem;\n  /* \n   * @cssprop [--sh-switch-item-condensed-padding=0.5rem 0.75rem] - switch  item condensed height\n   */\n  --sh-switch-item-condensed-padding: 0.5rem 0.75rem;\n  /* \n   * @cssprop [--sh-switch-item-icon-height=2rem] - switch  item icon height\n   */\n  --sh-switch-item-icon-height: 2rem;\n  /* \n   * @cssprop [--sh-switch-item-icon-width=2rem] - switch  item icon width\n   */\n  --sh-switch-item-icon-width: 2rem;\n  /* \n   * @cssprop [--sh-switch-item-icon-margin=0.25rem 1.75rem] - switch  item icon margin\n   */\n  --sh-switch-item-icon-margin: 0.25rem 1.75rem;\n  /* \n   * @cssprop [--sh-switch-item-label-height=1rem] - switch  item icon margin\n   */\n  --sh-switch-item-label-height: 1rem;\n}\n\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-switch-border-radius=1.25rem] - switch  border radius\n   */\n  --sh-switch-border-radius: 1.25rem;\n  /* \n   * @cssprop [--sh-switch-condensed-border-radius=1rem] - switch condensed border radius\n   */\n  --sh-switch-condensed-border-radius: 1rem;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-search-icon-top=0.5rem] - top margin of search icon\n   */\n  --sh-search-icon-top: 0.5rem;\n  /* \n   * @cssprop [--sh-search-icon-left=0.5rem] - left margin of search icon\n   */\n  --sh-search-icon-left: 0.5rem;\n  /* \n   * @cssprop [--sh-search-input-height=2.5rem] - height of search input\n   */\n  --sh-search-input-height: 2.5rem;\n  /* \n   * @cssprop [--sh-search-value-line-height=0.5rem] - line-height of value\n   */\n  --sh-search-value-line-height: 0.5rem;\n  /* \n   * @cssprop [--sh-search-input-padding=0.5rem 2.5rem] - padding of input\n   */\n  --sh-search-input-padding: 0.5rem 2.5rem;\n  /* \n   * @cssprop [--sh-search-border-radius=0.125rem 0.125rem 0rem 0rem] - border-radius of input\n   */\n  --sh-search-border-radius: 0.125rem 0.125rem 0rem 0rem;\n  /* \n   * @cssprop [--sh-search-border-bottom-thickness=0.0625rem] - border-bottom of input\n   */\n  --sh-search-border-bottom-thickness: 0.0625rem;\n  /* \n   * @cssprop [--sh-search-list-item-height=2.5rem] - list-item-height\n   */\n  --sh-search-list-item-height: 2.5rem;\n  /* \n   * @cssprop [--sh-search-single-line-list-item-padding=0.5rem] - list-item-padding\n   */\n  --sh-search-single-line-list-item-padding: 0.5rem;\n  /* \n   * @cssprop [--sh-search-list-item-line-height=1.5rem] - line-height of list item\n   */\n  --sh-search-list-item-line-height: 1.5rem;\n  /* \n   * @cssprop [--sh-search-close-icon-right=0.5rem] - distance between right of close icon and right of search input\n   */\n  --sh-search-close-icon-right: 0.5rem;\n  /* \n   * @cssprop [--sh-search-multi-line-list-item-padding=0.25rem 0.5rem] - multi-line list-item padding\n   */\n  --sh-search-multi-line-list-item-padding: 0.25rem 0.5rem;\n  /* \n   * @cssprop [--sh-search-multi-line-list-item-height=2.5rem] - multi-line list-item height\n   */\n  --sh-search-multi-line-list-item-height: 2.5rem;\n  /* \n   * @cssprop [--sh-search-multi-line-single-item-height=1rem] - multi-line single-item height\n   */\n  --sh-search-multi-line-single-item-height: 1rem;\n  /* \n   * @cssprop [--sh-search-empty-wrapper-padding=1rem 0.5rem] - padding of empty wrapper\n   */\n  --sh-search-empty-wrapper-padding: 1rem 0.5rem;\n  /* \n   * @cssprop [--sh-search-list-view-max-height=13.75rem] - max-height of list-view\n   */\n  --sh-search-list-view-max-height: 13.75rem;\n  /* \n   * @cssprop [--sh-search-empty-slot-item-gap=1rem] - the gap between the items in empty slot\n   */\n  --sh-search-empty-slot-item-gap: 1rem;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-accordion-header-wrapper-min-height=2.5rem] - minimum height of header wrapper\n   */\n  --sh-accordion-header-wrapper-min-height: 2.5rem;\n  /* \n   * @cssprop [--sh-accordion-container-padding-left-right=0 1rem] - Left and right side padding of container\n   */\n  --sh-accordion-container-padding-left-right: 0 1rem;\n  /* \n   * @cssprop [--sh-accordion-header-label-info-padding=0.5rem 0.5rem 0.5rem 0] - padding of accordion label and info\n   */\n  --sh-accordion-header-label-info-padding: 0.5rem 0.5rem 0.5rem 0;\n  /* \n   * @cssprop [--sh-accordion-wrapper-padding-bottom=1rem] - bottom padding of accordion wrapper\n   */\n  --sh-accordion-wrapper-padding-bottom: 1rem;\n  /* \n   * @cssprop [--sh-accordion-label-line-height=1.5rem] - line height of accordion label\n   */\n  --sh-accordion-label-line-height: 1.5rem;\n  /* \n   * @cssprop [--sh-accordion-expand-icon-margin=0.25rem 0 0.25rem 0] - margin of expand icon\n   */\n  --sh-accordion-expand-icon-margin: 0.25rem 0 0.25rem 0;\n  /* \n   * @cssprop [--sh-accordion-icon-padding=0.5rem 0.5rem 0.5rem 0] - padding of header icon\n   */\n  --sh-accordion-icon-padding: 0.5rem 0.5rem 0.5rem 0;\n  /* \n   * @cssprop [--sh-accordion-content-items-margin-top=0.5rem] - vertical gap between items in content\n   */\n  --sh-accordion-content-items-margin-top: 0.5rem;\n  /* \n   * @cssprop [--sh-accordion-content-items-margin-top-touch=1rem] - vertical gap between items in content for touch device\n   */\n  --sh-accordion-content-items-margin-top-touch: 1rem;\n  /* \n   * @cssprop [--sh-accordion-content-first-item-margin-top=0rem] - top margin of first item in the content\n   */\n  --sh-accordion-content-first-item-margin-top: 0rem;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-user-identifier-margin-left=0.5rem] - info margin left\n   */\n  --sh-user-identifier-margin-left: 0.5rem;\n  /* \n   * @cssprop [--sh-user-identifier-max-width=10rem] - max width of name and info\n   */\n  --sh-user-identifier-max-width: 10rem;\n  /* \n   * @cssprop [--sh-user-identifier-height=1rem] - height of name and info\n   */\n  --sh-user-identifier-height: 1rem;\n  /* \n   * @cssprop [--sh-user-identifier-circle-dimension=2rem] - height of name and info\n   */\n  --sh-user-identifier-circle-dimension: 2rem;\n  /* \n   * @cssprop [--sh-user-identifier-image-circle=2rem] - width and height of image circle\n   */\n  --sh-user-identifier-image-circle: 2rem;\n  /* \n   * @cssprop [--sh-user-identifier-margin=0rem] - width and height of image circle\n   */\n  --sh-user-identifier-margin: 0rem;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-stepper-circle-dimension=2rem] - stepper circle width\n   */\n  --sh-stepper-circle-dimension: 2rem;\n  /* \n   * @cssprop [--sh-stepper-circle-line-height=2rem] - stepper circle line height\n   */\n  --sh-stepper-circle-line-height: 2rem;\n  /* \n   * @cssprop [--sh-stepper-margin-bottom=0.5rem] - stepper circle height\n   */\n  --sh-stepper-margin-bottom: 0.5rem;\n  /* \n   * @cssprop [--sh-stepper-border-width=0.0625rem] - circle border width\n   */\n  --sh-stepper-border-width: 0.0625rem;\n  /* \n   * @cssprop [--sh-stepper-line-top=0.9375rem] - stepper line top\n   */\n  --sh-stepper-line-top: 0.9375rem;\n  /* \n   * @cssprop [--sh-stepper-label-padding=0 0.5rem] - label text padding\n   */\n  --sh-stepper-label-padding: 0 0.5rem;\n  /* \n   * @cssprop [--sh-stepper-label-line-height=1.5rem] - label line height\n   */\n  --sh-stepper-label-line-height: 1.5rem;\n  /* \n   * @cssprop [--sh-stepper-info-line-height=1rem] - info line height\n   */\n  --sh-stepper-info-line-height: 1rem;\n  /* \n   * @cssprop [--sh-stepper-badge-top=-0.25rem] - badge top\n   */\n  --sh-stepper-badge-top: -0.25rem;\n  /* \n   * @cssprop [--sh-stepper-badge-right=-0.375rem] - badge top\n   */\n  --sh-stepper-badge-right: -0.375rem;\n  /* \n   * @cssprop [--sh-stepper-condensed-circle-dimension=0.875rem] - condensed circle width\n   */\n  --sh-stepper-condensed-circle-dimension: 0.875rem;\n  /* \n   * @cssprop [--sh-stepper-condensed-border-width=0.125rem] - condensed border width\n   */\n  --sh-stepper-condensed-border-width: 0.125rem;\n  /* \n   * @cssprop [--sh-stepper-condensed-badge-top=-0.1875rem] - condensed badge top\n   */\n  --sh-stepper-condensed-badge-top: -0.1875rem;\n  /* \n   * @cssprop [--sh-stepper-condensed-badge-right=-0.1875rem] - condensed badge top\n   */\n  --sh-stepper-condensed-badge-right: -0.1875rem;\n  /* \n   * @cssprop [--sh-stepper-line-border-width=0.125rem] - line border width\n   */\n  --sh-stepper-line-border-width: 0.125rem;\n  /* \n   * @cssprop [--sh-stepper-line-width=1.5rem] - line  width\n   */\n  --sh-stepper-line-width: 1.5rem;\n  /* \n   * @cssprop [--sh-stepper-condensed-line-top=0.4375rem] - condensed stepper line top\n   */\n  --sh-stepper-condensed-line-top: 0.4375rem;\n  /* \n   * @cssprop [--sh-stepper-condensed-line-width=0.625rem] - line border width\n   */\n  --sh-stepper-condensed-line-width: 0.625rem;\n  /* \n   * @cssprop [--sh-stepper-icon-size=1rem] - Size of the  icon\n   */\n  --sh-stepper-icon-size: 1rem;\n  /* \n   * @cssprop [--sh-stepper-font-size=1rem] - font Size of the icon\n   */\n  --sh-stepper-font-size: 1rem;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-value-indicator-l-value-line-height=4rem] - line height of value for l size\n   */\n  --sh-value-indicator-l-value-line-height: 4rem;\n  /* \n   * @cssprop [--sh-value-indicator-l-label-line-height=1.5rem] - line height of label for l size\n   */\n  --sh-value-indicator-l-label-line-height: 1.5rem;\n  /* \n   * @cssprop [--sh-value-indicator-s-label-line-height=1rem] - line height of label for s size\n   */\n  --sh-value-indicator-s-label-line-height: 1rem;\n  /* \n   * @cssprop [--sh-value-indicator-l-icon-size-m=4rem] - icon size for l size\n   */\n  --sh-value-indicator-l-icon-size-m: 4rem;\n  /* \n   * @cssprop [--sh-value-indicator-s-icon-size-m=2rem] - icon size for s size\n   */\n  --sh-value-indicator-s-icon-size-m: 2rem;\n  /* \n   * @cssprop [--sh-value-indicator-s-value-line-height=2rem] - line height of value for s size\n   */\n  --sh-value-indicator-s-value-line-height: 2rem;\n  /* \n   * @cssprop [--sh-value-indicator-l-unit-line-height=2.5rem] - line height of unit for l size\n   */\n  --sh-value-indicator-l-unit-line-height: 2.5rem;\n  /* \n   * @cssprop [--sh-value-indicator-s-unit-line-height=1.25rem] - line height of unit for s size\n   */\n  --sh-value-indicator-s-unit-line-height: 1.25rem;\n  /* \n   * @cssprop [--sh-value-indicator-l-unit-font-size=1.75rem] - line height of unit for s size\n   */\n  --sh-value-indicator-l-unit-font-size: 1.75rem;\n  /* \n   * @cssprop [--sh-value-indicator-s-unit-font-size=0.875rem] - line height of unit for s size\n   */\n  --sh-value-indicator-s-unit-font-size: 0.875rem;\n  /* \n   * @cssprop [--sh-value-indicator-l-icon-font-size-m=4rem] - font size of icon for l size\n   */\n  --sh-value-indicator-l-icon-font-size-m: 4rem;\n  /* \n   * @cssprop [--sh-value-indicator-s-icon-font-size-m=2rem] - font size of icon for s size\n   */\n  --sh-value-indicator-s-icon-font-size-m: 2rem;\n  /* \n   * @cssprop [--sh-value-indicator-l-value-font-size=3.5rem] - font size of value for l size\n   */\n  --sh-value-indicator-l-value-font-size: 3.5rem;\n  /* \n   * @cssprop [--sh-value-indicator-s-value-font-size=1.75rem] - font size of value for s size\n   */\n  --sh-value-indicator-s-value-font-size: 1.75rem;\n  /* \n   * @cssprop [--sh-value-indicator-l-label-font-size=1rem] - font size of label for l size\n   */\n  --sh-value-indicator-l-label-font-size: 1rem;\n  /* \n   * @cssprop [--sh-value-indicator-s-label-font-size=0.875rem] - font size of label for s size\n   */\n  --sh-value-indicator-s-label-font-size: 0.875rem;\n  /* \n   * @cssprop [--sh-value-indicator-s-status-size-m=1.5rem] - size of status for s size\n   */\n  --sh-value-indicator-s-status-size-m: 1.5rem;\n  /* \n   * @cssprop [--sh-value-indicator-s-status-font-size-m=1.5rem] - font size of status for s size\n   */\n  --sh-value-indicator-s-status-font-size-m: 1.5rem;\n  /* \n   * @cssprop [--sh-value-indicator-s-icon-margin-right=0.25rem] - margin right of icon for s size\n   */\n  --sh-value-indicator-s-icon-margin-right: 0.25rem;\n  /* \n   * @cssprop [--sh-value-indicator-l-icon-margin-right=0.5rem] - margin right of icon for l size\n   */\n  --sh-value-indicator-l-icon-margin-right: 0.5rem;\n  /* \n   * @cssprop [--sh-value-indicator-s-unit-padding-top=0.625rem] - padding top of unit for s size\n   */\n  --sh-value-indicator-s-unit-padding-top: 0.625rem;\n  /* \n   * @cssprop [--sh-value-indicator-l-unit-padding-top=1.23rem] - padding top of unit for l size\n   */\n  --sh-value-indicator-l-unit-padding-top: 1.23rem;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-notification-item-header-margin=1rem 1rem 0 1rem] - margin of header area\n   */\n  --sh-notification-item-header-margin: 1rem 1rem 0 1rem;\n  /* \n   * @cssprop [--sh-notification-item-header-icon-margin=0 0.5rem 0 0] - margin of header icon\n   */\n  --sh-notification-item-header-icon-margin: 0 0.5rem 0 0;\n  /* \n   * @cssprop [--sh-notification-item-header-line-height=1.5rem] - header line height\n   */\n  --sh-notification-item-header-line-height: 1.5rem;\n  /* \n   * @cssprop [--sh-notification-item-header-max-height=3rem] - header max height\n   */\n  --sh-notification-item-header-max-height: 3rem;\n  /* \n   * @cssprop [--sh-notification-item-header-text-margin=0 0.5rem 0 0] - margin of header text\n   */\n  --sh-notification-item-header-text-margin: 0 0.5rem 0 0;\n  /* \n   * @cssprop [--sh-notification-item-header-close-button-margin=0] - margin of header close button\n   */\n  --sh-notification-item-header-close-button-margin: 0;\n  /* \n   * @cssprop [--sh-notification-item-description-container-margin=1rem] - margin of description container\n   */\n  --sh-notification-item-description-container-margin: 1rem;\n  /* \n   * @cssprop [--sh-notification-item-no-label-description-container-margin=1rem] - margin of description container when there is no label\n   */\n  --sh-notification-item-no-label-description-container-margin: 1rem;\n  /* \n   * @cssprop [--sh-notification-item-description-icon-margin=0 0.5rem 0 0] - margin of description icon\n   */\n  --sh-notification-item-description-icon-margin: 0 0.5rem 0 0;\n  /* \n   * @cssprop [--sh-notification-item-description-line-height=1.5rem] - description line height\n   */\n  --sh-notification-item-description-line-height: 1.5rem;\n  /* \n   * @cssprop [--sh-notification-item-description-text-margin=0 0.5rem 0 0] - description text margin\n   */\n  --sh-notification-item-description-text-margin: 0 0.5rem 0 0;\n  /* \n   * @cssprop [--sh-notification-item-description-close-button-margin=0rem] - margin of description close button\n   */\n  --sh-notification-item-description-close-button-margin: 0rem;\n  /* \n   * @cssprop [--sh-notification-item-footer-margin=0 1rem 1rem 1rem] - margin of footer area\n   */\n  --sh-notification-item-footer-margin: 0 1rem 1rem 1rem;\n  /* \n   * @cssprop [--sh-notification-item-footer-margin-with-no-description=1rem] - footer margin when no description is preset\n   */\n  --sh-notification-item-footer-margin-with-no-description: 1rem;\n  /* \n   * @cssprop [--sh-notification-item-description-slot-elements-margin-top=0rem] - margin between elements added in description slot\n   */\n  --sh-notification-item-description-slot-elements-margin-top: 0rem;\n  /* \n   * @cssprop [--sh-notification-item-badge-margin=0.5rem 1rem 0.5rem 1rem] - margin for the notification badge\n   */\n  --sh-notification-item-badge-margin: 0.5rem 1rem 0.5rem 1rem;\n  /* \n   * @cssprop [--sh-notification-item-footer-slot-child-margin-left=0.5rem] - margin-left for the components in the footer slot\n   */\n  --sh-notification-item-footer-slot-child-margin-left: 0.5rem;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-notification-width=20rem] - width of notification\n   */\n  --sh-notification-width: 20rem;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-input-number-status-text-padding=0.25rem 0.5rem 0 0.5rem] - padding of status text (warning, hint, ..)\n   */\n  --sh-input-number-status-text-padding: 0.25rem 0.5rem 0 0.5rem;\n  /* \n   * @cssprop [--sh-input-number-left-icon-padding=0 0 0 0.25rem] - padding of left icon\n   */\n  --sh-input-number-left-icon-padding: 0 0 0 0.25rem;\n  /* \n   * @cssprop [--sh-input-number-right-icon-padding=0] - padding of right icon\n   */\n  --sh-input-number-right-icon-padding: 0;\n  /* \n   * @cssprop [--sh-input-number-icon-size=1.9375rem] - size of the icon left and right\n   */\n  --sh-input-number-icon-size: 1.9375rem;\n  /* \n   * @cssprop [--sh-input-number-input-right-padding=0.25rem] - right padding of the input\n   */\n  --sh-input-number-input-right-padding: 0.25rem;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-numeric-keypad-width=11rem] - width of the keypad container\n   */\n  --sh-numeric-keypad-width: 11rem;\n  /* \n   * @cssprop [--sh-numeric-keypad-height=15rem] - height of the keypad container\n   */\n  --sh-numeric-keypad-height: 15rem;\n  /* \n   * @cssprop [--sh-numeric-keypad-circle-button-width=3rem] - width of the circle buttons\n   */\n  --sh-numeric-keypad-circle-button-width: 3rem;\n  /* \n   * @cssprop [--sh-numeric-keypad-circle-button-height=3rem] - height of the circle buttons\n   */\n  --sh-numeric-keypad-circle-button-height: 3rem;\n  /* \n   * @cssprop [--sh-numeric-keypad-container-padding=1rem] - padding of the keypad container\n   */\n  --sh-numeric-keypad-container-padding: 1rem;\n  /* \n   * @cssprop [--sh-numeric-keypad-button-margins=0.5rem] - margin for the circle buttons\n   */\n  --sh-numeric-keypad-button-margins: 0.5rem;\n  /* \n   * @cssprop [--sh-numeric-keypad-button-center-margin=0 0.5rem] - margin for the circle buttons in the center column\n   */\n  --sh-numeric-keypad-button-center-margin: 0 0.5rem;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-nav-bar-nav-bar-wrapper-height=3.5rem] - height of nav bar wrapper\n   */\n  --sh-nav-bar-nav-bar-wrapper-height: 3.5rem;\n  /* \n   * @cssprop [--sh-nav-bar-condensed-nav-bar-wrapper-height=2.5rem] - height of condensed nav bar wrapper height\n   */\n  --sh-nav-bar-condensed-nav-bar-wrapper-height: 2.5rem;\n  /* \n   * @cssprop [--sh-nav-bar-functions-wrapper-gap=0.5rem] - gap of functions wrapper\n   */\n  --sh-nav-bar-functions-wrapper-gap: 0.5rem;\n  /* \n   * @cssprop [--sh-nav-bar-functions-wrapper-padding=0 0 0 0.5rem] - padding of functions wrapper\n   */\n  --sh-nav-bar-functions-wrapper-padding: 0 0 0 0.5rem;\n  /* \n   * @cssprop [--sh-nav-bar-nav-bar-wrapper-padding=0 1rem] - padding of nav-bar-wrapper\n   */\n  --sh-nav-bar-nav-bar-wrapper-padding: 0 1rem;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-pane-wrapper-width=22rem] - width of the pane\n   */\n  --sh-pane-wrapper-width: 22rem;\n  /* \n   * @cssprop [--sh-pane-wrapper-padding=1rem] - padding of the head and body wrapper\n   */\n  --sh-pane-wrapper-padding: 1rem;\n  /* \n   * @cssprop [--sh-pane-arrow-placement-padding=0.75rem] - padding of the arrow when it is placed on top or bottom\n   */\n  --sh-pane-arrow-placement-padding: 0.75rem;\n  /* \n   * @cssprop [--sh-pane-arrow-position=-2rem] - position of the arrow from the left or right\n   */\n  --sh-pane-arrow-position: -2rem;\n  /* \n   * @cssprop [--sh-pane-condensed-width=6.25rem] - max-width of the condensed wrapper\n   */\n  --sh-pane-condensed-width: 6.25rem;\n  /* \n   * @cssprop [--sh-pane-body-wrapper-margin=0.5rem] - margin of the elements inside the body slot\n   */\n  --sh-pane-body-wrapper-margin: 0.5rem;\n  /* \n   * @cssprop [--sh-pane-arrow-wrapper-padding=0.25rem 0] - padding of the arrow wrapper to center align the arrow icon\n   */\n  --sh-pane-arrow-wrapper-padding: 0.25rem 0;\n  /* \n   * @cssprop [--sh-pane-border-radius-left=0rem 0.125rem 0.125rem 0rem] - border-radius of the left pane\n   */\n  --sh-pane-border-radius-left: 0rem 0.125rem 0.125rem 0rem;\n  /* \n   * @cssprop [--sh-pane-border-radius-right=0.125rem 0rem 0rem 0.125rem] - border-radius of the right pane\n   */\n  --sh-pane-border-radius-right: 0.125rem 0rem 0rem 0.125rem;\n  /* \n   * @cssprop [--sh-pane-box-shadow-left=0.125rem 0rem 0.25rem rgba(0, 0, 0, 0.1)] - box-shadow of the left pane\n   */\n  --sh-pane-box-shadow-left: 0.125rem 0rem 0.25rem rgba(0, 0, 0, 0.1);\n  /* \n   * @cssprop [--sh-pane-box-shadow-right=-0.125rem 0rem 0.25rem rgba(0, 0, 0, 0.1)] - box-shadow of the right pane\n   */\n  --sh-pane-box-shadow-right: -0.125rem 0rem 0.25rem rgba(0, 0, 0, 0.1);\n  /* \n   * @cssprop [--sh-pane-slot-child-margin-left=0.5rem] - Left margin of the items placed inside functions, footer slot\n   */\n  --sh-pane-slot-child-margin-left: 0.5rem;\n  /* \n   * @cssprop [--sh-pane-functions-slot-last-child-margin=0rem 0rem 0 var(--sh-pane-slot-child-margin-left)] - Margin of the last item placed inside functions slot\n   */\n  --sh-pane-functions-slot-last-child-margin: 0rem 0rem 0 var(--sh-pane-slot-child-margin-left);\n  /* \n   * @cssprop [--sh-pane-functions-slot-not-last-child-margin=0rem 0rem 0 var(--sh-pane-slot-child-margin-left)] - Margin of the all items except last placed inside functions slot\n   */\n  --sh-pane-functions-slot-not-last-child-margin: 0rem 0rem 0 var(--sh-pane-slot-child-margin-left);\n  /* \n   * @cssprop [--sh-pane-arrow-icon-size=2rem] - size of the arrow icon\n   */\n  --sh-pane-arrow-icon-size: 2rem;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-progress-header-line-height=1.25rem] - line-height of header\n   */\n  --sh-progress-header-line-height: 1.25rem;\n  /* \n   * @cssprop [--sh-progress-progress-bar-height=0.5rem] - height of the progress bar\n   */\n  --sh-progress-progress-bar-height: 0.5rem;\n  /* \n   * @cssprop [--sh-progress-indeterminate-bar-length=7.5rem] - the length of the inner bar of the indeterminate progress bar\n   */\n  --sh-progress-indeterminate-bar-length: 7.5rem;\n  /* \n   * @cssprop [--sh-progress-info-line-height=1rem] - line height of info text\n   */\n  --sh-progress-info-line-height: 1rem;\n  /* \n   * @cssprop [--sh-progress-header-margin-bottom=0.5rem] - margin bottom of header\n   */\n  --sh-progress-header-margin-bottom: 0.5rem;\n  /* \n   * @cssprop [--sh-progress-footer-margin-top=0.5rem] - margin-top of footer of linear-progress (the radial-progress footer has same margin-top as radial-progress header margin-bottom)\n   */\n  --sh-progress-footer-margin-top: 0.5rem;\n  /* \n   * @cssprop [--sh-progress-footer-height=1rem] - the height of the footer of linear-progress\n   */\n  --sh-progress-footer-height: 1rem;\n  /* \n   * @cssprop [--sh-progress-radial-header-margin-bottom=var(--sh-progress-header-margin-bottom)] - margin-bottom of header for radial progress\n   */\n  --sh-progress-radial-header-margin-bottom: var(--sh-progress-header-margin-bottom);\n  /* \n   * @cssprop [--sh-progress-radial-progress-height-xs=1rem] - height of radial progress of size xs\n   */\n  --sh-progress-radial-progress-height-xs: 1rem;\n  /* \n   * @cssprop [--sh-progress-radial-progress-ring-width-xs=0.25rem] - ring width of radial progress of size xs\n   */\n  --sh-progress-radial-progress-ring-width-xs: 0.25rem;\n  /* \n   * @cssprop [--sh-progress-radial-progress-height-s=2rem] - height of radial progress of size s\n   */\n  --sh-progress-radial-progress-height-s: 2rem;\n  /* \n   * @cssprop [--sh-progress-radial-progress-ring-width-s=0.375rem] - ring width of radial progress of size s\n   */\n  --sh-progress-radial-progress-ring-width-s: 0.375rem;\n  /* \n   * @cssprop [--sh-progress-radial-progress-height-m=4rem] - height of radial progress of size m\n   */\n  --sh-progress-radial-progress-height-m: 4rem;\n  /* \n   * @cssprop [--sh-progress-radial-progress-ring-width-m=0.5rem] - ring width of radial progress of size m\n   */\n  --sh-progress-radial-progress-ring-width-m: 0.5rem;\n  /* \n   * @cssprop [--sh-progress-radial-progress-height-l=8rem] - height of radial progress of size l\n   */\n  --sh-progress-radial-progress-height-l: 8rem;\n  /* \n   * @cssprop [--sh-progress-radial-progress-ring-width-l=0.625rem] - ring width of radial progress of size l\n   */\n  --sh-progress-radial-progress-ring-width-l: 0.625rem;\n  /* \n   * @cssprop [--sh-progress-radial-progress-height-xl=16rem] - height of radial progress of size xl\n   */\n  --sh-progress-radial-progress-height-xl: 16rem;\n  /* \n   * @cssprop [--sh-progress-radial-progress-ring-width-xl=0.75rem] - ring width of radial progress of size xl\n   */\n  --sh-progress-radial-progress-ring-width-xl: 0.75rem;\n  /* \n   * @cssprop [--sh-progress-radial-progress-label-width-m=2.5rem] - width of the radial progress label when progress size is m\n   */\n  --sh-progress-radial-progress-label-width-m: 2.5rem;\n  /* \n   * @cssprop [--sh-progress-radial-progress-label-width-l=5.5rem] - width of the radial progress label when progress size is l\n   */\n  --sh-progress-radial-progress-label-width-l: 5.5rem;\n  /* \n   * @cssprop [--sh-progress-radial-progress-label-width-xl=10.25rem] - width of the radial progress label when progress size is xl\n   */\n  --sh-progress-radial-progress-label-width-xl: 10.25rem;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-pagination-wrapper-height=2rem] - height of the pagination wrapper\n   */\n  --sh-pagination-wrapper-height: 2rem;\n  /* \n   * @cssprop [--sh-pagination-height=1.5rem] - height of the page number box\n   */\n  --sh-pagination-height: 1.5rem;\n  /* \n   * @cssprop [--sh-pagination-width=1.5rem] - width of the page number box\n   */\n  --sh-pagination-width: 1.5rem;\n  /* \n   * @cssprop [--sh-pagination-line-height=1.5rem] - line-height of the page number box\n   */\n  --sh-pagination-line-height: 1.5rem;\n  /* \n   * @cssprop [--sh-pagination-li-right-margin=0.5rem] - right margin of the li\n   */\n  --sh-pagination-li-right-margin: 0.5rem;\n  /* \n   * @cssprop [--sh-pagination-border-radius=0.75rem] - border-radius of the li\n   */\n  --sh-pagination-border-radius: 0.75rem;\n  /* \n   * @cssprop [--sh-pagination-prev-page-icon-right-margin=1rem] - right margin of the page icon\n   */\n  --sh-pagination-prev-page-icon-right-margin: 1rem;\n  /* \n   * @cssprop [--sh-pagination-next-page-icon-left-margin=0.5rem] - left margin of the next page icon\n   */\n  --sh-pagination-next-page-icon-left-margin: 0.5rem;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-split-button-icon-wrapper-width=2rem] - width of icon wrapper\n   */\n  --sh-split-button-icon-wrapper-width: 2rem;\n  /* \n   * @cssprop [--sh-split-button-current-scale=s] - the current scale of split-button used to set overlayTargetDistance for popover\n   */\n  --sh-split-button-current-scale: s;\n}\n\n:root,\n[sh-scale=s] {\n  /* \n   * @cssprop [--sh-drawer-width=22rem] - drawer width\n   */\n  --sh-drawer-width: 22rem;\n  /* \n   * @cssprop [--sh-drawer-header-wrapper-padding=1rem] - padding of the header-wrapper\n   */\n  --sh-drawer-header-wrapper-padding: 1rem;\n  /* \n   * @cssprop [--sh-drawer-label-wrapper-padding=1rem] - padding of the label-wrapper\n   */\n  --sh-drawer-label-wrapper-padding: 1rem;\n  /* \n   * @cssprop [--sh-drawer-gap-between-function-footer-slot-elements=0.5rem] - gap between function and footer slot elements\n   */\n  --sh-drawer-gap-between-function-footer-slot-elements: 0.5rem;\n  /* \n   * @cssprop [--sh-drawer-body-wrapper-padding=0 1rem] - padding of the body-wrapper\n   */\n  --sh-drawer-body-wrapper-padding: 0 1rem;\n  /* \n   * @cssprop [--sh-drawer-menu-item-margin-top=0.5rem] - margin-top of menu-item\n   */\n  --sh-drawer-menu-item-margin-top: 0.5rem;\n  /* \n   * @cssprop [--sh-drawer-headerless-body-wrapper-padding-top=1rem] - padding-top of body-wrapper when no header\n   */\n  --sh-drawer-headerless-body-wrapper-padding-top: 1rem;\n  /* \n   * @cssprop [--sh-drawer-footerless-body-wrapper-padding-bottom=var(--sh-drawer-headerless-body-wrapper-padding-top)] - padding bottom of body-wrapper when no footer\n   */\n  --sh-drawer-footerless-body-wrapper-padding-bottom: var(--sh-drawer-headerless-body-wrapper-padding-top);\n  /* \n   * @cssprop [--sh-drawer-body-wrapper-margin-top=0.5rem] - margin-top of elements in body-wrapper\n   */\n  --sh-drawer-body-wrapper-margin-top: 0.5rem;\n  /* \n   * @cssprop [--sh-drawer-footer-wrapper-padding=var(--sh-drawer-footerless-body-wrapper-padding-bottom)] - padding of the footer-wrapper\n   */\n  --sh-drawer-footer-wrapper-padding: var(--sh-drawer-footerless-body-wrapper-padding-bottom);\n  /* \n   * @cssprop [--sh-drawer-top-bottom-min-height=10rem] - min-height of top and bottom drawers\n   */\n  --sh-drawer-top-bottom-min-height: 10rem;\n  /* \n   * @cssprop [--sh-drawer-label-line-height=1.5rem] - line-height of the label\n   */\n  --sh-drawer-label-line-height: 1.5rem;\n  /* \n   * @cssprop [--sh-drawer-label-padding=0rem] - padding of the label\n   */\n  --sh-drawer-label-padding: 0rem;\n  /* \n   * @cssprop [--sh-drawer-label-margin-right=0.5rem] - margin-right of label\n   */\n  --sh-drawer-label-margin-right: 0.5rem;\n  /* \n   * @cssprop [--sh-drawer-touch-gap-between-function-footer-slot-elements=1rem] - gap of the elements in function and footer slot for touch\n   */\n  --sh-drawer-touch-gap-between-function-footer-slot-elements: 1rem;\n}\n\nsh-page[sh-debug-outlines], sh-page[sh-vrt-mode] {\n  --sh-interactive-area-outline: 1px solid #afe8d8;\n  --sh-debug-icon-outline-1: 1px solid #901aff4f;\n  --sh-debug-icon-outline-2: 1px solid #f652ff5b;\n}\n\nsh-page[sh-vrt-mode][sh-scale=s], [sh-scale=s] {\n  --sh-interactive-area-outline: none;\n  --sh-debug-icon-outline-1: none;\n  --sh-debug-icon-outline-2: none;\n}\n\n/*\n * main definitions for scales\n * will be pulled in later at top level (<html>)\n * or for containers (<sh-page> <sh-card>)\n */\n/*\n * Global default rules\n */\n:root {\n  font-size: var(--font-size);\n  line-height: var(--line-height);\n  --sh-debug-icon-outline-1: none;\n  --sh-debug-icon-outline-2: none;\n}\n\n/*\n * Definitions of where to apply the scales\n * any tag (including html) with sh-scale=s|m|l|xl|..\n * will set the scale for all descendents\n */\n:root, [sh-scale=s] {\n  --font-size: 1rem;\n  --font-size-super-header: 1.25rem;\n  --font-size-header-1: 1rem;\n  --font-size-header-2: 1rem;\n  --font-size-title-1: 0.875rem;\n  --font-size-title-2: 0.75rem;\n  --font-size-body-1: 0.875rem;\n  --font-size-body-2: 0.75rem;\n  --line-height: 1.5rem;\n  --super-header: normal 400 var(--font-size-super-header, calc(var(--font-size) * 1.25)) bree-headline, "Arial Black", Calibri, sans-serif;\n  --header-1: normal 400 var(--font-size-header-1, var(--font-size)) bree-headline, "Arial Black", Calibri, sans-serif;\n  --header-2: normal 700 var(--font-size-header-2, var(--font-size)) siemens sans, "Open Sans", "Roboto", "Droid Sans", -apple-system, BlinkMacSystemFont, "Arial", "Calibri", sans-serif;\n  --title-1: normal 700 var(--font-size-title-1, calc(var(--font-size) * 0.875)) siemens sans, "Open Sans", "Roboto", "Droid Sans", -apple-system, BlinkMacSystemFont, "Arial", "Calibri", sans-serif;\n  --title-2: normal 700 var(--font-size-title-2, calc(var(--font-size) * 0.75)) siemens sans, "Open Sans", "Roboto", "Droid Sans", -apple-system, BlinkMacSystemFont, "Arial", "Calibri", sans-serif;\n  --body-1: normal 400 var(--font-size-body-1, calc(var(--font-size) * 0.875)) siemens sans, "Open Sans", "Roboto", "Droid Sans", -apple-system, BlinkMacSystemFont, "Arial", "Calibri", sans-serif;\n  --body-2: normal 400 var(--font-size-body-2, calc(var(--font-size) * 0.75)) siemens sans, "Open Sans", "Roboto", "Droid Sans", -apple-system, BlinkMacSystemFont, "Arial", "Calibri", sans-serif;\n  --sh-badge-icon-font-size: 1rem;\n  --sh-min-touch-size: 0rem;\n  --sh-min-touch-size: 0rem;\n  --sh-min-touch-size: 0rem;\n  --sh-min-touch-size: 0rem;\n  --sh-min-touch-size: 0;\n  --sh-switch-item-height: 2.5rem;\n  --sh-switch-item-width: 4rem;\n  --sh-switch-item-border-radius: 1.25rem;\n  --sh-switch-item-padding: 0.75rem 0.75rem;\n  --sh-switch-item-label-alignment: center;\n  --sh-switch-border-radius: 1.25rem;\n  --sh-switch-condensed-border-radius: 1rem;\n  --sh-switch-item-condensed-border-radius: 1rem;\n  --sh-switch-item-condensed-height: 1rem;\n  --sh-switch-item-condensed-padding: 0.5rem 0.75rem;\n  --sh-switch-item-icon-margin: 0.25rem 1.75rem;\n  --sh-switch-item-label-height: 1rem;\n  --sh-switch-item-icon-height: 2rem;\n  --sh-switch-item-icon-width: 2rem;\n  --sh-min-touch-size: 0rem;\n  --sh-min-touch-size: 0rem;\n  --sh-min-touch-size: 0rem;\n  --sh-input-number-icon-size: 1.9375rem;\n  --sh-min-touch-size: 0;\n  --sh-min-touch-size: 0rem;\n  --sh-interactive-area-display: none;\n}\n\n[sh-scale=m] {\n  --font-size: 1rem;\n  --font-size-super-header: 1.375rem;\n  --font-size-header-1: 1.125rem;\n  --font-size-header-2: 1.125rem;\n  --font-size-title-1: 1rem;\n  --font-size-title-2: 0.875rem;\n  --font-size-body-1: 1rem;\n  --font-size-body-2: 0.875rem;\n  --line-height: 1.5rem;\n  --super-header: normal 400 var(--font-size-super-header, calc(var(--font-size) * 1.25)) bree-headline, "Arial Black", Calibri, sans-serif;\n  --header-1: normal 400 var(--font-size-header-1, var(--font-size)) bree-headline, "Arial Black", Calibri, sans-serif;\n  --header-2: normal 700 var(--font-size-header-2, var(--font-size)) siemens sans, "Open Sans", "Roboto", "Droid Sans", -apple-system, BlinkMacSystemFont, "Arial", "Calibri", sans-serif;\n  --title-1: normal 700 var(--font-size-title-1, calc(var(--font-size) * 0.875)) siemens sans, "Open Sans", "Roboto", "Droid Sans", -apple-system, BlinkMacSystemFont, "Arial", "Calibri", sans-serif;\n  --title-2: normal 700 var(--font-size-title-2, calc(var(--font-size) * 0.75)) siemens sans, "Open Sans", "Roboto", "Droid Sans", -apple-system, BlinkMacSystemFont, "Arial", "Calibri", sans-serif;\n  --body-1: normal 400 var(--font-size-body-1, calc(var(--font-size) * 0.875)) siemens sans, "Open Sans", "Roboto", "Droid Sans", -apple-system, BlinkMacSystemFont, "Arial", "Calibri", sans-serif;\n  --body-2: normal 400 var(--font-size-body-2, calc(var(--font-size) * 0.75)) siemens sans, "Open Sans", "Roboto", "Droid Sans", -apple-system, BlinkMacSystemFont, "Arial", "Calibri", sans-serif;\n  --sh-empty-state-text-width: 27.5rem;\n  --sh-empty-state-icon-size: 4rem;\n  --sh-empty-state-margin: 1rem;\n  --sh-icon-size-xs: 2.5rem;\n  --sh-icon-size-s: 2.5rem;\n  --sh-icon-size-m: 2.5rem;\n  --sh-icon-size-l: 3rem;\n  --sh-icon-font-size-xs: 1rem;\n  --sh-icon-font-size-s: 1.5rem;\n  --sh-icon-font-size-m: 2rem;\n  --sh-icon-font-size-l: 3rem;\n  --sh-badge-icon-font-size: 1rem;\n  --sh-button-width-size-s: 7rem;\n  --sh-button-width-size-m: 10.5rem;\n  --sh-button-width-size-l: 13rem;\n  --sh-button-label-line-height: 1.75rem;\n  --sh-button-button-height: 2.5rem;\n  --sh-button-button-border-radius: 1.5rem;\n  --sh-button-button-padding: 0.375rem 1.125rem;\n  --sh-button-icon-width: 3rem;\n  --sh-button-icon-height: 3rem;\n  --sh-button-icon-size: 2rem;\n  --sh-min-touch-size: 3rem;\n  --sh-button-padding-right-left: 2.25rem;\n  --sh-text-super-header-line-height: 2rem;\n  --sh-text-header-line-height: 1.75rem;\n  --sh-text-title1-line-height: 1.75rem;\n  --sh-text-title2-line-height: 1.25rem;\n  --sh-text-body1-line-height: 1.5rem;\n  --sh-text-body2-line-height: 1.25rem;\n  --sh-toggle-height: 1.75rem;\n  --sh-toggle-border-radius: 1.25rem;\n  --sh-toggle-circle-dimension: 1.25rem;\n  --sh-toggle-width: 3rem;\n  --sh-toggle-margin: 0.125rem 0.75rem 0.125rem 0.125rem;\n  --sh-toggle-circle-top: 0.125rem;\n  --sh-toggle-circle-left: 0.125rem;\n  --sh-toggle-active-left: 1.375rem;\n  --sh-toggle-line-height: 1.75rem;\n  --sh-toggle-label-line-height: 1.5rem;\n  --sh-toggle-label-padding: 0.25rem 0rem;\n  --sh-min-touch-size: 3rem;\n  --sh-checkbox-inner-width: 1.25rem;\n  --sh-checkbox-inner-height: 1.25rem;\n  --sh-checkbox-outer-width: 2rem;\n  --sh-checkbox-outer-height: 2rem;\n  --sh-checkbox-label-line-height: 1.5rem;\n  --sh-checkbox-margin-right: 0.375rem;\n  --sh-checkbox-tick-line-height: 1.125rem;\n  --sh-checkbox-margin-around-checkbox: 0.375rem;\n  --sh-checkbox-text-indent: 0rem;\n  --sh-checkbox-label-width: 2.375rem;\n  --sh-checkbox-tick-font-size: 1rem;\n  --sh-checkbox-padding: 0rem;\n  --sh-min-touch-size: 3rem;\n  --sh-checkbox-label-padding: 0.25rem 0rem;\n  --sh-checkbox-border-width: 0.125rem;\n  --sh-breadcrumb-item-item-height: 2.5rem;\n  --sh-breadcrumb-item-item-max-width: 12rem;\n  --sh-breadcrumb-item-item-line-height: 1.5rem;\n  --sh-breadcrumb-item-item-icon-margin: 3rem;\n  --sh-breadcrumb-item-item-icon-width: 2rem;\n  --sh-radio-button-container-margin: 0;\n  --sh-radio-button-label-line-height: 1.5rem;\n  --sh-radio-button-label-padding: 0.375rem;\n  --sh-radio-button-label-margin: 0.25rem 0;\n  --sh-radio-button-width: 2rem;\n  --sh-radio-button-height: 2rem;\n  --sh-radio-button-pseudo-width: 1.25rem;\n  --sh-radio-button-pseudo-height: 1.25rem;\n  --sh-radio-button-pseudo-margin: 0.375rem;\n  --sh-radio-button-pseudo-border-width: 0.125rem;\n  --sh-radio-button-pseudo-border-width-active: 0.375rem;\n  --sh-min-touch-size: 3rem;\n  --sh-radio-group-margin: 1rem;\n  --sh-tag-container-height: 2.5rem;\n  --sh-tag-wrapper-border: 0.0625rem;\n  --sh-tag-padding: 0 0.625rem;\n  --sh-tag-label-line-height: 2.5rem;\n  --sh-tag-icon-padding: 0 0 0 0.5rem;\n  --sh-tag-border-radius: 0.125rem;\n  --sh-spinner-width-s: 2rem;\n  --sh-spinner-height-s: 2rem;\n  --sh-spinner-width-m: 3rem;\n  --sh-spinner-height-m: 3rem;\n  --sh-spinner-label-height: 1.5rem;\n  --sh-spinner-label-line-height: 1.5rem;\n  --sh-spinner-margin-top: 0.375rem;\n  --sh-tooltip-max-content-width: 29rem;\n  --sh-tooltip-content-padding: 0.25rem 0.5rem;\n  --sh-tooltip-label-line-height: 1.25rem;\n  --sh-tooltip-padding-title: 0.5rem 0.5rem;\n  --sh-tooltip-title-line-height: 1.25rem;\n  --sh-switch-item-height: 3rem;\n  --sh-switch-item-width: 5.25rem;\n  --sh-switch-item-border-radius: 1.5rem;\n  --sh-switch-item-padding: 0.875rem 0.875rem;\n  --sh-switch-item-label-alignment: center;\n  --sh-switch-border-radius: 1.5rem;\n  --sh-switch-condensed-border-radius: 1.25rem;\n  --sh-switch-item-condensed-border-radius: 1.25rem;\n  --sh-switch-item-condensed-height: 1.5rem;\n  --sh-switch-item-condensed-padding: 0.5rem 0.875rem;\n  --sh-switch-item-icon-margin: 0.5rem 2.5rem;\n  --sh-switch-item-label-height: 1.25rem;\n  --sh-switch-item-icon-height: 2rem;\n  --sh-switch-item-icon-width: 2rem;\n  --sh-min-touch-size: 3rem;\n  --sh-search-icon-top: 0.25rem;\n  --sh-search-icon-left: 0rem;\n  --sh-search-input-height: 3rem;\n  --sh-search-value-line-height: 1.5rem;\n  --sh-search-input-padding: 0.75rem 2.5rem;\n  --sh-search-border-radius: 0.125rem 0.125rem 0rem 0rem;\n  --sh-search-border-bottom-thickness: 0.0625rem;\n  --sh-search-list-item-height: 3rem;\n  --sh-search-single-line-list-item-padding: 0.75rem 0.5rem;\n  --sh-search-list-item-line-height: 1.5rem;\n  --sh-search-close-icon-right: 0rem;\n  --sh-search-multi-line-list-item-padding: 0.25rem 0.5rem;\n  --sh-search-multi-line-list-item-height: 3rem;\n  --sh-search-multi-line-single-item-height: 1.25rem;\n  --sh-search-empty-slot-item-gap: 1rem;\n  --sh-search-empty-wrapper-padding: var(--sh-search-empty-slot-item-gap) 0.5rem;\n  --sh-search-list-view-max-height: 16.5rem;\n  --sh-input-text-label-left: 0.5rem;\n  --sh-input-text-empty-label-top: 0.75rem;\n  --sh-input-text-empty-label-line-height: 1.5rem;\n  --sh-input-text-empty-padding: 0.75rem 0 0.6875rem 0.5rem;\n  --sh-input-text-height: 2.9375rem;\n  --sh-input-text-padding: 1.5rem 0 0.1875rem 0.5rem;\n  --sh-input-text-label-top: 0.25rem;\n  --sh-input-text-label-line-height: 1.25rem;\n  --sh-input-text-empty-no-border-padding-bottom: 0.75rem;\n  --sh-input-text-no-border-padding-bottom: 0.25rem;\n  --sh-input-text-no-border-condensed-padding-bottom: 0.5rem;\n  --sh-input-text-icon-left-margin: 0.5rem;\n  --sh-input-text-icon-wrapper-right-padding: 0.5rem;\n  --sh-input-text-icon-size: 2.4375rem;\n  --sh-input-text-icon-wrapper-margin: 0.125rem;\n  --sh-input-text-helper-text-padding: 0.25rem 0.5rem 0;\n  --sh-input-text-condensed-label-top: 0.5rem;\n  --sh-input-text-condensed-padding: 0.5rem 0 0.4375rem 0.5rem;\n  --sh-input-text-condensed-height: 2.4375rem;\n  --sh-input-text-textarea-label-height: 1.5rem;\n  --sh-input-text-textarea-label-padding: 0.5rem 0 0.625rem 0.5rem;\n  --sh-input-text-textarea-padding: 0 0.5rem 0.4375rem;\n  --sh-input-text-textarea-line-height: 1.5rem;\n  --sh-input-text-textarea-empty-label-line-height: 1.5rem;\n  --sh-input-text-condensed-textarea-top: 0.5rem;\n  --sh-input-text-condensed-textarea-padding: 0.5rem 0 0.4375rem 0.5rem;\n  --sh-input-text-textarea-label-line-height: 1.25rem;\n  --sh-input-text-condensed-textarea-icon-top: 0rem;\n  --sh-accordion-header-wrapper-min-height: 3rem;\n  --sh-accordion-container-padding-left-right: 0rem 1rem;\n  --sh-accordion-wrapper-padding-bottom: 1rem;\n  --sh-accordion-label-line-height: 1.75rem;\n  --sh-accordion-expand-icon-margin: 0.25rem -0.5rem 0.25rem 0;\n  --sh-accordion-icon-padding: 0.75rem 0.5rem 0.75rem 0;\n  --sh-accordion-content-items-margin-top: 1rem;\n  --sh-accordion-content-items-margin-top-touch: 1rem;\n  --sh-accordion-content-first-item-margin-top: 0.5rem;\n  --sh-accordion-header-label-info-padding: 0.625rem 0.5rem 0.625rem 0;\n  --sh-user-identifier-margin-left: 0.5rem;\n  --sh-user-identifier-height: 1.25rem;\n  --sh-user-identifier-circle-dimension: 2rem;\n  --sh-user-identifier-image-circle: 2.5rem;\n  --sh-user-identifier-margin: 0.25rem;\n  --sh-user-identifier-max-width: 11.5rem;\n  --sh-stepper-circle-dimension: 2rem;\n  --sh-stepper-circle-line-height: 2rem;\n  --sh-stepper-label-line-height: 1.75rem;\n  --sh-stepper-info-line-height: 1.25rem;\n  --sh-stepper-line-top: 0.9375rem;\n  --sh-stepper-line-width: 1.5rem;\n  --sh-stepper-line-border-width: 0.125rem;\n  --sh-stepper-badge-top: -0.25rem;\n  --sh-stepper-badge-right: -0.375rem;\n  --sh-stepper-icon-size: 1rem;\n  --sh-stepper-font-size: 1rem;\n  --sh-stepper-condensed-circle-dimension: 0.875rem;\n  --sh-stepper-condensed-border-width: 0.125rem;\n  --sh-stepper-condensed-badge-top: -0.1875rem;\n  --sh-stepper-condensed-badge-right: -0.1875rem;\n  --sh-stepper-condensed-line-top: 0.4375rem;\n  --sh-stepper-condensed-line-width: 0.625rem;\n  --sh-nav-bar-nav-bar-wrapper-height: 3.75rem;\n  --sh-nav-bar-condensed-nav-bar-wrapper-height: 3rem;\n  --sh-nav-bar-functions-wrapper-gap: 0.75rem;\n  --sh-nav-bar-functions-wrapper-padding: 0 0 0 0.75rem;\n  --sh-nav-bar-nav-bar-wrapper-padding: 0 1rem;\n  --sh-value-indicator-s-label-line-height: 1.25rem;\n  --sh-value-indicator-l-label-line-height: 1.75rem;\n  --sh-value-indicator-s-value-line-height: 2.25rem;\n  --sh-value-indicator-l-value-line-height: 4rem;\n  --sh-value-indicator-l-unit-line-height: 2.625rem;\n  --sh-value-indicator-s-unit-line-height: 1.5rem;\n  --sh-value-indicator-s-unit-padding-top: 0.625rem;\n  --sh-value-indicator-l-unit-padding-top: 1.6rem;\n  --sh-value-indicator-l-unit-font-size: 2rem;\n  --sh-value-indicator-s-unit-font-size: 1rem;\n  --sh-value-indicator-l-icon-size-m: 4rem;\n  --sh-value-indicator-s-icon-size-m: 2rem;\n  --sh-value-indicator-s-icon-font-size-m: 2rem;\n  --sh-value-indicator-l-icon-font-size-m: 4rem;\n  --sh-value-indicator-l-label-font-size: 1.125rem;\n  --sh-value-indicator-s-label-font-size: 1rem;\n  --sh-value-indicator-l-value-font-size: 4rem;\n  --sh-value-indicator-s-value-font-size: 2rem;\n  --sh-value-indicator-s-status-size-m: 1.5rem;\n  --sh-value-indicator-s-status-font-size-m: 1.5rem;\n  --sh-value-indicator-s-icon-margin-right: 0.25rem;\n  --sh-value-indicator-l-icon-margin-right: 0.5rem;\n  --sh-notification-width: 20rem;\n  --sh-notification-item-header-margin: 0.5rem 0.5rem 0 1rem;\n  --sh-notification-item-header-icon-margin: 0.5rem 0.5rem 0.5rem 0;\n  --sh-notification-item-header-line-height: 1.75rem;\n  --sh-notification-item-header-max-height: 3.5rem;\n  --sh-notification-item-header-text-margin: 0.375rem 0.5rem 0.375rem 0;\n  --sh-notification-item-header-close-button-margin: 0rem 0.5rem 0 0;\n  --sh-notification-item-description-container-margin: 0.5rem 1rem 1rem 1rem;\n  --sh-notification-item-no-label-description-container-margin: 0.5rem 0.5rem 1rem 1rem;\n  --sh-notification-item-description-icon-margin: 0.5rem 0.5rem 0 0;\n  --sh-notification-item-description-line-height: 1.5rem;\n  --sh-notification-item-description-text-margin: 0.5rem 0.5rem 0rem 0;\n  --sh-notification-item-description-close-button-margin: -1rem;\n  --sh-notification-item-footer-margin: 0 1rem 1rem 1rem;\n  --sh-notification-item-description-slot-elements-margin-top: 1rem;\n  --sh-notification-item-badge-margin: 1rem 1rem 0.5rem 1rem;\n  --sh-notification-item-footer-slot-child-margin-left: 0.75rem;\n  --sh-input-number-icon-size: 2.4375rem;\n  --sh-input-number-input-right-padding: 0.25rem;\n  --sh-input-number-left-icon-padding: 0 0 0 0.5rem;\n  --sh-input-number-right-icon-padding: 0 0 0 0.5rem;\n  --sh-numeric-keypad-width: 11rem;\n  --sh-numeric-keypad-height: 15rem;\n  --sh-numeric-keypad-circle-button-height: 3rem;\n  --sh-numeric-keypad-circle-button-width: 3rem;\n  --sh-numeric-keypad-container-padding: 1rem;\n  --sh-numeric-keypad-button-margins: 0.5rem;\n  --sh-numeric-keypad-button-center-margin: 0 0.5rem;\n  --sh-pane-wrapper-width: 22rem;\n  --sh-pane-wrapper-padding: 1rem;\n  --sh-pane-arrow-placement-padding: 0.75rem;\n  --sh-pane-arrow-position: -2rem;\n  --sh-pane-condensed-width: 6.875rem;\n  --sh-pane-body-wrapper-margin: 1rem;\n  --sh-pane-arrow-wrapper-padding: 0.25rem 0;\n  --sh-pane-slot-child-margin-left: 0.75rem;\n  --sh-pane-functions-slot-last-child-margin: 0rem 0rem 0 var(--sh-pane-slot-child-margin-left);\n  --sh-pane-functions-slot-not-last-child-margin: 0rem 0rem 0 var(--sh-pane-slot-child-margin-left);\n  --sh-pane-arrow-icon-size: 2rem;\n  --sh-progress-header-line-height: 1.75rem;\n  --sh-progress-progress-bar-height: 0.5rem;\n  --sh-progress-info-line-height: 1.5rem;\n  --sh-progress-header-margin-bottom: 0.5rem;\n  --sh-progress-footer-margin-top: 0rem;\n  --sh-progress-radial-header-margin-bottom: var(--sh-progress-header-margin-bottom);\n  --sh-progress-radial-progress-height-xs: 1rem;\n  --sh-progress-radial-progress-ring-width-xs: 0.25rem;\n  --sh-progress-radial-progress-height-s: 2rem;\n  --sh-progress-radial-progress-ring-width-s: 0.375rem;\n  --sh-progress-radial-progress-height-m: 4.5rem;\n  --sh-progress-radial-progress-ring-width-m: 0.5rem;\n  --sh-progress-radial-progress-height-l: 8.5rem;\n  --sh-progress-radial-progress-ring-width-l: 0.625rem;\n  --sh-progress-radial-progress-height-xl: 17rem;\n  --sh-progress-radial-progress-ring-width-xl: 0.75rem;\n  --sh-progress-indeterminate-bar-length: 7.5rem;\n  --sh-progress-radial-progress-label-width-m: 3rem;\n  --sh-progress-radial-progress-label-width-l: 6rem;\n  --sh-progress-radial-progress-label-width-xl: 12rem;\n  --sh-pagination-wrapper-height: 2.5rem;\n  --sh-pagination-height: 2rem;\n  --sh-pagination-width: 2rem;\n  --sh-pagination-line-height: 2rem;\n  --sh-pagination-li-right-margin: 1rem;\n  --sh-pagination-border-radius: 1rem;\n  --sh-pagination-prev-page-icon-right-margin: 1rem;\n  --sh-pagination-next-page-icon-left-margin: 0;\n  --sh-min-touch-size: 3rem;\n  --sh-split-button-icon-wrapper-width: 3rem;\n  --sh-split-button-current-scale: m;\n  --sh-min-touch-size: 3rem;\n  --sh-drawer-width: 23rem;\n  --sh-drawer-header-wrapper-padding: 1rem;\n  --sh-drawer-label-wrapper-padding: 0.5rem 1rem;\n  --sh-drawer-gap-between-function-footer-slot-elements: 0.75rem;\n  --sh-drawer-body-wrapper-padding: 0 1rem;\n  --sh-drawer-menu-item-margin-top: 0rem;\n  --sh-drawer-headerless-body-wrapper-padding-top: 1rem;\n  --sh-drawer-footerless-body-wrapper-padding-bottom: var(--sh-drawer-headerless-body-wrapper-padding-top);\n  --sh-drawer-body-wrapper-margin-top: 1rem;\n  --sh-drawer-footer-wrapper-padding: var(--sh-drawer-footerless-body-wrapper-padding-bottom);\n  --sh-drawer-top-bottom-min-height: 11rem;\n  --sh-drawer-label-line-height: 1.75rem;\n  --sh-drawer-label-padding: 0.375rem 0;\n  --sh-drawer-label-margin-right: 0.5rem;\n  --sh-drawer-touch-gap-between-function-footer-slot-elements: 0.75rem;\n  --sh-interactive-area-display: block;\n  --sh-interactive-area-min-touch-size: 3rem;\n}\n\n[sh-scale=l] {\n  --font-size: 1rem;\n  --font-size-super-header: 1.5rem;\n  --font-size-header-1: 1.25rem;\n  --font-size-header-2: 1.25rem;\n  --font-size-title-1: 1.125rem;\n  --font-size-title-2: 1rem;\n  --font-size-body-1: 1.125rem;\n  --font-size-body-2: 1rem;\n  --line-height: 1.5rem;\n  --super-header: normal 400 var(--font-size-super-header, calc(var(--font-size) * 1.25)) bree-headline, "Arial Black", Calibri, sans-serif;\n  --header-1: normal 400 var(--font-size-header-1, var(--font-size)) bree-headline, "Arial Black", Calibri, sans-serif;\n  --header-2: normal 700 var(--font-size-header-2, var(--font-size)) siemens sans, "Open Sans", "Roboto", "Droid Sans", -apple-system, BlinkMacSystemFont, "Arial", "Calibri", sans-serif;\n  --title-1: normal 700 var(--font-size-title-1, calc(var(--font-size) * 0.875)) siemens sans, "Open Sans", "Roboto", "Droid Sans", -apple-system, BlinkMacSystemFont, "Arial", "Calibri", sans-serif;\n  --title-2: normal 700 var(--font-size-title-2, calc(var(--font-size) * 0.75)) siemens sans, "Open Sans", "Roboto", "Droid Sans", -apple-system, BlinkMacSystemFont, "Arial", "Calibri", sans-serif;\n  --body-1: normal 400 var(--font-size-body-1, calc(var(--font-size) * 0.875)) siemens sans, "Open Sans", "Roboto", "Droid Sans", -apple-system, BlinkMacSystemFont, "Arial", "Calibri", sans-serif;\n  --body-2: normal 400 var(--font-size-body-2, calc(var(--font-size) * 0.75)) siemens sans, "Open Sans", "Roboto", "Droid Sans", -apple-system, BlinkMacSystemFont, "Arial", "Calibri", sans-serif;\n  --sh-empty-state-icon-size: 5rem;\n  --sh-empty-state-text-width: 31rem;\n  --sh-empty-state-margin: 1.25rem;\n  --sh-icon-size-xs: 3rem;\n  --sh-icon-size-s: 3rem;\n  --sh-icon-size-m: 3rem;\n  --sh-icon-size-l: 3.5rem;\n  --sh-icon-font-size-xs: 1.5rem;\n  --sh-icon-font-size-s: 2rem;\n  --sh-icon-font-size-m: 2.5rem;\n  --sh-icon-font-size-l: 3.5rem;\n  --sh-icon-badge-bottom: calc(100% - 0.375rem);\n  --sh-icon-badge-left: calc(100% - 0.375rem);\n  --sh-badge-min-width: 1.5rem;\n  --sh-badge-max-width: 5rem;\n  --sh-badge-height: 1.5rem;\n  --sh-badge-line-height: 1rem;\n  --sh-badge-font-size: 0.75rem;\n  --sh-badge-no-label-size: 0.75rem;\n  --sh-badge-padding: 0.275rem 0.375rem 0.275rem 0.375rem;\n  --sh-badge-icon-font-size: 1.5rem;\n  --sh-button-width-size-s: 7.5rem;\n  --sh-button-width-size-m: 12rem;\n  --sh-button-width-size-l: 14.5rem;\n  --sh-button-label-line-height: 1.75rem;\n  --sh-button-button-height: 3rem;\n  --sh-button-button-border-radius: 1.5rem;\n  --sh-button-button-padding: 0.625rem 1.25rem;\n  --sh-button-icon-width: 3.5rem;\n  --sh-button-icon-height: 3.5rem;\n  --sh-button-icon-size: 2.5rem;\n  --sh-min-touch-size: 3.5rem;\n  --sh-button-padding-right-left: 2.5rem;\n  --sh-text-super-header-line-height: 2rem;\n  --sh-text-header-line-height: 1.75rem;\n  --sh-text-title1-line-height: 1.75rem;\n  --sh-text-title2-line-height: 1.5rem;\n  --sh-text-body1-line-height: 1.75rem;\n  --sh-text-body2-line-height: 1.5rem;\n  --sh-toggle-height: 2rem;\n  --sh-toggle-border-radius: 1.5rem;\n  --sh-toggle-circle-dimension: 1.5rem;\n  --sh-toggle-width: 3.5rem;\n  --sh-toggle-margin: 0.25rem 1rem 0.25rem 0.25rem;\n  --sh-toggle-circle-top: 0.125rem;\n  --sh-toggle-circle-left: 0.125rem;\n  --sh-toggle-active-left: 1.625rem;\n  --sh-toggle-line-height: 2rem;\n  --sh-toggle-label-line-height: 1.75rem;\n  --sh-toggle-label-padding: 0.375rem 0rem;\n  --sh-min-touch-size: 3.5rem;\n  --sh-checkbox-inner-width: 1.5rem;\n  --sh-checkbox-inner-height: 1.5rem;\n  --sh-checkbox-outer-width: 2.5rem;\n  --sh-checkbox-outer-height: 2.5rem;\n  --sh-checkbox-label-line-height: 1.75rem;\n  --sh-checkbox-margin-right: 0.5rem;\n  --sh-checkbox-tick-line-height: 1.365rem;\n  --sh-checkbox-margin-around-checkbox: 0.5rem;\n  --sh-checkbox-text-indent: 0rem;\n  --sh-checkbox-label-width: 3rem;\n  --sh-checkbox-tick-font-size: 1.25rem;\n  --sh-checkbox-padding: 0rem;\n  --sh-min-touch-size: 3.5rem;\n  --sh-checkbox-label-padding: 0.375rem 0rem;\n  --sh-checkbox-border-width: 0.125rem;\n  --sh-breadcrumb-item-item-height: 3rem;\n  --sh-breadcrumb-item-item-max-width: 14rem;\n  --sh-breadcrumb-item-item-line-height: 1.75rem;\n  --sh-breadcrumb-item-item-icon-margin: 3rem;\n  --sh-breadcrumb-item-item-icon-width: 2.5rem;\n  --sh-radio-button-container-margin: 0;\n  --sh-radio-button-label-line-height: 1.75rem;\n  --sh-radio-button-label-padding: 0.5rem;\n  --sh-radio-button-label-margin: 0.375rem 0;\n  --sh-radio-button-width: 2.5rem;\n  --sh-radio-button-height: 2.5rem;\n  --sh-radio-button-pseudo-width: 1.5rem;\n  --sh-radio-button-pseudo-height: 1.5rem;\n  --sh-radio-button-pseudo-margin: 0.5rem;\n  --sh-radio-button-pseudo-border-width: 0.125rem;\n  --sh-radio-button-pseudo-border-width-active: 0.4375rem;\n  --sh-min-touch-size: 3.5rem;\n  --sh-radio-group-margin: 1.5rem;\n  --sh-tag-container-height: 3rem;\n  --sh-tag-wrapper-border: 0.0625rem;\n  --sh-tag-padding: 0 0.75rem;\n  --sh-tag-label-line-height: 3rem;\n  --sh-tag-icon-padding: 0 0 0 0.5rem;\n  --sh-tag-border-radius: 0.125rem;\n  --sh-spinner-width-s: 2.5rem;\n  --sh-spinner-height-s: 2.5rem;\n  --sh-spinner-width-m: 3.5rem;\n  --sh-spinner-height-m: 3.5rem;\n  --sh-spinner-label-height: 1.75rem;\n  --sh-spinner-label-line-height: 1.75rem;\n  --sh-spinner-margin-top: 0.5rem;\n  --sh-tooltip-max-content-width: 33.5rem;\n  --sh-tooltip-content-padding: 0.5rem 0.75rem;\n  --sh-tooltip-label-line-height: 1.5rem;\n  --sh-tooltip-padding-title: 0.75rem 0.75rem;\n  --sh-tooltip-title-line-height: 1.25rem;\n  --sh-switch-item-height: 3rem;\n  --sh-switch-item-width: 6rem;\n  --sh-switch-item-padding: 1rem 1.25rem;\n  --sh-switch-item-border-radius: 1.75rem;\n  --sh-switch-item-label-alignment: center;\n  --sh-switch-border-radius: 1.75rem;\n  --sh-switch-condensed-border-radius: 1.5rem;\n  --sh-switch-item-condensed-border-radius: 1.5rem;\n  --sh-switch-item-condensed-height: 2rem;\n  --sh-switch-item-condensed-padding: 0.5rem 1.25rem;\n  --sh-switch-item-icon-margin: 0.5rem 3rem;\n  --sh-switch-item-label-height: 1.5rem;\n  --sh-switch-item-icon-height: 2.5rem;\n  --sh-switch-item-icon-width: 2.5rem;\n  --sh-min-touch-size: 3.5rem;\n  --sh-search-icon-top: 0.25rem;\n  --sh-search-icon-left: 0.25rem;\n  --sh-search-input-height: 3.5rem;\n  --sh-search-value-line-height: 1.75rem;\n  --sh-search-input-padding: 0.875rem 3.5rem;\n  --sh-search-border-radius: 0.125rem 0.125rem 0rem 0rem;\n  --sh-search-border-bottom-thickness: 0.0625rem;\n  --sh-search-list-item-height: 3.5rem;\n  --sh-search-single-line-list-item-padding: 0.875rem 0.75rem;\n  --sh-search-list-item-line-height: 1.75rem;\n  --sh-search-close-icon-right: 0.25rem;\n  --sh-search-multi-line-list-item-padding: 0.25rem 0.75rem;\n  --sh-search-multi-line-list-item-height: 3.5rem;\n  --sh-search-multi-line-single-item-height: 1.5rem;\n  --sh-search-empty-slot-item-gap: 1.25rem;\n  --sh-search-empty-wrapper-padding: var(--sh-search-empty-slot-item-gap) 0.75rem;\n  --sh-search-list-view-max-height: 19.25rem;\n  --sh-input-text-label-left: 0.75rem;\n  --sh-input-text-empty-label-top: 0.875rem;\n  --sh-input-text-empty-label-line-height: 1.75rem;\n  --sh-input-text-empty-padding: 0.875rem 0 0.8125rem 0.75rem;\n  --sh-input-text-height: 3.4375rem;\n  --sh-input-text-padding: 1.75rem 0 0.1875rem 0.75rem;\n  --sh-input-text-label-top: 0.25rem;\n  --sh-input-text-label-line-height: 1.5rem;\n  --sh-input-text-empty-no-border-padding-bottom: 0.875rem;\n  --sh-input-text-no-border-padding-bottom: 0.25rem;\n  --sh-input-text-no-border-condensed-padding-bottom: 0.625rem;\n  --sh-input-text-icon-left-margin: 0.5rem;\n  --sh-input-text-icon-wrapper-right-padding: 0.75rem;\n  --sh-input-text-icon-size: 2.9375rem;\n  --sh-input-text-icon-wrapper-margin: 0.25rem;\n  --sh-input-text-helper-text-padding: 0.25rem 0.75rem 0;\n  --sh-input-text-condensed-label-top: 0.625rem;\n  --sh-input-text-condensed-padding: 0.625rem 0 0.5625rem 0.75rem;\n  --sh-input-text-condensed-height: 2.9375rem;\n  --sh-input-text-textarea-label-height: 2rem;\n  --sh-input-text-textarea-label-padding: 0.5rem 0 0.75rem 0.75rem;\n  --sh-input-text-textarea-padding: 0 0.75rem 0.4375rem;\n  --sh-input-text-textarea-line-height: 1.75rem;\n  --sh-input-text-textarea-empty-label-line-height: 1.75rem;\n  --sh-input-text-condensed-textarea-top: 0.5rem;\n  --sh-input-text-condensed-textarea-padding: 0.5rem 0 0.4375rem 0.75rem;\n  --sh-input-text-textarea-label-line-height: 1.5rem;\n  --sh-input-text-condensed-textarea-icon-top: 0rem;\n  --sh-accordion-header-wrapper-min-height: 3.5rem;\n  --sh-accordion-container-padding-left-right: 0rem 1.25rem;\n  --sh-accordion-wrapper-padding-bottom: 1.25rem;\n  --sh-accordion-label-line-height: 1.75rem;\n  --sh-accordion-expand-icon-margin: 0.25rem -0.5rem 0.25rem 0;\n  --sh-accordion-icon-padding: 0.875rem 0.75rem 0.875rem 0;\n  --sh-accordion-content-items-margin-top: 1.25rem;\n  --sh-accordion-content-items-margin-top-touch: 1.25rem;\n  --sh-accordion-content-first-item-margin-top: 0.625rem;\n  --sh-accordion-header-label-info-padding: 0.875rem 0.75rem 0.875rem 0;\n  --sh-user-identifier-margin-left: 0.75rem;\n  --sh-user-identifier-height: 1.5rem;\n  --sh-user-identifier-circle-dimension: 2.5rem;\n  --sh-user-identifier-image-circle: 3rem;\n  --sh-user-identifier-margin: 0.25rem;\n  --sh-user-identifier-max-width: 13rem;\n  --sh-stepper-circle-dimension: 2.5rem;\n  --sh-stepper-circle-line-height: 2.5rem;\n  --sh-stepper-label-line-height: 1.75rem;\n  --sh-stepper-info-line-height: 1.5rem;\n  --sh-stepper-line-top: 1.25rem;\n  --sh-stepper-line-width: 2rem;\n  --sh-stepper-line-border-width: 0.1875rem;\n  --sh-stepper-badge-top: -0.25rem;\n  --sh-stepper-badge-right: -0.25rem;\n  --sh-stepper-icon-size: 1.5rem;\n  --sh-stepper-font-size: 1.25rem;\n  --sh-stepper-condensed-circle-dimension: 1.125rem;\n  --sh-stepper-condensed-border-width: 0.125rem;\n  --sh-stepper-condensed-badge-top: -0.1875rem;\n  --sh-stepper-condensed-badge-right: -0.25rem;\n  --sh-stepper-condensed-line-top: 0.625rem;\n  --sh-stepper-condensed-line-width: 0.875rem;\n  --sh-nav-bar-nav-bar-wrapper-height: 4rem;\n  --sh-nav-bar-condensed-nav-bar-wrapper-height: 3.5rem;\n  --sh-nav-bar-functions-wrapper-gap: 0.75rem;\n  --sh-nav-bar-functions-wrapper-padding: 0 0 0 1.25rem;\n  --sh-nav-bar-nav-bar-wrapper-padding: 0 1.25rem;\n  --sh-value-indicator-s-label-line-height: 1.5rem;\n  --sh-value-indicator-l-label-line-height: 1.75rem;\n  --sh-value-indicator-s-value-line-height: 2.625rem;\n  --sh-value-indicator-l-value-line-height: 5rem;\n  --sh-value-indicator-l-unit-line-height: 3.375rem;\n  --sh-value-indicator-s-unit-line-height: 1.75rem;\n  --sh-value-indicator-l-unit-font-size: 2.25rem;\n  --sh-value-indicator-s-unit-font-size: 1.125rem;\n  --sh-value-indicator-s-unit-padding-top: 0.75rem;\n  --sh-value-indicator-l-unit-padding-top: 2rem;\n  --sh-value-indicator-l-icon-size-m: 5rem;\n  --sh-value-indicator-s-icon-size-m: 2.5rem;\n  --sh-value-indicator-s-icon-font-size-m: 2.5rem;\n  --sh-value-indicator-l-icon-font-size-m: 5rem;\n  --sh-value-indicator-l-label-font-size: 1.25rem;\n  --sh-value-indicator-s-label-font-size: 1.125rem;\n  --sh-value-indicator-l-value-font-size: 4.5rem;\n  --sh-value-indicator-s-value-font-size: 2.25rem;\n  --sh-value-indicator-s-status-size-m: 2rem;\n  --sh-value-indicator-s-status-font-size-m: 2rem;\n  --sh-value-indicator-s-icon-margin-right: 0.5rem;\n  --sh-value-indicator-l-icon-margin-right: 0.75rem;\n  --sh-notification-width: 22rem;\n  --sh-notification-item-header-margin: 0.75rem 0.75rem 0 1.25rem;\n  --sh-notification-item-header-icon-margin: 0.5rem 0.75rem 0.5rem 0;\n  --sh-notification-item-header-line-height: 1.75rem;\n  --sh-notification-item-header-max-height: 3.5rem;\n  --sh-notification-item-header-text-margin: 0.625rem 0.75rem 0.625rem 0;\n  --sh-notification-item-header-close-button-margin: 0rem 0.75rem 0 0;\n  --sh-notification-item-description-container-margin: 0.75rem 1.25rem 1.25rem 1.25rem;\n  --sh-notification-item-no-label-description-container-margin: 0.75rem 0.75rem 1.25rem 1.25rem;\n  --sh-notification-item-description-icon-margin: 0.5rem 0.75rem 0 0;\n  --sh-notification-item-description-line-height: 1.75rem;\n  --sh-notification-item-description-text-margin: 0.625rem 0.75rem 0rem 0;\n  --sh-notification-item-description-close-button-margin: -1rem;\n  --sh-notification-item-footer-margin: 0 1.25rem 1.25rem 1.25rem;\n  --sh-notification-item-description-slot-elements-margin-top: 1.25rem;\n  --sh-notification-item-badge-margin: 1.125rem 1rem 0.5rem 1rem;\n  --sh-notification-item-footer-slot-child-margin-left: 0.75rem;\n  --sh-input-number-icon-size: 2.9375rem;\n  --sh-input-number-input-right-padding: 0.5rem;\n  --sh-input-number-left-icon-padding: 0 0 0 0.5rem;\n  --sh-input-number-right-icon-padding: 0 0 0 0.5rem;\n  --sh-input-number-status-text-padding: 0.25rem 0.75rem 0 0.75rem;\n  --sh-numeric-keypad-width: 13rem;\n  --sh-numeric-keypad-height: 17.75rem;\n  --sh-numeric-keypad-circle-button-height: 3.5rem;\n  --sh-numeric-keypad-circle-button-width: 3.5rem;\n  --sh-numeric-keypad-container-padding: 1.25rem;\n  --sh-numeric-keypad-button-margins: 0.625rem;\n  --sh-numeric-keypad-button-center-margin: 0 0.625rem;\n  --sh-pane-wrapper-width: 22.5rem;\n  --sh-pane-wrapper-padding: 1.25rem;\n  --sh-pane-arrow-placement-padding: 1rem;\n  --sh-pane-arrow-position: -2.5rem;\n  --sh-pane-condensed-width: 8rem;\n  --sh-pane-body-wrapper-margin: 1.25rem;\n  --sh-pane-arrow-wrapper-padding: 0.25rem 0;\n  --sh-pane-slot-child-margin-left: 0.75rem;\n  --sh-pane-functions-slot-last-child-margin: -0.25rem -0.25rem 0 var(--sh-pane-slot-child-margin-left);\n  --sh-pane-functions-slot-not-last-child-margin: -0.25rem 0rem 0 var(--sh-pane-slot-child-margin-left);\n  --sh-pane-arrow-icon-size: 2.5rem;\n  --sh-progress-header-line-height: 1.75rem;\n  --sh-progress-progress-bar-height: 0.625rem;\n  --sh-progress-info-line-height: 1.75rem;\n  --sh-progress-header-margin-bottom: 0.625rem;\n  --sh-progress-footer-margin-top: 0rem;\n  --sh-progress-radial-header-margin-bottom: 0.5rem;\n  --sh-progress-radial-progress-height-xs: 1.5rem;\n  --sh-progress-radial-progress-ring-width-xs: 0.25rem;\n  --sh-progress-radial-progress-height-s: 2.5rem;\n  --sh-progress-radial-progress-ring-width-s: 0.375rem;\n  --sh-progress-radial-progress-height-m: 5rem;\n  --sh-progress-radial-progress-ring-width-m: 0.5rem;\n  --sh-progress-radial-progress-height-l: 9rem;\n  --sh-progress-radial-progress-ring-width-l: 0.625rem;\n  --sh-progress-radial-progress-height-xl: 18rem;\n  --sh-progress-radial-progress-ring-width-xl: 0.75rem;\n  --sh-progress-indeterminate-bar-length: 7.5rem;\n  --sh-progress-radial-progress-label-width-m: 3.5rem;\n  --sh-progress-radial-progress-label-width-l: 6.5rem;\n  --sh-progress-radial-progress-label-width-xl: 13rem;\n  --sh-pagination-wrapper-height: 3rem;\n  --sh-pagination-height: 2.5rem;\n  --sh-pagination-width: 2.5rem;\n  --sh-pagination-line-height: 2.5rem;\n  --sh-pagination-li-right-margin: 1rem;\n  --sh-pagination-border-radius: 1.25rem;\n  --sh-pagination-prev-page-icon-right-margin: 1rem;\n  --sh-pagination-next-page-icon-left-margin: 0;\n  --sh-min-touch-size: 3.5rem;\n  --sh-split-button-icon-wrapper-width: 3.5rem;\n  --sh-split-button-current-scale: l;\n  --sh-min-touch-size: 3.5rem;\n  --sh-drawer-width: 24rem;\n  --sh-drawer-header-wrapper-padding: 1.25rem;\n  --sh-drawer-label-wrapper-padding: 0.75rem 1.25rem;\n  --sh-drawer-gap-between-function-footer-slot-elements: 0.75rem;\n  --sh-drawer-body-wrapper-padding: 0 1.25rem;\n  --sh-drawer-menu-item-margin-top: 0rem;\n  --sh-drawer-headerless-body-wrapper-padding-top: 1.25rem;\n  --sh-drawer-footerless-body-wrapper-padding-bottom: var(--sh-drawer-headerless-body-wrapper-padding-top);\n  --sh-drawer-body-wrapper-margin-top: 1.25rem;\n  --sh-drawer-footer-wrapper-padding: var(--sh-drawer-footerless-body-wrapper-padding-bottom);\n  --sh-drawer-top-bottom-min-height: 12rem;\n  --sh-drawer-label-line-height: 1.75rem;\n  --sh-drawer-label-padding: 0.625rem 0;\n  --sh-drawer-label-margin-right: 0.75rem;\n  --sh-drawer-touch-gap-between-function-footer-slot-elements: 0.75rem;\n  --sh-interactive-area-display: block;\n  --sh-interactive-area-min-touch-size: 3.5rem;\n}\n\n[sh-scale=xl] {\n  --font-size: 1rem;\n  --font-size-super-header: 1.875rem;\n  --font-size-header-1: 1.5rem;\n  --font-size-header-2: 1.5rem;\n  --font-size-title-1: 1.375rem;\n  --font-size-title-2: 1.25rem;\n  --font-size-body-1: 1.375rem;\n  --font-size-body-2: 1.25rem;\n  --line-height: 1.5rem;\n  --super-header: normal 400 var(--font-size-super-header, calc(var(--font-size) * 1.25)) bree-headline, "Arial Black", Calibri, sans-serif;\n  --header-1: normal 400 var(--font-size-header-1, var(--font-size)) bree-headline, "Arial Black", Calibri, sans-serif;\n  --header-2: normal 700 var(--font-size-header-2, var(--font-size)) siemens sans, "Open Sans", "Roboto", "Droid Sans", -apple-system, BlinkMacSystemFont, "Arial", "Calibri", sans-serif;\n  --title-1: normal 700 var(--font-size-title-1, calc(var(--font-size) * 0.875)) siemens sans, "Open Sans", "Roboto", "Droid Sans", -apple-system, BlinkMacSystemFont, "Arial", "Calibri", sans-serif;\n  --title-2: normal 700 var(--font-size-title-2, calc(var(--font-size) * 0.75)) siemens sans, "Open Sans", "Roboto", "Droid Sans", -apple-system, BlinkMacSystemFont, "Arial", "Calibri", sans-serif;\n  --body-1: normal 400 var(--font-size-body-1, calc(var(--font-size) * 0.875)) siemens sans, "Open Sans", "Roboto", "Droid Sans", -apple-system, BlinkMacSystemFont, "Arial", "Calibri", sans-serif;\n  --body-2: normal 400 var(--font-size-body-2, calc(var(--font-size) * 0.75)) siemens sans, "Open Sans", "Roboto", "Droid Sans", -apple-system, BlinkMacSystemFont, "Arial", "Calibri", sans-serif;\n  --sh-empty-state-icon-size: 6rem;\n  --sh-empty-state-text-width: 37.5rem;\n  --sh-empty-state-margin: 1.5rem;\n  --sh-icon-size-xs: 4rem;\n  --sh-icon-size-s: 4rem;\n  --sh-icon-size-m: 4rem;\n  --sh-icon-size-l: 4rem;\n  --sh-icon-font-size-xs: 2rem;\n  --sh-icon-font-size-s: 2.5rem;\n  --sh-icon-font-size-m: 3rem;\n  --sh-icon-font-size-l: 4rem;\n  --sh-icon-badge-bottom: calc(100% - 0.375rem);\n  --sh-icon-badge-left: calc(100% - 0.375rem);\n  --sh-badge-min-width: 1.5rem;\n  --sh-badge-max-width: 5rem;\n  --sh-badge-height: 1.5rem;\n  --sh-badge-line-height: 1rem;\n  --sh-badge-font-size: 0.75rem;\n  --sh-badge-no-label-size: 0.75rem;\n  --sh-badge-padding: 0.275rem 0.375rem 0.275rem 0.375rem;\n  --sh-badge-icon-font-size: 1.5rem;\n  --sh-button-width-size-s: 9rem;\n  --sh-button-width-size-m: 14.5rem;\n  --sh-button-width-size-l: 17.5rem;\n  --sh-button-label-line-height: 2.25rem;\n  --sh-button-button-height: 4rem;\n  --sh-button-button-border-radius: 2rem;\n  --sh-button-button-padding: 0.875rem 1.375rem;\n  --sh-button-icon-width: 4rem;\n  --sh-button-icon-height: 4rem;\n  --sh-button-icon-size: 2.5rem;\n  --sh-min-touch-size: 4.5rem;\n  --sh-button-padding-right-left: 2.75rem;\n  --sh-button-flex-shrink-icon: 0;\n  --sh-text-super-header-line-height: 2.5rem;\n  --sh-text-header-line-height: 2.25rem;\n  --sh-text-title1-line-height: 2.25rem;\n  --sh-text-title2-line-height: 2.25rem;\n  --sh-text-body1-line-height: 2rem;\n  --sh-text-body2-line-height: 1.75rem;\n  --sh-toggle-height: 2.25rem;\n  --sh-toggle-border-radius: 1.75rem;\n  --sh-toggle-circle-dimension: 1.625rem;\n  --sh-toggle-width: 4rem;\n  --sh-toggle-margin: 0.375rem 1rem 0.375rem 0.375rem;\n  --sh-toggle-circle-top: 0.125rem;\n  --sh-toggle-circle-left: 0.125rem;\n  --sh-toggle-active-left: 1.875rem;\n  --sh-toggle-line-height: 2.25rem;\n  --sh-toggle-label-line-height: 2rem;\n  --sh-toggle-label-padding: 0.5rem 0rem;\n  --sh-toggle-border-width: 0.1875rem;\n  --sh-min-touch-size: 4.5rem;\n  --sh-checkbox-inner-width: 1.625rem;\n  --sh-checkbox-inner-height: 1.625rem;\n  --sh-checkbox-outer-width: 2.75rem;\n  --sh-checkbox-outer-height: 2.75rem;\n  --sh-checkbox-label-line-height: 2rem;\n  --sh-checkbox-margin-right: 0.5rem;\n  --sh-checkbox-tick-line-height: 1.25rem;\n  --sh-checkbox-margin-around-checkbox: 0.5625rem;\n  --sh-checkbox-text-indent: -0.0625rem;\n  --sh-checkbox-label-width: 3.25rem;\n  --sh-checkbox-tick-font-size: 1.375rem;\n  --sh-checkbox-padding: 0.125rem;\n  --sh-min-touch-size: 4.5rem;\n  --sh-checkbox-label-padding: 0.375rem 0rem;\n  --sh-checkbox-border-width: 0.1875rem;\n  --sh-breadcrumb-item-item-height: 4rem;\n  --sh-breadcrumb-item-item-max-width: 16rem;\n  --sh-breadcrumb-item-item-line-height: 2rem;\n  --sh-breadcrumb-item-item-icon-margin: 3rem;\n  --sh-breadcrumb-item-item-icon-width: 3rem;\n  --sh-radio-button-container-margin: 0.125rem 0;\n  --sh-radio-button-label-line-height: 2rem;\n  --sh-radio-button-label-padding: 0.5rem;\n  --sh-radio-button-label-margin: 0.375rem 0;\n  --sh-radio-button-width: 2.75rem;\n  --sh-radio-button-height: 2.75rem;\n  --sh-radio-button-pseudo-width: 1.75rem;\n  --sh-radio-button-pseudo-height: 1.75rem;\n  --sh-radio-button-pseudo-margin: 0.5rem;\n  --sh-radio-button-pseudo-border-width: 0.1875rem;\n  --sh-radio-button-pseudo-border-width-active: 0.5rem;\n  --sh-min-touch-size: 4.5rem;\n  --sh-radio-group-margin: 2rem;\n  --sh-tag-container-height: 4rem;\n  --sh-tag-wrapper-border: 0.125rem;\n  --sh-tag-padding: 0 1rem;\n  --sh-tag-label-line-height: 4rem;\n  --sh-tag-icon-padding: 0 0 0 0.5rem;\n  --sh-tag-border-radius: 0.1875rem;\n  --sh-spinner-width-s: 3rem;\n  --sh-spinner-height-s: 3rem;\n  --sh-spinner-width-m: 4rem;\n  --sh-spinner-height-m: 4rem;\n  --sh-spinner-label-height: 2rem;\n  --sh-spinner-label-line-height: 2rem;\n  --sh-spinner-margin-top: 0.625rem;\n  --sh-tooltip-max-content-width: 42rem;\n  --sh-tooltip-content-padding: 0.5rem 1rem;\n  --sh-tooltip-label-line-height: 1.75rem;\n  --sh-tooltip-padding-title: 0.75rem 1rem;\n  --sh-tooltip-title-line-height: 2.25rem;\n  --sh-switch-item-height: 4.5rem;\n  --sh-switch-item-width: 7.25rem;\n  --sh-switch-item-border-radius: 2.25rem;\n  --sh-switch-item-padding: 1.375rem 1.375rem;\n  --sh-switch-item-label-alignment: center;\n  --sh-switch-border-radius: 2.25rem;\n  --sh-switch-condensed-border-radius: 2rem;\n  --sh-switch-item-condensed-border-radius: 2rem;\n  --sh-switch-item-condensed-height: 3rem;\n  --sh-switch-item-condensed-padding: 0.5rem 1.375rem;\n  --sh-switch-item-icon-margin: 0.5rem 3.5rem;\n  --sh-switch-item-label-height: 1.75rem;\n  --sh-switch-item-icon-height: 3.5rem;\n  --sh-switch-item-icon-width: 3rem;\n  --sh-min-touch-size: 4.5rem;\n  --sh-search-icon-top: 0.25rem;\n  --sh-search-icon-left: 0rem;\n  --sh-search-input-height: 4.5rem;\n  --sh-search-value-line-height: 2rem;\n  --sh-search-input-padding: 1.25rem 4rem;\n  --sh-search-border-radius: 0.125rem 0.125rem 0rem 0rem;\n  --sh-search-border-bottom-thickness: 0.0625rem;\n  --sh-search-list-item-height: 4.5rem;\n  --sh-search-single-line-list-item-padding: 1.25rem 0.75rem;\n  --sh-search-list-item-line-height: 2rem;\n  --sh-search-close-icon-right: 0rem;\n  --sh-search-multi-line-list-item-padding: 0.5rem 0.75rem;\n  --sh-search-multi-line-list-item-height: 4.5rem;\n  --sh-search-multi-line-single-item-height: 1.75rem;\n  --sh-search-empty-slot-item-gap: 1.5rem;\n  --sh-search-empty-wrapper-padding: var(--sh-search-empty-slot-item-gap) 0.75rem;\n  --sh-search-list-view-max-height: 24.75rem;\n  --sh-input-text-label-left: 0.75rem;\n  --sh-input-text-empty-label-top: 1.25rem;\n  --sh-input-text-empty-label-line-height: 2rem;\n  --sh-input-text-empty-padding: 1.25rem 0 1.1875rem 0.75rem;\n  --sh-input-text-height: 4.4375rem;\n  --sh-input-text-padding: 2.25rem 0 0.4375rem 0.75rem;\n  --sh-input-text-label-top: 0.5rem;\n  --sh-input-text-label-line-height: 1.75rem;\n  --sh-input-text-empty-no-border-padding-bottom: 1.25rem;\n  --sh-input-text-no-border-padding-bottom: 0.5rem;\n  --sh-input-text-no-border-condensed-padding-bottom: 1rem;\n  --sh-input-text-icon-left-margin: 0.5rem;\n  --sh-input-text-icon-wrapper-right-padding: 0.75rem;\n  --sh-input-text-icon-size: 3.9375rem;\n  --sh-input-text-icon-wrapper-margin: 0rem;\n  --sh-input-text-helper-text-padding: 0.25rem 0.75rem 0;\n  --sh-input-text-condensed-label-top: 1rem;\n  --sh-input-text-condensed-padding: 1rem 0 0.9375rem 0.75rem;\n  --sh-input-text-condensed-height: 3.9375rem;\n  --sh-input-text-textarea-label-height: 2.5rem;\n  --sh-input-text-textarea-label-padding: 0.75rem 0 0.75rem 0.75rem;\n  --sh-input-text-textarea-padding: 0 0.75rem 0.4375rem;\n  --sh-input-text-textarea-line-height: 2rem;\n  --sh-input-text-textarea-empty-label-line-height: 2rem;\n  --sh-input-text-condensed-textarea-top: 0.75rem;\n  --sh-input-text-condensed-textarea-padding: 0.75rem 0 0.4375rem 0.75rem;\n  --sh-input-text-textarea-label-line-height: 1.75rem;\n  --sh-input-text-condensed-textarea-icon-top: 0rem;\n  --sh-accordion-header-wrapper-min-height: 4.5rem;\n  --sh-accordion-container-padding-left-right: 0rem 1.5rem;\n  --sh-accordion-wrapper-padding-bottom: 1.5rem;\n  --sh-accordion-label-line-height: 2.25rem;\n  --sh-accordion-expand-icon-margin: 0.25rem -0.75rem 0.25rem 0;\n  --sh-accordion-icon-padding: 1.125rem 0.75rem 1.125rem 0;\n  --sh-accordion-content-items-margin-top: 1.5rem;\n  --sh-accordion-content-items-margin-top-touch: 1.25rem;\n  --sh-accordion-content-first-item-margin-top: 0.75rem;\n  --sh-accordion-header-label-info-padding: 1.125rem 0.75rem 1.125rem 0;\n  --sh-user-identifier-margin-left: 0.75rem;\n  --sh-user-identifier-height: 1.75rem;\n  --sh-user-identifier-circle-dimension: 3rem;\n  --sh-user-identifier-image-circle: 3.5rem;\n  --sh-user-identifier-margin: 0.25rem;\n  --sh-user-identifier-max-width: 16rem;\n  --sh-stepper-circle-dimension: 3rem;\n  --sh-stepper-circle-line-height: 3rem;\n  --sh-stepper-label-line-height: 2.25rem;\n  --sh-stepper-info-line-height: 1.75rem;\n  --sh-stepper-line-top: 1.5rem;\n  --sh-stepper-line-width: 2.25rem;\n  --sh-stepper-line-border-width: 0.1875rem;\n  --sh-stepper-badge-top: -0.25rem;\n  --sh-stepper-badge-right: -0.25rem;\n  --sh-stepper-icon-size: 1.5rem;\n  --sh-stepper-font-size: 1.25rem;\n  --sh-stepper-condensed-circle-dimension: 1.125rem;\n  --sh-stepper-condensed-border-width: 0.125rem;\n  --sh-stepper-condensed-badge-top: -0.1875rem;\n  --sh-stepper-condensed-badge-right: -0.25rem;\n  --sh-stepper-condensed-line-top: 0.625rem;\n  --sh-stepper-condensed-line-width: 0.875rem;\n  --sh-nav-bar-nav-bar-wrapper-height: 5rem;\n  --sh-nav-bar-condensed-nav-bar-wrapper-height: 4.5rem;\n  --sh-nav-bar-functions-wrapper-gap: 1rem;\n  --sh-nav-bar-functions-wrapper-padding: 0 0 0 1.75rem;\n  --sh-nav-bar-nav-bar-wrapper-padding: 0 1.5rem;\n  --sh-value-indicator-s-label-line-height: 1.75rem;\n  --sh-value-indicator-l-label-line-height: 2.25rem;\n  --sh-value-indicator-s-value-line-height: 3rem;\n  --sh-value-indicator-l-value-line-height: 6rem;\n  --sh-value-indicator-l-unit-line-height: 4rem;\n  --sh-value-indicator-s-unit-line-height: 2rem;\n  --sh-value-indicator-s-unit-padding-top: 1.2rem;\n  --sh-value-indicator-l-unit-padding-top: 2rem;\n  --sh-value-indicator-l-unit-font-size: 2.75rem;\n  --sh-value-indicator-s-unit-font-size: 1.375rem;\n  --sh-value-indicator-l-icon-size-m: 6rem;\n  --sh-value-indicator-s-icon-size-m: 3rem;\n  --sh-value-indicator-s-icon-font-size-m: 3rem;\n  --sh-value-indicator-l-icon-font-size-m: 6rem;\n  --sh-value-indicator-l-label-font-size: 1.5rem;\n  --sh-value-indicator-s-label-font-size: 1.375rem;\n  --sh-value-indicator-l-value-font-size: 5.5rem;\n  --sh-value-indicator-s-value-font-size: 2.75rem;\n  --sh-value-indicator-s-status-size-m: 2.5rem;\n  --sh-value-indicator-s-status-font-size-m: 2.5rem;\n  --sh-value-indicator-s-icon-margin-right: 0.5rem;\n  --sh-value-indicator-l-icon-margin-right: 0.75rem;\n  --sh-notification-width: 26rem;\n  --sh-notification-item-header-margin: 0.75rem 0.75rem 0 1.5rem;\n  --sh-notification-item-header-icon-margin: 0.75rem 0.75rem 0.75rem 0;\n  --sh-notification-item-header-line-height: 2.25rem;\n  --sh-notification-item-header-max-height: 4.5rem;\n  --sh-notification-item-header-text-margin: 0.875rem 0.75rem 0.875rem 0;\n  --sh-notification-item-header-close-button-margin: 0rem 0.75rem 0 0;\n  --sh-notification-item-description-container-margin: 0.75rem 1.5rem 1.5rem 1.5rem;\n  --sh-notification-item-no-label-description-container-margin: 0.75rem 0.75rem 1.5rem 1.5rem;\n  --sh-notification-item-description-icon-margin: 0.75rem 0.75rem 0 0;\n  --sh-notification-item-description-line-height: 2rem;\n  --sh-notification-item-description-text-margin: 1rem 0.75rem 0rem 0;\n  --sh-notification-item-description-close-button-margin: -1.5rem;\n  --sh-notification-item-footer-margin: 0 1.5rem 1.5rem 1.5rem;\n  --sh-notification-item-description-slot-elements-margin-top: 1.5rem;\n  --sh-notification-item-badge-margin: 1.625rem 1rem 0.5rem 1rem;\n  --sh-notification-item-footer-slot-child-margin-left: 1rem;\n  --sh-input-number-icon-size: 3.9375rem;\n  --sh-input-number-input-right-padding: 0.5rem;\n  --sh-input-number-left-icon-padding: 0 0 0 0.5rem;\n  --sh-input-number-right-icon-padding: 0 0 0 0.5rem;\n  --sh-input-number-status-text-padding: 0.25rem 0.75rem 0 0.75rem;\n  --sh-numeric-keypad-width: 15rem;\n  --sh-numeric-keypad-height: 19.75rem;\n  --sh-numeric-keypad-circle-button-height: 4rem;\n  --sh-numeric-keypad-circle-button-width: 4rem;\n  --sh-numeric-keypad-container-padding: 1.25rem 1.5rem;\n  --sh-numeric-keypad-button-margins: 0.75rem;\n  --sh-numeric-keypad-button-center-margin: 0 0.75rem;\n  --sh-pane-wrapper-width: 23rem;\n  --sh-pane-wrapper-padding: 1.5rem;\n  --sh-pane-arrow-placement-padding: 1.25rem;\n  --sh-pane-arrow-position: -3rem;\n  --sh-pane-condensed-width: 9.5rem;\n  --sh-pane-body-wrapper-margin: 1.5rem;\n  --sh-pane-arrow-wrapper-padding: 0.25rem 0;\n  --sh-pane-slot-child-margin-left: 1rem;\n  --sh-pane-functions-slot-last-child-margin: -0.25rem -0.25rem 0 var(--sh-pane-slot-child-margin-left);\n  --sh-pane-functions-slot-not-last-child-margin: -0.25rem 0rem 0 var(--sh-pane-slot-child-margin-left);\n  --sh-pane-arrow-icon-size: 3rem;\n  --sh-progress-header-line-height: 2.25rem;\n  --sh-progress-progress-bar-height: 0.75rem;\n  --sh-progress-info-line-height: 2rem;\n  --sh-progress-header-margin-bottom: 1rem;\n  --sh-progress-footer-margin-top: 0rem;\n  --sh-progress-radial-header-margin-bottom: 0.625rem;\n  --sh-progress-radial-progress-height-xs: 2.5rem;\n  --sh-progress-radial-progress-ring-width-xs: 0.375rem;\n  --sh-progress-radial-progress-height-s: 3.5rem;\n  --sh-progress-radial-progress-ring-width-s: 0.5rem;\n  --sh-progress-radial-progress-height-m: 6rem;\n  --sh-progress-radial-progress-ring-width-m: 0.5rem;\n  --sh-progress-radial-progress-height-l: 10rem;\n  --sh-progress-radial-progress-ring-width-l: 0.625rem;\n  --sh-progress-radial-progress-height-xl: 20rem;\n  --sh-progress-radial-progress-ring-width-xl: 0.75rem;\n  --sh-progress-indeterminate-bar-length: 9.5rem;\n  --sh-progress-radial-progress-label-width-m: 4rem;\n  --sh-progress-radial-progress-label-width-l: 8rem;\n  --sh-progress-radial-progress-label-width-xl: 15rem;\n  --sh-pagination-wrapper-height: 4rem;\n  --sh-pagination-height: 3rem;\n  --sh-pagination-width: 3rem;\n  --sh-pagination-line-height: 3rem;\n  --sh-pagination-li-right-margin: 1.5rem;\n  --sh-pagination-border-radius: 1.5rem;\n  --sh-pagination-prev-page-icon-right-margin: 1.5rem;\n  --sh-pagination-next-page-icon-left-margin: 0;\n  --sh-min-touch-size: 4.5rem;\n  --sh-split-button-icon-wrapper-width: 4.5rem;\n  --sh-split-button-current-scale: xl;\n  --sh-min-touch-size: 4.5rem;\n  --sh-drawer-width: 25rem;\n  --sh-drawer-header-wrapper-padding: 1.5rem;\n  --sh-drawer-label-wrapper-padding: 0.75rem 1.5rem;\n  --sh-drawer-gap-between-function-footer-slot-elements: 1rem;\n  --sh-drawer-body-wrapper-padding: 0 1.5rem;\n  --sh-drawer-menu-item-margin-top: 0rem;\n  --sh-drawer-headerless-body-wrapper-padding-top: 1.5rem;\n  --sh-drawer-footerless-body-wrapper-padding-bottom: var(--sh-drawer-headerless-body-wrapper-padding-top);\n  --sh-drawer-body-wrapper-margin-top: 1.5rem;\n  --sh-drawer-footer-wrapper-padding: var(--sh-drawer-footerless-body-wrapper-padding-bottom);\n  --sh-drawer-top-bottom-min-height: 13rem;\n  --sh-drawer-label-line-height: 2.25rem;\n  --sh-drawer-label-padding: 0.875rem 0;\n  --sh-drawer-label-margin-right: 0.75rem;\n  --sh-drawer-touch-gap-between-function-footer-slot-elements: 1rem;\n  --sh-interactive-area-display: block;\n  --sh-interactive-area-min-touch-size: 4.5rem;\n}\n\n/*\n * definitions of where to apply colors\n */\nhtml, [sh-color=light] {\n  -webkit-tap-highlight-color: transparent;\n  --focus-outline: 0.125rem solid #3b99fc;\n  --highlight-5: rgba(0, 0, 0, 0.05);\n  --highlight-10: rgba(0, 0, 0, 0.1);\n  --highlight-15: rgba(0, 0, 0, 0.15);\n  --highlight-20: rgba(0, 0, 0, 0.2);\n  --base-0: rgba(255,255,255,1);\n  --base-1: #ebebeb;\n  --base-2: whitesmoke;\n  --base-3: rgba(255,255,255,1);\n  --base-4: rgba(255,255,255,1);\n  --ui-0: 0,153,153;\n  --ui-1: 0,0,0;\n  --ui-2: 236,102,2;\n  --ui-3: 207,75,0;\n  --ui-4: 216,88,8;\n  --ui-5: 125,125,125;\n  --ui-6: 200,200,200;\n  --ui-7: 255,255,255;\n  --functional-red: 231,0,29;\n  --functional-yellow: 255,210,0;\n  --functional-green: 0,154,56;\n  --support-1: #007969;\n  --support-2: #8f1aff;\n  --support-3: #008800;\n  --support-4: #9a5323;\n  --support-5: #006add;\n  --support-6: #b21b5c;\n  --support-1-tint: #3dc3b0;\n  --support-2-tint: #dd6fff;\n  --support-3-tint: #11d900;\n  --support-4-tint: #f19e6a;\n  --support-5-tint: #6caeff;\n  --support-6-tint: #f05d8f;\n  --support-1-shade: #004f41;\n  --support-2-shade: #4c00d3;\n  --support-3-shade: #006200;\n  --support-4-shade: #692900;\n  --support-5-shade: #003da6;\n  --support-6-shade: #7f0034;\n  --text-white: white;\n  --text-highlight: rgba(207, 75, 0, 0.9);\n  --text-primary: rgba(0, 0, 0, 0.9);\n  --text-secondary: rgba(0, 0, 0, 0.6);\n  --text-disabled: rgba(0, 0, 0, 0.2);\n  --opacity-1: 1;\n  --opacity-2: 0.9;\n  --opacity-3: 0.6;\n  --opacity-4: 0.4;\n  --opacity-5: 0.2;\n  --opacity-6: 0.1;\n  --opacity-7: 0.05;\n  --ui-8: 255,255,255;\n  --text-white-disabled: rgba(255, 255, 255, 0.6);\n  --logo-1: #ec6602;\n  --logo-2: #009999;\n  --arrow-down: url("data:image/png,base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAvklEQVRYhe2X0QnDMAxEr6VLJcs0o3WaZiwXgT+CkFWdXEghOjAkYPwecmScW2sNZ+Z+Kv3yAiVQAn8vsAFYf8BY+1pmHg586UPynoA/D+8vPcGqwHYAoy+QqYSGL1Ylot8AK6Hhw1gCUqZ9QmIE36NbMCNBwT2BjAQN/ybASKTgklEbagmozoACpuAS5kak29NLCC5hjuLRduiE4axARIKCZwQ8CRqeFbAkUnBJpAs8CeuZSv0XlEAJXFwAwAfZRzJMuiMA2AAAAABJRU5ErkJggg==");\n  --arrow-up: url("data:image/png,base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAsUlEQVRYhe3W4QmAIBCG4SuapR2cpkarZWqHljEEAykvz+8Cf3SCP4TofZAO6rz31HL1Teu/BxjAAF8A5rjhNSjjLjkvyEvQG7jHHXoTCOAeVyFqAVwcRtQASnEIIQVw8TVuGCGZgrf4lpynDIJK01G6AWl8Q2/iDSCNqxAcoDYOI3IANA4hpFMgjZcQj5UDhK92V8Q5xJ6bCG4MrwcPMJ4iwhq5cbTfcgMYwABtAUR0AiVTLuJVBNbbAAAAAElFTkSuQmCC");\n  --arrow-right: url("data:image/png,base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAs0lEQVRYhe3XYQpAQBAF4EfO4g5chqOty3AHl1mp/SFRO/PepjCl2D/va1szVDFGPFn1o+mfB3gAY7pk1RjDu8NzUCByd+Ac3ql2IhewXqxJELmAGcBUAmE5hEUQ1rdAjvD0ASnC24hkCKYTShBsK6YRillAIV4xjnsAw8X6kjMvWAAVzgLocAYgCfcCZOEegDTcCpCHWwBFwi2AtkS4BRBSoDR8L8tXcbi5p+r/N/w4AMAGHW8wdt+xYmYAAAAASUVORK5CYII=");\n  --arrow-left: url("data:image/png,base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAuUlEQVRYhe3X4QmAIBAF4Fc0SzvYMjWaLVM7tIwRFERknN67+mEHQQbxPi4Vq0II+LLqT9OLB1gAhv0SV0MOd6exl7zE6sA13Ek7wQBcw49a3gDEwkcAkzVAHa4BUMJzAbTwHAA1PBVAD08BmIRLAWbhUoBpSQDbnj7fPO8BdFqctANmiJRPYIJInQN0RM4kpCJyVwENoVmGFIR2H1AjGBtRDNG+BbhDzNJDKfNU7CP3j/X/GxYOALACckAwdhxwRdcAAAAASUVORK5CYII=");\n  --shadow-flat: none;\n  --shadow-raised: 0 0.125rem 0.25rem rgba(0,0,0,0.10), 0 -0.0625rem 0.125rem rgba(0,0,0,0.1);\n  --shadow-navigation: 0 0 0.5rem rgba(0, 0, 0, 0.1);\n  --shadow-overlay: 0 0.25rem 0.5rem rgba(0,0,0,0.10), 0 -0.0625rem 0.25rem rgba(0,0,0,0.1);\n  --transition-time: 0.2s;\n  --hover-transition-time: 0.1s;\n  --focus-color: rgb(18, 132, 255);\n  --focus-outline: 0.125rem solid var(--focus-color);\n}\n\n[sh-color=dark], sh-toolbar[in-segment-theme] {\n  --highlight-5: rgba(255, 255, 255, 0.05);\n  --highlight-10: rgba(255, 255, 255, 0.1);\n  --highlight-15: rgba(255, 255, 255, 0.15);\n  --highlight-20: rgba(255, 255, 255, 0.2);\n  --base-0: #141414;\n  --base-1: #1e1e1e;\n  --blur-background-1: 30,30,30;\n  --base-2: #282828;\n  --base-3: #323232;\n  --base-4: #3c3c3c;\n  --ui-0: 0,153,153;\n  --ui-1: 255,255,255;\n  --ui-2: 236,102,2;\n  --ui-3: 207,75,0;\n  --ui-4: 171,70,6;\n  --ui-5: 125,125,125;\n  --ui-6: 60,60,60;\n  --ui-7: 0,0,0;\n  --functional-red: 231,0,29;\n  --functional-yellow: 255,210,0;\n  --functional-green: 0,154,56;\n  --support-1: #007969;\n  --support-2: #8f1aff;\n  --support-3: #008800;\n  --support-4: #9a5323;\n  --support-5: #006add;\n  --support-6: #b21b5c;\n  --support-1-tint: #3dc3b0;\n  --support-2-tint: #dd6fff;\n  --support-3-tint: #11d900;\n  --support-4-tint: #f19e6a;\n  --support-5-tint: #6caeff;\n  --support-6-tint: #f05d8f;\n  --support-1-shade: #004f41;\n  --support-2-shade: #4c00d3;\n  --support-3-shade: #006200;\n  --support-4-shade: #692900;\n  --support-5-shade: #003da6;\n  --support-6-shade: #7f0034;\n  --text-white: white;\n  --text-highlight: rgba(236, 102, 2, 0.9);\n  --text-primary: rgba(255, 255, 255, 0.9);\n  --text-secondary: rgba(255, 255, 255, 0.6);\n  --text-disabled: rgba(255, 255, 255, 0.2);\n  --opacity-1: 1;\n  --opacity-2: 0.9;\n  --opacity-3: 0.6;\n  --opacity-4: 0.4;\n  --opacity-5: 0.2;\n  --opacity-6: 0.1;\n  --opacity-7: 0.05;\n  --logo-1: rgba(255, 255, 255, 0.9);\n  --logo-2: rgba(255, 255, 255, 0.9);\n  --blur-1: 1.5rem;\n  --ui-8: 60,60,60;\n  --text-white-disabled: rgba(255, 255, 255, 0.2);\n  --arrow-down: url("data:image/png,base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAvklEQVRYhe2X0QnDMAxEr6VLJcs0o3WaZiwXgT+CkFWdXEghOjAkYPwecmScW2sNZ+Z+Kv3yAiVQAn8vsAFYf8BY+1pmHg586UPynoA/D+8vPcGqwHYAoy+QqYSGL1Ylot8AK6Hhw1gCUqZ9QmIE36NbMCNBwT2BjAQN/ybASKTgklEbagmozoACpuAS5kak29NLCC5hjuLRduiE4axARIKCZwQ8CRqeFbAkUnBJpAs8CeuZSv0XlEAJXFwAwAfZRzJMuiMA2AAAAABJRU5ErkJggg==");\n  --arrow-up: url("data:image/png,base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAsUlEQVRYhe3W4QmAIBCG4SuapR2cpkarZWqHljEEAykvz+8Cf3SCP4TofZAO6rz31HL1Teu/BxjAAF8A5rjhNSjjLjkvyEvQG7jHHXoTCOAeVyFqAVwcRtQASnEIIQVw8TVuGCGZgrf4lpynDIJK01G6AWl8Q2/iDSCNqxAcoDYOI3IANA4hpFMgjZcQj5UDhK92V8Q5xJ6bCG4MrwcPMJ4iwhq5cbTfcgMYwABtAUR0AiVTLuJVBNbbAAAAAElFTkSuQmCC");\n  --arrow-right: url("data:image/png,base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAs0lEQVRYhe3XYQpAQBAF4EfO4g5chqOty3AHl1mp/SFRO/PepjCl2D/va1szVDFGPFn1o+mfB3gAY7pk1RjDu8NzUCByd+Ac3ql2IhewXqxJELmAGcBUAmE5hEUQ1rdAjvD0ASnC24hkCKYTShBsK6YRillAIV4xjnsAw8X6kjMvWAAVzgLocAYgCfcCZOEegDTcCpCHWwBFwi2AtkS4BRBSoDR8L8tXcbi5p+r/N/w4AMAGHW8wdt+xYmYAAAAASUVORK5CYII=");\n  --arrow-left: url("data:image/png,base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAuUlEQVRYhe3X4QmAIBAF4Fc0SzvYMjWaLVM7tIwRFERknN67+mEHQQbxPi4Vq0II+LLqT9OLB1gAhv0SV0MOd6exl7zE6sA13Ek7wQBcw49a3gDEwkcAkzVAHa4BUMJzAbTwHAA1PBVAD08BmIRLAWbhUoBpSQDbnj7fPO8BdFqctANmiJRPYIJInQN0RM4kpCJyVwENoVmGFIR2H1AjGBtRDNG+BbhDzNJDKfNU7CP3j/X/GxYOALACckAwdhxwRdcAAAAASUVORK5CYII=");\n  --shadow-flat: none;\n  --shadow-raised: 0 0.125rem 0.25rem rgba(0,0,0,0.20), 0 -0.0625rem 0.125rem rgba(0,0,0,0.1);\n  --shadow-navigation: 0 0 0.5rem rgba(0, 0, 0, 0.2);\n  --shadow-overlay: 0 0.25rem 0.5rem rgba(0,0,0,0.20), 0 -0.0625rem 0.25rem rgba(0,0,0,0.1);\n  --focus-color: rgb(18, 132, 255);\n  --focus-outline: 0.125rem solid var(--focus-color);\n}\n\n/*\n * backward compatibility only!\n * TODO: get rid of these..\n */\nhtml[theme=light] {\n  -webkit-tap-highlight-color: transparent;\n  --focus-outline: 0.125rem solid #3b99fc;\n  --highlight-5: rgba(0, 0, 0, 0.05);\n  --highlight-10: rgba(0, 0, 0, 0.1);\n  --highlight-15: rgba(0, 0, 0, 0.15);\n  --highlight-20: rgba(0, 0, 0, 0.2);\n  --base-0: rgba(255,255,255,1);\n  --base-1: #ebebeb;\n  --base-2: whitesmoke;\n  --base-3: rgba(255,255,255,1);\n  --base-4: rgba(255,255,255,1);\n  --ui-0: 0,153,153;\n  --ui-1: 0,0,0;\n  --ui-2: 236,102,2;\n  --ui-3: 207,75,0;\n  --ui-4: 216,88,8;\n  --ui-5: 125,125,125;\n  --ui-6: 200,200,200;\n  --ui-7: 255,255,255;\n  --functional-red: 231,0,29;\n  --functional-yellow: 255,210,0;\n  --functional-green: 0,154,56;\n  --support-1: #007969;\n  --support-2: #8f1aff;\n  --support-3: #008800;\n  --support-4: #9a5323;\n  --support-5: #006add;\n  --support-6: #b21b5c;\n  --support-1-tint: #3dc3b0;\n  --support-2-tint: #dd6fff;\n  --support-3-tint: #11d900;\n  --support-4-tint: #f19e6a;\n  --support-5-tint: #6caeff;\n  --support-6-tint: #f05d8f;\n  --support-1-shade: #004f41;\n  --support-2-shade: #4c00d3;\n  --support-3-shade: #006200;\n  --support-4-shade: #692900;\n  --support-5-shade: #003da6;\n  --support-6-shade: #7f0034;\n  --text-white: white;\n  --text-highlight: rgba(207, 75, 0, 0.9);\n  --text-primary: rgba(0, 0, 0, 0.9);\n  --text-secondary: rgba(0, 0, 0, 0.6);\n  --text-disabled: rgba(0, 0, 0, 0.2);\n  --opacity-1: 1;\n  --opacity-2: 0.9;\n  --opacity-3: 0.6;\n  --opacity-4: 0.4;\n  --opacity-5: 0.2;\n  --opacity-6: 0.1;\n  --opacity-7: 0.05;\n  --ui-8: 255,255,255;\n  --text-white-disabled: rgba(255, 255, 255, 0.6);\n  --logo-1: #ec6602;\n  --logo-2: #009999;\n  --arrow-down: url("data:image/png,base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAvklEQVRYhe2X0QnDMAxEr6VLJcs0o3WaZiwXgT+CkFWdXEghOjAkYPwecmScW2sNZ+Z+Kv3yAiVQAn8vsAFYf8BY+1pmHg586UPynoA/D+8vPcGqwHYAoy+QqYSGL1Ylot8AK6Hhw1gCUqZ9QmIE36NbMCNBwT2BjAQN/ybASKTgklEbagmozoACpuAS5kak29NLCC5hjuLRduiE4axARIKCZwQ8CRqeFbAkUnBJpAs8CeuZSv0XlEAJXFwAwAfZRzJMuiMA2AAAAABJRU5ErkJggg==");\n  --arrow-up: url("data:image/png,base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAsUlEQVRYhe3W4QmAIBCG4SuapR2cpkarZWqHljEEAykvz+8Cf3SCP4TofZAO6rz31HL1Teu/BxjAAF8A5rjhNSjjLjkvyEvQG7jHHXoTCOAeVyFqAVwcRtQASnEIIQVw8TVuGCGZgrf4lpynDIJK01G6AWl8Q2/iDSCNqxAcoDYOI3IANA4hpFMgjZcQj5UDhK92V8Q5xJ6bCG4MrwcPMJ4iwhq5cbTfcgMYwABtAUR0AiVTLuJVBNbbAAAAAElFTkSuQmCC");\n  --arrow-right: url("data:image/png,base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAs0lEQVRYhe3XYQpAQBAF4EfO4g5chqOty3AHl1mp/SFRO/PepjCl2D/va1szVDFGPFn1o+mfB3gAY7pk1RjDu8NzUCByd+Ac3ql2IhewXqxJELmAGcBUAmE5hEUQ1rdAjvD0ASnC24hkCKYTShBsK6YRillAIV4xjnsAw8X6kjMvWAAVzgLocAYgCfcCZOEegDTcCpCHWwBFwi2AtkS4BRBSoDR8L8tXcbi5p+r/N/w4AMAGHW8wdt+xYmYAAAAASUVORK5CYII=");\n  --arrow-left: url("data:image/png,base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAuUlEQVRYhe3X4QmAIBAF4Fc0SzvYMjWaLVM7tIwRFERknN67+mEHQQbxPi4Vq0II+LLqT9OLB1gAhv0SV0MOd6exl7zE6sA13Ek7wQBcw49a3gDEwkcAkzVAHa4BUMJzAbTwHAA1PBVAD08BmIRLAWbhUoBpSQDbnj7fPO8BdFqctANmiJRPYIJInQN0RM4kpCJyVwENoVmGFIR2H1AjGBtRDNG+BbhDzNJDKfNU7CP3j/X/GxYOALACckAwdhxwRdcAAAAASUVORK5CYII=");\n  --shadow-flat: none;\n  --shadow-raised: 0 0.125rem 0.25rem rgba(0,0,0,0.10), 0 -0.0625rem 0.125rem rgba(0,0,0,0.1);\n  --shadow-navigation: 0 0 0.5rem rgba(0, 0, 0, 0.1);\n  --shadow-overlay: 0 0.25rem 0.5rem rgba(0,0,0,0.10), 0 -0.0625rem 0.25rem rgba(0,0,0,0.1);\n  --transition-time: 0.2s;\n  --hover-transition-time: 0.1s;\n  --focus-color: rgb(18, 132, 255);\n  --focus-outline: 0.125rem solid var(--focus-color);\n}\n\nhtml[theme=dark] {\n  --highlight-5: rgba(255, 255, 255, 0.05);\n  --highlight-10: rgba(255, 255, 255, 0.1);\n  --highlight-15: rgba(255, 255, 255, 0.15);\n  --highlight-20: rgba(255, 255, 255, 0.2);\n  --base-0: #141414;\n  --base-1: #1e1e1e;\n  --blur-background-1: 30,30,30;\n  --base-2: #282828;\n  --base-3: #323232;\n  --base-4: #3c3c3c;\n  --ui-0: 0,153,153;\n  --ui-1: 255,255,255;\n  --ui-2: 236,102,2;\n  --ui-3: 207,75,0;\n  --ui-4: 171,70,6;\n  --ui-5: 125,125,125;\n  --ui-6: 60,60,60;\n  --ui-7: 0,0,0;\n  --functional-red: 231,0,29;\n  --functional-yellow: 255,210,0;\n  --functional-green: 0,154,56;\n  --support-1: #007969;\n  --support-2: #8f1aff;\n  --support-3: #008800;\n  --support-4: #9a5323;\n  --support-5: #006add;\n  --support-6: #b21b5c;\n  --support-1-tint: #3dc3b0;\n  --support-2-tint: #dd6fff;\n  --support-3-tint: #11d900;\n  --support-4-tint: #f19e6a;\n  --support-5-tint: #6caeff;\n  --support-6-tint: #f05d8f;\n  --support-1-shade: #004f41;\n  --support-2-shade: #4c00d3;\n  --support-3-shade: #006200;\n  --support-4-shade: #692900;\n  --support-5-shade: #003da6;\n  --support-6-shade: #7f0034;\n  --text-white: white;\n  --text-highlight: rgba(236, 102, 2, 0.9);\n  --text-primary: rgba(255, 255, 255, 0.9);\n  --text-secondary: rgba(255, 255, 255, 0.6);\n  --text-disabled: rgba(255, 255, 255, 0.2);\n  --opacity-1: 1;\n  --opacity-2: 0.9;\n  --opacity-3: 0.6;\n  --opacity-4: 0.4;\n  --opacity-5: 0.2;\n  --opacity-6: 0.1;\n  --opacity-7: 0.05;\n  --logo-1: rgba(255, 255, 255, 0.9);\n  --logo-2: rgba(255, 255, 255, 0.9);\n  --blur-1: 1.5rem;\n  --ui-8: 60,60,60;\n  --text-white-disabled: rgba(255, 255, 255, 0.2);\n  --arrow-down: url("data:image/png,base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAvklEQVRYhe2X0QnDMAxEr6VLJcs0o3WaZiwXgT+CkFWdXEghOjAkYPwecmScW2sNZ+Z+Kv3yAiVQAn8vsAFYf8BY+1pmHg586UPynoA/D+8vPcGqwHYAoy+QqYSGL1Ylot8AK6Hhw1gCUqZ9QmIE36NbMCNBwT2BjAQN/ybASKTgklEbagmozoACpuAS5kak29NLCC5hjuLRduiE4axARIKCZwQ8CRqeFbAkUnBJpAs8CeuZSv0XlEAJXFwAwAfZRzJMuiMA2AAAAABJRU5ErkJggg==");\n  --arrow-up: url("data:image/png,base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAsUlEQVRYhe3W4QmAIBCG4SuapR2cpkarZWqHljEEAykvz+8Cf3SCP4TofZAO6rz31HL1Teu/BxjAAF8A5rjhNSjjLjkvyEvQG7jHHXoTCOAeVyFqAVwcRtQASnEIIQVw8TVuGCGZgrf4lpynDIJK01G6AWl8Q2/iDSCNqxAcoDYOI3IANA4hpFMgjZcQj5UDhK92V8Q5xJ6bCG4MrwcPMJ4iwhq5cbTfcgMYwABtAUR0AiVTLuJVBNbbAAAAAElFTkSuQmCC");\n  --arrow-right: url("data:image/png,base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAs0lEQVRYhe3XYQpAQBAF4EfO4g5chqOty3AHl1mp/SFRO/PepjCl2D/va1szVDFGPFn1o+mfB3gAY7pk1RjDu8NzUCByd+Ac3ql2IhewXqxJELmAGcBUAmE5hEUQ1rdAjvD0ASnC24hkCKYTShBsK6YRillAIV4xjnsAw8X6kjMvWAAVzgLocAYgCfcCZOEegDTcCpCHWwBFwi2AtkS4BRBSoDR8L8tXcbi5p+r/N/w4AMAGHW8wdt+xYmYAAAAASUVORK5CYII=");\n  --arrow-left: url("data:image/png,base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAuUlEQVRYhe3X4QmAIBAF4Fc0SzvYMjWaLVM7tIwRFERknN67+mEHQQbxPi4Vq0II+LLqT9OLB1gAhv0SV0MOd6exl7zE6sA13Ek7wQBcw49a3gDEwkcAkzVAHa4BUMJzAbTwHAA1PBVAD08BmIRLAWbhUoBpSQDbnj7fPO8BdFqctANmiJRPYIJInQN0RM4kpCJyVwENoVmGFIR2H1AjGBtRDNG+BbhDzNJDKfNU7CP3j/X/GxYOALACckAwdhxwRdcAAAAASUVORK5CYII=");\n  --shadow-flat: none;\n  --shadow-raised: 0 0.125rem 0.25rem rgba(0,0,0,0.20), 0 -0.0625rem 0.125rem rgba(0,0,0,0.1);\n  --shadow-navigation: 0 0 0.5rem rgba(0, 0, 0, 0.2);\n  --shadow-overlay: 0 0.25rem 0.5rem rgba(0,0,0,0.20), 0 -0.0625rem 0.25rem rgba(0,0,0,0.1);\n  --focus-color: rgb(18, 132, 255);\n  --focus-outline: 0.125rem solid var(--focus-color);\n}\n\nhtml[dicom] {\n  --ui-2: 228, 120, 20;\n  /* Orange (Idle) */\n  --ui-3: 208, 105, 24;\n  /* Orange (Hover) */\n  --ui-4: 163, 82, 18;\n  /* Orange(On Press) */\n}\n\n/* SCROLLBAR */\n::-webkit-scrollbar {\n  width: 0.5rem;\n  height: 0.5rem;\n  background-color: transparent;\n  visibility: hidden;\n}\n\n::-webkit-scrollbar-track {\n  background-color: rgba(var(--ui-1), var(--opacity-7));\n  border-radius: 0.5rem;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: rgba(var(--ui-1), var(--opacity-6));\n  border-radius: 0.5rem;\n}\n\n::-webkit-scrollbar-thumb:active,\n::-webkit-scrollbar-thumb:hover {\n  background-color: rgba(var(--ui-1), var(--opacity-4));\n}\n\n/* BODY STYLES */\nhtml, body {\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  margin: 0;\n  font-family: "siemens sans", "Open Sans", "Roboto", "Droid Sans", -apple-system, BlinkMacSystemFont, "Arial", "Calibri", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  overflow: hidden;\n}\n\nhtml {\n  zoom: 1;\n}\n\n:lang(ja) {\n  --super-header: normal 400 20px bree-headline, "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro W3", "Osaka", "メイリオ", "Meiryo", "ＭＳ Ｐゴシック", "MS PGothic", "Noto Sans CJK JP", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n  --header-1: normal 400 16px bree-headline, "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro W3", "Osaka", "メイリオ", "Meiryo", "ＭＳ Ｐゴシック", "MS PGothic", "Noto Sans CJK JP", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n  --header-2: normal 700 16px siemens sans, "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro W3", "Osaka", "メイリオ", "Meiryo", "ＭＳ Ｐゴシック", "MS PGothic", "Noto Sans CJK JP", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n  --title-1: normal 700 14px siemens sans, "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro W3", "Osaka", "メイリオ", "Meiryo", "ＭＳ Ｐゴシック", "MS PGothic", "Noto Sans CJK JP", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n  --title-2: normal 700 12px siemens sans, "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro W3", "Osaka", "メイリオ", "Meiryo", "ＭＳ Ｐゴシック", "MS PGothic", "Noto Sans CJK JP", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n  --body-1: normal 400 14px siemens sans, "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro W3", "Osaka", "メイリオ", "Meiryo", "ＭＳ Ｐゴシック", "MS PGothic", "Noto Sans CJK JP", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n  --body-2: normal 400 12px siemens sans, "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro W3", "Osaka", "メイリオ", "Meiryo", "ＭＳ Ｐゴシック", "MS PGothic", "Noto Sans CJK JP", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n}\n\n:lang(zh-Hans) {\n  --super-header: normal 400 20px bree-headline, "华文细黑", "STXihei", "PingFang SC", "微软雅黑体", "Microsoft YaHei New", "微软雅黑", "Microsoft Yahei", "SimSun", "宋体", "Noto Sans CJK SC", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n  --header-1: normal 400 16px bree-headline, "华文细黑", "STXihei", "PingFang SC", "微软雅黑体", "Microsoft YaHei New", "微软雅黑", "Microsoft Yahei", "SimSun", "宋体", "Noto Sans CJK SC", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n  --header-2: normal 700 16px siemens sans, "华文细黑", "STXihei", "PingFang SC", "微软雅黑体", "Microsoft YaHei New", "微软雅黑", "Microsoft Yahei", "SimSun", "宋体", "Noto Sans CJK SC", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n  --title-1: normal 700 14px siemens sans, "华文细黑", "STXihei", "PingFang SC", "微软雅黑体", "Microsoft YaHei New", "微软雅黑", "Microsoft Yahei", "SimSun", "宋体", "Noto Sans CJK SC", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n  --title-2: normal 700 12px siemens sans, "华文细黑", "STXihei", "PingFang SC", "微软雅黑体", "Microsoft YaHei New", "微软雅黑", "Microsoft Yahei", "SimSun", "宋体", "Noto Sans CJK SC", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n  --body-1: normal 400 14px siemens sans, "华文细黑", "STXihei", "PingFang SC", "微软雅黑体", "Microsoft YaHei New", "微软雅黑", "Microsoft Yahei", "SimSun", "宋体", "Noto Sans CJK SC", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n  --body-2: normal 400 12px siemens sans, "华文细黑", "STXihei", "PingFang SC", "微软雅黑体", "Microsoft YaHei New", "微软雅黑", "Microsoft Yahei", "SimSun", "宋体", "Noto Sans CJK SC", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n}\n\n:lang(ko) {\n  --super-header: normal 400 20px bree-headline, "Apple SD Gothic Neo", "NanumBarunGothic", "맑은 고딕", "Malgun Gothic", "굴림", "Gulim", "돋움", "Dotum", "Noto Sans CJK KR", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n  --header-1: normal 400 16px bree-headline, "Apple SD Gothic Neo", "NanumBarunGothic", "맑은 고딕", "Malgun Gothic", "굴림", "Gulim", "돋움", "Dotum", "Noto Sans CJK KR", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n  --header-2: normal 700 16px siemens sans, "Apple SD Gothic Neo", "NanumBarunGothic", "맑은 고딕", "Malgun Gothic", "굴림", "Gulim", "돋움", "Dotum", "Noto Sans CJK KR", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n  --title-1: normal 700 14px siemens sans, "Apple SD Gothic Neo", "NanumBarunGothic", "맑은 고딕", "Malgun Gothic", "굴림", "Gulim", "돋움", "Dotum", "Noto Sans CJK KR", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n  --title-2: normal 700 12px siemens sans, "Apple SD Gothic Neo", "NanumBarunGothic", "맑은 고딕", "Malgun Gothic", "굴림", "Gulim", "돋움", "Dotum", "Noto Sans CJK KR", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n  --body-1: normal 400 14px siemens sans, "Apple SD Gothic Neo", "NanumBarunGothic", "맑은 고딕", "Malgun Gothic", "굴림", "Gulim", "돋움", "Dotum", "Noto Sans CJK KR", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n  --body-2: normal 400 12px siemens sans, "Apple SD Gothic Neo", "NanumBarunGothic", "맑은 고딕", "Malgun Gothic", "굴림", "Gulim", "돋움", "Dotum", "Noto Sans CJK KR", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n}\n\n:lang(zh-Hant) {\n  --super-header: normal 400 20px bree-headline, "华文细黑", "STXihei", "PingFang TC", "微软雅黑体", "Microsoft YaHei New", "微软雅黑", "Microsoft Yahei", "SimSun", "宋体", "Noto Sans CJK TC", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n  --header-1: normal 400 16px bree-headline, "华文细黑", "STXihei", "PingFang TC", "微软雅黑体", "Microsoft YaHei New", "微软雅黑", "Microsoft Yahei", "SimSun", "宋体", "Noto Sans CJK TC", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n  --header-2: normal 700 16px siemens sans, "华文细黑", "STXihei", "PingFang TC", "微软雅黑体", "Microsoft YaHei New", "微软雅黑", "Microsoft Yahei", "SimSun", "宋体", "Noto Sans CJK TC", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n  --title-1: normal 700 14px siemens sans, "华文细黑", "STXihei", "PingFang TC", "微软雅黑体", "Microsoft YaHei New", "微软雅黑", "Microsoft Yahei", "SimSun", "宋体", "Noto Sans CJK TC", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n  --title-2: normal 700 12px siemens sans, "华文细黑", "STXihei", "PingFang TC", "微软雅黑体", "Microsoft YaHei New", "微软雅黑", "Microsoft Yahei", "SimSun", "宋体", "Noto Sans CJK TC", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n  --body-1: normal 400 14px siemens sans, "华文细黑", "STXihei", "PingFang TC", "微软雅黑体", "Microsoft YaHei New", "微软雅黑", "Microsoft Yahei", "SimSun", "宋体", "Noto Sans CJK TC", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n  --body-2: normal 400 12px siemens sans, "华文细黑", "STXihei", "PingFang TC", "微软雅黑体", "Microsoft YaHei New", "微软雅黑", "Microsoft Yahei", "SimSun", "宋体", "Noto Sans CJK TC", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";\n}\n\n/* Firefox scrollbar */\n* {\n  scrollbar-color: rgba(var(--ui-1), var(--opacity-6)) rgba(var(--ui-1), var(--opacity-7));\n  scrollbar-width: thin;\n}\n\n*:hover, *:active {\n  scrollbar-color: rgba(var(--ui-1), var(--opacity-4)) rgba(var(--ui-1), var(--opacity-7));\n  scrollbar-width: thin;\n}\n\n.max-resize-checker {\n  position: absolute;\n  z-index: -1;\n  visibility: hidden;\n  opacity: 0;\n  top: 0;\n  left: 0;\n  height: 100%;\n  transition: all 0s linear !important;\n}');var ce=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-badge-font-size=0.625rem] - font size for badge
   */
  --sh-badge-font-size: 0.625rem;
  /* 
   * @cssprop [--sh-badge-min-width=1rem] - min width of badge
   */
  --sh-badge-min-width: 1rem;
  /* 
   * @cssprop [--sh-badge-max-width=4rem] - max width of badge
   */
  --sh-badge-max-width: 4rem;
  /* 
   * @cssprop [--sh-badge-height=1rem] - height of badge
   */
  --sh-badge-height: 1rem;
  /* 
   * @cssprop [--sh-badge-line-height=0.5rem] - line height of badge
   */
  --sh-badge-line-height: 0.5rem;
  /* 
   * @cssprop [--sh-badge-no-label-size=0.5rem] - size of empty badge in case no label is set
   */
  --sh-badge-no-label-size: 0.5rem;
  /* 
   * @cssprop [--sh-badge-padding=0.25rem 0.25rem] - padding for text labels
   */
  --sh-badge-padding: 0.25rem 0.25rem;
  /* 
   * @cssprop [--sh-badge-icon-font-size=1.5rem] - applied to interllay used icon as --sh-icon-font-size-xs
   */
  --sh-badge-icon-font-size: 1.5rem;
}

:host {
  display: block;
  flex: none;
  padding: var(--sh-badge-padding);
  border-radius: var(--sh-badge-font-size);
  background: rgba(var(--ui-0), var(--opacity-1));
  font: var(--title-2);
  font-size: var(--sh-badge-font-size);
  color: white;
  max-width: var(--sh-badge-max-width);
  min-width: var(--sh-badge-min-width);
  width: fit-content;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  height: var(--sh-badge-height);
  line-height: var(--sh-badge-line-height);
  box-sizing: border-box;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

sh-icon {
  --sh-icon-font-size-xs: var(--sh-badge-icon-font-size);
}

:host([label=""]:not([type=error]):not([type=success]):not([type=warning])),
:host(:not([label]):not([type=error]):not([type=success]):not([type=warning])) {
  width: var(--sh-badge-no-label-size);
  height: var(--sh-badge-no-label-size);
  max-width: var(--sh-badge-no-label-size);
  max-height: var(--sh-badge-no-label-size);
  min-width: var(--sh-badge-no-label-size);
  min-height: var(--sh-badge-no-label-size);
}

:host([type]:not([label])) {
  padding: 0rem;
  background: transparent;
}

:host([type=error]) sh-icon {
  color: rgb(var(--functional-red));
}

:host([type=warning]) sh-icon {
  color: rgb(var(--functional-yellow));
}

:host([type=success]) sh-icon {
  color: rgb(var(--functional-green));
}

:host([disabled]:not([type])) {
  color: var(--text-white-disabled);
  background: rgba(var(--ui-0), var(--opacity-5));
}

:host([disabled][type]) {
  opacity: 0.2;
}`;customElements.define("sh-badge",class extends se{static get properties(){return{label:{type:String,reflect:!0},type:{type:String,reflect:!0},disabled:{type:Boolean,reflect:!0},_processedLabel:{type:String,reflect:!1,attribute:!1}}}static get styles(){return[ae,ce]}render(){return this._processedLabel||("error"===this.type||"warning"===this.type||"success"===this.type?V`<sh-icon icon="${this.type}" size="xs"></sh-icon>`:"")}updated(e){e.has("label")&&this._processLabel()}_processLabel(){if(this._processedLabel=this.label,this._processedLabel){const e=new RegExp("^[0-9]+$|^[0-9]+[+]$");null!==this.label.match(e)&&(parseInt(this.label,10)>=1e3||this.label.toString().length>3)&&(this.label="999+")}}});const le=function(e,t,o=null,i=!0,r=!0){e.dispatchEvent(new CustomEvent(t,{bubbles:i,composed:r,detail:o}))},he=function(e,t,o){t.forEach(((t,i)=>{const r=i.toString(),s=r.toString().replace(/([A-Z])/g,"-$1").toLowerCase();o.includes(r)&&le(e,`${s}-changed`,null,!1)}))},de=e=>class extends e{static get properties(){return{disabled:{type:Boolean,reflect:!0}}}firstUpdated(){super.firstUpdated(),this.hasAttribute("tabindex")||this.setAttribute("tabindex",0)}attributeChangedCallback(e,t,o){super.attributeChangedCallback(e,t,o),"disabled"===e&&this.setAttribute("aria-disabled",JSON.stringify(this.disabled))}updated(e){super.updated(e),e.has("disabled")&&this.handleDisabledChange(),he(this,e,["disabled"])}handleDisabledChange(){if(this.disabled)this.setAttribute("data-previous-tabindex",this.getAttribute("tabindex")),this.removeAttribute("tabindex"),this.blur();else{const e=this.dataset.previousTabindex;Number.isInteger(parseInt(e,10))&&this.setAttribute("tabindex",e)}}},pe={isTouchDevice:null,setIsTouchDevice(e){this.isTouchDevice=e}};!function(e,t,o){function i(e,t){return typeof e===t}function r(e){var t=u.className,o=h._config.classPrefix||"";if(m&&(t=t.baseVal),h._config.enableJSClass){var i=new RegExp("(^|\\s)"+o+"no-js(\\s|$)");t=t.replace(i,"$1"+o+"js$2")}h._config.enableClasses&&(t+=" "+o+e.join(" "+o),m?u.className.baseVal=t:u.className=t)}function s(e,t){if("object"==typeof e)for(var o in e)d(e,o)&&s(o,e[o]);else{var i=(e=e.toLowerCase()).split("."),n=h[i[0]];if(2==i.length&&(n=n[i[1]]),void 0!==n)return h;t="function"==typeof t?t():t,1==i.length?h[i[0]]=t:(!h[i[0]]||h[i[0]]instanceof Boolean||(h[i[0]]=new Boolean(h[i[0]])),h[i[0]][i[1]]=t),r([(t&&0!=t?"":"no-")+i.join("-")]),h._trigger(e,t)}return h}function n(){return"function"!=typeof t.createElement?t.createElement(arguments[0]):m?t.createElementNS.call(t,"http://www.w3.org/2000/svg",arguments[0]):t.createElement.apply(t,arguments)}function a(e,o,i,r){var s,a,c,l,h="modernizr",d=n("div"),p=function(){var e=t.body;return e||((e=n(m?"svg":"body")).fake=!0),e}();if(parseInt(i,10))for(;i--;)(c=n("div")).id=r?r[i]:h+(i+1),d.appendChild(c);return(s=n("style")).type="text/css",s.id="s"+h,(p.fake?p:d).appendChild(s),p.appendChild(d),s.styleSheet?s.styleSheet.cssText=e:s.appendChild(t.createTextNode(e)),d.id=h,p.fake&&(p.style.background="",p.style.overflow="hidden",l=u.style.overflow,u.style.overflow="hidden",u.appendChild(p)),a=o(d,e),p.fake?(p.parentNode.removeChild(p),u.style.overflow=l,u.offsetHeight):d.parentNode.removeChild(d),!!a}var c=[],l={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,t){var o=this;setTimeout((function(){t(o[e])}),0)},addTest:function(e,t,o){c.push({name:e,fn:t,options:o})},addAsyncTest:function(e){c.push({name:null,fn:e})}},h=function(){};h.prototype=l,h=new h;var d,p=[],u=t.documentElement,m="svg"===u.nodeName.toLowerCase();!function(){var e={}.hasOwnProperty;d=i(e,"undefined")||i(e.call,"undefined")?function(e,t){return t in e&&i(e.constructor.prototype[t],"undefined")}:function(t,o){return e.call(t,o)}}(),l._l={},l.on=function(e,t){this._l[e]||(this._l[e]=[]),this._l[e].push(t),h.hasOwnProperty(e)&&setTimeout((function(){h._trigger(e,h[e])}),0)},l._trigger=function(e,t){if(this._l[e]){var o=this._l[e];setTimeout((function(){var e;for(e=0;e<o.length;e++)(0,o[e])(t)}),0),delete this._l[e]}},h._q.push((function(){l.addTest=s}));var f=function(){var t=e.matchMedia||e.msMatchMedia;return t?function(e){var o=t(e);return o&&o.matches||!1}:function(t){var o=!1;return a("@media "+t+" { #modernizr { position: absolute; } }",(function(t){o="absolute"==(e.getComputedStyle?e.getComputedStyle(t,null):t.currentStyle).position})),o}}();l.mq=f,h.addTest("hovermq",f("(hover)")),function(){var e,t,o,r,s,n;for(var a in c)if(c.hasOwnProperty(a)){if(e=[],(t=c[a]).name&&(e.push(t.name.toLowerCase()),t.options&&t.options.aliases&&t.options.aliases.length))for(o=0;o<t.options.aliases.length;o++)e.push(t.options.aliases[o].toLowerCase());for(r=i(t.fn,"function")?t.fn():t.fn,s=0;s<e.length;s++)1===(n=e[s].split(".")).length?h[n[0]]=r:(!h[n[0]]||h[n[0]]instanceof Boolean||(h[n[0]]=new Boolean(h[n[0]])),h[n[0]][n[1]]=r),p.push((r?"":"no-")+n.join("-"))}}(),r(p),delete l.addTest,delete l.addAsyncTest;for(var g=0;g<h._q.length;g++)h._q[g]();e.Modernizr=h}(window,document);const ue={isTouch:!1,isTouchDevice:function(){return null!==pe.isTouchDevice?(this.isTouch=pe.isTouchDevice,this.isTouch):(Modernizr.hovermq?this.isTouch=!1:this.isTouch=!0,this.isTouch)}},me={TAB:9,ENTER:13,SPACE:32,ESCAPE:27,ARROW_LEFT:37,ARROW_UP:38,ARROW_RIGHT:39,ARROW_DOWN:40,NUM_0:48,NUM_9:57,NUMPAD_0:96,NUMPAD_9:105,V:86,C:67,A:65,X:88,Y:89,Z:90},fe=e=>class extends e{handleFocus(){this.addEventListener("keyup",this.handleKeyup)}handleBlur(){this.removeEventListener("keyup",this.handleKeyup);const e=this.shadowRoot.querySelector(".focus-item");e?e.classList.remove("item-focused"):this.classList.remove("item-focused")}firstUpdated(){super.firstUpdated(),this.addEventListener("focus",(()=>this.handleFocus())),this.addEventListener("blur",(()=>this.handleBlur()))}handleKeyup(e){const t=this.shadowRoot.querySelector(".focus-item");e.keyCode!==me.TAB||this.disabled||(t?t.classList.add("item-focused"):this.classList.add("item-focused")),e.keyCode===me.SPACE&&this._spaceKeyAction()}_spaceKeyAction(){}},ge=function({size:e="var(--sh-interactive-area-min-touch-size, 48px)",width:t=e,height:o=e}={}){return{left:"50%",top:"50%",width:"100%",height:"100%","outline-offset":"-1px","min-width":t,"min-height":o,transform:"translate(-50%,-50%)"}}();function be(e=":host",t=ge){return ie``}var ve=ve||{};ve.util={setWindowLocationHRef:function(e){window.location.href=e}};var ye=ie`/* native icons */
:host([icon=calculate]) .first:before {
  content: "\\E000";
}

:host([icon=calendar]) .first:before {
  content: "\\E001";
}

:host([icon=edit]) .first:before {
  content: "\\E003";
}

:host([icon=export]) .first:before {
  content: "\\E004";
}

:host([icon=favorite]) .first:before {
  content: "\\E005";
}

:host([icon=filter]) .first:before {
  content: "\\E006";
}

:host([icon=home]) .first:before {
  content: "\\E008";
}

:host([icon=import]) .first:before {
  content: "\\E009";
}

:host([icon=layout-1x1]) .first:before {
  content: "\\E00A";
}

:host([icon=layout-2x1]) .first:before {
  content: "\\E00B";
}

:host([icon=layout-2x2]) .first:before {
  content: "\\E00C";
}

:host([icon=layout-3x2]) .first:before {
  content: "\\E00D";
}

:host([icon=layout-4x4]) .first:before {
  content: "\\E00E";
}

:host([icon=lock]) .first:before {
  content: "\\E00F";
}

:host([icon=marker]) .first:before {
  content: "\\E010";
}

:host([icon=minus]) .first:before {
  content: "\\E011";
}

:host([icon=open]) .first:before {
  content: "\\E012";
}

:host([icon=pan]) .first:before {
  content: "\\E013";
}

:host([icon=patient]) .first:before {
  content: "\\E014";
}

:host([icon=patient-browser]) .first:before {
  content: "\\E015";
}

:host([icon=patient-scheduler]) .first:before {
  content: "\\E016";
}

:host([icon=pause]) .first:before {
  content: "\\E017";
}

:host([icon=play]) .first:before {
  content: "\\E018";
}

:host([icon=plus]) .first:before {
  content: "\\E019";
}

:host([icon=print]) .first:before {
  content: "\\E01A";
}

:host([icon=radiation]) .first:before {
  content: "\\E01B";
}

:host([icon=redo]) .first:before {
  content: "\\E01C";
}

:host([icon=rotate-2d]) .first:before {
  content: "\\E01D";
}

:host([icon=rotate-3d]) .first:before {
  content: "\\E01E";
}

:host([icon=save]) .first:before {
  content: "\\E01F";
}

:host([icon=save-as]) .first:before {
  content: "\\E020";
}

:host([icon=scanner]) .first:before {
  content: "\\E021";
}

:host([icon=search]) .first:before {
  content: "\\E022";
}

:host([icon=skip-backward]) .first:before {
  content: "\\E024";
}

:host([icon=skip-forward]) .first:before {
  content: "\\E025";
}

:host([icon=snapshot]) .first:before {
  content: "\\E026";
}

:host([icon=stop]) .first:before {
  content: "\\E027";
}

:host([icon=studies]) .first:before {
  content: "\\E028";
}

:host([icon=text]) .first:before {
  content: "\\E029";
}

:host([icon=undo]) .first:before {
  content: "\\E02A";
}

:host([icon=unlock]) .first:before {
  content: "\\E02B";
}

:host([icon=up]) .first:before,
:host([icon=arrow-face-up-l]) .first:before {
  content: "\\E02C";
}

:host([icon=windowing]) .first:before {
  content: "\\E02D";
}

:host([icon=zoom]) .first:before {
  content: "\\E02E";
}

:host([icon=zoom-minus]) .first:before {
  content: "\\E02F";
}

:host([icon=zoom-plus]) .first:before {
  content: "\\E030";
}

:host([icon=menu]) .first:before {
  content: "\\E035";
}

:host([icon=left-s]) .first:before,
:host([icon=arrow-face-left-s]) .first:before {
  content: "\\E036";
}

:host([icon=right-s]) .first:before,
:host([icon=arrow-face-right-s]) .first:before {
  content: "\\E037";
}

:host([icon=up-s]) .first:before,
:host([icon=arrow-face-up-s]) .first:before {
  content: "\\E038";
}

:host([icon=arrow-down-s]) .first:before,
:host([icon=arrow-line-down-s]) .first:before {
  content: "\\E039";
}

:host([icon=arrow-left-s]) .first:before,
:host([icon=arrow-line-left-s]) .first:before {
  content: "\\E03A";
}

:host([icon=arrow-right-s]) .first:before,
:host([icon=arrow-line-right-s]) .first:before {
  content: "\\E03B";
}

:host([icon=arrow-up-s]) .first:before,
:host([icon=arrow-line-up-s]) .first:before {
  content: "\\E03C";
}

:host([icon=down-s]) .first:before,
:host([icon=arrow-face-down-s]) .first:before {
  content: "\\E03D";
}

:host([icon=chapter]) .first:before {
  content: "\\E03E";
}

:host([icon=document]) .first:before {
  content: "\\E03F";
}

:host([icon=page]) .first:before {
  content: "\\E040";
}

:host([icon=pdf]) .first:before {
  content: "\\E041";
}

:host([icon=more]) .first:before {
  content: "\\E042";
}

:host([icon=grid-3d]) .first:before {
  content: "\\E043";
}

:host([icon=backward-4d]) .first:before {
  content: "\\E044";
}

:host([icon=data-correct-4d]) .first:before {
  content: "\\E045";
}

:host([icon=forward-4d]) .first:before {
  content: "\\E046";
}

:host([icon=series-create-4d]) .first:before {
  content: "\\E047";
}

:host([icon=series-split-4d]) .first:before {
  content: "\\E048";
}

:host([icon=ablation-catheter-settings]) .first:before {
  content: "\\E049";
}

:host([icon=ablation-catheter-connection-settings]) .first:before {
  content: "\\E04A";
}

:host([icon=acquisition-note]) .first:before {
  content: "\\E04B";
}

:host([icon=acquisition-time]) .first:before {
  content: "\\E04C";
}

:host([icon=acquisition-wizard]) .first:before {
  content: "\\E04D";
}

:host([icon=action-failed]) .first:before {
  content: "\\E04E";
}

:host([icon=add-circle]) .first:before,
:host([icon=circle-add]) .first:before {
  content: "\\E04F";
}

:host([icon=add-line]) .first:before,
:host([icon=line-add]) .first:before {
  content: "\\E050";
}

:host([icon=add-needle]) .first:before,
:host([icon=needle-add]) .first:before {
  content: "\\E051";
}

:host([icon=add-polygon]) .first:before,
:host([icon=polygon-add]) .first:before {
  content: "\\E052";
}

:host([icon=add-rectangle]) .first:before {
  content: "\\E053";
}

:host([icon=add-snapshot]) .first:before,
:host([icon=add-snapshot-to-finding]) .first:before {
  content: "\\E054";
}

:host([icon=adjust-c-arm]) .first:before,
:host([icon=adjust-c-arm-3d]) .first:before {
  content: "\\E057";
}

:host([icon=adjust-gamma-level]) .first:before {
  content: "\\E058";
}

:host([icon=adjust-needle]) .first:before {
  content: "\\E059";
}

:host([icon=adjust-objects]) .first:before {
  content: "\\E05A";
}

:host([icon=adjust-virtual-stent]) .first:before {
  content: "\\E05B";
}

:host([icon=adjustment-volume-hide]) .first:before {
  content: "\\E05C";
}

:host([icon=airways-measurement]) .first:before {
  content: "\\E05D";
}

:host([icon=algorithm-parameters-default]) .first:before {
  content: "\\E05E";
}

:host([icon=anatomical-background]) .first:before {
  content: "\\E05F";
}

:host([icon=angio-view]) .first:before {
  content: "\\E060";
}

:host([icon=annulus-plane]) .first:before {
  content: "\\E061";
}

:host([icon=aorta-reference-region]) .first:before {
  content: "\\E062";
}

:host([icon=aortic-valve-plane]) .first:before {
  content: "\\E063";
}

:host([icon=apply-segment-orientation]) .first:before {
  content: "\\E064";
}

:host([icon=arrow-down-2]) .first:before {
  content: "\\E065";
}

:host([icon=arrow-left-2]) .first:before {
  content: "\\E066";
}

:host([icon=arrow-right-2]) .first:before {
  content: "\\E067";
}

:host([icon=arrow-up-2]) .first:before {
  content: "\\E068";
}

:host([icon=auto-iso]) .first:before {
  content: "\\E06A";
}

:host([icon=auto-map-image]) .first:before {
  content: "\\E06B";
}

:host([icon=auto-pixelshift]) .first:before {
  content: "\\E06C";
}

:host([icon=auto-segmentation]) .first:before {
  content: "\\E06D";
}

:host([icon=c-arm]) .first:before {
  content: "\\E06E";
}

:host([icon=auto-tod]) .first:before {
  content: "\\E06F";
}

:host([icon=arrow-down]) .first:before,
:host([icon=arrow-line-down-l]) .first:before {
  content: "\\E070";
}

:host([icon=arrow]) .first:before {
  content: "\\E071";
}

:host([icon=angle]) .first:before {
  content: "\\E072";
}

:host([icon=arrow-up]) .first:before,
:host([icon=arrow-line-up-l]) .first:before {
  content: "\\E073";
}

:host([icon=arrow-right]) .first:before,
:host([icon=arrow-line-right-l]) .first:before {
  content: "\\E074";
}

:host([icon=arrow-left]) .first:before,
:host([icon=arrow-line-left-l]) .first:before {
  content: "\\E075";
}

:host([icon=three-point-mode]) .first:before {
  content: "\\E076";
}

:host([icon=artery-define]) .first:before {
  content: "\\E077";
}

:host([icon=balance-out-pressure]) .first:before {
  content: "\\E078";
}

:host([icon=battery-1-vertical]) .first:before {
  content: "\\E079";
}

:host([icon=battery-2-vertical]) .first:before {
  content: "\\E07A";
}

:host([icon=battery-3-horizontal]) .first:before {
  content: "\\E07B";
}

:host([icon=battery-3-vertical]) .first:before {
  content: "\\E07C";
}

:host([icon=battery-4-vertical]) .first:before {
  content: "\\E07D";
}

:host([icon=battery-charging]) .first:before,
:host([icon=battery-charging-horizontal]) .first:before {
  content: "\\E07E";
}

:host([icon=battery-empty-horizontal]) .first:before {
  content: "\\E07F";
}

:host([icon=battery-full-horizontal]) .first:before {
  content: "\\E080";
}

:host([icon=battery-full-vertical]) .first:before {
  content: "\\E081";
}

:host([icon=battery-1-horizontal]) .first:before,
:host([icon=battery-low-horizontal]) .first:before,
:host([icon=battery-1-horizontal]) .first:before {
  content: "\\E082";
}

:host([icon=bd-vessel-align]) .first:before {
  content: "\\E083";
}

:host([icon=black-box]) .first:before {
  content: "\\E084";
}

:host([icon=blood-lv-edit]) .first:before {
  content: "\\E085";
}

:host([icon=blood-removal]) .first:before {
  content: "\\E086";
}

:host([icon=blood-volume]) .first:before {
  content: "\\E087";
}

:host([icon=bold]) .first:before {
  content: "\\E088";
}

:host([icon=bone-cad-active]) .first:before {
  content: "\\E089";
}

:host([icon=bone-cad-display]) .first:before {
  content: "\\E08A";
}

:host([icon=bone-removal]) .first:before {
  content: "\\E08B";
}

:host([icon=bone-removal-auto]) .first:before {
  content: "\\E08C";
}

:host([icon=bone-removal-body]) .first:before {
  content: "\\E08D";
}

:host([icon=bone-removal-body-de]) .first:before {
  content: "\\E08E";
}

:host([icon=bone-removal-edit]) .first:before {
  content: "\\E08F";
}

:host([icon=bone-removal-head]) .first:before {
  content: "\\E090";
}

:host([icon=bone-removal-head-de]) .first:before {
  content: "\\E091";
}

:host([icon=bone-removal-leg]) .first:before {
  content: "\\E092";
}

:host([icon=bone-removal-structure-isolation]) .first:before {
  content: "\\E093";
}

:host([icon=bone-removal-tools]) .first:before {
  content: "\\E094";
}

:host([icon=bones-hide]) .first:before {
  content: "\\E095";
}

:host([icon=bones-show]) .first:before {
  content: "\\E096";
}

:host([icon=bookmark-add]) .first:before {
  content: "\\E097";
}

:host([icon=bookmark-segment]) .first:before {
  content: "\\E098";
}

:host([icon=brain]) .first:before {
  content: "\\E099";
}

:host([icon=breast-biopsy]) .first:before {
  content: "\\E09A";
}

:host([icon=breast-lesion-marker]) .first:before {
  content: "\\E09B";
}

:host([icon=brightness-decrease]) .first:before {
  content: "\\E09C";
}

:host([icon=brightness-increase]) .first:before {
  content: "\\E09D";
}

:host([icon=broad-worklist-query]) .first:before {
  content: "\\E09E";
}

:host([icon=bullets]) .first:before {
  content: "\\E09F";
}

:host([icon=cable-winder]) .first:before {
  content: "\\E0A0";
}

:host([icon=calcium-remove]) .first:before {
  content: "\\E0A1";
}

:host([icon=calculation-cancel]) .first:before {
  content: "\\E0A2";
}

:host([icon=caliper-measurement]) .first:before {
  content: "\\E0A3";
}

:host([icon=cardiac-layout-edit]) .first:before {
  content: "\\E0A4";
}

:host([icon=cardiac-mask-edit]) .first:before {
  content: "\\E0A5";
}

:host([icon=cardiac-output]) .first:before {
  content: "\\E0A6";
}

:host([icon=care-position]) .first:before {
  content: "\\E0A7";
}

:host([icon=cascoring-show-original]) .first:before {
  content: "\\E0A8";
}

:host([icon=catheter-pullback]) .first:before {
  content: "\\E0A9";
}

:host([icon=cava-calculate]) .first:before {
  content: "\\E0AA";
}

:host([icon=cava-prepare]) .first:before {
  content: "\\E0AB";
}

:host([icon=chamber-left]) .first:before {
  content: "\\E0AC";
}

:host([icon=chamber-left]) .first:after {
  content: "\\ECBB";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=chamber-middle]) .first:before {
  content: "\\E0AD";
}

:host([icon=chamber-middle]) .first:after {
  content: "\\ECBC";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=chamber-right]) .first:before {
  content: "\\E0AE";
}

:host([icon=chamber-right]) .first:after {
  content: "\\ECBD";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=change-view]) .first:before {
  content: "\\E0AF";
}

:host([icon=cinematic-vrt]) .first:before {
  content: "\\E0B0";
}

:host([icon=coil-information]) .first:before {
  content: "\\E0B2";
}

:host([icon=coils-hide]) .first:before {
  content: "\\E0B3";
}

:host([icon=colon-show-marked]) .first:before {
  content: "\\E0B4";
}

:host([icon=colon-solid-view]) .first:before {
  content: "\\E0B5";
}

:host([icon=combine]) .first:before,
:host([icon=structure-combine]) .first:before {
  content: "\\E0B6";
}

:host([icon=compare-protocols]) .first:before {
  content: "\\E0B7";
}

:host([icon=compute-maps]) .first:before {
  content: "\\E0B8";
}

:host([icon=configurations-sync]) .first:before,
:host([icon=sync-configurations]) .first:before {
  content: "\\E0B9";
}

:host([icon=contour-copy]) .first:before {
  content: "\\E0BB";
}

:host([icon=contour-delete-all]) .first:before {
  content: "\\E0BC";
}

:host([icon=contour-delete-single]) .first:before {
  content: "\\E0BD";
}

:host([icon=contour-draw-new]) .first:before {
  content: "\\E0BE";
}

:host([icon=contour-edit]) .first:before {
  content: "\\E0BF";
}

:host([icon=contour-edit-slices]) .first:before {
  content: "\\E0C0";
}

:host([icon=contour-preview]) .first:before {
  content: "\\E0C1";
}

:host([icon=contour-redraw]) .first:before {
  content: "\\E0C2";
}

:host([icon=contour-reflect]) .first:before {
  content: "\\E0C3";
}

:host([icon=contour-threshold]) .first:before {
  content: "\\E0C5";
}

:host([icon=contour-undo]) .first:before {
  content: "\\E0C6";
}

:host([icon=contours-compute]) .first:before {
  content: "\\E0C7";
}

:host([icon=contour-rv-edit]) .first:before,
:host([icon=contours-edit]) .first:before {
  content: "\\E0C8";
}

:host([icon=contours-reset]) .first:before {
  content: "\\E0C9";
}

:host([icon=contours-show]) .first:before {
  content: "\\E0CA";
}

:host([icon=contrast-agent-administration-applied]) .first:before,
:host([icon=contrast-agent-completed]) .first:before {
  content: "\\E0CB";
}

:host([icon=contrast-decrease]) .first:before {
  content: "\\E0CC";
}

:host([icon=contrast-increase]) .first:before {
  content: "\\E0CD";
}

:host([icon=contrast-optimum]) .first:before {
  content: "\\E0CE";
}

:host([icon=control-panel]) .first:before {
  content: "\\E0CF";
}

:host([icon=convert-to]) .first:before {
  content: "\\E0D0";
}

:host([icon=copy-and-go]) .first:before {
  content: "\\E0D1";
}

:host([icon=copy-image-to-clipboard]) .first:before {
  content: "\\E0D2";
}

:host([icon=copy-paste]) .first:before {
  content: "\\E0D3";
}

:host([icon=copy-reference-new]) .first:before {
  content: "\\E0D4";
}

:host([icon=copy-reference-source]) .first:before {
  content: "\\E0D5";
}

:host([icon=copy-reference-target]) .first:before {
  content: "\\E0D6";
}

:host([icon=coronary-tree]) .first:before {
  content: "\\E0DA";
}

:host([icon=correlated-cursors]) .first:before {
  content: "\\E0DB";
}

:host([icon=create-view-catheter-lab]) .first:before {
  content: "\\E0DC";
}

:host([icon=csi-matrix-interpolated]) .first:before {
  content: "\\E0DD";
}

:host([icon=csi-matrix-scan]) .first:before {
  content: "\\E0DE";
}

:host([icon=ct-laser-zero]) .first:before {
  content: "\\E0DF";
}

:host([icon=cut]) .first:before {
  content: "\\E0E0";
}

:host([icon=cutline-3d-draw]) .first:before {
  content: "\\E0E1";
}

:host([icon=down]) .first:before,
:host([icon=arrow-face-down-l]) .first:before {
  content: "\\E0E3";
}

:host([icon=distance-line]) .first:before {
  content: "\\E0E4";
}

:host([icon=delete]) .first:before {
  content: "\\E0E5";
}

:host([icon=checkmark]) .first:before {
  content: "\\E0E6";
}

:host([icon=contrast-administration]) .first:before,
:host([icon=injection]) .first:before {
  content: "\\E0E7";
}

:host([icon=scheduled]) .first:before,
:host([icon=time]) .first:before {
  content: "\\E0E8";
}

:host([icon=patient-scan]) .first:before {
  content: "\\E0E9";
}

:host([icon=reconstruction-running]) .first:before {
  content: "\\E0EA";
}

:host([icon=circle-filled]) .first:before {
  content: "\\E0EB";
}

:host([icon=circle-half]) .first:before {
  content: "\\E0EC";
}

:host([icon=circle-outline]) .first:before {
  content: "\\E0ED";
}

:host([icon=apps]) .first:before {
  content: "\\E0EE";
}

:host([icon=camera]) .first:before,
:host([icon=movie]) .first:before {
  content: "\\E0EF";
}

:host([icon=library]) .first:before {
  content: "\\E0F0";
}

:host([icon=upload-partner]) .first:before {
  content: "\\E0F7";
}

:host([icon=upload-user]) .first:before {
  content: "\\E0F9";
}

:host([icon=reject]) .first:before {
  content: "\\E0F3";
}

:host([icon=sort-custom]) .first:before {
  content: "\\E0F4";
}

:host([icon=standby]) .first:before {
  content: "\\E0F5";
}

:host([icon=user-avatar]) .first:before {
  content: "\\E0F8";
}

:host([icon=show]) .first:before {
  content: "\\E101";
}

:host([icon=pause-circle]) .first:before {
  content: "\\E121";
}

:host([icon=gantry-tilt-zero]) .first:before {
  content: "\\E127";
}

:host([icon=go-to-console]) .first:before {
  content: "\\E128";
}

:host([icon=table-height]) .first:before {
  content: "\\E12B";
}

:host([icon=table-in]) .first:before {
  content: "\\E12C";
}

:host([icon=table-longitudinal]) .first:before {
  content: "\\E12D";
}

:host([icon=table-out]) .first:before {
  content: "\\E12E";
}

:host([icon=voice-command-record]) .first:before {
  content: "\\E12F";
}

:host([icon=heart-bodypart]) .first:before {
  content: "\\E131";
}

:host([icon=image]) .first:before {
  content: "\\E132";
}

:host([icon=edit-partner]) .first:before,
:host([icon=partner-edit]) .first:before {
  content: "\\E136";
}

:host([icon=edit-user]) .first:before,
:host([icon=user-edit]) .first:before {
  content: "\\E137";
}

:host([icon=logoff]) .first:before {
  content: "\\E138";
}

:host([icon=invert]) .first:before {
  content: "\\E145";
}

:host([icon=image-text-custom]) .first:before {
  content: "\\E141";
}

:host([icon=image-text-configuration]) .first:before {
  content: "\\E140";
}

:host([icon=image-text-full]) .first:before {
  content: "\\E142";
}

:host([icon=rotate-left]) .first:before {
  content: "\\E14B";
}

:host([icon=rotate-right]) .first:before {
  content: "\\E14E";
}

:host([icon=finding-add]) .first:before {
  content: "\\E139";
}

:host([icon=finding-add]) .first:before {
  content: "\\E139";
}

:host([icon=mip]) .first:before {
  content: "\\E152";
}

:host([icon=roi-circle]) .first:before {
  content: "\\E153";
}

:host([icon=roi-ellipsis]) .first:before {
  content: "\\E154";
}

:host([icon=roi-freehand]) .first:before {
  content: "\\E155";
}

:host([icon=roi-polygonal]) .first:before {
  content: "\\E156";
}

:host([icon=roi-rectangle]) .first:before {
  content: "\\E157";
}

:host([icon=scroll]) .first:before {
  content: "\\E15A";
}

:host([icon=vrt]) .first:before {
  content: "\\E158";
}

:host([icon=delete-number]) .first:before {
  content: "\\E901";
}

:host([icon=compass-direction]) .first:before {
  content: "\\E900";
}

:host([icon=speakers-off]) .first:before {
  content: "\\E904";
}

:host([icon=speakers-on]) .first:before {
  content: "\\E905";
}

:host([icon=workstation-free-fd]) .first:before {
  content: "\\E933";
}

:host([icon=timer]) .first:before {
  content: "\\E92f";
}

:host([icon=switch-monitor]) .first:before {
  content: "\\E92e";
}

:host([icon=signal-strength-5]) .first:before {
  content: "\\E92C";
}

:host([icon=signal-strength-0]) .first:before {
  content: "\\E92C";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=show-all-monitors]) .first:before {
  content: "\\E923";
}

:host([icon=reset]) .first:before {
  content: "\\E91E";
}

:host([icon=patient-size-small]) .first:before {
  content: "\\E91B";
}

:host([icon=patient-size-large]) .first:before {
  content: "\\E91A";
}

:host([icon=open-chat]) .first:before {
  content: "\\E919";
}

:host([icon=focus-small]) .first:before {
  content: "\\E914";
}

:host([icon=focus-big]) .first:before {
  content: "\\E913";
}

:host([icon=fluoroscopy-control]) .first:before {
  content: "\\E912";
}

:host([icon=exposure-time-increase]) .first:before {
  content: "\\E911";
}

:host([icon=exposure-time-decrease]) .first:before {
  content: "\\E910";
}

:host([icon=expert-i]) .first:before {
  content: "\\E90F";
}

:host([icon=dual-monitor-mode]) .first:before {
  content: "\\E90E";
}

:host([icon=channel-3]) .first:before {
  content: "\\E909";
}

:host([icon=channel-2]) .first:before {
  content: "\\E908";
}

:host([icon=channel-1]) .first:before {
  content: "\\E907";
}

:host([icon=send-message]) .first:before {
  content: "\\E906";
}

:host([icon=like]) .first:before {
  content: "\\E93D";
}

:host([icon=dislike]) .first:before {
  content: "\\E939";
}

:host([icon=double-arrow-face-up-s]) .first:before {
  content: "\\E941";
}

:host([icon=double-arrow-face-down-s]) .first:before {
  content: "\\E93E";
}

:host([icon=double-arrow-face-left-s]) .first:before {
  content: "\\E93F";
}

:host([icon=double-arrow-face-right-s]) .first:before {
  content: "\\E940";
}

:host([icon=sync-on]) .first:before {
  content: "\\E94B";
}

:host([icon=share]) .first:before {
  content: "\\E948";
}

:host([icon=laser]) .first:before {
  content: "\\E943";
}

:host([icon=monitors]) .first:before,
:host([icon=monitor]) .first:before {
  content: "\\E942";
}

:host([icon=positive-negative]) .first:before {
  content: "\\E94E";
}

:host([icon=connected-tablet-0]) .first:before {
  content: "\\E95C";
}

:host([icon=connected-tablet-1]) .first:before {
  content: "\\E95D";
}

:host([icon=connected-tablet-2]) .first:before {
  content: "\\E95E";
}

:host([icon=connected-tablet-3]) .first:before {
  content: "\\E95F";
}

:host([icon=connected-tablet-4]) .first:before {
  content: "\\E960";
}

:host([icon=connected-tablet-5]) .first:before {
  content: "\\E961";
}

:host([icon=rating]) .first:before {
  content: "\\E922";
}

:host([icon=delivery]) .first:before {
  content: "\\E962";
}

:host([icon=envelope]) .first:before {
  content: "\\E963";
}

:host([icon=eraser]) .first:before {
  content: "\\E964";
}

:host([icon=financial-value]) .first:before {
  content: "\\E965";
}

:host([icon=image-quality-check]) .first:before {
  content: "\\E966";
}

:host([icon=refresh]) .first:before {
  content: "\\E96F";
}

:host([icon=scanner-settings]) .first:before {
  content: "\\E970";
}

:host([icon=series]) .first:before {
  content: "\\E971";
}

:host([icon=upload]) .first:before {
  content: "\\E974";
}

:host([icon=colon-solid-view]) .first:before {
  content: "\\E975";
}

:host([icon=drug-pharmaceutical]) .first:before,
:host([icon=medications]) .first:before {
  content: "\\E976";
}

:host([icon=liver]) .first:before {
  content: "\\E979";
}

:host([icon=mark-left]) .first:before {
  content: "\\E97C";
}

:host([icon=mark-right]) .first:before {
  content: "\\E97D";
}

:host([icon=surgery]) .first:before {
  content: "\\E97E";
}

:host([icon=blood-pressure]) .first:before {
  content: "\\E98E";
}

:host([icon=dashboard]) .first:before {
  content: "\\E9A2";
}

:host([icon=doctor-visit]) .first:before {
  content: "\\E9A6";
}

:host([icon=feedback-add]) .first:before {
  content: "\\E9A5";
}

:host([icon=group-series-configuration]) .first:before {
  content: "\\E9A4";
}

:host([icon=heart-chart]) .first:before {
  content: "\\E9A3";
}

:host([icon=kitmed-report]) .first:before {
  content: "\\E9AB";
}

:host([icon=locum-circles]) .first:before {
  content: "\\E9AC";
}

:host([icon=note-add]) .first:before {
  content: "\\E9B9";
}

:host([icon=observations]) .first:before {
  content: "\\E9B8";
}

:host([icon=open-tasks-add]) .first:before {
  content: "\\E9B7";
}

:host([icon=patient-insurance]) .first:before {
  content: "\\E9B6";
}

:host([icon=patient-measurement]) .first:before {
  content: "\\E9B5";
}

:host([icon=result-group-configuration]) .first:before {
  content: "\\E9B4";
}

:host([icon=studies-medical]) .first:before {
  content: "\\E9B3";
}

:host([icon=web-data-entry]) .first:before {
  content: "\\E9B2";
}

:host([icon=weight-measurement]) .first:before {
  content: "\\E9B1";
}

:host([icon=change-password]) .first:before {
  content: "\\E9BC";
}

:host([icon=comment]) .first:before {
  content: "\\E9CA";
}

:host([icon=kitpro]) .first:before {
  content: "\\E9C9";
}

:host([icon=histogram]) .first:before {
  content: "\\E9C8";
}

:host([icon=fine-tuning]) .first:before {
  content: "\\E9C7";
}

:host([icon=download]) .first:before {
  content: "\\E9C6";
}

:host([icon=wellbeing-good]) .first:before {
  content: "\\E9C3";
}

:host([icon=trending-graph]) .first:before {
  content: "\\E9C2";
}

:host([icon=report-new]) .first:before {
  content: "\\E9C1";
}

:host([icon=report]) .first:before {
  content: "\\E9C0";
}

:host([icon=patient-add]) .first:before {
  content: "\\E9BF";
}

:host([icon=open-tasks]) .first:before {
  content: "\\E9BE";
}

:host([icon=message-history]) .first:before {
  content: "\\E9BD";
}

:host([icon=fullscreen]) .first:before {
  content: "\\E9CE";
}

:host([icon=exit-fullscreen]) .first:before {
  content: "\\E9CD";
}

:host([icon=alpha-blending]) .first:before {
  content: "\\E9F2";
}

:host([icon=central-library]) .first:before {
  content: "\\E9F1";
}

:host([icon=cloud-download]) .first:before {
  content: "\\E9F0";
}

:host([icon=cloud-upload]) .first:before {
  content: "\\E9EE";
}

:host([icon=factory-default]) .first:before {
  content: "\\E9EA";
}

:host([icon=group-chat]) .first:before {
  content: "\\E9E7";
}

:host([icon=manual-phasing]) .first:before {
  content: "\\E9DF";
}

:host([icon=music-via-headphones]) .first:before {
  content: "\\E9DE";
}

:host([icon=music-via-speakers]) .first:before {
  content: "\\E9DD";
}

:host([icon=nerve-stimulation]) .first:before {
  content: "\\E9DC";
}

:host([icon=not-tablet-approved]) .first:before {
  content: "\\E9DB";
}

:host([icon=qr-code]) .first:before {
  content: "\\E9D6";
}

:host([icon=report-template-edit]) .first:before {
  content: "\\E9CF";
}

:host([icon=report-template-assignment]) .first:before {
  content: "\\E9D0";
}

:host([icon=rt-laser-switch]) .first:before {
  content: "\\E98B";
}

:host([icon=rt-laser-zero]) .first:before {
  content: "\\E991";
}

:host([icon=sar-simulation-limit-exceeded]) .first:before,
:host([icon=sar-stimulation-limit-exceeded]) .first:before {
  content: "\\E994";
}

:host([icon=spine]) .first:before {
  content: "\\E9FA";
}

:host([icon=user]) .first:before {
  content: "\\E9F9";
}

:host([icon=ventilation]) .first:before {
  content: "\\E9F6";
}

:host([icon=workflow-settings-active-mode]) .first:before {
  content: "\\E9F5";
}

:host([icon=workflow-settings-inactive-mode]) .first:before {
  content: "\\E9F4";
}

:host([icon=workflow-switch]) .first:before {
  content: "\\E9F3";
}

:host([icon=desktop-sharing]) .first:before {
  content: "\\EA08";
}

:host([icon=maximize]) .first:before {
  content: "\\EA04";
}

:host([icon=minimize]) .first:before {
  content: "\\EA03";
}

:host([icon=restore]) .first:before {
  content: "\\EA01";
}

:host([icon=quick-guidance]) .first:before {
  content: "\\EA02";
}

:host([icon=workstation]) .first:before {
  content: "\\E9FF";
}

:host([icon=zoom-pan]) .first:before {
  content: "\\EA0F";
}

:host([icon=dicom-data-not-included]) .first:before {
  content: "\\EA22";
}

:host([icon=image-export]) .first:before {
  content: "\\EA3C";
}

:host([icon=job-view]) .first:before {
  content: "\\EA3E";
}

:host([icon=patient-reject]) .first:before {
  content: "\\EA3F";
}

:host([icon=store-snapshot-segment]) .first:before {
  content: "\\EA40";
}

:host([icon=distance-ratio]) .first:before {
  content: "\\EA46";
}

:host([icon=injection-ready]) .first:before {
  content: "\\EA49";
}

:host([icon=pause-add]) .first:before {
  content: "\\EA53";
}

:host([icon=pause-remove]) .first:before {
  content: "\\EA54";
}

:host([icon=location-pin]) .first:before {
  content: "\\EA5B";
}

:host([icon=procedure-add]) .first:before {
  content: "\\EA5C";
}

:host([icon=structured-report]) .first:before {
  content: "\\EA5D";
}

:host([icon=study-pass]) .first:before {
  content: "\\EA5E";
}

:host([icon=blood-glucose]) .first:before {
  content: "\\EA61";
}

:host([icon=camera-enable]) .first:before {
  content: "\\EA62";
}

:host([icon=camera-swap]) .first:before {
  content: "\\EA63";
}

:host([icon=connect-to-hospital]) .first:before {
  content: "\\EA64";
}

:host([icon=hang-up-call]) .first:before {
  content: "\\EA65";
}

:host([icon=hospital-add]) .first:before {
  content: "\\EA66";
}

:host([icon=hospital]) .first:before {
  content: "\\EA67";
}

:host([icon=manage-message-templates]) .first:before {
  content: "\\EA68";
}

:host([icon=microphone-enable]) .first:before {
  content: "\\EA69";
}

:host([icon=phone]) .first:before {
  content: "\\EA6A";
}

:host([icon=questionnaire-symptom]) .first:before {
  content: "\\EA6B";
}

:host([icon=start-video-call]) .first:before {
  content: "\\EA6C";
}

:host([icon=step-count]) .first:before {
  content: "\\EA6D";
}

:host([icon=thermometer]) .first:before {
  content: "\\EA6E";
}

:host([icon=video-call-accept]) .first:before {
  content: "\\EA6F";
}

:host([icon=active-directory]) .first:before {
  content: "\\EA70";
}

:host([icon=brightness]) .first:before {
  content: "\\EA71";
}

:host([icon=delete-all]) .first:before {
  content: "\\EA78";
}

:host([icon=favorite-off]) .first:before {
  content: "\\EA7d";
}

:host([icon=image-forward]) .first:before {
  content: "\\EA7e";
}

:host([icon=virtual-collimation]) .first:before {
  content: "\\EA8b";
}

:host([icon=windowing-presets]) .first:before {
  content: "\\EA8c";
}

:host([icon=software-update]) .first:before {
  content: "\\EA7A";
}

:host([icon=cloud]) .first:before {
  content: "\\EA9B";
}

:host([icon=region-language]) .first:before {
  content: "\\EA9C";
}

:host([icon=image-metadata-edit]) .first:before {
  content: "\\EA9E";
}

:host([icon=attention-chat]) .first:before {
  content: "\\EAA3";
}

:host([icon=document-raw]) .first:before {
  content: "\\EAA2";
}

:host([icon=image-quality-assesment]) .first:before {
  content: "\\EAA1";
}

:host([icon=parked-view]) .first:before {
  content: "\\EAA8";
}

:host([icon=patient-history-studies]) .first:before {
  content: "\\EAA7";
}

:host([icon=dicom]) .first:before {
  content: "\\EAA9";
}

:host([icon=next-scene]) .first:before {
  content: "\\EAAA";
}

:host([icon=previous-scene]) .first:before {
  content: "\\EAAC";
}

:host([icon=parked-view-gallery]) .first:before {
  content: "\\EAAB";
}

:host([icon=demonstrate-visuals]) .first:before {
  content: "\\EAAD";
}

:host([icon=recording]) .first:before {
  content: "\\EAB2";
}

:host([icon=table-target-home]) .first:before {
  content: "\\EABA";
}

:host([icon=table-target-iso-center]) .first:before {
  content: "\\EABB";
}

:host([icon=export-to-xls]) .first:before {
  content: "\\EABD";
}

:host([icon=subitem-add]) .first:before {
  content: "\\EAC1";
}

:host([icon=user-group-edit]) .first:before {
  content: "\\EAC2";
}

:host([icon=image-flavor]) .first:before {
  content: "\\EAC0";
}

:host([icon=waterproof]) .first:before {
  content: "\\EAC3";
}

:host([icon=attachment]) .first:before {
  content: "\\EAC8";
}

:host([icon=command-prompt]) .first:before {
  content: "\\EAC9";
}

:host([icon=comment-add]) .first:before {
  content: "\\EACC";
}

:host([icon=dicom-configuration]) .first:before {
  content: "\\EACD";
}

:host([icon=dicom-search]) .first:before {
  content: "\\EACE";
}

:host([icon=filter-cancel]) .first:before {
  content: "\\EACF";
}

:host([icon=laboratory-results-edit]) .first:before {
  content: "\\EAD0";
}

:host([icon=laboratory-results-search]) .first:before {
  content: "\\EAD1";
}

:host([icon=laboratory-results]) .first:before {
  content: "\\EAD2";
}

:host([icon=laboratory-system]) .first:before {
  content: "\\EAD3";
}

:host([icon=log]) .first:before {
  content: "\\EAD4";
}

:host([icon=order-add]) .first:before {
  content: "\\EAD5";
}

:host([icon=order]) .first:before {
  content: "\\EAD8";
}

:host([icon=resize-tile-to-large]) .first:before {
  content: "\\EAD9";
}

:host([icon=resize-tile-to-small]) .first:before {
  content: "\\EADA";
}

:host([icon=translators-connection]) .first:before {
  content: "\\EADB";
}

:host([icon=wizard]) .first:before {
  content: "\\EADC";
}

:host([icon=layout-1x2]) .first:before {
  content: "\\EAE9";
}

:host([icon=private]) .first:before {
  content: "\\EAE6";
}

:host([icon=battery-4-horizontal]) .first:before {
  content: "\\EAEE";
}

:host([icon=battery-2-horizontal]) .first:before {
  content: "\\EAED";
}

:host([icon=bar-code]) .first:before {
  content: "\\EAEC";
}

:host([icon=apple]) .first:before {
  content: "\\EAEB";
}

:host([icon=apple-eaten]) .first:before {
  content: "\\EAEA";
}

:host([icon=remote-service-connected]) .first:before {
  content: "\\EAF3";
}

:host([icon=patient-open-tasks]) .first:before {
  content: "\\EAF2";
}

:host([icon=monitor-settings]) .first:before {
  content: "\\EAF1";
}

:host([icon=keyboard]) .first:before {
  content: "\\EAF0";
}

:host([icon=duration]) .first:before {
  content: "\\EAEF";
}

:host([icon=move-mask]) .first:before {
  content: "\\EAFC";
}

:host([icon=cr-cassette]) .first:before {
  content: "\\EAFB";
}

:host([icon=annotations]) .first:before {
  content: "\\EAFA";
}

:host([icon=annotations-edit]) .first:before {
  content: "\\EAF9";
}

:host([icon=annotations-delete]) .first:before {
  content: "\\EAF8";
}

:host([icon=calendar-monthly]) .first:before {
  content: "\\EB2C";
}

:host([icon=calendar-weekly]) .first:before {
  content: "\\EB2D";
}

:host([icon=toolbar-accept-reject]) .first:before {
  content: "\\EB34";
}

:host([icon=step-variants]) .first:before {
  content: "\\EB33";
}

:host([icon=program-template]) .first:before {
  content: "\\EB32";
}

:host([icon=program]) .first:before {
  content: "\\EB31";
}

:host([icon=create-new-step-variants]) .first:before {
  content: "\\EB30";
}

:host([icon=create-new-program-templates]) .first:before {
  content: "\\EB2F";
}

:host([icon=create-new-program]) .first:before {
  content: "\\EB2E";
}

:host([icon=patient-list]) .first:before {
  content: "\\EB3E";
}

:host([icon=layout-split-view]) .first:before {
  content: "\\EB3D";
}

:host([icon=layout-edit]) .first:before {
  content: "\\EB3C";
}

:host([icon=layout-5x4]) .first:before {
  content: "\\EB3B";
}

:host([icon=layout-4x3]) .first:before {
  content: "\\EB3A";
}

:host([icon=layout-3x3]) .first:before {
  content: "\\EB39";
}

:host([icon=layout-3x1]) .first:before {
  content: "\\EB38";
}

:host([icon=image-enlarge]) .first:before {
  content: "\\EB37";
}

:host([icon=export-to-csv]) .first:before {
  content: "\\EB36";
}

:host([icon=dicom-reset]) .first:before {
  content: "\\EB35";
}

:host([icon=shopping-cart-add]) .first:before {
  content: "\\EB41";
}

:host([icon=sync-off]) .first:before {
  content: "\\EB40";
}

:host([icon=dice]) .first:before {
  content: "\\EB06";
}

:host([icon=edge-enhancement-dicom]) .first:before {
  content: "\\EB05";
}

:host([icon=edge-enhancement-high]) .first:before {
  content: "\\EB04";
}

:host([icon=edge-enhancement-off]) .first:before {
  content: "\\EAFF";
}

:host([icon=expand-collapse]) .first:before {
  content: "\\EAFE";
}

:host([icon=handcontrol]) .first:before {
  content: "\\EB0B";
}

:host([icon=image-enhancement]) .first:before {
  content: "\\EB0A";
}

:host([icon=image-enhancement-advanced]) .first:before {
  content: "\\EB09";
}

:host([icon=match-settings]) .first:before {
  content: "\\EB1A";
}

:host([icon=patient-orientation-switch]) .first:before {
  content: "\\EB29";
}

:host([icon=radiation-high]) .first:before {
  content: "\\EB28";
}

:host([icon=repeat]) .first:before {
  content: "\\EB22";
}

:host([icon=report-template-search]) .first:before {
  content: "\\EB21";
}

:host([icon=technician-access]) .first:before {
  content: "\\EB20";
}

:host([icon=pain-scale]) .first:before {
  content: "\\EB2B";
}

:host([icon=patient-management]) .first:before {
  content: "\\EB48";
}

:host([icon=collision]) .first:before {
  content: "\\EB47";
}

:host([icon=browser]) .first:before {
  content: "\\EB46";
}

:host([icon=speaker-enable]) .first:before {
  content: "\\EB50";
}

:host([icon=user-group]) .first:before {
  content: "\\EB51";
}

:host([icon=drive]) .first:before {
  content: "\\EB65";
}

:host([icon=editing-rights]) .first:before {
  content: "\\EB62";
}

:host([icon=mammography-system]) .first:before {
  content: "\\EB61";
}

:host([icon=merge]) .first:before {
  content: "\\EB60";
}

:host([icon=metal-artifact]) .first:before {
  content: "\\EB5F";
}

:host([icon=pat-factor-low]) .first:before {
  content: "\\EB5E";
}

:host([icon=pat-factor-medium]) .first:before {
  content: "\\EB5D";
}

:host([icon=patient-copy-to]) .first:before {
  content: "\\EB5C";
}

:host([icon=patient-move-to]) .first:before {
  content: "\\EB5B";
}

:host([icon=rescue-brake-release]) .first:before {
  content: "\\EB59";
}

:host([icon=sending-job]) .first:before {
  content: "\\EB56";
}

:host([icon=split-horizontally]) .first:before {
  content: "\\EB68";
}

:host([icon=split-vertically]) .first:before {
  content: "\\EB67";
}

:host([icon=stress-layout-edit]) .first:before {
  content: "\\EB66";
}

:host([icon=stress-layout-reset]) .first:before {
  content: "\\EB6F";
}

:host([icon=stress-layout-show]) .first:before {
  content: "\\EB6E";
}

:host([icon=study-merge]) .first:before {
  content: "\\EB6D";
}

:host([icon=study-split]) .first:before {
  content: "\\EB6C";
}

:host([icon=unread]) .first:before {
  content: "\\EB6B";
}

:host([icon=viewing-rights]) .first:before {
  content: "\\EB6A";
}

:host([icon=advanced]) .first:before {
  content: "\\EB72";
}

:host([icon=battery-charging-vertical]) .first:before {
  content: "\\EB73";
}

:host([icon=battery-empty-vertical]) .first:before {
  content: "\\EB74";
}

:host([icon=c-arm-park-position]) .first:before {
  content: "\\EB75";
}

:host([icon=c-arm-save-position]) .first:before {
  content: "\\EB76";
}

:host([icon=c-arm-table]) .first:before {
  content: "\\EB77";
}

:host([icon=distance-calibration]) .first:before {
  content: "\\EB7C";
}

:host([icon=radiation-filter]) .first:before {
  content: "\\EB89";
}

:host([icon=sync-zoom-pan]) .first:before {
  content: "\\EB87";
}

:host([icon=sync-across-timepoints]) .first:before {
  content: "\\EB85";
}

:host([icon=sync-scroll]) .first:before {
  content: "\\EB86";
}

:host([icon=wifi]) .first:before {
  content: "\\EB84";
}

:host([icon=sign-in]) .first:before {
  content: "\\EB8B";
}

:host([icon=sign-out]) .first:before {
  content: "\\EB8C";
}

:host([icon=multiple-patients]) .first:before {
  content: "\\EB7F";
}

:host([icon=inr-medication-quarter-dose]) .first:before,
:host([icon=medication-quarter-dose]) .first:before {
  content: "\\EB8D";
}

:host([icon=rotate-to-0]) .first:before {
  content: "\\EBA5";
}

:host([icon=note-share]) .first:before {
  content: "\\EBA4";
}

:host([icon=metal-artifact-labeling]) .first:before {
  content: "\\EBA3";
}

:host([icon=import-from-usb-stick]) .first:before {
  content: "\\EBA2";
}

:host([icon=import-from-network]) .first:before {
  content: "\\EBA1";
}

:host([icon=export-to-usb-stick]) .first:before {
  content: "\\EBA0";
}

:host([icon=export-to-network]) .first:before {
  content: "\\EB9F";
}

:host([icon=export-to-dvd]) .first:before {
  content: "\\EB9E";
}

:host([icon=contrast]) .first:before {
  content: "\\EB9D";
}

:host([icon=utilities]) .first:before {
  content: "\\EBB2";
}

:host([icon=studies-medical-edit]) .first:before {
  content: "\\EBB1";
}

:host([icon=studies-medical-duplicate]) .first:before {
  content: "\\EBB0";
}

:host([icon=open-tasks-duplicate]) .first:before {
  content: "\\EBAF";
}

:host([icon=ethernet]) .first:before {
  content: "\\EBAE";
}

:host([icon=add-to-list]) .first:before {
  content: "\\EBD8";
}

:host([icon=bar-code-scanner]) .first:before {
  content: "\\EBD7";
}

:host([icon=footswitch-battery-2]) .first:before {
  content: "\\EBD2";
}

:host([icon=footswitch-battery-3]) .first:before {
  content: "\\EBD1";
}

:host([icon=footswitch-battery-4]) .first:before {
  content: "\\EBD0";
}

:host([icon=footswitch-battery-full]) .first:before {
  content: "\\EBCE";
}

:host([icon=handcontrol-battery-2]) .first:before {
  content: "\\EBCC";
}

:host([icon=handcontrol-battery-3]) .first:before {
  content: "\\EBCB";
}

:host([icon=handcontrol-battery-4]) .first:before {
  content: "\\EBCA";
}

:host([icon=handcontrol-battery-full]) .first:before {
  content: "\\EBC9";
}

:host([icon=injection-pump]) .first:before {
  content: "\\EBC8";
}

:host([icon=laboratory-system-scheduler]) .first:before {
  content: "\\EBC7";
}

:host([icon=open-tasks-quality]) .first:before {
  content: "\\EBC6";
}

:host([icon=remote-desktop]) .first:before {
  content: "\\EBC5";
}

:host([icon=remote-desktop-cancel]) .first:before {
  content: "\\EBC3";
}

:host([icon="utility-chart,"][icon=utility-cart]) .first:before {
  content: "\\EBBB";
}

:host([icon=window]) .first:before {
  content: "\\EBBA";
}

:host([icon=hematology]) .first:before {
  content: "\\EBDC";
}

:host([icon=copy-reference-target-table]) .first:before {
  content: "\\EBDB";
}

:host([icon=copy-reference-source-table]) .first:before {
  content: "\\EBDA";
}

:host([icon=touch-ui-home]) .first:before {
  content: "\\EBDE";
}

:host([icon=batch-orders]) .first:before {
  content: "\\EBED";
}

:host([icon=body-registration-anterior-posterior]) .first:before {
  content: "\\EBEC";
}

:host([icon=body-registration-lateral]) .first:before {
  content: "\\EBEB";
}

:host([icon=body-registration-superior-inferior]) .first:before {
  content: "\\EBEA";
}

:host([icon=cold-storage]) .first:before {
  content: "\\EBE9";
}

:host([icon=document-format]) .first:before {
  content: "\\EBE8";
}

:host([icon=document-scanner]) .first:before {
  content: "\\EBE7";
}

:host([icon=notification-off]) .first:before {
  content: "\\EBE3";
}

:host([icon=workflow-guided]) .first:before {
  content: "\\EBE2";
}

:host([icon=door-closed]) .first:before {
  content: "\\EBF2";
}

:host([icon=door-open]) .first:before {
  content: "\\EBF3";
}

:host([icon=reference-image-lock]) .first:before {
  content: "\\EBF8";
}

:host([icon=transfer-to-reference]) .first:before {
  content: "\\EBFB";
}

:host([icon=multiselect]) .first:before {
  content: "\\EBF6";
}

:host([icon=media-library]) .first:before {
  content: "\\EBF5";
}

:host([icon=rotate-text]) .first:before {
  content: "\\EBF9";
}

:host([icon=community]) .first:before {
  content: "\\EBFC";
}

:host([icon=study-forward]) .first:before {
  content: "\\EBFD";
}

:host([icon=detector-big]) .first:before {
  content: "\\EBFF";
}

:host([icon=detector-big-handle]) .first:before {
  content: "\\EBFE";
}

:host([icon=detector-small]) .first:before {
  content: "\\EC00";
}

:host([icon=detector-standard]) .first:before {
  content: "\\EC02";
}

:host([icon=detector-standard-handle]) .first:before {
  content: "\\EC01";
}

:host([icon=document-margins]) .first:before {
  content: "\\EC03";
}

:host([icon=highlighter]) .first:before {
  content: "\\EC0D";
}

:host([icon=image-save]) .first:before {
  content: "\\EC0E";
}

:host([icon=series-save]) .first:before {
  content: "\\EC12";
}

:host([icon=myocardial-map-t1]) .first:before {
  content: "\\EC0F";
}

:host([icon=myocardial-map-t2]) .first:before {
  content: "\\EC11";
}

:host([icon=myocardial-map-t2-star]) .first:before {
  content: "\\EC10";
}

:host([icon=speaker-bluetooth]) .first:before {
  content: "\\EC13";
}

:host([icon=study-received]) .first:before {
  content: "\\EC15";
}

:host([icon=table-view-switch]) .first:before {
  content: "\\EC16";
}

:host([icon=sort-ascending]) .first:before {
  content: "\\EC1E";
}

:host([icon=sort-descending]) .first:before {
  content: "\\EC1F";
}

:host([icon=resize-segments]) .first:before {
  content: "\\EC20";
}

:host([icon=pin]) .first:before {
  content: "\\EC24";
}

:host([icon=unpin]) .first:before {
  content: "\\EC25";
}

:host([icon=patient-orientation-define]) .first:before {
  content: "\\EC23";
}

:host([icon=monitoring-viewer]) .first:before {
  content: "\\EC22";
}

:host([icon=layout-grid]) .first:before {
  content: "\\EC21";
}

:host([icon=tree-map]) .first:before {
  content: "\\EC35";
}

:host([icon=scatter-plot]) .first:before {
  content: "\\EC34";
}

:host([icon=pivot-table]) .first:before {
  content: "\\EC33";
}

:host([icon=pie-chart]) .first:before {
  content: "\\EC32";
}

:host([icon=kpi]) .first:before {
  content: "\\EC30";
}

:host([icon=thumbnail-viewmode]) .first:before {
  content: "\\EC4B";
}

:host([icon=preview-mode]) .first:before {
  content: "\\EC38";
}

:host([icon=cp-mode]) .first:before {
  content: "\\EC31";
}

:host([icon=range-tools]) .first:before {
  content: "\\EC48";
}

:host([icon=mr-conditional]) .first:before {
  content: "\\EC37";
}

:host([icon=pacs]) .first:before {
  content: "\\EC4E";
}

:host([icon=kvm-switch]) .first:before {
  content: "\\EC4D";
}

:host([icon=weight]) .first:before {
  content: "\\EC4F";
}

:host([icon=scheduled-autofill]) .first:before {
  content: "\\EC52";
}

:host([icon=other-devices]) .first:before {
  content: "\\EC51";
}

:host([icon=image-not-available]) .first:before {
  content: "\\EA7f";
}

:host(:not([color])[icon=image-not-available]) .first:after {
  content: "\\E996";
  color: rgba(var(--functional-red));
}

:host(:not([color])[icon=image-not-available]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([icon=dicom-archivable]) .first:before {
  content: "\\EA1A";
}

:host([size=xs][icon=dicom-archivable]) .first:before {
  content: "\\EA19";
}

:host([icon=organizer-tree]) .first:before {
  content: "\\EB81";
}

:host([size=xs][icon=organizer-tree]) .first:before {
  content: "\\EB80";
}

:host([icon=marked]) .first:before {
  content: "\\EAE8";
}

:host([size=xs][icon=marked]) .first:before {
  content: "\\EAE7";
}

:host([icon=analytics]) .first:before {
  content: "\\EA48";
}

:host([size=xs][icon=analytics]) .first:before {
  content: "\\EA47";
}

:host([icon=validate-all]) .first:before {
  content: "\\EAF5";
}

:host([size=s][icon=validate-all]) .first:before {
  content: "\\EAF4";
}

:host([icon=shopping-cart]) .first:before {
  content: "\\EAF7";
}

:host([size=xs][icon=shopping-cart]) .first:before {
  content: "\\EAF6";
}

:host([size=xs][icon=open-link]) .first:before {
  content: "\\EAB5";
}

:host([size=s][icon=open-link]) .first:before {
  content: "\\EAB6";
}

:host([size=m][icon=open-link]) .first:before {
  content: "\\EAB7";
}

:host([icon=settings]) .first:before {
  content: "\\E023";
}

:host([size=s][icon=settings]) .first:before {
  content: "\\EBFA";
}

:host([icon=notification-center]) .first:before {
  content: "\\E135";
}

:host([size=s][icon=notification-center]) .first:before {
  content: "\\EBF7";
}

:host([icon=dragable]) .first:before,
:host([icon=draggable]) .first:before,
:host([icon=draggable-vertical-s]) .first:before {
  content: "\\EA7C";
}

:host([size=s][icon=draggable-vertical-s]) .first:before {
  content: "\\EC06";
}

:host([size=xs][icon=draggable-vertical-s]) .first:before {
  content: "\\EC19";
}

:host([size=xs][icon=draggable-horizontal-s]) .first:before {
  content: "\\EC18";
}

:host([size=s][icon=draggable-horizontal-s]) .first:before {
  content: "\\EC1A";
}

:host([size=m][icon=draggable-horizontal-s]) .first:before {
  content: "\\EC1B";
}

:host([size=l][icon=draggable-horizontal-s]) .first:before {
  content: "\\EC1B";
}

:host([size=xs][icon=draggable-horizontal-l]) .first:before {
  content: "\\EC05";
}

:host([size=s][icon=draggable-horizontal-l]) .first:before {
  content: "\\EC04";
}

:host([size=m][icon=draggable-horizontal-l]) .first:before {
  content: "\\EC05";
}

:host([size=l][icon=draggable-horizontal-l]) .first:before {
  content: "\\EC04";
}

:host([size=xs][icon=bookmark]) .first:before {
  content: "\\EBEF";
}

:host([size=s][icon=bookmark]) .first:before {
  content: "\\EBF0";
}

:host([size=m][icon=bookmark]) .first:before {
  content: "\\EBF1";
}

:host([size=l][icon=bookmark]) .first:before {
  content: "\\EBF0";
}

:host([icon=help]) .first:before {
  content: "\\E007";
}

:host([size=xs][icon=help]) .first:before {
  content: "\\EA9D";
}

:host([size=s][icon=help]) .first:before {
  content: "\\EBF4";
}

:host([size=xs][icon=standard-privacy]) .first:before {
  content: "\\EA39";
}

:host([size=s][icon=standard-privacy]) .first:before {
  content: "\\EA3A";
}

:host([size=m][icon=standard-privacy]) .first:before {
  content: "\\EA3B";
}

:host([size=l][icon=standard-privacy]) .first:before {
  content: "\\EA3A";
}

:host([size=xs][icon=restrictive-privacy]) .first:before {
  content: "\\EA36";
}

:host([size=s][icon=restrictive-privacy]) .first:before {
  content: "\\EA37";
}

:host([size=m][icon=restrictive-privacy]) .first:before {
  content: "\\EA38";
}

:host([size=l][icon=restrictive-privacy]) .first:before {
  content: "\\EA37";
}

:host([size=xs][icon=no-data-minimization]) .first:before {
  content: "\\EA33";
}

:host([size=s][icon=no-data-minimization]) .first:before {
  content: "\\EA34";
}

:host([size=m][icon=no-data-minimization]) .first:before {
  content: "\\EA35";
}

:host([size=l][icon=no-data-minimization]) .first:before {
  content: "\\EA34";
}

:host([size=xs][icon=high-privacy]) .first:before {
  content: "\\EA30";
}

:host([size=s][icon=high-privacy]) .first:before {
  content: "\\EA31";
}

:host([size=m][icon=high-privacy]) .first:before {
  content: "\\EA32";
}

:host([size=l][icon=high-privacy]) .first:before {
  content: "\\EA31";
}

:host([size=xs][icon=customized-privacy]) .first:before {
  content: "\\EA2D";
}

:host([size=s][icon=customized-privacy]) .first:before {
  content: "\\EA2E";
}

:host([size=m][icon=customized-privacy]) .first:before {
  content: "\\EA2F";
}

:host([size=l][icon=customized-privacy]) .first:before {
  content: "\\EA2E";
}

:host([size=xs][icon=result-table]) .first:before {
  content: "\\EB57";
}

:host([size=s][icon=result-table]) .first:before {
  content: "\\EB57";
}

:host([size=m][icon=result-table]) .first:before {
  content: "\\EB58";
}

:host([size=l][icon=result-table]) .first:before {
  content: "\\EB58";
}

:host([size=xs][icon=information]) .first:before {
  content: "\\E950";
}

:host([size=xs][icon=information]) .first:after {
  content: "\\E032";
  color: rgb(var(--ui-7));
}

:host([size=s][icon=information]) .first:before {
  content: "\\E957";
}

:host([size=s][icon=information]) .first:after {
  content: "\\E959";
  color: rgb(var(--ui-7));
}

:host([size=m][icon=information]) .first:before {
  content: "\\E94F";
}

:host([size=m][icon=information]) .first:after {
  content: "\\E952";
  color: rgb(var(--ui-7));
}

:host([size=l][icon=information]) .first:before {
  content: "\\E957";
}

:host([size=l][icon=information]) .first:after {
  content: "\\E959";
  color: rgb(var(--ui-7));
}

:host(:not([color])[size=xs][icon=information]) .first:before {
  content: "\\E950";
  color: #6e7b9f;
}

:host(:not([color])[size=xs][icon=information]) .first:after {
  content: "\\E032";
  color: #ffffff;
}

:host(:not([color])[size=s][icon=information]) .first:before {
  content: "\\E957";
  color: #6e7b9f;
}

:host(:not([color])[size=s][icon=information]) .first:after {
  content: "\\E959";
  color: #ffffff;
}

:host(:not([color])[size=m][icon=information]) .first:before {
  content: "\\E94F";
  color: #6e7b9f;
}

:host(:not([color])[size=m][icon=information]) .first:after {
  content: "\\E952";
  color: #ffffff;
}

:host(:not([color])[size=l][icon=information]) .first:before {
  content: "\\E957";
  color: #6e7b9f;
}

:host(:not([color])[size=l][icon=information]) .first:after {
  content: "\\E959";
  color: #ffffff;
}

:host([icon=confirmation]) .first:before {
  content: "\\E0BA";
}

:host([icon=confirmation]) .first:after {
  content: "\\EA5A";
  color: #ffffff;
}

:host(:not([color])[icon=confirmation]) .first:before {
  content: "\\E0BA";
  color: #6e7b9f;
}

:host(:not([color])[icon=confirmation]) .first:after {
  content: "\\EA5A";
  color: #ffffff;
}

:host([size=xs][icon=confirmation]) .first:before {
  content: "\\EA58";
}

:host([size=xs][icon=confirmation]) .first:after {
  content: "\\EA59";
  color: #ffffff;
}

:host(:not([color])[size=xs][icon=confirmation]) .first:before {
  content: "\\EA58";
  color: #6e7b9f;
}

:host(:not([color])[size=xs][icon=confirmation]) .first:after {
  content: "\\EA59";
  color: #ffffff;
}

:host([size=xs][color][icon=error]) .first:before {
  content: "\\E950";
}

:host([size=xs][color][icon=error]) .first:after {
  content: "\\E031";
  color: rgb(var(--ui-7));
}

:host([size=xs]:not([color])[icon=error]) .first:before {
  content: "\\E950";
  color: rgba(var(--functional-red), var(--opacity-1));
}

:host([size=xs]:not([color])[icon=error]) .first:after {
  content: "\\E031";
  color: white;
}

:host([size=s][color][icon=error]) .first:before {
  content: "\\E957";
}

:host([size=s][color][icon=error]) .first:after {
  content: "\\E958";
  color: rgb(var(--ui-7));
}

:host([size=s]:not([color])[icon=error]) .first:before {
  content: "\\E957";
  color: rgba(var(--functional-red), var(--opacity-1));
}

:host([size=s]:not([color])[icon=error]) .first:after {
  content: "\\E958";
  color: white;
}

:host([size=m][color][icon=error]) .first:before {
  content: "\\E94F";
}

:host([size=m][color][icon=error]) .first:after {
  content: "\\E951";
  color: rgb(var(--ui-7));
}

:host([size=m]:not([color])[icon=error]) .first:before {
  content: "\\E94F";
  color: rgba(var(--functional-red), var(--opacity-1));
}

:host([size=m]:not([color])[icon=error]) .first:after {
  content: "\\E951";
  color: white;
}

:host([size=l][color][icon=error]) .first:before {
  content: "\\E957";
}

:host([size=l][color][icon=error]) .first:after {
  content: "\\E958";
  color: rgb(var(--ui-7));
}

:host([size=l]:not([color])[icon=error]) .first:before {
  content: "\\E957";
  color: rgba(var(--functional-red), var(--opacity-1));
}

:host([size=l]:not([color])[icon=error]) .first:after {
  content: "\\E958";
  color: white;
}

:host([size=xs][icon=cancel]) .first:before {
  content: "\\E002";
}

:host([size=s][icon=cancel]) .first:before {
  content: "\\E98D";
}

:host([size=m][icon=cancel]) .first:before {
  content: "\\E98C";
}

:host([size=l][icon=cancel]) .first:before {
  content: "\\E98D";
}

:host([size=xs][color][icon=success]) .first:before {
  content: "\\E950";
}

:host([size=xs][color][icon=success]) .first:after {
  content: "\\E033";
  color: rgb(var(--ui-7));
}

:host([size=xs]:not([color])[icon=success]) .first:before {
  content: "\\E950";
  color: rgba(var(--functional-green), var(--opacity-1));
}

:host([size=xs]:not([color])[icon=success]) .first:after {
  content: "\\E033";
  color: white;
}

:host([size=s][color][icon=success]) .first:before {
  content: "\\E957";
}

:host([size=s][color][icon=success]) .first:after {
  content: "\\E95A";
  color: rgb(var(--ui-7));
}

:host([size=s]:not([color])[icon=success]) .first:before {
  content: "\\E957";
  color: rgba(var(--functional-green), var(--opacity-1));
}

:host([size=s]:not([color])[icon=success]) .first:after {
  content: "\\E95A";
  color: white;
}

:host([size=m][color][icon=success]) .first:before {
  content: "\\E94F";
}

:host([size=m][color][icon=success]) .first:after {
  content: "\\E953";
  color: rgb(var(--ui-7));
}

:host([size=m]:not([color])[icon=success]) .first:before {
  content: "\\E94F";
  color: rgba(var(--functional-green), var(--opacity-1));
}

:host([size=m]:not([color])[icon=success]) .first:after {
  content: "\\E953";
  color: white;
}

:host([size=l][color][icon=success]) .first:before {
  content: "\\E957";
}

:host([size=l][color][icon=success]) .first:after {
  content: "\\E95A";
  color: rgb(var(--ui-7));
}

:host([size=l]:not([color])[icon=success]) .first:before {
  content: "\\E957";
  color: rgba(var(--functional-green), var(--opacity-1));
}

:host([size=l]:not([color])[icon=success]) .first:after {
  content: "\\E95A";
  color: white;
}

:host([size=xs][color][icon=warning]) .first:before {
  content: "\\E950";
}

:host([size=xs][color][icon=warning]) .first:after {
  content: "\\E034";
  color: rgb(var(--ui-7));
}

:host([size=xs]:not([color])[icon=warning]) .first:before {
  content: "\\E950";
  color: rgba(var(--functional-yellow), var(--opacity-1));
}

:host([size=xs]:not([color])[icon=warning]) .first:after {
  content: "\\E034";
  color: black;
}

:host([size=s][color][icon=warning]) .first:before {
  content: "\\E957";
}

:host([size=s][color][icon=warning]) .first:after {
  content: "\\E95B";
  color: rgb(var(--ui-7));
}

:host([size=s]:not([color])[icon=warning]) .first:before {
  content: "\\E957";
  color: rgba(var(--functional-yellow), var(--opacity-1));
}

:host([size=s]:not([color])[icon=warning]) .first:after {
  content: "\\E95B";
  color: black;
}

:host([size=m][color][icon=warning]) .first:before {
  content: "\\E94F";
}

:host([size=m][color][icon=warning]) .first:after {
  content: "\\E954";
  color: rgb(var(--ui-7));
}

:host([size=m]:not([color])[icon=warning]) .first:before {
  content: "\\E94F";
  color: rgba(var(--functional-yellow), var(--opacity-1));
}

:host([size=m]:not([color])[icon=warning]) .first:after {
  content: "\\E954";
  color: black;
}

:host([size=l][color][icon=warning]) .first:before {
  content: "\\E957";
}

:host([size=l][color][icon=warning]) .first:after {
  content: "\\E95B";
  color: rgb(var(--ui-7));
}

:host([size=l]:not([color])[icon=warning]) .first:before {
  content: "\\E957";
  color: rgba(var(--functional-yellow), var(--opacity-1));
}

:host([size=l]:not([color])[icon=warning]) .first:after {
  content: "\\E95B";
  color: black;
}

:host([color][icon=in-progress]) .first:before {
  content: "\\EB07";
}

:host(:not([color])[icon=in-progress]) .first:before {
  content: "\\EB1C";
  color: #66bcea;
}

:host(:not([color])[icon=in-progress]) .first:after {
  content: "\\EB1B";
  color: black;
}

:host([size=xs][icon=pat-factor]) .first:before {
  content: "\\EA83";
}

:host([size=m][icon=pat-factor]) .first:before {
  content: "\\EA84";
}

:host([icon=generic-lesion-marker]) .first:before {
  content: "\\EBB3";
  color: rgba(var(--ui-1), var(--opacity-2));
}

:host(:not([color])[icon=generic-lesion-marker]) .first:after {
  content: "\\EBB4";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([color][icon=generic-lesion-marker]) .first:after {
  content: "\\EBB4";
}

:host([icon=liver-lesion-marker]) .first:before {
  content: "\\EBB8";
  color: rgba(var(--ui-1), var(--opacity-2));
}

:host(:not([color])[icon=liver-lesion-marker]) .first:after {
  content: "\\EBB9";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([color][icon=liver-lesion-marker]) .first:after {
  content: "\\EBB9";
}

:host([icon=lung-lesion-marker]) .first:before {
  content: "\\EBB5";
  color: rgba(var(--ui-1), var(--opacity-2));
}

:host([icon=lung-lesion-marker]) .first:after {
  content: "\\EBB6 ";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host(:not([color])[icon=lung-lesion-marker]) .second:before {
  content: "\\EBB7 ";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([color][icon=lung-lesion-marker]) .second:before {
  content: "\\EBB7 ";
}

:host([icon=two-d-view]) .first:before,
:host([icon=view-2d]) .first:before {
  content: "\\E14F";
}

:host([icon=two-d-view]) .first:after,
:host([icon=view-2d]) .first:after {
  content: "\\E151";
  color: rgba(var(--ui-1), var(--opacity-5));
}

:host([icon=airways-analyse]) .first:before {
  content: "\\E0FE";
}

:host([icon=airways-analyse]) .first:after {
  content: "\\E0FD";
  color: rgba(var(--ui-1), var(--opacity-5));
}

:host([icon=hide]) .first:before {
  content: "\\E100";
}

:host([icon=hide]) .first:after {
  content: "\\E0FF";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=head-first-supine]) .first:before {
  content: "\\E102";
}

:host([icon=head-first-supine]) .first:after {
  content: "\\E103";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=head-first-left-lateral]) .first:before {
  content: "\\E104";
}

:host([icon=head-first-left-lateral]) .first:after {
  content: "\\E105";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=head-first-right-lateral]) .first:before {
  content: "\\E106";
}

:host([icon=head-first-right-lateral]) .first:after {
  content: "\\E107";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=head-first-prone]) .first:before {
  content: "\\E108";
}

:host([icon=head-first-prone]) .first:after {
  content: "\\E109";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=feet-first-supine]) .first:before {
  content: "\\E10A";
}

:host([icon=feet-first-supine]) .first:after {
  content: "\\E10B";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=feet-first-left-lateral]) .first:before {
  content: "\\E10A";
}

:host([icon=feet-first-left-lateral]) .first:after {
  content: "\\E10C";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=feet-first-right-lateral]) .first:before {
  content: "\\E10A";
}

:host([icon=feet-first-right-lateral]) .first:after {
  content: "\\E10D";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=head-left-supine]) .first:before {
  content: "\\E10F";
}

:host([icon=head-left-supine]) .first:after {
  content: "\\E110";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=head-right-supine]) .first:before {
  content: "\\E111";
}

:host([icon=head-right-supine]) .first:after {
  content: "\\E112";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=head-left-prone]) .first:before {
  content: "\\E113";
}

:host([icon=head-left-prone]) .first:after {
  content: "\\E114";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=head-right-prone]) .first:before {
  content: "\\E115";
}

:host([icon=head-right-prone]) .first:after {
  content: "\\E116";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=upright]) .first:before {
  content: "\\E117";
}

:host([icon=upright]) .first:after {
  content: "\\E118";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=position-undefined]) .first:before {
  content: "\\E10A";
}

:host([icon=position-undefined]) .first:after {
  content: "\\E119";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=plantar]) .first:before {
  content: "\\E10A";
}

:host([icon=plantar]) .first:after {
  content: "\\E11A";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=superman-supine-wrist]) .first:before {
  content: "\\E11F";
}

:host([icon=superman-supine-wrist]) .first:after {
  content: "\\E11C";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=superman-prone-wrist]) .first:before {
  content: "\\E11D";
}

:host([icon=superman-prone-wrist]) .first:after {
  content: "\\E11E";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=superman-supine-elbow]) .first:before {
  content: "\\E11B";
}

:host([icon=superman-supine-elbow]) .first:after {
  content: "\\E11C";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=superman-prone-elbow]) .first:before {
  content: "\\E120";
}

:host([icon=superman-prone-elbow]) .first:after {
  content: "\\E11E";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=gantry-tilt]) .first:before {
  content: "\\E130";
}

:host([icon=gantry-tilt]) .first:after {
  content: "\\E122";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=gantry-tilt-left]) .first:before {
  content: "\\E123";
}

:host([icon=gantry-tilt-left]) .first:after {
  content: "\\E124";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=gantry-tilt-right]) .first:before {
  content: "\\E126";
}

:host([icon=gantry-tilt-right]) .first:after {
  content: "\\E125";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=image-hide]) .first:before {
  content: "\\E12A";
}

:host([icon=image-hide]) .first:after {
  content: "\\E129";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=image-text-hide]) .first:before {
  content: "\\E144";
}

:host([icon=image-text-hide]) .first:after {
  content: "\\E143";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=rotate-cw-90]) .first:before {
  content: "\\E149";
}

:host([icon=rotate-cw-90]) .first:after {
  content: "\\E14A";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=rotate-ccw-90]) .first:before {
  content: "\\E147";
}

:host([icon=rotate-ccw-90]) .first:after {
  content: "\\E148";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=pixel-lens]) .first:before {
  content: "\\E146";
}

:host([icon=pixel-lens]) .first:after {
  content: "\\E150";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=rotate-perpendicular]) .first:before {
  content: "\\E14C";
}

:host([icon=rotate-perpendicular]) .first:after {
  content: "\\E14D";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=flip-horizontal]) .first:before {
  content: "\\E13B";
}

:host([icon=flip-horizontal]) .first:after {
  content: "\\E13A";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=flip-vertical]) .first:before {
  content: "\\E13F";
}

:host([icon=flip-vertical]) .first:after {
  content: "\\E13E";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=flip-popup]) .first:before {
  content: "\\E13D";
}

:host([icon=flip-popup]) .first:after {
  content: "\\E13C";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=ecg-connection-state]) .first:before {
  content: "\\E902";
}

:host([icon=ecg-connection-state]) .first:after {
  content: "\\E903";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=signal-strength-4]) .first:before {
  content: "\\E92A";
}

:host([icon=signal-strength-4]) .first:after {
  content: "\\E92B";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=signal-strength-3]) .first:before {
  content: "\\E928";
}

:host([icon=signal-strength-3]) .first:after {
  content: "\\E929";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=signal-strength-2]) .first:before {
  content: "\\E926";
}

:host([icon=signal-strength-2]) .first:after {
  content: "\\E927";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=signal-strength-1]) .first:before {
  content: "\\E924";
}

:host([icon=signal-strength-1]) .first:after {
  content: "\\E925";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=select-monitor]) .first:before {
  content: "\\E920";
}

:host([icon=select-monitor]) .first:after {
  content: "\\E91F";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=patient-table]) .first:before {
  content: "\\E91D";
}

:host([icon=patient-table]) .first:after {
  content: "\\E91C";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=intervention-layout-switch]) .first:before {
  content: "\\E916";
}

:host([icon=intervention-layout-switch]) .first:after {
  content: "\\E915";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=connection-quality-low]) .first:before {
  content: "\\E90C";
}

:host([icon=connection-quality-low]) .first:after {
  content: "\\E90D";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=compass-direction-w]) .first:before {
  content: "\\E90B";
  color: #000000;
}

:host([icon=compass-direction-w]) .first:after {
  content: "\\E90A";
  color: rgba(var(--functional-yellow), var(--opacity-1));
}

:host([icon=show-breathing-curve]) .first:before {
  content: "\\E949";
}

:host([icon=show-breathing-curve]) .first:after {
  content: "\\E94A";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=relative-zero-position]) .first:before {
  content: "\\E946";
}

:host([icon=relative-zero-position]) .first:after {
  content: "\\E947";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=patient-mark]) .first:before {
  content: "\\E944";
}

:host([icon=patient-mark]) .first:after {
  content: "\\E945";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=physician]) .first:before {
  content: "\\E94C";
}

:host([icon=physician]) .first:after {
  content: "\\E94D";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=table-removal]) .first:before {
  content: "\\E972";
}

:host([icon=table-removal]) .first:after {
  content: "\\E973";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=mdt-ready]) .first:before {
  content: "\\E96D";
}

:host([icon=mdt-ready]) .first:after {
  content: "\\E96E";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=kidneys]) .first:before {
  content: "\\E977";
}

:host([icon=kidneys]) .first:after {
  content: "\\E978";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=lung]) .first:before {
  content: "\\E97A";
}

:host([icon=lung]) .first:after {
  content: "\\E97B";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=light-funnel]) .first:before {
  content: "\\E986";
}

:host([icon=light-funnel]) .first:after {
  content: "\\E987";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=light-ring]) .first:before {
  content: "\\E988";
}

:host([icon=light-ring]) .first:after {
  content: "\\E989";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=show-laser-crosshair]) .first:before,
:host([icon=laser-crosshair-show]) .first:before {
  content: "\\E99A";
}

:host([icon=show-laser-crosshair]) .first:after,
:host([icon=laser-crosshair-show]) .first:after {
  content: "\\E99B";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=user-position-left]) .first:before {
  content: "\\E99C";
}

:host([icon=user-position-left]) .first:after {
  content: "\\E99D";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=user-position-right]) .first:before {
  content: "\\E99E";
}

:host([icon=user-position-right]) .first:after {
  content: "\\E99F";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=inr-medication]) .first:before,
:host([icon=inr-measurement]) .first:before {
  content: "\\E9A9";
}

:host([icon=inr-medication]) .first:after,
:host([icon=inr-measurement]) .first:after {
  content: "\\E9A8";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=laboratory]) .first:before {
  content: "\\E9C4";
}

:host([icon=laboratory]) .first:after {
  content: "\\E9C5";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=fov-segment]) .first:before {
  content: "\\E9E9";
}

:host([icon=fov-segment]) .first:after {
  content: "\\E9E8";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=light-bore]) .first:before {
  content: "\\E9E5";
}

:host([icon=light-bore]) .first:after {
  content: "\\E9E6";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=light-outer-ring]) .first:before {
  content: "\\E9E3";
}

:host([icon=light-outer-ring]) .first:after {
  content: "\\E9E4";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=lobes-edit-sync]) .first:before {
  content: "\\E9E2";
}

:host([icon=lobes-edit-sync]) .first:after {
  content: "\\E9E1";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=open-reconstruction-tab]) .first:before {
  content: "\\E9DA";
}

:host([icon=open-reconstruction-tab]) .first:after {
  content: "\\E9D9";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=patient-position-change]) .first:before {
  content: "\\E9D8";
}

:host([icon=patient-position-change]) .first:after {
  content: "\\E9D7";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=qr-code-scan]) .first:before {
  content: "\\E9D4";
}

:host([icon=qr-code-scan]) .first:after {
  content: "\\E9D5";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=reference-segment]) .first:before {
  content: "\\E9D2";
}

:host([icon=reference-segment]) .first:after {
  content: "\\E9D1";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=show-hide-peak-information-map]) .first:before {
  content: "\\E992";
}

:host([icon=show-hide-peak-information-map]) .first:after {
  content: "\\E98A";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=show-hide-saturation-region]) .first:before {
  content: "\\E9FE";
}

:host([icon=show-hide-saturation-region]) .first:after {
  content: "\\E9FD";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=skull-unfolding]) .first:before {
  content: "\\E9FC";
}

:host([icon=skull-unfolding]) .first:after {
  content: "\\E9FB";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=user-planes]) .first:before {
  content: "\\E9F7";
}

:host([icon=user-planes]) .first:after {
  content: "\\E9F8";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=move-to-rt-laser]) .first:before {
  content: "\\EA0E";
}

:host([icon=move-to-rt-laser]) .first:after {
  content: "\\EA0D";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=move-to-ct-laser]) .first:before {
  content: "\\EA0B";
}

:host([icon=move-to-ct-laser]) .first:after {
  content: "\\EA0C";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=disc-space-1]) .first:before {
  content: "\\EA11";
}

:host([icon=disc-space-1]) .first:after {
  content: "\\EA15";
  color: rgba(var(--ui-1), var(--opacity-1));
}

:host([icon=disc-space-2]) .first:before {
  content: "\\EA16";
}

:host([icon=disc-space-2]) .first:after {
  content: "\\EA15";
  color: rgba(var(--ui-1), var(--opacity-1));
}

:host([icon=disc-space-3]) .first:before {
  content: "\\EA12";
}

:host([icon=disc-space-3]) .first:after {
  content: "\\EA15";
  color: rgba(var(--ui-1), var(--opacity-1));
}

:host([icon=disc-space-4]) .first:before {
  content: "\\EA13";
}

:host([icon=disc-space-4]) .first:after {
  content: "\\EA15";
  color: rgba(var(--ui-1), var(--opacity-1));
}

:host([icon=disc-space-5]) .first:before {
  content: "\\EA14";
}

:host([icon=disc-space-5]) .first:after {
  content: "\\EA15";
  color: rgba(var(--ui-1), var(--opacity-1));
}

:host([icon=annotations-hide]) .first:before {
  content: "\\EA10";
}

:host([icon=annotations-hide]) .first:after {
  content: "\\EA17";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=table-longitudinal-closeup]) .first:before {
  content: "\\EA41";
}

:host([icon=table-longitudinal-closeup]) .first:after {
  content: "\\EA42";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=move-table-top-only]) .first:before {
  content: "\\EA43";
}

:host([icon=move-table-top-only]) .first:after {
  content: "\\EA44";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=light-all]) .first:before {
  content: "\\E985";
}

:host([icon=light-all]) .first:after {
  content: "\\EA45";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=vessel-lumen-show]) .first:before {
  content: "\\EA4A";
}

:host([icon=vessel-lumen-show]) .first:after {
  content: "\\EA4C";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=pulmonary-density]) .first:before {
  content: "\\EA50";
}

:host([icon=pulmonary-density]) .first:after {
  content: "\\EA51";
  color: #be1818;
}

:host([icon=graphics-hide]) .first:before {
  content: "\\EA55";
}

:host([icon=graphics-hide]) .first:after {
  content: "\\EA56";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=pulse-oximetry]) .first:before {
  content: "\\EA5F";
}

:host([icon=pulse-oximetry]) .first:after {
  content: "\\EA60";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=chessboard-view]) .first:before {
  content: "\\EA72";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=chessboard-view]) .first:after {
  content: "\\EA73";
}

:host([icon=contour-cut-axial-caudal]) .first:before {
  content: "\\EA74";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=contour-cut-axial-caudal]) .first:after {
  content: "\\EA75";
}

:host([icon=contour-cut-axial-cranial]) .first:before {
  content: "\\EA76";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=contour-cut-axial-cranial]) .first:after {
  content: "\\EA77";
}

:host([icon=poi-crosshair-move]) .first:before {
  content: "\\EA85";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=poi-crosshair-move]) .first:after {
  content: "\\EA86";
}

:host([icon=poi-new]) .first:before {
  content: "\\EA87";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=poi-new]) .first:after {
  content: "\\EA88";
}

:host([icon=poi-to-crosshair]) .first:before {
  content: "\\EA89";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=poi-to-crosshair]) .first:after {
  content: "\\EA8a";
}

:host([icon=breast]) .first:before {
  content: "\\E056";
}

:host([icon=breast]) .first:after {
  content: "\\E0D8";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=breast-analytics]) .first:before {
  content: "\\E0D9";
}

:host([icon=breast-analytics]) .first:after {
  content: "\\EA8D";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=clinical-trial-matching]) .first:before {
  content: "\\EA8E";
}

:host([icon=clinical-trial-matching]) .first:after {
  content: "\\EA8F";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=coronary-artery-disease]) .first:before {
  content: "\\EA90";
}

:host([icon=coronary-artery-disease]) .first:after {
  content: "\\E0DA";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=infectious-disease]) .first:before {
  content: "\\EA91";
}

:host([icon=infectious-disease]) .first:after {
  content: "\\EA92";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=infectious-disease-analytics]) .first:before {
  content: "\\EA93";
}

:host([icon=infectious-disease-analytics]) .first:after {
  content: "\\EA92";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=lung-analytics]) .first:before {
  content: "\\EA94";
}

:host([icon=lung-analytics]) .first:after {
  content: "\\EA95";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=prostate]) .first:before {
  content: "\\EA96";
}

:host([icon=prostate]) .first:after {
  content: "\\EA97";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=prostate-analytics]) .first:before {
  content: "\\EA98";
}

:host([icon=prostate-analytics]) .first:after {
  content: "\\EA97";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=valvular-heart-disease]) .first:before {
  content: "\\EA99";
}

:host([icon=valvular-heart-disease]) .first:after {
  content: "\\EA9A";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=three-d-camera]) .first:before {
  content: "\\EAA0";
}

:host([icon=three-d-camera]) .first:after {
  content: "\\EA9F";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=radiopaedia]) .first:before {
  content: "\\EAA6";
}

:host([icon=radiopaedia]) .first:after {
  content: "\\EAA5";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=auto-organ-segmentation]) .first:before {
  content: "\\EAAE";
}

:host([icon=auto-organ-segmentation]) .first:after {
  content: "\\EAAF";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=isocontour]) .first:before {
  content: "\\EAB0";
}

:host([icon=isocontour]) .first:after {
  content: "\\EAB1";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=series-angle]) .first:before {
  content: "\\EAB8";
}

:host([icon=series-angle]) .first:after {
  content: "\\EAB9";
  color: rgba(var(--ui-1), var(--opacity-1));
}

:host([icon=table-move-to-laser-guidance-position]) .first:before {
  content: "\\EAC5";
}

:host([icon=table-move-to-laser-guidance-position]) .first:after {
  content: "\\EAC4";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=cutline-smooth]) .first:before {
  content: "\\EAC6";
}

:host([icon=cutline-smooth]) .first:after {
  content: "\\EAC7";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=combined-trending-graph]) .first:before {
  content: "\\EACA";
}

:host([icon=combined-trending-graph]) .first:after {
  content: "\\EACB";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=sample-delete]) .first:before {
  content: "\\EAD6";
}

:host([icon=sample-delete]) .first:after {
  content: "\\EAD7";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=sample-search]) .first:before {
  content: "\\EADE";
}

:host([icon=sample-search]) .first:after {
  content: "\\EADF";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=samples]) .first:before {
  content: "\\EAE0";
}

:host([icon=samples]) .first:after {
  content: "\\EAE1";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=trending-graph-pronounced]) .first:before {
  content: "\\EAE4";
}

:host([icon=trending-graph-pronounced]) .first:after {
  content: "\\EAE5";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=sample]) .first:before {
  content: "\\EB44";
}

:host([icon=sample]) .first:after {
  content: "\\EB45";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=send-rating-feedback]) .first:before {
  content: "\\EB42";
}

:host([icon=send-rating-feedback]) .first:after {
  content: "\\EB43";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=edge-enhancement-low]) .first:before {
  content: "\\EB03";
}

:host([icon=edge-enhancement-low]) .first:after {
  content: "\\EB02";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=edge-enhancement-medium]) .first:before {
  content: "\\EB00";
}

:host([icon=edge-enhancement-medium]) .first:after {
  content: "\\EB01";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=noise-reduce-filter-high]) .first:before {
  content: "\\EB19";
}

:host([icon=noise-reduce-filter-high]) .first:after {
  content: "\\EB18";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=noise-reduce-filter-low]) .first:before {
  content: "\\EB19";
}

:host([icon=noise-reduce-filter-low]) .first:after {
  content: "\\EB17";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=noise-reduce-filter-medium]) .first:before {
  content: "\\EB19";
}

:host([icon=noise-reduce-filter-medium]) .first:after {
  content: "\\EB16";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=noise-reduce-filter-off]) .first:before {
  content: "\\EB15";
}

:host([icon=noise-reduce-filter-off]) .first:after {
  content: "\\EB14";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=noise-reduce-lih-high]) .first:before {
  content: "\\EB13";
}

:host([icon=noise-reduce-lih-high]) .first:after {
  content: "\\EB12";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=noise-reduce-lih-low]) .first:before {
  content: "\\EB13";
}

:host([icon=noise-reduce-lih-low]) .first:after {
  content: "\\EB11";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=noise-reduce-lih-medium]) .first:before {
  content: "\\EB13";
}

:host([icon=noise-reduce-lih-medium]) .first:after {
  content: "\\EB10";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=noise-reduce-live-image-high]) .first:before {
  content: "\\EB0F";
}

:host([icon=noise-reduce-live-image-high]) .first:after {
  content: "\\EB0E";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=noise-reduce-live-image-low]) .first:before {
  content: "\\EB0F";
}

:host([icon=noise-reduce-live-image-low]) .first:after {
  content: "\\EB0D";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=noise-reduce-live-image-medium]) .first:before {
  content: "\\EB0F";
}

:host([icon=noise-reduce-live-image-medium]) .first:after {
  content: "\\EB0C";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=radiation-low]) .first:before {
  content: "\\EB26";
}

:host([icon=radiation-low]) .first:after {
  content: "\\EB25";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=radiation-medium]) .first:before {
  content: "\\EB23";
}

:host([icon=radiation-medium]) .first:after {
  content: "\\EB24";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=ed-percent]) .first:before {
  content: "\\EB64";
}

:host([icon=ed-percent]) .first:after {
  content: "\\EB63";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=stress-layout-hide]) .first:before {
  content: "\\EB71";
}

:host([icon=stress-layout-hide]) .first:after {
  content: "\\EB70";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=wifi-1]) .first:before {
  content: "\\EB82";
}

:host([icon=wifi-1]) .first:after {
  content: "\\EB83";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=wifi-2]) .first:before {
  content: "\\EB7A";
}

:host([icon=wifi-2]) .first:after {
  content: "\\EB7B";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=wifi-3]) .first:before {
  content: "\\EB78";
}

:host([icon=wifi-3]) .first:after {
  content: "\\EB79";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=fuse-images]) .first:before {
  content: "\\EB7D";
}

:host([icon=fuse-images]) .first:after {
  content: "\\EB7E";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=inr-medication-full-dose]) .first:before,
:host([icon=medication-full-dose]) .first:before {
  content: "\\EB90";
}

:host([icon=inr-medication-full-dose]) .first:after,
:host([icon=medication-full-dose]) .first:after {
  content: "\\EB91";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=inr-medication-half-dose]) .first:before,
:host([icon=medication-half-dose]) .first:before {
  content: "\\EB8E";
}

:host([icon=inr-medication-half-dose]) .first:after,
:host([icon=medication-half-dose]) .first:after {
  content: "\\EB8F";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=gantry-expand]) .first:before {
  content: "\\EBAD";
}

:host([icon=gantry-expand]) .first:after {
  content: "\\EBAC";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=delete-point]) .first:before {
  content: "\\EBD5";
}

:host([icon=delete-point]) .first:after {
  content: "\\EBD6";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=usb-stick-space-1]) .first:before {
  content: "\\EBC1";
  color: rgba(var(--ui-1), var(--opacity-2));
}

:host([icon=usb-stick-space-1]) .first:after {
  content: "\\EBC0";
}

:host([icon=usb-stick-space]) .first:before,
:host([icon=usb-stick-space-2]) .first:before {
  content: "\\EBC1";
  color: rgba(var(--ui-1), var(--opacity-2));
}

:host([icon=usb-stick-space]) .first:after,
:host([icon=usb-stick-space-2]) .first:after {
  content: "\\EBBF";
}

:host([icon=usb-stick-space-3]) .first:before {
  content: "\\EBC1";
  color: rgba(var(--ui-1), var(--opacity-2));
}

:host([icon=usb-stick-space-3]) .first:after {
  content: "\\EBBE";
}

:host([icon=usb-stick-space-4]) .first:before {
  content: "\\EBC1";
  color: rgba(var(--ui-1), var(--opacity-2));
}

:host([icon=usb-stick-space-4]) .first:after {
  content: "\\EBBD";
}

:host([icon=usb-stick-space-5]) .first:before {
  content: "\\EBC1";
  color: rgba(var(--ui-1), var(--opacity-2));
}

:host([icon=usb-stick-space-5]) .first:after {
  content: "\\EBBC";
}

:host([icon=mute-alarm]) .first:before {
  content: "\\EBE0";
}

:host([icon=mute-alarm]) .first:after {
  content: "\\EBE1";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=lung-breathing-percentile]) .first:before {
  content: "\\EBE5";
}

:host([icon=lung-breathing-percentile]) .first:after {
  content: "\\EBE4";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=heart-left-ventricle]) .first:before {
  content: "\\EC07";
}

:host([icon=heart-left-ventricle]) .first:after {
  content: "\\EC08";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=heart-ventricles]) .first:before {
  content: "\\EC09";
}

:host([icon=heart-ventricles]) .first:after {
  content: "\\EC0A";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=heart-ventricles-manual]) .first:before {
  content: "\\EC0B";
}

:host([icon=heart-ventricles-manual]) .first:after {
  content: "\\EC0C";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=vertebrae-centering]) .first:before {
  content: "\\EC17";
}

:host([icon=vertebrae-centering]) .first:after {
  content: "\\EC14";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=lung-breathing-percentile-restart]) .first:before {
  content: "\\EC1D";
}

:host([icon=lung-breathing-percentile-restart]) .first:after {
  content: "\\EC1C";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=patient-position-lateral-left]) .first:before {
  content: "\\EC2E";
}

:host([icon=patient-position-lateral-left]) .first:after {
  content: "\\EC2F";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=patient-position-lateral-right]) .first:before {
  content: "\\EC2D";
}

:host([icon=patient-position-lateral-right]) .first:after {
  content: "\\EC2C";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=patient-position-supine]) .first:before {
  content: "\\EC29";
}

:host([icon=patient-position-supine]) .first:after {
  content: "\\EC28";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=patient-position-prone]) .first:before {
  content: "\\EC2B";
}

:host([icon=patient-position-prone]) .first:after {
  content: "\\EC2A";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=virtual-reality]) .first:before {
  content: "\\EC27";
}

:host([icon=virtual-reality]) .first:after {
  content: "\\EC26";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=spine-ranges]) .first:before {
  content: "\\EC49";
}

:host([icon=spine-ranges]) .first:after {
  content: "\\EC4A";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=position-display-medium]) .first:before {
  content: "\\EC4C";
}

:host([icon=position-display-medium]) .first:after {
  content: "\\EC36";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=footswitch-battery-1]) .first:before {
  content: "\\EBD3";
  color: rgba(var(--ui-1), var(--opacity-2));
}

:host([icon=footswitch-battery-1]) .first:after {
  content: "\\EBD4";
}

:host([icon=footswitch-battery-empty]) .first:before {
  content: "\\EBD3";
  color: rgba(var(--ui-1), var(--opacity-2));
}

:host([icon=footswitch-battery-empty]) .first:after {
  content: "\\EBCF";
}

:host([icon=handcontrol-battery-1]) .first:before {
  content: "\\EBCD";
  color: rgba(var(--ui-1), var(--opacity-2));
}

:host([icon=handcontrol-battery-1]) .first:after {
  content: "\\EBD4";
}

:host([icon=handcontrol-battery-empty]) .first:before {
  content: "\\EBCD";
  color: rgba(var(--ui-1), var(--opacity-2));
}

:host([icon=handcontrol-battery-empty]) .first:after {
  content: "\\EBCF";
}

:host([icon=test-image]) .first:before {
  content: "\\EB1F";
}

:host([icon=test-image]) .first:after {
  content: "\\EB1E";
  color: rgba(var(--ui-1), var(--opacity-3));
}

:host([icon=test-image]) .second:before {
  content: "\\EB1D";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=isolate-volume]) .first:before {
  content: "\\EBAB";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=isolate-volume]) .first:after {
  content: "\\EBAA";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=isolate-volume]) .second:before {
  content: "\\EBA9";
}

:host([icon=download-completed]) .first:before {
  content: "\\EA79";
}

:host([icon=download-completed]) .first:after {
  content: "\\E990";
}

:host([icon=download-completed]) .second:before {
  content: "\\E995";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host(:not([color])[icon=download-completed]) .first:after {
  content: "\\E990";
  color: rgb(var(--functional-green));
}

:host(:not([color])[icon=download-completed]) .second:before {
  content: "\\E995";
  color: #ffffff;
}

:host([icon=import-completed]) .first:before {
  content: "\\EA80";
}

:host([icon=import-completed]) .first:after {
  content: "\\EA81";
}

:host([icon=import-completed]) .second:before {
  content: "\\EA82";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host(:not([color])[icon=import-completed]) .first:after {
  content: "\\E990";
  color: rgb(var(--functional-green));
}

:host(:not([color])[icon=import-completed]) .second:before {
  content: "\\E995";
  color: #ffffff;
}

:host([icon=rt-laser-not-zero]) .first:before {
  content: "\\E993";
}

:host([icon=rt-laser-not-zero]) .first:after {
  content: "\\EA4B";
  color: rgb(var(--functional-yellow));
}

:host([icon=rt-laser-not-zero]) .second:before {
  content: "\\EAB3";
  color: #000000;
}

:host([icon=connection-quality-medium]) .first:before {
  content: "\\E93C";
}

:host([icon=connection-quality-medium]) .first:after {
  content: "\\E93B";
  color: rgba(var(--ui-1), var(--opacity-3));
}

:host([icon=connection-quality-medium]) .second:before {
  content: "\\E93A";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=feet-first-prone]) .first:before {
  content: "\\E10A";
}

:host([icon=feet-first-prone]) .first:after {
  content: "\\E10E";
}

:host([icon=feet-first-prone]) .second:before {
  content: "\\E921";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=corner-menu-br-bounding-box]) .first:before {
  content: "\\E9ED";
}

:host([icon=corner-menu-br-bounding-box]) .first:after {
  content: "\\E9EC";
  color: rgba(var(--ui-1), var(--opacity-3));
}

:host([icon=corner-menu-br-bounding-box]) .second:before {
  content: "\\E9EB";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=vessel-coronary-ffr]) .first:before {
  content: "\\EA4D";
}

:host([icon=vessel-coronary-ffr]) .first:after {
  content: "\\EA4E";
}

:host([icon=vessel-coronary-ffr]) .second:before {
  content: "\\EA4F";
}

:host(:not([color])[icon=vessel-coronary-ffr]) .first:before {
  content: "\\EA4D";
  color: #ffff00;
}

:host(:not([color])[icon=vessel-coronary-ffr]) .first:after {
  content: "\\EA4E";
  color: #52c1ff;
}

:host(:not([color])[icon=vessel-coronary-ffr]) .second:before {
  content: "\\EA4F";
  color: #be1818;
}

:host([icon=aspect-overlay-hide]) .first:before {
  content: "\\EB93";
  color: rgba(var(--ui-1), var(--opacity-1));
}

:host(:not([color])[icon=aspect-overlay-hide]) .first:after {
  content: "\\EB95";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([color][icon=aspect-overlay-hide]) .first:after {
  content: "\\EB94";
}

:host([icon=aspect-score]) .first:before {
  content: "\\EB96";
  color: rgba(var(--ui-1), var(--opacity-1));
}

:host(:not([color])[icon=aspect-score]) .first:after {
  content: "\\EB98";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([color][icon=aspect-score]) .first:after {
  content: "\\EB97";
}

:host([icon=aspect-score-cancel]) .first:before {
  content: "\\EB99";
  color: rgba(var(--ui-1), var(--opacity-1));
}

:host(:not([color])[icon=aspect-score-cancel]) .first:after {
  content: "\\EB9B";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([color][icon=aspect-score-cancel]) .first:after {
  content: "\\EB9A";
}

:host([icon=aspect-score-confirm]) .first:before {
  content: "\\EB9C";
  color: rgba(var(--ui-1), var(--opacity-1));
}

:host(:not([color])[icon=aspect-score-confirm]) .first:after {
  content: "\\EB9B";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([color][icon=aspect-score-confirm]) .first:after {
  content: "\\EB9A";
}

:host([icon=connection-quality-high]) .first:before {
  content: "\\E937";
}

:host([icon=connection-quality-high]) .first:after {
  content: "\\E938";
  color: rgba(var(--ui-1), var(--opacity-3));
}

:host([icon=connection-quality-high]) .second:before {
  content: "\\E935";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=connection-quality-high]) .second:after {
  content: "\\E936";
  color: rgba(var(--ui-1), var(--opacity-5));
}

:host(:not([color])[icon=lines-show]) .first:before {
  content: "\\E917";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([color][icon=lines-show]) .first:before {
  content: "\\E917";
  color: rgba(var(--ui-1), var(--opacity-1));
}

:host([icon=lines-show]) .first:after {
  content: "\\E918";
}

:host([icon=show-hide-metal]) .first:before {
  content: "\\E956";
  color: rgba(var(--ui-1), var(--opacity-1));
}

:host([icon=show-hide-metal]) .first:after {
  content: "\\E955";
}

:host([icon=topogram]) .first:before {
  content: "\\E931";
  color: rgba(var(--ui-1), var(--opacity-1));
}

:host([icon=topogram]) .first:after {
  content: "\\E932";
}

:host([icon=mdt-postponed]) .first:before {
  content: "\\E96A";
  color: rgba(var(--ui-1), var(--opacity-1));
}

:host([icon=mdt-postponed]) .first:after {
  content: "\\E96B";
}

:host(:not([color])[icon=mdt-postponed]) .second:before {
  content: "\\E96C";
  color: rgba(var(--ui-1), 0);
}

:host([color][icon=mdt-postponed]) .second:before {
  content: "\\E96C";
  color: #000000;
}

:host([icon=trend-up]) .first:before {
  content: "\\E982";
}

:host(:not([color])[icon=trend-up]) .first:after {
  content: "\\E983";
  color: rgba(var(--ui-1), 0);
}

:host([color][icon=trend-up]) .first:after {
  content: "\\E983";
  color: #ffffff;
}

:host([icon=trend-stable]) .first:before {
  content: "\\E981";
}

:host(:not([color])[icon=trend-stable]) .first:after {
  content: "\\E984";
  color: rgba(var(--ui-1), 0);
}

:host([color][icon=trend-stable]) .first:after {
  content: "\\E984";
  color: #000000;
}

:host([icon=trend-down]) .first:before {
  content: "\\E97F";
}

:host(:not([color])[icon=trend-down]) .first:after {
  content: "\\E980";
  color: rgba(var(--ui-1), 0);
}

:host([color][icon=trend-down]) .first:after {
  content: "\\E980";
  color: #ffffff;
}

:host([icon=blood-pressure-completed]) .first:before {
  content: "\\E98F";
}

:host([icon=blood-pressure-completed]) .first:after {
  content: "\\E990";
}

:host(:not([color])[icon=blood-pressure-completed]) .first:after {
  content: "\\E990";
  color: rgb(var(--functional-green));
}

:host(:not([color])[icon=blood-pressure-completed]) .second:before {
  content: "\\E995";
  color: #ffffff;
}

:host([color][icon=blood-pressure-completed]) .second:before {
  content: "\\E995";
  color: rgb(var(--ui-7));
}

:host([icon=pain-scale-completed]) .first:before {
  content: "\\EB2A";
}

:host([icon=pain-scale-completed]) .first:after {
  content: "\\E990";
}

:host(:not([color])[icon=pain-scale-completed]) .first:after {
  content: "\\E990";
  color: rgb(var(--functional-green));
}

:host(:not([color])[icon=pain-scale-completed]) .second:before {
  content: "\\E995";
  color: #ffffff;
}

:host([color][icon=pain-scale-completed]) .second:before {
  content: "\\E995";
  color: rgb(var(--ui-7));
}

:host([icon=kvm-switch-completed]) .first:before {
  content: "\\EC50";
}

:host([icon=kvm-switch-completed]) .first:after {
  content: "\\E990";
}

:host(:not([color])[icon=kvm-switch-completed]) .first:after {
  content: "\\E990";
  color: rgb(var(--functional-green));
}

:host(:not([color])[icon=kvm-switch-completed]) .second:before {
  content: "\\E995";
  color: #ffffff;
}

:host([color][icon=kvm-switch-completed]) .second:before {
  content: "\\E995";
  color: rgb(var(--ui-7));
}

:host([icon=handcontrol-wifi-error]) .first:before {
  content: "\\EBE6";
}

:host([icon=handcontrol-wifi-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=handcontrol-wifi-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=handcontrol-wifi-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=handcontrol-wifi-error]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([icon=blood-pressure-error]) .first:before {
  content: "\\E98F";
}

:host([icon=blood-pressure-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=blood-pressure-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=blood-pressure-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=blood-pressure-error]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([icon=blood-pressure-in-progress]) .first:before {
  content: "\\E98F";
}

:host([icon=blood-pressure-in-progress]) .first:after {
  content: "\\E998";
}

:host(:not([color])[icon=blood-pressure-in-progress]) .first:after {
  content: "\\E998";
  color: #52c1ff;
}

:host(:not([color])[icon=blood-pressure-in-progress]) .second:before {
  content: "\\E999";
  color: #000000;
}

:host([color][icon=blood-pressure-in-progress]) .second:before {
  content: "\\E999";
  color: rgb(var(--ui-7));
}

:host([icon=blood-pressure-warning]) .first:before {
  content: "\\E98F";
}

:host([icon=blood-pressure-warning]) .first:after {
  content: "\\E9A0";
}

:host(:not([color])[icon=blood-pressure-warning]) .first:after {
  content: "\\E9A0";
  color: rgb(var(--functional-yellow));
}

:host(:not([color])[icon=blood-pressure-warning]) .second:before {
  content: "\\E9A1";
  color: #000000;
}

:host([color][icon=blood-pressure-warning]) .second:before {
  content: "\\E9A1";
  color: rgb(var(--ui-7));
}

:host([icon=inr-completed]) .first:before,
:host([icon=inr-measurement-completed]) .first:before {
  content: "\\E9A7";
}

:host([icon=inr-completed]) .first:after,
:host([icon=inr-measurement-completed]) .first:after {
  content: "\\E990";
}

:host(:not([color])[icon=inr-completed]) .first:after,
:host(:not([color])[icon=inr-measurement-completed]) .first:after {
  content: "\\E990";
  color: rgb(var(--functional-green));
}

:host(:not([color])[icon=inr-completed]) .second:before,
:host(:not([color])[icon=inr-measurement-completed]) .second:before {
  content: "\\E995";
  color: #ffffff;
}

:host([color][icon=inr-completed]) .second:before,
:host([color][icon=inr-measurement-completed]) .second:before {
  content: "\\E995";
  color: rgb(var(--ui-7));
}

:host([icon=inr-error]) .first:before,
:host([icon=inr-measurement-error]) .first:before {
  content: "\\E9A7";
}

:host([icon=inr-error]) .first:after,
:host([icon=inr-measurement-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=inr-error]) .first:after,
:host(:not([color])[icon=inr-measurement-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=inr-error]) .second:before,
:host(:not([color])[icon=inr-measurement-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=inr-error]) .second:before,
:host([color][icon=inr-measurement-error]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([icon=inr-in-progress]) .first:before,
:host([icon=inr-measurement-in-progress]) .first:before {
  content: "\\E9A7";
}

:host([icon=inr-in-progress]) .first:after,
:host([icon=inr-measurement-in-progress]) .first:after {
  content: "\\E998";
}

:host(:not([color])[icon=inr-in-progress]) .first:after,
:host(:not([color])[icon=inr-measurement-in-progress]) .first:after {
  content: "\\E998";
  color: #52c1ff;
}

:host(:not([color])[icon=inr-in-progress]) .second:before,
:host(:not([color])[icon=inr-measurement-in-progress]) .second:before {
  content: "\\E999";
  color: #000000;
}

:host([color][icon=inr-in-progress]) .second:before,
:host([color][icon=inr-measurement-in-progress]) .second:before {
  content: "\\E999";
  color: rgb(var(--ui-7));
}

:host([icon=inr-warning]) .first:before,
:host([icon=inr-measurement-warning]) .first:before {
  content: "\\E9A7";
}

:host([icon=inr-warning]) .first:after,
:host([icon=inr-measurement-warning]) .first:after {
  content: "\\E9A0";
}

:host(:not([color])[icon=inr-warning]) .first:after,
:host(:not([color])[icon=inr-measurement-warning]) .first:after {
  content: "\\E9A0";
  color: rgb(var(--functional-yellow));
}

:host(:not([color])[icon=inr-warning]) .second:before,
:host(:not([color])[icon=inr-measurement-warning]) .second:before {
  content: "\\E9A1";
  color: #000000;
}

:host([color][icon=inr-warning]) .second:before,
:host([color][icon=inr-measurement-warning]) .second:before {
  content: "\\E9A1";
  color: rgb(var(--ui-7));
}

:host([icon=kitmed-report-warning]) .first:before {
  content: "\\E9AA";
}

:host([icon=kitmed-report-warning]) .first:after {
  content: "\\E9A0";
}

:host(:not([color])[icon=kitmed-report-warning]) .first:after {
  content: "\\E9A0";
  color: rgb(var(--functional-yellow));
}

:host(:not([color])[icon=kitmed-report-warning]) .second:before {
  content: "\\E9A1";
  color: #000000;
}

:host([color][icon=kitmed-report-warning]) .second:before {
  content: "\\E9A1";
  color: rgb(var(--ui-7));
}

:host([icon=kitpro-warning]) .first:before {
  content: "\\E9AD";
}

:host([icon=kitpro-warning]) .first:after {
  content: "\\E9A0";
}

:host(:not([color])[icon=kitpro-warning]) .first:after {
  content: "\\E9A0";
  color: rgb(var(--functional-yellow));
}

:host(:not([color])[icon=kitpro-warning]) .second:before {
  content: "\\E9A1";
  color: #000000;
}

:host([color][icon=kitpro-warning]) .second:before {
  content: "\\E9A1";
  color: rgb(var(--ui-7));
}

:host([icon=active-implant-warning]) .first:before {
  content: "\\EAFD";
}

:host([icon=active-implant-warning]) .first:after {
  content: "\\E9A0";
}

:host(:not([color])[icon=active-implant-warning]) .first:after {
  content: "\\E9A0";
  color: rgb(var(--functional-yellow));
}

:host(:not([color])[icon=active-implant-warning]) .second:before {
  content: "\\E9A1";
  color: #000000;
}

:host([color][icon=active-implant-warning]) .second:before {
  content: "\\E9A1";
  color: rgb(var(--ui-7));
}

:host([icon=radiation-high-warning]) .first:before {
  content: "\\EB27";
}

:host([icon=radiation-high-warning]) .first:after {
  content: "\\E9A0";
}

:host(:not([color])[icon=radiation-high-warning]) .first:after {
  content: "\\E9A0";
  color: rgb(var(--functional-yellow));
}

:host(:not([color])[icon=radiation-high-warning]) .second:before {
  content: "\\E9A1";
  color: #000000;
}

:host([color][icon=radiation-high-warning]) .second:before {
  content: "\\E9A1";
  color: rgb(var(--ui-7));
}

:host([icon=medication-completed]) .first:before,
:host([icon=inr-medication-completed]) .first:before {
  content: "\\E9AF";
}

:host([icon=medication-completed]) .first:after,
:host([icon=inr-medication-completed]) .first:after {
  content: "\\E9AE";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=medication-completed]) .second:before,
:host([icon=inr-medication-completed]) .second:before {
  content: "\\E990";
}

:host(:not([color])[icon=medication-completed]) .second:before,
:host(:not([color])[icon=inr-medication-completed]) .second:before {
  content: "\\E990";
  color: rgb(var(--functional-green));
}

:host(:not([color])[icon=medication-completed]) .second:after,
:host(:not([color])[icon=inr-medication-completed]) .second:after {
  content: "\\E995";
  color: #ffffff;
}

:host([color][icon=medication-completed]) .second:after,
:host([color][icon=inr-medication-completed]) .second:after {
  content: "\\E995";
  color: rgb(var(--ui-7));
}

:host([icon=medication-error]) .first:before,
:host([icon=inr-medication-error]) .first:before {
  content: "\\E9AF";
}

:host([icon=medication-error]) .first:after,
:host([icon=inr-medication-error]) .first:after {
  content: "\\E9AE";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=medication-error]) .second:before,
:host([icon=inr-medication-error]) .second:before {
  content: "\\E996";
}

:host(:not([color])[icon=medication-error]) .second:before,
:host(:not([color])[icon=inr-medication-error]) .second:before {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=medication-error]) .second:after,
:host(:not([color])[icon=inr-medication-error]) .second:after {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=medication-error]) .second:after,
:host([color][icon=inr-medication-error]) .second:after {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([icon=medication-in-progress]) .first:before,
:host([icon=inr-medication-in-progress]) .first:before {
  content: "\\E9AF";
}

:host([icon=medication-in-progress]) .first:after,
:host([icon=inr-medication-in-progress]) .first:after {
  content: "\\E9AE";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=medication-in-progress]) .second:before,
:host([icon=inr-medication-in-progress]) .second:before {
  content: "\\E998";
}

:host(:not([color])[icon=medication-in-progress]) .second:before,
:host(:not([color])[icon=inr-medication-in-progress]) .second:before {
  content: "\\E998";
  color: #52c1ff;
}

:host(:not([color])[icon=medication-in-progress]) .second:after,
:host(:not([color])[icon=inr-medication-in-progress]) .second:after {
  content: "\\E999";
  color: #000000;
}

:host([color][icon=medication-in-progress]) .second:after,
:host([color][icon=inr-medication-in-progress]) .second:after {
  content: "\\E999";
  color: rgb(var(--ui-7));
}

:host([icon=medication-warning]) .first:before,
:host([icon=inr-medication-warning]) .first:before {
  content: "\\E9AF";
}

:host([icon=medication-warning]) .first:after,
:host([icon=inr-medication-warning]) .first:after {
  content: "\\E9AE";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=medication-warning]) .second:before,
:host([icon=inr-medication-warning]) .second:before {
  content: "\\E9A0";
}

:host(:not([color])[icon=medication-warning]) .second:before,
:host(:not([color])[icon=inr-medication-warning]) .second:before {
  content: "\\E9A0";
  color: rgb(var(--functional-yellow));
}

:host(:not([color])[icon=medication-warning]) .second:after,
:host(:not([color])[icon=inr-medication-warning]) .second:after {
  content: "\\E9A1";
  color: #000000;
}

:host([color][icon=medication-warning]) .second:after,
:host([color][icon=inr-medication-warning]) .second:after {
  content: "\\E9A1";
  color: rgb(var(--ui-7));
}

:host([icon=message-read-notification]) .first:before {
  content: "\\E9B0";
  color: rgba(var(--ui-1), var(--opacity-1));
}

:host([icon=message-read-notification]) .first:after {
  content: "\\E990";
}

:host(:not([color])[icon=message-read-notification]) .first:after {
  content: "\\E990";
  color: rgb(var(--functional-green));
}

:host(:not([color])[icon=message-read-notification]) .second:before {
  content: "\\E995";
  color: #ffffff;
}

:host([color][icon=message-read-notification]) .second:before {
  content: "\\E995";
  color: rgb(var(--ui-7));
}

:host([icon=remote-desktop-active]) .first:before {
  content: "\\EBC4";
}

:host([icon=remote-desktop-active]) .first:after {
  content: "\\E990";
}

:host(:not([color])[icon=remote-desktop-active]) .first:after {
  content: "\\E990";
  color: rgb(var(--functional-green));
}

:host(:not([color])[icon=remote-desktop-active]) .second:before {
  content: "\\E995";
  color: #ffffff;
}

:host([color][icon=remote-desktop-active]) .second:before {
  content: "\\E995";
  color: rgb(var(--ui-7));
}

:host([icon=weight-measurement-completed]) .first:before {
  content: "\\E9BB";
}

:host([icon=weight-measurement-completed]) .first:after {
  content: "\\E990";
}

:host(:not([color])[icon=weight-measurement-completed]) .first:after {
  content: "\\E990";
  color: rgb(var(--functional-green));
}

:host(:not([color])[icon=weight-measurement-completed]) .second:before {
  content: "\\E995";
  color: #ffffff;
}

:host([color][icon=weight-measurement-completed]) .second:before {
  content: "\\E995";
  color: rgb(var(--ui-7));
}

:host([icon=remote-service-error]) .first:before {
  content: "\\EBD9";
}

:host([icon=remote-service-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=remote-service-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=remote-service-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=remote-service-error]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([icon=remote-service-warning]) .first:before {
  content: "\\EBD9";
}

:host([icon=remote-service-warning]) .first:after {
  content: "\\E9A0";
}

:host(:not([color])[icon=remote-service-warning]) .first:after {
  content: "\\E9A0";
  color: rgb(var(--functional-yellow));
}

:host(:not([color])[icon=remote-service-warning]) .second:before {
  content: "\\E9A1";
  color: #000000;
}

:host([color][icon=remote-service-warning]) .second:before {
  content: "\\E9A1";
  color: rgb(var(--ui-7));
}

:host([icon=weight-measurement-error]) .first:before {
  content: "\\E9BB";
}

:host([icon=weight-measurement-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=weight-measurement-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=weight-measurement-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=weight-measurement-error]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([icon=weight-measurement-in-progress]) .first:before {
  content: "\\E9BB";
}

:host([icon=weight-measurement-in-progress]) .first:after {
  content: "\\E998";
}

:host(:not([color])[icon=weight-measurement-in-progress]) .first:after {
  content: "\\E998";
  color: #52c1ff;
}

:host(:not([color])[icon=weight-measurement-in-progress]) .second:before {
  content: "\\E999";
  color: #000000;
}

:host([color][icon=weight-measurement-in-progress]) .second:before {
  content: "\\E999";
  color: rgb(var(--ui-7));
}

:host([icon=weight-measurement-warning]) .first:before {
  content: "\\E9BB";
}

:host([icon=weight-measurement-warning]) .first:after {
  content: "\\E9A0";
}

:host(:not([color])[icon=weight-measurement-warning]) .first:after {
  content: "\\E9A0";
  color: rgb(var(--functional-yellow));
}

:host(:not([color])[icon=weight-measurement-warning]) .second:before {
  content: "\\E9A1";
  color: #000000;
}

:host([color][icon=weight-measurement-warning]) .second:before {
  content: "\\E9A1";
  color: rgb(var(--ui-7));
}

:host([icon=wellbeing-completed]) .first:before {
  content: "\\E9BA";
}

:host([icon=wellbeing-completed]) .first:after {
  content: "\\E990";
}

:host(:not([color])[icon=wellbeing-completed]) .first:after {
  content: "\\E990";
  color: rgb(var(--functional-green));
}

:host(:not([color])[icon=wellbeing-completed]) .second:before {
  content: "\\E995";
  color: #ffffff;
}

:host([color][icon=wellbeing-completed]) .second:before {
  content: "\\E995";
  color: rgb(var(--ui-7));
}

:host([icon=wellbeing-error]) .first:before {
  content: "\\E9BA";
}

:host([icon=wellbeing-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=wellbeing-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=wellbeing-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=wellbeing-error]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([icon=wellbeing-in-progress]) .first:before {
  content: "\\E9BA";
}

:host([icon=wellbeing-in-progress]) .first:after {
  content: "\\E998";
}

:host(:not([color])[icon=wellbeing-in-progress]) .first:after {
  content: "\\E998";
  color: #52c1ff;
}

:host(:not([color])[icon=wellbeing-in-progress]) .second:before {
  content: "\\E999";
  color: #000000;
}

:host([color][icon=wellbeing-in-progress]) .second:before {
  content: "\\E999";
  color: rgb(var(--ui-7));
}

:host([icon=wellbeing-warning]) .first:before {
  content: "\\E9BA";
}

:host([icon=wellbeing-warning]) .first:after {
  content: "\\E9A0";
}

:host(:not([color])[icon=wellbeing-warning]) .first:after {
  content: "\\E9A0";
  color: rgb(var(--functional-yellow));
}

:host(:not([color])[icon=wellbeing-warning]) .second:before {
  content: "\\E9A1";
  color: #000000;
}

:host([color][icon=wellbeing-warning]) .second:before {
  content: "\\E9A1";
  color: rgb(var(--ui-7));
}

:host([icon=sending-completed]) .first:before {
  content: "\\E9CC";
}

:host([icon=sending-completed]) .first:after {
  content: "\\E990";
}

:host(:not([color])[icon=sending-completed]) .first:after {
  content: "\\E990";
  color: rgb(var(--functional-green));
}

:host(:not([color])[icon=sending-completed]) .second:before {
  content: "\\E995";
  color: #ffffff;
}

:host([color][icon=sending-completed]) .second:before {
  content: "\\E995";
  color: rgb(var(--ui-7));
}

:host([icon=sending-failed]) .first:before {
  content: "\\E9CC";
}

:host([icon=sending-failed]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=sending-failed]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=sending-failed]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=sending-failed]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([icon=sending-in-progress]) .first:before {
  content: "\\E9CC";
}

:host([icon=sending-in-progress]) .first:after {
  content: "\\E998";
}

:host(:not([color])[icon=sending-in-progress]) .first:after {
  content: "\\E998";
  color: #52c1ff;
}

:host(:not([color])[icon=sending-in-progress]) .second:before {
  content: "\\E999";
  color: #000000;
}

:host([color][icon=sending-in-progress]) .second:before {
  content: "\\E999";
  color: rgb(var(--ui-7));
}

:host([icon=radiation-dose-warning]) .first:before {
  content: "\\E9D3";
}

:host([icon=radiation-dose-warning]) .first:after {
  content: "\\E9A0";
}

:host(:not([color])[icon=radiation-dose-warning]) .first:after {
  content: "\\E9A0";
  color: rgb(var(--functional-yellow));
}

:host(:not([color])[icon=radiation-dose-warning]) .second:before {
  content: "\\E9A1";
  color: #000000;
}

:host([color][icon=radiation-dose-warning]) .second:before {
  content: "\\E9A1";
  color: rgb(var(--ui-7));
}

:host([icon=radiation-error]) .first:before {
  content: "\\E9D3";
}

:host([icon=radiation-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=radiation-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=radiation-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=radiation-error]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([icon=radiation-ready]) .first:before {
  content: "\\E9D3";
}

:host([icon=radiation-ready]) .first:after {
  content: "\\E990";
}

:host(:not([color])[icon=radiation-ready]) .first:after {
  content: "\\E990";
  color: rgb(var(--functional-green));
}

:host(:not([color])[icon=radiation-ready]) .second:before {
  content: "\\E995";
  color: #ffffff;
}

:host([color][icon=radiation-ready]) .second:before {
  content: "\\E995";
  color: rgb(var(--ui-7));
}

:host([icon=dicom-confirmation]) .first:before {
  content: "\\EA07";
}

:host([icon=dicom-confirmation]) .first:after {
  content: "\\EA06";
}

:host(:not([color])[icon=dicom-confirmation]) .first:after {
  content: "\\EA06";
  color: #6e7b9f;
}

:host(:not([color])[icon=dicom-confirmation]) .second:before {
  content: "\\EA05";
  color: #ffffff;
}

:host([color][icon=dicom-confirmation]) .second:before {
  content: "\\EA05";
  color: #ffffff;
}

:host([icon=system-information]) .first:before {
  content: "\\EA00";
}

:host([icon=system-information]) .first:after {
  content: "\\EA0A";
}

:host(:not([color])[icon=system-information]) .first:after {
  content: "\\EA0A";
  color: #6e7b9f;
}

:host(:not([color])[icon=system-information]) .second:before {
  content: "\\EA09";
  color: #ffffff;
}

:host([color][icon=system-information]) .second:before {
  content: "\\EA09";
  color: rgb(var(--ui-7));
}

:host([size=xs][icon=dicom-archived]) .first:before {
  content: "\\EA1B";
  color: rgba(var(--ui-1), var(--opacity-1));
}

:host([size=xs][icon=dicom-archived]) .first:after {
  content: "\\EA1C";
}

:host(:not([color])[size=xs][icon=dicom-archived]) .first:after {
  content: "\\EA1C";
  color: rgb(var(--functional-green));
}

:host(:not([color])[size=xs][icon=dicom-archived]) .second:before {
  content: "\\EA1D";
  color: #ffffff;
}

:host([color][size=xs][icon=dicom-archived]) .second:before {
  content: "\\EA1D";
  color: rgb(var(--ui-7));
}

:host([size=s][icon=dicom-archived]) .first:before {
  content: "\\EA1E";
  color: rgba(var(--ui-1), var(--opacity-1));
}

:host([size=s][icon=dicom-archived]) .first:after {
  content: "\\EA1F";
}

:host(:not([color])[size=s][icon=dicom-archived]) .first:after {
  content: "\\EA1F";
  color: rgb(var(--functional-green));
}

:host(:not([color])[size=s][icon=dicom-archived]) .second:before {
  content: "\\EA20";
  color: #ffffff;
}

:host([color][size=s][icon=dicom-archived]) .second:before {
  content: "\\EA20";
  color: rgb(var(--ui-7));
}

:host([size=m][icon=dicom-archived]) .first:before {
  content: "\\EA07";
  color: rgba(var(--ui-1), var(--opacity-1));
}

:host([size=m][icon=dicom-archived]) .first:after {
  content: "\\E990";
}

:host(:not([color])[size=m][icon=dicom-archived]) .first:after {
  content: "\\E990";
  color: rgb(var(--functional-green));
}

:host(:not([color])[size=m][icon=dicom-archived]) .second:before {
  content: "\\E995";
  color: #ffffff;
}

:host([color][size=m][icon=dicom-archived]) .second:before {
  content: "\\E995";
  color: rgb(var(--ui-7));
}

:host([size=l][icon=dicom-archived]) .first:before {
  content: "\\EA1E";
  color: rgba(var(--ui-1), var(--opacity-1));
}

:host([size=l][icon=dicom-archived]) .first:after {
  content: "\\EA1F";
}

:host(:not([color])[size=l][icon=dicom-archived]) .first:after {
  content: "\\EA1F";
  color: rgb(var(--functional-green));
}

:host(:not([color])[size=l][icon=dicom-archived]) .second:before {
  content: "\\EA20";
  color: #ffffff;
}

:host([color][size=l][icon=dicom-archived]) .second:before {
  content: "\\EA20";
  color: rgb(var(--ui-7));
}

:host([size=xs][icon=dicom-failed]) .first:before {
  content: "\\EA1B";
}

:host([size=xs][icon=dicom-failed]) .first:after {
  content: "\\EA21";
}

:host(:not([color])[size=xs][icon=dicom-failed]) .first:after {
  content: "\\EA21";
  color: rgb(var(--functional-red));
}

:host(:not([color])[size=xs][icon=dicom-failed]) .second:before {
  content: "\\EA23";
  color: #ffffff;
}

:host([color][size=xs][icon=dicom-failed]) .second:before {
  content: "\\EA23";
  color: rgb(var(--ui-7));
}

:host([size=s][icon=dicom-failed]) .first:before {
  content: "\\EA1E";
}

:host([size=s][icon=dicom-failed]) .first:after {
  content: "\\EA24";
}

:host(:not([color])[size=s][icon=dicom-failed]) .first:after {
  content: "\\EA24";
  color: rgb(var(--functional-red));
}

:host(:not([color])[size=s][icon=dicom-failed]) .second:before {
  content: "\\EA25";
  color: #ffffff;
}

:host([color][size=s][icon=dicom-failed]) .second:before {
  content: "\\EA25";
  color: rgb(var(--ui-7));
}

:host([size=m][icon=dicom-failed]) .first:before {
  content: "\\EA07";
}

:host([size=m][icon=dicom-failed]) .first:after {
  content: "\\E996";
}

:host(:not([color])[size=m][icon=dicom-failed]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[size=m][icon=dicom-failed]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][size=m][icon=dicom-failed]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([size=l][icon=dicom-failed]) .first:before {
  content: "\\EA1E";
}

:host([size=l][icon=dicom-failed]) .first:after {
  content: "\\EA24";
}

:host(:not([color])[size=l][icon=dicom-failed]) .first:after {
  content: "\\EA24";
  color: rgb(var(--functional-red));
}

:host(:not([color])[size=l][icon=dicom-failed]) .second:before {
  content: "\\EA25";
  color: #ffffff;
}

:host([color][size=l][icon=dicom-failed]) .second:before {
  content: "\\EA25";
  color: rgb(var(--ui-7));
}

:host([size=xs][icon=dicom-sending-in-progress]) .first:before {
  content: "\\EA1B";
}

:host([size=xs][icon=dicom-sending-in-progress]) .first:after {
  content: "\\EA26";
}

:host(:not([color])[size=xs][icon=dicom-sending-in-progress]) .first:after {
  content: "\\EA26";
  color: #52c1ff;
}

:host(:not([color])[size=xs][icon=dicom-sending-in-progress]) .second:before {
  content: "\\EA27";
  color: #000000;
}

:host([color][size=xs][icon=dicom-sending-in-progress]) .second:before {
  content: "\\EA27";
  color: rgb(var(--ui-7));
}

:host([size=s][icon=dicom-sending-in-progress]) .first:before {
  content: "\\EA1E";
}

:host([size=s][icon=dicom-sending-in-progress]) .first:after {
  content: "\\EA28";
}

:host(:not([color])[size=s][icon=dicom-sending-in-progress]) .first:after {
  content: "\\EA28";
  color: #52c1ff;
}

:host(:not([color])[size=s][icon=dicom-sending-in-progress]) .second:before {
  content: "\\EA29";
  color: #000000;
}

:host([color][size=s][icon=dicom-sending-in-progress]) .second:before {
  content: "\\EA29";
  color: rgb(var(--ui-7));
}

:host([size=m][icon=dicom-sending-in-progress]) .first:before {
  content: "\\EA07";
}

:host([size=m][icon=dicom-sending-in-progress]) .first:after {
  content: "\\E998";
}

:host(:not([color])[size=m][icon=dicom-sending-in-progress]) .first:after {
  content: "\\E998";
  color: #52c1ff;
}

:host(:not([color])[size=m][icon=dicom-sending-in-progress]) .second:before {
  content: "\\E999";
  color: #000000;
}

:host([color][size=m][icon=dicom-sending-in-progress]) .second:before {
  content: "\\E999";
  color: rgb(var(--ui-7));
}

:host([size=l][icon=dicom-sending-in-progress]) .first:before {
  content: "\\EA1E";
}

:host([size=l][icon=dicom-sending-in-progress]) .first:after {
  content: "\\EA28";
}

:host(:not([color])[size=l][icon=dicom-sending-in-progress]) .first:after {
  content: "\\EA28";
  color: #52c1ff;
}

:host(:not([color])[size=l][icon=dicom-sending-in-progress]) .second:before {
  content: "\\EA29";
  color: #000000;
}

:host([color][size=l][icon=dicom-sending-in-progress]) .second:before {
  content: "\\EA29";
  color: rgb(var(--ui-7));
}

:host([icon=dicom-information]) .first:before {
  content: "\\EA07";
}

:host([icon=dicom-information]) .first:after {
  content: "\\EA0A";
}

:host(:not([color])[icon=dicom-information]) .first:after {
  content: "\\EA0A";
  color: #6e7b9f;
}

:host(:not([color])[icon=dicom-information]) .second:before {
  content: "\\EA09";
  color: #ffffff;
}

:host([color][icon=dicom-information]) .second:before {
  content: "\\EA09";
  color: rgb(var(--ui-7));
}

:host([icon=order-information]) .first:before {
  content: "\\EADD";
}

:host([icon=order-information]) .first:after {
  content: "\\EA0A";
}

:host(:not([color])[icon=order-information]) .first:after {
  content: "\\EA0A";
  color: #6e7b9f;
}

:host(:not([color])[icon=order-information]) .second:before {
  content: "\\EA09";
  color: #ffffff;
}

:host([color][icon=order-information]) .second:before {
  content: "\\EA09";
  color: rgb(var(--ui-7));
}

:host([icon=samples-information]) .first:before {
  content: "\\EAE2";
}

:host([icon=samples-information]) .first:after {
  content: "\\EAE3";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=samples-information]) .second:before {
  content: "\\EA0A";
}

:host(:not([color])[icon=samples-information]) .second:before {
  content: "\\EA0A";
  color: #6e7b9f;
}

:host(:not([color])[icon=samples-information]) .second:after {
  content: "\\EA09";
  color: #ffffff;
}

:host([color][icon=samples-information]) .second:after {
  content: "\\EA09";
  color: rgb(var(--ui-7));
}

:host([size=xs][icon=export-failed]) .first:before {
  content: "\\EA2A";
}

:host([size=xs][icon=export-failed]) .first:after {
  content: "\\EA21";
}

:host(:not([color])[size=xs][icon=export-failed]) .first:after {
  content: "\\EA21";
  color: rgb(var(--functional-red));
}

:host(:not([color])[size=xs][icon=export-failed]) .second:before {
  content: "\\EA23";
  color: #ffffff;
}

:host([color][size=xs][icon=export-failed]) .second:before {
  content: "\\EA23";
  color: rgb(var(--ui-7));
}

:host([size=s][icon=export-failed]) .first:before {
  content: "\\EA2B";
}

:host([size=s][icon=export-failed]) .first:after {
  content: "\\EA24";
}

:host(:not([color])[size=s][icon=export-failed]) .first:after {
  content: "\\EA24";
  color: rgb(var(--functional-red));
}

:host(:not([color])[size=s][icon=export-failed]) .second:before {
  content: "\\EA25";
  color: #ffffff;
}

:host([color][size=s][icon=export-failed]) .second:before {
  content: "\\EA25";
  color: rgb(var(--ui-7));
}

:host([size=m][icon=export-failed]) .first:before {
  content: "\\EA2C";
}

:host([size=m][icon=export-failed]) .first:after {
  content: "\\E996";
}

:host(:not([color])[size=m][icon=export-failed]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[size=m][icon=export-failed]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][size=m][icon=export-failed]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([size=l][icon=export-failed]) .first:before {
  content: "\\EA2B";
}

:host([size=l][icon=export-failed]) .first:after {
  content: "\\EA24";
}

:host(:not([color])[size=l][icon=export-failed]) .first:after {
  content: "\\EA24";
  color: rgb(var(--functional-red));
}

:host(:not([color])[size=l][icon=export-failed]) .second:before {
  content: "\\EA25";
  color: #ffffff;
}

:host([color][size=l][icon=export-failed]) .second:before {
  content: "\\EA25";
  color: rgb(var(--ui-7));
}

:host([size=xs][icon=export-finished]) .first:before {
  content: "\\EA2A";
  color: rgba(var(--ui-1), var(--opacity-1));
}

:host([size=xs][icon=export-finished]) .first:after {
  content: "\\EA1C";
}

:host(:not([color])[size=xs][icon=export-finished]) .first:after {
  content: "\\EA1C";
  color: rgb(var(--functional-green));
}

:host(:not([color])[size=xs][icon=export-finished]) .second:before {
  content: "\\EA1D";
  color: #ffffff;
}

:host([color][size=xs][icon=export-finished]) .second:before {
  content: "\\EA1D";
  color: rgb(var(--ui-7));
}

:host([size=s][icon=export-finished]) .first:before {
  content: "\\EA2B";
  color: rgba(var(--ui-1), var(--opacity-1));
}

:host([size=s][icon=export-finished]) .first:after {
  content: "\\EA1F";
}

:host(:not([color])[size=s][icon=export-finished]) .first:after {
  content: "\\EA1F";
  color: rgb(var(--functional-green));
}

:host(:not([color])[size=s][icon=export-finished]) .second:before {
  content: "\\EA20";
  color: #ffffff;
}

:host([color][size=s][icon=export-finished]) .second:before {
  content: "\\EA20";
  color: rgb(var(--ui-7));
}

:host([size=m][icon=export-finished]) .first:before {
  content: "\\EA2C";
  color: rgba(var(--ui-1), var(--opacity-1));
}

:host([size=m][icon=export-finished]) .first:after {
  content: "\\E990";
}

:host(:not([color])[size=m][icon=export-finished]) .first:after {
  content: "\\E990";
  color: rgb(var(--functional-green));
}

:host(:not([color])[size=m][icon=export-finished]) .second:before {
  content: "\\E995";
  color: #ffffff;
}

:host([color][size=m][icon=export-finished]) .second:before {
  content: "\\E995";
  color: rgb(var(--ui-7));
}

:host([size=l][icon=export-finished]) .first:before {
  content: "\\EA2B";
  color: rgba(var(--ui-1), var(--opacity-1));
}

:host([size=l][icon=export-finished]) .first:after {
  content: "\\EA1F";
}

:host(:not([color])[size=l][icon=export-finished]) .first:after {
  content: "\\EA1F";
  color: rgb(var(--functional-green));
}

:host(:not([color])[size=l][icon=export-finished]) .second:before {
  content: "\\EA20";
  color: #ffffff;
}

:host([color][size=l][icon=export-finished]) .second:before {
  content: "\\EA20";
  color: rgb(var(--ui-7));
}

:host([size=xs][icon=export-in-progress]) .first:before {
  content: "\\EA2A";
}

:host([size=xs][icon=export-in-progress]) .first:after {
  content: "\\EA26";
}

:host(:not([color])[size=xs][icon=export-in-progress]) .first:after {
  content: "\\EA26";
  color: #52c1ff;
}

:host(:not([color])[size=xs][icon=export-in-progress]) .second:before {
  content: "\\EA27";
  color: #000000;
}

:host([color][size=xs][icon=export-in-progress]) .second:before {
  content: "\\EA27";
  color: rgb(var(--ui-7));
}

:host([size=s][icon=export-in-progress]) .first:before {
  content: "\\EA2B";
}

:host([size=s][icon=export-in-progress]) .first:after {
  content: "\\EA28";
}

:host(:not([color])[size=s][icon=export-in-progress]) .first:after {
  content: "\\EA28";
  color: #52c1ff;
}

:host(:not([color])[size=s][icon=export-in-progress]) .second:before {
  content: "\\EA29";
  color: #000000;
}

:host([color][size=s][icon=export-in-progress]) .second:before {
  content: "\\EA29";
  color: rgb(var(--ui-7));
}

:host([size=m][icon=export-in-progress]) .first:before {
  content: "\\EA2C";
}

:host([size=m][icon=export-in-progress]) .first:after {
  content: "\\E998";
}

:host(:not([color])[size=m][icon=export-in-progress]) .first:after {
  content: "\\E998";
  color: #52c1ff;
}

:host(:not([color])[size=m][icon=export-in-progress]) .second:before {
  content: "\\E999";
  color: #000000;
}

:host([color][size=m][icon=export-in-progress]) .second:before {
  content: "\\E999";
  color: rgb(var(--ui-7));
}

:host([size=l][icon=export-in-progress]) .first:before {
  content: "\\EA2B";
}

:host([size=l][icon=export-in-progress]) .first:after {
  content: "\\EA28";
}

:host(:not([color])[size=l][icon=export-in-progress]) .first:after {
  content: "\\EA28";
  color: #52c1ff;
}

:host(:not([color])[size=l][icon=export-in-progress]) .second:before {
  content: "\\EA29";
  color: #000000;
}

:host([color][size=l][icon=export-in-progress]) .second:before {
  content: "\\EA29";
  color: rgb(var(--ui-7));
}

:host([icon=print-completed]) .first:before {
  content: "\\E9CB";
}

:host([icon=print-completed]) .first:after {
  content: "\\E990";
}

:host(:not([color])[icon=print-completed]) .first:after {
  content: "\\E990";
  color: rgb(var(--functional-green));
}

:host(:not([color])[icon=print-completed]) .second:before {
  content: "\\E995";
  color: #ffffff;
}

:host([color][icon=print-completed]) .second:before {
  content: "\\E995";
  color: rgb(var(--ui-7));
}

:host([size=s][icon=print-completed]) .first:before {
  content: "\\EA57";
}

:host([size=s][icon=print-completed]) .first:after {
  content: "\\EA1F";
}

:host(:not([color])[size=s][icon=print-completed]) .first:after {
  content: "\\EA1F";
  color: rgb(var(--functional-green));
}

:host(:not([color])[size=s][icon=print-completed]) .second:before {
  content: "\\EA20";
  color: #ffffff;
}

:host([color][size=s][icon=print-completed]) .second:before {
  content: "\\EA20";
  color: rgb(var(--ui-7));
}

:host([icon=print-error]) .first:before {
  content: "\\E9CB";
}

:host([icon=print-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=print-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=print-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=print-error]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([size=s][icon=print-error]) .first:before {
  content: "\\EA57";
}

:host([size=s][icon=print-error]) .first:after {
  content: "\\EA24";
}

:host(:not([color])[size=s][icon=print-error]) .first:after {
  content: "\\EA24";
  color: rgb(var(--functional-red));
}

:host(:not([color])[size=s][icon=print-error]) .second:before {
  content: "\\EA25";
  color: #ffffff;
}

:host([size=s][icon=print-error]) .second:before {
  content: "\\EA25";
  color: rgb(var(--ui-7));
}

:host([icon=patient-error]) .first:before {
  content: "\\EABE";
}

:host([icon=patient-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=patient-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=patient-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=patient-error]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([icon=print-in-progress]) .first:before {
  content: "\\E9CB";
}

:host([icon=print-in-progress]) .first:after {
  content: "\\E998";
}

:host(:not([color])[icon=print-in-progress]) .first:after {
  content: "\\E998";
  color: #52c1ff;
}

:host(:not([color])[icon=print-in-progress]) .second:before {
  content: "\\E999";
  color: #000000;
}

:host([color][icon=print-in-progress]) .second:before {
  content: "\\E999";
  color: rgb(var(--ui-7));
}

:host([icon=patient-in-progress]) .first:before {
  content: "\\EABE";
}

:host([icon=patient-in-progress]) .first:after {
  content: "\\E998";
}

:host(:not([color])[icon=patient-in-progress]) .first:after {
  content: "\\E998";
  color: #52c1ff;
}

:host(:not([color])[icon=patient-in-progress]) .second:before {
  content: "\\E999";
  color: #000000;
}

:host([color][icon=patient-in-progress]) .second:before {
  content: "\\E999";
  color: rgb(var(--ui-7));
}

:host([size=s][icon=print-in-progress]) .first:before {
  content: "\\EA57";
}

:host([size=s][icon=print-in-progress]) .first:after {
  content: "\\EA28";
}

:host(:not([color])[size=s][icon=print-in-progress]) .first:after {
  content: "\\EA28";
  color: #52c1ff;
}

:host(:not([color])[size=s][icon=print-in-progress]) .second:before {
  content: "\\EA29";
  color: #000000;
}

:host([color][size=s][icon=print-in-progress]) .second:before {
  content: "\\EA29";
  color: rgb(var(--ui-7));
}

:host([icon=image-processing-error]) .first:before {
  content: "\\EA3D";
}

:host([icon=image-processing-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=image-processing-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=image-processing-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=image-processing-error]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([icon=open-tasks-error]) .first:before {
  content: "\\EA52";
}

:host([color][icon=open-tasks-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=open-tasks-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=open-tasks-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=open-tasks-error]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([icon=open-tasks-error]) .first:before {
  content: "\\EA52";
  color: rgba(var(--ui-1), var(--opacity-1));
}

:host([icon=open-tasks-error]) .first:after {
  content: "\\E996";
}

:host([color][icon=open-tasks-error]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([icon=addin-info]) .first:before {
  content: "\\E055";
}

:host([icon=addin-info]) .first:after {
  content: "\\EA0A";
}

:host(:not([color])[icon=addin-info]) .first:after {
  content: "\\EA0A";
  color: #6e7b9f;
}

:host(:not([color])[icon=addin-info]) .second:before {
  content: "\\EA09";
  color: #ffffff;
}

:host([color][icon=addin-info]) .second:before {
  content: "\\EA09";
  color: rgb(var(--ui-7));
}

:host([icon=addin-warning]) .first:before {
  content: "\\E055";
}

:host([icon=addin-warning]) .first:after {
  content: "\\E9A0";
}

:host(:not([color])[icon=addin-warning]) .first:after {
  content: "\\E9A0";
  color: rgb(var(--functional-yellow));
}

:host(:not([color])[icon=addin-warning]) .second:before {
  content: "\\E9A1";
  color: #000000;
}

:host([color][icon=addin-warning]) .second:before {
  content: "\\E9A1";
  color: rgb(var(--ui-7));
}

:host([icon=auto-align-scout-failed]) .first:before {
  content: "\\E069";
}

:host([icon=auto-align-scout-failed]) .first:after {
  content: "\\EA0A";
}

:host(:not([color])[icon=addin-info]) .first:after {
  content: "\\EA0A";
  color: #6e7b9f;
}

:host(:not([color])[icon=addin-info]) .second:before {
  content: "\\EA09";
  color: #ffffff;
}

:host([color][icon=addin-info]) .second:before {
  content: "\\EA09";
  color: rgb(var(--ui-7));
}

:host([icon=close-patient]) .first:before,
:host([icon=patient-success]) .first:before,
:host([icon=patient-completed]) .first:before {
  content: "\\E0B1";
}

:host([icon=close-patient]) .first:after,
:host([icon=patient-success]) .first:after,
:host([icon=patient-completed]) .first:after {
  content: "\\E990";
}

:host(:not([color])[icon=close-patient]) .first:after,
:host(:not([color])[icon=patient-success]) .first:after,
:host(:not([color])[icon=patient-completed]) .first:after {
  content: "\\E990";
  color: rgb(var(--functional-green));
}

:host(:not([color])[icon=close-patient]) .second:before,
:host(:not([color])[icon=patient-success]) .second:before,
:host(:not([color])[icon=patient-completed]) .second:before {
  content: "\\E995";
  color: #ffffff;
}

:host([color][icon=close-patient]) .second:before,
:host([color][icon=patient-success]) .second:before,
:host([color][icon=patient-completed]) .second:before {
  content: "\\E995";
  color: rgb(var(--ui-7));
}

:host([icon=patient-warning]) .first:before {
  content: "\\E0B1";
}

:host([icon=patient-warning]) .first:after {
  content: "\\E9A0";
}

:host(:not([color])[icon=patient-warning]) .first:after {
  content: "\\E9A0";
  color: rgb(var(--functional-yellow));
}

:host(:not([color])[icon=patient-warning]) .second:before {
  content: "\\E9A1";
  color: #000000;
}

:host([color][icon=patient-warning]) .second:before {
  content: "\\E9A1";
  color: rgb(var(--ui-7));
}

:host([icon=patient-status-unknown]) .first:before {
  content: "\\E0B1";
}

:host([icon=patient-status-unknown]) .first:after {
  content: "\\EA06";
}

:host(:not([color])[icon=patient-status-unknown]) .first:after {
  content: "\\EA06";
  color: #6e7b9f;
}

:host(:not([color])[icon=patient-status-unknown]) .second:before {
  content: "\\EA05";
  color: #ffffff;
}

:host([color][icon=patient-status-unknown]) .second:before {
  content: "\\EA05";
  color: rgb(var(--ui-7));
}

:host([icon=copy-reference-target-busy]) .first:before {
  content: "\\E0D7";
}

:host([icon=copy-reference-target-busy]) .first:after {
  content: "\\E998";
}

:host(:not([color])[icon=copy-reference-target-busy]) .first:after {
  content: "\\E998";
  color: #52c1ff;
}

:host(:not([color])[icon=copy-reference-target-busy]) .second:before {
  content: "\\E999";
  color: #000000;
}

:host([icon=copy-reference-target-error]) .first:before {
  content: "\\E0D7";
}

:host([icon=copy-reference-target-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=copy-reference-target-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=copy-reference-target-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([icon=copy-reference-target-warning]) .first:before {
  content: "\\E0D7";
}

:host([icon=copy-reference-target-warning]) .first:after {
  content: "\\E9A0";
}

:host(:not([color])[icon=copy-reference-target-warning]) .first:after {
  content: "\\E9A0";
  color: rgb(var(--functional-yellow));
}

:host(:not([color])[icon=copy-reference-target-warning]) .second:before {
  content: "\\E9A1";
  color: #000000;
}

:host([icon=mdt-done]) .first:before {
  content: "\\E967";
}

:host([icon=mdt-done]) .first:after {
  content: "\\E990";
}

:host(:not([color])[icon=mdt-done]) .first:after {
  content: "\\E990";
  color: rgb(var(--functional-green));
}

:host(:not([color])[icon=mdt-done]) .second:before {
  content: "\\E995";
  color: #ffffff;
}

:host([icon=low-frame-rate]) .first:before {
  content: "\\E9E0";
}

:host([icon=low-frame-rate]) .first:after {
  content: "\\E9A0";
}

:host(:not([color])[icon=low-frame-rate]) .first:after {
  content: "\\E9A0";
  color: rgb(var(--functional-yellow));
}

:host(:not([color])[icon=low-frame-rate]) .second:before {
  content: "\\E9A1";
  color: #000000;
}

:host([icon=cloud-sync]) .first:before {
  content: "\\E9EF";
}

:host([icon=cloud-sync]) .first:after {
  content: "\\E998";
}

:host(:not([color])[icon=cloud-sync]) .first:after {
  content: "\\E998";
  color: #52c1ff;
}

:host(:not([color])[icon=cloud-sync]) .second:before {
  content: "\\E999";
  color: #000000;
}

:host([color][icon=cloud-sync]) .second:before {
  content: "\\E999";
  color: rgb(var(--ui-7));
}

:host([icon=cloud-completed]) .first:before {
  content: "\\E9EF";
}

:host([icon=cloud-completed]) .first:after {
  content: "\\E990";
}

:host(:not([color])[icon=cloud-completed]) .first:after {
  content: "\\E990";
  color: rgb(var(--functional-green));
}

:host(:not([color])[icon=cloud-completed]) .second:before {
  content: "\\E995";
  color: #ffffff;
}

:host([color][icon=cloud-completed]) .second:before {
  content: "\\E995";
  color: rgb(var(--ui-7));
}

:host([icon=cloud-warning]) .first:before {
  content: "\\E9EF";
}

:host([icon=cloud-warning]) .first:after {
  content: "\\E9A0";
}

:host(:not([color])[icon=cloud-warning]) .first:after {
  content: "\\E9A0";
  color: rgb(var(--functional-yellow));
}

:host(:not([color])[icon=cloud-warning]) .second:before {
  content: "\\E9A1";
  color: #000000;
}

:host([icon=cloud-error]) .first:before {
  content: "\\E9EF";
}

:host([icon=cloud-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=cloud-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=cloud-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=cloud-error]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([icon=show-all-monitors-error]) .first:before {
  content: "\\EAA4";
}

:host([color][icon=show-all-monitors-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=show-all-monitors-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=show-all-monitors-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=show-all-monitors-error]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([icon=show-all-monitors-warning]) .first:before {
  content: "\\EAA4";
}

:host([icon=show-all-monitors-warning]) .first:after {
  content: "\\E9A0";
}

:host(:not([color])[icon=show-all-monitors-warning]) .first:after {
  content: "\\E9A0";
  color: rgb(var(--functional-yellow));
}

:host(:not([color])[icon=show-all-monitors-warning]) .second:before {
  content: "\\E9A1";
  color: #000000;
}

:host([color][icon=show-all-monitors-warning]) .second:before {
  content: "\\E9A1";
  color: rgb(var(--ui-7));
}

:host([icon=match]) .first:before {
  content: "\\EAB4";
}

:host([color][icon=match]) .first:after {
  content: "\\E990";
}

:host(:not([color])[icon=match]) .first:after {
  content: "\\E990";
  color: rgb(var(--functional-green));
}

:host(:not([color])[icon=match]) .second:before {
  content: "\\E995";
  color: #ffffff;
}

:host([color][icon=match]) .second:before {
  content: "\\E995";
  color: rgb(var(--ui-7));
}

:host([icon=shopping-cart-success]) .first:before {
  content: "\\EB3F";
}

:host([icon=shopping-cart-success]) .first:after {
  content: "\\E990";
}

:host(:not([color])[icon=shopping-cart-success]) .first:after {
  content: "\\E990";
  color: rgb(var(--functional-green));
}

:host(:not([color])[icon=shopping-cart-success]) .second:before {
  content: "\\E995";
  color: #ffffff;
}

:host([color][icon=shopping-cart-success]) .second:before {
  content: "\\E995";
  color: rgb(var(--ui-7));
}

:host([icon=scanner-error]) .first:before {
  content: "\\EB4D";
}

:host([icon=scanner-error]) .first:after {
  content: "\\EB4E";
}

:host(:not([color])[icon=scanner-error]) .first:after {
  content: "\\EB4E";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=scanner-error]) .second:before {
  content: "\\EB4F";
  color: #ffffff;
}

:host([color][icon=scanner-error]) .second:before {
  content: "\\EB4F";
  color: rgb(var(--ui-7));
}

:host([icon=scanner-success]) .first:before {
  content: "\\EB4D";
}

:host([icon=scanner-success]) .first:after {
  content: "\\EB49";
}

:host(:not([color])[icon=scanner-success]) .first:after {
  content: "\\EB49";
  color: rgb(var(--functional-green));
}

:host(:not([color])[icon=scanner-success]) .second:before {
  content: "\\EB4A";
  color: #ffffff;
}

:host([color][icon=scanner-success]) .second:before {
  content: "\\EB4A";
  color: rgb(var(--ui-7));
}

:host([icon=scanner-in-progress]) .first:before {
  content: "\\EB4D";
}

:host([icon=scanner-in-progress]) .first:after {
  content: "\\EB4C";
}

:host(:not([color])[icon=scanner-in-progress]) .first:after {
  content: "\\EB4B";
  color: #000000;
}

:host(:not([color])[icon=scanner-in-progress]) .second:before {
  content: "\\EB4C";
  color: #52c1ff;
}

:host([color][icon=scanner-in-progress]) .second:before {
  content: "\\EB4B";
  color: rgb(var(--ui-7));
}

:host([icon=temperature-error]) .first:before {
  content: "\\EB55";
}

:host([icon=temperature-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=temperature-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=temperature-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=temperature-error]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([icon=temperature-warning]) .first:before {
  content: "\\EB53";
}

:host([icon=temperature-warning]) .first:after {
  content: "\\E9A0";
}

:host(:not([color])[icon=temperature-warning]) .first:after {
  content: "\\E9A0";
  color: rgb(var(--functional-yellow));
}

:host(:not([color])[icon=temperature-warning]) .second:before {
  content: "\\E9A1";
  color: #000000;
}

:host([color][icon=temperature-warning]) .second:before {
  content: "\\E9A1";
  color: rgb(var(--ui-7));
}

:host([icon=temperature-success]) .first:before {
  content: "\\EB54";
}

:host([icon=temperature-success]) .first:after {
  content: "\\E990";
}

:host(:not([color])[icon=temperature-success]) .first:after {
  content: "\\E990";
  color: rgb(var(--functional-green));
}

:host(:not([color])[icon=temperature-success]) .second:before {
  content: "\\E995";
  color: #ffffff;
}

:host([color][icon=temperature-success]) .second:before {
  content: "\\E995";
  color: rgb(var(--ui-7));
}

:host([icon=tube-error]) .first:before {
  content: "\\EB52";
}

:host([icon=tube-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=tube-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=tube-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=tube-error]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([icon=wifi-error]) .first:before {
  content: "\\EB69";
}

:host([icon=wifi-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=wifi-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=wifi-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=wifi-error]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([icon=ethernet-error]) .first:before {
  content: "\\EB8A";
}

:host([icon=ethernet-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=ethernet-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=ethernet-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=ethernet-error]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([icon=signal-strength-error]) .first:before {
  content: "\\EB88";
}

:host([icon=signal-strength-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=signal-strength-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=signal-strength-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=signal-strength-error]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([icon=network-export-error]) .first:before {
  content: "\\EBA8";
}

:host([icon=network-export-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=network-export-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=network-export-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=network-export-error]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([icon=network-import-error]) .first:before {
  content: "\\EBDF";
}

:host([icon=network-import-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=network-import-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=network-import-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=network-import-error]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([icon=usb-export-error]) .first:before {
  content: "\\EBA7";
}

:host([icon=usb-export-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=usb-export-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=usb-export-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=usb-export-error]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([icon=usb-import-error]) .first:before {
  content: "\\EBDD";
}

:host([icon=usb-import-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=usb-import-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=usb-import-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=usb-import-error]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([icon=tube-warning]) .first:before {
  content: "\\EB52";
}

:host([icon=tube-warning]) .first:after {
  content: "\\E9A0";
}

:host(:not([color])[icon=tube-warning]) .first:after {
  content: "\\E9A0";
  color: rgb(var(--functional-yellow));
}

:host(:not([color])[icon=tube-warning]) .second:before {
  content: "\\E9A1";
  color: #000000;
}

:host([color][icon=tube-warning]) .second:before {
  content: "\\E9A1";
  color: rgb(var(--ui-7));
}

:host([icon=tube-ready]) .first:before {
  content: "\\EB52";
}

:host([icon=tube-ready]) .first:after {
  content: "\\E990";
}

:host(:not([color])[icon=tube-ready]) .first:after {
  content: "\\E990";
  color: rgb(var(--functional-green));
}

:host(:not([color])[icon=tube-ready]) .second:before {
  content: "\\E995";
  color: #ffffff;
}

:host([color][icon=tube-ready]) .second:before {
  content: "\\E995";
  color: rgb(var(--ui-7));
}

:host([icon=read]) .first:before {
  content: "\\EB5A";
}

:host([icon=read]) .first:after {
  content: "\\E990";
}

:host(:not([color])[icon=read]) .first:after {
  content: "\\E990";
  color: rgb(var(--functional-green));
}

:host(:not([color])[icon=read]) .second:before {
  content: "\\E995";
  color: #ffffff;
}

:host([color][icon=read]) .second:before {
  content: "\\E995";
  color: rgb(var(--ui-7));
}

:host([icon=medications-completed]) .first:before {
  content: "\\EB92";
}

:host([icon=medications-completed]) .first:after {
  content: "\\E990";
}

:host(:not([color])[icon=medications-completed]) .first:after {
  content: "\\E990";
  color: rgb(var(--functional-green));
}

:host(:not([color])[icon=medications-completed]) .second:before {
  content: "\\E995";
  color: #ffffff;
}

:host([color][icon=medications-completed]) .second:before {
  content: "\\E995";
  color: rgb(var(--ui-7));
}

:host([icon=medications-warning]) .first:before {
  content: "\\EB92";
}

:host([icon=medications-warning]) .first:after {
  content: "\\E9A0";
}

:host(:not([color])[icon=medications-warning]) .first:after {
  content: "\\E9A0";
  color: rgb(var(--functional-yellow));
}

:host(:not([color])[icon=medications-warning]) .second:before {
  content: "\\E9A1";
  color: #000000;
}

:host([color][icon=medications-warning]) .second:before {
  content: "\\E9A1";
  color: rgb(var(--ui-7));
}

:host([icon=medications-error]) .first:before {
  content: "\\EB92";
}

:host([icon=medications-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=medications-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=medications-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=medications-error]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([icon=medications-in-progress]) .first:before {
  content: "\\EB92";
}

:host([icon=medications-in-progress]) .first:after {
  content: "\\E998";
}

:host(:not([color])[icon=medications-in-progress]) .first:after {
  content: "\\E998";
  color: #52c1ff;
}

:host(:not([color])[icon=medications-in-progress]) .second:before {
  content: "\\E999";
  color: #000000;
}

:host([color][icon=medications-in-progress]) .second:before {
  content: "\\E999";
  color: rgb(var(--ui-7));
}

:host([icon=tablet-horizontal-error]) .first:before {
  content: "\\EBC2";
}

:host([icon=tablet-horizontal-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=tablet-horizontal-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=tablet-horizontal-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=tablet-horizontal-error]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([icon=door-open-warning]) .first:before {
  content: "\\EBEE";
}

:host([icon=door-open-warning]) .first:after {
  content: "\\E9A0";
}

:host(:not([color])[icon=door-open-warning]) .first:after {
  content: "\\E9A0";
  color: rgb(var(--functional-yellow));
}

:host(:not([color])[icon=door-open-warning]) .second:before {
  content: "\\E9A1";
  color: #000000;
}

:host([color][icon=door-open-warning]) .second:before {
  content: "\\E9A1";
  color: rgb(var(--ui-7));
}

:host([icon=range-radial-volume]) .first:before {
  content: "\\EC42";
}

:host([icon=range-radial-volume]) .first:after {
  content: "\\EC43";
  color: rgba(var(--ui-1), var(--opacity-3));
}

:host([icon=range-radial-volume]) .second:before {
  content: "\\EC44";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=range-radial-slice]) .first:before {
  content: "\\EC3F";
}

:host([icon=range-radial-slice]) .first:after {
  content: "\\EC40";
  color: rgba(var(--ui-1), var(--opacity-3));
}

:host([icon=range-radial-slice]) .second:before {
  content: "\\EC41";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=range-parallel]) .first:before {
  content: "\\EC3C";
}

:host([icon=range-parallel]) .first:after {
  content: "\\EC3D";
  color: rgba(var(--ui-1), var(--opacity-3));
}

:host([icon=range-parallel]) .second:before {
  content: "\\EC3E";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=range-curved]) .first:before {
  content: "\\EC39";
}

:host([icon=range-curved]) .first:after {
  content: "\\EC3A";
  color: rgba(var(--ui-1), var(--opacity-3));
}

:host([icon=range-curved]) .second:before {
  content: "\\EC3B";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=range-shifted-curve]) .first:before {
  content: "\\EC45";
}

:host([icon=range-shifted-curve]) .first:after {
  content: "\\EC46";
  color: rgba(var(--ui-1), var(--opacity-3));
}

:host([icon=range-shifted-curve]) .second:before {
  content: "\\EC47";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=radiation-lock]) .first:before {
  content: "\\EC5B";
  color: rgba(var(--ui-1), var(--opacity-2));
}

:host([icon=radiation-lock]) .first:after {
  content: "\\EC5C";
}

:host([size=xs][icon=analyzer]) .first:before {
  content: "\\EC58";
}

:host([size=s][icon=analyzer]) .first:before {
  content: "\\EC59";
}

:host([icon=analyzer]) .first:before {
  content: "\\EC5A";
}

:host([size=xs][icon=recommendation]) .first:before {
  content: "\\EC55";
}

:host([size=s][icon=recommendation]) .first:before {
  content: "\\EC56";
}

:host([icon=recommendation]) .first:before {
  content: "\\EC57";
}

:host([icon=no-findings]) .first:before {
  content: "\\EC62";
}

:host([icon=analyzer-error][size=s]) .first:before {
  content: "\\EC5F";
}

:host([icon=analyzer-error][size=s]) .first:after {
  content: "\\EA24";
}

:host(:not([color])[icon=analyzer-error][size=s]) .first:after {
  content: "\\EA24";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=analyzer-error][size=s]) .second:before {
  content: "\\EA25";
  color: #ffffff;
}

:host([icon=analyzer-error]) .first:before {
  content: "\\EC60";
}

:host([icon=analyzer-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=analyzer-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=analyzer-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([icon=group]) .first:before {
  content: "\\EC61";
}

:host([icon=ungroup]) .first:before {
  content: "\\EC64";
}

:host([icon=projector]) .first:before {
  content: "\\EC63";
}

:host([icon=dual-energy-information]) .first:before {
  content: "\\EC5D";
  color: rgba(var(--ui-1), var(--opacity-2));
}

:host([icon=dual-energy-information]) .first:after {
  content: "\\EC5E";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host(:not([color])[icon=dual-energy-information]) .second:before {
  content: "\\EA0A";
  color: #6e7b9f;
}

:host(:not([color])[icon=dual-energy-information]) .second:after {
  content: "\\EA09";
  color: #ffffff;
}

:host([icon=dual-energy-information]) .second:before {
  content: "\\EA0A";
}

:host([icon=dual-energy-information]) .second:after {
  content: "\\EA09";
  color: rgb(var(--ui-7));
}

:host([icon=duplicate-step]) .first:before {
  content: "\\EC53";
}

:host([icon=detector-series]) .first:before {
  content: "\\EC67";
}

:host([icon=brush]) .first:before {
  content: "\\EC66";
}

:host([icon=body-registration-anterior-posterior-left]) .first:before {
  content: "\\EC65";
}

:host([icon=injection-information]) .first:before {
  content: "\\EC69";
}

:host([icon=injection-information]) .first:after {
  content: "\\EA0A";
}

:host(:not([color])[icon=injection-information]) .first:after {
  content: "\\EA0A";
  color: #6e7b9f;
}

:host(:not([color])[icon=injection-information]) .second:before {
  content: "\\EA09";
  color: #ffffff;
}

:host([color][icon=injection-information]) .second:before {
  content: "\\EA09";
  color: rgb(var(--ui-7));
}

:host([size=s][icon=injection-information]) .first:before {
  content: "\\EC68";
}

:host([size=s][icon=injection-information]) .first:after {
  content: "\\EC6A";
}

:host(:not([color])[size=s][icon=injection-information]) .first:after {
  content: "\\EC6A";
  color: #6e7b9f;
}

:host(:not([color])[size=s][icon=injection-information]) .second:before {
  content: "\\EC6B";
  color: #ffffff;
}

:host([color][size=s][icon=injection-information]) .second:before {
  content: "\\EC6B";
  color: rgb(var(--ui-7));
}

:host([icon=network-status-error]) .first:before {
  content: "\\EC6C";
}

:host([icon=network-status-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=network-status-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=network-status-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=network-status-error]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([icon=network-status-level-1]) .first:before {
  content: "\\EC71";
}

:host([icon=network-status-level-1]) .first:after {
  content: "\\EC72";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=network-status-level-2]) .first:before {
  content: "\\EC6F";
}

:host([icon=network-status-level-2]) .first:after {
  content: "\\EC70";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=network-status-level-3]) .first:before {
  content: "\\EC6D";
}

:host([icon=network-status-level-3]) .first:after {
  content: "\\EC6E";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=video-analog]) .first:before {
  content: "\\EC7B";
}

:host([size=s][icon=video-analog]) .first:before {
  content: "\\EC7A";
}

:host([size=xs][icon=video-analog]) .first:before {
  content: "\\EC79";
}

:host([icon=thumbnail-status-4d]) .first:before {
  content: "\\EC78";
}

:host([size=s][icon=thumbnail-status-4d]) .first:before {
  content: "\\EC77";
}

:host([size=xs][icon=thumbnail-status-4d]) .first:before {
  content: "\\EC76";
}

:host([icon=thumbnail-status-3d]) .first:before {
  content: "\\EC75";
}

:host([size=s][icon=thumbnail-status-3d]) .first:before {
  content: "\\EC74";
}

:host([size=xs][icon=thumbnail-status-3d]) .first:before {
  content: "\\EC73";
}

:host([icon=patient-emergency-add]) .first:before {
  content: "\\EC54";
}

:host([icon=exposure-correction]) .first:before {
  content: "\\EC95";
}

:host([icon=block-movement]) .first:before {
  content: "\\EC94";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=block-movement]) .first:after {
  content: "\\ECCA";
}

:host([icon=copy-results-to-clipboard]) .first:before {
  content: "\\EC93";
}

:host([icon=timer-cancel]) .first:before {
  content: "\\EC92";
}

:host([icon=grid]) .first:before {
  content: "\\EC91";
}

:host([icon=block-radiation]) .first:before {
  content: "\\ECAF";
}

:host([icon=block-radiation]) .first:after {
  content: "\\EC90";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=chamber-all]) .first:before {
  content: "\\EC8F";
}

:host([icon=chamber-left-middle]) .first:before {
  content: "\\EC8D";
}

:host([icon=chamber-left-middle]) .first:after {
  content: "\\EC8E";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=chamber-left-right]) .first:before {
  content: "\\EC8B";
}

:host([icon=chamber-left-right]) .first:after {
  content: "\\EC8C";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=chamber-middle-right]) .first:before {
  content: "\\EC89";
}

:host([icon=chamber-middle-right]) .first:after {
  content: "\\EC8A";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=collimation-rotated]) .first:before {
  content: "\\EC88";
}

:host([icon=detector-tray-empty]) .first:before {
  content: "\\EC87";
}

:host([icon=grid-off]) .first:before {
  content: "\\EC86";
}

:host([icon=patient-size-x-large]) .first:before {
  content: "\\EC85";
}

:host([icon=remote-pager]) .first:before {
  content: "\\EC84";
}

:host([icon=sid]) .first:before {
  content: "\\EC83";
}

:host([icon=size-collimation]) .first:before {
  content: "\\EC82";
}

:host([icon=sod-measure]) .first:before {
  content: "\\EC81";
}

:host([icon=table-ysio]) .first:before {
  content: "\\EC80";
}

:host([icon=top-alignment]) .first:before {
  content: "\\EC7F";
}

:host([icon=wallstand-angle]) .first:before {
  content: "\\EC97";
}

:host([icon=wallstand-angle]) .first:after {
  content: "\\EC7E";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=magnification-factor]) .first:before {
  content: "\\EC99";
}

:host([icon=magnification-factor]) .first:after {
  content: "\\EC98";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=workstation-wall]) .first:before {
  content: "\\EC7C";
}

:host([icon=workstation-wall]) .first:after {
  content: "\\EC7D";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=data-edit]) .first:before {
  content: "\\EC96";
}

:host([icon=tube-detector-angle-vertical]) .first:before {
  content: "\\ECAE";
}

:host([icon=tube-detector-angle-horizontal]) .first:before {
  content: "\\ECAD";
}

:host([icon=tube-angle-vertical]) .first:before {
  content: "\\ECAC";
}

:host([icon=tube-angle-horizontal]) .first:before {
  content: "\\ECAB";
}

:host([icon=table-height-measure]) .first:before {
  content: "\\ECAA";
}

:host([icon=radiographic-aid]) .first:before {
  content: "\\ECA9";
}

:host([icon=ortho-tube-rot-start]) .first:before {
  content: "\\ECA8";
}

:host([icon=ortho-tube-rot-start]) .first:after {
  content: "\\ECA7";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=ortho-tube-rot-end]) .first:before {
  content: "\\ECA6";
}

:host([icon=ortho-tube-rot-end]) .first:after {
  content: "\\ECA5";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=legal-information]) .first:before {
  content: "\\ECA4";
}

:host([icon=detector-tray-portrait]) .first:before {
  content: "\\ECA3";
}

:host([icon=detector-tray-landscape]) .first:before {
  content: "\\ECA2";
}

:host([icon=detector-square-angle-longitudinal]) .first:before {
  content: "\\ECA1";
}

:host([icon=detector-square-angle-lateral]) .first:before {
  content: "\\ECA0";
}

:host([icon=detector-small-angle-longitudinal]) .first:before {
  content: "\\EC9F";
}

:host([icon=detector-small-angle-lateral]) .first:before {
  content: "\\EC9E";
}

:host([icon=detector-handle-angle-longitudinal]) .first:before {
  content: "\\EC9D";
}

:host([icon=detector-handle-angle-lateral]) .first:before {
  content: "\\EC9C";
}

:host([icon=detector-angle-longitudinal]) .first:before {
  content: "\\EC9B";
}

:host([icon=detector-angle-lateral]) .first:before {
  content: "\\EC9A";
}

:host([icon=studies-reject]) .first:before {
  content: "\\ECBA";
}

:host([icon=photo-documentation]) .first:before {
  content: "\\ECB9";
}

:host([icon=lung-lobe]) .first:before {
  content: "\\ECB8";
}

:host([icon=lung-lobe]) .first:after {
  content: "\\ECB7";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=document-xls]) .first:before {
  content: "\\ECB6";
}

:host([icon=document-txt]) .first:before {
  content: "\\ECB5";
}

:host([icon=document-reject]) .first:before {
  content: "\\ECB4";
}

:host([icon=document-ppt]) .first:before {
  content: "\\ECB3";
}

:host([icon=document-pdf]) .first:before {
  content: "\\ECB2";
}

:host([icon=document-docx]) .first:before {
  content: "\\ECB1";
}

:host([icon=contouring-series]) .first:before {
  content: "\\ECB0";
}

:host([icon=log-phase-forward]) .first:before {
  content: "\\ECBF";
}

:host([size=s][icon=log-phase-forward]) .first:before {
  content: "\\ECBE";
}

:host([icon=vessel-coronary-ffr-marker]) .first:before {
  content: "\\ECC0";
  color: rgba(var(--ui-1), var(--opacity-2));
}

:host([icon=vessel-coronary-ffr-marker]) .first:after {
  content: "\\ECC1";
}

:host([color][icon=warning-triangle]) .first:before {
  content: "\\ECC6";
}

:host([color][icon=warning-triangle]) .first:after {
  content: "\\ECC5";
  color: rgb(var(--ui-7));
}

:host(:not([color])[icon=warning-triangle]) .first:before {
  content: "\\ECC6";
  color: rgba(var(--functional-yellow), var(--opacity-1));
}

:host(:not([color])[icon=warning-triangle]) .first:after {
  content: "\\ECC5";
  color: rgb(var(--ui-7));
  color: black;
}

:host([icon=patient-observation]) .first:before {
  content: "\\ECC4";
}

:host([icon=patient-observation]) .first:after {
  content: "\\ECC3";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=coil-warning]) .first:before {
  content: "\\ECC2";
}

:host([icon=coil-warning]) .first:after {
  content: "\\E9A0";
}

:host(:not([color])[icon=coil-warning]) .first:after {
  content: "\\E9A0";
  color: rgb(var(--functional-yellow));
}

:host(:not([color])[icon=coil-warning]) .second:before {
  content: "\\E9A1";
  color: #000000;
}

:host([color][icon=coil-warning]) .second:before {
  content: "\\E9A1";
  color: rgb(var(--ui-7));
}

:host([icon=translation-r-l-axis]) .first:before {
  content: "\\ECF0";
}

:host([icon=translation-r-l-axis]) .first:after {
  content: "\\ECF1";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=translation-cran-caud-axis]) .first:before {
  content: "\\ECEE";
}

:host([icon=translation-cran-caud-axis]) .first:after {
  content: "\\ECEF";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=translation-a-p-axis]) .first:before {
  content: "\\ECDF";
}

:host([icon=translation-a-p-axis]) .first:after {
  content: "\\ECE0";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=timelens]) .first:before {
  content: "\\ECDD";
}

:host([icon=target-pointer]) .first:before {
  content: "\\ECDB";
}

:host([icon=target-pointer]) .first:after {
  content: "\\ECDC";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=stroke-cockpit]) .first:before {
  content: "\\ECD9";
}

:host([icon=stroke-cockpit]) .first:after {
  content: "\\ECDA";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=rotation-stepwise-r-l-axis]) .first:before {
  content: "\\ECD7";
}

:host([icon=rotation-stepwise-r-l-axis]) .first:after {
  content: "\\ECD8";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=rotation-stepwise-cran-caud-axis]) .first:before {
  content: "\\ECD5";
}

:host([icon=rotation-stepwise-cran-caud-axis]) .first:after {
  content: "\\ECD6";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=rotation-stepwise-a-p-axis]) .first:before {
  content: "\\ECD3";
}

:host([icon=rotation-stepwise-a-p-axis]) .first:after {
  content: "\\ECD4";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=registration-auto]) .first:before {
  content: "\\ECD1";
}

:host([icon=registration-auto]) .first:after {
  content: "\\ECD2";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=headscanner-drive-mode-icu]) .first:before {
  content: "\\ECD0";
}

:host([icon=ambulance]) .first:before {
  content: "\\ECC9";
}

:host([icon=align-patient-manual]) .first:before {
  content: "\\ECC7";
}

:host([icon=align-patient-manual]) .first:after {
  content: "\\ECC8";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=cursor]) .first:before {
  content: "\\ECCB";
}

:host([icon=vertical-long-axis]) .first:before {
  content: "\\ECE3";
}

:host([icon=vertical-long-axis]) .second:before {
  content: "\\ECE4";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=short-axis]) .first:before {
  content: "\\ECE1";
}

:host([icon=short-axis]) .second:before {
  content: "\\ECE2";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=job-view-error]) .first:before {
  content: "\\ECE5";
}

:host([icon=job-view-error]) .first:after {
  content: "\\E996";
}

:host(:not([color])[icon=job-view-error]) .first:after {
  content: "\\E996";
  color: rgb(var(--functional-red));
}

:host(:not([color])[icon=job-view-error]) .second:before {
  content: "\\E997";
  color: #ffffff;
}

:host([color][icon=job-view-error]) .second:before {
  content: "\\E997";
  color: rgb(var(--ui-7));
}

:host([size=xs][icon=job-view-error]) .first:before {
  content: "\\ECDE";
}

:host([size=xs][icon=job-view-error]) .first:after {
  content: "\\EA21";
}

:host([size=xs]:not([color])[icon=job-view-error]) .first:after {
  content: "\\EA21";
  color: rgb(var(--functional-red));
}

:host([size=xs]:not([color])[icon=job-view-error]) .second:before {
  content: "\\EA23";
  color: #ffffff;
}

:host([size=xs][color][icon=job-view-error]) .second:before {
  content: "\\EA23";
  color: rgb(var(--ui-7));
}

:host([icon=horizontal-long-axis]) .first:before {
  content: "\\ECCE";
}

:host([icon=horizontal-long-axis]) .first:after {
  content: "\\ECCF";
  color: rgba(var(--ui-1), var(--opacity-4));
}

:host([icon=arrow-face-left-l]) .first:before {
  content: "\\ECCC";
}

:host([icon=arrow-face-right-l]) .first:before {
  content: "\\ECCD";
}`,we=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-icon-size-xs=1rem] - size of icon
   */
  --sh-icon-size-xs: 1rem;
  /* 
   * @cssprop [--sh-icon-size-s=1.5rem] - size of icon
   */
  --sh-icon-size-s: 1.5rem;
  /* 
   * @cssprop [--sh-icon-size-m=2rem] - size of icon
   */
  --sh-icon-size-m: 2rem;
  /* 
   * @cssprop [--sh-icon-size-l=3rem] - size of icon
   */
  --sh-icon-size-l: 3rem;
  /* 
   * @cssprop [--sh-icon-font-size-xs=1rem] - size of icon image
   */
  --sh-icon-font-size-xs: 1rem;
  /* 
   * @cssprop [--sh-icon-font-size-s=1.5rem] - size of icon image
   */
  --sh-icon-font-size-s: 1.5rem;
  /* 
   * @cssprop [--sh-icon-font-size-m=2rem] - size of icon image
   */
  --sh-icon-font-size-m: 2rem;
  /* 
   * @cssprop [--sh-icon-font-size-l=3rem] - size of icon image
   */
  --sh-icon-font-size-l: 3rem;
  /* 
   * @cssprop [--sh-icon-badge-left=calc(100% - 0.25rem)] - left position the badg will be centered around
   */
  --sh-icon-badge-left: calc(100% - 0.25rem);
  /* 
   * @cssprop [--sh-icon-badge-bottom=calc(100% - 0.25rem)] - bottom position the badg will be centered around
   */
  --sh-icon-badge-bottom: calc(100% - 0.25rem);
}

:host {
  display: flex;
  color: var(--text-primary);
  outline: 0rem;
  position: relative;
  align-items: center;
  font-weight: normal;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;
  vertical-align: middle;
  display: flex;
  justify-content: center;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  font-feature-settings: "liga";
  font-family: "sh-icons";
}
:host > div {
  position: absolute;
  flex: 1;
  transition: var(--transition-time) all ease-in-out;
}
:host > div:after, :host > div:before {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0rem;
  left: 0rem;
}
:host > .first {
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

:host([button]) > div {
  transition: var(--hover-transition-time) opacity;
}

:host(.item-focused) {
  outline: var(--focus-outline);
  outline-offset: -0.125rem;
}

:host(:not([icon])) {
  display: none;
}

:host([disabled]) {
  pointer-events: none;
  cursor: default;
  opacity: var(--opacity-5);
}

.badge {
  position: absolute;
  z-index: 1;
  bottom: var(--sh-icon-badge-bottom);
  left: var(--sh-icon-badge-left);
  transform: translate(-50%, 50%);
}

.badge[label=""],
.badge[label=""]:not(.number) {
  top: 0rem;
  right: 0rem;
  left: unset;
  transform: none;
}

:host([disabled]) .badge {
  pointer-events: none;
  cursor: default;
}

:host([button]:not([disabled]):not(.accordion-expand)) {
  cursor: pointer;
}
:host([button]:not([disabled]):not(.accordion-expand)) > .first,
:host([button]:not([disabled]):not(.accordion-expand)) > .after {
  opacity: var(--opacity-3);
}

/* hover
 */
:host([button]:hover:not(.no-hovermq)) > .first,
:host([button]:hover:not(.no-hovermq)) > .second,
:host([button].no-hovermq):hover > .first,
:host([button].no-hovermq):hover > .second {
  opacity: var(--opacity-2);
}

/* press (active) */
:host([button].active:not(.no-hovermq)) > .first,
:host([button].active:not(.no-hovermq)) > .second,
:host([button].no-hovermq).active > .first,
:host([button].no-hovermq).active > .second {
  opacity: var(--opacity-3);
}

:host(.badge-width) .badge {
  width: 1.375rem;
}

:host([size=xs]),
:host([size=xs]) > div {
  min-width: var(--sh-icon-font-size-xs);
  min-height: var(--sh-icon-font-size-xs);
  height: var(--sh-icon-font-size-xs);
  width: var(--sh-icon-font-size-xs);
  height: var(--sh-icon-font-size-xs);
  font-size: var(--sh-icon-font-size-xs);
  line-height: var(--sh-icon-font-size-xs);
}

:host([size=xs][button]) {
  min-width: var(--sh-icon-size-xs);
  min-height: var(--sh-icon-size-xs);
  width: var(--sh-icon-size-xs);
  height: var(--sh-icon-size-xs);
}

:host([size=s]),
:host([size=s]) > div {
  min-width: var(--sh-icon-font-size-s);
  min-height: var(--sh-icon-font-size-s);
  height: var(--sh-icon-font-size-s);
  width: var(--sh-icon-font-size-s);
  height: var(--sh-icon-font-size-s);
  font-size: var(--sh-icon-font-size-s);
  line-height: var(--sh-icon-font-size-s);
}

:host([size=s][button]) {
  min-width: var(--sh-icon-size-s);
  min-height: var(--sh-icon-size-s);
  width: var(--sh-icon-size-s);
  height: var(--sh-icon-size-s);
}

:host([size=m]),
:host([size=m]) > div {
  min-width: var(--sh-icon-font-size-m);
  min-height: var(--sh-icon-font-size-m);
  height: var(--sh-icon-font-size-m);
  width: var(--sh-icon-font-size-m);
  height: var(--sh-icon-font-size-m);
  font-size: var(--sh-icon-font-size-m);
  line-height: var(--sh-icon-font-size-m);
}

:host([size=m][button]) {
  min-width: var(--sh-icon-size-m);
  min-height: var(--sh-icon-size-m);
  width: var(--sh-icon-size-m);
  height: var(--sh-icon-size-m);
}

:host([size=l]),
:host([size=l]) > div {
  min-width: var(--sh-icon-font-size-l);
  min-height: var(--sh-icon-font-size-l);
  height: var(--sh-icon-font-size-l);
  width: var(--sh-icon-font-size-l);
  height: var(--sh-icon-font-size-l);
  font-size: var(--sh-icon-font-size-l);
  line-height: var(--sh-icon-font-size-l);
}

:host([size=l][button]) {
  min-width: var(--sh-icon-size-l);
  min-height: var(--sh-icon-size-l);
  width: var(--sh-icon-size-l);
  height: var(--sh-icon-size-l);
}

:host {
  outline: var(--sh-debug-icon-outline-1);
}
:host > div {
  outline: var(--sh-debug-icon-outline-2);
}`;class xe extends(de(fe(se))){static get properties(){return{icon:{type:String,reflect:!0},button:{type:Boolean,reflect:!0},color:{type:String,reflect:!0},size:{type:String,reflect:!0},href:{type:String,reflect:!0},badge:{type:String,reflect:!0}}}static get styles(){return[ye,we,be(":host([button])")]}render(){return V`<div class="first"></div>
      <div class="second"></div>
      <div>
        ${void 0!==this.badge&&null!==this.badge?V` <sh-badge class="badge" label="${this.badge}"></sh-badge>`:""}
      </div>`}constructor(){super(),this.size="m"}updated(e){super.updated(e),e.has("icon")&&this._updateIcon(),e.has("color")&&this._updateColor(),he(this,e,["icon","button","color","size","href","badge"])}connectedCallback(){this.button||this.hasAttribute("tabindex")||this.setAttribute("tabindex","-1"),super.connectedCallback(),ue.isTouchDevice()&&this.classList.add("no-hovermq")}firstUpdated(){super.firstUpdated(),this.addEventListener("click",this.clickEventListener),this.addEventListener("mousedown",(function(){this._addActiveClass()})),this.addEventListener("mouseup",(function(){this._removeActiveClass()}))}handleKeyup(e){super.handleKeyup(e),e.keyCode===me.ENTER&&this.click()}_spaceKeyAction(){this.click()}clickEventListener(e){void 0!==this.href&&ve.util.setWindowLocationHRef(this.href),this.disabled&&e.stopImmediatePropagation()}_addActiveClass(){this.classList.add("active")}_removeActiveClass(){this.classList.remove("active")}_updateIcon(){const e=this.shadowRoot.querySelector(".first");this.icon&&this.icon.indexOf("url")>=0?e.style.backgroundImage=this.icon:e.style.backgroundImage=""}_updateColor(){void 0!==this.color&&(this.style.color=this.color)}}customElements.define("sh-icon",xe);var _e=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-text-super-header-line-height=2rem] - line height of super header text
   */
  --sh-text-super-header-line-height: 2rem;
  /* 
   * @cssprop [--sh-text-header-line-height=1.5rem] - line height of header text
   */
  --sh-text-header-line-height: 1.5rem;
  /* 
   * @cssprop [--sh-text-title1-line-height=1.25rem] - line height of title1 text
   */
  --sh-text-title1-line-height: 1.25rem;
  /* 
   * @cssprop [--sh-text-title2-line-height=1rem] - line height of title2 text
   */
  --sh-text-title2-line-height: 1rem;
  /* 
   * @cssprop [--sh-text-body1-line-height=1.25rem] - line height of body1 text
   */
  --sh-text-body1-line-height: 1.25rem;
  /* 
   * @cssprop [--sh-text-body2-line-height=1rem] - line height of body2 text
   */
  --sh-text-body2-line-height: 1rem;
}

:host {
  height: auto;
  height: -ms-fit-content;
  height: -moz-fit-content;
  width: 100%;
  font-size: 0.875rem;
  -webkit-font-smoothing: antialiased !important;
  text-rendering: optimizeLegibility !important;
  -moz-osx-font-smoothing: grayscale !important;
  transition: var(--transition-time) color ease-in-out;
  display: block;
}

:host([super-header]),
:host([size=super-header]) {
  font: var(--super-header);
  line-height: var(--sh-text-super-header-line-height);
}

:host([size=header-1]) {
  font: var(--header-1);
}

:host([header]),
:host([size=header-2]) {
  font: var(--header-2);
}

:host([title-1]),
:host([size=title-1]) {
  font: var(--title-1);
}

:host([title-2]),
:host([size=title-2]) {
  font: var(--title-2);
}

:host([body-1]),
:host([size=body-1]) {
  font: var(--body-1);
}

:host([body-2]),
:host([size=body-2]) {
  font: var(--body-2);
  line-height: var(--sh-text-body2-line-height);
}

/* color */
:host([color=primary]),
:host([color=primary][href]) a {
  color: var(--text-primary);
}

/* color */
:host([color=secondary]),
:host([color=secondary][href]) a {
  color: var(--text-secondary);
}

/* disabled */
:host([disabled]),
:host([disabled][href]) a {
  color: var(--text-disabled);
  pointer-events: none;
}

:host([href][color=primary]:not([disabled])) a {
  color: var(--text-primary);
}

:host([href][color=secondary]:not([disabled])) a {
  color: var(--text-secondary);
}

/* href */
:host([href]:hover:not([disabled])[size=body-2]:not(.no-hovermq)) a,
:host([href]:hover:not([disabled])[size=body-1]:not(.no-hovermq)) a {
  color: var(--text-highlight);
  transition: var(--transition-time) all ease-in-out, var(--hover-transition-time) color;
}

:host h1,
h2,
h3,
h4,
h5,
p {
  margin: 0;
  font-size: inherit;
  font-weight: unset;
}

/* line height */
:host([size=header-1]),
:host([size=header-2]) {
  line-height: var(--sh-text-header-line-height);
}

:host([size=body-1]) {
  line-height: var(--sh-text-body1-line-height);
}

:host([size=title-1]) {
  line-height: var(--sh-text-title1-line-height);
}

:host([size=title-2]) {
  line-height: var(--sh-text-title2-line-height);
}`;customElements.define("sh-text",class extends se{static get properties(){return{size:{type:String,reflect:!0},color:{type:String,reflect:!0},href:{type:String,reflect:!0},disabled:{type:Boolean,reflect:!0}}}static get styles(){return _e}render(){return!this.href||"body-1"!==this.size&&"body-2"!==this.size?V`<slot></slot>`:V`<a href="${this.href}" tabindex=${this.disabled?"-1":"0"}><slot></slot></a>`}attributeChangedCallback(e,t,o){super.attributeChangedCallback(e,t,o),this.dispatchEvent(new Event(`${e}-changed`))}constructor(){super(),this.size="body-1",this.color="primary"}firstUpdated(){this.handleLegacyAttributes(),ue.isTouchDevice()&&this.classList.add("no-hovermq")}handleLegacyAttributes(){let e,t;e=["super-header","header","body-1","body-2","title-1","title-2"],t=this,e.forEach((e=>{t.hasAttribute(e)&&(console.warn(`You are using a legacy property (${e}) of sh-text component. Please use the new 'size' and 'color' properties instead.`),t.size&&t.removeAttribute("size"))}))}});const ke={valueMatches:function(e,t,o){let i;switch(t){case"<":i=e<o;break;case">":i=e>o;break;case"=":i=e===o;break;default:i=null}return i}};customElements.define("sh-access-bar",class extends se{static get properties(){return{label:{type:String,reflect:!0},mobile:{type:Boolean,reflect:!0},condensed:{type:Boolean,reflect:!0},embedded:{type:Boolean,reflect:!0},native:{type:Boolean,reflect:!0},logo:{type:String,reflect:!0},cursorChange:{type:Boolean,reflect:!0,attribute:"cursor-change"},_emptyInfo:{type:Boolean,reflect:!0,attribute:"empty-info"}}}static get styles(){return[ae,ie`
        :host {
          background: var(--base-0);
          transition: var(--transition-time) all ease-in-out;
          box-shadow: var(--shadow-navigation);
          display: block;
          padding: 0rem;
          z-index: 4;
          height: 4.5rem;
        }
        .access-wrapper {
          display: flex;
          width: 100%;
          height: 100%;
          padding: 1.25rem 1rem;
          box-sizing: border-box;
        }
        .logo {
          height: 2rem;
          width: 8.125rem;
          min-width: 8.125rem;
          margin-left: 0.5rem;
          margin-right: 2.5rem;
          background-size: cover;
        }
        :host([cursor-change]) .logo {
          cursor: pointer;
        }
        .siemens {
          fill: var(--logo-2);
        }
        .healthineers {
          fill: var(--logo-1);
        }
        .label {
          max-width: 18.5rem;
          margin-right: 2.5rem;
          font: var(--header-1);
          color: var(--text-primary);
          line-height: 2rem;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          -webkit-font-smoothing: antialiased !important;
          text-rendering: optimizeLegibility !important;
          -moz-osx-font-smoothing: grayscale !important;
          flex-direction: column;
          justify-content: center;
          font-size: 1rem;
        }
        :host([condensed]) .label {
          line-height: 1.5rem;
        }
        .tabs-wrapper {
          margin: -1.25rem 0;
          display: flex;
          flex-direction: row;
        }
        :host([empty-info]) .tabs-wrapper {
          flex: 1;
        }
        .overflow-hidden {
          overflow: hidden;
        }
        :host([condensed]) .tabs-wrapper {
          margin: -0.5rem auto -0.5rem 0;
        }
        .functions-wrapper > ::slotted([slot='functions']) {
          margin-left: 1rem;
        }
        .user-wrapper > ::slotted(sh-user-identifier[slot='user']) {
          margin-left: 1.5rem;
        }
        .functions-wrapper {
          display: flex;
        }
        /* native (window controls) */
        .window-controls {
          display: inline-flex;
          margin: -0.75rem -0.5rem 0rem 1rem;
        }
        .window-controls sh-icon {
          margin-right: 0.5rem;
        }
        .window-controls sh-icon:last-child {
          margin-right: 0;
        }
        /* condensed */
        :host([condensed]) {
          height: 2.5rem;
        }
        :host([condensed]) .sh-access-wrapper,
        :host([condensed]) .access-wrapper {
          padding: 0.5rem 1rem;
        }
        :host([condensed]) .logo svg {
          height: 1.5rem;
        }
        :host([condensed]) .logo {
          width: 6.125rem;
          min-width: 6.125rem;
        }
        :host([condensed]) .functions-wrapper > ::slotted([slot='functions']),
        :host([condensed]) .access-wrapper > ::slotted([slot='left']),
        :host([condensed]) .access-wrapper > ::slotted([slot='right']),
        :host([condensed]) .user-wrapper > ::slotted([slot='user']) {
          margin-top: -0.25rem;
        }
        :host([condensed]) .window-controls {
          margin-top: 0rem;
        }
        /* mobile */
        :host([mobile]) {
          height: 3.5rem;
        }
        .access-wrapper > ::slotted([slot='left']),
        .access-wrapper > ::slotted([slot='right']),
        :host([mobile]) .logo,
        :host([mobile]) .user-wrapper > ::slotted([slot='user']),
        :host([mobile]) .functions-wrapper > ::slotted([slot='functions']),
        :host([mobile]) .access-wrapper > .tabs-wrapper > ::slotted([slot='tabs']),
        :host([mobile]) .access-wrapper > .info-wrapper > ::slotted([slot='info']) {
          display: none;
        }
        :host(:not([empty-info])) .info-wrapper {
          display: flex;
          flex: 1;
          align-items: center;
        }
        :host(:not([empty-info])) .info-wrapper > ::slotted([slot='info']) {
          margin-left: 1rem;
        }
        :host([mobile]) .tabs-wrapper {
          margin: 0rem;
        }
        :host([mobile]) .access-wrapper > ::slotted([slot='left']),
        :host([mobile]) .access-wrapper > ::slotted([slot='right']) {
          display: flex;
        }
        :host([mobile]) .access-wrapper > ::slotted([slot='left']) {
          margin-right: 0.5rem;
        }
        :host([mobile]) .access-wrapper > ::slotted([slot='right']) {
          margin-left: 0.5rem;
        }
        :host([mobile]) .access-wrapper {
          justify-content: space-between;
          padding: 0.75rem 1rem;
        }
        :host([mobile]) .label {
          margin-right: 0;
          z-index: 5;
          max-width: calc(100% - 13rem);
          position: absolute;
          right: 50%;
          transform: translate(50%, 0);
        }
        /* slots */
        slot[name='right'],
        slot[name='left'] {
          display: flex;
        }
        slot[name='left'] {
          margin-right: 0.5rem;
        }
        slot[name='right'] {
          margin-left: 0.5rem;
        }
        /* 3rd party logo */
        .logo > img {
          height: 100%;
        }
        :host([logo]) .logo {
          width: auto;
        }
      `]}render(){return V`
      <div class="access-wrapper">
        ${this.embedded?"":V`
              <div class="logo" @click="${()=>le(this,"logo-clicked")}">
                ${this.logo?V` <img .src="${this.logo}" /> `:V`
                      <svg
                        xmlns:svg="http://www.w3.org/2000/svg"
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        viewBox="-1.24339497 -1.24339497 179.20878994 43.93328894"
                      >
                        <path
                          class="healthineers"
                          d="m 146.66688,22.51125 c 0.23875,0.23875 0.55125,0.35875 0.865,0.35875 0.3125,0 0.62625,-0.12 0.86375,-0.35875 0.24,-0.23875 0.35875,-0.55125 0.35875,-0.865 0,-0.3125 -0.11875,-0.625 -0.35875,-0.865 -0.2375,-0.23875 -0.55125,-0.3575 -0.86375,-0.3575 -0.31375,0 -0.62625,0.11875 -0.865,0.3575 -0.23875,0.24 -0.35875,0.5525 -0.35875,0.865 0,0.31375 0.12,0.62625 0.35875,0.865 m 6.16875,-6.16863 c 0.31,0.31 0.71625,0.465 1.12375,0.465 0.40625,0 0.81374,-0.155 1.12375,-0.465 0.31125,-0.31 0.46499,-0.7175 0.46499,-1.12375 0,-0.4075 -0.15375,-0.81375 -0.46499,-1.12375 -0.31001,-0.31 -0.7175,-0.46625 -1.12375,-0.46625 -0.4075,0 -0.81375,0.15625 -1.12375,0.46625 -0.31001,0.31 -0.465,0.71625 -0.465,1.12375 0,0.40625 0.155,0.81375 0.465,1.12375 m -0.008,12.84888 c 0.31,0.31 0.71625,0.465 1.12375,0.465 0.40625,0 0.81375,-0.155 1.12375,-0.465 0.31125,-0.31 0.465,-0.7175 0.465,-1.12375 0,-0.4075 -0.15376,-0.81375 -0.465,-1.12375 -0.31,-0.31 -0.7175,-0.46625 -1.12375,-0.46625 -0.4075,0 -0.81375,0.15625 -1.12375,0.46625 -0.31,0.31 -0.465,0.71625 -0.465,1.12375 0,0.40625 0.155,0.81375 0.465,1.12375 m 6.09812,-18.93988 c 0.40375,0.40375 0.9325,0.605 1.46125,0.605 0.52875,0 1.0575,-0.20125 1.46125,-0.605 0.40375,-0.40375 0.605,-0.9325 0.605,-1.46125 0,-0.52875 -0.20125,-1.0575 -0.605,-1.46125 -0.40375,-0.40375 -0.9325,-0.605 -1.46125,-0.605 -0.52875,0 -1.0575,0.20125 -1.46125,0.605 -0.40375,0.40375 -0.605,0.9325 -0.605,1.46125 0,0.52875 0.20125,1.0575 0.605,1.46125 m -0.008,12.84875 c 0.40375,0.40375 0.9325,0.605 1.46125,0.605 0.52875,0 1.0575,-0.20125 1.46125,-0.605 0.40375,-0.40375 0.605,-0.9325 0.605,-1.46125 0,-0.52875 -0.20125,-1.0575 -0.605,-1.46125 -0.40375,-0.40375 -0.9325,-0.605 -1.46125,-0.605 -0.52875,0 -1.0575,0.20125 -1.46125,0.605 -0.40375,0.40375 -0.605,0.9325 -0.605,1.46125 0,0.52875 0.20125,1.0575 0.605,1.46125 m -0.007,12.84925 c 0.40375,0.40375 0.9325,0.605 1.46125,0.605 0.52875,0 1.0575,-0.20125 1.46125,-0.605 0.40375,-0.40375 0.605,-0.9325 0.605,-1.46125 0,-0.52875 -0.20125,-1.0575 -0.605,-1.46125 -0.40375,-0.40375 -0.9325,-0.605 -1.46125,-0.605 -0.52875,0 -1.0575,0.20125 -1.46125,0.605 -0.40375,0.40375 -0.605,0.9325 -0.605,1.46125 0,0.52875 0.20125,1.0575 0.605,1.46125 m 5.99688,-18.839 c 0.52375,0.525 1.21125,0.78625 1.89875,0.78625 0.68875,0 1.37625,-0.26125 1.90125,-0.78625 0.52375,-0.52375 0.78625,-1.21125 0.78625,-1.89875 0,-0.6875 -0.2625,-1.375 -0.7875,-1.9 -0.525,-0.525 -1.2125,-0.7875 -1.9,-0.7875 -0.6875,0 -1.375,0.2625 -1.89875,0.78625 -0.525,0.525 -0.7875,1.2125 -0.7875,1.9 0,0.68875 0.2625,1.37625 0.7875,1.9 m -0.006,12.84925 c 0.52375,0.525 1.21125,0.78625 1.89875,0.78625 0.68875,0 1.37625,-0.26125 1.90125,-0.78625 0.52375,-0.525 0.78625,-1.21125 0.78625,-1.89875 0,-0.6875 -0.2625,-1.375 -0.7875,-1.9 -0.525,-0.525 -1.2125,-0.7875 -1.9,-0.7875 -0.6875,0 -1.375,0.26125 -1.89875,0.78625 -0.525,0.525 -0.7875,1.2125 -0.7875,1.9 0,0.68875 0.2625,1.375 0.7875,1.9 m 5.85787,-5.858 c 0.6825,0.6825 1.575,1.02375 2.47,1.02375 0.89375,0 1.78625,-0.34125 2.46875,-1.02375 0.6825,-0.6825 1.02375,-1.57625 1.02375,-2.47 0,-0.89375 -0.34125,-1.78625 -1.02375,-2.46875 -0.6825,-0.6825 -1.575,-1.02375 -2.46875,-1.02375 -0.895,0 -1.7875,0.34125 -2.47,1.02375 -0.6825,0.6825 -1.02375,1.575 -1.02375,2.46875 0,0.89375 0.34125,1.7875 1.02375,2.47"
                          style="fill-opacity:1;fill-rule:nonzero;stroke:none"
                        ></path>
                        <path
                          class="siemens"
                          d="m 132.43,15.29 0,-3.0175 c 1.70125,0.54125 3.22125,0.81125 4.5575,0.81125 1.82375,0 2.73625,-0.48125 2.73625,-1.445 0,-0.36 -0.13,-0.66125 -0.3875,-0.90625 -0.2725,-0.26 -0.9725,-0.61875 -2.1,-1.07875 -2.0025,-0.82 -3.31625,-1.525 -3.93,-2.11375 -0.79,-0.76375 -1.18625,-1.7375 -1.18625,-2.92375 0,-1.5025 0.57375,-2.65 1.7275,-3.44 C 134.9825,0.3925 136.46625,0 138.295,0 c 1.02625,0 2.3575,0.16375 3.99,0.49125 l 0.3775,0.065 0,2.90125 c -1.41875,-0.56625 -2.7375,-0.84875 -3.96125,-0.84875 -1.705,0 -2.5575,0.47 -2.5575,1.41375 0,0.35125 0.1725,0.63875 0.51625,0.8625 0.27375,0.17125 1.07,0.5525 2.38375,1.14375 1.85,0.82625 3.08875,1.545 3.71125,2.1575 0.735,0.72625 1.1025,1.665 1.1025,2.8175 0,1.65375 -0.7175,2.91625 -2.1475,3.78625 -1.1725,0.70375 -2.68875,1.05625 -4.5425,1.05625 -1.56875,0 -3.14875,-0.185 -4.7375,-0.55625 m -6.0335,-15.02513 0,10.22375 -5.24375,-10.22375 -4.945,0 0,15.2725 3.005,0 0,-10.36 5.385,10.36 4.80375,0 0,-15.2725 -3.005,0 z m -24.11275,0 0,15.2725 11.1175,0 0,-2.91875 -7.00625,0 0,-3.62375 5.945,0 0,-2.51875 -5.945,0 0,-3.4475 6.82875,0 0,-2.76375 -10.94,0 z m -9.16475,0 -3.94,9.7575 -3.84125,-9.7575 -5.53125,0 0,15.2725 3.005,0 0,-10.8125 4.3925,10.96625 2.645,0 4.47875,-10.96625 0,10.8125 4.04375,0 0,-15.2725 -5.2525,0 z m -27.214,0 0,15.2725 11.11625,0 0,-2.91875 -7.005,0 0,-3.62375 5.94375,0 0,-2.51875 -5.94375,0 0,-3.4475 6.82875,0 0,-2.76375 -10.94,0 z m -8.1775,15.27163 2.1325,0 2.13375,0 0,-7.63625 0,-7.63625 -2.13375,0 -2.1325,0 0,7.63625 0,7.63625 z M 43.89188,15.29 l 0,-3.0175 c 1.71624,0.54125 3.23499,0.81125 4.55749,0.81125 1.82375,0 2.73626,-0.48125 2.73626,-1.445 0,-0.36 -0.13376,-0.66125 -0.39875,-0.90625 -0.27376,-0.26 -0.96875,-0.61875 -2.09001,-1.07875 C 46.68813,8.8275 45.37563,8.1225 44.76562,7.54 43.97812,6.77 43.58187,5.8 43.58187,4.62625 c 0,-1.50875 0.57625,-2.66 1.7275,-3.45 C 46.44563,0.3925 47.92813,0 49.75437,0 c 1.00751,0 2.46501,0.185 4.37,0.55625 l 0,2.90125 c -1.41749,-0.56625 -2.735,-0.84875 -3.95,-0.84875 -1.71375,0 -2.56999,0.47 -2.56999,1.41375 0,0.35125 0.17374,0.63875 0.51875,0.8625 0.28749,0.17875 1.07874,0.56 2.3725,1.14375 1.86249,0.82625 3.10499,1.545 3.72125,2.1575 0.73374,0.72625 1.10249,1.665 1.10249,2.8175 0,1.65375 -0.71999,2.91625 -2.15999,3.78625 -1.16375,0.70375 -2.67626,1.05625 -4.53125,1.05625 -1.5675,0 -3.14626,-0.185 -4.73625,-0.55625"
                          style="fill-opacity:1;fill-rule:nonzero;stroke:none"
                        ></path>
                        <path
                          class="healthineers"
                          d="m 56.56775,30.56875 3.44875,0 0,-2.87 -3.44875,0 0,-4.15875 -3.65875,0 0,4.16 -2.03,0 0,2.87 2.03,0 0,6.5 c 0,2.2125 0.21,4.37 4.00125,4.37 1.15875,0 2.5525,-0.34125 3.34375,-0.84125 l -0.79125,-2.45 c -0.5775,0.2375 -1.13125,0.4225 -1.60625,0.4225 -0.97375,0 -1.28875,-0.58 -1.28875,-2.0275 l 0,-5.975 z m 86.37162,-2.10438 0.01,-0.0312 c -1.165,-0.7625 -2.6925,-1.2225 -4.35875,-1.135 -2.705,0.14125 -4.83125,1.75375 -4.68375,4.54 0.14625,2.78875 2.17875,3.44625 4.17875,3.92125 1.14875,0.2825 2.10875,0.4975 2.1625,1.5225 0.0525,1 -0.6375,1.43125 -1.60875,1.4825 -1.19,0.0612 -2.695,-0.4675 -3.665,-0.96625 l -1.09126,2.51 c 0.76876,0.51375 2.74875,1.24625 5.08,1.125 3.04625,-0.16 5.04,-1.76375 4.885,-4.73625 -0.14375,-2.735 -2.33125,-3.3325 -4.28124,-3.8375 -1.20125,-0.305 -2.08625,-0.6025 -2.14125,-1.6275 -0.045,-0.86875 0.6475,-1.2475 1.515,-1.29375 0.89875,-0.0462 1.86625,0.3475 2.89375,1.0675 l 1.105,-2.54125 z m -14.82687,4.289 c 0.0525,-1.39375 0.895,-2.29 2.21125,-2.29 0.68375,0 1.3175,0.18375 1.8675,0.47375 L 132.85,27.77837 c -0.63125,-0.3425 -1.44625,-0.47375 -2.185,-0.47375 -1.23625,0 -2.52625,0.73625 -3.1575,2.29 l -0.3425,-1.89625 -2.975,0 0.26375,2.3175 0,11.02875 3.65875,0 0,-8.29125 z m -40.03688,8.29188 0,-8.555 c 0,-1.26375 0.89626,-2.36875 2.29001,-2.36875 1.39625,0 1.63124,1.07875 1.63124,2.52625 l 0,8.3975 3.65875,0 0,-9.10875 c 0,-3.1575 -1.57875,-4.6325 -4.18374,-4.6325 -1.76376,0 -3.08,0.73875 -3.97501,1.975 l -0.26375,-1.58 -3.05375,0 0.23751,2.475 0,10.87125 3.65874,0 z M 77.35125,23.52912 c 0,0.555 0.19375,1.025 0.53875,1.3575 0.345,0.33125 0.84125,0.525 1.4475,0.525 0.5925,0 1.09625,-0.19375 1.45,-0.525 0.355,-0.3325 0.56125,-0.8025 0.56125,-1.3575 0,-0.51625 -0.20625,-0.98625 -0.56125,-1.32875 -0.35375,-0.34125 -0.8575,-0.55375 -1.45,-0.55375 -0.59375,0 -1.09,0.2125 -1.4375,0.55375 -0.34875,0.3425 -0.54875,0.8125 -0.54875,1.32875 m 0.16812,17.5165 1.83001,0 1.82875,0 0,-6.6725 0,-6.67375 -1.82875,0 -1.83001,0 0,6.67375 0,6.6725 z m -10.8175,-3.7e-4 0,-8.6075 c 0,-1.2375 0.89501,-2.31625 2.2375,-2.31625 1.39501,0 1.68376,1.0525 1.68376,2.42125 l 0,8.5025 3.65875,0 0,-9.05375 c 0,-3.13375 -1.5,-4.6875 -4.26376,-4.6875 -1.29,0 -2.47375,0.47375 -3.31625,1.36875 l 0,-5.1325 -3.65874,0 0,17.505 3.65874,0 z m -22.82162,-17.4785 0,13.50375 c 0,2.21125 0.21,4.37 4.00125,4.37 1.15875,0 2.5525,-0.34125 3.3425,-0.8425 l -0.79,-2.44875 c -0.57875,0.2375 -1.13125,0.4225 -1.60375,0.4225 -0.97625,0 -1.29125,-0.58 -1.29125,-2.0275 l 0,-12.9775 -3.65875,0 z m -3.05338,17.4785 -0.26374,-2.6575 0,-10.11 c -2,-0.73625 -3.94876,-0.97375 -4.84375,-0.97375 -4.65751,0 -6.97501,3.0275 -6.97501,7.66125 0,3.5525 1.29001,6.44875 5.10625,6.44875 1.4225,0 2.7375,-0.52625 3.52751,-1.7375 l 0.1325,0.0275 0.18374,1.34125 3.1325,0 z M 36.93063,36.7815 c 0,0.97375 -0.78875,1.97375 -2.15751,1.97375 -1.94874,0 -2.39625,-1.86875 -2.39625,-4.00125 0,-2.58 0.7375,-4.7375 2.89625,-4.7375 0.68376,0 1.315,0.13125 1.65751,0.28875 l 0,6.47625 z M 9.13375,23.54075 l 0,6.975 -5.37,0 0,-6.975 -3.76375,0 0,17.505 3.76375,0 0,-7.23875 5.37,0 0,7.23875 3.765,0 0,-17.505 -3.765,0 z m 17.50512,7.60712 c 0,-2.5 -1.71125,-3.84375 -4.37,-3.84375 -4.31624,0 -6.55375,3.52875 -6.55375,7.3975 0,3.94875 1.79001,6.73875 6.26376,6.73875 2.65999,0 4.5025,-1.21125 4.8175,-1.47375 l -1.0525,-2.4475 c -0.73625,0.49875 -1.86875,1.13125 -3.29001,1.13125 -2.00124,0 -2.84375,-1.34375 -3.02749,-2.60625 3.185,-0.13125 7.21249,-0.9225 7.21249,-4.89625 m -3.21125,0.0275 c 0,1.815 -2.44874,2.23625 -4.15875,2.29 0.0775,-1.8175 1.02625,-3.58125 2.81626,-3.58125 0.815,0 1.34249,0.5 1.34249,1.29125 m 98.18325,-0.0275 c 0,-2.5 -1.71125,-3.84375 -4.37,-3.84375 -4.31624,0 -6.55375,3.52875 -6.55375,7.3975 0,3.94875 1.79,6.73875 6.26375,6.73875 2.66,0 4.5025,-1.21125 4.8175,-1.47375 l -1.05375,-2.4475 c -0.73625,0.49875 -1.8675,1.13125 -3.28874,1.13125 -2.00125,0 -2.8425,-1.34375 -3.02751,-2.60625 3.18625,-0.13125 7.2125,-0.9225 7.2125,-4.89625 m -3.21124,0.0275 c 0,1.815 -2.44875,2.23625 -4.15875,2.29 0.0775,-1.8175 1.02625,-3.58125 2.81625,-3.58125 0.815,0 1.3425,0.5 1.3425,1.29125 m -9.55525,-0.0275 c 0,-2.5 -1.71125,-3.84375 -4.37,-3.84375 -4.31625,0 -6.55376,3.52875 -6.55376,7.3975 0,3.94875 1.79,6.73875 6.26376,6.73875 2.66,0 4.5025,-1.21125 4.8175,-1.47375 l -1.0525,-2.4475 c -0.7375,0.49875 -1.86875,1.13125 -3.29,1.13125 -2.00125,0 -2.84375,-1.34375 -3.0275,-2.60625 3.18625,-0.13125 7.2125,-0.9225 7.2125,-4.89625 m -3.21125,0.0275 c 0,1.815 -2.44875,2.23625 -4.15875,2.29 0.0775,-1.8175 1.02625,-3.58125 2.81625,-3.58125 0.815,0 1.3425,0.5 1.3425,1.29125"
                          style="fill-opacity:1;fill-rule:nonzero;stroke:none"
                        ></path>
                      </svg>
                    `}
              </div>
            `}
        <!-- left content -->
        ${this.mobile?V` <slot name="left"></slot> `:""}
        <!-- label -->
        ${this.label?V` <div class="label">${this.label}</div> `:""}
        <!-- right content -->
        ${this.mobile?V` <slot name="right"></slot> `:V`
              <div class="tabs-wrapper">
                <slot name="tabs" @slotchange="${this._handleTabsSlotChange.bind(this)}"></slot>
              </div>
              <div class="info-wrapper">
                <slot name="info" @slotchange="${this._handleInfoSlotChange.bind(this)}"></slot>
              </div>
              <div class="functions-wrapper">
                <slot name="functions"></slot>
              </div>
              <div class="user-wrapper">
                <slot name="user" tabindex="0"></slot>
              </div>
              ${this.native?V`
                    <div class="window-controls">
                      <sh-icon
                        button
                        icon="minimize"
                        size="s"
                        @click="${e=>this._dispatchEventOnClickOfWindowControl(e)}"
                      ></sh-icon>
                      <sh-icon
                        button
                        icon="maximize"
                        size="s"
                        @click="${e=>this._dispatchEventOnClickOfWindowControl(e)}"
                      ></sh-icon>
                      <sh-icon
                        button
                        icon="cancel"
                        size="s"
                        @click="${e=>this._dispatchEventOnClickOfWindowControl(e)}"
                      ></sh-icon>
                    </div>
                  `:""}
            `}
      </div>
    `}constructor(){super(),this._emptyInfo=!0}connectedCallback(){super.connectedCallback(),this.mobile||(this.resizeListener=this._handleResize.bind(this),window.addEventListener("resize",this.resizeListener))}firstUpdated(){const e=this.querySelectorAll("sh-icon").length,t=this.shadowRoot.querySelectorAll("sh-icon").length;if(this._updateTabsCollapsedState(),this._handleAccessContext(),e>0)for(let t=0;t<e;t++)this.querySelectorAll("sh-icon")[t].setAttribute("tabindex","0");if(t>0)for(let e=0;e<t;e++)this.shadowRoot.querySelectorAll("sh-icon")[e].setAttribute("tabindex","0");this.mobile=this.mobile||ke.valueMatches(document.documentElement.clientWidth,"<",768)}_handleTabsSlotChange(e){this._handleAccessContext();const t=e.target.assignedNodes({flatten:!0});t.length>0&&this._enableCollapsedMenuToOverflow(t[0].collapsed),this._updateTabsCollapsedState(),this._handleCondensed()}_handleInfoSlotChange(e){const t=e.target.assignedNodes({flatten:!0});this._emptyInfo=0===t.length}_enableCollapsedMenuToOverflow(e){const t=this.shadowRoot.querySelector(".tabs-wrapper");t&&(e?t.classList.remove("overflow-hidden"):t.classList.add("overflow-hidden"))}disconnectedCallback(){window.removeEventListener("resize",this.resizeListener),super.disconnectedCallback()}updated(e){he(this,e,["label","mobile","condensed","embedded","native"]),e.has("condensed")&&this._handleCondensed()}_handleResize(){this.mobile=ke.valueMatches(document.documentElement.clientWidth,"<",768),this._updateTabsCollapsedState()}_updateTabsCollapsedState(){const e=this.querySelector("sh-tabs");if(!e)return;e.addEventListener("collapsed-changed",(e=>this._enableCollapsedMenuToOverflow(e.target.collapsed)));const t=ke.valueMatches(document.documentElement.clientWidth,"<",1025)&&(!e.fixed||!e.hasAttribute("fixed"));e.collapsed=t}_handleAccessContext(){this.querySelectorAll("sh-tabs").forEach((e=>{e._accessContext=!0}));const e=this.querySelectorAll("sh-user-identifier");for(let t=0;t<e.length;t++)e[t]._accessContext=!0}_handleCondensed(){const e=this.querySelectorAll("sh-tab-item"),t=this.querySelectorAll("sh-tabs"),o=this.querySelectorAll("sh-user-identifier");t.forEach((e=>{e.condensed=this.condensed})),e.forEach((e=>{e.condensed=this.condensed})),o.forEach((e=>{e.condensed=this.condensed}))}_dispatchEventOnClickOfWindowControl(e){const t="cancel"===e.target.icon?"close":e.target.icon;le(this,`${t}-pressed`)}getWindowIconDirectly(e){let t;const o="close"===e?"cancel":e;switch(e){case"minimize":case"maximize":case"close":t=!0;break;default:t=!1}return t?this.shadowRoot.querySelector(`.window-controls sh-icon[icon="${o}"]`):void 0}});const Ce=e=>class extends e{static get properties(){return{active:{type:Boolean,reflect:!0},neutral:{type:Boolean,reflect:!0}}}updated(e){super.updated(e),he(this,e,["active","neutral"])}firstUpdated(){super.firstUpdated(),this.addEventListener("click",(()=>this.handleClick())),this.addEventListener("focus",(()=>this.handleFocus())),this.addEventListener("blur",(()=>this.handleBlur()))}handleClick(){this.active=!this.active}},Ee=e=>class extends e{connectedCallback(){super.connectedCallback(),this._preventSroll=this._preventSpaceScroll.bind(this),this.addEventListener("keydown",this._preventSroll)}_preventSpaceScroll(e){"Space"===e.code&&e.preventDefault()}disconnectedCallback(){this.removeEventListener("keydown",this._preventScroll),super.disconnectedCallback()}};var ze=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-checkbox-inner-width=1rem] - checkbox width
   */
  --sh-checkbox-inner-width: 1rem;
  /* 
   * @cssprop [--sh-checkbox-inner-height=1rem] - checkbox height
   */
  --sh-checkbox-inner-height: 1rem;
  /* 
   * @cssprop [--sh-checkbox-outer-width=1.5rem] - checkbox outer width
   */
  --sh-checkbox-outer-width: 1.5rem;
  /* 
   * @cssprop [--sh-checkbox-outer-height=1.5rem] - checkbox outer height
   */
  --sh-checkbox-outer-height: 1.5rem;
  /* 
   * @cssprop [--sh-checkbox-tick-line-height=0.875rem] - checkbox tick line height
   */
  --sh-checkbox-tick-line-height: 0.875rem;
  /* 
   * @cssprop [--sh-checkbox-tick-font-size=0.875rem] - tick font size
   */
  --sh-checkbox-tick-font-size: 0.875rem;
  /* 
   * @cssprop [--sh-checkbox-border-width=0.125rem] - checkbox border width
   */
  --sh-checkbox-border-width: 0.125rem;
  /* 
   * @cssprop [--sh-checkbox-border-radius=0.125rem] - checkbox border radius
   */
  --sh-checkbox-border-radius: 0.125rem;
  /* 
   * @cssprop [--sh-checkbox-label-line-height=1.25rem] - checkbox label line height
   */
  --sh-checkbox-label-line-height: 1.25rem;
  /* 
   * @cssprop [--sh-checkbox-margin-right=0.5rem] - checkbox margin right
   */
  --sh-checkbox-margin-right: 0.5rem;
  /* 
   * @cssprop [--sh-checkbox-margin-around-checkbox=0.25rem] - margin around checkbox
   */
  --sh-checkbox-margin-around-checkbox: 0.25rem;
  /* 
   * @cssprop [--sh-checkbox-text-indent=-0.0625rem] - tick text indent
   */
  --sh-checkbox-text-indent: -0.0625rem;
  /* 
   * @cssprop [--sh-checkbox-outline-offset=-0.125rem] - outline ofset
   */
  --sh-checkbox-outline-offset: -0.125rem;
  /* 
   * @cssprop [--sh-checkbox-label-width=2rem] - label width
   */
  --sh-checkbox-label-width: 2rem;
  /* 
   * @cssprop [--sh-checkbox-padding=0rem] - checkbox top and bottom padding
   */
  --sh-checkbox-padding: 0rem;
  /* 
   * @cssprop [--sh-checkbox-label-padding=0rem] - label padding
   */
  --sh-checkbox-label-padding: 0rem;
}

:host {
  display: flex;
  flex-direction: row;
  width: 100%;
  color: var(--text-primary);
  -webkit-font-smoothing: antialiased !important;
  text-rendering: optimizeLegibility !important;
  -moz-osx-font-smoothing: grayscale !important;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  outline: none;
  align-items: center;
  width: 100%;
  cursor: pointer;
  position: relative;
  font: var(--body-1);
  height: fit-content;
  padding: var(--sh-checkbox-padding) 0;
}

#checkbox {
  width: var(--sh-checkbox-inner-width);
  height: var(--sh-checkbox-inner-height);
  opacity: 0;
  position: absolute;
  margin: 0 var(--sh-checkbox-margin-around-checkbox);
  top: var(--sh-checkbox-margin-around-checkbox);
  align-self: flex-start;
}

.checkboxLabel {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: calc(100% - var(--sh-checkbox-label-width));
  line-height: var(--sh-checkbox-label-line-height);
  padding: var(--sh-checkbox-label-padding);
}

#pseudoCheckbox::before {
  border-style: solid;
  border-width: var(--sh-checkbox-border-width);
  border-color: rgba(var(--ui-1), var(--opacity-4));
  width: var(--sh-checkbox-inner-width);
  height: var(--sh-checkbox-inner-height);
  position: absolute;
  margin: var(--sh-checkbox-margin-around-checkbox);
  border-radius: var(--sh-checkbox-border-radius);
  content: "\\E0E6";
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  visibility: visible;
  box-sizing: border-box;
  transition: var(--transition-time) all ease-in-out, var(--hover-transition-time) background, var(--hover-transition-time) border-color;
  font-family: "sh-icons";
  font-weight: 700;
  color: transparent;
  font-size: var(--sh-checkbox-tick-font-size);
  text-indent: var(--sh-checkbox-text-indent);
  line-height: var(--sh-checkbox-tick-line-height);
  text-align: center;
  vertical-align: middle;
}

#pseudoCheckbox {
  width: var(--sh-checkbox-outer-width);
  height: var(--sh-checkbox-outer-height);
  visibility: hidden;
  cursor: pointer;
  position: relative;
  margin-right: var(--sh-checkbox-margin-right);
  align-self: flex-start;
  display: inline-block;
}

:host(.touch-device) #pseudoCheckbox {
  visibility: visible;
}

.item-focused:before {
  outline: var(--focus-outline);
  outline-offset: var(--sh-checkbox-outline-offset);
}

:host([active]) #pseudoCheckbox::before {
  color: var(--base-3);
  background: rgba(var(--ui-2), var(--opacity-1));
  border-color: transparent;
}

:host([neutral][active]:not([disabled])) #pseudoCheckbox::before {
  background: rgba(var(--ui-1), var(--opacity-3));
}

:host(:not([active]):hover:not(.touch-device)) #pseudoCheckbox::before {
  border-color: rgba(var(--ui-1), var(--opacity-3));
}

:host([active]:hover:not(.touch-device)) #pseudoCheckbox::before {
  background: rgba(var(--ui-3), var(--opacity-1));
}

:host([neutral][active]:hover:not(.touch-device)) #pseudoCheckbox::before {
  background: rgba(var(--ui-1), var(--opacity-2)) !important;
}

:host([indeterminate]) #pseudoCheckbox::before {
  content: "\\E011";
}

:host([disabled]) {
  cursor: not-allowed;
  pointer-events: none;
  color: var(--text-disabled);
}

:host([disabled]:not([active])) #pseudoCheckbox::before {
  border-color: rgba(var(--ui-1), var(--opacity-5));
}

:host([active][disabled]:not([neutral])) #pseudoCheckbox::before {
  background: rgba(var(--ui-2), var(--opacity-5));
}

:host([neutral][active][disabled]) #pseudoCheckbox::before {
  background: rgba(var(--ui-1), var(--opacity-5));
}`;class Ae extends(Ee(Ce(de(fe(se))))){static get properties(){return{indeterminate:{type:Boolean,reflect:!0},label:{type:String,reflect:!0}}}static get styles(){return[ae,ze,be()]}render(){return V`
      <input
        tabindex="-1"
        id="checkbox"
        type="checkbox"
        role="presentation"
        ?checked="${this.active}"
        ?active="${this.active}"
        ?disabled="${this.disabled}"
        ?aria-checked="${this.indeterminate?"mixed":this.active}"
        ?indeterminate="${this.indeterminate}"
        value="${this.active}"
      />
      <span id="pseudoCheckbox" class="focus-item"></span>
      <span class="checkboxLabel">${this.label}</span>
    `}constructor(){super(),this.label="label"}updated(e){super.updated(e),he(this,e,["label","indeterminate"])}firstUpdated(){super.firstUpdated(),this.addEventListener("click",(()=>{le(this,"checked")}))}connectedCallback(){super.connectedCallback(),this.hasAttribute("role")||this.setAttribute("role","checkbox"),ue.isTouchDevice()&&this.classList.add("touch-device")}_spaceKeyAction(){this.handleClick()}}customElements.define("sh-checkbox",Ae);var Se=function(e,t,o){o.classList.contains("touch-device")||(e.target.scrollWidth>e.target.offsetWidth||e.target.scrollHeight>e.target.offsetHeight?(o.target=e.target,o.setAttribute("label",t),o.visible=!0):(o.target=Math.random().toString(),o.visible=!1))};class Me extends(de(fe(se))){static get properties(){return{label:{type:String,reflect:!0},icon:{type:String,reflect:!0},href:{type:String,reflect:!0},active:{type:Boolean,reflect:!0},role:{type:String,reflect:!0},chapter:{type:Boolean,reflect:!0},expanded:{type:Boolean,reflect:!0},value:{type:String,reflect:!0},checkbox:{type:Boolean,reflect:!0},toggle:{type:Boolean,reflect:!0},iconColor:{type:String,reflect:!0,attribute:"icon-color"},iconSize:{type:String,reflect:!0,attribute:"icon-size"},verticalAlignment:{type:Boolean,reflect:!0,attribute:"vertical-alignment"},labelRows:{type:String,reflect:!0,attribute:"label-rows"}}}static get styles(){return[ae,ie`
        :host {
          width: 100%;
          outline: 0;
          display: block;
          height: fit-content;
        }
        :host([icon]:not([checkbox]):not([vertical-alignment])) .menu-item-wrapper {
          padding: 0.25rem 0;
          min-height: 2.5rem;
        }
        :host([icon]:not([checkbox]):not([vertical-alignment])) .menu-item-wrapper[active] {
          padding: 0.25rem 0.5rem;
        }
        .vertical-item-wrapper {
          display: flex;
          align-items: center;
          width: 100%;
        }
        :host([vertical-alignment]) .vertical-item-wrapper {
          display: block;
          margin: auto;
        }
        :host([vertical-alignment]) #checkbox,
        :host([vertical-alignment]) #menu-item-icon {
          margin: 0rem auto 0.5rem;
        }
        :host([vertical-alignment]) .menu-item-label {
          text-align: center;
          line-height: 1.5rem;
        }
        :host(:not(.touch-device):not([active])[vertical-alignment]) .menu-item-wrapper:hover,
        :host([vertical-alignment]) .menu-item-wrapper[active],
        :host([vertical-alignment]) .menu-item-wrapper {
          width: 100%;
          margin: 0rem;
          padding: 0.5rem;
        }
        :host(:not([label-rows='1'])) #checkbox,
        :host(:not([label-rows='1'])) #menu-item-icon,
        :host(:not([label-rows='1'])) ::slotted(*[slot='functions']),
        :host([vertical-alignment]) ::slotted(*[slot='functions']) {
          align-self: flex-start;
        }
        .menu-item-wrapper {
          height: fit-content;
          height: -ms-fit-content;
          height: -moz-fit-content;
          min-height: 2.5rem;
          width: 100%;
          box-sizing: border-box;
          padding: 0.25rem 0;
          transition: var(--transition-time) all ease-in-out,
            var(--hover-transition-time) background;
          border-radius: 0.125rem;
          display: flex;
          flex-direction: row;
          cursor: pointer;
          outline: none;
          align-items: center;
        }
        :host([chapter]) .item-wrapper > .menu-item-wrapper {
          width: calc(100% - 2rem);
        }
        :host(.chapter-sibling) .menu-item-wrapper {
          overflow: hidden;
        }
        /* active */
        .menu-item-wrapper[active] {
          padding: 0.25rem 0.5rem;
          margin: 0 -0.5rem;
          width: calc(100% + 1rem);
          background: rgba(var(--ui-1), var(--opacity-6));
        }
        .menu-item-wrapper.item-focused {
          outline: var(--focus-outline);
          outline-offset: -0.125rem;
          padding: 0.25rem 0.5rem;
          margin: 0 -0.5rem;
          width: calc(100% + 1rem);
        }
        :host(:not([chapter]).chapter-sibling) .item-wrapper > .menu-item-wrapper.item-focused {
          outline: var(--focus-outline);
          outline-offset: -0.125rem;
          padding: 0.25rem 0.5rem;
          margin: 0 -0.5rem 0 1.5rem;
          width: calc(100% + 1rem);
        }
        :host([icon]:not([checkbox]):not([vertical-alignment]))
          .item-wrapper
          > .menu-item-wrapper.item-focused,
        :host([icon]:not([checkbox]):not([vertical-alignment]))
          .item-wrapper
          > .menu-item-wrapper.item-focused:hover,
        :host([icon]:not([checkbox]):not(.touch-device):not([vertical-alignment]))
          .item-wrapper
          > .menu-item-wrapper.hover {
          padding: 0.25rem 0.5rem !important;
        }
        :host([chapter]) .item-wrapper > .menu-item-wrapper[active],
        :host([chapter]:not(.touch-device):not([active])) .item-wrapper > .menu-item-wrapper:hover,
        :host([chapter]:not(.touch-device):not([active])) .item-wrapper > .menu-item-wrapper.hover {
          width: calc(100% - 1rem);
        }
        /* disabled */
        :host([disabled]) {
          pointer-events: none;
        }
        .menu-item-label {
          font: var(--body-1);
          line-height: 1.5rem;
          font-weight: normal;
          color: var(--text-primary);
          flex: 1;
          transition: var(--transition-time) all ease-in-out;
          -webkit-font-smoothing: antialiased;
          text-rendering: optimizeLegibility;
          -moz-osx-font-smoothing: grayscale;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          overflow: hidden;
          -moz-user-select: none;
          -webkit-user-select: none;
          user-select: none;
          position: relative;
          word-break: break-all;
        }
        sh-icon#menu-item-icon {
          position: relative;
          color: var(--text-primary);
          margin-right: 0.5rem;
        }
        :host([vertical-alignment]) ::slotted(*[slot='functions']) {
          margin: 0.25rem 0rem 0rem -1.75rem;
        }
        :host(:not([vertical-alignment])) ::slotted(*[slot='functions']) {
          margin-left: 0.5rem;
        }
        :host(:not([vertical-alignment])[label-rows='1']) ::slotted(*[slot='functions']) {
          position: relative;
          align-self: center;
          flex-shrink: 0;
        }
        .item-wrapper {
          display: flex;
          flex-direction: row;
          text-decoration: none;
          align-items: center;
        }
        /* chapter menu */
        .chapter-wrapper {
          transition: 0.1s all ease-in-out;
        }
        .chapter-wrapper > ::slotted([chapter]) {
          margin-left: -2rem;
          width: calc(100% + 2rem);
        }
        .chapter-wrapper > ::slotted(*) {
          visibility: hidden;
        }
        :host([expanded]) .chapter-wrapper > ::slotted(*) {
          visibility: visible;
        }
        :host(:not([expanded])) > .chapter-wrapper {
          max-height: 0rem;
          overflow: hidden;
          pointer-events: none;
          transform: translateY(-0.5rem);
          opacity: 0;
        }
        :host([chapter]) > .chapter-wrapper {
          display: flex;
          flex-direction: column;
          margin-left: 3.5rem;
        }
        .arrow-icon {
          display: block;
          margin-right: 0.5rem;
        }
        :host([chapter][expanded]) > .item-wrapper > .arrow-icon {
          transform: rotate(90deg);
        }
        :host(:not([chapter]).chapter-sibling) > .item-wrapper > .menu-item-wrapper {
          margin-left: 2rem;
        }
        /* hover */
        /* CSS rules with .hover class are needed for use in dropdown component */
        :host(:not(.touch-device):not([active])) .menu-item-wrapper:hover,
        :host(:not(.touch-device):not([active])) .menu-item-wrapper.hover,
        :host(.hover:not(.touch-device):not([active])) .menu-item-wrapper {
          background: rgba(var(--ui-1), var(--opacity-7));
          padding: 0.25rem 0.5rem;
          margin: 0 -0.5rem;
          width: calc(100% + 1rem);
        }
        :host(.focus:not(.touch-device)) .menu-item-wrapper {
          outline: var(--focus-outline);
          outline-offset: -0.125rem;
        }
        :host([icon]:not([checkbox]):not(.touch-device):not([active]):not([vertical-alignment]))
          .menu-item-wrapper:hover,
        :host([icon]:not([checkbox]):not(.touch-device):not([active])) .menu-item-wrapper.hover,
        :host(.hover[icon]:not([checkbox]):not(.touch-device):not([active])) .menu-item-wrapper {
          background: rgba(var(--ui-1), var(--opacity-7));
          padding: 0.25rem 0.5rem;
        }
        :host(.chapter-sibling:not([chapter]):not(.touch-device)) .menu-item-wrapper:hover,
        :host(.chapter-sibling:not([chapter]):not(.touch-device)) .menu-item-wrapper.hover,
        :host(.hover.chapter-sibling:not([chapter]):not(.touch-device)) .menu-item-wrapper,
        :host(.chapter-sibling:not([chapter])[active]) .menu-item-wrapper {
          margin-left: 1.5rem;
        }
        :host(:not(.touch-device):not([active])) .menu-item-wrapper[disabled] {
          background: transparent;
        }
        :host([disabled]) .menu-item-label {
          color: var(--text-disabled);
        }
        :host([disabled]) #menu-item-icon {
          opacity: 0.2;
        }
        #checkbox {
          width: fit-content;
          width: -moz-fit-content;
        }
      `]}render(){return V`
      <div class="item-wrapper">
        ${this.chapter?V` <sh-icon
              id="menuExpandIcon"
              ?disabled="${this.disabled}"
              button
              icon="arrow-right-s"
              size="s"
              class="arrow-icon"
              @click="${this._handleExpandIconClick}"
              @focus="${this._handleExpandIconFocus}"
            >
            </sh-icon>`:""}
        <div
          id="menuExpandWrapper"
          class="menu-item-wrapper${this.chapter?"":" focus-item"}"
          role="button"
          ?active="${this.active}"
          ?disabled="${this.disabled}"
          @click="${this._handleClicked}"
        >
          <div class="vertical-item-wrapper">
            ${this.icon&&!this.checkbox?V` <sh-icon
                  .icon="${this.icon}"
                  size="${this.iconSize?this.iconSize:"m"}"
                  id="menu-item-icon"
                  .color="${this.iconColor}"
                >
                </sh-icon>`:""}
            ${this.checkbox?V` <sh-checkbox
                  neutral
                  tabindex="-1"
                  label=""
                  ?active="${this.active}"
                  ?disabled="${this.disabled}"
                  id="checkbox"
                ></sh-checkbox>`:""}
            <div
              class="menu-item-label"
              style="-webkit-line-clamp: ${"1"!==this.labelRows&&"2"!==this.labelRows&&"auto"!==this.labelRows?"2":this.labelRows}"
            >
              ${this.label}
            </div>
            <sh-tooltip placement="bottom-left"></sh-tooltip>
          </div>
          ${this.verticalAlignment?"":V`<slot name="functions" id="functions"></slot>`}
        </div>
        ${this.verticalAlignment?V`<slot name="functions" id="functions"></slot>`:""}
      </div>
      <div class="chapter-wrapper">
        <slot id="chapterSlot" @slotchange="${this._chapterSlotObserver}"></slot>
      </div>
    `}constructor(){super(),this.label="label",this.value="",this.toggle=!0,this.verticalAlignment=!1,this.iconSize="m",this.labelRows="1"}connectedCallback(){super.connectedCallback(),ue.isTouchDevice()&&this.classList.add("touch-device"),this.hasAttribute("role")||(this.role="listitem"),this._handleFocus=this._handleFocus.bind(this),this.addEventListener("focus",this._handleFocus),this._addOrRemoveClass()}firstUpdated(){super.firstUpdated();const e=this.shadowRoot.querySelector("sh-tooltip");this.shadowRoot.querySelector(".menu-item-label").addEventListener("mouseover",(function(t){Se(t,this.textContent,e)}))}updated(e){super.updated(e),e.has("disabled")&&this._handleDisabledChange(),e.has("active")&&this._handleActiveChange(),he(this,e,["icon","href","expanded","value"])}_handleFocus(){this.onkeyup=e=>{e.keyCode!==me.ENTER&&e.keyCode!==me.SPACE||e.composedPath()[0]!==this||this._handleClicked()}}_chapterSlotObserver(){const e=this.shadowRoot.querySelector("#functions"),t=this.childElementCount>e.assignedNodes({flatten:!0}).length;this.chapter=t,this._addOrRemoveClass()}_addOrRemoveClass(){if("SH-MENU-ITEM"===this.parentNode.tagName)return;const e=this.parentNode.children;if(this.chapter)for(const t of e)t.classList.add("chapter-sibling");else if(!this.classList.contains("chapter-sibling"))for(const t of e)if(t.chapter){this.classList.add("chapter-sibling");break}}_handleDisabledChange(){for(const e of this.children)e.disabled=this.disabled}_handleClicked(){void 0!==this.href&&(window.location.href=this.href);const e={label:""===this.value?this.label:this.value,icon:this.icon};le(this,"clicked",e),this.clicked=!0,this._toggleActive()}_toggleActive(){this.toggle&&(this.active=!this.active)}_handleActiveChange(){le(this,"active-changed"),this.active&&!this.clicked&&le(this,"menu-item-active"),this.clicked=!1}_handleExpandIconClick(){this.expanded?this._collapse():this._expand()}_handleExpandIconFocus(e){e.target.onkeyup=e=>{e.keyCode===me.ARROW_LEFT?this._collapse():e.keyCode===me.ARROW_RIGHT&&this._expand()}}_collapse(){this.expanded=!1,le(this,"collapse",null,!1)}_expand(){this.expanded=!0,le(this,"expand",null,!1)}disconnectedCallback(){this.removeEventListener("focus",this._handleFocus),super.disconnectedCallback()}}customElements.define("sh-menu-item",Me);var De=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-accordion-header-wrapper-min-height=2.5rem] - minimum height of header wrapper
   */
  --sh-accordion-header-wrapper-min-height: 2.5rem;
  /* 
   * @cssprop [--sh-accordion-container-padding-left-right=0 1rem] - Left and right side padding of container
   */
  --sh-accordion-container-padding-left-right: 0 1rem;
  /* 
   * @cssprop [--sh-accordion-header-label-info-padding=0.5rem 0.5rem 0.5rem 0] - padding of accordion label and info
   */
  --sh-accordion-header-label-info-padding: 0.5rem 0.5rem 0.5rem 0;
  /* 
   * @cssprop [--sh-accordion-wrapper-padding-bottom=1rem] - bottom padding of accordion wrapper
   */
  --sh-accordion-wrapper-padding-bottom: 1rem;
  /* 
   * @cssprop [--sh-accordion-label-line-height=1.5rem] - line height of accordion label
   */
  --sh-accordion-label-line-height: 1.5rem;
  /* 
   * @cssprop [--sh-accordion-expand-icon-margin=0.25rem 0 0.25rem 0] - margin of expand icon
   */
  --sh-accordion-expand-icon-margin: 0.25rem 0 0.25rem 0;
  /* 
   * @cssprop [--sh-accordion-icon-padding=0.5rem 0.5rem 0.5rem 0] - padding of header icon
   */
  --sh-accordion-icon-padding: 0.5rem 0.5rem 0.5rem 0;
  /* 
   * @cssprop [--sh-accordion-content-items-margin-top=0.5rem] - vertical gap between items in content
   */
  --sh-accordion-content-items-margin-top: 0.5rem;
  /* 
   * @cssprop [--sh-accordion-content-items-margin-top-touch=1rem] - vertical gap between items in content for touch device
   */
  --sh-accordion-content-items-margin-top-touch: 1rem;
  /* 
   * @cssprop [--sh-accordion-content-first-item-margin-top=0rem] - top margin of first item in the content
   */
  --sh-accordion-content-first-item-margin-top: 0rem;
}

:host {
  width: 100%;
  transition: var(--transition-time) max-height ease-in-out, var(--transition-time) background-color ease-in-out;
  box-shadow: var(--shadow-raised);
  padding: var(--sh-accordion-container-padding-left-right);
  box-sizing: border-box;
  background: var(--base-3);
  border-radius: 0.125rem;
  display: block;
}

:host([flat]) {
  border-radius: 0rem;
  background: transparent;
  padding: 0;
  box-shadow: none;
}

.accordion-wrapper {
  width: 100%;
  height: fit-content;
  height: -ms-fit-content;
  height: -moz-fit-content;
  display: flex;
  flex-direction: column;
  transition: var(--transition-time) all ease-in-out;
  box-sizing: border-box;
  border-radius: 0.125rem;
  word-break: break-word;
}

.header-wrapper {
  min-height: var(--sh-accordion-header-wrapper-min-height);
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  cursor: pointer;
}

.accordion-label {
  color: var(--text-primary);
  font: var(--header-2);
  line-height: var(--sh-accordion-label-line-height);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: var(--sh-accordion-header-label-info-padding);
  align-self: center;
}

:host([label-rows=auto]) .accordion-label {
  white-space: unset;
}

.label {
  display: contents;
}

.accordion-info {
  min-width: 1.125rem;
  width: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
  flex: auto;
  line-height: var(--sh-accordion-label-line-height);
  padding: var(--sh-accordion-header-label-info-padding);
}

:host([info]) .accordion-label {
  min-width: 3.375rem;
  width: auto;
  flex: auto;
}

:host(:not([info])) .accordion-info {
  display: none;
}

.accordion-wrapper sh-icon.expand {
  color: rgba(var(--ui-1), var(--opacity-3));
  transition: var(--transition-time) color ease-in-out;
  margin: 0.25rem 0;
}

:host(:not([flat])) > .accordion-wrapper sh-icon.expand {
  margin: var(--sh-accordion-expand-icon-margin);
}

.content-wrapper {
  display: flex;
  width: 100%;
  flex-direction: column;
}

/* expanded */
:host(:not([expanded])) > .accordion-wrapper > .content-wrapper {
  visibility: hidden;
  opacity: 0;
  overflow: hidden;
  transition: var(--transition-time) all ease-in-out, var(--transition-time) max-height ease-in-out, var(--transition-time) padding ease-in-out;
  max-height: 0rem;
}

:host([expanded]) > .accordion-wrapper {
  padding-bottom: var(--sh-accordion-wrapper-padding-bottom);
}

:host([expanded]) > .accordion-wrapper > .header-wrapper > sh-icon.expand {
  transform: rotate(-180deg);
  transform-style: preserve-3d;
}

:host([expanded]) > .accordion-wrapper > .content-wrapper {
  visibility: visible;
  opacity: 1;
  max-height: 9999rem;
  overflow: visible;
}

.accordion-icon {
  padding: var(--sh-accordion-icon-padding);
}

.footer-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-top: 1rem;
  margin-top: 0rem;
}

.footer-wrapper[empty-footer] {
  display: none;
}

.footer-wrapper > ::slotted(*) {
  margin-left: 0.5rem;
}

.content-wrapper > ::slotted(*) {
  margin-top: var(--sh-accordion-content-items-margin-top);
}

.content-wrapper > ::slotted(*:first-child) {
  margin-top: var(--sh-accordion-content-first-item-margin-top);
}

.content-wrapper > ::slotted(sh-menu-item) {
  margin-top: 0rem;
}

.header-slot-wrapper {
  flex: 1;
  max-width: calc(100% - 2.5rem);
  margin-right: 0.5rem;
}

.header-slot-wrapper > ::slotted(*) {
  padding: var(--sh-accordion-header-label-info-padding);
  line-height: var(--sh-accordion-label-line-height);
  font-weight: bold;
  font-size: var(--font-size-header-2);
}

.header-slot-wrapper[empty-header] {
  display: none;
}

/* disabled */
:host([disabled]) {
  pointer-events: none;
}

:host([disabled]) .header-slot-wrapper > ::slotted(*),
:host([disabled]) .accordion-label,
:host([disabled]) .accordion-info {
  color: var(--text-disabled);
}

/* touch */
@media (pointer: coarse) {
  .content-wrapper > ::slotted(*) {
    margin-top: var(--sh-accordion-content-items-margin-top-touch);
  }
}
/* hover */
:host(:not(.no-hovermq)) .header-wrapper:hover sh-icon.expand {
  color: rgba(var(--ui-1), var(--opacity-2));
}`;customElements.define("sh-accordion",class extends se{static get properties(){return{label:{type:String,reflect:!0},info:{type:String,reflect:!0},flat:{type:Boolean,reflect:!0},expanded:{type:Boolean,reflect:!0},icon:{type:String,reflect:!0},disabled:{type:Boolean,reflect:!0},_emptyFooter:{type:Boolean,reflect:!0},_emptyHeader:{type:Boolean,reflect:!0},iconColor:{type:String,reflect:!0,attribute:"icon-color"},labelRows:{type:String,reflect:!0,attribute:"label-rows"}}}static get styles(){return[ae,De]}render(){return V`
      <div class="accordion-wrapper">
        <div class="header-wrapper" @click="${()=>this._handleExpand()}">
          ${this.icon&&this._emptyHeader?V` <sh-icon
                size="s"
                .icon="${this.icon}"
                .color="${this.iconColor}"
                class="accordion-icon"
                ?disabled="${this.disabled}"
              ></sh-icon>`:""}
          ${this._emptyHeader?V` <sh-text size="header-2" class="accordion-label">${this.label}</sh-text>
                <sh-text size="body-1" color="secondary" class="accordion-info"
                  >${this.info}</sh-text
                >`:""}
          <div class="header-slot-wrapper" ?empty-header=${this._emptyHeader}>
            <slot
              name="header"
              class="header"
              @slotchange="${e=>this._updateHeaderSlotFlag(e.target)}"
            ></slot>
          </div>
          <sh-icon
            class="expand accordion-expand"
            icon="arrow-down-s"
            button
            ?disabled="${this.disabled}"
          ></sh-icon>
        </div>
        <div class="content-wrapper">
          <slot></slot>
          <div class="footer-wrapper" ?empty-footer=${this._emptyFooter}>
            <slot
              name="footer"
              class="footer"
              @slotchange="${e=>this._updateSlotFlag(e.target)}"
            ></slot>
          </div>
        </div>
      </div>
    `}firstUpdated(){ue.isTouchDevice()&&this.classList.add("no-hovermq")}updated(e){e.has("disabled")&&this._handleDisabled(),he(this,e,["label","info","flat","expanded","icon","disabled"])}constructor(){super(),this.label="Accordion Label",this._emptyFooter=!0,this._emptyHeader=!0}_updateSlotFlag(e){const t=e.assignedNodes({flatten:!0}).length;this._emptyFooter=0===t}_updateHeaderSlotFlag(e){const t=e.assignedNodes({flatten:!0}).length;this._emptyHeader=0===t}_handleExpand(){this.expanded=!this.expanded}_handleDisabled(){this.disabled&&(this.expanded=!1)}});var Be=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-breadcrumb-item-item-height=1.5rem] - height of breadcrumb item
   */
  --sh-breadcrumb-item-item-height: 1.5rem;
  /* 
   * @cssprop [--sh-breadcrumb-item-item-max-width=10rem] - max width of breadcrumb item
   */
  --sh-breadcrumb-item-item-max-width: 10rem;
  /* 
   * @cssprop [--sh-breadcrumb-item-item-line-height=1.25rem] - line height of breadcrumb item
   */
  --sh-breadcrumb-item-item-line-height: 1.25rem;
  /* 
   * @cssprop [--sh-breadcrumb-item-item-icon-margin=-0.25rem 0] - icon margin of breadcrumb
   */
  --sh-breadcrumb-item-item-icon-margin: -0.25rem 0;
  /* 
   * @cssprop [--sh-breadcrumb-item-item-icon-width=2rem] - icon max width
   */
  --sh-breadcrumb-item-item-icon-width: 2rem;
}

:host {
  display: block;
  float: left;
  margin-right: 0.25rem;
  height: var(--sh-breadcrumb-item-item-height);
  display: inline-flex;
  align-items: center;
}

sh-text {
  color: var(--text-secondary);
  text-decoration: none;
  font-weight: bold;
  margin-right: 0.25rem;
  transition: var(--transition-time) all ease-in-out, var(--hover-transition-time) color;
  max-width: var(--sh-breadcrumb-item-item-max-width);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  font: var(--body-1);
  line-height: var(--sh-breadcrumb-item-item-line-height);
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  outline: transparent;
}

sh-icon {
  color: rgba(var(--ui-1), var(--opacity-3));
  margin: -0.25rem 0;
  max-width: var(--sh-breadcrumb-item-item-icon-width);
}

/* State Styles */
:host([active]) sh-text {
  color: var(--text-primary);
  cursor: default;
  max-width: none;
}

:host([active]) sh-icon {
  display: none;
}

/* hover */
:host(:not(.no-hovermq)) sh-text:hover,
sh-text.hover {
  color: var(--text-primary);
}

/* focus */
.focus {
  outline: var(--focus-outline);
  outline-offset: -0.125rem;
}`;customElements.define("sh-breadcrumb-item",class extends se{static get properties(){return{active:{type:Boolean,reflect:!0},label:{type:String,reflect:!0},href:{type:String,reflect:!0}}}static get styles(){return[ae,Be]}render(){return V`
      <sh-text
        title="${this.label}"
        @click="${()=>this._navigateByHref()}"
        @mouseenter="${e=>this._showTooltip(e,this.label)}"
        onmouseover="title='';"
        >${this.label}</sh-text
      >
      <sh-tooltip placement="bottom-left"></sh-tooltip>
      <sh-icon icon="arrow-right-s"></sh-icon>
    `}_navigateByHref(){this.href&&!this.active&&ve.util.setWindowLocationHRef(this.href)}connectedCallback(){super.connectedCallback(),this.hasAttribute("role")||this.setAttribute("role","link")}firstUpdated(){this.shadowRoot.querySelector("sh-text").setAttribute("tabindex",0),this.addEventListener("focus",(()=>this._handleFocus())),this.addEventListener("blur",(()=>this._handleBlur()))}updated(){const e=this.shadowRoot.querySelector("sh-text");this.active&&e&&e.removeAttribute("title")}_handleFocus(){this.onkeyup=function(e){"Tab"===e.code&&this.shadowRoot.querySelector("sh-text").classList.add("focus"),"Enter"===e.code&&this._navigateByHref()}}_handleBlur(){this.shadowRoot.querySelector("sh-text").classList.remove("focus")}_showTooltip(e,t){const o=this.shadowRoot.querySelector("sh-tooltip");Se(e,t,o)}}),customElements.define("sh-breadcrumbs",class extends se{static get properties(){return{}}static get styles(){return[ae,ie`
        :host {
          float: left;
          display: block;
          overflow: hidden;
        }
      `]}render(){return V` <slot @slotchange="${this._handleSlotChange}"></slot> `}_handleSlotChange(){const e=this.querySelectorAll("sh-breadcrumb-item");for(let t=0;t<e.length;t++)e[t].active=!0,e[t-1]&&e[t]!==e.length&&(e[t-1].active=!1)}});const Te=e=>e*Number(getComputedStyle(document.documentElement)["font-size"].split("px")[0]);function Re(e,t,o,i,r,s,n=null,a=null,c=!1){let l;getComputedStyle(document.documentElement),({overlayRect:t,targetRect:o,actualViewport:l}=function(e,t,o,i){e=JSON.parse(JSON.stringify(e)),t=JSON.parse(JSON.stringify(t)),o=JSON.parse(JSON.stringify(o));const r=e.left+Te(i),s=e.right-Te(i),n=e.top+Te(i),a=e.bottom-Te(i);return{overlayRect:o,targetRect:t,actualViewport:{left:r,right:s,top:n,bottom:a,width:s-r,height:a-n}}}(i,o,t,s));let{overlayTop:h,overlayLeft:d,overlayRight:p,overlayBottom:u}=Le(e,o,t,r),m=d,f=h,g=!1;const b=Pe(h,d,p,u,l),v=function(e,t){return e.right<=t.left||e.left>=t.right||e.bottom<=t.top||e.top>=t.bottom}(o,l);if(!b){const i=function(e,t,o,i,r,s,n,a,c){let l=!1,h=function(e,t,o,i){let r;return r=t?o||function(e){return{top:[{from:"bottom",to:"bottom-diag-left",increment:"overlayRight",incrementBy:-1},{from:"bottom",to:"bottom-diag-right",increment:"overlayLeft",incrementBy:1},{from:"bottom-diag-left",to:"top-diag-left",increment:"overlayBottom",incrementBy:-1},{from:"bottom-diag-right",to:"top-diag-right",increment:"overlayBottom",incrementBy:-1}],bottom:[{from:"top",to:"top-diag-left",increment:"overlayRight",incrementBy:-1},{from:"top",to:"top-diag-right",increment:"overlayLeft",incrementBy:1},{from:"top-diag-left",to:"bottom-diag-left",increment:"overlayTop",incrementBy:1},{from:"top-diag-right",to:"bottom-diag-right",increment:"overlayTop",incrementBy:1}],left:[{from:"right",to:"top-diag-right",increment:"overlayBottom",incrementBy:-1},{from:"right",to:"bottom-diag-right",increment:"overlayTop",incrementBy:1},{from:"top-diag-right",to:"top-diag-left",increment:"overlayRight",incrementBy:-1},{from:"bottom-diag-right",to:"bottom-diag-left",increment:"overlayRight",incrementBy:-1}],right:[{from:"left",to:"top-diag-left",increment:"overlayBottom",incrementBy:-1},{from:"left",to:"bottom-diag-left",increment:"overlayTop",incrementBy:1},{from:"top-diag-left",to:"top-diag-right",increment:"overlayLeft",incrementBy:1},{from:"bottom-diag-left",to:"bottom-diag-right",increment:"overlayLeft",incrementBy:1}],"top-left":[{from:"bottom-left",to:"bottom-diag-left",increment:"overlayRight",incrementBy:-1},{from:"bottom-left",to:"bottom-diag-right",increment:"overlayLeft",incrementBy:1},{from:"bottom-diag-left",to:"top-diag-left",increment:"overlayBottom",incrementBy:-1},{from:"bottom-diag-right",to:"top-diag-right",increment:"overlayBottom",incrementBy:-1}],"top-right":[{from:"bottom-right",to:"bottom-diag-right",increment:"overlayLeft",incrementBy:1},{from:"bottom-right",to:"bottom-diag-left",increment:"overlayRight",incrementBy:-1},{from:"bottom-diag-right",to:"top-diag-right",increment:"overlayBottom",incrementBy:-1},{from:"bottom-diag-left",to:"top-diag-left",increment:"overlayBottom",incrementBy:-1}],"bottom-left":[{from:"top-left",to:"top-diag-left",increment:"overlayRight",incrementBy:-1},{from:"top-left",to:"top-diag-right",increment:"overlayLeft",incrementBy:1},{from:"top-diag-left",to:"bottom-diag-left",increment:"overlayTop",incrementBy:1},{from:"top-diag-right",to:"bottom-diag-right",increment:"overlayTop",incrementBy:1}],"bottom-right":[{from:"top-right",to:"top-diag-right",increment:"overlayLeft",incrementBy:1},{from:"top-right",to:"top-diag-left",increment:"overlayRight",incrementBy:-1},{from:"top-diag-right",to:"bottom-diag-right",increment:"overlayTop",incrementBy:1},{from:"top-diag-left",to:"bottom-diag-left",increment:"overlayTop",incrementBy:1}],"left-up":[{from:"right-up",to:"top-diag-right",increment:"overlayBottom",incrementBy:-1},{from:"right-up",to:"bottom-diag-right",increment:"overlayTop",incrementBy:1},{from:"top-diag-right",to:"top-diag-left",increment:"overlayRight",incrementBy:-1},{from:"bottom-diag-right",to:"bottom-diag-left",increment:"overlayRight",incrementBy:-1}],"right-up":[{from:"left-up",to:"top-diag-left",increment:"overlayBottom",incrementBy:-1},{from:"left-up",to:"bottom-diag-left",increment:"overlayTop",incrementBy:1},{from:"top-diag-left",to:"top-diag-right",increment:"overlayLeft",incrementBy:1},{from:"bottom-diag-left",to:"bottom-diag-right",increment:"overlayLeft",incrementBy:1}],"left-down":[{from:"right-down",to:"bottom-diag-right",increment:"overlayTop",incrementBy:1},{from:"right-down",to:"top-diag-right",increment:"overlayBottom",incrementBy:-1},{from:"top-diag-right",to:"top-diag-left",increment:"overlayRight",incrementBy:-1},{from:"bottom-diag-right",to:"bottom-diag-left",increment:"overlayRight",incrementBy:-1}],"right-down":[{from:"left-down",to:"bottom-diag-left",increment:"overlayTop",incrementBy:1},{from:"left-down",to:"top-diag-left",increment:"overlayBottom",incrementBy:-1},{from:"top-diag-left",to:"top-diag-right",increment:"overlayLeft",incrementBy:1},{from:"bottom-diag-left",to:"bottom-diag-right",increment:"overlayLeft",incrementBy:1}]}[e]}(e):i||function(e){return{bottom:[{from:"bottom",to:"bottom-diag-left",increment:"overlayRight",incrementBy:-1},{from:"bottom",to:"bottom-diag-right",increment:"overlayLeft",incrementBy:1},{from:"bottom-diag-left",to:"top-diag-left",increment:"overlayBottom",incrementBy:-1},{from:"bottom-diag-right",to:"top-diag-right",increment:"overlayBottom",incrementBy:-1}],top:[{from:"top",to:"top-diag-left",increment:"overlayRight",incrementBy:-1},{from:"top",to:"top-diag-right",increment:"overlayLeft",incrementBy:1},{from:"top-diag-left",to:"bottom-diag-left",increment:"overlayTop",incrementBy:1},{from:"top-diag-right",to:"bottom-diag-right",increment:"overlayTop",incrementBy:1}],right:[{from:"right",to:"top-diag-right",increment:"overlayBottom",incrementBy:-1},{from:"right",to:"bottom-diag-right",increment:"overlayTop",incrementBy:1},{from:"top-diag-right",to:"top-diag-left",increment:"overlayRight",incrementBy:-1},{from:"bottom-diag-right",to:"bottom-diag-left",increment:"overlayRight",incrementBy:-1}],left:[{from:"left",to:"top-diag-left",increment:"overlayBottom",incrementBy:-1},{from:"left",to:"bottom-diag-left",increment:"overlayTop",incrementBy:1},{from:"top-diag-left",to:"top-diag-right",increment:"overlayLeft",incrementBy:1},{from:"bottom-diag-left",to:"bottom-diag-right",increment:"overlayLeft",incrementBy:1}],"bottom-left":[{from:"bottom-left",to:"bottom-diag-left",increment:"overlayRight",incrementBy:-1},{from:"bottom-left",to:"bottom-diag-right",increment:"overlayLeft",incrementBy:1},{from:"bottom-diag-left",to:"top-diag-left",increment:"overlayBottom",incrementBy:-1},{from:"bottom-diag-right",to:"top-diag-right",increment:"overlayBottom",incrementBy:-1}],"bottom-right":[{from:"bottom-right",to:"bottom-diag-right",increment:"overlayLeft",incrementBy:1},{from:"bottom-right",to:"bottom-diag-left",increment:"overlayRight",incrementBy:-1},{from:"bottom-diag-right",to:"top-diag-right",increment:"overlayBottom",incrementBy:-1},{from:"bottom-diag-left",to:"top-diag-left",increment:"overlayBottom",incrementBy:-1}],"top-left":[{from:"top-left",to:"top-diag-left",increment:"overlayRight",incrementBy:-1},{from:"top-left",to:"top-diag-right",increment:"overlayLeft",incrementBy:1},{from:"top-diag-left",to:"bottom-diag-left",increment:"overlayTop",incrementBy:1},{from:"top-diag-right",to:"bottom-diag-right",increment:"overlayTop",incrementBy:1}],"top-right":[{from:"top-right",to:"top-diag-right",increment:"overlayLeft",incrementBy:1},{from:"top-right",to:"top-diag-left",increment:"overlayRight",incrementBy:-1},{from:"top-diag-right",to:"bottom-diag-right",increment:"overlayTop",incrementBy:1},{from:"top-diag-left",to:"bottom-diag-left",increment:"overlayTop",incrementBy:1}],"right-up":[{from:"right-up",to:"top-diag-right",increment:"overlayBottom",incrementBy:-1},{from:"right-up",to:"bottom-diag-right",increment:"overlayTop",incrementBy:1},{from:"top-diag-right",to:"top-diag-left",increment:"overlayRight",incrementBy:-1},{from:"bottom-diag-right",to:"bottom-diag-left",increment:"overlayRight",incrementBy:-1}],"left-up":[{from:"left-up",to:"top-diag-left",increment:"overlayBottom",incrementBy:-1},{from:"left-up",to:"bottom-diag-left",increment:"overlayTop",incrementBy:1},{from:"top-diag-left",to:"top-diag-right",increment:"overlayLeft",incrementBy:1},{from:"bottom-diag-left",to:"bottom-diag-right",increment:"overlayLeft",incrementBy:1}],"right-down":[{from:"right-down",to:"bottom-diag-right",increment:"overlayTop",incrementBy:1},{from:"right-down",to:"top-diag-right",increment:"overlayBottom",incrementBy:-1},{from:"top-diag-right",to:"top-diag-left",increment:"overlayRight",incrementBy:-1},{from:"bottom-diag-right",to:"bottom-diag-left",increment:"overlayRight",incrementBy:-1}],"left-down":[{from:"left-down",to:"bottom-diag-left",increment:"overlayTop",incrementBy:1},{from:"left-down",to:"top-diag-left",increment:"overlayBottom",incrementBy:-1},{from:"top-diag-left",to:"top-diag-right",increment:"overlayLeft",incrementBy:1},{from:"bottom-diag-left",to:"bottom-diag-right",increment:"overlayLeft",incrementBy:1}]}[e]}(e),r}(e,function(e,t,o,i,r){const s=Le(e,t,o,i);return{top:s.overlayTop<r.top,bottom:s.overlayBottom>r.bottom,left:s.overlayLeft<r.left,right:s.overlayRight>r.right,"top-left":s.overlayTop<r.top,"top-right":s.overlayTop<r.top,"bottom-left":s.overlayBottom>r.bottom,"bottom-right":s.overlayBottom>r.bottom,"left-up":s.overlayLeft<r.left,"left-down":s.overlayLeft<r.left,"right-up":s.overlayRight>r.right,"right-down":s.overlayRight>r.right}[e]}(e,i,r,s,n),a,c);for(let e=0;e<h.length;++e){const a=h[e],c=a.from,d=a.to,p=a.increment,u=a.incrementBy,m=Le(c,i,r,s),f=Le(d,i,r,s);for(let e=m[p];1===u?e<f[p]:e>f[p];1===u?++e:--e){const i=Oe(p,e,m,r);if(Pe(i.overlayTop,i.overlayLeft,i.overlayRight,i.overlayBottom,n)){t=i.overlayLeft,o=i.overlayTop,l=!0;break}}if(l)break}return{hasFoundIdeal:l,top:o,left:t}}(e,m,f,o,t,r,l,n,a);if(g=i.hasFoundIdeal,g)m=i.left,f=i.top;else{let i=function(e,t,o,i,r){let s=!1,n=Le(e,t,o,i);const a=function(e){let t=[];switch(e){case"top":case"top-left":case"top-right":t=["overlayTop","overlayRight","overlayBottom","overlayLeft"];break;case"bottom":case"bottom-left":case"bottom-right":t=["overlayBottom","overlayLeft","overlayTop","overlayRight"];break;case"left":case"left-up":case"left-down":t=["overlayLeft","overlayTop","overlayRight","overlayBottom"];break;case"right":case"right-up":case"right-down":t=["overlayRight","overlayBottom","overlayLeft","overlayTop"]}return t}(e);return n=Ne(a[0],n,o,r),n=Ne(a[1],n,o,r),n=Ne(a[2],n,o,r),n=Ne(a[3],n,o,r),s=Pe(n.overlayTop,n.overlayLeft,n.overlayRight,n.overlayBottom,r),{foundIdealWrtViewport:s,placementInfo:n}}(e,o,t,r,l);c||console.warn("Could not find an ideal position within the viewport for the overlay without overlap with the target\n\nSo trying to fit the overlay within the viewport","\nby correcting for the given placement: \t",e,"\n\nNote: The target will be overlapped.\n\nSuggestion: Try to place the target in some other position within the viewport OR try to reduce the overlay's width and height"),m=i.placementInfo.overlayLeft,f=i.placementInfo.overlayTop,i.foundIdealWrtViewport||c||console.warn("Could not fit the Overlay within the Viewport.\n\n","Are you sure the overlay width and/or height is less than effective viewport width (viewport width -"+Te(s)+"px ) and/or effective viewport height (viewport height -"+Te(s)+"px ) ?")}}return v&&!c&&console.warn("The effective target (target boundary + "+Te(r)+"px margin around it) is outside the effective viewport (viewport boundary - "+Te(s)+"px inner padding)"),{requiredLeft:m,requiredTop:f,targetIsOutsideViewport:v}}function Le(e,t,o,i){let r,s,n,a;switch(e){case"top":r=t.top-o.height-Te(i),s=t.left+t.width/2-o.width/2;break;case"top-left":r=t.top-o.height-Te(i),s=t.left;break;case"top-right":r=t.top-o.height-Te(i),s=t.right-o.width;break;case"bottom":r=t.bottom+Te(i),s=t.left+t.width/2-o.width/2;break;case"bottom-left":r=t.bottom+Te(i),s=t.left;break;case"bottom-right":r=t.bottom+Te(i),s=t.right-o.width;break;case"left":r=t.top+t.height/2-o.height/2,s=t.left-o.width-Te(i);break;case"left-up":r=t.top,s=t.left-o.width-Te(i);break;case"left-down":r=t.bottom-o.height,s=t.left-o.width-Te(i);break;case"right":r=t.top+t.height/2-o.height/2,s=t.right+Te(i);break;case"right-up":r=t.top,s=t.right+Te(i);break;case"right-down":r=t.bottom-o.height,s=t.right+Te(i);break;case"top-diag-left":r=t.top-o.height-Te(i),s=t.left-o.width-Te(i);break;case"top-diag-right":r=t.top-o.height-Te(i),s=t.right+Te(i);break;case"bottom-diag-left":r=t.bottom+Te(i),s=t.left-o.width-Te(i);break;case"bottom-diag-right":r=t.bottom+Te(i),s=t.right+Te(i)}return r=Math.round(r),s=Math.round(s),n=s+o.width,a=r+o.height,{overlayTop:r,overlayLeft:s,overlayRight:n,overlayBottom:a}}function Pe(e,t,o,i,r){return t>=r.left&&o<=r.right&&e>=r.top&&i<=r.bottom}function Oe(e,t,o,i){const r={overlayLeft:{overlayTop:o.overlayTop,overlayLeft:t},overlayTop:{overlayTop:t,overlayLeft:o.overlayLeft},overlayRight:{overlayTop:o.overlayTop,overlayLeft:t-i.width},overlayBottom:{overlayTop:t-i.height,overlayLeft:o.overlayLeft}}[e],s=r.overlayLeft+i.width,n=r.overlayTop+i.height;return{...r,overlayRight:s,overlayBottom:n}}function Ne(e,t,o,i){return"overlayTop"===e&&t.overlayTop<i.top&&(t.overlayTop=i.top),"overlayRight"===e&&t.overlayRight>i.right&&(t.overlayRight=i.right),"overlayLeft"===e&&t.overlayLeft<i.left&&(t.overlayLeft=i.left),"overlayBottom"===e&&t.overlayBottom>i.bottom&&(t.overlayBottom=i.bottom),Oe(e,t[e],t,o)}var Fe=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-tooltip-max-content-width=25rem] - maximum width of the tooltip
   */
  --sh-tooltip-max-content-width: 25rem;
  /* 
   * @cssprop [--sh-tooltip-content-padding=0.25rem 0.5rem] - padding for the tooltip
   */
  --sh-tooltip-content-padding: 0.25rem 0.5rem;
  /* 
   * @cssprop [--sh-tooltip-label-line-height=1rem] - line height of the tooltip label
   */
  --sh-tooltip-label-line-height: 1rem;
  /* 
   * @cssprop [--sh-tooltip-padding-title=0.5rem] - padding for the tooltip with title
   */
  --sh-tooltip-padding-title: 0.5rem;
  /* 
   * @cssprop [--sh-tooltip-title-line-height=1rem] - line height of the tooltip title
   */
  --sh-tooltip-title-line-height: 1rem;
  /* 
   * @cssprop [--sh-tooltip-margin-value=0.5rem] - margin value of the tooltip title and error icon
   */
  --sh-tooltip-margin-value: 0.5rem;
  /* 
   * @cssprop [--sh-tooltip-content-border-radius=0.125rem] - border-radius of the tooltip
   */
  --sh-tooltip-content-border-radius: 0.125rem;
  /* 
   * @cssprop [--sh-tooltip-margin-top-value=0rem] - margin top for the tooltip
   */
  --sh-tooltip-margin-top-value: 0rem;
}

:host {
  position: fixed;
  opacity: 0;
  visibility: hidden;
  color: var(--text-primary);
  transition-property: opacity, visibility, z-index;
  transition-timing-function: ease-in-out;
  transition-duration: var(--transition-time);
  transition-delay: 0s;
  width: fit-content;
  width: -ms-fit-content;
  width: -moz-fit-content;
  height: auto;
  margin-top: var(--sh-tooltip-margin-top-value) !important;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
  display: block;
  background: var(--base-4);
  box-shadow: var(--shadow-overlay);
  border-radius: var(--sh-tooltip-content-border-radius);
  padding: var(--sh-tooltip-content-padding);
  z-index: 999;
  max-width: var(--sh-tooltip-max-content-width);
  box-sizing: border-box;
  word-break: break-all;
}

:host([title]) {
  padding: var(--sh-tooltip-padding-title);
}

:host .tooltip-label {
  font: var(--body-2);
  color: var(--text-primary);
  line-height: var(--sh-tooltip-label-line-height);
}

:host .tooltip-title {
  font: var(--title-2);
  color: var(--text-primary);
  display: block;
  line-height: var(--sh-tooltip-title-line-height);
  margin-bottom: var(--sh-tooltip-margin-value);
  word-break: break-all;
}

.label-wrapper {
  display: flex;
  flex-direction: row;
}

#tooltipIcon {
  margin-right: var(--sh-tooltip-margin-value);
}

:host([visible]) {
  visibility: visible;
  opacity: 1;
  pointer-events: all;
}

:host([visible][delay]) {
  transition-delay: 0.4s;
}`;customElements.define("sh-tooltip",class extends se{static get properties(){return{label:{type:String,reflect:!0},title:{type:String,reflect:!0},variation:{type:String,reflect:!0},target:{type:String,reflect:!0},visible:{type:Boolean,reflect:!0},placement:{type:String,reflect:!0},icon:{type:String,reflect:!0},error:{type:Boolean,reflect:!0},delay:{type:Boolean,reflect:!0},_targetEl:{type:Object}}}static get styles(){return[ae,Fe]}render(){return V`
      ${this.title&&"long"===this.variation?V` <div class="tooltip-title">${this.title}</div> `:""}
      <div class="label-wrapper">
        ${this.icon?V` <sh-icon icon="${this.icon}" id="tooltipIcon" size="s"></sh-icon> `:""}
        ${this.label?V` <div class="tooltip-label">${this.label}</div> `:""}
      </div>
      <slot></slot>
    `}constructor(){super(),this.variation="long",this.placement="top"}updated(e){e.has("target")&&this._handleTarget(),(e.has("visible")&&this.visible||e.has("placement"))&&this._targetEl&&"pointer"!==this.placement&&this._setOverlayPlacement(this._targetEl),e.has("error")&&this._handleError(),e.has("_targetEl")&&e.get("_targetEl")&&this._removeTargetEventListener(e.get("_targetEl")),he(this,e,["label","title","variation","target","visible","placement","icon","error"])}getTarget(){const e=this.target;if(e){if("string"==typeof e)return this.parentElement&&this.parentElement.querySelector(`[id="${e}"]`)||document.getElementById(e);if(e instanceof HTMLElement)return e;throw new Error('\n\nThe "target" property is not of valid type.\nThe "target" property can take string value corresponding to the id of the target.\nIt can also have its value equal to a DOM Node reference (instance of HTMLElement)\n')}return null}_setOverlayPlacement(e){const t=Re(this.placement,this.getBoundingClientRect(),e.getBoundingClientRect(),JSON.parse(JSON.stringify(document.body.getBoundingClientRect())),.5,.5,null,null,!0);this.style.left=t.requiredLeft+"px",this.style.top=t.requiredTop+"px"}firstUpdated(){super.firstUpdated(),ue.isTouchDevice()&&this.classList.add("touch-device"),this._showListener=this._setVisible.bind(this),this._hideListener=this._clearVisible.bind(this),this._tooltipMouseEnter=this._tooltipMouseEnterActions.bind(this),this._tooltipMouseLeave=this._tooltipMouseLeaveActions.bind(this),this.addEventListener("mouseenter",this._tooltipMouseEnter),this.addEventListener("mouseleave",this._tooltipMouseLeave)}_tooltipMouseEnterActions(){this.visible=!0}_tooltipMouseLeaveActions(){this.visible=!1}_handleTarget(){this._targetEl=this.getTarget(this.target),this._targetEl&&(this._targetEl.addEventListener("mouseenter",this._showListener),this._targetEl.addEventListener("mouseleave",this._hideListener),this._targetEl.addEventListener("focus",this._showListener),this._targetEl.addEventListener("blur",this._hideListener),this._targetEl.addEventListener("tap",this._hideListener))}_removeTargetEventListener(e){e.removeEventListener("mouseenter",this._showListener),e.removeEventListener("focus",this._showListener),e.removeEventListener("mouseleave",this._hideListener),e.removeEventListener("blur",this._hideListener),e.removeEventListener("tap",this._hideListener)}disconnectedCallback(){this._targetEl&&this._removeTargetEventListener(this._targetEl),this.removeEventListener("mouseenter",this._tooltipMouseEnter),this.removeEventListener("mouseleave",this._tooltipMouseLeave),super.disconnectedCallback()}_setVisible(e){if("pointer"===this.placement){const t=8;this.style.left=e.clientX+this.offsetWidth>document.body.getBoundingClientRect().right?`${e.clientX-this.offsetWidth+t}px`:`${e.clientX+t}px`,this.style.top=e.clientY+this.offsetHeight>document.body.getBoundingClientRect().bottom?`${e.clientY-this.offsetHeight+t}px`:`${e.clientY+t}px`}this.classList.contains("touch-device")||(this.visible=!0)}_clearVisible(){this.visible=!1}_handleError(){this.error&&(this.icon="error")}});var $e=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-button-button-height=2rem] - height of the button
   */
  --sh-button-button-height: 2rem;
  /* 
   * @cssprop [--sh-button-width-size-s=6rem] - width of the button s
   */
  --sh-button-width-size-s: 6rem;
  /* 
   * @cssprop [--sh-button-width-size-m=9.5rem] - width of the button m
   */
  --sh-button-width-size-m: 9.5rem;
  /* 
   * @cssprop [--sh-button-width-size-l=11.5rem] - width of the button l
   */
  --sh-button-width-size-l: 11.5rem;
  /* 
   * @cssprop [--sh-button-label-line-height=1.5rem] - line height of the label
   */
  --sh-button-label-line-height: 1.5rem;
  /* 
   * @cssprop [--sh-button-button-border-radius=1rem] - border radius of the button
   */
  --sh-button-button-border-radius: 1rem;
  /* 
   * @cssprop [--sh-button-button-padding=0.25rem 1rem] - padding of the button
   */
  --sh-button-button-padding: 0.25rem 1rem;
  /* 
   * @cssprop [--sh-button-icon-width=3rem] - width of the icon button
   */
  --sh-button-icon-width: 3rem;
  /* 
   * @cssprop [--sh-button-icon-height=3rem] - height of the icon button
   */
  --sh-button-icon-height: 3rem;
  /* 
   * @cssprop [--sh-button-icon-size=2rem] - size of the icon
   */
  --sh-button-icon-size: 2rem;
  /* 
   * @cssprop [--sh-button-icon-padding=0.5rem] - padding of the icon
   */
  --sh-button-icon-padding: 0.5rem;
  /* 
   * @cssprop [--sh-button-padding-right-left=2rem] - left right padding of the button
   */
  --sh-button-padding-right-left: 2rem;
  /* 
   * @cssprop [--sh-button-tooltip-height=1.5rem] - line height and height of the tooltip
   */
  --sh-button-tooltip-height: 1.5rem;
  /* 
   * @cssprop [--sh-button-tooltip-max-width=15rem] - max width of the tooltip
   */
  --sh-button-tooltip-max-width: 15rem;
  /* 
   * @cssprop [--sh-button-tooltip-top-margin=0rem] - margin-top for the tooltip
   */
  --sh-button-tooltip-top-margin: 0rem;
  /* 
   * @cssprop [--sh-button-tooltip-margin=0.25rem] - margin for the tooltip
   */
  --sh-button-tooltip-margin: 0.25rem;
  /* 
   * @cssprop [--sh-button-tooltip-margin-top=-1.5rem] - margin for tooltip top placement
   */
  --sh-button-tooltip-margin-top: -1.5rem;
  /* 
   * @cssprop [--sh-button-tooltip-hover-margin-top=-1.75rem] - margin for tooltip top placement on hover
   */
  --sh-button-tooltip-hover-margin-top: -1.75rem;
  /* 
   * @cssprop [--sh-button-tertiary-border-thickness=0.0625rem] - border thickness of a tertiary button
   */
  --sh-button-tertiary-border-thickness: 0.0625rem;
  /* 
   * @cssprop [--sh-button-flex-shrink-icon=unset] - flex-shrink of an icon button
   */
  --sh-button-flex-shrink-icon: unset;
}

:host {
  display: flex;
  height: var(--sh-button-button-height);
  padding: var(--sh-button-button-padding);
  position: relative;
  flex-direction: row;
  border-radius: var(--sh-button-button-border-radius);
  cursor: pointer;
  box-sizing: border-box;
  outline: 0;
  justify-content: center;
  transition: var(--hover-transition-time) background;
  align-items: center;
}

:host([icon]) {
  flex-shrink: var(--sh-button-flex-shrink-icon);
}

.label {
  text-align: center;
  align-self: center;
  line-height: var(--sh-button-label-line-height) !important;
  font: var(--title-1);
  overflow: hidden;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  font-weight: bold;
  -webkit-font-smoothing: antialiased !important;
  text-rendering: optimizeLegibility !important;
  -moz-osx-font-smoothing: grayscale !important;
  -moz-user-select: none;
  -webkit-user-select: none;
}

:host sh-icon {
  margin: auto;
}

/* size */
:host(:not([icon])[size=s]) .label,
:host([shape=pill-s]) .label {
  width: calc(var(--sh-button-width-size-s) - var(--sh-button-padding-right-left));
}

:host(:not([icon])[size=m]) .label,
:host([shape=pill-m]) .label {
  width: calc(var(--sh-button-width-size-m) - var(--sh-button-padding-right-left));
}

:host(:not([icon])[size=l]) .label,
:host([shape=pill-l]) .label {
  width: calc(var(--sh-button-width-size-l) - var(--sh-button-padding-right-left));
}

/* icon button */
:host([icon]:not([shape^=pill-])) {
  position: relative;
  width: var(--sh-button-icon-width);
  height: var(--sh-button-icon-height);
  padding: var(--sh-button-icon-padding);
  border-radius: 50%;
}

sh-icon {
  --sh-icon-size-m: var(--sh-button-icon-size);
  --sh-icon-font-size-m: var(--sh-button-icon-size);
}

/* color='primary' */
:host([color=primary]) {
  background-color: rgba(var(--ui-3), var(--opacity-1));
}

:host([color=primary]:hover:not(:active):not(.no-hovermq)) {
  background-color: rgba(var(--ui-2), var(--opacity-1));
}

:host([color=primary]:active) {
  background-color: rgba(var(--ui-4), var(--opacity-1));
}

:host([color=primary]) .label,
:host([color=primary]) sh-icon {
  color: var(--text-white);
}

/* color='secondary' */
:host([color=secondary]) {
  background-color: rgba(var(--ui-1), var(--opacity-6));
}

:host([color=secondary]:hover:not(:active):not(.no-hovermq)) {
  background-color: rgba(var(--ui-1), var(--opacity-5));
}

:host([color=secondary]:active) {
  background-color: rgba(var(--ui-1), var(--opacity-7));
}

:host([color=secondary]) .label {
  color: var(--text-primary);
}

/* color='tertiary' */
:host(:not([icon])[color=tertiary]) {
  padding: var(--sh-button-button-padding);
  border: var(--sh-button-tertiary-border-thickness) solid rgba(var(--ui-1), var(--opacity-6));
  color: var(--text-primary);
}

:host(:not([icon])[color=tertiary]:hover:not(:active):not(.no-hovermq)) {
  background-color: rgba(var(--ui-1), var(--opacity-5));
}

:host(:not([icon])[color=tertiary]:active) {
  background-color: rgba(var(--ui-1), var(--opacity-7));
}

:host([color=tertiary]) {
  background-color: transparent;
}

:host([color=tertiary]) sh-icon {
  color: rgba(var(--ui-1), var(--opacity-3));
}

:host([icon][color=tertiary]:hover:not(:active):not(.no-hovermq)) sh-icon {
  color: rgba(var(--ui-1), var(--opacity-2));
}

:host([color=tertiary]:active) {
  background-color: rgba(var(--ui-1), var(--opacity-7));
}

:host([color=tertiary]) .label {
  color: var(--text-primary);
}

/* disabled */
:host([disabled]) {
  pointer-events: none;
  cursor: not-allowed;
}

:host([color=primary][disabled]) .label,
:host([color=primary][disabled]) sh-icon {
  color: var(--text-white-disabled);
}

:host(:not([color=primary])[disabled]) .label,
:host(:not([color=primary])[disabled]) sh-icon {
  color: rgba(var(--ui-1), var(--opacity-5));
}

:host([color=primary][disabled]) {
  background-color: rgba(var(--ui-2), var(--opacity-5));
}

:host([color=secondary][disabled]) {
  background-color: rgba(var(--ui-1), var(--opacity-7));
}

:host(:not([icon])[color=tertiary][disabled]) {
  border: var(--sh-button-tertiary-border-thickness) solid rgba(var(--ui-1), var(--opacity-7));
}

:host([color=tertiary]) .label {
  color: var(--text-primary);
}

/* touch */
:host(:hover:not(:active):not(.no-hovermq)) .tooltip {
  opacity: 1;
  visibility: visible;
}

:host(:hover:not(:active):not(.no-hovermq)) .top.tooltip {
  margin-top: var(--sh-button-tooltip-hover-margin-top);
}

:host(:hover:not(:active):not(.no-hovermq)) .bottom.tooltip {
  margin-top: var(--sh-button-tooltip-margin);
}

:host(:hover:not(:active):not(.no-hovermq)) .left.tooltip {
  margin-right: var(--sh-button-tooltip-margin);
}

:host(:hover:not(:active):not(.no-hovermq)) .right.tooltip {
  margin-left: var(--sh-button-tooltip-margin);
}

:host(:not([icon])) {
  /**
           * To prevent the browser from
           * shrinking the button when 
           * the window is resized to a
           * smaller size, we set 
           * flex-shrink to 0.
          */
  flex-shrink: 0;
  min-width: var(--sh-button-width-size-s);
  max-width: var(--sh-button-width-size-l);
}

:host([size=s]),
:host([shape=pill-s]) {
  width: var(--sh-button-width-size-s);
}

:host([size=m]),
:host([shape=pill-m]) {
  width: var(--sh-button-width-size-m);
}

:host([size=l]),
:host([shape=pill-l]) {
  width: var(--sh-button-width-size-l);
}

:host([size=auto]),
:host([size=max-content]) {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
}

:host([size=max-content]) {
  max-width: unset;
}

:host([size=full-width]) {
  max-width: unset;
  width: 100%;
}`;class Ie extends(Ee(de(se))){static get properties(){return{icon:{type:String,reflect:!0},label:{type:String,reflect:!0},size:{type:String,reflect:!0},color:{type:String,reflect:!0},tooltip:{type:String,reflect:!0},href:{type:String,reflect:!0},role:{type:String,reflect:!0}}}static get styles(){return[be(),$e]}render(){return V`
      ${!this.icon||this.getAttribute("shape")&&this.getAttribute("shape").includes("pill")?V` <div class="label">${this.label}</div> `:V`
            <div>
              <sh-icon icon="${this.icon}"></sh-icon>
              ${this.tooltip?V` <sh-tooltip
                    .target="${this}"
                    placement="${this.tooltip}"
                    label="${this.label}"
                  ></sh-tooltip>`:""}
            </div>
          `}
    `}updated(e){super.updated(e),e.has("href")&&this.href&&this.addHrefListener(),he(this,e,["icon","label","size","color","tooltip","href"])}constructor(){super(),this.label="Label",this.size="s",this.color="primary",this.role="button"}firstUpdated(){super.firstUpdated(),Modernizr.hovermq||this.classList.add("no-hovermq"),this.addEventListener("focus",(()=>this.handleFocus())),this.addEventListener("blur",(()=>this.handleBlur())),this.hasAttribute("shape")&&this.handleLegacyAttributes()}addHrefListener(){this.addEventListener("click",(()=>{window.location.href=this.href}))}handleLegacyAttributes(){const e=this.getAttribute("shape");"pill-s"==e?this.size="s":"pill-m"==e?this.size="m":"pill-l"==e?this.size="l":"circle"==e&&(this.icon||(this.icon="save")),console.warn(`You are using a legacy property (${e}) of sh-button component. Please use the new 'size' property instead.`)}handleFocus(){this.addEventListener("keyup",this.handleKeyboard)}handleKeyboard(e){let t;if(t=this,e.keyCode!==me.ENTER&&e.keyCode!==me.SPACE||t.click(),"Tab"===e.code){t.style.outline="var(--focus-outline)",t.style.outlineOffset="-0.125rem";const e=t.shadowRoot.querySelector(".tooltip");e&&(e.style.opacity=1,e.style.visibility="visible")}}handleBlur(){const e=this.shadowRoot.querySelector(".tooltip");this.style.outline="",this.style.outlineOffset="",this.removeEventListener("keyup",this.handleKeyboard),e&&(e.style.opacity="",e.style.visibility="")}}customElements.define("sh-button",Ie),customElements.define("sh-card",class extends se{static get properties(){return{label:{type:String,reflect:!0},icon:{type:String,reflect:!0},image:{type:String,reflect:!0},href:{type:String,reflect:!0},badge:{type:String,reflect:!0},imageIcon:{type:String,reflect:!0,attribute:"image-icon"},imageContain:{type:Boolean,reflect:!0,attribute:"image-contain"},disabled:{type:Boolean,reflect:!0},_emptyFooter:{type:Boolean},_emptyHeader:{type:Boolean},_emptyContent:{type:Boolean},cardHeight:{type:String,reflect:!0,attribute:"card-height"},iconColor:{type:String,reflect:!0,attribute:"icon-color"},labelRows:{type:String,reflect:!0,attribute:"label-rows"}}}static get styles(){return[ae,ie`
        :host {
          width: 100%;
        }
        .card-wrapper {
          position: relative;
          height: 100%;
          display: flex;
          flex-direction: column;
          border-radius: 0.125rem;
          background-color: var(--base-3);
          box-shadow: var(--shadow-raised);
          transition: var(--transition-time) all ease-in-out,
            var(--hover-transition-time) box-shadow ease;
        }
        .label-wrapper {
          display: flex;
          flex-direction: row;
          padding: 1rem;
          align-items: center;
          min-height: fit-content;
          min-height: -ms-fit-content;
          min-height: -moz-fit-content;
        }
        :host([label-rows='auto']) .label-wrapper,
        :host([label-rows='auto']) slot[name='functions'] {
          align-items: unset;
        }

        sh-icon.card-icon {
          margin-right: 0.5rem;
        }
        .card-label {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-weight: bold;
          line-height: 1.5rem !important;
          flex: 1;
          color: var(--text-primary);
          font: var(--header-2);
          -webkit-font-smoothing: antialiased !important;
          text-rendering: optimizeLegibility !important;
          -moz-osx-font-smoothing: grayscale !important;
          max-width: 100%;
        }
        /* slots */
        .label-wrapper + .header-wrapper {
          padding-top: 0rem;
        }
        slot {
          display: flex;
        }
        .header-wrapper,
        slot[name='footer'] {
          padding: 1rem;
        }
        slot:not([name]) {
          padding: 0rem 1rem;
        }
        slot[name='functions'] {
          align-items: center;
        }
        .header-wrapper {
          height: fit-content;
          overflow: hidden;
        }
        slot:not([name]) {
          flex: 1;
          box-sizing: border-box;
          flex-direction: column;
          overflow: auto;
          font: var(--body-1);
          color: var(--text-primary);
          line-height: 1.25rem;
        }
        slot[name='footer'] {
          height: fit-content;
          flex-wrap: wrap;
          justify-content: flex-end;
          align-items: center;
        }
        slot[name='header']::slotted(sh-tabs) {
          margin-top: -1rem;
        }
        slot:not([name]).empty-header:not(.empty-content) {
          padding-top: 1rem;
        }
        slot:not([name]).empty-footer:not(.empty-content) {
          padding-bottom: 1rem;
        }
        slot.empty,
        .header-wrapper.empty {
          padding: 0rem;
        }
        /* image */
        .image-wrapper {
          height: 0rem;
          padding-top: 56.25%;
          position: relative;
          background-color: rgba(var(--ui-1), var(--opacity-7));
        }
        .image-wrapper sh-icon,
        .image-wrapper img {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate3d(-50%, -50%, 0);
        }
        .image-wrapper sh-icon {
          --sh-icon-size-m: 4rem;
          --sh-icon-font-size-m: 4rem;
        }
        img {
          height: 100%;
          width: 100%;
          display: block;
          background-position: center;
          object-fit: cover;
          background-repeat: no-repeat;
        }
        :host([image-contain]) img {
          object-fit: contain;
        }
        :host([image][href]) .label-wrapper,
        :host([image]) .label-wrapper,
        :host([image-icon]) .label-wrapper {
          padding-bottom: 0.5rem;
        }
        /* Content Spacing */
        slot:not([name])::slotted(*:not(:first-child)) {
          margin-top: 0.5rem;
        }
        slot[name='functions']::slotted(*),
        slot[name='footer']::slotted(*:not(:first-child)) {
          margin-left: 0.5rem;
        }
        /* href */
        :host([href]) {
          cursor: pointer;
        }
        :host([href]:hover) .card-wrapper {
          box-shadow: var(--shadow-overlay);
        }
        .card-wrapper::before {
          pointer-events: none;
          transition: var(--transition-time) all ease-in-out,
            var(--hover-transition-time) background;
          content: '';
          border-radius: 0.125rem;
          height: 100%;
          width: 100%;
          position: absolute;
        }
        .card-badge {
          position: absolute;
          left: calc(100% - 0.25rem);
          bottom: calc(100% - 0.25rem);
          transform: translate(-50%, 50%);
        }
        .icon-badge-wrapper {
          position: relative;
        }
        :host([href]:hover) .card-wrapper::before {
          background-color: rgba(var(--ui-5), var(--opacity-7));
        }
        :host([href]:not([image])) .label-wrapper.empty-content {
          padding: 1rem;
          height: 100%;
          align-items: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          text-align: center;
        }
        :host([href]:not([image])) .label-wrapper.empty-content:not(.empty-footer) {
          padding-bottom: 0rem;
        }
        :host([href]) .label-wrapper.empty-content .card-label {
          flex: unset;
        }
        :host([href]:not([image])) .card-icon.empty-content {
          margin-right: unset;
          margin-bottom: 0.5rem;
        }
        :host([href]) slot[name='footer']::slotted(*:not(:first-child)) {
          margin: unset;
        }
        :host([href]:not([image])) slot[name='footer']:not(.empty).empty-content {
          border-top: 0.0625rem solid rgba(var(--ui-1), var(--opacity-6));
        }
        :host([href]:not([image])) slot[name='footer']:not(.empty) {
          margin: 0 1rem;
          padding: 1rem 0;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
        /* href disabled */
        :host([href][disabled]) {
          pointer-events: none;
        }
        :host([href][disabled]) .card-wrapper {
          opacity: var(--opacity-4);
        }
        :host([href][disabled]) .card-label {
          color: var(--text-disabled);
        }
        :host([label-rows='auto']) .card-label {
          white-space: unset;
        }
        /* touch */
        @media (pointer: coarse) {
          slot:not([name])::slotted(*:not(:first-child)) {
            margin-top: 1rem;
          }
          slot[name='functions']::slotted(*:not(:first-child)),
          slot[name='footer']::slotted(*:not(:first-child)) {
            margin-left: 1rem;
          }
        }
      `]}render(){return V`
      <div class="card-wrapper">
        ${this.image||this.imageIcon?V`
              <div class="image-wrapper">
                ${this.image?V` <img src="${this.image}" /> `:""}
                ${this.imageIcon&&!this.image?V`
                      <sh-icon
                        color="rgba(var(--ui-1), var(--opacity-5))"
                        icon="${this.imageIcon}"
                        class="image-icon"
                      ></sh-icon>
                    `:""}
              </div>
            `:""}
        ${this.label?V`
              <div
                class="label-wrapper ${this._emptyFooter?"empty-footer":""} ${this._emptyContent?"empty-content":""}"
              >
                <div class="icon-badge-wrapper">
                  ${this.icon?V`
                        <sh-icon
                          size="${(this.href||this.hasAttribute("href"))&&!this.image&&this._emptyContent?"l":"s"}"
                          icon="${this.icon}"
                          .disabled="${(this.href||this.hasAttribute("href"))&&this.disabled}"
                          .color="${this.iconColor}"
                          class="card-icon ${this._emptyContent?"empty-content":""}"
                        >
                        </sh-icon>
                        ${null!==this.badge&&void 0!==this.badge&&null!==this.href&&void 0!==this.href?V`${"warning"===this.badge||"success"===this.badge||"error"===this.badge?V`<sh-badge class="card-badge" type="${this.badge}"></sh-badge>`:V`<sh-badge
                                  class="card-badge"
                                  label="${this.badge}"
                                ></sh-badge>`}`:""}
                      `:""}
                </div>
                <div class="card-label">${this.label}</div>
                ${this._emptyContent&&this.href?"":V` <slot name="functions"></slot> `}
              </div>
            `:""}
        ${this.href?"":V`
              <div class="header-wrapper ${this._emptyHeader?"empty":""}">
                <slot
                  name="header"
                  @slotchange="${e=>this.updateSlotFlag(e.target,"_emptyHeader")}"
                ></slot>
              </div>
            `}
        <slot
          class="${this._emptyHeader&&!this.label?"empty-header":""} ${this._emptyFooter?"empty-footer":""} ${this._emptyContent?"empty-content":""}"
          @slotchange="${e=>this.updateContentSlotFlag(e.target,"_emptyContent")}"
        ></slot>
        <slot
          name="footer"
          @slotchange="${e=>this.updateSlotFlag(e.target,"_emptyFooter")}"
          class="${this._emptyFooter?"empty":""} ${this._emptyContent?"empty-content":""}"
        ></slot>
      </div>
    `}constructor(){super(),this._emptyFooter=!0,this._emptyHeader=!0,this._emptyContent=!0}attributeChangedCallback(e,t,o){super.attributeChangedCallback(e,t,o)}updated(e){he(this,e,["label","icon","image","cardHeight","disabled"]),e.has("cardHeight")&&this&&(console.warn('You are using a legacy property (cardHeight) of the "sh-card" component. For adjusting the height of the Card please use CSS styles instead.'),this.handleCardHeight())}firstUpdated(){this.addEventListener("click",(()=>{this.href&&(window.location.href=this.href)}))}updateContentSlotFlag(e,t){let o=Array.from(e.assignedNodes()).filter((e=>e.data&&"SH-CHART"!==e.tagName?e.data.trim().split("\n").join("").split(" ").join(""):""));this[t]=0===o.length&&0===e.assignedElements().length}updateSlotFlag(e,t){this[t]=0===e.assignedNodes({flatten:!0}).length}handleCardHeight(){const e=this.shadowRoot.querySelector(".card-wrapper");e.style.minHeight=this.cardHeight,e.style.maxHeight=this.cardHeight}});const Ve=new WeakMap,He=b((e=>t=>{if(!(t instanceof M)||t instanceof R||"style"!==t.committer.name||t.committer.parts.length>1)throw new Error("The `styleMap` directive must be used in the style attribute and must be the only part in the attribute.");const{committer:o}=t,{style:i}=o.element;let r=Ve.get(t);void 0===r&&(i.cssText=o.strings.join(" "),Ve.set(t,r=new Set)),r.forEach((t=>{t in e||(r.delete(t),-1===t.indexOf("-")?i[t]=null:i.removeProperty(t))}));for(const t in e)r.add(t),-1===t.indexOf("-")?i[t]=e[t]:i.setProperty(t,e[t])}));var We,qe,Ye,je,Ue,Ze,Ke,Ge,Xe,Je,Qe;Ue=Object.create,Ze=Object.defineProperty,Ke=Object.getOwnPropertyDescriptor,Ge=Object.getOwnPropertyNames,Xe=Object.getPrototypeOf,Je=Object.prototype.hasOwnProperty,We={"node_modules/smoothscroll-polyfill/dist/smoothscroll.js"(e,t){!function(){function o(){var e=window,t=document;if(!("scrollBehavior"in t.documentElement.style)||!0===e.__forceSmoothScrollPolyfill__){var o,i=e.HTMLElement||e.Element,r={scroll:e.scroll||e.scrollTo,scrollBy:e.scrollBy,elementScroll:i.prototype.scroll||a,scrollIntoView:i.prototype.scrollIntoView},s=e.performance&&e.performance.now?e.performance.now.bind(e.performance):Date.now,n=(o=e.navigator.userAgent,new RegExp(["MSIE ","Trident/","Edge/"].join("|")).test(o)?1:0);e.scroll=e.scrollTo=function(){void 0!==arguments[0]&&(!0!==c(arguments[0])?m.call(e,t.body,void 0!==arguments[0].left?~~arguments[0].left:e.scrollX||e.pageXOffset,void 0!==arguments[0].top?~~arguments[0].top:e.scrollY||e.pageYOffset):r.scroll.call(e,void 0!==arguments[0].left?arguments[0].left:"object"!=typeof arguments[0]?arguments[0]:e.scrollX||e.pageXOffset,void 0!==arguments[0].top?arguments[0].top:void 0!==arguments[1]?arguments[1]:e.scrollY||e.pageYOffset))},e.scrollBy=function(){void 0!==arguments[0]&&(c(arguments[0])?r.scrollBy.call(e,void 0!==arguments[0].left?arguments[0].left:"object"!=typeof arguments[0]?arguments[0]:0,void 0!==arguments[0].top?arguments[0].top:void 0!==arguments[1]?arguments[1]:0):m.call(e,t.body,~~arguments[0].left+(e.scrollX||e.pageXOffset),~~arguments[0].top+(e.scrollY||e.pageYOffset)))},i.prototype.scroll=i.prototype.scrollTo=function(){if(void 0!==arguments[0])if(!0!==c(arguments[0])){var e=arguments[0].left,t=arguments[0].top;m.call(this,this,void 0===e?this.scrollLeft:~~e,void 0===t?this.scrollTop:~~t)}else{if("number"==typeof arguments[0]&&void 0===arguments[1])throw new SyntaxError("Value could not be converted");r.elementScroll.call(this,void 0!==arguments[0].left?~~arguments[0].left:"object"!=typeof arguments[0]?~~arguments[0]:this.scrollLeft,void 0!==arguments[0].top?~~arguments[0].top:void 0!==arguments[1]?~~arguments[1]:this.scrollTop)}},i.prototype.scrollBy=function(){void 0!==arguments[0]&&(!0!==c(arguments[0])?this.scroll({left:~~arguments[0].left+this.scrollLeft,top:~~arguments[0].top+this.scrollTop,behavior:arguments[0].behavior}):r.elementScroll.call(this,void 0!==arguments[0].left?~~arguments[0].left+this.scrollLeft:~~arguments[0]+this.scrollLeft,void 0!==arguments[0].top?~~arguments[0].top+this.scrollTop:~~arguments[1]+this.scrollTop))},i.prototype.scrollIntoView=function(){if(!0!==c(arguments[0])){var o=p(this),i=o.getBoundingClientRect(),s=this.getBoundingClientRect();o!==t.body?(m.call(this,o,o.scrollLeft+s.left-i.left,o.scrollTop+s.top-i.top),"fixed"!==e.getComputedStyle(o).position&&e.scrollBy({left:i.left,top:i.top,behavior:"smooth"})):e.scrollBy({left:s.left,top:s.top,behavior:"smooth"})}else r.scrollIntoView.call(this,void 0===arguments[0]||arguments[0])}}function a(e,t){this.scrollLeft=e,this.scrollTop=t}function c(e){if(null===e||"object"!=typeof e||void 0===e.behavior||"auto"===e.behavior||"instant"===e.behavior)return!0;if("object"==typeof e&&"smooth"===e.behavior)return!1;throw new TypeError("behavior member of ScrollOptions "+e.behavior+" is not a valid value for enumeration ScrollBehavior.")}function l(e,t){return"Y"===t?e.clientHeight+n<e.scrollHeight:"X"===t?e.clientWidth+n<e.scrollWidth:void 0}function h(t,o){var i=e.getComputedStyle(t,null)["overflow"+o];return"auto"===i||"scroll"===i}function d(e){var t=l(e,"Y")&&h(e,"Y"),o=l(e,"X")&&h(e,"X");return t||o}function p(e){for(;e!==t.body&&!1===d(e);)e=e.parentNode||e.host;return e}function u(t){var o,i,r,n,a=(s()-t.startTime)/468;n=a=a>1?1:a,o=.5*(1-Math.cos(Math.PI*n)),i=t.startX+(t.x-t.startX)*o,r=t.startY+(t.y-t.startY)*o,t.method.call(t.scrollable,i,r),i===t.x&&r===t.y||e.requestAnimationFrame(u.bind(e,t))}function m(o,i,n){var c,l,h,d,p=s();o===t.body?(c=e,l=e.scrollX||e.pageXOffset,h=e.scrollY||e.pageYOffset,d=r.scroll):(c=o,l=o.scrollLeft,h=o.scrollTop,d=a),u({scrollable:c,method:d,startTime:p,startX:l,startY:h,x:i,y:n})}}"object"==typeof e&&void 0!==t?t.exports={polyfill:o}:o()}()}},qe||(0,We[Object.keys(We)[0]])((qe={exports:{}}).exports,qe),Ye=qe.exports,Qe=((e,t,o)=>{if(t&&"object"==typeof t||"function"==typeof t)for(let i of Ge(t))Je.call(e,i)||"default"===i||Ze(e,i,{get:()=>t[i],enumerable:!(o=Ke(t,i))||o.enumerable});return e})((je=Ze(null!=Ye?Ue(Xe(Ye)):{},"default",Ye&&Ye.__esModule&&"default"in Ye?{get:()=>Ye.default,enumerable:!0}:{value:Ye,enumerable:!0}),Ze(je,"__esModule",{value:!0})),Ye),window.____smoothscroll=Qe;class et{static enable(){window.____smoothscroll.polyfill()}}const tt=e=>class extends e{throttle(e,t){this.timer||(this.throttleCallback=e,this.delay=t,this.clock=window.requestAnimationFrame(this._clockControl.bind(this)))}_clockControl(){this.timer=setTimeout((()=>{this.timer=void 0,this.throttleCallback()}),this.delay)}disconnectedCallback(){window.cancelAnimationFrame(this.clock),clearTimeout(this.timer),super.disconnectedCallback()}};class ot extends(tt(se)){static get properties(){return{elementWidth:{type:String,reflect:!0,attribute:"element-width"},gap:{type:String,reflect:!0},snap:{type:String,reflect:!0},counter:{type:Boolean,reflect:!0},arrows:{type:Boolean,reflect:!0},_currentItem:{type:Number},_totalSlotElements:{type:Number}}}static get styles(){return[ie`
        :host {
          display: flex;
          position: relative;
          font: var(--body-1);
          width: 100%;
          height: fit-content;
          height: -moz-fit-content;
        }
        slot::-webkit-scrollbar {
          display: none;
        }
        slot {
          display: flex;
          align-items: center;
          scroll-snap-type: x mandatory;
          overflow-x: scroll;
          scroll-behavior: smooth;
          width: 100%;
          height: fit-content;
          scrollbar-width: none;
        }
        ::slotted(*) {
          flex: none;
          width: var(--slot-component-width);
        }
        /* snap */
        :host([snap='start']) ::slotted(*) {
          scroll-snap-align: start;
        }
        :host([snap='end']) ::slotted(*) {
          scroll-snap-align: end;
        }
        :host([snap='center']) ::slotted(*) {
          scroll-snap-align: center;
        }
        /* counter */
        .counter {
          position: absolute;
          bottom: 0.25rem;
          left: 50%;
          transform: translateX(-50%);
          border-radius: 0.125rem;
          line-height: 1rem;
          color: var(--text-primary);
        }
        /* arrow */
        .arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          border-radius: 50%;
          transition: 0.2s all ease-in-out;
        }
        /* temp */
        .arrow,
        .counter {
          padding: 0.25rem;
          background: rgba(var(--ui-7), var(--opacity-3));
        }
        .arrow:hover {
          background: rgba(var(--ui-7), var(--opacity-2));
        }
        .arrow.left {
          left: 0.5rem;
        }
        .arrow.right {
          right: 0.5rem;
        }
      `]}render(){return V`
      <slot
        style="${He(this._getDimentionStyles())}"
        @scroll="${this._throttleScroll}"
        @slotchange="${e=>this._handleScrollIfEmpty(e.target)}"
      ></slot>
      ${this.counter?V` <div class="counter">${this._currentItem} / ${this._totalSlotElements}</div> `:""}
      ${this.arrows?V`
            <sh-icon
              button
              icon="arrow-left-s"
              size="s"
              class="arrow left"
              @click="${()=>this._scrollToItem(this._currentItem-1)}"
            ></sh-icon>

            <sh-icon
              button
              icon="arrow-right-s"
              size="s"
              class="arrow right"
              @click="${()=>this._scrollToItem(this._currentItem+1)}"
            ></sh-icon>
          `:""}
    `}constructor(){super(),this.gap="0.5rem",this.elementWidth="30%",this.snap="start",this._currentItem=1,this._totalSlotElements=0}connectedCallback(){super.connectedCallback(),et.enable()}updated(e){e.has("snap")&&this.arrows&&(this.snap="start"),e.has("arrows")&&this.arrows&&"start"!==this.snap&&(this.snap="start")}_handleScrollIfEmpty(e){0!==e.assignedElements({flatten:!0}).length&&(this._totalSlotElements=this.children.length,this._handleScroll())}_getDimentionStyles(){return{"--slot-component-width":this.elementWidth,gap:this.gap}}_handleScroll(){const e=this.shadowRoot.querySelector("slot");this._currentItem=Math.floor(e.scrollLeft/(this.children[0].clientWidth+parseInt(this.gap))+1)}_scrollToItem(e){0===e&&(e=1);const t=this.children[e-1];null==t||t.scrollIntoView({block:"nearest",inline:this.snap})}_throttleScroll(){this.throttle(this._handleScroll.bind(this),50)}}customElements.define("sh-carousel",ot),(()=>{var e=Object.create,t=Object.defineProperty,o=Object.getOwnPropertyDescriptor,i=Object.getOwnPropertyNames,r=Object.getPrototypeOf,s=Object.prototype.hasOwnProperty,n=(e=>"undefined"!=typeof require?require:"undefined"!=typeof Proxy?new Proxy(e,{get:(e,t)=>("undefined"!=typeof require?require:e)[t]}):e)((function(e){if("undefined"!=typeof require)return require.apply(this,arguments);throw new Error('Dynamic require of "'+e+'" is not supported')})),a=(e,t)=>function(){return t||(0,e[Object.keys(e)[0]])((t={exports:{}}).exports,t),t.exports},c=n=>((e,r,n)=>{if(r&&"object"==typeof r||"function"==typeof r)for(let a of i(r))s.call(e,a)||"default"===a||t(e,a,{get:()=>r[a],enumerable:!(n=o(r,a))||n.enumerable});return e})((e=>t(e,"__esModule",{value:!0}))(t(null!=n?e(r(n)):{},"default",n&&n.__esModule&&"default"in n?{get:()=>n.default,enumerable:!0}:{value:n,enumerable:!0})),n),l=a({"node_modules/chart.js/node_modules/moment/moment.js"(e,t){var o,i;o=e,i=function(){var e,o;function i(){return e.apply(null,arguments)}function r(e){return e instanceof Array||"[object Array]"===Object.prototype.toString.call(e)}function s(e){return null!=e&&"[object Object]"===Object.prototype.toString.call(e)}function a(e,t){return Object.prototype.hasOwnProperty.call(e,t)}function c(e){if(Object.getOwnPropertyNames)return 0===Object.getOwnPropertyNames(e).length;var t;for(t in e)if(a(e,t))return!1;return!0}function l(e){return void 0===e}function h(e){return"number"==typeof e||"[object Number]"===Object.prototype.toString.call(e)}function d(e){return e instanceof Date||"[object Date]"===Object.prototype.toString.call(e)}function p(e,t){var o,i=[],r=e.length;for(o=0;o<r;++o)i.push(t(e[o],o));return i}function u(e,t){for(var o in t)a(t,o)&&(e[o]=t[o]);return a(t,"toString")&&(e.toString=t.toString),a(t,"valueOf")&&(e.valueOf=t.valueOf),e}function m(e,t,o,i){return Et(e,t,o,i,!0).utc()}function f(e){return null==e._pf&&(e._pf={empty:!1,unusedTokens:[],unusedInput:[],overflow:-2,charsLeftOver:0,nullInput:!1,invalidEra:null,invalidMonth:null,invalidFormat:!1,userInvalidated:!1,iso:!1,parsedDateParts:[],era:null,meridiem:null,rfc2822:!1,weekdayMismatch:!1}),e._pf}function g(e){if(null==e._isValid){var t=f(e),i=o.call(t.parsedDateParts,(function(e){return null!=e})),r=!isNaN(e._d.getTime())&&t.overflow<0&&!t.empty&&!t.invalidEra&&!t.invalidMonth&&!t.invalidWeekday&&!t.weekdayMismatch&&!t.nullInput&&!t.invalidFormat&&!t.userInvalidated&&(!t.meridiem||t.meridiem&&i);if(e._strict&&(r=r&&0===t.charsLeftOver&&0===t.unusedTokens.length&&void 0===t.bigHour),null!=Object.isFrozen&&Object.isFrozen(e))return r;e._isValid=r}return e._isValid}function b(e){var t=m(NaN);return null!=e?u(f(t),e):f(t).userInvalidated=!0,t}o=Array.prototype.some?Array.prototype.some:function(e){var t,o=Object(this),i=o.length>>>0;for(t=0;t<i;t++)if(t in o&&e.call(this,o[t],t,o))return!0;return!1};var v=i.momentProperties=[],y=!1;function w(e,t){var o,i,r,s=v.length;if(l(t._isAMomentObject)||(e._isAMomentObject=t._isAMomentObject),l(t._i)||(e._i=t._i),l(t._f)||(e._f=t._f),l(t._l)||(e._l=t._l),l(t._strict)||(e._strict=t._strict),l(t._tzm)||(e._tzm=t._tzm),l(t._isUTC)||(e._isUTC=t._isUTC),l(t._offset)||(e._offset=t._offset),l(t._pf)||(e._pf=f(t)),l(t._locale)||(e._locale=t._locale),s>0)for(o=0;o<s;o++)l(r=t[i=v[o]])||(e[i]=r);return e}function x(e){w(this,e),this._d=new Date(null!=e._d?e._d.getTime():NaN),this.isValid()||(this._d=new Date(NaN)),!1===y&&(y=!0,i.updateOffset(this),y=!1)}function _(e){return e instanceof x||null!=e&&null!=e._isAMomentObject}function k(e){!1===i.suppressDeprecationWarnings&&"undefined"!=typeof console&&console.warn&&console.warn("Deprecation warning: "+e)}function C(e,t){var o=!0;return u((function(){if(null!=i.deprecationHandler&&i.deprecationHandler(null,e),o){var r,s,n,c=[],l=arguments.length;for(s=0;s<l;s++){if(r="","object"==typeof arguments[s]){for(n in r+="\n["+s+"] ",arguments[0])a(arguments[0],n)&&(r+=n+": "+arguments[0][n]+", ");r=r.slice(0,-2)}else r=arguments[s];c.push(r)}k(e+"\nArguments: "+Array.prototype.slice.call(c).join("")+"\n"+(new Error).stack),o=!1}return t.apply(this,arguments)}),t)}var E,z={};function A(e,t){null!=i.deprecationHandler&&i.deprecationHandler(e,t),z[e]||(k(t),z[e]=!0)}function S(e){return"undefined"!=typeof Function&&e instanceof Function||"[object Function]"===Object.prototype.toString.call(e)}function M(e,t){var o,i=u({},e);for(o in t)a(t,o)&&(s(e[o])&&s(t[o])?(i[o]={},u(i[o],e[o]),u(i[o],t[o])):null!=t[o]?i[o]=t[o]:delete i[o]);for(o in e)a(e,o)&&!a(t,o)&&s(e[o])&&(i[o]=u({},i[o]));return i}function D(e){null!=e&&this.set(e)}function B(e,t,o){var i=""+Math.abs(e),r=t-i.length;return(e>=0?o?"+":"":"-")+Math.pow(10,Math.max(0,r)).toString().substr(1)+i}i.suppressDeprecationWarnings=!1,i.deprecationHandler=null,E=Object.keys?Object.keys:function(e){var t,o=[];for(t in e)a(e,t)&&o.push(t);return o};var T=/(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,R=/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,L={},P={};function O(e,t,o,i){var r=i;"string"==typeof i&&(r=function(){return this[i]()}),e&&(P[e]=r),t&&(P[t[0]]=function(){return B(r.apply(this,arguments),t[1],t[2])}),o&&(P[o]=function(){return this.localeData().ordinal(r.apply(this,arguments),e)})}function N(e,t){return e.isValid()?(t=F(t,e.localeData()),L[t]=L[t]||function(e){var t,o,i,r=e.match(T);for(t=0,o=r.length;t<o;t++)P[r[t]]?r[t]=P[r[t]]:r[t]=(i=r[t]).match(/\[[\s\S]/)?i.replace(/^\[|\]$/g,""):i.replace(/\\/g,"");return function(t){var i,s="";for(i=0;i<o;i++)s+=S(r[i])?r[i].call(t,e):r[i];return s}}(t),L[t](e)):e.localeData().invalidDate()}function F(e,t){var o=5;function i(e){return t.longDateFormat(e)||e}for(R.lastIndex=0;o>=0&&R.test(e);)e=e.replace(R,i),R.lastIndex=0,o-=1;return e}var $={};function I(e,t){var o=e.toLowerCase();$[o]=$[o+"s"]=$[t]=e}function V(e){return"string"==typeof e?$[e]||$[e.toLowerCase()]:void 0}function H(e){var t,o,i={};for(o in e)a(e,o)&&(t=V(o))&&(i[t]=e[o]);return i}var W={};function q(e,t){W[e]=t}function Y(e){return e%4==0&&e%100!=0||e%400==0}function j(e){return e<0?Math.ceil(e)||0:Math.floor(e)}function U(e){var t=+e,o=0;return 0!==t&&isFinite(t)&&(o=j(t)),o}function Z(e,t){return function(o){return null!=o?(G(this,e,o),i.updateOffset(this,t),this):K(this,e)}}function K(e,t){return e.isValid()?e._d["get"+(e._isUTC?"UTC":"")+t]():NaN}function G(e,t,o){e.isValid()&&!isNaN(o)&&("FullYear"===t&&Y(e.year())&&1===e.month()&&29===e.date()?(o=U(o),e._d["set"+(e._isUTC?"UTC":"")+t](o,e.month(),_e(o,e.month()))):e._d["set"+(e._isUTC?"UTC":"")+t](o))}var X,J=/\d/,Q=/\d\d/,ee=/\d{3}/,te=/\d{4}/,oe=/[+-]?\d{6}/,ie=/\d\d?/,re=/\d\d\d\d?/,se=/\d\d\d\d\d\d?/,ne=/\d{1,3}/,ae=/\d{1,4}/,ce=/[+-]?\d{1,6}/,le=/\d+/,he=/[+-]?\d+/,de=/Z|[+-]\d\d:?\d\d/gi,pe=/Z|[+-]\d\d(?::?\d\d)?/gi,ue=/[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;function me(e,t,o){X[e]=S(t)?t:function(e,i){return e&&o?o:t}}function fe(e,t){return a(X,e)?X[e](t._strict,t._locale):new RegExp(ge(e.replace("\\","").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,(function(e,t,o,i,r){return t||o||i||r}))))}function ge(e){return e.replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&")}X={};var be,ve={};function ye(e,t){var o,i,r=t;for("string"==typeof e&&(e=[e]),h(t)&&(r=function(e,o){o[t]=U(e)}),i=e.length,o=0;o<i;o++)ve[e[o]]=r}function we(e,t){ye(e,(function(e,o,i,r){i._w=i._w||{},t(e,i._w,i,r)}))}function xe(e,t,o){null!=t&&a(ve,e)&&ve[e](t,o._a,o,e)}function _e(e,t){if(isNaN(e)||isNaN(t))return NaN;var o=(t%12+12)%12;return e+=(t-o)/12,1===o?Y(e)?29:28:31-o%7%2}be=Array.prototype.indexOf?Array.prototype.indexOf:function(e){var t;for(t=0;t<this.length;++t)if(this[t]===e)return t;return-1},O("M",["MM",2],"Mo",(function(){return this.month()+1})),O("MMM",0,0,(function(e){return this.localeData().monthsShort(this,e)})),O("MMMM",0,0,(function(e){return this.localeData().months(this,e)})),I("month","M"),q("month",8),me("M",ie),me("MM",ie,Q),me("MMM",(function(e,t){return t.monthsShortRegex(e)})),me("MMMM",(function(e,t){return t.monthsRegex(e)})),ye(["M","MM"],(function(e,t){t[1]=U(e)-1})),ye(["MMM","MMMM"],(function(e,t,o,i){var r=o._locale.monthsParse(e,i,o._strict);null!=r?t[1]=r:f(o).invalidMonth=e}));var ke="January_February_March_April_May_June_July_August_September_October_November_December".split("_"),Ce="Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),Ee=/D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,ze=ue,Ae=ue;function Se(e,t,o){var i,r,s,n=e.toLocaleLowerCase();if(!this._monthsParse)for(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[],i=0;i<12;++i)s=m([2e3,i]),this._shortMonthsParse[i]=this.monthsShort(s,"").toLocaleLowerCase(),this._longMonthsParse[i]=this.months(s,"").toLocaleLowerCase();return o?"MMM"===t?-1!==(r=be.call(this._shortMonthsParse,n))?r:null:-1!==(r=be.call(this._longMonthsParse,n))?r:null:"MMM"===t?-1!==(r=be.call(this._shortMonthsParse,n))||-1!==(r=be.call(this._longMonthsParse,n))?r:null:-1!==(r=be.call(this._longMonthsParse,n))||-1!==(r=be.call(this._shortMonthsParse,n))?r:null}function Me(e,t){var o;if(!e.isValid())return e;if("string"==typeof t)if(/^\d+$/.test(t))t=U(t);else if(!h(t=e.localeData().monthsParse(t)))return e;return o=Math.min(e.date(),_e(e.year(),t)),e._d["set"+(e._isUTC?"UTC":"")+"Month"](t,o),e}function De(e){return null!=e?(Me(this,e),i.updateOffset(this,!0),this):K(this,"Month")}function Be(){function e(e,t){return t.length-e.length}var t,o,i=[],r=[],s=[];for(t=0;t<12;t++)o=m([2e3,t]),i.push(this.monthsShort(o,"")),r.push(this.months(o,"")),s.push(this.months(o,"")),s.push(this.monthsShort(o,""));for(i.sort(e),r.sort(e),s.sort(e),t=0;t<12;t++)i[t]=ge(i[t]),r[t]=ge(r[t]);for(t=0;t<24;t++)s[t]=ge(s[t]);this._monthsRegex=new RegExp("^("+s.join("|")+")","i"),this._monthsShortRegex=this._monthsRegex,this._monthsStrictRegex=new RegExp("^("+r.join("|")+")","i"),this._monthsShortStrictRegex=new RegExp("^("+i.join("|")+")","i")}function Te(e){return Y(e)?366:365}O("Y",0,0,(function(){var e=this.year();return e<=9999?B(e,4):"+"+e})),O(0,["YY",2],0,(function(){return this.year()%100})),O(0,["YYYY",4],0,"year"),O(0,["YYYYY",5],0,"year"),O(0,["YYYYYY",6,!0],0,"year"),I("year","y"),q("year",1),me("Y",he),me("YY",ie,Q),me("YYYY",ae,te),me("YYYYY",ce,oe),me("YYYYYY",ce,oe),ye(["YYYYY","YYYYYY"],0),ye("YYYY",(function(e,t){t[0]=2===e.length?i.parseTwoDigitYear(e):U(e)})),ye("YY",(function(e,t){t[0]=i.parseTwoDigitYear(e)})),ye("Y",(function(e,t){t[0]=parseInt(e,10)})),i.parseTwoDigitYear=function(e){return U(e)+(U(e)>68?1900:2e3)};var Re=Z("FullYear",!0);function Le(e,t,o,i,r,s,n){var a;return e<100&&e>=0?(a=new Date(e+400,t,o,i,r,s,n),isFinite(a.getFullYear())&&a.setFullYear(e)):a=new Date(e,t,o,i,r,s,n),a}function Pe(e){var t,o;return e<100&&e>=0?((o=Array.prototype.slice.call(arguments))[0]=e+400,t=new Date(Date.UTC.apply(null,o)),isFinite(t.getUTCFullYear())&&t.setUTCFullYear(e)):t=new Date(Date.UTC.apply(null,arguments)),t}function Oe(e,t,o){var i=7+t-o;return-(7+Pe(e,0,i).getUTCDay()-t)%7+i-1}function Ne(e,t,o,i,r){var s,n,a=1+7*(t-1)+(7+o-i)%7+Oe(e,i,r);return a<=0?n=Te(s=e-1)+a:a>Te(e)?(s=e+1,n=a-Te(e)):(s=e,n=a),{year:s,dayOfYear:n}}function Fe(e,t,o){var i,r,s=Oe(e.year(),t,o),n=Math.floor((e.dayOfYear()-s-1)/7)+1;return n<1?i=n+$e(r=e.year()-1,t,o):n>$e(e.year(),t,o)?(i=n-$e(e.year(),t,o),r=e.year()+1):(r=e.year(),i=n),{week:i,year:r}}function $e(e,t,o){var i=Oe(e,t,o),r=Oe(e+1,t,o);return(Te(e)-i+r)/7}function Ie(e,t){return e.slice(t,7).concat(e.slice(0,t))}O("w",["ww",2],"wo","week"),O("W",["WW",2],"Wo","isoWeek"),I("week","w"),I("isoWeek","W"),q("week",5),q("isoWeek",5),me("w",ie),me("ww",ie,Q),me("W",ie),me("WW",ie,Q),we(["w","ww","W","WW"],(function(e,t,o,i){t[i.substr(0,1)]=U(e)})),O("d",0,"do","day"),O("dd",0,0,(function(e){return this.localeData().weekdaysMin(this,e)})),O("ddd",0,0,(function(e){return this.localeData().weekdaysShort(this,e)})),O("dddd",0,0,(function(e){return this.localeData().weekdays(this,e)})),O("e",0,0,"weekday"),O("E",0,0,"isoWeekday"),I("day","d"),I("weekday","e"),I("isoWeekday","E"),q("day",11),q("weekday",11),q("isoWeekday",11),me("d",ie),me("e",ie),me("E",ie),me("dd",(function(e,t){return t.weekdaysMinRegex(e)})),me("ddd",(function(e,t){return t.weekdaysShortRegex(e)})),me("dddd",(function(e,t){return t.weekdaysRegex(e)})),we(["dd","ddd","dddd"],(function(e,t,o,i){var r=o._locale.weekdaysParse(e,i,o._strict);null!=r?t.d=r:f(o).invalidWeekday=e})),we(["d","e","E"],(function(e,t,o,i){t[i]=U(e)}));var Ve="Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),He="Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),We="Su_Mo_Tu_We_Th_Fr_Sa".split("_"),qe=ue,Ye=ue,je=ue;function Ue(e,t,o){var i,r,s,n=e.toLocaleLowerCase();if(!this._weekdaysParse)for(this._weekdaysParse=[],this._shortWeekdaysParse=[],this._minWeekdaysParse=[],i=0;i<7;++i)s=m([2e3,1]).day(i),this._minWeekdaysParse[i]=this.weekdaysMin(s,"").toLocaleLowerCase(),this._shortWeekdaysParse[i]=this.weekdaysShort(s,"").toLocaleLowerCase(),this._weekdaysParse[i]=this.weekdays(s,"").toLocaleLowerCase();return o?"dddd"===t?-1!==(r=be.call(this._weekdaysParse,n))?r:null:"ddd"===t?-1!==(r=be.call(this._shortWeekdaysParse,n))?r:null:-1!==(r=be.call(this._minWeekdaysParse,n))?r:null:"dddd"===t?-1!==(r=be.call(this._weekdaysParse,n))||-1!==(r=be.call(this._shortWeekdaysParse,n))||-1!==(r=be.call(this._minWeekdaysParse,n))?r:null:"ddd"===t?-1!==(r=be.call(this._shortWeekdaysParse,n))||-1!==(r=be.call(this._weekdaysParse,n))||-1!==(r=be.call(this._minWeekdaysParse,n))?r:null:-1!==(r=be.call(this._minWeekdaysParse,n))||-1!==(r=be.call(this._weekdaysParse,n))||-1!==(r=be.call(this._shortWeekdaysParse,n))?r:null}function Ze(){function e(e,t){return t.length-e.length}var t,o,i,r,s,n=[],a=[],c=[],l=[];for(t=0;t<7;t++)o=m([2e3,1]).day(t),i=ge(this.weekdaysMin(o,"")),r=ge(this.weekdaysShort(o,"")),s=ge(this.weekdays(o,"")),n.push(i),a.push(r),c.push(s),l.push(i),l.push(r),l.push(s);n.sort(e),a.sort(e),c.sort(e),l.sort(e),this._weekdaysRegex=new RegExp("^("+l.join("|")+")","i"),this._weekdaysShortRegex=this._weekdaysRegex,this._weekdaysMinRegex=this._weekdaysRegex,this._weekdaysStrictRegex=new RegExp("^("+c.join("|")+")","i"),this._weekdaysShortStrictRegex=new RegExp("^("+a.join("|")+")","i"),this._weekdaysMinStrictRegex=new RegExp("^("+n.join("|")+")","i")}function Ke(){return this.hours()%12||12}function Ge(e,t){O(e,0,0,(function(){return this.localeData().meridiem(this.hours(),this.minutes(),t)}))}function Xe(e,t){return t._meridiemParse}O("H",["HH",2],0,"hour"),O("h",["hh",2],0,Ke),O("k",["kk",2],0,(function(){return this.hours()||24})),O("hmm",0,0,(function(){return""+Ke.apply(this)+B(this.minutes(),2)})),O("hmmss",0,0,(function(){return""+Ke.apply(this)+B(this.minutes(),2)+B(this.seconds(),2)})),O("Hmm",0,0,(function(){return""+this.hours()+B(this.minutes(),2)})),O("Hmmss",0,0,(function(){return""+this.hours()+B(this.minutes(),2)+B(this.seconds(),2)})),Ge("a",!0),Ge("A",!1),I("hour","h"),q("hour",13),me("a",Xe),me("A",Xe),me("H",ie),me("h",ie),me("k",ie),me("HH",ie,Q),me("hh",ie,Q),me("kk",ie,Q),me("hmm",re),me("hmmss",se),me("Hmm",re),me("Hmmss",se),ye(["H","HH"],3),ye(["k","kk"],(function(e,t,o){var i=U(e);t[3]=24===i?0:i})),ye(["a","A"],(function(e,t,o){o._isPm=o._locale.isPM(e),o._meridiem=e})),ye(["h","hh"],(function(e,t,o){t[3]=U(e),f(o).bigHour=!0})),ye("hmm",(function(e,t,o){var i=e.length-2;t[3]=U(e.substr(0,i)),t[4]=U(e.substr(i)),f(o).bigHour=!0})),ye("hmmss",(function(e,t,o){var i=e.length-4,r=e.length-2;t[3]=U(e.substr(0,i)),t[4]=U(e.substr(i,2)),t[5]=U(e.substr(r)),f(o).bigHour=!0})),ye("Hmm",(function(e,t,o){var i=e.length-2;t[3]=U(e.substr(0,i)),t[4]=U(e.substr(i))})),ye("Hmmss",(function(e,t,o){var i=e.length-4,r=e.length-2;t[3]=U(e.substr(0,i)),t[4]=U(e.substr(i,2)),t[5]=U(e.substr(r))}));var Je,Qe=Z("Hours",!0),et={calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},longDateFormat:{LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},invalidDate:"Invalid date",ordinal:"%d",dayOfMonthOrdinalParse:/\d{1,2}/,relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",w:"a week",ww:"%d weeks",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},months:ke,monthsShort:Ce,week:{dow:0,doy:6},weekdays:Ve,weekdaysMin:We,weekdaysShort:He,meridiemParse:/[ap]\.?m?\.?/i},tt={},ot={};function it(e,t){var o,i=Math.min(e.length,t.length);for(o=0;o<i;o+=1)if(e[o]!==t[o])return o;return i}function rt(e){return e?e.toLowerCase().replace("_","-"):e}function st(e){var o=null;if(void 0===tt[e]&&void 0!==t&&t&&t.exports&&function(e){return null!=e.match("^[^/\\\\]*$")}(e))try{o=Je._abbr,n("./locale/"+e),nt(o)}catch(t){tt[e]=null}return tt[e]}function nt(e,t){var o;return e&&((o=l(t)?ct(e):at(e,t))?Je=o:"undefined"!=typeof console&&console.warn&&console.warn("Locale "+e+" not found. Did you forget to load it?")),Je._abbr}function at(e,t){if(null!==t){var o,i=et;if(t.abbr=e,null!=tt[e])A("defineLocaleOverride","use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."),i=tt[e]._config;else if(null!=t.parentLocale)if(null!=tt[t.parentLocale])i=tt[t.parentLocale]._config;else{if(null==(o=st(t.parentLocale)))return ot[t.parentLocale]||(ot[t.parentLocale]=[]),ot[t.parentLocale].push({name:e,config:t}),null;i=o._config}return tt[e]=new D(M(i,t)),ot[e]&&ot[e].forEach((function(e){at(e.name,e.config)})),nt(e),tt[e]}return delete tt[e],null}function ct(e){var t;if(e&&e._locale&&e._locale._abbr&&(e=e._locale._abbr),!e)return Je;if(!r(e)){if(t=st(e))return t;e=[e]}return function(e){for(var t,o,i,r,s=0;s<e.length;){for(t=(r=rt(e[s]).split("-")).length,o=(o=rt(e[s+1]))?o.split("-"):null;t>0;){if(i=st(r.slice(0,t).join("-")))return i;if(o&&o.length>=t&&it(r,o)>=t-1)break;t--}s++}return Je}(e)}function lt(e){var t,o=e._a;return o&&-2===f(e).overflow&&(t=o[1]<0||o[1]>11?1:o[2]<1||o[2]>_e(o[0],o[1])?2:o[3]<0||o[3]>24||24===o[3]&&(0!==o[4]||0!==o[5]||0!==o[6])?3:o[4]<0||o[4]>59?4:o[5]<0||o[5]>59?5:o[6]<0||o[6]>999?6:-1,f(e)._overflowDayOfYear&&(t<0||t>2)&&(t=2),f(e)._overflowWeeks&&-1===t&&(t=7),f(e)._overflowWeekday&&-1===t&&(t=8),f(e).overflow=t),e}var ht=/^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,dt=/^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,pt=/Z|[+-]\d\d(?::?\d\d)?/,ut=[["YYYYYY-MM-DD",/[+-]\d{6}-\d\d-\d\d/],["YYYY-MM-DD",/\d{4}-\d\d-\d\d/],["GGGG-[W]WW-E",/\d{4}-W\d\d-\d/],["GGGG-[W]WW",/\d{4}-W\d\d/,!1],["YYYY-DDD",/\d{4}-\d{3}/],["YYYY-MM",/\d{4}-\d\d/,!1],["YYYYYYMMDD",/[+-]\d{10}/],["YYYYMMDD",/\d{8}/],["GGGG[W]WWE",/\d{4}W\d{3}/],["GGGG[W]WW",/\d{4}W\d{2}/,!1],["YYYYDDD",/\d{7}/],["YYYYMM",/\d{6}/,!1],["YYYY",/\d{4}/,!1]],mt=[["HH:mm:ss.SSSS",/\d\d:\d\d:\d\d\.\d+/],["HH:mm:ss,SSSS",/\d\d:\d\d:\d\d,\d+/],["HH:mm:ss",/\d\d:\d\d:\d\d/],["HH:mm",/\d\d:\d\d/],["HHmmss.SSSS",/\d\d\d\d\d\d\.\d+/],["HHmmss,SSSS",/\d\d\d\d\d\d,\d+/],["HHmmss",/\d\d\d\d\d\d/],["HHmm",/\d\d\d\d/],["HH",/\d\d/]],ft=/^\/?Date\((-?\d+)/i,gt=/^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,bt={UT:0,GMT:0,EDT:-240,EST:-300,CDT:-300,CST:-360,MDT:-360,MST:-420,PDT:-420,PST:-480};function vt(e){var t,o,i,r,s,n,a=e._i,c=ht.exec(a)||dt.exec(a),l=ut.length,h=mt.length;if(c){for(f(e).iso=!0,t=0,o=l;t<o;t++)if(ut[t][1].exec(c[1])){r=ut[t][0],i=!1!==ut[t][2];break}if(null==r)return void(e._isValid=!1);if(c[3]){for(t=0,o=h;t<o;t++)if(mt[t][1].exec(c[3])){s=(c[2]||" ")+mt[t][0];break}if(null==s)return void(e._isValid=!1)}if(!i&&null!=s)return void(e._isValid=!1);if(c[4]){if(!pt.exec(c[4]))return void(e._isValid=!1);n="Z"}e._f=r+(s||"")+(n||""),kt(e)}else e._isValid=!1}function yt(e){var t=parseInt(e,10);return t<=49?2e3+t:t<=999?1900+t:t}function wt(e){var t,o,i,r,s,n,a,c,l=gt.exec(e._i.replace(/\([^()]*\)|[\n\t]/g," ").replace(/(\s\s+)/g," ").replace(/^\s\s*/,"").replace(/\s\s*$/,""));if(l){if(o=l[4],i=l[3],r=l[2],s=l[5],n=l[6],a=l[7],c=[yt(o),Ce.indexOf(i),parseInt(r,10),parseInt(s,10),parseInt(n,10)],a&&c.push(parseInt(a,10)),t=c,!function(e,t,o){return!e||He.indexOf(e)===new Date(t[0],t[1],t[2]).getDay()||(f(o).weekdayMismatch=!0,o._isValid=!1,!1)}(l[1],t,e))return;e._a=t,e._tzm=function(e,t,o){if(e)return bt[e];if(t)return 0;var i=parseInt(o,10),r=i%100;return(i-r)/100*60+r}(l[8],l[9],l[10]),e._d=Pe.apply(null,e._a),e._d.setUTCMinutes(e._d.getUTCMinutes()-e._tzm),f(e).rfc2822=!0}else e._isValid=!1}function xt(e,t,o){return null!=e?e:null!=t?t:o}function _t(e){var t,o,r,s,n,a=[];if(!e._d){for(r=function(e){var t=new Date(i.now());return e._useUTC?[t.getUTCFullYear(),t.getUTCMonth(),t.getUTCDate()]:[t.getFullYear(),t.getMonth(),t.getDate()]}(e),e._w&&null==e._a[2]&&null==e._a[1]&&function(e){var t,o,i,r,s,n,a,c,l;null!=(t=e._w).GG||null!=t.W||null!=t.E?(s=1,n=4,o=xt(t.GG,e._a[0],Fe(zt(),1,4).year),i=xt(t.W,1),((r=xt(t.E,1))<1||r>7)&&(c=!0)):(s=e._locale._week.dow,n=e._locale._week.doy,l=Fe(zt(),s,n),o=xt(t.gg,e._a[0],l.year),i=xt(t.w,l.week),null!=t.d?((r=t.d)<0||r>6)&&(c=!0):null!=t.e?(r=t.e+s,(t.e<0||t.e>6)&&(c=!0)):r=s),i<1||i>$e(o,s,n)?f(e)._overflowWeeks=!0:null!=c?f(e)._overflowWeekday=!0:(a=Ne(o,i,r,s,n),e._a[0]=a.year,e._dayOfYear=a.dayOfYear)}(e),null!=e._dayOfYear&&(n=xt(e._a[0],r[0]),(e._dayOfYear>Te(n)||0===e._dayOfYear)&&(f(e)._overflowDayOfYear=!0),o=Pe(n,0,e._dayOfYear),e._a[1]=o.getUTCMonth(),e._a[2]=o.getUTCDate()),t=0;t<3&&null==e._a[t];++t)e._a[t]=a[t]=r[t];for(;t<7;t++)e._a[t]=a[t]=null==e._a[t]?2===t?1:0:e._a[t];24===e._a[3]&&0===e._a[4]&&0===e._a[5]&&0===e._a[6]&&(e._nextDay=!0,e._a[3]=0),e._d=(e._useUTC?Pe:Le).apply(null,a),s=e._useUTC?e._d.getUTCDay():e._d.getDay(),null!=e._tzm&&e._d.setUTCMinutes(e._d.getUTCMinutes()-e._tzm),e._nextDay&&(e._a[3]=24),e._w&&void 0!==e._w.d&&e._w.d!==s&&(f(e).weekdayMismatch=!0)}}function kt(e){if(e._f!==i.ISO_8601)if(e._f!==i.RFC_2822){e._a=[],f(e).empty=!0;var t,o,r,s,n,a,c,l=""+e._i,h=l.length,d=0;for(c=(r=F(e._f,e._locale).match(T)||[]).length,t=0;t<c;t++)s=r[t],(o=(l.match(fe(s,e))||[])[0])&&((n=l.substr(0,l.indexOf(o))).length>0&&f(e).unusedInput.push(n),l=l.slice(l.indexOf(o)+o.length),d+=o.length),P[s]?(o?f(e).empty=!1:f(e).unusedTokens.push(s),xe(s,o,e)):e._strict&&!o&&f(e).unusedTokens.push(s);f(e).charsLeftOver=h-d,l.length>0&&f(e).unusedInput.push(l),e._a[3]<=12&&!0===f(e).bigHour&&e._a[3]>0&&(f(e).bigHour=void 0),f(e).parsedDateParts=e._a.slice(0),f(e).meridiem=e._meridiem,e._a[3]=(p=e._locale,u=e._a[3],null==(m=e._meridiem)?u:null!=p.meridiemHour?p.meridiemHour(u,m):null!=p.isPM?((g=p.isPM(m))&&u<12&&(u+=12),g||12!==u||(u=0),u):u),null!==(a=f(e).era)&&(e._a[0]=e._locale.erasConvertYear(a,e._a[0])),_t(e),lt(e)}else wt(e);else vt(e);var p,u,m,g}function Ct(e){var t=e._i,o=e._f;return e._locale=e._locale||ct(e._l),null===t||void 0===o&&""===t?b({nullInput:!0}):("string"==typeof t&&(e._i=t=e._locale.preparse(t)),_(t)?new x(lt(t)):(d(t)?e._d=t:r(o)?function(e){var t,o,i,r,s,n,a=!1,c=e._f.length;if(0===c)return f(e).invalidFormat=!0,void(e._d=new Date(NaN));for(r=0;r<c;r++)s=0,n=!1,t=w({},e),null!=e._useUTC&&(t._useUTC=e._useUTC),t._f=e._f[r],kt(t),g(t)&&(n=!0),s+=f(t).charsLeftOver,s+=10*f(t).unusedTokens.length,f(t).score=s,a?s<i&&(i=s,o=t):(null==i||s<i||n)&&(i=s,o=t,n&&(a=!0));u(e,o||t)}(e):o?kt(e):function(e){var t=e._i;l(t)?e._d=new Date(i.now()):d(t)?e._d=new Date(t.valueOf()):"string"==typeof t?function(e){var t=ft.exec(e._i);null===t?(vt(e),!1===e._isValid&&(delete e._isValid,wt(e),!1===e._isValid&&(delete e._isValid,e._strict?e._isValid=!1:i.createFromInputFallback(e)))):e._d=new Date(+t[1])}(e):r(t)?(e._a=p(t.slice(0),(function(e){return parseInt(e,10)})),_t(e)):s(t)?function(e){if(!e._d){var t=H(e._i),o=void 0===t.day?t.date:t.day;e._a=p([t.year,t.month,o,t.hour,t.minute,t.second,t.millisecond],(function(e){return e&&parseInt(e,10)})),_t(e)}}(e):h(t)?e._d=new Date(t):i.createFromInputFallback(e)}(e),g(e)||(e._d=null),e))}function Et(e,t,o,i,n){var a,l={};return!0!==t&&!1!==t||(i=t,t=void 0),!0!==o&&!1!==o||(i=o,o=void 0),(s(e)&&c(e)||r(e)&&0===e.length)&&(e=void 0),l._isAMomentObject=!0,l._useUTC=l._isUTC=n,l._l=o,l._i=e,l._f=t,l._strict=i,(a=new x(lt(Ct(l))))._nextDay&&(a.add(1,"d"),a._nextDay=void 0),a}function zt(e,t,o,i){return Et(e,t,o,i,!1)}i.createFromInputFallback=C("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",(function(e){e._d=new Date(e._i+(e._useUTC?" UTC":""))})),i.ISO_8601=function(){},i.RFC_2822=function(){};var At=C("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",(function(){var e=zt.apply(null,arguments);return this.isValid()&&e.isValid()?e<this?this:e:b()})),St=C("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",(function(){var e=zt.apply(null,arguments);return this.isValid()&&e.isValid()?e>this?this:e:b()}));function Mt(e,t){var o,i;if(1===t.length&&r(t[0])&&(t=t[0]),!t.length)return zt();for(o=t[0],i=1;i<t.length;++i)t[i].isValid()&&!t[i][e](o)||(o=t[i]);return o}var Dt=["year","quarter","month","week","day","hour","minute","second","millisecond"];function Bt(e){var t=H(e),o=t.year||0,i=t.quarter||0,r=t.month||0,s=t.week||t.isoWeek||0,n=t.day||0,c=t.hour||0,l=t.minute||0,h=t.second||0,d=t.millisecond||0;this._isValid=function(e){var t,o,i=!1,r=Dt.length;for(t in e)if(a(e,t)&&(-1===be.call(Dt,t)||null!=e[t]&&isNaN(e[t])))return!1;for(o=0;o<r;++o)if(e[Dt[o]]){if(i)return!1;parseFloat(e[Dt[o]])!==U(e[Dt[o]])&&(i=!0)}return!0}(t),this._milliseconds=+d+1e3*h+6e4*l+1e3*c*60*60,this._days=+n+7*s,this._months=+r+3*i+12*o,this._data={},this._locale=ct(),this._bubble()}function Tt(e){return e instanceof Bt}function Rt(e){return e<0?-1*Math.round(-1*e):Math.round(e)}function Lt(e,t){O(e,0,0,(function(){var e=this.utcOffset(),o="+";return e<0&&(e=-e,o="-"),o+B(~~(e/60),2)+t+B(~~e%60,2)}))}Lt("Z",":"),Lt("ZZ",""),me("Z",pe),me("ZZ",pe),ye(["Z","ZZ"],(function(e,t,o){o._useUTC=!0,o._tzm=Ot(pe,e)}));var Pt=/([\+\-]|\d\d)/gi;function Ot(e,t){var o,i,r=(t||"").match(e);return null===r?null:0===(i=60*(o=((r[r.length-1]||[])+"").match(Pt)||["-",0,0])[1]+U(o[2]))?0:"+"===o[0]?i:-i}function Nt(e,t){var o,r;return t._isUTC?(o=t.clone(),r=(_(e)||d(e)?e.valueOf():zt(e).valueOf())-o.valueOf(),o._d.setTime(o._d.valueOf()+r),i.updateOffset(o,!1),o):zt(e).local()}function Ft(e){return-Math.round(e._d.getTimezoneOffset())}function $t(){return!!this.isValid()&&this._isUTC&&0===this._offset}i.updateOffset=function(){};var It=/^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,Vt=/^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;function Ht(e,t){var o,i,r,s,n,c,l=e,d=null;return Tt(e)?l={ms:e._milliseconds,d:e._days,M:e._months}:h(e)||!isNaN(+e)?(l={},t?l[t]=+e:l.milliseconds=+e):(d=It.exec(e))?(o="-"===d[1]?-1:1,l={y:0,d:U(d[2])*o,h:U(d[3])*o,m:U(d[4])*o,s:U(d[5])*o,ms:U(Rt(1e3*d[6]))*o}):(d=Vt.exec(e))?(o="-"===d[1]?-1:1,l={y:Wt(d[2],o),M:Wt(d[3],o),w:Wt(d[4],o),d:Wt(d[5],o),h:Wt(d[6],o),m:Wt(d[7],o),s:Wt(d[8],o)}):null==l?l={}:"object"==typeof l&&("from"in l||"to"in l)&&(s=zt(l.from),n=zt(l.to),r=s.isValid()&&n.isValid()?(n=Nt(n,s),s.isBefore(n)?c=qt(s,n):((c=qt(n,s)).milliseconds=-c.milliseconds,c.months=-c.months),c):{milliseconds:0,months:0},(l={}).ms=r.milliseconds,l.M=r.months),i=new Bt(l),Tt(e)&&a(e,"_locale")&&(i._locale=e._locale),Tt(e)&&a(e,"_isValid")&&(i._isValid=e._isValid),i}function Wt(e,t){var o=e&&parseFloat(e.replace(",","."));return(isNaN(o)?0:o)*t}function qt(e,t){var o={};return o.months=t.month()-e.month()+12*(t.year()-e.year()),e.clone().add(o.months,"M").isAfter(t)&&--o.months,o.milliseconds=+t-+e.clone().add(o.months,"M"),o}function Yt(e,t){return function(o,i){var r;return null===i||isNaN(+i)||(A(t,"moment()."+t+"(period, number) is deprecated. Please use moment()."+t+"(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."),r=o,o=i,i=r),jt(this,Ht(o,i),e),this}}function jt(e,t,o,r){var s=t._milliseconds,n=Rt(t._days),a=Rt(t._months);e.isValid()&&(r=null==r||r,a&&Me(e,K(e,"Month")+a*o),n&&G(e,"Date",K(e,"Date")+n*o),s&&e._d.setTime(e._d.valueOf()+s*o),r&&i.updateOffset(e,n||a))}Ht.fn=Bt.prototype,Ht.invalid=function(){return Ht(NaN)};var Ut=Yt(1,"add"),Zt=Yt(-1,"subtract");function Kt(e){return"string"==typeof e||e instanceof String}function Gt(e){return _(e)||d(e)||Kt(e)||h(e)||function(e){var t=r(e),o=!1;return t&&(o=0===e.filter((function(t){return!h(t)&&Kt(e)})).length),t&&o}(e)||function(e){var t,o=s(e)&&!c(e),i=!1,r=["years","year","y","months","month","M","days","day","d","dates","date","D","hours","hour","h","minutes","minute","m","seconds","second","s","milliseconds","millisecond","ms"],n=r.length;for(t=0;t<n;t+=1)i=i||a(e,r[t]);return o&&i}(e)||null==e}function Xt(e){var t,o=s(e)&&!c(e),i=!1,r=["sameDay","nextDay","lastDay","nextWeek","lastWeek","sameElse"];for(t=0;t<r.length;t+=1)i=i||a(e,r[t]);return o&&i}function Jt(e,t){if(e.date()<t.date())return-Jt(t,e);var o=12*(t.year()-e.year())+(t.month()-e.month()),i=e.clone().add(o,"months");return-(o+(t-i<0?(t-i)/(i-e.clone().add(o-1,"months")):(t-i)/(e.clone().add(o+1,"months")-i)))||0}function Qt(e){var t;return void 0===e?this._locale._abbr:(null!=(t=ct(e))&&(this._locale=t),this)}i.defaultFormat="YYYY-MM-DDTHH:mm:ssZ",i.defaultFormatUtc="YYYY-MM-DDTHH:mm:ss[Z]";var eo=C("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",(function(e){return void 0===e?this.localeData():this.locale(e)}));function to(){return this._locale}var oo=1e3,io=6e4,ro=36e5,so=126227808e5;function no(e,t){return(e%t+t)%t}function ao(e,t,o){return e<100&&e>=0?new Date(e+400,t,o)-so:new Date(e,t,o).valueOf()}function co(e,t,o){return e<100&&e>=0?Date.UTC(e+400,t,o)-so:Date.UTC(e,t,o)}function lo(e,t){return t.erasAbbrRegex(e)}function ho(){var e,t,o=[],i=[],r=[],s=[],n=this.eras();for(e=0,t=n.length;e<t;++e)i.push(ge(n[e].name)),o.push(ge(n[e].abbr)),r.push(ge(n[e].narrow)),s.push(ge(n[e].name)),s.push(ge(n[e].abbr)),s.push(ge(n[e].narrow));this._erasRegex=new RegExp("^("+s.join("|")+")","i"),this._erasNameRegex=new RegExp("^("+i.join("|")+")","i"),this._erasAbbrRegex=new RegExp("^("+o.join("|")+")","i"),this._erasNarrowRegex=new RegExp("^("+r.join("|")+")","i")}function po(e,t){O(0,[e,e.length],0,t)}function uo(e,t,o,i,r){var s;return null==e?Fe(this,i,r).year:(t>(s=$e(e,i,r))&&(t=s),mo.call(this,e,t,o,i,r))}function mo(e,t,o,i,r){var s=Ne(e,t,o,i,r),n=Pe(s.year,0,s.dayOfYear);return this.year(n.getUTCFullYear()),this.month(n.getUTCMonth()),this.date(n.getUTCDate()),this}O("N",0,0,"eraAbbr"),O("NN",0,0,"eraAbbr"),O("NNN",0,0,"eraAbbr"),O("NNNN",0,0,"eraName"),O("NNNNN",0,0,"eraNarrow"),O("y",["y",1],"yo","eraYear"),O("y",["yy",2],0,"eraYear"),O("y",["yyy",3],0,"eraYear"),O("y",["yyyy",4],0,"eraYear"),me("N",lo),me("NN",lo),me("NNN",lo),me("NNNN",(function(e,t){return t.erasNameRegex(e)})),me("NNNNN",(function(e,t){return t.erasNarrowRegex(e)})),ye(["N","NN","NNN","NNNN","NNNNN"],(function(e,t,o,i){var r=o._locale.erasParse(e,i,o._strict);r?f(o).era=r:f(o).invalidEra=e})),me("y",le),me("yy",le),me("yyy",le),me("yyyy",le),me("yo",(function(e,t){return t._eraYearOrdinalRegex||le})),ye(["y","yy","yyy","yyyy"],0),ye(["yo"],(function(e,t,o,i){var r;o._locale._eraYearOrdinalRegex&&(r=e.match(o._locale._eraYearOrdinalRegex)),o._locale.eraYearOrdinalParse?t[0]=o._locale.eraYearOrdinalParse(e,r):t[0]=parseInt(e,10)})),O(0,["gg",2],0,(function(){return this.weekYear()%100})),O(0,["GG",2],0,(function(){return this.isoWeekYear()%100})),po("gggg","weekYear"),po("ggggg","weekYear"),po("GGGG","isoWeekYear"),po("GGGGG","isoWeekYear"),I("weekYear","gg"),I("isoWeekYear","GG"),q("weekYear",1),q("isoWeekYear",1),me("G",he),me("g",he),me("GG",ie,Q),me("gg",ie,Q),me("GGGG",ae,te),me("gggg",ae,te),me("GGGGG",ce,oe),me("ggggg",ce,oe),we(["gggg","ggggg","GGGG","GGGGG"],(function(e,t,o,i){t[i.substr(0,2)]=U(e)})),we(["gg","GG"],(function(e,t,o,r){t[r]=i.parseTwoDigitYear(e)})),O("Q",0,"Qo","quarter"),I("quarter","Q"),q("quarter",7),me("Q",J),ye("Q",(function(e,t){t[1]=3*(U(e)-1)})),O("D",["DD",2],"Do","date"),I("date","D"),q("date",9),me("D",ie),me("DD",ie,Q),me("Do",(function(e,t){return e?t._dayOfMonthOrdinalParse||t._ordinalParse:t._dayOfMonthOrdinalParseLenient})),ye(["D","DD"],2),ye("Do",(function(e,t){t[2]=U(e.match(ie)[0])}));var fo=Z("Date",!0);O("DDD",["DDDD",3],"DDDo","dayOfYear"),I("dayOfYear","DDD"),q("dayOfYear",4),me("DDD",ne),me("DDDD",ee),ye(["DDD","DDDD"],(function(e,t,o){o._dayOfYear=U(e)})),O("m",["mm",2],0,"minute"),I("minute","m"),q("minute",14),me("m",ie),me("mm",ie,Q),ye(["m","mm"],4);var go=Z("Minutes",!1);O("s",["ss",2],0,"second"),I("second","s"),q("second",15),me("s",ie),me("ss",ie,Q),ye(["s","ss"],5);var bo,vo,yo=Z("Seconds",!1);for(O("S",0,0,(function(){return~~(this.millisecond()/100)})),O(0,["SS",2],0,(function(){return~~(this.millisecond()/10)})),O(0,["SSS",3],0,"millisecond"),O(0,["SSSS",4],0,(function(){return 10*this.millisecond()})),O(0,["SSSSS",5],0,(function(){return 100*this.millisecond()})),O(0,["SSSSSS",6],0,(function(){return 1e3*this.millisecond()})),O(0,["SSSSSSS",7],0,(function(){return 1e4*this.millisecond()})),O(0,["SSSSSSSS",8],0,(function(){return 1e5*this.millisecond()})),O(0,["SSSSSSSSS",9],0,(function(){return 1e6*this.millisecond()})),I("millisecond","ms"),q("millisecond",16),me("S",ne,J),me("SS",ne,Q),me("SSS",ne,ee),bo="SSSS";bo.length<=9;bo+="S")me(bo,le);function wo(e,t){t[6]=U(1e3*("0."+e))}for(bo="S";bo.length<=9;bo+="S")ye(bo,wo);vo=Z("Milliseconds",!1),O("z",0,0,"zoneAbbr"),O("zz",0,0,"zoneName");var xo=x.prototype;function _o(e){return e}xo.add=Ut,xo.calendar=function(e,t){1===arguments.length&&(arguments[0]?Gt(arguments[0])?(e=arguments[0],t=void 0):Xt(arguments[0])&&(t=arguments[0],e=void 0):(e=void 0,t=void 0));var o=e||zt(),r=Nt(o,this).startOf("day"),s=i.calendarFormat(this,r)||"sameElse",n=t&&(S(t[s])?t[s].call(this,o):t[s]);return this.format(n||this.localeData().calendar(s,this,zt(o)))},xo.clone=function(){return new x(this)},xo.diff=function(e,t,o){var i,r,s;if(!this.isValid())return NaN;if(!(i=Nt(e,this)).isValid())return NaN;switch(r=6e4*(i.utcOffset()-this.utcOffset()),t=V(t)){case"year":s=Jt(this,i)/12;break;case"month":s=Jt(this,i);break;case"quarter":s=Jt(this,i)/3;break;case"second":s=(this-i)/1e3;break;case"minute":s=(this-i)/6e4;break;case"hour":s=(this-i)/36e5;break;case"day":s=(this-i-r)/864e5;break;case"week":s=(this-i-r)/6048e5;break;default:s=this-i}return o?s:j(s)},xo.endOf=function(e){var t,o;if(void 0===(e=V(e))||"millisecond"===e||!this.isValid())return this;switch(o=this._isUTC?co:ao,e){case"year":t=o(this.year()+1,0,1)-1;break;case"quarter":t=o(this.year(),this.month()-this.month()%3+3,1)-1;break;case"month":t=o(this.year(),this.month()+1,1)-1;break;case"week":t=o(this.year(),this.month(),this.date()-this.weekday()+7)-1;break;case"isoWeek":t=o(this.year(),this.month(),this.date()-(this.isoWeekday()-1)+7)-1;break;case"day":case"date":t=o(this.year(),this.month(),this.date()+1)-1;break;case"hour":t=this._d.valueOf(),t+=ro-no(t+(this._isUTC?0:this.utcOffset()*io),ro)-1;break;case"minute":t=this._d.valueOf(),t+=io-no(t,io)-1;break;case"second":t=this._d.valueOf(),t+=oo-no(t,oo)-1}return this._d.setTime(t),i.updateOffset(this,!0),this},xo.format=function(e){e||(e=this.isUtc()?i.defaultFormatUtc:i.defaultFormat);var t=N(this,e);return this.localeData().postformat(t)},xo.from=function(e,t){return this.isValid()&&(_(e)&&e.isValid()||zt(e).isValid())?Ht({to:this,from:e}).locale(this.locale()).humanize(!t):this.localeData().invalidDate()},xo.fromNow=function(e){return this.from(zt(),e)},xo.to=function(e,t){return this.isValid()&&(_(e)&&e.isValid()||zt(e).isValid())?Ht({from:this,to:e}).locale(this.locale()).humanize(!t):this.localeData().invalidDate()},xo.toNow=function(e){return this.to(zt(),e)},xo.get=function(e){return S(this[e=V(e)])?this[e]():this},xo.invalidAt=function(){return f(this).overflow},xo.isAfter=function(e,t){var o=_(e)?e:zt(e);return!(!this.isValid()||!o.isValid())&&("millisecond"===(t=V(t)||"millisecond")?this.valueOf()>o.valueOf():o.valueOf()<this.clone().startOf(t).valueOf())},xo.isBefore=function(e,t){var o=_(e)?e:zt(e);return!(!this.isValid()||!o.isValid())&&("millisecond"===(t=V(t)||"millisecond")?this.valueOf()<o.valueOf():this.clone().endOf(t).valueOf()<o.valueOf())},xo.isBetween=function(e,t,o,i){var r=_(e)?e:zt(e),s=_(t)?t:zt(t);return!!(this.isValid()&&r.isValid()&&s.isValid())&&("("===(i=i||"()")[0]?this.isAfter(r,o):!this.isBefore(r,o))&&(")"===i[1]?this.isBefore(s,o):!this.isAfter(s,o))},xo.isSame=function(e,t){var o,i=_(e)?e:zt(e);return!(!this.isValid()||!i.isValid())&&("millisecond"===(t=V(t)||"millisecond")?this.valueOf()===i.valueOf():(o=i.valueOf(),this.clone().startOf(t).valueOf()<=o&&o<=this.clone().endOf(t).valueOf()))},xo.isSameOrAfter=function(e,t){return this.isSame(e,t)||this.isAfter(e,t)},xo.isSameOrBefore=function(e,t){return this.isSame(e,t)||this.isBefore(e,t)},xo.isValid=function(){return g(this)},xo.lang=eo,xo.locale=Qt,xo.localeData=to,xo.max=St,xo.min=At,xo.parsingFlags=function(){return u({},f(this))},xo.set=function(e,t){if("object"==typeof e){var o,i=function(e){var t,o=[];for(t in e)a(e,t)&&o.push({unit:t,priority:W[t]});return o.sort((function(e,t){return e.priority-t.priority})),o}(e=H(e)),r=i.length;for(o=0;o<r;o++)this[i[o].unit](e[i[o].unit])}else if(S(this[e=V(e)]))return this[e](t);return this},xo.startOf=function(e){var t,o;if(void 0===(e=V(e))||"millisecond"===e||!this.isValid())return this;switch(o=this._isUTC?co:ao,e){case"year":t=o(this.year(),0,1);break;case"quarter":t=o(this.year(),this.month()-this.month()%3,1);break;case"month":t=o(this.year(),this.month(),1);break;case"week":t=o(this.year(),this.month(),this.date()-this.weekday());break;case"isoWeek":t=o(this.year(),this.month(),this.date()-(this.isoWeekday()-1));break;case"day":case"date":t=o(this.year(),this.month(),this.date());break;case"hour":t=this._d.valueOf(),t-=no(t+(this._isUTC?0:this.utcOffset()*io),ro);break;case"minute":t=this._d.valueOf(),t-=no(t,io);break;case"second":t=this._d.valueOf(),t-=no(t,oo)}return this._d.setTime(t),i.updateOffset(this,!0),this},xo.subtract=Zt,xo.toArray=function(){var e=this;return[e.year(),e.month(),e.date(),e.hour(),e.minute(),e.second(),e.millisecond()]},xo.toObject=function(){var e=this;return{years:e.year(),months:e.month(),date:e.date(),hours:e.hours(),minutes:e.minutes(),seconds:e.seconds(),milliseconds:e.milliseconds()}},xo.toDate=function(){return new Date(this.valueOf())},xo.toISOString=function(e){if(!this.isValid())return null;var t=!0!==e,o=t?this.clone().utc():this;return o.year()<0||o.year()>9999?N(o,t?"YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]":"YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"):S(Date.prototype.toISOString)?t?this.toDate().toISOString():new Date(this.valueOf()+60*this.utcOffset()*1e3).toISOString().replace("Z",N(o,"Z")):N(o,t?"YYYY-MM-DD[T]HH:mm:ss.SSS[Z]":"YYYY-MM-DD[T]HH:mm:ss.SSSZ")},xo.inspect=function(){if(!this.isValid())return"moment.invalid(/* "+this._i+" */)";var e,t,o,i="moment",r="";return this.isLocal()||(i=0===this.utcOffset()?"moment.utc":"moment.parseZone",r="Z"),e="["+i+'("]',t=0<=this.year()&&this.year()<=9999?"YYYY":"YYYYYY",o=r+'[")]',this.format(e+t+"-MM-DD[T]HH:mm:ss.SSS"+o)},"undefined"!=typeof Symbol&&null!=Symbol.for&&(xo[Symbol.for("nodejs.util.inspect.custom")]=function(){return"Moment<"+this.format()+">"}),xo.toJSON=function(){return this.isValid()?this.toISOString():null},xo.toString=function(){return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")},xo.unix=function(){return Math.floor(this.valueOf()/1e3)},xo.valueOf=function(){return this._d.valueOf()-6e4*(this._offset||0)},xo.creationData=function(){return{input:this._i,format:this._f,locale:this._locale,isUTC:this._isUTC,strict:this._strict}},xo.eraName=function(){var e,t,o,i=this.localeData().eras();for(e=0,t=i.length;e<t;++e){if(o=this.clone().startOf("day").valueOf(),i[e].since<=o&&o<=i[e].until)return i[e].name;if(i[e].until<=o&&o<=i[e].since)return i[e].name}return""},xo.eraNarrow=function(){var e,t,o,i=this.localeData().eras();for(e=0,t=i.length;e<t;++e){if(o=this.clone().startOf("day").valueOf(),i[e].since<=o&&o<=i[e].until)return i[e].narrow;if(i[e].until<=o&&o<=i[e].since)return i[e].narrow}return""},xo.eraAbbr=function(){var e,t,o,i=this.localeData().eras();for(e=0,t=i.length;e<t;++e){if(o=this.clone().startOf("day").valueOf(),i[e].since<=o&&o<=i[e].until)return i[e].abbr;if(i[e].until<=o&&o<=i[e].since)return i[e].abbr}return""},xo.eraYear=function(){var e,t,o,r,s=this.localeData().eras();for(e=0,t=s.length;e<t;++e)if(o=s[e].since<=s[e].until?1:-1,r=this.clone().startOf("day").valueOf(),s[e].since<=r&&r<=s[e].until||s[e].until<=r&&r<=s[e].since)return(this.year()-i(s[e].since).year())*o+s[e].offset;return this.year()},xo.year=Re,xo.isLeapYear=function(){return Y(this.year())},xo.weekYear=function(e){return uo.call(this,e,this.week(),this.weekday(),this.localeData()._week.dow,this.localeData()._week.doy)},xo.isoWeekYear=function(e){return uo.call(this,e,this.isoWeek(),this.isoWeekday(),1,4)},xo.quarter=xo.quarters=function(e){return null==e?Math.ceil((this.month()+1)/3):this.month(3*(e-1)+this.month()%3)},xo.month=De,xo.daysInMonth=function(){return _e(this.year(),this.month())},xo.week=xo.weeks=function(e){var t=this.localeData().week(this);return null==e?t:this.add(7*(e-t),"d")},xo.isoWeek=xo.isoWeeks=function(e){var t=Fe(this,1,4).week;return null==e?t:this.add(7*(e-t),"d")},xo.weeksInYear=function(){var e=this.localeData()._week;return $e(this.year(),e.dow,e.doy)},xo.weeksInWeekYear=function(){var e=this.localeData()._week;return $e(this.weekYear(),e.dow,e.doy)},xo.isoWeeksInYear=function(){return $e(this.year(),1,4)},xo.isoWeeksInISOWeekYear=function(){return $e(this.isoWeekYear(),1,4)},xo.date=fo,xo.day=xo.days=function(e){if(!this.isValid())return null!=e?this:NaN;var t=this._isUTC?this._d.getUTCDay():this._d.getDay();return null!=e?(e=function(e,t){return"string"!=typeof e?e:isNaN(e)?"number"==typeof(e=t.weekdaysParse(e))?e:null:parseInt(e,10)}(e,this.localeData()),this.add(e-t,"d")):t},xo.weekday=function(e){if(!this.isValid())return null!=e?this:NaN;var t=(this.day()+7-this.localeData()._week.dow)%7;return null==e?t:this.add(e-t,"d")},xo.isoWeekday=function(e){if(!this.isValid())return null!=e?this:NaN;if(null!=e){var t=function(e,t){return"string"==typeof e?t.weekdaysParse(e)%7||7:isNaN(e)?null:e}(e,this.localeData());return this.day(this.day()%7?t:t-7)}return this.day()||7},xo.dayOfYear=function(e){var t=Math.round((this.clone().startOf("day")-this.clone().startOf("year"))/864e5)+1;return null==e?t:this.add(e-t,"d")},xo.hour=xo.hours=Qe,xo.minute=xo.minutes=go,xo.second=xo.seconds=yo,xo.millisecond=xo.milliseconds=vo,xo.utcOffset=function(e,t,o){var r,s=this._offset||0;if(!this.isValid())return null!=e?this:NaN;if(null!=e){if("string"==typeof e){if(null===(e=Ot(pe,e)))return this}else Math.abs(e)<16&&!o&&(e*=60);return!this._isUTC&&t&&(r=Ft(this)),this._offset=e,this._isUTC=!0,null!=r&&this.add(r,"m"),s!==e&&(!t||this._changeInProgress?jt(this,Ht(e-s,"m"),1,!1):this._changeInProgress||(this._changeInProgress=!0,i.updateOffset(this,!0),this._changeInProgress=null)),this}return this._isUTC?s:Ft(this)},xo.utc=function(e){return this.utcOffset(0,e)},xo.local=function(e){return this._isUTC&&(this.utcOffset(0,e),this._isUTC=!1,e&&this.subtract(Ft(this),"m")),this},xo.parseZone=function(){if(null!=this._tzm)this.utcOffset(this._tzm,!1,!0);else if("string"==typeof this._i){var e=Ot(de,this._i);null!=e?this.utcOffset(e):this.utcOffset(0,!0)}return this},xo.hasAlignedHourOffset=function(e){return!!this.isValid()&&(e=e?zt(e).utcOffset():0,(this.utcOffset()-e)%60==0)},xo.isDST=function(){return this.utcOffset()>this.clone().month(0).utcOffset()||this.utcOffset()>this.clone().month(5).utcOffset()},xo.isLocal=function(){return!!this.isValid()&&!this._isUTC},xo.isUtcOffset=function(){return!!this.isValid()&&this._isUTC},xo.isUtc=$t,xo.isUTC=$t,xo.zoneAbbr=function(){return this._isUTC?"UTC":""},xo.zoneName=function(){return this._isUTC?"Coordinated Universal Time":""},xo.dates=C("dates accessor is deprecated. Use date instead.",fo),xo.months=C("months accessor is deprecated. Use month instead",De),xo.years=C("years accessor is deprecated. Use year instead",Re),xo.zone=C("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",(function(e,t){return null!=e?("string"!=typeof e&&(e=-e),this.utcOffset(e,t),this):-this.utcOffset()})),xo.isDSTShifted=C("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",(function(){if(!l(this._isDSTShifted))return this._isDSTShifted;var e,t={};return w(t,this),(t=Ct(t))._a?(e=t._isUTC?m(t._a):zt(t._a),this._isDSTShifted=this.isValid()&&function(e,t,o){var i,r=Math.min(e.length,t.length),s=Math.abs(e.length-t.length),n=0;for(i=0;i<r;i++)U(e[i])!==U(t[i])&&n++;return n+s}(t._a,e.toArray())>0):this._isDSTShifted=!1,this._isDSTShifted}));var ko=D.prototype;function Co(e,t,o,i){var r=ct(),s=m().set(i,t);return r[o](s,e)}function Eo(e,t,o){if(h(e)&&(t=e,e=void 0),e=e||"",null!=t)return Co(e,t,o,"month");var i,r=[];for(i=0;i<12;i++)r[i]=Co(e,i,o,"month");return r}function zo(e,t,o,i){"boolean"==typeof e?(h(t)&&(o=t,t=void 0),t=t||""):(o=t=e,e=!1,h(t)&&(o=t,t=void 0),t=t||"");var r,s=ct(),n=e?s._week.dow:0,a=[];if(null!=o)return Co(t,(o+n)%7,i,"day");for(r=0;r<7;r++)a[r]=Co(t,(r+n)%7,i,"day");return a}ko.calendar=function(e,t,o){var i=this._calendar[e]||this._calendar.sameElse;return S(i)?i.call(t,o):i},ko.longDateFormat=function(e){var t=this._longDateFormat[e],o=this._longDateFormat[e.toUpperCase()];return t||!o?t:(this._longDateFormat[e]=o.match(T).map((function(e){return"MMMM"===e||"MM"===e||"DD"===e||"dddd"===e?e.slice(1):e})).join(""),this._longDateFormat[e])},ko.invalidDate=function(){return this._invalidDate},ko.ordinal=function(e){return this._ordinal.replace("%d",e)},ko.preparse=_o,ko.postformat=_o,ko.relativeTime=function(e,t,o,i){var r=this._relativeTime[o];return S(r)?r(e,t,o,i):r.replace(/%d/i,e)},ko.pastFuture=function(e,t){var o=this._relativeTime[e>0?"future":"past"];return S(o)?o(t):o.replace(/%s/i,t)},ko.set=function(e){var t,o;for(o in e)a(e,o)&&(S(t=e[o])?this[o]=t:this["_"+o]=t);this._config=e,this._dayOfMonthOrdinalParseLenient=new RegExp((this._dayOfMonthOrdinalParse.source||this._ordinalParse.source)+"|"+/\d{1,2}/.source)},ko.eras=function(e,t){var o,r,s,n=this._eras||ct("en")._eras;for(o=0,r=n.length;o<r;++o)switch("string"==typeof n[o].since&&(s=i(n[o].since).startOf("day"),n[o].since=s.valueOf()),typeof n[o].until){case"undefined":n[o].until=1/0;break;case"string":s=i(n[o].until).startOf("day").valueOf(),n[o].until=s.valueOf()}return n},ko.erasParse=function(e,t,o){var i,r,s,n,a,c=this.eras();for(e=e.toUpperCase(),i=0,r=c.length;i<r;++i)if(s=c[i].name.toUpperCase(),n=c[i].abbr.toUpperCase(),a=c[i].narrow.toUpperCase(),o)switch(t){case"N":case"NN":case"NNN":if(n===e)return c[i];break;case"NNNN":if(s===e)return c[i];break;case"NNNNN":if(a===e)return c[i]}else if([s,n,a].indexOf(e)>=0)return c[i]},ko.erasConvertYear=function(e,t){var o=e.since<=e.until?1:-1;return void 0===t?i(e.since).year():i(e.since).year()+(t-e.offset)*o},ko.erasAbbrRegex=function(e){return a(this,"_erasAbbrRegex")||ho.call(this),e?this._erasAbbrRegex:this._erasRegex},ko.erasNameRegex=function(e){return a(this,"_erasNameRegex")||ho.call(this),e?this._erasNameRegex:this._erasRegex},ko.erasNarrowRegex=function(e){return a(this,"_erasNarrowRegex")||ho.call(this),e?this._erasNarrowRegex:this._erasRegex},ko.months=function(e,t){return e?r(this._months)?this._months[e.month()]:this._months[(this._months.isFormat||Ee).test(t)?"format":"standalone"][e.month()]:r(this._months)?this._months:this._months.standalone},ko.monthsShort=function(e,t){return e?r(this._monthsShort)?this._monthsShort[e.month()]:this._monthsShort[Ee.test(t)?"format":"standalone"][e.month()]:r(this._monthsShort)?this._monthsShort:this._monthsShort.standalone},ko.monthsParse=function(e,t,o){var i,r,s;if(this._monthsParseExact)return Se.call(this,e,t,o);for(this._monthsParse||(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[]),i=0;i<12;i++){if(r=m([2e3,i]),o&&!this._longMonthsParse[i]&&(this._longMonthsParse[i]=new RegExp("^"+this.months(r,"").replace(".","")+"$","i"),this._shortMonthsParse[i]=new RegExp("^"+this.monthsShort(r,"").replace(".","")+"$","i")),o||this._monthsParse[i]||(s="^"+this.months(r,"")+"|^"+this.monthsShort(r,""),this._monthsParse[i]=new RegExp(s.replace(".",""),"i")),o&&"MMMM"===t&&this._longMonthsParse[i].test(e))return i;if(o&&"MMM"===t&&this._shortMonthsParse[i].test(e))return i;if(!o&&this._monthsParse[i].test(e))return i}},ko.monthsRegex=function(e){return this._monthsParseExact?(a(this,"_monthsRegex")||Be.call(this),e?this._monthsStrictRegex:this._monthsRegex):(a(this,"_monthsRegex")||(this._monthsRegex=Ae),this._monthsStrictRegex&&e?this._monthsStrictRegex:this._monthsRegex)},ko.monthsShortRegex=function(e){return this._monthsParseExact?(a(this,"_monthsRegex")||Be.call(this),e?this._monthsShortStrictRegex:this._monthsShortRegex):(a(this,"_monthsShortRegex")||(this._monthsShortRegex=ze),this._monthsShortStrictRegex&&e?this._monthsShortStrictRegex:this._monthsShortRegex)},ko.week=function(e){return Fe(e,this._week.dow,this._week.doy).week},ko.firstDayOfYear=function(){return this._week.doy},ko.firstDayOfWeek=function(){return this._week.dow},ko.weekdays=function(e,t){var o=r(this._weekdays)?this._weekdays:this._weekdays[e&&!0!==e&&this._weekdays.isFormat.test(t)?"format":"standalone"];return!0===e?Ie(o,this._week.dow):e?o[e.day()]:o},ko.weekdaysMin=function(e){return!0===e?Ie(this._weekdaysMin,this._week.dow):e?this._weekdaysMin[e.day()]:this._weekdaysMin},ko.weekdaysShort=function(e){return!0===e?Ie(this._weekdaysShort,this._week.dow):e?this._weekdaysShort[e.day()]:this._weekdaysShort},ko.weekdaysParse=function(e,t,o){var i,r,s;if(this._weekdaysParseExact)return Ue.call(this,e,t,o);for(this._weekdaysParse||(this._weekdaysParse=[],this._minWeekdaysParse=[],this._shortWeekdaysParse=[],this._fullWeekdaysParse=[]),i=0;i<7;i++){if(r=m([2e3,1]).day(i),o&&!this._fullWeekdaysParse[i]&&(this._fullWeekdaysParse[i]=new RegExp("^"+this.weekdays(r,"").replace(".","\\.?")+"$","i"),this._shortWeekdaysParse[i]=new RegExp("^"+this.weekdaysShort(r,"").replace(".","\\.?")+"$","i"),this._minWeekdaysParse[i]=new RegExp("^"+this.weekdaysMin(r,"").replace(".","\\.?")+"$","i")),this._weekdaysParse[i]||(s="^"+this.weekdays(r,"")+"|^"+this.weekdaysShort(r,"")+"|^"+this.weekdaysMin(r,""),this._weekdaysParse[i]=new RegExp(s.replace(".",""),"i")),o&&"dddd"===t&&this._fullWeekdaysParse[i].test(e))return i;if(o&&"ddd"===t&&this._shortWeekdaysParse[i].test(e))return i;if(o&&"dd"===t&&this._minWeekdaysParse[i].test(e))return i;if(!o&&this._weekdaysParse[i].test(e))return i}},ko.weekdaysRegex=function(e){return this._weekdaysParseExact?(a(this,"_weekdaysRegex")||Ze.call(this),e?this._weekdaysStrictRegex:this._weekdaysRegex):(a(this,"_weekdaysRegex")||(this._weekdaysRegex=qe),this._weekdaysStrictRegex&&e?this._weekdaysStrictRegex:this._weekdaysRegex)},ko.weekdaysShortRegex=function(e){return this._weekdaysParseExact?(a(this,"_weekdaysRegex")||Ze.call(this),e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex):(a(this,"_weekdaysShortRegex")||(this._weekdaysShortRegex=Ye),this._weekdaysShortStrictRegex&&e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex)},ko.weekdaysMinRegex=function(e){return this._weekdaysParseExact?(a(this,"_weekdaysRegex")||Ze.call(this),e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex):(a(this,"_weekdaysMinRegex")||(this._weekdaysMinRegex=je),this._weekdaysMinStrictRegex&&e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex)},ko.isPM=function(e){return"p"===(e+"").toLowerCase().charAt(0)},ko.meridiem=function(e,t,o){return e>11?o?"pm":"PM":o?"am":"AM"},nt("en",{eras:[{since:"0001-01-01",until:1/0,offset:1,name:"Anno Domini",narrow:"AD",abbr:"AD"},{since:"0000-12-31",until:-1/0,offset:1,name:"Before Christ",narrow:"BC",abbr:"BC"}],dayOfMonthOrdinalParse:/\d{1,2}(th|st|nd|rd)/,ordinal:function(e){var t=e%10;return e+(1===U(e%100/10)?"th":1===t?"st":2===t?"nd":3===t?"rd":"th")}}),i.lang=C("moment.lang is deprecated. Use moment.locale instead.",nt),i.langData=C("moment.langData is deprecated. Use moment.localeData instead.",ct);var Ao=Math.abs;function So(e,t,o,i){var r=Ht(t,o);return e._milliseconds+=i*r._milliseconds,e._days+=i*r._days,e._months+=i*r._months,e._bubble()}function Mo(e){return e<0?Math.floor(e):Math.ceil(e)}function Do(e){return 4800*e/146097}function Bo(e){return 146097*e/4800}function To(e){return function(){return this.as(e)}}var Ro=To("ms"),Lo=To("s"),Po=To("m"),Oo=To("h"),No=To("d"),Fo=To("w"),$o=To("M"),Io=To("Q"),Vo=To("y");function Ho(e){return function(){return this.isValid()?this._data[e]:NaN}}var Wo=Ho("milliseconds"),qo=Ho("seconds"),Yo=Ho("minutes"),jo=Ho("hours"),Uo=Ho("days"),Zo=Ho("months"),Ko=Ho("years"),Go=Math.round,Xo={ss:44,s:45,m:45,h:22,d:26,w:null,M:11};function Jo(e,t,o,i,r){return r.relativeTime(t||1,!!o,e,i)}var Qo=Math.abs;function ei(e){return(e>0)-(e<0)||+e}function ti(){if(!this.isValid())return this.localeData().invalidDate();var e,t,o,i,r,s,n,a,c=Qo(this._milliseconds)/1e3,l=Qo(this._days),h=Qo(this._months),d=this.asSeconds();return d?(e=j(c/60),t=j(e/60),c%=60,e%=60,o=j(h/12),h%=12,i=c?c.toFixed(3).replace(/\.?0+$/,""):"",r=d<0?"-":"",s=ei(this._months)!==ei(d)?"-":"",n=ei(this._days)!==ei(d)?"-":"",a=ei(this._milliseconds)!==ei(d)?"-":"",r+"P"+(o?s+o+"Y":"")+(h?s+h+"M":"")+(l?n+l+"D":"")+(t||e||c?"T":"")+(t?a+t+"H":"")+(e?a+e+"M":"")+(c?a+i+"S":"")):"P0D"}var oi=Bt.prototype;return oi.isValid=function(){return this._isValid},oi.abs=function(){var e=this._data;return this._milliseconds=Ao(this._milliseconds),this._days=Ao(this._days),this._months=Ao(this._months),e.milliseconds=Ao(e.milliseconds),e.seconds=Ao(e.seconds),e.minutes=Ao(e.minutes),e.hours=Ao(e.hours),e.months=Ao(e.months),e.years=Ao(e.years),this},oi.add=function(e,t){return So(this,e,t,1)},oi.subtract=function(e,t){return So(this,e,t,-1)},oi.as=function(e){if(!this.isValid())return NaN;var t,o,i=this._milliseconds;if("month"===(e=V(e))||"quarter"===e||"year"===e)switch(t=this._days+i/864e5,o=this._months+Do(t),e){case"month":return o;case"quarter":return o/3;case"year":return o/12}else switch(t=this._days+Math.round(Bo(this._months)),e){case"week":return t/7+i/6048e5;case"day":return t+i/864e5;case"hour":return 24*t+i/36e5;case"minute":return 1440*t+i/6e4;case"second":return 86400*t+i/1e3;case"millisecond":return Math.floor(864e5*t)+i;default:throw new Error("Unknown unit "+e)}},oi.asMilliseconds=Ro,oi.asSeconds=Lo,oi.asMinutes=Po,oi.asHours=Oo,oi.asDays=No,oi.asWeeks=Fo,oi.asMonths=$o,oi.asQuarters=Io,oi.asYears=Vo,oi.valueOf=function(){return this.isValid()?this._milliseconds+864e5*this._days+this._months%12*2592e6+31536e6*U(this._months/12):NaN},oi._bubble=function(){var e,t,o,i,r,s=this._milliseconds,n=this._days,a=this._months,c=this._data;return s>=0&&n>=0&&a>=0||s<=0&&n<=0&&a<=0||(s+=864e5*Mo(Bo(a)+n),n=0,a=0),c.milliseconds=s%1e3,e=j(s/1e3),c.seconds=e%60,t=j(e/60),c.minutes=t%60,o=j(t/60),c.hours=o%24,n+=j(o/24),a+=r=j(Do(n)),n-=Mo(Bo(r)),i=j(a/12),a%=12,c.days=n,c.months=a,c.years=i,this},oi.clone=function(){return Ht(this)},oi.get=function(e){return e=V(e),this.isValid()?this[e+"s"]():NaN},oi.milliseconds=Wo,oi.seconds=qo,oi.minutes=Yo,oi.hours=jo,oi.days=Uo,oi.weeks=function(){return j(this.days()/7)},oi.months=Zo,oi.years=Ko,oi.humanize=function(e,t){if(!this.isValid())return this.localeData().invalidDate();var o,i,r=!1,s=Xo;return"object"==typeof e&&(t=e,e=!1),"boolean"==typeof e&&(r=e),"object"==typeof t&&(s=Object.assign({},Xo,t),null!=t.s&&null==t.ss&&(s.ss=t.s-1)),i=function(e,t,o,i){var r=Ht(e).abs(),s=Go(r.as("s")),n=Go(r.as("m")),a=Go(r.as("h")),c=Go(r.as("d")),l=Go(r.as("M")),h=Go(r.as("w")),d=Go(r.as("y")),p=s<=o.ss&&["s",s]||s<o.s&&["ss",s]||n<=1&&["m"]||n<o.m&&["mm",n]||a<=1&&["h"]||a<o.h&&["hh",a]||c<=1&&["d"]||c<o.d&&["dd",c];return null!=o.w&&(p=p||h<=1&&["w"]||h<o.w&&["ww",h]),(p=p||l<=1&&["M"]||l<o.M&&["MM",l]||d<=1&&["y"]||["yy",d])[2]=t,p[3]=+e>0,p[4]=i,Jo.apply(null,p)}(this,!r,s,o=this.localeData()),r&&(i=o.pastFuture(+this,i)),o.postformat(i)},oi.toISOString=ti,oi.toString=ti,oi.toJSON=ti,oi.locale=Qt,oi.localeData=to,oi.toIsoString=C("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",ti),oi.lang=eo,O("X",0,0,"unix"),O("x",0,0,"valueOf"),me("x",he),me("X",/[+-]?\d+(\.\d{1,3})?/),ye("X",(function(e,t,o){o._d=new Date(1e3*parseFloat(e))})),ye("x",(function(e,t,o){o._d=new Date(U(e))})),i.version="2.29.4",e=zt,i.fn=xo,i.min=function(){var e=[].slice.call(arguments,0);return Mt("isBefore",e)},i.max=function(){var e=[].slice.call(arguments,0);return Mt("isAfter",e)},i.now=function(){return Date.now?Date.now():+new Date},i.utc=m,i.unix=function(e){return zt(1e3*e)},i.months=function(e,t){return Eo(e,t,"months")},i.isDate=d,i.locale=nt,i.invalid=b,i.duration=Ht,i.isMoment=_,i.weekdays=function(e,t,o){return zo(e,t,o,"weekdays")},i.parseZone=function(){return zt.apply(null,arguments).parseZone()},i.localeData=ct,i.isDuration=Tt,i.monthsShort=function(e,t){return Eo(e,t,"monthsShort")},i.weekdaysMin=function(e,t,o){return zo(e,t,o,"weekdaysMin")},i.defineLocale=at,i.updateLocale=function(e,t){if(null!=t){var o,i,r=et;null!=tt[e]&&null!=tt[e].parentLocale?tt[e].set(M(tt[e]._config,t)):(null!=(i=st(e))&&(r=i._config),t=M(r,t),null==i&&(t.abbr=e),(o=new D(t)).parentLocale=tt[e],tt[e]=o),nt(e)}else null!=tt[e]&&(null!=tt[e].parentLocale?(tt[e]=tt[e].parentLocale,e===nt()&&nt(e)):null!=tt[e]&&delete tt[e]);return tt[e]},i.locales=function(){return E(tt)},i.weekdaysShort=function(e,t,o){return zo(e,t,o,"weekdaysShort")},i.normalizeUnits=V,i.relativeTimeRounding=function(e){return void 0===e?Go:"function"==typeof e&&(Go=e,!0)},i.relativeTimeThreshold=function(e,t){return void 0!==Xo[e]&&(void 0===t?Xo[e]:(Xo[e]=t,"s"===e&&(Xo.ss=t-1),!0))},i.calendarFormat=function(e,t){var o=e.diff(t,"days",!0);return o<-6?"sameElse":o<-1?"lastWeek":o<0?"lastDay":o<1?"sameDay":o<2?"nextDay":o<7?"nextWeek":"sameElse"},i.prototype=xo,i.HTML5_FMT={DATETIME_LOCAL:"YYYY-MM-DDTHH:mm",DATETIME_LOCAL_SECONDS:"YYYY-MM-DDTHH:mm:ss",DATETIME_LOCAL_MS:"YYYY-MM-DDTHH:mm:ss.SSS",DATE:"YYYY-MM-DD",TIME:"HH:mm",TIME_SECONDS:"HH:mm:ss",TIME_MS:"HH:mm:ss.SSS",WEEK:"GGGG-[W]WW",MONTH:"YYYY-MM"},i},"object"==typeof e&&void 0!==t?t.exports=i():"function"==typeof define&&define.amd?define(i):o.moment=i()}}),h=a({"node_modules/chart.js/dist/Chart.js"(e,t){var o,i;o=e,i=function(e){e=e&&e.hasOwnProperty("default")?e.default:e;var t,o,i={aliceblue:[240,248,255],antiquewhite:[250,235,215],aqua:[0,255,255],aquamarine:[127,255,212],azure:[240,255,255],beige:[245,245,220],bisque:[255,228,196],black:[0,0,0],blanchedalmond:[255,235,205],blue:[0,0,255],blueviolet:[138,43,226],brown:[165,42,42],burlywood:[222,184,135],cadetblue:[95,158,160],chartreuse:[127,255,0],chocolate:[210,105,30],coral:[255,127,80],cornflowerblue:[100,149,237],cornsilk:[255,248,220],crimson:[220,20,60],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgoldenrod:[184,134,11],darkgray:[169,169,169],darkgreen:[0,100,0],darkgrey:[169,169,169],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkseagreen:[143,188,143],darkslateblue:[72,61,139],darkslategray:[47,79,79],darkslategrey:[47,79,79],darkturquoise:[0,206,209],darkviolet:[148,0,211],deeppink:[255,20,147],deepskyblue:[0,191,255],dimgray:[105,105,105],dimgrey:[105,105,105],dodgerblue:[30,144,255],firebrick:[178,34,34],floralwhite:[255,250,240],forestgreen:[34,139,34],fuchsia:[255,0,255],gainsboro:[220,220,220],ghostwhite:[248,248,255],gold:[255,215,0],goldenrod:[218,165,32],gray:[128,128,128],green:[0,128,0],greenyellow:[173,255,47],grey:[128,128,128],honeydew:[240,255,240],hotpink:[255,105,180],indianred:[205,92,92],indigo:[75,0,130],ivory:[255,255,240],khaki:[240,230,140],lavender:[230,230,250],lavenderblush:[255,240,245],lawngreen:[124,252,0],lemonchiffon:[255,250,205],lightblue:[173,216,230],lightcoral:[240,128,128],lightcyan:[224,255,255],lightgoldenrodyellow:[250,250,210],lightgray:[211,211,211],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightsalmon:[255,160,122],lightseagreen:[32,178,170],lightskyblue:[135,206,250],lightslategray:[119,136,153],lightslategrey:[119,136,153],lightsteelblue:[176,196,222],lightyellow:[255,255,224],lime:[0,255,0],limegreen:[50,205,50],linen:[250,240,230],magenta:[255,0,255],maroon:[128,0,0],mediumaquamarine:[102,205,170],mediumblue:[0,0,205],mediumorchid:[186,85,211],mediumpurple:[147,112,219],mediumseagreen:[60,179,113],mediumslateblue:[123,104,238],mediumspringgreen:[0,250,154],mediumturquoise:[72,209,204],mediumvioletred:[199,21,133],midnightblue:[25,25,112],mintcream:[245,255,250],mistyrose:[255,228,225],moccasin:[255,228,181],navajowhite:[255,222,173],navy:[0,0,128],oldlace:[253,245,230],olive:[128,128,0],olivedrab:[107,142,35],orange:[255,165,0],orangered:[255,69,0],orchid:[218,112,214],palegoldenrod:[238,232,170],palegreen:[152,251,152],paleturquoise:[175,238,238],palevioletred:[219,112,147],papayawhip:[255,239,213],peachpuff:[255,218,185],peru:[205,133,63],pink:[255,192,203],plum:[221,160,221],powderblue:[176,224,230],purple:[128,0,128],rebeccapurple:[102,51,153],red:[255,0,0],rosybrown:[188,143,143],royalblue:[65,105,225],saddlebrown:[139,69,19],salmon:[250,128,114],sandybrown:[244,164,96],seagreen:[46,139,87],seashell:[255,245,238],sienna:[160,82,45],silver:[192,192,192],skyblue:[135,206,235],slateblue:[106,90,205],slategray:[112,128,144],slategrey:[112,128,144],snow:[255,250,250],springgreen:[0,255,127],steelblue:[70,130,180],tan:[210,180,140],teal:[0,128,128],thistle:[216,191,216],tomato:[255,99,71],turquoise:[64,224,208],violet:[238,130,238],wheat:[245,222,179],white:[255,255,255],whitesmoke:[245,245,245],yellow:[255,255,0],yellowgreen:[154,205,50]},r=(t=function(e){var t={};for(var o in i)i.hasOwnProperty(o)&&(t[i[o]]=o);var r=e.exports={rgb:{channels:3,labels:"rgb"},hsl:{channels:3,labels:"hsl"},hsv:{channels:3,labels:"hsv"},hwb:{channels:3,labels:"hwb"},cmyk:{channels:4,labels:"cmyk"},xyz:{channels:3,labels:"xyz"},lab:{channels:3,labels:"lab"},lch:{channels:3,labels:"lch"},hex:{channels:1,labels:["hex"]},keyword:{channels:1,labels:["keyword"]},ansi16:{channels:1,labels:["ansi16"]},ansi256:{channels:1,labels:["ansi256"]},hcg:{channels:3,labels:["h","c","g"]},apple:{channels:3,labels:["r16","g16","b16"]},gray:{channels:1,labels:["gray"]}};for(var s in r)if(r.hasOwnProperty(s)){if(!("channels"in r[s]))throw new Error("missing channels property: "+s);if(!("labels"in r[s]))throw new Error("missing channel labels property: "+s);if(r[s].labels.length!==r[s].channels)throw new Error("channel and label counts mismatch: "+s);var n=r[s].channels,a=r[s].labels;delete r[s].channels,delete r[s].labels,Object.defineProperty(r[s],"channels",{value:n}),Object.defineProperty(r[s],"labels",{value:a})}r.rgb.hsl=function(e){var t,o,i=e[0]/255,r=e[1]/255,s=e[2]/255,n=Math.min(i,r,s),a=Math.max(i,r,s),c=a-n;return a===n?t=0:i===a?t=(r-s)/c:r===a?t=2+(s-i)/c:s===a&&(t=4+(i-r)/c),(t=Math.min(60*t,360))<0&&(t+=360),o=(n+a)/2,[t,100*(a===n?0:o<=.5?c/(a+n):c/(2-a-n)),100*o]},r.rgb.hsv=function(e){var t,o,i,r,s,n=e[0]/255,a=e[1]/255,c=e[2]/255,l=Math.max(n,a,c),h=l-Math.min(n,a,c),d=function(e){return(l-e)/6/h+.5};return 0===h?r=s=0:(s=h/l,t=d(n),o=d(a),i=d(c),n===l?r=i-o:a===l?r=1/3+t-i:c===l&&(r=2/3+o-t),r<0?r+=1:r>1&&(r-=1)),[360*r,100*s,100*l]},r.rgb.hwb=function(e){var t=e[0],o=e[1],i=e[2];return[r.rgb.hsl(e)[0],1/255*Math.min(t,Math.min(o,i))*100,100*(i=1-1/255*Math.max(t,Math.max(o,i)))]},r.rgb.cmyk=function(e){var t,o=e[0]/255,i=e[1]/255,r=e[2]/255;return[100*((1-o-(t=Math.min(1-o,1-i,1-r)))/(1-t)||0),100*((1-i-t)/(1-t)||0),100*((1-r-t)/(1-t)||0),100*t]},r.rgb.keyword=function(e){var o=t[e];if(o)return o;var r,s,n,a=1/0;for(var c in i)if(i.hasOwnProperty(c)){var l=(s=e,n=i[c],Math.pow(s[0]-n[0],2)+Math.pow(s[1]-n[1],2)+Math.pow(s[2]-n[2],2));l<a&&(a=l,r=c)}return r},r.keyword.rgb=function(e){return i[e]},r.rgb.xyz=function(e){var t=e[0]/255,o=e[1]/255,i=e[2]/255;return[100*(.4124*(t=t>.04045?Math.pow((t+.055)/1.055,2.4):t/12.92)+.3576*(o=o>.04045?Math.pow((o+.055)/1.055,2.4):o/12.92)+.1805*(i=i>.04045?Math.pow((i+.055)/1.055,2.4):i/12.92)),100*(.2126*t+.7152*o+.0722*i),100*(.0193*t+.1192*o+.9505*i)]},r.rgb.lab=function(e){var t=r.rgb.xyz(e),o=t[0],i=t[1],s=t[2];return i/=100,s/=108.883,o=(o/=95.047)>.008856?Math.pow(o,1/3):7.787*o+16/116,[116*(i=i>.008856?Math.pow(i,1/3):7.787*i+16/116)-16,500*(o-i),200*(i-(s=s>.008856?Math.pow(s,1/3):7.787*s+16/116))]},r.hsl.rgb=function(e){var t,o,i,r,s,n=e[0]/360,a=e[1]/100,c=e[2]/100;if(0===a)return[s=255*c,s,s];t=2*c-(o=c<.5?c*(1+a):c+a-c*a),r=[0,0,0];for(var l=0;l<3;l++)(i=n+1/3*-(l-1))<0&&i++,i>1&&i--,s=6*i<1?t+6*(o-t)*i:2*i<1?o:3*i<2?t+(o-t)*(2/3-i)*6:t,r[l]=255*s;return r},r.hsl.hsv=function(e){var t=e[0],o=e[1]/100,i=e[2]/100,r=o,s=Math.max(i,.01);return o*=(i*=2)<=1?i:2-i,r*=s<=1?s:2-s,[t,100*(0===i?2*r/(s+r):2*o/(i+o)),(i+o)/2*100]},r.hsv.rgb=function(e){var t=e[0]/60,o=e[1]/100,i=e[2]/100,r=Math.floor(t)%6,s=t-Math.floor(t),n=255*i*(1-o),a=255*i*(1-o*s),c=255*i*(1-o*(1-s));switch(i*=255,r){case 0:return[i,c,n];case 1:return[a,i,n];case 2:return[n,i,c];case 3:return[n,a,i];case 4:return[c,n,i];case 5:return[i,n,a]}},r.hsv.hsl=function(e){var t,o,i,r=e[0],s=e[1]/100,n=e[2]/100,a=Math.max(n,.01);return i=(2-s)*n,o=s*a,[r,100*(o=(o/=(t=(2-s)*a)<=1?t:2-t)||0),100*(i/=2)]},r.hwb.rgb=function(e){var t,o,i,r,s,n,a,c=e[0]/360,l=e[1]/100,h=e[2]/100,d=l+h;switch(d>1&&(l/=d,h/=d),i=6*c-(t=Math.floor(6*c)),0!=(1&t)&&(i=1-i),r=l+i*((o=1-h)-l),t){default:case 6:case 0:s=o,n=r,a=l;break;case 1:s=r,n=o,a=l;break;case 2:s=l,n=o,a=r;break;case 3:s=l,n=r,a=o;break;case 4:s=r,n=l,a=o;break;case 5:s=o,n=l,a=r}return[255*s,255*n,255*a]},r.cmyk.rgb=function(e){var t=e[0]/100,o=e[1]/100,i=e[2]/100,r=e[3]/100;return[255*(1-Math.min(1,t*(1-r)+r)),255*(1-Math.min(1,o*(1-r)+r)),255*(1-Math.min(1,i*(1-r)+r))]},r.xyz.rgb=function(e){var t,o,i,r=e[0]/100,s=e[1]/100,n=e[2]/100;return o=-.9689*r+1.8758*s+.0415*n,i=.0557*r+-.204*s+1.057*n,t=(t=3.2406*r+-1.5372*s+-.4986*n)>.0031308?1.055*Math.pow(t,1/2.4)-.055:12.92*t,o=o>.0031308?1.055*Math.pow(o,1/2.4)-.055:12.92*o,i=i>.0031308?1.055*Math.pow(i,1/2.4)-.055:12.92*i,[255*(t=Math.min(Math.max(0,t),1)),255*(o=Math.min(Math.max(0,o),1)),255*(i=Math.min(Math.max(0,i),1))]},r.xyz.lab=function(e){var t=e[0],o=e[1],i=e[2];return o/=100,i/=108.883,t=(t/=95.047)>.008856?Math.pow(t,1/3):7.787*t+16/116,[116*(o=o>.008856?Math.pow(o,1/3):7.787*o+16/116)-16,500*(t-o),200*(o-(i=i>.008856?Math.pow(i,1/3):7.787*i+16/116))]},r.lab.xyz=function(e){var t,o,i,r=e[0];t=e[1]/500+(o=(r+16)/116),i=o-e[2]/200;var s=Math.pow(o,3),n=Math.pow(t,3),a=Math.pow(i,3);return o=s>.008856?s:(o-16/116)/7.787,t=n>.008856?n:(t-16/116)/7.787,i=a>.008856?a:(i-16/116)/7.787,[t*=95.047,o*=100,i*=108.883]},r.lab.lch=function(e){var t,o=e[0],i=e[1],r=e[2];return(t=360*Math.atan2(r,i)/2/Math.PI)<0&&(t+=360),[o,Math.sqrt(i*i+r*r),t]},r.lch.lab=function(e){var t,o=e[0],i=e[1];return t=e[2]/360*2*Math.PI,[o,i*Math.cos(t),i*Math.sin(t)]},r.rgb.ansi16=function(e){var t=e[0],o=e[1],i=e[2],s=1 in arguments?arguments[1]:r.rgb.hsv(e)[2];if(0===(s=Math.round(s/50)))return 30;var n=30+(Math.round(i/255)<<2|Math.round(o/255)<<1|Math.round(t/255));return 2===s&&(n+=60),n},r.hsv.ansi16=function(e){return r.rgb.ansi16(r.hsv.rgb(e),e[2])},r.rgb.ansi256=function(e){var t=e[0],o=e[1],i=e[2];return t===o&&o===i?t<8?16:t>248?231:Math.round((t-8)/247*24)+232:16+36*Math.round(t/255*5)+6*Math.round(o/255*5)+Math.round(i/255*5)},r.ansi16.rgb=function(e){var t=e%10;if(0===t||7===t)return e>50&&(t+=3.5),[t=t/10.5*255,t,t];var o=.5*(1+~~(e>50));return[(1&t)*o*255,(t>>1&1)*o*255,(t>>2&1)*o*255]},r.ansi256.rgb=function(e){if(e>=232){var t=10*(e-232)+8;return[t,t,t]}var o;return e-=16,[Math.floor(e/36)/5*255,Math.floor((o=e%36)/6)/5*255,o%6/5*255]},r.rgb.hex=function(e){var t=(((255&Math.round(e[0]))<<16)+((255&Math.round(e[1]))<<8)+(255&Math.round(e[2]))).toString(16).toUpperCase();return"000000".substring(t.length)+t},r.hex.rgb=function(e){var t=e.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);if(!t)return[0,0,0];var o=t[0];3===t[0].length&&(o=o.split("").map((function(e){return e+e})).join(""));var i=parseInt(o,16);return[i>>16&255,i>>8&255,255&i]},r.rgb.hcg=function(e){var t,o=e[0]/255,i=e[1]/255,r=e[2]/255,s=Math.max(Math.max(o,i),r),n=Math.min(Math.min(o,i),r),a=s-n;return t=a<=0?0:s===o?(i-r)/a%6:s===i?2+(r-o)/a:4+(o-i)/a+4,t/=6,[360*(t%=1),100*a,100*(a<1?n/(1-a):0)]},r.hsl.hcg=function(e){var t,o=e[1]/100,i=e[2]/100,r=0;return(t=i<.5?2*o*i:2*o*(1-i))<1&&(r=(i-.5*t)/(1-t)),[e[0],100*t,100*r]},r.hsv.hcg=function(e){var t=e[1]/100,o=e[2]/100,i=t*o,r=0;return i<1&&(r=(o-i)/(1-i)),[e[0],100*i,100*r]},r.hcg.rgb=function(e){var t=e[0]/360,o=e[1]/100,i=e[2]/100;if(0===o)return[255*i,255*i,255*i];var r,s=[0,0,0],n=t%1*6,a=n%1,c=1-a;switch(Math.floor(n)){case 0:s[0]=1,s[1]=a,s[2]=0;break;case 1:s[0]=c,s[1]=1,s[2]=0;break;case 2:s[0]=0,s[1]=1,s[2]=a;break;case 3:s[0]=0,s[1]=c,s[2]=1;break;case 4:s[0]=a,s[1]=0,s[2]=1;break;default:s[0]=1,s[1]=0,s[2]=c}return r=(1-o)*i,[255*(o*s[0]+r),255*(o*s[1]+r),255*(o*s[2]+r)]},r.hcg.hsv=function(e){var t=e[1]/100,o=t+e[2]/100*(1-t),i=0;return o>0&&(i=t/o),[e[0],100*i,100*o]},r.hcg.hsl=function(e){var t=e[1]/100,o=e[2]/100*(1-t)+.5*t,i=0;return o>0&&o<.5?i=t/(2*o):o>=.5&&o<1&&(i=t/(2*(1-o))),[e[0],100*i,100*o]},r.hcg.hwb=function(e){var t=e[1]/100,o=t+e[2]/100*(1-t);return[e[0],100*(o-t),100*(1-o)]},r.hwb.hcg=function(e){var t=e[1]/100,o=1-e[2]/100,i=o-t,r=0;return i<1&&(r=(o-i)/(1-i)),[e[0],100*i,100*r]},r.apple.rgb=function(e){return[e[0]/65535*255,e[1]/65535*255,e[2]/65535*255]},r.rgb.apple=function(e){return[e[0]/255*65535,e[1]/255*65535,e[2]/255*65535]},r.gray.rgb=function(e){return[e[0]/100*255,e[0]/100*255,e[0]/100*255]},r.gray.hsl=r.gray.hsv=function(e){return[0,0,e[0]]},r.gray.hwb=function(e){return[0,100,e[0]]},r.gray.cmyk=function(e){return[0,0,0,e[0]]},r.gray.lab=function(e){return[e[0],0,0]},r.gray.hex=function(e){var t=255&Math.round(e[0]/100*255),o=((t<<16)+(t<<8)+t).toString(16).toUpperCase();return"000000".substring(o.length)+o},r.rgb.gray=function(e){return[(e[0]+e[1]+e[2])/3/255*100]}},t(o={exports:{}}),o.exports);function s(e,t){return function(o){return t(e(o))}}function n(e,t){for(var o=[t[e].parent,e],i=r[t[e].parent][e],n=t[e].parent;t[n].parent;)o.unshift(t[n].parent),i=s(r[t[n].parent][n],i),n=t[n].parent;return i.conversion=o,i}r.rgb,r.hsl,r.hsv,r.hwb,r.cmyk,r.xyz,r.lab,r.lch,r.hex,r.keyword,r.ansi16,r.ansi256,r.hcg,r.apple,r.gray;var a={};Object.keys(r).forEach((function(e){a[e]={},Object.defineProperty(a[e],"channels",{value:r[e].channels}),Object.defineProperty(a[e],"labels",{value:r[e].labels});var t=function(e){for(var t=function(e){var t=function(){for(var e={},t=Object.keys(r),o=t.length,i=0;i<o;i++)e[t[i]]={distance:-1,parent:null};return e}(),o=[e];for(t[e].distance=0;o.length;)for(var i=o.pop(),s=Object.keys(r[i]),n=s.length,a=0;a<n;a++){var c=s[a],l=t[c];-1===l.distance&&(l.distance=t[i].distance+1,l.parent=i,o.unshift(c))}return t}(e),o={},i=Object.keys(t),s=i.length,a=0;a<s;a++){var c=i[a];null!==t[c].parent&&(o[c]=n(c,t))}return o}(e);Object.keys(t).forEach((function(o){var i=t[o];a[e][o]=function(e){var t=function(t){if(null==t)return t;arguments.length>1&&(t=Array.prototype.slice.call(arguments));var o=e(t);if("object"==typeof o)for(var i=o.length,r=0;r<i;r++)o[r]=Math.round(o[r]);return o};return"conversion"in e&&(t.conversion=e.conversion),t}(i),a[e][o].raw=function(e){var t=function(t){return null==t?t:(arguments.length>1&&(t=Array.prototype.slice.call(arguments)),e(t))};return"conversion"in e&&(t.conversion=e.conversion),t}(i)}))}));var c=a,l={aliceblue:[240,248,255],antiquewhite:[250,235,215],aqua:[0,255,255],aquamarine:[127,255,212],azure:[240,255,255],beige:[245,245,220],bisque:[255,228,196],black:[0,0,0],blanchedalmond:[255,235,205],blue:[0,0,255],blueviolet:[138,43,226],brown:[165,42,42],burlywood:[222,184,135],cadetblue:[95,158,160],chartreuse:[127,255,0],chocolate:[210,105,30],coral:[255,127,80],cornflowerblue:[100,149,237],cornsilk:[255,248,220],crimson:[220,20,60],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgoldenrod:[184,134,11],darkgray:[169,169,169],darkgreen:[0,100,0],darkgrey:[169,169,169],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkseagreen:[143,188,143],darkslateblue:[72,61,139],darkslategray:[47,79,79],darkslategrey:[47,79,79],darkturquoise:[0,206,209],darkviolet:[148,0,211],deeppink:[255,20,147],deepskyblue:[0,191,255],dimgray:[105,105,105],dimgrey:[105,105,105],dodgerblue:[30,144,255],firebrick:[178,34,34],floralwhite:[255,250,240],forestgreen:[34,139,34],fuchsia:[255,0,255],gainsboro:[220,220,220],ghostwhite:[248,248,255],gold:[255,215,0],goldenrod:[218,165,32],gray:[128,128,128],green:[0,128,0],greenyellow:[173,255,47],grey:[128,128,128],honeydew:[240,255,240],hotpink:[255,105,180],indianred:[205,92,92],indigo:[75,0,130],ivory:[255,255,240],khaki:[240,230,140],lavender:[230,230,250],lavenderblush:[255,240,245],lawngreen:[124,252,0],lemonchiffon:[255,250,205],lightblue:[173,216,230],lightcoral:[240,128,128],lightcyan:[224,255,255],lightgoldenrodyellow:[250,250,210],lightgray:[211,211,211],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightsalmon:[255,160,122],lightseagreen:[32,178,170],lightskyblue:[135,206,250],lightslategray:[119,136,153],lightslategrey:[119,136,153],lightsteelblue:[176,196,222],lightyellow:[255,255,224],lime:[0,255,0],limegreen:[50,205,50],linen:[250,240,230],magenta:[255,0,255],maroon:[128,0,0],mediumaquamarine:[102,205,170],mediumblue:[0,0,205],mediumorchid:[186,85,211],mediumpurple:[147,112,219],mediumseagreen:[60,179,113],mediumslateblue:[123,104,238],mediumspringgreen:[0,250,154],mediumturquoise:[72,209,204],mediumvioletred:[199,21,133],midnightblue:[25,25,112],mintcream:[245,255,250],mistyrose:[255,228,225],moccasin:[255,228,181],navajowhite:[255,222,173],navy:[0,0,128],oldlace:[253,245,230],olive:[128,128,0],olivedrab:[107,142,35],orange:[255,165,0],orangered:[255,69,0],orchid:[218,112,214],palegoldenrod:[238,232,170],palegreen:[152,251,152],paleturquoise:[175,238,238],palevioletred:[219,112,147],papayawhip:[255,239,213],peachpuff:[255,218,185],peru:[205,133,63],pink:[255,192,203],plum:[221,160,221],powderblue:[176,224,230],purple:[128,0,128],rebeccapurple:[102,51,153],red:[255,0,0],rosybrown:[188,143,143],royalblue:[65,105,225],saddlebrown:[139,69,19],salmon:[250,128,114],sandybrown:[244,164,96],seagreen:[46,139,87],seashell:[255,245,238],sienna:[160,82,45],silver:[192,192,192],skyblue:[135,206,235],slateblue:[106,90,205],slategray:[112,128,144],slategrey:[112,128,144],snow:[255,250,250],springgreen:[0,255,127],steelblue:[70,130,180],tan:[210,180,140],teal:[0,128,128],thistle:[216,191,216],tomato:[255,99,71],turquoise:[64,224,208],violet:[238,130,238],wheat:[245,222,179],white:[255,255,255],whitesmoke:[245,245,245],yellow:[255,255,0],yellowgreen:[154,205,50]},h={getRgba:d,getHsla:p,getRgb:function(e){var t=d(e);return t&&t.slice(0,3)},getHsl:function(e){var t=p(e);return t&&t.slice(0,3)},getHwb:u,getAlpha:function(e){var t=d(e);return t||(t=p(e))||(t=u(e))?t[3]:void 0},hexString:function(e,t){return t=void 0!==t&&3===e.length?t:e[3],"#"+v(e[0])+v(e[1])+v(e[2])+(t>=0&&t<1?v(Math.round(255*t)):"")},rgbString:function(e,t){return t<1||e[3]&&e[3]<1?m(e,t):"rgb("+e[0]+", "+e[1]+", "+e[2]+")"},rgbaString:m,percentString:function(e,t){return t<1||e[3]&&e[3]<1?f(e,t):"rgb("+Math.round(e[0]/255*100)+"%, "+Math.round(e[1]/255*100)+"%, "+Math.round(e[2]/255*100)+"%)"},percentaString:f,hslString:function(e,t){return t<1||e[3]&&e[3]<1?g(e,t):"hsl("+e[0]+", "+e[1]+"%, "+e[2]+"%)"},hslaString:g,hwbString:function(e,t){return void 0===t&&(t=void 0!==e[3]?e[3]:1),"hwb("+e[0]+", "+e[1]+"%, "+e[2]+"%"+(void 0!==t&&1!==t?", "+t:"")+")"},keyword:function(e){return y[e.slice(0,3)]}};function d(e){if(e){var t=[0,0,0],o=1,i=e.match(/^#([a-fA-F0-9]{3,4})$/i),r="";if(i){r=(i=i[1])[3];for(var s=0;s<t.length;s++)t[s]=parseInt(i[s]+i[s],16);r&&(o=Math.round(parseInt(r+r,16)/255*100)/100)}else if(i=e.match(/^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i)){for(r=i[2],i=i[1],s=0;s<t.length;s++)t[s]=parseInt(i.slice(2*s,2*s+2),16);r&&(o=Math.round(parseInt(r,16)/255*100)/100)}else if(i=e.match(/^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i)){for(s=0;s<t.length;s++)t[s]=parseInt(i[s+1]);o=parseFloat(i[4])}else if(i=e.match(/^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i)){for(s=0;s<t.length;s++)t[s]=Math.round(2.55*parseFloat(i[s+1]));o=parseFloat(i[4])}else if(i=e.match(/(\w+)/)){if("transparent"==i[1])return[0,0,0,0];if(!(t=l[i[1]]))return}for(s=0;s<t.length;s++)t[s]=b(t[s],0,255);return o=o||0==o?b(o,0,1):1,t[3]=o,t}}function p(e){if(e){var t=e.match(/^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/);if(t){var o=parseFloat(t[4]);return[b(parseInt(t[1]),0,360),b(parseFloat(t[2]),0,100),b(parseFloat(t[3]),0,100),b(isNaN(o)?1:o,0,1)]}}}function u(e){if(e){var t=e.match(/^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/);if(t){var o=parseFloat(t[4]);return[b(parseInt(t[1]),0,360),b(parseFloat(t[2]),0,100),b(parseFloat(t[3]),0,100),b(isNaN(o)?1:o,0,1)]}}}function m(e,t){return void 0===t&&(t=void 0!==e[3]?e[3]:1),"rgba("+e[0]+", "+e[1]+", "+e[2]+", "+t+")"}function f(e,t){return"rgba("+Math.round(e[0]/255*100)+"%, "+Math.round(e[1]/255*100)+"%, "+Math.round(e[2]/255*100)+"%, "+(t||e[3]||1)+")"}function g(e,t){return void 0===t&&(t=void 0!==e[3]?e[3]:1),"hsla("+e[0]+", "+e[1]+"%, "+e[2]+"%, "+t+")"}function b(e,t,o){return Math.min(Math.max(t,e),o)}function v(e){var t=e.toString(16).toUpperCase();return t.length<2?"0"+t:t}var y={};for(var w in l)y[l[w]]=w;var x=function(e){return e instanceof x?e:this instanceof x?(this.valid=!1,this.values={rgb:[0,0,0],hsl:[0,0,0],hsv:[0,0,0],hwb:[0,0,0],cmyk:[0,0,0,0],alpha:1},void("string"==typeof e?(t=h.getRgba(e))?this.setValues("rgb",t):(t=h.getHsla(e))?this.setValues("hsl",t):(t=h.getHwb(e))&&this.setValues("hwb",t):"object"==typeof e&&(void 0!==(t=e).r||void 0!==t.red?this.setValues("rgb",t):void 0!==t.l||void 0!==t.lightness?this.setValues("hsl",t):void 0!==t.v||void 0!==t.value?this.setValues("hsv",t):void 0!==t.w||void 0!==t.whiteness?this.setValues("hwb",t):void 0===t.c&&void 0===t.cyan||this.setValues("cmyk",t)))):new x(e);var t};x.prototype={isValid:function(){return this.valid},rgb:function(){return this.setSpace("rgb",arguments)},hsl:function(){return this.setSpace("hsl",arguments)},hsv:function(){return this.setSpace("hsv",arguments)},hwb:function(){return this.setSpace("hwb",arguments)},cmyk:function(){return this.setSpace("cmyk",arguments)},rgbArray:function(){return this.values.rgb},hslArray:function(){return this.values.hsl},hsvArray:function(){return this.values.hsv},hwbArray:function(){var e=this.values;return 1!==e.alpha?e.hwb.concat([e.alpha]):e.hwb},cmykArray:function(){return this.values.cmyk},rgbaArray:function(){var e=this.values;return e.rgb.concat([e.alpha])},hslaArray:function(){var e=this.values;return e.hsl.concat([e.alpha])},alpha:function(e){return void 0===e?this.values.alpha:(this.setValues("alpha",e),this)},red:function(e){return this.setChannel("rgb",0,e)},green:function(e){return this.setChannel("rgb",1,e)},blue:function(e){return this.setChannel("rgb",2,e)},hue:function(e){return e&&(e=(e%=360)<0?360+e:e),this.setChannel("hsl",0,e)},saturation:function(e){return this.setChannel("hsl",1,e)},lightness:function(e){return this.setChannel("hsl",2,e)},saturationv:function(e){return this.setChannel("hsv",1,e)},whiteness:function(e){return this.setChannel("hwb",1,e)},blackness:function(e){return this.setChannel("hwb",2,e)},value:function(e){return this.setChannel("hsv",2,e)},cyan:function(e){return this.setChannel("cmyk",0,e)},magenta:function(e){return this.setChannel("cmyk",1,e)},yellow:function(e){return this.setChannel("cmyk",2,e)},black:function(e){return this.setChannel("cmyk",3,e)},hexString:function(){return h.hexString(this.values.rgb)},rgbString:function(){return h.rgbString(this.values.rgb,this.values.alpha)},rgbaString:function(){return h.rgbaString(this.values.rgb,this.values.alpha)},percentString:function(){return h.percentString(this.values.rgb,this.values.alpha)},hslString:function(){return h.hslString(this.values.hsl,this.values.alpha)},hslaString:function(){return h.hslaString(this.values.hsl,this.values.alpha)},hwbString:function(){return h.hwbString(this.values.hwb,this.values.alpha)},keyword:function(){return h.keyword(this.values.rgb,this.values.alpha)},rgbNumber:function(){var e=this.values.rgb;return e[0]<<16|e[1]<<8|e[2]},luminosity:function(){for(var e=this.values.rgb,t=[],o=0;o<e.length;o++){var i=e[o]/255;t[o]=i<=.03928?i/12.92:Math.pow((i+.055)/1.055,2.4)}return.2126*t[0]+.7152*t[1]+.0722*t[2]},contrast:function(e){var t=this.luminosity(),o=e.luminosity();return t>o?(t+.05)/(o+.05):(o+.05)/(t+.05)},level:function(e){var t=this.contrast(e);return t>=7.1?"AAA":t>=4.5?"AA":""},dark:function(){var e=this.values.rgb;return(299*e[0]+587*e[1]+114*e[2])/1e3<128},light:function(){return!this.dark()},negate:function(){for(var e=[],t=0;t<3;t++)e[t]=255-this.values.rgb[t];return this.setValues("rgb",e),this},lighten:function(e){var t=this.values.hsl;return t[2]+=t[2]*e,this.setValues("hsl",t),this},darken:function(e){var t=this.values.hsl;return t[2]-=t[2]*e,this.setValues("hsl",t),this},saturate:function(e){var t=this.values.hsl;return t[1]+=t[1]*e,this.setValues("hsl",t),this},desaturate:function(e){var t=this.values.hsl;return t[1]-=t[1]*e,this.setValues("hsl",t),this},whiten:function(e){var t=this.values.hwb;return t[1]+=t[1]*e,this.setValues("hwb",t),this},blacken:function(e){var t=this.values.hwb;return t[2]+=t[2]*e,this.setValues("hwb",t),this},greyscale:function(){var e=this.values.rgb,t=.3*e[0]+.59*e[1]+.11*e[2];return this.setValues("rgb",[t,t,t]),this},clearer:function(e){var t=this.values.alpha;return this.setValues("alpha",t-t*e),this},opaquer:function(e){var t=this.values.alpha;return this.setValues("alpha",t+t*e),this},rotate:function(e){var t=this.values.hsl,o=(t[0]+e)%360;return t[0]=o<0?360+o:o,this.setValues("hsl",t),this},mix:function(e,t){var o=this,i=e,r=void 0===t?.5:t,s=2*r-1,n=o.alpha()-i.alpha(),a=((s*n==-1?s:(s+n)/(1+s*n))+1)/2,c=1-a;return this.rgb(a*o.red()+c*i.red(),a*o.green()+c*i.green(),a*o.blue()+c*i.blue()).alpha(o.alpha()*r+i.alpha()*(1-r))},toJSON:function(){return this.rgb()},clone:function(){var e,t,o=new x,i=this.values,r=o.values;for(var s in i)i.hasOwnProperty(s)&&(e=i[s],"[object Array]"===(t={}.toString.call(e))?r[s]=e.slice(0):"[object Number]"===t?r[s]=e:console.error("unexpected color value:",e));return o}},x.prototype.spaces={rgb:["red","green","blue"],hsl:["hue","saturation","lightness"],hsv:["hue","saturation","value"],hwb:["hue","whiteness","blackness"],cmyk:["cyan","magenta","yellow","black"]},x.prototype.maxes={rgb:[255,255,255],hsl:[360,100,100],hsv:[360,100,100],hwb:[360,100,100],cmyk:[100,100,100,100]},x.prototype.getValues=function(e){for(var t=this.values,o={},i=0;i<e.length;i++)o[e.charAt(i)]=t[e][i];return 1!==t.alpha&&(o.a=t.alpha),o},x.prototype.setValues=function(e,t){var o,i,r=this.values,s=this.spaces,n=this.maxes,a=1;if(this.valid=!0,"alpha"===e)a=t;else if(t.length)r[e]=t.slice(0,e.length),a=t[e.length];else if(void 0!==t[e.charAt(0)]){for(o=0;o<e.length;o++)r[e][o]=t[e.charAt(o)];a=t.a}else if(void 0!==t[s[e][0]]){var l=s[e];for(o=0;o<e.length;o++)r[e][o]=t[l[o]];a=t.alpha}if(r.alpha=Math.max(0,Math.min(1,void 0===a?r.alpha:a)),"alpha"===e)return!1;for(o=0;o<e.length;o++)i=Math.max(0,Math.min(n[e][o],r[e][o])),r[e][o]=Math.round(i);for(var h in s)h!==e&&(r[h]=c[e][h](r[e]));return!0},x.prototype.setSpace=function(e,t){var o=t[0];return void 0===o?this.getValues(e):("number"==typeof o&&(o=Array.prototype.slice.call(t)),this.setValues(e,o),this)},x.prototype.setChannel=function(e,t,o){var i=this.values[e];return void 0===o?i[t]:(o===i[t]||(i[t]=o,this.setValues(e,i)),this)},"undefined"!=typeof window&&(window.Color=x);var _=x;function k(e){return-1===["__proto__","prototype","constructor"].indexOf(e)}var C,E={noop:function(){},uid:(C=0,function(){return C++}),isNullOrUndef:function(e){return null==e},isArray:function(e){if(Array.isArray&&Array.isArray(e))return!0;var t=Object.prototype.toString.call(e);return"[object"===t.substr(0,7)&&"Array]"===t.substr(-6)},isObject:function(e){return null!==e&&"[object Object]"===Object.prototype.toString.call(e)},isFinite:function(e){return("number"==typeof e||e instanceof Number)&&isFinite(e)},valueOrDefault:function(e,t){return void 0===e?t:e},valueAtIndexOrDefault:function(e,t,o){return E.valueOrDefault(E.isArray(e)?e[t]:e,o)},callback:function(e,t,o){if(e&&"function"==typeof e.call)return e.apply(o,t)},each:function(e,t,o,i){var r,s,n;if(E.isArray(e))if(s=e.length,i)for(r=s-1;r>=0;r--)t.call(o,e[r],r);else for(r=0;r<s;r++)t.call(o,e[r],r);else if(E.isObject(e))for(s=(n=Object.keys(e)).length,r=0;r<s;r++)t.call(o,e[n[r]],n[r])},arrayEquals:function(e,t){var o,i,r,s;if(!e||!t||e.length!==t.length)return!1;for(o=0,i=e.length;o<i;++o)if(r=e[o],s=t[o],r instanceof Array&&s instanceof Array){if(!E.arrayEquals(r,s))return!1}else if(r!==s)return!1;return!0},clone:function(e){if(E.isArray(e))return e.map(E.clone);if(E.isObject(e)){for(var t=Object.create(e),o=Object.keys(e),i=o.length,r=0;r<i;++r)t[o[r]]=E.clone(e[o[r]]);return t}return e},_merger:function(e,t,o,i){if(k(e)){var r=t[e],s=o[e];E.isObject(r)&&E.isObject(s)?E.merge(r,s,i):t[e]=E.clone(s)}},_mergerIf:function(e,t,o){if(k(e)){var i=t[e],r=o[e];E.isObject(i)&&E.isObject(r)?E.mergeIf(i,r):t.hasOwnProperty(e)||(t[e]=E.clone(r))}},merge:function(e,t,o){var i,r,s,n,a,c=E.isArray(t)?t:[t],l=c.length;if(!E.isObject(e))return e;for(i=(o=o||{}).merger||E._merger,r=0;r<l;++r)if(t=c[r],E.isObject(t))for(a=0,n=(s=Object.keys(t)).length;a<n;++a)i(s[a],e,t,o);return e},mergeIf:function(e,t){return E.merge(e,t,{merger:E._mergerIf})},extend:Object.assign||function(e){return E.merge(e,[].slice.call(arguments,1),{merger:function(e,t,o){t[e]=o[e]}})},inherits:function(e){var t=this,o=e&&e.hasOwnProperty("constructor")?e.constructor:function(){return t.apply(this,arguments)},i=function(){this.constructor=o};return i.prototype=t.prototype,o.prototype=new i,o.extend=E.inherits,e&&E.extend(o.prototype,e),o.__super__=t.prototype,o},_deprecated:function(e,t,o,i){void 0!==t&&console.warn(e+': "'+o+'" is deprecated. Please use "'+i+'" instead')}},z=E;E.callCallback=E.callback,E.indexOf=function(e,t,o){return Array.prototype.indexOf.call(e,t,o)},E.getValueOrDefault=E.valueOrDefault,E.getValueAtIndexOrDefault=E.valueAtIndexOrDefault;var A={linear:function(e){return e},easeInQuad:function(e){return e*e},easeOutQuad:function(e){return-e*(e-2)},easeInOutQuad:function(e){return(e/=.5)<1?.5*e*e:-.5*(--e*(e-2)-1)},easeInCubic:function(e){return e*e*e},easeOutCubic:function(e){return(e-=1)*e*e+1},easeInOutCubic:function(e){return(e/=.5)<1?.5*e*e*e:.5*((e-=2)*e*e+2)},easeInQuart:function(e){return e*e*e*e},easeOutQuart:function(e){return-((e-=1)*e*e*e-1)},easeInOutQuart:function(e){return(e/=.5)<1?.5*e*e*e*e:-.5*((e-=2)*e*e*e-2)},easeInQuint:function(e){return e*e*e*e*e},easeOutQuint:function(e){return(e-=1)*e*e*e*e+1},easeInOutQuint:function(e){return(e/=.5)<1?.5*e*e*e*e*e:.5*((e-=2)*e*e*e*e+2)},easeInSine:function(e){return 1-Math.cos(e*(Math.PI/2))},easeOutSine:function(e){return Math.sin(e*(Math.PI/2))},easeInOutSine:function(e){return-.5*(Math.cos(Math.PI*e)-1)},easeInExpo:function(e){return 0===e?0:Math.pow(2,10*(e-1))},easeOutExpo:function(e){return 1===e?1:1-Math.pow(2,-10*e)},easeInOutExpo:function(e){return 0===e?0:1===e?1:(e/=.5)<1?.5*Math.pow(2,10*(e-1)):.5*(2-Math.pow(2,-10*--e))},easeInCirc:function(e){return e>=1?e:-(Math.sqrt(1-e*e)-1)},easeOutCirc:function(e){return Math.sqrt(1-(e-=1)*e)},easeInOutCirc:function(e){return(e/=.5)<1?-.5*(Math.sqrt(1-e*e)-1):.5*(Math.sqrt(1-(e-=2)*e)+1)},easeInElastic:function(e){var t=1.70158,o=0,i=1;return 0===e?0:1===e?1:(o||(o=.3),i<1?(i=1,t=o/4):t=o/(2*Math.PI)*Math.asin(1/i),-i*Math.pow(2,10*(e-=1))*Math.sin((e-t)*(2*Math.PI)/o))},easeOutElastic:function(e){var t=1.70158,o=0,i=1;return 0===e?0:1===e?1:(o||(o=.3),i<1?(i=1,t=o/4):t=o/(2*Math.PI)*Math.asin(1/i),i*Math.pow(2,-10*e)*Math.sin((e-t)*(2*Math.PI)/o)+1)},easeInOutElastic:function(e){var t=1.70158,o=0,i=1;return 0===e?0:2==(e/=.5)?1:(o||(o=.45),i<1?(i=1,t=o/4):t=o/(2*Math.PI)*Math.asin(1/i),e<1?i*Math.pow(2,10*(e-=1))*Math.sin((e-t)*(2*Math.PI)/o)*-.5:i*Math.pow(2,-10*(e-=1))*Math.sin((e-t)*(2*Math.PI)/o)*.5+1)},easeInBack:function(e){var t=1.70158;return e*e*((t+1)*e-t)},easeOutBack:function(e){var t=1.70158;return(e-=1)*e*((t+1)*e+t)+1},easeInOutBack:function(e){var t=1.70158;return(e/=.5)<1?e*e*((1+(t*=1.525))*e-t)*.5:.5*((e-=2)*e*((1+(t*=1.525))*e+t)+2)},easeInBounce:function(e){return 1-A.easeOutBounce(1-e)},easeOutBounce:function(e){return e<1/2.75?7.5625*e*e:e<2/2.75?7.5625*(e-=1.5/2.75)*e+.75:e<2.5/2.75?7.5625*(e-=2.25/2.75)*e+.9375:7.5625*(e-=2.625/2.75)*e+.984375},easeInOutBounce:function(e){return e<.5?.5*A.easeInBounce(2*e):.5*A.easeOutBounce(2*e-1)+.5}},S={effects:A};z.easingEffects=A;var M=Math.PI,D=M/180,B=2*M,T=M/2,R=M/4,L=2*M/3,P={clear:function(e){e.ctx.clearRect(0,0,e.width,e.height)},roundedRect:function(e,t,o,i,r,s){if(s){var n=Math.min(s,r/2,i/2),a=t+n,c=o+n,l=t+i-n,h=o+r-n;e.moveTo(t,c),a<l&&c<h?(e.arc(a,c,n,-M,-T),e.arc(l,c,n,-T,0),e.arc(l,h,n,0,T),e.arc(a,h,n,T,M)):a<l?(e.moveTo(a,o),e.arc(l,c,n,-T,T),e.arc(a,c,n,T,M+T)):c<h?(e.arc(a,c,n,-M,0),e.arc(a,h,n,0,M)):e.arc(a,c,n,-M,M),e.closePath(),e.moveTo(t,o)}else e.rect(t,o,i,r)},drawPoint:function(e,t,o,i,r,s){var n,a,c,l,h,d=(s||0)*D;if(t&&"object"==typeof t&&("[object HTMLImageElement]"===(n=t.toString())||"[object HTMLCanvasElement]"===n))return e.save(),e.translate(i,r),e.rotate(d),e.drawImage(t,-t.width/2,-t.height/2,t.width,t.height),void e.restore();if(!(isNaN(o)||o<=0)){switch(e.beginPath(),t){default:e.arc(i,r,o,0,B),e.closePath();break;case"triangle":e.moveTo(i+Math.sin(d)*o,r-Math.cos(d)*o),d+=L,e.lineTo(i+Math.sin(d)*o,r-Math.cos(d)*o),d+=L,e.lineTo(i+Math.sin(d)*o,r-Math.cos(d)*o),e.closePath();break;case"rectRounded":l=o-(h=.516*o),a=Math.cos(d+R)*l,c=Math.sin(d+R)*l,e.arc(i-a,r-c,h,d-M,d-T),e.arc(i+c,r-a,h,d-T,d),e.arc(i+a,r+c,h,d,d+T),e.arc(i-c,r+a,h,d+T,d+M),e.closePath();break;case"rect":if(!s){l=Math.SQRT1_2*o,e.rect(i-l,r-l,2*l,2*l);break}d+=R;case"rectRot":a=Math.cos(d)*o,c=Math.sin(d)*o,e.moveTo(i-a,r-c),e.lineTo(i+c,r-a),e.lineTo(i+a,r+c),e.lineTo(i-c,r+a),e.closePath();break;case"crossRot":d+=R;case"cross":a=Math.cos(d)*o,c=Math.sin(d)*o,e.moveTo(i-a,r-c),e.lineTo(i+a,r+c),e.moveTo(i+c,r-a),e.lineTo(i-c,r+a);break;case"star":a=Math.cos(d)*o,c=Math.sin(d)*o,e.moveTo(i-a,r-c),e.lineTo(i+a,r+c),e.moveTo(i+c,r-a),e.lineTo(i-c,r+a),d+=R,a=Math.cos(d)*o,c=Math.sin(d)*o,e.moveTo(i-a,r-c),e.lineTo(i+a,r+c),e.moveTo(i+c,r-a),e.lineTo(i-c,r+a);break;case"line":a=Math.cos(d)*o,c=Math.sin(d)*o,e.moveTo(i-a,r-c),e.lineTo(i+a,r+c);break;case"dash":e.moveTo(i,r),e.lineTo(i+Math.cos(d)*o,r+Math.sin(d)*o)}e.fill(),e.stroke()}},_isPointInArea:function(e,t){var o=1e-6;return e.x>t.left-o&&e.x<t.right+o&&e.y>t.top-o&&e.y<t.bottom+o},clipArea:function(e,t){e.save(),e.beginPath(),e.rect(t.left,t.top,t.right-t.left,t.bottom-t.top),e.clip()},unclipArea:function(e){e.restore()},lineTo:function(e,t,o,i){var r=o.steppedLine;if(r){if("middle"===r){var s=(t.x+o.x)/2;e.lineTo(s,i?o.y:t.y),e.lineTo(s,i?t.y:o.y)}else"after"===r&&!i||"after"!==r&&i?e.lineTo(t.x,o.y):e.lineTo(o.x,t.y);e.lineTo(o.x,o.y)}else o.tension?e.bezierCurveTo(i?t.controlPointPreviousX:t.controlPointNextX,i?t.controlPointPreviousY:t.controlPointNextY,i?o.controlPointNextX:o.controlPointPreviousX,i?o.controlPointNextY:o.controlPointPreviousY,o.x,o.y):e.lineTo(o.x,o.y)}},O=P;z.clear=P.clear,z.drawRoundedRectangle=function(e){e.beginPath(),P.roundedRect.apply(P,arguments)};var N={_set:function(e,t){return z.merge(this[e]||(this[e]={}),t)}};N._set("global",{defaultColor:"rgba(0,0,0,0.1)",defaultFontColor:"#666",defaultFontFamily:"'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",defaultFontSize:12,defaultFontStyle:"normal",defaultLineHeight:1.2,showLines:!0});var F=N,$=z.valueOrDefault,I={toLineHeight:function(e,t){var o=(""+e).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);if(!o||"normal"===o[1])return 1.2*t;switch(e=+o[2],o[3]){case"px":return e;case"%":e/=100}return t*e},toPadding:function(e){var t,o,i,r;return z.isObject(e)?(t=+e.top||0,o=+e.right||0,i=+e.bottom||0,r=+e.left||0):t=o=i=r=+e||0,{top:t,right:o,bottom:i,left:r,height:t+i,width:r+o}},_parseFont:function(e){var t=F.global,o=$(e.fontSize,t.defaultFontSize),i={family:$(e.fontFamily,t.defaultFontFamily),lineHeight:z.options.toLineHeight($(e.lineHeight,t.defaultLineHeight),o),size:o,style:$(e.fontStyle,t.defaultFontStyle),weight:null,string:""};return i.string=function(e){return!e||z.isNullOrUndef(e.size)||z.isNullOrUndef(e.family)?null:(e.style?e.style+" ":"")+(e.weight?e.weight+" ":"")+e.size+"px "+e.family}(i),i},resolve:function(e,t,o,i){var r,s,n,a=!0;for(r=0,s=e.length;r<s;++r)if(void 0!==(n=e[r])&&(void 0!==t&&"function"==typeof n&&(n=n(t),a=!1),void 0!==o&&z.isArray(n)&&(n=n[o],a=!1),void 0!==n))return i&&!a&&(i.cacheable=!1),n}},V={_factorize:function(e){var t,o=[],i=Math.sqrt(e);for(t=1;t<i;t++)e%t==0&&(o.push(t),o.push(e/t));return i===(0|i)&&o.push(i),o.sort((function(e,t){return e-t})).pop(),o},log10:Math.log10||function(e){var t=Math.log(e)*Math.LOG10E,o=Math.round(t);return e===Math.pow(10,o)?o:t}},H=V;z.log10=V.log10;var W=z,q=S,Y=O,j=I,U=H;W.easing=q,W.canvas=Y,W.options=j,W.math=U,W.rtl={getRtlAdapter:function(e,t,o){return e?function(e,t){return{x:function(o){return e+e+t-o},setWidth:function(e){t=e},textAlign:function(e){return"center"===e?e:"right"===e?"left":"right"},xPlus:function(e,t){return e-t},leftForLtr:function(e,t){return e-t}}}(t,o):{x:function(e){return e},setWidth:function(e){},textAlign:function(e){return e},xPlus:function(e,t){return e+t},leftForLtr:function(e,t){return e}}},overrideTextDirection:function(e,t){var o,i;"ltr"!==t&&"rtl"!==t||(i=[(o=e.canvas.style).getPropertyValue("direction"),o.getPropertyPriority("direction")],o.setProperty("direction",t,"important"),e.prevTextDirection=i)},restoreTextDirection:function(e){var t=e.prevTextDirection;void 0!==t&&(delete e.prevTextDirection,e.canvas.style.setProperty("direction",t[0],t[1]))}};var Z=function(e){W.extend(this,e),this.initialize.apply(this,arguments)};W.extend(Z.prototype,{_type:void 0,initialize:function(){this.hidden=!1},pivot:function(){var e=this;return e._view||(e._view=W.extend({},e._model)),e._start={},e},transition:function(e){var t=this,o=t._model,i=t._start,r=t._view;return o&&1!==e?(r||(r=t._view={}),i||(i=t._start={}),function(e,t,o,i){var r,s,n,a,c,l,h,d,p,u=Object.keys(o);for(r=0,s=u.length;r<s;++r)if(l=o[n=u[r]],t.hasOwnProperty(n)||(t[n]=l),(a=t[n])!==l&&"_"!==n[0]){if(e.hasOwnProperty(n)||(e[n]=a),(h=typeof l)==typeof(c=e[n]))if("string"===h){if((d=_(c)).valid&&(p=_(l)).valid){t[n]=p.mix(d,i).rgbString();continue}}else if(W.isFinite(c)&&W.isFinite(l)){t[n]=c+(l-c)*i;continue}t[n]=l}}(i,r,o,e),t):(t._view=W.extend({},o),t._start=null,t)},tooltipPosition:function(){return{x:this._model.x,y:this._model.y}},hasValue:function(){return W.isNumber(this._model.x)&&W.isNumber(this._model.y)}}),Z.extend=W.inherits;var K=Z,G=K.extend({chart:null,currentStep:0,numSteps:60,easing:"",render:null,onAnimationProgress:null,onAnimationComplete:null}),X=G;Object.defineProperty(G.prototype,"animationObject",{get:function(){return this}}),Object.defineProperty(G.prototype,"chartInstance",{get:function(){return this.chart},set:function(e){this.chart=e}}),F._set("global",{animation:{duration:1e3,easing:"easeOutQuart",onProgress:W.noop,onComplete:W.noop}});var J={animations:[],request:null,addAnimation:function(e,t,o,i){var r,s,n=this.animations;for(t.chart=e,t.startTime=Date.now(),t.duration=o,i||(e.animating=!0),r=0,s=n.length;r<s;++r)if(n[r].chart===e)return void(n[r]=t);n.push(t),1===n.length&&this.requestAnimationFrame()},cancelAnimation:function(e){var t=W.findIndex(this.animations,(function(t){return t.chart===e}));-1!==t&&(this.animations.splice(t,1),e.animating=!1)},requestAnimationFrame:function(){var e=this;null===e.request&&(e.request=W.requestAnimFrame.call(window,(function(){e.request=null,e.startDigest()})))},startDigest:function(){var e=this;e.advance(),e.animations.length>0&&e.requestAnimationFrame()},advance:function(){for(var e,t,o,i,r=this.animations,s=0;s<r.length;)t=(e=r[s]).chart,o=e.numSteps,i=Math.floor((Date.now()-e.startTime)/e.duration*o)+1,e.currentStep=Math.min(i,o),W.callback(e.render,[t,e],t),W.callback(e.onAnimationProgress,[e],t),e.currentStep>=o?(W.callback(e.onAnimationComplete,[e],t),t.animating=!1,r.splice(s,1)):++s}},Q=W.options.resolve,ee=["push","pop","shift","splice","unshift"];function te(e,t){var o=e._chartjs;if(o){var i=o.listeners,r=i.indexOf(t);-1!==r&&i.splice(r,1),i.length>0||(ee.forEach((function(t){delete e[t]})),delete e._chartjs)}}var oe=function(e,t){this.initialize(e,t)};W.extend(oe.prototype,{datasetElementType:null,dataElementType:null,_datasetElementOptions:["backgroundColor","borderCapStyle","borderColor","borderDash","borderDashOffset","borderJoinStyle","borderWidth"],_dataElementOptions:["backgroundColor","borderColor","borderWidth","pointStyle"],initialize:function(e,t){var o=this;o.chart=e,o.index=t,o.linkScales(),o.addElements(),o._type=o.getMeta().type},updateIndex:function(e){this.index=e},linkScales:function(){var e=this,t=e.getMeta(),o=e.chart,i=o.scales,r=e.getDataset(),s=o.options.scales;null!==t.xAxisID&&t.xAxisID in i&&!r.xAxisID||(t.xAxisID=r.xAxisID||s.xAxes[0].id),null!==t.yAxisID&&t.yAxisID in i&&!r.yAxisID||(t.yAxisID=r.yAxisID||s.yAxes[0].id)},getDataset:function(){return this.chart.data.datasets[this.index]},getMeta:function(){return this.chart.getDatasetMeta(this.index)},getScaleForId:function(e){return this.chart.scales[e]},_getValueScaleId:function(){return this.getMeta().yAxisID},_getIndexScaleId:function(){return this.getMeta().xAxisID},_getValueScale:function(){return this.getScaleForId(this._getValueScaleId())},_getIndexScale:function(){return this.getScaleForId(this._getIndexScaleId())},reset:function(){this._update(!0)},destroy:function(){this._data&&te(this._data,this)},createMetaDataset:function(){var e=this,t=e.datasetElementType;return t&&new t({_chart:e.chart,_datasetIndex:e.index})},createMetaData:function(e){var t=this,o=t.dataElementType;return o&&new o({_chart:t.chart,_datasetIndex:t.index,_index:e})},addElements:function(){var e,t,o=this,i=o.getMeta(),r=o.getDataset().data||[],s=i.data;for(e=0,t=r.length;e<t;++e)s[e]=s[e]||o.createMetaData(e);i.dataset=i.dataset||o.createMetaDataset()},addElementAndReset:function(e){var t=this.createMetaData(e);this.getMeta().data.splice(e,0,t),this.updateElement(t,e,!0)},buildOrUpdateElements:function(){var e,t,o=this,i=o.getDataset(),r=i.data||(i.data=[]);o._data!==r&&(o._data&&te(o._data,o),r&&Object.isExtensible(r)&&(t=o,(e=r)._chartjs?e._chartjs.listeners.push(t):(Object.defineProperty(e,"_chartjs",{configurable:!0,enumerable:!1,value:{listeners:[t]}}),ee.forEach((function(t){var o="onData"+t.charAt(0).toUpperCase()+t.slice(1),i=e[t];Object.defineProperty(e,t,{configurable:!0,enumerable:!1,value:function(){var t=Array.prototype.slice.call(arguments),r=i.apply(this,t);return W.each(e._chartjs.listeners,(function(e){"function"==typeof e[o]&&e[o].apply(e,t)})),r}})})))),o._data=r),o.resyncElements()},_configure:function(){var e=this;e._config=W.merge(Object.create(null),[e.chart.options.datasets[e._type],e.getDataset()],{merger:function(e,t,o){"_meta"!==e&&"data"!==e&&W._merger(e,t,o)}})},_update:function(e){var t=this;t._configure(),t._cachedDataOpts=null,t.update(e)},update:W.noop,transition:function(e){for(var t=this.getMeta(),o=t.data||[],i=o.length,r=0;r<i;++r)o[r].transition(e);t.dataset&&t.dataset.transition(e)},draw:function(){var e=this.getMeta(),t=e.data||[],o=t.length,i=0;for(e.dataset&&e.dataset.draw();i<o;++i)t[i].draw()},getStyle:function(e){var t,o=this,i=o.getMeta(),r=i.dataset;return o._configure(),r&&void 0===e?t=o._resolveDatasetElementOptions(r||{}):(e=e||0,t=o._resolveDataElementOptions(i.data[e]||{},e)),!1!==t.fill&&null!==t.fill||(t.backgroundColor=t.borderColor),t},_resolveDatasetElementOptions:function(e,t){var o,i,r,s,n=this,a=n.chart,c=n._config,l=e.custom||{},h=a.options.elements[n.datasetElementType.prototype._type]||{},d=n._datasetElementOptions,p={},u={chart:a,dataset:n.getDataset(),datasetIndex:n.index,hover:t};for(o=0,i=d.length;o<i;++o)r=d[o],s=t?"hover"+r.charAt(0).toUpperCase()+r.slice(1):r,p[r]=Q([l[s],c[s],h[s]],u);return p},_resolveDataElementOptions:function(e,t){var o=this,i=e&&e.custom,r=o._cachedDataOpts;if(r&&!i)return r;var s,n,a,c,l=o.chart,h=o._config,d=l.options.elements[o.dataElementType.prototype._type]||{},p=o._dataElementOptions,u={},m={chart:l,dataIndex:t,dataset:o.getDataset(),datasetIndex:o.index},f={cacheable:!i};if(i=i||{},W.isArray(p))for(n=0,a=p.length;n<a;++n)u[c=p[n]]=Q([i[c],h[c],d[c]],m,t,f);else for(n=0,a=(s=Object.keys(p)).length;n<a;++n)u[c=s[n]]=Q([i[c],h[p[c]],h[c],d[c]],m,t,f);return f.cacheable&&(o._cachedDataOpts=Object.freeze(u)),u},removeHoverStyle:function(e){W.merge(e._model,e.$previousStyle||{}),delete e.$previousStyle},setHoverStyle:function(e){var t=this.chart.data.datasets[e._datasetIndex],o=e._index,i=e.custom||{},r=e._model,s=W.getHoverColor;e.$previousStyle={backgroundColor:r.backgroundColor,borderColor:r.borderColor,borderWidth:r.borderWidth},r.backgroundColor=Q([i.hoverBackgroundColor,t.hoverBackgroundColor,s(r.backgroundColor)],void 0,o),r.borderColor=Q([i.hoverBorderColor,t.hoverBorderColor,s(r.borderColor)],void 0,o),r.borderWidth=Q([i.hoverBorderWidth,t.hoverBorderWidth,r.borderWidth],void 0,o)},_removeDatasetHoverStyle:function(){var e=this.getMeta().dataset;e&&this.removeHoverStyle(e)},_setDatasetHoverStyle:function(){var e,t,o,i,r,s,n=this.getMeta().dataset,a={};if(n){for(s=n._model,r=this._resolveDatasetElementOptions(n,!0),e=0,t=(i=Object.keys(r)).length;e<t;++e)a[o=i[e]]=s[o],s[o]=r[o];n.$previousStyle=a}},resyncElements:function(){var e=this,t=e.getMeta(),o=e.getDataset().data,i=t.data.length,r=o.length;r<i?t.data.splice(r,i-r):r>i&&e.insertElements(i,r-i)},insertElements:function(e,t){for(var o=0;o<t;++o)this.addElementAndReset(e+o)},onDataPush:function(){var e=arguments.length;this.insertElements(this.getDataset().data.length-e,e)},onDataPop:function(){this.getMeta().data.pop()},onDataShift:function(){this.getMeta().data.shift()},onDataSplice:function(e,t){this.getMeta().data.splice(e,t),this.insertElements(e,arguments.length-2)},onDataUnshift:function(){this.insertElements(0,arguments.length)}}),oe.extend=W.inherits;var ie=oe,re=2*Math.PI;function se(e,t){var o=t.startAngle,i=t.endAngle,r=t.pixelMargin,s=r/t.outerRadius,n=t.x,a=t.y;e.beginPath(),e.arc(n,a,t.outerRadius,o-s,i+s),t.innerRadius>r?(s=r/t.innerRadius,e.arc(n,a,t.innerRadius-r,i+s,o-s,!0)):e.arc(n,a,r,i+Math.PI/2,o-Math.PI/2),e.closePath(),e.clip()}F._set("global",{elements:{arc:{backgroundColor:F.global.defaultColor,borderColor:"#fff",borderWidth:2,borderAlign:"center"}}});var ne=K.extend({_type:"arc",inLabelRange:function(e){var t=this._view;return!!t&&Math.pow(e-t.x,2)<Math.pow(t.radius+t.hoverRadius,2)},inRange:function(e,t){var o=this._view;if(o){for(var i=W.getAngleFromPoint(o,{x:e,y:t}),r=i.angle,s=i.distance,n=o.startAngle,a=o.endAngle;a<n;)a+=re;for(;r>a;)r-=re;for(;r<n;)r+=re;var c=r>=n&&r<=a,l=s>=o.innerRadius&&s<=o.outerRadius;return c&&l}return!1},getCenterPoint:function(){var e=this._view,t=(e.startAngle+e.endAngle)/2,o=(e.innerRadius+e.outerRadius)/2;return{x:e.x+Math.cos(t)*o,y:e.y+Math.sin(t)*o}},getArea:function(){var e=this._view;return Math.PI*((e.endAngle-e.startAngle)/(2*Math.PI))*(Math.pow(e.outerRadius,2)-Math.pow(e.innerRadius,2))},tooltipPosition:function(){var e=this._view,t=e.startAngle+(e.endAngle-e.startAngle)/2,o=(e.outerRadius-e.innerRadius)/2+e.innerRadius;return{x:e.x+Math.cos(t)*o,y:e.y+Math.sin(t)*o}},draw:function(){var e,t=this._chart.ctx,o=this._view,i="inner"===o.borderAlign?.33:0,r={x:o.x,y:o.y,innerRadius:o.innerRadius,outerRadius:Math.max(o.outerRadius-i,0),pixelMargin:i,startAngle:o.startAngle,endAngle:o.endAngle,fullCircles:Math.floor(o.circumference/re)};if(t.save(),t.fillStyle=o.backgroundColor,t.strokeStyle=o.borderColor,r.fullCircles){for(r.endAngle=r.startAngle+re,t.beginPath(),t.arc(r.x,r.y,r.outerRadius,r.startAngle,r.endAngle),t.arc(r.x,r.y,r.innerRadius,r.endAngle,r.startAngle,!0),t.closePath(),e=0;e<r.fullCircles;++e)t.fill();r.endAngle=r.startAngle+o.circumference%re}t.beginPath(),t.arc(r.x,r.y,r.outerRadius,r.startAngle,r.endAngle),t.arc(r.x,r.y,r.innerRadius,r.endAngle,r.startAngle,!0),t.closePath(),t.fill(),o.borderWidth&&function(e,t,o){var i="inner"===t.borderAlign;i?(e.lineWidth=2*t.borderWidth,e.lineJoin="round"):(e.lineWidth=t.borderWidth,e.lineJoin="bevel"),o.fullCircles&&function(e,t,o,i){var r,s=o.endAngle;for(i&&(o.endAngle=o.startAngle+re,se(e,o),o.endAngle=s,o.endAngle===o.startAngle&&o.fullCircles&&(o.endAngle+=re,o.fullCircles--)),e.beginPath(),e.arc(o.x,o.y,o.innerRadius,o.startAngle+re,o.startAngle,!0),r=0;r<o.fullCircles;++r)e.stroke();for(e.beginPath(),e.arc(o.x,o.y,t.outerRadius,o.startAngle,o.startAngle+re),r=0;r<o.fullCircles;++r)e.stroke()}(e,t,o,i),i&&se(e,o),e.beginPath(),e.arc(o.x,o.y,t.outerRadius,o.startAngle,o.endAngle),e.arc(o.x,o.y,o.innerRadius,o.endAngle,o.startAngle,!0),e.closePath(),e.stroke()}(t,o,r),t.restore()}}),ae=W.valueOrDefault,ce=F.global.defaultColor;F._set("global",{elements:{line:{tension:.4,backgroundColor:ce,borderWidth:3,borderColor:ce,borderCapStyle:"butt",borderDash:[],borderDashOffset:0,borderJoinStyle:"miter",capBezierPoints:!0,fill:!0}}});var le=K.extend({_type:"line",draw:function(){var e,t,o,i=this,r=i._view,s=i._chart.ctx,n=r.spanGaps,a=i._children.slice(),c=F.global,l=c.elements.line,h=-1,d=i._loop;if(a.length){if(i._loop){for(e=0;e<a.length;++e)if(t=W.previousItem(a,e),!a[e]._view.skip&&t._view.skip){a=a.slice(e).concat(a.slice(0,e)),d=n;break}d&&a.push(a[0])}for(s.save(),s.lineCap=r.borderCapStyle||l.borderCapStyle,s.setLineDash&&s.setLineDash(r.borderDash||l.borderDash),s.lineDashOffset=ae(r.borderDashOffset,l.borderDashOffset),s.lineJoin=r.borderJoinStyle||l.borderJoinStyle,s.lineWidth=ae(r.borderWidth,l.borderWidth),s.strokeStyle=r.borderColor||c.defaultColor,s.beginPath(),(o=a[0]._view).skip||(s.moveTo(o.x,o.y),h=0),e=1;e<a.length;++e)o=a[e]._view,t=-1===h?W.previousItem(a,e):a[h],o.skip||(h!==e-1&&!n||-1===h?s.moveTo(o.x,o.y):W.canvas.lineTo(s,t._view,o),h=e);d&&s.closePath(),s.stroke(),s.restore()}}}),he=W.valueOrDefault,de=F.global.defaultColor;function pe(e){var t=this._view;return!!t&&Math.abs(e-t.x)<t.radius+t.hitRadius}F._set("global",{elements:{point:{radius:3,pointStyle:"circle",backgroundColor:de,borderColor:de,borderWidth:1,hitRadius:1,hoverRadius:4,hoverBorderWidth:1}}});var ue=K.extend({_type:"point",inRange:function(e,t){var o=this._view;return!!o&&Math.pow(e-o.x,2)+Math.pow(t-o.y,2)<Math.pow(o.hitRadius+o.radius,2)},inLabelRange:pe,inXRange:pe,inYRange:function(e){var t=this._view;return!!t&&Math.abs(e-t.y)<t.radius+t.hitRadius},getCenterPoint:function(){var e=this._view;return{x:e.x,y:e.y}},getArea:function(){return Math.PI*Math.pow(this._view.radius,2)},tooltipPosition:function(){var e=this._view;return{x:e.x,y:e.y,padding:e.radius+e.borderWidth}},draw:function(e){var t=this._view,o=this._chart.ctx,i=t.pointStyle,r=t.rotation,s=t.radius,n=t.x,a=t.y,c=F.global,l=c.defaultColor;t.skip||(void 0===e||W.canvas._isPointInArea(t,e))&&(o.strokeStyle=t.borderColor||l,o.lineWidth=he(t.borderWidth,c.elements.point.borderWidth),o.fillStyle=t.backgroundColor||l,W.canvas.drawPoint(o,i,s,n,a,r))}}),me=F.global.defaultColor;function fe(e){return e&&void 0!==e.width}function ge(e){var t,o,i,r,s;return fe(e)?(s=e.width/2,t=e.x-s,o=e.x+s,i=Math.min(e.y,e.base),r=Math.max(e.y,e.base)):(s=e.height/2,t=Math.min(e.x,e.base),o=Math.max(e.x,e.base),i=e.y-s,r=e.y+s),{left:t,top:i,right:o,bottom:r}}function be(e,t,o){return e===t?o:e===o?t:e}function ve(e,t,o){var i=null===t,r=null===o,s=!(!e||i&&r)&&ge(e);return s&&(i||t>=s.left&&t<=s.right)&&(r||o>=s.top&&o<=s.bottom)}F._set("global",{elements:{rectangle:{backgroundColor:me,borderColor:me,borderSkipped:"bottom",borderWidth:0}}});var ye=K.extend({_type:"rectangle",draw:function(){var e=this._chart.ctx,t=this._view,o=function(e){var t=ge(e),o=t.right-t.left,i=t.bottom-t.top,r=function(e,t,o){var i,r,s,n,a=e.borderWidth,c=function(e){var t=e.borderSkipped,o={};return t?(e.horizontal?e.base>e.x&&(t=be(t,"left","right")):e.base<e.y&&(t=be(t,"bottom","top")),o[t]=!0,o):o}(e);return W.isObject(a)?(i=+a.top||0,r=+a.right||0,s=+a.bottom||0,n=+a.left||0):i=r=s=n=+a||0,{t:c.top||i<0?0:i>o?o:i,r:c.right||r<0?0:r>t?t:r,b:c.bottom||s<0?0:s>o?o:s,l:c.left||n<0?0:n>t?t:n}}(e,o/2,i/2);return{outer:{x:t.left,y:t.top,w:o,h:i},inner:{x:t.left+r.l,y:t.top+r.t,w:o-r.l-r.r,h:i-r.t-r.b}}}(t),i=o.outer,r=o.inner;e.fillStyle=t.backgroundColor,e.fillRect(i.x,i.y,i.w,i.h),i.w===r.w&&i.h===r.h||(e.save(),e.beginPath(),e.rect(i.x,i.y,i.w,i.h),e.clip(),e.fillStyle=t.borderColor,e.rect(r.x,r.y,r.w,r.h),e.fill("evenodd"),e.restore())},height:function(){var e=this._view;return e.base-e.y},inRange:function(e,t){return ve(this._view,e,t)},inLabelRange:function(e,t){var o=this._view;return fe(o)?ve(o,e,null):ve(o,null,t)},inXRange:function(e){return ve(this._view,e,null)},inYRange:function(e){return ve(this._view,null,e)},getCenterPoint:function(){var e,t,o=this._view;return fe(o)?(e=o.x,t=(o.y+o.base)/2):(e=(o.x+o.base)/2,t=o.y),{x:e,y:t}},getArea:function(){var e=this._view;return fe(e)?e.width*Math.abs(e.y-e.base):e.height*Math.abs(e.x-e.base)},tooltipPosition:function(){var e=this._view;return{x:e.x,y:e.y}}}),we={},xe=ne,_e=le,ke=ue,Ce=ye;we.Arc=xe,we.Line=_e,we.Point=ke,we.Rectangle=Ce;var Ee=W._deprecated,ze=W.valueOrDefault;F._set("bar",{hover:{mode:"label"},scales:{xAxes:[{type:"category",offset:!0,gridLines:{offsetGridLines:!0}}],yAxes:[{type:"linear"}]}}),F._set("global",{datasets:{bar:{categoryPercentage:.8,barPercentage:.9}}});var Ae=ie.extend({dataElementType:we.Rectangle,_dataElementOptions:["backgroundColor","borderColor","borderSkipped","borderWidth","barPercentage","barThickness","categoryPercentage","maxBarThickness","minBarLength"],initialize:function(){var e,t,o=this;ie.prototype.initialize.apply(o,arguments),(e=o.getMeta()).stack=o.getDataset().stack,e.bar=!0,t=o._getIndexScale().options,Ee("bar chart",t.barPercentage,"scales.[x/y]Axes.barPercentage","dataset.barPercentage"),Ee("bar chart",t.barThickness,"scales.[x/y]Axes.barThickness","dataset.barThickness"),Ee("bar chart",t.categoryPercentage,"scales.[x/y]Axes.categoryPercentage","dataset.categoryPercentage"),Ee("bar chart",o._getValueScale().options.minBarLength,"scales.[x/y]Axes.minBarLength","dataset.minBarLength"),Ee("bar chart",t.maxBarThickness,"scales.[x/y]Axes.maxBarThickness","dataset.maxBarThickness")},update:function(e){var t,o,i=this,r=i.getMeta().data;for(i._ruler=i.getRuler(),t=0,o=r.length;t<o;++t)i.updateElement(r[t],t,e)},updateElement:function(e,t,o){var i=this,r=i.getMeta(),s=i.getDataset(),n=i._resolveDataElementOptions(e,t);e._xScale=i.getScaleForId(r.xAxisID),e._yScale=i.getScaleForId(r.yAxisID),e._datasetIndex=i.index,e._index=t,e._model={backgroundColor:n.backgroundColor,borderColor:n.borderColor,borderSkipped:n.borderSkipped,borderWidth:n.borderWidth,datasetLabel:s.label,label:i.chart.data.labels[t]},W.isArray(s.data[t])&&(e._model.borderSkipped=null),i._updateElementGeometry(e,t,o,n),e.pivot()},_updateElementGeometry:function(e,t,o,i){var r=this,s=e._model,n=r._getValueScale(),a=n.getBasePixel(),c=n.isHorizontal(),l=r._ruler||r.getRuler(),h=r.calculateBarValuePixels(r.index,t,i),d=r.calculateBarIndexPixels(r.index,t,l,i);s.horizontal=c,s.base=o?a:h.base,s.x=c?o?a:h.head:d.center,s.y=c?d.center:o?a:h.head,s.height=c?d.size:void 0,s.width=c?void 0:d.size},_getStacks:function(e){var t,o,i=this._getIndexScale(),r=i._getMatchingVisibleMetas(this._type),s=i.options.stacked,n=r.length,a=[];for(t=0;t<n&&(o=r[t],(!1===s||-1===a.indexOf(o.stack)||void 0===s&&void 0===o.stack)&&a.push(o.stack),o.index!==e);++t);return a},getStackCount:function(){return this._getStacks().length},getStackIndex:function(e,t){var o=this._getStacks(e),i=void 0!==t?o.indexOf(t):-1;return-1===i?o.length-1:i},getRuler:function(){var e,t,o=this,i=o._getIndexScale(),r=[];for(e=0,t=o.getMeta().data.length;e<t;++e)r.push(i.getPixelForValue(null,e,o.index));return{pixels:r,start:i._startPixel,end:i._endPixel,stackCount:o.getStackCount(),scale:i}},calculateBarValuePixels:function(e,t,o){var i,r,s,n,a,c,l,h=this,d=h.chart,p=h._getValueScale(),u=p.isHorizontal(),m=d.data.datasets,f=p._getMatchingVisibleMetas(h._type),g=p._parseValue(m[e].data[t]),b=o.minBarLength,v=p.options.stacked,y=h.getMeta().stack,w=void 0===g.start?0:g.max>=0&&g.min>=0?g.min:g.max,x=void 0===g.start?g.end:g.max>=0&&g.min>=0?g.max-g.min:g.min-g.max,_=f.length;if(v||void 0===v&&void 0!==y)for(i=0;i<_&&(r=f[i]).index!==e;++i)r.stack===y&&(s=void 0===(l=p._parseValue(m[r.index].data[t])).start?l.end:l.min>=0&&l.max>=0?l.max:l.min,(g.min<0&&s<0||g.max>=0&&s>0)&&(w+=s));return n=p.getPixelForValue(w),c=(a=p.getPixelForValue(w+x))-n,void 0!==b&&Math.abs(c)<b&&(c=b,a=x>=0&&!u||x<0&&u?n-b:n+b),{size:c,base:n,head:a,center:a+c/2}},calculateBarIndexPixels:function(e,t,o,i){var r="flex"===i.barThickness?function(e,t,o){var i,r=t.pixels,s=r[e],n=e>0?r[e-1]:null,a=e<r.length-1?r[e+1]:null,c=o.categoryPercentage;return null===n&&(n=s-(null===a?t.end-t.start:a-s)),null===a&&(a=s+s-n),i=s-(s-Math.min(n,a))/2*c,{chunk:Math.abs(a-n)/2*c/t.stackCount,ratio:o.barPercentage,start:i}}(t,o,i):function(e,t,o){var i,r,s=o.barThickness,n=t.stackCount,a=t.pixels[e],c=W.isNullOrUndef(s)?function(e,t){var o,i,r,s,n=e._length;for(r=1,s=t.length;r<s;++r)n=Math.min(n,Math.abs(t[r]-t[r-1]));for(r=0,s=e.getTicks().length;r<s;++r)i=e.getPixelForTick(r),n=r>0?Math.min(n,Math.abs(i-o)):n,o=i;return n}(t.scale,t.pixels):-1;return W.isNullOrUndef(s)?(i=c*o.categoryPercentage,r=o.barPercentage):(i=s*n,r=1),{chunk:i/n,ratio:r,start:a-i/2}}(t,o,i),s=this.getStackIndex(e,this.getMeta().stack),n=r.start+r.chunk*s+r.chunk/2,a=Math.min(ze(i.maxBarThickness,1/0),r.chunk*r.ratio);return{base:n-a/2,head:n+a/2,center:n,size:a}},draw:function(){var e=this,t=e.chart,o=e._getValueScale(),i=e.getMeta().data,r=e.getDataset(),s=i.length,n=0;for(W.canvas.clipArea(t.ctx,t.chartArea);n<s;++n){var a=o._parseValue(r.data[n]);isNaN(a.min)||isNaN(a.max)||i[n].draw()}W.canvas.unclipArea(t.ctx)},_resolveDataElementOptions:function(){var e=this,t=W.extend({},ie.prototype._resolveDataElementOptions.apply(e,arguments)),o=e._getIndexScale().options,i=e._getValueScale().options;return t.barPercentage=ze(o.barPercentage,t.barPercentage),t.barThickness=ze(o.barThickness,t.barThickness),t.categoryPercentage=ze(o.categoryPercentage,t.categoryPercentage),t.maxBarThickness=ze(o.maxBarThickness,t.maxBarThickness),t.minBarLength=ze(i.minBarLength,t.minBarLength),t}}),Se=W.valueOrDefault,Me=W.options.resolve;F._set("bubble",{hover:{mode:"single"},scales:{xAxes:[{type:"linear",position:"bottom",id:"x-axis-0"}],yAxes:[{type:"linear",position:"left",id:"y-axis-0"}]},tooltips:{callbacks:{title:function(){return""},label:function(e,t){var o=t.datasets[e.datasetIndex].label||"",i=t.datasets[e.datasetIndex].data[e.index];return o+": ("+e.xLabel+", "+e.yLabel+", "+i.r+")"}}}});var De=ie.extend({dataElementType:we.Point,_dataElementOptions:["backgroundColor","borderColor","borderWidth","hoverBackgroundColor","hoverBorderColor","hoverBorderWidth","hoverRadius","hitRadius","pointStyle","rotation"],update:function(e){var t=this,o=t.getMeta().data;W.each(o,(function(o,i){t.updateElement(o,i,e)}))},updateElement:function(e,t,o){var i=this,r=i.getMeta(),s=e.custom||{},n=i.getScaleForId(r.xAxisID),a=i.getScaleForId(r.yAxisID),c=i._resolveDataElementOptions(e,t),l=i.getDataset().data[t],h=i.index,d=o?n.getPixelForDecimal(.5):n.getPixelForValue("object"==typeof l?l:NaN,t,h),p=o?a.getBasePixel():a.getPixelForValue(l,t,h);e._xScale=n,e._yScale=a,e._options=c,e._datasetIndex=h,e._index=t,e._model={backgroundColor:c.backgroundColor,borderColor:c.borderColor,borderWidth:c.borderWidth,hitRadius:c.hitRadius,pointStyle:c.pointStyle,rotation:c.rotation,radius:o?0:c.radius,skip:s.skip||isNaN(d)||isNaN(p),x:d,y:p},e.pivot()},setHoverStyle:function(e){var t=e._model,o=e._options,i=W.getHoverColor;e.$previousStyle={backgroundColor:t.backgroundColor,borderColor:t.borderColor,borderWidth:t.borderWidth,radius:t.radius},t.backgroundColor=Se(o.hoverBackgroundColor,i(o.backgroundColor)),t.borderColor=Se(o.hoverBorderColor,i(o.borderColor)),t.borderWidth=Se(o.hoverBorderWidth,o.borderWidth),t.radius=o.radius+o.hoverRadius},_resolveDataElementOptions:function(e,t){var o=this,i=o.chart,r=o.getDataset(),s=e.custom||{},n=r.data[t]||{},a=ie.prototype._resolveDataElementOptions.apply(o,arguments),c={chart:i,dataIndex:t,dataset:r,datasetIndex:o.index};return o._cachedDataOpts===a&&(a=W.extend({},a)),a.radius=Me([s.radius,n.r,o._config.radius,i.options.elements.point.radius],c,t),a}}),Be=W.valueOrDefault,Te=Math.PI,Re=2*Te,Le=Te/2;F._set("doughnut",{animation:{animateRotate:!0,animateScale:!1},hover:{mode:"single"},legendCallback:function(e){var t,o,i,r=document.createElement("ul"),s=e.data,n=s.datasets,a=s.labels;if(r.setAttribute("class",e.id+"-legend"),n.length)for(t=0,o=n[0].data.length;t<o;++t)(i=r.appendChild(document.createElement("li"))).appendChild(document.createElement("span")).style.backgroundColor=n[0].backgroundColor[t],a[t]&&i.appendChild(document.createTextNode(a[t]));return r.outerHTML},legend:{labels:{generateLabels:function(e){var t=e.data;return t.labels.length&&t.datasets.length?t.labels.map((function(o,i){var r=e.getDatasetMeta(0),s=r.controller.getStyle(i);return{text:o,fillStyle:s.backgroundColor,strokeStyle:s.borderColor,lineWidth:s.borderWidth,hidden:isNaN(t.datasets[0].data[i])||r.data[i].hidden,index:i}})):[]}},onClick:function(e,t){var o,i,r,s=t.index,n=this.chart;for(o=0,i=(n.data.datasets||[]).length;o<i;++o)(r=n.getDatasetMeta(o)).data[s]&&(r.data[s].hidden=!r.data[s].hidden);n.update()}},cutoutPercentage:50,rotation:-Le,circumference:Re,tooltips:{callbacks:{title:function(){return""},label:function(e,t){var o=t.labels[e.index],i=": "+t.datasets[e.datasetIndex].data[e.index];return W.isArray(o)?(o=o.slice())[0]+=i:o+=i,o}}}});var Pe=ie.extend({dataElementType:we.Arc,linkScales:W.noop,_dataElementOptions:["backgroundColor","borderColor","borderWidth","borderAlign","hoverBackgroundColor","hoverBorderColor","hoverBorderWidth"],getRingIndex:function(e){for(var t=0,o=0;o<e;++o)this.chart.isDatasetVisible(o)&&++t;return t},update:function(e){var t,o,i,r,s=this,n=s.chart,a=n.chartArea,c=n.options,l=1,h=1,d=0,p=0,u=s.getMeta(),m=u.data,f=c.cutoutPercentage/100||0,g=c.circumference,b=s._getRingWeight(s.index);if(g<Re){var v=c.rotation%Re,y=(v+=v>=Te?-Re:v<-Te?Re:0)+g,w=Math.cos(v),x=Math.sin(v),_=Math.cos(y),k=Math.sin(y),C=v<=0&&y>=0||y>=Re,E=v<=Le&&y>=Le||y>=Re+Le,z=v<=-Le&&y>=-Le||y>=Te+Le,A=v===-Te||y>=Te?-1:Math.min(w,w*f,_,_*f),S=z?-1:Math.min(x,x*f,k,k*f),M=C?1:Math.max(w,w*f,_,_*f),D=E?1:Math.max(x,x*f,k,k*f);l=(M-A)/2,h=(D-S)/2,d=-(M+A)/2,p=-(D+S)/2}for(i=0,r=m.length;i<r;++i)m[i]._options=s._resolveDataElementOptions(m[i],i);for(n.borderWidth=s.getMaxBorderWidth(),t=(a.right-a.left-n.borderWidth)/l,o=(a.bottom-a.top-n.borderWidth)/h,n.outerRadius=Math.max(Math.min(t,o)/2,0),n.innerRadius=Math.max(n.outerRadius*f,0),n.radiusLength=(n.outerRadius-n.innerRadius)/(s._getVisibleDatasetWeightTotal()||1),n.offsetX=d*n.outerRadius,n.offsetY=p*n.outerRadius,u.total=s.calculateTotal(),s.outerRadius=n.outerRadius-n.radiusLength*s._getRingWeightOffset(s.index),s.innerRadius=Math.max(s.outerRadius-n.radiusLength*b,0),i=0,r=m.length;i<r;++i)s.updateElement(m[i],i,e)},updateElement:function(e,t,o){var i=this,r=i.chart,s=r.chartArea,n=r.options,a=n.animation,c=(s.left+s.right)/2,l=(s.top+s.bottom)/2,h=n.rotation,d=n.rotation,p=i.getDataset(),u=o&&a.animateRotate||e.hidden?0:i.calculateCircumference(p.data[t])*(n.circumference/Re),m=o&&a.animateScale?0:i.innerRadius,f=o&&a.animateScale?0:i.outerRadius,g=e._options||{};W.extend(e,{_datasetIndex:i.index,_index:t,_model:{backgroundColor:g.backgroundColor,borderColor:g.borderColor,borderWidth:g.borderWidth,borderAlign:g.borderAlign,x:c+r.offsetX,y:l+r.offsetY,startAngle:h,endAngle:d,circumference:u,outerRadius:f,innerRadius:m,label:W.valueAtIndexOrDefault(p.label,t,r.data.labels[t])}});var b=e._model;o&&a.animateRotate||(b.startAngle=0===t?n.rotation:i.getMeta().data[t-1]._model.endAngle,b.endAngle=b.startAngle+b.circumference),e.pivot()},calculateTotal:function(){var e,t=this.getDataset(),o=this.getMeta(),i=0;return W.each(o.data,(function(o,r){e=t.data[r],isNaN(e)||o.hidden||(i+=Math.abs(e))})),i},calculateCircumference:function(e){var t=this.getMeta().total;return t>0&&!isNaN(e)?Re*(Math.abs(e)/t):0},getMaxBorderWidth:function(e){var t,o,i,r,s,n,a,c,l=0,h=this.chart;if(!e)for(t=0,o=h.data.datasets.length;t<o;++t)if(h.isDatasetVisible(t)){e=(i=h.getDatasetMeta(t)).data,t!==this.index&&(s=i.controller);break}if(!e)return 0;for(t=0,o=e.length;t<o;++t)r=e[t],s?(s._configure(),n=s._resolveDataElementOptions(r,t)):n=r._options,"inner"!==n.borderAlign&&(a=n.borderWidth,l=(c=n.hoverBorderWidth)>(l=a>l?a:l)?c:l);return l},setHoverStyle:function(e){var t=e._model,o=e._options,i=W.getHoverColor;e.$previousStyle={backgroundColor:t.backgroundColor,borderColor:t.borderColor,borderWidth:t.borderWidth},t.backgroundColor=Be(o.hoverBackgroundColor,i(o.backgroundColor)),t.borderColor=Be(o.hoverBorderColor,i(o.borderColor)),t.borderWidth=Be(o.hoverBorderWidth,o.borderWidth)},_getRingWeightOffset:function(e){for(var t=0,o=0;o<e;++o)this.chart.isDatasetVisible(o)&&(t+=this._getRingWeight(o));return t},_getRingWeight:function(e){return Math.max(Be(this.chart.data.datasets[e].weight,1),0)},_getVisibleDatasetWeightTotal:function(){return this._getRingWeightOffset(this.chart.data.datasets.length)}});F._set("horizontalBar",{hover:{mode:"index",axis:"y"},scales:{xAxes:[{type:"linear",position:"bottom"}],yAxes:[{type:"category",position:"left",offset:!0,gridLines:{offsetGridLines:!0}}]},elements:{rectangle:{borderSkipped:"left"}},tooltips:{mode:"index",axis:"y"}}),F._set("global",{datasets:{horizontalBar:{categoryPercentage:.8,barPercentage:.9}}});var Oe=Ae.extend({_getValueScaleId:function(){return this.getMeta().xAxisID},_getIndexScaleId:function(){return this.getMeta().yAxisID}}),Ne=W.valueOrDefault,Fe=W.options.resolve,$e=W.canvas._isPointInArea;function Ie(e,t){var o=e&&e.options.ticks||{},i=o.reverse,r=void 0===o.min?t:0,s=void 0===o.max?t:0;return{start:i?s:r,end:i?r:s}}function Ve(e,t,o){var i=o/2,r=Ie(e,i),s=Ie(t,i);return{top:s.end,right:r.end,bottom:s.start,left:r.start}}function He(e){var t,o,i,r;return W.isObject(e)?(t=e.top,o=e.right,i=e.bottom,r=e.left):t=o=i=r=e,{top:t,right:o,bottom:i,left:r}}F._set("line",{showLines:!0,spanGaps:!1,hover:{mode:"label"},scales:{xAxes:[{type:"category",id:"x-axis-0"}],yAxes:[{type:"linear",id:"y-axis-0"}]}});var We=ie.extend({datasetElementType:we.Line,dataElementType:we.Point,_datasetElementOptions:["backgroundColor","borderCapStyle","borderColor","borderDash","borderDashOffset","borderJoinStyle","borderWidth","cubicInterpolationMode","fill"],_dataElementOptions:{backgroundColor:"pointBackgroundColor",borderColor:"pointBorderColor",borderWidth:"pointBorderWidth",hitRadius:"pointHitRadius",hoverBackgroundColor:"pointHoverBackgroundColor",hoverBorderColor:"pointHoverBorderColor",hoverBorderWidth:"pointHoverBorderWidth",hoverRadius:"pointHoverRadius",pointStyle:"pointStyle",radius:"pointRadius",rotation:"pointRotation"},update:function(e){var t,o,i=this,r=i.getMeta(),s=r.dataset,n=r.data||[],a=i.chart.options,c=i._config,l=i._showLine=Ne(c.showLine,a.showLines);for(i._xScale=i.getScaleForId(r.xAxisID),i._yScale=i.getScaleForId(r.yAxisID),l&&(void 0!==c.tension&&void 0===c.lineTension&&(c.lineTension=c.tension),s._scale=i._yScale,s._datasetIndex=i.index,s._children=n,s._model=i._resolveDatasetElementOptions(s),s.pivot()),t=0,o=n.length;t<o;++t)i.updateElement(n[t],t,e);for(l&&0!==s._model.tension&&i.updateBezierControlPoints(),t=0,o=n.length;t<o;++t)n[t].pivot()},updateElement:function(e,t,o){var i,r,s=this,n=s.getMeta(),a=e.custom||{},c=s.getDataset(),l=s.index,h=c.data[t],d=s._xScale,p=s._yScale,u=n.dataset._model,m=s._resolveDataElementOptions(e,t);i=d.getPixelForValue("object"==typeof h?h:NaN,t,l),r=o?p.getBasePixel():s.calculatePointY(h,t,l),e._xScale=d,e._yScale=p,e._options=m,e._datasetIndex=l,e._index=t,e._model={x:i,y:r,skip:a.skip||isNaN(i)||isNaN(r),radius:m.radius,pointStyle:m.pointStyle,rotation:m.rotation,backgroundColor:m.backgroundColor,borderColor:m.borderColor,borderWidth:m.borderWidth,tension:Ne(a.tension,u?u.tension:0),steppedLine:!!u&&u.steppedLine,hitRadius:m.hitRadius}},_resolveDatasetElementOptions:function(e){var t=this,o=t._config,i=e.custom||{},r=t.chart.options,s=r.elements.line,n=ie.prototype._resolveDatasetElementOptions.apply(t,arguments);return n.spanGaps=Ne(o.spanGaps,r.spanGaps),n.tension=Ne(o.lineTension,s.tension),n.steppedLine=Fe([i.steppedLine,o.steppedLine,s.stepped]),n.clip=He(Ne(o.clip,Ve(t._xScale,t._yScale,n.borderWidth))),n},calculatePointY:function(e,t,o){var i,r,s,n,a,c,l,h=this.chart,d=this._yScale,p=0,u=0;if(d.options.stacked){for(a=+d.getRightValue(e),l=(c=h._getSortedVisibleDatasetMetas()).length,i=0;i<l&&(s=c[i]).index!==o;++i)r=h.data.datasets[s.index],"line"===s.type&&s.yAxisID===d.id&&((n=+d.getRightValue(r.data[t]))<0?u+=n||0:p+=n||0);return a<0?d.getPixelForValue(u+a):d.getPixelForValue(p+a)}return d.getPixelForValue(e)},updateBezierControlPoints:function(){var e,t,o,i,r=this.chart,s=this.getMeta(),n=s.dataset._model,a=r.chartArea,c=s.data||[];function l(e,t,o){return Math.max(Math.min(e,o),t)}if(n.spanGaps&&(c=c.filter((function(e){return!e._model.skip}))),"monotone"===n.cubicInterpolationMode)W.splineCurveMonotone(c);else for(e=0,t=c.length;e<t;++e)o=c[e]._model,i=W.splineCurve(W.previousItem(c,e)._model,o,W.nextItem(c,e)._model,n.tension),o.controlPointPreviousX=i.previous.x,o.controlPointPreviousY=i.previous.y,o.controlPointNextX=i.next.x,o.controlPointNextY=i.next.y;if(r.options.elements.line.capBezierPoints)for(e=0,t=c.length;e<t;++e)o=c[e]._model,$e(o,a)&&(e>0&&$e(c[e-1]._model,a)&&(o.controlPointPreviousX=l(o.controlPointPreviousX,a.left,a.right),o.controlPointPreviousY=l(o.controlPointPreviousY,a.top,a.bottom)),e<c.length-1&&$e(c[e+1]._model,a)&&(o.controlPointNextX=l(o.controlPointNextX,a.left,a.right),o.controlPointNextY=l(o.controlPointNextY,a.top,a.bottom)))},draw:function(){var e,t=this,o=t.chart,i=t.getMeta(),r=i.data||[],s=o.chartArea,n=o.canvas,a=0,c=r.length;for(t._showLine&&(e=i.dataset._model.clip,W.canvas.clipArea(o.ctx,{left:!1===e.left?0:s.left-e.left,right:!1===e.right?n.width:s.right+e.right,top:!1===e.top?0:s.top-e.top,bottom:!1===e.bottom?n.height:s.bottom+e.bottom}),i.dataset.draw(),W.canvas.unclipArea(o.ctx));a<c;++a)r[a].draw(s)},setHoverStyle:function(e){var t=e._model,o=e._options,i=W.getHoverColor;e.$previousStyle={backgroundColor:t.backgroundColor,borderColor:t.borderColor,borderWidth:t.borderWidth,radius:t.radius},t.backgroundColor=Ne(o.hoverBackgroundColor,i(o.backgroundColor)),t.borderColor=Ne(o.hoverBorderColor,i(o.borderColor)),t.borderWidth=Ne(o.hoverBorderWidth,o.borderWidth),t.radius=Ne(o.hoverRadius,o.radius)}}),qe=W.options.resolve;F._set("polarArea",{scale:{type:"radialLinear",angleLines:{display:!1},gridLines:{circular:!0},pointLabels:{display:!1},ticks:{beginAtZero:!0}},animation:{animateRotate:!0,animateScale:!0},startAngle:-.5*Math.PI,legendCallback:function(e){var t,o,i,r=document.createElement("ul"),s=e.data,n=s.datasets,a=s.labels;if(r.setAttribute("class",e.id+"-legend"),n.length)for(t=0,o=n[0].data.length;t<o;++t)(i=r.appendChild(document.createElement("li"))).appendChild(document.createElement("span")).style.backgroundColor=n[0].backgroundColor[t],a[t]&&i.appendChild(document.createTextNode(a[t]));return r.outerHTML},legend:{labels:{generateLabels:function(e){var t=e.data;return t.labels.length&&t.datasets.length?t.labels.map((function(o,i){var r=e.getDatasetMeta(0),s=r.controller.getStyle(i);return{text:o,fillStyle:s.backgroundColor,strokeStyle:s.borderColor,lineWidth:s.borderWidth,hidden:isNaN(t.datasets[0].data[i])||r.data[i].hidden,index:i}})):[]}},onClick:function(e,t){var o,i,r,s=t.index,n=this.chart;for(o=0,i=(n.data.datasets||[]).length;o<i;++o)(r=n.getDatasetMeta(o)).data[s].hidden=!r.data[s].hidden;n.update()}},tooltips:{callbacks:{title:function(){return""},label:function(e,t){return t.labels[e.index]+": "+e.yLabel}}}});var Ye=ie.extend({dataElementType:we.Arc,linkScales:W.noop,_dataElementOptions:["backgroundColor","borderColor","borderWidth","borderAlign","hoverBackgroundColor","hoverBorderColor","hoverBorderWidth"],_getIndexScaleId:function(){return this.chart.scale.id},_getValueScaleId:function(){return this.chart.scale.id},update:function(e){var t,o,i,r=this,s=r.getDataset(),n=r.getMeta(),a=r.chart.options.startAngle||0,c=r._starts=[],l=r._angles=[],h=n.data;for(r._updateRadius(),n.count=r.countVisibleElements(),t=0,o=s.data.length;t<o;t++)c[t]=a,i=r._computeAngle(t),l[t]=i,a+=i;for(t=0,o=h.length;t<o;++t)h[t]._options=r._resolveDataElementOptions(h[t],t),r.updateElement(h[t],t,e)},_updateRadius:function(){var e=this,t=e.chart,o=t.chartArea,i=t.options,r=Math.min(o.right-o.left,o.bottom-o.top);t.outerRadius=Math.max(r/2,0),t.innerRadius=Math.max(i.cutoutPercentage?t.outerRadius/100*i.cutoutPercentage:1,0),t.radiusLength=(t.outerRadius-t.innerRadius)/t.getVisibleDatasetCount(),e.outerRadius=t.outerRadius-t.radiusLength*e.index,e.innerRadius=e.outerRadius-t.radiusLength},updateElement:function(e,t,o){var i=this,r=i.chart,s=i.getDataset(),n=r.options,a=n.animation,c=r.scale,l=r.data.labels,h=c.xCenter,d=c.yCenter,p=n.startAngle,u=e.hidden?0:c.getDistanceFromCenterForValue(s.data[t]),m=i._starts[t],f=m+(e.hidden?0:i._angles[t]),g=a.animateScale?0:c.getDistanceFromCenterForValue(s.data[t]),b=e._options||{};W.extend(e,{_datasetIndex:i.index,_index:t,_scale:c,_model:{backgroundColor:b.backgroundColor,borderColor:b.borderColor,borderWidth:b.borderWidth,borderAlign:b.borderAlign,x:h,y:d,innerRadius:0,outerRadius:o?g:u,startAngle:o&&a.animateRotate?p:m,endAngle:o&&a.animateRotate?p:f,label:W.valueAtIndexOrDefault(l,t,l[t])}}),e.pivot()},countVisibleElements:function(){var e=this.getDataset(),t=this.getMeta(),o=0;return W.each(t.data,(function(t,i){isNaN(e.data[i])||t.hidden||o++})),o},setHoverStyle:function(e){var t=e._model,o=e._options,i=W.getHoverColor,r=W.valueOrDefault;e.$previousStyle={backgroundColor:t.backgroundColor,borderColor:t.borderColor,borderWidth:t.borderWidth},t.backgroundColor=r(o.hoverBackgroundColor,i(o.backgroundColor)),t.borderColor=r(o.hoverBorderColor,i(o.borderColor)),t.borderWidth=r(o.hoverBorderWidth,o.borderWidth)},_computeAngle:function(e){var t=this,o=this.getMeta().count,i=t.getDataset(),r=t.getMeta();if(isNaN(i.data[e])||r.data[e].hidden)return 0;var s={chart:t.chart,dataIndex:e,dataset:i,datasetIndex:t.index};return qe([t.chart.options.elements.arc.angle,2*Math.PI/o],s,e)}});F._set("pie",W.clone(F.doughnut)),F._set("pie",{cutoutPercentage:0});var je=Pe,Ue=W.valueOrDefault;F._set("radar",{spanGaps:!1,scale:{type:"radialLinear"},elements:{line:{fill:"start",tension:0}}});var Ze=ie.extend({datasetElementType:we.Line,dataElementType:we.Point,linkScales:W.noop,_datasetElementOptions:["backgroundColor","borderWidth","borderColor","borderCapStyle","borderDash","borderDashOffset","borderJoinStyle","fill"],_dataElementOptions:{backgroundColor:"pointBackgroundColor",borderColor:"pointBorderColor",borderWidth:"pointBorderWidth",hitRadius:"pointHitRadius",hoverBackgroundColor:"pointHoverBackgroundColor",hoverBorderColor:"pointHoverBorderColor",hoverBorderWidth:"pointHoverBorderWidth",hoverRadius:"pointHoverRadius",pointStyle:"pointStyle",radius:"pointRadius",rotation:"pointRotation"},_getIndexScaleId:function(){return this.chart.scale.id},_getValueScaleId:function(){return this.chart.scale.id},update:function(e){var t,o,i=this,r=i.getMeta(),s=r.dataset,n=r.data||[],a=i.chart.scale,c=i._config;for(void 0!==c.tension&&void 0===c.lineTension&&(c.lineTension=c.tension),s._scale=a,s._datasetIndex=i.index,s._children=n,s._loop=!0,s._model=i._resolveDatasetElementOptions(s),s.pivot(),t=0,o=n.length;t<o;++t)i.updateElement(n[t],t,e);for(i.updateBezierControlPoints(),t=0,o=n.length;t<o;++t)n[t].pivot()},updateElement:function(e,t,o){var i=this,r=e.custom||{},s=i.getDataset(),n=i.chart.scale,a=n.getPointPositionForValue(t,s.data[t]),c=i._resolveDataElementOptions(e,t),l=i.getMeta().dataset._model,h=o?n.xCenter:a.x,d=o?n.yCenter:a.y;e._scale=n,e._options=c,e._datasetIndex=i.index,e._index=t,e._model={x:h,y:d,skip:r.skip||isNaN(h)||isNaN(d),radius:c.radius,pointStyle:c.pointStyle,rotation:c.rotation,backgroundColor:c.backgroundColor,borderColor:c.borderColor,borderWidth:c.borderWidth,tension:Ue(r.tension,l?l.tension:0),hitRadius:c.hitRadius}},_resolveDatasetElementOptions:function(){var e=this,t=e._config,o=e.chart.options,i=ie.prototype._resolveDatasetElementOptions.apply(e,arguments);return i.spanGaps=Ue(t.spanGaps,o.spanGaps),i.tension=Ue(t.lineTension,o.elements.line.tension),i},updateBezierControlPoints:function(){var e,t,o,i,r=this.getMeta(),s=this.chart.chartArea,n=r.data||[];function a(e,t,o){return Math.max(Math.min(e,o),t)}for(r.dataset._model.spanGaps&&(n=n.filter((function(e){return!e._model.skip}))),e=0,t=n.length;e<t;++e)o=n[e]._model,i=W.splineCurve(W.previousItem(n,e,!0)._model,o,W.nextItem(n,e,!0)._model,o.tension),o.controlPointPreviousX=a(i.previous.x,s.left,s.right),o.controlPointPreviousY=a(i.previous.y,s.top,s.bottom),o.controlPointNextX=a(i.next.x,s.left,s.right),o.controlPointNextY=a(i.next.y,s.top,s.bottom)},setHoverStyle:function(e){var t=e._model,o=e._options,i=W.getHoverColor;e.$previousStyle={backgroundColor:t.backgroundColor,borderColor:t.borderColor,borderWidth:t.borderWidth,radius:t.radius},t.backgroundColor=Ue(o.hoverBackgroundColor,i(o.backgroundColor)),t.borderColor=Ue(o.hoverBorderColor,i(o.borderColor)),t.borderWidth=Ue(o.hoverBorderWidth,o.borderWidth),t.radius=Ue(o.hoverRadius,o.radius)}});F._set("scatter",{hover:{mode:"single"},scales:{xAxes:[{id:"x-axis-1",type:"linear",position:"bottom"}],yAxes:[{id:"y-axis-1",type:"linear",position:"left"}]},tooltips:{callbacks:{title:function(){return""},label:function(e){return"("+e.xLabel+", "+e.yLabel+")"}}}}),F._set("global",{datasets:{scatter:{showLine:!1}}});var Ke={bar:Ae,bubble:De,doughnut:Pe,horizontalBar:Oe,line:We,polarArea:Ye,pie:je,radar:Ze,scatter:We};function Ge(e,t){return e.native?{x:e.x,y:e.y}:W.getRelativePosition(e,t)}function Xe(e,t){var o,i,r,s,n,a,c=e._getSortedVisibleDatasetMetas();for(i=0,s=c.length;i<s;++i)for(r=0,n=(o=c[i].data).length;r<n;++r)(a=o[r])._view.skip||t(a)}function Je(e,t){var o=[];return Xe(e,(function(e){e.inRange(t.x,t.y)&&o.push(e)})),o}function Qe(e,t,o,i){var r=Number.POSITIVE_INFINITY,s=[];return Xe(e,(function(e){if(!o||e.inRange(t.x,t.y)){var n=e.getCenterPoint(),a=i(t,n);a<r?(s=[e],r=a):a===r&&s.push(e)}})),s}function et(e){var t=-1!==e.indexOf("x"),o=-1!==e.indexOf("y");return function(e,i){var r=t?Math.abs(e.x-i.x):0,s=o?Math.abs(e.y-i.y):0;return Math.sqrt(Math.pow(r,2)+Math.pow(s,2))}}function tt(e,t,o){var i=Ge(t,e);o.axis=o.axis||"x";var r=et(o.axis),s=o.intersect?Je(e,i):Qe(e,i,!1,r),n=[];return s.length?(e._getSortedVisibleDatasetMetas().forEach((function(e){var t=e.data[s[0]._index];t&&!t._view.skip&&n.push(t)})),n):[]}var ot={modes:{single:function(e,t){var o=Ge(t,e),i=[];return Xe(e,(function(e){if(e.inRange(o.x,o.y))return i.push(e),i})),i.slice(0,1)},label:tt,index:tt,dataset:function(e,t,o){var i=Ge(t,e);o.axis=o.axis||"xy";var r=et(o.axis),s=o.intersect?Je(e,i):Qe(e,i,!1,r);return s.length>0&&(s=e.getDatasetMeta(s[0]._datasetIndex).data),s},"x-axis":function(e,t){return tt(e,t,{intersect:!1})},point:function(e,t){return Je(e,Ge(t,e))},nearest:function(e,t,o){var i=Ge(t,e);o.axis=o.axis||"xy";var r=et(o.axis);return Qe(e,i,o.intersect,r)},x:function(e,t,o){var i=Ge(t,e),r=[],s=!1;return Xe(e,(function(e){e.inXRange(i.x)&&r.push(e),e.inRange(i.x,i.y)&&(s=!0)})),o.intersect&&!s&&(r=[]),r},y:function(e,t,o){var i=Ge(t,e),r=[],s=!1;return Xe(e,(function(e){e.inYRange(i.y)&&r.push(e),e.inRange(i.x,i.y)&&(s=!0)})),o.intersect&&!s&&(r=[]),r}}},it=W.extend;function rt(e,t){return W.where(e,(function(e){return e.pos===t}))}function st(e,t){return e.sort((function(e,o){var i=t?o:e,r=t?e:o;return i.weight===r.weight?i.index-r.index:i.weight-r.weight}))}function nt(e,t,o,i){return Math.max(e[o],t[o])+Math.max(e[i],t[i])}function at(e,t,o){var i,r,s=o.box,n=e.maxPadding;if(o.size&&(e[o.pos]-=o.size),o.size=o.horizontal?s.height:s.width,e[o.pos]+=o.size,s.getPadding){var a=s.getPadding();n.top=Math.max(n.top,a.top),n.left=Math.max(n.left,a.left),n.bottom=Math.max(n.bottom,a.bottom),n.right=Math.max(n.right,a.right)}if(i=t.outerWidth-nt(n,e,"left","right"),r=t.outerHeight-nt(n,e,"top","bottom"),i!==e.w||r!==e.h){e.w=i,e.h=r;var c=o.horizontal?[i,e.w]:[r,e.h];return!(c[0]===c[1]||isNaN(c[0])&&isNaN(c[1]))}}function ct(e,t){var o,i=t.maxPadding;return o={left:0,top:0,right:0,bottom:0},(e?["left","right"]:["top","bottom"]).forEach((function(e){o[e]=Math.max(t[e],i[e])})),o}function lt(e,t,o){var i,r,s,n,a,c,l=[];for(i=0,r=e.length;i<r;++i)(n=(s=e[i]).box).update(s.width||t.w,s.height||t.h,ct(s.horizontal,t)),at(t,o,s)&&(c=!0,l.length&&(a=!0)),n.fullWidth||l.push(s);return a&&lt(l,t,o)||c}function ht(e,t,o){var i,r,s,n,a=o.padding,c=t.x,l=t.y;for(i=0,r=e.length;i<r;++i)n=(s=e[i]).box,s.horizontal?(n.left=n.fullWidth?a.left:t.left,n.right=n.fullWidth?o.outerWidth-a.right:t.left+t.w,n.top=l,n.bottom=l+n.height,n.width=n.right-n.left,l=n.bottom):(n.left=c,n.right=c+n.width,n.top=t.top,n.bottom=t.top+t.h,n.height=n.bottom-n.top,c=n.right);t.x=c,t.y=l}F._set("global",{layout:{padding:{top:0,right:0,bottom:0,left:0}}});var dt,pt={defaults:{},addBox:function(e,t){e.boxes||(e.boxes=[]),t.fullWidth=t.fullWidth||!1,t.position=t.position||"top",t.weight=t.weight||0,t._layers=t._layers||function(){return[{z:0,draw:function(){t.draw.apply(t,arguments)}}]},e.boxes.push(t)},removeBox:function(e,t){var o=e.boxes?e.boxes.indexOf(t):-1;-1!==o&&e.boxes.splice(o,1)},configure:function(e,t,o){for(var i,r=["fullWidth","position","weight"],s=r.length,n=0;n<s;++n)i=r[n],o.hasOwnProperty(i)&&(t[i]=o[i])},update:function(e,t,o){if(e){var i=e.options.layout||{},r=W.options.toPadding(i.padding),s=t-r.width,n=o-r.height,a=function(e){var t=function(e){var t,o,i,r=[];for(t=0,o=(e||[]).length;t<o;++t)i=e[t],r.push({index:t,box:i,pos:i.position,horizontal:i.isHorizontal(),weight:i.weight});return r}(e),o=st(rt(t,"left"),!0),i=st(rt(t,"right")),r=st(rt(t,"top"),!0),s=st(rt(t,"bottom"));return{leftAndTop:o.concat(r),rightAndBottom:i.concat(s),chartArea:rt(t,"chartArea"),vertical:o.concat(i),horizontal:r.concat(s)}}(e.boxes),c=a.vertical,l=a.horizontal,h=Object.freeze({outerWidth:t,outerHeight:o,padding:r,availableWidth:s,vBoxMaxWidth:s/2/c.length,hBoxMaxHeight:n/2}),d=it({maxPadding:it({},r),w:s,h:n,x:r.left,y:r.top},r);!function(e,t){var o,i,r;for(o=0,i=e.length;o<i;++o)(r=e[o]).width=r.horizontal?r.box.fullWidth&&t.availableWidth:t.vBoxMaxWidth,r.height=r.horizontal&&t.hBoxMaxHeight}(c.concat(l),h),lt(c,d,h),lt(l,d,h)&&lt(c,d,h),function(e){var t=e.maxPadding;function o(o){var i=Math.max(t[o]-e[o],0);return e[o]+=i,i}e.y+=o("top"),e.x+=o("left"),o("right"),o("bottom")}(d),ht(a.leftAndTop,d,h),d.x+=d.w,d.y+=d.h,ht(a.rightAndBottom,d,h),e.chartArea={left:d.left,top:d.top,right:d.left+d.w,bottom:d.top+d.h},W.each(a.chartArea,(function(t){var o=t.box;it(o,e.chartArea),o.update(d.w,d.h)}))}}},ut=(dt=Object.freeze({__proto__:null,default:"/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n\tfrom { opacity: 0.99; }\r\n\tto { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n\tanimation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n\tposition: absolute;\r\n\tdirection: ltr;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\tvisibility: hidden;\r\n\tz-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n\tposition: absolute;\r\n\twidth: 1000000px;\r\n\theight: 1000000px;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n\tposition: absolute;\r\n\twidth: 200%;\r\n\theight: 200%;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n"}))&&dt.default||dt,mt="chartjs-size-monitor",ft="chartjs-render-monitor",gt=["animationstart","webkitAnimationStart"],bt={touchstart:"mousedown",touchmove:"mousemove",touchend:"mouseup",pointerenter:"mouseenter",pointerdown:"mousedown",pointermove:"mousemove",pointerup:"mouseup",pointerleave:"mouseout",pointerout:"mouseout"};function vt(e,t){var o=W.getStyle(e,t),i=o&&o.match(/^(\d+)(\.\d+)?px$/);return i?Number(i[1]):void 0}var yt=!!function(){var e=!1;try{var t=Object.defineProperty({},"passive",{get:function(){e=!0}});window.addEventListener("e",null,t)}catch(e){}return e}()&&{passive:!0};function wt(e,t,o){e.addEventListener(t,o,yt)}function xt(e,t,o){e.removeEventListener(t,o,yt)}function _t(e,t,o,i,r){return{type:e,chart:t,native:r||null,x:void 0!==o?o:null,y:void 0!==i?i:null}}function kt(e){var t=document.createElement("div");return t.className=e||"",t}var Ct={disableCSSInjection:!1,_enabled:"undefined"!=typeof window&&"undefined"!=typeof document,_ensureLoaded:function(e){if(!this.disableCSSInjection){var t=e.getRootNode?e.getRootNode():document;!function(e,t){var o=e.$chartjs||(e.$chartjs={});if(!o.containsStyles){o.containsStyles=!0,t="/* Chart.js */\n"+t;var i=document.createElement("style");i.setAttribute("type","text/css"),i.appendChild(document.createTextNode(t)),e.appendChild(i)}}(t.host?t:document.head,ut)}},acquireContext:function(e,t){"string"==typeof e?e=document.getElementById(e):e.length&&(e=e[0]),e&&e.canvas&&(e=e.canvas);var o=e&&e.getContext&&e.getContext("2d");return o&&o.canvas===e?(this._ensureLoaded(e),function(e,t){var o=e.style,i=e.getAttribute("height"),r=e.getAttribute("width");if(e.$chartjs={initial:{height:i,width:r,style:{display:o.display,height:o.height,width:o.width}}},o.display=o.display||"block",null===r||""===r){var s=vt(e,"width");void 0!==s&&(e.width=s)}if(null===i||""===i)if(""===e.style.height)e.height=e.width/(t.options.aspectRatio||2);else{var n=vt(e,"height");void 0!==s&&(e.height=n)}}(e,t),o):null},releaseContext:function(e){var t=e.canvas;if(t.$chartjs){var o=t.$chartjs.initial;["height","width"].forEach((function(e){var i=o[e];W.isNullOrUndef(i)?t.removeAttribute(e):t.setAttribute(e,i)})),W.each(o.style||{},(function(e,o){t.style[o]=e})),t.width=t.width,delete t.$chartjs}},addEventListener:function(e,t,o){var i=e.canvas;if("resize"!==t){var r=o.$chartjs||(o.$chartjs={}),s=(r.proxies||(r.proxies={}))[e.id+"_"+t]=function(t){o(function(e,t){var o=bt[e.type]||e.type,i=W.getRelativePosition(e,t);return _t(o,t,i.x,i.y,e)}(t,e))};wt(i,t,s)}else!function(e,t,o){var i=e.$chartjs||(e.$chartjs={}),r=i.resizer=function(e){var t=1e6,o=kt(mt),i=kt(mt+"-expand"),r=kt(mt+"-shrink");i.appendChild(kt()),r.appendChild(kt()),o.appendChild(i),o.appendChild(r),o._reset=function(){i.scrollLeft=t,i.scrollTop=t,r.scrollLeft=t,r.scrollTop=t};var s=function(){o._reset(),e()};return wt(i,"scroll",s.bind(i,"expand")),wt(r,"scroll",s.bind(r,"shrink")),o}(function(e,t){var o=!1,i=[];return function(){i=Array.prototype.slice.call(arguments),t=t||this,o||(o=!0,W.requestAnimFrame.call(window,(function(){o=!1,e.apply(t,i)})))}}((function(){if(i.resizer){var r=o.options.maintainAspectRatio&&e.parentNode,s=r?r.clientWidth:0;t(_t("resize",o)),r&&r.clientWidth<s&&o.canvas&&t(_t("resize",o))}})));!function(e,t){var o=e.$chartjs||(e.$chartjs={}),i=o.renderProxy=function(e){"chartjs-render-animation"===e.animationName&&t()};W.each(gt,(function(t){wt(e,t,i)})),o.reflow=!!e.offsetParent,e.classList.add(ft)}(e,(function(){if(i.resizer){var t=e.parentNode;t&&t!==r.parentNode&&t.insertBefore(r,t.firstChild),r._reset()}}))}(i,o,e)},removeEventListener:function(e,t,o){var i,r,s,n=e.canvas;if("resize"!==t){var a=((o.$chartjs||{}).proxies||{})[e.id+"_"+t];a&&xt(n,t,a)}else r=(i=n).$chartjs||{},s=r.resizer,delete r.resizer,function(e){var t=e.$chartjs||{},o=t.renderProxy;o&&(W.each(gt,(function(t){xt(e,t,o)})),delete t.renderProxy),e.classList.remove(ft)}(i),s&&s.parentNode&&s.parentNode.removeChild(s)}};W.addEvent=wt,W.removeEvent=xt;var Et=Ct._enabled?Ct:{acquireContext:function(e){return e&&e.canvas&&(e=e.canvas),e&&e.getContext("2d")||null}},zt=W.extend({initialize:function(){},acquireContext:function(){},releaseContext:function(){},addEventListener:function(){},removeEventListener:function(){}},Et);F._set("global",{plugins:{}});var At={_plugins:[],_cacheId:0,register:function(e){var t=this._plugins;[].concat(e).forEach((function(e){-1===t.indexOf(e)&&t.push(e)})),this._cacheId++},unregister:function(e){var t=this._plugins;[].concat(e).forEach((function(e){var o=t.indexOf(e);-1!==o&&t.splice(o,1)})),this._cacheId++},clear:function(){this._plugins=[],this._cacheId++},count:function(){return this._plugins.length},getAll:function(){return this._plugins},notify:function(e,t,o){var i,r,s,n,a,c=this.descriptors(e),l=c.length;for(i=0;i<l;++i)if("function"==typeof(a=(s=(r=c[i]).plugin)[t])&&((n=[e].concat(o||[])).push(r.options),!1===a.apply(s,n)))return!1;return!0},descriptors:function(e){var t=e.$plugins||(e.$plugins={});if(t.id===this._cacheId)return t.descriptors;var o=[],i=[],r=e&&e.config||{},s=r.options&&r.options.plugins||{};return this._plugins.concat(r.plugins||[]).forEach((function(e){if(-1===o.indexOf(e)){var t=e.id,r=s[t];!1!==r&&(!0===r&&(r=W.clone(F.global.plugins[t])),o.push(e),i.push({plugin:e,options:r||{}}))}})),t.descriptors=i,t.id=this._cacheId,i},_invalidate:function(e){delete e.$plugins}},St={constructors:{},defaults:{},registerScaleType:function(e,t,o){this.constructors[e]=t,this.defaults[e]=W.clone(o)},getScaleConstructor:function(e){return this.constructors.hasOwnProperty(e)?this.constructors[e]:void 0},getScaleDefaults:function(e){return this.defaults.hasOwnProperty(e)?W.merge(Object.create(null),[F.scale,this.defaults[e]]):{}},updateScaleDefaults:function(e,t){var o=this;o.defaults.hasOwnProperty(e)&&(o.defaults[e]=W.extend(o.defaults[e],t))},addScalesToLayout:function(e){W.each(e.scales,(function(t){t.fullWidth=t.options.fullWidth,t.position=t.options.position,t.weight=t.options.weight,pt.addBox(e,t)}))}},Mt=W.valueOrDefault,Dt=W.rtl.getRtlAdapter;F._set("global",{tooltips:{enabled:!0,custom:null,mode:"nearest",position:"average",intersect:!0,backgroundColor:"rgba(0,0,0,0.8)",titleFontStyle:"bold",titleSpacing:2,titleMarginBottom:6,titleFontColor:"#fff",titleAlign:"left",bodySpacing:2,bodyFontColor:"#fff",bodyAlign:"left",footerFontStyle:"bold",footerSpacing:2,footerMarginTop:6,footerFontColor:"#fff",footerAlign:"left",yPadding:6,xPadding:6,caretPadding:2,caretSize:5,cornerRadius:6,multiKeyBackground:"#fff",displayColors:!0,borderColor:"rgba(0,0,0,0)",borderWidth:0,callbacks:{beforeTitle:W.noop,title:function(e,t){var o="",i=t.labels,r=i?i.length:0;if(e.length>0){var s=e[0];s.label?o=s.label:s.xLabel?o=s.xLabel:r>0&&s.index<r&&(o=i[s.index])}return o},afterTitle:W.noop,beforeBody:W.noop,beforeLabel:W.noop,label:function(e,t){var o=t.datasets[e.datasetIndex].label||"";return o&&(o+=": "),W.isNullOrUndef(e.value)?o+=e.yLabel:o+=e.value,o},labelColor:function(e,t){var o=t.getDatasetMeta(e.datasetIndex).data[e.index]._view;return{borderColor:o.borderColor,backgroundColor:o.backgroundColor}},labelTextColor:function(){return this._options.bodyFontColor},afterLabel:W.noop,afterBody:W.noop,beforeFooter:W.noop,footer:W.noop,afterFooter:W.noop}}});var Bt={average:function(e){if(!e.length)return!1;var t,o,i=0,r=0,s=0;for(t=0,o=e.length;t<o;++t){var n=e[t];if(n&&n.hasValue()){var a=n.tooltipPosition();i+=a.x,r+=a.y,++s}}return{x:i/s,y:r/s}},nearest:function(e,t){var o,i,r,s=t.x,n=t.y,a=Number.POSITIVE_INFINITY;for(o=0,i=e.length;o<i;++o){var c=e[o];if(c&&c.hasValue()){var l=c.getCenterPoint(),h=W.distanceBetweenPoints(t,l);h<a&&(a=h,r=c)}}if(r){var d=r.tooltipPosition();s=d.x,n=d.y}return{x:s,y:n}}};function Tt(e,t){return t&&(W.isArray(t)?Array.prototype.push.apply(e,t):e.push(t)),e}function Rt(e){return("string"==typeof e||e instanceof String)&&e.indexOf("\n")>-1?e.split("\n"):e}function Lt(e){var t=F.global;return{xPadding:e.xPadding,yPadding:e.yPadding,xAlign:e.xAlign,yAlign:e.yAlign,rtl:e.rtl,textDirection:e.textDirection,bodyFontColor:e.bodyFontColor,_bodyFontFamily:Mt(e.bodyFontFamily,t.defaultFontFamily),_bodyFontStyle:Mt(e.bodyFontStyle,t.defaultFontStyle),_bodyAlign:e.bodyAlign,bodyFontSize:Mt(e.bodyFontSize,t.defaultFontSize),bodySpacing:e.bodySpacing,titleFontColor:e.titleFontColor,_titleFontFamily:Mt(e.titleFontFamily,t.defaultFontFamily),_titleFontStyle:Mt(e.titleFontStyle,t.defaultFontStyle),titleFontSize:Mt(e.titleFontSize,t.defaultFontSize),_titleAlign:e.titleAlign,titleSpacing:e.titleSpacing,titleMarginBottom:e.titleMarginBottom,footerFontColor:e.footerFontColor,_footerFontFamily:Mt(e.footerFontFamily,t.defaultFontFamily),_footerFontStyle:Mt(e.footerFontStyle,t.defaultFontStyle),footerFontSize:Mt(e.footerFontSize,t.defaultFontSize),_footerAlign:e.footerAlign,footerSpacing:e.footerSpacing,footerMarginTop:e.footerMarginTop,caretSize:e.caretSize,cornerRadius:e.cornerRadius,backgroundColor:e.backgroundColor,opacity:0,legendColorBackground:e.multiKeyBackground,displayColors:e.displayColors,borderColor:e.borderColor,borderWidth:e.borderWidth}}function Pt(e,t){return"center"===t?e.x+e.width/2:"right"===t?e.x+e.width-e.xPadding:e.x+e.xPadding}function Ot(e){return Tt([],Rt(e))}var Nt=K.extend({initialize:function(){this._model=Lt(this._options),this._lastActive=[]},getTitle:function(){var e=this,t=e._options,o=t.callbacks,i=o.beforeTitle.apply(e,arguments),r=o.title.apply(e,arguments),s=o.afterTitle.apply(e,arguments),n=[];return n=Tt(n,Rt(i)),n=Tt(n,Rt(r)),Tt(n,Rt(s))},getBeforeBody:function(){return Ot(this._options.callbacks.beforeBody.apply(this,arguments))},getBody:function(e,t){var o=this,i=o._options.callbacks,r=[];return W.each(e,(function(e){var s={before:[],lines:[],after:[]};Tt(s.before,Rt(i.beforeLabel.call(o,e,t))),Tt(s.lines,i.label.call(o,e,t)),Tt(s.after,Rt(i.afterLabel.call(o,e,t))),r.push(s)})),r},getAfterBody:function(){return Ot(this._options.callbacks.afterBody.apply(this,arguments))},getFooter:function(){var e=this,t=e._options.callbacks,o=t.beforeFooter.apply(e,arguments),i=t.footer.apply(e,arguments),r=t.afterFooter.apply(e,arguments),s=[];return s=Tt(s,Rt(o)),s=Tt(s,Rt(i)),Tt(s,Rt(r))},update:function(e){var t,o,i,r,s,n,a,c,l,h,d=this,p=d._options,u=d._model,m=d._model=Lt(p),f=d._active,g=d._data,b={xAlign:u.xAlign,yAlign:u.yAlign},v={x:u.x,y:u.y},y={width:u.width,height:u.height},w={x:u.caretX,y:u.caretY};if(f.length){m.opacity=1;var x=[],_=[];w=Bt[p.position].call(d,f,d._eventPosition);var k=[];for(t=0,o=f.length;t<o;++t)k.push((r=void 0,s=void 0,void 0,void 0,c=void 0,l=void 0,h=void 0,r=(i=f[t])._xScale,s=i._yScale||i._scale,n=i._index,a=i._datasetIndex,l=(c=i._chart.getDatasetMeta(a).controller)._getIndexScale(),h=c._getValueScale(),{xLabel:r?r.getLabelForIndex(n,a):"",yLabel:s?s.getLabelForIndex(n,a):"",label:l?""+l.getLabelForIndex(n,a):"",value:h?""+h.getLabelForIndex(n,a):"",index:n,datasetIndex:a,x:i._model.x,y:i._model.y}));p.filter&&(k=k.filter((function(e){return p.filter(e,g)}))),p.itemSort&&(k=k.sort((function(e,t){return p.itemSort(e,t,g)}))),W.each(k,(function(e){x.push(p.callbacks.labelColor.call(d,e,d._chart)),_.push(p.callbacks.labelTextColor.call(d,e,d._chart))})),m.title=d.getTitle(k,g),m.beforeBody=d.getBeforeBody(k,g),m.body=d.getBody(k,g),m.afterBody=d.getAfterBody(k,g),m.footer=d.getFooter(k,g),m.x=w.x,m.y=w.y,m.caretPadding=p.caretPadding,m.labelColors=x,m.labelTextColors=_,m.dataPoints=k,y=function(e,t){var o=e._chart.ctx,i=2*t.yPadding,r=0,s=t.body,n=s.reduce((function(e,t){return e+t.before.length+t.lines.length+t.after.length}),0);n+=t.beforeBody.length+t.afterBody.length;var a=t.title.length,c=t.footer.length,l=t.titleFontSize,h=t.bodyFontSize,d=t.footerFontSize;i+=a*l,i+=a?(a-1)*t.titleSpacing:0,i+=a?t.titleMarginBottom:0,i+=n*h,i+=n?(n-1)*t.bodySpacing:0,i+=c?t.footerMarginTop:0,i+=c*d,i+=c?(c-1)*t.footerSpacing:0;var p=0,u=function(e){r=Math.max(r,o.measureText(e).width+p)};return o.font=W.fontString(l,t._titleFontStyle,t._titleFontFamily),W.each(t.title,u),o.font=W.fontString(h,t._bodyFontStyle,t._bodyFontFamily),W.each(t.beforeBody.concat(t.afterBody),u),p=t.displayColors?h+2:0,W.each(s,(function(e){W.each(e.before,u),W.each(e.lines,u),W.each(e.after,u)})),p=0,o.font=W.fontString(d,t._footerFontStyle,t._footerFontFamily),W.each(t.footer,u),{width:r+=2*t.xPadding,height:i}}(this,m),b=function(e,t){var o,i,r,s,n,a=e._model,c=e._chart,l=e._chart.chartArea,h="center",d="center";a.y<t.height?d="top":a.y>c.height-t.height&&(d="bottom");var p=(l.left+l.right)/2,u=(l.top+l.bottom)/2;"center"===d?(o=function(e){return e<=p},i=function(e){return e>p}):(o=function(e){return e<=t.width/2},i=function(e){return e>=c.width-t.width/2}),r=function(e){return e+t.width+a.caretSize+a.caretPadding>c.width},s=function(e){return e-t.width-a.caretSize-a.caretPadding<0},n=function(e){return e<=u?"top":"bottom"},o(a.x)?(h="left",r(a.x)&&(h="center",d=n(a.y))):i(a.x)&&(h="right",s(a.x)&&(h="center",d=n(a.y)));var m=e._options;return{xAlign:m.xAlign?m.xAlign:h,yAlign:m.yAlign?m.yAlign:d}}(this,y),v=function(e,t,o,i){var r=e.x,s=e.y,n=e.caretSize,a=e.caretPadding,c=e.cornerRadius,l=o.xAlign,h=o.yAlign,d=n+a,p=c+a;return"right"===l?r-=t.width:"center"===l&&((r-=t.width/2)+t.width>i.width&&(r=i.width-t.width),r<0&&(r=0)),"top"===h?s+=d:s-="bottom"===h?t.height+d:t.height/2,"center"===h?"left"===l?r+=d:"right"===l&&(r-=d):"left"===l?r-=p:"right"===l&&(r+=p),{x:r,y:s}}(m,y,b,d._chart)}else m.opacity=0;return m.xAlign=b.xAlign,m.yAlign=b.yAlign,m.x=v.x,m.y=v.y,m.width=y.width,m.height=y.height,m.caretX=w.x,m.caretY=w.y,d._model=m,e&&p.custom&&p.custom.call(d,m),d},drawCaret:function(e,t){var o=this._chart.ctx,i=this._view,r=this.getCaretPosition(e,t,i);o.lineTo(r.x1,r.y1),o.lineTo(r.x2,r.y2),o.lineTo(r.x3,r.y3)},getCaretPosition:function(e,t,o){var i,r,s,n,a,c,l=o.caretSize,h=o.cornerRadius,d=o.xAlign,p=o.yAlign,u=e.x,m=e.y,f=t.width,g=t.height;if("center"===p)a=m+g/2,"left"===d?(r=(i=u)-l,s=i,n=a+l,c=a-l):(r=(i=u+f)+l,s=i,n=a-l,c=a+l);else if("left"===d?(i=(r=u+h+l)-l,s=r+l):"right"===d?(i=(r=u+f-h-l)-l,s=r+l):(i=(r=o.caretX)-l,s=r+l),"top"===p)a=(n=m)-l,c=n;else{a=(n=m+g)+l,c=n;var b=s;s=i,i=b}return{x1:i,x2:r,x3:s,y1:n,y2:a,y3:c}},drawTitle:function(e,t,o){var i,r,s,n=t.title,a=n.length;if(a){var c=Dt(t.rtl,t.x,t.width);for(e.x=Pt(t,t._titleAlign),o.textAlign=c.textAlign(t._titleAlign),o.textBaseline="middle",i=t.titleFontSize,r=t.titleSpacing,o.fillStyle=t.titleFontColor,o.font=W.fontString(i,t._titleFontStyle,t._titleFontFamily),s=0;s<a;++s)o.fillText(n[s],c.x(e.x),e.y+i/2),e.y+=i+r,s+1===a&&(e.y+=t.titleMarginBottom-r)}},drawBody:function(e,t,o){var i,r,s,n,a,c,l,h,d=t.bodyFontSize,p=t.bodySpacing,u=t._bodyAlign,m=t.body,f=t.displayColors,g=0,b=f?Pt(t,"left"):0,v=Dt(t.rtl,t.x,t.width),y=function(t){o.fillText(t,v.x(e.x+g),e.y+d/2),e.y+=d+p},w=v.textAlign(u);for(o.textAlign=u,o.textBaseline="middle",o.font=W.fontString(d,t._bodyFontStyle,t._bodyFontFamily),e.x=Pt(t,w),o.fillStyle=t.bodyFontColor,W.each(t.beforeBody,y),g=f&&"right"!==w?"center"===u?d/2+1:d+2:0,a=0,l=m.length;a<l;++a){for(i=m[a],r=t.labelTextColors[a],s=t.labelColors[a],o.fillStyle=r,W.each(i.before,y),c=0,h=(n=i.lines).length;c<h;++c){if(f){var x=v.x(b);o.fillStyle=t.legendColorBackground,o.fillRect(v.leftForLtr(x,d),e.y,d,d),o.lineWidth=1,o.strokeStyle=s.borderColor,o.strokeRect(v.leftForLtr(x,d),e.y,d,d),o.fillStyle=s.backgroundColor,o.fillRect(v.leftForLtr(v.xPlus(x,1),d-2),e.y+1,d-2,d-2),o.fillStyle=r}y(n[c])}W.each(i.after,y)}g=0,W.each(t.afterBody,y),e.y-=p},drawFooter:function(e,t,o){var i,r,s=t.footer,n=s.length;if(n){var a=Dt(t.rtl,t.x,t.width);for(e.x=Pt(t,t._footerAlign),e.y+=t.footerMarginTop,o.textAlign=a.textAlign(t._footerAlign),o.textBaseline="middle",i=t.footerFontSize,o.fillStyle=t.footerFontColor,o.font=W.fontString(i,t._footerFontStyle,t._footerFontFamily),r=0;r<n;++r)o.fillText(s[r],a.x(e.x),e.y+i/2),e.y+=i+t.footerSpacing}},drawBackground:function(e,t,o,i){o.fillStyle=t.backgroundColor,o.strokeStyle=t.borderColor,o.lineWidth=t.borderWidth;var r=t.xAlign,s=t.yAlign,n=e.x,a=e.y,c=i.width,l=i.height,h=t.cornerRadius;o.beginPath(),o.moveTo(n+h,a),"top"===s&&this.drawCaret(e,i),o.lineTo(n+c-h,a),o.quadraticCurveTo(n+c,a,n+c,a+h),"center"===s&&"right"===r&&this.drawCaret(e,i),o.lineTo(n+c,a+l-h),o.quadraticCurveTo(n+c,a+l,n+c-h,a+l),"bottom"===s&&this.drawCaret(e,i),o.lineTo(n+h,a+l),o.quadraticCurveTo(n,a+l,n,a+l-h),"center"===s&&"left"===r&&this.drawCaret(e,i),o.lineTo(n,a+h),o.quadraticCurveTo(n,a,n+h,a),o.closePath(),o.fill(),t.borderWidth>0&&o.stroke()},draw:function(){var e=this._chart.ctx,t=this._view;if(0!==t.opacity){var o={width:t.width,height:t.height},i={x:t.x,y:t.y},r=Math.abs(t.opacity<.001)?0:t.opacity,s=t.title.length||t.beforeBody.length||t.body.length||t.afterBody.length||t.footer.length;this._options.enabled&&s&&(e.save(),e.globalAlpha=r,this.drawBackground(i,t,e,o),i.y+=t.yPadding,W.rtl.overrideTextDirection(e,t.textDirection),this.drawTitle(i,t,e),this.drawBody(i,t,e),this.drawFooter(i,t,e),W.rtl.restoreTextDirection(e,t.textDirection),e.restore())}},handleEvent:function(e){var t,o=this,i=o._options;return o._lastActive=o._lastActive||[],"mouseout"===e.type?o._active=[]:(o._active=o._chart.getElementsAtEventForMode(e,i.mode,i),i.reverse&&o._active.reverse()),(t=!W.arrayEquals(o._active,o._lastActive))&&(o._lastActive=o._active,(i.enabled||i.custom)&&(o._eventPosition={x:e.x,y:e.y},o.update(!0),o.pivot())),t}}),Ft=Bt,$t=Nt;$t.positioners=Ft;var It=W.valueOrDefault;function Vt(){return W.merge(Object.create(null),[].slice.call(arguments),{merger:function(e,t,o,i){if("xAxes"===e||"yAxes"===e){var r,s,n,a=o[e].length;for(t[e]||(t[e]=[]),r=0;r<a;++r)n=o[e][r],s=It(n.type,"xAxes"===e?"category":"linear"),r>=t[e].length&&t[e].push({}),!t[e][r].type||n.type&&n.type!==t[e][r].type?W.merge(t[e][r],[St.getScaleDefaults(s),n]):W.merge(t[e][r],n)}else W._merger(e,t,o,i)}})}function Ht(){return W.merge(Object.create(null),[].slice.call(arguments),{merger:function(e,t,o,i){var r=t[e]||Object.create(null),s=o[e];"scales"===e?t[e]=Vt(r,s):"scale"===e?t[e]=W.merge(r,[St.getScaleDefaults(s.type),s]):W._merger(e,t,o,i)}})}function Wt(e){var t=e.options;W.each(e.scales,(function(t){pt.removeBox(e,t)})),t=Ht(F.global,F[e.config.type],t),e.options=e.config.options=t,e.ensureScalesHaveIDs(),e.buildOrUpdateScales(),e.tooltip._options=t.tooltips,e.tooltip.initialize()}function qt(e,t,o){var i,r=function(e){return e.id===i};do{i=t+o++}while(W.findIndex(e,r)>=0);return i}function Yt(e){return"top"===e||"bottom"===e}function jt(e,t){return function(o,i){return o[e]===i[e]?o[t]-i[t]:o[e]-i[e]}}F._set("global",{elements:{},events:["mousemove","mouseout","click","touchstart","touchmove"],hover:{onHover:null,mode:"nearest",intersect:!0,animationDuration:400},onClick:null,maintainAspectRatio:!0,responsive:!0,responsiveAnimationDuration:0});var Ut=function(e,t){return this.construct(e,t),this};W.extend(Ut.prototype,{construct:function(e,t){var o=this;t=function(e){var t=(e=e||Object.create(null)).data=e.data||{};return t.datasets=t.datasets||[],t.labels=t.labels||[],e.options=Ht(F.global,F[e.type],e.options||{}),e}(t);var i=zt.acquireContext(e,t),r=i&&i.canvas,s=r&&r.height,n=r&&r.width;o.id=W.uid(),o.ctx=i,o.canvas=r,o.config=t,o.width=n,o.height=s,o.aspectRatio=s?n/s:null,o.options=t.options,o._bufferedRender=!1,o._layers=[],o.chart=o,o.controller=o,Ut.instances[o.id]=o,Object.defineProperty(o,"data",{get:function(){return o.config.data},set:function(e){o.config.data=e}}),i&&r?(o.initialize(),o.update()):console.error("Failed to create chart: can't acquire context from the given item")},initialize:function(){var e=this;return At.notify(e,"beforeInit"),W.retinaScale(e,e.options.devicePixelRatio),e.bindEvents(),e.options.responsive&&e.resize(!0),e.initToolTip(),At.notify(e,"afterInit"),e},clear:function(){return W.canvas.clear(this),this},stop:function(){return J.cancelAnimation(this),this},resize:function(e){var t=this,o=t.options,i=t.canvas,r=o.maintainAspectRatio&&t.aspectRatio||null,s=Math.max(0,Math.floor(W.getMaximumWidth(i))),n=Math.max(0,Math.floor(r?s/r:W.getMaximumHeight(i)));if((t.width!==s||t.height!==n)&&(i.width=t.width=s,i.height=t.height=n,i.style.width=s+"px",i.style.height=n+"px",W.retinaScale(t,o.devicePixelRatio),!e)){var a={width:s,height:n};At.notify(t,"resize",[a]),o.onResize&&o.onResize(t,a),t.stop(),t.update({duration:o.responsiveAnimationDuration})}},ensureScalesHaveIDs:function(){var e=this.options,t=e.scales||{},o=e.scale;W.each(t.xAxes,(function(e,o){e.id||(e.id=qt(t.xAxes,"x-axis-",o))})),W.each(t.yAxes,(function(e,o){e.id||(e.id=qt(t.yAxes,"y-axis-",o))})),o&&(o.id=o.id||"scale")},buildOrUpdateScales:function(){var e=this,t=e.options,o=e.scales||{},i=[],r=Object.keys(o).reduce((function(e,t){return e[t]=!1,e}),{});t.scales&&(i=i.concat((t.scales.xAxes||[]).map((function(e){return{options:e,dtype:"category",dposition:"bottom"}})),(t.scales.yAxes||[]).map((function(e){return{options:e,dtype:"linear",dposition:"left"}})))),t.scale&&i.push({options:t.scale,dtype:"radialLinear",isDefault:!0,dposition:"chartArea"}),W.each(i,(function(t){var i=t.options,s=i.id,n=It(i.type,t.dtype);Yt(i.position)!==Yt(t.dposition)&&(i.position=t.dposition),r[s]=!0;var a=null;if(s in o&&o[s].type===n)(a=o[s]).options=i,a.ctx=e.ctx,a.chart=e;else{var c=St.getScaleConstructor(n);if(!c)return;a=new c({id:s,type:n,options:i,ctx:e.ctx,chart:e}),o[a.id]=a}a.mergeTicksOptions(),t.isDefault&&(e.scale=a)})),W.each(r,(function(e,t){e||delete o[t]})),e.scales=o,St.addScalesToLayout(this)},buildOrUpdateControllers:function(){var e,t,o=this,i=[],r=o.data.datasets;for(e=0,t=r.length;e<t;e++){var s=r[e],n=o.getDatasetMeta(e),a=s.type||o.config.type;if(n.type&&n.type!==a&&(o.destroyDatasetMeta(e),n=o.getDatasetMeta(e)),n.type=a,n.order=s.order||0,n.index=e,n.controller)n.controller.updateIndex(e),n.controller.linkScales();else{var c=Ke[n.type];if(void 0===c)throw new Error('"'+n.type+'" is not a chart type.');n.controller=new c(o,e),i.push(n.controller)}}return i},resetElements:function(){var e=this;W.each(e.data.datasets,(function(t,o){e.getDatasetMeta(o).controller.reset()}),e)},reset:function(){this.resetElements(),this.tooltip.initialize()},update:function(e){var t,o,i=this;if(e&&"object"==typeof e||(e={duration:e,lazy:arguments[1]}),Wt(i),At._invalidate(i),!1!==At.notify(i,"beforeUpdate")){i.tooltip._data=i.data;var r=i.buildOrUpdateControllers();for(t=0,o=i.data.datasets.length;t<o;t++)i.getDatasetMeta(t).controller.buildOrUpdateElements();i.updateLayout(),i.options.animation&&i.options.animation.duration&&W.each(r,(function(e){e.reset()})),i.updateDatasets(),i.tooltip.initialize(),i.lastActive=[],At.notify(i,"afterUpdate"),i._layers.sort(jt("z","_idx")),i._bufferedRender?i._bufferedRequest={duration:e.duration,easing:e.easing,lazy:e.lazy}:i.render(e)}},updateLayout:function(){var e=this;!1!==At.notify(e,"beforeLayout")&&(pt.update(this,this.width,this.height),e._layers=[],W.each(e.boxes,(function(t){t._configure&&t._configure(),e._layers.push.apply(e._layers,t._layers())}),e),e._layers.forEach((function(e,t){e._idx=t})),At.notify(e,"afterScaleUpdate"),At.notify(e,"afterLayout"))},updateDatasets:function(){var e=this;if(!1!==At.notify(e,"beforeDatasetsUpdate")){for(var t=0,o=e.data.datasets.length;t<o;++t)e.updateDataset(t);At.notify(e,"afterDatasetsUpdate")}},updateDataset:function(e){var t=this,o=t.getDatasetMeta(e),i={meta:o,index:e};!1!==At.notify(t,"beforeDatasetUpdate",[i])&&(o.controller._update(),At.notify(t,"afterDatasetUpdate",[i]))},render:function(e){var t=this;e&&"object"==typeof e||(e={duration:e,lazy:arguments[1]});var o=t.options.animation,i=It(e.duration,o&&o.duration),r=e.lazy;if(!1!==At.notify(t,"beforeRender")){var s=function(e){At.notify(t,"afterRender"),W.callback(o&&o.onComplete,[e],t)};if(o&&i){var n=new X({numSteps:i/16.66,easing:e.easing||o.easing,render:function(e,t){var o=W.easing.effects[t.easing],i=t.currentStep,r=i/t.numSteps;e.draw(o(r),r,i)},onAnimationProgress:o.onProgress,onAnimationComplete:s});J.addAnimation(t,n,i,r)}else t.draw(),s(new X({numSteps:0,chart:t}));return t}},draw:function(e){var t,o,i=this;if(i.clear(),W.isNullOrUndef(e)&&(e=1),i.transition(e),!(i.width<=0||i.height<=0)&&!1!==At.notify(i,"beforeDraw",[e])){for(o=i._layers,t=0;t<o.length&&o[t].z<=0;++t)o[t].draw(i.chartArea);for(i.drawDatasets(e);t<o.length;++t)o[t].draw(i.chartArea);i._drawTooltip(e),At.notify(i,"afterDraw",[e])}},transition:function(e){for(var t=this,o=0,i=(t.data.datasets||[]).length;o<i;++o)t.isDatasetVisible(o)&&t.getDatasetMeta(o).controller.transition(e);t.tooltip.transition(e)},_getSortedDatasetMetas:function(e){var t,o,i=this,r=[];for(t=0,o=(i.data.datasets||[]).length;t<o;++t)e&&!i.isDatasetVisible(t)||r.push(i.getDatasetMeta(t));return r.sort(jt("order","index")),r},_getSortedVisibleDatasetMetas:function(){return this._getSortedDatasetMetas(!0)},drawDatasets:function(e){var t,o,i=this;if(!1!==At.notify(i,"beforeDatasetsDraw",[e])){for(o=(t=i._getSortedVisibleDatasetMetas()).length-1;o>=0;--o)i.drawDataset(t[o],e);At.notify(i,"afterDatasetsDraw",[e])}},drawDataset:function(e,t){var o={meta:e,index:e.index,easingValue:t};!1!==At.notify(this,"beforeDatasetDraw",[o])&&(e.controller.draw(t),At.notify(this,"afterDatasetDraw",[o]))},_drawTooltip:function(e){var t=this,o=t.tooltip,i={tooltip:o,easingValue:e};!1!==At.notify(t,"beforeTooltipDraw",[i])&&(o.draw(),At.notify(t,"afterTooltipDraw",[i]))},getElementAtEvent:function(e){return ot.modes.single(this,e)},getElementsAtEvent:function(e){return ot.modes.label(this,e,{intersect:!0})},getElementsAtXAxis:function(e){return ot.modes["x-axis"](this,e,{intersect:!0})},getElementsAtEventForMode:function(e,t,o){var i=ot.modes[t];return"function"==typeof i?i(this,e,o):[]},getDatasetAtEvent:function(e){return ot.modes.dataset(this,e,{intersect:!0})},getDatasetMeta:function(e){var t=this,o=t.data.datasets[e];o._meta||(o._meta={});var i=o._meta[t.id];return i||(i=o._meta[t.id]={type:null,data:[],dataset:null,controller:null,hidden:null,xAxisID:null,yAxisID:null,order:o.order||0,index:e}),i},getVisibleDatasetCount:function(){for(var e=0,t=0,o=this.data.datasets.length;t<o;++t)this.isDatasetVisible(t)&&e++;return e},isDatasetVisible:function(e){var t=this.getDatasetMeta(e);return"boolean"==typeof t.hidden?!t.hidden:!this.data.datasets[e].hidden},generateLegend:function(){return this.options.legendCallback(this)},destroyDatasetMeta:function(e){var t=this.id,o=this.data.datasets[e],i=o._meta&&o._meta[t];i&&(i.controller.destroy(),delete o._meta[t])},destroy:function(){var e,t,o=this,i=o.canvas;for(o.stop(),e=0,t=o.data.datasets.length;e<t;++e)o.destroyDatasetMeta(e);i&&(o.unbindEvents(),W.canvas.clear(o),zt.releaseContext(o.ctx),o.canvas=null,o.ctx=null),At.notify(o,"destroy"),delete Ut.instances[o.id]},toBase64Image:function(){return this.canvas.toDataURL.apply(this.canvas,arguments)},initToolTip:function(){var e=this;e.tooltip=new $t({_chart:e,_chartInstance:e,_data:e.data,_options:e.options.tooltips},e)},bindEvents:function(){var e=this,t=e._listeners={},o=function(){e.eventHandler.apply(e,arguments)};W.each(e.options.events,(function(i){zt.addEventListener(e,i,o),t[i]=o})),e.options.responsive&&(o=function(){e.resize()},zt.addEventListener(e,"resize",o),t.resize=o)},unbindEvents:function(){var e=this,t=e._listeners;t&&(delete e._listeners,W.each(t,(function(t,o){zt.removeEventListener(e,o,t)})))},updateHoverStyle:function(e,t,o){var i,r,s,n=o?"set":"remove";for(r=0,s=e.length;r<s;++r)(i=e[r])&&this.getDatasetMeta(i._datasetIndex).controller[n+"HoverStyle"](i);"dataset"===t&&this.getDatasetMeta(e[0]._datasetIndex).controller["_"+n+"DatasetHoverStyle"]()},eventHandler:function(e){var t=this,o=t.tooltip;if(!1!==At.notify(t,"beforeEvent",[e])){t._bufferedRender=!0,t._bufferedRequest=null;var i=t.handleEvent(e);o&&(i=o._start?o.handleEvent(e):i|o.handleEvent(e)),At.notify(t,"afterEvent",[e]);var r=t._bufferedRequest;return r?t.render(r):i&&!t.animating&&(t.stop(),t.render({duration:t.options.hover.animationDuration,lazy:!0})),t._bufferedRender=!1,t._bufferedRequest=null,t}},handleEvent:function(e){var t,o=this,i=o.options||{},r=i.hover;return o.lastActive=o.lastActive||[],"mouseout"===e.type?o.active=[]:o.active=o.getElementsAtEventForMode(e,r.mode,r),W.callback(i.onHover||i.hover.onHover,[e.native,o.active],o),"mouseup"!==e.type&&"click"!==e.type||i.onClick&&i.onClick.call(o,e.native,o.active),o.lastActive.length&&o.updateHoverStyle(o.lastActive,r.mode,!1),o.active.length&&r.mode&&o.updateHoverStyle(o.active,r.mode,!0),t=!W.arrayEquals(o.active,o.lastActive),o.lastActive=o.active,t}}),Ut.instances={};var Zt=Ut;function Kt(){throw new Error("This method is not implemented: either no adapter can be found or an incomplete integration was provided.")}function Gt(e){this.options=e||{}}Ut.Controller=Ut,Ut.types={},W.configMerge=Ht,W.scaleMerge=Vt,W.extend(Gt.prototype,{formats:Kt,parse:Kt,format:Kt,add:Kt,diff:Kt,startOf:Kt,endOf:Kt,_create:function(e){return e}}),Gt.override=function(e){W.extend(Gt.prototype,e)};var Xt={_date:Gt},Jt={formatters:{values:function(e){return W.isArray(e)?e:""+e},linear:function(e,t,o){var i=o.length>3?o[2]-o[1]:o[1]-o[0];Math.abs(i)>1&&e!==Math.floor(e)&&(i=e-Math.floor(e));var r=W.log10(Math.abs(i)),s="";if(0!==e)if(Math.max(Math.abs(o[0]),Math.abs(o[o.length-1]))<1e-4){var n=W.log10(Math.abs(e)),a=Math.floor(n)-Math.floor(r);a=Math.max(Math.min(a,20),0),s=e.toExponential(a)}else{var c=-1*Math.floor(r);c=Math.max(Math.min(c,20),0),s=e.toFixed(c)}else s="0";return s},logarithmic:function(e,t,o){var i=e/Math.pow(10,Math.floor(W.log10(e)));return 0===e?"0":1===i||2===i||5===i||0===t||t===o.length-1?e.toExponential():""}}},Qt=W.isArray,eo=W.isNullOrUndef,to=W.valueOrDefault,oo=W.valueAtIndexOrDefault;function io(e,t,o){var i,r=e.getTicks().length,s=Math.min(t,r-1),n=e.getPixelForTick(s),a=e._startPixel,c=e._endPixel,l=1e-6;if(!(o&&(i=1===r?Math.max(n-a,c-n):0===t?(e.getPixelForTick(1)-n)/2:(n-e.getPixelForTick(s-1))/2,(n+=s<t?i:-i)<a-l||n>c+l)))return n}function ro(e){return e.drawTicks?e.tickMarkLength:0}function so(e){var t,o;return e.display?(t=W.options._parseFont(e),o=W.options.toPadding(e.padding),t.lineHeight+o.height):0}function no(e,t){return W.extend(W.options._parseFont({fontFamily:to(t.fontFamily,e.fontFamily),fontSize:to(t.fontSize,e.fontSize),fontStyle:to(t.fontStyle,e.fontStyle),lineHeight:to(t.lineHeight,e.lineHeight)}),{color:W.options.resolve([t.fontColor,e.fontColor,F.global.defaultFontColor])})}function ao(e){var t=no(e,e.minor);return{minor:t,major:e.major.enabled?no(e,e.major):t}}function co(e){var t,o,i,r=[];for(o=0,i=e.length;o<i;++o)void 0!==(t=e[o])._index&&r.push(t);return r}function lo(e,t,o,i){var r,s,n,a,c=to(o,0),l=Math.min(to(i,e.length),e.length),h=0;for(t=Math.ceil(t),i&&(t=(r=i-o)/Math.floor(r/t)),a=c;a<0;)h++,a=Math.round(c+h*t);for(s=Math.max(c,0);s<l;s++)n=e[s],s===a?(n._index=s,h++,a=Math.round(c+h*t)):delete n.label}F._set("scale",{display:!0,position:"left",offset:!1,gridLines:{display:!0,color:"rgba(0,0,0,0.1)",lineWidth:1,drawBorder:!0,drawOnChartArea:!0,drawTicks:!0,tickMarkLength:10,zeroLineWidth:1,zeroLineColor:"rgba(0,0,0,0.25)",zeroLineBorderDash:[],zeroLineBorderDashOffset:0,offsetGridLines:!1,borderDash:[],borderDashOffset:0},scaleLabel:{display:!1,labelString:"",padding:{top:4,bottom:4}},ticks:{beginAtZero:!1,minRotation:0,maxRotation:50,mirror:!1,padding:0,reverse:!1,display:!0,autoSkip:!0,autoSkipPadding:0,labelOffset:0,callback:Jt.formatters.values,minor:{},major:{}}});var ho=K.extend({zeroLineIndex:0,getPadding:function(){var e=this;return{left:e.paddingLeft||0,top:e.paddingTop||0,right:e.paddingRight||0,bottom:e.paddingBottom||0}},getTicks:function(){return this._ticks},_getLabels:function(){var e=this.chart.data;return this.options.labels||(this.isHorizontal()?e.xLabels:e.yLabels)||e.labels||[]},mergeTicksOptions:function(){},beforeUpdate:function(){W.callback(this.options.beforeUpdate,[this])},update:function(e,t,o){var i,r,s,n,a,c=this,l=c.options.ticks,h=l.sampleSize;if(c.beforeUpdate(),c.maxWidth=e,c.maxHeight=t,c.margins=W.extend({left:0,right:0,top:0,bottom:0},o),c._ticks=null,c.ticks=null,c._labelSizes=null,c._maxLabelLines=0,c.longestLabelWidth=0,c.longestTextCache=c.longestTextCache||{},c._gridLineItems=null,c._labelItems=null,c.beforeSetDimensions(),c.setDimensions(),c.afterSetDimensions(),c.beforeDataLimits(),c.determineDataLimits(),c.afterDataLimits(),c.beforeBuildTicks(),n=c.buildTicks()||[],(!(n=c.afterBuildTicks(n)||n)||!n.length)&&c.ticks)for(n=[],i=0,r=c.ticks.length;i<r;++i)n.push({value:c.ticks[i],major:!1});return c._ticks=n,a=h<n.length,s=c._convertTicksToLabels(a?function(e,t){for(var o=[],i=e.length/t,r=0,s=e.length;r<s;r+=i)o.push(e[Math.floor(r)]);return o}(n,h):n),c._configure(),c.beforeCalculateTickRotation(),c.calculateTickRotation(),c.afterCalculateTickRotation(),c.beforeFit(),c.fit(),c.afterFit(),c._ticksToDraw=l.display&&(l.autoSkip||"auto"===l.source)?c._autoSkip(n):n,a&&(s=c._convertTicksToLabels(c._ticksToDraw)),c.ticks=s,c.afterUpdate(),c.minSize},_configure:function(){var e,t,o=this,i=o.options.ticks.reverse;o.isHorizontal()?(e=o.left,t=o.right):(e=o.top,t=o.bottom,i=!i),o._startPixel=e,o._endPixel=t,o._reversePixels=i,o._length=t-e},afterUpdate:function(){W.callback(this.options.afterUpdate,[this])},beforeSetDimensions:function(){W.callback(this.options.beforeSetDimensions,[this])},setDimensions:function(){var e=this;e.isHorizontal()?(e.width=e.maxWidth,e.left=0,e.right=e.width):(e.height=e.maxHeight,e.top=0,e.bottom=e.height),e.paddingLeft=0,e.paddingTop=0,e.paddingRight=0,e.paddingBottom=0},afterSetDimensions:function(){W.callback(this.options.afterSetDimensions,[this])},beforeDataLimits:function(){W.callback(this.options.beforeDataLimits,[this])},determineDataLimits:W.noop,afterDataLimits:function(){W.callback(this.options.afterDataLimits,[this])},beforeBuildTicks:function(){W.callback(this.options.beforeBuildTicks,[this])},buildTicks:W.noop,afterBuildTicks:function(e){var t=this;return Qt(e)&&e.length?W.callback(t.options.afterBuildTicks,[t,e]):(t.ticks=W.callback(t.options.afterBuildTicks,[t,t.ticks])||t.ticks,e)},beforeTickToLabelConversion:function(){W.callback(this.options.beforeTickToLabelConversion,[this])},convertTicksToLabels:function(){var e=this,t=e.options.ticks;e.ticks=e.ticks.map(t.userCallback||t.callback,this)},afterTickToLabelConversion:function(){W.callback(this.options.afterTickToLabelConversion,[this])},beforeCalculateTickRotation:function(){W.callback(this.options.beforeCalculateTickRotation,[this])},calculateTickRotation:function(){var e,t,o,i,r,s,n,a=this,c=a.options,l=c.ticks,h=a.getTicks().length,d=l.minRotation||0,p=l.maxRotation,u=d;!a._isVisible()||!l.display||d>=p||h<=1||!a.isHorizontal()?a.labelRotation=d:(t=(e=a._getLabelSizes()).widest.width,o=e.highest.height-e.highest.offset,i=Math.min(a.maxWidth,a.chart.width-t),t+6>(r=c.offset?a.maxWidth/h:i/(h-1))&&(r=i/(h-(c.offset?.5:1)),s=a.maxHeight-ro(c.gridLines)-l.padding-so(c.scaleLabel),n=Math.sqrt(t*t+o*o),u=W.toDegrees(Math.min(Math.asin(Math.min((e.highest.height+6)/r,1)),Math.asin(Math.min(s/n,1))-Math.asin(o/n))),u=Math.max(d,Math.min(p,u))),a.labelRotation=u)},afterCalculateTickRotation:function(){W.callback(this.options.afterCalculateTickRotation,[this])},beforeFit:function(){W.callback(this.options.beforeFit,[this])},fit:function(){var e=this,t=e.minSize={width:0,height:0},o=e.chart,i=e.options,r=i.ticks,s=i.scaleLabel,n=i.gridLines,a=e._isVisible(),c="bottom"===i.position,l=e.isHorizontal();if(l?t.width=e.maxWidth:a&&(t.width=ro(n)+so(s)),l?a&&(t.height=ro(n)+so(s)):t.height=e.maxHeight,r.display&&a){var h=ao(r),d=e._getLabelSizes(),p=d.first,u=d.last,m=d.widest,f=d.highest,g=.4*h.minor.lineHeight,b=r.padding;if(l){var v=0!==e.labelRotation,y=W.toRadians(e.labelRotation),w=Math.cos(y),x=Math.sin(y),_=x*m.width+w*(f.height-(v?f.offset:0))+(v?0:g);t.height=Math.min(e.maxHeight,t.height+_+b);var k,C,E=e.getPixelForTick(0)-e.left,z=e.right-e.getPixelForTick(e.getTicks().length-1);v?(k=c?w*p.width+x*p.offset:x*(p.height-p.offset),C=c?x*(u.height-u.offset):w*u.width+x*u.offset):(k=p.width/2,C=u.width/2),e.paddingLeft=Math.max((k-E)*e.width/(e.width-E),0)+3,e.paddingRight=Math.max((C-z)*e.width/(e.width-z),0)+3}else{var A=r.mirror?0:m.width+b+g;t.width=Math.min(e.maxWidth,t.width+A),e.paddingTop=p.height/2,e.paddingBottom=u.height/2}}e.handleMargins(),l?(e.width=e._length=o.width-e.margins.left-e.margins.right,e.height=t.height):(e.width=t.width,e.height=e._length=o.height-e.margins.top-e.margins.bottom)},handleMargins:function(){var e=this;e.margins&&(e.margins.left=Math.max(e.paddingLeft,e.margins.left),e.margins.top=Math.max(e.paddingTop,e.margins.top),e.margins.right=Math.max(e.paddingRight,e.margins.right),e.margins.bottom=Math.max(e.paddingBottom,e.margins.bottom))},afterFit:function(){W.callback(this.options.afterFit,[this])},isHorizontal:function(){var e=this.options.position;return"top"===e||"bottom"===e},isFullWidth:function(){return this.options.fullWidth},getRightValue:function(e){if(eo(e))return NaN;if(("number"==typeof e||e instanceof Number)&&!isFinite(e))return NaN;if(e)if(this.isHorizontal()){if(void 0!==e.x)return this.getRightValue(e.x)}else if(void 0!==e.y)return this.getRightValue(e.y);return e},_convertTicksToLabels:function(e){var t,o,i,r=this;for(r.ticks=e.map((function(e){return e.value})),r.beforeTickToLabelConversion(),t=r.convertTicksToLabels(e)||r.ticks,r.afterTickToLabelConversion(),o=0,i=e.length;o<i;++o)e[o].label=t[o];return t},_getLabelSizes:function(){var e=this,t=e._labelSizes;return t||(e._labelSizes=t=function(e,t,o,i){var r,s,n,a,c,l,h,d,p,u,m,f,g,b=o.length,v=[],y=[],w=[],x=0,_=0;for(r=0;r<b;++r){if(a=o[r].label,c=o[r].major?t.major:t.minor,e.font=l=c.string,h=i[l]=i[l]||{data:{},gc:[]},d=c.lineHeight,p=u=0,eo(a)||Qt(a)){if(Qt(a))for(s=0,n=a.length;s<n;++s)m=a[s],eo(m)||Qt(m)||(p=W.measureText(e,h.data,h.gc,p,m),u+=d)}else p=W.measureText(e,h.data,h.gc,p,a),u=d;v.push(p),y.push(u),w.push(d/2),x=Math.max(p,x),_=Math.max(u,_)}function k(e){return{width:v[e]||0,height:y[e]||0,offset:w[e]||0}}return function(e,t){W.each(e,(function(e){var o,i=e.gc,r=i.length/2;if(r>t){for(o=0;o<r;++o)delete e.data[i[o]];i.splice(0,r)}}))}(i,b),f=v.indexOf(x),g=y.indexOf(_),{first:k(0),last:k(b-1),widest:k(f),highest:k(g)}}(e.ctx,ao(e.options.ticks),e.getTicks(),e.longestTextCache),e.longestLabelWidth=t.widest.width),t},_parseValue:function(e){var t,o,i,r;return Qt(e)?(t=+this.getRightValue(e[0]),o=+this.getRightValue(e[1]),i=Math.min(t,o),r=Math.max(t,o)):(t=void 0,o=e=+this.getRightValue(e),i=e,r=e),{min:i,max:r,start:t,end:o}},_getScaleLabel:function(e){var t=this._parseValue(e);return void 0!==t.start?"["+t.start+", "+t.end+"]":+this.getRightValue(e)},getLabelForIndex:W.noop,getPixelForValue:W.noop,getValueForPixel:W.noop,getPixelForTick:function(e){var t=this,o=t.options.offset,i=t._ticks.length,r=1/Math.max(i-(o?0:1),1);return e<0||e>i-1?null:t.getPixelForDecimal(e*r+(o?r/2:0))},getPixelForDecimal:function(e){var t=this;return t._reversePixels&&(e=1-e),t._startPixel+e*t._length},getDecimalForPixel:function(e){var t=(e-this._startPixel)/this._length;return this._reversePixels?1-t:t},getBasePixel:function(){return this.getPixelForValue(this.getBaseValue())},getBaseValue:function(){var e=this,t=e.min,o=e.max;return e.beginAtZero?0:t<0&&o<0?o:t>0&&o>0?t:0},_autoSkip:function(e){var t,o,i,r,s=this,n=s.options.ticks,a=s._length,c=n.maxTicksLimit||a/s._tickSize()+1,l=n.major.enabled?function(e){var t,o,i=[];for(t=0,o=e.length;t<o;t++)e[t].major&&i.push(t);return i}(e):[],h=l.length,d=l[0],p=l[h-1];if(h>c)return function(e,t,o){var i,r,s=0,n=t[0];for(o=Math.ceil(o),i=0;i<e.length;i++)r=e[i],i===n?(r._index=i,n=t[++s*o]):delete r.label}(e,l,h/c),co(e);if(i=function(e,t,o,i){var r,s,n,a,c=function(e){var t,o,i=e.length;if(i<2)return!1;for(o=e[0],t=1;t<i;++t)if(e[t]-e[t-1]!==o)return!1;return o}(e),l=(t.length-1)/i;if(!c)return Math.max(l,1);for(n=0,a=(r=W.math._factorize(c)).length-1;n<a;n++)if((s=r[n])>l)return s;return Math.max(l,1)}(l,e,0,c),h>0){for(t=0,o=h-1;t<o;t++)lo(e,i,l[t],l[t+1]);return r=h>1?(p-d)/(h-1):null,lo(e,i,W.isNullOrUndef(r)?0:d-r,d),lo(e,i,p,W.isNullOrUndef(r)?e.length:p+r),co(e)}return lo(e,i),co(e)},_tickSize:function(){var e=this,t=e.options.ticks,o=W.toRadians(e.labelRotation),i=Math.abs(Math.cos(o)),r=Math.abs(Math.sin(o)),s=e._getLabelSizes(),n=t.autoSkipPadding||0,a=s?s.widest.width+n:0,c=s?s.highest.height+n:0;return e.isHorizontal()?c*i>a*r?a/i:c/r:c*r<a*i?c/i:a/r},_isVisible:function(){var e,t,o,i=this,r=i.chart,s=i.options.display;if("auto"!==s)return!!s;for(e=0,t=r.data.datasets.length;e<t;++e)if(r.isDatasetVisible(e)&&((o=r.getDatasetMeta(e)).xAxisID===i.id||o.yAxisID===i.id))return!0;return!1},_computeGridLineItems:function(e){var t,o,i,r,s,n,a,c,l,h,d,p,u,m,f,g,b,v=this,y=v.chart,w=v.options,x=w.gridLines,_=w.position,k=x.offsetGridLines,C=v.isHorizontal(),E=v._ticksToDraw,z=E.length+(k?1:0),A=ro(x),S=[],M=x.drawBorder?oo(x.lineWidth,0,0):0,D=M/2,B=W._alignPixel,T=function(e){return B(y,e,M)};for("top"===_?(t=T(v.bottom),a=v.bottom-A,l=t-D,d=T(e.top)+D,u=e.bottom):"bottom"===_?(t=T(v.top),d=e.top,u=T(e.bottom)-D,a=t+D,l=v.top+A):"left"===_?(t=T(v.right),n=v.right-A,c=t-D,h=T(e.left)+D,p=e.right):(t=T(v.left),h=e.left,p=T(e.right)-D,n=t+D,c=v.left+A),o=0;o<z;++o)i=E[o]||{},eo(i.label)&&o<E.length||(o===v.zeroLineIndex&&w.offset===k?(m=x.zeroLineWidth,f=x.zeroLineColor,g=x.zeroLineBorderDash||[],b=x.zeroLineBorderDashOffset||0):(m=oo(x.lineWidth,o,1),f=oo(x.color,o,"rgba(0,0,0,0.1)"),g=x.borderDash||[],b=x.borderDashOffset||0),void 0!==(r=io(v,i._index||o,k))&&(s=B(y,r,m),C?n=c=h=p=s:a=l=d=u=s,S.push({tx1:n,ty1:a,tx2:c,ty2:l,x1:h,y1:d,x2:p,y2:u,width:m,color:f,borderDash:g,borderDashOffset:b})));return S.ticksLength=z,S.borderValue=t,S},_computeLabelItems:function(){var e,t,o,i,r,s,n,a,c,l,h,d,p=this,u=p.options,m=u.ticks,f=u.position,g=m.mirror,b=p.isHorizontal(),v=p._ticksToDraw,y=ao(m),w=m.padding,x=ro(u.gridLines),_=-W.toRadians(p.labelRotation),k=[];for("top"===f?(s=p.bottom-x-w,n=_?"left":"center"):"bottom"===f?(s=p.top+x+w,n=_?"right":"center"):"left"===f?(r=p.right-(g?0:x)-w,n=g?"left":"right"):(r=p.left+(g?0:x)+w,n=g?"right":"left"),e=0,t=v.length;e<t;++e)i=(o=v[e]).label,eo(i)||(a=p.getPixelForTick(o._index||e)+m.labelOffset,l=(c=o.major?y.major:y.minor).lineHeight,h=Qt(i)?i.length:1,b?(r=a,d="top"===f?((_?1:.5)-h)*l:(_?0:.5)*l):(s=a,d=(1-h)*l/2),k.push({x:r,y:s,rotation:_,label:i,font:c,textOffset:d,textAlign:n}));return k},_drawGrid:function(e){var t=this,o=t.options.gridLines;if(o.display){var i,r,s,n,a,c=t.ctx,l=t.chart,h=W._alignPixel,d=o.drawBorder?oo(o.lineWidth,0,0):0,p=t._gridLineItems||(t._gridLineItems=t._computeGridLineItems(e));for(s=0,n=p.length;s<n;++s)i=(a=p[s]).width,r=a.color,i&&r&&(c.save(),c.lineWidth=i,c.strokeStyle=r,c.setLineDash&&(c.setLineDash(a.borderDash),c.lineDashOffset=a.borderDashOffset),c.beginPath(),o.drawTicks&&(c.moveTo(a.tx1,a.ty1),c.lineTo(a.tx2,a.ty2)),o.drawOnChartArea&&(c.moveTo(a.x1,a.y1),c.lineTo(a.x2,a.y2)),c.stroke(),c.restore());if(d){var u,m,f,g,b=d,v=oo(o.lineWidth,p.ticksLength-1,1),y=p.borderValue;t.isHorizontal()?(u=h(l,t.left,b)-b/2,m=h(l,t.right,v)+v/2,f=g=y):(f=h(l,t.top,b)-b/2,g=h(l,t.bottom,v)+v/2,u=m=y),c.lineWidth=d,c.strokeStyle=oo(o.color,0),c.beginPath(),c.moveTo(u,f),c.lineTo(m,g),c.stroke()}}},_drawLabels:function(){var e=this;if(e.options.ticks.display){var t,o,i,r,s,n,a,c,l=e.ctx,h=e._labelItems||(e._labelItems=e._computeLabelItems());for(t=0,i=h.length;t<i;++t){if(n=(s=h[t]).font,l.save(),l.translate(s.x,s.y),l.rotate(s.rotation),l.font=n.string,l.fillStyle=n.color,l.textBaseline="middle",l.textAlign=s.textAlign,a=s.label,c=s.textOffset,Qt(a))for(o=0,r=a.length;o<r;++o)l.fillText(""+a[o],0,c),c+=n.lineHeight;else l.fillText(a,0,c);l.restore()}}},_drawTitle:function(){var e=this,t=e.ctx,o=e.options,i=o.scaleLabel;if(i.display){var r,s,n=to(i.fontColor,F.global.defaultFontColor),a=W.options._parseFont(i),c=W.options.toPadding(i.padding),l=a.lineHeight/2,h=o.position,d=0;if(e.isHorizontal())r=e.left+e.width/2,s="bottom"===h?e.bottom-l-c.bottom:e.top+l+c.top;else{var p="left"===h;r=p?e.left+l+c.top:e.right-l-c.top,s=e.top+e.height/2,d=p?-.5*Math.PI:.5*Math.PI}t.save(),t.translate(r,s),t.rotate(d),t.textAlign="center",t.textBaseline="middle",t.fillStyle=n,t.font=a.string,t.fillText(i.labelString,0,0),t.restore()}},draw:function(e){var t=this;t._isVisible()&&(t._drawGrid(e),t._drawTitle(),t._drawLabels())},_layers:function(){var e=this,t=e.options,o=t.ticks&&t.ticks.z||0,i=t.gridLines&&t.gridLines.z||0;return e._isVisible()&&o!==i&&e.draw===e._draw?[{z:i,draw:function(){e._drawGrid.apply(e,arguments),e._drawTitle.apply(e,arguments)}},{z:o,draw:function(){e._drawLabels.apply(e,arguments)}}]:[{z:o,draw:function(){e.draw.apply(e,arguments)}}]},_getMatchingVisibleMetas:function(e){var t=this,o=t.isHorizontal();return t.chart._getSortedVisibleDatasetMetas().filter((function(i){return(!e||i.type===e)&&(o?i.xAxisID===t.id:i.yAxisID===t.id)}))}});ho.prototype._draw=ho.prototype.draw;var po=ho,uo=W.isNullOrUndef,mo=po.extend({determineDataLimits:function(){var e,t=this,o=t._getLabels(),i=t.options.ticks,r=i.min,s=i.max,n=0,a=o.length-1;void 0!==r&&(e=o.indexOf(r))>=0&&(n=e),void 0!==s&&(e=o.indexOf(s))>=0&&(a=e),t.minIndex=n,t.maxIndex=a,t.min=o[n],t.max=o[a]},buildTicks:function(){var e=this,t=e._getLabels(),o=e.minIndex,i=e.maxIndex;e.ticks=0===o&&i===t.length-1?t:t.slice(o,i+1)},getLabelForIndex:function(e,t){var o=this,i=o.chart;return i.getDatasetMeta(t).controller._getValueScaleId()===o.id?o.getRightValue(i.data.datasets[t].data[e]):o._getLabels()[e]},_configure:function(){var e=this,t=e.options.offset,o=e.ticks;po.prototype._configure.call(e),e.isHorizontal()||(e._reversePixels=!e._reversePixels),o&&(e._startValue=e.minIndex-(t?.5:0),e._valueRange=Math.max(o.length-(t?0:1),1))},getPixelForValue:function(e,t,o){var i,r,s,n=this;return uo(t)||uo(o)||(e=n.chart.data.datasets[o].data[t]),uo(e)||(i=n.isHorizontal()?e.x:e.y),(void 0!==i||void 0!==e&&isNaN(t))&&(r=n._getLabels(),e=W.valueOrDefault(i,e),t=-1!==(s=r.indexOf(e))?s:t,isNaN(t)&&(t=e)),n.getPixelForDecimal((t-n._startValue)/n._valueRange)},getPixelForTick:function(e){var t=this.ticks;return e<0||e>t.length-1?null:this.getPixelForValue(t[e],e+this.minIndex)},getValueForPixel:function(e){var t=this,o=Math.round(t._startValue+t.getDecimalForPixel(e)*t._valueRange);return Math.min(Math.max(o,0),t.ticks.length-1)},getBasePixel:function(){return this.bottom}});mo._defaults={position:"bottom"};var fo=W.noop,go=W.isNullOrUndef,bo=po.extend({getRightValue:function(e){return"string"==typeof e?+e:po.prototype.getRightValue.call(this,e)},handleTickRangeOptions:function(){var e=this,t=e.options.ticks;if(t.beginAtZero){var o=W.sign(e.min),i=W.sign(e.max);o<0&&i<0?e.max=0:o>0&&i>0&&(e.min=0)}var r=void 0!==t.min||void 0!==t.suggestedMin,s=void 0!==t.max||void 0!==t.suggestedMax;void 0!==t.min?e.min=t.min:void 0!==t.suggestedMin&&(null===e.min?e.min=t.suggestedMin:e.min=Math.min(e.min,t.suggestedMin)),void 0!==t.max?e.max=t.max:void 0!==t.suggestedMax&&(null===e.max?e.max=t.suggestedMax:e.max=Math.max(e.max,t.suggestedMax)),r!==s&&e.min>=e.max&&(r?e.max=e.min+1:e.min=e.max-1),e.min===e.max&&(e.max++,t.beginAtZero||e.min--)},getTickLimit:function(){var e,t=this,o=t.options.ticks,i=o.stepSize,r=o.maxTicksLimit;return i?e=Math.ceil(t.max/i)-Math.floor(t.min/i)+1:(e=t._computeTickLimit(),r=r||11),r&&(e=Math.min(r,e)),e},_computeTickLimit:function(){return Number.POSITIVE_INFINITY},handleDirectionalChanges:fo,buildTicks:function(){var e=this,t=e.options.ticks,o=e.getTickLimit(),i={maxTicks:o=Math.max(2,o),min:t.min,max:t.max,precision:t.precision,stepSize:W.valueOrDefault(t.fixedStepSize,t.stepSize)},r=e.ticks=function(e,t){var o,i,r,s,n=[],a=e.stepSize,c=a||1,l=e.maxTicks-1,h=e.min,d=e.max,p=e.precision,u=t.min,m=t.max,f=W.niceNum((m-u)/l/c)*c;if(f<1e-14&&go(h)&&go(d))return[u,m];(s=Math.ceil(m/f)-Math.floor(u/f))>l&&(f=W.niceNum(s*f/l/c)*c),a||go(p)?o=Math.pow(10,W._decimalPlaces(f)):(o=Math.pow(10,p),f=Math.ceil(f*o)/o),i=Math.floor(u/f)*f,r=Math.ceil(m/f)*f,a&&(!go(h)&&W.almostWhole(h/f,f/1e3)&&(i=h),!go(d)&&W.almostWhole(d/f,f/1e3)&&(r=d)),s=(r-i)/f,s=W.almostEquals(s,Math.round(s),f/1e3)?Math.round(s):Math.ceil(s),i=Math.round(i*o)/o,r=Math.round(r*o)/o,n.push(go(h)?i:h);for(var g=1;g<s;++g)n.push(Math.round((i+g*f)*o)/o);return n.push(go(d)?r:d),n}(i,e);e.handleDirectionalChanges(),e.max=W.max(r),e.min=W.min(r),t.reverse?(r.reverse(),e.start=e.max,e.end=e.min):(e.start=e.min,e.end=e.max)},convertTicksToLabels:function(){var e=this;e.ticksAsNumbers=e.ticks.slice(),e.zeroLineIndex=e.ticks.indexOf(0),po.prototype.convertTicksToLabels.call(e)},_configure:function(){var e,t=this,o=t.getTicks(),i=t.min,r=t.max;po.prototype._configure.call(t),t.options.offset&&o.length&&(i-=e=(r-i)/Math.max(o.length-1,1)/2,r+=e),t._startValue=i,t._endValue=r,t._valueRange=r-i}}),vo={position:"left",ticks:{callback:Jt.formatters.linear}};function yo(e,t,o,i){var r,s,n=e.options,a=function(e,t,o){var i=[o.type,void 0===t&&void 0===o.stack?o.index:"",o.stack].join(".");return void 0===e[i]&&(e[i]={pos:[],neg:[]}),e[i]}(t,n.stacked,o),c=a.pos,l=a.neg,h=i.length;for(r=0;r<h;++r)s=e._parseValue(i[r]),isNaN(s.min)||isNaN(s.max)||o.data[r].hidden||(c[r]=c[r]||0,l[r]=l[r]||0,n.relativePoints?c[r]=100:s.min<0||s.max<0?l[r]+=s.min:c[r]+=s.max)}function wo(e,t,o){var i,r,s=o.length;for(i=0;i<s;++i)r=e._parseValue(o[i]),isNaN(r.min)||isNaN(r.max)||t.data[i].hidden||(e.min=Math.min(e.min,r.min),e.max=Math.max(e.max,r.max))}var xo=bo.extend({determineDataLimits:function(){var e,t,o,i,r=this,s=r.options,n=r.chart.data.datasets,a=r._getMatchingVisibleMetas(),c=s.stacked,l={},h=a.length;if(r.min=Number.POSITIVE_INFINITY,r.max=Number.NEGATIVE_INFINITY,void 0===c)for(e=0;!c&&e<h;++e)c=void 0!==(t=a[e]).stack;for(e=0;e<h;++e)o=n[(t=a[e]).index].data,c?yo(r,l,t,o):wo(r,t,o);W.each(l,(function(e){i=e.pos.concat(e.neg),r.min=Math.min(r.min,W.min(i)),r.max=Math.max(r.max,W.max(i))})),r.min=W.isFinite(r.min)&&!isNaN(r.min)?r.min:0,r.max=W.isFinite(r.max)&&!isNaN(r.max)?r.max:1,r.handleTickRangeOptions()},_computeTickLimit:function(){var e,t=this;return t.isHorizontal()?Math.ceil(t.width/40):(e=W.options._parseFont(t.options.ticks),Math.ceil(t.height/e.lineHeight))},handleDirectionalChanges:function(){this.isHorizontal()||this.ticks.reverse()},getLabelForIndex:function(e,t){return this._getScaleLabel(this.chart.data.datasets[t].data[e])},getPixelForValue:function(e){var t=this;return t.getPixelForDecimal((+t.getRightValue(e)-t._startValue)/t._valueRange)},getValueForPixel:function(e){return this._startValue+this.getDecimalForPixel(e)*this._valueRange},getPixelForTick:function(e){var t=this.ticksAsNumbers;return e<0||e>t.length-1?null:this.getPixelForValue(t[e])}}),_o=vo;xo._defaults=_o;var ko=W.valueOrDefault,Co=W.math.log10,Eo={position:"left",ticks:{callback:Jt.formatters.logarithmic}};function zo(e,t){return W.isFinite(e)&&e>=0?e:t}var Ao=po.extend({determineDataLimits:function(){var e,t,o,i,r,s,n=this,a=n.options,c=n.chart,l=c.data.datasets,h=n.isHorizontal();function d(e){return h?e.xAxisID===n.id:e.yAxisID===n.id}n.min=Number.POSITIVE_INFINITY,n.max=Number.NEGATIVE_INFINITY,n.minNotZero=Number.POSITIVE_INFINITY;var p=a.stacked;if(void 0===p)for(e=0;e<l.length;e++)if(t=c.getDatasetMeta(e),c.isDatasetVisible(e)&&d(t)&&void 0!==t.stack){p=!0;break}if(a.stacked||p){var u={};for(e=0;e<l.length;e++){var m=[(t=c.getDatasetMeta(e)).type,void 0===a.stacked&&void 0===t.stack?e:"",t.stack].join(".");if(c.isDatasetVisible(e)&&d(t))for(void 0===u[m]&&(u[m]=[]),r=0,s=(i=l[e].data).length;r<s;r++){var f=u[m];o=n._parseValue(i[r]),isNaN(o.min)||isNaN(o.max)||t.data[r].hidden||o.min<0||o.max<0||(f[r]=f[r]||0,f[r]+=o.max)}}W.each(u,(function(e){if(e.length>0){var t=W.min(e),o=W.max(e);n.min=Math.min(n.min,t),n.max=Math.max(n.max,o)}}))}else for(e=0;e<l.length;e++)if(t=c.getDatasetMeta(e),c.isDatasetVisible(e)&&d(t))for(r=0,s=(i=l[e].data).length;r<s;r++)o=n._parseValue(i[r]),isNaN(o.min)||isNaN(o.max)||t.data[r].hidden||o.min<0||o.max<0||(n.min=Math.min(o.min,n.min),n.max=Math.max(o.max,n.max),0!==o.min&&(n.minNotZero=Math.min(o.min,n.minNotZero)));n.min=W.isFinite(n.min)?n.min:null,n.max=W.isFinite(n.max)?n.max:null,n.minNotZero=W.isFinite(n.minNotZero)?n.minNotZero:null,this.handleTickRangeOptions()},handleTickRangeOptions:function(){var e=this,t=e.options.ticks;e.min=zo(t.min,e.min),e.max=zo(t.max,e.max),e.min===e.max&&(0!==e.min&&null!==e.min?(e.min=Math.pow(10,Math.floor(Co(e.min))-1),e.max=Math.pow(10,Math.floor(Co(e.max))+1)):(e.min=1,e.max=10)),null===e.min&&(e.min=Math.pow(10,Math.floor(Co(e.max))-1)),null===e.max&&(e.max=0!==e.min?Math.pow(10,Math.floor(Co(e.min))+1):10),null===e.minNotZero&&(e.min>0?e.minNotZero=e.min:e.max<1?e.minNotZero=Math.pow(10,Math.floor(Co(e.max))):e.minNotZero=1)},buildTicks:function(){var e=this,t=e.options.ticks,o=!e.isHorizontal(),i={min:zo(t.min),max:zo(t.max)},r=e.ticks=function(e,t){var o,i,r=[],s=ko(e.min,Math.pow(10,Math.floor(Co(t.min)))),n=Math.floor(Co(t.max)),a=Math.ceil(t.max/Math.pow(10,n));0===s?(o=Math.floor(Co(t.minNotZero)),i=Math.floor(t.minNotZero/Math.pow(10,o)),r.push(s),s=i*Math.pow(10,o)):(o=Math.floor(Co(s)),i=Math.floor(s/Math.pow(10,o)));var c=o<0?Math.pow(10,Math.abs(o)):1;do{r.push(s),10==++i&&(i=1,c=++o>=0?1:c),s=Math.round(i*Math.pow(10,o)*c)/c}while(o<n||o===n&&i<a);var l=ko(e.max,s);return r.push(l),r}(i,e);e.max=W.max(r),e.min=W.min(r),t.reverse?(o=!o,e.start=e.max,e.end=e.min):(e.start=e.min,e.end=e.max),o&&r.reverse()},convertTicksToLabels:function(){this.tickValues=this.ticks.slice(),po.prototype.convertTicksToLabels.call(this)},getLabelForIndex:function(e,t){return this._getScaleLabel(this.chart.data.datasets[t].data[e])},getPixelForTick:function(e){var t=this.tickValues;return e<0||e>t.length-1?null:this.getPixelForValue(t[e])},_getFirstTickValue:function(e){var t=Math.floor(Co(e));return Math.floor(e/Math.pow(10,t))*Math.pow(10,t)},_configure:function(){var e=this,t=e.min,o=0;po.prototype._configure.call(e),0===t&&(t=e._getFirstTickValue(e.minNotZero),o=ko(e.options.ticks.fontSize,F.global.defaultFontSize)/e._length),e._startValue=Co(t),e._valueOffset=o,e._valueRange=(Co(e.max)-Co(t))/(1-o)},getPixelForValue:function(e){var t=this,o=0;return(e=+t.getRightValue(e))>t.min&&e>0&&(o=(Co(e)-t._startValue)/t._valueRange+t._valueOffset),t.getPixelForDecimal(o)},getValueForPixel:function(e){var t=this,o=t.getDecimalForPixel(e);return 0===o&&0===t.min?0:Math.pow(10,t._startValue+(o-t._valueOffset)*t._valueRange)}}),So=Eo;Ao._defaults=So;var Mo=W.valueOrDefault,Do=W.valueAtIndexOrDefault,Bo=W.options.resolve,To={display:!0,animate:!0,position:"chartArea",angleLines:{display:!0,color:"rgba(0,0,0,0.1)",lineWidth:1,borderDash:[],borderDashOffset:0},gridLines:{circular:!1},ticks:{showLabelBackdrop:!0,backdropColor:"rgba(255,255,255,0.75)",backdropPaddingY:2,backdropPaddingX:2,callback:Jt.formatters.linear},pointLabels:{display:!0,fontSize:10,callback:function(e){return e}}};function Ro(e){var t=e.ticks;return t.display&&e.display?Mo(t.fontSize,F.global.defaultFontSize)+2*t.backdropPaddingY:0}function Lo(e,t,o,i,r){return e===i||e===r?{start:t-o/2,end:t+o/2}:e<i||e>r?{start:t-o,end:t}:{start:t,end:t+o}}function Po(e){return 0===e||180===e?"center":e<180?"left":"right"}function Oo(e,t,o,i){var r,s,n=o.y+i/2;if(W.isArray(t))for(r=0,s=t.length;r<s;++r)e.fillText(t[r],o.x,n),n+=i;else e.fillText(t,o.x,n)}function No(e,t,o){90===e||270===e?o.y-=t.h/2:(e>270||e<90)&&(o.y-=t.h)}function Fo(e){return W.isNumber(e)?e:0}var $o=bo.extend({setDimensions:function(){var e=this;e.width=e.maxWidth,e.height=e.maxHeight,e.paddingTop=Ro(e.options)/2,e.xCenter=Math.floor(e.width/2),e.yCenter=Math.floor((e.height-e.paddingTop)/2),e.drawingArea=Math.min(e.height-e.paddingTop,e.width)/2},determineDataLimits:function(){var e=this,t=e.chart,o=Number.POSITIVE_INFINITY,i=Number.NEGATIVE_INFINITY;W.each(t.data.datasets,(function(r,s){if(t.isDatasetVisible(s)){var n=t.getDatasetMeta(s);W.each(r.data,(function(t,r){var s=+e.getRightValue(t);isNaN(s)||n.data[r].hidden||(o=Math.min(s,o),i=Math.max(s,i))}))}})),e.min=o===Number.POSITIVE_INFINITY?0:o,e.max=i===Number.NEGATIVE_INFINITY?0:i,e.handleTickRangeOptions()},_computeTickLimit:function(){return Math.ceil(this.drawingArea/Ro(this.options))},convertTicksToLabels:function(){var e=this;bo.prototype.convertTicksToLabels.call(e),e.pointLabels=e.chart.data.labels.map((function(){var t=W.callback(e.options.pointLabels.callback,arguments,e);return t||0===t?t:""}))},getLabelForIndex:function(e,t){return+this.getRightValue(this.chart.data.datasets[t].data[e])},fit:function(){var e=this,t=e.options;t.display&&t.pointLabels.display?function(e){var t,o,i,r=W.options._parseFont(e.options.pointLabels),s={l:0,r:e.width,t:0,b:e.height-e.paddingTop},n={};e.ctx.font=r.string,e._pointLabelSizes=[];var a,c,l,h=e.chart.data.labels.length;for(t=0;t<h;t++){i=e.getPointPosition(t,e.drawingArea+5),a=e.ctx,c=r.lineHeight,l=e.pointLabels[t],o=W.isArray(l)?{w:W.longestText(a,a.font,l),h:l.length*c}:{w:a.measureText(l).width,h:c},e._pointLabelSizes[t]=o;var d=e.getIndexAngle(t),p=W.toDegrees(d)%360,u=Lo(p,i.x,o.w,0,180),m=Lo(p,i.y,o.h,90,270);u.start<s.l&&(s.l=u.start,n.l=d),u.end>s.r&&(s.r=u.end,n.r=d),m.start<s.t&&(s.t=m.start,n.t=d),m.end>s.b&&(s.b=m.end,n.b=d)}e.setReductions(e.drawingArea,s,n)}(e):e.setCenterPoint(0,0,0,0)},setReductions:function(e,t,o){var i=this,r=t.l/Math.sin(o.l),s=Math.max(t.r-i.width,0)/Math.sin(o.r),n=-t.t/Math.cos(o.t),a=-Math.max(t.b-(i.height-i.paddingTop),0)/Math.cos(o.b);r=Fo(r),s=Fo(s),n=Fo(n),a=Fo(a),i.drawingArea=Math.min(Math.floor(e-(r+s)/2),Math.floor(e-(n+a)/2)),i.setCenterPoint(r,s,n,a)},setCenterPoint:function(e,t,o,i){var r=this,s=r.width-t-r.drawingArea,n=e+r.drawingArea,a=o+r.drawingArea,c=r.height-r.paddingTop-i-r.drawingArea;r.xCenter=Math.floor((n+s)/2+r.left),r.yCenter=Math.floor((a+c)/2+r.top+r.paddingTop)},getIndexAngle:function(e){var t=this.chart,o=(e*(360/t.data.labels.length)+((t.options||{}).startAngle||0))%360;return(o<0?o+360:o)*Math.PI*2/360},getDistanceFromCenterForValue:function(e){var t=this;if(W.isNullOrUndef(e))return NaN;var o=t.drawingArea/(t.max-t.min);return t.options.ticks.reverse?(t.max-e)*o:(e-t.min)*o},getPointPosition:function(e,t){var o=this,i=o.getIndexAngle(e)-Math.PI/2;return{x:Math.cos(i)*t+o.xCenter,y:Math.sin(i)*t+o.yCenter}},getPointPositionForValue:function(e,t){return this.getPointPosition(e,this.getDistanceFromCenterForValue(t))},getBasePosition:function(e){var t=this,o=t.min,i=t.max;return t.getPointPositionForValue(e||0,t.beginAtZero?0:o<0&&i<0?i:o>0&&i>0?o:0)},_drawGrid:function(){var e,t,o,i=this,r=i.ctx,s=i.options,n=s.gridLines,a=s.angleLines,c=Mo(a.lineWidth,n.lineWidth),l=Mo(a.color,n.color);if(s.pointLabels.display&&function(e){var t=e.ctx,o=e.options,i=o.pointLabels,r=Ro(o),s=e.getDistanceFromCenterForValue(o.ticks.reverse?e.min:e.max),n=W.options._parseFont(i);t.save(),t.font=n.string,t.textBaseline="middle";for(var a=e.chart.data.labels.length-1;a>=0;a--){var c=0===a?r/2:0,l=e.getPointPosition(a,s+c+5),h=Do(i.fontColor,a,F.global.defaultFontColor);t.fillStyle=h;var d=e.getIndexAngle(a),p=W.toDegrees(d);t.textAlign=Po(p),No(p,e._pointLabelSizes[a],l),Oo(t,e.pointLabels[a],l,n.lineHeight)}t.restore()}(i),n.display&&W.each(i.ticks,(function(e,o){0!==o&&(t=i.getDistanceFromCenterForValue(i.ticksAsNumbers[o]),function(e,t,o,i){var r,s=e.ctx,n=t.circular,a=e.chart.data.labels.length,c=Do(t.color,i-1),l=Do(t.lineWidth,i-1);if((n||a)&&c&&l){if(s.save(),s.strokeStyle=c,s.lineWidth=l,s.setLineDash&&(s.setLineDash(t.borderDash||[]),s.lineDashOffset=t.borderDashOffset||0),s.beginPath(),n)s.arc(e.xCenter,e.yCenter,o,0,2*Math.PI);else{r=e.getPointPosition(0,o),s.moveTo(r.x,r.y);for(var h=1;h<a;h++)r=e.getPointPosition(h,o),s.lineTo(r.x,r.y)}s.closePath(),s.stroke(),s.restore()}}(i,n,t,o))})),a.display&&c&&l){for(r.save(),r.lineWidth=c,r.strokeStyle=l,r.setLineDash&&(r.setLineDash(Bo([a.borderDash,n.borderDash,[]])),r.lineDashOffset=Bo([a.borderDashOffset,n.borderDashOffset,0])),e=i.chart.data.labels.length-1;e>=0;e--)t=i.getDistanceFromCenterForValue(s.ticks.reverse?i.min:i.max),o=i.getPointPosition(e,t),r.beginPath(),r.moveTo(i.xCenter,i.yCenter),r.lineTo(o.x,o.y),r.stroke();r.restore()}},_drawLabels:function(){var e=this,t=e.ctx,o=e.options.ticks;if(o.display){var i,r,s=e.getIndexAngle(0),n=W.options._parseFont(o),a=Mo(o.fontColor,F.global.defaultFontColor);t.save(),t.font=n.string,t.translate(e.xCenter,e.yCenter),t.rotate(s),t.textAlign="center",t.textBaseline="middle",W.each(e.ticks,(function(s,c){(0!==c||o.reverse)&&(i=e.getDistanceFromCenterForValue(e.ticksAsNumbers[c]),o.showLabelBackdrop&&(r=t.measureText(s).width,t.fillStyle=o.backdropColor,t.fillRect(-r/2-o.backdropPaddingX,-i-n.size/2-o.backdropPaddingY,r+2*o.backdropPaddingX,n.size+2*o.backdropPaddingY)),t.fillStyle=a,t.fillText(s,0,-i))})),t.restore()}},_drawTitle:W.noop}),Io=To;$o._defaults=Io;var Vo=W._deprecated,Ho=W.options.resolve,Wo=W.valueOrDefault,qo=Number.MIN_SAFE_INTEGER||-9007199254740991,Yo=Number.MAX_SAFE_INTEGER||9007199254740991,jo={millisecond:{common:!0,size:1,steps:1e3},second:{common:!0,size:1e3,steps:60},minute:{common:!0,size:6e4,steps:60},hour:{common:!0,size:36e5,steps:24},day:{common:!0,size:864e5,steps:30},week:{common:!1,size:6048e5,steps:4},month:{common:!0,size:2628e6,steps:12},quarter:{common:!1,size:7884e6,steps:4},year:{common:!0,size:3154e7}},Uo=Object.keys(jo);function Zo(e,t){return e-t}function Ko(e){return W.valueOrDefault(e.time.min,e.ticks.min)}function Go(e){return W.valueOrDefault(e.time.max,e.ticks.max)}function Xo(e,t,o,i){var r=function(e,t,o){for(var i,r,s,n=0,a=e.length-1;n>=0&&n<=a;){if(r=e[(i=n+a>>1)-1]||null,s=e[i],!r)return{lo:null,hi:s};if(s[t]<o)n=i+1;else{if(!(r[t]>o))return{lo:r,hi:s};a=i-1}}return{lo:s,hi:null}}(e,t,o),s=r.lo?r.hi?r.lo:e[e.length-2]:e[0],n=r.lo?r.hi?r.hi:e[e.length-1]:e[1],a=n[t]-s[t],c=a?(o-s[t])/a:0,l=(n[i]-s[i])*c;return s[i]+l}function Jo(e,t){var o=e._adapter,i=e.options.time,r=i.parser,s=r||i.format,n=t;return"function"==typeof r&&(n=r(n)),W.isFinite(n)||(n="string"==typeof s?o.parse(n,s):o.parse(n)),null!==n?+n:(r||"function"!=typeof s||(n=s(t),W.isFinite(n)||(n=o.parse(n))),n)}function Qo(e,t){if(W.isNullOrUndef(t))return null;var o=e.options.time,i=Jo(e,e.getRightValue(t));return null===i||o.round&&(i=+e._adapter.startOf(i,o.round)),i}function ei(e,t,o,i){var r,s,n,a=Uo.length;for(r=Uo.indexOf(e);r<a-1;++r)if(n=(s=jo[Uo[r]]).steps?s.steps:Yo,s.common&&Math.ceil((o-t)/(n*s.size))<=i)return Uo[r];return Uo[a-1]}function ti(e,t,o){var i,r,s=[],n={},a=t.length;for(i=0;i<a;++i)n[r=t[i]]=i,s.push({value:r,major:!1});return 0!==a&&o?function(e,t,o,i){var r,s,n=e._adapter,a=+n.startOf(t[0].value,i),c=t[t.length-1].value;for(r=a;r<=c;r=+n.add(r,1,i))(s=o[r])>=0&&(t[s].major=!0);return t}(e,s,n,o):s}var oi=po.extend({initialize:function(){this.mergeTicksOptions(),po.prototype.initialize.call(this)},update:function(){var e=this,t=e.options,o=t.time||(t.time={}),i=e._adapter=new Xt._date(t.adapters.date);return Vo("time scale",o.format,"time.format","time.parser"),Vo("time scale",o.min,"time.min","ticks.min"),Vo("time scale",o.max,"time.max","ticks.max"),W.mergeIf(o.displayFormats,i.formats()),po.prototype.update.apply(e,arguments)},getRightValue:function(e){return e&&void 0!==e.t&&(e=e.t),po.prototype.getRightValue.call(this,e)},determineDataLimits:function(){var e,t,o,i,r,s,n,a=this,c=a.chart,l=a._adapter,h=a.options,d=h.time.unit||"day",p=Yo,u=qo,m=[],f=[],g=[],b=a._getLabels();for(e=0,o=b.length;e<o;++e)g.push(Qo(a,b[e]));for(e=0,o=(c.data.datasets||[]).length;e<o;++e)if(c.isDatasetVisible(e))if(r=c.data.datasets[e].data,W.isObject(r[0]))for(f[e]=[],t=0,i=r.length;t<i;++t)s=Qo(a,r[t]),m.push(s),f[e][t]=s;else f[e]=g.slice(0),n||(m=m.concat(g),n=!0);else f[e]=[];g.length&&(p=Math.min(p,g[0]),u=Math.max(u,g[g.length-1])),m.length&&(m=o>1?function(e){var t,o,i,r={},s=[];for(t=0,o=e.length;t<o;++t)r[i=e[t]]||(r[i]=!0,s.push(i));return s}(m).sort(Zo):m.sort(Zo),p=Math.min(p,m[0]),u=Math.max(u,m[m.length-1])),p=Qo(a,Ko(h))||p,u=Qo(a,Go(h))||u,p=p===Yo?+l.startOf(Date.now(),d):p,u=u===qo?+l.endOf(Date.now(),d)+1:u,a.min=Math.min(p,u),a.max=Math.max(p+1,u),a._table=[],a._timestamps={data:m,datasets:f,labels:g}},buildTicks:function(){var e,t,o,i=this,r=i.min,s=i.max,n=i.options,a=n.ticks,c=n.time,l=i._timestamps,h=[],d=i.getLabelCapacity(r),p=a.source,u=n.distribution;for(l="data"===p||"auto"===p&&"series"===u?l.data:"labels"===p?l.labels:function(e,t,o,i){var r,s=e._adapter,n=e.options,a=n.time,c=a.unit||ei(a.minUnit,t,o,i),l=Ho([a.stepSize,a.unitStepSize,1]),h="week"===c&&a.isoWeekday,d=t,p=[];if(h&&(d=+s.startOf(d,"isoWeek",h)),d=+s.startOf(d,h?"day":c),s.diff(o,t,c)>1e5*l)throw t+" and "+o+" are too far apart with stepSize of "+l+" "+c;for(r=d;r<o;r=+s.add(r,l,c))p.push(r);return r!==o&&"ticks"!==n.bounds||p.push(r),p}(i,r,s,d),"ticks"===n.bounds&&l.length&&(r=l[0],s=l[l.length-1]),r=Qo(i,Ko(n))||r,s=Qo(i,Go(n))||s,e=0,t=l.length;e<t;++e)(o=l[e])>=r&&o<=s&&h.push(o);return i.min=r,i.max=s,i._unit=c.unit||(a.autoSkip?ei(c.minUnit,i.min,i.max,d):function(e,t,o,i,r){var s,n;for(s=Uo.length-1;s>=Uo.indexOf(o);s--)if(n=Uo[s],jo[n].common&&e._adapter.diff(r,i,n)>=t-1)return n;return Uo[o?Uo.indexOf(o):0]}(i,h.length,c.minUnit,i.min,i.max)),i._majorUnit=a.major.enabled&&"year"!==i._unit?function(e){for(var t=Uo.indexOf(e)+1,o=Uo.length;t<o;++t)if(jo[Uo[t]].common)return Uo[t]}(i._unit):void 0,i._table=function(e,t,o,i){if("linear"===i||!e.length)return[{time:t,pos:0},{time:o,pos:1}];var r,s,n,a,c,l=[],h=[t];for(r=0,s=e.length;r<s;++r)(a=e[r])>t&&a<o&&h.push(a);for(h.push(o),r=0,s=h.length;r<s;++r)c=h[r+1],n=h[r-1],a=h[r],void 0!==n&&void 0!==c&&Math.round((c+n)/2)===a||l.push({time:a,pos:r/(s-1)});return l}(i._timestamps.data,r,s,u),i._offsets=function(e,t,o,i,r){var s,n,a=0,c=0;return r.offset&&t.length&&(s=Xo(e,"time",t[0],"pos"),a=1===t.length?1-s:(Xo(e,"time",t[1],"pos")-s)/2,n=Xo(e,"time",t[t.length-1],"pos"),c=1===t.length?n:(n-Xo(e,"time",t[t.length-2],"pos"))/2),{start:a,end:c,factor:1/(a+1+c)}}(i._table,h,0,0,n),a.reverse&&h.reverse(),ti(i,h,i._majorUnit)},getLabelForIndex:function(e,t){var o=this,i=o._adapter,r=o.chart.data,s=o.options.time,n=r.labels&&e<r.labels.length?r.labels[e]:"",a=r.datasets[t].data[e];return W.isObject(a)&&(n=o.getRightValue(a)),s.tooltipFormat?i.format(Jo(o,n),s.tooltipFormat):"string"==typeof n?n:i.format(Jo(o,n),s.displayFormats.datetime)},tickFormatFunction:function(e,t,o,i){var r=this,s=r._adapter,n=r.options,a=n.time.displayFormats,c=a[r._unit],l=r._majorUnit,h=a[l],d=o[t],p=n.ticks,u=l&&h&&d&&d.major,m=s.format(e,i||(u?h:c)),f=u?p.major:p.minor,g=Ho([f.callback,f.userCallback,p.callback,p.userCallback]);return g?g(m,t,o):m},convertTicksToLabels:function(e){var t,o,i=[];for(t=0,o=e.length;t<o;++t)i.push(this.tickFormatFunction(e[t].value,t,e));return i},getPixelForOffset:function(e){var t=this,o=t._offsets,i=Xo(t._table,"time",e,"pos");return t.getPixelForDecimal((o.start+i)*o.factor)},getPixelForValue:function(e,t,o){var i=this,r=null;if(void 0!==t&&void 0!==o&&(r=i._timestamps.datasets[o][t]),null===r&&(r=Qo(i,e)),null!==r)return i.getPixelForOffset(r)},getPixelForTick:function(e){var t=this.getTicks();return e>=0&&e<t.length?this.getPixelForOffset(t[e].value):null},getValueForPixel:function(e){var t=this,o=t._offsets,i=t.getDecimalForPixel(e)/o.factor-o.end,r=Xo(t._table,"pos",i,"time");return t._adapter._create(r)},_getLabelSize:function(e){var t=this,o=t.options.ticks,i=t.ctx.measureText(e).width,r=W.toRadians(t.isHorizontal()?o.maxRotation:o.minRotation),s=Math.cos(r),n=Math.sin(r),a=Wo(o.fontSize,F.global.defaultFontSize);return{w:i*s+a*n,h:i*n+a*s}},getLabelWidth:function(e){return this._getLabelSize(e).w},getLabelCapacity:function(e){var t=this,o=t.options.time,i=o.displayFormats,r=i[o.unit]||i.millisecond,s=t.tickFormatFunction(e,0,ti(t,[e],t._majorUnit),r),n=t._getLabelSize(s),a=Math.floor(t.isHorizontal()?t.width/n.w:t.height/n.h);return t.options.offset&&a--,a>0?a:1}});oi._defaults={position:"bottom",distribution:"linear",bounds:"data",adapters:{},time:{parser:!1,unit:!1,round:!1,displayFormat:!1,isoWeekday:!1,minUnit:"millisecond",displayFormats:{}},ticks:{autoSkip:!1,source:"auto",major:{enabled:!1}}};var ii={category:mo,linear:xo,logarithmic:Ao,radialLinear:$o,time:oi},ri={datetime:"MMM D, YYYY, h:mm:ss a",millisecond:"h:mm:ss.SSS a",second:"h:mm:ss a",minute:"h:mm a",hour:"hA",day:"MMM D",week:"ll",month:"MMM YYYY",quarter:"[Q]Q - YYYY",year:"YYYY"};Xt._date.override("function"==typeof e?{_id:"moment",formats:function(){return ri},parse:function(t,o){return"string"==typeof t&&"string"==typeof o?t=e(t,o):t instanceof e||(t=e(t)),t.isValid()?t.valueOf():null},format:function(t,o){return e(t).format(o)},add:function(t,o,i){return e(t).add(o,i).valueOf()},diff:function(t,o,i){return e(t).diff(e(o),i)},startOf:function(t,o,i){return t=e(t),"isoWeek"===o?t.isoWeekday(i).valueOf():t.startOf(o).valueOf()},endOf:function(t,o){return e(t).endOf(o).valueOf()},_create:function(t){return e(t)}}:{}),F._set("global",{plugins:{filler:{propagate:!0}}});var si={dataset:function(e){var t=e.fill,o=e.chart,i=o.getDatasetMeta(t),r=i&&o.isDatasetVisible(t)&&i.dataset._children||[],s=r.length||0;return s?function(e,t){return t<s&&r[t]._view||null}:null},boundary:function(e){var t=e.boundary,o=t?t.x:null,i=t?t.y:null;return W.isArray(t)?function(e,o){return t[o]}:function(e){return{x:null===o?e.x:o,y:null===i?e.y:i}}}};function ni(e,t,o){var i,r=e._model||{},s=r.fill;if(void 0===s&&(s=!!r.backgroundColor),!1===s||null===s)return!1;if(!0===s)return"origin";if(i=parseFloat(s,10),isFinite(i)&&Math.floor(i)===i)return"-"!==s[0]&&"+"!==s[0]||(i=t+i),!(i===t||i<0||i>=o)&&i;switch(s){case"bottom":return"start";case"top":return"end";case"zero":return"origin";case"origin":case"start":case"end":return s;default:return!1}}function ai(e){return(e.el._scale||{}).getPointPositionForValue?function(e){var t,o,i,r,s,n=e.el._scale,a=n.options,c=n.chart.data.labels.length,l=e.fill,h=[];if(!c)return null;for(t=a.ticks.reverse?n.max:n.min,o=a.ticks.reverse?n.min:n.max,i=n.getPointPositionForValue(0,t),r=0;r<c;++r)s="start"===l||"end"===l?n.getPointPositionForValue(r,"start"===l?t:o):n.getBasePosition(r),a.gridLines.circular&&(s.cx=i.x,s.cy=i.y,s.angle=n.getIndexAngle(r)-Math.PI/2),h.push(s);return h}(e):function(e){var t,o=e.el._model||{},i=e.el._scale||{},r=e.fill,s=null;if(isFinite(r))return null;if("start"===r?s=void 0===o.scaleBottom?i.bottom:o.scaleBottom:"end"===r?s=void 0===o.scaleTop?i.top:o.scaleTop:void 0!==o.scaleZero?s=o.scaleZero:i.getBasePixel&&(s=i.getBasePixel()),null!=s){if(void 0!==s.x&&void 0!==s.y)return s;if(W.isFinite(s))return{x:(t=i.isHorizontal())?s:null,y:t?null:s}}return null}(e)}function ci(e,t,o){var i,r=e[t].fill,s=[t];if(!o)return r;for(;!1!==r&&-1===s.indexOf(r);){if(!isFinite(r))return r;if(!(i=e[r]))return!1;if(i.visible)return r;s.push(r),r=i.fill}return!1}function li(e){var t=e.fill,o="dataset";return!1===t?null:(isFinite(t)||(o="boundary"),si[o](e))}function hi(e){return e&&!e.skip}function di(e,t,o,i,r){var s,n,a,c;if(i&&r){for(e.moveTo(t[0].x,t[0].y),s=1;s<i;++s)W.canvas.lineTo(e,t[s-1],t[s]);if(void 0===o[0].angle)for(e.lineTo(o[r-1].x,o[r-1].y),s=r-1;s>0;--s)W.canvas.lineTo(e,o[s],o[s-1],!0);else for(n=o[0].cx,a=o[0].cy,c=Math.sqrt(Math.pow(o[0].x-n,2)+Math.pow(o[0].y-a,2)),s=r-1;s>0;--s)e.arc(n,a,c,o[s].angle,o[s-1].angle,!0)}}function pi(e,t,o,i,r,s){var n,a,c,l,h,d,p,u,m=t.length,f=i.spanGaps,g=[],b=[],v=0,y=0;for(e.beginPath(),n=0,a=m;n<a;++n)h=o(l=t[c=n%m]._view,c,i),d=hi(l),p=hi(h),s&&void 0===u&&d&&(a=m+(u=n+1)),d&&p?(v=g.push(l),y=b.push(h)):v&&y&&(f?(d&&g.push(l),p&&b.push(h)):(di(e,g,b,v,y),v=y=0,g=[],b=[]));di(e,g,b,v,y),e.closePath(),e.fillStyle=r,e.fill()}var ui={id:"filler",afterDatasetsUpdate:function(e,t){var o,i,r,s,n=(e.data.datasets||[]).length,a=t.propagate,c=[];for(i=0;i<n;++i)s=null,(r=(o=e.getDatasetMeta(i)).dataset)&&r._model&&r instanceof we.Line&&(s={visible:e.isDatasetVisible(i),fill:ni(r,i,n),chart:e,el:r}),o.$filler=s,c.push(s);for(i=0;i<n;++i)(s=c[i])&&(s.fill=ci(c,i,a),s.boundary=ai(s),s.mapper=li(s))},beforeDatasetsDraw:function(e){var t,o,i,r,s,n,a,c=e._getSortedVisibleDatasetMetas(),l=e.ctx;for(o=c.length-1;o>=0;--o)(t=c[o].$filler)&&t.visible&&(r=(i=t.el)._view,s=i._children||[],n=t.mapper,a=r.backgroundColor||F.global.defaultColor,n&&a&&s.length&&(W.canvas.clipArea(l,e.chartArea),pi(l,s,n,r,a,i._loop),W.canvas.unclipArea(l)))}},mi=W.rtl.getRtlAdapter,fi=W.noop,gi=W.valueOrDefault;function bi(e,t){return e.usePointStyle&&e.boxWidth>t?t:e.boxWidth}F._set("global",{legend:{display:!0,position:"top",align:"center",fullWidth:!0,reverse:!1,weight:1e3,onClick:function(e,t){var o=t.datasetIndex,i=this.chart,r=i.getDatasetMeta(o);r.hidden=null===r.hidden?!i.data.datasets[o].hidden:null,i.update()},onHover:null,onLeave:null,labels:{boxWidth:40,padding:10,generateLabels:function(e){var t=e.data.datasets,o=e.options.legend||{},i=o.labels&&o.labels.usePointStyle;return e._getSortedDatasetMetas().map((function(o){var r=o.controller.getStyle(i?0:void 0);return{text:t[o.index].label,fillStyle:r.backgroundColor,hidden:!e.isDatasetVisible(o.index),lineCap:r.borderCapStyle,lineDash:r.borderDash,lineDashOffset:r.borderDashOffset,lineJoin:r.borderJoinStyle,lineWidth:r.borderWidth,strokeStyle:r.borderColor,pointStyle:r.pointStyle,rotation:r.rotation,datasetIndex:o.index}}),this)}}},legendCallback:function(e){var t,o,i,r=document.createElement("ul"),s=e.data.datasets;for(r.setAttribute("class",e.id+"-legend"),t=0,o=s.length;t<o;t++)(i=r.appendChild(document.createElement("li"))).appendChild(document.createElement("span")).style.backgroundColor=s[t].backgroundColor,s[t].label&&i.appendChild(document.createTextNode(s[t].label));return r.outerHTML}});var vi=K.extend({initialize:function(e){var t=this;W.extend(t,e),t.legendHitBoxes=[],t._hoveredItem=null,t.doughnutMode=!1},beforeUpdate:fi,update:function(e,t,o){var i=this;return i.beforeUpdate(),i.maxWidth=e,i.maxHeight=t,i.margins=o,i.beforeSetDimensions(),i.setDimensions(),i.afterSetDimensions(),i.beforeBuildLabels(),i.buildLabels(),i.afterBuildLabels(),i.beforeFit(),i.fit(),i.afterFit(),i.afterUpdate(),i.minSize},afterUpdate:fi,beforeSetDimensions:fi,setDimensions:function(){var e=this;e.isHorizontal()?(e.width=e.maxWidth,e.left=0,e.right=e.width):(e.height=e.maxHeight,e.top=0,e.bottom=e.height),e.paddingLeft=0,e.paddingTop=0,e.paddingRight=0,e.paddingBottom=0,e.minSize={width:0,height:0}},afterSetDimensions:fi,beforeBuildLabels:fi,buildLabels:function(){var e=this,t=e.options.labels||{},o=W.callback(t.generateLabels,[e.chart],e)||[];t.filter&&(o=o.filter((function(o){return t.filter(o,e.chart.data)}))),e.options.reverse&&o.reverse(),e.legendItems=o},afterBuildLabels:fi,beforeFit:fi,fit:function(){var e=this,t=e.options,o=t.labels,i=t.display,r=e.ctx,s=W.options._parseFont(o),n=s.size,a=e.legendHitBoxes=[],c=e.minSize,l=e.isHorizontal();if(l?(c.width=e.maxWidth,c.height=i?10:0):(c.width=i?10:0,c.height=e.maxHeight),i){if(r.font=s.string,l){var h=e.lineWidths=[0],d=0;r.textAlign="left",r.textBaseline="middle",W.each(e.legendItems,(function(e,t){var i=bi(o,n)+n/2+r.measureText(e.text).width;(0===t||h[h.length-1]+i+2*o.padding>c.width)&&(d+=n+o.padding,h[h.length-(t>0?0:1)]=0),a[t]={left:0,top:0,width:i,height:n},h[h.length-1]+=i+o.padding})),c.height+=d}else{var p=o.padding,u=e.columnWidths=[],m=e.columnHeights=[],f=o.padding,g=0,b=0;W.each(e.legendItems,(function(e,t){var i=bi(o,n)+n/2+r.measureText(e.text).width;t>0&&b+n+2*p>c.height&&(f+=g+o.padding,u.push(g),m.push(b),g=0,b=0),g=Math.max(g,i),b+=n+p,a[t]={left:0,top:0,width:i,height:n}})),f+=g,u.push(g),m.push(b),c.width+=f}e.width=c.width,e.height=c.height}else e.width=c.width=e.height=c.height=0},afterFit:fi,isHorizontal:function(){return"top"===this.options.position||"bottom"===this.options.position},draw:function(){var e=this,t=e.options,o=t.labels,i=F.global,r=i.defaultColor,s=i.elements.line,n=e.height,a=e.columnHeights,c=e.width,l=e.lineWidths;if(t.display){var h,d=mi(t.rtl,e.left,e.minSize.width),p=e.ctx,u=gi(o.fontColor,i.defaultFontColor),m=W.options._parseFont(o),f=m.size;p.textAlign=d.textAlign("left"),p.textBaseline="middle",p.lineWidth=.5,p.strokeStyle=u,p.fillStyle=u,p.font=m.string;var g=bi(o,f),b=e.legendHitBoxes,v=function(e,i){switch(t.align){case"start":return o.padding;case"end":return e-i;default:return(e-i+o.padding)/2}},y=e.isHorizontal();h=y?{x:e.left+v(c,l[0]),y:e.top+o.padding,line:0}:{x:e.left+o.padding,y:e.top+v(n,a[0]),line:0},W.rtl.overrideTextDirection(e.ctx,t.textDirection);var w=f+o.padding;W.each(e.legendItems,(function(t,i){var u=p.measureText(t.text).width,m=g+f/2+u,x=h.x,_=h.y;d.setWidth(e.minSize.width),y?i>0&&x+m+o.padding>e.left+e.minSize.width&&(_=h.y+=w,h.line++,x=h.x=e.left+v(c,l[h.line])):i>0&&_+w>e.top+e.minSize.height&&(x=h.x=x+e.columnWidths[h.line]+o.padding,h.line++,_=h.y=e.top+v(n,a[h.line]));var k=d.x(x);!function(e,t,i){if(!(isNaN(g)||g<=0)){p.save();var n=gi(i.lineWidth,s.borderWidth);if(p.fillStyle=gi(i.fillStyle,r),p.lineCap=gi(i.lineCap,s.borderCapStyle),p.lineDashOffset=gi(i.lineDashOffset,s.borderDashOffset),p.lineJoin=gi(i.lineJoin,s.borderJoinStyle),p.lineWidth=n,p.strokeStyle=gi(i.strokeStyle,r),p.setLineDash&&p.setLineDash(gi(i.lineDash,s.borderDash)),o&&o.usePointStyle){var a=g*Math.SQRT2/2,c=d.xPlus(e,g/2),l=t+f/2;W.canvas.drawPoint(p,i.pointStyle,a,c,l,i.rotation)}else p.fillRect(d.leftForLtr(e,g),t,g,f),0!==n&&p.strokeRect(d.leftForLtr(e,g),t,g,f);p.restore()}}(k,_,t),b[i].left=d.leftForLtr(k,b[i].width),b[i].top=_,function(e,t,o,i){var r=f/2,s=d.xPlus(e,g+r),n=t+r;p.fillText(o.text,s,n),o.hidden&&(p.beginPath(),p.lineWidth=2,p.moveTo(s,n),p.lineTo(d.xPlus(s,i),n),p.stroke())}(k,_,t,u),y?h.x+=m+o.padding:h.y+=w})),W.rtl.restoreTextDirection(e.ctx,t.textDirection)}},_getLegendItemAt:function(e,t){var o,i,r,s=this;if(e>=s.left&&e<=s.right&&t>=s.top&&t<=s.bottom)for(r=s.legendHitBoxes,o=0;o<r.length;++o)if(e>=(i=r[o]).left&&e<=i.left+i.width&&t>=i.top&&t<=i.top+i.height)return s.legendItems[o];return null},handleEvent:function(e){var t,o=this,i=o.options,r="mouseup"===e.type?"click":e.type;if("mousemove"===r){if(!i.onHover&&!i.onLeave)return}else{if("click"!==r)return;if(!i.onClick)return}t=o._getLegendItemAt(e.x,e.y),"click"===r?t&&i.onClick&&i.onClick.call(o,e.native,t):(i.onLeave&&t!==o._hoveredItem&&(o._hoveredItem&&i.onLeave.call(o,e.native,o._hoveredItem),o._hoveredItem=t),i.onHover&&t&&i.onHover.call(o,e.native,t))}});function yi(e,t){var o=new vi({ctx:e.ctx,options:t,chart:e});pt.configure(e,o,t),pt.addBox(e,o),e.legend=o}var wi={id:"legend",_element:vi,beforeInit:function(e){var t=e.options.legend;t&&yi(e,t)},beforeUpdate:function(e){var t=e.options.legend,o=e.legend;t?(W.mergeIf(t,F.global.legend),o?(pt.configure(e,o,t),o.options=t):yi(e,t)):o&&(pt.removeBox(e,o),delete e.legend)},afterEvent:function(e,t){var o=e.legend;o&&o.handleEvent(t)}},xi=W.noop;F._set("global",{title:{display:!1,fontStyle:"bold",fullWidth:!0,padding:10,position:"top",text:"",weight:2e3}});var _i=K.extend({initialize:function(e){W.extend(this,e),this.legendHitBoxes=[]},beforeUpdate:xi,update:function(e,t,o){var i=this;return i.beforeUpdate(),i.maxWidth=e,i.maxHeight=t,i.margins=o,i.beforeSetDimensions(),i.setDimensions(),i.afterSetDimensions(),i.beforeBuildLabels(),i.buildLabels(),i.afterBuildLabels(),i.beforeFit(),i.fit(),i.afterFit(),i.afterUpdate(),i.minSize},afterUpdate:xi,beforeSetDimensions:xi,setDimensions:function(){var e=this;e.isHorizontal()?(e.width=e.maxWidth,e.left=0,e.right=e.width):(e.height=e.maxHeight,e.top=0,e.bottom=e.height),e.paddingLeft=0,e.paddingTop=0,e.paddingRight=0,e.paddingBottom=0,e.minSize={width:0,height:0}},afterSetDimensions:xi,beforeBuildLabels:xi,buildLabels:xi,afterBuildLabels:xi,beforeFit:xi,fit:function(){var e,t=this,o=t.options,i=t.minSize={},r=t.isHorizontal();o.display?(e=(W.isArray(o.text)?o.text.length:1)*W.options._parseFont(o).lineHeight+2*o.padding,t.width=i.width=r?t.maxWidth:e,t.height=i.height=r?e:t.maxHeight):t.width=i.width=t.height=i.height=0},afterFit:xi,isHorizontal:function(){var e=this.options.position;return"top"===e||"bottom"===e},draw:function(){var e=this,t=e.ctx,o=e.options;if(o.display){var i,r,s,n=W.options._parseFont(o),a=n.lineHeight,c=a/2+o.padding,l=0,h=e.top,d=e.left,p=e.bottom,u=e.right;t.fillStyle=W.valueOrDefault(o.fontColor,F.global.defaultFontColor),t.font=n.string,e.isHorizontal()?(r=d+(u-d)/2,s=h+c,i=u-d):(r="left"===o.position?d+c:u-c,s=h+(p-h)/2,i=p-h,l=Math.PI*("left"===o.position?-.5:.5)),t.save(),t.translate(r,s),t.rotate(l),t.textAlign="center",t.textBaseline="middle";var m=o.text;if(W.isArray(m))for(var f=0,g=0;g<m.length;++g)t.fillText(m[g],0,f,i),f+=a;else t.fillText(m,0,0,i);t.restore()}}});function ki(e,t){var o=new _i({ctx:e.ctx,options:t,chart:e});pt.configure(e,o,t),pt.addBox(e,o),e.titleBlock=o}var Ci={},Ei=ui,zi=wi,Ai={id:"title",_element:_i,beforeInit:function(e){var t=e.options.title;t&&ki(e,t)},beforeUpdate:function(e){var t=e.options.title,o=e.titleBlock;t?(W.mergeIf(t,F.global.title),o?(pt.configure(e,o,t),o.options=t):ki(e,t)):o&&(pt.removeBox(e,o),delete e.titleBlock)}};for(var Si in Ci.filler=Ei,Ci.legend=zi,Ci.title=Ai,Zt.helpers=W,function(){function e(e,t,o){var i;return"string"==typeof e?(i=parseInt(e,10),-1!==e.indexOf("%")&&(i=i/100*t.parentNode[o])):i=e,i}function t(e){return null!=e&&"none"!==e}function o(o,i,r){var s=document.defaultView,n=W._getParentNode(o),a=s.getComputedStyle(o)[i],c=s.getComputedStyle(n)[i],l=t(a),h=t(c),d=Number.POSITIVE_INFINITY;return l||h?Math.min(l?e(a,o,r):d,h?e(c,n,r):d):"none"}W.where=function(e,t){if(W.isArray(e)&&Array.prototype.filter)return e.filter(t);var o=[];return W.each(e,(function(e){t(e)&&o.push(e)})),o},W.findIndex=Array.prototype.findIndex?function(e,t,o){return e.findIndex(t,o)}:function(e,t,o){o=void 0===o?e:o;for(var i=0,r=e.length;i<r;++i)if(t.call(o,e[i],i,e))return i;return-1},W.findNextWhere=function(e,t,o){W.isNullOrUndef(o)&&(o=-1);for(var i=o+1;i<e.length;i++){var r=e[i];if(t(r))return r}},W.findPreviousWhere=function(e,t,o){W.isNullOrUndef(o)&&(o=e.length);for(var i=o-1;i>=0;i--){var r=e[i];if(t(r))return r}},W.isNumber=function(e){return!isNaN(parseFloat(e))&&isFinite(e)},W.almostEquals=function(e,t,o){return Math.abs(e-t)<o},W.almostWhole=function(e,t){var o=Math.round(e);return o-t<=e&&o+t>=e},W.max=function(e){return e.reduce((function(e,t){return isNaN(t)?e:Math.max(e,t)}),Number.NEGATIVE_INFINITY)},W.min=function(e){return e.reduce((function(e,t){return isNaN(t)?e:Math.min(e,t)}),Number.POSITIVE_INFINITY)},W.sign=Math.sign?function(e){return Math.sign(e)}:function(e){return 0==(e=+e)||isNaN(e)?e:e>0?1:-1},W.toRadians=function(e){return e*(Math.PI/180)},W.toDegrees=function(e){return e*(180/Math.PI)},W._decimalPlaces=function(e){if(W.isFinite(e)){for(var t=1,o=0;Math.round(e*t)/t!==e;)t*=10,o++;return o}},W.getAngleFromPoint=function(e,t){var o=t.x-e.x,i=t.y-e.y,r=Math.sqrt(o*o+i*i),s=Math.atan2(i,o);return s<-.5*Math.PI&&(s+=2*Math.PI),{angle:s,distance:r}},W.distanceBetweenPoints=function(e,t){return Math.sqrt(Math.pow(t.x-e.x,2)+Math.pow(t.y-e.y,2))},W.aliasPixel=function(e){return e%2==0?0:.5},W._alignPixel=function(e,t,o){var i=e.currentDevicePixelRatio,r=o/2;return Math.round((t-r)*i)/i+r},W.splineCurve=function(e,t,o,i){var r=e.skip?t:e,s=t,n=o.skip?t:o,a=Math.sqrt(Math.pow(s.x-r.x,2)+Math.pow(s.y-r.y,2)),c=Math.sqrt(Math.pow(n.x-s.x,2)+Math.pow(n.y-s.y,2)),l=a/(a+c),h=c/(a+c),d=i*(l=isNaN(l)?0:l),p=i*(h=isNaN(h)?0:h);return{previous:{x:s.x-d*(n.x-r.x),y:s.y-d*(n.y-r.y)},next:{x:s.x+p*(n.x-r.x),y:s.y+p*(n.y-r.y)}}},W.EPSILON=Number.EPSILON||1e-14,W.splineCurveMonotone=function(e){var t,o,i,r,s,n,a,c,l,h=(e||[]).map((function(e){return{model:e._model,deltaK:0,mK:0}})),d=h.length;for(t=0;t<d;++t)if(!(i=h[t]).model.skip){if(o=t>0?h[t-1]:null,(r=t<d-1?h[t+1]:null)&&!r.model.skip){var p=r.model.x-i.model.x;i.deltaK=0!==p?(r.model.y-i.model.y)/p:0}!o||o.model.skip?i.mK=i.deltaK:!r||r.model.skip?i.mK=o.deltaK:this.sign(o.deltaK)!==this.sign(i.deltaK)?i.mK=0:i.mK=(o.deltaK+i.deltaK)/2}for(t=0;t<d-1;++t)i=h[t],r=h[t+1],i.model.skip||r.model.skip||(W.almostEquals(i.deltaK,0,this.EPSILON)?i.mK=r.mK=0:(s=i.mK/i.deltaK,n=r.mK/i.deltaK,(c=Math.pow(s,2)+Math.pow(n,2))<=9||(a=3/Math.sqrt(c),i.mK=s*a*i.deltaK,r.mK=n*a*i.deltaK)));for(t=0;t<d;++t)(i=h[t]).model.skip||(o=t>0?h[t-1]:null,r=t<d-1?h[t+1]:null,o&&!o.model.skip&&(l=(i.model.x-o.model.x)/3,i.model.controlPointPreviousX=i.model.x-l,i.model.controlPointPreviousY=i.model.y-l*i.mK),r&&!r.model.skip&&(l=(r.model.x-i.model.x)/3,i.model.controlPointNextX=i.model.x+l,i.model.controlPointNextY=i.model.y+l*i.mK))},W.nextItem=function(e,t,o){return o?t>=e.length-1?e[0]:e[t+1]:t>=e.length-1?e[e.length-1]:e[t+1]},W.previousItem=function(e,t,o){return o?t<=0?e[e.length-1]:e[t-1]:t<=0?e[0]:e[t-1]},W.niceNum=function(e,t){var o=Math.floor(W.log10(e)),i=e/Math.pow(10,o);return(t?i<1.5?1:i<3?2:i<7?5:10:i<=1?1:i<=2?2:i<=5?5:10)*Math.pow(10,o)},W.requestAnimFrame="undefined"==typeof window?function(e){e()}:window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||window.oRequestAnimationFrame||window.msRequestAnimationFrame||function(e){return window.setTimeout(e,1e3/60)},W.getRelativePosition=function(e,t){var o,i,r=e.originalEvent||e,s=e.target||e.srcElement,n=s.getBoundingClientRect(),a=r.touches;a&&a.length>0?(o=a[0].clientX,i=a[0].clientY):(o=r.clientX,i=r.clientY);var c=parseFloat(W.getStyle(s,"padding-left")),l=parseFloat(W.getStyle(s,"padding-top")),h=parseFloat(W.getStyle(s,"padding-right")),d=parseFloat(W.getStyle(s,"padding-bottom")),p=n.right-n.left-c-h,u=n.bottom-n.top-l-d;return{x:o=Math.round((o-n.left-c)/p*s.width/t.currentDevicePixelRatio),y:i=Math.round((i-n.top-l)/u*s.height/t.currentDevicePixelRatio)}},W.getConstraintWidth=function(e){return o(e,"max-width","clientWidth")},W.getConstraintHeight=function(e){return o(e,"max-height","clientHeight")},W._calculatePadding=function(e,t,o){return(t=W.getStyle(e,t)).indexOf("%")>-1?o*parseInt(t,10)/100:parseInt(t,10)},W._getParentNode=function(e){var t=e.parentNode;return t&&"[object ShadowRoot]"===t.toString()&&(t=t.host),t},W.getMaximumWidth=function(e){var t=W._getParentNode(e);if(!t)return e.clientWidth;var o=t.clientWidth,i=o-W._calculatePadding(t,"padding-left",o)-W._calculatePadding(t,"padding-right",o),r=W.getConstraintWidth(e);return isNaN(r)?i:Math.min(i,r)},W.getMaximumHeight=function(e){var t=W._getParentNode(e);if(!t)return e.clientHeight;var o=t.clientHeight,i=o-W._calculatePadding(t,"padding-top",o)-W._calculatePadding(t,"padding-bottom",o),r=W.getConstraintHeight(e);return isNaN(r)?i:Math.min(i,r)},W.getStyle=function(e,t){return e.currentStyle?e.currentStyle[t]:document.defaultView.getComputedStyle(e,null).getPropertyValue(t)},W.retinaScale=function(e,t){var o=e.currentDevicePixelRatio=t||"undefined"!=typeof window&&window.devicePixelRatio||1;if(1!==o){var i=e.canvas,r=e.height,s=e.width;i.height=r*o,i.width=s*o,e.ctx.scale(o,o),i.style.height||i.style.width||(i.style.height=r+"px",i.style.width=s+"px")}},W.fontString=function(e,t,o){return t+" "+e+"px "+o},W.longestText=function(e,t,o,i){var r=(i=i||{}).data=i.data||{},s=i.garbageCollect=i.garbageCollect||[];i.font!==t&&(r=i.data={},s=i.garbageCollect=[],i.font=t),e.font=t;var n,a,c,l,h,d=0,p=o.length;for(n=0;n<p;n++)if(null!=(l=o[n])&&!0!==W.isArray(l))d=W.measureText(e,r,s,d,l);else if(W.isArray(l))for(a=0,c=l.length;a<c;a++)null==(h=l[a])||W.isArray(h)||(d=W.measureText(e,r,s,d,h));var u=s.length/2;if(u>o.length){for(n=0;n<u;n++)delete r[s[n]];s.splice(0,u)}return d},W.measureText=function(e,t,o,i,r){var s=t[r];return s||(s=t[r]=e.measureText(r).width,o.push(r)),s>i&&(i=s),i},W.numberOfLabelLines=function(e){var t=1;return W.each(e,(function(e){W.isArray(e)&&e.length>t&&(t=e.length)})),t},W.color=_?function(e){return e instanceof CanvasGradient&&(e=F.global.defaultColor),_(e)}:function(e){return console.error("Color.js not found!"),e},W.getHoverColor=function(e){return e instanceof CanvasPattern||e instanceof CanvasGradient?e:W.color(e).saturate(.5).darken(.1).rgbString()}}(),Zt._adapters=Xt,Zt.Animation=X,Zt.animationService=J,Zt.controllers=Ke,Zt.DatasetController=ie,Zt.defaults=F,Zt.Element=K,Zt.elements=we,Zt.Interaction=ot,Zt.layouts=pt,Zt.platform=zt,Zt.plugins=At,Zt.Scale=po,Zt.scaleService=St,Zt.Ticks=Jt,Zt.Tooltip=$t,Zt.helpers.each(ii,(function(e,t){Zt.scaleService.registerScaleType(t,e,e._defaults)})),Ci)Ci.hasOwnProperty(Si)&&Zt.plugins.register(Ci[Si]);Zt.platform.initialize();var Mi=Zt;return"undefined"!=typeof window&&(window.Chart=Zt),Zt.Chart=Zt,Zt.Legend=Ci.legend._element,Zt.Title=Ci.title._element,Zt.pluginService=Zt.plugins,Zt.PluginBase=Zt.Element.extend({}),Zt.canvasHelpers=Zt.helpers.canvas,Zt.layoutService=Zt.layouts,Zt.LinearScaleBase=bo,Zt.helpers.each(["Bar","Bubble","Doughnut","Line","PolarArea","Radar","Scatter"],(function(e){Zt[e]=function(t,o){return new Zt(t,Zt.helpers.merge(o||{},{type:e.charAt(0).toLowerCase()+e.slice(1)}))}})),Mi},"object"==typeof e&&void 0!==t?t.exports=i(function(){try{return l()}catch(e){}}()):"function"==typeof define&&define.amd?define(["require"],(function(e){return i(function(){try{return e("moment")}catch(e){}}())})):(o=o||self).Chart=i(o.moment)}}),d=a({"node_modules/chartjs-plugin-annotation/src/element.js"(e,t){t.exports=function(e){var t=e.helpers;return e.Element.extend({initialize:function(){this.hidden=!1,this.hovering=!1,this._model=t.clone(this._model)||{},this.setDataLimits()},destroy:function(){},setDataLimits:function(){},configure:function(){},inRange:function(){},getCenterPoint:function(){},getWidth:function(){},getHeight:function(){},getArea:function(){},draw:function(){}})}}}),p=a({"node_modules/chartjs-plugin-annotation/src/helpers.js"(e,t){function o(){}function i(e){var t=e.annotation.elements;return Object.keys(t).map((function(e){return t[e]}))}function r(){return Math.random().toString(36).substr(2,6)}function s(e){return null!=e&&("number"==typeof e?isFinite(e):!!e)}function n(e,t,o){var i="$";e[i+t]||(e[t]?(e[i+t]=e[t].bind(e),e[t]=function(){var r=[e[i+t]].concat(Array.prototype.slice.call(arguments));return o.apply(e,r)}):e[t]=function(){var t=[void 0].concat(Array.prototype.slice.call(arguments));return o.apply(e,t)})}function a(e,t){e.forEach((function(e){(t?e[t]:e)()}))}function c(e){return"on"+e[0].toUpperCase()+e.substring(1)}function l(e,t){try{return new MouseEvent(e,t)}catch(r){try{var o=document.createEvent("MouseEvent");return o.initMouseEvent(e,t.canBubble,t.cancelable,t.view,t.detail,t.screenX,t.screenY,t.clientX,t.clientY,t.ctrlKey,t.altKey,t.shiftKey,t.metaKey,t.button,t.relatedTarget),o}catch(o){var i=document.createEvent("Event");return i.initEvent(e,t.canBubble,t.cancelable),i}}}t.exports=function(e){var t=e.helpers;return{initConfig:function(o){return o=t.configMerge(e.Annotation.defaults,o),t.isArray(o.annotations)&&o.annotations.forEach((function(o){o.label=t.configMerge(e.Annotation.labelDefaults,o.label)})),o},elements:i,callEach:a,noop:o,objectId:r,isValid:s,decorate:n,adjustScaleRange:function(e){var t,o,r,s,n,a=(t=e.id,o=i(e.chart),r=e.min,s=e.max,{min:(n=o.filter((function(e){return!!e._model.ranges[t]})).map((function(e){return e._model.ranges[t]}))).map((function(e){return Number(e.min)})).reduce((function(e,t){return isFinite(t)&&!isNaN(t)&&t<e?t:e}),r),max:n.map((function(e){return Number(e.max)})).reduce((function(e,t){return isFinite(t)&&!isNaN(t)&&t>e?t:e}),s)});void 0===e.options.ticks.min&&void 0===e.options.ticks.suggestedMin&&(e.min=a.min),void 0===e.options.ticks.max&&void 0===e.options.ticks.suggestedMax&&(e.max=a.max),e.handleTickRangeOptions&&e.handleTickRangeOptions()},getNearestItems:function(e,o){var i=Number.POSITIVE_INFINITY;return e.filter((function(e){return e.inRange(o.x,o.y)})).reduce((function(e,r){var s=r.getCenterPoint(),n=t.distanceBetweenPoints(o,s);return n<i?(e=[r],i=n):n===i&&e.push(r),e}),[]).sort((function(e,t){var o=e.getArea(),i=t.getArea();return o>i||o<i?o-i:e._index-t._index})).slice(0,1)[0]},getEventHandlerName:c,createMouseEvent:l}}}}),u=a({"node_modules/chartjs-plugin-annotation/src/types/line.js"(e,t){t.exports=function(e){var t=e.helpers,o=p()(e),i="horizontal",r="vertical";function s(e){var t=(e.x2-e.x1)/(e.y2-e.y1),o=e.x1||0;this.m=t,this.b=o,this.getX=function(i){return t*(i-e.y1)+o},this.getY=function(i){return(i-o)/t+e.y1},this.intersects=function(e,t,o){o=o||.001;var i=this.getY(e),r=this.getX(t);return(!isFinite(i)||Math.abs(t-i)<o)&&(!isFinite(r)||Math.abs(e-r)<o)}}return e.Annotation.Element.extend({setDataLimits:function(){var e=this._model,t=this.options;e.ranges={},e.ranges[t.scaleID]={min:t.value,max:t.endValue||t.value}},configure:function(){var e,n,a=this._model,c=this.options,l=this.chartInstance,h=l.chart.ctx,d=l.scales[c.scaleID];if(d&&(e=o.isValid(c.value)?d.getPixelForValue(c.value):NaN,n=o.isValid(c.endValue)?d.getPixelForValue(c.endValue):e),!isNaN(e)){var p=l.chartArea;a.clip={x1:p.left,x2:p.right,y1:p.top,y2:p.bottom},this.options.mode==i?(a.x1=p.left,a.x2=p.right,a.y1=e,a.y2=n):(a.y1=p.top,a.y2=p.bottom,a.x1=e,a.x2=n),a.line=new s(a),a.mode=c.mode,a.labelBackgroundColor=c.label.backgroundColor,a.labelFontFamily=c.label.fontFamily,a.labelFontSize=c.label.fontSize,a.labelFontStyle=c.label.fontStyle,a.labelFontColor=c.label.fontColor,a.labelXPadding=c.label.xPadding,a.labelYPadding=c.label.yPadding,a.labelCornerRadius=c.label.cornerRadius,a.labelPosition=c.label.position,a.labelXAdjust=c.label.xAdjust,a.labelYAdjust=c.label.yAdjust,a.labelEnabled=c.label.enabled,a.labelContent=c.label.content,h.font=t.fontString(a.labelFontSize,a.labelFontStyle,a.labelFontFamily);var u=h.measureText(a.labelContent).width,m=h.measureText("M").width,f=function(e,t,o,s,n){var a=e.line,c={},l=0,h=0;switch(!0){case e.mode==r&&"top"==e.labelPosition:h=n+e.labelYAdjust,l=t/2+e.labelXAdjust,c.y=e.y1+h,c.x=(isFinite(a.m)?a.getX(c.y):e.x1)-l;break;case e.mode==r&&"bottom"==e.labelPosition:h=o+n+e.labelYAdjust,l=t/2+e.labelXAdjust,c.y=e.y2-h,c.x=(isFinite(a.m)?a.getX(c.y):e.x1)-l;break;case e.mode==i&&"left"==e.labelPosition:l=s+e.labelXAdjust,h=-o/2+e.labelYAdjust,c.x=e.x1+l,c.y=a.getY(c.x)+h;break;case e.mode==i&&"right"==e.labelPosition:l=t+s+e.labelXAdjust,h=-o/2+e.labelYAdjust,c.x=e.x2-l,c.y=a.getY(c.x)+h;break;default:c.x=(e.x1+e.x2-t)/2+e.labelXAdjust,c.y=(e.y1+e.y2-o)/2+e.labelYAdjust}return c}(a,u,m,a.labelXPadding,a.labelYPadding);a.labelX=f.x-a.labelXPadding,a.labelY=f.y-a.labelYPadding,a.labelWidth=u+2*a.labelXPadding,a.labelHeight=m+2*a.labelYPadding,a.borderColor=c.borderColor,a.borderWidth=c.borderWidth,a.borderDash=c.borderDash||[],a.borderDashOffset=c.borderDashOffset||0}},inRange:function(e,t){var o=this._model;return o.line&&o.line.intersects(e,t,this.getHeight())||o.labelEnabled&&o.labelContent&&e>=o.labelX&&e<=o.labelX+o.labelWidth&&t>=o.labelY&&t<=o.labelY+o.labelHeight},getCenterPoint:function(){return{x:(this._model.x2+this._model.x1)/2,y:(this._model.y2+this._model.y1)/2}},getWidth:function(){return Math.abs(this._model.right-this._model.left)},getHeight:function(){return this._model.borderWidth||1},getArea:function(){return Math.sqrt(Math.pow(this.getWidth(),2)+Math.pow(this.getHeight(),2))},draw:function(){var e=this._view,o=this.chartInstance.chart.ctx;e.clip&&(o.save(),o.beginPath(),o.rect(e.clip.x1,e.clip.y1,e.clip.x2-e.clip.x1,e.clip.y2-e.clip.y1),o.clip(),o.lineWidth=e.borderWidth,o.strokeStyle=e.borderColor,o.setLineDash&&o.setLineDash(e.borderDash),o.lineDashOffset=e.borderDashOffset,o.beginPath(),o.moveTo(e.x1,e.y1),o.lineTo(e.x2,e.y2),o.stroke(),e.labelEnabled&&e.labelContent&&(o.beginPath(),o.rect(e.clip.x1,e.clip.y1,e.clip.x2-e.clip.x1,e.clip.y2-e.clip.y1),o.clip(),o.fillStyle=e.labelBackgroundColor,t.drawRoundedRectangle(o,e.labelX,e.labelY,e.labelWidth,e.labelHeight,e.labelCornerRadius),o.fill(),o.font=t.fontString(e.labelFontSize,e.labelFontStyle,e.labelFontFamily),o.fillStyle=e.labelFontColor,o.textAlign="center",o.textBaseline="middle",o.fillText(e.labelContent,e.labelX+e.labelWidth/2,e.labelY+e.labelHeight/2)),o.restore())}})}}}),m=a({"node_modules/chartjs-plugin-annotation/src/types/box.js"(e,t){t.exports=function(e){var t=p()(e);return e.Annotation.Element.extend({setDataLimits:function(){var e=this._model,o=this.options,i=this.chartInstance,r=i.scales[o.xScaleID],s=i.scales[o.yScaleID],n=i.chartArea;if(e.ranges={},n){var a=0,c=0;r&&(a=t.isValid(o.xMin)?o.xMin:r.getPixelForValue(n.left),c=t.isValid(o.xMax)?o.xMax:r.getPixelForValue(n.right),e.ranges[o.xScaleID]={min:Math.min(a,c),max:Math.max(a,c)}),s&&(a=t.isValid(o.yMin)?o.yMin:s.getPixelForValue(n.bottom),c=t.isValid(o.yMax)?o.yMax:s.getPixelForValue(n.top),e.ranges[o.yScaleID]={min:Math.min(a,c),max:Math.max(a,c)})}},configure:function(){var e=this._model,o=this.options,i=this.chartInstance,r=i.scales[o.xScaleID],s=i.scales[o.yScaleID],n=i.chartArea;e.clip={x1:n.left,x2:n.right,y1:n.top,y2:n.bottom};var a,c,l=n.left,h=n.top,d=n.right,p=n.bottom;r&&(a=t.isValid(o.xMin)?r.getPixelForValue(o.xMin):n.left,c=t.isValid(o.xMax)?r.getPixelForValue(o.xMax):n.right,l=Math.min(a,c),d=Math.max(a,c)),s&&(a=t.isValid(o.yMin)?s.getPixelForValue(o.yMin):n.bottom,c=t.isValid(o.yMax)?s.getPixelForValue(o.yMax):n.top,h=Math.min(a,c),p=Math.max(a,c)),e.left=l,e.top=h,e.right=d,e.bottom=p,e.borderColor=o.borderColor,e.borderWidth=o.borderWidth,e.backgroundColor=o.backgroundColor},inRange:function(e,t){var o=this._model;return o&&e>=o.left&&e<=o.right&&t>=o.top&&t<=o.bottom},getCenterPoint:function(){var e=this._model;return{x:(e.right+e.left)/2,y:(e.bottom+e.top)/2}},getWidth:function(){var e=this._model;return Math.abs(e.right-e.left)},getHeight:function(){var e=this._model;return Math.abs(e.bottom-e.top)},getArea:function(){return this.getWidth()*this.getHeight()},draw:function(){var e=this._view,t=this.chartInstance.chart.ctx;t.save(),t.beginPath(),t.rect(e.clip.x1,e.clip.y1,e.clip.x2-e.clip.x1,e.clip.y2-e.clip.y1),t.clip(),t.lineWidth=e.borderWidth,t.strokeStyle=e.borderColor,t.fillStyle=e.backgroundColor;var o=e.right-e.left,i=e.bottom-e.top;t.fillRect(e.left,e.top,o,i),t.strokeRect(e.left,e.top,o,i),t.restore()}})}}}),f=a({"node_modules/chartjs-plugin-annotation/src/events.js"(e,t){t.exports=function(e){var t=e.helpers,o=p()(e);function i(e){var t=!1,o=e.filter((function(e){switch(e){case"mouseenter":case"mouseover":case"mouseout":case"mouseleave":return t=!0,!1;default:return!0}}));return t&&-1===o.indexOf("mousemove")&&o.push("mousemove"),o}return{dispatcher:function(e){var r=this.annotation,s=o.elements(this),n=t.getRelativePosition(e,this.chart),a=o.getNearestItems(s,n),c=i(r.options.events),l=r.options.dblClickSpeed,h=[],d=o.getEventHandlerName(e.type),p=(a||{}).options;if("mousemove"===e.type&&(a&&!a.hovering?["mouseenter","mouseover"].forEach((function(t){var i=o.getEventHandlerName(t),r=o.createMouseEvent(t,e);a.hovering=!0,"function"==typeof p[i]&&h.push([p[i],r,a])})):a||s.forEach((function(t){if(t.hovering){t.hovering=!1;var i=t.options;["mouseout","mouseleave"].forEach((function(r){var s=o.getEventHandlerName(r),n=o.createMouseEvent(r,e);"function"==typeof i[s]&&h.push([i[s],n,t])}))}}))),a&&c.indexOf("dblclick")>-1&&"function"==typeof p.onDblclick){if("click"===e.type&&"function"==typeof p.onClick)return clearTimeout(a.clickTimeout),a.clickTimeout=setTimeout((function(){delete a.clickTimeout,p.onClick.call(a,e)}),l),e.stopImmediatePropagation(),void e.preventDefault();"dblclick"===e.type&&a.clickTimeout&&(clearTimeout(a.clickTimeout),delete a.clickTimeout)}a&&"function"==typeof p[d]&&0===h.length&&h.push([p[d],e,a]),h.length>0&&(e.stopImmediatePropagation(),e.preventDefault(),h.forEach((function(e){e[0].call(e[2],e[1])})))},collapseHoverEvents:i}}}}),g=a({"node_modules/chartjs-plugin-annotation/src/annotation.js"(e,t){t.exports=function(e){var t=e.helpers,o=p()(e),i=f()(e),r=e.Annotation.types;function s(e){o.decorate(e,"afterDataLimits",(function(e,t){e&&e(t),o.adjustScaleRange(t)}))}function n(e){return function(t,i){var r=t.annotation.options.drawTime;o.elements(t).filter((function(t){return e===(t.options.drawTime||r)})).forEach((function(e){e.transition(i).draw()}))}}return{beforeInit:function(e){var i=e.options,r=e.annotation={elements:{},options:o.initConfig(i.annotation||{}),onDestroy:[],firstRun:!0,supported:!1};e.ensureScalesHaveIDs(),i.scales&&(r.supported=!0,t.each(i.scales.xAxes,s),t.each(i.scales.yAxes,s))},beforeUpdate:function(e){var t=e.annotation;if(t.supported){t.firstRun?t.firstRun=!1:t.options=o.initConfig(e.options.annotation||{});var i=[];t.options.annotations.forEach((function(s){var n=s.id||o.objectId();if(!t.elements[n]&&r[s.type]){var a=new(0,r[s.type])({id:n,options:s,chartInstance:e});a.initialize(),t.elements[n]=a,s.id=n,i.push(n)}else t.elements[n]&&i.push(n)})),Object.keys(t.elements).forEach((function(e){-1===i.indexOf(e)&&(t.elements[e].destroy(),delete t.elements[e])}))}},afterScaleUpdate:function(e){o.elements(e).forEach((function(e){e.configure()}))},beforeDatasetsDraw:n("beforeDatasetsDraw"),afterDatasetsDraw:n("afterDatasetsDraw"),afterDraw:n("afterDraw"),afterInit:function(e){var o=e.annotation.options.events;if(t.isArray(o)&&o.length>0){var r=e.chart.canvas,s=i.dispatcher.bind(e);i.collapseHoverEvents(o).forEach((function(o){t.addEvent(r,o,s),e.annotation.onDestroy.push((function(){t.removeEvent(r,o,s)}))}))}},destroy:function(e){for(var t=e.annotation.onDestroy;t.length>0;)t.pop()()}}}}}),b=a({"node_modules/chartjs-plugin-annotation/src/index.js"(e,t){var o=h();(o="function"==typeof o?o:window.Chart).Annotation=o.Annotation||{},o.Annotation.drawTimeOptions={afterDraw:"afterDraw",afterDatasetsDraw:"afterDatasetsDraw",beforeDatasetsDraw:"beforeDatasetsDraw"},o.Annotation.defaults={drawTime:"afterDatasetsDraw",dblClickSpeed:350,events:[],annotations:[]},o.Annotation.labelDefaults={backgroundColor:"rgba(0,0,0,0.8)",fontFamily:o.defaults.global.defaultFontFamily,fontSize:o.defaults.global.defaultFontSize,fontStyle:"bold",fontColor:"#fff",xPadding:6,yPadding:6,cornerRadius:6,position:"center",xAdjust:0,yAdjust:0,enabled:!1,content:null},o.Annotation.Element=d()(o),o.Annotation.types={line:u()(o),box:m()(o)};var i=g()(o);t.exports=i,o.pluginService.register(i)}}),v=a({"node_modules/chartjs-plugin-datalabels/dist/chartjs-plugin-datalabels.js"(e,t){var o,i;o=e,i=function(e){var t=(e=e&&e.hasOwnProperty("default")?e.default:e).helpers,o=function(){if("undefined"!=typeof window){if(window.devicePixelRatio)return window.devicePixelRatio;var e=window.screen;if(e)return(e.deviceXDPI||1)/(e.logicalXDPI||1)}return 1}(),i={toTextLines:function(e){var o,i=[];for(e=[].concat(e);e.length;)"string"==typeof(o=e.pop())?i.unshift.apply(i,o.split("\n")):Array.isArray(o)?e.push.apply(e,o):t.isNullOrUndef(e)||i.unshift(""+o);return i},toFontString:function(e){return!e||t.isNullOrUndef(e.size)||t.isNullOrUndef(e.family)?null:(e.style?e.style+" ":"")+(e.weight?e.weight+" ":"")+e.size+"px "+e.family},textSize:function(e,t,o){var i,r=[].concat(t),s=r.length,n=e.font,a=0;for(e.font=o.string,i=0;i<s;++i)a=Math.max(e.measureText(r[i]).width,a);return e.font=n,{height:s*o.lineHeight,width:a}},parseFont:function(o){var r=e.defaults.global,s=t.valueOrDefault(o.size,r.defaultFontSize),n={family:t.valueOrDefault(o.family,r.defaultFontFamily),lineHeight:t.options.toLineHeight(o.lineHeight,s),size:s,style:t.valueOrDefault(o.style,r.defaultFontStyle),weight:t.valueOrDefault(o.weight,null),string:""};return n.string=i.toFontString(n),n},bound:function(e,t,o){return Math.max(e,Math.min(t,o))},arrayDiff:function(e,t){var o,i,r,s,n=e.slice(),a=[];for(o=0,r=t.length;o<r;++o)s=t[o],-1===(i=n.indexOf(s))?a.push([s,1]):n.splice(i,1);for(o=0,r=n.length;o<r;++o)a.push([n[o],-1]);return a},rasterize:function(e){return Math.round(e*o)/o}};function r(e,t){var o=t.x,i=t.y;if(null===o)return{x:0,y:-1};if(null===i)return{x:1,y:0};var r=e.x-o,s=e.y-i,n=Math.sqrt(r*r+s*s);return{x:n?r/n:0,y:n?s/n:-1}}function s(e,t,o){var i=0;return e<o.left?i|=1:e>o.right&&(i|=2),t<o.top?i|=8:t>o.bottom&&(i|=4),i}function n(e,t){var o,i,r=t.anchor,n=e;return t.clamp&&(n=function(e,t){for(var o,i,r,n=e.x0,a=e.y0,c=e.x1,l=e.y1,h=s(n,a,t),d=s(c,l,t);h|d&&!(h&d);)8&(o=h||d)?(i=n+(c-n)*(t.top-a)/(l-a),r=t.top):4&o?(i=n+(c-n)*(t.bottom-a)/(l-a),r=t.bottom):2&o?(r=a+(l-a)*(t.right-n)/(c-n),i=t.right):1&o&&(r=a+(l-a)*(t.left-n)/(c-n),i=t.left),o===h?h=s(n=i,a=r,t):d=s(c=i,l=r,t);return{x0:n,x1:c,y0:a,y1:l}}(n,t.area)),"start"===r?(o=n.x0,i=n.y0):"end"===r?(o=n.x1,i=n.y1):(o=(n.x0+n.x1)/2,i=(n.y0+n.y1)/2),function(e,t,o,i,r){switch(r){case"center":o=i=0;break;case"bottom":o=0,i=1;break;case"right":o=1,i=0;break;case"left":o=-1,i=0;break;case"top":o=0,i=-1;break;case"start":o=-o,i=-i;break;case"end":break;default:r*=Math.PI/180,o=Math.cos(r),i=Math.sin(r)}return{x:e,y:t,vx:o,vy:i}}(o,i,e.vx,e.vy,t.align)}var a=function(e,t){var o=(e.startAngle+e.endAngle)/2,i=Math.cos(o),r=Math.sin(o),s=e.innerRadius,a=e.outerRadius;return n({x0:e.x+i*s,y0:e.y+r*s,x1:e.x+i*a,y1:e.y+r*a,vx:i,vy:r},t)},c=function(e,t){var o=r(e,t.origin),i=o.x*e.radius,s=o.y*e.radius;return n({x0:e.x-i,y0:e.y-s,x1:e.x+i,y1:e.y+s,vx:o.x,vy:o.y},t)},l=function(e,t){var o=r(e,t.origin),i=e.x,s=e.y,a=0,c=0;return e.horizontal?(i=Math.min(e.x,e.base),a=Math.abs(e.base-e.x)):(s=Math.min(e.y,e.base),c=Math.abs(e.base-e.y)),n({x0:i,y0:s+c,x1:i+a,y1:s,vx:o.x,vy:o.y},t)},h=function(e,t){var o=r(e,t.origin);return n({x0:e.x,y0:e.y,x1:e.x,y1:e.y,vx:o.x,vy:o.y},t)},d=e.helpers,p=i.rasterize;function u(e){var t=e._model.horizontal,o=e._scale||t&&e._xScale||e._yScale;if(!o)return null;if(void 0!==o.xCenter&&void 0!==o.yCenter)return{x:o.xCenter,y:o.yCenter};var i=o.getBasePixel();return t?{x:i,y:null}:{x:null,y:i}}function m(e,t,o){var i=e.shadowBlur,r=o.stroked,s=p(o.x),n=p(o.y),a=p(o.w);r&&e.strokeText(t,s,n,a),o.filled&&(i&&r&&(e.shadowBlur=0),e.fillText(t,s,n,a),i&&r&&(e.shadowBlur=i))}var f=function(e,t,o,i){var r=this;r._config=e,r._index=i,r._model=null,r._rects=null,r._ctx=t,r._el=o};d.extend(f.prototype,{_modelize:function(t,o,r,s){var n,p=this,m=p._index,f=d.options.resolve,g=i.parseFont(f([r.font,{}],s,m)),b=f([r.color,e.defaults.global.defaultFontColor],s,m);return{align:f([r.align,"center"],s,m),anchor:f([r.anchor,"center"],s,m),area:s.chart.chartArea,backgroundColor:f([r.backgroundColor,null],s,m),borderColor:f([r.borderColor,null],s,m),borderRadius:f([r.borderRadius,0],s,m),borderWidth:f([r.borderWidth,0],s,m),clamp:f([r.clamp,!1],s,m),clip:f([r.clip,!1],s,m),color:b,display:t,font:g,lines:o,offset:f([r.offset,0],s,m),opacity:f([r.opacity,1],s,m),origin:u(p._el),padding:d.options.toPadding(f([r.padding,0],s,m)),positioner:(n=p._el,n instanceof e.elements.Arc?a:n instanceof e.elements.Point?c:n instanceof e.elements.Rectangle?l:h),rotation:f([r.rotation,0],s,m)*(Math.PI/180),size:i.textSize(p._ctx,o,g),textAlign:f([r.textAlign,"start"],s,m),textShadowBlur:f([r.textShadowBlur,0],s,m),textShadowColor:f([r.textShadowColor,b],s,m),textStrokeColor:f([r.textStrokeColor,b],s,m),textStrokeWidth:f([r.textStrokeWidth,0],s,m)}},update:function(e){var t,o,r,s=this,n=null,a=null,c=s._index,l=s._config,h=d.options.resolve([l.display,!0],e,c);h&&(t=e.dataset.data[c],o=d.valueOrDefault(d.callback(l.formatter,[t,e]),t),(r=d.isNullOrUndef(o)?[]:i.toTextLines(o)).length&&(a=function(e){var t=e.borderWidth||0,o=e.padding,i=e.size.height,r=e.size.width,s=-r/2,n=-i/2;return{frame:{x:s-o.left-t,y:n-o.top-t,w:r+o.width+2*t,h:i+o.height+2*t},text:{x:s,y:n,w:r,h:i}}}(n=s._modelize(h,r,l,e)))),s._model=n,s._rects=a},geometry:function(){return this._rects?this._rects.frame:{}},rotation:function(){return this._model?this._model.rotation:0},visible:function(){return this._model&&this._model.opacity},model:function(){return this._model},draw:function(e,t){var o,r=e.ctx,s=this._model,n=this._rects;this.visible()&&(r.save(),s.clip&&(o=s.area,r.beginPath(),r.rect(o.left,o.top,o.right-o.left,o.bottom-o.top),r.clip()),r.globalAlpha=i.bound(0,s.opacity,1),r.translate(p(t.x),p(t.y)),r.rotate(s.rotation),function(e,t,o){var i=o.backgroundColor,r=o.borderColor,s=o.borderWidth;(i||r&&s)&&(e.beginPath(),d.canvas.roundedRect(e,p(t.x)+s/2,p(t.y)+s/2,p(t.w)-s,p(t.h)-s,o.borderRadius),e.closePath(),i&&(e.fillStyle=i,e.fill()),r&&s&&(e.strokeStyle=r,e.lineWidth=s,e.lineJoin="miter",e.stroke()))}(r,n.frame,s),function(e,t,o,i){var r,s=i.textAlign,n=i.color,a=!!n,c=i.font,l=t.length,h=i.textStrokeColor,d=i.textStrokeWidth,p=h&&d;if(l&&(a||p))for(o=function(e,t,o){var i=o.lineHeight,r=e.w,s=e.x;return"center"===t?s+=r/2:"end"!==t&&"right"!==t||(s+=r),{h:i,w:r,x:s,y:e.y+i/2}}(o,s,c),e.font=c.string,e.textAlign=s,e.textBaseline="middle",e.shadowBlur=i.textShadowBlur,e.shadowColor=i.textShadowColor,a&&(e.fillStyle=n),p&&(e.lineJoin="round",e.lineWidth=d,e.strokeStyle=h),r=0,l=t.length;r<l;++r)m(e,t[r],{stroked:p,filled:a,w:o.w,x:o.x,y:o.y+o.h*r})}(r,s.lines,n.text,s),r.restore())}});var g=e.helpers,b=Number.MIN_SAFE_INTEGER||-9007199254740991,v=Number.MAX_SAFE_INTEGER||9007199254740991;function y(e,t,o){var i=Math.cos(o),r=Math.sin(o),s=t.x,n=t.y;return{x:s+i*(e.x-s)-r*(e.y-n),y:n+r*(e.x-s)+i*(e.y-n)}}function w(e,t){var o,i,r,s,n,a=v,c=b,l=t.origin;for(o=0;o<e.length;++o)r=(i=e[o]).x-l.x,s=i.y-l.y,n=t.vx*r+t.vy*s,a=Math.min(a,n),c=Math.max(c,n);return{min:a,max:c}}function x(e,t){var o=t.x-e.x,i=t.y-e.y,r=Math.sqrt(o*o+i*i);return{vx:(t.x-e.x)/r,vy:(t.y-e.y)/r,origin:e,ln:r}}var _=function(){this._rotation=0,this._rect={x:0,y:0,w:0,h:0}};function k(e,t,o){var i=t.positioner(e,t),r=i.vx,s=i.vy;if(!r&&!s)return{x:i.x,y:i.y};var n=o.w,a=o.h,c=t.rotation,l=Math.abs(n/2*Math.cos(c))+Math.abs(a/2*Math.sin(c)),h=Math.abs(n/2*Math.sin(c))+Math.abs(a/2*Math.cos(c)),d=1/Math.max(Math.abs(r),Math.abs(s));return l*=r*d,h*=s*d,l+=t.offset*r,h+=t.offset*s,{x:i.x+l,y:i.y+h}}g.extend(_.prototype,{center:function(){var e=this._rect;return{x:e.x+e.w/2,y:e.y+e.h/2}},update:function(e,t,o){this._rotation=o,this._rect={x:t.x+e.x,y:t.y+e.y,w:t.w,h:t.h}},contains:function(e){var t=this,o=t._rect;return!((e=y(e,t.center(),-t._rotation)).x<o.x-1||e.y<o.y-1||e.x>o.x+o.w+2||e.y>o.y+o.h+2)},intersects:function(e){var t,o,i,r=this._points(),s=e._points(),n=[x(r[0],r[1]),x(r[0],r[3])];for(this._rotation!==e._rotation&&n.push(x(s[0],s[1]),x(s[0],s[3])),t=0;t<n.length;++t)if(o=w(r,n[t]),i=w(s,n[t]),o.max<i.min||i.max<o.min)return!1;return!0},_points:function(){var e=this,t=e._rect,o=e._rotation,i=e.center();return[y({x:t.x,y:t.y},i,o),y({x:t.x+t.w,y:t.y},i,o),y({x:t.x+t.w,y:t.y+t.h},i,o),y({x:t.x,y:t.y+t.h},i,o)]}});var C={prepare:function(e){var t,o,i,r,s,n=[];for(t=0,i=e.length;t<i;++t)for(o=0,r=e[t].length;o<r;++o)s=e[t][o],n.push(s),s.$layout={_box:new _,_hidable:!1,_visible:!0,_set:t,_idx:o};return n.sort((function(e,t){var o=e.$layout,i=t.$layout;return o._idx===i._idx?o._set-i._set:i._idx-o._idx})),this.update(n),n},update:function(e){var t,o,i,r,s,n=!1;for(t=0,o=e.length;t<o;++t)r=(i=e[t]).model(),(s=i.$layout)._hidable=r&&"auto"===r.display,s._visible=i.visible(),n|=s._hidable;n&&function(e){var t,o,i,r,s,n;for(t=0,o=e.length;t<o;++t)(r=(i=e[t]).$layout)._visible&&(s=i.geometry(),n=k(i._el._model,i.model(),s),r._box.update(n,s,i.rotation()));!function(e,t){var o,i,r,s;for(o=e.length-1;o>=0;--o)for(r=e[o].$layout,i=o-1;i>=0&&r._visible;--i)(s=e[i].$layout)._visible&&r._box.intersects(s._box)&&t(r,s)}(e,(function(e,t){var o=e._hidable,i=t._hidable;o&&i||i?t._visible=!1:o&&(e._visible=!1)}))}(e)},lookup:function(e,t){var o,i;for(o=e.length-1;o>=0;--o)if((i=e[o].$layout)&&i._visible&&i._box.contains(t))return{dataset:i._set,label:e[o]};return null},draw:function(e,t){var o,i,r,s,n,a;for(o=0,i=t.length;o<i;++o)(s=(r=t[o]).$layout)._visible&&(n=r.geometry(),a=k(r._el._view,r.model(),n),s._box.update(a,n,r.rotation()),r.draw(e,a))}},E=e.helpers,z={align:"center",anchor:"center",backgroundColor:null,borderColor:null,borderRadius:0,borderWidth:0,clamp:!1,clip:!1,color:void 0,display:!0,font:{family:void 0,lineHeight:1.2,size:void 0,style:void 0,weight:null},formatter:function(e){if(E.isNullOrUndef(e))return null;var t,o,i,r=e;if(E.isObject(e))if(E.isNullOrUndef(e.label))if(E.isNullOrUndef(e.r))for(r="",i=0,o=(t=Object.keys(e)).length;i<o;++i)r+=(0!==i?", ":"")+t[i]+": "+e[t[i]];else r=e.r;else r=e.label;return""+r},listeners:{},offset:4,opacity:1,padding:{top:4,right:4,bottom:4,left:4},rotation:0,textAlign:"start",textStrokeColor:void 0,textStrokeWidth:0,textShadowBlur:0,textShadowColor:void 0},A=e.helpers;function S(e,t,o){var i=t&&t[o.dataset];if(i){var r=o.label,s=r.$context;!0===A.callback(i,[s])&&(e.$datalabels._dirty=!0,r.update(s))}}e.defaults.global.plugins.datalabels=z;var M={id:"datalabels",beforeInit:function(e){e.$datalabels={_actives:[]}},beforeUpdate:function(e){var t=e.$datalabels;t._listened=!1,t._listeners={},t._datasets=[],t._labels=[]},afterDatasetUpdate:function(e,t,o){var i,r,s,n=t.index,a=e.$datalabels,c=a._datasets[n]=[],l=e.isDatasetVisible(n),h=e.data.datasets[n],d=function(e,t){var o=e.datalabels;return!1===o?null:(!0===o&&(o={}),A.merge({},[t,o]))}(h,o),p=t.meta.data||[],u=p.length,m=e.ctx;for(m.save(),i=0;i<u;++i)r=p[i],l&&r&&!r.hidden&&!r._model.skip?(c.push(s=new f(d,m,r,i)),s.update(s.$context={active:!1,chart:e,dataIndex:i,dataset:h,datasetIndex:n})):s=null,r.$datalabels=s;m.restore(),A.merge(a._listeners,d.listeners||{},{merger:function(e,o,i){o[e]=o[e]||{},o[e][t.index]=i[e],a._listened=!0}})},afterUpdate:function(e,t){e.$datalabels._labels=C.prepare(e.$datalabels._datasets,t)},afterDatasetsDraw:function(e){C.draw(e,e.$datalabels._labels)},beforeEvent:function(e,t){if(e.$datalabels._listened)switch(t.type){case"mousemove":case"mouseout":!function(e,t){var o,i,r=e.$datalabels,s=r._listeners;if(s.enter||s.leave){if("mousemove"===t.type)i=C.lookup(r._labels,t);else if("mouseout"!==t.type)return;o=r._hovered,r._hovered=i,function(e,t,o,i){var r,s;(o||i)&&(o?i?o.label!==i.label&&(s=r=!0):s=!0:r=!0,s&&S(e,t.leave,o),r&&S(e,t.enter,i))}(e,s,o,i)}}(e,t);break;case"click":!function(e,t){var o=e.$datalabels,i=o._listeners.click,r=i&&C.lookup(o._labels,t);r&&S(e,i,r)}(e,t)}},afterEvent:function(t){var o,r,s,n,a=t.$datalabels,c=a._actives,l=a._actives=t.lastActive||[],h=i.arrayDiff(c,l);for(o=0,r=h.length;o<r;++o)(s=h[o])[1]&&(n=s[0].$datalabels)&&(n.$context.active=1===s[1],n.update(n.$context));(a._dirty||h.length)&&(C.update(a._labels),function(t){if(!t.animating){for(var o=e.animationService.animations,i=0,r=o.length;i<r;++i)if(o[i].chart===t)return;t.render({duration:1,lazy:!0})}}(t)),delete a._dirty}};return e.plugins.register(M),M},"object"==typeof e&&void 0!==t?t.exports=i(h()):"function"==typeof define&&define.amd?define(["chart.js"],i):(o=o||self).ChartDataLabels=i(o.Chart)}}),y=c(h()),w=c(b()),x=c(v());window._____chartjses={Chart:y.default,ChartAnnotation:w,ChartDataLabels:x.default}})();const it=window._____chartjses.Chart,rt=window._____chartjses.ChartAnnotation,st=window._____chartjses.ChartDataLabels,nt=e=>class extends e{connectedCallback(){super.connectedCallback(),this.windowDimensionObserver=this.handleResize.bind(this),window.addEventListener("resize",this.windowDimensionObserver)}disconnectedCallback(){window.removeEventListener("resize",this.windowDimensionObserver),super.disconnectedCallback()}};class at extends(nt(se)){static get styles(){return[ae,ie`
        :host {
          height: 100%;
          width: 100%;
          position: relative;
          display: flex;
        }
        .chart-parent {
          height: 100%;
          width: 100%;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          display: flex;
          flex: 1;
          position: relative;
        }
      `]}render(){return V` <div class="chart-parent">
      <canvas id="chart-wrapper" width="0" height="0"></canvas>
    </div>`}static get properties(){return{type:{type:String,reflect:!0},legend:{type:Boolean,reflect:!0},data:{type:Object,reflect:!0},options:{type:Object,reflect:!0},_chartData:{type:Object}}}constructor(){super(),this.type="line",this.legend=!1}firstUpdated(){it.plugins.register([st,rt]),this._createChart()}updated(e){super.updated(e),(e.has("type")||e.has("legend")||e.has("data")||e.has("options"))&&this._createChart(),he(this,e,["options","type","legend","data"])}handleResize(){let e;for(e in it.instances)it.instances.hasOwnProperty(e)&&it.instances[e].resize()}disconnectedCallback(){super.disconnectedCallback(),this._chartData.destroy()}_setChartData(){if(null===this.data||void 0===this.data)return;const e=this.data.datasets.length;for(let t=0;t<e;t++)this.data.datasets[t].label=this.data.datasets[t].label?this.data.datasets[t].label:"Dataset Label",void 0===this.data.datasets[t].color&&("pie"!==this.type&&"doughnut"!==this.type&&e>1?this._setChartDataColor(t):this.data.datasets[t].color=["rgba(50,158,188,.8)","rgba(139,50,188,.8)","rgba(50,188,77,.8)","rgba(50,188,167,.8)","rgba(50,144,188,.8)","rgba(188,50,115,.8)"]),this.data.datasets[t].fill=void 0!==this.data.datasets[t].fill&&this.data.datasets[t].fill,this.data.datasets[t].pointBorderColor="transparent",this.data.datasets[t].pointRadius=4,this.data.datasets[t].pointHoverRadius=8,this.data.datasets[t].pointHitRadius=4,this.data.datasets[t].backgroundColor=this.data.datasets[t].color,this.data.datasets[t].hoverBackgroundColor=this.data.datasets[t].color,this.data.datasets[t].pointBackgroundColor=this.data.datasets[t].color,this.data.datasets[t].pointHoverBackgroundColor=this.data.datasets[t].color,this.data.datasets[t].borderColor=this.data.datasets[t].color,"line"===this.type||"radar"===this.type||"pie"===this.type||"doughnut"===this.type?(this.data.datasets[t].borderWidth=2,"pie"!==this.type&&"doughnut"!==this.type||(this.data.datasets[t].borderColor="white")):this.data.datasets[t].borderWidth=0,"radar"===this.type&&(this.data.datasets[t].lineTension=0)}_setChartDataColor(e){switch(e){case 0:this.data.datasets[e].color="rgba(50,158,188,1)";break;case 1:this.data.datasets[e].color="rgba(139,50,188,.8)";break;case 2:this.data.datasets[e].color="rgba(50,188,77,.8)";break;case 3:this.data.datasets[e].color="rgba(50,188,167,.8)";break;case 4:this.data.datasets[e].color="rgba(50,144,188,.8)";break;case 5:this.data.datasets[e].color="rgba(188,50,115,.8)"}}_createChart(){void 0!==this._chartData&&null!==this._chartData&&this._chartData.destroy(),this._setChartData(),it.defaults.global.defaultFontColor="rgba(0,0,0,.6)",it.defaults.global.defaultFontFamily="siemens sans",it.defaults.global.defaultFontSize=14,it.defaults.global.legend.labels.fontSize=12,it.defaults.global.legend.labels.fontColor="rgba(0,0,0,.9)",it.defaults.global.legend.labels.padding=16,it.defaults.global.legend.labels.usePointStyle=!0,this.ctx=this.shadowRoot.querySelector("#chart-wrapper").getContext("2d"),this._chartData=new it(this.ctx,{type:this.type,data:this.data,options:this.options}),this._chartData.options.tooltips.backgroundColor="rgb(255, 255, 255)",this._chartData.options.tooltips.titleFontColor="rgba(0,0,0,.9)",this._chartData.options.tooltips.bodyFontColor="rgba(0,0,0,.9)",this._chartData.options.tooltips.titleSpacing=8,this._chartData.options.tooltips.bodySpacing=4,this._chartData.options.tooltips.footerSpacing=4,this._chartData.options.tooltips.xPadding=8,this._chartData.options.tooltips.yPadding=8,this._chartData.options.tooltips.borderColor="rgba(0,0,0,.2)",this._chartData.options.tooltips.multiKeyBackground="transparent",this._chartData.options.tooltips.cornerRadius=2,this._chartData.options.tooltips.borderWidth=1,this._chartData.options.legend.display=this.legend,"line"===this.type&&(this.borderWidth=2)}}customElements.define("sh-chart",at);var ct=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-drawer-width=22rem] - drawer width
   */
  --sh-drawer-width: 22rem;
  /* 
   * @cssprop [--sh-drawer-header-wrapper-padding=1rem] - padding of the header-wrapper
   */
  --sh-drawer-header-wrapper-padding: 1rem;
  /* 
   * @cssprop [--sh-drawer-label-wrapper-padding=1rem] - padding of the label-wrapper
   */
  --sh-drawer-label-wrapper-padding: 1rem;
  /* 
   * @cssprop [--sh-drawer-gap-between-function-footer-slot-elements=0.5rem] - gap between function and footer slot elements
   */
  --sh-drawer-gap-between-function-footer-slot-elements: 0.5rem;
  /* 
   * @cssprop [--sh-drawer-body-wrapper-padding=0 1rem] - padding of the body-wrapper
   */
  --sh-drawer-body-wrapper-padding: 0 1rem;
  /* 
   * @cssprop [--sh-drawer-menu-item-margin-top=0.5rem] - margin-top of menu-item
   */
  --sh-drawer-menu-item-margin-top: 0.5rem;
  /* 
   * @cssprop [--sh-drawer-headerless-body-wrapper-padding-top=1rem] - padding-top of body-wrapper when no header
   */
  --sh-drawer-headerless-body-wrapper-padding-top: 1rem;
  /* 
   * @cssprop [--sh-drawer-footerless-body-wrapper-padding-bottom=var(--sh-drawer-headerless-body-wrapper-padding-top)] - padding bottom of body-wrapper when no footer
   */
  --sh-drawer-footerless-body-wrapper-padding-bottom: var(--sh-drawer-headerless-body-wrapper-padding-top);
  /* 
   * @cssprop [--sh-drawer-body-wrapper-margin-top=0.5rem] - margin-top of elements in body-wrapper
   */
  --sh-drawer-body-wrapper-margin-top: 0.5rem;
  /* 
   * @cssprop [--sh-drawer-footer-wrapper-padding=var(--sh-drawer-footerless-body-wrapper-padding-bottom)] - padding of the footer-wrapper
   */
  --sh-drawer-footer-wrapper-padding: var(--sh-drawer-footerless-body-wrapper-padding-bottom);
  /* 
   * @cssprop [--sh-drawer-top-bottom-min-height=10rem] - min-height of top and bottom drawers
   */
  --sh-drawer-top-bottom-min-height: 10rem;
  /* 
   * @cssprop [--sh-drawer-label-line-height=1.5rem] - line-height of the label
   */
  --sh-drawer-label-line-height: 1.5rem;
  /* 
   * @cssprop [--sh-drawer-label-padding=0rem] - padding of the label
   */
  --sh-drawer-label-padding: 0rem;
  /* 
   * @cssprop [--sh-drawer-label-margin-right=0.5rem] - margin-right of label
   */
  --sh-drawer-label-margin-right: 0.5rem;
  /* 
   * @cssprop [--sh-drawer-touch-gap-between-function-footer-slot-elements=1rem] - gap of the elements in function and footer slot for touch
   */
  --sh-drawer-touch-gap-between-function-footer-slot-elements: 1rem;
}

:host {
  position: fixed;
  top: 0rem;
  left: 0rem;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.4);
  /**
    Setting z-index is necessary here inorder to make the drawer appear.

    Why the value is set to 6?

    Since
    pane has z-index=2,
    access-bar has z-index=4,
    a reasonable value of 6 is chosen. 

    Why not a high value like that of popover ?

    Since we have no concrete control in what way the BL intends to display its popovers
    (whether it has to appear above the drawers or below it), we are not choosing such high values.

    Since the z-index is applied directly to the host, the Business Line can any time
    modify the z-index according to the business needs.
    */
  z-index: 6;
  max-height: 0rem;
  opacity: 0;
  transition: var(--transition-time) all ease-in-out, 0s height ease-in-out var(--transition-time), 0s max-height ease-in-out var(--transition-time), 0s visibility linear 0s;
  display: block;
  visibility: hidden;
}

:host(:not([visible])) {
  overflow: hidden;
  pointer-events: none;
}

.drawer-wrapper {
  background: var(--base-3);
  position: absolute;
  display: flex;
  flex-direction: column;
  box-shadow: var(--shadow-navigation);
  box-sizing: border-box;
  transition: var(--transition-time) all ease-in-out;
  --drawer-width: var(--sh-drawer-width);
}

/* slot styles */
:host(:not([label])) .drawer-wrapper[empty-function] .label-wrapper,
.drawer-wrapper:not([empty-header]) .label-wrapper {
  display: none;
}

.header-wrapper {
  display: flex;
  flex-direction: row;
  padding: var(--sh-drawer-header-wrapper-padding);
}

.label-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: var(--sh-drawer-label-wrapper-padding);
  min-height: fit-content;
  min-height: -ms-fit-content;
  min-height: -moz-fit-content;
}

.functions-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--sh-drawer-gap-between-function-footer-slot-elements);
}

.body-wrapper {
  flex: 1;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: auto;
  overflow-x: hidden;
  padding: var(--sh-drawer-body-wrapper-padding);
}

.drawer-wrapper[empty-header] .body-wrapper {
  padding-top: var(--sh-drawer-headerless-body-wrapper-padding-top);
}

.drawer-wrapper[empty-footer] .body-wrapper {
  padding-bottom: var(--sh-drawer-footerless-body-wrapper-padding-bottom);
}

.drawer-wrapper:not([empty-header]) .body-wrapper,
:host([label]) .body-wrapper {
  padding-top: 0rem;
}

.body-wrapper > ::slotted(*:not(:first-child):not(sh-menu-item)) {
  margin-top: var(--sh-drawer-body-wrapper-margin-top);
}

.body-wrapper > ::slotted(sh-menu-item:not(:first-child)) {
  margin-top: var(--sh-drawer-menu-item-margin-top) !important;
}

.footer-wrapper {
  min-height: fit-content;
  min-height: -ms-fit-content;
  min-height: -moz-fit-content;
  padding: var(--sh-drawer-footer-wrapper-padding);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: var(--sh-drawer-gap-between-function-footer-slot-elements);
}

.drawer-wrapper[empty-header] .header-wrapper,
.drawer-wrapper[empty-footer] .footer-wrapper {
  display: none;
}

/* positioning */
:host([position=top]) .drawer-wrapper,
:host([position=bottom]) .drawer-wrapper {
  height: auto;
  min-height: var(--sh-drawer-top-bottom-min-height);
  max-height: calc(100% - 6.5rem);
  width: 100%;
}

:host([position=left]) .drawer-wrapper,
:host([position=right]) .drawer-wrapper {
  width: var(--drawer-width);
  height: 100%;
}

:host([position=top]) .drawer-wrapper {
  top: 0rem;
  transform: translateY(-5rem);
}

:host([position=bottom]) .drawer-wrapper {
  bottom: 0rem;
  transform: translateY(5rem);
}

:host([position=left]) .drawer-wrapper {
  left: 0rem;
  transform: translateX(-5rem);
}

:host([position=right]) .drawer-wrapper {
  right: 0rem;
  transform: translateX(5rem);
}

/* Margin constraint */
:host([position=left]) .drawer-wrapper,
:host([position=right]) .drawer-wrapper {
  max-width: calc(100% - 6.5rem);
}

/* visible */
:host([visible]) {
  max-height: 100%;
  opacity: 1;
  transition: var(--transition-time) all ease-in-out var(--transition-time), 0s height ease-in-out, 0s max-height ease-in-out, 0s visibility linear 0s;
  visibility: visible;
}

:host([visible]) .drawer-wrapper {
  transition: var(--transition-time) all ease-in-out var(--transition-time);
  transform: none;
}

.drawer-label {
  overflow: hidden;
  width: -webkit-fill-available;
  width: -moz-available;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--text-primary);
  font: var(--header-2);
  line-height: var(--sh-drawer-label-line-height);
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  padding: var(--sh-drawer-label-padding);
  margin-right: var(--sh-drawer-label-margin-right);
}

/* touch */
@media (any-pointer: coarse) {
  .functions-wrapper,
.footer-wrapper {
    gap: var(--sh-drawer-touch-gap-between-function-footer-slot-elements);
  }
}
/* scrollpicker */
:host(.point5-vertical-padding) .body-wrapper {
  padding: 0.5rem 1rem;
}

:host([position=bottom][visible].initial-slide-on-connect) {
  animation: fade-in var(--transition-time) ease-in-out;
}

:host([position=bottom][visible].initial-slide-on-connect) .drawer-wrapper {
  animation: slide-on-connect var(--transition-time) ease-in-out;
}

@keyframes slide-on-connect {
  0% {
    bottom: 0rem;
    transform: translateY(5rem);
  }
  100% {
    transform: none;
  }
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}`;window.customElements.define("sh-drawer",class extends se{static get properties(){return{visible:{type:Boolean,reflect:!0},label:{type:String,reflect:!0},position:{type:String,reflect:!0},sticky:{type:Boolean,reflect:!0},drawerWidth:{type:String,reflect:!0,attribute:"drawer-width"},_emptyHeader:{type:Boolean},_emptyFooter:{type:Boolean},_emptyFunction:{type:Boolean}}}static get styles(){return[ae,ct]}render(){return V`
      <div
        class="drawer-wrapper"
        id="content"
        ?empty-footer="${this._emptyFooter}"
        ?empty-header="${this._emptyHeader}"
        ?empty-function="${this._emptyFunction}"
      >
        <div class="label-wrapper">
          ${this.label?V`<div class="drawer-label">${this.label}</div>`:V`<div class="drawer-label"></div>`}
          <div class="functions-wrapper">
            <slot
              name="functions"
              id="functions"
              @slotchange="${e=>this._updateSlotFlag(e.target,"_emptyFunction")}"
            ></slot>
          </div>
        </div>
        <div class="header-wrapper">
          <slot
            name="header"
            id="header"
            @slotchange="${e=>this._updateSlotFlag(e.target,"_emptyHeader")}"
          ></slot>
        </div>
        <div class="body-wrapper">
          <slot id="body"></slot>
        </div>
        <div class="footer-wrapper">
          <slot
            name="footer"
            id="footer"
            @slotchange="${e=>this._updateSlotFlag(e.target,"_emptyFooter")}"
          ></slot>
        </div>
      </div>
    `}constructor(){super(),this.position="left",this._emptyHeader=!0,this._emptyFooter=!0,this._emptyFunction=!0}updated(e){super.updated(e),e.has("visible")&&this._drawerStatus(),e.has("drawerWidth")&&this.shadowRoot.querySelector(".drawer-wrapper").style.setProperty("--drawer-width",this.drawerWidth),he(this,e,["visible","label","position","sticky","drawerWidth"])}firstUpdated(){super.firstUpdated(),this.addEventListener("mousedown",(function(){this.sticky||this._closeDrawer()})),this.shadowRoot.querySelector("#content").addEventListener("mousedown",(function(e){e.stopPropagation()})),this._documentKeyupListenerRef=this._handleDocumentKeyup.bind(this)}connectedCallback(){super.connectedCallback(),this.hasAttribute("tabindex")||this.setAttribute("tabindex",0)}disconnectedCallback(){document.removeEventListener("keyup",this._documentKeyupListenerRef),super.disconnectedCallback()}_updateSlotFlag(e,t){const o=e.assignedNodes({flatten:!0}).length;this[t]=0===o}_closeDrawer(){this.visible=!1,le(this,"drawer-closed"),console.warn("The drawer-closed event is a legacy event of sh-drawer component and will be deprecated soon.\nPlease use the visible-changed event to observe changes in visible property")}_drawerStatus(){this.visible?(this.focus(),this.style.outline="0",document.addEventListener("keyup",this._documentKeyupListenerRef)):document.removeEventListener("keyup",this._documentKeyupListenerRef)}_handleDocumentKeyup(e){e.keyCode!==me.ESCAPE||this.sticky||this._closeDrawer()}});var lt=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-input-text-label-left=0.5rem] - left of the input label
   */
  --sh-input-text-label-left: 0.5rem;
  /* 
   * @cssprop [--sh-input-text-empty-label-top=0.5rem] - top of the input label when no value
   */
  --sh-input-text-empty-label-top: 0.5rem;
  /* 
   * @cssprop [--sh-input-text-empty-label-line-height=1.5rem] - line-height of the input label when no value
   */
  --sh-input-text-empty-label-line-height: 1.5rem;
  /* 
   * @cssprop [--sh-input-text-empty-padding=0.5rem 0 0.4375rem 0.5rem] - padding of the input-text when no value
   */
  --sh-input-text-empty-padding: 0.5rem 0 0.4375rem 0.5rem;
  /* 
   * @cssprop [--sh-input-text-height=2.4375rem] - height of the input-text
   */
  --sh-input-text-height: 2.4375rem;
  /* 
   * @cssprop [--sh-input-text-padding=1.25rem 0 0.1875rem 0.5rem] - padding of the input-text with value
   */
  --sh-input-text-padding: 1.25rem 0 0.1875rem 0.5rem;
  /* 
   * @cssprop [--sh-input-text-label-top=0.25rem] - top of the input label with value
   */
  --sh-input-text-label-top: 0.25rem;
  /* 
   * @cssprop [--sh-input-text-label-line-height=1rem] - line-height of the input label with value
   */
  --sh-input-text-label-line-height: 1rem;
  /* 
   * @cssprop [--sh-input-text-empty-no-border-padding-bottom=0.5rem] - padding-bottom of the input when no border
   */
  --sh-input-text-empty-no-border-padding-bottom: 0.5rem;
  /* 
   * @cssprop [--sh-input-text-no-border-padding-bottom=0.25rem] - padding-bottom of the input with value when no border
   */
  --sh-input-text-no-border-padding-bottom: 0.25rem;
  /* 
   * @cssprop [--sh-input-text-no-border-condensed-padding-bottom=0.25rem] - padding-bottom of the condensed input when no border
   */
  --sh-input-text-no-border-condensed-padding-bottom: 0.25rem;
  /* 
   * @cssprop [--sh-input-text-icon-left-margin=0.5rem] - margin-left of the icon
   */
  --sh-input-text-icon-left-margin: 0.5rem;
  /* 
   * @cssprop [--sh-input-text-icon-wrapper-right-padding=0.5rem] - right-padding of the icon-wrapper
   */
  --sh-input-text-icon-wrapper-right-padding: 0.5rem;
  /* 
   * @cssprop [--sh-input-text-icon-size=1.5rem] - size of the icon
   */
  --sh-input-text-icon-size: 1.5rem;
  /* 
   * @cssprop [--sh-input-text-icon-wrapper-margin=0rem] - margin-bottom of the icon
   */
  --sh-input-text-icon-wrapper-margin: 0rem;
  /* 
   * @cssprop [--sh-input-text-helper-text-padding=0.25rem 0.5rem 0] - padding of the helper-text
   */
  --sh-input-text-helper-text-padding: 0.25rem 0.5rem 0;
  /* 
   * @cssprop [--sh-input-text-condensed-label-top=0.25rem] - top of the condensed label
   */
  --sh-input-text-condensed-label-top: 0.25rem;
  /* 
   * @cssprop [--sh-input-text-condensed-padding=0.25rem 0 0.1875rem 0.5rem] - padding of the condensed input
   */
  --sh-input-text-condensed-padding: 0.25rem 0 0.1875rem 0.5rem;
  /* 
   * @cssprop [--sh-input-text-condensed-height=1.9375rem] - height of the condensed input
   */
  --sh-input-text-condensed-height: 1.9375rem;
  /* 
   * @cssprop [--sh-input-text-textarea-label-height=1.5rem] - height of the textarea label
   */
  --sh-input-text-textarea-label-height: 1.5rem;
  /* 
   * @cssprop [--sh-input-text-textarea-label-padding=0.25rem 0 0.25rem 0.5rem] - padding of the textarea label
   */
  --sh-input-text-textarea-label-padding: 0.25rem 0 0.25rem 0.5rem;
  /* 
   * @cssprop [--sh-input-text-textarea-padding=0 0.5rem 0.3125rem] - padding of the textarea
   */
  --sh-input-text-textarea-padding: 0 0.5rem 0.3125rem;
  /* 
   * @cssprop [--sh-input-text-textarea-line-height=1.0625rem] - line-height of the textarea
   */
  --sh-input-text-textarea-line-height: 1.0625rem;
  /* 
   * @cssprop [--sh-input-text-textarea-empty-label-line-height=1.25rem] - line-height of the empty textarea (without value)
   */
  --sh-input-text-textarea-empty-label-line-height: 1.25rem;
  /* 
   * @cssprop [--sh-input-text-condensed-textarea-top=0.25rem] - top of the icon-wrapper and label of condensed textarea
   */
  --sh-input-text-condensed-textarea-top: 0.25rem;
  /* 
   * @cssprop [--sh-input-text-condensed-textarea-padding=0.25rem 0 0.3125rem 0.5rem] - padding of the div of condensed textarea
   */
  --sh-input-text-condensed-textarea-padding: 0.25rem 0 0.3125rem 0.5rem;
  /* 
   * @cssprop [--sh-input-text-textarea-label-line-height=1rem] - line-height of the label of textarea with value
   */
  --sh-input-text-textarea-label-line-height: 1rem;
  /* 
   * @cssprop [--sh-input-text-condensed-textarea-icon-top=0.25rem] - top of the icon of condensed textarea with value
   */
  --sh-input-text-condensed-textarea-icon-top: 0.25rem;
}

:host {
  width: 100%;
  height: auto;
  position: relative;
  display: flex;
  flex-direction: column;
}

.outer-wrapper {
  display: flex;
  flex-direction: column;
}

.input-wrapper {
  display: flex;
  flex-direction: row;
  border-radius: 0.125rem 0.125rem 0 0;
  background: rgba(var(--ui-1), var(--opacity-7));
  border-bottom: 0.0625rem solid transparent;
  border-color: rgba(var(--ui-1), var(--opacity-4));
  transition: var(--hover-transition-time) background;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
}

.input-text-label {
  color: var(--text-secondary);
  position: absolute;
  left: var(--sh-input-text-label-left);
  width: calc(100% - var(--sh-input-text-label-left));
  transition: var(--transition-time) all ease-in-out;
  pointer-events: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  top: var(--sh-input-text-empty-label-top);
  font: var(--body-1);
  line-height: var(--sh-input-text-empty-label-line-height);
  display: flex;
  align-items: center;
}

.label-wrapper {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: fit-content;
}

input {
  outline: none;
  border: none;
  font: var(--body-1);
  color: var(--text-primary);
  background: transparent;
  height: var(--sh-input-text-height);
  width: 100%;
  box-sizing: border-box;
  text-overflow: ellipsis;
  transition: var(--transition-time) all ease-in-out;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  -webkit-appearance: none;
  padding: var(--sh-input-text-padding);
}

:host(.empty) input {
  padding: var(--sh-input-text-empty-padding);
}

:host([no-border]:not([textarea]):not([condensed])) input {
  height: calc(var(--sh-input-text-height) + 0.0625rem);
  padding-bottom: var(--sh-input-text-empty-no-border-padding-bottom);
}

:host([no-border]:not([textarea]):not([condensed]):not(.empty)) input {
  height: calc(var(--sh-input-text-height) + 0.0625rem);
  padding-bottom: var(--sh-input-text-no-border-padding-bottom);
}

:host([condensed][no-border]:not([textarea])) input,
:host([condensed][no-clear][no-border]:not([textarea])) input {
  padding-bottom: var(--sh-input-text-no-border-condensed-padding-bottom);
  height: calc(var(--sh-input-text-condensed-height) + 0.0625rem);
}

:host(:not(.empty)) .input-text-label,
:host(:not([readonly])) input:focus + .input-text-label,
:host([show-outline]) .input-text-label {
  top: var(--sh-input-text-label-top);
  font: var(--body-2);
  line-height: var(--sh-input-text-label-line-height);
}

:host(:not([readonly])) .textarea:focus + .input-text-label,
:host([textarea]:not(.empty)) .input-text-label,
:host([textarea][textarea-focused]) .input-text-label {
  font: var(--body-2);
  line-height: var(--sh-input-text-textarea-label-line-height);
}

input::-ms-clear,
input::-ms-reveal {
  display: none;
}

.icon-wrapper {
  position: relative;
  align-items: center;
  right: 0;
  display: flex;
  padding-right: var(--sh-input-text-icon-wrapper-right-padding);
  width: fit-content;
  border-radius: 0 0.125rem 0 0;
}

:host([textarea]) .icon-wrapper {
  margin-bottom: var(--sh-input-text-icon-wrapper-margin);
}

:host([textarea][condensed]) .icon-wrapper {
  height: fit-content;
  top: var(--sh-input-text-condensed-textarea-top);
}

:host([textarea][condensed]:not(.empty):hover:not(.no-hovermq)) .icon-wrapper,
:host([textarea][condensed][error]:not(.empty)) .icon-wrapper {
  top: var(--sh-input-text-condensed-textarea-icon-top);
}

.icon-wrapper > sh-icon[icon=error],
.icon-wrapper > sh-icon[icon=success] {
  margin-left: var(--sh-input-text-icon-left-margin);
}

.icon-wrapper > ::slotted(sh-icon) {
  margin-left: var(--sh-input-text-icon-left-margin);
}

:host([condensed]:not([textarea])) #clear,
:host([condensed]:not([textarea])) .icon-wrapper > ::slotted(sh-icon) {
  --sh-icon-size-s: var(--sh-input-text-icon-size) !important;
}

/* disabled */
input:disabled,
textarea:disabled {
  opacity: unset;
}

:host([disabled]) .input-text-label,
:host([disabled][textarea]) .input-text-label,
:host([disabled]) input,
:host([disabled]) .textarea {
  color: var(--text-disabled);
}

:host([mandatory][disabled]) #mandatory {
  color: rgba(var(--ui-2), var(--opacity-5));
}

:host([disabled]) .icon-wrapper > ::slotted(*) {
  pointer-events: none;
  color: var(--text-disabled);
}

:host([disabled][textarea]) .textarea {
  color: var(--text-disabled);
}

/* Validation Styles */
:host([mandatory]) #mandatory {
  display: inline-block;
  color: rgba(var(--ui-2), var(--opacity-1));
}

:host([error]) .input-wrapper,
:host([error]) input:focus,
:host([textarea][error][condensed]) .input-wrapper,
:host([textarea][error]:not([condensed])) .outer-wrapper {
  border-color: rgba(var(--functional-red), var(--opacity-1));
}

:host([success]) .input-wrapper,
:host([success]) input:focus,
:host([textarea][success][condensed]) .input-wrapper,
:host([textarea][success]:not([condensed])) .outer-wrapper {
  border-color: rgba(var(--functional-green), var(--opacity-1));
}

:host([safety]) .input-wrapper,
:host([safety]) input:focus,
:host([textarea][safety][condensed]) .input-wrapper,
:host([textarea][safety]:not([condensed])) .outer-wrapper {
  border-color: rgba(var(--functional-yellow), var(--opacity-2));
}

/* focus */
:host(:not([error]):not([success]):not([safety]):not([readonly]):not([disabled])) .input-wrapper:focus-within,
:host([show-outline]) .input-wrapper {
  border-color: rgba(var(--ui-1), var(--opacity-2));
}

:host(.empty:not([condensed])) input:focus,
.textarea:focus {
  padding: var(--sh-input-text-padding);
}

/* readonly */
:host([readonly]) .input-wrapper,
:host([readonly]) .textarea {
  background: transparent;
}

:host([readonly]) input,
:host([readonly]) .textarea,
:host([disabled]) input,
:host([disabled]) .textarea {
  cursor: default;
  overflow: hidden;
  text-overflow: ellipsis;
}

:host([value=""][readonly]),
:host([disabled]) input,
:host([disabled]) .textarea {
  pointer-events: none;
}

/* Clear Field Icon */
#clear {
  opacity: 0;
  z-index: -1;
  padding: unset;
  pointer-events: none;
  transition: none;
  cursor: pointer;
  --sh-icon-size-s: 0;
  --sh-icon-font-size-s: 0;
}

:host([error]:not([value=""])) #clear {
  opacity: 1;
  z-index: auto;
  margin-left: var(--sh-input-text-icon-left-margin);
  --sh-icon-size-s: unset;
  --sh-icon-font-size-s: unset;
}

:host(.no-hovermq) #clear {
  opacity: 1;
  z-index: auto;
  pointer-events: all;
  --sh-icon-size-s: unset;
  --sh-icon-font-size-s: unset;
}

/* No Clear */
/* hover */
:host(:not([readonly]):not([disabled]):not([textarea]):hover) .input-wrapper {
  background: rgba(var(--ui-1), var(--opacity-6));
}

:host(:not([readonly]):not([disabled]):not(.empty):hover:not(.no-hovermq)) #clear,
:host(:not([readonly]):not([disabled]):not(.empty).no-hovermq):hover #clear,
#clear:focus {
  pointer-events: all;
  opacity: 1;
  z-index: auto;
  margin-left: var(--sh-input-text-icon-left-margin);
  --sh-icon-size-s: unset;
  --sh-icon-font-size-s: unset;
}

:host([condensed]:not([readonly]):not([disabled]):not(.empty):hover:not(.no-hovermq)) #clear,
:host([condensed]:not([readonly]):not([disabled]):not(.empty).no-hovermq):hover #clear,
:host([condensed]) #clear:focus,
:host([condensed]) .icon-wrapper > sh-icon[icon=error],
:host([condensed]) .icon-wrapper > sh-icon[icon=success],
:host([condensed][error]:not([value=""])) #clear,
:host([condensed]) .icon-wrapper > ::slotted(sh-icon) {
  margin-left: var(--sh-input-text-icon-left-margin);
}

/* helper text */
.helper-text {
  padding: var(--sh-input-text-helper-text-padding);
  box-sizing: border-box;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

:host([disabled]) .helper-text {
  color: var(--text-disabled);
}

/*condensed*/
:host([condensed]) .input-text-label,
:host([condensed]) input:focus + .input-text-label,
:host([condensed][textarea]) .textarea:focus + .input-text-label {
  display: none;
}

:host([condensed][textarea]) #shinputDiv {
  padding: var(--sh-input-text-condensed-textarea-padding);
}

:host(.empty[condensed][readonly]) input:focus + .input-text-label {
  display: flex;
}

:host(.empty[condensed]) .input-text-label {
  display: flex;
  top: var(--sh-input-text-condensed-label-top);
}

:host(.empty[textarea][condensed]) .input-text-label {
  line-height: var(--sh-input-text-textarea-line-height);
  top: unset;
  height: unset;
}

:host([condensed]) input,
:host([condensed][no-clear]) input {
  padding: var(--sh-input-text-condensed-padding);
  height: var(--sh-input-text-condensed-height);
}

/*textarea*/
:host([textarea]) .outer-wrapper {
  transition: var(--transition-time) all ease-in-out, var(--hover-transition-time) background, 0s height;
  background: rgba(var(--ui-1), var(--opacity-7));
  border-bottom: 0.0625rem solid transparent;
  border-color: rgba(var(--ui-1), var(--opacity-5));
  border-radius: 0.125rem 0.125rem 0 0;
}

:host([textarea]) .input-text-label {
  background-color: transparent;
  transition: color var(--transition-time) ease-in-out, font var(--transition-time) ease-in-out, top var(--transition-time) ease-in-out, line-height var(--transition-time) ease-in-out;
  height: var(--sh-input-text-textarea-label-height);
  line-height: var(--sh-input-text-textarea-empty-label-line-height);
}

:host([textarea]:not([condensed])) .input-text-label {
  position: relative;
  width: 100%;
  top: unset;
  left: unset;
}

:host([textarea]:not([condensed])) .content-wrapper {
  border-radius: 0.125rem 0 0 0;
}

:host([textarea]) .textarea,
:host([readonly][textarea]) .textarea:focus {
  outline: none;
  border: none;
  font: var(--body-1);
  color: var(--text-primary);
  background-color: transparent;
  width: 100%;
  box-sizing: border-box;
  padding: 0rem;
  resize: none;
  overflow-y: auto;
  line-height: var(--sh-input-text-textarea-line-height);
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
}

:host([textarea]) .input-wrapper {
  transition: none;
  border-radius: none;
  border-bottom: none;
  border-color: unset;
  border-radius: unset;
  background: none;
}

:host([textarea]:not([condensed])) .textarea,
:host([textarea][readonly]:not([condensed])) .textarea {
  padding: var(--sh-input-text-textarea-padding);
}

:host(:not([disabled]):not([readonly])[textarea]:hover) .outer-wrapper {
  background: rgba(var(--ui-1), var(--opacity-6));
}

:host(:not([readonly]):not(.no-hovermq)[textarea]:hover) input:hover:not(:focus),
:host(:not([readonly]):not(.no-hovermq)[textarea]:hover) .textarea:hover:not(:focus),
:host([textarea][readonly]) .outer-wrapper,
:host([textarea][readonly]) .input-wrapper {
  background-color: transparent;
}

:host([textarea]) #shinputDiv {
  padding: var(--sh-input-text-textarea-label-padding);
  box-sizing: border-box;
}

:host([textarea]:not([readonly]):not([disabled])) #shinputDiv {
  cursor: text;
}

/* textarea auto height */
:host([textarea][rows=auto]) .content-wrapper,
:host([textarea][rows=auto]) textarea {
  display: flex;
  flex: 1;
}

:host([no-border]) .input-wrapper,
:host([no-border][readonly]) input:focus .input-wrapper,
:host([textarea][no-border]) .outer-wrapper,
:host([textarea][error][condensed][no-border]) .input-wrapper,
:host([textarea][error][no-border]:not([condensed])) .outer-wrapper,
:host([textarea][success][condensed][no-border]) .input-wrapper,
:host([textarea][success][no-border]:not([condensed])) .outer-wrapper,
:host([textarea][safety][condensed][no-border]) .input-wrapper,
:host([textarea][safety][no-border]:not([condensed])) .outer-wrapper {
  border-bottom: none;
}`;customElements.define("sh-input-text",class extends se{static get properties(){return{label:{type:String,reflect:!0},value:{type:String,reflect:!0},hint:{type:String,reflect:!0},type:{type:String,reflect:!0},textarea:{type:Boolean,reflect:!0},rows:{type:String,reflect:!0},maxlength:{type:String,reflect:!0},readonly:{type:Boolean,reflect:!0},disabled:{type:Boolean,reflect:!0},role:{type:String,reflect:!0},mandatory:{type:Boolean,reflect:!0},error:{type:Boolean,reflect:!0},success:{type:Boolean,reflect:!0},safety:{type:Boolean,reflect:!0},errorMessage:{type:String,reflect:!0,attribute:"error-message"},condensed:{type:Boolean,reflect:!0},resizable:{type:Boolean,reflect:!0},noClear:{type:Boolean,reflect:!0,attribute:"no-clear"},autofocus:{type:Boolean,reflect:!0},noBorder:{type:Boolean,reflect:!0,attribute:"no-border"},_iconslot:{type:Boolean,reflect:!0},_notifyInputClick:{type:Boolean},_notifyInputFocus:{type:Boolean},_inputReadonly:{type:Boolean},_showOutline:{type:Boolean,reflect:!0,attribute:"show-outline"},_iconWrapperWidth:{type:Number}}}static get styles(){return[lt,ae]}render(){return V`
      <div class="outer-wrapper">
        <div class="input-wrapper">
          <div id="shinputDiv" class="content-wrapper">
            ${this.textarea?"":V`
                  <input
                    type="${this.type}"
                    @input="${e=>this.value=e.target.value}"
                    ?readonly="${this.readonly||this._inputReadonly}"
                    .value="${this.value?this.value:""}"
                    maxlength="${this.maxlength}"
                    id="input"
                    ?disabled="${this.disabled}"
                    ?autofocus="${this.autofocus}"
                    tabindex="${this.disabled?"-1":"0"}"
                    @click="${()=>{this._notifyInputClick&&le(this,"input-clicked",null,!1,!1)}}"
                    @focus="${()=>{this._notifyInputFocus&&le(this,"input-focused",null,!1,!1)}}"
                  />
                `}
            ${this.textarea&&this.condensed?V`
                  <textarea
                    class="textarea"
                    .value="${this.value?this.value:""}"
                    @input="${e=>this.value=e.target.value}"
                    maxlength="${this.maxlength}"
                    rows="${this.rows}"
                    ?readonly="${this.readonly}"
                    ?disabled="${this.disabled}"
                    ?autofocus="${this.autofocus}"
                    tabindex="${this.disabled?"-1":"0"}"
                  >
${this.value}</textarea
                  >
                `:""}

            <div class="input-text-label">
              ${this.label?V` <div class="label-wrapper">${this.label}</div> `:""}
              ${this.mandatory?V` <span id="mandatory"> *</span> `:""}
            </div>
          </div>
          <div class="icon-wrapper">
            ${!this.value||this.noClear||this.disabled||this.readonly?"":V`
                  <sh-icon
                    size="s"
                    button
                    icon="cancel"
                    id="clear"
                    tabindex="${this.value>0?"":"0"}"
                    @click="${e=>{this._clearField(e),le(this,"clear-clicked",null,!1,!1)}}"
                    @focusout="${()=>{this._enableClear=!1}}"
                  ></sh-icon>
                `}
            ${this.success||this.error?V`
                  <sh-icon
                    icon="${this.error?"error":"success"}"
                    size="s"
                    ?disabled="${this.disabled}"
                  ></sh-icon>
                `:""}
            <slot name="icon" id="icon" @slotchange="${()=>this._iconSlotObserver()}"></slot>
          </div>
        </div>
        ${this.textarea&&!this.condensed?V` <textarea
              class="textarea"
              .value="${this.value?this.value:""}"
              @input="${e=>this.value=e.target.value}"
              maxlength="${this.maxlength}"
              rows="${this.rows}"
              ?readonly="${this.readonly}"
              ?disabled="${this.disabled}"
              ?autofocus="${this.autofocus}"
              tabindex="${this.disabled?"-1":"0"}"
              @focus=${()=>{this.readonly||this.setAttribute("textarea-focused","")}}
              @blur=${()=>{this.removeAttribute("textarea-focused")}}
            >
${this.value}</textarea
            >`:""}
      </div>
      ${this.hint&&!this.errorMessage?V`
            <sh-text size="body-2" class="helper-text hint" color="secondary">${this.hint}</sh-text>
          `:""}
      ${this.hint&&this.errorMessage&&!this.error?V`
            <sh-text size="body-2" class="helper-text hint" color="secondary">${this.hint}</sh-text>
          `:""}
      ${this.error&&this.errorMessage?V`
            <sh-text size="body-2" class="helper-text error-message" color="secondary"
              >${this.errorMessage}</sh-text
            >
          `:""}
    `}constructor(){super(),this.label="label",this.type="text",this.value="",this._iconWrapperWidth=0}connectedCallback(){super.connectedCallback(),this.textareaLabelClick=this._handleTextareaLabelClick.bind(this),ue.isTouchDevice()&&this.classList.add("no-hovermq"),this.hasAttribute("role")||this.setAttribute("role","textbox"),this.textarea&&document.body.addEventListener("click",this.textareaLabelClick),this._addTabindex()}disconnectedCallback(){document.body.removeEventListener("click",this.textareaLabelClick),super.disconnectedCallback()}firstUpdated(){super.firstUpdated()}updated(e){e.has("value")&&this._handleValueChanged(),e.has("resizable")&&this.textarea&&this._handleResizableChanged(),this.textarea&&!this.rows&&(this.rows=3),he(this,e,["label","value","textarea","resizable","type","condensed","error","readonly","disabled"])}focus(){this.textarea?this.shadowRoot.querySelector("textarea").focus():this.shadowRoot.querySelector("#input").focus()}defocus(){this.shadowRoot.querySelector("#input").blur()}select(){this.textarea?this.shadowRoot.querySelector("textarea").select():this.shadowRoot.querySelector("#input").select()}_addTabindex(){const e=this.querySelectorAll("sh-icon").length;if(!this.disabled&&e>0)for(let t=0;t<e;t++)this.querySelectorAll("sh-icon")[t].setAttribute("tabindex","0")}_handleTextareaLabelClick(e){e.target===this&&this.textarea&&this.shadowRoot.querySelector("textarea").focus()}_handleValueChanged(){if(this.value?this.classList.remove("empty"):this.classList.add("empty"),this.textarea){const e=this.shadowRoot.querySelector("textarea");e.scrollHeight>e.clientHeight?e.title=this.value:e.title=""}}_handleResizableChanged(){this.textarea&&this.resizable?this.shadowRoot.querySelector("textarea").style.resize="vertical":this.shadowRoot.querySelector("textarea").style.resize="none"}_iconSlotObserver(){const e=this.shadowRoot.querySelector("#icon").assignedNodes({flatten:!0}).length;this._iconslot=e>0}_clearField(){this.value="",this.textarea?this.shadowRoot.querySelector("textarea").focus():this.shadowRoot.querySelector("#input").focus()}});const ht=new WeakMap;function dt(e){return t=>{if(function(e,t){let o=t;for(;o;){if(ht.get(o)===e)return!0;o=Object.getPrototypeOf(o)}return!1}(e,t))return t;const o=e(t);return ht.set(o,e),o}}const pt=dt((e=>class extends e{static get properties(){return{sizingTarget:{type:Object},fitInto:{type:Object},noOverlap:{type:Boolean},_oldNoOverlap:{type:Boolean,attribute:"no-overlap"},positionTarget:{type:Object},horizontalAlign:{type:String},_oldHorizontalAlign:{type:String,attribute:"horizontal-align"},verticalAlign:{type:String},_oldVerticalAlign:{type:String,attribute:"vertical-align"},dynamicAlign:{type:Boolean},_oldDynamicAlign:{type:Boolean,attribute:"dynamic-align"},horizontalOffset:{type:Number,reflect:!0},_oldHorizontalOffset:{type:Number,attribute:"horizontal-offset"},verticalOffset:{type:Number,reflect:!0},_oldVerticalOffset:{type:Number,attribute:"vertical-offset"},autoFitOnAttach:{type:Boolean,reflect:!0},_oldAutoFitOnAttach:{type:Boolean,attribute:"auto-fit-on-attach"},_fitInfo:{type:Object},fitPositionTarget:{type:Boolean}}}get _fitWidth(){let e;return e=this.fitInto===window?this.fitInto.innerWidth:this.fitInto.getBoundingClientRect().width,e}get _fitHeight(){let e;return e=this.fitInto===window?this.fitInto.innerHeight:this.fitInto.getBoundingClientRect().height,e}get _fitLeft(){let e;return e=this.fitInto===window?0:this.fitInto.getBoundingClientRect().left,e}get _fitTop(){let e;return e=this.fitInto===window?0:this.fitInto.getBoundingClientRect().top,e}get _defaultPositionTarget(){let e=this.parentNode;return e&&e.nodeType===Node.DOCUMENT_FRAGMENT_NODE&&(e=e.host),e}get _localeHorizontalAlign(){if(this._isRTL){if("right"===this.horizontalAlign)return"left";if("left"===this.horizontalAlign)return"right"}return this.horizontalAlign}get __shouldPosition(){return(this.horizontalAlign||this.verticalAlign)&&this.positionTarget}get"sizing-target"(){return this.sizingTarget}set"sizing-target"(e){this.sizingTarget=e}get"fit-into"(){return this.fitInto}set"fit-into"(e){this.fitInto=e}get _oldNoOverlap(){return this.noOverlap}set _oldNoOverlap(e){this.noOverlap=e}get"position-target"(){return this.positionTarget}set"position-target"(e){this.positionTarget=e}get"horizontal-align"(){return this.horizontalAlign}set"horizontal-align"(e){this.horizontalAlign=e}get _oldHorizontalAlign(){return this.horizontalAlign}set _oldHorizontalAlign(e){this.horizontalAlign=e}get"vertical-align"(){return this.verticalAlign}set"vertical-align"(e){this.verticalAlign=e}get _oldVerticalAlign(){return this.verticalAlign}set _oldVerticalAlign(e){this.verticalAlign=e}get _oldDynamicAlign(){return this.dynamicAlign}set _oldDynamicAlign(e){this.dynamicAlign=e}get _oldHorizontalOffset(){return this.horizontalOffset}set _oldHorizontalOffset(e){this.horizontalOffset=e}get"horizontal-offset"(){return this.horizontalOffset}set"horizontal-offset"(e){this.horizontalOffset=e}get _oldVerticalOffset(){return this.verticalOffset}set _oldVerticalOffset(e){this.verticalOffset=e}get"vertical-offset"(){return this.verticalOffset}set"vertical-offset"(e){this.verticalOffset=e}get _oldAutoFitOnAttach(){return this.autoFitOnAttach}set _oldAutoFitOnAttach(e){this.autoFitOnAttach=e}connectedCallback(){super.connectedCallback&&super.connectedCallback(),void 0===this._isRTL&&(this._isRTL="rtl"===window.getComputedStyle(this).direction),this.positionTarget=this.positionTarget||this._defaultPositionTarget,this.autoFitOnAttach&&setTimeout((()=>this.fit()))}disconnectedCallback(){super.disconnectedCallback&&super.disconnectedCallback(),this.__deferredFit&&(clearTimeout(this.__deferredFit),this.__deferredFit=null)}constructor(){super(),this.sizingTarget=this,this.fitInto=window,this.horizontalOffset=0,this.verticalOffset=0,this.autoFitOnAttach=!1,this.fitPositionTarget=!1}fit(){this.position(),this.constrain(),this.center()}_discoverInfo(){if(this._fitInfo)return;const e=window.getComputedStyle(this),t=window.getComputedStyle(this.sizingTarget);let o,i;o="auto"!==e.top?"top":"auto"!==e.bottom?"bottom":null,i="auto"!==e.left?"left":"auto"!==e.right?"right":null,this._fitInfo={inlineStyle:{top:this.style.top||"",left:this.style.left||"",position:this.style.position||""},sizerInlineStyle:{maxWidth:this.sizingTarget.style.maxWidth||"",maxHeight:this.sizingTarget.style.maxHeight||"",boxSizing:this.sizingTarget.style.boxSizing||""},positionedBy:{vertically:o,horizontally:i},sizedBy:{height:"none"!==t.maxHeight,width:"none"!==t.maxWidth,minWidth:parseInt(t.minWidth,10)||0,minHeight:parseInt(t.minHeight,10)||0},margin:{top:parseInt(e.marginTop,10)||0,right:parseInt(e.marginRight,10)||0,bottom:parseInt(e.marginBottom,10)||0,left:parseInt(e.marginLeft,10)||0}}}resetFit(){const{_fitInfo:e}=this;e&&e.sizerInlineStyle&&Object.keys(e.sizerInlineStyle).forEach((t=>{this.sizingTarget.style[t]=e.sizerInlineStyle[t]})),e&&e.inlineStyle&&Object.keys(e.inlineStyle).forEach((t=>{this.style[t]=e.inlineStyle[t]})),this._fitInfo=null}refit(){const{scrollLeft:e}=this.sizingTarget,{scrollTop:t}=this.sizingTarget;this.resetFit(),this.fit(),this.sizingTarget.scrollLeft=e,this.sizingTarget.scrollTop=t}position(){if(!this.__shouldPosition)return;this._discoverInfo(),this.style.position="fixed",this.sizingTarget.style.boxSizing="border-box",this.style.left="0px",this.style.top="0px";const e=this.getBoundingClientRect(),t=this.__getNormalizedRect(this.positionTarget),o=this.__getNormalizedRect(this.fitInto),{margin:i}=this._fitInfo,r={width:e.width+i.left+i.right,height:e.height+i.top+i.bottom},s=this.__getPosition(this._localeHorizontalAlign,this.verticalAlign,r,e,t,o);let n=s.left+i.left,a=s.top+i.top;const c=Math.min(o.right-i.right,n+e.width),l=Math.min(o.bottom-i.bottom,a+e.height);n=Math.max(o.left+i.left,Math.min(n,c-this._fitInfo.sizedBy.minWidth)),a=Math.max(o.top+i.top,Math.min(a,l-this._fitInfo.sizedBy.minHeight)),this.fitPositionTarget?(this.sizingTarget.style.maxWidth=`${Math.max(c-n,this._fitInfo.sizedBy.minWidth,t.width)}px`,this.style.width=this.sizingTarget.style.maxWidth):this.sizingTarget.style.maxWidth=`${Math.max(c-n,this._fitInfo.sizedBy.minWidth)}px`,this.sizingTarget.style.maxHeight=`${Math.max(l-a,this._fitInfo.sizedBy.minHeight)}px`,this.style.left=n-e.left+"px",this.style.top=a-e.top+"px"}constrain(){if(this.__shouldPosition)return;this._discoverInfo();const e=this._fitInfo;e.positionedBy.vertically||(this.style.position="fixed",this.style.top="0px"),e.positionedBy.horizontally||(this.style.position="fixed",this.style.left="0px"),this.sizingTarget.style.boxSizing="border-box";const t=this.getBoundingClientRect();e.sizedBy.height||this.__sizeDimension(t,e.positionedBy.vertically,"top","bottom","Height"),e.sizedBy.width||this.__sizeDimension(t,e.positionedBy.horizontally,"left","right","Width")}__sizeDimension(e,t,o,i,r){const s=this._fitInfo,n=this.__getNormalizedRect(this.fitInto),a="Width"===r?n.width:n.height,c=t===i,l=c?a-e[i]:e[o],h=s.margin[c?o:i],d=`offset${r}`,p=this[d]-this.sizingTarget[d];this.sizingTarget.style[`max${r}`]=a-h-l-p+"px"}center(){if(this.__shouldPosition)return;this._discoverInfo();const{positionedBy:e}=this._fitInfo;if(e.vertically&&e.horizontally)return;this.style.position="fixed",e.vertically||(this.style.top="0px"),e.horizontally||(this.style.left="0px");const t=this.getBoundingClientRect(),o=this.__getNormalizedRect(this.fitInto);if(!e.vertically){const e=o.top-t.top+(o.height-t.height)/2;this.style.top=`${e}px`}if(!e.horizontally){const e=o.left-t.left+(o.width-t.width)/2;this.style.left=`${e}px`}}__getNormalizedRect(e){return e===document.documentElement||e===window?{top:0,left:0,width:window.innerWidth,height:window.innerHeight,right:window.innerWidth,bottom:window.innerHeight}:e.getBoundingClientRect()}__getOffscreenArea(e,t,o){const i=Math.min(0,e.top)+Math.min(0,o.bottom-(e.top+t.height)),r=Math.min(0,e.left)+Math.min(0,o.right-(e.left+t.width));return Math.abs(i)*t.width+Math.abs(r)*t.height}__getPosition(e,t,o,i,r,s){const n=[{verticalAlign:"top",horizontalAlign:"left",top:r.top+this.verticalOffset,left:r.left+this.horizontalOffset},{verticalAlign:"top",horizontalAlign:"right",top:r.top+this.verticalOffset,left:r.right-o.width-this.horizontalOffset},{verticalAlign:"bottom",horizontalAlign:"left",top:r.bottom-o.height-this.verticalOffset,left:r.left+this.horizontalOffset},{verticalAlign:"bottom",horizontalAlign:"right",top:r.bottom-o.height-this.verticalOffset,left:r.right-o.width-this.horizontalOffset}];if(this.noOverlap){for(let e=0,t=n.length;e<t;e++){const t={},o=Object.keys(n[e]);for(let i=0,r=o.length;i<r;i++){const r=o[i];t[r]=n[e][r]}n.push(t)}n[0].top=n[1].top+=r.height,n[2].top=n[3].top-=r.height,n[4].left=n[6].left+=r.width,n[5].left=n[7].left-=r.width}let a;t="auto"===t?null:t,(e="auto"===e?null:e)&&"center"!==e||(n.push({verticalAlign:"top",horizontalAlign:"center",top:r.top+this.verticalOffset+(this.noOverlap?r.height:0),left:r.left-i.width/2+r.width/2+this.horizontalOffset}),n.push({verticalAlign:"bottom",horizontalAlign:"center",top:r.bottom-o.height-this.verticalOffset-(this.noOverlap?r.height:0),left:r.left-i.width/2+r.width/2+this.horizontalOffset})),t&&"middle"!==t||(n.push({verticalAlign:"middle",horizontalAlign:"left",top:r.top-i.height/2+r.height/2+this.verticalOffset,left:r.left+this.horizontalOffset+(this.noOverlap?r.width:0)}),n.push({verticalAlign:"middle",horizontalAlign:"right",top:r.top-i.height/2+r.height/2+this.verticalOffset,left:r.right-o.width-this.horizontalOffset-(this.noOverlap?r.width:0)})),"middle"===t&&"center"===e&&n.push({verticalAlign:"middle",horizontalAlign:"center",top:r.top-i.height/2+r.height/2+this.verticalOffset,left:r.left-i.width/2+r.width/2+this.horizontalOffset});for(let i=0;i<n.length;i++){const r=n[i],c=r.verticalAlign===t,l=r.horizontalAlign===e;if(!this.dynamicAlign&&!this.noOverlap&&c&&l){a=r;break}const h=(!t||c)&&(!e||l);if(!this.dynamicAlign&&!h)continue;if(r.offscreenArea=this.__getOffscreenArea(r,o,s),0===r.offscreenArea&&h){a=r;break}a=a||r;const d=r.offscreenArea-a.offscreenArea;(d<0||0===d&&(c||l))&&(a=r)}return a}})),ut=new Set,mt="requestresizenotifications",ft="resize",gt="iron-resize",bt=dt((e=>class extends e{get _parentResizable(){return this.__parentResizable}set _parentResizable(e){const t=this.__parentResizable;this.__parentResizable=e,t!==e&&this._parentResizableChanged(e)}get _notifyingDescendant(){return this.__notifyingDescendant}set _notifyingDescendant(e){this.__notifyingDescendant=e}constructor(){super(),this._interestedResizables=[],this._notifyingDescendant=!1,this._onIronRequestResizeNotifications=this._onIronRequestResizeNotifications.bind(this),this.notifyResize=this.notifyResize.bind(this),this._onDescendantIronResize=this._onDescendantIronResize.bind(this),this.addEventListener(mt,this._onIronRequestResizeNotifications,!0)}connectedCallback(){super.connectedCallback&&super.connectedCallback(),this.isAttached=!0,setTimeout((()=>{this._requestResizeNotifications()}))}disconnectedCallback(){super.disconnectedCallback&&super.disconnectedCallback(),this.isAttached=!1,this._parentResizable?this._parentResizable.stopResizeNotificationsFor(this):(ut.delete(this),window.removeEventListener("resize",this.notifyResize)),this._parentResizable=null}notifyResize(){this.isAttached&&(this._interestedResizables.forEach((e=>{this.resizerShouldNotify(e)&&this._notifyDescendant(e)})),this._fireResize())}assignParentResizable(e){this._parentResizable&&this._parentResizable.stopResizeNotificationsFor(this),this._parentResizable=e,e&&-1===e._interestedResizables.indexOf(this)&&(e._interestedResizables.push(this),e._subscribeIronResize(this))}stopResizeNotificationsFor(e){const t=this._interestedResizables.indexOf(e);t>-1&&(this._interestedResizables.splice(t,1),this._unsubscribeIronResize(e))}_subscribeIronResize(e){e.addEventListener(gt,this._onDescendantIronResize),e.addEventListener(ft,this._onDescendantIronResize)}_unsubscribeIronResize(e){e.removeEventListener(gt,this._onDescendantIronResize),e.removeEventListener(ft,this._onDescendantIronResize)}resizerShouldNotify(e){return!0}_onDescendantIronResize(e){this._notifyingDescendant?e.stopPropagation():this._fireResize()}_fireResize(){this.dispatchEvent(new CustomEvent(ft))}_onIronRequestResizeNotifications(e){let t;t=e.composedPath&&e.composedPath()||e.path||[];const o=t[0];o!==this&&(o.assignParentResizable&&o.assignParentResizable(this),this._notifyDescendant(o),e.stopPropagation())}_parentResizableChanged(e){e&&window.removeEventListener("resize",this.notifyResize)}_notifyDescendant(e){this.isAttached&&(this._notifyingDescendant=!0,e.notifyResize(),this._notifyingDescendant=!1)}_requestResizeNotifications(){if(this.isAttached)if("loading"===document.readyState){const e=this._requestResizeNotifications.bind(this);document.addEventListener("readystatechange",(function t(){document.removeEventListener("readystatechange",t),e()}))}else this._findParent(),this._parentResizable?this._parentResizable._interestedResizables.forEach((e=>{e!==this&&e._findParent()})):(ut.forEach((e=>{e!==this&&e._findParent()})),window.addEventListener("resize",this.notifyResize),this.notifyResize())}_findParent(){this.assignParentResizable(null),this.dispatchEvent(new CustomEvent(mt,{bubbles:!0,cancelable:!0,composed:!0})),this._parentResizable?ut.delete(this):ut.add(this)}})),vt=Element.prototype,yt=vt.matches||vt.matchesSelector||vt.mozMatchesSelector||vt.msMatchesSelector||vt.oMatchesSelector||vt.webkitMatchesSelector,wt=new class{getTabbableNodes(e){const t=[];return this._collectTabbableNodes(e,t)?this._sortByTabIndex(t):t}isFocusable(e){return yt.call(e,"input, select, textarea, button, object")?yt.call(e,":not([disabled])"):yt.call(e,"a[href], area[href], iframe, [tabindex], [contentEditable]")}isTabbable(e){return this.isFocusable(e)&&yt.call(e,':not([tabindex="-1"])')&&this._isVisible(e)}_normalizedTabIndex(e){if(this.isFocusable(e)){const t=e.getAttribute("tabindex")||0;return Number(t)}return-1}_collectTabbableNodes(e,t){if(e.nodeType!==Node.ELEMENT_NODE)return!1;const o=e;if(-1!==t.indexOf(o))return!1;if(!this._isVisible(o))return!1;const i=this._normalizedTabIndex(o);let r,s=i>0;i>=0&&t.push(o),r="slot"===o.localName?o.assignedNodes().filter((e=>e.nodeType===Node.ELEMENT_NODE)):o.shadowRoot&&o.shadowRoot.querySelectorAll?o.shadowRoot.querySelectorAll("*"):o.children;for(let e=0;e<r.length;e++)s=this._collectTabbableNodes(r[e],t)||s;return s}_isVisible(e){let{style:t}=e;return"hidden"!==t.visibility&&"none"!==t.display&&(t=window.getComputedStyle(e),"hidden"!==t.visibility&&"none"!==t.display)}_sortByTabIndex(e){const t=e.length;if(t<2)return e;const o=Math.ceil(t/2),i=this._sortByTabIndex(e.slice(0,o)),r=this._sortByTabIndex(e.slice(o));return this._mergeSortByTabIndex(i,r)}_mergeSortByTabIndex(e,t){const o=[];for(;e.length>0&&t.length>0;)this._hasLowerTabOrder(e[0],t[0])?o.push(t.shift()):o.push(e.shift());return o.concat(e,t)}_hasLowerTabOrder(e,t){const o=Math.max(e.tabIndex,0),i=Math.max(t.tabIndex,0);return 0===o||0===i?i>o:o>i}},xt="undefined"!=typeof window&&null!=window.customElements&&void 0!==window.customElements.polyfillWrapFlushCallback,_t=(e,t,o=null)=>{for(;t!==o;){const o=t.nextSibling;e.removeChild(t),t=o}},kt=`{{lit-${String(Math.random()).slice(2)}}}`,Ct=`\x3c!--${kt}--\x3e`,Et=new RegExp(`${kt}|${Ct}`),zt="$lit$";class At{constructor(e,t){this.parts=[],this.element=t;const o=[],i=[],r=document.createTreeWalker(t.content,133,null,!1);let s=0,n=-1,a=0;const{strings:c,values:{length:l}}=e;for(;a<l;){const e=r.nextNode();if(null!==e){if(n++,1===e.nodeType){if(e.hasAttributes()){const t=e.attributes,{length:o}=t;let i=0;for(let e=0;e<o;e++)St(t[e].name,zt)&&i++;for(;i-- >0;){const t=c[a],o=Bt.exec(t)[2],i=o.toLowerCase()+zt,r=e.getAttribute(i);e.removeAttribute(i);const s=r.split(Et);this.parts.push({type:"attribute",index:n,name:o,strings:s}),a+=s.length-1}}"TEMPLATE"===e.tagName&&(i.push(e),r.currentNode=e.content)}else if(3===e.nodeType){const t=e.data;if(t.indexOf(kt)>=0){const i=e.parentNode,r=t.split(Et),s=r.length-1;for(let t=0;t<s;t++){let o,s=r[t];if(""===s)o=Dt();else{const e=Bt.exec(s);null!==e&&St(e[2],zt)&&(s=s.slice(0,e.index)+e[1]+e[2].slice(0,-zt.length)+e[3]),o=document.createTextNode(s)}i.insertBefore(o,e),this.parts.push({type:"node",index:++n})}""===r[s]?(i.insertBefore(Dt(),e),o.push(e)):e.data=r[s],a+=s}}else if(8===e.nodeType)if(e.data===kt){const t=e.parentNode;null!==e.previousSibling&&n!==s||(n++,t.insertBefore(Dt(),e)),s=n,this.parts.push({type:"node",index:n}),null===e.nextSibling?e.data="":(o.push(e),n--),a++}else{let t=-1;for(;-1!==(t=e.data.indexOf(kt,t+1));)this.parts.push({type:"node",index:-1}),a++}}else r.currentNode=i.pop()}for(const e of o)e.parentNode.removeChild(e)}}const St=(e,t)=>{const o=e.length-t.length;return o>=0&&e.slice(o)===t},Mt=e=>-1!==e.index,Dt=()=>document.createComment(""),Bt=/([ \x09\x0a\x0c\x0d])([^\0-\x1F\x7F-\x9F "'>=/]+)([ \x09\x0a\x0c\x0d]*=[ \x09\x0a\x0c\x0d]*(?:[^ \x09\x0a\x0c\x0d"'`<>=]*|"[^"]*|'[^']*))$/;function Tt(e,t){const{element:{content:o},parts:i}=e,r=document.createTreeWalker(o,133,null,!1);let s=Lt(i),n=i[s],a=-1,c=0;const l=[];let h=null;for(;r.nextNode();){a++;const e=r.currentNode;for(e.previousSibling===h&&(h=null),t.has(e)&&(l.push(e),null===h&&(h=e)),null!==h&&c++;void 0!==n&&n.index===a;)n.index=null!==h?-1:n.index-c,s=Lt(i,s),n=i[s]}l.forEach((e=>e.parentNode.removeChild(e)))}const Rt=e=>{let t=11===e.nodeType?0:1;const o=document.createTreeWalker(e,133,null,!1);for(;o.nextNode();)t++;return t},Lt=(e,t=-1)=>{for(let o=t+1;o<e.length;o++){const t=e[o];if(Mt(t))return o}return-1},Pt=new WeakMap,Ot=e=>"function"==typeof e&&Pt.has(e),Nt={},Ft={};class $t{constructor(e,t,o){this.__parts=[],this.template=e,this.processor=t,this.options=o}update(e){let t=0;for(const o of this.__parts)void 0!==o&&o.setValue(e[t]),t++;for(const e of this.__parts)void 0!==e&&e.commit()}_clone(){const e=xt?this.template.element.content.cloneNode(!0):document.importNode(this.template.element.content,!0),t=[],o=this.template.parts,i=document.createTreeWalker(e,133,null,!1);let r,s=0,n=0,a=i.nextNode();for(;s<o.length;)if(r=o[s],Mt(r)){for(;n<r.index;)n++,"TEMPLATE"===a.nodeName&&(t.push(a),i.currentNode=a.content),null===(a=i.nextNode())&&(i.currentNode=t.pop(),a=i.nextNode());if("node"===r.type){const e=this.processor.handleTextExpression(this.options);e.insertAfterNode(a.previousSibling),this.__parts.push(e)}else this.__parts.push(...this.processor.handleAttributeExpressions(a,r.name,r.strings,this.options));s++}else this.__parts.push(void 0),s++;return xt&&(document.adoptNode(e),customElements.upgrade(e)),e}}const It=window.trustedTypes&&trustedTypes.createPolicy("lit-html",{createHTML:e=>e}),Vt=` ${kt} `;class Ht{constructor(e,t,o,i){this.strings=e,this.values=t,this.type=o,this.processor=i}getHTML(){const e=this.strings.length-1;let t="",o=!1;for(let i=0;i<e;i++){const e=this.strings[i],r=e.lastIndexOf("\x3c!--");o=(r>-1||o)&&-1===e.indexOf("--\x3e",r+1);const s=Bt.exec(e);t+=null===s?e+(o?Vt:Ct):e.substr(0,s.index)+s[1]+s[2]+zt+s[3]+kt}return t+=this.strings[e],t}getTemplateElement(){const e=document.createElement("template");let t=this.getHTML();return void 0!==It&&(t=It.createHTML(t)),e.innerHTML=t,e}}const Wt=e=>null===e||!("object"==typeof e||"function"==typeof e),qt=e=>Array.isArray(e)||!(!e||!e[Symbol.iterator]);class Yt{constructor(e,t,o){this.dirty=!0,this.element=e,this.name=t,this.strings=o,this.parts=[];for(let e=0;e<o.length-1;e++)this.parts[e]=this._createPart()}_createPart(){return new jt(this)}_getValue(){const e=this.strings,t=e.length-1,o=this.parts;if(1===t&&""===e[0]&&""===e[1]){const e=o[0].value;if("symbol"==typeof e)return String(e);if("string"==typeof e||!qt(e))return e}let i="";for(let r=0;r<t;r++){i+=e[r];const t=o[r];if(void 0!==t){const e=t.value;if(Wt(e)||!qt(e))i+="string"==typeof e?e:String(e);else for(const t of e)i+="string"==typeof t?t:String(t)}}return i+=e[t],i}commit(){this.dirty&&(this.dirty=!1,this.element.setAttribute(this.name,this._getValue()))}}class jt{constructor(e){this.value=void 0,this.committer=e}setValue(e){e===Nt||Wt(e)&&e===this.value||(this.value=e,Ot(e)||(this.committer.dirty=!0))}commit(){for(;Ot(this.value);){const e=this.value;this.value=Nt,e(this)}this.value!==Nt&&this.committer.commit()}}class Ut{constructor(e){this.value=void 0,this.__pendingValue=void 0,this.options=e}appendInto(e){this.startNode=e.appendChild(Dt()),this.endNode=e.appendChild(Dt())}insertAfterNode(e){this.startNode=e,this.endNode=e.nextSibling}appendIntoPart(e){e.__insert(this.startNode=Dt()),e.__insert(this.endNode=Dt())}insertAfterPart(e){e.__insert(this.startNode=Dt()),this.endNode=e.endNode,e.endNode=this.startNode}setValue(e){this.__pendingValue=e}commit(){if(null===this.startNode.parentNode)return;for(;Ot(this.__pendingValue);){const e=this.__pendingValue;this.__pendingValue=Nt,e(this)}const e=this.__pendingValue;e!==Nt&&(Wt(e)?e!==this.value&&this.__commitText(e):e instanceof Ht?this.__commitTemplateResult(e):e instanceof Node?this.__commitNode(e):qt(e)?this.__commitIterable(e):e===Ft?(this.value=Ft,this.clear()):this.__commitText(e))}__insert(e){this.endNode.parentNode.insertBefore(e,this.endNode)}__commitNode(e){this.value!==e&&(this.clear(),this.__insert(e),this.value=e)}__commitText(e){const t=this.startNode.nextSibling,o="string"==typeof(e=null==e?"":e)?e:String(e);t===this.endNode.previousSibling&&3===t.nodeType?t.data=o:this.__commitNode(document.createTextNode(o)),this.value=e}__commitTemplateResult(e){const t=this.options.templateFactory(e);if(this.value instanceof $t&&this.value.template===t)this.value.update(e.values);else{const o=new $t(t,e.processor,this.options),i=o._clone();o.update(e.values),this.__commitNode(i),this.value=o}}__commitIterable(e){Array.isArray(this.value)||(this.value=[],this.clear());const t=this.value;let o,i=0;for(const r of e)o=t[i],void 0===o&&(o=new Ut(this.options),t.push(o),0===i?o.appendIntoPart(this):o.insertAfterPart(t[i-1])),o.setValue(r),o.commit(),i++;i<t.length&&(t.length=i,this.clear(o&&o.endNode))}clear(e=this.startNode){_t(this.startNode.parentNode,e.nextSibling,this.endNode)}}class Zt{constructor(e,t,o){if(this.value=void 0,this.__pendingValue=void 0,2!==o.length||""!==o[0]||""!==o[1])throw new Error("Boolean attributes can only contain a single expression");this.element=e,this.name=t,this.strings=o}setValue(e){this.__pendingValue=e}commit(){for(;Ot(this.__pendingValue);){const e=this.__pendingValue;this.__pendingValue=Nt,e(this)}if(this.__pendingValue===Nt)return;const e=!!this.__pendingValue;this.value!==e&&(e?this.element.setAttribute(this.name,""):this.element.removeAttribute(this.name),this.value=e),this.__pendingValue=Nt}}class Kt extends Yt{constructor(e,t,o){super(e,t,o),this.single=2===o.length&&""===o[0]&&""===o[1]}_createPart(){return new Gt(this)}_getValue(){return this.single?this.parts[0].value:super._getValue()}commit(){this.dirty&&(this.dirty=!1,this.element[this.name]=this._getValue())}}class Gt extends jt{}let Xt=!1;(()=>{try{const e={get capture(){return Xt=!0,!1}};window.addEventListener("test",e,e),window.removeEventListener("test",e,e)}catch(e){}})();class Jt{constructor(e,t,o){this.value=void 0,this.__pendingValue=void 0,this.element=e,this.eventName=t,this.eventContext=o,this.__boundHandleEvent=e=>this.handleEvent(e)}setValue(e){this.__pendingValue=e}commit(){for(;Ot(this.__pendingValue);){const e=this.__pendingValue;this.__pendingValue=Nt,e(this)}if(this.__pendingValue===Nt)return;const e=this.__pendingValue,t=this.value,o=null==e||null!=t&&(e.capture!==t.capture||e.once!==t.once||e.passive!==t.passive),i=null!=e&&(null==t||o);o&&this.element.removeEventListener(this.eventName,this.__boundHandleEvent,this.__options),i&&(this.__options=Qt(e),this.element.addEventListener(this.eventName,this.__boundHandleEvent,this.__options)),this.value=e,this.__pendingValue=Nt}handleEvent(e){"function"==typeof this.value?this.value.call(this.eventContext||this.element,e):this.value.handleEvent(e)}}const Qt=e=>e&&(Xt?{capture:e.capture,passive:e.passive,once:e.once}:e.capture);function eo(e){let t=to.get(e.type);void 0===t&&(t={stringsArray:new WeakMap,keyString:new Map},to.set(e.type,t));let o=t.stringsArray.get(e.strings);if(void 0!==o)return o;const i=e.strings.join(kt);return o=t.keyString.get(i),void 0===o&&(o=new At(e,e.getTemplateElement()),t.keyString.set(i,o)),t.stringsArray.set(e.strings,o),o}const to=new Map,oo=new WeakMap,io=new class{handleAttributeExpressions(e,t,o,i){const r=t[0];return"."===r?new Kt(e,t.slice(1),o).parts:"@"===r?[new Jt(e,t.slice(1),i.eventContext)]:"?"===r?[new Zt(e,t.slice(1),o)]:new Yt(e,t,o).parts}handleTextExpression(e){return new Ut(e)}};"undefined"!=typeof window&&(window.litHtmlVersions||(window.litHtmlVersions=[])).push("1.4.1");const ro=(e,...t)=>new Ht(e,t,"html",io),so=(e,t)=>`${e}--${t}`;let no=!0;void 0===window.ShadyCSS?no=!1:void 0===window.ShadyCSS.prepareTemplateDom&&(console.warn("Incompatible ShadyCSS version detected. Please update to at least @webcomponents/webcomponentsjs@2.0.2 and @webcomponents/shadycss@1.3.1."),no=!1);const ao=e=>t=>{const o=so(t.type,e);let i=to.get(o);void 0===i&&(i={stringsArray:new WeakMap,keyString:new Map},to.set(o,i));let r=i.stringsArray.get(t.strings);if(void 0!==r)return r;const s=t.strings.join(kt);if(r=i.keyString.get(s),void 0===r){const o=t.getTemplateElement();no&&window.ShadyCSS.prepareTemplateDom(o,e),r=new At(t,o),i.keyString.set(s,r)}return i.stringsArray.set(t.strings,r),r},co=["html","svg"],lo=new Set;window.JSCompiler_renameProperty=(e,t)=>e;const ho={toAttribute(e,t){switch(t){case Boolean:return e?"":null;case Object:case Array:return null==e?e:JSON.stringify(e)}return e},fromAttribute(e,t){switch(t){case Boolean:return null!==e;case Number:return null===e?null:Number(e);case Object:case Array:return JSON.parse(e)}return e}},po=(e,t)=>t!==e&&(t==t||e==e),uo={attribute:!0,type:String,converter:ho,reflect:!1,hasChanged:po};class mo extends HTMLElement{constructor(){super(),this.initialize()}static get observedAttributes(){this.finalize();const e=[];return this._classProperties.forEach(((t,o)=>{const i=this._attributeNameForProperty(o,t);void 0!==i&&(this._attributeToPropertyMap.set(i,o),e.push(i))})),e}static _ensureClassProperties(){if(!this.hasOwnProperty(JSCompiler_renameProperty("_classProperties",this))){this._classProperties=new Map;const e=Object.getPrototypeOf(this)._classProperties;void 0!==e&&e.forEach(((e,t)=>this._classProperties.set(t,e)))}}static createProperty(e,t=uo){if(this._ensureClassProperties(),this._classProperties.set(e,t),t.noAccessor||this.prototype.hasOwnProperty(e))return;const o="symbol"==typeof e?Symbol():`__${e}`,i=this.getPropertyDescriptor(e,o,t);void 0!==i&&Object.defineProperty(this.prototype,e,i)}static getPropertyDescriptor(e,t,o){return{get(){return this[t]},set(i){const r=this[e];this[t]=i,this.requestUpdateInternal(e,r,o)},configurable:!0,enumerable:!0}}static getPropertyOptions(e){return this._classProperties&&this._classProperties.get(e)||uo}static finalize(){const e=Object.getPrototypeOf(this);if(e.hasOwnProperty("finalized")||e.finalize(),this.finalized=!0,this._ensureClassProperties(),this._attributeToPropertyMap=new Map,this.hasOwnProperty(JSCompiler_renameProperty("properties",this))){const e=this.properties,t=[...Object.getOwnPropertyNames(e),..."function"==typeof Object.getOwnPropertySymbols?Object.getOwnPropertySymbols(e):[]];for(const o of t)this.createProperty(o,e[o])}}static _attributeNameForProperty(e,t){const o=t.attribute;return!1===o?void 0:"string"==typeof o?o:"string"==typeof e?e.toLowerCase():void 0}static _valueHasChanged(e,t,o=po){return o(e,t)}static _propertyValueFromAttribute(e,t){const o=t.type,i=t.converter||ho,r="function"==typeof i?i:i.fromAttribute;return r?r(e,o):e}static _propertyValueToAttribute(e,t){if(void 0===t.reflect)return;const o=t.type,i=t.converter;return(i&&i.toAttribute||ho.toAttribute)(e,o)}initialize(){this._updateState=0,this._updatePromise=new Promise((e=>this._enableUpdatingResolver=e)),this._changedProperties=new Map,this._saveInstanceProperties(),this.requestUpdateInternal()}_saveInstanceProperties(){this.constructor._classProperties.forEach(((e,t)=>{if(this.hasOwnProperty(t)){const e=this[t];delete this[t],this._instanceProperties||(this._instanceProperties=new Map),this._instanceProperties.set(t,e)}}))}_applyInstanceProperties(){this._instanceProperties.forEach(((e,t)=>this[t]=e)),this._instanceProperties=void 0}connectedCallback(){this.enableUpdating()}enableUpdating(){void 0!==this._enableUpdatingResolver&&(this._enableUpdatingResolver(),this._enableUpdatingResolver=void 0)}disconnectedCallback(){}attributeChangedCallback(e,t,o){t!==o&&this._attributeToProperty(e,o)}_propertyToAttribute(e,t,o=uo){const i=this.constructor,r=i._attributeNameForProperty(e,o);if(void 0!==r){const e=i._propertyValueToAttribute(t,o);if(void 0===e)return;this._updateState=8|this._updateState,null==e?this.removeAttribute(r):this.setAttribute(r,e),this._updateState=-9&this._updateState}}_attributeToProperty(e,t){if(8&this._updateState)return;const o=this.constructor,i=o._attributeToPropertyMap.get(e);if(void 0!==i){const e=o.getPropertyOptions(i);this._updateState=16|this._updateState,this[i]=o._propertyValueFromAttribute(t,e),this._updateState=-17&this._updateState}}requestUpdateInternal(e,t,o){let i=!0;if(void 0!==e){const r=this.constructor;o=o||r.getPropertyOptions(e),r._valueHasChanged(this[e],t,o.hasChanged)?(this._changedProperties.has(e)||this._changedProperties.set(e,t),!0!==o.reflect||16&this._updateState||(void 0===this._reflectingProperties&&(this._reflectingProperties=new Map),this._reflectingProperties.set(e,o))):i=!1}!this._hasRequestedUpdate&&i&&(this._updatePromise=this._enqueueUpdate())}requestUpdate(e,t){return this.requestUpdateInternal(e,t),this.updateComplete}async _enqueueUpdate(){this._updateState=4|this._updateState;try{await this._updatePromise}catch(e){}const e=this.performUpdate();return null!=e&&await e,!this._hasRequestedUpdate}get _hasRequestedUpdate(){return 4&this._updateState}get hasUpdated(){return 1&this._updateState}performUpdate(){if(!this._hasRequestedUpdate)return;this._instanceProperties&&this._applyInstanceProperties();let e=!1;const t=this._changedProperties;try{e=this.shouldUpdate(t),e?this.update(t):this._markUpdated()}catch(t){throw e=!1,this._markUpdated(),t}e&&(1&this._updateState||(this._updateState=1|this._updateState,this.firstUpdated(t)),this.updated(t))}_markUpdated(){this._changedProperties=new Map,this._updateState=-5&this._updateState}get updateComplete(){return this._getUpdateComplete()}_getUpdateComplete(){return this.getUpdateComplete()}getUpdateComplete(){return this._updatePromise}shouldUpdate(e){return!0}update(e){void 0!==this._reflectingProperties&&this._reflectingProperties.size>0&&(this._reflectingProperties.forEach(((e,t)=>this._propertyToAttribute(t,this[t],e))),this._reflectingProperties=void 0),this._markUpdated()}updated(e){}firstUpdated(e){}}mo.finalized=!0;const fo=Element.prototype;fo.msMatchesSelector||fo.webkitMatchesSelector;const go=window.ShadowRoot&&(void 0===window.ShadyCSS||window.ShadyCSS.nativeShadow)&&"adoptedStyleSheets"in Document.prototype&&"replace"in CSSStyleSheet.prototype,bo=Symbol();class vo{constructor(e,t){if(t!==bo)throw new Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");this.cssText=e}get styleSheet(){return void 0===this._styleSheet&&(go?(this._styleSheet=new CSSStyleSheet,this._styleSheet.replaceSync(this.cssText)):this._styleSheet=null),this._styleSheet}toString(){return this.cssText}}const yo=(e,...t)=>{const o=t.reduce(((t,o,i)=>t+(e=>{if(e instanceof vo)return e.cssText;if("number"==typeof e)return e;throw new Error(`Value passed to 'css' function must be a 'css' function result: ${e}. Use 'unsafeCSS' to pass non-literal values, but\n            take care to ensure page security.`)})(o)+e[i+1]),e[0]);return new vo(o,bo)};(window.litElementVersions||(window.litElementVersions=[])).push("2.5.1");const wo={};class xo extends mo{static getStyles(){return this.styles}static _getUniqueStyles(){if(this.hasOwnProperty(JSCompiler_renameProperty("_styles",this)))return;const e=this.getStyles();if(Array.isArray(e)){const t=(e,o)=>e.reduceRight(((e,o)=>Array.isArray(o)?t(o,e):(e.add(o),e)),o),o=t(e,new Set),i=[];o.forEach((e=>i.unshift(e))),this._styles=i}else this._styles=void 0===e?[]:[e];this._styles=this._styles.map((e=>{if(e instanceof CSSStyleSheet&&!go){const t=Array.prototype.slice.call(e.cssRules).reduce(((e,t)=>e+t.cssText),"");return new vo(String(t),bo)}return e}))}initialize(){super.initialize(),this.constructor._getUniqueStyles(),this.renderRoot=this.createRenderRoot(),window.ShadowRoot&&this.renderRoot instanceof window.ShadowRoot&&this.adoptStyles()}createRenderRoot(){return this.attachShadow(this.constructor.shadowRootOptions)}adoptStyles(){const e=this.constructor._styles;0!==e.length&&(void 0===window.ShadyCSS||window.ShadyCSS.nativeShadow?go?this.renderRoot.adoptedStyleSheets=e.map((e=>e instanceof CSSStyleSheet?e:e.styleSheet)):this._needsShimAdoptedStyleSheets=!0:window.ShadyCSS.ScopingShim.prepareAdoptedCssText(e.map((e=>e.cssText)),this.localName))}connectedCallback(){super.connectedCallback(),this.hasUpdated&&void 0!==window.ShadyCSS&&window.ShadyCSS.styleElement(this)}update(e){const t=this.render();super.update(e),t!==wo&&this.constructor.render(t,this.renderRoot,{scopeName:this.localName,eventContext:this}),this._needsShimAdoptedStyleSheets&&(this._needsShimAdoptedStyleSheets=!1,this.constructor._styles.forEach((e=>{const t=document.createElement("style");t.textContent=e.cssText,this.renderRoot.appendChild(t)})))}render(){return wo}}xo.finalized=!0,xo.render=(e,t,o)=>{if(!o||"object"!=typeof o||!o.scopeName)throw new Error("The `scopeName` option is required.");const i=o.scopeName,r=oo.has(t),s=no&&11===t.nodeType&&!!t.host,n=s&&!lo.has(i),a=n?document.createDocumentFragment():t;if(((e,t,o)=>{let i=oo.get(t);void 0===i&&(_t(t,t.firstChild),oo.set(t,i=new Ut(Object.assign({templateFactory:eo},o))),i.appendInto(t)),i.setValue(e),i.commit()})(e,a,Object.assign({templateFactory:ao(i)},o)),n){const e=oo.get(a);oo.delete(a);((e,t,o)=>{lo.add(e);const i=o?o.element:document.createElement("template"),r=t.querySelectorAll("style"),{length:s}=r;if(0===s)return void window.ShadyCSS.prepareTemplateStyles(i,e);const n=document.createElement("style");for(let e=0;e<s;e++){const t=r[e];t.parentNode.removeChild(t),n.textContent+=t.textContent}(e=>{co.forEach((t=>{const o=to.get(so(t,e));void 0!==o&&o.keyString.forEach((e=>{const{element:{content:t}}=e,o=new Set;Array.from(t.querySelectorAll("style")).forEach((e=>{o.add(e)})),Tt(e,o)}))}))})(e);const a=i.content;o?function(e,t,o=null){const{element:{content:i},parts:r}=e;if(null==o)return void i.appendChild(t);const s=document.createTreeWalker(i,133,null,!1);let n=Lt(r),a=0,c=-1;for(;s.nextNode();)for(c++,s.currentNode===o&&(a=Rt(t),o.parentNode.insertBefore(t,o));-1!==n&&r[n].index===c;){if(a>0){for(;-1!==n;)r[n].index+=a,n=Lt(r,n);return}n=Lt(r,n)}}(o,n,a.firstChild):a.insertBefore(n,a.firstChild),window.ShadyCSS.prepareTemplateStyles(i,e);const c=a.querySelector("style");if(window.ShadyCSS.nativeShadow&&null!==c)t.insertBefore(c.cloneNode(!0),t.firstChild);else if(o){a.insertBefore(n,a.firstChild);const e=new Set;e.add(n),Tt(o,e)}})(i,a,e.value instanceof $t?e.value.template:void 0),_t(t,t.firstChild),t.appendChild(a),oo.set(t,e)}!r&&s&&window.ShadyCSS.styleElement(t.host)},xo.shadowRootOptions={mode:"open"},window.customElements.define("arc-overlay-backdrop",class extends xo{get styles(){return yo`
    :host {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: var(--arc-overlay-backdrop-background-color,
        var(--iron-overlay-backdrop-background-color, #000));
      opacity: 0;
      transition: var(--arc-overlay-backdrop-transition, opacity 0.2s);
      pointer-events: none;
    }

    :host(.opened) {
      opacity: var(--arc-overlay-backdrop-opacity, var(--iron-overlay-backdrop-opacity, 0.6));
      pointer-events: auto;
    }`}static get properties(){return{opened:{type:Boolean,reflect:!0}}}get opened(){return this.__opened}set opened(e){this.__opened!==e&&(this.__opened=e,this._openedChanged(e))}constructor(){super(),this.opened=!1,this.__openedRaf=null,this._onTransitionend=this._onTransitionend.bind(this)}connectedCallback(){this.isAttached=!0,super.connectedCallback(),this.addEventListener("transitionend",this._onTransitionend,!0),this.opened&&this._openedChanged(this.opened)}disconnectedCallback(){this.isAttached=!1,super.disconnectedCallback(),this.removeEventListener("transitionend",this._onTransitionend)}prepare(){this.opened&&!this.parentNode&&document.body.appendChild(this)}open(){this.opened=!0}close(){this.opened=!1}complete(){this.opened||this.parentNode!==document.body||this.parentNode.removeChild(this)}_onTransitionend(e){e&&e.target===this&&this.complete()}_openedChanged(e){if(e)this.prepare();else{const e=window.getComputedStyle(this);"0s"!==e.transitionDuration&&"0"!==e.opacity||this.complete()}if(!this.isAttached)return;this.__openedRaf&&(window.cancelAnimationFrame(this.__openedRaf),this.__openedRaf=null);const{scrollTop:t}=this;this.scrollTop=void 0,this.scrollTop=t,this.__openedRaf=window.requestAnimationFrame((()=>{this.__openedRaf=null,this.toggleClass("opened",this.opened)}))}toggleClass(e,t){t?this.classList.contains(e)||this.classList.add(e):this.classList.contains(e)&&this.classList.remove(e)}render(){return ro`<style>${this.styles}</style><slot></slot>`}});const _o=new class{constructor(){this._overlays=[],this._minimumZ=101,this._backdropElement=null,document.documentElement.addEventListener("click",(()=>{})),document.addEventListener("click",this._onCaptureClick.bind(this),!0),document.addEventListener("focus",this._onCaptureFocus.bind(this),!0),document.addEventListener("keydown",this._onCaptureKeyDown.bind(this),!0)}get backdropElement(){return this._backdropElement||(this._backdropElement=document.createElement("arc-overlay-backdrop")),this._backdropElement}get deepActiveElement(){let e=document.activeElement;for(e&&e instanceof Element!=0||(e=document.body);e.shadowRoot&&e.shadowRoot.activeElement;)e=e.shadowRoot.activeElement;return e}_bringOverlayAtIndexToFront(e){const t=this._overlays[e];if(!t)return;let o=this._overlays.length-1;const i=this._overlays[o];if(i&&this._shouldBeBehindOverlay(t,i)&&o--,e>=o)return;const r=Math.max(this.currentOverlayZ(),this._minimumZ);for(this._getZ(t)<=r&&this._applyOverlayZ(t,r);e<o;)this._overlays[e]=this._overlays[e+1],e++;this._overlays[o]=t}addOrRemoveOverlay(e){e.opened?this.addOverlay(e):this.removeOverlay(e)}addOverlay(e){const t=this._overlays.indexOf(e);if(t>=0)return this._bringOverlayAtIndexToFront(t),void this.trackBackdrop();let o=this._overlays.length;const i=this._overlays[o-1];let r=Math.max(this._getZ(i),this._minimumZ);const s=this._getZ(e);if(i&&this._shouldBeBehindOverlay(e,i)){this._applyOverlayZ(i,r),o--;const e=this._overlays[o-1];r=Math.max(this._getZ(e),this._minimumZ)}s<=r&&this._applyOverlayZ(e,r),this._overlays.splice(o,0,e),this.trackBackdrop()}removeOverlay(e){const t=this._overlays.indexOf(e);-1!==t&&(this._overlays.splice(t,1),this.trackBackdrop())}currentOverlay(){const e=this._overlays.length-1;return this._overlays[e]}currentOverlayZ(){return this._getZ(this.currentOverlay())}ensureMinimumZ(e){this._minimumZ=Math.max(this._minimumZ,e)}focusOverlay(){const e=this.currentOverlay();e&&e._applyFocus()}trackBackdrop(){const e=this._overlayWithBackdrop();(e||this._backdropElement)&&(this.backdropElement.style.zIndex=String(this._getZ(e)-1),this.backdropElement.opened=!!e,this.backdropElement.prepare())}getBackdrops(){const e=[];for(let t=0;t<this._overlays.length;t++)this._overlays[t].withBackdrop&&e.push(this._overlays[t]);return e}backdropZ(){return this._getZ(this._overlayWithBackdrop())-1}_overlayWithBackdrop(){for(let e=this._overlays.length-1;e>=0;e--)if(this._overlays[e].withBackdrop)return this._overlays[e]}_getZ(e){let t=this._minimumZ;if(e){const o=Number(e.style.zIndex||window.getComputedStyle(e).zIndex);Number.isNaN(o)||(t=o)}return t}_setZ(e,t){e.style.zIndex=String(t)}_applyOverlayZ(e,t){this._setZ(e,t+2)}_overlayInPath(e){e=e||[];for(let t=0;t<e.length;t++)if(e[t]._manager===this)return e[t]}_onCaptureClick(e){let t=this._overlays.length-1;if(-1===t)return;const o=e.composedPath&&e.composedPath()||e.path;let i;for(;(i=this._overlays[t])&&this._overlayInPath(o)!==i&&(i._onCaptureClick(e),i.allowClickThrough);)t--}_onCaptureFocus(e){const t=this.currentOverlay();t&&t._onCaptureFocus(e)}_onCaptureKeyDown(e){const t=this.currentOverlay();t&&(this._keyboardEventMatchesKeys(e,"Escape")?t._onCaptureEsc(e):this._keyboardEventMatchesKeys(e,"Tab")&&t._onCaptureTab(e))}_keyboardEventMatchesKeys(e,t){return!(!e.key||e.key!==t)||!(!e.detail||e.detail.key!==t)}_shouldBeBehindOverlay(e,t){return!e.alwaysOnTop&&t.alwaysOnTop}},ko={pageX:0,pageY:0};let Co=null,Eo=[];const zo=["wheel","mousewheel","DOMMouseScroll","touchstart","touchmove"];let Ao,So;const Mo=[];let Do=null,Bo=null;function To(e){if(e.cancelable&&function(e){const t=e.composedPath&&e.composedPath()||e.path,o=t[0];if("touchmove"!==e.type&&Co!==o&&(Co=o,Eo=function(e){const t=[],o=e.indexOf(So);for(let i=0;i<=o;i++){if(e[i].nodeType!==Node.ELEMENT_NODE)continue;const o=e[i];let{style:r}=o;r.overflow.includes("scroll")||r.overflow.includes("auto")||(r=window.getComputedStyle(o)),(r.overflow.includes("scroll")||r.overflow.includes("auto"))&&t.push(o)}return t}(t)),!Eo.length)return!0;if("touchstart"===e.type)return!1;const i=function(e){const t={deltaX:e.deltaX,deltaY:e.deltaY};if("deltaX"in e);else if("wheelDeltaX"in e&&"wheelDeltaY"in e)t.deltaX=-e.wheelDeltaX,t.deltaY=-e.wheelDeltaY;else if("wheelDelta"in e)t.deltaX=0,t.deltaY=-e.wheelDelta;else if("axis"in e)t.deltaX=1===e.axis?e.detail:0,t.deltaY=2===e.axis?e.detail:0;else if(e.targetTouches){const o=e.targetTouches[0];t.deltaX=ko.pageX-o.pageX,t.deltaY=ko.pageY-o.pageY}return t}(e);return!function(e,t,o){if(!t&&!o)return;const i=Math.abs(o)>=Math.abs(t);for(let r=0;r<e.length;r++){const s=e[r];let n=!1;if(n=i?o<0?s.scrollTop>0:s.scrollTop<s.scrollHeight-s.clientHeight:t<0?s.scrollLeft>0:s.scrollLeft<s.scrollWidth-s.clientWidth,n)return s}}(Eo,i.deltaX,i.deltaY)}(e)&&e.preventDefault(),e.targetTouches){const t=e.targetTouches[0];ko.pageX=t.pageX,ko.pageY=t.pageY}}const Ro=dt((e=>{class t extends(pt(bt(e))){static get properties(){return{opened:{type:Boolean,reflect:!0},__canceled:{type:Boolean,reflect:!0,attribute:"canceled"},withBackdrop:{type:Boolean,reflect:!0},_oldWithBackdrop:{type:Boolean,attribute:"with-backdrop"},noAutoFocus:{type:Boolean,reflect:!0},_oldNoAutoFocus:{type:Boolean,attribute:"no-auto-focus"},noCancelOnEscKey:{type:Boolean,reflect:!0},_oldNoCancelOnEscKey:{type:Boolean,attribute:"no-cancel-on-esc-key"},noCancelOnOutsideClick:{type:Boolean,reflect:!0},_oldNoCancelOnOutsideClick:{type:Boolean,attribute:"no-cancel-on-outside-click"},closingReason:{type:Object},restoreFocusOnClose:{type:Boolean,reflect:!0},_oldRestoreFocusOnClose:{type:Boolean,attribute:"restore-focus-on-close"},allowClickThrough:{type:Boolean,reflect:!0},_oldAllowClickThrough:{type:Boolean,attribute:"allow-click-through"},alwaysOnTop:{type:Boolean,reflect:!0},_oldAlwaysOnTop:{type:Boolean,attribute:"always-on-top"},scrollAction:{type:String,reflect:!0},_oldScrollAction:{type:String,attribute:"scroll-action"},_manager:{type:Object},_focusedChild:{type:Object}}}get opened(){return this._opened}set opened(e){const t=this._opened;e!==t&&(this._opened=e,this.requestUpdate&&this.requestUpdate("opened",t),this._openedChanged(e),this.__updateScrollObservers(this._isAttached,e,this.scrollAction),this.dispatchEvent(new CustomEvent("openedchange")),this.dispatchEvent(new CustomEvent("opened-changed",{detail:{value:e}})))}get canceled(){return this.__canceled}get _canceled(){return this.__canceled}set _canceled(e){e!==this.__canceled&&(this.__canceled=e,this._canceledChanged())}get withBackdrop(){return this._withBackdrop}set withBackdrop(e){const t=this._withBackdrop;e!==t&&(this._withBackdrop=e,this.requestUpdate&&this.requestUpdate("withBackdrop",t),this._withBackdropChanged())}get _oldWithBackdrop(){return this.withBackdrop}set _oldWithBackdrop(e){this.withBackdrop=e}get _oldNoAutoFocus(){return this.noAutoFocus}set _oldNoAutoFocus(e){this.noAutoFocus=e}get _oldNoCancelOnEscKey(){return this.noCancelOnEscKey}set _oldNoCancelOnEscKey(e){this.noCancelOnEscKey=e}get _oldNoCancelOnOutsideClick(){return this.noCancelOnOutsideClick}set _oldNoCancelOnOutsideClick(e){this.noCancelOnOutsideClick=e}get _oldRestoreFocusOnClose(){return this.restoreFocusOnClose}set _oldRestoreFocusOnClose(e){this.restoreFocusOnClose=e}get _oldAllowClickThrough(){return this.allowClickThrough}set _oldAllowClickThrough(e){this.allowClickThrough=e}get _oldAlwaysOnTop(){return this.alwaysOnTop}set _oldAlwaysOnTop(e){this.alwaysOnTop=e}get _oldScrollAction(){return this.scrollAction}set _oldScrollAction(e){this.scrollAction=e}get"scroll-action"(){return this.scrollAction}set"scroll-action"(e){this.scrollAction=e}get isAttached(){return this._isAttached}set isAttached(e){this._isAttached=e,this.__updateScrollObservers(e,this._opened,this.scrollAction)}get scrollAction(){return this._scrollAction}set scrollAction(e){this._scrollAction=e,this.__updateScrollObservers(this._isAttached,this._opened,e)}get backdropElement(){return this._manager.backdropElement}get _focusNode(){return this._focusedChild||this.querySelector("[autofocus]")||this}get _focusableNodes(){return wt.getTabbableNodes(this)}get onopenedchanged(){return this["_onopened-changed"]}set onopenedchanged(e){this._registerCallback("opened-changed",e)}get onoverlaycanceled(){return this["_onoverlay-canceled"]}set onoverlaycanceled(e){this._registerCallback("overlay-canceled",e)}get onoverlayopened(){return this["_onoverlay-opened"]}set onoverlayopened(e){this._registerCallback("overlay-opened",e)}get onoverlayclosed(){return this["_onoverlay-closed"]}set onoverlayclosed(e){this._registerCallback("overlay-closed",e)}get onopened(){return this._onopened}set onopened(e){this._registerCallback("opened",e)}get onclosed(){return this._onclosed}set onclosed(e){this._registerCallback("closed",e)}constructor(){super(),this._opened=!1,this._canceled=!1,this.noAutoFocus=!1,this.noCancelOnEscKey=!1,this.noCancelOnOutsideClick=!1,this.restoreFocusOnClose=!1,this._manager=_o,this.__isAnimating=!1,this.__shouldRemoveTabIndex=!1,this.__firstFocusableNode=this.__lastFocusableNode=null,this.__rafs={},this.__restoreFocusNode=null,this.__scrollTop=this.__scrollLeft=null,this.__rootNodes=null,this._onIronResize=this._onIronResize.bind(this),this.__onCaptureScroll=this.__onCaptureScroll.bind(this),this._boundSchedule=this._boundSchedule.bind(this)}connectedCallback(){super.connectedCallback(),this.addEventListener("iron-resize",this._onIronResize),this._elementReady||(this._elementReady=!0,this.updateComplete?this.updateComplete.then((()=>{this._ensureSetup()})):this._ensureSetup()),this.opened&&this._openedChanged(this.opened),this._setupSlotListeners(),this._ensureAria()}disconnectedCallback(){super.disconnectedCallback(),this.removeEventListener("iron-resize",this._onIronResize),this._removeSlotListeners(),Object.keys(this.__rafs).forEach((e=>{null!==this.__rafs[e]&&cancelAnimationFrame(this.__rafs[e])})),this.__rafs={},this._manager.removeOverlay(this),this.__isAnimating&&(this.opened?this._finishRenderOpened():(this._applyFocus(),this._finishRenderClosed()))}_registerCallback(e,t){const o=`_on${e}`;this[o]&&this.removeEventListener(e,this[o]),"function"==typeof t?(this[o]=t,this.addEventListener(e,t)):this[o]=null}_setupSlotListeners(){const e=new MutationObserver((e=>{this._processMutations(e)}));this._childrenObserver=e,this._childrenObserver.observe(this,{childList:!0})}_removeSlotListeners(){this._unlistenSlots(this.children),this._childrenObserver.disconnect(),this._childrenObserver=null}_processMutations(e){if(e){for(let t=0;t<e.length;t++){const o=e[t];o.addedNodes&&this._listenSlots(o.addedNodes),o.removedNodes&&this._unlistenSlots(o.removedNodes)}this._onNodesChange()}}_listenSlots(e){for(let t=0;t<e.length;t++){const o=e[t];"slot"===o.localName&&o.addEventListener("slotchange",this._boundSchedule)}}_unlistenSlots(e){for(let t=0;t<e.length;t++){const o=e[t];"slot"===o.localName&&o.removeEventListener("slotchange",this._boundSchedule)}}_boundSchedule(){setTimeout((()=>{this._onNodesChange()}))}toggle(){this._canceled=!1,this.opened=!this.opened}open(){this._canceled=!1,this.opened=!0}close(){this._canceled=!1,this.opened=!1}cancel(e){const t={cancelable:!0,bubbles:!0,composed:!0,detail:e};let o=new Event("cancel",{cancelable:!0,bubbles:!0});this.dispatchEvent(o),o.defaultPrevented||(o=new CustomEvent("overlay-canceled",t),this.dispatchEvent(o),o.defaultPrevented||(o=new CustomEvent("iron-overlay-canceled",t),this.dispatchEvent(o),o.defaultPrevented||(this._canceled=!0,this.opened=!1)))}invalidateTabbables(){this.__firstFocusableNode=this.__lastFocusableNode=null}_ensureSetup(){this._overlaySetup||(this._overlaySetup=!0,this.style.outline="none",this.style.display="none")}_openedChanged(e){this._ensureAria(e),this.isAttached&&(this.__isAnimating=!0,this.__deraf("__openedChanged",this.__openedChanged))}_ensureAria(e){void 0===e&&(e=this.opened),e?this.removeAttribute("aria-hidden"):this.setAttribute("aria-hidden","true")}_canceledChanged(){this.closingReason=this.closingReason||{},this.closingReason.canceled=this.canceled}_withBackdropChanged(){this.withBackdrop&&!this.hasAttribute("tabindex")?(this.setAttribute("tabindex","-1"),this.__shouldRemoveTabIndex=!0):this.__shouldRemoveTabIndex&&(this.removeAttribute("tabindex"),this.__shouldRemoveTabIndex=!1),this.opened&&this.isAttached&&this._manager.trackBackdrop()}_prepareRenderOpened(){this.__restoreFocusNode=this._manager.deepActiveElement,this._preparePositioning(),this.refit(),this._finishPositioning(),this.noAutoFocus&&document.activeElement===this._focusNode&&(this._focusNode.blur(),this.__restoreFocusNode.focus())}_renderOpened(){this._finishRenderOpened()}_renderClosed(){this._finishRenderClosed()}_finishRenderOpened(){this.notifyResize(),this.__isAnimating=!1;const e={bubbles:!0,composed:!0};this.dispatchEvent(new CustomEvent("opened",e)),this.dispatchEvent(new CustomEvent("overlay-opened",e)),this.dispatchEvent(new CustomEvent("iron-overlay-opened",e))}_finishRenderClosed(){this.style.display="none",this.style.zIndex="",this.notifyResize(),this.__isAnimating=!1;const e={bubbles:!0,composed:!0,detail:this.closingReason};this.dispatchEvent(new CustomEvent("closed",e)),this.dispatchEvent(new CustomEvent("overlay-closed",e)),this.dispatchEvent(new CustomEvent("iron-overlay-closed",e))}_preparePositioning(){this.style.transition=this.style.webkitTransition="none",this.style.transform=this.style.webkitTransform="none",this.style.display=""}_finishPositioning(){this.style.display="none";let{scrollTop:e}=this;this.scrollTop=void 0,this.scrollTop=e,this.style.transition=this.style.webkitTransition="",this.style.transform=this.style.webkitTransform="",this.style.display="",e=this.scrollTop,this.scrollTop=void 0,this.scrollTop=e}_applyFocus(){if(this.opened)this.noAutoFocus||this._focusNode.focus();else{if(this.restoreFocusOnClose&&this.__restoreFocusNode){const e=this._manager.deepActiveElement;(e===document.body||this.shadowRoot.contains(e)||this.contains(e))&&this.__restoreFocusNode.focus()}this.__restoreFocusNode=null,this._focusNode.blur(),this._focusedChild=null}}_onCaptureClick(e){this.noCancelOnOutsideClick||this.cancel(e)}_onCaptureFocus(e){if(!this.withBackdrop)return;const t=e.composedPath&&e.composedPath()||e.path;-1===t.indexOf(this)?(e.stopPropagation(),this._applyFocus()):this._focusedChild=t[0]}_onCaptureEsc(e){this.noCancelOnEscKey||this.cancel(e)}_onCaptureTab(e){if(!this.withBackdrop)return;this.__ensureFirstLastFocusables();const t=e.shiftKey,o=t?this.__firstFocusableNode:this.__lastFocusableNode,i=t?this.__lastFocusableNode:this.__firstFocusableNode;let r=!1;if(o===i)r=!0;else{const e=this._manager.deepActiveElement;r=e===o||e===this}r&&(e.preventDefault(),this._focusedChild=i,this._applyFocus())}_onIronResize(){this.opened&&!this.__isAnimating&&this.__deraf("refit",this.refit)}_onNodesChange(){this.opened&&!this.__isAnimating&&(this.invalidateTabbables(),this.notifyResize())}__ensureFirstLastFocusables(){const e=this._focusableNodes;this.__firstFocusableNode=e[0],this.__lastFocusableNode=e[e.length-1]}__openedChanged(){this.opened?(this._prepareRenderOpened(),this._manager.addOverlay(this),this._applyFocus(),this._renderOpened()):(this._manager.removeOverlay(this),this._applyFocus(),this._renderClosed())}__deraf(e,t){const o=this.__rafs;null!==o[e]&&cancelAnimationFrame(o[e]),o[e]=requestAnimationFrame(function(){o[e]=null,t.call(this)}.bind(this))}__updateScrollObservers(e,t,o){e&&t&&this.__isValidScrollAction(o)?("lock"===o&&(this.__saveScrollPosition(),this,Mo.indexOf(this)>=0||(0===Mo.length&&function(){Ao=Ao||To.bind(void 0);for(let e=0,t=zo.length;e<t;e++)document.addEventListener(zo[e],Ao,{capture:!0,passive:!1})}(),Mo.push(this),So=Mo[Mo.length-1],Do=[],Bo=[])),this.__addScrollListeners()):(function(e){const t=Mo.indexOf(e);-1!==t&&(Mo.splice(t,1),So=Mo[Mo.length-1],Do=[],Bo=[],0===Mo.length&&function(){for(let e=0,t=zo.length;e<t;e++)document.removeEventListener(zo[e],Ao,{capture:!0,passive:!1})}())}(this),this.__removeScrollListeners())}__addScrollListeners(){if(!this.__rootNodes){this.__rootNodes=[];let e=this;for(;e;)e.nodeType===Node.DOCUMENT_FRAGMENT_NODE&&e.host&&this.__rootNodes.push(e),e=e.host||e.assignedSlot||e.parentNode;this.__rootNodes.push(document)}this.__rootNodes.forEach((e=>{e.addEventListener("scroll",this.__onCaptureScroll,{capture:!0,passive:!0})}))}__removeScrollListeners(){this.__rootNodes&&this.__rootNodes.forEach((e=>{e.removeEventListener("scroll",this.__onCaptureScroll,{capture:!0,passive:!0})})),this.isAttached||(this.__rootNodes=null)}__isValidScrollAction(e){return"lock"===e||"refit"===e||"cancel"===e}__onCaptureScroll(e){if(!(this.__isAnimating||(e.composedPath&&e.composedPath()||e.path).indexOf(this)>=0))switch(this.scrollAction){case"lock":this.__restoreScrollPosition();break;case"refit":this.__deraf("refit",this.refit);break;case"cancel":this.cancel(e)}}__saveScrollPosition(){document.scrollingElement?(this.__scrollTop=document.scrollingElement.scrollTop,this.__scrollLeft=document.scrollingElement.scrollLeft):(this.__scrollTop=Math.max(document.documentElement.scrollTop,document.body.scrollTop),this.__scrollLeft=Math.max(document.documentElement.scrollLeft,document.body.scrollLeft))}__restoreScrollPosition(){document.scrollingElement?(document.scrollingElement.scrollTop=this.__scrollTop,document.scrollingElement.scrollLeft=this.__scrollLeft):(document.documentElement.scrollTop=document.body.scrollTop=this.__scrollTop,document.documentElement.scrollLeft=document.body.scrollLeft=this.__scrollLeft)}}return t}));class Lo extends(Ro(se)){static get styles(){return ie`
      :host {
        background: transparent;
      }
    `}render(){return V` <slot></slot> `}firstUpdated(){this.addEventListener("closed",(e=>{e.stopImmediatePropagation()})),this.addEventListener("opened",(e=>{e.stopImmediatePropagation()}))}}customElements.define("sh-overlay",Lo),customElements.define("sh-scrollpicker",class extends se{static get properties(){return{items:{type:Array},visible:{type:Boolean,reflect:!0},values:{type:Array,reflect:!0},scrollerStyles:{type:Array,reflect:!0},scroll:{type:Boolean,reflect:!0}}}static get styles(){return[ie`
        :host * {
          box-sizing: border-box;
        }
        .main-container {
          height: 12.5rem;
          position: relative;
          transition: 0s all linear !important;
        }
        .scrollers-container {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          height: 100%;
          transition: 0s all linear !important;
        }
        .scroll-container {
          height: 100%;
          overflow-y: auto;
          scroll-snap-type: y mandatory;
          transition: 0s all linear !important;
          scroll-behavior: smooth;
          scrollbar-width: none;
          width: fit-content;
        }
        .scroll-container::-webkit-scrollbar {
          display: none;
        }
        .row {
          height: 2.5rem;
          width: 3.25rem;
          font: var(--body-1);
          color: var(--text-secondary);
          display: flex;
          justify-content: center;
          align-items: center;
          scroll-snap-align: start;
          box-sizing: border-box;
          word-break: keep-all;
          padding: 0.5rem 1rem;
          transition: 0s all linear !important;
        }
        .selector {
          position: absolute;
          top: 5rem;
          border-top-color: rgba(var(--ui-1), var(--opacity-6));
          border-bottom-color: rgba(var(--ui-1), var(--opacity-6));
          border-left-color: transparent;
          border-right-color: transparent;
          border-style: solid;
          border-width: 0.0625rem;
          height: 2.5rem;
          width: 100%;
          box-sizing: border-box;
          pointer-events: none;
          transition: 0s all linear !important;
        }
        .row.selected {
          color: var(--text-primary);
        }
        .row.no-click {
          width: 100%;
          padding: 0;
        }
      `]}constructor(){super(),this.items=[],this.scrollerStyles=[],this.values=[],this.rowClicklistener={handleEvent(e){e.target.previousElementSibling.previousElementSibling.scrollIntoView({behavior:"smooth"})},passive:!0},this.values=[],this._previousValues=[]}connectedCallback(){super.connectedCallback(),this.resizeObserver=new ResizeObserver((()=>{this.requestUpdate()})),this.resizeObserver.observe(this),et.enable()}render(){return V`<sh-drawer
      position="bottom"
      class="point5-vertical-padding initial-slide-on-connect"
      .visible="${this.visible}"
      @transitionend="${e=>{e.target.visible||(this.visible=!1)}}"
      ><div class="main-container">
        <div class="selector"></div>
        <div class="scrollers-container">${this._getScrollerDOM()}</div>
      </div></sh-drawer
    >`}updated(e){super.updated(e),he(this,e,["visible","scroll"]),e.has("values")&&this.values&&this.values.length>0&&JSON.stringify(this._previousValues)!==JSON.stringify(this.values)&&(this._previousValues=this.values,le(this,"values-changed")),e.has("scroll")&&this.scroll&&this.scrollToValues()}disconnectedCallback(){this.resizeObserver.disconnect(),super.disconnectedCallback()}async scrollToValues(e=this.values){e.length!==this.items.length&&console.warn("Items and values array should have same length"),await this.updateComplete,this._scrollAllScrollersToValues(e),this.scroll=!1}_getScrollerDOM(){let e=[];if(this.items&&this.items.length>0){for(let t=0;t<this.items.length;t++){const o=this.items[t];e.push(V`<div
          class="scroll-container"
          @scroll="${e=>{this._scrollerScrollTasks(e)}}"
        >
          <div class="row no-click"></div>
          <div class="row no-click"></div>
          ${this._getScrollDOMArray(o,t)}
          <div class="row no-click"></div>
          <div class="row no-click"></div>
        </div>`)}return e}}_scrollerScrollTasks(e){clearTimeout(e.target._scrollCorrectTimeout);const t=e.target;t.setAttribute("is-scrolling",""),t._scrollCorrectTimeout=setTimeout(this._scrollerScrollEndTasks.bind(this),300,t)}_setScrollerSelectedValue(e){const t=Array.from(e.parentNode.children).indexOf(e),o=e.scrollTop,i=Te(2.5);e._selectedValue=this.items[t][Math.round(o/i)]}_updateValues(){const e=Array.from(this.shadowRoot.querySelector(".scrollers-container").children),t=[];for(let o=0;o<e.length;o++){const i=e[o];this._setScrollerSelectedValue(i),t[o]=i._selectedValue}t.join("")!==this.values.join("")&&(this.values=t)}_scrollerScrollEndTasks(e){const t=e.scrollTop,o=Te(2.5);this._scrollerHasNotStoppedAtMiddle(t,o)?this._nudgeScroller(e,t):(e.removeAttribute("is-scrolling"),e.blur(),this._hasAllScrollersStopped()&&this._updateValues())}_nudgeScroller(e,t){e.scrollTop=t}_scrollerHasNotStoppedAtMiddle(e,t){return e%t!=0}_hasAllScrollersStopped(){const e=Array.from(this.shadowRoot.querySelector(".scrollers-container").children);let t=0;for(let o=0;o<e.length;o++)if(e[o].hasAttribute("is-scrolling")){++t;break}return 0===t}_scrollAllScrollersToValues(e){const t=Array.from(this.shadowRoot.querySelector(".scrollers-container").children);let o=0;for(let i=0;i<e.length;i++){const r=2.5,s=e[i],n=this._getValueIndexForColumn(i,s)*Te(r),a=t[i];a.scrollTop!==n?this._setScrollerScrollTop(n,a):++o}o===t.length&&this._updateValues()}_getValueIndexForColumn(e,t){return this.items[e].indexOf(t)}_setScrollerScrollTop(e,t){t.scrollTop=e}_getScrollDOMArray(e,t){const o=e.length,i=[];for(let r=0;r<o;r++)i.push(V`<div
          class="row
            ${this.values[t]&&this.values[t]===e[r]?" selected":""}"
          @click="${this.rowClicklistener}"
          data-value="${e[r]}"
          style="${this.scrollerStyles[t]?this.scrollerStyles[t]:""}"
        >
          ${e[r]}
        </div>`);return i}});class Po{static getFormattedDate(e,t,o,i){let r=this.insertSeperator(o,t);return t.includes("MMM")?r=r.replace("MMM",this._getFormattedPart(e,"MMM",i)):t.includes("MM")?r=r.replace("MM",this._getFormattedPart(e,"MM","en")):t.includes("M")&&(r=r.replace("M",this._getFormattedPart(e,"M","en"))),t.includes("DD")?r=r.replace("DD",this._getFormattedPart(e,"DD","en")):t.includes("D")&&(r=r.replace("D",this._getFormattedPart(e,"D","en"))),t.includes("YYYY")?r=r.replace("YYYY",this._getFormattedPart(e,"YYYY","en")):t.includes("YY")&&(r=r.replace("YY",this._getFormattedPart(e,"YY","en"))),r}static isValidDate(e,t,o,i,r){let s=!1;const n=this.insertSeperator(o,t);if(this._hastheSameSeperatorCount(e,n,o)&&this._hasSameNoOfParts(e,n,o)){const t=this._validateAndGetParts(e,n,o,i);if(!t.find((e=>!e.isValid))){const e=this._extractDateFromParts(t,r),{year:o,month:i}=this._extractActualParts(t,r);s=e.getMonth()===i&&e.getFullYear()===o}}return s}static insertSeperator(e,t){let o=t[0];for(let i=0;i<t.length;)if(o!==t[i]&&i!==t.length){let r=t.split("");r=[...r.slice(0,i),e,...r.slice(i)],t=r.join(""),i+=e.length,o=t[i]}else++i;return t}static isValueValid(e,t,o,i,r,s,n,a,c,l){let h,d,p,u=!1,m=this.insertSeperator(o,i);if(t){const[t,r]=this.extractFromToParts(e,o,m),s=Boolean(t)&&this.isValidDate(t,i,o,l,n),a=Boolean(r)&&this.isValidDate(r,i,o,l,n);s&&a&&(u=!0,h=this.parseDate(t,m,o,l,n),d=this.parseDate(r,m,o,l,n),h.getTime()>d.getTime()&&(u=!1))}else this.isValidDate(e,i,o,l,n)&&(p=this.parseDate(e,m,o,l,n),u=!0);if(t&&u){const e=this._isDisabledDate(h,n,r,s,a,c),t=this._isDisabledDate(d,n,r,s,a,c);(e||t)&&(u=!1)}else!t&&u&&this._isDisabledDate(p,n,r,s,a,c)&&(u=!1);return u}static parseDate(e,t,o,i,r){const s=this._validateAndGetParts(e,t,o,i);return this._extractDateFromParts(s,r)}static parseRangeDates(e,t,o,i,r){const[s,n]=this.extractFromToParts(e,o,t);return[this.parseDate(s,t,o,i,r),this.parseDate(n,t,o,i,r)]}static extractFromToParts(e,t,o){let i="",r="";if("-"===t){let t=-1,s=0;const n=this._getOccurenceCount(o,"-")+1;for(let o=0;o<e.length;o++)if("-"===e[o]&&++s,s===n){t=o;break}-1!==t&&(i=e.substring(0,t),r=e.substring(t+1))}else{const t=e.split("-");i=t[0],r=t[1]}return[i,r]}static getMonthIndex(e,t){return new Array(12).fill("_").map(((e,o)=>this.getShortMonthName(o,t))).indexOf(e)}static getShortMonthName(e,t="en"){t=t||"en";let o=this._getMonthDateDict()[e].toLocaleString(t,{month:"short"});return o=o[0].toLocaleUpperCase(t)+o.slice(1),o}static getWeekDays(e,t="en"){let o="en"===(t=t||"en")||"de"===t||"es"===t||"fr"===t?"short":"narrow",i=new Array(7).fill("_");i=i.map(((e,t)=>new Date(2022,4,t+1,0,0,0,0)));let r=i[e].toLocaleString(t,{weekday:o});return r=r[0].toLocaleUpperCase(t)+r.slice(1),r}static _getFormattedPart(e,t,o){let i;switch(t){case"D":i={day:"numeric"};break;case"DD":i={day:"2-digit"};break;case"M":i={month:"numeric"};break;case"MM":i={month:"2-digit"};break;case"MMM":i={month:"short"};break;case"YYYY":i={year:"numeric"};break;case"YY":i={year:"2-digit"}}let r=e.toLocaleString(o,i);return"MMM"===t&&(r=r[0].toLocaleUpperCase(o)+r.slice(1)),r}static _getOccurenceCount(e,t){let o=0,i="*";t.includes("*")&&(i="$");const r=e.replaceAll(t,i);for(let e=0;e<r.length;e++)r[e]===i&&++o;return o}static _hastheSameSeperatorCount(e,t,o){return this._getOccurenceCount(t,o)===this._getOccurenceCount(e,o)}static _hasSameNoOfParts(e,t,o){const i=e.split(o),r=t.split(o);return i.length===r.length}static _extractVariousData(e,t,o){const i=e.split(o),r=t.split(o);let s={};return r.forEach(((e,t)=>{s[e]=i[t]})),s}static _isOfCorrectLengthAndNumber(e,t){return e.length===t&&Number.isInteger(Number(e))}static _validateAndGetPart(e,t,o){let i,r,s=!1;switch(e){case"M":case"D":case"YY":case"YYYY":case"MM":case"DD":if("M"===e||"D"===e?Number.isInteger(Number(t)):this._isOfCorrectLengthAndNumber(t,e.length))switch(i=Number(t),e[0]){case"D":s=i>=1&&i<=31,r="date";break;case"M":s=i>=1&&i<=12,i-=1,r="month";break;case"Y":if("YYYY"===e)s=i>=1e3&&i<=9999;else if("YY"===e){s=!0;const e=(new Date).getFullYear(),o="20",r=Number(`19${t}`),n=Number(`${o}${t}`);i=Math.min(Math.abs(n-e),Math.abs(r-e))===Math.abs(n-e)?n:r}r="year"}break;case"MMM":{const e=this._getMonthDateDict().map((e=>e.toLocaleString(o,{month:"long"}).toLocaleLowerCase(o))),n=this._getMonthDateDict().map((e=>e.toLocaleString(o,{month:"short"}).toLocaleLowerCase(o))),a=e.map(((e,i)=>{if(Boolean(t)&&e.startsWith(t.toLocaleLowerCase(o)))return{monthName:e,monthIndex:i}})).filter((e=>void 0!==e)),c=n.map(((e,i)=>{if(Boolean(t)&&e.startsWith(t.toLocaleLowerCase(o)))return{monthName:e,monthIndex:i}})).filter((e=>void 0!==e));s=a.length>0||c.length>0,s&&(i=a.length>0?a[0].monthIndex:c[0].monthIndex,r="month")}}return{isValid:s,value:i,part:r}}static _validateAndGetParts(e,t,o,i){return Object.entries(this._extractVariousData(e,t,o)).map((e=>{const t=e[0],o=e[1];return this._validateAndGetPart(t,o,i)}))}static _isDisabledDate(e,t,o,i,r,s){const n=e.getTime(),a=t.getTime();let c=Boolean(o)&&n>a||Boolean(i)&&n<a;if(!c){if(this.isValidDate(r,"YYYYMMDD","-","en",t)){const t=Number(r.split("-")[0]),o=Number(r.split("-")[1]-1),i=Number(r.split("-")[2]),s=new Date(t,o,i,0,0,0,0);e.getTime()<s.getTime()&&(c=!0)}if(this.isValidDate(s,"YYYYMMDD","-","en",t)){const t=Number(s.split("-")[0]),o=Number(s.split("-")[1]-1),i=Number(s.split("-")[2]),r=new Date(t,o,i,0,0,0,0);e.getTime()>r.getTime()&&(c=!0)}}return c}static _extractDateFromParts(e,t){const{year:o,month:i,date:r}=this._extractActualParts(e,t);return new Date(o,i,r,0,0,0,0)}static _extractActualParts(e,t){const o=e.find((e=>"date"===e.part)),i=e.find((e=>"month"===e.part)),r=e.find((e=>"year"===e.part)),s=o?o.value:t.getDate(),n=i?i.value:t.getMonth();return{year:r?r.value:t.getFullYear(),month:n,date:s}}static _getMonthDateDict(){let e=new Array(12).fill("_");return e=e.map(((e,t)=>new Date(2022,t,1,0,0,0,0))),e}}class Oo{constructor(e){this.classes=new Set,this.changed=!1,this.element=e;const t=(e.getAttribute("class")||"").split(/\s+/);for(const e of t)this.classes.add(e)}add(e){this.classes.add(e),this.changed=!0}remove(e){this.classes.delete(e),this.changed=!0}commit(){if(this.changed){let e="";this.classes.forEach((t=>e+=t+" ")),this.element.setAttribute("class",e)}}}const No=new WeakMap,Fo=b((e=>t=>{if(!(t instanceof M)||t instanceof R||"class"!==t.committer.name||t.committer.parts.length>1)throw new Error("The `classMap` directive must be used in the `class` attribute and must be the only part in the attribute.");const{committer:o}=t,{element:i}=o;let r=No.get(t);void 0===r&&(i.setAttribute("class",o.strings.join(" ")),No.set(t,r=new Set));const s=i.classList||new Oo(i);r.forEach((t=>{t in e||(s.remove(t),r.delete(t))}));for(const t in e){const o=e[t];o!=r.has(t)&&(o?(s.add(t),r.add(t)):(s.remove(t),r.delete(t)))}"function"==typeof s.commit&&s.commit()}));class $o{constructor(){this.date=null,this.isOtherMonthDay=!1,this.isSelected=!1,this.isToday=!1,this.isWithinRange=!1,this.isDisabled=!1}}function Io(e,t,o,i=[],r=!1,s=!1,n=null,a=null,c=0){const l=[],h=new Date(t,e,1,0,0,0,0).getDay(),d=new Date(t,e,0===h&&1===c?-5:1-h+c,0,0,0,0);for(let t=0;t<42;t++){const t=new $o;t.date=new Date(JSON.parse(JSON.stringify(d))),t.isOtherMonthDay=t.date.getMonth()!==e,t.isDisabled=Vo(d,o,r,s,n,a),t.isOtherMonthDay||t.isDisabled||(t.isSelected=2===i.length?t.date.getTime()===i[0].getTime()||t.date.getTime()===i[1].getTime():1===i.length&&t.date.getTime()===i[0].getTime(),t.isToday=t.date.getTime()===o.getTime(),t.isWithinRange=2===i.length&&t.date.getTime()>=i[0].getTime()&&t.date.getTime()<=i[1].getTime()),l.push(t),d.setDate(d.getDate()+1)}return l}function Vo(e,t,o,i,r,s){const n=e.getTime(),a=t.getTime();let c=Boolean(o)&&n>a||Boolean(i)&&n<a;return!c&&r&&e.getTime()<r.getTime()&&(c=!0),!c&&s&&e.getTime()>s.getTime()&&(c=!0),c}const Ho=e=>class extends e{static get properties(){return{_setHostFocus:{type:Boolean,reflect:!0,attribute:"set-host-focus"}}}static get styles(){return ie`
        :host([set-host-focus]:not(.item-focused)),
        .focus-item:not(.item-focused) {
          outline: none;
        }
        :host(.item-focused:not(.touch-device)),
        :host(:not(.touch-device)) *.item-focused {
          outline: var(--focus-outline) !important;
          outline-offset: -0.125rem;
        }
      `}constructor(){super(),this._setHostFocus=!0}connectedCallback(){super.connectedCallback(),this._keyUpListener=this._keyUpCallBack.bind(this),this._shadowFocusOutListener=this._shadowFocusOutCallBack.bind(this),this.addEventListener("keyup",this._keyUpListener),this.shadowRoot.addEventListener("focusout",this._shadowFocusOutListener),this._setHostFocus&&(this.focusOutListener=this.focusOutCallBack.bind(this),this.addEventListener("focusout",this.focusOutListener))}disconnectedCallback(){this.removeEventListener("keyup",this._keyUpListener),this.shadowRoot.removeEventListener("focusout",this._shadowFocusOutListener),this.removeEventListener("focusout",this.focusOutListener),super.disconnectedCallback()}_keyUpCallBack(e){const t=e.keyCode===me.ENTER,o=e.keyCode===me.TAB,i=this.shadowRoot.activeElement;let r;if(t||o){if(i){const t=this.shadowRoot.querySelectorAll(".focus-item");r=Array.from(t).find((t=>e.composedPath()[0]===t)),this.classList.remove("item-focused")}else this._setHostFocus&&e.composedPath()[0]===this&&(r=this);r&&t?this._enterKeyAction(r):r&&o&&r.classList.add("item-focused")}}_shadowFocusOutCallBack(){const e=this.shadowRoot.querySelector(".item-focused");e&&e.classList.remove("item-focused")}focusOutCallBack(){this.classList.remove("item-focused")}_enterKeyAction(e){}};class Wo extends(Ho(se)){static get properties(){return{month:{type:Number},year:{type:Number},months:{type:Number},range:{type:Boolean},futureDateDisable:{type:Boolean},pastDateDisable:{type:Boolean},todaysDate:{type:Object},selectedDates:{type:Array},minDate:{type:Object},maxDate:{type:Object},responsive:{type:Boolean,reflect:!0},locale:{type:String},_calendarDatas:{type:Array},_monthYearDatas:{type:Array}}}static get styles(){return[super.styles,ae,ie`
        .months {
          display: flex;
          flex-direction: row;
          grid-gap: 0.5rem;
          background-color: var(--base-4);
          width: fit-content;
          box-shadow: var(--shadow-overlay);
          overflow: hidden;
        }
        .date-panel {
          display: block;
          width: 18rem;
          box-sizing: border-box;
          padding: 1rem 0.5rem 0.5rem 0.5rem;
          display: flex;
          flex-direction: column;
          height: 21rem;
        }
        .header-area {
          height: 2rem;
          box-sizing: border-box;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          overflow: hidden;
        }
        .month-and-year-display {
          width: 9.375rem;
          border-radius: 1rem;
          font: var(--title-1);
          color: var(--text-primary);
          text-align: center;
          line-height: 2rem;
          box-sizing: border-box;
          cursor: pointer;
          transition: var(--hover-transition-time) background;
        }
        :host(:not(.touch-device)) .month-and-year-display:hover {
          background-color: rgba(var(--ui-1), var(--opacity-7));
        }
        .date-grid {
          display: grid;
          grid-template-rows: 2rem;
          grid-template-columns: repeat(7, 2rem);
          grid-gap: 0.5rem;
          margin-top: 0.5rem;
          box-sizing: border-box;
        }
        .week-day-name {
          line-height: 2rem;
          text-align: center;
          font: var(--title-2);
          color: var(--text-primary);
          line-height: 2rem;
          box-sizing: border-box;
        }
        .date {
          line-height: 2rem;
          text-align: center;
          font: var(--body-1);
          color: var(--text-primary);
          line-height: 2rem;
          border-radius: 1rem;
          box-sizing: border-box;
          cursor: pointer;
          height: 2rem;
          width: 2rem;
          display: inline-block;
          outline: none;
          transition: var(--hover-transition-time) background;
        }
        .date::empty {
          height: 0;
          width: 0;
        }
        :host(:not(.touch-device)) .date:hover:not(.selected) {
          background-color: rgba(var(--ui-1), var(--opacity-7));
        }
        .date.selected:not(.other-month):not(.disabled) {
          background-color: rgb(var(--ui-3), var(--opacity-1)) !important;
          font: var(--title-1);
          color: var(--text-white);
          line-height: 2rem;
        }
        .date.within-range:not(.selected):not(.disabled) {
          background-color: rgba(var(--ui-1), var(--opacity-7));
        }
        .date.today:not(.other-month):not(.selected):not(.disabled) {
          font: var(--title-1);
          color: var(--text-highlight);
          line-height: 2rem;
        }
        .date.other-month:not(.disabled) {
          color: var(--text-disabled);
        }
        .date.disabled {
          color: var(--text-disabled);
          pointer-events: none;
        }
        .icon-dummy {
          width: 2rem;
          height: 2rem;
        }
        :host([responsive]) .date-panel {
          padding: 0;
          width: auto;
        }
        :host([responsive]) .header-area {
          height: 1.5rem;
          align-items: center;
        }
        :host([responsive]) .date-grid {
          gap: 0.75rem;
          margin-top: 1rem;
        }
        :host([responsive]) .months {
          justify-content: center;
          width: 100%;
          box-shadow: none;
          background-color: transparent;
        }
        :host {
          display: block;
        }
      `]}constructor(){super(),this.selectedDates=[],this._calendarDatas=[],this._monthYearDatas=[]}render(){return V`<div class="months">
      ${this._calendarDatas.map(((e,t)=>V`<div class="date-panel">
            <div class="header-area">
              ${0===t?V`<sh-icon
                    icon="arrow-left-s"
                    size="m"
                    button
                    @click="${()=>{--this.month,this.generateCalendarDatas()}}"
                  ></sh-icon>`:V`<div class="icon-dummy"></div>`}
              <div
                class="month-and-year-display focus-item"
                @click="${()=>{le(this,"month-header-clicked",{clickedYear:this._monthYearDatas[t][1]})}}"
                tabindex="0"
              >
                ${this._getMonthYearHeader(this._monthYearDatas[t])}
              </div>
              ${t===this._calendarDatas.length-1?V`<sh-icon
                    icon="arrow-right-s"
                    size="m"
                    button
                    @click="${()=>{++this.month,this.generateCalendarDatas()}}"
                  ></sh-icon>`:V`<div class="icon-dummy"></div>`}
            </div>
            <div class="date-grid">
              ${new Array(7).fill("_").map(((e,t)=>{const o="de"===this.locale||"es"===this.locale||"zh"===this.locale||"fr"===this.locale?1:0,i=t+o<7?t+o:0;return V`<span class="week-day-name"
                  >${Po.getWeekDays(i,this.locale)}</span
                >`}))}
              ${e.map((e=>V`<span
                    class="${Fo(this._getComputedClasses(e))}"
                    @click="${()=>{this._addToSelectedDates(e.date,e)}}"
                    tabindex="${e.isDisabled?"-1":"0"}"
                    @mouseover="${()=>{this.range&&1===this.selectedDates.length&&this._hoverActions(e.date)}}"
                    >${e.date.getDate()}</span
                  >`))}
            </div>
          </div>`))}
    </div>`}connectedCallback(){super.connectedCallback(),ue.isTouchDevice()?this.classList.add("touch-device"):this.setAttribute("tabindex",0)}updated(e){super.updated(e),e.has("selectedDates")&&0!==this.selectedDates.length&&le(this,"selected-dates-changed")}generateCalendarDatas(){this.month>11&&(this.month=0,++this.year),this.month<0&&(this.month=11,--this.year);let e=this.month,t=this.year,o=[],i=[];for(let r=0;r<this.months;r++)i.push([e,t]),o.push(Io(e,t,this.todaysDate,this.selectedDates,this.futureDateDisable,this.pastDateDisable,this.minDate,this.maxDate,"de"===this.locale||"es"===this.locale||"zh"===this.locale||"fr"===this.locale?1:0)),++e,12===e&&(e=0,++t);this._calendarDatas=o,this._monthYearDatas=i}_getComputedClasses(e){return{date:!0,"other-month":e.isOtherMonthDay,disabled:e.isDisabled,today:e.isToday,selected:e.isSelected,"within-range":e.isWithinRange,"focus-item":!0}}_addToSelectedDates(e,t){let o=this.selectedDates;if(!this.range)return this._clearAllData(),this.selectedDates=[e],this._updateSelectedDate(e),void le(this,"ready-to-update-value",{selectedDates:this.selectedDates},!0);if(o.length<2){if(o.push(e),this._updateSelectedDate(e),2===o.length)return o.sort(((e,t)=>e.getTime()-t.getTime())),this.selectedDates=o,void le(this,"ready-to-update-value",{selectedDates:this.selectedDates},!0);1===o.length&&this._switchViewIfDateIsOutsideView(e)}else if(2===o.length)return this.selectedDates=[],this._clearAllData(),void this._addToSelectedDates(e,t);this.range&&2!==o.length&&(this.selectedDates=o,this.requestUpdate())}_switchViewIfDateIsOutsideView(e){const t=JSON.parse(JSON.stringify(this._monthYearDatas[0])).reverse(),o=JSON.parse(JSON.stringify(this._monthYearDatas[this._monthYearDatas.length-1])).reverse(),i=this._getDayCountforMonthYear(o[1],o[0]),r=new Date(...t,1,0,0,0,0),s=new Date(...o,i,0,0,0,0),n=e.getTime()<r.getTime(),a=e.getTime()>s.getTime();(n||a)&&(n?this.shadowRoot.querySelector('sh-icon[icon="arrow-left-s"]').click():this.shadowRoot.querySelector('sh-icon[icon="arrow-right-s"]').click())}_hoverActions(e){const t=this._updateWithinRangeCalendarData(this._calendarDatas,this.selectedDates[0],e);this._calendarDatas=t}_extractNewCalendarDatas(e){const t=e.length/42;let o=0;const i=[];for(let r=0;r<t;r++){const t=[],r=o+41;for(let i=o;i<=r;i++)t.push(e[i]),++o;i.push(t)}return i}_clearAllData(){let e=this._calendarDatas.flat();e.map((e=>e.isWithinRange=!1)),e.map((e=>e.isSelected=!1));const t=this._extractNewCalendarDatas(e);this._calendarDatas=t}_updateSelectedDate(e){let t=this._calendarDatas.flat(),o=t.findIndex((t=>t.date.getTime()===e.getTime()&&!t.isOtherMonthDay));-1!==o&&(t[o].isSelected=!0);const i=this._extractNewCalendarDatas(t);this._calendarDatas=i,this.requestUpdate()}_updateWithinRangeCalendarData(e,t,o){o.getTime()>t.getTime()?(this.fromDate=t,this.toDate=o):(this.fromDate=o,this.toDate=t);let i=e.flat();i.map((e=>e.isWithinRange=!1));let r=i.findIndex((e=>e.date.getTime()===this.fromDate.getTime()&&!e.isOtherMonthDay));r=-1===r?0:r;let s=i.findIndex((e=>e.date.getTime()===this.toDate.getTime()&&!e.isOtherMonthDay));s=-1===s?i.length-1:s;for(let e=r;e<=s;e++){const t=i[e];t.isOtherMonthDay||(t.isWithinRange=!0)}return this._extractNewCalendarDatas(i)}_getDayCountforMonthYear(e,t){let o=0;for(let i=1;i<=31&&new Date(t,e,i,0,0,0,0).getMonth()===e;i++)++o;return o}_enterKeyAction(e){e!==this&&e.click()}_getMonthYearHeader(e){const t=e[0],o=e[1];let i=new Date(o,t,1,0,0,0,0).toLocaleString(this.locale,{month:"long",year:"numeric"});return i=i[0].toLocaleUpperCase(this.locale)+i.slice(1),i}}customElements.define("sh-private-date-selector",Wo);class qo{constructor(){this.date=null,this.isSelected=!1,this.isThisMonth=!1,this.isDisabled=!1}}function Yo(e,t,o=null,i=!1,r=!1,s=null,n=null){const a=[];for(let c=0;c<12;c++){const l=new qo;l.date=new Date(e,c,1,0,0,0,0),l.isDisabled=jo(l.date,t,i,r,s,n),l.isDisabled||(l.isSelected=Boolean(o)&&l.date.getTime()===o.getTime(),l.isThisMonth=l.date.getTime()===t.getTime()),a.push(l)}return a}function jo(e,t,o,i,r,s){const n=e.getTime(),a=t.getTime();let c=Boolean(o)&&n>a||Boolean(i)&&n<a;return!c&&r&&e.getTime()<r.getTime()&&(c=!0),!c&&s&&e.getTime()>s.getTime()&&(c=!0),c}class Uo extends(Ho(se)){static get properties(){return{months:{type:Number},year:{type:Number},futureDateDisable:{type:Boolean},pastDateDisable:{type:Boolean},todaysDate:{type:Object},selectedDate:{type:Object},responsive:{type:Boolean,reflect:!0},minDate:{type:Object},maxDate:{type:Object},locale:{type:String},_monthViewDatas:{type:Array},_yearDecadeDatas:{type:Array}}}static get styles(){return[super.styles,ae,ie`
        .months {
          display: flex;
          flex-direction: row;
          grid-gap: 0.5rem;
          background-color: var(--base-4);
          width: fit-content;
          box-sizing: border-box;
          box-shadow: var(--shadow-overlay);
          overflow: hidden;
        }
        .date-panel {
          display: block;
          width: 18rem;
          box-sizing: border-box;
          padding: 1rem 0.5rem 1.75rem 0.5rem;
          display: flex;
          flex-direction: column;
          height: 21rem;
        }
        .header-area {
          height: 1.5rem;
          box-sizing: border-box;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
        }
        .month-and-year-display {
          width: 4.5rem;
          border-radius: 1rem;
          font: var(--title-1);
          color: var(--text-primary);
          text-align: center;
          line-height: 2rem;
          box-sizing: border-box;
          cursor: pointer;
          height: 2rem;
        }
        :host(:not(.touch-device)) .month-and-year-display:hover {
          background-color: rgba(var(--ui-1), var(--opacity-7));
        }
        .date-grid {
          display: grid;
          grid-template-rows: repeat(4, 3rem);
          grid-template-columns: repeat(3, 4rem);
          grid-gap: 1rem;
          margin: 1.75rem 1.5rem 0rem 1.5rem;
          box-sizing: border-box;
          width: 14rem;
          align-items: center;
        }
        .month {
          font: var(--body-1);
          color: var(--text-primary);
          text-align: center;
          height: 2rem;
          line-height: 2rem;
          border-radius: 1rem;
          cursor: pointer;
          transition: var(--hover-transition-time) background;
        }
        :host(:not(.touch-device)) .month:hover:not(.selected) {
          background-color: rgba(var(--ui-1), var(--opacity-7));
        }
        .month.selected:not(.disabled) {
          background-color: rgb(var(--ui-3), var(--opacity-1)) !important;
          font: var(--title-1);
          color: var(--text-white);
          line-height: 2rem;
        }
        .month.today:not(.selected):not(.disabled) {
          font: var(--title-1);
          color: var(--text-highlight);
          line-height: 2rem;
        }
        .month.disabled {
          color: var(--text-disabled);
          pointer-events: none;
        }
        .icon-dummy {
          width: 2rem;
          height: 2rem;
        }
        :host([responsive]) .months {
          justify-content: center;
          width: 100%;
          box-shadow: none;
          background-color: transparent;
        }
        :host {
          display: block;
        }
      `]}constructor(){super(),this._monthViewDatas=[],this._yearDecadeDatas=[]}render(){return V`<div class="months">
      ${this._monthViewDatas.map(((e,t)=>V`<div class="date-panel">
            <div class="header-area">
              ${0===t?V`<sh-icon
                    icon="arrow-left-s"
                    button
                    size="m"
                    @click="${()=>{--this.year,this.generateMonthViewData()}}"
                  ></sh-icon>`:V`<div class="icon-dummy"></div>`}
              <div
                class="month-and-year-display focus-item"
                @click="${()=>{le(this,"year-header-clicked",{belongingDecade:this._yearDecadeDatas[t].year-this._yearDecadeDatas[t].year%10})}}"
                tabindex="0"
              >
                ${this._yearDecadeDatas[t].year}
              </div>
              ${t===this._monthViewDatas.length-1?V`<sh-icon
                    icon="arrow-right-s"
                    button
                    size="m"
                    @click="${()=>{++this.year,this.generateMonthViewData()}}"
                  ></sh-icon>`:V`<div class="icon-dummy"></div>`}
            </div>
            <div class="date-grid">
              <span
                class="${Fo(this._getComputedClasses(e[0]))}"
                @click="${()=>{le(this,"month-clicked",{clickedMonth:0,clickedYear:this._yearDecadeDatas[t].year})}}"
                tabindex="${e[0].isDisabled?"-1":"0"}"
              >
                ${Po.getShortMonthName(0,this.locale)}
              </span>
              <span
                class="${Fo(this._getComputedClasses(e[1]))}"
                @click="${()=>{le(this,"month-clicked",{clickedMonth:1,clickedYear:this._yearDecadeDatas[t].year})}}"
                tabindex="${e[1].isDisabled?"-1":"0"}"
              >
                ${Po.getShortMonthName(1,this.locale)}
              </span>
              <span
                class="${Fo(this._getComputedClasses(e[2]))}"
                @click="${()=>{le(this,"month-clicked",{clickedMonth:2,clickedYear:this._yearDecadeDatas[t].year})}}"
                tabindex="${e[2].isDisabled?"-1":"0"}"
              >
                ${Po.getShortMonthName(2,this.locale)}
              </span>
              <span
                class="${Fo(this._getComputedClasses(e[3]))}"
                @click="${()=>{le(this,"month-clicked",{clickedMonth:3,clickedYear:this._yearDecadeDatas[t].year})}}"
                tabindex="${e[3].isDisabled?"-1":"0"}"
              >
                ${Po.getShortMonthName(3,this.locale)}
              </span>
              <span
                class="${Fo(this._getComputedClasses(e[4]))}"
                @click="${()=>{le(this,"month-clicked",{clickedMonth:4,clickedYear:this._yearDecadeDatas[t].year})}}"
                tabindex="${e[4].isDisabled?"-1":"0"}"
              >
                ${Po.getShortMonthName(4,this.locale)}
              </span>
              <span
                class="${Fo(this._getComputedClasses(e[5]))}"
                @click="${()=>{le(this,"month-clicked",{clickedMonth:5,clickedYear:this._yearDecadeDatas[t].year})}}"
                tabindex="${e[5].isDisabled?"-1":"0"}"
              >
                ${Po.getShortMonthName(5,this.locale)}
              </span>
              <span
                class="${Fo(this._getComputedClasses(e[6]))}"
                @click="${()=>{le(this,"month-clicked",{clickedMonth:6,clickedYear:this._yearDecadeDatas[t].year})}}"
                tabindex="${e[6].isDisabled?"-1":"0"}"
              >
                ${Po.getShortMonthName(6,this.locale)}
              </span>
              <span
                class="${Fo(this._getComputedClasses(e[7]))}"
                @click="${()=>{le(this,"month-clicked",{clickedMonth:7,clickedYear:this._yearDecadeDatas[t].year})}}"
                tabindex="${e[7].isDisabled?"-1":"0"}"
              >
                ${Po.getShortMonthName(7,this.locale)}
              </span>
              <span
                class="${Fo(this._getComputedClasses(e[8]))}"
                @click="${()=>{le(this,"month-clicked",{clickedMonth:8,clickedYear:this._yearDecadeDatas[t].year})}}"
                tabindex="${e[8].isDisabled?"-1":"0"}"
              >
                ${Po.getShortMonthName(8,this.locale)}
              </span>
              <span
                class="${Fo(this._getComputedClasses(e[9]))}"
                @click="${()=>{le(this,"month-clicked",{clickedMonth:9,clickedYear:this._yearDecadeDatas[t].year})}}"
                tabindex="${e[9].isDisabled?"-1":"0"}"
              >
                ${Po.getShortMonthName(9,this.locale)}
              </span>
              <span
                class="${Fo(this._getComputedClasses(e[10]))}"
                @click="${()=>{le(this,"month-clicked",{clickedMonth:10,clickedYear:this._yearDecadeDatas[t].year})}}"
                tabindex="${e[10].isDisabled?"-1":"0"}"
              >
                ${Po.getShortMonthName(10,this.locale)}
              </span>
              <span
                class="${Fo(this._getComputedClasses(e[11]))}"
                @click="${()=>{le(this,"month-clicked",{clickedMonth:11,clickedYear:this._yearDecadeDatas[t].year})}}"
                tabindex="${e[11].isDisabled?"-1":"0"}"
              >
                ${Po.getShortMonthName(11,this.locale)}
              </span>
            </div>
          </div>`))}
    </div>`}connectedCallback(){super.connectedCallback(),ue.isTouchDevice()?this.classList.add("touch-device"):this.setAttribute("tabindex",0)}generateMonthViewData(){let e=this.year,t=[],o=[];for(let i=0;i<this.months;i++)t.push(Yo(e,this.todaysDate,this.selectedDate,this.futureDateDisable,this.pastDateDisable,this.minDate,this.maxDate)),o.push({year:e,decade:e-e%10}),++e;this._monthViewDatas=t,this._yearDecadeDatas=o}_getComputedClasses(e){return{month:!0,"focus-item":!0,today:e.isThisMonth,selected:e.isSelected,disabled:e.isDisabled}}_enterKeyAction(e){e!==this&&e.click()}}customElements.define("sh-private-month-selector",Uo);class Zo{constructor(){this.date=null,this.isSelected=!1,this.isThisYear=!1,this.isDisabled=!1}}function Ko(e,t,o=null,i=!1,r=!1,s=null,n=null){const a=[],c=e-1;for(let e=c;e<=c+11;e++){const c=new Zo;c.date=new Date(e,0,1,0,0,0,0),c.isDisabled=Go(c.date,t,i,r,s,n),c.isDisabled||(c.isSelected=Boolean(o)&&c.date.getTime()===o.getTime(),c.isThisYear=c.date.getTime()===t.getTime()),a.push(c)}return a}function Go(e,t,o,i,r,s){const n=e.getTime(),a=t.getTime();let c=Boolean(o)&&n>a||Boolean(i)&&n<a;return!c&&r&&e.getTime()<r.getTime()&&(c=!0),!c&&s&&e.getTime()>s.getTime()&&(c=!0),c}class Xo extends(Ho(se)){static get properties(){return{months:{type:Number},decade:{type:Number},todaysDate:{type:Object},selectedDate:{type:Object},futureDateDisable:{type:Boolean},pastDateDisable:{type:Boolean},minDate:{type:Object},maxDate:{type:Object},responsive:{type:Boolean,reflect:!0},_yearViewDatas:{type:Array}}}static get styles(){return[super.styles,ae,ie`
        .months {
          display: flex;
          flex-direction: row;
          grid-gap: 0.5rem;
          background-color: var(--base-4);
          width: fit-content;
          box-sizing: border-box;
          box-shadow: var(--shadow-overlay);
          overflow-x: hidden;
        }
        .date-panel {
          display: block;
          width: 18rem;
          box-sizing: border-box;
          padding: 1rem 0.5rem 1.75rem 0.5rem;
          display: flex;
          flex-direction: column;
          height: 21rem;
        }
        .header-area {
          height: 1.5rem;
          box-sizing: border-box;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
        }
        .month-and-year-display {
          font: var(--title-1);
          color: var(--text-primary);
          text-align: center;
          line-height: 1.5rem;
          box-sizing: border-box;
        }
        .date-grid {
          display: grid;
          grid-template-rows: repeat(4, 3rem);
          grid-template-columns: repeat(3, 4rem);
          grid-gap: 1rem;
          margin: 1.75rem 1.5rem 0rem 1.5rem;
          box-sizing: border-box;
          width: 14rem;
          align-items: center;
        }
        .icon-dummy {
          width: 2rem;
          height: 2rem;
        }
        .year {
          font: var(--body-1);
          color: var(--text-primary);
          text-align: center;
          height: 2rem;
          line-height: 2rem;
          border-radius: 1rem;
          cursor: pointer;
          transition: var(--hover-transition-time) background;
        }
        :host(:not(.touch-device)) .year:hover:not(.selected) {
          background-color: rgba(var(--ui-1), var(--opacity-7));
        }
        .year.selected:not(.other-decade):not(.disabled) {
          background-color: rgb(var(--ui-3), var(--opacity-1)) !important;
          font: var(--title-1);
          color: var(--text-white);
          line-height: 2rem;
        }
        .year.today:not(.other-decade):not(.selected):not(.disabled) {
          font: var(--title-1);
          color: var(--text-highlight);
          line-height: 2rem;
        }
        .year.other-decade:not(.disabled) {
          color: var(--text-disabled);
          pointer-events: none;
        }
        .year.disabled {
          color: var(--text-disabled);
          pointer-events: none;
        }
        .icon-dummy {
          width: 2rem;
          height: 2rem;
        }
        :host([responsive]) .months {
          justify-content: center;
          width: 100%;
          box-shadow: none;
          background-color: transparent;
        }
        :host {
          display: block;
        }
      `]}constructor(){super(),this.selectedDate=null,this.minDate=null,this.maxDate=null,this._yearViewDatas=[]}render(){return V`<div class="months">
      ${this._yearViewDatas.map(((e,t)=>V`<div class="date-panel">
          <div class="header-area">
            ${0===t?V`<sh-icon
                  icon="arrow-left-s"
                  size="m"
                  button
                  @click="${()=>{this.decade-=10,this.generateYearViewData()}}"
                ></sh-icon>`:V`<div class="icon-dummy"></div>`}
            <div class="month-and-year-display">
              ${e[1].date.getFullYear()} - ${e[10].date.getFullYear()}
            </div>
            ${t===this._yearViewDatas.length-1?V`<sh-icon
                  icon="arrow-right-s"
                  size="m"
                  button
                  @click="${()=>{this.decade+=10,this.generateYearViewData()}}"
                ></sh-icon>`:V`<div class="icon-dummy"></div>`}
          </div>
          <div class="date-grid">
            ${e.map(((e,t)=>V`<span
                  class="${Fo(this._getComputedClasses(e,t))}"
                  @click="${()=>{le(this,"year-clicked",{clickedYear:e.date.getFullYear()})}}"
                  tabindex="${e.isDisabled?"-1":"0"}"
                >
                  ${e.date.getFullYear()}
                </span>`))}
          </div>
        </div> `))}
    </div>`}connectedCallback(){super.connectedCallback(),ue.isTouchDevice()?this.classList.add("touch-device"):this.setAttribute("tabindex",0)}generateYearViewData(){let e=this.decade,t=[];for(let o=0;o<this.months;o++)t.push(Ko(e,this.todaysDate,this.selectedDate,this.futureDateDisable,this.pastDateDisable,this.minDate,this.maxDate)),e+=10;this._yearViewDatas=t}_getComputedClasses(e,t){return{year:!0,today:e.isThisYear,selected:e.isSelected,disabled:e.isDisabled,"other-decade":0===t||11===t,"focus-item":!0}}_enterKeyAction(e){e!==this&&e.click()}}customElements.define("sh-private-year-selector",Xo),customElements.define("sh-private-calendar-view",class extends se{static get properties(){return{currentView:{type:String},startingMonth:{type:Number},startingYear:{type:Number},startingDecade:{type:Number},todaysDate:{type:Object},selectedDates:{type:Array},futureDateDisable:{type:Boolean},pastDateDisable:{type:Boolean},minDate:{type:Object},maxDate:{type:Object},months:{type:Number},range:{type:Boolean},attachNode:{type:Object},responsive:{type:Boolean},locale:{type:String},close:{type:Boolean,reflect:!0}}}static get styles(){return[ie`
        :host {
          display: table;
          animation: fade-in var(--transition-time) ease-in-out;
        }
        @keyframes fade-in {
          0% {
            opacity: 0;
            visibility: hidden;
          }
          100% {
            opacity: 1;
            visibility: visible;
          }
        }
        :host([close]) {
          animation: fade-out var(--transition-time) ease-in-out;
        }
        @keyframes fade-out {
          0% {
            opacity: 1;
            visibility: visible;
          }
          100% {
            opacity: 0;
            visibility: hidden;
          }
        }
      `]}constructor(){super(),this.selectedDates=[]}connectedCallback(){super.connectedCallback(),this.documentBodyClickListener=this._documentBodyClickActions.bind(this),document.body.addEventListener("click",this.documentBodyClickListener)}render(){return V`${"date"===this.currentView?V`<sh-private-date-selector
          .months="${this.months}"
          .month="${this.startingMonth}"
          .year="${this.startingYear}"
          .todaysDate="${this.todaysDate}"
          .selectedDates="${this.selectedDates}"
          .futureDateDisable="${this.futureDateDisable}"
          .pastDateDisable="${this.pastDateDisable}"
          .minDate="${this.minDate}"
          .maxDate="${this.maxDate}"
          .range="${this.range}"
          @selected-dates-changed="${e=>{e.stopPropagation(),this.selectedDates=e.target.selectedDates}}"
          @month-header-clicked="${e=>{e.stopPropagation(),this.startingYear=e.detail.clickedYear,this.currentView="month"}}"
          .responsive="${this.responsive}"
          .locale="${this.locale}"
        ></sh-private-date-selector>`:""}
    ${"month"===this.currentView?V`<sh-private-month-selector
          .months="${this.months}"
          .year="${this.startingYear}"
          .todaysDate="${this._getMonthViewFormatDate(this.todaysDate)}"
          .minDate="${this._getMonthViewFormatDate(this.minDate)}"
          .maxDate="${this._getMonthViewFormatDate(this.maxDate)}"
          .selectedDate="${this._getMonthViewSelectedDate(this.selectedDates)}"
          .futureDateDisable="${this.futureDateDisable}"
          .pastDateDisable="${this.pastDateDisable}"
          .locale="${this.locale}"
          @month-clicked="${e=>{e.stopPropagation(),this.startingMonth=e.detail.clickedMonth,this.startingYear=e.detail.clickedYear,this.currentView="date"}}"
          @year-header-clicked="${e=>{e.stopPropagation(),this.startingDecade=e.detail.belongingDecade,this.currentView="year"}}"
          .responsive="${this.responsive}"
        ></sh-private-month-selector>`:""}
    ${"year"===this.currentView?V`<sh-private-year-selector
          .months="${this.months}"
          .decade="${this.startingDecade}"
          .todaysDate="${this._getYearViewFormatDate(this.todaysDate)}"
          .selectedDate="${this._getYearViewSelectedDate(this.selectedDates)}"
          .minDate="${this._getYearViewFormatDate(this.minDate)}"
          .maxDate="${this._getYearViewFormatDate(this.maxDate)}"
          .futureDateDisable="${this.futureDateDisable}"
          .pastDateDisable="${this.pastDateDisable}"
          @year-clicked="${e=>{e.stopPropagation(),this.startingYear=e.detail.clickedYear,this.currentView="month"}}"
          .responsive="${this.responsive}"
        ></sh-private-year-selector>`:""}`}updated(e){super.updated(e),e.has("currentView")&&this.currentView&&this.openCurrentView()}disconnectedCallback(){document.body.removeEventListener("click",this.documentBodyClickListener),super.disconnectedCallback()}_documentBodyClickActions(e){-1!==e.composedPath().indexOf(this)||-1!==e.composedPath().indexOf(this.attachNode)||this.responsive||le(this,"calendar-closed")}_getMonthViewFormatDate(e){let t;return e&&(t=new Date(e.getTime()),t.setDate(1),t.setHours(0,0,0,0)),t}_getYearViewFormatDate(e){let t;return e&&(t=new Date(e.getTime()),t.setMonth(0,1),t.setHours(0,0,0,0)),t}_getMonthViewSelectedDate(e){return 2===e.length&&this.range?this._getMonthViewFormatDate(this.selectedDates[1]):1!==e.length||this.range?null:this._getMonthViewFormatDate(this.selectedDates[0])}_getYearViewSelectedDate(e){return 2===e.length&&this.range?this._getYearViewFormatDate(this.selectedDates[1]):1!==e.length||this.range?null:this._getYearViewFormatDate(this.selectedDates[0])}openCurrentView(){const e="date"===this.currentView?"date-selector":"month"===this.currentView?"month-selector":"year-selector",t="date"===this.currentView?"generateCalendarDatas":"month"===this.currentView?"generateMonthViewData":"generateYearViewData",o=this.shadowRoot.querySelector(`sh-private-${e}`);o[t](),o.focus()}}),customElements.define("sh-datepicker",class extends se{static get properties(){return{label:{type:String,reflect:!0},error:{type:Boolean,reflect:!0},errorMessage:{type:String,reflect:!0,attribute:"error-message"},hint:{type:String,reflect:!0,attribute:"hint"},success:{type:Boolean,reflect:!0},disabled:{type:Boolean,reflect:!0},readonly:{type:Boolean,reflect:!0},safety:{type:Boolean,reflect:!0},mandatory:{type:Boolean,reflect:!0},value:{type:String,reflect:!0},active:{type:Boolean,reflect:!0},range:{type:Boolean,reflect:!0},separator:{type:String,reflect:!0},format:{type:String,reflect:!0},futureDateDisable:{type:Boolean,reflect:!0,attribute:"future-date-disable"},condensed:{type:Boolean,reflect:!0},noBorder:{type:Boolean,reflect:!0,attribute:"no-border"},min:{type:String,reflect:!0},max:{type:String,reflect:!0},editable:{type:Boolean,reflect:!0},months:{type:Number,reflect:!0},pastDateDisable:{type:Boolean,reflect:!0,attribute:"past-date-disable"},responsive:{type:String,reflect:!0},scrollpicker:{type:String,reflect:!0},fromDate:{type:String,reflect:!0,attribute:"from-date"},toDate:{type:String,reflect:!0,attribute:"to-date"},locale:{type:String,reflect:!0},standardValue:{type:Array},_currentView:{type:String},_selectedDates:{type:Array},_todaysDate:{type:Object},_showOverlay:{type:Boolean},_month:{type:Number},_year:{type:Number},_minDate:{type:String},_maxDate:{type:String},_scrollpicker:{type:Boolean},_responsive:{type:Boolean},_scrollpickerItems:{type:Array},_scrollpickerScroll:{type:Array},_scrollpickerValues:{type:Array}}}static get styles(){return ie`
      :host {
        display: block;
        width: 100%;
        position: relative;
      }
      /**
      Correcting the icon opacity to the
      idle state color of button icon so
      that the calendar icon is not so light
      when disabled property is applied to 
      datepicker
       */
      :host([disabled]) sh-icon[icon='calendar'] {
        color: rgba(var(--ui-1), var(--opacity-3));
      }
      .overlay-container {
        position: absolute;
        height: 2.5rem;
        top: 0px;
        left: 0px;
      }
      :host([condensed]) .overlay-container {
        height: 2rem;
      }
      .input {
        outline: none;
      }
    `}constructor(){super(),this.label="Label",this.format="MMDDYYYY",this.separator="/",this.months=1,this.disabled=!1,this.readonly=!1,this.range=!1,this.futureDateDisable=!1,this.pastDateDisable=!1,this.condensed=!1,this.editable=!1,this.responsive="false",this.scrollpicker="false",this.error=!1,this.success=!1,this.safety=!1,this.noBorder=!1,this.mandatory=!1,this.max="",this.min="",this.locale="en",this.standardValue=[],this._selectedDates=[],this._scrollpickerValues=[]}render(){return V`<sh-input-text
        .label="${this.label}"
        .error="${this.error}"
        .errorMessage="${this.errorMessage}"
        .hint="${this.hint}"
        .success="${this.success}"
        .disabled="${this.disabled}"
        .safety="${this.safety}"
        .mandatory="${this.mandatory}"
        .readonly="${this.readonly}"
        .value="${this.value}"
        ._inputReadonly="${!this.editable}"
        ._showOutline="${this.active&&!this.readonly}"
        .condensed="${this.condensed}"
        .noBorder="${this.noBorder}"
        ._notifyInputClick="${!0}"
        @input-clicked="${e=>{e.stopPropagation(),this._toggleActive()}}"
        @input="${e=>{this.active=!1,this.value=e.target.value}}"
        @clear-clicked="${e=>{e.stopPropagation(),this.value="",this.active||this.editable?this.active=!1:e.target.defocus()}}"
        class="input"
      >
        ${this.readonly?"":V`<sh-icon
              slot="icon"
              icon="calendar"
              size="s"
              button
              @click="${()=>{this._toggleActive()}}"
              .disabled="${this.disabled}"
            ></sh-icon>`}
      </sh-input-text>
      <div class="overlay-container">
        ${this._responsive?"":V`
              <sh-overlay
                .opened=${this._showOverlay&&!this.readonly}
                scroll-action="cancel"
                no-overlap
                horizontal-align="auto"
                auto-fit-on-attach
                .noCancelOnOutsideClick="${!0}"
                @overlay-canceled=${e=>{this._overlayCancelledCallback(e)}}
              >
                ${this._showOverlay?V`<sh-private-calendar-view
                      .currentView="${this._currentView}"
                      .months="${this.months}"
                      .startingMonth="${this._month}"
                      .startingYear="${this._year}"
                      .todaysDate="${this._todaysDate}"
                      .selectedDates="${this._selectedDates}"
                      .futureDateDisable="${this.futureDateDisable}"
                      .minDate="${this._minDate}"
                      .maxDate="${this._maxDate}"
                      .range="${this.range}"
                      .pastDateDisable="${this.pastDateDisable}"
                      .attachNode="${this}"
                      .locale="${this.locale}"
                      @ready-to-update-value="${e=>{e.stopPropagation(),this._updateValue(e.detail.selectedDates),e.target.close=!0}}"
                      @calendar-closed="${e=>{e.stopPropagation(),e.target.close=!0}}"
                      @animationend="${e=>{e.stopPropagation(),e.target.close&&(this.active=!1)}}"
                    ></sh-private-calendar-view>`:""}
              </sh-overlay>
            `}
      </div>
      ${this._responsive&&this._showOverlay&&!this.readonly?this._scrollpicker?V`<sh-scrollpicker
              .items="${this._scrollpickerItems}"
              .visible="${this._showOverlay}"
              .scroll="${this._scrollpickerScroll}"
              .values="${this._scrollpickerValues}"
              @values-changed="${e=>{e.stopPropagation(),this._updateValueFromScrollPicker(e.target)}}"
              @visible-changed="${e=>{e.stopPropagation(),e.target.visible||(this.active=!1)}}"
              @scroll-changed="${e=>{e.stopPropagation(),this._scrollpickerScroll=e.target.scroll}}"
            ></sh-scrollpicker>`:V`<sh-drawer
              .visible="${this._showOverlay&&!this.readonly}"
              position="bottom"
              @transitionend="${e=>{e.stopPropagation(),e.target.visible||(this.active=!1)}}"
              class="initial-slide-on-connect"
            >
              <sh-private-calendar-view
                .currentView="${this._currentView}"
                .months="${this.months}"
                .startingMonth="${this._month}"
                .startingYear="${this._year}"
                .todaysDate="${this._todaysDate}"
                .selectedDates="${this._selectedDates}"
                .futureDateDisable="${this.futureDateDisable}"
                .minDate="${this._minDate}"
                .maxDate="${this._maxDate}"
                .range="${this.range}"
                .pastDateDisable="${this.pastDateDisable}"
                .attachNode="${this}"
                .responsive="${!0}"
                .locale="${this.locale}"
                @ready-to-update-value="${e=>{e.stopPropagation(),this._updateValue(e.detail.selectedDates),e.target.parentElement.visible=!1}}"
              ></sh-private-calendar-view>
            </sh-drawer>`:""}`}connectedCallback(){super.connectedCallback(),ke.valueMatches(document.documentElement.clientWidth,"<",768)&&(this.responsive="true")}updated(e){super.updated(e),e.has("active")&&this._handleActive(),e.has("min")&&this._handleMin(),e.has("max")&&this._handleMax(),e.has("scrollpicker")&&(this._scrollpicker=JSON.parse(this.scrollpicker)),e.has("responsive")&&(this._responsive=JSON.parse(this.responsive)),e.has("value")&&(this._setResetFromToDates(),this.value||this._clearSelectedDates()),he(this,e,["active","value","error","disabled"])}_overlayCancelledCallback(e){"scroll"===e.detail.type&&(this.active=!1)}_handleMin(){if(this.min){const e=this._getTodaysDate(),t=Po.isValidDate(this.min,"YYYYMMDD","-","en",e);this._minDate=t?Po.parseDate(this.min,"YYYY-MM-DD","-","en",e):null}else this._minDate=null}_handleMax(){if(this.max){const e=this._getTodaysDate(),t=Po.isValidDate(this.max,"YYYYMMDD","-","en",e);this._maxDate=t?Po.parseDate(this.max,"YYYY-MM-DD","-","en",e):null}else this._maxDate=null}_updateValue(e){2===e.length?this.value=`${Po.getFormattedDate(e[0],this.format,this.separator,this.locale)}-${Po.getFormattedDate(e[1],this.format,this.separator,this.locale)}`:this.value=`${Po.getFormattedDate(e[0],this.format,this.separator,this.locale)}`}_setMonthYearDate(e){this._month=e.getMonth(),this._year=e.getFullYear(),this._scrollpickerDate=e.getDate()}_setDefaultVariables(e){this._setMonthYearDate(e),this._selectedDates=[]}_setSingleDateVariables(e){this._setMonthYearDate(e),this._selectedDates=[e]}_setRangeDateVariables(e){this._setMonthYearDate(e[1]),this._selectedDates=e}_updateVariables(){if(this._todaysDate=this._getTodaysDate(),this._currentView="date",this.value){const e=Po.insertSeperator(this.separator,this.format);if(Po.isValueValid(this.value,this.range,this.separator,this.format,this.futureDateDisable,this.pastDateDisable,this._todaysDate,this.min,this.max,this.locale))if(this.range){const t=Po.parseRangeDates(this.value,e,this.separator,this.locale,this._todaysDate);this._setRangeDateVariables(t)}else{const t=Po.parseDate(this.value,e,this.separator,this.locale,this._todaysDate);this._setSingleDateVariables(t)}else this._setDefaultVariables(this._todaysDate)}else this._setDefaultVariables(this._todaysDate)}_getTodaysDate(){const e=new Date;return e.setHours(0,0,0,0),e}_toggleActive(){this.active=!this.active}_handleActive(){this.active&&(this._updateVariables(),this._showOverlay=!0,this._scrollpicker&&this._initialiseScrollpicker()),this.active||(this.editable||this.value?this.shadowRoot.querySelector("sh-input-text").focus():this.value||this.shadowRoot.querySelector("sh-input-text").defocus(),this._showOverlay=!1,this._scrollpickerItems=[],this._scrollpickerValues=[],this._scrollpickerScroll=!1,this._clearSelectedDates())}_initialiseScrollpicker(){const e=new Array(12).fill(0).map(((e,t)=>Po.getShortMonthName(t,this.locale))),t=new Array(201).fill(0).map(((e,t)=>t+1900)),o=this._getDayCountforMonthYear(this._month,this._year),i=new Array(o).fill(0).map(((e,t)=>t+1));this._scrollpickerItems=[e,i,t],this._scrollpickerValues=[Po.getShortMonthName(this._month,this.locale),this._scrollpickerDate,this._year],this._scrollpickerScroll=!0}_getDayCountforMonthYear(e,t){let o=0;for(let i=1;i<=31&&new Date(t,e,i,0,0,0,0).getMonth()===e;i++)++o;return o}_updateValueFromScrollPicker(e){const t=e.values,o=Po.getMonthIndex(t[0],this.locale),i=t[2],r=t[1],s=this._getDayCountforMonthYear(o,i),n=s!==e.items[1].length,a=n&&r>s?s:r;if(this._scrollpickerValues=[Po.getShortMonthName(o,this.locale),a,i],this.value=Po.getFormattedDate(new Date(i,o,a,0,0,0,0),this.format,this.separator,this.locale),n){const e=new Array(s).fill(0).map(((e,t)=>t+1));this._scrollpickerItems[1]=e,this._scrollpickerScroll=!0}}_resetFromToDate(){this.fromDate=null,this.toDate=null}_setResetFromToDates(){this._todaysDate=this._getTodaysDate();let e=[],t=null,o=null;if(this.value){const i=Po.insertSeperator(this.separator,this.format);Po.isValueValid(this.value,this.range,this.separator,this.format,this.futureDateDisable,this.pastDateDisable,this._todaysDate,this.min,this.max,this.locale)&&(this.range?([t,o]=Po.extractFromToParts(this.value,this.separator,i),e=Po.parseRangeDates(this.value,i,this.separator,this.locale,this._todaysDate)):e=[Po.parseDate(this.value,i,this.separator,this.locale,this._todaysDate)])}this.fromDate=t,this.toDate=o,this.standardValue=e}_clearSelectedDates(){this._selectedDates=[]}});var Jo=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-divider-thickness=0.0625rem] - width / height of the  vertical & horizontal divider
   */
  --sh-divider-thickness: 0.0625rem;
  /* 
   * @cssprop [--sh-divider-horizontal-s=0.5rem 0] - spacing s for the horizontal divider
   */
  --sh-divider-horizontal-s: 0.5rem 0;
  /* 
   * @cssprop [--sh-divider-horizontal-m=1rem 0] - spacing m for the horizontal divider
   */
  --sh-divider-horizontal-m: 1rem 0;
  /* 
   * @cssprop [--sh-divider-horizontal-l=1.5rem 0] - spacing l for the horizontal divider
   */
  --sh-divider-horizontal-l: 1.5rem 0;
  /* 
   * @cssprop [--sh-divider-horizontal-xl=3rem 0] - spacing xl for the horizontal divider
   */
  --sh-divider-horizontal-xl: 3rem 0;
  /* 
   * @cssprop [--sh-divider-vertical-s=0 0.5rem] - spacing s for the vertical divider
   */
  --sh-divider-vertical-s: 0 0.5rem;
  /* 
   * @cssprop [--sh-divider-vertical-m=0 1rem] - spacing m for the vertical divider
   */
  --sh-divider-vertical-m: 0 1rem;
  /* 
   * @cssprop [--sh-divider-vertical-l=0 1.5rem] - spacing l for the vertical divider
   */
  --sh-divider-vertical-l: 0 1.5rem;
  /* 
   * @cssprop [--sh-divider-vertical-xl=0 3rem] - spacing xl for the vertical divider
   */
  --sh-divider-vertical-xl: 0 3rem;
}

:host {
  height: fit-content;
  height: -ms-fit-content;
  height: -moz-fit-content;
  display: block;
}

.divider-wrapper {
  background-color: rgba(var(--ui-1), var(--opacity-6));
}

:host(:not([vertical])) :host(:not([vertical])) .divider-wrapper {
  width: 100%;
}

:host([vertical]),
:host([vertical]) .divider-wrapper {
  height: 100%;
}

:host(:not([vertical])) .divider-wrapper {
  height: var(--sh-divider-thickness);
}

:host([vertical]) .divider-wrapper {
  width: var(--sh-divider-thickness);
}

/* spacing */
:host([spacing=s]) .divider-wrapper {
  margin: var(--sh-divider-horizontal-s);
}

:host([spacing=m]) .divider-wrapper {
  margin: var(--sh-divider-horizontal-m);
}

:host([spacing=l]) .divider-wrapper {
  margin: var(--sh-divider-horizontal-l);
}

:host([spacing=xl]) .divider-wrapper {
  margin: var(--sh-divider-horizontal-xl);
}

/* vertical divider spacing */
:host([vertical][spacing=s]) .divider-wrapper {
  margin: var(--sh-divider-vertical-s);
}

:host([vertical][spacing=m]) .divider-wrapper {
  margin: var(--sh-divider-vertical-m);
}

:host([vertical][spacing=l]) .divider-wrapper {
  margin: var(--sh-divider-vertical-l);
}

:host([vertical][spacing=xl]) .divider-wrapper {
  margin: var(--sh-divider-vertical-xl);
}`;customElements.define("sh-divider",class extends se{static get properties(){return{spacing:{type:String,reflect:!0},vertical:{type:Boolean,reflect:!0}}}static get styles(){return[Jo]}render(){return V` <div class="divider-wrapper"></div> `}attributeChangedCallback(e,t,o){super.attributeChangedCallback(e,t,o),this.dispatchEvent(new Event(`${e}-changed`))}constructor(){super(),this.spacing="s"}}),customElements.define("sh-dropdown",class extends se{static get properties(){return{label:{type:String,reflect:!0},value:{type:String,reflect:!0},hint:{type:String,reflect:!0},icon:{type:String,reflect:!0},active:{type:Boolean,reflect:!0},errorMessage:{type:String,reflect:!0,attribute:"error-message"},readonly:{type:Boolean,reflect:!0},disabled:{type:Boolean,reflect:!0},condensed:{type:Boolean,reflect:!0},_currentFocus:{type:Number},multiSelect:{type:Boolean,reflect:!0,attribute:"multi-select"},noBorder:{type:Boolean,reflect:!0,attribute:"no-border"},noClear:{type:Boolean,reflect:!0,attribute:"no-clear"},mandatory:{type:Boolean,reflect:!0},error:{type:Boolean,reflect:!0},success:{type:Boolean,reflect:!0},safety:{type:Boolean,reflect:!0},editable:{type:Boolean,reflect:!0},items:{type:Number,reflect:!0}}}static get styles(){return[ae,ie`
        :host {
          width: 100%;
          height: auto;
          position: relative;
          display: block;
        }
        .dropdown-label {
          color: var(--text-secondary);
          position: absolute;
          left: 0.5rem;
          width: calc(100% - 2.5rem);
          -webkit-font-smoothing: antialiased;
          text-rendering: optimizeLegibility;
          -moz-osx-font-smoothing: grayscale;
          top: 0.5rem;
          font: var(--body-1);
          line-height: 1.5rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          transition: var(--transition-time) all ease-in-out;
          display: flex;
        }
        :host(:not(.empty)) .dropdown-label,
        :host([active]) .dropdown-label {
          top: 0.25rem;
          right: 0.25rem;
          font: var(--body-2);
          line-height: 1rem;
        }
        :host(:hover:not([no-clear]):not(.empty)) .dropdown-label {
          width: calc(100% - 4.5rem);
        }
        :host(:hover[icon]:not([no-clear])) .dropdown-label {
          width: calc(100% - 7.5rem);
        }
        :host(:hover[error]:not([no-clear]):not(.empty)) .dropdown-label,
        :host(:hover[success]:not([no-clear]):not(.empty)) .dropdown-label {
          width: calc(100% - 6.5rem);
        }
        :host(:hover[icon][error]:not([no-clear])) .dropdown-label,
        :host(:hover[icon][success]:not([no-clear])) .dropdown-label {
          width: calc(100% - 9.5rem);
        }
        .label {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          flex: 1;
          max-width: fit-content;
          max-width: -moz-fit-content;
          transition: none;
        }
        sh-text[size='body-1'] {
          line-height: 1.5rem;
        }
        input {
          outline: none;
          border: none;
          cursor: pointer;
          font: var(--body-1);
          line-height: 1 rem;
          color: var(--text-primary);
          background: rgba(var(--ui-1), var(--opacity-7));
          height: 2.5rem;
          border-radius: 0.125rem 0.125rem 0 0;
          width: 100%;
          box-sizing: border-box;
          padding: 1.25rem 2.5rem 0.25rem 0.5rem;
          -webkit-font-smoothing: antialiased;
          text-rendering: optimizeLegibility;
          -moz-osx-font-smoothing: grayscale;
          text-overflow: ellipsis;
          border-bottom: 0.0625rem solid transparent;
          border-color: rgba(var(--ui-1), var(--opacity-4));
          transition: var(--hover-transition-time) background;
        }
        :host([active]) input {
          outline: none;
          border-color: rgba(var(--ui-1), var(--opacity-2));
        }
        :host(:hover:not([no-clear])) input {
          padding-right: 4.5rem;
        }
        :host(:hover[error]:not([readonly]):not([no-clear])) input,
        :host(:hover[success]:not([readonly]):not([no-clear])) input {
          padding-right: 6.5rem;
        }
        .dropdown-wrapper {
          position: relative;
        }
        .content-wrapper {
          display: flex;
          flex-direction: column;
          width: 100%;
        }
        #dropdown-icon {
          position: absolute;
          top: 0.5rem;
          right: 0.25rem;
          margin: -0.25rem 0;
        }

        :host([active]) #dropdown-icon {
          transform: rotate(180deg);
        }

        .overlay {
          min-width: 0;
          overflow: auto;
          padding: 0 0.5rem;
          background: var(--base-4);
          box-shadow: var(--shadow-overlay);
          box-sizing: border-box;
          border-radius: 0.125rem;
          display: none;
        }
        :host(:not([items])) .overlay {
          max-height: 13.75rem !important;
        }
        :host([active]) .overlay {
          display: block;
          max-width: unset !important;
        }
        :host([disabled]) {
          pointer-events: none;
          cursor: not-allowed;
        }
        :host([disabled]) .dropdown-label,
        :host([disabled]) input {
          color: var(--text-disabled);
          opacity: unset;
        }
        /* Validation Styles */
        #mandatory {
          display: none;
          color: rgba(var(--ui-2), var(--opacity-1));
        }
        :host([disabled]) #mandatory {
          color: rgba(var(--ui-2), var(--opacity-5));
        }
        :host([mandatory]) #mandatory {
          display: inline-block;
        }
        :host([error]) input,
        :host([status='error']) input {
          border-color: rgba(var(--functional-red), var(--opacity-1));
        }
        :host([success]) input,
        :host([status='success']) input {
          border-color: rgba(var(--functional-green), var(--opacity-1));
        }
        :host([safety]) input,
        :host([status='safety']) input {
          border-color: rgba(var(--functional-yellow), var(--opacity-2));
        }
        :host([readonly]) input {
          background: transparent;
          cursor: default;
        }
        :host([readonly]) #dropdown-icon {
          display: none;
        }
        :host([readonly]) input:focus + .dropdown-label {
          color: var(--text-secondary);
        }
        :host([readonly]),
        :host([readonly]) * {
          pointer-events: none;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
        }

        /* Clear */
        #clear {
          opacity: 0;
          pointer-events: none;
          position: absolute;
          transition: var(--transition-time) all ease-in-out, var(--hover-transition-time) opacity;
          cursor: pointer;
          right: 2.5rem;
          top: 0.5rem;
        }
        :host(:hover) #clear,
        :host(:focus) #clear,
        :host(:hover[error]) #clear,
        :host(:hover[success]) #clear,
        #clear:focus {
          opacity: 1;
          pointer-events: all;
        }
        :host([error]:not(.empty)) #clear,
        :host([success]:not(.empty)) #clear {
          right: 4.5rem;
        }
        /* condensed styles */
        :host([condensed]) {
          height: auto;
        }
        :host([condensed]:not(.empty)) .dropdown-label {
          display: none;
        }
        :host([condensed]) .dropdown-label,
        :host([condensed]) #clear {
          top: 0.25rem;
        }
        :host([condensed]) input,
        :host([condensed]) input:focus {
          padding: 0.25rem 2.5rem 0.25rem 0.5rem;
          height: 2rem;
        }
        :host([condensed]) #dropdown-icon {
          margin-top: -0.5rem;
        }
        /* icon */
        :host([icon]) input {
          padding-left: 3rem;
        }
        :host([condensed][icon][active][no-clear]) input,
        :host([condensed][icon][no-clear]) input,
        :host(:not([no-clear])[condensed][icon]) input {
          padding-left: 3rem !important;
        }
        :host(:hover:not([no-clear])[condensed][icon]:not([error]):not([success])) input,
        :host(:hover:not([no-clear])[condensed][active]:not([error]):not([success])) input {
          padding-right: 4.5rem;
        }
        :host([icon]) .dropdown-label {
          padding-left: 2.5rem;
          width: calc(100% - 6rem);
        }
        :host([icon][error]) .dropdown-label,
        :host([icon][success]) .dropdown-label {
          width: calc(100% - 7.5rem);
        }
        :host([editable][condensed][active]) .dropdown-label {
          display: none;
        }
        .dropdown-icon {
          position: absolute;
          top: 0.25rem;
          left: 0.5rem;
        }
        :host([condensed]) .dropdown-icon {
          min-height: 1.5rem;
          min-width: 1.5rem;
          font-size: 1.5rem;
          line-height: 1.625rem;
        }
        :host([condensed]) .status-icon {
          top: 0.25rem;
        }
        /* hover */
        :host(:hover:not([active]):not(.no-hovermq)) input,
        :host(.hover:not([active])) input {
          background: rgba(var(--ui-1), var(--opacity-6));
        }
        /* helper text */
        .helper-text {
          padding: 0.25rem 0.5rem 0rem 0.5rem;
          box-sizing: border-box;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        :host([disabled]) .helper-text {
          color: var(--text-disabled);
        }
        /* status icons */
        .status-icon {
          position: absolute;
          top: 0.5rem;
          right: 2.5rem;
        }
        :host([readonly]) .status-icon {
          right: 0.5rem;
        }
        :host([success]) .dropdown-label,
        :host([error]) .dropdown-label {
          width: calc(100% - 3rem - 2rem);
        }
        :host([success]:not([readonly])) input,
        :host([error]:not([readonly])) input {
          padding-right: 4.5rem;
        }
        :host([no-border]) input {
          border-bottom: none;
        }
        ::slotted([class='hidden']) {
          display: none;
        }
      `]}render(){return V`
      <div class="dropdown-wrapper">
        <div class="content-wrapper">
          ${this.icon&&!this.multiSelect?V` <sh-icon
                icon="${this.icon}"
                tabindex="-1"
                class="dropdown-icon"
                ?disabled="${this.disabled}"
              ></sh-icon>`:""}
          <input
            id="dropdownInput"
            ?readonly="${!this.editable}"
            @input="${this._inputChangeListener}"
            ​​​​
            type="text"
            .value="${this.value?this.value:""}"
            ?disabled="${this.disabled}"
          />
          <div class="dropdown-label">
            ${!this.label||this.condensed&&this.value?"":V` <sh-text
                  .size="${this.value||this.active?"body-2":"body-1"}"
                  .color=${this.disabled?"disabled":"secondary"}
                  class="label"
                  >${this.label}
                </sh-text>`}
            ${this.mandatory?V`<span id="mandatory"> *</span>`:""}
          </div>
        </div>
        ${!this.value||this.noClear||this.disabled||this.readonly?"":V`
            <sh-icon button size='s' icon='cancel' tabindex='0' @click=${this._resetValue}' id='clear'></sh-icon>`}
        ${this.error?V` <sh-icon
              icon="error"
              tabindex="-1"
              class="status-icon"
              size="s"
              ?disabled="${this.disabled}"
            ></sh-icon>`:""}
        ${this.success?V` <sh-icon
              icon="success"
              tabindex="-1"
              class="status-icon"
              size="s"
              ?disabled="${this.disabled}"
            ></sh-icon>`:""}
        <sh-icon
          button
          icon="down-s"
          id="dropdown-icon"
          tabindex="0"
          ?disabled="${this.disabled||this.readonly}"
        ></sh-icon>
        <sh-overlay
          class="overlay"
          style="width:${getComputedStyle(this).width};"
          @click="${e=>this.multiSelect?e.stopPropagation():""}"
          scroll-action="cancel"
          no-overlap
          horizontal-align="left"
        >
          <slot id="dropdownMenu" @slotchange="${this._handleSlotChange}"></slot>
        </sh-overlay>
      </div>
      ${this.error&&this.errorMessage?V` <sh-text class="helper-text error-message" size="body-2" color="secondary"
            >${this.errorMessage}</sh-text
          >`:""}
      ${this.hint&&!this.errorMessage?V`
            <sh-text size="body-2" class="helper-text hint" color="secondary">${this.hint}</sh-text>
          `:""}
      ${this.hint&&this.errorMessage&&!this.error?V` <sh-text size="body-2" class="helper-text hint" color="secondary"
            >${this.hint}</sh-text
          >`:""}
    `}constructor(){super(),this.value="",this.label="label",this._currentFocus=-1,this.noClear=!0,this._multiValue=[]}connectedCallback(){super.connectedCallback(),this.setAttribute("role","listbox"),this._handleMenuItemActiveChange=this._updateDropdown.bind(this),this.addEventListener("active-changed",this._handleMenuItemActiveChange),this.addEventListener("click",this._handleClick),this.resizeListener=this._handleResize.bind(this),window.addEventListener("resize",this.resizeListener)}updated(e){e.has("active")&&this._toggleDropdown(),e.has("value")&&this._valueObserver(),e.has("multiSelect")&&this._addMenuItemCheckboxes(),e.has("items")&&this._updateMaxHeight(),he(this,e,["label","value","hint","active","icon","errorMessage","readonly","disabled","condensed","multiSelect","noBorder","noClear","mandatory","error","success","safety","editable"])}_updateMaxHeight(){const e=this.shadowRoot.querySelector(".overlay");this.items&&(e.sizingTarget.style.maxHeight=2.5*this.items+"rem",e._fitInfo&&(e._fitInfo.sizerInlineStyle.maxHeight=2.5*this.items+"rem"))}_inputChangeListener(e){const t=this.querySelectorAll("sh-menu-item");let o,i=this.value=e.target.value;this._hideCategories();for(let e of t)o=e.value||e.label,-1===o.toLowerCase().indexOf(i.toLowerCase())?e.classList.add("hidden"):e.classList.remove("hidden");this.editable&&this.shadowRoot.querySelector("sh-overlay")._fireResize()}_hideCategories(){const e=this.querySelectorAll(":not(sh-menu-item)");if(e.length>0)for(let t of e)t.classList.add("hidden")}firstUpdated(){const e=this.shadowRoot.querySelector(".label"),t=this.shadowRoot.querySelector(".overlay");t.addEventListener("opened",(()=>{this.items&&(t.sizingTarget.style.maxHeight=2.5*this.items+"rem")})),ue.isTouchDevice()&&this.classList.add("no-hovermq"),this.addEventListener("overlay-canceled",this._overlayCancelledCallback),this.addEventListener("focus",(()=>this._handleFocus())),this.addEventListener("keydown",(e=>this._handleKeydown(e))),this.shadowRoot.querySelector("#dropdownInput").addEventListener("mouseover",(function(){this.offsetWidth<this.scrollWidth?this.setAttribute("title",this.value):this.removeAttribute("title")})),e&&e.addEventListener("mouseover",(()=>{e.offsetWidth<e.scrollWidth?e.setAttribute("title",this.label):e.removeAttribute("title")}))}_handleResize(){this.active=!1}disconnectedCallback(){this.removeEventListener("active-changed",this._handleMenuItemActiveChange),window.removeEventListener("resize",this.resizeListener),super.disconnectedCallback()}_addMenuItemCheckboxes(){const e=this.querySelectorAll("sh-menu-item");for(let t of e)t.checkbox=!0}_handleSlotChange(){this.multiSelect&&this._addMenuItemCheckboxes()}_valueObserver(){this.value?(this.classList.remove("empty"),this._updateMenuItemState()):(this.classList.add("empty"),this.icon=null,this.editable&&(this._removeHiddenClass(),this._unselectActiveItems()))}_updateMenuItemState(){if(this.multiSelect)return;let e=!1;const t=this.querySelectorAll("sh-menu-item");let o=0;for(let i of t){const t=i.value||i.label,r=i.icon;this.icon&&this.value===t&&this.icon===r?(i.active=!0,e=!0,o+=1,this._removeHiddenClass()):this.icon||this.value!==t?i.active=!1:(i.active=!0,e=!0,o+=1,this._removeHiddenClass())}o>1&&console.warn("Multiple menu-items are found to be active. This happens when no difference is found in terms of label or icon used.\n        If not multi-select it is advisable to have only a single menu-item as active."),e||(this.icon=null)}_updateDropdown(e){if(e.target===this)return;const t=e.target,o=e.target.clicked;this.multiSelect?this._updateMultiSelectDropdownValue(t):this._updateDropdownValue(t,o)}_overlayCancelledCallback(e){const t=e.detail;("click"===t.type&&t.target!==this||"keydown"===t.type&&t.keyCode===me.ESCAPE||"scroll"===t.type)&&(this.active=!1)}_handleClick(e){const t=this.shadowRoot.querySelector("#dropdownInput");e.target===this&&(this.active=!this.active),this.active?t.focus({preventScroll:!0}):t.blur(),this.editable&&this.active&&t.removeAttribute("readonly")}_handleKeydown(e){e.keyCode===me.ARROW_UP||e.keyCode===me.ARROW_DOWN?(e.preventDefault(),e.stopPropagation()):e.keyCode===me.TAB&&(this.active=!1,this._toggleDropdown())}_toggleDropdown(){const e=this.shadowRoot.querySelector(".overlay");this.active?e.open():(e.close(),this._resetMenuItemHoverStyle(),this._currentFocus=-1)}_updateDropdownValue(e,t){const o=e.value||e.label;e.active?(this.value=o,this._updateDropdownIcon(e),this._unselectSiblings(e),this.active=!1):!e.active&&this.value===o&&t&&(this.icon?e.active=this.icon===e.icon:e.active=!0)}_updateDropdownIcon(e){this.value&&e.active&&!this.multiSelect?this.icon=e.icon:this.value&&!this.multiSelect||this.removeAttribute("icon")}_unselectSiblings(e){const t=this.querySelectorAll("sh-menu-item[active]");for(let o=0;o<t.length;o++)(this.icon&&this.icon!==t[o].icon||e.label&&t[o].label!==e.label||e.value&&t[o].value!==e.value)&&(t[o].active=!1)}_updateMultiSelectDropdownValue(e){const t=e.value||e.label;e.active?this._multiValue.push(t):this._multiValue=this._multiValue.filter((e=>e!==t)),this.value=this._multiValue.toString()}_resetValue(e){e.stopPropagation(),this.editable&&this._removeHiddenClass(),this.active=!1,this.value="",this._unselectActiveItems()}_removeHiddenClass(){const e=this.querySelectorAll("*");for(let t of e)t.classList.remove("hidden")}_resetMenuItemHoverStyle(){if(-1!==this._currentFocus){const e=this.querySelectorAll("sh-menu-item.hover");for(let t of e)t.classList.remove("hover"),t.classList.remove("focus"),t.blur()}}_unselectActiveItems(){const e=this.querySelectorAll("sh-menu-item[active]");for(let t=0;t<e.length;t++)e[t].active=!1}_handleFocus(){this.onkeyup=e=>{this._keyEvents(e)}}_keyEvents(e){if(e.keyCode===me.ENTER||e.keyCode===me.TAB){if("dropdownInput"===this._getEventSource(e).id&&!this.readonly){const e=this.shadowRoot.querySelector("#dropdownInput");this.active=!this.active,this.editable&&(this.active||""!==this.value?e.removeAttribute("readonly"):e.setAttribute("readonly","true"))}}else if(e.keyCode===me.ARROW_DOWN){const t=this.querySelectorAll("sh-menu-item:not([class='hidden'])");0!==t.length&&(this._currentFocus=++this._currentFocus%t.length,this._updateFocusedItem(e))}else if(e.keyCode===me.ARROW_UP){const t=this.querySelectorAll("sh-menu-item:not([class='hidden'])");0!==t.length&&(this._decrementCurrentFocus(t),this._updateFocusedItem(e))}}_updateFocusedItem(e){e.stopImmediatePropagation(),e.preventDefault();const t=this.querySelectorAll("sh-menu-item:not([class='hidden'])");this._resetMenuItemHoverStyle(),t[this._currentFocus].classList.add("hover"),t[this._currentFocus].classList.add("focus"),t[this._currentFocus].focus()}_decrementCurrentFocus(e){-1===this._currentFocus?this._currentFocus=(this._currentFocus+e.length)%e.length:this._currentFocus=(this._currentFocus-1+e.length)%e.length}_getEventSource(e){return e.composedPath()?e.composedPath()[0]:null}});var Qo=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-empty-state-icon-size=4rem] - Size of the empty state icon
   */
  --sh-empty-state-icon-size: 4rem;
  /* 
   * @cssprop [--sh-empty-state-text-width=24rem] - Width of the empty state text
   */
  --sh-empty-state-text-width: 24rem;
  /* 
   * @cssprop [--sh-empty-state-text-max-width=calc(100% - 4rem)] - Maximum width of the empty state text 
   */
  --sh-empty-state-text-max-width: calc(100% - 4rem);
  /* 
   * @cssprop [--sh-empty-state-margin=1rem] - Top margin for the footer slot & Bottom margin of the icon 
   */
  --sh-empty-state-margin: 1rem;
  /* 
   * @cssprop [--sh-empty-state-thickness=0.125rem] - Border thickness of the dotted line when drag and drop is set
   */
  --sh-empty-state-thickness: 0.125rem;
  /* 
   * @cssprop [--sh-empty-state-left-margin=0.5rem] - left margin of the non first footer slot elements
   */
  --sh-empty-state-left-margin: 0.5rem;
}

:host {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

sh-icon {
  /* WARNING: this rule is only to make */
  /* the rescaled implementation look like the legacy one. */
  /* It nudges the icon down a bit which seems like a change */
  /* that was introduced at some point */
  /* !!!!this rule probably should go!!!! */
  margin-bottom: var(--sh-empty-state-margin);
  --sh-icon-size-m: var(--sh-empty-state-icon-size);
  --sh-icon-font-size-m: var(--sh-empty-state-icon-size);
  color: rgba(var(--ui-1), var(--opacity-5));
}

sh-text {
  text-align: center;
  width: var(--sh-empty-state-text-width);
  max-width: var(--sh-empty-state-text-max-width);
}

/* footer */
.footer-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: var(--sh-empty-state-margin);
}

.footer-wrapper > ::slotted(*:not(:first-child)) {
  margin-left: var(--sh-empty-state-left-margin);
}

.footer-wrapper[empty-footer] {
  display: none;
}

/* drag and drop */
:host([drag-and-drop]) {
  border: var(--sh-empty-state-thickness) dotted rgba(var(--ui-1), var(--opacity-5));
}`;customElements.define("sh-empty-state",class extends se{static get properties(){return{label:{type:String,reflect:!0},icon:{type:String,reflect:!0},dragAndDrop:{type:Boolean,reflect:!0,attribute:"drag-and-drop"},_emptyFooter:{type:Boolean},iconColor:{type:String,reflect:!0,attribute:"icon-color"}}}static get styles(){return[ae,Qo]}render(){return V`
      ${this.icon?V`<sh-icon icon="${this.icon}" .color="${this.iconColor}"></sh-icon>`:""}
      <sh-text size="body-1">${this.label}</sh-text>
      <div class="footer-wrapper" ?empty-footer="${this._emptyFooter}">
        <slot
          name="footer"
          @slotchange="${this._handleSlotNodes.bind(this)}"
          id="footerSlot"
        ></slot>
      </div>
    `}constructor(){super(),this._emptyFooter=!0}updated(e){he(this,e,["icon","label","dragAndDrop"])}_handleSlotNodes(){const e=this.shadowRoot.querySelector("#footerSlot").assignedNodes({flatten:!0}).length;this._emptyFooter=0===e}});var ei=ie`:host {
  display: grid;
  display: -ms-grid;
  grid-template-columns: repeat(12, 1fr);
  -ms-grid-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
}

::slotted(*) {
  width: auto;
  min-width: 0;
  min-height: 0;
}

/* small spacing */
:host([spacing=s]) {
  margin: -0.25rem !important;
  height: calc(100% + 0.5rem) !important;
  width: calc(100% + 0.5rem) !important;
}

:host([spacing=s]) ::slotted(*) {
  margin: 0.25rem;
}

/* medium spacing (default) */
:host([spacing=m]) {
  height: calc(100% + 1rem) !important;
  width: calc(100% + 1rem) !important;
  margin: -0.5rem !important;
}

:host([spacing=m]) ::slotted(*) {
  margin: 0.5rem;
}

/* large spacing */
:host([spacing=l]) {
  margin: -0.75rem !important;
  height: calc(100% + 1.5rem) !important;
  width: calc(100% + 1.5rem) !important;
}

:host([spacing=l]) ::slotted(*) {
  margin: 0.75rem;
}

/* fit-content */
:host([fit-content]) {
  height: auto !important;
}

/* columns rules: large screen */
::slotted([columns="0"]) {
  display: none;
}

::slotted(*:not([columns])),
::slotted([columns="1"]) {
  grid-column: span 1;
  -ms-grid-column-span: 1;
}

::slotted([columns="2"]) {
  grid-column: span 2;
  -ms-grid-column-span: 2;
}

::slotted([columns="3"]) {
  grid-column: span 3;
  -ms-grid-column-span: 3;
}

::slotted([columns="4"]) {
  grid-column: span 4;
  -ms-grid-column-span: 4;
}

::slotted([columns="5"]) {
  grid-column: span 5;
  -ms-grid-column-span: 5;
}

::slotted([columns="6"]) {
  grid-column: span 6;
  -ms-grid-column-span: 6;
}

::slotted([columns="7"]) {
  grid-column: span 7;
  -ms-grid-column-span: 7;
}

::slotted([columns="8"]) {
  grid-column: span 8;
  -ms-grid-column-span: 8;
}

::slotted([columns="9"]) {
  grid-column: span 9;
  -ms-grid-column-span: 9;
}

::slotted([columns="10"]) {
  grid-column: span 10;
  -ms-grid-column-span: 10;
}

::slotted([columns="11"]) {
  grid-column: span 11;
  -ms-grid-column-span: 11;
}

::slotted([columns="12"]) {
  grid-column: span 12;
  -ms-grid-column-span: 12;
}

/* columns rules: medium screen */
@media only screen and (max-width: 64.0625rem) {
  ::slotted([col-m="0"]) {
    display: none;
  }

  ::slotted([col-m="1"]) {
    grid-column: span 1;
    -ms-grid-column-span: 1;
  }

  ::slotted([col-m="2"]) {
    grid-column: span 2;
    -ms-grid-column-span: 2;
  }

  ::slotted([col-m="3"]) {
    grid-column: span 3;
    -ms-grid-column-span: 3;
  }

  ::slotted([col-m="4"]) {
    grid-column: span 4;
    -ms-grid-column-span: 4;
  }

  ::slotted([col-m="5"]) {
    grid-column: span 5;
    -ms-grid-column-span: 5;
  }

  ::slotted([col-m="6"]) {
    grid-column: span 6;
    -ms-grid-column-span: 6;
  }

  ::slotted([col-m="7"]) {
    grid-column: span 7;
    -ms-grid-column-span: 7;
  }

  ::slotted([col-m="8"]) {
    grid-column: span 8;
    -ms-grid-column-span: 8;
  }

  ::slotted([col-m="9"]) {
    grid-column: span 9;
    -ms-grid-column-span: 9;
  }

  ::slotted([col-m="10"]) {
    grid-column: span 10;
    -ms-grid-column-span: 10;
  }

  ::slotted([col-m="11"]) {
    grid-column: span 11;
    -ms-grid-column-span: 11;
  }

  ::slotted([col-m="12"]) {
    grid-column: span 12;
    -ms-grid-column-span: 12;
  }
}
/* columns rules: small screen */
@media only screen and (max-width: 47.9375rem) {
  ::slotted([col-s="0"]) {
    display: none;
  }

  ::slotted([col-s="1"]) {
    grid-column: span 1;
    -ms-grid-column-span: 1;
  }

  ::slotted([col-s="2"]) {
    grid-column: span 2;
    -ms-grid-column-span: 2;
  }

  ::slotted([col-s="3"]) {
    grid-column: span 3;
    -ms-grid-column-span: 3;
  }

  ::slotted([col-s="4"]) {
    grid-column: span 4;
    -ms-grid-column-span: 4;
  }

  ::slotted([col-s="5"]) {
    grid-column: span 5;
    -ms-grid-column-span: 5;
  }

  ::slotted([col-s="6"]) {
    grid-column: span 6;
    -ms-grid-column-span: 6;
  }

  ::slotted([col-s="7"]) {
    grid-column: span 7;
    -ms-grid-column-span: 7;
  }

  ::slotted([col-s="8"]) {
    grid-column: span 8;
    -ms-grid-column-span: 8;
  }

  ::slotted([col-s="9"]) {
    grid-column: span 9;
    -ms-grid-column-span: 9;
  }

  ::slotted([col-s="10"]) {
    grid-column: span 10;
    -ms-grid-column-span: 10;
  }

  ::slotted([col-s="11"]) {
    grid-column: span 11;
    -ms-grid-column-span: 11;
  }

  ::slotted([col-s="12"]) {
    grid-column: span 12;
    -ms-grid-column-span: 12;
  }
}
/* rows rules */
::slotted(*:not([rows])),
::slotted([rows="1"]) {
  grid-row: span 1;
  -ms-grid-row-span: 1;
}

::slotted([rows="2"]) {
  grid-row: span 2;
  -ms-grid-row-span: 2;
}

::slotted([rows="3"]) {
  grid-row: span 3;
  -ms-grid-row-span: 3;
}

::slotted([rows="4"]) {
  grid-row: span 4;
  -ms-grid-row-span: 4;
}

::slotted([rows="5"]) {
  grid-row: span 5;
  -ms-grid-row-span: 5;
}

::slotted([rows="6"]) {
  grid-row: span 6;
  -ms-grid-row-span: 6;
}

::slotted([rows="7"]) {
  grid-row: span 7;
  -ms-grid-row-span: 7;
}

::slotted([rows="8"]) {
  grid-row: span 8;
  -ms-grid-row-span: 8;
}

::slotted([rows="9"]) {
  grid-row: span 9;
  -ms-grid-row-span: 9;
}

::slotted([rows="10"]) {
  grid-row: span 10;
  -ms-grid-row-span: 10;
}

::slotted([rows="11"]) {
  grid-row: span 11;
  -ms-grid-row-span: 11;
}

::slotted([rows="12"]) {
  grid-row: span 12;
  -ms-grid-row-span: 12;
}`;customElements.define("sh-grid",class extends se{static get properties(){return{spacing:{type:String,reflect:!0},columns:{type:Number,reflect:!0},rows:{type:Number,reflect:!0},fitContent:{type:Boolean,value:!1,reflect:!0,attribute:"fit-content"}}}static get styles(){return[ae,ei]}render(){return V` <slot spacing="${this.spacing}" style="min-width: 0rem"></slot> `}constructor(){super(),this.spacing="m"}updated(e){e.has("rows")&&this._rowsChanged(),e.has("columns")&&this._columnsChanged()}_rowsChanged(){void 0!==this.rows&&(this.style.gridTemplateRows="repeat("+this.rows+", 1fr)",this.style.msGridRows="(1fr)["+this.rows+"]")}_columnsChanged(){void 0!==this.rows&&(this.style.gridTemplateColumns="repeat("+this.columns+", 1fr)",this.style.msGridColumns="(1fr)["+this.columns+"]")}}),customElements.define("sh-home-card",class extends se{static get properties(){return{icon:{type:String,reflect:!0},label:{type:String,reflect:!0},notifications:{type:Number,reflect:!0},errors:{type:Number,reflect:!0}}}static get styles(){return[ae,ie`
        :host {
          cursor: pointer;
          transition: var(--transition-time) all ease-in-out;
          display: flex;
        }

        :host(:hover) {
          transform: translateY(-0.25rem);
        }

        sh-card {
          height: 100%;
        }

        sh-card {
          height: 16.5rem;
          width: 19rem;
          margin: 0.5rem;
        }

        .card-wrapper {
          height: 100%;
          display: flex;
          flex-direction: column;
        }

        .content-wrapper {
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        #card-icon {
          color: var(--text-secondary);
          --sh-icon-size-m: 4rem;
          --sh-icon-font-size-m: 4rem;
          position: relative;
        }
        .card-title {
          margin-top: 0.5rem;
          text-align: center;
        }

        #footer-wrapper {
          border-top: 0.0625rem solid rgba(var(--ui-1), var(--opacity-6));
          padding-top: 1rem;
          height: 4.5rem;
          overflow: auto;
        }
        :host([notifications]) .notification-dot {
          background: var(--support-5);
          height: 1rem;
          width: 1rem;
          font: var(--body-2);
          text-align: center;
          font-weight: bold;
          line-height: 1rem;
          color: var(--base-3);
          border: 0.125rem solid var(--base-3);
          position: absolute;
          right: 0rem;
          bottom: 0rem;
          border-radius: 50%;
        }

        :host([errors]) .error-dot {
          background: rgb(var(--functional-red));
          height: 1rem;
          width: 1rem;
          font: var(--body-2);
          text-align: center;
          font-weight: bold;
          line-height: 1rem;
          color: var(--base-3);
          border: 0.125rem solid var(--base-3);
          position: absolute;
          right: 0rem;
          bottom: 0rem;
          border-radius: 50%;
        }

        /* small screens */
        @media only screen and (max-width: 47.9375rem) {
          :host(:hover) {
            transform: none;
          }
        }
      `]}render(){return V`
      <sh-card>
        <div class="card-wrapper">
          <div class="content-wrapper">
            <div style="position: relative">
              ${this.icon?V` <sh-icon id="card-icon" icon="${this.icon}"></sh-icon>`:""}
              ${this.notifications?V` <div class="notification-dot">${this.notifications}</div>`:""}
              ${this.errors?V` <div class="error-dot">${this.errors}</div> `:""}
            </div>
            ${this.label?V` <sh-text class="card-title" title-1>${this.label}</sh-text> `:""}
          </div>
          <div id="footer-wrapper">
            <slot @slotchange="${this._handleSlotChange.bind(this)}"></slot>
          </div>
        </div>
      </sh-card>
    `}constructor(){super(),this.icon="patient",this.label="Card Label"}_handleSlotChange(){0===this.children.length?this.shadowRoot.querySelector("#footer-wrapper").setAttribute("style","display: none"):this.shadowRoot.querySelector("#footer-wrapper").setAttribute("style","display: block")}}),customElements.define("sh-home-screen",class extends se{static get properties(){return{functions:{type:Boolean,reflect:!0},mobile:{type:Boolean,reflect:!0},_iconVisible:{type:Boolean,reflect:!1}}}static get styles(){return[ae,ie`
        :host {
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          overflow-y: auto;
          overflow-x: hidden;
        }

        .cards-wrapper {
          display: flex;
          flex-wrap: wrap;
          min-height: fit-content;
          width: fit-content;
          max-height: calc(100% + 1rem);
          max-width: calc(100% + 1rem);
          margin: -0.5rem;
          justify-content: center;
          align-items: center;
        }

        #functions-button {
          position: fixed;
          bottom: 1rem;
          right: 1rem;
        }

        .functions-card:not([active]) {
          opacity: 0;
          margin-bottom: -1rem;
          pointer-events: none;
        }

        .functions-card {
          transition: var(--transition-time) all ease-in-out;
          position: fixed;
          right: 1rem;
          bottom: 3.5rem;
          width: 15rem;
        }
        .functions-div {
          margin: -0.5rem 0;
        }

        /* small screens */
        :host([mobile]) {
          align-items: flex-start;
        }
        :host([mobile]) .cards-wrapper {
          width: calc(100% + 1rem);
          flex-direction: column;
        }
        :host([mobile]) .cards-wrapper > ::slotted(sh-home-card) {
          width: calc(100% - 1rem);
        }
      `]}render(){return V` <div class="cards-wrapper">
        <slot></slot>
      </div>
      ${this._iconVisible?V` <sh-icon
            button
            icon="standby"
            id="functions-button"
            @click="${this._handleFunctions}"
          ></sh-icon>`:""}
      <sh-card class="functions-card" ?active="${this.functions}">
        <div class="functions-div" @click="${this._handleFunctions}">
          <slot
            name="functions"
            @slotchange=${e=>{this.slotChanged(e.target)}}
          ></slot>
        </div>
      </sh-card>`}slotChanged(e){e.assignedNodes({flatten:!0}).length>0?this._iconVisible=!0:(this._iconVisible=!1,this.functions=!1)}connectedCallback(){super.connectedCallback(),this.windowDimensionObserver=this.handleResize.bind(this),window.addEventListener("resize",this.windowDimensionObserver)}disconnectedCallback(){super.disconnectedCallback(),window.removeEventListener("resize",this.windowDimensionObserver)}updated(e){he(this,e,["mobile"])}handleResize(){this.mobile=document.documentElement.clientWidth<767}_handleFunctions(){this.functions=!this.functions}}),customElements.define("sh-image-segment",class extends se{static get properties(){return{color:{type:String,reflect:!0},focus:{type:Boolean,reflect:!0},hideOverlay:{type:Boolean,reflect:!0,attribute:"hide-overlay"}}}static get styles(){return[ie`
        :host {
          position: relative;
          border-radius: 0.125rem;
          background: black;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }
        /* slotted image */
        :host > ::slotted(*:not([slot])) {
          height: 100%;
          width: 100%;
          flex: 1;
        }
        /* outlines */
        .segment-outline {
          position: absolute;
          top: 0.125rem;
          left: 0.125rem;
          height: calc(100% - 0.25rem);
          width: calc(100% - 0.25rem);
          box-sizing: border-box;
          border: 0.0625rem solid transparent;
          border-radius: 0.125rem;
          transition: var(--transition-time) all ease-in-out;
          opacity: var(--opacity-3);
        }
        :host(:not([outline])[focus]) .segment-outline {
          border-color: rgb(var(--ui-0));
        }
        :host([focus]) .segment-outline {
          border-width: 0.125rem;
          opacity: var(--opacity-2);
        }
        /* slots */
        :host ::slotted(*[slot]) {
          pointer-events: all;
        }
        .corner,
        .side {
          pointer-events: none;
          position: absolute;
          height: auto;
          width: auto;
          transition: var(--transition-time) all ease-in-out;
        }
        :host([hide-overlay]) .corner,
        :host([hide-overlay]) .side {
          opacity: 0;
          pointer-events: none;
        }
        /* corner slots */
        .corner {
          max-width: calc(50% - 0.75rem);
          display: flex;
          flex-direction: column;
        }
        .corner > ::slotted(*) {
          display: flex;
          flex-direction: column;
        }
        .corner.right ::slotted(*) {
          text-align: right;
          margin-left: 0.5rem;
        }
        /* side slots */
        .side {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .side.left > ::slotted(*),
        .side.right > ::slotted(*) {
          margin: 0.25rem 0;
        }
        .side.left,
        .side.right {
          height: calc(100% - 1.5rem);
          flex-direction: column;
        }
        .side.top > ::slotted(*),
        .side.bottom > ::slotted(*) {
          margin: 0 0.25rem;
        }
        .side.top,
        .side.bottom {
          width: calc(100% - 1.5rem);
          flex-direction: row;
        }
        .left {
          left: 0.75rem;
        }
        .right {
          right: 0.75rem;
        }
        .top {
          top: 0.75rem;
        }
        .bottom {
          bottom: 0.75rem;
        }
      `]}render(){return V`
      <div class="segment-outline" style="border-color: ${this.color}"></div>
      <!-- corner slots -->
      <div class="corner top left">
        <slot name="top-left"></slot>
      </div>
      <div class="corner top right">
        <slot name="top-right"></slot>
      </div>
      <div class="corner bottom left">
        <slot name="bottom-left"></slot>
      </div>
      <div class="corner bottom right">
        <slot name="bottom-right"></slot>
      </div>
      <!-- side slots -->
      <div class="side left">
        <slot name="left"></slot>
      </div>
      <div class="side right">
        <slot name="right"></slot>
      </div>
      <div class="side top">
        <slot name="top"></slot>
      </div>
      <div class="side bottom">
        <slot name="bottom"></slot>
      </div>
      <!-- image slot -->
      <slot></slot>
    `}}),customElements.define("sh-image-text",class extends se{static get properties(){return{alignment:{type:String,reflect:!0}}}render(){return V` <slot></slot> `}static get styles(){return[ie`
        :host {
          transition: var(--transition-time) all ease-in-out;
          width: 100%;
          font: var(--body-1);
          line-height: 1.25rem;
          color: var(--text-white);
          text-shadow: 0.0625rem 0.0625rem 0.25rem black, -0.0625rem -0.0625rem 0.25rem black,
            0rem 0rem 0.25rem black, 0rem 0rem 0.125rem black;
          word-wrap: break-word;
        }
        :host([alignment='left']) {
          text-align: left;
        }
        :host([alignment='right']) {
          text-align: right;
        }
      `]}}),customElements.define("sh-toolbar",class extends se{static get properties(){return{orientation:{type:String,reflect:!0},inSegmentTheme:{type:Boolean,reflect:!0,attribute:"in-segment-theme"}}}render(){return V` <slot></slot> `}static get styles(){return[ie`
        :host {
          display: flex;
          background: rgba(var(--ui-6), var(--opacity-2));
          border-radius: 0.125rem;
        }
        :host([orientation='horizontal']),
        :host([slot='top']),
        :host([slot='bottom']) {
          flex-direction: row;
        }
        :host([orientation='vertical']),
        :host([slot='left']),
        :host([slot='right']) {
          flex-direction: column;
        }
      `]}});var ti=function(){let e=".";const t="120.94";return"120,94"===Number(t).toLocaleString()?e=",":Number(t).toLocaleString()===t&&(e="."),e}(),oi=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-input-number-status-text-padding=0.25rem 0.5rem 0 0.5rem] - padding of status text (warning, hint, ..)
   */
  --sh-input-number-status-text-padding: 0.25rem 0.5rem 0 0.5rem;
  /* 
   * @cssprop [--sh-input-number-left-icon-padding=0 0 0 0.25rem] - padding of left icon
   */
  --sh-input-number-left-icon-padding: 0 0 0 0.25rem;
  /* 
   * @cssprop [--sh-input-number-right-icon-padding=0] - padding of right icon
   */
  --sh-input-number-right-icon-padding: 0;
  /* 
   * @cssprop [--sh-input-number-icon-size=1.9375rem] - size of the icon left and right
   */
  --sh-input-number-icon-size: 1.9375rem;
  /* 
   * @cssprop [--sh-input-number-input-right-padding=0.25rem] - right padding of the input
   */
  --sh-input-number-input-right-padding: 0.25rem;
}

:host {
  width: 100%;
  height: fit-content;
  height: -moz-fit-content;
  position: relative;
  display: inline-block;
  flex-direction: column;
  --sh-input-text-icon-wrapper-right-padding: var(--sh-input-number-input-right-padding);
}
:host sh-icon {
  margin-top: auto;
  margin-bottom: auto;
}
:host sh-icon[icon=left-s] {
  margin: var(--sh-input-number-left-icon-padding);
}
:host sh-icon[icon=right-s] {
  margin: var(--sh-input-number-right-icon-padding);
}
:host sh-text {
  width: 100%;
}

:host([condensed]) sh-icon[icon=left-s],
:host([condensed]) sh-icon[icon=right-s] {
  --sh-icon-size-m: var(--sh-input-number-icon-size);
}

/* Stepper Styles */
:host([disabled]) .icon-container > * {
  pointer-events: none;
}

/* helper text */
.helper-text {
  padding: var(--sh-input-number-status-text-padding);
  box-sizing: border-box;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

:host([disabled]) .helper-text {
  color: var(--text-disabled);
}`,ii=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-numeric-keypad-width=11rem] - width of the keypad container
   */
  --sh-numeric-keypad-width: 11rem;
  /* 
   * @cssprop [--sh-numeric-keypad-height=15rem] - height of the keypad container
   */
  --sh-numeric-keypad-height: 15rem;
  /* 
   * @cssprop [--sh-numeric-keypad-circle-button-width=3rem] - width of the circle buttons
   */
  --sh-numeric-keypad-circle-button-width: 3rem;
  /* 
   * @cssprop [--sh-numeric-keypad-circle-button-height=3rem] - height of the circle buttons
   */
  --sh-numeric-keypad-circle-button-height: 3rem;
  /* 
   * @cssprop [--sh-numeric-keypad-container-padding=1rem] - padding of the keypad container
   */
  --sh-numeric-keypad-container-padding: 1rem;
  /* 
   * @cssprop [--sh-numeric-keypad-button-margins=0.5rem] - margin for the circle buttons
   */
  --sh-numeric-keypad-button-margins: 0.5rem;
  /* 
   * @cssprop [--sh-numeric-keypad-button-center-margin=0 0.5rem] - margin for the circle buttons in the center column
   */
  --sh-numeric-keypad-button-center-margin: 0 0.5rem;
}

:host {
  visibility: hidden;
  opacity: 0;
  overflow: hidden;
  max-height: 0rem;
  height: 0rem;
  width: 13rem;
  z-index: 9999;
  position: fixed;
  background-color: var(--base-3);
  box-sizing: border-box;
  top: 2.5rem;
  box-shadow: var(--shadow-raised);
  transition: var(--transition-time) opacity var(--transition-time) ease-in-out;
}

:host([visible]) {
  visibility: visible;
  opacity: 1;
  overflow: visible;
  max-height: fit-content;
  height: fit-content;
  padding: var(--sh-numeric-keypad-container-padding);
  display: table;
}

:host([condensed]) {
  top: 2rem;
}

.functions-wrapper {
  position: relative;
  display: flex;
  justify-content: space-between;
  padding-right: 0.5rem;
  box-sizing: border-box;
}

.functions-wrapper > ::slotted(*:first-child) {
  margin-left: 1rem;
  margin-right: 0.5rem;
}

.functions-wrapper > ::slotted(:not(*:first-child)) {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.keypad-main-frame {
  width: var(--sh-numeric-keypad-width);
  height: var(--sh-numeric-keypad-height);
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: space-between;
}

.circle-buttons {
  transition: var(--transition-time) all ease-in-out, var(--hover-transition-time) background;
  border-radius: 50%;
  width: var(--sh-numeric-keypad-circle-button-width);
  height: var(--sh-numeric-keypad-circle-button-height);
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(var(--ui-1), var(--opacity-6));
  font: var(--header-2);
  color: var(--text-primary);
  cursor: pointer;
  user-select: none;
  -webkit-touch-callout: none;
  -ms-user-select: none;
  -moz-user-select: none;
  line-height: 1.5rem;
}

.circle-buttons[value="1"],
.circle-buttons[value="4"],
.circle-buttons[value="7"],
.circle-buttons[value="."] {
  margin-right: var(--sh-numeric-keypad-button-margins);
}

.circle-buttons[value="2"],
.circle-buttons[value="5"],
.circle-buttons[value="8"],
.circle-buttons[value="0"] {
  margin: var(--sh-numeric-keypad-button-center-margin);
}

.circle-buttons[value="3"],
.circle-buttons[value="6"],
.circle-buttons[value="9"],
.erase-button {
  margin-left: var(--sh-numeric-keypad-button-margins);
}

.erase-button {
  background-color: transparent;
}

:host(:not(.no-hovermq)) .circle-buttons:hover {
  background-color: rgba(var(--ui-1), var(--opacity-5));
}

.circle-buttons:active {
  background-color: rgba(var(--ui-1), var(--opacity-7));
}

:host([disabled]) .circle-buttons.dont-disable {
  pointer-events: all !important;
}

:host([disabled]) .circle-buttons:not(.dont-disable) {
  pointer-events: none;
  background-color: rgba(var(--ui-1), var(--opacity-7)) !important;
  color: rgba(var(--ui-1), var(--opacity-5));
}

:host([keypad][decimals="0"]) .circle-buttons.decimals-point {
  pointer-events: none;
  opacity: 0;
}

.footer-wrapper {
  position: relative;
  display: flex;
  justify-content: flex-end;
}`;class ri extends(fe(se)){static get properties(){return{visible:{type:Boolean,reflect:!0},condensed:{type:Boolean,reflect:!0},target:{type:String,reflect:!0},decimals:{type:String,reflect:!0},disabled:{type:Boolean,reflect:!0},europeanNumberConvention:{type:Boolean,reflect:!0,attribute:"european-number-convention"},_decimalSeparator:{type:String},_isKeypadButtonFocused:{type:Boolean}}}static get styles(){return[ae,ii]}render(){return V`
      <div class="functions-wrapper">
        <slot name="functions" id="functionsSlot" @slotchange=${this.addMargins}></slot>
      </div>
      <div class="keypad-main-frame">
        <div
          value="1"
          class="circle-buttons"
          tabindex=${this.disabled?-1:0}
          @click="${e=>{this._circleButtonClick(e)}}"
          @keyup="${e=>{this._EnterKeyIsPressedOnButton(e,e.target)}}"
          @keydown="${e=>{this._keyDownOnNumberOne(e)}}"
        >
          1
        </div>

        <div
          value="2"
          class="circle-buttons"
          tabindex=${this.disabled?-1:0}
          @click="${e=>{this._circleButtonClick(e)}}"
          @keyup="${e=>{this._EnterKeyIsPressedOnButton(e,e.target)}}"
        >
          2
        </div>

        <div
          value="3"
          class="circle-buttons"
          tabindex=${this.disabled?-1:0}
          @click="${e=>{this._circleButtonClick(e)}}"
          @keyup="${e=>{this._EnterKeyIsPressedOnButton(e,e.target)}}"
        >
          3
        </div>

        <div
          value="4"
          class="circle-buttons"
          tabindex=${this.disabled?-1:0}
          @click="${e=>{this._circleButtonClick(e)}}"
          @keyup="${e=>{this._EnterKeyIsPressedOnButton(e,e.target)}}"
        >
          4
        </div>

        <div
          value="5"
          class="circle-buttons"
          tabindex=${this.disabled?-1:0}
          @click="${e=>{this._circleButtonClick(e)}}"
          @keyup="${e=>{this._EnterKeyIsPressedOnButton(e,e.target)}}"
        >
          5
        </div>

        <div
          value="6"
          class="circle-buttons"
          tabindex=${this.disabled?-1:0}
          @click="${e=>{this._circleButtonClick(e)}}"
          @keyup="${e=>{this._EnterKeyIsPressedOnButton(e,e.target)}}"
        >
          6
        </div>

        <div
          value="7"
          class="circle-buttons"
          tabindex=${this.disabled?-1:0}
          @click="${e=>{this._circleButtonClick(e)}}"
          @keyup="${e=>{this._EnterKeyIsPressedOnButton(e,e.target)}}"
        >
          7
        </div>

        <div
          value="8"
          class="circle-buttons"
          tabindex=${this.disabled?-1:0}
          @click="${e=>{this._circleButtonClick(e)}}"
          @keyup="${e=>{this._EnterKeyIsPressedOnButton(e,e.target)}}"
        >
          8
        </div>

        <div
          value="9"
          class="circle-buttons"
          tabindex=${this.disabled?-1:0}
          @click="${e=>{this._circleButtonClick(e)}}"
          @keyup="${e=>{this._EnterKeyIsPressedOnButton(e,e.target)}}"
        >
          9
        </div>

        <div
          class="circle-buttons decimals-point dont-disable"
          tabindex="0"
          @click="${e=>{this._circleButtonClick(e)}}"
          @keyup="${e=>{this._EnterKeyIsPressedOnButton(e,e.target)}}"
          value="${this._decimalSeparator}"
        >
          ${this._decimalSeparator}
        </div>

        <div
          value="0"
          class="circle-buttons"
          tabindex=${this.disabled?-1:0}
          @click="${e=>{this._circleButtonClick(e)}}"
          @keyup="${e=>{this._EnterKeyIsPressedOnButton(e,e.target)}}"
        >
          0
        </div>

        <div
          class="circle-buttons erase-button dont-disable"
          tabindex="0"
          @click="${e=>{this._circleButtonClick(e)}}"
          @keyup="${e=>{this._EnterKeyIsPressedOnButton(e,e.target)}}"
          @keydown="${e=>{this._keyDownOnEraseButton(e)}}"
        >
          <sh-icon icon="delete-number" tabindex="-1"></sh-icon>
        </div>
      </div>
      <sh-divider class="divider" spacing="m"></sh-divider>
      <div class="footer-wrapper">
        <slot
          name="footer"
          id="footer"
          @slotchange=${this._hideOrDisplayDividerBasedOnFooter}
        ></slot>
      </div>
    `}constructor(){super(),this._decimalSeparator=".",this._isKeypadButtonFocused=!1}connectedCallback(){super.connectedCallback(),ue.isTouchDevice()&&this.classList.add("no-hovermq")}updated(e){super.updated(e),e.has("europeanNumberConvention")&&this._europeanNumberConventionObserver(),he(this,e,["visible","condensed","target","decimals","disabled","europeanNumberConvention"])}_circleButtonClick(e){const t="SH-ICON"===e.target.tagName||e.target.classList.contains("erase-button"),o={isEraseButton:t,keyValueString:t?"":e.target.getAttribute("value"),changeFocus:!this._isKeypadButtonFocused};le(this,"key-press",o),this._isKeypadButtonFocused=!1}_keyDownOnEraseButton(e){if(e.keyCode===me.TAB&&!e.shiftKey){const e=!0;this._slotNodesPresent(e)||le(this,"closing",null)}}_keyDownOnNumberOne(e){if(e.keyCode===me.TAB&&e.shiftKey){const e=!1;this._slotNodesPresent(e)||le(this,"closing",null)}}_slotNodesPresent(e){if(e){const e=this.shadowRoot.querySelector('[name="footer"]');if(null!==e&&0!==e.assignedNodes({flatten:!0}).length)return!0}else{const e=this.shadowRoot.querySelector('[name="functions"]');if(null!==e&&0!==e.assignedNodes({flatten:!0}).length)return!0}return!1}_EnterKeyIsPressedOnButton(e,t){"SH-ICON"!==e.srcElement.tagName&&(e.keyCode===me.ENTER&&!this.disabled||e.keyCode===me.ENTER&&t.classList.contains("dont-disable"))&&(t.focus(),this._isKeypadButtonFocused=!0,t.click())}_hideOrDisplayDividerBasedOnFooter(){0!==this.shadowRoot.querySelector("#footer").assignedNodes({flatten:!0}).length?this.shadowRoot.querySelector(".divider").style.display="initial":this.shadowRoot.querySelector(".divider").style.display="none"}addMargins(){const e=this.shadowRoot.querySelector(".functions-wrapper"),t=this.shadowRoot.querySelector("#functionsSlot").assignedNodes({flatten:!0});e.style.marginBottom=0!==t.length?"1rem":"0rem"}_europeanNumberConventionObserver(){"boolean"!=typeof this.europeanNumberConvention?this._decimalSeparator=ti:this._decimalSeparator=this.europeanNumberConvention?",":"."}}customElements.define("sh-numeric-keypad",ri);class si extends(fe(se)){static get properties(){return{label:{type:String,reflect:!0},value:{type:Number,reflect:!0},step:{type:Number,reflect:!0},readonly:{type:Boolean,reflect:!0},min:{type:Number,reflect:!0},max:{type:Number,reflect:!0},mandatory:{type:Boolean,reflect:!0},error:{type:Boolean,reflect:!0},success:{type:Boolean,reflect:!0},safety:{type:Boolean,reflect:!0},hint:{type:String,reflect:!0},condensed:{type:Boolean,reflect:!0},decimals:{type:Number,reflect:!0},keypad:{type:Boolean,reflect:!0},disabled:{type:Boolean,reflect:!0},errorMessage:{type:String,reflect:!0,attribute:"error-message"},noClear:{type:Boolean,reflect:!0,attribute:"no-clear"},noArrows:{type:Boolean,reflect:!0,attribute:"no-arrows"},inputDisabled:{type:Boolean,reflect:!0,attribute:"input-disabled"},keypadActive:{type:Boolean,reflect:!0,attribute:"keypad-active"},keypadDisabled:{type:Boolean,reflect:!0,attribute:"keypad-disabled"},noBorder:{type:Boolean,reflect:!0,attribute:"no-border"},noValidate:{type:Boolean,reflect:!0,attribute:"no-validate"},europeanNumberConvention:{type:Boolean,reflect:!0,attribute:"european-number-convention"},role:{type:String,reflect:!0},_displayValue:{type:String},_decimalSeparator:{type:String},_inputMode:{type:String},_cursorPosition:{type:Number}}}static get styles(){return[oi,ae]}render(){return V`
      <div style="display: flex; width: 100%">
        <sh-input-text
          .label=${this.label}
          id="input"
          .value=${this.value}
          ?error=${this.error}
          ?success=${this.success}
          ?safety=${this.safety}
          type="text"
          ?condensed="${this.condensed}"
          ?readonly="${this.readonly}"
          ?disabled="${this.disabled}"
          ?no-border="${this.noBorder}"
          ?no-clear="${this.noClear}"
          ?mandatory="${this.mandatory}"
          min="${this.min}"
          max="${this.max}"
          step="${this.step}"
          @click="${e=>{this._storeCursorPosition(e.target)}}"
          @input-clicked="${e=>{e.stopPropagation()}}"
          @input-focused="${e=>{e.stopPropagation(),this._inputFocus(e)}}"
          @input="${e=>{this.value=this.europeanNumberConvention?e.target.value.toString().split(",").join("."):e.target.value}}"
          @value-changed="${()=>{if(""!==this.value){let e=this.shadowRoot.querySelector("#input");e.shadowRoot.querySelector("#clear")&&e.shadowRoot.querySelector("#clear").setAttribute("tabindex","0")}!this.value&&this.keypadActive&&this.shadowRoot.querySelector("#input").classList.remove("empty")}}"
          ._notifyInputClick="${!0}"
          ._notifyInputFocus="${!0}"
          @clear-clicked="${()=>this._clearField()}"
          @keydown="${e=>{this._restrictOnlyNumberKeys(e),this.inputDisabled?e.preventDefault():this._closeKeypadIfBackTabbed(e)}}"
          @keyup="${()=>this._updateDisplayValue.bind(this)}"
          @focus="${()=>{this.keypad,this.shadowRoot.querySelector("sh-input-text").shadowRoot.querySelector("input").inputMode=this._inputMode}}"
          @blur="${e=>this._handleBlur(e)}"
          ><div class="icon-wrapper" style="display: flex;" slot="icon">
            ${this.noArrows||this.readonly?"":V` <sh-icon
                    button
                    icon="left-s"
                    id="minus"
                    ?disabled="${this.disabled}"
                    @keypress="${e=>this._releaseMinusCounter(e)}"
                    @mousedown="${e=>this._startMinusCounter(e)}"
                    @mouseup="${e=>this._releaseMinusCounter(e)}"
                    @touchstart="${e=>this._startMinusCounter(e)}"
                    @touchend="${e=>this._releaseMinusCounter(e)}"
                  ></sh-icon>
                  <sh-icon
                    button
                    icon="right-s"
                    id="plus"
                    ?disabled="${this.disabled}"
                    @keypress="${e=>this._releasePlusCounter(e)}"
                    @mousedown="${e=>this._startPlusCounter(e)}"
                    @mouseup="${e=>this._releasePlusCounter(e)}"
                    @touchstart="${e=>this._startPlusCounter(e)}"
                    @touchend="${e=>this._releasePlusCounter(e)}"
                  ></sh-icon>`}
          </div></sh-input-text
        >
        ${this.keypad?V`
              <sh-numeric-keypad
                @key-press="${e=>{this._updateInputBox(e,this.shadowRoot.querySelector("#input"))}}"
                @closing="${()=>{this._closeKeypadIfTabbed()}}"
                .target=${this}
                .disabled=${this.keypadDisabled}
                .visible=${this.keypadActive}
                .condensed=${this.condensed}
                .decimals=${this.decimals}
                .europeanNumberConvention=${this.europeanNumberConvention}
              >
                <slot name="functions" slot="functions"></slot>
                <slot name="footer" slot="footer"></slot>
              </sh-numeric-keypad>
            `:""}
      </div>
      ${this.hint&&!this.error?V`
            <sh-text size="body-2" class="helper-text hint" color="secondary">${this.hint}</sh-text>
          `:""}
      ${this.error&&this.errorMessage?V`
            <sh-text size="body-2" class="helper-text error-message" color="secondary"
              >${this.errorMessage}</sh-text
            >
          `:""}
    `}firstUpdated(){super.firstUpdated()}constructor(){super(),this.label="label",this.step=1,this.decimals="",this._decimalSeparator=".",this._inputMode="numeric",this._displayValue="",this.boundMove=this._releasePlusCounter.bind(this),this.closeListener=this._closeInputKeyPad.bind(this),this._rAFCallBack=this._showKeypad.bind(this)}updated(e){super.updated(e),e.has("value")&&this.valueChanged(),e.has("decimals")&&this._decimalsObserver(),e.has("inputDisabled")&&this._handleInputDisabledChange(),e.has("keypad")&&this._keypadObserver(),e.has("keypadActive")&&this._handleKeypadActive(),e.has("europeanNumberConvention")&&this._europeanNumberConventionObserver(),he(this,e,["label","value","step","readonly","disabled","min","max","mandatory","error","success","safety","hint","condensed","decimals","keypad","errorMessage","noClear","noArrows","inputDisabled","keypadActive","keypadDisabled","noBorder","noValidate","europeanNumberConvention","role"])}valueChanged(){if(this.value||0===this.value){this.classList.remove("empty"),this.shadowRoot.querySelector("#input").classList.remove("empty");let e=this.shadowRoot.querySelector("#input");if(e.shadowRoot.querySelector("#clear")&&e.shadowRoot.querySelector("#clear").setAttribute("tabindex","0"),this.value||0===this.value){const e=this.value.toString();if(""!==e&&e.indexOf(".")>-1){const t=e.split(".")[1].length;this.shadowRoot.querySelector("#input").step=Math.pow(10,-t)}let t;t=void 0===this.europeanNumberConvention||null===this.europeanNumberConvention?","===ti?"European":"English":this.europeanNumberConvention?"European":"English",this._displayValue="English"===t?this.value.toString().split(",").join("."):this.value.toString().split(".").join(",")}}else this.classList.add("empty"),this.shadowRoot.querySelector("#input").classList.add("empty"),this._displayValue="";this._displayValueChange()}connectedCallback(){super.connectedCallback(),ue.isTouchDevice()&&this.classList.add("touch-device"),document.body.addEventListener("mousemove",this.boundMove),this.addEventListener("blur",(()=>{this._validateOnBlurOnNormalInput()})),this._checkMaxMin(),this._renewStableValue(this.value),void 0!==this.europeanNumberConvention&&null!==this.europeanNumberConvention||this._setBrowserLanguageBasedEuropeanNumberConventionProperty(),this.value||0===this.value||this.classList.add("empty"),this.hasAttribute("role")||this.setAttribute("role","textbox"),this.addEventListener("keydown",(e=>{this._closeKeypadIfTabbedOnAppropriateElement(e)}))}getValue(){if(void 0!==this.value&&null!==this.value){const e=parseFloat(this.value.toString(),10);return isNaN(e)?"":e}}async _updateInputBox(e,t){const o=t.shadowRoot.querySelector("input"),i=e.detail.isEraseButton;let r;i||(r=Number(e.detail.keyValueString.toString()));const s=e.detail.keyValueString.toString(),n=this._displayValue?this._displayValue.toString():"",a=""!==s&&r>=0&&r<=9||"."===s||","===s;let c;this._cursorPosition=o.selectionStart,a&&(c=n.slice(0,this._cursorPosition)+s+n.slice(this._cursorPosition),this.value=c.toString().split(",").join("."),o.style.caretColor="transparent",setTimeout((()=>{o.setSelectionRange(this._cursorPosition+1,this._cursorPosition+1),o.style.caretColor="auto"}),0)),i&&0!==this._cursorPosition&&(c=n.slice(0,this._cursorPosition-1)+n.slice(this._cursorPosition),this.value=c.toString().split(",").join("."),o.style.caretColor="transparent",setTimeout((()=>{o.setSelectionRange(this._cursorPosition-1,this._cursorPosition-1),o.style.caretColor="auto"}),0)),this._cursorPosition=o.selectionStart,e.detail.changeFocus&&o.focus()}_closeKeypadIfTabbedOnAppropriateElement(e){const t=e.keyCode===me.TAB&&!e.shiftKey,o=e.keyCode===me.TAB&&e.shiftKey;if(t){const t=this.shadowRoot.querySelector('[name="footer"]');if(null===t)return;const o=t.assignedNodes({flatten:!0}),i=0!==o.length,r=this._determineForwardTabCheckingElement(i,o);this._closeKeypadIfForwardTabbedOnForwardTabElement(e,r)}else if(o){const t=this.shadowRoot.querySelector('[name="functions"]');if(null===t)return;const o=t.assignedNodes({flatten:!0}),i=0!==o.length,r=this._determineBackwardTabCheckingElement(i,o);this._closeKeypadIfBackwardTabbedOnBackwardTabElement(e,r)}}_closeKeypadIfTabbed(){this._closeKeypad(),this._finalCheck(),this._checkMaxMin()}_determineForwardTabCheckingElement(e,t){if(e)return t[t.length-1]}_determineBackwardTabCheckingElement(e,t){if(e)return t[0]}_closeKeypadIfForwardTabbedOnForwardTabElement(e,t){e.target===t&&(this._closeKeypad(),this._finalCheck(),this._checkMaxMin())}_closeKeypadIfBackwardTabbedOnBackwardTabElement(e,t){e.target===t&&(this._closeKeypad(),this._finalCheck(),this._checkMaxMin())}_clearValueIfEnterKeyPressed(e){e.keyCode===me.ENTER&&this._clearField(),this.style.outlineOffset="-0.125rem"}_storeCursorPosition(e){this._cursorPosition=e.selectionStart}_inputFocus(e){this.keypadActive||this._openKeypadIfAppropriate(),e.target.onkeydown=e=>{this.inputDisabled?e.preventDefault():this._addOrSubtractBasedOnKey(e)}}_handleBlur(e){(""!==this.value||e.currentTarget&&"SH-INPUT-TEXT"==e.currentTarget.tagName)&&this.keypadActive&&this.shadowRoot.querySelector("#input").classList.remove("empty")}_openKeypadIfAppropriate(){!this.keypad||this.readonly||this.disabled||this._openKeypad()}_openKeypad(){this.keypadActive=!0}_addOrSubtractBasedOnKey(e){switch(e.which){case 38:if(e.preventDefault(),this.disabled||this.readonly)return;this._handlePlus();break;case 40:if(e.preventDefault(),this.disabled||this.readonly)return;this._handleMinus()}}_closeKeypadIfBackTabbed(e){e.keyCode===me.TAB&&e.shiftKey&&"plus"!==e.target.id&&"minus"!==e.target.id&&(this._finalCheck(),this._checkMaxMin(),this._closeKeypad())}_finalCheck(){""===this.value||isNaN(this.value)?(this.shadowRoot.querySelector("#input").value=null,this.value=""):(this.value=Number(parseFloat(this.value)).toString(),this.decimals&&(this.value=Number(this.value).toFixed(Number(this.decimals)).toString()))}_validateOnBlurOnNormalInput(){this.noValidate||this._finalCheck(),this.inputDisabled||this._checkMaxMin(),this.readonly||(this.shadowRoot.querySelector("#input").readonly=!1)}_closeInputKeyPad(e){const t=this.shadowRoot.querySelector("#input").shadowRoot.querySelector("input");this._checkIfClickedOutsideKeypad(e)&&(this._validateOnBlurOnKeypadInput(t),this.blur())}_validateOnBlurOnKeypadInput(e){this._closeKeypad(),this._checkMaxMin(),this.readonly||(e.readonly=!1)}_closeKeypad(){this.keypadActive=!1,""==this.value&&this.shadowRoot.querySelector("#input").classList.add("empty")}_checkMaxMin(){if(void 0!==this.max||void 0!==this.min){const e=this._getNumberOfPrecision();self.value=Number(self.value).toFixed(e),""!==this.value&&Number(this.value)>Number(this.max)&&(this.value=""==this.decimals?this.max:Number(this.max).toFixed(e)),Number(this.value)<Number(this.min)&&(this.value=""==this.decimals?this.min:Number(this.min).toFixed(e))}}_checkIfClickedOutsideKeypad(e){let t;const o=e.composedPath().length;let i=this.shadowRoot.querySelector("#input");for(let r=0;r<o;r++){const o=e.composedPath()[r]===this.shadowRoot.querySelector("sh-numeric-keypad")||e.composedPath()[r]===i.shadowRoot.querySelector("input")||e.composedPath()[r]===this.shadowRoot.querySelector("#clear")||e.composedPath()[r]===this,s=e.composedPath()[r]===this.shadowRoot.querySelector(".functions-wrapper")||e.composedPath()[r]===this.shadowRoot.querySelector(".footer-wrapper"),n=e.composedPath()[r]===this.shadowRoot.querySelector(".divider"),a=e.composedPath()[r]===this.shadowRoot.querySelector(".host-wrapper");if(o||s||n||a){t=!1;break}t=!0}return t}_setBrowserLanguageBasedEuropeanNumberConventionProperty(){"120,94"===Number("120.94").toLocaleString()?this.europeanNumberConvention=!0:"120.94"===Number("120.94").toLocaleString()&&(this.europeanNumberConvention=!1)}_handleKeypadActive(){this.keypadActive?(this.inputDisabled&&(document.removeEventListener("keydown",this.keyDownListener),this.keyDownListener=this._closeOnInactive.bind(this),document.addEventListener("keydown",this.keyDownListener)),document.body.addEventListener("click",this.closeListener),document.body.addEventListener("touchstart",this.closeListener),le(this,"keypad-opened",this),clearTimeout(this._rAFFrameControlDelay),cancelAnimationFrame(this._positioningFrame),this._positioningFrame=window.requestAnimationFrame(this._rAFCallBack)):(document.removeEventListener("keydown",this.keyDownListener),document.body.removeEventListener("click",this.closeListener),document.body.removeEventListener("touchstart",this.closeListener),le(this,"keypad-closed",this),clearTimeout(this._rAFFrameControlDelay),cancelAnimationFrame(this._positioningFrame))}_closeOnInactive(){document.activeElement!==this&&this._closeKeypad()}_showKeypad(){this._rAFFrameControlDelay=setTimeout((()=>{clearTimeout(this._rAFFrameControlDelay),this._handleOffset(),this.keypadActive?this._positioningFrame=window.requestAnimationFrame(this._rAFCallBack):cancelAnimationFrame(this._positioningFrame)}),10)}_handleOffset(){const e=this.shadowRoot.querySelector("sh-numeric-keypad"),t=parseFloat(window.getComputedStyle(document.querySelector("html"),null).getPropertyValue("font-size"));e.style.left=this.offsetX/16+"rem";let o,i,r=this;for(;r.parentNode&&"body"!==r.parentNode.nodeName.toLowerCase();){if("none"!==getComputedStyle(r.parentNode).transform){o=!0,i=r.parentNode;break}o=!1,r=r.parentNode}this.offsetY=this.getBoundingClientRect().top;var s=this.getBoundingClientRect();if(this.offsetY+e.clientHeight+this.offsetHeight>window.innerHeight&&this.offsetY>e.clientHeight||this.isDropUp)if(e.style.left=s.left/t+"rem",e.style.top=o?(0-i.getBoundingClientRect().top+this.offsetY-e.clientHeight)/t+"rem":(this.offsetY-e.clientHeight)/t+"rem",s.left+e.offsetWidth+16>window.innerWidth){let o=(window.innerWidth-e.offsetWidth-16)/t+"rem";e.style.left=o}else e.style.left&&(e.style.left=s.left/t+"rem");else if(this.offsetY+e.clientHeight+this.offsetHeight<window.innerHeight)if(e.style.left=s.left/t+"rem",e.style.top=o?(0-i.getBoundingClientRect().top+this.offsetY+this.offsetHeight)/t+"rem":(this.offsetY+this.offsetHeight)/t+"rem",s.left+e.offsetWidth+16>window.innerWidth){let o=(window.innerWidth-e.offsetWidth-16)/t+"rem";e.style.left=o}else e.style.left&&(e.style.left=s.left/t+"rem");else if((s=this.getBoundingClientRect()).left>e.clientWidth)e.style.left=(s.left-e.clientWidth)/t+"rem",e.style.top=(window.innerHeight-e.clientHeight-16)/t+"rem";else if(s.left+this.offsetWidth+e.offsetWidth+16<window.innerWidth){let o=(s.left+this.offsetWidth)/t+"rem";e.style.left=o,e.style.top=(window.innerHeight-e.clientHeight-16)/t+"rem"}else{let o=(window.innerWidth-e.offsetWidth-16)/t+"rem";e.style.left=o}}_keypadObserver(){this.keypad?this._inputMode="none":this._inputMode="numeric"}_handleInputDisabledChange(){document.removeEventListener("keydown",this.keyDownListener),this.inputDisabled&&this.keypadActive&&(this.keyDownListener=this._closeOnInactive.bind(this),document.addEventListener("keydown",this.keyDownListener))}_decimalsObserver(){const e=Number(this.decimals);this.shadowRoot.querySelector("#input").step=Math.pow(10,-e)}_displayValueChange(){const e=!!this._displayValue;""===this._displayValue&&(this.shadowRoot.querySelector("#input").value=this._displayValue),e&&(this.shadowRoot.querySelector("#input").value=this._displayValue)}_restrictOnlyNumberKeys(e){if(this._checkIfValidInput(e)&&!this.inputDisabled){let t;t=void 0===this.europeanNumberConvention||null===this.europeanNumberConvention?","===ti?"European":"English":this.europeanNumberConvention?"European":"English","English"===t&&","===e.key&&e.preventDefault(),"European"===t&&"."===e.key&&e.preventDefault()}else e.preventDefault()}_checkIfValidInput(e){let t=!1;const o=e.key,i=["0","1","2","3","4","5","6","7","8","9","e","Shift","Enter","Tab","Backspace","Delete","Home","End","ArrowUp","ArrowDown","ArrowRight","ArrowLeft","-","+",",","=",".","Space"],r=i.length;for(let s=0;s<r;s++){if(o===i[s]){t=!0;break}if((e.metaKey||e.ctrlKey)&&-1!=[me.V,me.C,me.A,me.X,me.Z,me.Y].indexOf(e.keyCode)){t=!0;break}}return t}_updateDisplayValue(){this.value=this.value?this.value.toString().split(",").join("."):""}_clearField(){this.value=""}_startMinusCounter(e){this.shadowRoot.querySelector("#input").classList.remove("empty"),e.touches&&(this.skipMouseMove=!0),e.target.style.transition="0s all linear",this._releaseMinusCounter(),this._releasePlusCounter(),this.minusClock=setInterval(this._handleMinusOnMouseDown,120,this)}_startPlusCounter(e){this.shadowRoot.querySelector("#input").classList.remove("empty"),e.touches&&(this.skipMouseMove=!0),e.target.style.transition="0s all linear",this._releasePlusCounter(),this._releaseMinusCounter(),this.plusClock=setInterval(this._handlePlusOnMouseDown,120,this)}_releasePlusCounter(e=null){e&&"keypress"===e.type&&e.keyCode!==me.ENTER||(e&&"mousemove"===e.type&&this.skipMouseMove?this.skipMouseMove=!1:(this.plusIcon&&clearInterval(this.plusClock),this.minusIcon&&clearInterval(this.minusClock),clearInterval(this.plusClock),e&&"mousemove"!==e.type&&this._handlePlus(),e&&e.touches&&e.preventDefault()))}_releaseMinusCounter(e=null){e&&"keypress"===e.type&&e.keyCode!==me.ENTER||(e&&"mousemove"===e.type&&this.skipMouseMove?this.skipMouseMove=!1:(this.plusIcon&&clearInterval(this.plusClock),this.minusIcon&&clearInterval(this.minusClock),clearInterval(this.minusClock),e&&"mousemove"!==e.type&&this._handleMinus(),e&&e.touches&&e.preventDefault()))}_handlePlusOnMouseDown(e){if(e.disabled)e._releasePlusCounter();else{null!==e.value&&void 0!==e.value||(e.value=""),null!==e.step&&void 0!==e.step||(e.step="1");const t=e._getNumberOfPrecision();e.value=Number(e.step)+Number(e.value),e.value=Number(e.value).toFixed(t),e._checkMaxMin(),e._renewStableValue(e.value),e.minusIcon=!1,e.plusIcon=!0,le(e,"plusPressed",e),e.mouseDownAddition=!0}}_getNumberOfPrecision(){const e=this.value?this.value.toString():"";let t=!1,o=!1,i=0,r=0,s=0;this.step!==Math.round(this.step)&&(o=!0,r=(""+this.step).split(".")[1].length),e.includes(".")&&(t=!0,i=e.split(".")[1].length),(t||o)&&(s=r>i?r:i);const n=this.decimals,a=Number(n);return 0!==n.length&&a>0?(this.shadowRoot.querySelector("#input")&&(this.shadowRoot.querySelector("#input").step=Math.pow(10,-a)),a):(this.shadowRoot.querySelector("#input")&&(this.shadowRoot.querySelector("#input").step=Math.pow(10,-s)),s)}_handleMinusOnMouseDown(e){if(e.disabled)e._releaseMinusCounter();else{null!==e.value&&void 0!==e.value||(e.value=""),null!==e.step&&void 0!==e.step||(e.step="1");const t=e._getNumberOfPrecision();e.value=Number(e.value)-Number(e.step),e.value=Number(e.value).toFixed(t),e._checkMaxMin(),e._renewStableValue(e.value),e.plusIcon=!1,e.minusIcon=!0,le(e,"minusPressed",e),e.mouseDownSubtraction=!0}}_handlePlus(){if(!this.disabled){if(this.mouseDownAddition)return void(this.mouseDownAddition=!1);null!==this.value&&void 0!==this.value||(this.value=""),null!==this.step&&void 0!==this.step||(this.step="1");const e=this._getNumberOfPrecision();this.value=Number(this.step)+Number(this.value),this.value=Number(this.value).toFixed(e),this._checkMaxMin(),this._renewStableValue(this.value),le(this,"plusPressed",this)}this._releaseMinusCounter(),this._releasePlusCounter()}_handleMinus(){if(!this.disabled){if(this.mouseDownSubtraction)return void(this.mouseDownSubtraction=!1);null!==this.value&&void 0!==this.value||(this.value=""),null!==this.step&&void 0!==this.step||(this.step="1");const e=this._getNumberOfPrecision();this.value=Number(this.value)-Number(this.step),this.value=Number(this.value).toFixed(e),this._checkMaxMin(),this._renewStableValue(this.value),le(this,"minusPressed",this)}this._releaseMinusCounter(),this._releasePlusCounter()}_renewStableValue(e){let t=Number(e);this.min&&this.max?Number(this.value)>=Number(this.min)&&Number(this.value)<=Number(this.max)&&(this.stableValue=t):this.stableValue=t}_europeanNumberConventionObserver(){const e=this.europeanNumberConvention?".":",";this._decimalSeparator=this.europeanNumberConvention?",":".",this._displayValue&&(this._displayValue=this._displayValue.toString().split(e).join(this._decimalSeparator),this._displayValueChange())}disconnectedCallback(){this._rAFFrameControlDelay&&clearTimeout(this._rAFFrameControlDelay),this._positioningFrame&&cancelAnimationFrame(this._positioningFrame),this.keyDownListener&&document.removeEventListener("keydown",this.keyDownListener),document.body.removeEventListener("click",this.closeListener),document.body.removeEventListener("mousemove",this.boundMove),document.body.removeEventListener("click",this.closeListener),super.disconnectedCallback()}}customElements.define("sh-input-number",si),customElements.define("sh-menu-group",class extends se{static get properties(){return{selected:{type:String,reflect:!0},group:{type:String,reflect:!0},role:{type:String,reflect:!0}}}static get styles(){return[ie`
        :host {
          width: 100%;
          display: block;
        }

        .menu-wrapper {
          display: flex;
          flex-direction: column;
          width: 100%;
        }

        #grouped {
          flex: 1;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          overflow: hidden;
        }

        .menu-wrapper > ::slotted(sh-menu-item) {
          margin-top: 0.5rem;
        }
        .menu-wrapper > ::slotted(*:first-child) {
          margin-top: 0rem !important;
        }
        /* touch */
        @media (any-pointer: coarse) {
          .menu-wrapper > ::slotted(sh-menu-item) {
            margin-top: 1rem;
          }
        }
      `]}render(){return V`
      <div class="menu-wrapper">
        <slot id="grouped" @slotchange="${this._handleSlotChange}"></slot>
      </div>
    `}constructor(){super(),this.selected="defaultId",this.group="defaultGroup",this.role="listgroup"}connectedCallback(){super.connectedCallback(),this._handleMenuItemActiveChange=this._activeHandle.bind(this),this.addEventListener("clicked",this._handleMenuItemActiveChange)}_activeHandle(){let e;e=this.querySelectorAll("sh-menu-item[active]");for(let t=0;t<e.length;t++)e[t].removeAttribute("active")}_handleSlotChange(){for(let e=0;e<this.children.length;e++)this.children[e].hasAttribute("disabled")||this.children[e].setAttribute("tabindex","0")}disconnectedCallback(){this.removeEventListener("clicked",this._handleMenuItemActiveChange),super.disconnectedCallback()}});const ni=new Map;function ai(e){return e.hasAttribute("hidden")||e.hasAttribute("aria-hidden")&&"false"!==e.getAttribute("aria-hidden")||"none"===e.style.display||"0"===e.style.opacity||"hidden"===e.style.visibility||"collapse"===e.style.visibility}function ci(e){return"-1"!==e.getAttribute("tabindex")&&!ai(e)&&!function(e){return e.hasAttribute("disabled")||e.hasAttribute("aria-disabled")&&"false"!==e.getAttribute("aria-disabled")}(e)&&(e.hasAttribute("tabindex")||(e instanceof HTMLAnchorElement||e instanceof HTMLAreaElement)&&e.hasAttribute("href")||e instanceof HTMLButtonElement||e instanceof HTMLInputElement||e instanceof HTMLTextAreaElement||e instanceof HTMLSelectElement||e instanceof HTMLIFrameElement)}function li(e,t,o,i=20,r=0){let s=[];if(r>=i)return s;const n=e=>{const s=e.assignedNodes().filter((e=>1===e.nodeType));return s.length>0?li(s[0].parentElement,t,o,i,r+1):[]},a=Array.from(e.children||[]);for(const e of a)t(e)||(o(e)&&s.push(e),null!=e.shadowRoot?s.push(...li(e.shadowRoot,t,o,i,r+1)):"SLOT"===e.tagName?s.push(...n(e)):s.push(...li(e,t,o,i,r+1)));return s}const hi=document.createElement("template");hi.innerHTML='\n\t<div id="start"></div>\n\t<div id="backup"></div>\n\t<slot></slot>\n\t<div id="end"></div>\n';class di extends HTMLElement{constructor(){super(),this.debounceId=Math.random().toString(),this._focused=!1;const e=this.attachShadow({mode:"open"});e.appendChild(hi.content.cloneNode(!0)),this.$backup=e.querySelector("#backup"),this.$start=e.querySelector("#start"),this.$end=e.querySelector("#end"),this.focusLastElement=this.focusLastElement.bind(this),this.focusFirstElement=this.focusFirstElement.bind(this),this.onFocusIn=this.onFocusIn.bind(this),this.onFocusOut=this.onFocusOut.bind(this)}static get observedAttributes(){return["inactive"]}get inactive(){return this.hasAttribute("inactive")}set inactive(e){e?this.setAttribute("inactive",""):this.removeAttribute("inactive")}get focused(){return this._focused}connectedCallback(){this.$start.addEventListener("focus",this.focusLastElement),this.$end.addEventListener("focus",this.focusFirstElement),this.addEventListener("focusin",this.onFocusIn),this.addEventListener("focusout",this.onFocusOut),this.render()}disconnectedCallback(){this.$start.removeEventListener("focus",this.focusLastElement),this.$end.removeEventListener("focus",this.focusFirstElement),this.removeEventListener("focusin",this.onFocusIn),this.removeEventListener("focusout",this.onFocusOut)}attributeChangedCallback(){this.render()}focusFirstElement(){this.trapFocus()}focusLastElement(){this.trapFocus(!0)}getFocusableElements(){return li(this,ai,ci)}trapFocus(e){if(this.inactive)return;let t=this.getFocusableElements();t.length>0?(e?t[t.length-1].focus():t[0].focus(),this.$backup.setAttribute("tabindex","-1")):(this.$backup.setAttribute("tabindex","0"),this.$backup.focus())}onFocusIn(){this.updateFocused(!0)}onFocusOut(){this.updateFocused(!1)}updateFocused(e){!function(e,t,o){const i=ni.get(o);null!=i&&window.clearTimeout(i),ni.set(o,window.setTimeout((()=>{e(),ni.delete(o)}),0))}((()=>{this.focused!==e&&(this._focused=e,this.render())}),0,this.debounceId)}render(){this.$start.setAttribute("tabindex",!this.focused||this.inactive?"-1":"0"),this.$end.setAttribute("tabindex",!this.focused||this.inactive?"-1":"0"),this.focused?this.setAttribute("focused",""):this.removeAttribute("focused")}}window.customElements.define("focus-trap",di),customElements.define("sh-modal",class extends se{static get properties(){return{label:{type:String,reflect:!0},icon:{type:String,reflect:!0},type:{type:String,reflect:!0},modalHeight:{type:String,reflect:!0,attribute:"modal-height"},modalWidth:{type:String,reflect:!0,attribute:"modal-width"},visible:{type:Boolean,reflect:!0},sticky:{type:Boolean,reflect:!0},_emptyFooter:{type:Boolean},_emptyHeader:{type:Boolean},iconColor:{type:String,reflect:!0,attribute:"icon-color"}}}static get styles(){return[ae,ie`
        :host {
          visibility: hidden;
          position: fixed;
          top: 0rem;
          left: 0rem;
          width: 100%;
          height: 0rem;
          max-height: 0rem;
          overflow: hidden;
          opacity: 0;
          z-index: 5;
          align-items: center;
          justify-content: center;
          display: flex;
          outline: transparent;
          background: rgba(0, 0, 0, 0.4); /* Modal Background (UI 1 - Light / UI 7 - Dark) */
          transition: var(--transition-time) all ease-in-out,
            0s height ease-in-out var(--transition-time),
            0s max-height ease-in-out var(--transition-time), 0s visibility linear 0s;
        }

        :host([visible]) {
          visibility: visible;
          opacity: 1;
          height: 100%;
          max-height: 100%;
          transition: var(--transition-time) all ease-in-out var(--transition-time),
            0s height ease-in-out, 0s max-height ease-in-out, 0s visibility linear 0s;
        }

        :host([visible]) .modal-wrapper {
          transform: none;
          transition: var(--transition-time) all ease-in-out var(--transition-time);
        }

        .modal-wrapper {
          transition: var(--transition-time) all ease-in-out;
          transform: translateY(2.5rem);
          background: var(--base-3);
          box-shadow: var(--shadow-navigation);
          display: flex;
          flex-direction: column;
          border-radius: 0.125rem;
          z-index: 5;
          position: relative;
        }

        .focus-wrapper {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          overflow: auto;
        }

        .label-wrapper {
          display: flex;
          flex-direction: row;
          padding: 1rem;
          align-items: center;
          min-height: fit-content;
          min-height: -ms-fit-content;
          min-height: -moz-fit-content;
        }

        .modal-label {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: var(--text-primary);
          font: var(--header-2);
          line-height: 1.5rem;
          flex: 1;
          -webkit-font-smoothing: antialiased;
          text-rendering: optimizeLegibility;
          -moz-osx-font-smoothing: grayscale;
        }

        .close-button-2 {
          margin: 1rem 1rem 0rem 0.5rem;
        }

        .functions-wrapper {
          display: flex;
          flex-direction: row;
          align-items: center;
        }

        .functions-wrapper > ::slotted(*),
        .footer-wrapper > ::slotted(*) {
          margin-left: 0.5rem;
        }

        .header-wrapper {
          display: flex;
          flex-direction: row;
        }

        .header-slot-wrapper > ::slotted(:not(sh-tabs)) {
          margin: 1rem;
        }

        .header-slot-wrapper > ::slotted(sh-tabs) {
          margin-bottom: 1rem;
        }

        .header-slot-wrapper {
          flex: 1 1 0%;
          display: flex;
          overflow: hidden;
        }

        .body-wrapper {
          flex: 1;
          padding: 1rem;
          box-sizing: border-box;
          display: block;
          flex-direction: column;
          overflow: auto;
          font: var(--body-1);
          color: var(--text-primary);
          line-height: 1.25rem;
        }

        .body-wrapper > ::slotted(*) {
          margin-bottom: 0.5rem;
        }

        .footer-wrapper {
          min-height: fit-content;
          min-height: -ms-fit-content;
          min-height: -moz-fit-content;
          padding: 1rem;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: flex-end;
          align-items: center;
        }

        .footer-wrapper > ::slotted(*) {
          color: var(--text-primary);
          font: var(--body-2);
          line-height: 1rem;
        }

        .close-button {
          transition: var(--transition-time) all ease-in-out;
          margin-left: 0.5rem;
        }

        .modal-wrapper[empty-header] .header-wrapper {
          display: none;
        }

        :host(:not([label])) .label-wrapper {
          display: none;
        }

        .modal-wrapper[empty-footer] .footer-wrapper {
          display: none;
        }

        .modal-wrapper:not([empty-header]) .label-wrapper {
          display: none;
        }

        .modal-wrapper:not([empty-header]) .body-wrapper,
        :host([label]) .body-wrapper {
          padding-top: 0rem;
        }

        .modal-wrapper:not([empty-footer]) .body-wrapper {
          padding-bottom: 0rem;
        }

        /* Modal Type Styles */
        .modal-wrapper .label-wrapper sh-icon:not(.close-button) {
          margin-right: 0.5rem;
          margin-left: 0rem;
        }

        /* touch */
        @media (any-pointer: coarse) {
          .functions-wrapper > ::slotted(*),
          .footer-wrapper > ::slotted(*) {
            margin-left: 1rem;
          }
        }

        .body-wrapper > ::slotted(sh-badge) {
          display: block;
        }
      `]}render(){return V`
      <div
        class="modal-wrapper"
        style="height: ${this.modalHeight}; width: ${this.modalWidth}"
        ?empty-header=${this._emptyHeader}
        ?empty-footer=${this._emptyFooter}
      >
        <focus-trap class="focus-wrapper">
          <div class="label-wrapper">
            ${this.icon?V` <sh-icon
                  icon="${this.icon}"
                  .color="${this.iconColor}"
                  class="modal-icon"
                  size="s"
                ></sh-icon>`:""}
            ${"error"===this.type?V` <sh-icon icon="error" size="s"></sh-icon>`:""}
            ${"alert"===this.type||"warning"===this.type?V` <sh-icon icon="warning" size="s"></sh-icon>`:""}
            ${"confirmation"===this.type||"success"===this.type?V` <sh-icon icon="success" size="s"></sh-icon>`:""}
            <div class="modal-label">${this.label}</div>
            <div class="functions-wrapper">
              <slot name="functions"></slot>
              ${this.sticky?"":V` <sh-icon
                    button
                    icon="cancel"
                    class="close-button"
                    size="s"
                    @click="${()=>this._closeModal()}"
                  ></sh-icon>`}
            </div>
          </div>
          <div class="header-wrapper">
            <div class="header-slot-wrapper">
              <slot
                name="header"
                class="header"
                @slotchange="${e=>this._updateSlotFlag(e.target,"_emptyHeader")}"
              ></slot>
            </div>
            ${this.sticky?"":V` <sh-icon
                  button
                  icon="cancel"
                  class="close-button-2"
                  size="s"
                  @click="${()=>this._closeModal()}"
                ></sh-icon>`}
          </div>
          <div class="body-wrapper">
            <slot></slot>
          </div>
          <div class="footer-wrapper">
            <slot
              name="footer"
              class="footer"
              @slotchange="${e=>this._updateSlotFlag(e.target,"_emptyFooter")}"
            ></slot>
          </div>
        </focus-trap>
      </div>
    `}constructor(){super(),this.modalHeight="30rem",this.modalWidth="30rem",this.visible=!1,this._emptyFooter=!0,this._emptyHeader=!0}connectedCallback(){super.connectedCallback(),this.hasAttribute("role")||this.setAttribute("role","dialog"),this.hasAttribute("tabindex")||this.setAttribute("tabindex","0")}updated(e){e.has("visible")&&this._handleVisibleChanged(),he(this,e,["label","visible","type","icon","sticky","modalHeight","modalWidth"])}firstUpdated(){this.addEventListener("mousedown",this._closeNonstickyModal),this.addEventListener("dblclick",this._closeNonstickyModal);const e=this.shadowRoot.querySelector(".modal-wrapper");e.addEventListener("mousedown",(function(e){e.stopPropagation()})),e.addEventListener("dblclick",(function(e){e.stopPropagation()})),this._keyEventHandler=this._handleKeyup.bind(this)}_updateSlotFlag(e,t){const o=e.assignedNodes({flatten:!0}).length;this[t]=0===o}_handleVisibleChanged(){this.visible?(this.focus(),this.shadowRoot.querySelector(".modal-wrapper").style.outline="0",document.addEventListener("keyup",this._keyEventHandler)):document.removeEventListener("keyup",this._keyEventHandler)}_handleKeyup(e){e.stopPropagation(),e.keyCode===me.ESCAPE&&this._closeNonstickyModal(),e.keyCode===me.TAB&&(this.contains(e.target)||this.focus())}_closeNonstickyModal(){this.sticky||this._closeModal()}_closeModal(){this.visible=!1,le(this,"modal-closed")}disconnectedCallback(){document.removeEventListener("keyup",this._keyEventHandler),super.disconnectedCallback()}});var pi=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-nav-bar-nav-bar-wrapper-height=3.5rem] - height of nav bar wrapper
   */
  --sh-nav-bar-nav-bar-wrapper-height: 3.5rem;
  /* 
   * @cssprop [--sh-nav-bar-condensed-nav-bar-wrapper-height=2.5rem] - height of condensed nav bar wrapper height
   */
  --sh-nav-bar-condensed-nav-bar-wrapper-height: 2.5rem;
  /* 
   * @cssprop [--sh-nav-bar-functions-wrapper-gap=0.5rem] - gap of functions wrapper
   */
  --sh-nav-bar-functions-wrapper-gap: 0.5rem;
  /* 
   * @cssprop [--sh-nav-bar-functions-wrapper-padding=0 0 0 0.5rem] - padding of functions wrapper
   */
  --sh-nav-bar-functions-wrapper-padding: 0 0 0 0.5rem;
  /* 
   * @cssprop [--sh-nav-bar-nav-bar-wrapper-padding=0 1rem] - padding of nav-bar-wrapper
   */
  --sh-nav-bar-nav-bar-wrapper-padding: 0 1rem;
}

:host {
  background-color: var(--base-2);
  transition: var(--transition-time) all ease-in-out;
  box-shadow: var(--shadow-navigation);
  z-index: 3;
  width: 100%;
  overflow: auto;
  display: block;
  flex-shrink: 0;
}

.nav-bar-wrapper {
  height: var(--sh-nav-bar-nav-bar-wrapper-height);
  width: 100%;
  padding: var(--sh-nav-bar-nav-bar-wrapper-padding);
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
}

:host([slot=footer]) .tabs-wrapper {
  flex: none;
  margin: auto;
}

.tabs-wrapper {
  flex: 1;
  display: flex;
  overflow: hidden;
  height: 100%;
  align-items: center;
}

.tabs-wrapper > ::slotted(sh-tabs) {
  margin: -1rem 0;
}

.functions-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: var(--sh-nav-bar-functions-wrapper-padding);
  gap: var(--sh-nav-bar-functions-wrapper-gap);
}

:host([condensed]) .nav-bar-wrapper {
  height: var(--sh-nav-bar-condensed-nav-bar-wrapper-height);
}`;customElements.define("sh-nav-bar",class extends se{static get properties(){return{role:{type:String,reflect:!0},condensed:{type:Boolean,reflect:!0}}}static get styles(){return[ae,pi]}render(){return V`
      <div class="nav-bar-wrapper">
        <div class="tabs-wrapper">
          <slot id="tabs" @slotchange=${()=>this.tabsSlotUpdated()}></slot>
        </div>
        <div class="functions-wrapper">
          <slot name="functions" id="functions"></slot>
        </div>
      </div>
    `}firstUpdated(){this.hasAttribute("role")||this.setAttribute("role","button")}tabsSlotUpdated(){const e=this.querySelectorAll("sh-tabs");if("nav"===this.slot)for(let t=0;t<e.length;t++)e[t]._navContext=!0;if("footer"===this.slot)for(let t=0;t<e.length;t++)e[t]._footerContext=!0;this._handleCondensed()}updated(e){e.has("condensed")&&this._handleCondensed()}_handleCondensed(){const e=this.querySelectorAll("sh-tab-item");this.querySelectorAll("sh-tabs").forEach((e=>{e.condensed=this.condensed})),e.forEach((e=>{e.condensed=this.condensed}))}});var ui=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-notification-item-header-margin=1rem 1rem 0 1rem] - margin of header area
   */
  --sh-notification-item-header-margin: 1rem 1rem 0 1rem;
  /* 
   * @cssprop [--sh-notification-item-header-icon-margin=0 0.5rem 0 0] - margin of header icon
   */
  --sh-notification-item-header-icon-margin: 0 0.5rem 0 0;
  /* 
   * @cssprop [--sh-notification-item-header-line-height=1.5rem] - header line height
   */
  --sh-notification-item-header-line-height: 1.5rem;
  /* 
   * @cssprop [--sh-notification-item-header-max-height=3rem] - header max height
   */
  --sh-notification-item-header-max-height: 3rem;
  /* 
   * @cssprop [--sh-notification-item-header-text-margin=0 0.5rem 0 0] - margin of header text
   */
  --sh-notification-item-header-text-margin: 0 0.5rem 0 0;
  /* 
   * @cssprop [--sh-notification-item-header-close-button-margin=0] - margin of header close button
   */
  --sh-notification-item-header-close-button-margin: 0;
  /* 
   * @cssprop [--sh-notification-item-description-container-margin=1rem] - margin of description container
   */
  --sh-notification-item-description-container-margin: 1rem;
  /* 
   * @cssprop [--sh-notification-item-no-label-description-container-margin=1rem] - margin of description container when there is no label
   */
  --sh-notification-item-no-label-description-container-margin: 1rem;
  /* 
   * @cssprop [--sh-notification-item-description-icon-margin=0 0.5rem 0 0] - margin of description icon
   */
  --sh-notification-item-description-icon-margin: 0 0.5rem 0 0;
  /* 
   * @cssprop [--sh-notification-item-description-line-height=1.5rem] - description line height
   */
  --sh-notification-item-description-line-height: 1.5rem;
  /* 
   * @cssprop [--sh-notification-item-description-text-margin=0 0.5rem 0 0] - description text margin
   */
  --sh-notification-item-description-text-margin: 0 0.5rem 0 0;
  /* 
   * @cssprop [--sh-notification-item-description-close-button-margin=0rem] - margin of description close button
   */
  --sh-notification-item-description-close-button-margin: 0rem;
  /* 
   * @cssprop [--sh-notification-item-footer-margin=0 1rem 1rem 1rem] - margin of footer area
   */
  --sh-notification-item-footer-margin: 0 1rem 1rem 1rem;
  /* 
   * @cssprop [--sh-notification-item-footer-margin-with-no-description=1rem] - footer margin when no description is preset
   */
  --sh-notification-item-footer-margin-with-no-description: 1rem;
  /* 
   * @cssprop [--sh-notification-item-description-slot-elements-margin-top=0rem] - margin between elements added in description slot
   */
  --sh-notification-item-description-slot-elements-margin-top: 0rem;
  /* 
   * @cssprop [--sh-notification-item-badge-margin=0.5rem 1rem 0.5rem 1rem] - margin for the notification badge
   */
  --sh-notification-item-badge-margin: 0.5rem 1rem 0.5rem 1rem;
  /* 
   * @cssprop [--sh-notification-item-footer-slot-child-margin-left=0.5rem] - margin-left for the components in the footer slot
   */
  --sh-notification-item-footer-slot-child-margin-left: 0.5rem;
}

:host {
  width: 100%;
  height: auto;
  height: -ms-fit-content;
  height: -moz-fit-content;
  background: var(--base-4);
  box-shadow: var(--shadow-overlay);
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  border-radius: 0.125rem;
  box-sizing: border-box;
  overflow: hidden;
  transition: var(--transition-time) all ease-in-out, 0s max-height ease-in-out, 0s width ease-in-out, 0s padding ease-in-out, 0s margin ease-in-out;
}

/* flat */
:host([flat]) {
  background: transparent;
  box-shadow: var(--shadow-flat);
}

:host([inline]) {
  background: rgba(var(--ui-1), var(--opacity-7));
  box-shadow: none;
  border-left: 4px solid rgba(var(--ui-1), var(--opacity-3));
  transition: none;
}

:host([inline][type=alert]),
:host([inline][type=warning]) {
  border-left: 4px solid rgb(var(--functional-yellow));
}

:host([inline][type=confirmation]),
:host([inline][type=success]) {
  border-left: 4px solid rgb(var(--functional-green));
}

:host([inline][type=error]) {
  border-left: 4px solid rgb(var(--functional-red));
}

:host([flat]:hover) {
  background: rgba(var(--ui-1), var(--opacity-7));
}

/* hidden */
:host(:not([visible])) {
  max-height: 0rem;
  min-height: unset;
  width: 0rem;
  padding: 0;
  margin: 0 !important;
  pointer-events: none;
  transform: translateX(5rem);
  opacity: 0;
  transition: var(--transition-time) all ease-in-out, 0s max-height ease-in-out var(--transition-time), 0s width ease-in-out var(--transition-time), 0s padding ease-in-out var(--transition-time), 0s margin ease-in-out var(--transition-time);
}

:host(:not([visible])[inline]) {
  transition: none;
}

/* header */
.header-wrapper {
  display: flex;
  margin: var(--sh-notification-item-header-margin);
}

.header-wrapper > sh-icon:not([icon=cancel]) {
  margin: var(--sh-notification-item-header-icon-margin);
}

.header-wrapper > sh-text {
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: var(--sh-notification-item-header-line-height);
  max-height: var(--sh-notification-item-header-max-height);
  margin: var(--sh-notification-item-header-text-margin);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
}

.default {
  margin: var(--sh-notification-item-description-container-margin);
}

:host(:not([label])) .default {
  display: flex;
  flex-direction: row-reverse;
  margin: var(--sh-notification-item-no-label-description-container-margin);
}

.default > sh-icon:not([icon=cancel]) {
  margin: var(--sh-notification-item-description-icon-margin);
}

/* body */
sh-text[size=body-1] {
  line-height: var(--sh-notification-item-description-line-height);
}

:host(:not([label])) sh-text[size=body-1] {
  line-height: var(--sh-notification-item-description-line-height);
  margin: var(--sh-notification-item-description-text-margin);
}

sh-text[size=body-1] > ::slotted(*:first-child),
sh-text[size=body-1] > ::slotted(sh-menu-item) {
  margin-top: 0rem;
}

sh-text[size=body-1] > ::slotted(*) {
  margin-top: var(--sh-notification-item-description-slot-elements-margin-top);
}

/* footer */
.footer-wrapper {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  margin: var(--sh-notification-item-footer-margin);
}

.footer-wrapper[empty-footer] {
  display: none;
}

.footer-wrapper > ::slotted(*) {
  margin-left: var(--sh-notification-item-footer-slot-child-margin-left);
}

/* no label */
:host(:not([label])) sh-text[body-1] {
  margin-right: 2.5rem;
  margin-top: -2.5rem;
  width: calc(100% - 2.5rem);
}

:host(:not([label])[type]) sh-text[body-1] {
  margin-left: 2.5rem;
  width: calc(100% - 5rem);
}

.badge {
  margin: var(--sh-notification-item-badge-margin);
}`;customElements.define("sh-notification-item",class extends se{static get properties(){return{label:{type:String,reflect:!0},message:{type:String,reflect:!0},type:{type:String,reflect:!0},visible:{type:Boolean,reflect:!0},duration:{type:String,reflect:!0},sticky:{type:Boolean,reflect:!0},icon:{type:String,reflect:!0},flat:{type:Boolean,reflect:!0},new:{type:Boolean,reflect:!0},inline:{type:Boolean,reflect:!0},iconColor:{type:String,reflect:!0,attribute:"icon-color"},_emptyFooter:{type:Boolean,reflect:!0}}}static get styles(){return[ui,ae]}render(){return V`
      ${this.label?this.createHeaderWrapper():""} ${this.getDescription()}
      <div class="footer-wrapper" ?empty-footer=${this._emptyFooter}>
        <slot
          id="footer"
          name="footer"
          @slotchange="${e=>this._updateFooterSlot(e.target)}"
        ></slot>
      </div>
    `}constructor(){super(),this._emptyFooter=!0}createHeaderWrapper(){return V`
      <div class="header-wrapper">
        ${this.icon&&"alert"!==this.type&&"confirmation"!==this.type&&"error"!==this.type?V` <sh-icon
              icon="${this.icon}"
              .color="${this.iconColor}"
              id="notification-icon"
              size="s"
            ></sh-icon>`:""}
        ${"error"===this.type?V`<sh-icon icon="error" class="type-icon-error" size="s"></sh-icon>`:""}
        ${"alert"===this.type||"warning"===this.type?V`<sh-icon icon="warning" class="type-icon-warning" size="s"></sh-icon>`:""}
        ${"confirmation"===this.type||"success"===this.type?V`<sh-icon icon="success" class="type-icon-success" size="s"></sh-icon>`:""}
        ${this.label?V`<sh-text size="header-2" id="label">${this.label}</sh-text>`:""}
        ${this.new?V`<sh-badge class="badge"></sh-badge>`:""}
        ${!this.sticky&&this.label?V`<sh-icon
              button
              icon="cancel"
              size="s"
              tabindex="0"
              @click="${()=>this._fireClosevent()}"
              id="close-button"
            ></sh-icon>`:""}
      </div>
    `}getDescription(){return V` <div class="default">
      ${this.sticky||this.label?"":V`
            <sh-icon
              button
              icon="cancel"
              size="s"
              tabindex="0"
              @click="${()=>this._fireClosevent()}"
              id="close-button-2"
            ></sh-icon>
            ${this.new?V`<sh-badge class="badge"></sh-badge>`:""}
          `}
      <sh-text size="body-1"> ${this.message?this.message:V` <slot></slot> `} </sh-text>
      ${this.label?"":this.getBodyIcon()}
    </div>`}getBodyIcon(){return V`
      ${this.icon&&"alert"!==this.type&&"confirmation"!==this.type&&"error"!==this.type?V` <sh-icon icon="${this.icon}" id="notification-icon" size="s"></sh-icon>`:""}
      ${"error"===this.type?V`<sh-icon icon="error" class="type-icon-error" size="s"></sh-icon>`:""}
      ${"alert"===this.type||"warning"===this.type?V`<sh-icon icon="warning" class="type-icon-warning" size="s"></sh-icon>`:""}
      ${"confirmation"===this.type||"success"===this.type?V`<sh-icon icon="success" class="type-icon-success" size="s"></sh-icon>`:""}
    `}_updateFooterSlot(e){const t=e.assignedNodes({flatten:!0}).length;this._emptyFooter=0===t}_fireClosevent(){this.visible=!1,le(this,"close")}updated(e){e.has("visible")&&this._autoClose(),he(this,e,["label","icon","type","message","visible","sticky","flat","new"])}_autoClose(){"short"===this.duration&&this.visible&&(this._delay=setTimeout((()=>{this._fireClosevent(),clearTimeout(this._delay)}),2e3)),"long"===this.duration&&this.visible&&(this._delay=setTimeout((()=>{this._fireClosevent(),clearTimeout(this._delay)}),5e3))}});var mi=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-notification-width=20rem] - width of notification
   */
  --sh-notification-width: 20rem;
}

:host {
  height: fit-content;
  height: -ms-fit-content;
  height: -moz-fit-content;
  width: var(--sh-notification-width);
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 5;
}

/* positions */
:host,
:host([position=top-right]) {
  top: 1rem;
  bottom: auto;
  left: auto;
  right: 1rem;
}

:host([position=top-left]) {
  top: 1rem;
  bottom: auto;
  left: 1rem;
  right: auto;
}

:host([position=bottom-right]) {
  top: auto;
  bottom: 1rem;
  left: auto;
  right: 1rem;
}

:host([position=bottom-left]) {
  top: auto;
  bottom: 1rem;
  left: 1rem;
  right: auto;
}

:host([position=top-right]) ::slotted(*),
:host([position=top-left]) ::slotted(*) {
  margin-bottom: 0.5rem;
}

:host([position=bottom-right]) ::slotted(*),
:host([position=bottom-left]) ::slotted(*) {
  margin-top: 0.5rem;
}

/* mobile */
:host([mobile][position=top-right]),
:host([mobile][position=top-left]) {
  top: 4.5rem;
}

:host([mobile]) {
  width: calc(100% - 2rem);
}`;class fi extends(nt(se)){static get properties(){return{position:{type:String,reflect:!0},mobile:{type:Boolean,reflect:!0}}}static get styles(){return[ae,mi]}render(){return V` <slot></slot> `}constructor(){super(),this.position="top-right"}handleResize(){this.mobile=ke.valueMatches(document.documentElement.clientWidth,"<",640)}}customElements.define("sh-notifications",fi);class gi{static setHTMLAttribute(e,t){document.documentElement.setAttribute(e,t)}static removeHTMLAttribute(e){document.documentElement.removeAttribute(e)}}const bi=(e,{activationProp:t="pulltorefresh",refreshingProp:o="refreshing"}={})=>class extends e{static get properties(){return{[t]:{type:Boolean,reflect:!0},[o]:{type:Boolean,reflect:!0}}}static get styles(){return[ie`
          :host([${oe(t)}]) .spinner-parent-element {
            overflow-y: scroll;
            display: flex;
            flex-direction: column;
            scroll-snap-align: end;
            scroll-snap-type: y mandatory;
          }
          :host([${oe(t)}]) .spinner-parent-element::-webkit-scrollbar {
            display: none;
          }
          :host([${oe(t)}]) .ptr-area + * {
            scroll-snap-align: start;
            min-height: 100%;
          }
          :host([${oe(t)}]) .ptr-area {
            width: 100%;
            padding-top: 1rem;
          }
          :host([${oe(t)}][${oe(o)}]) .spinner-parent-element {
            scroll-snap-type: none;
          }
        `]}renderSpinner(e){return V`
        <sh-spinner class="ptr-area" size="s"></sh-spinner>
        <div class="body-element">${e}</div>
      `}connectedCallback(){super.connectedCallback()}_pullToRefresh(){this.shadowRoot.querySelector("sh-spinner").parentElement.scrollTop<=0?this[o]=!0:this[o]=!1}updated(e){if(super.updated(e),this[t]){const e=this.shadowRoot.querySelector("sh-spinner").parentElement;e.addEventListener("scroll",this._pullToRefresh.bind(this)),!e.classList.contains("spinner-parent-element")&&(e.className+=" spinner-parent-element")}else{const e=this.shadowRoot.querySelector(".spinner-parent-element");e&&e.classList.remove("spinner-parent-element"),this[o]=!1}}};class vi extends(bi(se)){static get properties(){return{theme:{type:String,reflect:!0},scrollable:{type:Boolean,reflect:!0},flat:{type:Boolean,reflect:!0},dicom:{type:Boolean,reflect:!0},noPadding:{type:Boolean,reflect:!0,attribute:"no-padding"}}}static get styles(){return[ae,super.styles,ie`
        :host {
          width: 100%;
          height: 100%;
          display: block;
        }

        :host([sh-vrt-mode]) {
          width: initial;
          height: initial;
          display: inline-block;
        }

        :host([sh-vrt-mode]) .page-content {
          /* background-color: initial; */
        }

        .page-wrapper {
          display: flex;
          flex-direction: column;
          width: 100%;
          height: 100%;
        }

        .page-content {
          display: flex;
          flex: 1;
          flex-direction: row;
          background-color: var(--base-1);
          transition: var(--transition-time) all ease-in-out;
          overflow: hidden;
        }

        :host([flat]) .page-content {
          background-color: var(--base-3);
        }

        .main-wrapper {
          overflow-y: auto;
          height: 100%;
          width: 100%;
        }

        .body-wrapper {
          flex: 1;
          height: 100%;
          overflow: hidden;
          padding: 1rem;
          box-sizing: border-box;
          position: relative;
          display: flex;
          justify-content: center;
        }
        .body-wrapper[scrollable] {
          min-height: fit-content;
          min-height: -ms-fit-content;
          min-height: -moz-fit-content;
          overflow-y: auto;
        }
        :host([no-padding]) .body-wrapper {
          padding: 0;
        }
        .body-wrapper > ::slotted(*),
        .body-wrapper > ::slotted(sh-button[size='full-width']) {
          width: 100%;
        }
        .body-wrapper > ::slotted(sh-button),
        .body-wrapper > ::slotted(sh-badge),
        .body-wrapper > ::slotted(sh-tag),
        .body-wrapper > ::slotted(sh-tooltip) {
          width: fit-content;
          width: -webkit-fit-content;
          width: -moz-fit-content;
        }
      `]}pageContentTemplate(){return V`
      <div class="body-wrapper" ?scrollable="${this.scrollable}">
        <slot></slot>
      </div>
    `}render(){return V`
      <div class="page-wrapper">
        <slot name="access" id="access"></slot>
        <slot name="nav" id="nav"></slot>
        <div class="page-content">
          <slot name="left" id="left"></slot>
          <div class="main-wrapper">
            ${this.pulltorefresh?this.renderSpinner(this.pageContentTemplate()):this.pageContentTemplate()}
            </div>
            <slot name="right" id="right"> </slot>
          </div>
          <slot name="footer" id="footer"></slot>
        </div>
      </div>
    `}constructor(){super(),this.theme="light"}updated(e){super.updated(e),e.has("theme")&&this._defineTheme(),e.has("dicom")&&this._dicomObserver(),he(this,e,["theme","scrollable","flat","dicom","noPadding"])}_defineTheme(){this.theme?gi.setHTMLAttribute("theme",this.theme):gi.removeHTMLAttribute("theme")}_dicomObserver(){this.dicom?gi.setHTMLAttribute("dicom",""):gi.removeHTMLAttribute("dicom")}}customElements.define("sh-page",vi);var yi=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-pagination-wrapper-height=2rem] - height of the pagination wrapper
   */
  --sh-pagination-wrapper-height: 2rem;
  /* 
   * @cssprop [--sh-pagination-height=1.5rem] - height of the page number box
   */
  --sh-pagination-height: 1.5rem;
  /* 
   * @cssprop [--sh-pagination-width=1.5rem] - width of the page number box
   */
  --sh-pagination-width: 1.5rem;
  /* 
   * @cssprop [--sh-pagination-line-height=1.5rem] - line-height of the page number box
   */
  --sh-pagination-line-height: 1.5rem;
  /* 
   * @cssprop [--sh-pagination-li-right-margin=0.5rem] - right margin of the li
   */
  --sh-pagination-li-right-margin: 0.5rem;
  /* 
   * @cssprop [--sh-pagination-border-radius=0.75rem] - border-radius of the li
   */
  --sh-pagination-border-radius: 0.75rem;
  /* 
   * @cssprop [--sh-pagination-prev-page-icon-right-margin=1rem] - right margin of the page icon
   */
  --sh-pagination-prev-page-icon-right-margin: 1rem;
  /* 
   * @cssprop [--sh-pagination-next-page-icon-left-margin=0.5rem] - left margin of the next page icon
   */
  --sh-pagination-next-page-icon-left-margin: 0.5rem;
}

:host {
  position: relative;
  width: fit-content;
  white-space: nowrap;
  list-style: none;
  display: flex;
  height: var(--sh-pagination-wrapper-height);
  margin: 0 auto;
  transition: all var(--transition-time) ease-in-out;
}

:host ul {
  display: inline-flex;
  list-style: none;
  margin: 0 auto;
  padding: 0;
  height: 100%;
  align-items: center;
}

:host ul li {
  text-align: center;
  font: var(--title-1);
  line-height: var(--sh-pagination-line-height);
  color: var(--text-secondary);
  background: transparent;
  cursor: pointer;
  transition: all var(--transition-time) ease-in-out, var(--hover-transition-time) background, var(--hover-transition-time) color;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
}

:host ul li:not(:first-child):not(:last-child) {
  height: var(--sh-pagination-height);
  width: var(--sh-pagination-width);
  border-radius: var(--sh-pagination-border-radius);
  margin-right: var(--sh-pagination-li-right-margin);
}

:host ul li:first-child,
:host ul li:last-child {
  height: var(--sh-pagination-wrapper-height);
  width: var(--sh-pagination-wrapper-height);
}

:host li[active] {
  background: rgba(var(--ui-1), var(--opacity-6));
  color: var(--text-primary);
}

ul.condensed li {
  font-size: 0.625rem;
}

.prevPageIcon {
  margin-right: var(--sh-pagination-prev-page-icon-right-margin);
}

.nextPageIcon {
  margin-left: var(--sh-pagination-next-page-icon-left-margin);
}

:host ul li sh-icon {
  position: unset;
}

/* State Styles */
:host ul .sh-pagination-item[click-disabled] {
  pointer-events: none;
}

/* disabled styles */
.prevPageIcon.disabled,
.nextPageIcon.disabled {
  cursor: default;
  pointer-events: none;
}

/* Focus Styles - Accessibility */
:focus,
:active {
  outline: 0;
}

/* hover */
:host(:not(.touch-device)) ul .sh-pagination-item:hover,
:host .sh-pagination-item.hover {
  background: rgba(var(--ui-1), var(--opacity-7));
  color: var(--text-primary);
}`;customElements.define("sh-pagination",class extends se{static get properties(){return{pages:{type:Number,reflect:!0},currentPage:{type:Number,reflect:!0,attribute:"current-page"}}}static get styles(){return[be(),yi]}render(){return V`
      <ul id="ul" class="${this.pages>999?"condensed":""}">
        <li
          title="Previous Page"
          @click="${this._prevPage}"
          class="prevPageIcon ${this.currentPage<=1?"disabled":""}"
          id="leftArrowWrapper"
        >
          <sh-icon
            icon="arrow-line-left-s"
            size="m"
            button
            ?disabled=${this.currentPage<=1}
          ></sh-icon>
        </li>
        ${this._getPaginationItems()}
        <li
          title="Next Page"
          @click="${this._nextPage}"
          class="nextPageIcon ${this.currentPage>=this.pages?"disabled":""}"
          id="rightArrowWrapper"
        >
          <sh-icon
            icon="arrow-line-right-s"
            size="m"
            button
            ?disabled=${this.currentPage>=this.pages}
          ></sh-icon>
        </li>
      </ul>
    `}_getPaginationItems(){let e=this._getPaginationValues(),t=[];for(let o=0;o<e.length;o++)t.push(V`<li
        class="sh-pagination-item"
        id="item"
        @click="${this._handleClick}"
        ?active=${e[o]===this.currentPage}
        ?click-disabled=${"..."===e[o].toString()}
      >
        ${e[o]}
      </li>`);return t}firstUpdated(){ue.isTouchDevice()&&this.classList.add("touch-device")}updated(e){(e.has("currentPage")||e.has("pages"))&&(this.currentPage=this.currentPage?this.currentPage:1),e.has("pages")&&(this.style.display=this.pages<=1?"none":"flex"),he(this,e,["pages","currentPage"])}_getPaginationValues(){this.pages=this.pages?this.pages:1;let e=[];return e=this.pages<=7?this._getPaginationValuesWhenPagesLessThanSeven():this._getPaginationValuesWhenPagesGreaterThanSeven(),e}_getPaginationValuesWhenPagesLessThanSeven(){let e=[];for(let t=1;t<=this.pages;t++)e.push(t);return e}_getPaginationValuesWhenPagesGreaterThanSeven(){const e=this.pages-3;let t=[];return t=this.currentPage<=4?this._getPaginationValuesWhenCurrentPageLessthanFour():this.currentPage>4&&this.currentPage<e?this._getPaginationValuesWhenCurrentPageGreaterthanFour():this._getPaginationValuesWhenCurrentPageGreaterthanFourthlast(),t}_getPaginationValuesWhenCurrentPageLessthanFour(){let e=[];for(let t=1;t<=7;t++)t<=5?e.push(t):6===t?e.push("..."):e.push(this.pages);return e}_getPaginationValuesWhenCurrentPageGreaterthanFour(){let e=[];for(let t=1;t<=5;t++)if(1===t)e.push(t);else if(2===t||4===t)e.push("...");else if(3===t)for(let t=1;t<=3;t++)switch(t){case 1:e.push(this.currentPage-1);break;case 2:e.push(this.currentPage);break;case 3:e.push(this.currentPage+1)}else e.push(this.pages);return e}_getPaginationValuesWhenCurrentPageGreaterthanFourthlast(){let e=[];const t=this.pages-3;for(let o=1;o<=3;o++)switch(o){case 1:e.push(o);break;case 2:e.push("...");break;case 3:{let o=1;for(let i=1;i<=5;i++)e.push(t-o),--o}}return e}_handleClick(e){let t,o;t=Number(e.target.innerText),o=isNaN(t),o||(this.currentPage=t,le(this,"clicked-page-move"))}_prevPage(){let e=this.currentPage-1;e>=1&&(this.currentPage=e,le(this,"previous-page-move"))}_nextPage(){let e=this.currentPage+1;e<=this.pages&&(this.currentPage=e,le(this,"next-page-move"))}});var wi=parseFloat(window.getComputedStyle(document.querySelector("html"),null).getPropertyValue("font-size")),xi=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-pane-wrapper-width=22rem] - width of the pane
   */
  --sh-pane-wrapper-width: 22rem;
  /* 
   * @cssprop [--sh-pane-wrapper-padding=1rem] - padding of the head and body wrapper
   */
  --sh-pane-wrapper-padding: 1rem;
  /* 
   * @cssprop [--sh-pane-arrow-placement-padding=0.75rem] - padding of the arrow when it is placed on top or bottom
   */
  --sh-pane-arrow-placement-padding: 0.75rem;
  /* 
   * @cssprop [--sh-pane-arrow-position=-2rem] - position of the arrow from the left or right
   */
  --sh-pane-arrow-position: -2rem;
  /* 
   * @cssprop [--sh-pane-condensed-width=6.25rem] - max-width of the condensed wrapper
   */
  --sh-pane-condensed-width: 6.25rem;
  /* 
   * @cssprop [--sh-pane-body-wrapper-margin=0.5rem] - margin of the elements inside the body slot
   */
  --sh-pane-body-wrapper-margin: 0.5rem;
  /* 
   * @cssprop [--sh-pane-arrow-wrapper-padding=0.25rem 0] - padding of the arrow wrapper to center align the arrow icon
   */
  --sh-pane-arrow-wrapper-padding: 0.25rem 0;
  /* 
   * @cssprop [--sh-pane-border-radius-left=0rem 0.125rem 0.125rem 0rem] - border-radius of the left pane
   */
  --sh-pane-border-radius-left: 0rem 0.125rem 0.125rem 0rem;
  /* 
   * @cssprop [--sh-pane-border-radius-right=0.125rem 0rem 0rem 0.125rem] - border-radius of the right pane
   */
  --sh-pane-border-radius-right: 0.125rem 0rem 0rem 0.125rem;
  /* 
   * @cssprop [--sh-pane-box-shadow-left=0.125rem 0rem 0.25rem rgba(0, 0, 0, 0.1)] - box-shadow of the left pane
   */
  --sh-pane-box-shadow-left: 0.125rem 0rem 0.25rem rgba(0, 0, 0, 0.1);
  /* 
   * @cssprop [--sh-pane-box-shadow-right=-0.125rem 0rem 0.25rem rgba(0, 0, 0, 0.1)] - box-shadow of the right pane
   */
  --sh-pane-box-shadow-right: -0.125rem 0rem 0.25rem rgba(0, 0, 0, 0.1);
  /* 
   * @cssprop [--sh-pane-slot-child-margin-left=0.5rem] - Left margin of the items placed inside functions, footer slot
   */
  --sh-pane-slot-child-margin-left: 0.5rem;
  /* 
   * @cssprop [--sh-pane-functions-slot-last-child-margin=0rem 0rem 0 var(--sh-pane-slot-child-margin-left)] - Margin of the last item placed inside functions slot
   */
  --sh-pane-functions-slot-last-child-margin: 0rem 0rem 0 var(--sh-pane-slot-child-margin-left);
  /* 
   * @cssprop [--sh-pane-functions-slot-not-last-child-margin=0rem 0rem 0 var(--sh-pane-slot-child-margin-left)] - Margin of the all items except last placed inside functions slot
   */
  --sh-pane-functions-slot-not-last-child-margin: 0rem 0rem 0 var(--sh-pane-slot-child-margin-left);
  /* 
   * @cssprop [--sh-pane-arrow-icon-size=2rem] - size of the arrow icon
   */
  --sh-pane-arrow-icon-size: 2rem;
}

:host {
  z-index: 2;
  /**
    Setting z-index is necessary here inorder to make the pane appear.

    Why the value is set to 2?

    Since
      Nav-bar has z-index=3,
      access-bar has z-index=4,
      a reasonable value of 2 is chosen. 

  */
  display: block;
  background-color: var(--base-2);
  transition: var(--transition-time) all ease-in-out;
  box-shadow: var(--shadow-navigation);
  width: unset;
  min-width: unset;
}

.pane-wrapper {
  width: var(--sh-pane-wrapper-width);
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  transition: var(--transition-time) all ease-in-out;
}

.label-wrapper {
  min-height: fit-content;
  min-height: -ms-fit-content;
  min-height: -moz-fit-content;
  padding: var(--sh-pane-wrapper-padding);
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.header-wrapper {
  padding: var(--sh-pane-wrapper-padding);
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
}

.body-wrapper {
  flex: 1;
  padding: var(--sh-pane-wrapper-padding);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}

.body-wrapper > ::slotted(*:not(:first-child):not(sh-menu-item)) {
  margin-top: var(--sh-pane-body-wrapper-margin);
}

.condensed-wrapper > ::slotted(*:not(sh-menu-item)) {
  margin-bottom: var(--sh-pane-body-wrapper-margin);
}

.footer-wrapper {
  min-height: fit-content;
  min-height: -ms-fit-content;
  min-height: -moz-fit-content;
  padding: var(--sh-pane-wrapper-padding);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  box-sizing: border-box;
}

.footer-wrapper > ::slotted(sh-button[slot=footer]),
.footer-wrapper > ::slotted(sh-icon[slot=footer]),
.label-wrapper > ::slotted([slot=functions]) {
  margin-left: var(--sh-pane-slot-child-margin-left);
}

.label-wrapper > ::slotted(:not(:last-child)[slot=functions]) {
  margin: var(--sh-pane-functions-slot-not-last-child-margin);
}

.label-wrapper > ::slotted(sh-icon[slot=functions]:last-of-type) {
  margin: var(--sh-pane-functions-slot-last-child-margin);
}

.pane-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--text-primary);
}

.header-wrapper > ::slotted(sh-tabs[slot=header]) {
  margin: -1rem 0 0 0;
}

.pane-wrapper[empty-header] .header-wrapper,
.pane-wrapper[empty-footer] .footer-wrapper {
  display: none;
}

.pane-wrapper:not([empty-header]) .body-wrapper {
  padding-top: 0rem;
}

.pane-wrapper:not([empty-footer]) .body-wrapper {
  padding-bottom: 0rem;
}

/* collapse / condense behavior */
:host([size=expanded]) .pane-wrapper {
  max-width: var(--sh-pane-wrapper-width);
}

:host([size=collapsed]) .pane-wrapper {
  max-width: 0rem;
}

:host([size=condensed]) .pane-wrapper {
  max-width: var(--sh-pane-condensed-width);
}

:host([size$=expanded]) .transition,
:host([size$=px]) .transition,
:host([size$="%"]) .transition,
:host([size$=rem]) .transition,
:host([size$=vw]) .transition {
  transition: var(--transition-time) opacity ease-in-out var(--transition-time);
}

:host([size=expanded]) .label-wrapper,
:host([size=expanded]) .header-wrapper,
:host([size=expanded]) .body-wrapper,
:host([size=expanded]) .footer-wrapper {
  width: var(--sh-pane-wrapper-width);
}

:host(:not([size=expanded]):not([size=resizable]):not([size*=px]):not([size*=rem]):not([size*="%"]):not([size*=vw])) .label-wrapper,
:host(:not([size=expanded]):not([size=resizable]):not([size*=px]):not([size*=rem]):not([size*="%"]):not([size*=vw])) .header-wrapper,
:host(:not([size=expanded]):not([size=resizable]):not([size*=px]):not([size*=rem]):not([size*="%"]):not([size*=vw])) .body-wrapper,
:host(:not([size=expanded]):not([size=resizable]):not([size*=px]):not([size*=rem]):not([size*="%"]):not([size*=vw])) .footer-wrapper {
  width: 0rem;
  max-height: 0rem;
  opacity: 0;
  transition: 0s all;
  pointer-events: none;
}

:host([size=condensed]) .condensed-wrapper {
  transition: var(--transition-time) opacity ease-in-out var(--transition-time);
  height: 100%;
  position: absolute;
  width: var(--sh-pane-condensed-width);
  padding: var(--sh-pane-wrapper-padding);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
}

:host(:not([size=condensed])) .condensed-wrapper {
  opacity: 0;
  width: 0rem;
  height: 0rem;
}

.arrow-wrapper {
  padding: var(--sh-pane-arrow-wrapper-padding);
  position: absolute;
  transition: var(--transition-time) all ease-in-out;
  background-color: var(--base-2);
  transform: translateZ(0);
}

:host([slot=left]) .arrow-wrapper {
  right: var(--sh-pane-arrow-position);
  box-shadow: var(--sh-pane-box-shadow-left);
  border-radius: var(--sh-pane-border-radius-left);
}

:host([slot=right]) .arrow-wrapper {
  left: var(--sh-pane-arrow-position);
  box-shadow: var(--sh-pane-box-shadow-right);
  border-radius: var(--sh-pane-border-radius-right);
}

.arrow {
  --sh-icon-size-m: var(--sh-pane-arrow-icon-size);
}

/* arrow position */
:host([arrow-position=top]) .arrow-wrapper {
  top: var(--sh-pane-arrow-placement-padding);
}

:host([arrow-position=bottom]) .arrow-wrapper {
  bottom: var(--sh-pane-arrow-placement-padding);
}

:host([arrow-position=center]) .arrow-wrapper {
  top: calc(50% - (var(--sh-icon-size-m) + 0.5rem) / 2);
}

/* arrow */
:host([slot=right][size=condensed][behavior=condense]) .arrow,
:host([slot=right][size=collapsed][behavior=collapse]) .arrow,
:host([slot=right][size=collapsed][behavior=condense]) .arrow,
:host([slot=left][size=condensed][behavior=collapse]) .arrow,
:host([slot=left][size=expanded]) .arrow,
:host([slot=left][size$=px]) .arrow,
:host([slot=left][size$=rem]) .arrow,
:host([slot=left][size$=vw]) .arrow,
:host([slot=left][size$="%"]) .arrow {
  transform: rotateY(180deg);
  -webkit-transform: rotateY(180deg);
}

.resize-handle:active,
.resize-handle,
.resize-handle:hover {
  position: absolute;
  height: 100%;
  width: 0.125rem;
  display: block;
  cursor: ew-resize;
}

/* positioning */
:host([slot=left]) .resize-handle {
  right: 0rem;
}

:host([slot=right]) .resize-handle {
  left: 0rem;
}

:host([size=resizable]) .label-wrapper,
:host([size=resizable]) .header-wrapper,
:host([size=resizable]) .body-wrapper,
:host([size=resizable]) .footer-wrapper,
:host([size=resizable]) .condensed-wrapper {
  max-width: unset;
  width: 100%;
  -webkit-transition: all 0s linear;
  -o-transition: all 0s linear;
  transition: all 0s linear;
}

:host([size=resizable]) {
  -webkit-transition: all 0s linear;
  -o-transition: all 0s linear;
  transition: all 0s linear;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  min-width: -webkit-fit-content;
  min-width: -moz-fit-content;
  min-width: fit-content;
}

:host([size=resizable]) .pane-wrapper {
  max-width: unset;
  -webkit-transition: all 0s linear;
  -o-transition: all 0s linear;
  transition: all 0s linear;
  --resized-width: var(--sh-pane-wrapper-width);
  width: var(--resized-width);
  min-width: var(--resized-width);
}

:host(:not([size=resizable])) .resize-handle {
  display: none;
}

:host([is-Resize]) {
  cursor: ew-resize;
}

:host([label]) .body-wrapper {
  padding-top: 0rem;
}`;customElements.define("sh-pane",class extends se{static get properties(){return{label:{type:String,reflect:!0},behavior:{type:String,reflect:!0},size:{type:String,reflect:!0,value:"expanded"},_fixSize:{type:String},arrowPosition:{type:String,reflect:!0,value:"center",attribute:"arrow-position"},_emptyFooter:{type:Boolean},_emptyHeader:{type:Boolean},_isResize:{type:Boolean},maxResizeWidth:{type:String,reflect:!0,attribute:"max-resize-width"}}}static get styles(){return[ae,xi]}render(){return V`
      <div
        class="pane-wrapper"
        ?empty-footer="${this._emptyFooter}"
        ?empty-header="${this._emptyHeader}"
        ?is-Resize="${this._isResize}"
        style="${He(this._getWidth())}"
      >
        <div class="header-wrapper transition">
          <slot
            name="header"
            id="header"
            @slotchange="${e=>this._updateHeaderSlotFlag(e.target)}"
          ></slot>
        </div>
        ${this.label&&this._emptyHeader?V` <div class="label-wrapper transition">
              <sh-text size="super-header" class="pane-label">${this.label}</sh-text>
              <slot name="functions" id="functions"></slot>
            </div>`:""}

        <div class="body-wrapper transition">
          <slot id="body"></slot>
        </div>
        <div class="footer-wrapper transition">
          <slot
            name="footer"
            id="footer"
            @slotchange="${e=>this._updateFooterSlotFlag(e.target)}"
          ></slot>
        </div>
        ${"condense"===this.behavior||"condensed"===this.size?V` <div class="condensed-wrapper">
              <slot name="condensed" id="condensed"></slot>
            </div>`:""}
        ${this.behavior?V` <div class="arrow-wrapper" @click="${()=>this._handleExpand()}">
              <sh-icon icon="arrow-right-s" button="" class="arrow"></sh-icon>
            </div>`:""}
        <div class="resize-handle"></div>
      </div>
    `}constructor(){super(),this.size="expanded",this.arrowPosition="center",this._emptyHeader=!0,this._emptyFooter=!0,this._isResize=!1,this.maxResizeWidth="75%"}firstUpdated(){this.shadowRoot.querySelector(".resize-handle").onmousedown=()=>{this._removeEventListenersFromDocument(),"resizable"===this.size&&this._addEventListenersToDocument()}}connectedCallback(){super.connectedCallback(),this._documentMouseDownListener=this._documentMouseDownActions.bind(this),this._documentMouseUpListener=this._documentMouseUpActions.bind(this),this._documentMouseMoveListener=this._documentMouseMoveActions.bind(this),this._documentMouseOverListener=this._documentMouseOverActions.bind(this),this._documentDragStartListener=this._documentDragStartActions.bind(this),this._body=document.body,this._resizeObserver=new ResizeObserver((e=>{for(const t of e)this._hundredPercentWidth=t.contentRect.width,this._handleMaxResizeChange()})),this._resizeObserver.observe(this._body)}disconnectedCallback(){this._removeEventListenersFromDocument(),this._resizeObserver.disconnect(),super.disconnectedCallback()}updated(e){he(this,e,["label","size","arrowPosition","behavior"]),e.has("size")&&this._updateSize(),e.has("maxResizeWidth")&&this._handleMaxResizeChange()}_getWidth(){return"expanded"===this.size||"resizable"===this.size?{width:"var(--sh-pane-wrapper-width)"}:{width:this._fixSize}}_updateSize(){/[0-9]*\.?[0-9]+(px|rem|vw)/.test(this.size)?this._fixSize=this.size:/[0-9]*\.?[0-9]+(%)/.test(this.size)?this._fixSize=`${parseInt(this.size)}vw`:"expanded"!==this.size&&"resizable"!==this.size||(this._fixSize=null)}_updateHeaderSlotFlag(e){const t=e.assignedNodes({flatten:!0}).length;this._emptyHeader=0===t}_updateFooterSlotFlag(e){const t=e.assignedNodes({flatten:!0}).length;this._emptyFooter=0===t}_documentMouseDownActions(e){e.composedPath()[0]===this.shadowRoot.querySelector(".resize-handle")&&(this._isResize=!0)}_documentMouseMoveActions(e){this._setPaneWidth(e)}_documentMouseOverActions(e){this._setPaneWidth(e)}_documentMouseUpActions(){this._removeEventListenersFromDocument(),this._isResize=!1}_documentDragStartActions(e){this._isResize&&e.preventDefault()}_setPaneWidth(e){const t="left"===this.getAttribute("slot");if(this._isResize){let o;o=t?e.clientX:this._hundredPercentWidth-e.clientX,o>=this._maxResizeLimit?o=this._maxResizeLimit:o/16<=22&&(o=352),this.shadowRoot.querySelector(".pane-wrapper").style.setProperty("--resized-width",o/16+"rem")}}_addEventListenersToDocument(){document.body.addEventListener("mousedown",this._documentMouseDownListener),document.body.addEventListener("mouseup",this._documentMouseUpListener),document.body.addEventListener("mousemove",this._documentMouseMoveListener),document.body.addEventListener("mouseover",this._documentMouseOverListener),document.body.addEventListener("dragstart",this._documentDragStartListener)}_removeEventListenersFromDocument(){document.body.removeEventListener("mouseup",this._documentMouseUpListener),document.body.removeEventListener("mousedown",this._documentMouseDownListener),document.body.removeEventListener("mousemove",this._documentMouseMoveListener),document.body.removeEventListener("mouseover",this._documentMouseOverListener),document.body.removeEventListener("dragstart",this._documentDragStartListener)}_handleMaxResizeChange(){this._maxLimitChecker=document.createElement("div"),document.body.appendChild(this._maxLimitChecker),this._maxLimitChecker.classList.add("max-resize-checker"),this._maxLimitChecker.style.width=`${this.maxResizeWidth}`,this._maxResizeLimit=this._maxLimitChecker.getBoundingClientRect().width,document.body.removeChild(this._maxLimitChecker),this._maxLimitChecker=null}_handleExpand(){"expanded"===this.size||/[0-9]*\.?[0-9]+(px|%|rem|vw)/.test(this.size)?"condense"===this.behavior?this.size="condensed":"collapse"===this.behavior&&(this.size="collapsed"):"collapsed"===this.size&&"condense"===this.behavior?(this.size="condensed",this.behavior="collapse"):"condensed"===this.size&&"collapse"===this.behavior?(this.size="collapsed",this.behavior="condense"):this._fixSize?this.size=this._fixSize:this.size="expanded"}});customElements.define("sh-patient-illustration",class extends se{static get properties(){return{image:{type:String,reflect:!0},active:{type:Number,reflect:!0},disabled:{type:Array,reflect:!0},currentSelected:{type:String,reflect:!0,attribute:"current-selected"},activeRegions:{type:Array,reflect:!0,attribute:"active-regions"},multiSelect:{type:Boolean,reflect:!0,attribute:"multi-select"},_illustrationLevel:{type:Number},_lastSelected:{type:String},_currentActive:{type:String,reflect:!0},_areaStates:{type:JSON}}}static get styles(){return[ae,ie`
        :host {
          height: 100%;
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }

        svg {
          height: 100%;
          width: 100%;
        }

        .region[hover] {
          fill: rgba(var(--ui-1), var(--opacity-5));
        }

        .region {
          fill: rgba(var(--ui-1), var(--opacity-6));
          cursor: pointer;
          transition: 0.2s all ease-in-out;
        }

        .region[disabled] {
          fill: transparent;
          pointer-events: none;
        }

        .region[active] {
          fill: rgba(var(--ui-2), var(--opacity-3));
        }

        .outline {
          fill: rgba(var(--ui-1), var(--opacity-5));
        }

        .vascular {
          fill: rgba(var(--functional-red), 1);
          pointer-events: none;
        }

        .bone {
          fill: rgba(var(--ui-1), var(--opacity-5));
          pointer-events: none;
        }

        .bone[disabled] {
          fill: rgba(var(--ui-1), var(--opacity-7));
          pointer-events: none;
        }

        .transparent {
          fill: transparent;
        }
      `]}constructor(){super(),this.image="ct_adult_anatomical",this._illustrationLevel=0,this.multiSelect=!1,this.activeRegions=[],this._areaStates={xp_skull:{hidden:["xp_skull_selection"],disabled:["xp_skull_bone"]},xp_upper_extremities:{hidden:["xp_upper_extremities_selection"],disabled:["xp_upper_extremities_bone"]},xp_thorax:{hidden:["xp_thorax_selection"],disabled:["xp_thorax_bone"],active:["xp_thorax_1"]},xp_shoulder_girdle:{hidden:["xp_shoulder_girdle_selection","xp_shoulder_girdle_bone","xp_shoulder_girdle_default","xp_thorax_bone"],disabled:[]},xp_vertebral_column:{hidden:["xp_vertebral_column_default","xp_vertebral_column_bone","xp_vertebral_column_selection","xp_thorax_bone","xp_clavicula_default"],disabled:[]},xp_lower_extremities:{hidden:["xp_lower_extremities_selection"],disabled:["xp_lower_extremities_bone"]},xp_abdomen:{hidden:["xp_abdomen_selection"],disabled:[],active:["xp_abdomen_1"]},xp_pelvis:{hidden:["xp_pelvis_selection"],disabled:["xp_pelvis_bone"]}}}render(){return V`${(e=>{switch(e){case"ct_adult_vascular":return V`<svg
    id="ct_adult_vascular"
    hidden
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    style="width:10rem; height:36.25rem;"
    viewBox="0 0 160 580"
  >
    <path
      index="1"
      class="region"
      d="M80.016,82.092c6.838,0,12.143-4.129,15.778-12.272a57.507,57.507,0,0,0,2.833-8.462c.114-.453.217-.886.3-1.268.155-.735.277-1.4.369-1.948.154-.912.225-1.491.226-1.5a.554.554,0,0,1,.378-.459.548.548,0,0,1,.575.15,1.509,1.509,0,0,0,.323.271.783.783,0,0,0,.328.112,1.14,1.14,0,0,0,.738-.245,5.836,5.836,0,0,0,1.849-2.419,25.573,25.573,0,0,0,2.132-5.7l.223-.878a39.624,39.624,0,0,0,1.025-5.09c.037-.255.07-.508.1-.757A19.217,19.217,0,0,0,107.3,37.2a3.808,3.808,0,0,0-.443-1.572,1.044,1.044,0,0,0-.1-.133.608.608,0,0,1-.148-.469l0-.031c.021-.137.109-.725.2-1.491a40.078,40.078,0,0,0,.116-8.718,32.414,32.414,0,0,0-1.826-8.447,24.659,24.659,0,0,0-2.93-5.65,21.382,21.382,0,0,0-6.9-6.177c-4.219-2.328-9.063-3.411-15.245-3.411S68.99,2.188,64.772,4.516a21.363,21.363,0,0,0-6.9,6.177,24.689,24.689,0,0,0-2.931,5.65,32.409,32.409,0,0,0-1.825,8.447,40.079,40.079,0,0,0,.115,8.718c.093.766.18,1.354.2,1.491l0,.031a.553.553,0,0,1-.127.445,1.2,1.2,0,0,0-.114.147,3.75,3.75,0,0,0-.453,1.582c-.005.042-.008.091-.013.134a19.851,19.851,0,0,0,.122,4.285c.03.25.064.5.1.758a39.639,39.639,0,0,0,1.025,5.089l.224.878a25.523,25.523,0,0,0,2.132,5.7,5.828,5.828,0,0,0,1.848,2.419.926.926,0,0,0,1.389-.138.54.54,0,0,1,.238-.142.624.624,0,0,1,.075-.016.6.6,0,0,1,.092-.019.553.553,0,0,1,.549.486c0,.015.182,1.489.595,3.448a57.1,57.1,0,0,0,3.13,9.73C67.884,77.963,73.188,82.092,80.016,82.092Z"
    />
    <path
      index="2"
      class="region"
      d="M54.791,93.61a170.189,170.189,0,0,0-22.158,5.873l6.659,25.254h81.469l6.659-25.251a170.273,170.273,0,0,0-22.168-5.876c-6.141-1.308-9.392-2.036-10.379-3-2.126-2.076-.838-11.442.138-16.874C91.291,80.01,86.267,83.2,80.027,83.2s-11.273-3.184-14.993-9.457c.974,5.426,2.261,14.794.136,16.87C64.182,91.574,60.932,92.3,54.791,93.61Z"
    />
    <path
      index="3"
      class="region"
      d="M19.833,293.8c-.083-.975-2.011-24.015,1.03-35.608,4.2-15.952,6.328-26.268,6.328-30.665,0-3.148.152-8.029.286-12.336.1-3.245.188-6.048.188-7.407,0-1.178.232-6.966.526-14.3.5-12.545,1.193-29.726,1.193-35.659a.518.518,0,0,1,.027-.143v-.008c.007-.022.009-.045.018-.066L38.3,125.287l-6.7-25.42C24.986,102.344,18.807,105.6,14.7,110,6.706,118.556,2.76,155.175,3.583,213.113c.02,1.349.033,2.308.033,2.81,0,3.839-.415,8.144-.9,13.128-.613,6.346-1.307,13.539-1.307,21.677,0,7.7.875,16.291,1.722,24.6.73,7.152,1.418,13.906,1.418,19.131a.555.555,0,0,1-.029.176,78.778,78.778,0,0,0-3.419,22.321c0,12.888,6.514,28.215,8.537,28.215,1.84,0,6.729,0,6.741-21.67a.552.552,0,1,1,1.1,0c0,.451.094,2.7,1.949,2.7,1.657,0,3.37-5.86,3.37-15.666a57.578,57.578,0,0,0-2.943-16.6A.549.549,0,0,1,19.833,293.8Z"
    />
    <path
      index="3"
      class="region"
      d="M155.519,294.633a.555.555,0,0,1-.029-.176c0-5.225.688-11.979,1.418-19.131.846-8.307,1.722-16.9,1.722-24.6,0-8.138-.694-15.331-1.307-21.677-.481-4.984-.9-9.289-.9-13.128,0-.5.014-1.461.033-2.81.824-57.938-3.122-94.557-11.111-103.11-4.111-4.4-10.285-7.656-16.888-10.132l-6.7,25.416,8.884,32.395a.455.455,0,0,1,.007.09.5.5,0,0,1,.01.056c0,5.933.69,23.114,1.193,35.659.294,7.329.526,13.117.526,14.3,0,1.359.087,4.162.188,7.407.134,4.307.285,9.188.285,12.336,0,4.4,2.13,14.713,6.328,30.664,3.041,11.594,1.114,34.634,1.03,35.609a.6.6,0,0,1-.029.138,57.523,57.523,0,0,0-2.944,16.6c0,9.806,1.714,15.666,3.37,15.666,1.855,0,1.949-2.247,1.949-2.7a.553.553,0,1,1,1.1,0c.011,21.67,4.9,21.67,6.741,21.67,2.023,0,8.537-15.327,8.537-28.215A78.778,78.778,0,0,0,155.519,294.633Z"
    />
    <path
      index="4"
      class="region"
      d="M120.765,125.842H39.288L30.5,157.877c.279,1.7,2.359,14.447,4.189,27.237H125.35c1.838-12.846,3.928-25.644,4.193-27.262Zm-14.219,38.971c-2.034,6.8-17.309,4.469-22.5,3.114a21.285,21.285,0,0,1-4.391-1.721,8.813,8.813,0,0,1-.236,2.448c-.382.876-1.868,1.189-3.132,1.189s-2.749-.313-3.132-1.189a10.783,10.783,0,0,1-.257-3.161,27.291,27.291,0,0,0-.354-4.963,7.36,7.36,0,0,1-.737-1.092C69.6,155.224,70,146,72.56,141.745a19.579,19.579,0,0,0,.489-4.967,8.881,8.881,0,0,1,.259-2.8c.381-.877,1.867-1.19,3.131-1.19s2.751.313,3.132,1.19a11.31,11.31,0,0,1,.258,3.261c.009.761.02,1.6.06,2.37,9.654-2.337,13.449.045,16.774,2.923C103.42,148.377,108.223,159.208,106.546,164.813Z"
    />
    <path
      index="5"
      class="region"
      d="M79.394,164.8a20.532,20.532,0,0,0,4.931,2.053c5.944,1.553,19.526,3.111,21.163-2.36,1.543-5.158-3.186-15.627-9.548-21.134-2.677-2.317-6.009-5.2-16.422-2.527a.554.554,0,0,1-.458-.086.548.548,0,0,1-.23-.4c-.079-.962-.093-2.1-.105-3.1a15.316,15.316,0,0,0-.167-2.834,4.529,4.529,0,0,0-4.237,0,10.706,10.706,0,0,0-.168,2.38,19.937,19.937,0,0,1-.559,5.347.525.525,0,0,1-.056.12c-2.387,3.9-2.788,12.773-.752,16.664a7.108,7.108,0,0,0,.7,1.02.57.57,0,0,1,.1.21A26.732,26.732,0,0,1,74,165.479a14.111,14.111,0,0,0,.166,2.734,4.535,4.535,0,0,0,4.238,0,21.764,21.764,0,0,0,.161-2.931.556.556,0,0,1,.827-.477Z"
    />
    <path
      index="6"
      class="region"
      d="M79.349,302.957c.076-4,.118-7.556.12-10.52a.553.553,0,0,1,1.105,0c0,2.964.044,6.518.12,10.52h52.15c.2-5.771.313-11.778.313-18.064,0-6.824-2.29-18.9-4.714-31.7-2.931-15.461-5.962-31.447-5.962-42.408,0-4.239,1.256-14.318,2.711-24.57H34.851c1.454,10.251,2.71,20.331,2.71,24.57,0,10.961-3.03,26.947-5.961,42.408-2.424,12.791-4.715,24.872-4.715,31.7,0,6.286.114,12.293.314,18.064Z"
    />
    <path
      index="3"
      class="region"
      d="M132.806,304.062H80.715c.824,41.258,4.989,127.817,5.036,128.781a36.32,36.32,0,0,1-1.239,8.009,94.094,94.094,0,0,0-2.65,23.054c0,15.619,3.454,44.235,3.489,44.522a125.009,125.009,0,0,1-1.475,16.607,86.838,86.838,0,0,0-1.044,10.5c0,3.15.46,7.5.906,11.7.448,4.233.912,8.611.912,11.819,0,1.257-.108,2.817-.223,4.467-.36,5.2-.808,11.672,1.6,14.253A3.587,3.587,0,0,0,88.8,578.9c8.09,0,26.485-5.278,26.485-13.969,0-2.571-2.453-6.118-5.294-10.225-4.032-5.833-9.051-13.09-9.051-20.811,0-5.351,2.643-14.916,5.7-25.991,4.582-16.58,10.283-37.214,10.283-54.415a216.205,216.205,0,0,0-1.082-21.621c-.406-4.5-.791-8.74-.791-13.889,0-4.188,1.587-10.47,3.784-19.167C123.569,380.083,131.108,350.207,132.806,304.062Z"
    />
    <path
      index="3"
      class="region"
      d="M75.531,440.852a36.4,36.4,0,0,1-1.24-7.982c.047-.988,4.212-87.55,5.037-128.808H27.237c1.7,46.145,9.237,76.021,13.967,94.745,2.2,8.7,3.783,14.979,3.783,19.167,0,5.149-.384,9.394-.791,13.889a216.205,216.205,0,0,0-1.082,21.621c0,17.2,5.7,37.835,10.284,54.415,3.06,11.075,5.7,20.64,5.7,25.991,0,7.721-5.019,14.978-9.052,20.811-2.84,4.107-5.293,7.654-5.293,10.225,0,8.691,18.4,13.969,26.485,13.969a3.586,3.586,0,0,0,2.774-1.121c2.408-2.581,1.961-9.053,1.6-14.253-.114-1.65-.222-3.21-.222-4.467,0-3.208.463-7.586.912-11.819.445-4.206.906-8.554.906-11.7a87.014,87.014,0,0,0-1.043-10.5,125.492,125.492,0,0,1-1.48-16.54c.039-.354,3.492-28.971,3.492-44.589A94.106,94.106,0,0,0,75.531,440.852Z"
    />
    <path
      class="vascular"
      d="M86.576,181.56c-.57,2.35-1.1,4.56-1.57,6.64,7.34,1.63,8.38,4.64,9.38,7.56.67,1.93,1.29,3.75,3.69,5.38a.557.557,0,0,1-.31,1.01.5.5,0,0,1-.31-.1,10.235,10.235,0,0,1-4.11-5.94c-.99-2.86-1.85-5.36-8.57-6.83-1.06,4.9-1.67,9.09-1.26,12.68a61.346,61.346,0,0,1,.14,7.22c3.84.63,7.26-.24,10.59-1.09,5.24-1.34,10.67-2.72,16.38,2.93a1.1,1.1,0,0,1-.78,1.89,1.132,1.132,0,0,1-.78-.32c-4.82-4.77-8.99-3.7-14.28-2.36-3.31.85-7.01,1.79-11.2,1.18-.11,2.93-.28,6.16-.48,9.36a17.143,17.143,0,0,0,4.82,5.52c2.18,1.86,4.44,3.78,5.42,7.07a.556.556,0,0,1-.37.69.414.414,0,0,1-.16.02.564.564,0,0,1-.53-.39c-.89-2.98-2.92-4.72-5.07-6.55a22.009,22.009,0,0,1-4.24-4.37c-.52,7.73-1.15,14.8-1.28,16.24,15.73,18.05,22.72,31.29,24.82,46.95,1.88,13.94,1.35,33.12.89,50.04-.26,9.44-.51,18.36-.24,24.54.74,17.1,1.53,40.89,1.53,56.34,0,15.27-5.34,61.2-7.1,76.29a326.019,326.019,0,0,0-2.72,41.69,36.537,36.537,0,0,0,10.03,25.36,1.1,1.1,0,1,1-1.5,1.62,38.085,38.085,0,0,1-10.74-26.99,325.791,325.791,0,0,1,2.74-41.93c1.44-12.41,5.31-45.7,6.63-65.51-1.62,6.94-3.98,18.35-6.99,38.71-1.19,8.07-2.36,15.43-3.5,22.54-3.2,20.06-5.73,35.9-5.42,48.41.41,16.07,10.43,22.15,10.53,22.21a.544.544,0,0,1,.2.75.55.55,0,0,1-.48.28.6.6,0,0,1-.28-.08c-.43-.26-10.65-6.46-11.07-23.13-.32-12.62,2.22-28.5,5.43-48.61,1.14-7.11,2.31-14.47,3.5-22.53,3.89-26.3,6.7-37.71,8.21-43.84.07-.29.14-.56.21-.83.07-1.65.11-3.14.11-4.41,0-15.42-.79-39.16-1.53-56.25-.27-6.25-.02-15.21.24-24.69.46-16.84.98-35.92-.87-49.68a62.945,62.945,0,0,0-5.27-18.29c1.23,9.45.55,16.59-.22,24.62a155.782,155.782,0,0,0-.82,25.99.549.549,0,0,1-.52.58h-.03a.556.556,0,0,1-.55-.52,157.036,157.036,0,0,1,.83-26.15c.85-8.91,1.58-16.7-.3-27.81-3.87-7.41-9.5-15.14-17.46-24.27-7.94,9.09-13.33,16.39-16.96,23.36-2.08,11.6-1.32,19.57-.45,28.72a157.186,157.186,0,0,1,.82,26.15.549.549,0,0,1-.55.52h-.03a.555.555,0,0,1-.52-.58,154.709,154.709,0,0,0-.82-25.99c-.79-8.24-1.48-15.54-.12-25.36a59.656,59.656,0,0,0-4.71,18c-1.58,14-1.49,33.7-1.4,51.09.05,9.77.09,18.21-.17,24.31-.74,17.09-1.53,40.83-1.53,56.25,0,1.27.04,2.76.11,4.41.07.27.14.55.21.83,1.51,6.13,4.32,17.55,8.21,43.84,1.19,8.06,2.36,15.41,3.5,22.52,3.21,20.12,5.75,36,5.43,48.62-.42,16.67-10.64,22.87-11.07,23.13a.6.6,0,0,1-.28.08.55.55,0,0,1-.48-.28.544.544,0,0,1,.2-.75c.1-.06,10.12-6.18,10.53-22.21.31-12.51-2.22-28.36-5.42-48.41-1.14-7.12-2.31-14.48-3.5-22.54-3.01-20.36-5.37-31.77-6.99-38.71,1.32,19.8,5.19,53.1,6.63,65.51a325.674,325.674,0,0,1,2.74,41.93,38.085,38.085,0,0,1-10.74,26.99,1.1,1.1,0,0,1-.75.3,1.071,1.071,0,0,1-.81-.36,1.1,1.1,0,0,1,.06-1.56,36.537,36.537,0,0,0,10.03-25.36,325.9,325.9,0,0,0-2.72-41.69c-1.76-15.09-7.1-61.04-7.1-76.29,0-15.45.79-39.24,1.53-56.34.26-6.05.22-14.47.17-24.21-.09-17.45-.18-37.22,1.41-51.35,1.83-16.19,7.68-27.48,23.93-46.08.06-.7,1.49-16.44,1.9-27.5-4.25.65-7.99-.3-11.35-1.16-5.28-1.35-9.46-2.41-14.28,2.36a1.091,1.091,0,0,1-.77.32,1.1,1.1,0,0,1-.78-1.89c5.71-5.65,11.13-4.27,16.38-2.93,3.4.87,6.91,1.75,10.87,1.04a56.749,56.749,0,0,0-.12-6.79c-.67-5.94,1.01-12.83,3.13-21.57.3-1.22.61-2.5.92-3.81a35.427,35.427,0,0,1-8.84,1.26,29.189,29.189,0,0,1-7.69-1.12,20.063,20.063,0,0,0-4.94-.81h-.07a.555.555,0,0,1,0-1.11,20.875,20.875,0,0,1,5.28.85c3.8.95,8.08,2.02,16.55-.29.63-2.66,1.25-5.47,1.82-8.4,1,.19,2.11.38,3.27.54-.53,2.76-1.12,5.41-1.71,7.93,7.42,4.02,10.85,4.02,15.96,3.99,1.9-.01,4.07-.02,6.76.17a.556.556,0,0,1-.04,1.11c-.01,0-.03-.01-.04-.01-2.64-.19-4.79-.17-6.68-.17-5.21.03-8.74.03-16.22-3.97C87.316,178.52,86.936,180.09,86.576,181.56Z"
    />
    <path
      class="vascular"
      d="M151.946,324.04a1.091,1.091,0,0,1-1.02.69,1.059,1.059,0,0,1-.42-.09,1.1,1.1,0,0,1-.6-1.43c.04-.11,4.43-11.64-.84-42.43-2.02-11.78-1.56-26.46-1.16-39.41.34-10.99.64-20.49-.55-26.25-.49-2.35-1.26-5.05-2.16-8.17-.75-2.6-1.57-5.5-2.36-8.63-.38,7.64-1.63,15.81-2.69,22.72-.66,4.34-1.24,8.09-1.43,10.69-.58,7.89,1.37,16.54,3.83,27.5l.1.42c6.42,28.53-2.12,45.23-2.21,45.4a.544.544,0,0,1-.49.29.616.616,0,0,1-.26-.06.558.558,0,0,1-.23-.75c.09-.16,8.43-16.54,2.11-44.63l-.09-.43c-2.49-11.04-4.45-19.77-3.86-27.82.19-2.65.77-6.42,1.44-10.78,1.26-8.2,2.78-18.17,2.78-26.87a88.811,88.811,0,0,1-2.02-23.43l.16-2.76c1.11-19.52,2.5-43.8-16.65-49.44-14.85-4.38-24.59-.29-29.01,12.09a7.979,7.979,0,0,1,1.81,1.9,9.694,9.694,0,0,1,1.54,5.57,16.722,16.722,0,0,1-.35,3.26,1.516,1.516,0,0,1-.04.19c-.02.08-.03.16-.05.24-.13.56-.38,1.58-.63,2.33-.22-.2-.44-.4-.66-.59a16.409,16.409,0,0,0-3.13-2.27c.7-2.73.58-4.89-.34-6.25a4.137,4.137,0,0,0-3.13-1.69,3.664,3.664,0,0,0-3.17.97c-1.17,1.16-1.72,3.25-1.52,5.76.01.15.02.29.04.44a2.209,2.209,0,0,1-4.39.49.86.86,0,0,1-.01-.16c-.42-4.05.56-7.48,2.78-9.67a7.579,7.579,0,0,1,1.09-.89c-8.08-16.42-22.31-21.75-42.34-15.82-13.47,3.99-25.41,13.57-21.6,56.26a77.534,77.534,0,0,1-2.01,24.65c.13,8.41,1.57,17.86,2.77,25.69.67,4.36,1.25,8.13,1.44,10.78.59,8.05-1.37,16.78-3.85,27.82l-.1.43c-6.32,28.09,2.03,44.47,2.11,44.63a.558.558,0,0,1-.23.75.583.583,0,0,1-.26.06.544.544,0,0,1-.49-.29c-.09-.17-8.62-16.87-2.21-45.4l.1-.42c2.46-10.96,4.41-19.61,3.83-27.5-.19-2.6-.77-6.35-1.43-10.69-1.03-6.7-2.23-14.59-2.64-22.02-.75,2.8-1.54,5.39-2.26,7.76-.97,3.19-1.81,5.95-2.3,8.34-1.2,5.76-.9,15.26-.56,26.25.4,12.95.86,27.63-1.16,39.41-5.27,30.79-.88,42.32-.83,42.43a1.1,1.1,0,0,1-.62,1.43.978.978,0,0,1-.41.09,1.091,1.091,0,0,1-1.02-.69c-.2-.48-4.7-12.07.7-43.63,1.98-11.57,1.53-26.13,1.13-38.97-.34-11.13-.64-20.75.6-26.77.52-2.49,1.37-5.29,2.36-8.53,2.7-8.91,6.41-21.11,5.14-35.41-3.2-35.79,3.52-52.76,23.18-58.58,14.47-4.28,26.33-2.8,35.1,4.24-.03-1.26-.04-2.99-.05-5.31-.04-8.38-.1-22.4-1.62-28.77-.43-1.8-.86-3.64-1.29-5.5-8.37-11.79-8.47-26.2-8.47-26.34a.55.55,0,0,1,1.1,0,50.854,50.854,0,0,0,6.67,23.26c-2.49-11.35-4.35-23.43-2.05-34.68a1.108,1.108,0,0,1,2.17.45c-2.8,13.65.82,28.87,4.02,42.3,1.58,6.62,1.64,20.25,1.68,29.27.02,3.48.04,6.77.16,7.31a.163.163,0,0,0,0,.07,38.934,38.934,0,0,1,7.52,10.65c.14-.05.3-.08.45-.12-1.85-10.42-5.41-38.38-3.31-47.18,3.19-13.43,6.82-28.64,4.02-42.3a1.108,1.108,0,0,1,.86-1.31,1.091,1.091,0,0,1,1.3.86c2.31,11.25.45,23.33-2.05,34.68a50.937,50.937,0,0,0,6.68-23.26.55.55,0,1,1,1.1,0c0,.14-.1,14.55-8.47,26.34-.43,1.86-.86,3.7-1.29,5.5-2,8.4,1.58,36.34,3.35,46.39a9.549,9.549,0,0,1,3.56.68c4.88-13.25,15.77-17.79,31.61-13.13,20.83,6.13,19.33,32.46,18.23,51.68l-.15,2.76c-.79,14.46,2.73,26.71,5.29,35.65.91,3.17,1.7,5.9,2.2,8.33,1.25,6.02.95,15.64.6,26.77-.4,12.84-.85,27.4,1.13,38.97C156.646,311.97,152.146,323.56,151.946,324.04Z"
    />
    <path
      class="outline"
      d="M88.8,580a4.691,4.691,0,0,1-3.582-1.473c-2.736-2.931-2.27-9.668-1.895-15.082.113-1.631.22-3.173.22-4.391,0-3.149-.461-7.5-.906-11.7-.449-4.233-.912-8.611-.912-11.82a87.514,87.514,0,0,1,1.054-10.644A124.867,124.867,0,0,0,84.25,508.5c-.031-.221-3.492-28.9-3.492-44.589a95.062,95.062,0,0,1,2.677-23.3,35.7,35.7,0,0,0,1.212-7.738c-.04-.83-3.3-68.541-4.626-112.77-1.326,44.229-4.585,111.945-4.626,112.8a35.794,35.794,0,0,0,1.213,7.711,95.062,95.062,0,0,1,2.677,23.3c0,15.685-3.462,44.368-3.5,44.656a125.566,125.566,0,0,0,1.474,16.325,87.716,87.716,0,0,1,1.054,10.644c0,3.209-.464,7.587-.913,11.82-.445,4.206-.905,8.554-.905,11.7,0,1.218.107,2.76.219,4.391.375,5.414.842,12.151-1.894,15.082A4.691,4.691,0,0,1,71.241,580c-8.007,0-27.59-5.282-27.59-15.074,0-2.916,2.544-6.594,5.49-10.854C53.086,548.366,58,541.265,58,533.89c0-5.2-2.624-14.7-5.663-25.7-4.6-16.645-10.323-37.359-10.323-54.71A216.846,216.846,0,0,1,43.1,431.763c.421-4.662.785-8.69.785-13.789,0-4.05-1.573-10.277-3.75-18.9-5.368-21.251-14.351-56.818-14.351-114.185,0-6.928,2.3-19.059,4.734-31.9,2.785-14.692,5.942-31.344,5.942-42.2,0-7.513-4.138-34.493-6.081-46.744-.217,7.935-.7,20.027-1.081,29.486-.293,7.317-.525,13.1-.525,14.251,0,1.377-.088,4.187-.189,7.441-.133,4.3-.285,9.171-.285,12.3,0,4.492-2.142,14.9-6.365,30.946-2.912,11.105-1.119,33.747-1,35.165a58.64,58.64,0,0,1,2.983,16.895c0,2.8-.216,16.771-4.475,16.771a2.672,2.672,0,0,1-1.984-.788c-.41,17.434-4.353,19.76-7.81,19.76C6.236,346.274,0,329.037,0,316.954a80.2,80.2,0,0,1,3.448-22.585c-.007-5.157-.69-11.849-1.412-18.93C1.187,267.1.308,258.485.308,250.728c0-8.192.7-15.412,1.312-21.782.478-4.957.892-9.238.892-13.023,0-.5-.014-1.452-.033-2.794-.84-59.069,3.1-94.99,11.409-103.88C23.276,99.2,42.86,95.024,54.561,92.53c4.846-1.033,9.032-1.925,9.838-2.712,2.1-2.054-.3-15.8-1.181-19.6a58.7,58.7,0,0,1-3.181-9.9c-.226-1.078-.383-2-.481-2.634a2.045,2.045,0,0,1-1.99-.295,7.093,7.093,0,0,1-2.215-2.83,26.636,26.636,0,0,1-2.222-5.941l-.222-.874a40.428,40.428,0,0,1-1.047-5.2,21.978,21.978,0,0,1-.213-5.477,4.532,4.532,0,0,1,.663-2.1c-.04-.27-.106-.745-.176-1.318a41.12,41.12,0,0,1-.118-8.948A33.414,33.414,0,0,1,53.9,15.964a25.825,25.825,0,0,1,3.071-5.915,22.51,22.51,0,0,1,7.263-6.5C68.626,1.127,73.64,0,80.016,0s11.4,1.127,15.789,3.548a22.51,22.51,0,0,1,7.263,6.5,25.867,25.867,0,0,1,3.071,5.915,33.451,33.451,0,0,1,1.888,8.728,41.119,41.119,0,0,1-.119,8.948c-.069.574-.135,1.05-.175,1.32a4.538,4.538,0,0,1,.663,2.1,22.024,22.024,0,0,1-.213,5.477,40.385,40.385,0,0,1-1.048,5.206l-.222.874a26.586,26.586,0,0,1-2.222,5.941,7.084,7.084,0,0,1-2.215,2.83,2.043,2.043,0,0,1-1.989.295c-.1.633-.255,1.556-.482,2.634a58.511,58.511,0,0,1-3.2,9.952c-.843,3.64-3.27,17.486-1.159,19.548.8.787,4.991,1.679,9.838,2.712,11.7,2.494,31.286,6.667,40.673,16.719,8.3,8.89,12.249,44.811,11.409,103.88-.019,1.342-.033,2.3-.033,2.794,0,3.785.413,8.066.892,13.023.615,6.37,1.312,13.59,1.312,21.782,0,7.757-.879,16.375-1.729,24.711-.721,7.081-1.4,13.773-1.411,18.93a80.179,80.179,0,0,1,3.448,22.585c0,12.083-6.237,29.32-9.642,29.32-3.457,0-7.4-2.326-7.811-19.76a2.668,2.668,0,0,1-1.984.788c-4.259,0-4.474-13.97-4.474-16.771a58.642,58.642,0,0,1,2.982-16.895c.117-1.416,1.91-24.061-1-35.166-4.223-16.042-6.364-26.453-6.364-30.945,0-3.131-.152-8-.285-12.3-.1-3.254-.189-6.064-.189-7.441,0-1.155-.232-6.934-.525-14.251-.38-9.459-.865-21.551-1.081-29.487-1.943,12.252-6.081,39.232-6.081,46.745,0,10.857,3.157,27.509,5.942,42.2,2.434,12.844,4.734,24.975,4.734,31.9,0,57.367-8.984,92.934-14.352,114.185-2.177,8.619-3.75,14.846-3.75,18.9,0,5.1.364,9.127.787,13.789a217.205,217.205,0,0,1,1.086,21.721c0,17.351-5.724,38.065-10.323,54.71-3.039,11-5.664,20.495-5.664,25.7,0,7.375,4.91,14.476,8.856,20.182,2.946,4.26,5.49,7.938,5.49,10.854C116.392,574.718,96.809,580,88.8,580ZM80.021,291.885a.553.553,0,0,1,.553.552c.017,33.178,5.125,139.338,5.177,140.406a36.32,36.32,0,0,1-1.239,8.009,94.094,94.094,0,0,0-2.65,23.054c0,15.619,3.454,44.235,3.489,44.522a125.009,125.009,0,0,1-1.475,16.607,86.838,86.838,0,0,0-1.044,10.5c0,3.15.46,7.5.905,11.7.449,4.233.913,8.611.913,11.819,0,1.257-.108,2.817-.223,4.467-.36,5.2-.808,11.672,1.6,14.253A3.587,3.587,0,0,0,88.8,578.9c8.09,0,26.485-5.278,26.485-13.969,0-2.571-2.453-6.118-5.294-10.225-4.032-5.833-9.051-13.09-9.051-20.811,0-5.351,2.643-14.916,5.7-25.991,4.582-16.58,10.283-37.214,10.283-54.415a216.205,216.205,0,0,0-1.082-21.621c-.406-4.5-.791-8.74-.791-13.889,0-4.188,1.587-10.47,3.784-19.167,5.356-21.2,14.318-56.685,14.318-113.914,0-6.824-2.29-18.9-4.714-31.7-2.931-15.461-5.962-31.447-5.962-42.408,0-9.858,6.792-51.292,7.081-53.051a.561.561,0,0,1,.59-.461.552.552,0,0,1,.507.551c0,5.933.69,23.114,1.193,35.659.294,7.329.526,13.118.526,14.3,0,1.359.087,4.162.187,7.407.135,4.307.286,9.188.286,12.336,0,4.4,2.13,14.713,6.329,30.664,3.04,11.594,1.113,34.634,1.029,35.609a.548.548,0,0,1-.029.138,57.523,57.523,0,0,0-2.944,16.6c0,9.806,1.714,15.666,3.37,15.666,1.855,0,1.949-2.247,1.949-2.7a.553.553,0,0,1,1.1,0c.011,21.67,4.9,21.67,6.741,21.67,2.023,0,8.537-15.327,8.537-28.215a78.778,78.778,0,0,0-3.419-22.321.555.555,0,0,1-.029-.176c0-5.225.688-11.979,1.417-19.131.847-8.307,1.723-16.9,1.723-24.6,0-8.138-.694-15.331-1.307-21.677-.481-4.984-.9-9.289-.9-13.128,0-.5.014-1.461.033-2.81.824-57.938-3.122-94.557-11.111-103.11-9.15-9.8-28.522-13.926-40.1-16.393-6.141-1.308-9.392-2.036-10.379-3-3.022-2.951.857-20.659.929-20.806a57.2,57.2,0,0,0,3.122-9.713c.412-1.959.593-3.433.595-3.448a.554.554,0,0,1,.378-.459.548.548,0,0,1,.575.15.928.928,0,0,0,1.39.138,5.845,5.845,0,0,0,1.848-2.419,25.573,25.573,0,0,0,2.132-5.7l.223-.878a39.624,39.624,0,0,0,1.025-5.09A20.862,20.862,0,0,0,107.3,37.2c-.164-1.27-.451-1.6-.545-1.7a.608.608,0,0,1-.148-.469s.1-.647.205-1.522a40.078,40.078,0,0,0,.116-8.718,32.414,32.414,0,0,0-1.826-8.447,24.659,24.659,0,0,0-2.93-5.65,21.4,21.4,0,0,0-6.9-6.177c-4.219-2.328-9.063-3.411-15.245-3.411S68.99,2.188,64.772,4.516a21.375,21.375,0,0,0-6.9,6.177,24.689,24.689,0,0,0-2.931,5.65,32.409,32.409,0,0,0-1.825,8.447,40.079,40.079,0,0,0,.115,8.718c.106.875.2,1.518.206,1.522a.553.553,0,0,1-.127.445c-.116.131-.4.458-.567,1.728a20.928,20.928,0,0,0,.21,5.178,39.494,39.494,0,0,0,1.024,5.089l.224.878a25.472,25.472,0,0,0,2.132,5.7,5.828,5.828,0,0,0,1.848,2.419.926.926,0,0,0,1.389-.138.553.553,0,0,1,.954.309c0,.015.182,1.489.594,3.448a57.2,57.2,0,0,0,3.131,9.73c.063.13,3.943,17.838.921,20.789-.988.965-4.238,1.693-10.379,3C43.217,96.077,23.846,100.205,14.7,110,6.706,118.556,2.76,155.175,3.583,213.113c.02,1.349.033,2.308.033,2.81,0,3.839-.415,8.144-.9,13.128-.613,6.346-1.307,13.539-1.307,21.677,0,7.7.875,16.291,1.722,24.6.73,7.152,1.418,13.906,1.418,19.131a.555.555,0,0,1-.029.176,78.778,78.778,0,0,0-3.419,22.321c0,12.888,6.514,28.215,8.537,28.215,1.84,0,6.729,0,6.741-21.67a.552.552,0,0,1,.552-.552h0a.552.552,0,0,1,.552.552c0,.451.094,2.7,1.949,2.7,1.657,0,3.37-5.86,3.37-15.666a57.578,57.578,0,0,0-2.943-16.6.549.549,0,0,1-.03-.138c-.083-.975-2.011-24.015,1.03-35.608,4.2-15.952,6.328-26.268,6.328-30.665,0-3.148.152-8.029.286-12.336.1-3.245.188-6.048.188-7.407,0-1.177.232-6.966.526-14.3.5-12.545,1.193-29.726,1.193-35.659a.552.552,0,0,1,1.1-.09c.289,1.759,7.08,43.193,7.08,53.051,0,10.961-3.03,26.947-5.961,42.408-2.424,12.791-4.715,24.872-4.715,31.7,0,57.229,8.963,92.713,14.319,113.914,2.2,8.7,3.783,14.979,3.783,19.167,0,5.149-.384,9.394-.791,13.889a216.205,216.205,0,0,0-1.082,21.621c0,17.2,5.7,37.835,10.284,54.415,3.06,11.075,5.7,20.64,5.7,25.991,0,7.721-5.019,14.978-9.052,20.811-2.84,4.107-5.293,7.654-5.293,10.225,0,8.691,18.4,13.969,26.485,13.969a3.586,3.586,0,0,0,2.774-1.121c2.408-2.581,1.961-9.052,1.6-14.253-.114-1.65-.222-3.21-.222-4.467,0-3.208.463-7.586.912-11.819.445-4.206.906-8.554.906-11.7a87.014,87.014,0,0,0-1.043-10.5,125.492,125.492,0,0,1-1.48-16.54c.039-.354,3.492-28.971,3.492-44.589a94.106,94.106,0,0,0-2.649-23.054,36.4,36.4,0,0,1-1.24-7.982c.052-1.1,5.161-107.255,5.178-140.433A.552.552,0,0,1,80.021,291.885Z"
    />
  </svg>`;case"ct_child_anatomical":return V`<svg
    id="ct_child_anatomical"
    hidden
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    style="width:10.89375rem; height:36.25rem;"
    viewBox="0 0 174.3 580"
    xml:space="preserve"
  >
    <path
      index="1"
      class="region"
      d="M87.135,113c23.94-.02,28.869-30.28,28.916-30.586a.524.524,0,0,1,.561-.468l.1,0c3.414,0,5.945-4.961,6.783-6.6a30.583,30.583,0,0,0,3.309-11.208,15.289,15.289,0,0,0,.087-2.147,4.263,4.263,0,0,0-.873-2.915,1.232,1.232,0,0,0-.742-.382c-.08-.009-.141-.01-.147-.01a.56.56,0,0,1-.608-.651c2.415-12.774.63-27.142-4.656-37.5-.566-1.107-1.206-2.241-1.932-3.377-.544-.853-1.135-1.707-1.778-2.552q-.642-.846-1.355-1.676C109.334,6.569,100.694,1.111,87.146,1.105c-12.385.006-20.668,4.556-26.178,10.187A35.164,35.164,0,0,0,58.113,14.6q-.644.846-1.219,1.7a40.229,40.229,0,0,0-2.491,4.23c-5.286,10.355-7.071,24.723-4.656,37.5a.553.553,0,0,1-.143.484.539.539,0,0,1-.476.166,1.19,1.19,0,0,0-.878.393,2.928,2.928,0,0,0-.69,1.438,11.125,11.125,0,0,0-.1,3.625A30.263,30.263,0,0,0,48.6,69.961a32.349,32.349,0,0,0,2.173,5.381c.846,1.656,3.42,6.751,6.883,6.6h.016c.014,0,.026.006.04.007a.526.526,0,0,1,.506.461c0,.006.008.051.019.115C58.593,84.578,63.955,112.976,87.135,113Z"
    />
    <path
      index="2"
      class="region"
      d="M141,130.965a161.709,161.709,0,0,0-15.862-5.128c-7.58-2.153-13.568-3.853-16-6.711-2.095-2.462-1.783-9.539-.69-16.066-4.562,6.021-11.343,11.031-21.307,11.04-9.963-.009-16.744-5.019-21.306-11.04,1.093,6.527,1.405,13.605-.69,16.066-2.434,2.858-8.422,4.558-16,6.711A162.186,162.186,0,0,0,33.3,130.954L43.52,150.609H78.357a4.349,4.349,0,0,0,.388-2.013,4.015,4.015,0,0,0-.946-2.879,4.3,4.3,0,0,1-1.055-2.845c0-4.885,4.661-8.86,10.39-8.86s10.391,3.975,10.391,8.86a4.3,4.3,0,0,1-1.055,2.845,4.011,4.011,0,0,0-.946,2.879,4.349,4.349,0,0,0,.388,2.013h34.871Z"
    />
    <path
      index="3"
      class="region"
      d="M87.134,135.012c-5.186,0-9.39,3.519-9.39,7.86,0,2.41,2,2.195,2,5.724s-2,3.314-2,5.724,2,2.195,2,5.724-2,3.314-2,5.724,2,2.195,2,5.725-2,3.313-2,5.724,2,2.195,2,5.724-2,3.314-2,5.724,2,2.2,2,5.724-2,3.314-2,5.724,2,2.195,2,5.724-2,3.314-2,5.724,2,2.195,2,5.724-2,3.314-2,5.724,2,2.2,2,5.724-2,3.314-2,5.724,2,2.195,2,5.725-2,3.313-2,5.724,2,2.195,2,5.724-2,3.314-2,5.724,2,2.195,2,5.724-2,3.314-2,5.724,2,2.195,2,5.724-2,3.314-2,5.724,2,2.195,2,5.724-2,3.314-2,5.724,2,2.195,2,5.724-2,3.314-2,5.724c0,4.341,4.2,7.861,9.39,7.861s9.391-3.52,9.391-7.861c0-2.41-2-2.195-2-5.724s2-3.314,2-5.724-2-2.195-2-5.724,2-3.314,2-5.724-2-2.195-2-5.724,2-3.314,2-5.724-2-2.195-2-5.724,2-3.314,2-5.724-2-2.195-2-5.724,2-3.314,2-5.724-2-2.195-2-5.724,2-3.314,2-5.725-2-2.195-2-5.724,2-3.314,2-5.724-2-2.195-2-5.724,2-3.314,2-5.724-2-2.195-2-5.724,2-3.314,2-5.724-2-2.195-2-5.724,2-3.314,2-5.724-2-2.195-2-5.724,2-3.314,2-5.724-2-2.2-2-5.724,2-3.314,2-5.725-2-2.194-2-5.724,2-3.314,2-5.724-2-2.195-2-5.724,2-3.314,2-5.724C96.525,138.531,92.321,135.012,87.134,135.012Z"
    />
    <path
      index="4"
      class="region"
      d="M42.588,151.211,32.275,131.374c-6.809,2.822-13.3,6.61-18.07,12.263-3.5,4.151-7.346,14.616-9.276,39.406H32.362Z"
    />
    <path
      index="4"
      class="region"
      d="M160.064,143.637c-4.763-5.645-11.244-9.431-18.043-12.251l-10.307,19.826,10.194,31.831H169.34C167.41,158.253,163.566,147.788,160.064,143.637Z"
    />
    <path
      index="5"
      class="region"
      d="M3.8,235.386c.023,1.33.039,2.279.039,2.779a113.543,113.543,0,0,1-.978,12.207,172.83,172.83,0,0,0-1.423,20.12c0,7.149.954,16.143,1.877,24.842.794,7.486,1.544,14.558,1.544,19.414a.547.547,0,0,1-.039.2,63.387,63.387,0,0,0-3.718,20.692c0,11.333,6.848,26.167,9.351,26.167,2.209,0,7.382,0,7.4-20.088a.552.552,0,1,1,1.1,0c0,.412.105,2.467,2.173,2.467,2.122,0,3.721-6.239,3.721-14.512,0-7.591-3.167-15.3-3.2-15.371a.561.561,0,0,1-.043-.231c.007-.225.756-22.627,2.821-33.923.475-2.6,1.013-5.417,1.557-8.269,1.79-9.37,3.641-19.058,3.641-22.942,0-2.926.166-7.461.311-11.462.11-3.013.205-5.615.205-6.876,0-1.1.253-6.474.574-13.282.548-11.651,1.3-27.607,1.3-33.115a.574.574,0,0,1,.019-.1c0-.021,0-.041.007-.061H4.854C3.888,196.983,3.435,213.73,3.8,235.386Z"
    />
    <path
      index="5"
      class="region"
      d="M169.445,314.951a.567.567,0,0,1-.038-.2c0-4.856.749-11.928,1.543-19.414.924-8.7,1.878-17.693,1.878-24.842a173.05,173.05,0,0,0-1.423-20.12,113.543,113.543,0,0,1-.978-12.207c0-.5.016-1.449.039-2.779.368-21.656-.085-38.4-1.051-51.343H142.227c.006.024,0,.048.008.072a.563.563,0,0,1,.018.091c0,5.508.75,21.464,1.3,33.115.321,6.808.574,12.186.574,13.282,0,1.261.095,3.863.205,6.876.147,4,.312,8.536.312,11.462,0,3.882,1.848,13.562,3.637,22.923.546,2.859,1.084,5.681,1.561,8.288,2.065,11.3,2.813,33.7,2.82,33.923a.544.544,0,0,1-.042.231,46.477,46.477,0,0,0-3.2,15.371c0,8.273,1.6,14.512,3.721,14.512,2.069,0,2.173-2.055,2.173-2.467a.553.553,0,1,1,1.105,0c.012,20.088,5.185,20.088,7.395,20.088,2.5,0,9.351-14.834,9.351-26.167A63.373,63.373,0,0,0,169.445,314.951Z"
    />
    <path
      index="6"
      class="region"
      d="M43.51,151.609,33.089,184.05a.48.48,0,0,1,.024.063c.264,1.548,6.177,36.295,6.748,47.544l0,.046H77.6c.037-.051.075-.1.112-.152a4.753,4.753,0,0,0,0-5.635,4.465,4.465,0,0,1,0-5.814,4.752,4.752,0,0,0,0-5.634,4.465,4.465,0,0,1,0-5.814,4.752,4.752,0,0,0,0-5.634,4.465,4.465,0,0,1,0-5.814,4.752,4.752,0,0,0,0-5.634,4.465,4.465,0,0,1,0-5.814c.1-.14.481-.775.884-1.473a5.415,5.415,0,0,0,.146-1.344,6.726,6.726,0,0,0-.043-.754l-.106,0a3.786,3.786,0,0,0-.881-2.062,4.464,4.464,0,0,1,0-5.813,4.753,4.753,0,0,0,0-5.635,4.464,4.464,0,0,1,0-5.813,4.753,4.753,0,0,0,0-5.635,4.434,4.434,0,0,1-1.076-2.907,4.266,4.266,0,0,1,.933-2.711H43.51Z"
    />
    <path
      index="6"
      class="region"
      d="M96.7,151.609a4.266,4.266,0,0,1,.933,2.711,4.439,4.439,0,0,1-1.076,2.907,4.749,4.749,0,0,0,0,5.635,4.464,4.464,0,0,1,0,5.813,4.749,4.749,0,0,0,0,5.635,4.464,4.464,0,0,1,0,5.813c-.084.113-.164.225-.242.338l-.124,0a3.959,3.959,0,0,0-.664,2.484A5.259,5.259,0,0,0,95.7,184.4c.438.708.782,1.255.856,1.356a4.465,4.465,0,0,1,0,5.814,4.748,4.748,0,0,0,0,5.634,4.465,4.465,0,0,1,0,5.814,4.748,4.748,0,0,0,0,5.634,4.465,4.465,0,0,1,0,5.814,4.748,4.748,0,0,0,0,5.634,4.465,4.465,0,0,1,0,5.814,4.749,4.749,0,0,0,0,5.635c.037.049.075.1.112.152h37.739l0-.043c.57-11.247,6.484-46,6.748-47.547a.569.569,0,0,1,.024-.065l-10.389-32.439H96.7Z"
    />
    <path
      index="7"
      class="region"
      d="M95.628,274.526a3.923,3.923,0,0,0,.926,2.817,4.442,4.442,0,0,1,1.076,2.907,4.306,4.306,0,0,1-.975,2.769h45.254c-.5-2.693-1.03-5.469-1.567-8.285-2.941-15.414-5.982-31.352-5.982-41.536,0-.119,0-.261.007-.39H97.314a4.189,4.189,0,0,1,.316,1.649,4.437,4.437,0,0,1-1.076,2.907,4.749,4.749,0,0,0,0,5.635,4.464,4.464,0,0,1,0,5.813,4.749,4.749,0,0,0,0,5.635,4.465,4.465,0,0,1,0,5.814,4.748,4.748,0,0,0,0,5.634,4.465,4.465,0,0,1,0,5.814A3.923,3.923,0,0,0,95.628,274.526Z"
    />
    <path
      index="7"
      class="region"
      d="M32.36,283.019H77.614a4.306,4.306,0,0,1-.975-2.769,4.436,4.436,0,0,1,1.076-2.907,4.752,4.752,0,0,0,0-5.634,4.465,4.465,0,0,1,0-5.814,4.752,4.752,0,0,0,0-5.634,4.465,4.465,0,0,1,0-5.814,4.753,4.753,0,0,0,0-5.635,4.464,4.464,0,0,1,0-5.813,4.753,4.753,0,0,0,0-5.635,4.432,4.432,0,0,1-1.076-2.907,4.189,4.189,0,0,1,.316-1.649H39.9c0,.129.007.271.007.39,0,10.184-3.041,26.122-5.982,41.536C33.389,277.55,32.861,280.326,32.36,283.019Z"
    />
    <path
      index="8"
      class="region"
      d="M86.274,337.178q.163-5.358.308-10.941a.553.553,0,0,1,1.105,0q.144,5.586.308,10.941h56.1c.616-9.567.98-19.976.98-31.312,0-4.745-1.289-12.693-2.958-21.742H95.953a4.425,4.425,0,0,0-.325,1.85,3.923,3.923,0,0,0,.926,2.817,4.465,4.465,0,0,1,0,5.814,4.749,4.749,0,0,0,0,5.635,4.436,4.436,0,0,1,1.076,2.906c0,4.944-4.709,8.965-10.5,8.965s-10.5-4.021-10.5-8.965a4.431,4.431,0,0,1,1.076-2.906,4.753,4.753,0,0,0,0-5.635,4.465,4.465,0,0,1,0-5.814,3.928,3.928,0,0,0,.925-2.817,4.409,4.409,0,0,0-.325-1.85H32.154c-1.669,9.049-2.959,17-2.959,21.742,0,11.336.365,21.745.981,31.312Z"
    />
    <path
      index="9"
      class="region"
      d="M144.022,338.282H88.028c1.7,55.271,4.788,91.888,8.775,103.675.443,1.309-.024,3.987-.732,8.04a131.433,131.433,0,0,0-2.378,23.49c0,14.518,1.666,37.993,1.683,38.229,0,5.226-.5,11.176-.933,16.425-.355,4.253-.662,7.926-.662,10.518,0,2.933.279,6.989.548,10.91.27,3.941.55,8.016.55,10.988,0,.94-.055,2.067-.113,3.259-.224,4.635-.53,10.982,2.067,13.707a4.573,4.573,0,0,0,3.5,1.372c8.829,0,28.907-4.886,28.907-12.934,0-2.358-2.576-5.645-5.559-9.45-4.251-5.425-9.542-12.176-9.542-19.378,0-4.985,2.794-13.875,6.029-24.169,4.839-15.393,10.86-34.55,10.86-50.511a171.145,171.145,0,0,0-1.179-20.07,115.616,115.616,0,0,1-.862-12.912c0-3.892,1.41-9.729,3.363-17.806A403.426,403.426,0,0,0,144.022,338.282Z"
    />
    <path
      index="9"
      class="region"
      d="M78.2,450c-.708-4.053-1.175-6.731-.732-8.04,3.987-11.787,7.073-48.4,8.774-103.675H30.247a403.426,403.426,0,0,0,11.669,73.383c1.952,8.077,3.363,13.914,3.363,17.806a115.616,115.616,0,0,1-.862,12.912,171.145,171.145,0,0,0-1.179,20.07c0,15.961,6.021,35.118,10.86,50.511,3.235,10.294,6.029,19.184,6.029,24.169,0,7.2-5.291,13.953-9.543,19.378-2.982,3.805-5.558,7.092-5.558,9.45,0,8.048,20.077,12.934,28.907,12.934a4.574,4.574,0,0,0,3.5-1.372c2.6-2.725,2.29-9.072,2.066-13.707-.057-1.192-.112-2.319-.112-3.259,0-2.972.28-7.047.55-10.988.269-3.921.547-7.977.547-10.91,0-2.592-.306-6.265-.661-10.518-.438-5.249-.935-11.2-.935-16.386.019-.275,1.685-23.751,1.685-38.268A131.433,131.433,0,0,0,78.2,450Z"
    />
    <path
      class="outline"
      d="M100.336,580a5.7,5.7,0,0,1-4.3-1.714c-2.924-3.07-2.6-9.69-2.37-14.523.057-1.179.111-2.292.111-3.206,0-2.934-.279-6.989-.548-10.911-.27-3.941-.549-8.016-.549-10.987,0-2.638.308-6.332.665-10.61.436-5.227.931-11.152.931-16.294-.016-.2-1.685-23.711-1.685-38.268a132.37,132.37,0,0,1,2.4-23.68c.654-3.747,1.127-6.453.774-7.5-4.76-14.069-7.286-57.52-8.623-97.4-1.336,39.876-3.862,83.327-8.622,97.4-.353,1.043.12,3.749.774,7.5a132.464,132.464,0,0,1,2.395,23.68c0,14.557-1.669,38.072-1.687,38.307,0,5.1.5,11.028.933,16.255.357,4.278.665,7.972.665,10.61,0,2.971-.279,7.046-.549,10.987-.27,3.922-.548,7.977-.548,10.911,0,.914.054,2.027.111,3.206.234,4.833.554,11.453-2.37,14.523a5.7,5.7,0,0,1-4.3,1.714c-8.71,0-30.012-4.92-30.012-14.039,0-2.74,2.685-6.165,5.794-10.132,4.147-5.291,9.307-11.875,9.307-18.7,0-4.816-2.77-13.63-5.978-23.837-4.861-15.466-10.911-34.713-10.911-50.843a172.314,172.314,0,0,1,1.185-20.187,113.118,113.118,0,0,0,.856-12.8c0-3.76-1.4-9.543-3.332-17.547-4.769-19.738-12.751-52.774-12.751-106.058,0-6.44,2.307-18.534,4.751-31.339,2.8-14.648,5.962-31.249,5.962-41.329,0-6.944-3.935-31.693-5.81-43.085-.238,7.374-.763,18.526-1.174,27.26-.32,6.794-.572,12.16-.572,13.23,0,1.281-.1,3.892-.206,6.916-.145,3.991-.31,8.516-.31,11.422,0,3.988-1.86,13.724-3.658,23.14-.545,2.852-1.083,5.668-1.559,8.269-1.973,10.794-2.737,31.871-2.8,33.644a46.625,46.625,0,0,1,3.237,15.683c0,7.2-1.264,15.616-4.826,15.616a3.058,3.058,0,0,1-2.209-.814c-.438,16.269-4.714,18.436-8.463,18.436C6.763,362.915,0,346.882,0,335.643a64.732,64.732,0,0,1,3.757-21c-.011-4.8-.752-11.793-1.538-19.2C1.293,286.723.336,277.7.336,270.492a173.764,173.764,0,0,1,1.43-20.244,112.927,112.927,0,0,0,.971-12.083c0-.5-.016-1.439-.038-2.76-1.1-64.687,5.191-86,10.662-92.48,8.957-10.618,23.659-14.8,35.472-18.15,7.109-2.02,13.247-3.763,15.463-6.366,1.715-2.014,1.734-8.812.051-17.334a52.778,52.778,0,0,1-7.14-18.04c-3.892-.28-6.436-5.267-7.418-7.192A31.566,31.566,0,0,1,46.366,64.25c-.307-2.951.077-4.968,1.14-6a2.4,2.4,0,0,1,1.047-.606c-2.294-12.855-.446-27.215,4.866-37.619C58.082,10.9,67.714.01,87.122,0c19.433.01,29.065,10.9,33.728,20.029,5.311,10.4,7.16,24.764,4.865,37.619a2.393,2.393,0,0,1,1.047.606c1.064,1.028,1.448,3.045,1.141,5.995a31.593,31.593,0,0,1-3.424,11.594c-.981,1.925-3.526,6.911-7.417,7.192a52.8,52.8,0,0,1-7.14,18.04c-1.683,8.522-1.664,15.32.051,17.334,2.216,2.6,8.354,4.346,15.462,6.366,11.813,3.355,26.516,7.532,35.473,18.15,5.47,6.484,11.761,27.793,10.662,92.48-.022,1.321-.038,2.264-.038,2.76a112.927,112.927,0,0,0,.971,12.083,173.764,173.764,0,0,1,1.43,20.244c0,7.207-.957,16.231-1.883,24.958-.786,7.4-1.528,14.4-1.538,19.2a64.732,64.732,0,0,1,3.757,21c0,11.239-6.763,27.272-10.456,27.272-3.749,0-8.025-2.167-8.463-18.436a3.058,3.058,0,0,1-2.209.814c-3.562,0-4.826-8.412-4.826-15.616a46.625,46.625,0,0,1,3.237-15.683c-.061-1.773-.825-22.851-2.8-33.644-.476-2.6-1.014-5.417-1.559-8.269-1.8-9.416-3.658-19.152-3.658-23.14,0-2.906-.165-7.431-.311-11.422-.11-3.024-.206-5.635-.206-6.916,0-1.07-.252-6.436-.572-13.23-.411-8.734-.935-19.886-1.173-27.26-1.875,11.393-5.81,36.141-5.81,43.085,0,10.08,3.167,26.681,5.962,41.329,2.444,12.805,4.751,24.9,4.751,31.339,0,53.284-7.982,86.32-12.751,106.058-1.935,8-3.332,13.787-3.332,17.547a112.886,112.886,0,0,0,.856,12.8,172.314,172.314,0,0,1,1.185,20.187c0,16.13-6.05,35.377-10.911,50.843-3.208,10.207-5.978,19.021-5.978,23.837,0,6.821,5.16,13.4,9.307,18.7,3.109,3.967,5.793,7.392,5.793,10.132C130.347,575.08,109.046,580,100.336,580Zm-13.2-254.3a.553.553,0,0,1,.553.539c1.608,62,4.846,103.1,9.116,115.72.443,1.309-.024,3.987-.732,8.04a131.433,131.433,0,0,0-2.378,23.49c0,14.518,1.666,37.993,1.683,38.229,0,5.226-.5,11.176-.933,16.425-.355,4.253-.662,7.926-.662,10.518,0,2.933.279,6.989.548,10.91.27,3.942.55,8.016.55,10.988,0,.94-.055,2.067-.113,3.259-.224,4.635-.53,10.982,2.067,13.707a4.573,4.573,0,0,0,3.5,1.372c8.829,0,28.907-4.886,28.907-12.934,0-2.358-2.576-5.645-5.559-9.45-4.251-5.425-9.542-12.176-9.542-19.378,0-4.985,2.794-13.875,6.029-24.169,4.839-15.393,10.86-34.55,10.86-50.511a171.145,171.145,0,0,0-1.179-20.07,115.616,115.616,0,0,1-.862-12.912c0-3.892,1.41-9.729,3.363-17.806,4.757-19.69,12.72-52.647,12.72-105.8,0-6.335-2.3-18.38-4.731-31.132-2.941-15.414-5.982-31.352-5.982-41.536,0-9.161,6.518-47.459,6.8-49.085a.542.542,0,0,1,.591-.457.552.552,0,0,1,.506.55c0,5.508.751,21.464,1.3,33.115.32,6.808.573,12.186.573,13.282,0,1.261.095,3.863.205,6.876.146,4,.312,8.536.312,11.462,0,3.883,1.85,13.567,3.638,22.933.546,2.855,1.084,5.673,1.56,8.278,2.065,11.3,2.813,33.7,2.821,33.923a.561.561,0,0,1-.043.231,46.488,46.488,0,0,0-3.2,15.371c0,8.273,1.6,14.511,3.721,14.511,2.068,0,2.173-2.054,2.173-2.466a.552.552,0,1,1,1.1,0c.013,20.088,5.186,20.088,7.395,20.088,2.5,0,9.351-14.834,9.351-26.167a63.387,63.387,0,0,0-3.718-20.692.547.547,0,0,1-.039-.2c0-4.856.75-11.928,1.544-19.415.923-8.7,1.877-17.692,1.877-24.841a172.83,172.83,0,0,0-1.423-20.12,113.543,113.543,0,0,1-.978-12.207c0-.5.016-1.449.039-2.779,1.093-64.345-5.054-85.409-10.4-91.749-8.739-10.36-23.261-14.485-34.93-17.8-7.58-2.153-13.568-3.853-16-6.711-2.346-2.756-1.678-11.3-.271-18.373a.559.559,0,0,1,.081-.2,51.432,51.432,0,0,0,7.11-18.147.524.524,0,0,1,.561-.468l.1,0c3.414,0,5.945-4.961,6.783-6.6a30.583,30.583,0,0,0,3.309-11.208c.35-3.363-.343-4.615-.787-5.062a1.182,1.182,0,0,0-.888-.392.56.56,0,0,1-.608-.651c2.415-12.774.63-27.142-4.656-37.5C115.343,11.674,106,1.114,87.146,1.105,68.273,1.114,58.926,11.674,54.4,20.532c-5.286,10.355-7.071,24.723-4.656,37.5a.553.553,0,0,1-.143.484.539.539,0,0,1-.475.166,1.19,1.19,0,0,0-.879.393c-.444.447-1.136,1.7-.786,5.063a30.584,30.584,0,0,0,3.309,11.207c.846,1.656,3.42,6.751,6.883,6.6a.529.529,0,0,1,.562.468,51.511,51.511,0,0,0,7.11,18.147.559.559,0,0,1,.081.2c1.407,7.075,2.074,15.617-.272,18.373-2.433,2.858-8.421,4.558-16,6.711-11.669,3.315-26.191,7.44-34.931,17.8-5.349,6.34-11.495,27.4-10.4,91.749.023,1.33.039,2.28.039,2.779a113.543,113.543,0,0,1-.978,12.207,172.83,172.83,0,0,0-1.423,20.12c0,7.149.954,16.143,1.877,24.841.794,7.487,1.544,14.559,1.544,19.415a.547.547,0,0,1-.039.2,63.387,63.387,0,0,0-3.718,20.692c0,11.333,6.847,26.167,9.351,26.167,2.209,0,7.382,0,7.394-20.088a.554.554,0,0,1,.553-.553h0a.553.553,0,0,1,.552.553c0,.412.105,2.466,2.173,2.466,2.121,0,3.721-6.238,3.721-14.511a46.488,46.488,0,0,0-3.2-15.371.561.561,0,0,1-.043-.231c.008-.225.755-22.628,2.821-33.923.476-2.6,1.014-5.423,1.559-8.278,1.789-9.366,3.639-19.05,3.639-22.933,0-2.926.165-7.461.311-11.462.11-3.013.205-5.615.205-6.876,0-1.1.253-6.474.574-13.282.548-11.651,1.3-27.607,1.3-33.115a.552.552,0,0,1,.506-.55.545.545,0,0,1,.591.457c.277,1.626,6.8,39.924,6.8,49.085,0,10.184-3.041,26.122-5.982,41.536-2.433,12.752-4.732,24.8-4.732,31.132,0,53.152,7.963,86.109,12.721,105.8,1.952,8.077,3.363,13.914,3.363,17.806a115.616,115.616,0,0,1-.862,12.912,171.145,171.145,0,0,0-1.179,20.07c0,15.961,6.021,35.118,10.86,50.511,3.235,10.294,6.029,19.184,6.029,24.169,0,7.2-5.291,13.953-9.543,19.378-2.982,3.805-5.558,7.092-5.558,9.45,0,8.048,20.077,12.934,28.907,12.934a4.574,4.574,0,0,0,3.5-1.372c2.6-2.725,2.29-9.072,2.066-13.707-.057-1.192-.112-2.319-.112-3.259,0-2.972.28-7.046.55-10.988.269-3.921.547-7.977.547-10.91,0-2.592-.306-6.265-.661-10.518-.438-5.249-.935-11.2-.935-16.386.019-.275,1.685-23.751,1.685-38.268A131.433,131.433,0,0,0,78.2,450c-.708-4.053-1.175-6.731-.732-8.04,4.27-12.623,7.507-53.721,9.116-115.72A.553.553,0,0,1,87.134,325.7Z"
    />
  </svg>`;case"ct_child_vascular":return V`<svg
    id="ct_child_vascular"
    hidden
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    style="width:10.89375rem; height:36.25rem;"
    viewBox="0 0 174.3 580"
    xml:space="preserve"
  >
    <path
      index="1"
      class="region"
      d="M87.134,113c23.942-.02,28.87-30.28,28.917-30.586a.549.549,0,0,1,.562-.468c3.481.125,6.038-4.943,6.883-6.6a30.6,30.6,0,0,0,3.31-11.208c.043-.424.071-.814.084-1.173,0-.091,0-.164,0-.251,0-.255.009-.51,0-.733-.006-.139-.021-.253-.031-.38-.011-.147-.019-.3-.036-.436s-.042-.24-.063-.358c-.019-.1-.034-.214-.056-.3-.026-.11-.057-.2-.086-.295-.024-.077-.045-.163-.07-.232s-.065-.15-.1-.222-.054-.13-.082-.183-.066-.108-.1-.161-.058-.1-.087-.137-.066-.08-.1-.117-.051-.061-.075-.085a1.232,1.232,0,0,0-.206-.158c-.037-.026-.076-.063-.111-.083a1.235,1.235,0,0,0-.244-.1c-.009,0-.02-.009-.029-.011a.97.97,0,0,0-.291-.034.508.508,0,0,1-.085-.011.544.544,0,0,1-.38-.156.552.552,0,0,1-.142-.484c2.414-12.773.63-27.141-4.657-37.5C115.344,11.674,106,1.114,87.146,1.105,69.453,1.113,60.131,10.4,55.309,18.854q-.481.846-.9,1.678c-5.287,10.356-7.072,24.723-4.657,37.5a.553.553,0,0,1-.143.484.539.539,0,0,1-.475.166,1.183,1.183,0,0,0-.879.393,2.935,2.935,0,0,0-.691,1.438,11.16,11.16,0,0,0-.095,3.625,30.137,30.137,0,0,0,1.691,7.495,32.947,32.947,0,0,0,1.619,3.712c.845,1.656,3.376,6.693,6.883,6.6h.016a.552.552,0,0,1,.48.28h0a.569.569,0,0,1,.065.187C58.265,82.715,63.208,112.975,87.134,113Z"
    />
    <path
      index="2"
      class="region"
      d="M43.52,150.609h87.263L141,130.965a161.811,161.811,0,0,0-15.863-5.128c-7.58-2.153-13.568-3.853-16-6.711-2.1-2.462-1.784-9.539-.691-16.066-4.562,6.021-11.343,11.031-21.307,11.04-9.963-.009-16.744-5.019-21.305-11.04,1.093,6.527,1.4,13.605-.691,16.066-2.434,2.858-8.421,4.558-16,6.711A162.273,162.273,0,0,0,33.3,130.954Z"
    />
    <path
      index="3"
      class="region"
      d="M25.987,271.883c1.79-9.37,3.64-19.058,3.64-22.942,0-2.926.166-7.461.312-11.462.11-3.013.2-5.615.2-6.876,0-1.1.253-6.474.573-13.282.548-11.651,1.3-27.607,1.3-33.115a.5.5,0,0,1,.02-.1.49.49,0,0,1,.007-.067l10.545-32.826L32.275,131.374c-6.808,2.822-13.3,6.61-18.07,12.263-5.349,6.34-11.495,27.4-10.4,91.749.022,1.33.038,2.279.038,2.779a113.543,113.543,0,0,1-.978,12.207,173.05,173.05,0,0,0-1.423,20.12c0,7.149.955,16.143,1.877,24.842.794,7.486,1.544,14.558,1.544,19.414a.546.546,0,0,1-.038.2,63.342,63.342,0,0,0-3.719,20.692c0,11.333,6.848,26.167,9.351,26.167,2.209,0,7.383,0,7.4-20.088a.553.553,0,1,1,1.105,0c0,.412.1,2.467,2.173,2.467,2.121,0,3.721-6.239,3.721-14.512a46.477,46.477,0,0,0-3.2-15.371.561.561,0,0,1-.043-.231c.008-.225.756-22.627,2.821-33.923C24.9,277.551,25.442,274.735,25.987,271.883Z"
    />
    <path
      index="3"
      class="region"
      d="M169.446,314.951a.547.547,0,0,1-.039-.2c0-4.856.75-11.928,1.544-19.414.923-8.7,1.877-17.693,1.877-24.842a172.83,172.83,0,0,0-1.423-20.12,113.8,113.8,0,0,1-.978-12.207c0-.5.017-1.449.039-2.779,1.093-64.345-5.053-85.409-10.4-91.749-4.762-5.645-11.244-9.431-18.043-12.251l-10.307,19.826,10.513,32.826a.5.5,0,0,1,.008.077.473.473,0,0,1,.018.091c0,5.508.751,21.464,1.3,33.115.32,6.808.574,12.186.574,13.282,0,1.261.095,3.863.2,6.876.146,4,.311,8.536.311,11.462,0,3.882,1.849,13.562,3.637,22.923.546,2.859,1.085,5.681,1.561,8.288,2.065,11.3,2.813,33.7,2.821,33.923a.577.577,0,0,1-.042.231,46.448,46.448,0,0,0-3.2,15.371c0,8.273,1.6,14.512,3.721,14.512,2.068,0,2.173-2.055,2.173-2.467a.552.552,0,1,1,1.1,0c.012,20.088,5.185,20.088,7.395,20.088,2.5,0,9.352-14.834,9.352-26.167A63.4,63.4,0,0,0,169.446,314.951Z"
    />
    <path
      index="4"
      class="region"
      d="M130.714,151.713H43.587L33.136,184.248c.317,1.862,3.288,19.39,5.189,33.366h97.619c1.9-13.981,4.873-31.514,5.189-33.367Zm-15.981,39.232c-2.153,7.193-18.341,4.716-23.842,3.281a22.639,22.639,0,0,1-4.7-1.849,9.516,9.516,0,0,1-.248,2.64c-.4.915-1.962,1.241-3.293,1.241s-2.9-.326-3.293-1.242a11.442,11.442,0,0,1-.271-3.341,28.889,28.889,0,0,0-.378-5.282,7.879,7.879,0,0,1-.783-1.159c-2.336-4.467-1.913-14.245.8-18.751a20.8,20.8,0,0,0,.522-5.285,9.449,9.449,0,0,1,.271-2.964c.4-.915,1.962-1.242,3.294-1.242s2.895.327,3.293,1.243a12.1,12.1,0,0,1,.27,3.445c.01.823.022,1.731.065,2.56,10.263-2.492,14.289.035,17.815,3.086C111.415,173.527,116.509,185.006,114.733,190.945Z"
    />
    <path
      index="5"
      class="region"
      d="M85.927,190.974a21.884,21.884,0,0,0,5.242,2.183c6.321,1.65,20.761,3.3,22.505-2.529,1.642-5.486-3.384-16.614-10.145-22.467-2.846-2.465-6.391-5.531-17.462-2.69a.563.563,0,0,1-.457-.086.548.548,0,0,1-.23-.4c-.084-1.02-.1-2.224-.113-3.287a16.26,16.26,0,0,0-.178-3.019,4.788,4.788,0,0,0-4.561,0,11.337,11.337,0,0,0-.18,2.54,21.162,21.162,0,0,1-.592,5.665A.493.493,0,0,1,79.7,167c-2.538,4.141-2.964,13.581-.8,17.72a7.591,7.591,0,0,0,.75,1.088.57.57,0,0,1,.1.21,28.351,28.351,0,0,1,.436,5.642,14.716,14.716,0,0,0,.179,2.915,4.784,4.784,0,0,0,4.561,0,22.8,22.8,0,0,0,.173-3.111.57.57,0,0,1,.278-.481A.555.555,0,0,1,85.927,190.974Z"
    />
    <path
      index="6"
      class="region"
      d="M86.292,336.562q.153-5.066.29-10.325a.553.553,0,0,1,1.105,0c.091,3.517.188,6.951.289,10.325h56.155c.592-9.4.943-19.6.943-30.7,0-6.334-2.3-18.38-4.732-31.132-2.941-15.414-5.982-31.352-5.982-41.536a139.428,139.428,0,0,1,1.435-14.479H38.474A139.525,139.525,0,0,1,39.91,233.2c0,10.184-3.042,26.122-5.983,41.536-2.433,12.752-4.731,24.8-4.731,31.132,0,11.1.35,21.3.943,30.7Z"
    />
    <path
      index="3"
      class="region"
      d="M144.063,337.666H88.008c1.706,56.326,4.732,92.28,8.8,104.291.444,1.31-.025,3.987-.732,8.04a131.455,131.455,0,0,0-2.378,23.49c0,14.517,1.667,37.993,1.684,38.228,0,5.228-.495,11.178-.934,16.427-.355,4.253-.662,7.925-.662,10.517,0,2.933.279,6.989.547,10.91.271,3.941.551,8.016.551,10.988,0,.94-.054,2.067-.113,3.259-.224,4.635-.53,10.981,2.067,13.707a4.574,4.574,0,0,0,3.5,1.372c8.829,0,28.906-4.886,28.906-12.934,0-2.358-2.576-5.645-5.559-9.45-4.251-5.425-9.542-12.176-9.542-19.378,0-4.985,2.794-13.875,6.03-24.169,4.838-15.393,10.859-34.55,10.859-50.511a171.145,171.145,0,0,0-1.179-20.07,115.6,115.6,0,0,1-.862-12.911c0-3.892,1.41-9.73,3.363-17.808A403.313,403.313,0,0,0,144.063,337.666Z"
    />
    <path
      index="3"
      class="region"
      d="M78.2,450c-.708-4.053-1.175-6.731-.732-8.04,4-11.831,7.1-48.672,8.794-104.291H30.206a403.4,403.4,0,0,0,11.71,74c1.952,8.078,3.363,13.916,3.363,17.808a115.6,115.6,0,0,1-.862,12.911,171.145,171.145,0,0,0-1.179,20.07c0,15.961,6.021,35.118,10.86,50.511,3.235,10.294,6.029,19.184,6.029,24.169,0,7.2-5.291,13.953-9.543,19.378-2.982,3.805-5.557,7.092-5.557,9.45,0,8.048,20.077,12.934,28.906,12.934a4.571,4.571,0,0,0,3.5-1.372c2.6-2.725,2.29-9.072,2.066-13.706-.057-1.192-.112-2.32-.112-3.26,0-2.972.28-7.047.55-10.988.269-3.921.547-7.977.547-10.91,0-2.592-.306-6.264-.661-10.517-.438-5.249-.934-11.2-.934-16.387.018-.275,1.685-23.751,1.685-38.268A131.439,131.439,0,0,0,78.2,450Z"
    />
    <path
      class="vascular"
      d="M123.165,236.72a1.1,1.1,0,0,1-1.56.14c-5.86-4.86-11.17-3.73-17.32-2.41-4.02.86-8.5,1.82-13.58,1.12-.12,2.92-.33,6.13-.58,9.22,1.14,2.48,3,4.07,4.92,5.71,2.18,1.85,4.44,3.78,5.42,7.07a.556.556,0,0,1-.37.69.875.875,0,0,1-.16.02.555.555,0,0,1-.53-.39c-.89-2.99-2.92-4.72-5.08-6.55a21.777,21.777,0,0,1-4.36-4.56c-.43,5.13-.91,9.63-1.12,11.49,16.94,19.38,26.48,33.02,28.25,48.7,1.6,14.13,1.5,33.91,1.42,51.35-.05,9.74-.09,18.16.17,24.21.73,17.1,1.52,40.88,1.52,56.34,0,15.37-4.46,61.24-7.1,76.35-6.06,34.8,7.08,44.81,7.21,44.9a1.1,1.1,0,1,1-1.28,1.8c-.59-.42-14.44-10.74-8.11-47.08,2.55-14.6,6.81-58.03,7.06-74.55-.06.48-.12.94-.19,1.44-1.52,11.49-3.81,28.85-7.82,49.4-4.03,20.71-6.05,35.02-6.35,45.03-.62,21.11,6.82,23.03,6.9,23.04a.566.566,0,0,1,.42.66.547.547,0,0,1-.54.44c-.03,0-.07-.01-.11-.01-.34-.07-8.42-1.97-7.77-24.16.3-10.07,2.32-24.44,6.37-45.21,4-20.52,6.29-37.86,7.81-49.34.5-3.81.91-6.9,1.25-9.11-.16-15.08-.84-34.99-1.48-49.85-.26-6.1-.22-14.54-.17-24.31.08-17.38.18-37.09-1.4-51.09a48.8,48.8,0,0,0-4.74-15.81c1.3,10.2.41,18.89-.53,28.01-.87,8.43-1.77,17.15-1.14,28.05a.565.565,0,0,1-.52.59h-.04a.556.556,0,0,1-.55-.52c-.63-10.99.27-19.76,1.15-28.23,1.03-9.99,2.01-19.46.06-30.95-4.68-8.62-11.86-17.71-21.46-28.69-9.62,11-16.8,20.1-21.49,28.72-1.94,11.48-.96,20.94.07,30.92.87,8.47,1.78,17.24,1.14,28.23a.549.549,0,0,1-.55.52h-.03a.552.552,0,0,1-.52-.59c.63-10.9-.27-19.62-1.14-28.05-.94-9.11-1.83-17.79-.53-27.99a48.592,48.592,0,0,0-4.74,15.79c-1.58,14-1.49,33.7-1.4,51.09.05,9.77.09,18.21-.17,24.31-.64,14.86-1.32,34.77-1.49,49.85.35,2.21.76,5.3,1.26,9.12,1.52,11.48,3.81,28.82,7.81,49.33,4.05,20.76,6.07,35.13,6.37,45.21.65,22.19-7.43,24.09-7.78,24.16-.03,0-.07.01-.11.01a.546.546,0,0,1-.54-.45.559.559,0,0,1,.43-.65c.11-.02,7.51-1.98,6.89-23.04-.29-10.02-2.31-24.33-6.35-45.03-4-20.55-6.3-37.91-7.81-49.39-.07-.5-.13-.97-.19-1.45.24,16.51,4.51,59.95,7.05,74.55,6.34,36.34-7.51,46.66-8.1,47.08a1.107,1.107,0,0,1-1.29-1.8c.23-.17,13.26-10.23,7.22-44.9-2.64-15.11-7.11-60.98-7.11-76.35,0-15.46.79-39.24,1.53-56.34.26-6.06.22-14.47.17-24.21-.09-17.45-.18-37.22,1.41-51.35,1.78-15.69,11.36-29.35,28.38-48.81.3-2.74,1.51-14.07,1.87-22.61-5.13.74-9.67-.23-13.73-1.1-6.14-1.32-11.46-2.46-17.32,2.41a1.084,1.084,0,0,1-.7.26,1.1,1.1,0,0,1-.85-.4,1.109,1.109,0,0,1,.14-1.56c6.69-5.55,12.76-4.25,19.2-2.87,4.16.89,8.45,1.79,13.34,1a47.369,47.369,0,0,0-.13-5.64c-.68-5.93,1-12.83,3.13-21.56.39-1.61.8-3.31,1.21-5.06a44.9,44.9,0,0,1-10.51,1.4,36.252,36.252,0,0,1-8.6-1.12,24.869,24.869,0,0,0-5.44-.81h-.21a.555.555,0,0,1,0-1.11,25.916,25.916,0,0,1,5.89.84c4.15.93,9.26,2.06,19.16-.41q.69-2.97,1.34-6.17c1,.2,2.1.39,3.26.55-.4,2.02-.83,3.99-1.26,5.88,8.25,3.95,12.09,3.94,17.81,3.92,2.15-.01,4.57-.02,7.58.18a.55.55,0,0,1-.03,1.1h-.04c-2.97-.19-5.37-.18-7.5-.17-5.81.02-9.76.03-18.08-3.93-.46,1.98-.92,3.89-1.36,5.69q-.72,2.94-1.34,5.59c7.13,1.64,8.16,4.61,9.15,7.5.67,1.93,1.29,3.76,3.69,5.38a.55.55,0,0,1,.14.77.53.53,0,0,1-.45.24.561.561,0,0,1-.31-.09,10.264,10.264,0,0,1-4.11-5.94c-.98-2.83-1.83-5.3-8.35-6.78-1.19,5.36-1.92,9.89-1.48,13.74a48.068,48.068,0,0,1,.14,6.06c4.77.71,8.97-.18,13.05-1.05,6.43-1.38,12.51-2.68,19.19,2.87A1.11,1.11,0,0,1,123.165,236.72Z"
    />
    <path
      class="vascular"
      d="M164.468,302.707c-1.98-11.562-1.528-26.123-1.128-38.968.346-11.132.646-20.746-.6-26.769-.518-2.5-1.383-5.313-2.386-8.572-2.738-8.9-6.488-21.1-5.111-35.36,2.111-21.878-5.325-41.15-18.5-47.959-10.794-5.575-24.208-2.269-37.836,9.268a10.419,10.419,0,0,0-2.04-.457,9.175,9.175,0,0,0-1.566-.047c-1.341-11.869-1.773-34.566.405-43.706.4-1.7.793-3.49,1.168-5.338.009-.01.023-.015.031-.026,8.458-11.8,10.037-32.062,10.052-32.265a.552.552,0,0,0-1.1-.081c-.014.188-1.39,17.833-8.432,29.539,2.707-14.522,4.23-32.178,1.947-43.312A1.1,1.1,0,0,0,97.2,59.1c2.666,13-.022,35.306-3.649,50.526-2.237,9.389-1.8,32.6-.435,44.607a7.685,7.685,0,0,0-1.069.453,57.25,57.25,0,0,0-6.526-6.01c-.206-4.632-2.62-29.962-4.785-39.05C77.112,94.4,74.423,72.1,77.09,59.1a1.1,1.1,0,0,0-2.164-.444c-2.284,11.134-.761,28.79,1.946,43.312-7.039-11.7-8.418-29.351-8.432-29.539a.552.552,0,0,0-1.1.081c.015.2,1.594,20.469,10.051,32.265.009.011.023.016.032.026.374,1.848.764,3.643,1.167,5.338,1.947,8.169,4.057,29.679,4.6,36.824-11.5-7.992-24.521-9.826-36.559-4.735-18.041,7.628-28.907,28.042-27.038,50.8,1.178,14.329-2.493,26.537-5.173,35.451-.971,3.229-1.809,6.017-2.322,8.5-1.246,6.023-.947,15.637-.6,26.769.4,12.845.852,27.406-1.128,38.968-5.407,31.568-.9,43.154-.706,43.632a1.1,1.1,0,0,0,2.048-.83c-.045-.112-4.438-11.636.836-42.429,2.017-11.782,1.561-26.46,1.158-39.41-.342-10.992-.638-20.485.556-26.252.493-2.384,1.319-5.129,2.274-8.308.725-2.412,1.52-5.067,2.276-7.932.412,7.48,1.62,15.42,2.654,22.161.664,4.341,1.239,8.09,1.43,10.691.581,7.889-1.367,16.542-3.831,27.5l-.1.426c-6.417,28.523,2.122,45.23,2.209,45.4a.552.552,0,0,0,.978-.513c-.085-.162-8.438-16.509-2.109-44.639l.1-.427C22.631,270.725,24.594,262,24,253.949c-.194-2.645-.772-6.413-1.44-10.777-1.21-7.9-2.665-17.443-2.779-25.909A79.415,79.415,0,0,0,21.8,192.841c-1.791-21.8,8.536-41.324,25.7-48.58,14.5-6.132,29.965-1.856,42.726,11.7-.054.051-.113.094-.166.147-2.1,2.08-3.11,5.28-2.83,9.08.01.24.03.49.06.74a2.208,2.208,0,1,0,4.39-.48c-.03-.34-.06-.68-.07-1a6.93,6.93,0,0,1,1.56-5.2,3.639,3.639,0,0,1,3.16-.98,4.2,4.2,0,0,1,3.13,1.69c.85,1.27,1.02,3.2.49,5.65a16.2,16.2,0,0,1,3.58,2.55l.23.2c.1-.28.21-.62.32-1.05,1.29-5.03.2-8.12-.96-9.82a7.85,7.85,0,0,0-2.049-2.066c12.642-10.426,24.9-13.421,34.661-8.382,12.384,6.4,19.343,24.8,17.317,45.784a75.444,75.444,0,0,0,2,24.855c-.154,8.363-1.576,17.726-2.767,25.494-.668,4.362-1.246,8.13-1.44,10.774-.592,8.052,1.371,16.776,3.856,27.82l.1.427c6.32,28.093-2.024,44.477-2.11,44.639a.552.552,0,1,0,.978.513c.088-.165,8.626-16.872,2.21-45.4l-.1-.426c-2.465-10.955-4.412-19.608-3.832-27.5.191-2.6.766-6.348,1.43-10.687,1.021-6.66,2.21-14.488,2.636-21.888.743,2.737,1.523,5.275,2.235,7.593.986,3.2,1.838,5.973,2.333,8.37,1.194,5.767.9,15.26.557,26.252-.4,12.95-.86,27.628,1.158,39.41,5.274,30.793.881,42.317.837,42.426a1.1,1.1,0,0,0,.607,1.439,1.09,1.09,0,0,0,.416.082,1.107,1.107,0,0,0,1.024-.688C165.368,345.861,169.874,334.275,164.468,302.707Z"
    />
    <path
      class="outline"
      d="M100.337,580a5.694,5.694,0,0,1-4.3-1.715c-2.924-3.069-2.6-9.689-2.37-14.522.057-1.179.111-2.292.111-3.206,0-2.934-.279-6.989-.547-10.911-.271-3.941-.55-8.016-.55-10.987,0-2.638.308-6.332.665-10.609.436-5.228.931-11.153.931-16.295-.015-.2-1.685-23.711-1.685-38.268a132.381,132.381,0,0,1,2.4-23.68c.654-3.745,1.127-6.453.774-7.5-4.759-14.067-7.286-57.519-8.623-97.4-1.335,39.876-3.862,83.327-8.622,97.4-.353,1.043.12,3.749.774,7.5a132.381,132.381,0,0,1,2.395,23.68c0,14.557-1.669,38.072-1.686,38.307,0,5.1.5,11.028.932,16.256.357,4.277.665,7.971.665,10.609,0,2.971-.279,7.046-.549,10.987-.27,3.922-.548,7.977-.548,10.911,0,.914.054,2.028.111,3.206.234,4.834.554,11.454-2.37,14.523a5.7,5.7,0,0,1-4.3,1.714c-8.709,0-30.011-4.92-30.011-14.039,0-2.74,2.685-6.165,5.793-10.132,4.147-5.291,9.307-11.875,9.307-18.7,0-4.816-2.77-13.63-5.978-23.837-4.861-15.466-10.911-34.713-10.911-50.843a172.3,172.3,0,0,1,1.185-20.187,113.116,113.116,0,0,0,.856-12.794c0-3.76-1.4-9.544-3.332-17.548-4.769-19.739-12.751-52.775-12.751-106.058,0-6.439,2.308-18.534,4.751-31.339,2.8-14.648,5.963-31.249,5.963-41.329,0-6.944-3.936-31.693-5.811-43.085-.238,7.373-.762,18.525-1.173,27.26-.32,6.794-.573,12.16-.573,13.23,0,1.281-.1,3.892-.205,6.916-.146,3.991-.311,8.516-.311,11.422,0,3.989-1.86,13.729-3.66,23.149-.544,2.85-1.081,5.662-1.557,8.26-1.972,10.793-2.737,31.871-2.8,33.644a46.625,46.625,0,0,1,3.237,15.683c0,7.2-1.264,15.617-4.825,15.617a3.063,3.063,0,0,1-2.21-.813c-.438,16.265-4.714,18.434-8.463,18.434C6.763,362.915,0,346.882,0,335.643a64.69,64.69,0,0,1,3.758-21c-.011-4.8-.753-11.793-1.538-19.2C1.294,286.723.337,277.7.337,270.492a173.764,173.764,0,0,1,1.43-20.244,112.927,112.927,0,0,0,.971-12.083c0-.5-.017-1.439-.039-2.76-1.1-64.687,5.191-86,10.662-92.48,8.958-10.618,23.66-14.8,35.473-18.15,7.108-2.02,13.246-3.763,15.462-6.366,1.716-2.013,1.734-8.811.051-17.334a52.822,52.822,0,0,1-7.14-18.04c-3.892-.281-6.436-5.267-7.417-7.192A31.622,31.622,0,0,1,46.366,64.25c-.307-2.951.077-4.968,1.14-6a2.4,2.4,0,0,1,1.047-.606c-2.294-12.854-.445-27.214,4.867-37.619C58.082,10.9,67.714.01,87.123,0c19.432.01,29.064,10.9,33.727,20.029,5.311,10.405,7.161,24.765,4.866,37.619a2.385,2.385,0,0,1,1.046.606c1.064,1.028,1.448,3.045,1.142,5.995a31.628,31.628,0,0,1-3.425,11.594c-.981,1.925-3.525,6.911-7.417,7.192a52.8,52.8,0,0,1-7.139,18.039c-1.684,8.523-1.665,15.322.05,17.335,2.216,2.6,8.355,4.346,15.462,6.366,11.814,3.355,26.516,7.532,35.473,18.15,5.47,6.484,11.762,27.793,10.663,92.48-.023,1.321-.039,2.264-.039,2.76a112.927,112.927,0,0,0,.971,12.083,173.764,173.764,0,0,1,1.43,20.244c0,7.207-.957,16.231-1.883,24.958-.785,7.4-1.528,14.4-1.538,19.2a64.739,64.739,0,0,1,3.757,21c0,11.239-6.763,27.272-10.456,27.272-3.749,0-8.025-2.169-8.463-18.434a3.062,3.062,0,0,1-2.209.813c-3.563,0-4.826-8.413-4.826-15.617a46.59,46.59,0,0,1,3.238-15.683c-.062-1.773-.826-22.851-2.8-33.644-.476-2.6-1.014-5.423-1.559-8.279-1.8-9.411-3.656-19.144-3.656-23.13,0-2.906-.165-7.431-.311-11.422-.111-3.024-.206-5.635-.206-6.916,0-1.07-.253-6.436-.572-13.23-.412-8.734-.936-19.886-1.174-27.26-1.875,11.392-5.81,36.141-5.81,43.085,0,10.08,3.167,26.681,5.962,41.329,2.444,12.805,4.752,24.9,4.752,31.339,0,53.283-7.983,86.319-12.752,106.058-1.935,8-3.332,13.788-3.332,17.548a112.879,112.879,0,0,0,.857,12.794,172.56,172.56,0,0,1,1.184,20.187c0,16.13-6.05,35.377-10.91,50.843-3.209,10.207-5.979,19.021-5.979,23.837,0,6.821,5.16,13.4,9.307,18.7,3.109,3.967,5.793,7.392,5.793,10.132C130.347,575.08,109.046,580,100.337,580Zm-13.2-254.3a.553.553,0,0,1,.553.539c1.632,62.9,4.785,102.915,9.116,115.72.444,1.31-.025,3.987-.732,8.04a131.548,131.548,0,0,0-2.378,23.49c0,14.517,1.667,37.993,1.684,38.228,0,5.228-.495,11.178-.934,16.427-.355,4.253-.662,7.925-.662,10.517,0,2.933.279,6.989.547,10.91.271,3.942.551,8.016.551,10.988,0,.94-.054,2.067-.113,3.259-.224,4.635-.53,10.981,2.067,13.707a4.574,4.574,0,0,0,3.5,1.372c8.829,0,28.906-4.886,28.906-12.934,0-2.358-2.576-5.645-5.559-9.45-4.251-5.425-9.542-12.176-9.542-19.378,0-4.985,2.794-13.875,6.03-24.169,4.838-15.393,10.859-34.55,10.859-50.511a171.145,171.145,0,0,0-1.179-20.07,115.6,115.6,0,0,1-.862-12.911c0-3.892,1.41-9.73,3.363-17.808,4.758-19.691,12.721-52.647,12.721-105.8,0-6.334-2.3-18.38-4.732-31.132-2.941-15.414-5.982-31.352-5.982-41.536,0-9.161,6.518-47.459,6.8-49.085a.552.552,0,0,1,1.1.093c0,5.508.751,21.464,1.3,33.115.32,6.808.574,12.186.574,13.282,0,1.261.095,3.863.2,6.876.146,4,.311,8.536.311,11.462,0,3.882,1.849,13.562,3.637,22.923.546,2.859,1.085,5.681,1.561,8.288,2.065,11.3,2.813,33.7,2.821,33.923a.577.577,0,0,1-.042.231,46.448,46.448,0,0,0-3.2,15.371c0,8.273,1.6,14.512,3.721,14.512,2.068,0,2.173-2.055,2.173-2.467a.552.552,0,1,1,1.1,0c.012,20.088,5.185,20.088,7.395,20.088,2.5,0,9.352-14.834,9.352-26.167a63.4,63.4,0,0,0-3.719-20.692.547.547,0,0,1-.039-.2c0-4.856.75-11.928,1.544-19.414.923-8.7,1.877-17.693,1.877-24.842a172.83,172.83,0,0,0-1.423-20.12,113.8,113.8,0,0,1-.978-12.207c0-.5.017-1.449.039-2.779,1.093-64.345-5.053-85.409-10.4-91.749-8.74-10.36-23.262-14.485-34.931-17.8-7.58-2.153-13.568-3.853-16-6.711-2.345-2.755-1.677-11.3-.27-18.373a.541.541,0,0,1,.081-.2,51.442,51.442,0,0,0,7.109-18.147.549.549,0,0,1,.562-.468c3.481.125,6.038-4.943,6.883-6.6a30.6,30.6,0,0,0,3.31-11.208c.349-3.363-.344-4.615-.787-5.062a1.182,1.182,0,0,0-.889-.392.563.563,0,0,1-.467-.177.551.551,0,0,1-.14-.474c2.414-12.773.63-27.141-4.657-37.5C115.344,11.674,106,1.114,87.146,1.105,68.273,1.114,58.926,11.674,54.4,20.532c-5.287,10.356-7.072,24.723-4.657,37.5a.553.553,0,0,1-.143.484.539.539,0,0,1-.475.166,1.183,1.183,0,0,0-.879.393c-.444.447-1.136,1.7-.786,5.063a30.578,30.578,0,0,0,3.31,11.207c.845,1.656,3.376,6.693,6.883,6.6a.562.562,0,0,1,.562.468,51.5,51.5,0,0,0,7.109,18.147.559.559,0,0,1,.081.2c1.407,7.076,2.074,15.618-.271,18.373-2.434,2.858-8.421,4.558-16,6.711-11.668,3.315-26.191,7.44-34.931,17.8-5.349,6.34-11.495,27.4-10.4,91.749.022,1.33.038,2.279.038,2.779a113.543,113.543,0,0,1-.978,12.207,173.05,173.05,0,0,0-1.423,20.12c0,7.149.955,16.143,1.877,24.842.794,7.486,1.544,14.558,1.544,19.414a.546.546,0,0,1-.038.2,63.342,63.342,0,0,0-3.719,20.692c0,11.333,6.848,26.167,9.351,26.167,2.209,0,7.383,0,7.4-20.088a.553.553,0,0,1,.552-.553h0a.553.553,0,0,1,.553.553c0,.412.1,2.467,2.173,2.467,2.121,0,3.721-6.239,3.721-14.512a46.477,46.477,0,0,0-3.2-15.371.561.561,0,0,1-.043-.231c.008-.225.756-22.627,2.821-33.923.475-2.6,1.013-5.417,1.558-8.269,1.79-9.37,3.64-19.058,3.64-22.942,0-2.926.166-7.461.312-11.462.11-3.013.2-5.615.2-6.876,0-1.1.253-6.474.573-13.282.548-11.651,1.3-27.607,1.3-33.115a.552.552,0,0,1,1.1-.093c.277,1.626,6.8,39.924,6.8,49.085,0,10.184-3.042,26.122-5.983,41.536-2.433,12.752-4.731,24.8-4.731,31.132,0,53.151,7.962,86.107,12.72,105.8,1.952,8.078,3.363,13.916,3.363,17.808a115.6,115.6,0,0,1-.862,12.911,171.145,171.145,0,0,0-1.179,20.07c0,15.961,6.021,35.118,10.86,50.511,3.235,10.294,6.029,19.184,6.029,24.169,0,7.2-5.291,13.953-9.543,19.378-2.982,3.805-5.557,7.092-5.557,9.45,0,8.048,20.077,12.934,28.906,12.934a4.571,4.571,0,0,0,3.5-1.372c2.6-2.725,2.29-9.072,2.066-13.706-.057-1.192-.112-2.32-.112-3.26,0-2.972.28-7.046.55-10.988.269-3.921.547-7.977.547-10.91,0-2.592-.306-6.264-.661-10.517-.438-5.249-.934-11.2-.934-16.387.018-.275,1.684-23.751,1.684-38.268A131.455,131.455,0,0,0,78.2,450c-.708-4.053-1.175-6.731-.732-8.04,4.27-12.623,7.507-53.721,9.116-115.72A.552.552,0,0,1,87.134,325.7Z"
    />
  </svg>`;case"xp_abdomen":return V`<svg
    id="xp_abdomen"
    hidden
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0"
    y="0"
    style="width:12rem; height:55rem;"
    viewBox="0 0 192 580"
    style="enable-background:new 0 0 192 580;"
    xml:space="preserve"
  >
    <path
      class="region"
      index="1"
      d="M144.75,253.2c-2.93-15.46-5.95-31.45-5.95-42.41c0-7.52,3.95-33.44,5.95-46.07H47.91c2,12.63,6,38.55,6,46.07c0,11-3,27-6,42.41c-2.42,12.79-4.71,24.88-4.71,31.7c0,6.53,0.11,12.59,0.33,18.57h52.12c0.08-4.36,0.13-8,0.13-11.2c0-0.3,0.25-0.55,0.55-0.55c0.3,0,0.55,0.25,0.55,0.55c0,0,0,0,0,0c0,3.16,0,6.84,0.13,11.2h52.12c0.22-6,0.33-12,0.33-18.57C149.46,278.08,147.18,266,144.75,253.2z"
    />

    <path
      class="outline"
      d="M105.11,580c-1.35,0.05-2.65-0.49-3.58-1.47c-2.74-2.94-2.27-9.67-1.9-15.08c0.12-1.64,0.22-3.18,0.22-4.4c0-3.15-0.46-7.49-0.91-11.7s-0.91-8.61-0.91-11.81c0.13-3.57,0.49-7.13,1.06-10.65c0.85-5.42,1.34-10.9,1.47-16.39c0-0.22-3.5-28.91-3.5-44.6c-0.07-7.84,0.83-15.67,2.68-23.29c0.68-2.53,1.09-5.12,1.21-7.74c0-0.83-3.29-68.52-4.62-112.75C95,364.35,91.75,432,91.71,432.9c0.12,2.61,0.53,5.19,1.21,7.71c1.85,7.62,2.75,15.45,2.68,23.29c0,15.69-3.47,44.38-3.5,44.67c0.13,5.47,0.62,10.92,1.47,16.32c0.57,3.52,0.93,7.08,1.06,10.65c0,3.2-0.47,7.58-0.91,11.81s-0.91,8.55-0.91,11.7c0,1.22,0.1,2.76,0.22,4.4c0.37,5.41,0.84,12.14-1.9,15.08c-0.93,0.98-2.23,1.52-3.58,1.47c-8,0-27.59-5.28-27.59-15.07c0-2.92,2.54-6.59,5.49-10.85c3.94-5.71,8.85-12.81,8.85-20.19c0-5.2-2.62-14.69-5.66-25.68c-4.6-16.65-10.31-37.37-10.31-54.73c0-7.25,0.36-14.5,1.09-21.72c0.42-4.66,0.79-8.69,0.79-13.78c0-4.05-1.58-10.28-3.75-18.9C51.09,377.83,42.1,342.26,42.1,284.9c0-6.93,2.3-19.06,4.73-31.9c2.79-14.7,5.94-31.35,5.94-42.21c0-7.53-4.15-34.59-6.09-46.82c-0.24,8-0.79,20.4-1.23,30.06c-0.33,7.43-0.59,13.31-0.59,14.46c0,1.38-0.09,4.19-0.19,7.44c-0.13,4.3-0.28,9.18-0.28,12.31c0,3.63-1.5,10.44-3.23,18.33c-0.93,4.23-1.89,8.61-2.68,12.79c-0.07,0.4-0.26,1.33-0.52,2.62c-1.4,7-5.13,25.7-5,28.54c0.14,2.43,2,25.66,2.24,28.48c0.52,5.14,0.47,14-1.27,17.72c-2.73,5.73-12.43,8.39-16.78,8.48c-1.46,0.03-2.85-0.62-3.75-1.77c-4.26-5.06-3.2-20.36-2.31-27.54c-1.6,3.18-3.46,6.23-5.56,9.11c-0.85,1.26-2.51,1.69-3.86,1c-1.52-0.97-2.09-2.92-1.34-4.56c0.13-0.36,0.36-1,0.66-1.94c1.88-5.64,6.87-20.61,11.45-25c2.54-2.45,5.29-11.59,4-41.21c0-0.94-0.07-1.57-0.07-1.82c0.07-7.28,0.51-14.55,1.31-21.79c0.47-5,0.88-9.23,0.88-13c0-0.47,0-1.34,0-2.55c-0.51-41.6,1.09-93.55,11.63-104.84c1.3-1.37,2.72-2.61,4.25-3.71c10.15-7.41,26-10.78,36.43-13c4.85-1,9-1.93,9.84-2.71c2.11-2.07-0.3-15.81-1.18-19.6c-1.37-3.21-2.44-6.54-3.2-9.95c-0.23-1.08-0.39-2-0.49-2.64c-0.67,0.27-1.43,0.16-2-0.29c-0.97-0.74-1.73-1.71-2.22-2.83c-0.97-1.88-1.72-3.88-2.22-5.94l-0.23-0.88c-0.44-1.71-0.78-3.45-1-5.2c-0.3-1.81-0.37-3.65-0.21-5.48c0.04-0.74,0.27-1.47,0.66-2.1c0-0.27-0.11-0.75-0.18-1.32c-0.36-2.97-0.39-5.97-0.11-8.95c0.24-2.97,0.87-5.89,1.88-8.69c0.78-2.11,1.83-4.11,3.12-5.95c1.92-2.67,4.4-4.89,7.27-6.5C84.93,1.13,89.95,0,96.33,0s11.41,1.13,15.79,3.55c2.87,1.61,5.35,3.83,7.27,6.5c1.27,1.85,2.3,3.84,3.06,5.95c1.01,2.8,1.64,5.72,1.88,8.69c0.28,3,0.24,6.01-0.12,9c-0.07,0.57-0.14,1-0.18,1.32c0.39,0.64,0.61,1.36,0.66,2.1c0.16,1.83,0.09,3.67-0.21,5.48c-0.22,1.75-0.56,3.49-1,5.2l-0.23,0.88c-0.5,2.06-1.25,4.06-2.22,5.94c-0.49,1.12-1.25,2.09-2.22,2.83c-0.57,0.45-1.33,0.56-2,0.29c-0.1,0.64-0.26,1.56-0.49,2.64c-0.76,3.42-1.84,6.77-3.2,10c-0.84,3.64-3.28,17.48-1.16,19.55c0.81,0.78,5,1.68,9.84,2.71c10.46,2.23,26.28,5.6,36.43,13c1.53,1.1,2.95,2.34,4.25,3.71c10.54,11.29,12.14,63.24,11.63,104.84c0,1.21,0,2.08,0,2.55c0,3.78,0.41,8.06,0.88,13c0.8,7.24,1.24,14.51,1.31,21.79c0,0.25,0,0.88-0.07,1.82c-1.3,29.62,1.45,38.76,4,41.21c4.58,4.42,9.57,19.39,11.45,25c0.3,0.91,0.53,1.58,0.66,1.94l0,0c0.71,1.61,0.15,3.5-1.31,4.47c-1.35,0.69-3.01,0.26-3.86-1c-2.11-2.86-3.98-5.89-5.59-9.06c0.89,7.18,1.95,22.48-2.31,27.54c-0.9,1.14-2.29,1.8-3.75,1.77c-4.35-0.09-14.05-2.75-16.78-8.48c-1.74-3.69-1.79-12.58-1.27-17.72c0.29-2.82,2.1-26.05,2.24-28.48c0.17-2.84-3.56-21.51-5-28.54c-0.26-1.29-0.45-2.22-0.52-2.62c-0.79-4.18-1.75-8.56-2.68-12.79c-1.73-7.89-3.23-14.7-3.23-18.33c0-3.13-0.15-8-0.28-12.31c-0.1-3.25-0.19-6.06-0.19-7.44c0-1.15-0.26-7-0.59-14.46c-0.43-9.66-1-22-1.23-30.06c-1.94,12.23-6.09,39.29-6.09,46.82c0,10.86,3.15,27.51,5.94,42.21c2.43,12.84,4.73,25,4.73,31.9c0,57.36-9,92.93-14.35,114.18c-2.18,8.62-3.76,14.85-3.76,18.9c0,5.09,0.37,9.12,0.79,13.78c0.72,7.21,1.08,14.46,1.08,21.71c0,17.36-5.72,38.08-10.32,54.73c-3,11-5.66,20.48-5.66,25.68c0,7.38,4.91,14.48,8.85,20.19c3,4.26,5.49,7.93,5.49,10.85C132.7,574.72,113.12,580,105.11,580zM96.33,291.71c0.3,0,0.55,0.25,0.55,0.55c0,0,0,0.01,0,0.01c0,33,5.12,139.5,5.17,140.57c-0.11,2.7-0.53,5.39-1.23,8c-1.83,7.53-2.72,15.25-2.65,23c0,15.62,3.45,44.25,3.49,44.53c-0.12,5.57-0.62,11.13-1.48,16.63c-0.55,3.48-0.88,6.98-1,10.5c0,3.14,0.46,7.49,0.9,11.69s0.92,8.62,0.92,11.82c0,1.26-0.11,2.82-0.23,4.47c-0.36,5.2-0.8,11.67,1.6,14.25c0.72,0.77,1.73,1.18,2.78,1.13c8.09,0,26.48-5.28,26.48-14c0-2.57-2.45-6.12-5.29-10.23c-4-5.83-9-13.09-9-20.81c0-5.35,2.64-14.91,5.7-26c4.59-16.58,10.29-37.22,10.29-54.43c0-7.22-0.36-14.44-1.09-21.62c-0.4-4.49-0.79-8.74-0.79-13.88c0-4.19,1.59-10.48,3.78-19.17c5.36-21.2,14.32-56.69,14.32-113.91c0-6.82-2.28-18.91-4.71-31.7c-2.93-15.46-5.95-31.45-5.95-42.41c0-9.86,6.78-51.29,7.07-53c0.02-0.3,0.29-0.53,0.6-0.51s0.53,0.29,0.51,0.6c0,5.93,0.78,23.4,1.35,36.15c0.33,7.45,0.6,13.33,0.6,14.51c0,1.36,0.09,4.16,0.19,7.41c0.13,4.31,0.28,9.19,0.28,12.34c0,3.51,1.55,10.59,3.2,18.09c0.93,4.24,1.89,8.63,2.68,12.83c0.08,0.39,0.26,1.32,0.52,2.61c2.4,12,5.14,26.17,5,28.81c-0.14,2.44-1.95,25.7-2.24,28.53c-0.5,4.87-0.47,13.68,1.17,17.13c2.4,5.06,11.43,7.76,15.81,7.85c1.12,0.04,2.2-0.47,2.87-1.37c4.87-5.78,2.16-26.91,1.59-29.9c-0.06-0.27,0.1-0.54,0.36-0.63c0.26-0.08,0.55,0.03,0.67,0.28c0.05,0.09,4.3,8.55,7,11.77c0.51,0.84,1.58,1.15,2.46,0.71c1-0.71,1.34-2.03,0.82-3.13l0,0c-0.13-0.36-0.36-1.05-0.67-2c-1.85-5.57-6.78-20.35-11.17-24.59c-3.93-3.79-5.38-17.94-4.32-42.05c0-0.91,0.07-1.53,0.07-1.77c0-8.14-0.7-15.33-1.31-21.68c-0.47-5-0.89-9.28-0.89-13.12c0-0.47,0-1.34,0-2.57c0.72-58.51-3.31-95.47-11.34-104.06c-1.25-1.32-2.62-2.52-4.09-3.58c-10-7.27-25.64-10.61-36-12.82c-6.14-1.31-9.39-2-10.38-3c-3-3,0.86-20.67,0.94-20.82c1.33-3.13,2.37-6.38,3.11-9.7c0.42-2,0.6-3.43,0.6-3.45c0.03-0.21,0.17-0.39,0.38-0.46c0.2-0.06,0.42,0,0.57,0.15c0.3,0.42,0.88,0.51,1.3,0.22c0.03-0.02,0.06-0.05,0.09-0.08c0.82-0.63,1.46-1.46,1.85-2.42c0.93-1.81,1.65-3.72,2.13-5.7l0.23-0.89c0.44-1.67,0.77-3.37,1-5.08c0.28-1.71,0.35-3.45,0.21-5.18c-0.17-1.27-0.45-1.59-0.55-1.7c-0.11-0.13-0.16-0.3-0.15-0.47c0,0,0.1-0.65,0.21-1.52c0.36-2.89,0.4-5.82,0.12-8.72c-0.23-2.89-0.85-5.73-1.83-8.45c-0.73-2-1.72-3.9-2.93-5.65c-1.82-2.54-4.18-4.64-6.9-6.17c-4.34-2.26-9.15-3.35-15.34-3.35s-11,1.09-15.25,3.42c-2.72,1.53-5.08,3.63-6.9,6.17c-1.21,1.75-2.2,3.65-2.93,5.65c-0.98,2.72-1.6,5.56-1.83,8.45c-0.28,2.9-0.24,5.83,0.12,8.72c0.11,0.87,0.2,1.52,0.21,1.52c0.02,0.16-0.03,0.32-0.13,0.44c-0.12,0.14-0.4,0.46-0.57,1.73c-0.14,1.73-0.07,3.47,0.21,5.18c0.23,1.71,0.56,3.41,1,5.08l0.23,0.89c0.48,1.98,1.2,3.89,2.13,5.7c0.39,0.96,1.03,1.79,1.85,2.42c0.38,0.35,0.96,0.33,1.31-0.05c0.03-0.03,0.05-0.06,0.08-0.09c0.15-0.15,0.37-0.21,0.57-0.15c0.21,0.07,0.35,0.25,0.38,0.46c0,0,0.18,1.49,0.6,3.45c0.75,3.33,1.79,6.59,3.13,9.73c0.06,0.12,4,17.82,0.92,20.79c-1,1-4.24,1.69-10.38,3c-10.37,2.21-26,5.55-36,12.82c-1.47,1.06-2.84,2.25-4.08,3.57c-8,8.59-12.06,45.55-11.34,104.06c0,1.23,0,2.1,0,2.57c0,3.84-0.42,8.14-0.89,13.12c-0.61,6.35-1.31,13.54-1.31,21.68c0,0.24,0,0.86,0.07,1.77c1.06,24.11-0.39,38.26-4.32,42.05c-4.39,4.24-9.32,19-11.17,24.59c-0.31,0.92-0.54,1.61-0.67,2c-0.53,1.12-0.17,2.46,0.85,3.16c0.88,0.44,1.95,0.13,2.46-0.71c2.68-3.22,6.94-11.68,7-11.77c0.12-0.25,0.41-0.36,0.67-0.28c0.26,0.09,0.42,0.36,0.36,0.63c-0.57,3-3.28,24.12,1.59,29.9c0.68,0.9,1.75,1.41,2.87,1.37c4.38-0.09,13.41-2.79,15.81-7.85c1.64-3.45,1.67-12.26,1.17-17.13c-0.29-2.83-2.1-26.09-2.24-28.53c-0.16-2.64,2.58-16.78,5-28.81c0.26-1.29,0.44-2.22,0.52-2.61c0.79-4.2,1.75-8.59,2.68-12.83c1.65-7.5,3.2-14.58,3.2-18.09c0-3.15,0.15-8,0.28-12.34c0.11-3.25,0.19-6.05,0.19-7.41c0-1.18,0.27-7.06,0.6-14.51c0.57-12.75,1.35-30.22,1.35-36.15c-0.02-0.3,0.2-0.57,0.51-0.6c0.3-0.02,0.57,0.2,0.59,0.51c0.29,1.76,7.07,43.19,7.07,53c0,11-3,27-6,42.41c-2.43,12.79-4.71,24.88-4.71,31.7c0,57.22,9,92.71,14.32,113.91c2.2,8.69,3.82,14.98,3.82,19.19c0,5.14-0.39,9.39-0.79,13.88c-0.73,7.18-1.09,14.4-1.09,21.62c0,17.21,5.7,37.85,10.29,54.43c3.06,11.07,5.7,20.63,5.7,26c0,7.72-5,15-9,20.81c-2.84,4.11-5.29,7.66-5.29,10.23c0,8.69,18.39,14,26.48,14c1.03,0.01,2.01-0.43,2.7-1.2c2.4-2.58,2-9,1.6-14.25c-0.12-1.65-0.23-3.21-0.23-4.47c0-3.2,0.47-7.58,0.92-11.82s0.9-8.55,0.9-11.69c-0.12-3.52-0.45-7.02-1-10.5c-0.86-5.47-1.36-11-1.48-16.54c0-0.35,3.49-29,3.49-44.6c0.07-7.75-0.82-15.47-2.65-23c-0.7-2.61-1.12-5.3-1.23-8c0-1.1,5.17-107.61,5.17-140.6C95.8,292,96.02,291.73,96.33,291.71C96.33,291.71,96.33,291.71,96.33,291.71z"
    />
    <path
      class="bone"
      disabled
      d="M71.65,205c2.93-2.09,8-5.4,9.94-7.62c1.64-1.98,3.16-4.07,4.54-6.24c1.3-1.93,1.85-3.3,0.79-3.92s-2.7,1.07-3.74,2.1s-3.66,4.67-5.93,6.82c-2.06,2-7.07,5.12-10.46,8s-5.87,5.67-5.33,7.36C62.27,214,68.75,207.07,71.65,205z"
    />
    <path
      class="bone"
      disabled
      d="M121.25,205c-2.93-2.09-8-5.4-10-7.62c-1.64-1.98-3.15-4.07-4.53-6.24c-1.31-1.93-1.86-3.3-0.8-3.92s2.71,1.07,3.74,2.1s3.67,4.67,5.93,6.82c2.06,2,7.08,5.12,10.46,8c3.38,2.88,5.87,5.67,5.34,7.36C130.62,214,124.14,207.07,121.25,205z"
    />
    <path
      class="bone"
      disabled
      d="M82.56,111.91c1.73,1.94,6,0.39,6.64-2.07c0.4-1.65-0.17-2.51-1.9-3.21c-15-6-22.78-5.63-35.38-3.5c-4.05,0.69-5.87,1.41-6.1,2.08s0.78,0.88,1.32,2c0.41,0.82-0.25,1.76,0.2,2.3s4.12-0.89,7.65-1.36C63.84,106.91,78.33,107.15,82.56,111.91z"
    />
    <path
      class="bone"
      disabled
      d="M110.09,111.91c-1.72,1.94-6,0.39-6.64-2.07c-0.4-1.65,0.18-2.51,1.9-3.21c15-6,22.78-5.63,35.38-3.5c4.06,0.69,5.87,1.41,6.1,2.08s-0.77,0.88-1.31,2c-0.41,0.82,0.24,1.76-0.21,2.3s-4.12-0.89-7.65-1.36C128.81,106.91,114.33,107.15,110.09,111.91z"
    />
    <path
      class="bone"
      disabled
      d="M86.05,104.07c1.3-0.06,2.42-2.73,0-3.32c-3.44,0-6.88,0.28-10.27,0.86c3.24,0.63,6.44,1.46,9.58,2.49L86.05,104.07z"
    />
    <path
      class="bone"
      disabled
      d="M106.6,104.07h0.66c3.14-1.03,6.34-1.86,9.58-2.49c-3.39-0.58-6.82-0.86-10.26-0.86C104.18,101.34,105.33,104,106.6,104.07z"
    />
    <path
      class="bone"
      disabled
      d="M5.42,316.19c-0.23-0.25-0.27,0.18-0.34,0.4C5,317.06,4.96,317.53,4.97,318c-0.06,0.43-0.22,0.84-0.48,1.19c-0.29,0.32-0.46,0.74-0.47,1.18c0,0.4,0.32,0.73,0.68,0.48c0.28-0.25,0.5-0.55,0.65-0.89c0.22-0.39,0.38-0.83,0.62-1.21s0.57-0.44,0.9-0.67s0.63-0.51,0.39-0.63C6.55,317.2,5.91,316.77,5.42,316.19z"
    />
    <path
      class="bone"
      disabled
      d="M22.23,317.35c0.22-0.09,0.38-0.27,0.44-0.5c0.11-0.55,0.09-1.12-0.07-1.66c-0.66-2.67-0.51-5.47,0.43-8.06c0.23-0.63,0.31-1.12,0.52-1.76c0.15-0.4,0.15-0.84,0-1.24c-0.4-0.83-1.14-0.73-1.77-0.5c-0.3,0.14-0.57,0.34-0.78,0.6c-0.51,0.81-0.64,1.8-0.36,2.71c0.2,1.2,0.15,2.42-0.13,3.6c-0.15,1.13-0.38,2.25-0.67,3.35c-0.29,0.9-1,2.1-0.55,3.05l0,0C20.11,317.63,21.25,317.79,22.23,317.35z"
    />
    <path
      class="bone"
      disabled
      d="M15.66,300c-0.29-0.35-0.53-0.78-0.83-1.13c-0.52-0.61-0.93-1.05-1.44-0.25c-0.42,0.91-0.77,1.84-1.06,2.8c-0.42,0.95-0.96,1.85-1.61,2.66c-0.56,0.64-1.42,1-1.76,1.83c-0.08,0.18-0.14,0.36-0.17,0.55c-0.01,0.07-0.01,0.15,0,0.22c0.39,0.67,0.97,1.21,1.67,1.55c0.67,0.35,1.47,0.35,2.14,0c0.06-0.08,0.1-0.16,0.13-0.25c0.12-0.47,0.17-0.95,0.16-1.43c0.05-0.55,0.18-1.1,0.39-1.61c0.35-1.05,0.94-2,1.72-2.78c0.4-0.33,1.56-0.47,1.43-1.18C16.33,300.59,15.89,300.23,15.66,300z"
    />
    <path
      class="bone"
      disabled
      d="M9.56,308.81c-0.7-0.33-0.79-0.78-1.23-1.15c-0.44-0.37-0.51,0.48-0.55,0.7c-0.18,1.67-0.52,3.31-1,4.92c-0.25,0.51-1.43,1.45-1.33,1.87s2,1.77,2.5,1.63c0.29-0.08,0.18-0.64,0.18-0.92c-0.05-0.87,0.13-1.74,0.53-2.52c0.33-0.8,0.83-1.52,1.46-2.12c0.54-0.42,1.32-0.73,1.41-1.61C11.58,308.89,10.45,309.23,9.56,308.81z"
    />
    <path
      class="bone"
      disabled
      d="M19,301.53c-1.22-0.27-2.21-0.17-2.45,1c-0.03,0.48-0.02,0.97,0.05,1.45c0.08,1.32-0.08,2.64-0.45,3.91c-0.3,1.32-0.34,2.72-0.73,4s-1.4,2.28-1.92,3.55c-0.16,0.35-0.18,0.75-0.06,1.12c0.11,0.3,0.37,0.53,0.69,0.59c0.74,0.18,1.51,0.26,2.27,0.25c0.28-0.01,0.54-0.13,0.72-0.34c0.21-0.27,0.35-0.59,0.38-0.93c0.04-0.69,0.02-1.38-0.07-2.06c-0.06-0.84-0.06-1.68,0-2.52c0.12-1.75,0.61-3.46,1.45-5c0.29-0.65,0.63-1.28,1-1.88c0.37-0.43,0.63-0.94,0.78-1.49C20.88,302.05,19.97,301.74,19,301.53z"
    />
    <path
      class="bone"
      disabled
      d="M28.12,316c0.31-0.26,0.43-0.68,0.31-1.07c-0.2-0.47-0.43-0.92-0.69-1.36c-0.34-1.01-0.5-2.07-0.46-3.13c-0.06-0.8-0.28-2.67-0.29-3.45c0-1,0.55-2.34,0.21-3.34s-2-1-2.72-0.5c-0.93,0.66-0.13,1.67,0.19,2.5c0.13,0.52,0.22,1.04,0.29,1.57c0.41,1.98,0.44,4.01,0.1,6c-0.09,0.51-0.1,1.03-0.05,1.54c0.06,0.52,0.39,0.98,0.86,1.22c0.46,0.26,0.99,0.37,1.51,0.32C27.65,316.27,27.9,316.16,28.12,316z"
    />
    <path
      class="bone"
      disabled
      d="M33.26,321.56c-0.72,0.37-1.54,0.47-2.32,0.3c-0.2-0.07-0.32-0.28-0.28-0.49c0.1-0.45,0.41-0.94,0.45-1.36c0.02-0.69-0.14-1.38-0.45-2c-0.34-0.6-0.65-1.22-0.93-1.85c-0.12-0.39-0.14-0.78,0.1-0.75c0.46,0.19,0.94,0.33,1.43,0.4l0,0c0.42-0.1,0.83-0.24,1.22-0.43c0.17,0,0.11,0.6,0.07,0.84c-0.09,0.39-0.12,0.78-0.1,1.18c0.03,0.51,0.08,1.02,0.17,1.53c0.06,0.3,0.17,0.59,0.32,0.86C33.27,320.37,33.75,321.4,33.26,321.56z"
    />
    <path
      class="bone"
      disabled
      d="M33.33,326.61c0.42-0.18,0-0.81-0.14-1.09c-0.27-0.32-0.44-0.72-0.47-1.14c0-0.44,0.29-0.83,0.21-1.28s-0.55-0.52-0.92-0.38c-0.37,0.14-1.13-0.17-1.34,0s0.2,0.85,0.34,1.13c0.18,0.39,0.28,0.82,0.28,1.26c-0.04,0.41-0.04,0.83,0,1.24c0.01,0.07,0.04,0.14,0.09,0.19C31.98,326.88,32.71,326.91,33.33,326.61z"
    />
    <path
      class="bone"
      disabled
      d="M28.33,326.16c0.18-0.09,0.29-0.27,0.28-0.47c-0.11-0.57-0.29-1.13-0.54-1.65c-0.28-1.03-0.42-2.09-0.39-3.16c0.17-0.9,0.38-1.79,0.64-2.67c0.16-0.9-0.42-1-1.19-1h-0.8c-0.62,0-1.53-0.25-1.74,0.58s0.36,2,0.72,2.76c0.47,0.82,0.65,1.78,0.51,2.71c-0.31,0.84-0.51,1.72-0.62,2.61c0.01,0.19,0.15,0.35,0.33,0.39C26.45,326.52,27.43,326.49,28.33,326.16z"
    />
    <path
      class="bone"
      disabled
      d="M27.94,327.49c-0.17,0-0.6,0.19-0.92,0.2h-0.09c-0.44-0.02-0.87-0.1-1.29-0.22c-0.09-0.01-0.17,0.02-0.24,0.07c-0.69,0.42-0.15,1.09,0.2,1.76c0.36,0.77,0.47,1.64,0.3,2.47c-0.2,0.73-0.26,1.48-0.17,2.23c0.19,0.61,1.07,0.5,1.55,0.56s1.12,0.33,1.2-0.32s-0.55-1.43-0.56-2.11s-0.18-1.29-0.21-2s0.51-1.18,0.52-1.81C28.24,327.92,28.12,327.54,27.94,327.49z"
    />
    <path
      class="bone"
      disabled
      d="M15.94,327.28c0.21-0.24,0.34-0.53,0.39-0.84c0.18-0.9-0.42-1.79-0.53-2.7c-0.13-0.84,0-1.7,0.37-2.46c0.34-0.72,1.23-1.5,0.87-2.25c-0.21-0.59-0.84-0.91-1.44-0.73c-1.43,0.2-2.32-0.51-2.39,0.5c0.02,0.94,0.18,1.87,0.46,2.77c0.23,0.86,0.3,1.76,0.21,2.65c-0.07,0.5-0.19,0.99-0.36,1.46c-0.12,0.38-0.42,0.8-0.32,1.19c0.04,0.12,0.09,0.23,0.17,0.33C14.16,327.65,15.12,327.68,15.94,327.28z"
    />
    <path
      class="bone"
      disabled
      d="M15.6,335.2c-0.39,0.2-0.82,0.32-1.26,0.34c-0.18,0.01-0.36-0.01-0.54-0.06c-0.13,0-0.28-0.13-0.33-0.14s-0.1,0-0.12,0.07c-0.39,0.6,0.61,1.2,0.55,1.93s-0.08,1.87,0.84,1.82c0.38-0.06,0.69-0.32,0.82-0.68c0.11-0.42,0.01-0.88-0.27-1.21c-0.19-0.32-0.35-0.54-0.12-0.88c0.28-0.27,0.49-0.59,0.63-0.95C15.85,335.09,15.6,335.2,15.6,335.2z"
    />
    <path
      class="bone"
      disabled
      d="M14,334.76c0.61,0.05,1.22-0.13,1.7-0.51c0.05-0.39-0.02-0.79-0.21-1.14c-0.26-0.59-0.33-1.25-0.22-1.89c0.12-0.77,1.52-2.79,0.51-3c-0.65,0.05-1.29,0.15-1.92,0.29c-0.6,0-0.8,0.35-0.75,1s0.47,0.91,0.57,1.6c0.08,0.64,0.02,1.29-0.17,1.91l-0.07,0.22c-0.04,0.36-0.04,0.72,0,1.08l0,0C13.56,334.54,13.76,334.69,14,334.76z"
    />
    <path
      class="bone"
      disabled
      d="M20.11,335.73c0.67,0,1.34-0.03,2-0.11c0.1-0.05,0.18-0.13,0.24-0.23c0.25-0.52-0.1-1.52-0.17-2.06c-0.13-0.7-0.23-1.4-0.28-2.11c0-0.7,0.43-1.11,0.58-1.74s-0.06-0.92-0.7-0.83c-0.35,0.11-0.71,0.2-1.07,0.27c-0.39,0-0.7-0.23-1-0.15c-0.81,0.19-0.57,1-0.23,1.55c0.44,0.73,0.93,1.19,0.89,2.12c-0.02,0.77-0.2,1.52-0.54,2.21C19.83,334.65,19.24,335.64,20.11,335.73z"
    />
    <path
      class="bone"
      disabled
      d="M41.33,217.7c0.66-3.54-3.71-6.66-4.06-11.65s2.2-67.68,4.37-71.72c0.67-1.37,1.65-2.57,2.86-3.49c3.08-2.44,4.39-6.5,3.32-10.29c-1.16-4.36-4.21-6-7.59-6c-1.7-0.02-3.24,0.99-3.9,2.55c-1.17-0.33-3.46-0.2-3.8,2c-0.46,4.66-0.4,9.35,0.16,14c0.68,4.75-1.27,42.89-1.68,53.24c-0.36,9.16-1.48,17.08-4.08,20.65s-5.76,4.75-5.56,8.11c0.18,3.15,3.54,6.27,6.31,5.21c1.67-0.63,2-1.2,2.57-1.33c0.29-0.06,0.56-0.58,1.27,0.13c0.69,0.7,1.53,1.23,2.46,1.56C36.33,221.47,40.51,222.18,41.33,217.7z"
    />
    <path
      class="bone"
      disabled
      d="M22.17,337.68c0.16-0.37,0.55-0.81,0.18-1.19s-0.73,0-1.11,0h-0.28c-0.33,0-1,0-1.1,0.47s0.38,0.73,0.55,1c0.25,0.41,0.4,0.87,0.43,1.35c-0.06,0.47,0,0.96,0.18,1.4c0.23,0.35,0.53,0.69,0.95,0.58c0.43-0.14,0.71-0.55,0.69-1C22.63,339.42,21.79,338.57,22.17,337.68z"
    />
    <path
      class="bone"
      disabled
      d="M28.15,336.58c0.16-0.34,0.21-0.31,0.16-0.75s-0.62-0.44-1-0.23l-0.35-0.05c-0.3,0-0.85-0.06-1,0.34s0.34,0.67,0.49,0.94c0.23,0.37,0.36,0.79,0.38,1.23c-0.07,0.43-0.02,0.87,0.15,1.27c0.2,0.31,0.47,0.63,0.87,0.54c0.4-0.13,0.67-0.51,0.65-0.93C28.56,338.16,27.79,337.37,28.15,336.58z"
    />
    <path
      class="bone"
      disabled
      d="M33.63,327.39c-0.34-0.13-0.75,0.32-1,0.25l-0.42-0.2c-0.32-0.06-0.77-0.25-0.91,0.08s0.27,0.6,0.39,0.85c0.18,0.34,0.27,0.71,0.26,1.09c0,0.37-0.16,0.77,0,1.09c0.16,0.32,0.4,0.58,0.77,0.54c0.37-0.06,0.65-0.37,0.68-0.75c0-0.67-0.6-1.41-0.2-2.06C33.41,328,34.02,327.54,33.63,327.39z"
    />
    <path
      class="bone"
      disabled
      d="M22.71,319.85c0.1-0.8-0.35-1.15-1.14-1.39c-0.61-0.22-1.29-0.15-1.83,0.21c-0.73,0.45-0.35,1.21-0.16,1.85c0.26,0.84,0.38,1.72,0.34,2.6c-0.07,0.89-0.14,1.77-0.15,2.67c-0.03,0.24-0.09,0.47-0.16,0.7c0,0.68-0.12,1.4,0.7,1.53c0.79,0.11,1.59-0.17,2.13-0.75c0.42-0.64-0.11-1.32-0.25-2c-0.17-0.89-0.2-1.81-0.08-2.71C22.22,321.64,22.6,320.78,22.71,319.85z"
    />
    <path
      class="bone"
      disabled
      d="M32.39,314.47c0.67-0.86,0.09-2-0.33-2.81c-0.48-0.91-0.8-1.91-0.93-2.93c-0.2-1.15-0.31-2.31-0.32-3.47c0.03-0.52,0.08-1.04,0.17-1.56c0.1-0.39,0.08-0.81-0.06-1.19c-0.44-0.85-1.86-0.61-2.52-0.28c-1.06,0.54-0.44,1.39,0,2.23c0.97,2.2,1.36,4.61,1.12,7c-0.17,1-0.39,2.17,0.31,3c0.61,0.71,1.67,0.79,2.38,0.19C32.28,314.59,32.34,314.53,32.39,314.47z"
    />
    <path
      class="bone"
      disabled
      d="M32.19,223.46c1.08,0.71,2.43,0.85,3.63,0.39c1.1-0.42,1.9-0.8,1.95,0.55c0.09,2.3-1.49,2.17-2,8.84s-1.57,20.13-1.34,25.18s-1.49,15.91-2.16,20.63c-0.67,4.72-1.33,5.71-1.27,7.86c0,0.94,0.15,3.34-0.35,4.48c-0.16,0.35-0.55,0.52-0.92,0.41c-0.28-0.08-0.64-0.18-1.07-0.28c-1.29-0.69-2.45-2-1.64-5.48c1.13-5.65,1.95-11.36,2.46-17.1c0.34-4-0.33-16.9-0.67-21.13l-0.68-13.42c-0.61,3.55-1.87,10.43-3.18,17.43s0,32.36,1,37.27c0.12,0.46,0.18,0.93,0.18,1.4c-0.02,0.3-0.28,0.53-0.58,0.51c-0.01,0-0.02,0-0.04,0c-0.84-0.1-1.68-0.1-2.52,0c-1.43,0.24-2.83,0.65-4.17,1.23c-0.54,0.22-1.15-0.04-1.37-0.58c-0.03-0.07-0.05-0.15-0.06-0.23c0-1.29,0.12-2.58,0.36-3.85c0.26-2.8,1.71-8.55,1.91-15.28s0.19-19.76,2.69-30.74c2-8.64,2.46-13.78,1-15.89s-1.08-3.21,1.28-2.78c0.91,0.4,1.94,0.4,2.85,0c0.8-0.39,1.67-0.63,2.56-0.7C30.67,222.28,31.33,222.92,32.19,223.46z"
    />
    <path
      class="bone"
      disabled
      d="M30.72,295.42c-0.09-0.49-0.38-0.93-0.8-1.2c-1.94-0.62-3.97-0.92-6-0.87c-1.23,0.17-2.43,0.48-3.58,0.93l-1,0.57c-0.72,0.58-1.53,1.06-2.39,1.41c-0.57,0.23-1.02,0.68-1.25,1.25c0,0.14,0.02,0.29,0.05,0.43c0,0,0,0,0,0.06c0.36,0.8,0.84,1.53,1.44,2.16c0.42,0.09,0.85,0.14,1.28,0.14c0.92-0.06,1.83,0.14,2.64,0.58c0.13,0.1,0.25,0.21,0.36,0.33c0.52,0.61,1.31,0.91,2.1,0.8c0.74-0.07,1.46-0.27,2.12-0.6c0.72-0.34,1.48-0.57,2.27-0.68c1-0.12,1.39,0.06,2.38-0.06s0.53-4.51,0.53-4.51C30.81,295.9,30.76,295.66,30.72,295.42z"
    />
    <path
      class="bone"
      disabled
      d="M87.23,571c-1.09-0.39-2.69-0.45-3.42,0.39c-0.14,0.25-0.21,0.53-0.2,0.82c0,0.58,0.73,0.83,0.86,1.36c0.18,0.77-0.67,1.18-0.79,1.86c-0.24,1.38,1.77,1.62,2.53,1.14c0.56-0.37,0.47-1,0.73-1.54s0.65-0.63,1-1.11c0.63-0.9,0.41-2.15-0.49-2.79C87.38,571.08,87.31,571.04,87.23,571z"
    />
    <path
      class="bone"
      disabled
      d="M79.26,548.15c-0.71,0.4-0.43,1.17-0.51,1.9c-0.23,1.72-0.59,3.42-1.09,5.09c-0.09,0.29-0.2,0.58-0.33,0.86c-0.34,0.62-0.12,1.4,0.5,1.74c0.21,0.12,0.44,0.17,0.68,0.16c0.39,0,0.77-0.11,1.09-0.32c0.6-0.33,0.66-0.7,0.57-1.37c-0.42-3.2,1.4-6.72,1-7.39c-0.28-0.69-1.07-1.02-1.76-0.74C79.36,548.1,79.31,548.12,79.26,548.15z"
    />
    <path
      class="bone"
      disabled
      d="M71.04,564.15c-0.06-0.07-0.27-0.19-0.31-0.1c-0.42,0.81,0.09,1.55-0.41,2.41c-0.28,0.64-0.6,1.26-0.95,1.86c-0.22,0.29-0.46,0.35-0.53,0.77s0.08,0.8,0,1.19s-0.3,0.68-0.07,1s0.52,0.26,0.73,0c0.5-0.63,0.09-1.36,1.06-1.63c0.08-0.4,0-0.79,0-1.18c0.14-0.32,0.3-0.62,0.49-0.91c0.28-0.55,0.39-1.23,1-1.45c0.41-0.15,0.67,0,0.95-0.4s0.1-0.57-0.21-0.88c-0.22-0.15-0.49-0.23-0.76-0.24c-0.5,0-0.77,0.06-0.88-0.19S71.17,564.31,71.04,564.15z"
    />
    <path
      class="bone"
      disabled
      d="M68.8,563.15c-0.37-0.57-0.64,0-1.25-0.27c0,0,0-0.17-0.06-0.22s-0.31-0.3-0.39-0.27c-0.85,0.26,0.18,1.37-0.31,2.16c-0.3,0.57-0.63,1.11-1,1.64c-0.21,0.26-0.43,0.3-0.51,0.67s0,0.73,0,1.09s-0.3,0.6-0.1,0.93s0.46,0.26,0.66,0c0.48-0.56,0.14-1.24,1-1.43c0.1-0.37,0-0.73,0.1-1.08c0.14-0.28,0.3-0.55,0.49-0.8c0.27-0.49,0.41-1.11,1-1.28c0.37-0.12,0.38,0.14,0.54-0.31C69.07,563.69,69.01,563.37,68.8,563.15z"
    />
    <path
      class="bone"
      disabled
      d="M65.42,562.8c-0.37,0.1-0.47,0.51-0.67,0.84c-0.13,0.16-0.25,0.34-0.35,0.52c-0.08,0.24,0,0.48-0.09,0.72c-0.6,0.11-0.39,0.58-0.73,1c-0.14,0.15-0.31,0.19-0.44,0s0-0.43,0.09-0.63s0-0.5,0-0.73s0.21-0.27,0.36-0.44c0.25-0.35,0.47-0.71,0.68-1.08c0.35-0.52-0.35-1.23,0.22-1.39c0.09,0,0.18,0.05,0.24,0.12c0.04,0.09,0.09,0.17,0.15,0.25c0.32,0.25,0.67-0.06,1,0.28C65.96,562.18,66.22,562.6,65.42,562.8z"
    />
    <path
      class="bone"
      disabled
      d="M74.7,571.63c0.2-0.86,0.25-1.75,0.14-2.63c0.02-0.32,0.19-0.62,0.46-0.79c0.37-0.27,0.81-0.42,1.27-0.44c0.3,0.07,0.58,0.21,0.82,0.4c0.3,0.24,0.44,0.63,0.36,1c-0.08,0.29-0.18,0.57-0.3,0.84c-0.46,1.16-0.58,2.42-1,3.61c-0.2,0.55-1.75,1.14-2.17,0.14C73.91,572.91,74.33,572.34,74.7,571.63z"
    />
    <path
      class="bone"
      disabled
      d="M85.33,536.23c1.59,0.13,3.33,1.07,3.53,2.69c0.28,1.46,1.08,2.77,2.26,3.68c0.79,0.7,1.23,1.71,1.21,2.77c0.06,1.81,0.09,5.29-1.69,5.23c-1.1-0.15-2.1-0.75-2.74-1.66c-0.93-1.05-2.66-1.35-4.89-1.19c-1.64,0.11-3.14-1.35-5.06-1.19s-2.39,1-3.72,1.41s-1.86-1.05-0.86-2c0.93-0.71,1.92-1.33,2.96-1.88c2.81-1.58,2-4.63,2.4-5.76C79.26,536.74,83.43,536.08,85.33,536.23z"
    />
    <path
      class="bone"
      disabled
      d="M88.61,563.65c0.74,1.13,1.55,2.89,0.15,2.81c-0.59-0.86-1.34-1.6-2.21-2.17c-1-0.43-2,0.51-3,1.63c-0.29,0.1-0.35-0.08-0.46-0.36c-0.43-1.12,0.36-2.78,0.45-3.91c0.12-1.51-0.54-2.54-1-3.92c-0.46-1.54,0.09-2.1,0.09-2.1s1.88-2,3.66-1.63c0.44,0.1,0.84,0.34,1.14,0.68c0.59,0.59,0.94,1.37,1,2.2c0.05,1.01-0.03,2.01-0.23,3C87.96,561.37,87.79,562.4,88.61,563.65z"
    />
    <path
      class="bone"
      disabled
      d="M82.38,554.35c0.05,0.07,0.15,0.09,0.22,0.04c0.01-0.01,0.03-0.02,0.04-0.04c0.68-0.83,1.63-1.38,2.69-1.55c1.28-0.15,3.24,1.3,3.53,1.67s0.43-0.44,0.37-0.9c-0.21-1.5-1.22-3.51-2.35-4.09c-1.17-0.54-2.51-0.6-3.72-0.15c-0.59,0.25-1.07,0.71-1.33,1.3c-0.3,0.62-0.37,1.33-0.19,2C81.79,553.24,82.04,553.82,82.38,554.35z"
    />
    <path
      class="bone"
      disabled
      d="M74.33,556.18c-0.32-0.23,2-7.83,2-7.83c0.13-0.17,0.32-0.28,0.53-0.32c1.48-0.39,1.21,0.1,1.21,0.1c-1.29,2.44-1.53,7.33-1.87,7.89C76.25,556,75.72,557.13,74.33,556.18z"
    />
    <path
      class="bone"
      disabled
      d="M71.25,552.31c0.29-0.81,0.64-1.57,0.94-2.38l0.13-0.13c0.11,0,0.74-0.32,0.61,0.07s-0.88,2.5-0.88,2.5c-0.37,0.88-0.66,1.68-0.76,1.79s-0.59,0.28-0.7,0C70.33,553.53,71.06,552.84,71.25,552.31z"
    />
    <path
      class="bone"
      disabled
      d="M74.97,549.58c-0.15,0.36-1.79,5.79-1.86,6s-0.54,0-0.74-0.24c-0.6-0.66,0.21-1.43,0.33-2.15v-0.16c0,0,1-3.17,1-3.37S75.11,549.21,74.97,549.58z"
    />
    <path
      class="bone"
      disabled
      d="M76.8,564.52c-0.31,0.04-0.62,0.11-0.91,0.21c-0.1,0.04-0.21-0.01-0.24-0.11c0-0.01,0-0.01-0.01-0.02c-0.28-1.08,0.87-2,1-3.25s-0.45-2.77,1.33-2.38c0.41-0.01,0.82,0.01,1.23,0.06c0.36,0.13,0.58,0.26,0.55,0.65l-0.42,5.24c0,0-0.06,0.38-0.78,0.07l-0.54-0.25C77.64,564.55,77.22,564.48,76.8,564.52z"
    />
    <path
      class="bone"
      disabled
      d="M71.74,562.6c0.09-0.41,0.25-0.8,0.46-1.17c0.1-0.4,0.29-0.77,0.57-1.08c0.27-0.39,0.51-0.81,0.71-1.24c0.2-0.42,0.09-1.19,0.51-1.36c0.49-0.09,1-0.01,1.45,0.22c0.13,0.33-0.24,0.85-0.45,1.32c-0.42,1-1,1.91-1.41,2.89s-0.39,1.43-0.78,1.44l-0.82-0.46C71.85,563,71.76,562.81,71.74,562.6z"
    />
    <path
      class="bone"
      disabled
      d="M75.08,566.21c0,0-0.41,0.35-0.35,0.61s0.45,0.31,0.45,0.31c0.45-0.27,0.98-0.39,1.5-0.36c0.57,0.16,1.1,0.43,1.55,0.81c0.34,0.23,0.52-0.27,0.51-0.81c-0.01-0.43-0.26-0.82-0.65-1c-0.21-0.1-0.44-0.17-0.67-0.21c-0.83,0-1.64,0.24-2.34,0.69"
    />
    <path
      class="bone"
      disabled
      d="M72.38,557.33c-0.32,0.93-1,1.36-1.55,2.12c-0.28,0.39-0.51,0.81-0.67,1.26c-0.15,0.43-0.43,1.28-0.68,1.34s-1.49-0.13-1.5-0.38s3.18-5,3.45-5.31S72.62,556.61,72.38,557.33z"
    />
    <path
      class="bone"
      disabled
      d="M66.69,561.21c-0.2,0-1.48-0.21-1.55-0.53s1.49-2.06,2.5-2.86s1.12-2,2.13-2.48c0.42-0.2,1.12,0.07,0.83,0.54s-3.51,5-3.51,5C66.97,561,66.83,561.11,66.69,561.21z"
    />
    <path
      class="bone"
      disabled
      d="M87.14,569.82c0,0,0.22,0,0.26,0s1.59-0.49,1.28-1.63s-2.06-2.77-2.57-2.64c0,0-0.66-0.15-1.83,1.3c-0.35,0.42-0.58,0.93-0.66,1.47c-0.05,0.41,0.17,0.81,0.54,1c0.39-0.06,0.78-0.09,1.17-0.1c0.54,0.11,1.05,0.33,1.5,0.66C86.94,569.9,87.05,569.88,87.14,569.82z"
    />
    <path
      class="bone"
      disabled
      d="M187.26,316.19c0.23-0.25,0.27,0.18,0.34,0.4c0.07,0.46,0.11,0.92,0.1,1.39c0.06,0.43,0.23,0.84,0.49,1.19c0.29,0.32,0.46,0.74,0.46,1.18c0,0.4-0.31,0.73-0.67,0.48c-0.28-0.25-0.5-0.55-0.65-0.89c-0.22-0.39-0.39-0.83-0.62-1.21s-0.57-0.44-0.91-0.67s-0.62-0.51-0.38-0.63C186.13,317.18,186.77,316.76,187.26,316.19z"
    />
    <path
      class="bone"
      disabled
      d="M170.44,317.35c-0.22-0.09-0.38-0.27-0.44-0.5c-0.1-0.55-0.08-1.12,0.08-1.66c0.65-2.67,0.5-5.47-0.43-8.06c-0.24-0.63-0.32-1.12-0.53-1.76c-0.16-0.4-0.16-0.84,0-1.24c0.4-0.83,1.14-0.73,1.76-0.5c0.31,0.14,0.58,0.34,0.79,0.6c0.51,0.81,0.64,1.8,0.35,2.71c-0.19,1.2-0.14,2.42,0.14,3.6c0.15,1.13,0.38,2.25,0.67,3.35c0.29,0.9,1,2.1,0.55,3.05l0,0C172.56,317.63,171.42,317.79,170.44,317.35z"
    />
    <path
      class="bone"
      disabled
      d="M177.02,300c0.29-0.35,0.53-0.78,0.83-1.13c0.52-0.61,0.93-1.05,1.44-0.25c0.42,0.93,0.79,1.88,1.09,2.85c0.41,0.96,0.95,1.85,1.61,2.66c0.55,0.64,1.42,1,1.76,1.83c0.08,0.18,0.14,0.36,0.17,0.55c0.01,0.07,0.01,0.15,0,0.22c-0.39,0.67-0.97,1.21-1.67,1.55c-0.67,0.35-1.46,0.35-2.13,0c-0.06-0.08-0.1-0.16-0.14-0.25c-0.11-0.47-0.16-0.95-0.15-1.43c-0.05-0.55-0.18-1.1-0.39-1.61c-0.35-1.05-0.94-2-1.72-2.78c-0.4-0.33-1.56-0.47-1.44-1.18C176.33,300.59,176.79,300.23,177.02,300z"
    />
    <path
      class="bone"
      disabled
      d="M183.12,308.81c0.7-0.33,0.79-0.78,1.22-1.15s0.51,0.48,0.55,0.7c0.18,1.67,0.52,3.31,1,4.92c0.25,0.51,1.43,1.45,1.33,1.87s-2,1.77-2.5,1.63c-0.29-0.08-0.19-0.64-0.19-0.92c0.06-0.87-0.13-1.74-0.53-2.52c-0.33-0.8-0.82-1.52-1.45-2.12c-0.54-0.42-1.32-0.73-1.41-1.61C181.09,308.89,182.23,309.23,183.12,308.81z"
    />
    <path
      class="bone"
      disabled
      d="M173.67,301.53c1.23-0.27,2.21-0.17,2.46,1c0.03,0.48,0.02,0.97-0.05,1.45c-0.08,1.32,0.08,2.64,0.45,3.91c0.29,1.32,0.33,2.72,0.73,4s1.4,2.28,1.91,3.55c0.16,0.35,0.19,0.75,0.07,1.12c-0.11,0.31-0.38,0.53-0.7,0.59c-0.74,0.18-1.5,0.26-2.26,0.25c-0.28-0.01-0.55-0.13-0.73-0.34c-0.21-0.27-0.34-0.59-0.37-0.93c-0.04-0.69-0.02-1.38,0.06-2.06c0.07-0.84,0.07-1.68,0-2.52c-0.12-1.75-0.61-3.45-1.44-5c-0.3-0.64-0.63-1.27-1-1.88c-0.37-0.43-0.64-0.94-0.79-1.49C171.8,302.05,172.7,301.74,173.67,301.53z"
    />
    <path
      class="bone"
      disabled
      d="M164.56,316c-0.31-0.26-0.43-0.68-0.31-1.07c0.2-0.47,0.42-0.92,0.68-1.36c0.35-1.01,0.5-2.07,0.46-3.13c0.07-0.8,0.29-2.67,0.29-3.45c0-1-0.55-2.34-0.2-3.34s2-1,2.71-0.5c0.93,0.66,0.14,1.67-0.19,2.5c-0.12,0.52-0.22,1.04-0.28,1.57c-0.42,1.98-0.45,4.01-0.1,6c0.08,0.51,0.09,1.03,0.05,1.54c-0.07,0.52-0.39,0.98-0.86,1.22c-0.46,0.26-0.99,0.37-1.51,0.32C165.03,316.27,164.78,316.16,164.56,316z"
    />
    <path
      class="bone"
      disabled
      d="M159.42,321.56c0.72,0.37,1.54,0.47,2.32,0.3c0.2-0.07,0.32-0.28,0.28-0.49c-0.1-0.45-0.41-0.94-0.46-1.36c-0.01-0.69,0.14-1.38,0.45-2c0.35-0.6,0.66-1.21,0.94-1.85c0.11-0.39,0.14-0.78-0.1-0.75c-0.46,0.2-0.94,0.33-1.44,0.4l0,0c-0.42-0.09-0.83-0.24-1.22-0.43c-0.17,0-0.11,0.6-0.07,0.84c0.08,0.39,0.11,0.78,0.1,1.18c-0.03,0.51-0.09,1.02-0.18,1.53c-0.06,0.3-0.16,0.59-0.31,0.86C159.4,320.37,158.93,321.4,159.42,321.56z"
    />
    <path
      class="bone"
      disabled
      d="M159.33,326.61c-0.42-0.18-0.05-0.81,0.15-1.09c0.27-0.32,0.44-0.72,0.47-1.14c0-0.44-0.29-0.83-0.21-1.28s0.54-0.52,0.92-0.38s1.12-0.17,1.34,0s-0.2,0.85-0.35,1.13c-0.18,0.4-0.27,0.83-0.27,1.26c0.04,0.41,0.04,0.83,0,1.24c-0.02,0.07-0.05,0.13-0.09,0.19C160.69,326.88,159.96,326.91,159.33,326.61z"
    />
    <path
      class="bone"
      disabled
      d="M164.33,326.16c-0.18-0.09-0.29-0.27-0.28-0.47c0.1-0.57,0.28-1.13,0.53-1.65c0.28-1.03,0.42-2.09,0.39-3.16c-0.16-0.9-0.37-1.79-0.63-2.67c-0.16-0.9,0.42-1,1.19-1h0.8c0.62,0,1.52-0.25,1.74,0.58s-0.36,2-0.72,2.76c-0.47,0.82-0.65,1.77-0.51,2.71c0.31,0.84,0.51,1.72,0.62,2.61c-0.01,0.19-0.15,0.35-0.33,0.39C166.21,326.52,165.23,326.49,164.33,326.16z"
    />
    <path
      class="bone"
      disabled
      d="M164.73,327.49c0.18,0,0.61,0.19,0.93,0.2h0.08c0.44-0.02,0.87-0.1,1.29-0.22c0.09-0.01,0.18,0.02,0.25,0.07c0.69,0.42,0.15,1.09-0.21,1.76c-0.35,0.77-0.45,1.64-0.29,2.47c0.19,0.73,0.25,1.48,0.17,2.23c-0.19,0.61-1.08,0.5-1.55,0.56s-1.12,0.33-1.2-0.32s0.55-1.43,0.56-2.11s0.18-1.29,0.2-2s-0.5-1.18-0.51-1.81C164.44,327.92,164.56,327.54,164.73,327.49z"
    />
    <path
      class="bone"
      disabled
      d="M176.74,327.28c-0.21-0.24-0.34-0.53-0.39-0.84c-0.18-0.9,0.41-1.79,0.53-2.7c0.12-0.84-0.01-1.69-0.37-2.46c-0.34-0.72-1.24-1.5-0.87-2.25c0.21-0.58,0.84-0.9,1.43-0.73c1.43,0.2,2.33-0.51,2.4,0.5c-0.02,0.94-0.18,1.87-0.46,2.77c-0.23,0.86-0.3,1.76-0.21,2.65c0.06,0.5,0.18,0.99,0.35,1.46c0.13,0.38,0.43,0.8,0.32,1.19c-0.03,0.12-0.08,0.23-0.16,0.33C178.52,327.65,177.56,327.68,176.74,327.28z"
    />
    <path
      class="bone"
      disabled
      d="M177.08,335.2c0.39,0.2,0.82,0.32,1.26,0.34c0.18,0.01,0.36-0.01,0.54-0.06c0.13,0,0.27-0.13,0.33-0.14s0.09,0,0.12,0.07c0.39,0.6-0.61,1.2-0.56,1.93s0.09,1.87-0.83,1.82c-0.38-0.06-0.69-0.32-0.82-0.68c-0.11-0.42-0.02-0.87,0.26-1.21c0.19-0.32,0.36-0.54,0.13-0.88c-0.28-0.27-0.49-0.59-0.63-0.95C176.82,335.09,177.08,335.2,177.08,335.2z"
    />
    <path
      class="bone"
      disabled
      d="M178.68,334.76c-0.61,0.06-1.22-0.13-1.7-0.51c-0.05-0.39,0.02-0.79,0.21-1.14c0.25-0.6,0.33-1.25,0.22-1.89c-0.12-0.77-1.53-2.79-0.51-3c0.65,0.06,1.29,0.15,1.92,0.29c0.6,0,0.79,0.35,0.75,1s-0.48,0.91-0.58,1.6c-0.07,0.64-0.01,1.29,0.18,1.91l0.07,0.22c0.04,0.36,0.04,0.72,0,1.08l0,0C179.13,334.54,178.92,334.7,178.68,334.76z"
    />
    <path
      class="bone"
      disabled
      d="M172.57,335.73c-0.67,0-1.34-0.03-2-0.11c-0.1-0.05-0.18-0.13-0.24-0.23c-0.26-0.52,0.1-1.52,0.17-2.06c0.13-0.7,0.23-1.4,0.28-2.11c0-0.7-0.44-1.11-0.58-1.74s0.06-0.92,0.7-0.83c0.35,0.11,0.7,0.2,1.06,0.27c0.4,0,0.71-0.23,1-0.15c0.81,0.19,0.57,1,0.22,1.55c-0.44,0.73-0.92,1.19-0.88,2.12c0.01,0.77,0.2,1.52,0.54,2.21C172.84,334.65,173.44,335.64,172.57,335.73z"
    />
    <path
      class="bone"
      disabled
      d="M170.51,337.68c-0.16-0.37-0.55-0.81-0.19-1.19s0.73,0,1.12,0h0.28c0.33,0,1,0,1.1,0.47s-0.39,0.73-0.55,1c-0.25,0.41-0.4,0.87-0.44,1.35c0.06,0.47,0.01,0.96-0.17,1.4c-0.23,0.35-0.53,0.69-1,0.58c-0.43-0.14-0.7-0.55-0.68-1C170.05,339.42,170.89,338.57,170.51,337.68z"
    />
    <path
      class="bone"
      disabled
      d="M164.52,336.58c-0.15-0.34-0.21-0.31-0.16-0.75s0.62-0.44,1-0.23l0.35-0.05c0.3,0,0.84-0.06,1,0.34s-0.34,0.67-0.49,0.94c-0.23,0.37-0.36,0.79-0.39,1.23c0.07,0.43,0.02,0.87-0.14,1.27c-0.2,0.31-0.48,0.63-0.88,0.54c-0.4-0.13-0.66-0.51-0.64-0.93C164.12,338.16,164.89,337.37,164.52,336.58z"
    />
    <path
      class="bone"
      disabled
      d="M159.04,327.39c0.35-0.13,0.76,0.32,1,0.25l0.42-0.2c0.32-0.06,0.77-0.25,0.91,0.08s-0.27,0.6-0.39,0.85c-0.18,0.33-0.27,0.71-0.26,1.09c0,0.37,0.15,0.77,0,1.09s-0.4,0.58-0.78,0.54c-0.37-0.06-0.65-0.37-0.67-0.75c0-0.67,0.6-1.41,0.2-2.06C159.27,328,158.65,327.54,159.04,327.39z"
    />
    <path
      class="bone"
      disabled
      d="M169.96,319.85c-0.09-0.8,0.36-1.15,1.15-1.39c0.61-0.22,1.29-0.14,1.83,0.21c0.72,0.45,0.34,1.21,0.16,1.85c-0.27,0.84-0.39,1.72-0.34,2.6c0.07,0.89,0.13,1.77,0.15,2.67c0.03,0.24,0.08,0.47,0.15,0.7c0,0.68,0.13,1.4-0.7,1.53c-0.79,0.11-1.58-0.17-2.12-0.75c-0.42-0.64,0.1-1.32,0.25-2c0.17-0.89,0.2-1.81,0.07-2.71C170.45,321.64,170.07,320.78,169.96,319.85z"
    />
    <path
      class="bone"
      disabled
      d="M160.33,314.47c-0.66-0.86-0.08-2,0.34-2.81c0.48-0.91,0.8-1.91,0.93-2.93c0.2-1.15,0.3-2.31,0.31-3.47c-0.02-0.52-0.08-1.04-0.16-1.56c-0.1-0.39-0.08-0.81,0.06-1.19c0.43-0.85,1.86-0.61,2.52-0.28c1.06,0.54,0.44,1.39,0,2.23c-0.97,2.2-1.36,4.61-1.13,7c0.18,1,0.4,2.17-0.31,3c-0.61,0.71-1.67,0.79-2.38,0.19C160.44,314.59,160.39,314.53,160.33,314.47z"
    />
    <path
      class="bone"
      disabled
      d="M160.49,223.46c-1.08,0.71-2.43,0.86-3.64,0.39c-1.09-0.42-1.89-0.8-1.94,0.55c-0.09,2.3,1.49,2.17,2,8.84s1.57,20.13,1.34,25.18s1.48,15.91,2.16,20.63s1.33,5.71,1.26,7.86c0,0.94-0.15,3.34,0.36,4.48c0.16,0.34,0.55,0.52,0.91,0.41c0.28-0.08,0.65-0.18,1.08-0.28c1.29-0.69,2.45-2,1.64-5.48c-1.13-5.65-1.95-11.36-2.46-17.1c-0.35-4,0.32-16.9,0.66-21.13l0.68-13.42c0.62,3.55,1.88,10.43,3.19,17.43s0,32.36-1,37.27c-0.12,0.46-0.18,0.93-0.18,1.4c0.01,0.3,0.27,0.53,0.56,0.51c0.02,0,0.03,0,0.05,0c0.84-0.1,1.68-0.1,2.52,0c1.43,0.24,2.83,0.65,4.17,1.23c0.5,0.24,1.1,0.03,1.33-0.47c0.05-0.11,0.08-0.22,0.1-0.34c0-1.29-0.12-2.58-0.35-3.85c-0.26-2.8-1.72-8.55-1.91-15.28s-0.19-19.76-2.7-30.74c-2-8.64-2.45-13.78-1-15.89s1.08-3.21-1.28-2.78c-0.91,0.4-1.94,0.4-2.85,0c-0.8-0.39-1.67-0.63-2.56-0.7C162.01,222.28,161.33,222.92,160.49,223.46z"
    />
    <path
      class="bone"
      disabled
      d="M161.96,295.42c0.09-0.49,0.38-0.93,0.8-1.2c1.94-0.63,3.97-0.92,6-0.87c1.23,0.17,2.43,0.48,3.58,0.93l1,0.57c0.72,0.59,1.53,1.06,2.39,1.41c0.57,0.23,1.02,0.68,1.24,1.25c0.02,0.14,0.02,0.29,0,0.43c0,0,0,0,0,0.06c-0.36,0.8-0.84,1.53-1.44,2.16c-0.42,0.09-0.86,0.14-1.29,0.14c-0.92-0.06-1.83,0.14-2.64,0.58l-0.36,0.33c-0.51,0.61-1.3,0.91-2.09,0.8c-0.74-0.07-1.46-0.27-2.13-0.6c-0.71-0.34-1.48-0.57-2.26-0.68c-1-0.12-1.39,0.06-2.38-0.06s-0.53-4.51-0.53-4.51C161.87,295.9,161.91,295.66,161.96,295.42z"
    />
    <path
      class="bone"
      disabled
      d="M103.15,96.39c-0.78,0.17-2.09,0.82-2.11,0c0-0.49,1.07-1.44-0.9-1.61c0,0-1.63,0-3.81,0s-3.82,0-3.82,0c-2,0.17-0.88,1.12-0.89,1.61c0,0.83-1.33,0.18-2.12,0s-1.57,1.17,0,1.34s2.71,0.34,2.64,1.11c-0.08,1,1.94,1.21,4.19,1.21s4.26-0.24,4.18-1.21c-0.06-0.77,1.07-0.94,2.64-1.11S103.94,96.23,103.15,96.39z"
    />
    <path
      class="bone"
      disabled
      d="M103.67,184.82c-0.85,0.23-2.26,1.11-2.28,0c0-0.67,1.15-2-1-2.19c0,0-1.76-0.08-4.1-0.08s-4.11,0.08-4.11,0.08c-2.11,0.23-0.94,1.52-1,2.19c0,1.13-1.43,0.25-2.28,0c-0.5,0-0.91,0.41-0.91,0.91s0.41,0.91,0.91,0.91c1.69,0.23,2.92,0.46,2.85,1.52c-0.09,1.32,2.08,1.65,4.5,1.65s4.59-0.33,4.5-1.65c-0.07-1.06,1.15-1.29,2.84-1.52c0.5,0.02,0.93-0.37,0.95-0.87C104.56,185.27,104.17,184.84,103.67,184.82z"
    />
    <path
      class="bone"
      disabled
      d="M102.94,177.12c-0.76,0.21-2,1-2,0c0-0.6,1-1.76-0.87-2c0,0-1.58-0.07-3.69-0.07s-3.7,0.07-3.7,0.07c-1.9,0.21-0.85,1.37-0.86,2c0,1-1.29,0.23-2,0c-0.45,0-0.82,0.37-0.82,0.82c0,0.45,0.37,0.82,0.82,0.82c0,0,0,0,0,0c1.52,0.21,2.62,0.41,2.56,1.37c-0.08,1.18,1.87,1.48,4,1.48s4.13-0.3,4-1.48c-0.06-1,1-1.16,2.56-1.37c0.45,0,0.82-0.37,0.82-0.82C103.76,177.49,103.39,177.12,102.94,177.12z"
    />
    <path
      class="bone"
      disabled
      d="M102.11,85.6c-0.67,0.13-1.78,0.65-1.79,0c0-0.39,0.9-1.14-0.76-1.27c0,0-1.39,0-3.23,0s-3.23,0-3.23,0c-1.67,0.13-0.75,0.88-0.76,1.27c0,0.66-1.13,0.14-1.79,0s-1.34,0.93,0,1.06s2.29,0.27,2.23,0.88s1.64,1,3.55,1s3.61-0.2,3.54-1s0.91-0.75,2.24-0.88S102.77,85.47,102.11,85.6z"
    />
    <path
      class="bone"
      disabled
      d="M102.11,80.55c-0.67,0.13-1.78,0.64-1.79,0c0-0.39,0.9-1.14-0.76-1.27c0,0-1.39,0-3.23,0s-3.23,0-3.23,0c-1.67,0.13-0.75,0.88-0.76,1.27c0,0.65-1.13,0.14-1.79,0s-1.34,0.93,0,1.06s2.29,0.26,2.23,0.88s1.64,1,3.55,1s3.61-0.19,3.54-1s0.91-0.75,2.24-0.88S102.77,80.42,102.11,80.55z"
    />
    <path
      class="bone"
      disabled
      d="M102.11,90.76c-0.67,0.14-1.78,0.69-1.79,0c0-0.42,0.9-1.23-0.76-1.38c0,0-1.39,0-3.23-0.05s-3.23,0.05-3.23,0.05c-1.67,0.15-0.75,1-0.76,1.38c0,0.7-1.13,0.15-1.79,0s-1.34,1,0,1.14s2.29,0.29,2.23,1c-0.07,0.82,1.64,1,3.55,1s3.61-0.21,3.54-1c-0.05-0.67,0.91-0.81,2.24-1S102.77,90.62,102.11,90.76z"
    />
    <path
      class="bone"
      disabled
      d="M105.62,193.3c-0.93,0.26-3.7,1.22-3.72,0c0-0.74,1.26-2.16-1.06-2.41c0,0-1.93-0.08-4.51-0.08s-4.52,0.08-4.52,0.08c-2.32,0.25-1,1.67-1,2.41c0,1.24-2.79,0.28-3.72,0c-0.55,0-1,0.45-1,1s0.45,1,1,1c1.86,0.25,4.41,0.5,4.34,1.67c-0.1,1.45,2.29,1.81,5,1.81s5-0.36,5-1.81c-0.08-1.17,2.48-1.42,4.34-1.67c0.55-0.04,0.97-0.52,0.92-1.07C106.65,193.67,106.17,193.26,105.62,193.3L105.62,193.3z"
    />
    <path
      class="bone"
      disabled
      d="M108.99,233.21c-1.26,0.35-5,1.67-5.07,0c0-1,1.73-2.94-1.44-3.29c0,0-2.63-0.11-6.15-0.11s-6.16,0.11-6.16,0.11c-3.17,0.35-1.42,2.28-1.44,3.29c0,1.7-3.8,0.38-5.07,0c-0.76,0-1.37,0.61-1.37,1.37c0,0.76,0.61,1.37,1.37,1.37c2.54,0.34,6,0.68,5.92,2.28c-0.13,2,3.12,2.46,6.75,2.46s6.88-0.49,6.75-2.46c-0.11-1.6,3.38-1.94,5.91-2.28c0.76,0,1.37-0.61,1.37-1.37C110.36,233.82,109.75,233.21,108.99,233.21z"
    />
    <path
      class="bone"
      disabled
      d="M106.46,212.23c-1,0.27-4,1.33-4.06,0c0-0.81,1.39-2.36-1.15-2.64c0,0-2.11-0.09-4.92-0.09s-4.93,0.09-4.93,0.09c-2.53,0.28-1.14,1.83-1.15,2.64c0,1.35-3,0.29-4.06,0c-0.6-0.06-1.14,0.39-1.2,0.99c-0.06,0.6,0.39,1.14,0.99,1.2c0.07,0.01,0.14,0.01,0.21,0c2,0.27,4.82,0.55,4.74,1.82c-0.11,1.58,2.5,2,5.4,2s5.5-0.39,5.4-2c-0.09-1.27,2.7-1.55,4.73-1.82c0.84,0,1.53-0.25,1.53-1.1C107.99,212.48,107.3,211.8,106.46,212.23z"
    />
    <path
      class="bone"
      disabled
      d="M107.47,222.22c-1.11,0.3-4.43,1.46-4.46,0c0-0.89,1.52-2.59-1.27-2.89c0,0-2.32-0.11-5.41-0.11s-5.42,0.11-5.42,0.11c-2.79,0.3-1.25,2-1.27,2.89c0,1.49-3.34,0.33-4.46,0c-0.66,0-1.2,0.53-1.2,1.2s0.53,1.2,1.2,1.2c0,0,0,0,0.01,0c2.23,0.3,5.3,0.61,5.21,2c-0.12,1.73,2.75,2.17,5.94,2.17s6-0.44,5.94-2.17c-0.09-1.4,3-1.71,5.2-2c0.55,0.37,1.43,0.02,1.8-0.53c0.37-0.55,0.22-1.3-0.33-1.66C108.54,222.15,108.01,222.15,107.47,222.22z"
    />
    <path
      class="bone"
      disabled
      d="M106.46,202.52c-1,0.27-4,1.33-4.06,0c0-0.8,1.39-2.35-1.15-2.63c0,0-2.11-0.09-4.92-0.09s-4.93,0.09-4.93,0.09c-2.53,0.28-1.14,1.83-1.15,2.63c0,1.36-3,0.3-4.06,0c-0.6-0.06-1.14,0.39-1.2,0.99c-0.06,0.6,0.39,1.14,0.99,1.2c0.07,0.01,0.14,0.01,0.21,0c2,0.27,4.82,0.54,4.74,1.82c-0.11,1.58,2.5,2,5.4,2s5.5-0.39,5.4-2c-0.09-1.28,2.7-1.55,4.73-1.82c0.61,0,1.1-0.49,1.1-1.1C107.56,203.01,107.07,202.51,106.46,202.52C106.46,202.51,106.46,202.51,106.46,202.52z"
    />
    <path
      class="bone"
      disabled
      d="M113.98,54.62c0-0.37-0.23-0.36-0.55-0.36c-1.92,0-4.56,0.18-4.74,0.8c-0.11,0.38-0.21,0.82-0.32,1.28c-0.36,1.56-0.87,5.17-2,6.43c0,0-3.25,3.49-10,3.49l0,0c-6.72,0-10-3.49-10-3.49c-1.17-1.26-1.67-4.87-2-6.43c-0.11-0.46-0.21-0.9-0.32-1.28c-0.18-0.62-2.83-0.79-4.74-0.8c-0.32,0-0.53,0-0.56,0.36c0,0.14-0.58,4.19,0.86,5s0.67,8.9,3.52,10.37c4.16,2.15,4.64,8.26,13.26,8.27l0,0c8.62,0,9.09-6.12,13.26-8.27c2.85-1.47,2.06-9.56,3.51-10.37S113.99,54.76,113.98,54.62z"
    />
    <path
      class="bone"
      disabled
      d="M115.05,13.58c-4.26-6.14-11.24-9.83-18.72-9.89l0,0c-7.47,0.06-14.44,3.75-18.7,9.89c-3.49,4.84-4.54,12.77-4.3,17.42c0.27,5.72,2.94,21.82,5.41,22.24c1.83,0.32,5.66,0.08,6.2,1.55c0.14,0.39,1.08,4.58,2.06,5.64c1.33,1.41,5.53,2.57,9.33,2.57l0,0c3.8,0,8-1.18,9.34-2.61c1-1.06,1.93-5.25,2.07-5.64c0.54-1.47,4.36-1.23,6.2-1.55c2.48-0.4,5.16-16.5,5.39-22.2C119.59,26.35,118.54,18.42,115.05,13.58z M84.05,45.88c-2.34-0.16-3.2-1.89-3.21-7.09c0-4.06,2.84-4.51,7.44-5.4c1-0.18,3.1-0.75,4.2,1.26c0.92,1.7,0.61,4.52-0.4,6.5S86.38,46,84.05,45.88z M97.12,54.12c-0.24-0.11-0.5-0.17-0.77-0.2l0,0c-0.27,0.03-0.53,0.09-0.78,0.2c-3.79,1.66-3.33-1.85-2.71-5.08c0.53-2.8,1.29-5,2-5.85s1,0,1.48,0l0,0c0.53,0,0.86-0.65,1.47,0s1.49,3.05,2,5.85C100.46,52.27,100.91,55.78,97.12,54.12z M108.63,45.88c-2.34,0.15-7-2.73-8-4.73s-1.33-4.8-0.4-6.5c1.1-2,3.25-1.44,4.2-1.26c4.6,0.89,7.44,1.34,7.44,5.4C111.83,44,110.96,45.72,108.63,45.88z"
    />
    <path
      class="bone"
      disabled
      d="M114,240.28c-1.62-5.39-5.29-2-8,1.33c-1.37,1.67-3.07,3.03-5,4c-2.87,1.45-6.27,1.45-9.14,0c-1.93-0.97-3.63-2.33-5-4c-2.73-3.37-6.41-6.72-8-1.33c-1.9,6.35-0.8,10.6,2.93,13.06c2.71,1.78-0.5,5.71,2.75,8.75c3.07,2.87,1.67,5.05,4.71,6.32c1.93,0.8,1.2,5,3,6.16c1,0.69-0.09,3.48,1.22,4.08c0.78,0.36,1.31,2,3,2s2.21-1.65,3-2c1.31-0.6,0.19-3.39,1.22-4.08c1.76-1.16,1-5.36,3-6.16c3-1.27,1.64-3.45,4.7-6.32c3.25-3,0-7,2.75-8.75C114.81,250.88,115.91,246.63,114,240.28z"
    />
    <path
      class="bone"
      disabled
      d="M136.84,275.39c-2.89,0.14-2.09,2.69-3.56,2s-0.26-2.57,0.24-3.91s0.07-3.93-1.74-4.58c-3.33-1.19-6.28,1.75-7.47,4.1c-1.22,2.48-1.77,5.24-1.58,8c0.39,2.67,3.43,1.57,5.58,2.18c2.15,0.61,2.41,5.46,1.23,8.35s-1.87,3.83-0.86,7.38c1.01,3.55-3,27.23-5.88,46.86c-1.93,13.38-5.88,34.63-9,47.32c-1.33,5.36-4.67,15.14-6,16.66c-3.74,4.24-4.64,8.37-3,14.39c1.07,4,3.5,4.82,5.43,4.49c1.84-0.6,1.45-2.09,1.09-3.1s-1.81-4.28-1.28-7.29c0.71-3.85,4.4-6.4,8.25-5.7c1.25,0.23,2.42,0.79,3.38,1.63c2.18,1.94,3,5.45,2.19,8.63c-0.54,2.11-1.46,2.85-1,4.16c0.59,1.56,2.88,1.12,5.12-0.91c0.76-0.68,2-2.09,1.09-8.65c-0.77-5.73-4-6.19-4.55-12.15s5.87-46.77,7.2-54.63c1.19-7,6.4-45.14,6.58-46.77c0.39-3.53,4.06-7.68,5.17-13C146.25,277.56,139.73,275.26,136.84,275.39z"
    />
    <path
      class="bone"
      disabled
      d="M151.33,217.7c-0.67-3.54,3.71-6.66,4.06-11.65s-2.21-67.68-4.37-71.72c-0.67-1.37-1.65-2.57-2.87-3.49c-3.08-2.45-4.39-6.5-3.32-10.29c1.16-4.36,4.21-6,7.59-6c1.7-0.02,3.24,0.99,3.91,2.55c1.17-0.33,3.45-0.2,3.79,2c0.46,4.66,0.41,9.35-0.15,14c-0.69,4.75,1.27,42.89,1.67,53.24c0.36,9.16,1.49,17.08,4.08,20.65s5.77,4.75,5.57,8.11c-0.18,3.15-3.54,6.27-6.31,5.21c-1.68-0.63-2-1.2-2.58-1.33c-0.29-0.06-0.55-0.58-1.26,0.13c-0.69,0.7-1.54,1.23-2.47,1.56C156.33,221.47,152.16,222.18,151.33,217.7z"
    />
    <path
      class="bone"
      disabled
      d="M105.44,571c1.08-0.39,2.68-0.45,3.42,0.39c0.13,0.25,0.2,0.54,0.19,0.82c0,0.58-0.72,0.83-0.85,1.36c-0.19,0.77,0.67,1.18,0.78,1.86c0.25,1.38-1.76,1.62-2.52,1.14c-0.57-0.37-0.48-1-0.73-1.54s-0.65-0.63-1-1.11c-0.63-0.9-0.41-2.15,0.49-2.79C105.29,571.08,105.36,571.04,105.44,571z"
    />
    <path
      class="bone"
      disabled
      d="M113.4,548.15c0.71,0.4,0.43,1.17,0.51,1.9c0.23,1.72,0.6,3.42,1.1,5.09c0.09,0.3,0.2,0.58,0.34,0.86c0.34,0.62,0.12,1.4-0.5,1.74c-0.21,0.12-0.45,0.17-0.69,0.16c-0.39,0-0.77-0.11-1.09-0.32c-0.59-0.33-0.65-0.7-0.57-1.37c0.42-3.2-1.4-6.72-1-7.39c0.29-0.69,1.09-1.02,1.78-0.73C113.32,548.11,113.36,548.13,113.4,548.15z"
    />
    <path
      class="bone"
      disabled
      d="M121.62,564.15c0.07-0.07,0.27-0.19,0.31-0.1c0.42,0.81-0.09,1.55,0.41,2.41c0.3,0.64,0.63,1.26,1,1.86c0.22,0.29,0.46,0.35,0.53,0.77s-0.08,0.8,0,1.19s0.3,0.68,0.06,1s-0.51,0.26-0.73,0c-0.49-0.63-0.09-1.36-1-1.63c-0.09-0.4,0-0.79-0.05-1.18c-0.14-0.32-0.31-0.62-0.5-0.91c-0.27-0.55-0.38-1.23-1-1.45c-0.41-0.15-0.67,0-0.94-0.4s-0.11-0.57,0.21-0.88c0.22-0.15,0.48-0.24,0.75-0.24c0.5,0,0.78,0.06,0.89-0.19S121.49,564.31,121.62,564.15z"
    />
    <path
      class="bone"
      disabled
      d="M123.87,563.15c0.37-0.57,0.64,0,1.24-0.27c0.06,0,0-0.17,0.06-0.22s0.32-0.3,0.4-0.27c0.84,0.26-0.18,1.37,0.31,2.16c0.28,0.56,0.6,1.11,0.95,1.64c0.21,0.26,0.44,0.3,0.52,0.67s0,0.73,0,1.09s0.3,0.6,0.11,0.93s-0.46,0.26-0.67,0c-0.47-0.56-0.14-1.24-1-1.43c-0.09-0.37,0-0.73-0.1-1.08c-0.13-0.28-0.3-0.55-0.49-0.8c-0.27-0.49-0.4-1.11-0.94-1.28c-0.38-0.12-0.39,0.14-0.54-0.31C123.61,563.7,123.67,563.38,123.87,563.15z"
    />
    <path
      class="bone"
      disabled
      d="M127.25,562.8c0.37,0.1,0.47,0.51,0.67,0.84c0.13,0.16,0.25,0.34,0.34,0.52c0.08,0.24,0,0.48,0.1,0.72c0.6,0.11,0.39,0.58,0.72,1c0.15,0.15,0.32,0.19,0.45,0s0-0.43-0.09-0.63s0-0.5-0.05-0.73s-0.22-0.27-0.36-0.44c-0.25-0.34-0.48-0.71-0.69-1.08c-0.35-0.52,0.36-1.23-0.22-1.39c-0.09,0.01-0.18,0.05-0.24,0.12c-0.04,0.09-0.09,0.17-0.15,0.25c-0.31,0.25-0.66-0.06-1,0.28C126.71,562.18,126.45,562.6,127.25,562.8z"
    />
    <path
      class="bone"
      disabled
      d="M117.97,571.63c-0.21-0.86-0.26-1.75-0.15-2.63c-0.01-0.32-0.18-0.61-0.45-0.79c-0.37-0.27-0.82-0.42-1.28-0.44c-0.3,0.07-0.57,0.21-0.81,0.4c-0.3,0.24-0.44,0.63-0.36,1c0.08,0.29,0.18,0.57,0.29,0.84c0.47,1.16,0.58,2.42,1,3.61c0.2,0.55,1.76,1.14,2.17,0.14C118.75,572.91,118.33,572.34,117.97,571.63z"
    />
    <path
      class="bone"
      disabled
      d="M107.33,536.23c-1.58,0.13-3.32,1.07-3.53,2.69c-0.27,1.46-1.08,2.78-2.26,3.68c-0.81,0.69-1.26,1.71-1.25,2.77c0,1.81-0.08,5.29,1.69,5.23c1.1-0.15,2.1-0.75,2.74-1.66c0.93-1.05,2.67-1.35,4.89-1.19c1.64,0.11,3.14-1.35,5.06-1.19s2.39,1,3.72,1.41s1.87-1.05,0.86-2c-0.92-0.72-1.89-1.36-2.92-1.92c-2.81-1.58-2-4.63-2.4-5.76C113.4,536.74,109.23,536.08,107.33,536.23z"
    />
    <path
      class="bone"
      disabled
      d="M127.96,430.82c0.39-1.3-0.46-2.53-1.09-2.27c-2.63,1.07-3.3,1.13-5,0.34c-1.11-0.52-2.94,1.23-4.92,1.33c-2.14,0.12-3-2-4.18-1.25c-1.54,0.94-4.19,1.71-6.08,0.79c-0.36-0.17-0.79-0.12-1.11,0.13c-0.65,0.3-1.09,0.93-1.15,1.65c-0.11,0.86,0.34,2.18,1.79,4.63c6.44,10.88,3.53,31,2.46,45.41c-3,39.51-6.32,39.6-7.26,52.23c-0.07,1,0.62,2.54,1.42,2.61s3-1.24,5.25-1.36c2.21,0.11,4.4,0.5,6.51,1.18c2,0.71,0.44-3.65,0-7.32c-1.16-9,3.6-48.92,4.41-55.22c0.69-5.37,2.64-26.1,3.42-30C123.5,438.26,126.79,434.78,127.96,430.82z"
    />
    <path
      class="bone"
      disabled
      d="M104.05,563.65c-0.74,1.13-1.54,2.89-0.14,2.81c0.58-0.86,1.33-1.6,2.21-2.17c0.94-0.43,2,0.51,3,1.63c0.28,0.1,0.35-0.08,0.45-0.36c0.43-1.12-0.36-2.78-0.45-3.91c-0.11-1.51,0.55-2.54,1-3.92c0.46-1.54-0.1-2.1-0.1-2.1s-1.87-2-3.66-1.63c-0.44,0.11-0.83,0.34-1.13,0.68c-0.59,0.59-0.94,1.37-1,2.2c-0.05,1.01,0.02,2.01,0.22,3C104.7,561.37,104.88,562.4,104.05,563.65z"
    />
    <path
      class="bone"
      disabled
      d="M110.33,554.35c-0.05,0.07-0.15,0.09-0.22,0.04c-0.01-0.01-0.03-0.02-0.04-0.04c-0.69-0.84-1.67-1.39-2.74-1.55c-1.27-0.15-3.23,1.3-3.52,1.67s-0.44-0.44-0.37-0.9c0.21-1.5,1.21-3.51,2.35-4.09c1.17-0.54,2.5-0.6,3.71-0.15c0.6,0.24,1.07,0.71,1.33,1.3c0.3,0.62,0.37,1.33,0.19,2C110.89,553.24,110.65,553.82,110.33,554.35z"
    />
    <path
      class="bone"
      disabled
      d="M118.33,556.18c0.33-0.23-2-7.83-2-7.83c-0.13-0.17-0.31-0.28-0.52-0.32c-1.49-0.39-1.21,0.1-1.21,0.1c1.29,2.44,1.53,7.33,1.86,7.89C116.41,556,116.95,557.13,118.33,556.18z"
    />
    <path
      class="bone"
      disabled
      d="M121.42,552.31c-0.29-0.81-0.65-1.57-0.94-2.38l-0.13-0.13c-0.11,0-0.74-0.32-0.62,0.07s0.88,2.5,0.88,2.5c0.37,0.88,0.66,1.68,0.76,1.79s0.59,0.28,0.71,0C122.33,553.53,121.61,552.84,121.42,552.31z"
    />
    <path
      class="bone"
      disabled
      d="M117.7,549.58c0.14,0.36,1.79,5.79,1.86,6s0.53,0,0.74-0.24c0.6-0.66-0.21-1.43-0.34-2.15v-0.16c0,0-0.95-3.17-1-3.37S117.56,549.21,117.7,549.58z"
    />
    <path
      class="bone"
      disabled
      d="M115.86,564.52c0.31,0.03,0.62,0.1,0.91,0.21c0.1,0.04,0.22-0.02,0.26-0.12c0,0,0-0.01,0-0.01c0.27-1.08-0.87-2-1-3.25s0.44-2.77-1.34-2.38c-0.41-0.01-0.82,0.01-1.23,0.06c-0.36,0.13-0.58,0.26-0.54,0.65l0.42,5.24c0,0,0.06,0.38,0.77,0.07l0.55-0.25C115.03,564.55,115.45,564.48,115.86,564.52z"
    />
    <path
      class="bone"
      disabled
      d="M120.92,562.6c-0.09-0.41-0.25-0.81-0.46-1.17c-0.09-0.4-0.28-0.78-0.56-1.08c-0.28-0.39-0.51-0.8-0.71-1.24c-0.21-0.42-0.09-1.19-0.52-1.36c-0.49-0.09-1-0.01-1.45,0.22c-0.13,0.33,0.25,0.85,0.45,1.32c0.42,1,1,1.91,1.42,2.89s0.38,1.43,0.77,1.44l0.83-0.46C120.82,563,120.9,562.81,120.92,562.6z"
    />
    <path
      class="bone"
      disabled
      d="M117.58,566.21c0,0,0.42,0.35,0.35,0.61s-0.44,0.31-0.44,0.31c-0.45-0.27-0.98-0.39-1.5-0.36c-0.57,0.16-1.1,0.43-1.56,0.81c-0.33,0.23-0.51-0.27-0.51-0.81c0.01-0.43,0.27-0.82,0.66-1c0.21-0.1,0.44-0.17,0.67-0.21c0.83,0,1.64,0.24,2.33,0.69"
    />
    <path
      class="bone"
      disabled
      d="M120.33,557.33c0.31,0.93,1,1.36,1.54,2.12c0.29,0.38,0.52,0.81,0.67,1.26c0.15,0.43,0.44,1.28,0.69,1.34s1.48-0.13,1.5-0.38s-3.18-5-3.46-5.31S120.04,556.61,120.33,557.33z"
    />
    <path
      class="bone"
      disabled
      d="M125.98,561.21c0.19,0,1.48-0.21,1.55-0.53s-1.49-2.06-2.5-2.86s-1.12-2-2.13-2.48c-0.43-0.2-1.13,0.07-0.84,0.54s3.51,5,3.51,5C125.7,561,125.84,561.11,125.98,561.21z"
    />
    <path
      class="bone"
      disabled
      d="M105.52,569.82c0,0-0.21,0-0.26,0s-1.58-0.49-1.28-1.63s2.07-2.77,2.57-2.64c0,0,0.67-0.15,1.83,1.3c0.35,0.42,0.59,0.93,0.67,1.47c0.04,0.42-0.18,0.81-0.55,1c-0.39-0.06-0.78-0.09-1.17-0.1c-0.54,0.11-1.05,0.34-1.5,0.66C105.72,569.9,105.61,569.88,105.52,569.82z"
    />
    <path
      class="bone"
      disabled
      d="M130.4,230.55c-9.66-1.78-14.75,2.58-15.08,7.08c-0.51,7,4,18.87,1.21,24.81c-2.7,5.71-6.83,10.62-12,14.24c-1.9,1.34-4.12,2.74-5.35,4.88c-1.89,0.31-3.81,0.31-5.7,0c-1.24-2.14-3.46-3.54-5.36-4.88c-5.17-3.62-9.3-8.53-12-14.24c-2.79-5.94,1.72-17.82,1.21-24.81c-0.33-4.5-5.41-8.86-15.07-7.08c-6.2,1.14-11.39,5.28-11.4,12.54c0,6.89,1.53,18.69,12.11,23.53c4.38,2,7.11,4.3,8,8.54c1.29,6.32-0.54,12.71,0.5,16.71c1.67,6.45,5.85,8.7,11.64,8.64c5.6-0.05,8.82-5.26,10.41-10.21c0-0.14,0.08-0.28,0.13-0.42c0.73,0.7,1.68,1.11,2.69,1.18l0,0c1.01-0.07,1.96-0.49,2.69-1.18l0.12,0.42c1.59,4.95,4.81,10.16,10.41,10.21c5.79,0.06,10-2.19,11.65-8.64c1-4-0.8-10.39,0.5-16.71c0.86-4.24,3.59-6.53,8-8.54c10.58-4.84,12.11-16.64,12.1-23.53C141.78,235.83,136.59,231.69,130.4,230.55z M84.18,293.86c-2.57,1.31-3.73-3.11-4.79-4.76c-1.37-2.14-3.34-4.26-2.51-7.07s4-2.24,6.24-1.2c2.24,1.23,3.84,3.36,4.4,5.85C87.78,289,86.44,292.71,84.18,293.86z M113.27,289.1c-1.07,1.65-2.23,6.07-4.8,4.76c-2.25-1.15-3.6-4.84-3.33-7.18c0.56-2.49,2.15-4.62,4.39-5.85c2.21-1,5.38-1.75,6.25,1.2S114.63,287,113.27,289.1L113.27,289.1z"
    />
    <path
      class="bone"
      disabled
      d="M100.64,100.94c0,0-1.85-0.06-4.31-0.06s-4.31,0.06-4.31,0.06c-2.22,0.18-0.69,3.61-0.4,4.49s2.17,1.23,4.71,1.23s4.37-0.22,4.71-1.23S102.86,101.12,100.64,100.94z"
    />
    <path
      class="bone"
      disabled
      d="M111.45,418.29c0.77-3.91,6-4,7.74-3.34c1.43,0.57,3.66,3.85,3.53,6.24s-2.33,7.39-5.89,7.19C113.44,428.18,110.45,423.36,111.45,418.29z"
    />
    <path
      class="bone"
      disabled
      d="M55.82,275.39c2.89,0.14,2.09,2.69,3.55,2s0.27-2.57-0.24-3.91s-0.07-3.93,1.75-4.58c3.33-1.19,6.27,1.75,7.46,4.1c1.23,2.48,1.78,5.24,1.58,8c-0.38,2.67-3.42,1.57-5.57,2.18s-2.42,5.46-1.24,8.35s1.88,3.83,0.86,7.38s3,27.23,5.88,46.86c1.94,13.38,5.89,34.63,9,47.32c1.32,5.36,4.67,15.14,6,16.66c3.75,4.24,4.65,8.37,3,14.39c-1.07,4-3.51,4.82-5.43,4.49c-1.84-0.6-1.46-2.09-1.1-3.1s1.81-4.28,1.29-7.29c-0.71-3.86-4.41-6.41-8.27-5.69c-1.25,0.23-2.41,0.79-3.37,1.62c-2.17,1.94-3,5.45-2.19,8.63c0.54,2.11,1.46,2.85,1,4.16c-0.6,1.56-2.88,1.12-5.12-0.91c-0.76-0.68-2-2.09-1.1-8.65c0.77-5.73,4-6.19,4.56-12.15s-5.88-46.77-7.2-54.63c-1.2-7-6.41-45.14-6.59-46.77c-0.39-3.53-4.06-7.68-5.17-13C46.41,277.56,52.92,275.26,55.82,275.39z"
    />
    <path
      class="bone"
      disabled
      d="M64.69,430.82c-0.38-1.3,0.47-2.53,1.09-2.27c2.63,1.07,3.3,1.13,5,0.34c1.11-0.52,2.94,1.23,4.91,1.33c2.14,0.12,3-2,4.18-1.25c1.55,0.94,4.2,1.71,6.08,0.79c0.37-0.17,0.8-0.12,1.12,0.13c0.65,0.31,1.08,0.94,1.14,1.65c0.11,0.86-0.34,2.18-1.79,4.63c-6.43,10.88-3.53,31-2.45,45.41c2.94,39.51,6.32,39.6,7.25,52.23c0.08,1-0.62,2.54-1.41,2.61s-3-1.24-5.25-1.36c-2.21,0.11-4.4,0.5-6.51,1.18c-2,0.71-0.44-3.65,0-7.32c1.16-9-3.6-48.92-4.4-55.22c-0.69-5.37-2.65-26.1-3.43-30C69.16,438.26,65.87,434.78,64.69,430.82z"
    />
    <path
      class="bone"
      disabled
      d="M81.21,418.29c-0.78-3.91-6-4-7.75-3.34c-1.43,0.57-3.65,3.85-3.53,6.24s2.33,7.39,5.89,7.19C79.22,428.18,82.21,423.36,81.21,418.29z"
    />
    <path
      class="bone"
      disabled
      d="M156.02,109.82c-1.83-1.07-3.73-2.01-5.69-2.82c-1.28-0.46-2.35-0.5-3.09,0.2s-0.69,2.09-0.4,3.35s-3.15,2.12-4.16,2s-2.68-2.2-4.37-2.74s-4.07,0.75-5.39,0.88c-0.73,0.08-2.59-0.08-4.65-0.18c0.02,0.33,0.02,0.67,0,1c2.54,1.13,6.89,3.51,8,7c0.55,1.59,0.21,3.35-0.89,4.62c1.54,1.43,3.25,3.52,3.33,5.81c0.07,1.26-0.26,2.52-0.94,3.58c1.53,1.28,3.06,3.17,2.82,5.5c-0.14,1.58-0.85,3.05-2,4.14c0.64,0.43,1.25,0.9,1.83,1.41c3.46-7.13,5.46-12.69,4.29-13.76c-1.03-1.18-1.72-2.62-2-4.16c-0.28-3.06,0.47-6.13,2.12-8.72c1.4-2.21,4.83-4.62,10.94-3.27C158.15,114.12,157.71,110.88,156.02,109.82z"
    />
    <path
      class="bone"
      disabled
      d="M47.98,129.74c-1.17,1.07,0.83,6.63,4.28,13.76c0.58-0.51,1.19-0.98,1.83-1.41c-1.14-1.09-1.85-2.56-2-4.14c-0.24-2.33,1.3-4.22,2.83-5.5c-0.69-1.07-1.02-2.32-0.95-3.59c0.09-2.28,1.79-4.37,3.34-5.8c-1.1-1.27-1.44-3.02-0.9-4.61c1.16-3.45,5.51-5.83,8.06-7c0-0.3,0-0.62,0-1c-2,0.1-3.91,0.26-4.65,0.18c-1.31-0.13-3.64-1.43-5.38-0.88s-3.34,2.62-4.37,2.74s-4.44-0.72-4.16-2s0.32-2.65-0.4-3.35s-1.82-0.66-3.09-0.2c-1.98,0.8-3.89,1.73-5.74,2.79c-1.68,1.06-2.12,4.3,0.29,3.77c6.12-1.35,9.54,1.06,10.95,3.27c1.65,2.59,2.4,5.66,2.12,8.72C49.75,127.07,49.04,128.54,47.98,129.74z"
    />
    <path
      class="bone"
      disabled
      d="M103.74,170.19c-0.14-0.35-0.47-0.63-0.8-0.54c-0.76,0.21-2,1-2,0c0-0.61,1-1.77-0.87-2c0,0-1.58-0.07-3.69-0.07s-3.7,0.07-3.7,0.07c-1.9,0.21-0.85,1.37-0.86,2c0,1-1.29,0.22-2,0c-0.36-0.04-0.7,0.19-0.8,0.54c0,0.15,0,0.3-0.07,0.44c0,0.31,0.3,0.59,0.87,0.66c1.52,0.21,2.62,0.42,2.56,1.37c-0.08,1.18,1.87,1.48,4,1.48s4.13-0.3,4-1.48c-0.06-0.95,1-1.16,2.56-1.37c0.56-0.07,0.81-0.35,0.86-0.66L103.74,170.19z"
    />
    <path
      class="bone"
      disabled
      d="M140.48,156.23c-0.17-1.82-3.86-3.44-3.86-3.44s4.53-1.69,4.47-4.14c-0.09-3.47-7-6.53-7-6.53s4-0.87,4.33-4.4c0.28-2.73-4.29-5.05-4.29-5.05c1.54-0.56,2.52-2.08,2.39-3.72c-0.1-2.87-4.7-5.92-4.7-5.92s3.22-1.36,2.38-3.88c-1.28-3.78-8.49-6.3-8.49-6.3c0.33-0.96,0.44-1.99,0.32-3c-1.84,0-3.55,0.17-5.12,0.34c0,1.36-0.43,2.94-3.21,3.25c-0.76,0.09-10.41,0.33-11.67,0.38c-0.3,0.02-0.6,0.06-0.89,0.13c-0.88-0.48-1.67-1.11-2.34-1.86c-0.86-1.12-0.79-3.22-2-3.6c-0.7-0.22-2.12,0.2-4.41,0.2s-3.72-0.42-4.42-0.2c-1.23,0.38-1.16,2.48-2,3.6c-0.67,0.74-1.46,1.37-2.34,1.86c-0.3-0.07-0.6-0.11-0.9-0.13c-1.26,0-10.9-0.29-11.67-0.38c-2.78-0.31-3.24-1.89-3.2-3.25c-1.57-0.17-3.29-0.29-5.12-0.34c-0.12,1.01-0.02,2.04,0.32,3c0,0-7.22,2.52-8.49,6.3c-0.84,2.52,2.38,3.88,2.38,3.88s-4.62,3.05-4.78,5.97c-0.13,1.64,0.85,3.16,2.39,3.72c0,0-4.56,2.28-4.23,5c0.36,3.53,4.33,4.4,4.33,4.4s-7,3.06-7.05,6.53c-0.06,2.45,4.47,4.14,4.47,4.14s-3.68,1.62-3.85,3.44c-0.35,3.81,3.77,5.27,3.77,5.27s-4,2.24-3.55,5.29c0.24,1.54,2.57,3.52,2.57,3.52s-2.82,2.77-2.33,6c0.35,1.64,1.27,3.11,2.6,4.14c0,0-2.73,2.77-2,6s4.42,3.78,4.42,3.78c-0.07,0.21-1.62,4.11-1.29,5.93c0.91,4.89,6.14,4.24,7.63,4.12c2.79-0.41,5.37-1.69,7.39-3.66c0.84-0.85,1.9-2.06,3.05-3.47c2.4-1.1,4.69-2.44,6.83-4c1.91-1.73,3.71-3.57,5.39-5.52c1.57-1.73,2.31-3,1.35-3.77s-2.83,0.67-4,1.53c-0.62,0.46-1.79,1.58-3.13,2.8c0.42-0.68,0.8-1.34,1.15-2c2.32-4.21,5.22-5,6.6-10.4c0.5-2,0.42-6.31,3.6-11c0.84,3.52,2.08,6.55,3.75,6.71h0.34h0.34c1.67-0.16,2.9-3.19,3.74-6.72c3.18,4.69,3.11,9,3.61,11c1.37,5.44,4.27,6.19,6.59,10.4c0.27,0.49,0.56,1,0.86,1.49c-1.11-1-2.06-1.91-2.59-2.31c-1.18-0.86-3-2.3-4-1.53s-0.22,2,1.35,3.77c1.69,1.94,3.49,3.79,5.39,5.52c2.01,1.49,4.16,2.77,6.43,3.83c1.21,1.5,2.34,2.79,3.22,3.68c2.01,1.97,4.6,3.25,7.39,3.66c1.48,0.12,6.71,0.77,7.62-4.12c0.33-1.82-1.21-5.72-1.28-5.93c0,0,3.67-0.58,4.41-3.78s-2-6-2-6c1.32-1.03,2.25-2.5,2.6-4.14c0.48-3.27-2.33-6-2.33-6s2.32-2,2.57-3.52c0.48-3-3.55-5.29-3.55-5.29S140.83,160,140.48,156.23z M69.83,115.68c2.2,0.8,4.5,1.32,6.84,1.52c1.89,0.15,6.55,0.41,9.16,0.48c0.23,1.6,1.02,3.06,2.23,4.13c0.09,0.1,0.17,0.21,0.24,0.32c-3.67,0-12.48-0.14-17-0.82C62.93,120,69.83,115.68,69.83,115.68z M66.76,124.55c4.01,0.81,8.06,1.38,12.14,1.69c3.41,0.21,8.31,0.19,10.8,0.2c0.27,1.55,0.48,3.36,0.64,5.28c-4.92-0.12-15.92-0.54-20-1.15C59.33,128.91,66.76,124.55,66.76,124.55z M64.91,134.68c0,0,5.63,1,8.59,1.25c2.79,0.24,13.52,0.55,17.1,0.14c0.07,1.57,0.11,3.15,0.15,4.66h-0.42c-4.34,0.33-17.65,0.81-21.61,0.13C56.04,138.68,64.91,134.68,64.91,134.68L64.91,134.68z M64.61,144.18c0,0,4.72,1,7.63,1.3c6.2,0.29,12.41,0.03,18.56-0.79c0,1.31,0,2.5,0,3.51c-6.51,3.43-16.92,4.45-23.41,3.13C52.69,148.34,64.61,144.18,64.61,144.18L64.61,144.18z M58.49,172.87c0,0,1.39,0.31,2.61,0.67c1.64,0.42,3.31,0.73,5,0.91c2.49,0.21,4.99,0.09,7.44-0.38c2.23-0.38,3-0.79,5.36-1.07s1.3,1.27-0.93,3.18s-10.41,4.28-18,2.3C54.86,177.15,58.49,172.87,58.49,172.87L58.49,172.87z M58.01,185.64c-0.87-1,0-2.75,0-2.75c2.42,0.64,4.91,1.01,7.42,1.11c5.87,0,7.69-0.91,10.57-1.66s1.46,0.63,0.75,1.23c-1.28,1.09-4.66,4.07-11.86,4.27C62.59,187.88,58.93,186.75,58.01,185.64L58.01,185.64z M65.55,195.57c-2.56,0.79-4.25-0.59-4.06-1.53c0.12-0.57,0.31-1.11,0.59-1.62c2.18,0.67,4.47,0.89,6.73,0.63C70.7,192.73,68.17,194.76,65.55,195.57z M82.55,165.45c-2.43,2.9-10.46,6.19-19.88,4.32c-7.76-1.53-1.9-5.82-1.9-5.82c3.07,0.94,6.28,1.38,9.49,1.31c4.78-0.12,8.74-0.93,11.26-2.24s2.39,0.74,0.99,2.43L82.55,165.45z M82.61,157.95c-5.4,3.2-12.65,3.34-16,2.87c-11.46-1.62-6.51-6.18-6.51-6.18c2.99,0.8,6.02,1.4,9.09,1.82c3,0.32,10.48,0.23,13.77-0.86c1.37-0.45,0.95,1.55-0.39,2.4L82.61,157.95z M90.55,156.88c-1.25,0.59-4.05,0.59-2.7-1c0.98-1.08,2.04-2.09,3.18-3c0.09,1,0.22,2.17,0.41,3.4c-0.29,0.23-0.6,0.43-0.93,0.6H90.55zM104.64,121.81c1.2-1.07,1.99-2.53,2.23-4.13c2.6-0.07,7.26-0.33,9.15-0.48c2.34-0.2,4.64-0.71,6.84-1.52c0,0,6.9,4.36-1.44,5.63c-4.55,0.68-13.36,0.78-17,0.82c0.05-0.11,0.11-0.22,0.18-0.32L104.64,121.81z M103,126.44c2.48,0,7.38,0,10.8-0.2c4.07-0.31,8.13-0.88,12.13-1.69c0,0,7.41,4.36-3.58,6c-4.07,0.61-15.08,1-20,1.15c0.12-1.9,0.33-3.7,0.61-5.26H103z M102.09,136.07c3.58,0.42,14.32,0.1,17.1-0.14c3-0.25,8.6-1.25,8.6-1.25s8.86,4-3.82,6.19c-4,0.68-17.27,0.2-21.61-0.13h-0.41c-0.01-1.52,0.03-3.1,0.1-4.67H102.09z M101.89,144.69c6.15,0.82,12.37,1.08,18.57,0.79c2.91-0.27,7.62-1.3,7.62-1.3s11.93,4.16-2.79,7.15c-6.5,1.32-16.91,0.3-23.42-3.13c-0.03-1.01-0.03-2.2-0.02-3.51H101.89z M102.18,156.88c-0.31-0.15-0.61-0.34-0.88-0.55c0.18-1.23,0.31-2.4,0.41-3.4c1.14,0.91,2.2,1.92,3.18,3c1.3,1.54-1.5,1.54-2.75,0.95H102.18zM109.78,155.6c3.28,1.09,10.76,1.18,13.77,0.86c3.06-0.42,6.09-1.02,9.08-1.82c0,0,5,4.56-6.51,6.18c-3.35,0.47-10.59,0.33-16-2.87c-1.38-0.8-1.79-2.8-0.38-2.35H109.78z M110.19,165.45c-1.4-1.69-1.5-3.75,1-2.43s6.47,2.12,11.26,2.24c3.21,0.08,6.41-0.34,9.48-1.26c0,0,5.85,4.29-1.91,5.82c-9.41,1.82-17.45-1.47-19.87-4.37L110.19,165.45z M127.19,195.57c-2.61-0.81-5.14-2.84-3.25-2.52c2.26,0.26,4.55,0.04,6.72-0.63c0.28,0.51,0.48,1.05,0.6,1.62c0.07,0.96-1.59,2.32-4.16,1.53H127.19z M134.73,185.64c-0.91,1.11-4.57,2.24-6.88,2.18c-7.19-0.2-10.58-3.18-11.86-4.27c-0.71-0.6-2-2,0.76-1.23s4.58,1.68,10.47,1.68c2.49-0.09,4.96-0.46,7.37-1.09c0,0,0.93,1.68,0.05,2.73L134.73,185.64z M132.73,178.48c-7.62,2-15.71-0.3-18-2.3s-3.25-3.47-0.93-3.18s3.13,0.69,5.37,1.07c2.45,0.47,4.95,0.59,7.43,0.38c1.69-0.18,3.36-0.49,5-0.91c1.23-0.36,2.61-0.67,2.61-0.67s3.58,4.28-1.53,5.61L132.73,178.48z"
    />
  </svg>`;case"xp_all_in_one":return V` <svg
    id="xp_all_in_one"
    hidden
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 194 580"
    style="width:12.125rem; height:36.25rem;"
  >
    <defs>
      <style>
        .bone,
        .region {
          isolation: isolate;
        }
      </style>
    </defs>
    <g id="default">
      <g id="xp_lower_extremities" index="xp_lower_extremities" class="region">
        <path
          d="M58.2,398.8c2.2,8.7,3.8,15,3.8,19.2s-.4,9.4-.8,13.9c-.7,7.2-1.1,14.4-1.1,21.6,0,17.2,5.7,37.8,10.3,54.4,3.1,11.1,5.7,20.7,5.7,26,0,7.7-5,15-9,20.8-2.8,4.1-5.3,7.7-5.3,10.3,0,8.7,18.4,14,26.5,14a4,4,0,0,0,2.7-1.2c2.4-2.6,2-9,1.6-14.3-.1-1.6-.2-3.2-.2-4.4a113.7,113.7,0,0,1,.9-11.9c.4-4.2.9-8.5.9-11.7a93.2,93.2,0,0,0-1-10.5,113.7,113.7,0,0,1-1.5-16.5c0-.3,3.5-29,3.5-44.6a93.8,93.8,0,0,0-2.6-23,31.1,31.1,0,0,1-1.3-8c0-1,4.4-91.3,5.1-131.4H44.1C45.6,349.1,53.4,379.7,58.2,398.8Z"
        />
        <path
          d="M102.8,432.9a36.1,36.1,0,0,1-1.3,8,93.3,93.3,0,0,0-2.6,23c0,15.6,3.4,44.2,3.5,44.5a131.4,131.4,0,0,1-1.6,16.6c-.5,3.5-.8,7-1,10.5a113.1,113.1,0,0,0,1,11.7c.4,4.2.9,8.6.9,11.8a39.1,39.1,0,0,1-.3,4.5c-.3,5.2-.8,11.6,1.6,14.2a3.9,3.9,0,0,0,2.8,1.2c8.1,0,26.5-5.3,26.5-14,0-2.6-2.5-6.2-5.3-10.3-4-5.8-9-13.1-9-20.8,0-5.3,2.7-14.9,5.7-26,4.6-16.6,10.3-37.2,10.3-54.4,0-7.2-.4-14.4-1.1-21.6-.4-4.5-.8-8.8-.8-13.9s1.6-10.5,3.8-19.2A423.6,423.6,0,0,0,150,301.5H97.7C98.4,341.6,102.7,431.9,102.8,432.9Z"
        />
      </g>
      <path
        id="xp_pelvis"
        index="xp_pelvis"
        class="region"
        d="M96.5,292.3a.6.6,0,0,1,.5-.6.6.6,0,0,1,.6.6h0c0,2.4,0,5.1.1,8.2H150c.1-5,.2-10.3.2-15.7s-2.3-18.9-4.7-31.7c-1.1-6-2.3-12-3.2-17.9H115v46.4H79V235.2H51.9c-1,5.9-2.2,12-3.3,18-2.4,12.8-4.7,24.9-4.7,31.7s.1,10.6.2,15.6H96.4C96.5,297.4,96.5,294.7,96.5,292.3Z"
      />
      <g id="xp_abdomen" class="region">
        <path d="M53.8,201.4a88,88,0,0,1,.8,9.4c0,6.5-1.1,14.7-2.5,23.4H79V201.4Z" />
        <path d="M142.1,234.2a148.5,148.5,0,0,1-2.5-23.5,81,81,0,0,1,.7-9.3H115v32.8Z" />
      </g>
      <g id="xp_upper_extremities" index="xp_upper_extremities" class="region">
        <path
          d="M20.3,214.1v2.5c0,3.9-.4,8.2-.9,13.2s-1.3,13.5-1.3,21.6a15.3,15.3,0,0,0,.1,1.8c1.1,24.1-.4,38.3-4.3,42s-9.3,19-11.2,24.6a13.8,13.8,0,0,1-.7,2,2.6,2.6,0,0,0,.9,3.2,1.9,1.9,0,0,0,2.4-.7c2.7-3.2,7-11.7,7-11.8a1.1,1.1,0,0,1,.7-.3.7.7,0,0,1,.4.7c-.6,3-3.3,24.1,1.6,29.9a3.1,3.1,0,0,0,2.8,1.3c4.4-.1,13.4-2.8,15.9-7.8,1.6-3.5,1.6-12.3,1.1-17.1-.3-3-2.1-26-2.2-28.6s2.6-16.7,5-28.8c.2-1.3.4-2.2.5-2.6.8-4.2,1.7-8.6,2.7-12.8,1.6-7.5,3.2-14.6,3.2-18.1s.1-8,.3-12.3.2-6.1.2-7.5.2-7,.5-14.5c.6-12.7,1.4-30.2,1.4-36.1a.4.4,0,0,1,.1-.3l4.1-20.1H23.4C21,155.6,19.9,181.5,20.3,214.1Z"
        />
        <path
          d="M192,321.8a13.8,13.8,0,0,1-.7-2c-1.9-5.5-6.8-20.3-11.2-24.6s-5.4-17.9-4.3-42c0-.9.1-1.5.1-1.8-.1-7.2-.5-14.5-1.3-21.7-.5-5-.9-9.2-.9-13.1V214c.4-32.5-.7-58.4-3.1-76.5H143.5l4.1,19.9c.1.1.1.2.1.4,0,5.9.8,23.4,1.4,36.1.3,7.5.6,13.4.6,14.5s.1,4.2.2,7.5.3,9.1.3,12.3,1.5,10.6,3.2,18.1c.9,4.2,1.8,8.6,2.6,12.8l.6,2.6c2.4,12,5.1,26.2,5,28.8s-2,25.7-2.3,28.6c-.5,4.8-.5,13.6,1.2,17.1,2.4,5.1,11.4,7.8,15.8,7.8a3.3,3.3,0,0,0,2.9-1.3c4.8-5.8,2.1-26.9,1.6-29.9a.5.5,0,0,1,.2-.6c.3-.1.5,0,.7.3s4.3,8.5,7,11.7a1.7,1.7,0,0,0,2.4.7A2.5,2.5,0,0,0,192,321.8Z"
        />
      </g>
      <g id="xp_thorax" index="xp_thorax" class="region">
        <path d="M53.7,200.4H79V118.8H55.4l-7.9,38.9h0C47.7,159.2,51.9,184.6,53.7,200.4Z" />
        <path d="M140.4,200.4c1.8-15.8,6-41.3,6.2-42.7l-7.9-38.9H115v81.6Z" />
      </g>
      <g id="xp_shoulder_girdle" index="xp_shoulder_girdle" class="region">
        <path
          d="M54.6,117.8H79V92l-7.2,1.6c-10.4,2.2-26,5.6-36,12.8a28.6,28.6,0,0,0-4.1,3.6c-3.5,3.7-6.2,12.9-8.2,26.8H50.7l3.8-18.2Z"
        />
        <path
          d="M158.2,106.4c-10-7.3-25.6-10.6-36-12.8L115,91.9v25.9h24.5l.2.8,3.7,18.2h27.1c-1.9-13.9-4.7-23.1-8.2-26.8A28.6,28.6,0,0,0,158.2,106.4Z"
        />
      </g>
      <path
        id="xp_vertebral_column"
        index="xp_vertebral_column"
        class="region"
        d="M111.1,79.3H82.8c.6,4.7.8,9.8-.7,11.3A5.6,5.6,0,0,1,80,91.7V280.6h34V91.6a4,4,0,0,1-2.1-1C110.4,89.1,110.6,84,111.1,79.3Z"
      />
      <path
        id="xp_skull"
        index="xp_skull"
        class="region"
        d="M115.9,60.1c.4-2,.6-3.5.6-3.5a.4.4,0,0,1,.4-.4.7.7,0,0,1,.6.1.8.8,0,0,0,1.2.2h.1a5.8,5.8,0,0,0,1.9-2.5,27.8,27.8,0,0,0,2.1-5.7l.3-.9c.4-1.6.7-3.3,1-5a30.5,30.5,0,0,0,.2-5.2c-.2-1.3-.5-1.6-.6-1.7s-.2-.3-.1-.5.1-.6.2-1.5a42.2,42.2,0,0,0,.1-8.7,34.8,34.8,0,0,0-1.8-8.5,27.3,27.3,0,0,0-3-5.6,19.6,19.6,0,0,0-6.9-6.2c-4.2-2.3-9-3.4-15.2-3.4S86,2.2,81.8,4.5a21.9,21.9,0,0,0-7,6.2,27,27,0,0,0-2.9,5.6,31.5,31.5,0,0,0-1.8,8.5,42.2,42.2,0,0,0,.1,8.7c.1.9.2,1.5.2,1.5a.9.9,0,0,1-.1.5c-.1.1-.4.4-.6,1.7a22.7,22.7,0,0,0,.2,5.2c.3,1.7.6,3.4,1,5.1l.3.8A23,23,0,0,0,73.3,54a6.4,6.4,0,0,0,1.8,2.5,1.1,1.1,0,0,0,1.4-.1h0a.7.7,0,0,1,.6-.1.4.4,0,0,1,.4.4s.2,1.5.6,3.5a54.8,54.8,0,0,0,3.1,9.7c0,.1.9,4,1.5,8.5h28.6c.6-4.5,1.5-8.5,1.5-8.5A57.5,57.5,0,0,0,115.9,60.1Z"
      />
    </g>
    <g id="subselection">
      <path
        id="outline"
        class="outline"
        d="M105.8,580a4.8,4.8,0,0,1-3.6-1.5c-2.7-2.9-2.3-9.6-1.9-15,.1-1.7.2-3.2.2-4.5a112.3,112.3,0,0,0-.9-11.7c-.4-4.2-.9-8.6-.9-11.8a76.2,76.2,0,0,1,1.1-10.6,128.1,128.1,0,0,0,1.4-16.4c0-.2-3.5-28.9-3.5-44.6a101.6,101.6,0,0,1,2.7-23.3,33.4,33.4,0,0,0,1.2-7.7c0-.9-3.3-68.6-4.6-112.8-1.3,44.3-4.6,111.9-4.6,112.8a33.4,33.4,0,0,0,1.2,7.7,101.6,101.6,0,0,1,2.7,23.3c0,15.7-3.5,44.4-3.5,44.7a128.1,128.1,0,0,0,1.4,16.3,76.2,76.2,0,0,1,1.1,10.6c0,3.2-.5,7.6-.9,11.9a108.4,108.4,0,0,0-.9,11.7c0,1.2.1,2.7.2,4.4.4,5.4.8,12.1-1.9,15a4.8,4.8,0,0,1-3.6,1.5c-8,0-27.6-5.3-27.6-15.1,0-2.9,2.6-6.6,5.5-10.8,4-5.7,8.9-12.8,8.9-20.2,0-5.2-2.7-14.7-5.7-25.7C64.7,491.6,59,470.8,59,453.5c0-7.3.4-14.5,1.1-21.7.4-4.7.8-8.7.8-13.8s-1.6-10.3-3.8-18.9c-5.3-21.3-14.3-56.8-14.3-114.2,0-6.9,2.3-19.1,4.7-31.9,2.8-14.7,5.9-31.3,5.9-42.2,0-7.5-4.1-34.6-6-46.8-.3,8-.8,20.4-1.3,30-.3,7.5-.6,13.3-.6,14.5s-.1,4.2-.2,7.4-.2,9.2-.2,12.3-1.5,10.5-3.3,18.4c-.9,4.2-1.9,8.6-2.6,12.8l-.6,2.6c-1.4,7-5.1,25.7-5,28.5s2,25.7,2.3,28.5c.5,5.1.4,14-1.3,17.7-2.7,5.8-12.4,8.4-16.8,8.5a4.6,4.6,0,0,1-3.7-1.8c-4.3-5-3.2-20.3-2.3-27.5A65.4,65.4,0,0,1,6.2,325a3,3,0,0,1-3.9,1A3.6,3.6,0,0,1,1,321.4l.7-1.9c1.8-5.6,6.8-20.6,11.4-25,2.6-2.5,5.3-11.6,4-41.2,0-.9-.1-1.6-.1-1.8a197.8,197.8,0,0,1,1.4-21.8c.4-5,.8-9.3.8-13v-2.6c-.5-41.6,1.1-93.5,11.7-104.8a29.3,29.3,0,0,1,4.2-3.7c10.2-7.4,26-10.8,36.4-13,4.9-1,9-2,9.9-2.7s-.3-15.8-1.2-19.6a58.2,58.2,0,0,1-3.2-10l-.5-2.6a2.1,2.1,0,0,1-2-.3,6.7,6.7,0,0,1-2.2-2.8,25.4,25.4,0,0,1-2.2-6l-.3-.9c-.4-1.7-.7-3.4-1-5.2a24.4,24.4,0,0,1-.2-5.4,4.8,4.8,0,0,1,.7-2.1,11.5,11.5,0,0,0-.2-1.4,44,44,0,0,1-.1-8.9A32.2,32.2,0,0,1,70.9,16,25.5,25.5,0,0,1,74,10.1a21.7,21.7,0,0,1,7.3-6.5C85.6,1.1,90.6,0,97,0s11.4,1.1,15.8,3.6A23.3,23.3,0,0,1,123.1,16a32.2,32.2,0,0,1,1.9,8.7,45.1,45.1,0,0,1-.1,9,10.5,10.5,0,0,0-.2,1.3,5.2,5.2,0,0,1,.7,2.1,20.4,20.4,0,0,1-.3,5.5,31.8,31.8,0,0,1-1,5.2l-.2.9a26.3,26.3,0,0,1-2.2,5.9,7.6,7.6,0,0,1-2.2,2.8,1.8,1.8,0,0,1-2,.3c-.1.7-.3,1.6-.5,2.7a61.2,61.2,0,0,1-3.2,10c-.9,3.6-3.3,17.4-1.2,19.5s5,1.7,9.9,2.7c10.4,2.3,26.2,5.6,36.4,13a30,30,0,0,1,4.2,3.7c10.6,11.3,12.2,63.3,11.7,104.9v2.5c0,3.8.4,8.1.9,13,.6,6.4,1.3,13.6,1.3,21.8a15.3,15.3,0,0,1-.1,1.8c-1.3,29.7,1.4,38.8,4,41.2,4.6,4.5,9.6,19.4,11.4,25,.3.9.6,1.6.7,2a3.6,3.6,0,0,1-1.3,4.5,3.1,3.1,0,0,1-3.9-1,76.5,76.5,0,0,1-5.6-9.1c.9,7.2,2,22.5-2.3,27.5a4.3,4.3,0,0,1-3.6,1.8h-.1c-4.4-.1-14.1-2.7-16.8-8.5-1.7-3.7-1.8-12.6-1.3-17.7.3-2.8,2.1-26,2.3-28.5s-3.6-21.5-5-28.5a17.4,17.4,0,0,1-.5-2.6c-.8-4.2-1.8-8.6-2.7-12.8-1.8-7.9-3.3-14.7-3.3-18.4s-.1-8-.2-12.3-.2-6-.2-7.4-.3-7-.6-14.5c-.4-9.6-1-22-1.2-30-2,12.2-6.1,39.3-6.1,46.8,0,10.9,3.1,27.5,5.9,42.2,2.4,12.8,4.7,25,4.7,31.9,0,57.4-9,92.9-14.3,114.2-2.2,8.6-3.8,14.8-3.8,18.9s.4,9.1.8,13.8c.7,7.2,1.1,14.4,1.1,21.7,0,17.3-5.7,38.1-10.3,54.7-3,11-5.7,20.5-5.7,25.7,0,7.4,4.9,14.5,8.9,20.2,3,4.2,5.5,7.9,5.5,10.8C133.4,574.7,113.8,580,105.8,580ZM97,291.7a.6.6,0,0,1,.6.6h0c0,33,5.1,139.5,5.1,140.5a36,36,0,0,1-1.2,8,99.7,99.7,0,0,0-2.7,23c0,15.7,3.5,44.3,3.5,44.6a116.4,116.4,0,0,1-1.5,16.6c-.5,3.5-.8,7-1,10.5a113.1,113.1,0,0,0,1,11.7c.4,4.2.9,8.6.9,11.8a39.1,39.1,0,0,1-.3,4.5c-.3,5.2-.8,11.6,1.6,14.2a3.9,3.9,0,0,0,2.8,1.2c8.1,0,26.5-5.3,26.5-14,0-2.6-2.5-6.2-5.3-10.3-4-5.8-9-13.1-9-20.8,0-5.3,2.6-14.9,5.7-26,4.6-16.6,10.3-37.2,10.3-54.4,0-7.2-.4-14.4-1.1-21.6-.4-4.5-.8-8.8-.8-13.9s1.6-10.5,3.8-19.2c5.4-21.2,14.3-56.7,14.3-113.9,0-6.8-2.3-18.9-4.7-31.7-2.9-15.5-5.9-31.4-5.9-42.4s6.7-51.3,7-53a.6.6,0,0,1,.6-.5.5.5,0,0,1,.5.6c0,5.9.8,23.4,1.4,36.1.3,7.5.6,13.4.6,14.5s.1,4.2.2,7.5.3,9.1.3,12.3,1.5,10.6,3.2,18.1c.9,4.2,1.8,8.6,2.6,12.8l.6,2.6c2.4,12,5.1,26.2,5,28.8s-2,25.7-2.3,28.6c-.5,4.8-.5,13.6,1.2,17.1,2.4,5.1,11.4,7.8,15.8,7.8a3.3,3.3,0,0,0,2.9-1.3c4.8-5.8,2.1-26.9,1.6-29.9a.5.5,0,0,1,.3-.7.8.8,0,0,1,.7.3c0,.1,4.3,8.6,7,11.8a1.9,1.9,0,0,0,2.4.7,2.5,2.5,0,0,0,.9-3.1,20.5,20.5,0,0,1-.7-2c-1.9-5.6-6.8-20.4-11.2-24.6s-5.4-17.9-4.3-42.1c0-.9.1-1.5.1-1.7-.1-7.3-.5-14.5-1.3-21.7-.5-5-.9-9.3-.9-13.1V214c.7-58.5-3.3-95.5-11.4-104.1a23,23,0,0,0-4.1-3.5c-10-7.3-25.6-10.6-36-12.9-6.1-1.3-9.3-2-10.3-3-3-3,.8-20.6.9-20.8A52.3,52.3,0,0,0,116,60c.4-2,.6-3.4.6-3.4a.7.7,0,0,1,.4-.5.7.7,0,0,1,.6.2.9.9,0,0,0,1.3.2.1.1,0,0,1,.1-.1,6.1,6.1,0,0,0,1.8-2.4,27.8,27.8,0,0,0,2.1-5.7l.3-.9c.4-1.7.7-3.4,1-5.1a29.8,29.8,0,0,0,.2-5.2,3.3,3.3,0,0,0-.6-1.7.6.6,0,0,1-.1-.4l.2-1.6a42.1,42.1,0,0,0,.1-8.7,30,30,0,0,0-1.8-8.4,25.9,25.9,0,0,0-3-5.7,20.3,20.3,0,0,0-6.9-6.1C108,2.2,103.2,1.1,97,1.1S86,2.2,81.8,4.5a21.9,21.9,0,0,0-7,6.2,27,27,0,0,0-2.9,5.6,31.5,31.5,0,0,0-1.8,8.5,42.2,42.2,0,0,0,.1,8.7c.1.9.2,1.5.2,1.5a.9.9,0,0,1-.1.5c-.1.1-.4.4-.6,1.7a22.7,22.7,0,0,0,.2,5.2c.3,1.7.6,3.4,1,5.1l.3.8A23,23,0,0,0,73.3,54a6.4,6.4,0,0,0,1.8,2.5,1.1,1.1,0,0,0,1.4-.1h0a.7.7,0,0,1,.6-.1.4.4,0,0,1,.4.4s.2,1.5.6,3.5a54.8,54.8,0,0,0,3.1,9.7c.1.1,3.9,17.9.9,20.8-1,1-4.2,1.7-10.4,3-10.3,2.2-26,5.6-36,12.8a34.2,34.2,0,0,0-4,3.6c-8,8.6-12.1,45.6-11.4,104.1v2.5c0,3.9-.4,8.2-.9,13.2s-1.3,13.5-1.3,21.6a15.3,15.3,0,0,0,.1,1.8c1.1,24.1-.4,38.3-4.3,42s-9.3,19-11.2,24.6a13.8,13.8,0,0,1-.7,2,2.6,2.6,0,0,0,.9,3.2,2,2,0,0,0,2.5-.7c2.6-3.2,6.9-11.7,7-11.8a.7.7,0,0,1,.6-.3.7.7,0,0,1,.4.7c-.6,3-3.3,24.1,1.6,29.9a3.1,3.1,0,0,0,2.8,1.3c4.4,0,13.4-2.7,15.9-7.8,1.6-3.5,1.6-12.3,1.1-17.1-.3-3-2.1-26-2.2-28.6s2.6-16.7,5-28.8c.2-1.3.4-2.2.5-2.6.8-4.2,1.7-8.6,2.7-12.8,1.6-7.5,3.2-14.6,3.2-18.1s.1-8,.3-12.4.1-6,.1-7.4.3-7,.6-14.5c.6-12.7,1.4-30.2,1.4-36.1a.6.6,0,1,1,1.1-.1c.3,1.8,7.1,43.2,7.1,53s-3,27-6,42.4c-2.4,12.8-4.7,24.9-4.7,31.7,0,57.2,9,92.7,14.3,113.9,2.2,8.7,3.8,15,3.8,19.2s-.4,9.4-.8,13.9c-.7,7.2-1.1,14.4-1.1,21.6,0,17.2,5.7,37.9,10.3,54.4,3.1,11.1,5.7,20.7,5.7,26,0,7.7-5,15-9,20.8-2.8,4.1-5.3,7.7-5.3,10.3,0,8.7,18.4,14,26.5,14a4,4,0,0,0,2.7-1.2c2.4-2.6,2-9,1.6-14.3-.1-1.6-.2-3.2-.2-4.4a113.7,113.7,0,0,1,.9-11.9c.4-4.2.9-8.5.9-11.7a93.2,93.2,0,0,0-1-10.5,113.7,113.7,0,0,1-1.5-16.5c0-.3,3.5-29,3.5-44.6a93.8,93.8,0,0,0-2.6-23,31.1,31.1,0,0,1-1.3-8c0-1.1,5.2-107.6,5.2-140.6A.6.6,0,0,1,97,291.7Z"
      />

      <g id="xp_clavicula_default" class="bone" disabled>
        <path
          d="M83.2,111.9c1.8,2,6,.4,6.7-2.1s-.2-2.5-1.9-3.2c-15-6-22.8-5.6-35.4-3.5-4.1.7-5.9,1.4-6.1,2.1s.8.9,1.3,2-.2,1.8.2,2.3,4.1-.9,7.7-1.4C64.5,106.9,79,107.2,83.2,111.9Z"
        />
        <path
          d="M110.8,111.9c-1.8,2-6,.4-6.7-2.1s.2-2.5,1.9-3.2c15-6,22.8-5.6,35.4-3.5,4.1.7,5.9,1.4,6.1,2.1s-.8.9-1.3,2,.2,1.8-.2,2.3-4.1-.9-7.7-1.4C129.5,106.9,115,107.2,110.8,111.9Z"
        />
      </g>
      <g id="xp_skull_bone" class="bone" disabled>
        <path
          d="M114.7,54.6c0-.4-.3-.3-.6-.3-1.9,0-4.6.1-4.7.8s-.2.8-.4,1.2-.8,5.2-2,6.5-3.2,3.5-10,3.5h0c-6.7,0-10-3.5-10-3.5s-1.6-4.9-2-6.5l-.3-1.2c-.2-.7-2.8-.8-4.7-.8-.3,0-.5,0-.6.3s-.6,4.2.9,5S81,68.5,83.8,70s4.6,8.2,13.3,8.3h0c8.6,0,9.1-6.2,13.2-8.3s2.1-9.6,3.5-10.4S114.7,54.8,114.7,54.6Z"
        />
        <path
          d="M115.7,13.6A22.6,22.6,0,0,0,97,3.7h0a23,23,0,0,0-18.7,9.9C74.8,18.4,73.8,26.4,74,31s2.9,21.8,5.4,22.2,5.7.1,6.2,1.6,1.1,4.6,2.1,5.6S93.2,63,97,63h0c3.8,0,8-1.2,9.3-2.6s2-5.3,2.1-5.6,4.4-1.3,6.2-1.6S119.8,36.7,120,31,119.2,18.4,115.7,13.6Zm-31,32.3c-2.3-.2-3.2-1.9-3.2-7.1s2.8-4.5,7.5-5.4c1-.2,3.1-.8,4.2,1.2s.6,4.6-.4,6.5S87.1,46,84.7,45.9Zm13.1,8.2-.8-.2h0l-.7.2c-3.8,1.7-3.4-1.8-2.8-5.1s1.3-5,2-5.8,1,0,1.5,0h0c.5,0,.9-.7,1.5,0s1.5,3,2,5.8S101.6,55.8,97.8,54.1Zm11.5-8.2c-2.3.1-7-2.8-8-4.8s-1.3-4.8-.4-6.5,3.3-1.4,4.2-1.2c4.6.9,7.4,1.3,7.4,5.4S111.6,45.7,109.3,45.9Z"
        />
      </g>
      <g id="xp_skull_selection" hidden>
        <path
          id="xp_skull_2"
          index="xp_skull_2"
          class="region"
          d="M75.2,56.5a1,1,0,0,0,1.3,0h.1c.1-.2.4-.2.6-.2s.4.2.4.5.2,1.5.6,3.4a54.5,54.5,0,0,0,3,9.7c0,.1,1,4,1.6,8.4h28.4c.6-4.5,1.6-8.4,1.6-8.5a47.3,47.3,0,0,0,3-9.7c.4-2,.6-3.4.6-3.5a.7.7,0,0,1,.4-.5c.2-.1.4,0,.6.2a1.1,1.1,0,0,0,1.4.2h0a3.9,3.9,0,0,0,1.6-2H73.6A3.6,3.6,0,0,0,75.2,56.5Z"
        />
        <path
          id="xp_skull_1"
          index="xp_skull_1"
          class="region"
          d="M69.8,37.2a30.1,30.1,0,0,0,.1,5.2,45.9,45.9,0,0,0,1,5.1l.2.9a23,23,0,0,0,1.8,5H121a23,23,0,0,0,1.8-5l.2-.9a45.9,45.9,0,0,0,1-5.1,18.2,18.2,0,0,0,.2-5.2c-.2-1.3-.4-1.6-.6-1.7a.8.8,0,0,1-.2-.5l.2-1.5a36.2,36.2,0,0,0,.1-8.7,31.5,31.5,0,0,0-1.8-8.5,22.9,22.9,0,0,0-2.9-5.6,22.8,22.8,0,0,0-6.9-6.2c-4.2-2.3-9-3.4-15.2-3.4S86.1,2.2,81.8,4.5a21.8,21.8,0,0,0-7,6.2,42.5,42.5,0,0,0-2.9,5.6,30.7,30.7,0,0,0-1.8,8.5,42.2,42.2,0,0,0,.1,8.7c.1.9.2,1.5.2,1.5s0,.3-.1.4A2.6,2.6,0,0,0,69.8,37.2Z"
        />
      </g>
      <g id="xp_upper_extremities_bone" class="bone" disabled>
        <path
          d="M6.1,316.2c-.2-.3-.3.2-.3.4a5.9,5.9,0,0,0-.2,1.4,2.8,2.8,0,0,1-.4,1.2,1.7,1.7,0,0,0-.5,1.2c0,.4.3.7.7.4a2,2,0,0,0,.6-.9l.6-1.2a4.7,4.7,0,0,1,.9-.6c.4-.3.7-.6.4-.7A3.6,3.6,0,0,1,6.1,316.2Z"
        />
        <path
          d="M22.9,317.4a.7.7,0,0,0,.4-.5,3.3,3.3,0,0,0,0-1.7,14,14,0,0,1,.4-8.1l.5-1.7a1.5,1.5,0,0,0,0-1.3c-.4-.8-1.1-.7-1.7-.5l-.8.6a3.2,3.2,0,0,0-.4,2.7,8.7,8.7,0,0,1-.1,3.6,34,34,0,0,1-.7,3.4c-.3.9-1,2.1-.5,3h0A2.8,2.8,0,0,0,22.9,317.4Z"
        />
        <path
          d="M16.3,300a10.5,10.5,0,0,0-.8-1.1c-.5-.6-.9-1.1-1.4-.3a16.2,16.2,0,0,0-1.1,2.8,12,12,0,0,1-1.6,2.7c-.6.6-1.4,1-1.8,1.8a1.3,1.3,0,0,0-.1.6c-.1,0-.1.1,0,.2a2.9,2.9,0,0,0,1.6,1.5,2.2,2.2,0,0,0,2.2,0,.3.3,0,0,0,.1-.2,3.8,3.8,0,0,0,.1-1.5,12.4,12.4,0,0,1,.4-1.6,7.1,7.1,0,0,1,1.8-2.7c.4-.4,1.5-.5,1.4-1.2A2,2,0,0,0,16.3,300Z"
        />
        <path
          d="M10.2,308.8c-.7-.3-.8-.8-1.2-1.1s-.5.4-.6.7a21.3,21.3,0,0,1-1,4.9c-.2.5-1.4,1.4-1.3,1.8a4.4,4.4,0,0,0,2.5,1.7c.3-.1.2-.7.2-.9a5.8,5.8,0,0,1,.5-2.6,8,8,0,0,1,1.5-2.1c.5-.4,1.3-.7,1.4-1.6S11.1,309.2,10.2,308.8Z"
        />
        <path
          d="M19.7,301.5c-1.2-.2-2.2-.1-2.5,1a7.6,7.6,0,0,0,.1,1.5,13.1,13.1,0,0,1-.5,3.9c-.3,1.3-.3,2.7-.7,4s-1.4,2.3-1.9,3.5a1.7,1.7,0,0,0-.1,1.2.8.8,0,0,0,.7.5,8.5,8.5,0,0,0,2.3.3,1.1,1.1,0,0,0,.7-.3,3,3,0,0,0,.4-1,13.4,13.4,0,0,0-.1-2,10.4,10.4,0,0,1,0-2.5,12,12,0,0,1,1.4-5c.3-.7.7-1.3,1-1.9a3.7,3.7,0,0,0,.8-1.5C21.5,302,20.6,301.7,19.7,301.5Z"
        />
        <path
          d="M28.8,316a1.1,1.1,0,0,0,.3-1.1,5.4,5.4,0,0,0-.7-1.3,8.5,8.5,0,0,1-.4-3.2c-.1-.8-.3-2.6-.3-3.4s.5-2.4.2-3.4-2-1-2.7-.5-.2,1.7.1,2.5a5,5,0,0,1,.3,1.6,15.2,15.2,0,0,1,.1,6,4.3,4.3,0,0,0,0,1.6,1.6,1.6,0,0,0,.8,1.2,4.1,4.1,0,0,0,1.6.3A1.1,1.1,0,0,0,28.8,316Z"
        />
        <path
          d="M33.9,321.6a4.5,4.5,0,0,1-2.3.3.5.5,0,0,1-.3-.5c.1-.5.4-1,.5-1.4a4.6,4.6,0,0,0-.5-2l-.9-1.8c-.1-.4-.1-.8.1-.8l1.4.4h0l1.3-.4c.1,0,.1.6,0,.8a4.9,4.9,0,0,0-.1,1.2,7.7,7.7,0,0,0,.2,1.5l.3.9C33.9,320.4,34.4,321.4,33.9,321.6Z"
        />
        <path
          d="M34,326.6c.4-.2,0-.8-.1-1.1a1.6,1.6,0,0,1-.5-1.1c0-.5.3-.9.2-1.3s-.6-.5-.9-.4-1.2-.2-1.4,0,.2.9.4,1.1a3.1,3.1,0,0,1,.3,1.3,2.4,2.4,0,0,0,0,1.2v.2A2,2,0,0,0,34,326.6Z"
        />
        <path
          d="M29,326.2a.5.5,0,0,0,.3-.5,5.8,5.8,0,0,0-.6-1.7,16.5,16.5,0,0,1-.4-3.1,26.8,26.8,0,0,1,.7-2.7c.1-.9-.4-1-1.2-1H27c-.6,0-1.5-.2-1.7.6s.3,2,.7,2.7a5.4,5.4,0,0,1,.5,2.8,11,11,0,0,0-.6,2.6c0,.2.1.3.3.4A5.3,5.3,0,0,0,29,326.2Z"
        />
        <path
          d="M28.6,327.5l-.9.2h-.1l-1.3-.2h-.2c-.7.5-.2,1.1.2,1.8a5.2,5.2,0,0,1,.3,2.5,5.5,5.5,0,0,0-.2,2.2c.2.6,1.1.5,1.5.6s1.2.3,1.2-.4-.5-1.4-.5-2.1-.2-1.3-.2-2,.5-1.1.5-1.8S28.8,327.5,28.6,327.5Z"
        />
        <path
          d="M16.6,327.3a1.5,1.5,0,0,0,.4-.9c.2-.9-.4-1.8-.5-2.7a3.9,3.9,0,0,1,.3-2.4c.4-.7,1.3-1.5.9-2.3a1.1,1.1,0,0,0-1.4-.7c-1.4.2-2.3-.5-2.4.5a13.5,13.5,0,0,0,.4,2.8,5.7,5.7,0,0,1,.2,2.6,4,4,0,0,1-.3,1.5c-.1.4-.4.8-.3,1.2s.1.2.1.3A2.7,2.7,0,0,0,16.6,327.3Z"
        />
        <path
          d="M16.3,335.2a3.1,3.1,0,0,1-1.3.3c-.2.1-.4,0-.5,0l-.4-.2H14c-.4.6.6,1.2.6,1.9s-.1,1.9.8,1.9a1.1,1.1,0,0,0,.8-.7,1.6,1.6,0,0,0-.2-1.2c-.2-.3-.4-.6-.2-.9a3.6,3.6,0,0,0,.7-1C16.5,335.1,16.3,335.2,16.3,335.2Z"
        />
        <path
          d="M14.7,334.8a2.7,2.7,0,0,0,1.7-.6,5.2,5.2,0,0,0-.2-1.1,3.1,3.1,0,0,1-.3-1.9c.2-.8,1.6-2.8.6-3l-2,.3c-.6,0-.8.4-.7,1s.5.9.6,1.6a5.8,5.8,0,0,1-.2,1.9v1.3h0A1,1,0,0,0,14.7,334.8Z"
        />
        <path
          d="M20.8,335.7h2a.2.2,0,0,0,.2-.2c.3-.5-.1-1.5-.1-2.1a7.6,7.6,0,0,1-.3-2.1c0-.7.4-1.1.5-1.7s0-.9-.7-.8l-1,.2c-.4,0-.7-.2-1-.1s-.6,1-.3,1.5,1,1.2.9,2.1a5.9,5.9,0,0,1-.5,2.3S19.9,335.6,20.8,335.7Z"
        />
        <path
          d="M42,217.7c.7-3.5-3.7-6.7-4.1-11.6s2.2-67.7,4.4-71.8a12.1,12.1,0,0,1,2.9-3.5,9.6,9.6,0,0,0,3.3-10.3c-1.2-4.3-4.2-6-7.6-6a4.2,4.2,0,0,0-3.9,2.6c-1.2-.3-3.5-.2-3.8,2a59.5,59.5,0,0,0,.2,14c.6,4.8-1.3,42.9-1.7,53.2s-1.5,17.1-4.1,20.7-5.8,4.7-5.6,8.1,3.6,6.3,6.3,5.2,2-1.2,2.6-1.3.6-.6,1.3.1a7.8,7.8,0,0,0,2.4,1.6C37,221.5,41.2,222.2,42,217.7Z"
        />
        <path
          d="M22.8,337.7c.2-.4.6-.8.2-1.2s-.7,0-1.1,0h-.3c-.3,0-1,0-1.1.5s.4.7.6,1a2.8,2.8,0,0,1,.4,1.3,2.2,2.2,0,0,0,.2,1.4.9.9,0,0,0,1,.6,1.2,1.2,0,0,0,.7-1C23.3,339.4,22.5,338.6,22.8,337.7Z"
        />
        <path
          d="M28.8,336.6a1.1,1.1,0,0,0,.2-.8c-.1-.4-.6-.4-1-.2h-.4c-.3,0-.8,0-1,.4s.4.7.5.9a2,2,0,0,1,.4,1.3c0,.4-.1.9.1,1.2s.5.7.9.6a1.1,1.1,0,0,0,.7-1C29.2,338.2,28.5,337.4,28.8,336.6Z"
        />
        <path
          d="M34.3,327.4c-.3-.1-.7.3-1,.2l-.4-.2c-.3,0-.8-.2-.9.1s.3.6.4.9a3.6,3.6,0,0,1,.2,1.1,3.4,3.4,0,0,0,0,1c.2.4.4.6.8.6a.8.8,0,0,0,.7-.8c0-.6-.6-1.4-.2-2S34.7,327.5,34.3,327.4Z"
        />
        <path
          d="M23.4,319.9c.1-.8-.4-1.2-1.2-1.4a1.7,1.7,0,0,0-1.8.2c-.7.4-.3,1.2-.2,1.8a7.8,7.8,0,0,1,.4,2.6c-.1.9-.1,1.8-.2,2.7a1.7,1.7,0,0,1-.1.7c0,.7-.1,1.4.7,1.5a2.3,2.3,0,0,0,2.1-.7c.4-.7-.1-1.3-.2-2a8.2,8.2,0,0,1-.1-2.7C22.9,321.6,23.3,320.8,23.4,319.9Z"
        />
        <path
          d="M33.1,314.5c.6-.9.1-2-.4-2.8a8,8,0,0,1-.9-3,19.5,19.5,0,0,1-.3-3.4c0-.6.1-1,.1-1.6a2.4,2.4,0,0,0,0-1.2c-.5-.8-1.9-.6-2.5-.3s-.5,1.4,0,2.3a15.2,15.2,0,0,1,1.1,7,3.5,3.5,0,0,0,.3,3,1.6,1.6,0,0,0,2.4.1Z"
        />
        <path
          d="M32.9,223.5a4.1,4.1,0,0,0,3.6.4c1.1-.5,1.9-.8,1.9.5s-1.4,2.2-2,8.8-1.5,20.2-1.3,25.2-1.5,15.9-2.2,20.7-1.3,5.7-1.2,7.8a14.2,14.2,0,0,1-.4,4.5.8.8,0,0,1-.9.4l-1.1-.3c-1.3-.7-2.4-2-1.6-5.5,1.1-5.6,1.9-11.3,2.5-17.1.3-4-.4-16.9-.7-21.1l-.7-13.4c-.6,3.5-1.9,10.4-3.2,17.4s0,32.4,1,37.3a5.9,5.9,0,0,1,.2,1.4.6.6,0,0,1-.6.5h0a10.4,10.4,0,0,0-2.5,0,18.6,18.6,0,0,0-4.2,1.2,1.1,1.1,0,0,1-1.4-.6v-.2a23.4,23.4,0,0,1,.3-3.8c.3-2.8,1.7-8.6,1.9-15.3s.2-19.8,2.7-30.7c2-8.7,2.5-13.8,1-15.9s-1.1-3.3,1.3-2.8a3.7,3.7,0,0,0,2.9,0,5.5,5.5,0,0,1,2.5-.7A7.7,7.7,0,0,1,32.9,223.5Z"
        />
        <path
          d="M31.4,295.4a2,2,0,0,0-.8-1.2,17.4,17.4,0,0,0-6-.8,11.9,11.9,0,0,0-3.6.9l-1,.6a13.8,13.8,0,0,1-2.4,1.4,1.8,1.8,0,0,0-1.2,1.2v.4h0a10.7,10.7,0,0,0,1.5,2.2h1.2a4.2,4.2,0,0,1,2.7.6l.3.3a2.5,2.5,0,0,0,2.1.8,7.9,7.9,0,0,0,2.2-.6,8.1,8.1,0,0,1,2.2-.7c1-.1,1.4.1,2.4,0s.5-4.5.5-4.5S31.4,295.7,31.4,295.4Z"
        />
        <path
          d="M187.9,316.2c.3-.3.3.2.4.4s.1.9.1,1.4a2.1,2.1,0,0,0,.5,1.2,1.6,1.6,0,0,1,.4,1.2c0,.4-.3.7-.6.4a1.6,1.6,0,0,1-.7-.9l-.6-1.2c-.2-.3-.6-.4-.9-.6s-.6-.6-.4-.7A3.6,3.6,0,0,0,187.9,316.2Z"
        />
        <path
          d="M171.1,317.4a.7.7,0,0,1-.4-.5,3.2,3.2,0,0,1,.1-1.7,14,14,0,0,0-.5-8.1l-.5-1.7a1.5,1.5,0,0,1,0-1.3c.4-.8,1.1-.7,1.8-.5l.7.6a2.9,2.9,0,0,1,.4,2.7,8.7,8.7,0,0,0,.1,3.6,34,34,0,0,0,.7,3.4c.3.9,1,2.1.6,3h0A3,3,0,0,1,171.1,317.4Z"
        />
        <path
          d="M177.7,300a10.5,10.5,0,0,1,.8-1.1c.5-.6.9-1.1,1.5-.3s.7,1.9,1.1,2.9a10.1,10.1,0,0,0,1.6,2.6c.5.7,1.4,1,1.7,1.9a.8.8,0,0,1,.2.5v.2a4.4,4.4,0,0,1-1.7,1.6,2.6,2.6,0,0,1-2.1,0l-.2-.3a6.1,6.1,0,0,1-.1-1.4,4.2,4.2,0,0,0-.4-1.6,6.2,6.2,0,0,0-1.7-2.8c-.4-.3-1.6-.5-1.5-1.2S177.5,300.2,177.7,300Z"
        />
        <path
          d="M183.8,308.8c.7-.3.8-.8,1.2-1.1s.5.4.6.7a21.3,21.3,0,0,0,1,4.9c.2.5,1.4,1.4,1.3,1.8a4.4,4.4,0,0,1-2.5,1.7c-.3-.1-.2-.7-.2-.9a4.7,4.7,0,0,0-.5-2.6,8,8,0,0,0-1.5-2.1c-.5-.4-1.3-.7-1.4-1.6S182.9,309.2,183.8,308.8Z"
        />
        <path
          d="M174.3,301.5c1.3-.2,2.3-.1,2.5,1V304a10.4,10.4,0,0,0,.4,3.9c.3,1.3.3,2.7.7,4s1.4,2.3,1.9,3.5a1.7,1.7,0,0,1,.1,1.2.8.8,0,0,1-.7.5,8.5,8.5,0,0,1-2.3.3,1.1,1.1,0,0,1-.7-.3,1.7,1.7,0,0,1-.3-1,6.7,6.7,0,0,1,0-2,10.4,10.4,0,0,0,0-2.5,12,12,0,0,0-1.4-5c-.3-.7-.7-1.3-1-1.9a3.7,3.7,0,0,1-.8-1.5C172.5,302,173.4,301.7,174.3,301.5Z"
        />
        <path
          d="M165.2,316a1.1,1.1,0,0,1-.3-1.1,8.3,8.3,0,0,1,.7-1.3,11.3,11.3,0,0,0,.5-3.2c0-.8.2-2.6.2-3.4s-.5-2.4-.2-3.4,2-1,2.8-.5.1,1.7-.2,2.5a11,11,0,0,0-.3,1.6,15.2,15.2,0,0,0-.1,6,4.3,4.3,0,0,1,0,1.6,1.4,1.4,0,0,1-.8,1.2,4,4,0,0,1-1.5.3A1.1,1.1,0,0,1,165.2,316Z"
        />
        <path
          d="M160.1,321.6a4.5,4.5,0,0,0,2.3.3.5.5,0,0,0,.3-.5c-.1-.5-.4-1-.5-1.4a4.6,4.6,0,0,1,.5-2l.9-1.8c.1-.4.2-.8-.1-.8l-1.4.4h0a4.2,4.2,0,0,1-1.2-.4c-.2,0-.2.6-.1.8a4.9,4.9,0,0,1,.1,1.2,7.7,7.7,0,0,1-.2,1.5,3.2,3.2,0,0,1-.3.9C160.1,320.4,159.6,321.4,160.1,321.6Z"
        />
        <path
          d="M160,326.6c-.4-.2-.1-.8.1-1.1a1.6,1.6,0,0,0,.5-1.1c0-.5-.3-.9-.2-1.3s.5-.5.9-.4,1.1-.2,1.4,0-.2.9-.4,1.1a6.1,6.1,0,0,0-.3,1.3,2.4,2.4,0,0,1,0,1.2v.2A2,2,0,0,1,160,326.6Z"
        />
        <path
          d="M165,326.2a.5.5,0,0,1-.3-.5,5.8,5.8,0,0,1,.6-1.7,10.9,10.9,0,0,0,.3-3.1,13.1,13.1,0,0,0-.6-2.7c-.2-.9.4-1,1.2-1h.8c.6,0,1.5-.2,1.7.6s-.3,2-.7,2.7a4.5,4.5,0,0,0-.5,2.8,11,11,0,0,1,.6,2.6c0,.2-.1.3-.3.4A5.3,5.3,0,0,1,165,326.2Z"
        />
        <path
          d="M165.4,327.5l.9.2h.1l1.3-.2h.2c.7.5.2,1.1-.2,1.8a5.2,5.2,0,0,0-.3,2.5,5.5,5.5,0,0,1,.2,2.2c-.2.6-1.1.5-1.5.6s-1.2.3-1.2-.4.5-1.4.5-2.1.2-1.3.2-2-.5-1.1-.5-1.8S165.2,327.5,165.4,327.5Z"
        />
        <path
          d="M177.4,327.3a2.5,2.5,0,0,1-.4-.9c-.2-.9.4-1.8.6-2.7a4.9,4.9,0,0,0-.4-2.4c-.4-.7-1.3-1.5-.9-2.3a1.1,1.1,0,0,1,1.4-.7c1.5.2,2.4-.5,2.4.5a9,9,0,0,1-.4,2.8,7.4,7.4,0,0,0-.2,2.6,8,8,0,0,0,.3,1.5c.1.4.4.8.3,1.2a.4.4,0,0,1-.1.3A2.7,2.7,0,0,1,177.4,327.3Z"
        />
        <path
          d="M177.8,335.2a2.4,2.4,0,0,0,1.2.3c.2.1.4,0,.5,0l.4-.2h.1c.4.6-.6,1.2-.6,1.9s.1,1.9-.8,1.9a1.1,1.1,0,0,1-.8-.7,1.6,1.6,0,0,1,.2-1.2c.2-.3.4-.6.2-.9a3.6,3.6,0,0,1-.7-1C177.5,335.1,177.8,335.2,177.8,335.2Z"
        />
        <path
          d="M179.4,334.8a2.4,2.4,0,0,1-1.7-.6,1.5,1.5,0,0,1,.2-1.1,4,4,0,0,0,.2-1.9c-.1-.8-1.5-2.8-.5-3l1.9.3c.6,0,.8.4.7,1s-.4.9-.5,1.6a5.9,5.9,0,0,0,.1,1.9v.2a2,2,0,0,1,0,1.1h0A1.2,1.2,0,0,1,179.4,334.8Z"
        />
        <path
          d="M173.2,335.7h-2c-.1,0-.1-.1-.2-.2s.1-1.5.2-2.1a14.9,14.9,0,0,0,.2-2.1c0-.7-.4-1.1-.5-1.7s0-.9.7-.8l1,.2c.4,0,.7-.2,1-.1s.6,1,.2,1.5-.9,1.2-.8,2.1a5.9,5.9,0,0,0,.5,2.3S174.1,335.6,173.2,335.7Z"
        />
        <path
          d="M171.2,337.7c-.2-.4-.6-.8-.2-1.2s.7,0,1.1,0h.3c.3,0,1,0,1.1.5s-.4.7-.6,1a2.8,2.8,0,0,0-.4,1.3,2.2,2.2,0,0,1-.2,1.4.9.9,0,0,1-1,.6,1.2,1.2,0,0,1-.7-1C170.7,339.4,171.6,338.6,171.2,337.7Z"
        />
        <path
          d="M165.2,336.6a1.1,1.1,0,0,1-.2-.8c.1-.4.6-.4,1-.2h.4c.3,0,.8,0,1,.4s-.4.7-.5.9a2.8,2.8,0,0,0-.4,1.3,2.5,2.5,0,0,1-.1,1.2c-.2.3-.5.7-.9.6a1.1,1.1,0,0,1-.7-1C164.8,338.2,165.6,337.4,165.2,336.6Z"
        />
        <path
          d="M159.7,327.4c.4-.1.8.3,1,.2l.4-.2c.4,0,.8-.2.9.1s-.2.6-.3.9a2,2,0,0,0-.3,1.1c0,.3.2.7,0,1s-.4.6-.8.6a1,1,0,0,1-.7-.8c0-.6.6-1.4.2-2S159.3,327.5,159.7,327.4Z"
        />
        <path
          d="M170.6,319.9c-.1-.8.4-1.2,1.2-1.4a1.7,1.7,0,0,1,1.8.2c.7.4.3,1.2.2,1.8a7.8,7.8,0,0,0-.4,2.6,24.5,24.5,0,0,1,.2,2.7c0,.2.1.5.1.7s.2,1.4-.7,1.5a2.4,2.4,0,0,1-2.1-.7c-.4-.7.1-1.3.3-2a8.2,8.2,0,0,0,0-2.7C171.1,321.6,170.7,320.8,170.6,319.9Z"
        />
        <path
          d="M161,314.5c-.7-.9-.1-2,.3-2.8a10.6,10.6,0,0,0,1-3,19.5,19.5,0,0,0,.3-3.4,7.8,7.8,0,0,0-.2-1.6,1.7,1.7,0,0,1,.1-1.2c.4-.8,1.8-.6,2.5-.3s.4,1.4,0,2.3a13,13,0,0,0-1.1,7c.1,1,.4,2.1-.3,3a1.6,1.6,0,0,1-2.4.1Z"
        />
        <path
          d="M161.2,223.5a4.4,4.4,0,0,1-3.7.4c-1.1-.5-1.9-.8-1.9.5s1.5,2.2,2,8.8,1.6,20.2,1.3,25.2,1.5,15.9,2.2,20.7,1.3,5.7,1.2,7.8a14.2,14.2,0,0,0,.4,4.5.8.8,0,0,0,.9.4l1.1-.3c1.3-.7,2.4-2,1.6-5.5a159.9,159.9,0,0,1-2.4-17.1c-.4-4,.3-16.9.6-21.1l.7-13.4c.6,3.5,1.9,10.4,3.2,17.4s0,32.4-1,37.3a5.9,5.9,0,0,0-.2,1.4.6.6,0,0,0,.6.5h0a11.3,11.3,0,0,1,2.6,0,19.3,19.3,0,0,1,4.1,1.2,1,1,0,0,0,1.4-.4v-.4a23.4,23.4,0,0,0-.3-3.8c-.3-2.8-1.7-8.6-1.9-15.3s-.2-19.8-2.7-30.7c-2-8.7-2.5-13.8-1-15.9s1.1-3.3-1.3-2.8a3.4,3.4,0,0,1-2.8,0,5.9,5.9,0,0,0-2.6-.7A6.3,6.3,0,0,0,161.2,223.5Z"
        />
        <path
          d="M162.6,295.4a2,2,0,0,1,.8-1.2,17.7,17.7,0,0,1,6-.8,10.6,10.6,0,0,1,3.6.9l1,.6a13.8,13.8,0,0,0,2.4,1.4,1.8,1.8,0,0,1,1.2,1.2c.1.2.1.3,0,.4h0a7.4,7.4,0,0,1-1.4,2.2h-1.3a4,4,0,0,0-2.6.6l-.4.3a2.4,2.4,0,0,1-2.1.8,8.3,8.3,0,0,1-2.1-.6,8.8,8.8,0,0,0-2.3-.7c-1-.1-1.4.1-2.3,0s-.6-4.5-.6-4.5S162.6,295.7,162.6,295.4Z"
        />
        <path
          d="M152,217.7c-.7-3.5,3.7-6.7,4.1-11.6s-2.3-67.7-4.4-71.8a12.1,12.1,0,0,0-2.9-3.5,9.6,9.6,0,0,1-3.3-10.3c1.2-4.3,4.2-6,7.6-6a4.2,4.2,0,0,1,3.9,2.6c1.2-.3,3.4-.2,3.8,2a59.5,59.5,0,0,1-.2,14c-.7,4.8,1.3,42.9,1.7,53.2s1.5,17.1,4.1,20.7,5.8,4.7,5.6,8.1-3.6,6.3-6.3,5.2-2-1.2-2.6-1.3-.6-.6-1.3.1a7.2,7.2,0,0,1-2.5,1.6C157,221.5,152.8,222.2,152,217.7Z"
        />
      </g>
      <g id="xp_upper_extremities_selection" hidden>
        <g id="xp_upper_extremities_4" index="xp_upper_extremities_4" class="region">
          <path
            d="M181,312.2c.3-.1.5,0,.7.3s4.3,8.5,7,11.7a1.7,1.7,0,0,0,2.4.7,2.5,2.5,0,0,0,.9-3.1,10.3,10.3,0,0,1-.7-2c-1.9-5.6-6.8-20.3-11.2-24.6-2-1.9-3.3-6.4-4-13.5H160.3a52.8,52.8,0,0,1,1.1,8.9c-.1,2.4-1.9,25.6-2.2,28.5-.5,4.8-.5,13.7,1.2,17.1,2.4,5.1,11.4,7.8,15.8,7.9a3.4,3.4,0,0,0,2.8-1.4c4.9-5.8,2.2-26.9,1.6-29.9A.7.7,0,0,1,181,312.2Z"
          />
          <path
            d="M13.9,295.3c-4.4,4.2-9.3,19-11.2,24.5l-.6,2a2.5,2.5,0,0,0,.8,3.2,2,2,0,0,0,2.5-.7c2.6-3.2,6.9-11.7,7-11.8a.5.5,0,0,1,.6-.2c.3,0,.4.3.4.6-.6,3-3.3,24.1,1.6,29.9a3.1,3.1,0,0,0,2.8,1.3c4.4,0,13.4-2.7,15.9-7.8,1.6-3.5,1.6-12.3,1.1-17.1-.3-2.9-2.1-26.1-2.2-28.6a66.1,66.1,0,0,1,1.1-8.8H18C17.2,288.8,15.9,293.4,13.9,295.3Z"
          />
        </g>
        <g id="xp_upper_extremities_3" index="xp_upper_extremities_3" class="region">
          <path
            d="M153.3,246.3c.9,4.3,1.8,8.7,2.6,12.9l.6,2.6c1.2,6.3,2.6,13.2,3.6,18.7h15.8a226.1,226.1,0,0,1-.1-27.3v-1.8c0-5-.2-9.6-.6-14H151.4C151.9,240.2,152.6,243.2,153.3,246.3Z"
          />
          <path
            d="M18.2,253.2a226.1,226.1,0,0,1-.1,27.3H33.9c1-5.5,2.4-12.4,3.6-18.7.3-1.3.5-2.3.6-2.6.7-4.2,1.7-8.6,2.6-12.9s1.4-6.1,1.9-8.9H18.8c-.4,4.4-.6,9-.6,14Z"
          />
        </g>
        <g id="xp_upper_extremities_2" index="xp_upper_extremities_2" class="region">
          <path
            d="M174.5,229.8c-.4-5-.9-9.3-.9-13.2v-2.5c.1-5.4.1-10.5.1-15.5H149.2c.2,5.2.4,9,.4,9.9s.1,4.1.2,7.4.3,9.2.3,12.3a52.7,52.7,0,0,0,1,8.1h24C174.9,234,174.7,231.9,174.5,229.8Z"
          />
          <path
            d="M44.2,215.9c.1-3.3.2-6.1.2-7.4s.2-4.7.4-9.9H20.2c0,5,.1,10.1.1,15.5v2.5c0,3.9-.4,8.2-.9,13.2-.2,2-.4,4.2-.6,6.5h24a42.7,42.7,0,0,0,1.1-8.1C43.9,225.1,44.1,220.2,44.2,215.9Z"
          />
        </g>
        <g id="xp_upper_extremities_1" index="xp_upper_extremities_1" class="region">
          <path
            d="M31.7,110c-7.3,7.8-11.3,38.6-11.4,87.5H44.8c0-1.1.1-2.3.2-3.5.5-11.4,1.2-28.9,1.3-36.2-.1-1.9,11.4-33.4-4.3-55.2a57.3,57.3,0,0,0-6.2,3.8A28.6,28.6,0,0,0,31.7,110Z"
          />
          <path
            d="M162.3,110c7.3,7.8,11.3,38.6,11.5,87.5H149.2c-.1-1.1-.1-2.3-.2-3.5-.5-11.4-1.2-28.9-1.3-36.2.1-1.9-11.4-33.4,4.2-55.2a43.9,43.9,0,0,1,6.3,3.8A28.6,28.6,0,0,1,162.3,110Z"
          />
        </g>
      </g>
      <g id="xp_thorax_bone" class="bone" disabled>
        <path
          d="M72.3,205c2.9-2.1,8-5.4,10-7.6a71.7,71.7,0,0,0,4.5-6.3c1.3-1.9,1.9-3.3.8-3.9s-2.7,1.1-3.7,2.1-3.7,4.7-6,6.8-7,5.2-10.4,8-5.9,5.7-5.4,7.4S69.4,207.1,72.3,205Z"
        />
        <path
          d="M121.9,205c-2.9-2.1-8-5.4-10-7.6a71.7,71.7,0,0,1-4.5-6.3c-1.3-1.9-1.9-3.3-.8-3.9s2.7,1.1,3.7,2.1,3.7,4.7,6,6.8,7,5.2,10.4,8,5.9,5.7,5.4,7.4S124.8,207.1,121.9,205Z"
        />
        <path
          d="M86.7,104.1c1.3-.1,2.4-2.8,0-3.3a59.6,59.6,0,0,0-10.3.8,75.1,75.1,0,0,1,9.6,2.5Z"
        />
        <path
          d="M107.3,104.1h.6a67.9,67.9,0,0,1,9.6-2.5,58.9,58.9,0,0,0-10.3-.9C104.8,101.3,106,104,107.3,104.1Z"
        />
        <path
          d="M141.1,156.2c-.1-1.8-3.8-3.4-3.8-3.4s4.5-1.7,4.5-4.2-7-6.5-7-6.5,4-.9,4.3-4.4-4.3-5-4.3-5a3.8,3.8,0,0,0,2.4-3.8c-.1-2.8-4.7-5.9-4.7-5.9s3.2-1.3,2.4-3.8-8.5-6.4-8.5-6.4a7.3,7.3,0,0,0,.3-3,40.6,40.6,0,0,0-5.1.4c0,1.3-.4,2.9-3.2,3.2l-11.7.4h-.9a6.8,6.8,0,0,1-2.3-1.8c-.9-1.1-.8-3.2-2-3.6s-2.1.2-4.4.2-3.8-.4-4.5-.2-1.1,2.5-2,3.6a6.8,6.8,0,0,1-2.3,1.8h-.9l-11.7-.4c-2.7-.3-3.2-1.9-3.2-3.2l-5.1-.4a7.3,7.3,0,0,0,.3,3s-7.2,2.6-8.5,6.4,2.4,3.8,2.4,3.8-4.6,3.1-4.8,6a3.7,3.7,0,0,0,2.4,3.7s-4.5,2.3-4.2,5,4.3,4.4,4.3,4.4-7,3.1-7,6.5,4.5,4.2,4.5,4.2-3.7,1.6-3.9,3.4c-.3,3.8,3.8,5.3,3.8,5.3s-4,2.2-3.6,5.3c.3,1.5,2.6,3.5,2.6,3.5s-2.8,2.8-2.3,6a6.3,6.3,0,0,0,2.6,4.1s-2.8,2.8-2,6,4.4,3.8,4.4,3.8-1.6,4.1-1.3,6c.9,4.8,6.1,4.2,7.6,4.1a13.1,13.1,0,0,0,7.4-3.7,43.6,43.6,0,0,0,3.1-3.5,35.7,35.7,0,0,0,6.8-4,56.2,56.2,0,0,0,5.4-5.5c1.6-1.7,2.3-3,1.3-3.7s-2.8.6-4,1.5-1.8,1.6-3.1,2.8l1.2-2c2.3-4.2,5.2-5,6.6-10.4.5-2,.4-6.3,3.6-11,.8,3.5,2,6.5,3.7,6.7h.7c1.6-.2,2.9-3.2,3.7-6.7,3.2,4.7,3.1,9,3.6,11,1.4,5.4,4.3,6.2,6.6,10.4l.9,1.5-2.6-2.3c-1.2-.9-3-2.3-4-1.6s-.2,2,1.3,3.8a70.1,70.1,0,0,0,5.4,5.5,32.5,32.5,0,0,0,6.5,3.8,47.7,47.7,0,0,0,3.2,3.7,13.1,13.1,0,0,0,7.4,3.7c1.4.1,6.7.8,7.6-4.1.3-1.9-1.2-5.8-1.3-6s3.7-.5,4.4-3.7-2-6-2-6a7.2,7.2,0,0,0,2.6-4.2c.5-3.2-2.3-6-2.3-6s2.3-2,2.6-3.5-3.6-5.3-3.6-5.3S141.5,160,141.1,156.2ZM70.5,115.7a26.7,26.7,0,0,0,6.8,1.5l9.2.5a6.7,6.7,0,0,0,2.2,4.1l.3.3c-3.7,0-12.5-.1-17-.8C63.6,120,70.5,115.7,70.5,115.7Zm-3.1,8.9a99.3,99.3,0,0,0,12.2,1.6c3.4.3,8.3.2,10.8.2.2,1.6.5,3.4.6,5.3-4.9-.1-15.9-.5-20-1.1C60,128.9,67.4,124.6,67.4,124.6Zm-1.8,10.1s5.6,1,8.6,1.2a137.4,137.4,0,0,0,17.1.2c0,1.5.1,3.1.1,4.6H91c-4.3.4-17.7.8-21.6.2-12.7-2.2-3.8-6.2-3.8-6.2Zm-.3,9.5s4.7,1,7.6,1.3a105.3,105.3,0,0,0,18.6-.8v3.5c-6.5,3.4-16.9,4.5-23.4,3.1-14.7-3-2.8-7.1-2.8-7.1Zm-6.1,28.7,2.6.6a27.7,27.7,0,0,0,5,1,30.4,30.4,0,0,0,7.4-.4c2.2-.4,3-.8,5.4-1.1s1.3,1.3-1,3.2-10.4,4.3-18,2.3c-5.1-1.4-1.4-5.6-1.4-5.6Zm-.5,12.7c-.9-1,0-2.7,0-2.7a36.7,36.7,0,0,0,7.4,1.1,29.4,29.4,0,0,0,10.6-1.7c2.8-.7,1.4.7.7,1.3s-4.6,4-11.8,4.2c-2.3.1-6-1-6.9-2.2Zm7.5,10c-2.5.8-4.2-.6-4-1.6a5.2,5.2,0,0,1,.6-1.6,16.7,16.7,0,0,0,6.7.7C71.4,192.7,68.8,194.8,66.2,195.6Zm17-30.1c-2.4,2.9-10.4,6.1-19.9,4.3-7.7-1.6-1.9-5.8-1.9-5.8a34,34,0,0,0,9.5,1.3c4.8-.2,8.8-1,11.3-2.3s2.4.8,1,2.4Zm.1-7.5c-5.4,3.2-12.7,3.3-16,2.8-11.5-1.6-6.5-6.2-6.5-6.2a91.8,91.8,0,0,0,9.1,1.9c3,.3,10.4.2,13.7-.9,1.4-.5,1,1.5-.4,2.4Zm7.9-1.1c-1.2.6-4,.6-2.7-1a30,30,0,0,1,3.2-3c.1,1,.2,2.2.4,3.4l-.9.6Zm14.1-35.1a6.7,6.7,0,0,0,2.2-4.1l9.2-.5a26.7,26.7,0,0,0,6.8-1.5s6.9,4.3-1.4,5.6c-4.6.7-13.4.8-17,.8l.2-.3Zm-1.6,4.6c2.5,0,7.3,0,10.8-.2a100.3,100.3,0,0,0,12.1-1.6s7.4,4.3-3.6,6c-4,.6-15.1,1-20,1.1a40.8,40.8,0,0,1,.6-5.3Zm-.9,9.7a137.7,137.7,0,0,0,17.1-.2c3-.2,8.6-1.2,8.6-1.2s8.8,4-3.9,6.2c-4,.7-17.2.2-21.6-.2h-.4c0-1.5.1-3.1.1-4.6Zm-.2,8.6a103.8,103.8,0,0,0,18.5.8c2.9-.3,7.7-1.3,7.7-1.3s11.9,4.1-2.8,7.1c-6.5,1.3-16.9.3-23.5-3.1v-3.5Zm.2,12.2-.8-.6c.2-1.2.3-2.4.4-3.4a30,30,0,0,1,3.2,3c1.3,1.6-1.5,1.6-2.8,1Zm7.6-1.3c3.3,1.1,10.8,1.2,13.8.9a91.8,91.8,0,0,0,9.1-1.9s5,4.6-6.5,6.2c-3.4.5-10.6.3-16-2.9-1.4-.8-1.8-2.8-.4-2.3Zm.5,9.9c-1.4-1.7-1.5-3.8,1-2.5s6.4,2.1,11.2,2.3a34,34,0,0,0,9.5-1.3s5.9,4.3-1.9,5.8c-9.4,1.8-17.5-1.4-19.9-4.4Zm17,30.1c-2.7-.8-5.2-2.9-3.3-2.5a16.7,16.7,0,0,0,6.7-.7,5.2,5.2,0,0,1,.6,1.6c.1,1-1.6,2.4-4.1,1.6Zm7.5-10c-.9,1.2-4.6,2.3-6.9,2.2-7.2-.2-10.6-3.2-11.8-4.2s-2-2,.7-1.3a28.4,28.4,0,0,0,10.5,1.7,36.7,36.7,0,0,0,7.4-1.1s.9,1.7,0,2.7Zm-2-7.1c-7.6,2-15.7-.3-18-2.3s-3.3-3.5-.9-3.2,3.1.7,5.3,1.1a31.5,31.5,0,0,0,7.5.4,29.5,29.5,0,0,0,5-1l2.6-.6s3.6,4.2-1.5,5.6Z"
        />
      </g>
      <g id="xp_thorax_selection" hidden>
        <path
          id="xp_thorax_1"
          index="xp_thorax_1"
          class="region"
          d="M133.3,96.1H60.7a99,99,0,0,0-17.6,6.1c16.1,22.6,5.6,51.1,4,55.1l.4.4c.3,1.8,7,43.2,7,53,0,1.4,0,2.9-.1,4.5h85.2c-.1-1.6-.1-3-.1-4.5,0-9.8,6.7-51.2,7-53l.4-.4c-1.7-4-12.5-32.6,3.8-55.2A99.5,99.5,0,0,0,133.3,96.1Z"
        />
      </g>
      <g id="xp_shoulder_girdle_default" class="bone" disabled>
        <path
          d="M156.7,109.8A37.7,37.7,0,0,0,151,107c-1.3-.5-2.4-.5-3.1.2s-.7,2.1-.4,3.3-3.1,2.2-4.1,2-2.7-2.2-4.4-2.7-4.1.8-5.4.9-2.6-.1-4.6-.2v1c2.5,1.1,6.8,3.5,8,7a4.8,4.8,0,0,1-.9,4.6c1.5,1.5,3.2,3.5,3.3,5.8a6.2,6.2,0,0,1-.9,3.6c1.5,1.3,3,3.2,2.8,5.5a7.2,7.2,0,0,1-2,4.2l1.8,1.4c3.5-7.2,5.5-12.7,4.3-13.8a9.1,9.1,0,0,1-2-4.2,14.1,14.1,0,0,1,2.1-8.7c1.4-2.2,4.8-4.6,11-3.2C158.8,114.1,158.4,110.9,156.7,109.8Z"
        />
        <path
          d="M48.7,129.7c-1.2,1.1.8,6.7,4.2,13.8a13.3,13.3,0,0,1,1.9-1.4,6.2,6.2,0,0,1-2-4.2c-.3-2.3,1.3-4.2,2.8-5.5a6.2,6.2,0,0,1-1-3.5c.1-2.3,1.8-4.4,3.4-5.8a4.7,4.7,0,0,1-.9-4.7c1.1-3.4,5.5-5.8,8-7v-1c-2,.1-3.9.3-4.6.2s-3.7-1.4-5.4-.8-3.3,2.6-4.4,2.7-4.4-.7-4.1-2,.3-2.7-.4-3.4-1.8-.6-3.1-.2a61.9,61.9,0,0,0-5.8,2.8c-1.6,1.1-2.1,4.3.3,3.8,6.2-1.3,9.6,1.1,11,3.3a14,14,0,0,1,2.1,8.7A9.1,9.1,0,0,1,48.7,129.7Z"
        />
      </g>
      <g id="xp_shoulder_girdle_bone" class="bone" hidden>
        <path
          d="M83.2,111.9c1.8,2,6,.4,6.7-2.1s-.2-2.5-1.9-3.2c-15-6-22.8-5.6-35.4-3.5-4.1.7-5.9,1.4-6.1,2.1s.8.9,1.3,2-.2,1.8.2,2.3,4.1-.9,7.7-1.3C64.5,106.9,79,107.2,83.2,111.9Z"
        />
        <path
          d="M110.8,111.9c-1.8,2-6,.4-6.7-2.1s.2-2.5,1.9-3.2c15-6,22.8-5.6,35.4-3.5,4.1.7,5.9,1.4,6.1,2.1s-.8.9-1.3,2,.2,1.8-.2,2.3-4.1-.9-7.7-1.3C129.5,106.9,115,107.2,110.8,111.9Z"
        />
        <path
          d="M156.4,113.6c-6.1-1.4-9.5,1-10.9,3.3a14,14,0,0,0-2.2,8.7,8.8,8.8,0,0,0,2,4.1c1.4,1.3-1.5,8.5-6,17.3-1.9,3.7-8.8,16.7-11.6,15-1.3-.8-6.5-4-9.7-31.6-1.4-12,2.7-19.6,6.1-19.9s8.2.4,9.5.2,3.6-1.4,5.4-.9,3.3,2.7,4.3,2.8,4.5-.7,4.2-2-.3-2.7.4-3.4,1.8-.6,3.1-.2a50.3,50.3,0,0,1,5.7,2.8C158.4,110.9,158.8,114.1,156.4,113.6Z"
        />
        <path
          d="M37.6,113.6c6.1-1.4,9.5,1,10.9,3.3a14,14,0,0,1,2.2,8.7,8.8,8.8,0,0,1-2,4.1c-1.4,1.3,1.5,8.5,6,17.3,1.9,3.7,8.8,16.7,11.6,15s6.5-4,9.7-31.6c1.4-12-2.7-19.6-6.1-19.9s-8.2.4-9.5.2-3.6-1.4-5.4-.9-3.3,2.7-4.3,2.8-4.5-.7-4.2-2,.3-2.7-.4-3.4-1.8-.6-3.1-.2a50.3,50.3,0,0,0-5.7,2.8C35.6,110.9,35.2,114.1,37.6,113.6Z"
        />
      </g>
      <g id="xp_shoulder_girdle_selection" hidden>
        <path
          class="bone"
          disabled
          d="M72.3,205c2.9-2.1,8-5.4,10-7.6a71.7,71.7,0,0,0,4.5-6.3c1.3-1.9,1.9-3.3.8-3.9s-2.7,1.1-3.7,2.1-3.7,4.7-6,6.8-7,5.2-10.4,8-5.9,5.7-5.4,7.4S69.4,207.1,72.3,205Z"
        />
        <path
          class="bone"
          disabled
          d="M121.9,205c-2.9-2.1-8-5.4-10-7.6a71.7,71.7,0,0,1-4.5-6.3c-1.3-1.9-1.9-3.3-.8-3.9s2.7,1.1,3.7,2.1,3.7,4.7,6,6.8,7,5.2,10.4,8,5.9,5.7,5.4,7.4S124.8,207.1,121.9,205Z"
        />
        <path
          class="bone"
          disabled
          d="M86.7,104.1c1.3-.1,2.4-2.8,0-3.3a59.6,59.6,0,0,0-10.3.8,75.1,75.1,0,0,1,9.6,2.5Z"
        />
        <path
          class="bone"
          disabled
          d="M107.3,104.1h.6a67.9,67.9,0,0,1,9.6-2.5,58.9,58.9,0,0,0-10.3-.9C104.8,101.3,106,104,107.3,104.1Z"
        />
        <path
          class="bone"
          disabled
          d="M137.4,161.5s4.1-1.5,3.8-5.3c-.2-1.1-1.7-2.2-2.8-2.9-6.3,11-8.9,11-10.1,11h0a2.3,2.3,0,0,1-1.8-.5,8.6,8.6,0,0,1-2.9-2.8c-3.7,0-8.8-.7-12.8-3.1-1.4-.8-1.8-2.8-.4-2.3s7.4,1.1,10.9,1a37.1,37.1,0,0,1-1.6-4.7c-5.8,0-12.5-1.3-17.2-3.7v-3.5a102.1,102.1,0,0,0,15.6.9,43.8,43.8,0,0,1-.8-4.4c-5.3,0-11.6-.3-14.3-.5h-.4c0-1.5,0-3.1.1-4.6q6.9.3,13.8,0c-.3-1.6-.5-3.2-.7-5l-12.8.6a38.8,38.8,0,0,1,.6-5.3c2.5,0,7.4,0,10.8-.2h1.1a31,31,0,0,1,.2-4.3l-10.7.3.3-.3a6.9,6.9,0,0,0,2.2-4.2c2.6,0,7.1-.3,9-.4a17.4,17.4,0,0,1,1.4-3.8l-11.3.4h-.9a7.1,7.1,0,0,1-2.3-1.9c-.9-1.1-.8-3.2-2-3.6s-2.1.2-4.4.2-3.8-.4-4.5-.2-1.1,2.5-2,3.6a7.1,7.1,0,0,1-2.3,1.9h-.9L76,113.4a17.4,17.4,0,0,1,1.4,3.8c2,.1,6.5.4,9,.4a6.6,6.6,0,0,0,2.3,4.2c0,.1.1.2.2.3l-10.7-.3a31,31,0,0,1,.2,4.3h1.1c3.4.2,8.3.2,10.8.2a38.8,38.8,0,0,1,.6,5.3l-12.8-.6c-.2,1.8-.4,3.4-.6,5,4.5.2,9.1.2,13.7,0,.1,1.5.1,3.1.1,4.6H91c-2.7.2-9,.5-14.3.5-.2,1.6-.5,3-.8,4.4a102.1,102.1,0,0,0,15.6-.9v3.5c-4.7,2.4-11.4,3.7-17.2,3.7a37.1,37.1,0,0,1-1.6,4.7c3.5.1,8.4-.2,10.9-1s1,1.5-.4,2.3c-4,2.4-9.1,3.1-12.8,3.1a9.6,9.6,0,0,1-2.9,2.8,2.4,2.4,0,0,1-1.8.5c-1.2,0-3.8,0-10.1-11-1.1.7-2.7,1.8-2.8,2.9-.3,3.8,3.8,5.3,3.8,5.3s-4,2.2-3.5,5.3c.2,1.5,2.5,3.5,2.5,3.5s-2.8,2.8-2.3,6a6.7,6.7,0,0,0,2.6,4.1s-2.7,2.8-2,6,4.4,3.8,4.4,3.8-1.6,4.1-1.3,6c.9,4.8,6.2,4.2,7.7,4.1a13.1,13.1,0,0,0,7.3-3.7,43.9,43.9,0,0,0,3.2-3.6,36.9,36.9,0,0,0,6.6-3.9,70.1,70.1,0,0,0,5.4-5.5c1.6-1.7,2.3-3,1.3-3.8s-2.8.7-4,1.5l-2.8,2.6,1-1.7c2.3-4.2,5.2-5,6.6-10.4.5-2,.4-6.3,3.6-11,.8,3.5,2.1,6.5,3.7,6.7h.7c1.7-.2,2.9-3.2,3.7-6.7,3.2,4.6,3.1,9,3.6,11,1.4,5.4,4.3,6.1,6.6,10.4l1,1.7-2.8-2.6c-1.2-.8-3-2.3-4-1.5s-.2,2,1.3,3.8a70.1,70.1,0,0,0,5.4,5.5,44,44,0,0,0,6.6,3.9,43.9,43.9,0,0,0,3.2,3.6,13.1,13.1,0,0,0,7.4,3.7c1.5.1,6.7.7,7.6-4.2.3-1.8-1.2-5.7-1.3-5.9s3.7-.6,4.4-3.8-2-6-2-6a6.5,6.5,0,0,0,2.6-4.1c.5-3.3-2.3-6-2.3-6s2.3-2,2.6-3.5C141.4,163.7,137.4,161.5,137.4,161.5ZM59.2,172.9l2.6.6a21,21,0,0,0,5,.9,26.1,26.1,0,0,0,7.4-.3c2.2-.4,3-.8,5.4-1.1s1.3,1.3-.9,3.2-10.5,4.3-18,2.3C55.5,177.1,59.2,172.9,59.2,172.9Zm-.5,12.7c-.9-1,0-2.7,0-2.7a36.7,36.7,0,0,0,7.4,1.1,29.4,29.4,0,0,0,10.6-1.7c2.8-.7,1.4.7.7,1.3s-4.6,4-11.8,4.2C63.3,187.9,59.6,186.8,58.7,185.6Zm7.5,10c-2.5.8-4.2-.6-4-1.6a5.2,5.2,0,0,1,.6-1.6,16.7,16.7,0,0,0,6.7.7C71.4,192.7,68.8,194.8,66.2,195.6Zm17-30.1c-2.4,2.9-10.4,6.1-19.8,4.3-7.8-1.6-1.9-5.8-1.9-5.8a32.8,32.8,0,0,0,9.4,1.3c4.8-.2,8.8-1,11.3-2.3s2.4.8,1,2.4Zm8-8.6c-1.2.6-4,.6-2.7-1a30,30,0,0,1,3.2-3c.1,1,.2,2.2.4,3.4l-.9.6Zm11.7,0-.9-.6c.2-1.2.3-2.4.4-3.4a30,30,0,0,1,3.2,3c1.3,1.6-1.5,1.6-2.8,1Zm8,8.6c-1.4-1.7-1.5-3.8,1-2.5s6.4,2.1,11.2,2.3a34,34,0,0,0,9.5-1.3s5.9,4.3-1.9,5.8c-9.4,1.8-17.5-1.4-19.9-4.4Zm17,30.1c-2.7-.8-5.2-2.9-3.3-2.5a16.7,16.7,0,0,0,6.7-.7,5.2,5.2,0,0,1,.6,1.6c.1,1-1.6,2.4-4.1,1.6Zm7.5-10c-.9,1.2-4.6,2.3-6.9,2.2-7.2-.2-10.6-3.2-11.8-4.2s-2-2,.7-1.3a28.4,28.4,0,0,0,10.5,1.7,36.7,36.7,0,0,0,7.4-1.1s.9,1.7,0,2.7Zm-2-7.1c-7.6,2-15.7-.3-18-2.3s-3.3-3.5-.9-3.2,3.1.7,5.3,1.1a31.5,31.5,0,0,0,7.5.4,29.5,29.5,0,0,0,5-1l2.6-.6s3.6,4.2-1.5,5.6Z"
        />
        <path
          id="xp_shoulder_girdle_2"
          index="xp_shoulder_girdle_2"
          class="region"
          d="M171,141.1c-1.4-12-3.4-21-5.8-26.5H28.8c-2.5,5.5-4.4,14.5-5.8,26.5Z"
        />
        <path
          id="xp_shoulder_girdle_1"
          index="xp_shoulder_girdle_1"
          class="region"
          d="M82.2,90.6c-1,1-4.3,1.7-10.4,3-10.4,2.2-26,5.6-36,12.8a28.6,28.6,0,0,0-4.1,3.6,13.6,13.6,0,0,0-2.4,3.5H164.7a13.6,13.6,0,0,0-2.4-3.5,28.6,28.6,0,0,0-4.1-3.6c-10-7.2-25.6-10.6-36-12.8-6.1-1.3-9.3-2-10.3-3s-1.3-6.5-.8-11.3H82.9C83.5,84.1,83.6,89.2,82.2,90.6Z"
        />
      </g>
      <g id="xp_vertebral_column_default" class="bone" disabled>
        <path
          d="M103.8,96.4c-.8.2-2.1.8-2.1,0s1.1-1.5-.9-1.6H93.2c-2,.1-.9,1.1-.9,1.6s-1.3.2-2.1,0-1.6,1.2,0,1.3,2.7.4,2.6,1.1,2,1.2,4.2,1.2,4.3-.2,4.2-1.2,1-.9,2.6-1.1S104.6,96.2,103.8,96.4Z"
        />
        <path
          d="M104.3,184.8c-.8.3-2.2,1.1-2.2,0s1.1-2-1-2.2H92.8c-2.1.3-.9,1.6-1,2.2s-1.4.3-2.2,0a.9.9,0,1,0,0,1.8c1.7.3,2.9.5,2.8,1.6s2.1,1.6,4.5,1.6,4.6-.3,4.5-1.6,1.2-1.3,2.9-1.6a.8.8,0,0,0,.9-.8A1,1,0,0,0,104.3,184.8Z"
        />
        <path
          d="M103.6,177.1c-.8.2-2,1-2,0s1-1.7-.9-2H93.3c-1.9.2-.8,1.4-.8,2s-1.3.2-2,0a.8.8,0,0,0-.8.8.8.8,0,0,0,.8.9h0c1.5.2,2.6.4,2.5,1.3s1.9,1.5,4,1.5,4.2-.3,4-1.5,1-1.1,2.6-1.3a.8.8,0,0,0,.8-.9A.8.8,0,0,0,103.6,177.1Z"
        />
        <path
          d="M102.8,85.6c-.7.1-1.8.6-1.8,0s.9-1.1-.8-1.3H93.8c-1.7.2-.8.9-.8,1.3s-1.1.1-1.8,0-1.3.9,0,1.1,2.3.2,2.2.8,1.7,1,3.6,1,3.6-.2,3.5-1,.9-.7,2.3-.8S103.4,85.5,102.8,85.6Z"
        />
        <path
          d="M102.8,80.6c-.7.1-1.8.6-1.8,0s.9-1.2-.8-1.3H93.8c-1.7.1-.8.9-.8,1.3s-1.1.1-1.8,0-1.3.9,0,1,2.3.3,2.2.9,1.7,1,3.6,1,3.6-.2,3.5-1,.9-.8,2.3-.9S103.4,80.4,102.8,80.6Z"
        />
        <path
          d="M102.8,90.8c-.7.1-1.8.7-1.8,0s.9-1.3-.8-1.4H93.8c-1.7.1-.8,1-.8,1.4s-1.1.1-1.8,0-1.3,1,0,1.1,2.3.3,2.2,1,1.7,1,3.6,1,3.6-.2,3.5-1,.9-.8,2.3-1S103.4,90.6,102.8,90.8Z"
        />
        <path
          d="M106.3,193.3c-.9.3-3.7,1.2-3.7,0s1.2-2.2-1.1-2.4h-9c-2.3.2-1,1.7-1,2.4s-2.8.3-3.7,0a1,1,0,0,0,0,2c1.8.3,4.4.5,4.3,1.7s2.3,1.8,5,1.8,5-.4,5-1.8,2.5-1.4,4.3-1.7a1,1,0,0,0,1-1.1,1.2,1.2,0,0,0-1.1-.9Z"
        />
        <path
          d="M109.7,233.2c-1.3.4-5,1.7-5.1,0s1.7-2.9-1.4-3.3H90.8c-3.1.4-1.4,2.3-1.4,3.3s-3.8.4-5.1,0a1.3,1.3,0,0,0-1.3,1.4,1.4,1.4,0,0,0,1.3,1.4c2.6.3,6,.6,5.9,2.2s3.2,2.5,6.8,2.5,6.9-.5,6.7-2.5,3.4-1.9,6-2.2a1.4,1.4,0,0,0,1.3-1.4A1.3,1.3,0,0,0,109.7,233.2Z"
        />
        <path
          d="M107.1,212.2c-1,.3-4,1.4-4,0s1.4-2.3-1.1-2.6H92.1c-2.5.3-1.1,1.8-1.1,2.6s-3,.3-4.1,0a1.2,1.2,0,0,0-1.2,1,1.1,1.1,0,0,0,1,1.2h.2c2,.3,4.8.6,4.7,1.8s2.5,2,5.4,2,5.5-.3,5.4-2,2.7-1.5,4.8-1.8a1.1,1.1,0,0,0,1.2-1,1.3,1.3,0,0,0-1.1-1.2Z"
        />
        <path
          d="M108.1,222.2c-1.1.3-4.4,1.5-4.4,0s1.5-2.6-1.3-2.9H91.6c-2.8.3-1.3,2-1.3,2.9s-3.3.4-4.4,0a1.3,1.3,0,0,0-1.3,1.2,1.2,1.2,0,0,0,1.2,1.2h.1c2.2.3,5.3.6,5.2,2s2.7,2.2,5.9,2.2,6-.5,5.9-2.2,3-1.7,5.2-2a1.4,1.4,0,0,0,1.8-.5,1.2,1.2,0,0,0-.3-1.7A3.4,3.4,0,0,0,108.1,222.2Z"
        />
        <path
          d="M107.1,202.5c-1,.3-4,1.4-4,0s1.4-2.3-1.1-2.6H92.1c-2.5.3-1.1,1.8-1.1,2.6s-3,.3-4.1,0a1.2,1.2,0,0,0-1.2,1,1.1,1.1,0,0,0,1,1.2h.2c2,.3,4.8.5,4.7,1.8s2.5,2,5.4,2,5.5-.4,5.4-2,2.7-1.5,4.8-1.8a1.1,1.1,0,0,0,1.2-1,1.3,1.3,0,0,0-1.1-1.2Z"
        />
        <path
          d="M114.7,240.3c-1.7-5.4-5.3-2-8,1.3a16.1,16.1,0,0,1-5,4,10,10,0,0,1-9.2,0,16.1,16.1,0,0,1-5-4c-2.7-3.4-6.4-6.7-8-1.3s-.8,10.6,3,13-.5,5.7,2.7,8.8,1.7,5,4.7,6.3,1.2,5,3,6.2-.1,3.5,1.2,4,1.3,2,3,2,2.2-1.6,3-2,.2-3.3,1.3-4,1-5.4,3-6.2,1.6-3.4,4.7-6.3,0-7,2.7-8.8S116.6,246.6,114.7,240.3Z"
        />
        <path
          d="M101.3,100.9H92.7c-2.2.2-.7,3.7-.4,4.5s2.2,1.3,4.7,1.3,4.4-.3,4.7-1.3S103.5,101.1,101.3,100.9Z"
        />
        <path
          d="M104.4,170.2a.7.7,0,0,0-.8-.5c-.8.2-2,1-2,0s1-1.8-.9-2H93.3c-1.9.2-.8,1.3-.8,2s-1.3.2-2,0a.6.6,0,0,0-.8.5.6.6,0,0,1-.1.4c0,.3.3.6.9.7s2.6.4,2.5,1.4,1.9,1.4,4,1.4,4.2-.3,4-1.4,1-1.2,2.6-1.4a1,1,0,0,0,.9-.7Z"
        />
      </g>
      <g id="xp_vertebral_column_bone" class="bone" hidden>
        <path
          d="M103.8,97.6c-.8.2-2.1.8-2.1,0s1.1-1.4-.9-1.6H93.2c-2,.2-.9,1.1-.9,1.6s-1.3.2-2.1,0-1.6,1.2,0,1.3,2.7.4,2.6,1.2,2,1.2,4.2,1.2,4.3-.3,4.2-1.2,1-1,2.6-1.2S104.6,97.4,103.8,97.6Z"
        />
        <path
          d="M104.3,183.5c-.8.3-2.2,1.1-2.2,0s1.1-2-1-2.2H92.8c-2.1.3-.9,1.6-1,2.2s-1.4.3-2.2,0a.9.9,0,0,0-.9.9.9.9,0,0,0,.9,1c1.7.2,2.9.4,2.8,1.5s2.1,1.6,4.5,1.6,4.6-.3,4.5-1.6,1.2-1.3,2.9-1.5a.9.9,0,0,0,.9-.9A1.1,1.1,0,0,0,104.3,183.5Z"
        />
        <path
          d="M103,146c-.7.2-1.8.9-1.8,0s.9-1.6-.8-1.8H93.9c-1.7.2-.8,1.3-.8,1.8s-1.2.2-1.8,0a.8.8,0,0,0-.8.7.9.9,0,0,0,.8.8c1.3.1,2.3.3,2.2,1.2s1.7,1.3,3.6,1.3,3.7-.3,3.6-1.3,1-1,2.3-1.2a.8.8,0,0,0,.7-.8A.7.7,0,0,0,103,146Z"
        />
        <path
          d="M102.9,153c-.7.2-1.8.9-1.8,0s.9-1.6-.8-1.8H93.7c-1.7.2-.7,1.3-.7,1.8s-1.2.2-1.8,0a.8.8,0,0,0-.8.7.9.9,0,0,0,.8.8c1.3.2,2.3.3,2.2,1.2S95.1,157,97,157s3.7-.3,3.6-1.3,1-1,2.3-1.2a.8.8,0,0,0,.7-.8A.7.7,0,0,0,102.9,153Z"
        />
        <path
          d="M103.2,160.2c-.7.2-1.9,1-1.9,0s1-1.7-.8-1.8h-7c-1.8.1-.8,1.2-.8,1.8s-1.2.2-1.9,0a.8.8,0,0,0-.9.7c-.1.4.3.8.7.9h.2c1.4.2,2.4.3,2.4,1.3s1.7,1.3,3.8,1.3,3.9-.2,3.8-1.3,1-1.2,2.4-1.3a.8.8,0,0,0,.9-.8A.8.8,0,0,0,103.2,160.2Z"
        />
        <path
          d="M103.2,119.2c-.7.2-1.9,1-1.9,0s1-1.6-.8-1.8h-7c-1.8.2-.8,1.3-.8,1.8s-1.2.3-1.9,0a.8.8,0,0,0-.9.7.7.7,0,0,0,.7.9h.2c1.4.2,2.4.4,2.4,1.3s1.7,1.4,3.8,1.4,3.9-.3,3.8-1.4,1-1.1,2.4-1.3a.9.9,0,0,0,1.1-.5.9.9,0,0,0-.5-1Z"
        />
        <path
          d="M103.6,175.5c-.8.2-2,1-2,0s1-1.7-.9-2H93.3c-1.9.2-.8,1.4-.8,2s-1.3.3-2,0a.8.8,0,0,0-.8.8.8.8,0,0,0,.8.9h0c1.5.2,2.6.4,2.5,1.3s1.9,1.5,4,1.5,4.2-.3,4-1.5,1-1.1,2.6-1.3a.9.9,0,0,0,1-.8A.9.9,0,0,0,103.6,175.5Z"
        />
        <path
          d="M103.6,111.6c-.8.2-2,1-2,0s1-1.8-.9-2H93.3c-1.9.2-.8,1.4-.8,2s-1.3.2-2,0a.8.8,0,0,0,0,1.6h0c1.5.2,2.6.4,2.5,1.4s1.9,1.5,4,1.5,4.2-.3,4-1.5,1-1.2,2.6-1.4a.8.8,0,0,0,.9-.8A.8.8,0,0,0,103.6,111.6Z"
        />
        <path
          d="M103.6,104.2c-.8.2-2,1-2,0s1-1.8-.9-2H93.3c-1.9.2-.8,1.3-.8,2s-1.3.2-2,0a.8.8,0,0,0,0,1.6h0c1.5.2,2.6.4,2.5,1.4s1.9,1.5,4,1.5,4.2-.3,4-1.5,1-1.2,2.6-1.4a.8.8,0,0,0,0-1.6Z"
        />
        <path
          d="M103.6,167.7c-.8.3-2,1-2,0s1-1.7-.9-2H93.3c-1.9.3-.8,1.4-.8,2s-1.3.3-2,0a.8.8,0,0,0-.8.9.8.8,0,0,0,.8.8h0c1.5.2,2.6.4,2.5,1.4s1.9,1.4,4,1.4,4.2-.3,4-1.4,1-1.2,2.6-1.4a.9.9,0,0,0,1-.8A.9.9,0,0,0,103.6,167.7Z"
        />
        <path
          d="M102.3,139.3c-.6.2-1.6.8-1.7,0s.9-1.4-.7-1.6h-6c-1.5.2-.6,1.1-.6,1.6s-1,.2-1.7,0a.7.7,0,0,0-.7.6.6.6,0,0,0,.6.7h.1c1.2.2,2.1.4,2.1,1.1s1.5,1.2,3.2,1.2,3.3-.2,3.2-1.2.9-.9,2-1.1.8-.1.8-.5a.7.7,0,0,0-.5-.8Z"
        />
        <path
          d="M102.3,132.9c-.6.1-1.6.7-1.7,0s.9-1.5-.7-1.6h-6c-1.5.1-.6,1.1-.6,1.6s-1,.1-1.7,0a.6.6,0,0,0-.7.5c-.1.4.2.7.6.8h.1c1.2.1,2.1.3,2.1,1s1.5,1.2,3.2,1.2,3.3-.2,3.2-1.2.9-.9,2-1,.8-.2.8-.6a.6.6,0,0,0-.5-.7Z"
        />
        <path
          d="M102.3,126.4c-.6.1-1.6.8-1.7,0s.9-1.5-.7-1.6h-6c-1.5.1-.6,1.1-.6,1.6s-1,.1-1.7,0a.6.6,0,0,0-.6.6.7.7,0,0,0,.6.7c1.2.2,2.1.3,2.1,1.1s1.5,1.2,3.2,1.2,3.3-.3,3.2-1.2.9-.9,2-1.1a.8.8,0,0,0,.8-.6.7.7,0,0,0-.6-.7Z"
        />
        <path
          d="M102.8,86c-.7.1-1.8.6-1.8,0s.9-1.1-.8-1.3H93.8c-1.7.2-.8.9-.8,1.3s-1.1.1-1.8,0-1.3.9,0,1.1,2.3.2,2.2.8,1.7,1,3.6,1,3.6-.2,3.5-1,.9-.7,2.3-.8S103.4,85.9,102.8,86Z"
        />
        <path
          d="M102.8,80.6c-.7.1-1.8.6-1.8,0s.9-1.2-.8-1.3H93.8c-1.7.1-.8.9-.8,1.3s-1.1.1-1.8,0-1.3.9,0,1,2.3.3,2.2.9,1.7,1,3.6,1,3.6-.2,3.5-1,.9-.8,2.3-.9S103.4,80.4,102.8,80.6Z"
        />
        <path
          d="M102.8,91.6c-.7.1-1.8.7-1.8,0s.9-1.3-.8-1.4H93.8c-1.7.1-.8,1-.8,1.4s-1.1.1-1.8,0-1.3,1,0,1.1,2.3.3,2.2,1,1.7,1,3.6,1,3.6-.2,3.5-1,.9-.8,2.3-1S103.4,91.4,102.8,91.6Z"
        />
        <path
          d="M106.3,192.3c-.9.2-3.7,1.2-3.7,0s1.2-2.2-1.1-2.4h-9c-2.3.2-1,1.6-1,2.4s-2.8.3-3.7,0a.9.9,0,0,0-1,1,1,1,0,0,0,1,1c1.8.2,4.4.5,4.3,1.6s2.3,1.9,5,1.9,5-.4,5-1.9,2.5-1.4,4.3-1.6a1.1,1.1,0,0,0,1-1.1C107.3,192.7,106.8,192.2,106.3,192.3Z"
        />
        <path
          d="M109.7,233.2c-1.3.4-5,1.7-5.1,0s1.7-2.9-1.4-3.3H90.8c-3.1.4-1.4,2.3-1.4,3.3s-3.8.4-5.1,0a1.3,1.3,0,0,0-1.3,1.4,1.4,1.4,0,0,0,1.3,1.4c2.6.3,6,.6,5.9,2.2s3.2,2.5,6.8,2.5,6.9-.5,6.7-2.5,3.4-1.9,6-2.2a1.4,1.4,0,0,0,1.3-1.4A1.3,1.3,0,0,0,109.7,233.2Z"
        />
        <path
          d="M107.1,211.7c-1,.3-4,1.4-4,0s1.4-2.3-1.1-2.6H92.1c-2.5.3-1.1,1.8-1.1,2.6s-3,.3-4.1,0a1.2,1.2,0,0,0-1.2,1,1.1,1.1,0,0,0,1,1.2h.2c2,.3,4.8.5,4.7,1.8s2.5,2,5.4,2,5.5-.4,5.4-2,2.7-1.5,4.8-1.8a1.1,1.1,0,0,0,1.2-1,1.3,1.3,0,0,0-1.1-1.2Z"
        />
        <path
          d="M108.1,222c-1.1.3-4.4,1.5-4.4,0s1.5-2.6-1.3-2.9H91.6c-2.8.3-1.3,2-1.3,2.9s-3.3.3-4.4,0a1.2,1.2,0,0,0-1.4,1.1,1.3,1.3,0,0,0,1.1,1.3h.3c2.2.3,5.3.6,5.2,2s2.7,2.2,5.9,2.2,6-.4,5.9-2.2,3-1.7,5.2-2,1.8-.2,1.8-1.2a1.7,1.7,0,0,0-1.8-1.7Z"
        />
        <path
          d="M107.1,201.8c-1,.2-4,1.3-4,0s1.4-2.4-1.1-2.7H92.1c-2.5.3-1.1,1.8-1.1,2.7s-3,.2-4.1,0a1,1,0,0,0-1.2.9,1.1,1.1,0,0,0,1,1.2h.2c2,.3,4.8.6,4.7,1.9s2.5,2,5.4,2,5.5-.4,5.4-2,2.7-1.6,4.8-1.9a1.1,1.1,0,0,0,1.2-1,1.3,1.3,0,0,0-1.1-1.2Z"
        />
        <path
          d="M114.7,239.2c-1.7-5.4-5.3-2-8,1.3a16.1,16.1,0,0,1-5,4,10,10,0,0,1-9.2,0,16.1,16.1,0,0,1-5-4c-2.7-3.4-6.4-6.7-8-1.3s-.8,10.6,3,13S82,258,85.2,261s1.7,5,4.7,6.3,1.2,5,3,6.2,0,3.5,1.3,4.1,1.3,2,3,2,2.2-1.7,3-2,.2-3.4,1.2-4.1,1-5.4,3-6.2,1.6-3.4,4.7-6.3,0-7,2.7-8.8S116.6,245.5,114.7,239.2Z"
        />
      </g>
      <g id="xp_vertebral_column_selection" hidden>
        <path
          class="bone"
          disabled
          d="M86.2,104.1h.7c1.3-.1,2.4-2.7,0-3.3a70.4,70.4,0,0,0-10.3.8A96.3,96.3,0,0,1,86.2,104.1Z"
        />
        <path
          class="bone"
          disabled
          d="M108.1,104.1h-.7c-1.3-.1-2.4-2.7,0-3.3a70.4,70.4,0,0,1,10.3.8A96.3,96.3,0,0,0,108.1,104.1Z"
        />
        <path
          class="bone"
          disabled
          d="M147.5,105.2c-.2-.7-2-1.4-6.1-2.1-12.6-2.1-20.4-2.5-35.4,3.5l-.5.3a2.1,2.1,0,0,1,.4.6c.8,1.5,1.8,3.4,2.6,5.3a3.3,3.3,0,0,0,2.3-.9c4.2-4.8,18.7-5,27.6-3.8,3.5.5,7.1,2,7.6,1.4s-.2-1.5.2-2.3S147.8,106,147.5,105.2Z"
        />
        <path
          class="bone"
          disabled
          d="M85.6,112.8c.8-1.9,1.8-3.8,2.5-5.3l.5-.6-.6-.3c-15-6-22.8-5.6-35.4-3.5-4,.7-5.8,1.4-6.1,2.1s.8.9,1.4,2-.3,1.8.2,2.3,4.1-.9,7.6-1.4c8.9-1.2,23.3-1,27.6,3.8A2.8,2.8,0,0,0,85.6,112.8Z"
        />
        <path
          class="bone"
          disabled
          d="M141.3,156.2c-.2-1.8-3.8-3.4-3.8-3.4s4.5-1.7,4.4-4.2-7-6.5-7-6.5,4-.9,4.4-4.4-4.3-5-4.3-5a3.8,3.8,0,0,0,2.4-3.8c-.2-2.8-4.7-5.9-4.7-5.9s3.2-1.3,2.3-3.8-8.5-6.4-8.5-6.4a5.9,5.9,0,0,0,.4-3,40.7,40.7,0,0,0-5.2.4c0,1.3-.4,2.9-3.2,3.2l-9.6.4a12.3,12.3,0,0,1,.8,3.8l7.2-.4a26.7,26.7,0,0,0,6.8-1.5s6.9,4.4-1.4,5.6a132.9,132.9,0,0,1-14,.8,41.4,41.4,0,0,0-2,4.3h8.3a121.5,121.5,0,0,0,12.1-1.7s7.4,4.3-3.5,6c-3.6.5-12.6.9-18,1a15,15,0,0,0-.2,2.2v2.4c4.6.2,12.6-.1,15-.3s8.6-1.2,8.6-1.2,8.8,4-3.8,6.2c-3.5.6-14.3.3-19.8,0V145a97.5,97.5,0,0,0,16.2.5c2.9-.3,7.7-1.3,7.7-1.3s11.9,4.1-2.8,7.1a40.6,40.6,0,0,1-21-2v6l.6.6c.7.9.2,1.2-.6,1.3.1,5.6.2,11.5.4,16.6s4,4.8,5.9,8.4l1.2,2-3.1-2.8c-1.2-.9-3-2.3-4-1.5s-.2,2,1.3,3.7a71.4,71.4,0,0,0,5.4,5.6,57.7,57.7,0,0,0,6.8,4l3.1,3.4a13.1,13.1,0,0,0,7.4,3.7c1.5.1,6.7.8,7.6-4.1.3-1.8-1.2-5.8-1.3-6s3.7-.5,4.4-3.7-2-6-2-6a6.7,6.7,0,0,0,2.6-4.2c.5-3.3-2.3-6-2.3-6s2.3-2,2.6-3.5-3.6-5.3-3.6-5.3S141.7,160,141.3,156.2Zm-30.7-.6c3.3,1.1,10.7,1.2,13.7.9a91.8,91.8,0,0,0,9.1-1.9s5,4.6-6.5,6.2c-3.3.5-10.6.3-16-2.9-1.3-.8-1.7-2.8-.3-2.3Zm.4,9.8c-1.4-1.6-1.5-3.7,1-2.4s6.5,2.1,11.2,2.3a33.5,33.5,0,0,0,9.5-1.3s5.9,4.2-1.9,5.8C121.4,171.6,113.4,168.4,111,165.4Zm16.9,30.2c-2.6-.8-5.1-2.9-3.2-2.5a17.1,17.1,0,0,0,6.7-.7,4.4,4.4,0,0,1,.6,1.6c.2,1-1.5,2.4-4.1,1.6Zm7.6-10c-.9,1.1-4.6,2.3-6.9,2.2-7.2-.2-10.6-3.2-11.9-4.3s-2-2,.8-1.2A28.8,28.8,0,0,0,128,184a36.7,36.7,0,0,0,7.4-1.1s1,1.7.1,2.7Zm-2-7.1c-7.7,2-15.7-.3-18-2.3s-3.3-3.5-1-3.2,3.2.7,5.4,1.1a26.4,26.4,0,0,0,7.4.3,21,21,0,0,0,5-.9l2.7-.6s3.6,4.2-1.5,5.6Z"
        />
        <path
          class="bone"
          disabled
          d="M69.6,140.9c-12.7-2.2-3.9-6.2-3.9-6.2s5.7,1,8.6,1.2,10.1.5,14.7.3v-2.4a13.4,13.4,0,0,0-.1-2.1c-5.5-.2-14.2-.6-17.7-1.1-11-1.7-3.6-6-3.6-6,4,.8,8.1,1.3,12.2,1.7h8a41.4,41.4,0,0,0-2-4.3,124.4,124.4,0,0,1-13.7-.8c-8.4-1.2-1.5-5.6-1.5-5.6a26.5,26.5,0,0,0,6.9,1.5l6.9.4a12.3,12.3,0,0,1,.8-3.8l-9.4-.3c-2.8-.4-3.2-1.9-3.2-3.3a41.2,41.2,0,0,0-5.1-.3,7.7,7.7,0,0,0,.3,3s-7.2,2.5-8.5,6.3,2.4,3.8,2.4,3.8-4.6,3.1-4.7,6a3.7,3.7,0,0,0,2.4,3.7s-4.5,2.3-4.2,5.1,4.3,4.4,4.3,4.4-7,3-7,6.5,4.5,4.1,4.5,4.1-3.7,1.7-3.9,3.5c-.3,3.8,3.8,5.3,3.8,5.3s-4,2.2-3.6,5.2,2.6,3.6,2.6,3.6-2.8,2.7-2.3,6a6.5,6.5,0,0,0,2.6,4.1s-2.8,2.8-2,6,4.4,3.8,4.4,3.8-1.6,4.1-1.3,5.9c.9,4.9,6.1,4.3,7.6,4.2a13.1,13.1,0,0,0,7.4-3.7,47.7,47.7,0,0,0,3.2-3.7,35.6,35.6,0,0,0,6.5-3.8,54.9,54.9,0,0,0,5.3-5.5c1.6-1.8,2.4-3,1.4-3.8s-2.8.7-4,1.5l-2.6,2.4.9-1.5c1.8-3.5,4.1-4.6,5.6-7.8.2-5.3.3-11.4.4-17.2-.6-.2-.9-.6-.3-1.3l.3-.3c0-2.2,0-4.2.1-6.2a42.1,42.1,0,0,1-20.8,1.9c-14.7-3-2.8-7.1-2.8-7.1s4.7,1,7.7,1.3A103.9,103.9,0,0,0,89,145v-4.1C83.5,141.2,73,141.5,69.6,140.9Zm-10.3,32,2.6.6a21.9,21.9,0,0,0,5,.9,27,27,0,0,0,7.5-.3c2.2-.4,3-.8,5.3-1.1s1.3,1.3-.9,3.2-10.4,4.2-18,2.3c-5.1-1.4-1.5-5.6-1.5-5.6Zm-.5,12.7c-.8-1,.1-2.7.1-2.7a36.7,36.7,0,0,0,7.4,1.1,28.8,28.8,0,0,0,10.5-1.7c2.9-.7,1.5.7.8,1.3s-4.7,4-11.9,4.2c-2.3.1-5.9-1-6.9-2.2Zm7.6,10c-2.6.8-4.3-.6-4.1-1.6a5.2,5.2,0,0,1,.6-1.6,17.1,17.1,0,0,0,6.7.7c1.9-.4-.6,1.7-3.2,2.5Zm17-30.2c-2.4,2.9-10.5,6.2-19.9,4.4-7.7-1.6-1.9-5.9-1.9-5.9a30.6,30.6,0,0,0,9.4,1.4c4.8-.2,8.8-1,11.3-2.3s2.4.8,1,2.4ZM60.9,154.6a73.2,73.2,0,0,0,9.1,1.8c3,.4,10.5.3,13.8-.8,1.4-.5,1,1.5-.3,2.3-5.5,3.2-12.7,3.4-16,2.9-11.6-1.6-6.6-6.2-6.6-6.2Z"
        />
        <rect
          id="xp_vertebral-column_4"
          index="xp_vertebral-column_4"
          class="region"
          x="77"
          y="242.3"
          width="40.1"
          height="39.09"
        />
        <rect
          id="xp_vertebral-column_3"
          index="xp_vertebral-column_3"
          class="region"
          x="77"
          y="189.7"
          width="40.1"
          height="51.52"
        />
        <rect
          id="xp_vertebral-column_2"
          index="xp_vertebral-column_2"
          class="region"
          x="77"
          y="102.4"
          width="40.1"
          height="86.21"
        />
        <path
          id="xp_vertebral-column_1"
          index="xp_vertebral-column_1"
          class="region"
          d="M117,92.5c-2.8-.7-4.5-1.3-5.1-1.9s-1.4-6.5-.8-11.2H82.9c.6,4.7.8,9.8-.7,11.2s-2.3,1.2-5.2,1.9v8.8h40Z"
        />
      </g>
      <g id="xp_lower_extremities_bone" class="bone" disabled>
        <path
          d="M87.9,571c-1.1-.4-2.7-.5-3.4.4a1.1,1.1,0,0,0-.2.8c0,.6.7.8.8,1.4s-.6,1.2-.7,1.8,1.7,1.6,2.5,1.2.5-1,.7-1.6.7-.6,1-1.1a2.1,2.1,0,0,0-.5-2.8Z"
        />
        <path
          d="M79.9,548.2c-.7.4-.4,1.1-.5,1.9a31,31,0,0,1-1.1,5.1l-.3.8a1.3,1.3,0,0,0,.5,1.7.8.8,0,0,0,.7.2,2.3,2.3,0,0,0,1.1-.3c.6-.4.6-.7.5-1.4-.4-3.2,1.4-6.7,1-7.4a1.2,1.2,0,0,0-1.7-.7Z"
        />
        <path
          d="M71.7,564.2c0-.1-.3-.2-.3-.1s.1,1.5-.4,2.4a16.2,16.2,0,0,1-1,1.8c-.2.3-.4.4-.5.8s.1.8,0,1.2-.3.7-.1,1a.5.5,0,0,0,.8,0c.5-.6.1-1.4,1-1.6a4.8,4.8,0,0,0,0-1.2,7.3,7.3,0,0,1,.5-.9c.3-.6.4-1.3,1-1.5s.7,0,1-.4.1-.6-.2-.9l-.8-.2c-.5,0-.8.1-.9-.2S71.8,564.3,71.7,564.2Z"
        />
        <path
          d="M69.5,563.2c-.4-.6-.7,0-1.3-.3v-.2l-.4-.3c-.9.3.2,1.4-.3,2.1l-1,1.7c-.2.3-.5.3-.5.7a4,4,0,0,0,0,1.1c0,.3-.3.5-.1.9s.4.2.6,0,.2-1.3,1-1.4,0-.8.1-1.1a2.2,2.2,0,0,1,.5-.8c.3-.5.4-1.1,1-1.3s.4.1.5-.3A.8.8,0,0,0,69.5,563.2Z"
        />
        <path
          d="M66.1,562.8c-.4.1-.5.5-.7.8l-.3.6c-.1.2,0,.4-.1.7s-.4.6-.8,1-.3.2-.4,0a.7.7,0,0,1,.1-.6c.1-.2,0-.5,0-.8s.2-.2.4-.4l.6-1.1c.4-.5-.3-1.2.3-1.4h.2c0,.1.1.2.1.3s.7-.1,1,.3S66.9,562.6,66.1,562.8Z"
        />
        <path
          d="M75.4,571.6a7.5,7.5,0,0,0,.1-2.6,1,1,0,0,1,.5-.8,1.7,1.7,0,0,1,1.2-.4,1.8,1.8,0,0,1,.9.4.9.9,0,0,1,.3,1l-.3.8c-.4,1.2-.6,2.4-1,3.6s-1.7,1.2-2.2.2A2.5,2.5,0,0,1,75.4,571.6Z"
        />
        <path
          d="M86,536.2c1.6.2,3.3,1.1,3.5,2.7a6.1,6.1,0,0,0,2.3,3.7,3.6,3.6,0,0,1,1.2,2.8c.1,1.8.1,5.3-1.7,5.2a3.5,3.5,0,0,1-2.7-1.7c-1-1-2.7-1.3-4.9-1.1s-3.2-1.4-5.1-1.2-2.4,1-3.7,1.4-1.9-1.1-.9-2a24.9,24.9,0,0,1,3-1.9c2.8-1.6,2-4.6,2.4-5.8S84.1,536.1,86,536.2Z"
        />
        <path
          d="M89.3,563.7c.7,1.1,1.5,2.8.1,2.8a7.7,7.7,0,0,0-2.2-2.2c-.9-.4-2,.5-3,1.6s-.3-.1-.4-.3.3-2.8.4-3.9-.5-2.6-1-4,.1-2.1.1-2.1,1.9-2,3.7-1.6a1.9,1.9,0,0,1,1.1.7,3.5,3.5,0,0,1,1,2.2,10.1,10.1,0,0,1-.2,3A4.6,4.6,0,0,0,89.3,563.7Z"
        />
        <path
          d="M83.1,554.3c0,.1.1.1.2.1h0a4.6,4.6,0,0,1,2.7-1.5c1.3-.2,3.2,1.3,3.5,1.7s.5-.5.4-.9-1.2-3.5-2.3-4.1a5,5,0,0,0-3.8-.2,2.7,2.7,0,0,0-1.3,1.3,2.8,2.8,0,0,0-.2,2A5.3,5.3,0,0,0,83.1,554.3Z"
        />
        <path
          d="M75,556.2c-.3-.2,2-7.9,2-7.9l.5-.3c1.5-.4,1.2.1,1.2.1-1.3,2.5-1.5,7.4-1.8,7.9S76.4,557.1,75,556.2Z"
        />
        <path
          d="M71.9,552.3l1-2.4H73c.1,0,.7-.3.6.1s-.9,2.5-.9,2.5a18.7,18.7,0,0,0-.7,1.8c-.1.1-.6.2-.7,0S71.7,552.8,71.9,552.3Z"
        />
        <path
          d="M75.6,549.6c-.1.3-1.8,5.8-1.8,6s-.6,0-.8-.3.2-1.4.4-2.1V553s1-3.1,1-3.3S75.8,549.2,75.6,549.6Z"
        />
        <path
          d="M77.5,564.5l-.9.2c-.1.1-.2,0-.3-.1h0c-.3-1.1.9-2,1-3.2s-.4-2.8,1.3-2.4h1.3c.3.2.6.3.5.7l-.4,5.2s-.1.4-.8.1l-.5-.3Z"
        />
        <path
          d="M72.4,562.6a6.1,6.1,0,0,1,.5-1.2,5.4,5.4,0,0,1,.5-1.1,5,5,0,0,0,.8-1.2c.2-.4,0-1.2.5-1.3a1.7,1.7,0,0,1,1.4.2c.1.3-.2.8-.4,1.3l-1.5,2.9c-.4,1-.3,1.4-.7,1.4l-.8-.4A.9.9,0,0,1,72.4,562.6Z"
        />
        <path
          d="M75.8,566.2s-.5.4-.4.6a.4.4,0,0,0,.4.3,2.7,2.7,0,0,1,1.5-.3,3.5,3.5,0,0,1,1.6.8c.3.2.5-.3.5-.8a1,1,0,0,0-.6-1l-.7-.2a4.4,4.4,0,0,0-2.3.6"
        />
        <path
          d="M73.1,557.3a8.9,8.9,0,0,1-1.6,2.2,4.7,4.7,0,0,0-.7,1.2,3.7,3.7,0,0,1-.6,1.4c-.3,0-1.5-.2-1.5-.4s3.1-5,3.4-5.3S73.3,556.6,73.1,557.3Z"
        />
        <path d="M67.4,561.2c-.2,0-1.5-.2-1.6-.5s1.5-2.1,2.5-2.9,1.1-2,2.1-2.5,1.2.1.9.6l-3.5,5Z" />
        <path
          d="M87.8,569.8h.3s1.6-.5,1.2-1.6-2-2.8-2.5-2.7-.7-.1-1.9,1.3a4.7,4.7,0,0,0-.6,1.5,1,1,0,0,0,.5,1H86a4.1,4.1,0,0,1,1.5.7Z"
        />
        <path
          d="M137.5,275.4c-2.9.1-2.1,2.7-3.6,2s-.2-2.6.3-3.9.1-3.9-1.8-4.6-6.2,1.8-7.4,4.1a15.8,15.8,0,0,0-1.6,8c.4,2.7,3.4,1.6,5.6,2.2s2.4,5.4,1.2,8.3-1.9,3.9-.9,7.4-3,27.2-5.8,46.9c-2,13.4-5.9,34.6-9,47.3-1.4,5.4-4.7,15.1-6,16.7-3.8,4.2-4.7,8.3-3,14.3,1,4,3.5,4.9,5.4,4.5s1.5-2.1,1.1-3.1-1.8-4.2-1.3-7.3a7.2,7.2,0,0,1,8.3-5.7,7,7,0,0,1,3.3,1.7c2.2,1.9,3,5.4,2.2,8.6s-1.4,2.9-1,4.2,2.9,1.1,5.2-.9c.7-.7,2-2.1,1-8.7s-4-6.2-4.5-12.1,5.9-46.8,7.2-54.7,6.4-45.1,6.6-46.7c.4-3.6,4-7.7,5.1-13C146.9,277.6,140.4,275.3,137.5,275.4Z"
        />
        <path
          d="M106.1,571c1.1-.4,2.7-.5,3.4.4a1.1,1.1,0,0,1,.2.8c0,.6-.7.8-.8,1.4s.6,1.2.8,1.8-1.8,1.6-2.6,1.2-.4-1-.7-1.6-.6-.6-1-1.1a2.1,2.1,0,0,1,.5-2.8Z"
        />
        <path
          d="M114.1,548.2c.7.4.4,1.1.5,1.9a31,31,0,0,0,1.1,5.1l.3.8a1.2,1.2,0,0,1-.5,1.7.8.8,0,0,1-.7.2,2.3,2.3,0,0,1-1.1-.3,1.2,1.2,0,0,1-.5-1.4c.4-3.2-1.4-6.7-1-7.4a1.4,1.4,0,0,1,1.8-.7Z"
        />
        <path
          d="M122.3,564.2c.1-.1.3-.2.3-.1s-.1,1.5.4,2.4a16.2,16.2,0,0,0,1,1.8c.2.3.5.4.5.8a4.8,4.8,0,0,1,0,1.2c.1.4.3.7.1,1s-.5.2-.7,0-.1-1.4-1-1.6,0-.8-.1-1.2a2.6,2.6,0,0,0-.5-.9c-.3-.6-.4-1.3-1-1.5s-.7,0-.9-.4-.1-.6.2-.9l.7-.2c.5,0,.8.1.9-.2S122.2,564.3,122.3,564.2Z"
        />
        <path
          d="M124.5,563.2c.4-.6.7,0,1.3-.3v-.2l.4-.3c.9.3-.1,1.4.3,2.1l1,1.7c.2.3.4.3.5.7a4,4,0,0,1,0,1.1c0,.3.3.5.1.9s-.4.2-.6,0-.2-1.3-1-1.4,0-.8-.1-1.1a5.6,5.6,0,0,0-.5-.8c-.3-.5-.4-1.1-1-1.3s-.4.1-.5-.3A.8.8,0,0,1,124.5,563.2Z"
        />
        <path
          d="M127.9,562.8c.4.1.5.5.7.8l.3.6c.1.2,0,.4.1.7s.4.6.8,1,.3.2.4,0a.7.7,0,0,0-.1-.6c-.1-.2,0-.5,0-.8s-.3-.2-.4-.4L129,563c-.3-.5.4-1.2-.2-1.4h-.3a.4.4,0,0,1-.1.3c-.3.2-.7-.1-1,.3S127.1,562.6,127.9,562.8Z"
        />
        <path
          d="M118.6,571.6a7.5,7.5,0,0,1-.1-2.6,1,1,0,0,0-.5-.8,1.7,1.7,0,0,0-1.2-.4,1.2,1.2,0,0,0-.8.4.8.8,0,0,0-.4,1l.3.8c.5,1.2.6,2.4,1,3.6s1.7,1.2,2.2.2A2.5,2.5,0,0,0,118.6,571.6Z"
        />
        <path
          d="M108,536.2c-1.6.2-3.3,1.1-3.5,2.7a6.1,6.1,0,0,1-2.3,3.7,3.3,3.3,0,0,0-1.2,2.8c0,1.8-.1,5.3,1.7,5.2a3.7,3.7,0,0,0,2.7-1.7c.9-1,2.7-1.3,4.9-1.1s3.1-1.4,5-1.2,2.4,1,3.8,1.4,1.8-1.1.8-2l-2.9-2c-2.8-1.5-2-4.6-2.4-5.7S109.9,536.1,108,536.2Z"
        />
        <path
          d="M128.6,430.8c.4-1.3-.4-2.5-1.1-2.2-2.6,1-3.3,1.1-5,.3s-2.9,1.2-4.9,1.3-3-2-4.2-1.2-4.1,1.7-6,.8a.9.9,0,0,0-1.1.1,2,2,0,0,0-1.2,1.6c-.1.9.3,2.2,1.8,4.7,6.4,10.9,3.5,31,2.5,45.4-3,39.5-6.4,39.6-7.3,52.2-.1,1,.6,2.5,1.4,2.6s3-1.2,5.3-1.3a28.5,28.5,0,0,1,6.5,1.1c2,.8.4-3.6,0-7.3-1.2-9,3.6-48.9,4.4-55.2s2.6-26.1,3.4-30S127.5,434.8,128.6,430.8Z"
        />
        <path
          d="M104.7,563.7c-.7,1.1-1.5,2.8-.1,2.8a7.7,7.7,0,0,1,2.2-2.2c.9-.4,2,.5,3,1.6s.3-.1.4-.3-.3-2.8-.4-3.9.5-2.6.9-4-.1-2.1-.1-2.1-1.8-2-3.6-1.6a1.9,1.9,0,0,0-1.1.7,3,3,0,0,0-1,2.2,10.1,10.1,0,0,0,.2,3C105.4,561.4,105.6,562.4,104.7,563.7Z"
        />
        <path
          d="M111,554.3h-.3a4.6,4.6,0,0,0-2.7-1.5c-1.3-.2-3.2,1.3-3.5,1.7s-.5-.5-.4-.9,1.2-3.5,2.4-4.1a4.7,4.7,0,0,1,3.7-.2,2.7,2.7,0,0,1,1.3,1.3,2.8,2.8,0,0,1,.2,2A5.1,5.1,0,0,1,111,554.3Z"
        />
        <path
          d="M119,556.2c.3-.2-2-7.9-2-7.9l-.5-.3c-1.5-.4-1.2.1-1.2.1,1.3,2.5,1.5,7.4,1.8,7.9S117.6,557.1,119,556.2Z"
        />
        <path
          d="M122.1,552.3l-1-2.4H121c-.1,0-.7-.3-.6.1s.9,2.5.9,2.5l.7,1.8c.1.1.6.2.7,0S122.3,552.8,122.1,552.3Z"
        />
        <path
          d="M118.4,549.6c.1.3,1.8,5.8,1.8,6s.6,0,.8-.3-.2-1.4-.4-2.1V553s-.9-3.1-1-3.3S118.2,549.2,118.4,549.6Z"
        />
        <path
          d="M116.5,564.5l.9.2a.2.2,0,0,0,.3-.1h0c.3-1.1-.9-2-1-3.2s.4-2.8-1.3-2.4h-1.3c-.3.2-.5.3-.5.7l.4,5.2s.1.4.8.1l.5-.3Z"
        />
        <path
          d="M121.6,562.6a6.1,6.1,0,0,0-.5-1.2,5.4,5.4,0,0,0-.5-1.1,4.7,4.7,0,0,1-.7-1.2c-.2-.4-.1-1.2-.6-1.3a1.7,1.7,0,0,0-1.4.2c-.1.3.2.8.4,1.3l1.5,2.9c.4,1,.3,1.4.7,1.4l.9-.4A1.4,1.4,0,0,0,121.6,562.6Z"
        />
        <path
          d="M118.2,566.2s.5.4.4.6a.4.4,0,0,1-.4.3,2.7,2.7,0,0,0-1.5-.3,3.5,3.5,0,0,0-1.6.8c-.3.2-.5-.3-.5-.8a1.1,1.1,0,0,1,.6-1l.7-.2a4.4,4.4,0,0,1,2.3.6"
        />
        <path
          d="M121,557.3c.3,1,1,1.4,1.5,2.2a2.9,2.9,0,0,1,.7,1.2c.2.4.5,1.3.7,1.4s1.5-.2,1.5-.4a53.7,53.7,0,0,0-3.5-5.3C121.7,556.1,120.7,556.6,121,557.3Z"
        />
        <path
          d="M126.6,561.2c.2,0,1.5-.2,1.6-.5s-1.5-2.1-2.5-2.9-1.1-2-2.1-2.5-1.2.1-.9.6l3.5,5Z"
        />
        <path
          d="M106.2,569.8h-.3s-1.6-.5-1.2-1.6,2-2.8,2.5-2.7.7-.1,1.9,1.3a4.7,4.7,0,0,1,.6,1.5,1,1,0,0,1-.5,1H108a4.1,4.1,0,0,0-1.5.7Z"
        />
        <path
          d="M112.1,418.3c.8-3.9,6-4,7.8-3.3s3.6,3.8,3.5,6.2-2.3,7.4-5.9,7.2S111.1,423.4,112.1,418.3Z"
        />
        <path
          d="M56.5,275.4c2.9.1,2.1,2.7,3.5,2s.3-2.6-.2-3.9-.1-3.9,1.8-4.6,6.2,1.8,7.4,4.1a15.8,15.8,0,0,1,1.6,8c-.4,2.7-3.4,1.6-5.6,2.2s-2.4,5.4-1.2,8.3,1.9,3.9.8,7.4,3,27.2,5.9,46.9c2,13.4,5.9,34.6,9,47.3,1.3,5.4,4.7,15.1,6,16.7,3.8,4.2,4.7,8.3,3,14.3-1,4-3.5,4.9-5.4,4.5s-1.5-2.1-1.1-3.1,1.8-4.2,1.3-7.3a7.2,7.2,0,0,0-8.3-5.7,7.8,7.8,0,0,0-3.4,1.7,8.7,8.7,0,0,0-2.1,8.6c.5,2.1,1.4,2.9,1,4.2s-2.9,1.1-5.2-.9c-.7-.7-2-2.1-1.1-8.7s4-6.2,4.6-12.1-5.9-46.8-7.2-54.7-6.4-45.1-6.6-46.7c-.4-3.6-4.1-7.7-5.2-13C47.1,277.6,53.6,275.3,56.5,275.4Z"
        />
        <path
          d="M65.4,430.8c-.4-1.3.4-2.5,1-2.2,2.7,1,3.4,1.1,5,.3s3,1.2,5,1.3,3-2,4.1-1.2,4.2,1.7,6.1.8a.9.9,0,0,1,1.1.1,2,2,0,0,1,1.2,1.6c.1.9-.4,2.2-1.8,4.7-6.4,10.9-3.5,31-2.5,45.4,3,39.5,6.4,39.6,7.3,52.2.1,1-.6,2.5-1.4,2.6s-3-1.2-5.3-1.3a28.5,28.5,0,0,0-6.5,1.1c-2,.8-.4-3.6,0-7.3,1.2-9-3.6-48.9-4.4-55.2s-2.6-26.1-3.4-30S66.5,434.8,65.4,430.8Z"
        />
        <path
          d="M81.9,418.3c-.8-3.9-6-4-7.8-3.3s-3.6,3.8-3.5,6.2,2.3,7.4,5.9,7.2S82.9,423.4,81.9,418.3Z"
        />
      </g>
      <g id="xp_lower_extremities_selection" hidden>
        <g id="xp_lower_extremities_5" index="xp_lower_extremities_5" class="region">
          <path
            d="M103,577.8a3.9,3.9,0,0,0,2.8,1.1c8.1,0,26.5-5.3,26.5-14,0-2.6-2.5-6.1-5.3-10.2s-5.5-7.9-7.3-12.4H100.2c.2,1.6.3,3.3.5,4.9a110.1,110.1,0,0,1,.9,11.8c0,1.3-.1,2.8-.2,4.5C101,568.7,100.6,575.2,103,577.8Z"
          />
          <path
            d="M74.3,542.3c-1.8,4.5-4.7,8.7-7.3,12.4s-5.3,7.7-5.3,10.2c0,8.7,18.4,14,26.5,14a3.6,3.6,0,0,0,2.8-1.1c2.4-2.6,2-9,1.6-14.3-.1-1.6-.2-3.2-.2-4.4a113.7,113.7,0,0,1,.9-11.9c.2-1.6.3-3.3.5-4.9Z"
          />
        </g>
        <g id="xp_lower_extremities_4" index="xp_lower_extremities_4" class="region">
          <path
            d="M117.9,533.9c0-5.4,2.7-14.9,5.7-26,1.3-4.7,2.7-9.7,4-14.9H100.7c.8,8.6,1.6,15.3,1.6,15.4a115.1,115.1,0,0,1-1.5,16.6c-.5,3.5-.8,7-1,10.5,0,1.6.2,3.6.4,5.7h19.1A23,23,0,0,1,117.9,533.9Z"
          />
          <path
            d="M93.2,525a115,115,0,0,1-1.5-16.5c0-.2.8-6.9,1.6-15.5H66.4c1.3,5.2,2.7,10.2,4,14.9,3,11,5.7,20.6,5.7,26a23,23,0,0,1-1.4,7.3H93.9q.3-3.2.3-5.7A93.2,93.2,0,0,0,93.2,525Z"
          />
        </g>
        <g id="xp_lower_extremities_3" index="xp_lower_extremities_3" class="region">
          <path
            d="M98.8,463.9c0,7.8.9,18.9,1.8,28h27.3c3.2-12.8,6-26.5,6-38.5v-1.7H99.5C99.1,455.7,98.8,459.8,98.8,463.9Z"
          />
          <path
            d="M60.1,453.5c0,12,2.8,25.7,6,38.5H93.4c.9-9.2,1.8-20.3,1.8-28,0-4.1-.3-8.2-.7-12.3H60.1Z"
          />
        </g>
        <g id="xp_lower_extremities_2" index="xp_lower_extremities_2" class="region">
          <path
            d="M132,418c0-4.2,1.6-10.5,3.8-19.2.3-1,.5-2.2.8-3.3H101c.9,21.2,1.7,37,1.7,37.4a36.9,36.9,0,0,1-1.2,8c-.6,2.6-1.3,5.7-1.9,9.7h34.3c-.1-8.1-.6-13.7-1.1-18.7S132,423.1,132,418Z"
          />
          <path
            d="M58.2,398.8c2.2,8.7,3.8,15,3.8,19.2s-.4,9.4-.8,13.9-1,10.7-1.1,18.7H94.3a90.8,90.8,0,0,0-1.8-9.7,36,36,0,0,1-1.2-8c0-.4.7-16.2,1.7-37.4H57.3Z"
          />
        </g>
        <path
          id="xp_lower_extremities_1"
          index="xp_lower_extremities_1"
          class="region"
          d="M147.7,265.6H46.3c-1.4,7.9-2.4,14.8-2.4,19.3,0,53.4,7.8,87.9,13.2,109.5H93c1.5-34.3,3.4-82,3.4-102.1a.6.6,0,0,1,.6-.6.6.6,0,0,1,.5.6h0c0,20.1,1.9,67.8,3.4,102.1h36c5.4-21.6,13.2-56.1,13.2-109.5C150.1,280.4,149.1,273.5,147.7,265.6Z"
        />
      </g>
      <g id="xp_abdomen_selection" hidden>
        <path
          id="xp_abdomen_1"
          index="xp_abdomen_1"
          class="region"
          d="M145.4,253.2c-2.9-15.5-5.9-31.4-5.9-42.4,0-7.5,3.9-33.4,5.9-46.1H48.6c2,12.7,6,38.6,6,46.1,0,11-3,27-6,42.4-2.4,12.8-4.7,24.9-4.7,31.7s.1,12.6.3,18.6H96.3c.1-4.4.1-8,.1-11.2a.6.6,0,0,1,.6-.6.6.6,0,0,1,.5.6h0c0,3.1,0,6.8.2,11.2h52.1c.2-6,.3-12,.3-18.6S147.9,266,145.4,253.2Z"
        />
      </g>
      <path
        id="xp_pelvis_bone"
        class="bone"
        disabled
        d="M131.1,230.6c-9.7-1.8-14.8,2.5-15.1,7-.5,7,4,18.9,1.2,24.8a36.2,36.2,0,0,1-12,14.3c-1.9,1.3-4.1,2.7-5.3,4.9a18.2,18.2,0,0,1-5.7,0c-1.3-2.2-3.5-3.6-5.4-4.9a36.2,36.2,0,0,1-12-14.3c-2.8-5.9,1.7-17.8,1.2-24.8-.3-4.5-5.4-8.8-15.1-7-6.2,1.1-11.4,5.2-11.4,12.5s1.6,18.7,12.1,23.5c4.4,2,7.2,4.3,8,8.6,1.3,6.3-.5,12.7.5,16.7,1.7,6.4,5.9,8.7,11.7,8.6s8.8-5.3,10.4-10.2c0-.1.1-.3.1-.4a4.7,4.7,0,0,0,2.7,1.2h0a4.5,4.5,0,0,0,2.7-1.2v.4c1.6,5,4.8,10.2,10.4,10.2s10-2.2,11.7-8.6c1-4-.8-10.4.5-16.7.8-4.3,3.6-6.6,8-8.6,10.6-4.8,12.1-16.6,12.1-23.5S137.3,231.7,131.1,230.6ZM84.8,293.9c-2.5,1.3-3.7-3.1-4.7-4.8s-3.4-4.3-2.6-7.1,4-2.2,6.3-1.2a9.4,9.4,0,0,1,4.4,5.9C88.4,289,87.1,292.7,84.8,293.9Zm29.1-4.8c-1,1.6-2.2,6.1-4.8,4.8s-3.6-4.9-3.3-7.2a9.4,9.4,0,0,1,4.4-5.9c2.2-1,5.4-1.7,6.2,1.2s-1.1,5-2.5,7.1Z"
      />
      <g id="xp_pelvis_selection" hidden>
        <path
          id="xp_pelvis_2"
          index="xp_pelvis_2"
          class="region"
          d="M47.2,260.5c-1.8,10-3.3,18.9-3.3,24.4s.1,12.8.3,18.7H96.3c.1-4.3.1-8.2.1-11.3a.6.6,0,1,1,1.2,0h0c0,3.1,0,7,.1,11.3h52.1c.2-6,.3-12.2.3-18.7s-1.5-14.4-3.3-24.4Z"
        />
        <path
          id="xp_pelvis_1"
          index="xp_pelvis_1"
          class="region"
          d="M145.4,253.2c-1.5-8.2-3.1-16.6-4.3-24.3H52.9c-1.2,7.7-2.8,16-4.3,24.3l-1.2,6.2h99.2Z"
        />
      </g>
    </g>
    <g id="back-to-default">
      <path
        class="transparent"
        d="M132.7,35c2.8,14.1-5.4,24.2-7.2,22.7-.6,9.6-11.6,24.5-2.5,27.2,67.2,14.7,54.9,14.1,61.4,152.4.6,56-1.5,39.4,9.6,69.1V0H121.7C130.8,7.8,134.4,21.6,132.7,35Z"
      />
      <path
        class="transparent"
        d="M12.2,157.3c4.9-50.3-.5-60.8,56.7-71.9,12.1.3-.4-21.2-.4-27.7-8.6-2.9-8.1-17.8-7.2-22.7C60.7,18.8,63.2,6.8,71.6,0H0V305.8C7.8,288.4,10,296.1,12.2,157.3Z"
      />
      <path class="transparent" d="M37.8,228.7c-1-1-.7-.9-.8,0Z" />
      <path
        class="transparent"
        d="M155.4,346.3c-3.9,35.2-8.9,41.9-14,68.2.7,41.5,7,38.8-13.7,113.6-9.4,20,50.4,50-27.3,51.9H194V334.6C184.1,346.2,177.7,360.1,155.4,346.3Z"
      />
      <path
        class="transparent"
        d="M52.6,564.9c2.7-10.4,16.6-22.4,14.3-32.7-4.6-27.9-21.4-60.9-14.1-111.3-2-27.1-10.8-37.2-14.2-74.6C16.7,355.9,21.1,357,0,335V580H100.3C84.6,579.6,58,582.8,52.6,564.9Z"
      />
    </g>
  </svg>`;case"xp_default":return V` <svg
    id="xp_default"
    hidden
    version="1.1"
    baseProfile="tiny"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0"
    y="0"
    style="width:12rem; height:55rem;"
    viewBox="0 0 192 580"
    xml:space="preserve"
  >
    <path
      class="bone"
      disabled
      d="M71.65,205c2.93-2.09,8-5.4,9.94-7.62c1.64-1.98,3.16-4.07,4.54-6.24c1.31-1.93,1.85-3.3,0.79-3.92s-2.7,1.07-3.74,2.1s-3.66,4.67-5.93,6.82c-2.06,2-7.07,5.12-10.46,8s-5.87,5.67-5.33,7.36C62.27,214,68.75,207.07,71.65,205z"
    />
    <path
      class="bone"
      disabled
      d="M121.25,205c-2.93-2.09-8-5.4-10-7.62c-1.64-1.98-3.15-4.07-4.53-6.24c-1.31-1.93-1.86-3.3-0.8-3.92s2.71,1.07,3.74,2.1s3.67,4.67,5.93,6.82c2.06,2,7.08,5.12,10.46,8c3.38,2.88,5.87,5.67,5.34,7.36C130.62,214,124.14,207.07,121.25,205z"
    />
    <path
      class="bone"
      disabled
      d="M82.56,111.91c1.73,1.94,6,0.39,6.64-2.07c0.4-1.65-0.17-2.51-1.9-3.21c-15-6-22.78-5.63-35.38-3.5c-4.05,0.69-5.87,1.41-6.1,2.08s0.78,0.88,1.32,2c0.41,0.81-0.25,1.75,0.2,2.29s4.12-0.89,7.65-1.36C63.84,106.91,78.33,107.15,82.56,111.91z"
    />
    <path
      class="bone"
      disabled
      d="M110.09,111.91c-1.72,1.94-6,0.39-6.64-2.07c-0.4-1.65,0.18-2.51,1.9-3.21c15-6,22.78-5.63,35.38-3.5c4.06,0.69,5.87,1.41,6.1,2.08s-0.77,0.88-1.31,2c-0.41,0.81,0.24,1.75-0.21,2.29s-4.12-0.89-7.64-1.36C128.81,106.91,114.33,107.15,110.09,111.91z"
    />
    <path
      class="bone"
      disabled
      d="M86.05,104.07c1.3-0.06,2.42-2.73,0-3.32c-3.44,0-6.88,0.29-10.27,0.86c3.24,0.63,6.44,1.46,9.58,2.49L86.05,104.07z"
    />
    <path
      class="bone"
      disabled
      d="M106.6,104.07h0.66c3.14-1.03,6.34-1.86,9.58-2.49c-3.39-0.57-6.82-0.86-10.26-0.86C104.18,101.34,105.33,104,106.6,104.07z"
    />
    <path
      class="bone"
      disabled
      d="M5.42,316.19c-0.23-0.25-0.27,0.18-0.34,0.4c-0.08,0.46-0.12,0.92-0.1,1.39c-0.07,0.43-0.23,0.84-0.49,1.19c-0.29,0.32-0.46,0.74-0.47,1.18c0,0.4,0.32,0.73,0.68,0.48c0.28-0.25,0.5-0.55,0.65-0.89c0.22-0.39,0.38-0.83,0.62-1.21s0.57-0.44,0.9-0.67s0.63-0.51,0.39-0.63C6.55,317.19,5.91,316.76,5.42,316.19z"
    />
    <path
      class="bone"
      disabled
      d="M22.23,317.35c0.22-0.09,0.38-0.27,0.44-0.5c0.11-0.55,0.09-1.12-0.07-1.66c-0.66-2.67-0.51-5.47,0.43-8.06c0.23-0.63,0.31-1.12,0.52-1.76c0.15-0.4,0.15-0.84,0-1.24c-0.4-0.83-1.14-0.73-1.77-0.5c-0.3,0.14-0.57,0.34-0.78,0.6c-0.51,0.81-0.64,1.8-0.36,2.71c0.2,1.2,0.15,2.42-0.13,3.6c-0.15,1.13-0.38,2.25-0.67,3.35c-0.29,0.9-1,2.1-0.55,3.05l0,0C20.11,317.64,21.25,317.8,22.23,317.35z"
    />
    <path
      class="bone"
      disabled
      d="M15.66,300c-0.29-0.35-0.53-0.78-0.83-1.13c-0.52-0.61-0.93-1.05-1.44-0.25c-0.42,0.91-0.77,1.84-1.06,2.8c-0.42,0.95-0.96,1.85-1.61,2.66c-0.56,0.64-1.42,1-1.76,1.83c-0.08,0.17-0.14,0.36-0.17,0.55c-0.01,0.07-0.01,0.15,0,0.22c0.39,0.67,0.96,1.21,1.66,1.55c0.67,0.35,1.47,0.35,2.14,0c0.06-0.08,0.1-0.16,0.13-0.25c0.12-0.47,0.17-0.95,0.16-1.43c0.05-0.55,0.18-1.09,0.39-1.6c0.34-1.05,0.93-2.01,1.72-2.79c0.4-0.33,1.56-0.47,1.43-1.18C16.25,300.59,15.99,300.26,15.66,300z"
    />
    <path
      class="bone"
      disabled
      d="M9.56,308.81c-0.7-0.33-0.79-0.78-1.23-1.15c-0.44-0.37-0.51,0.48-0.55,0.71c-0.18,1.66-0.52,3.31-1,4.91c-0.25,0.51-1.43,1.45-1.33,1.87s2,1.77,2.5,1.63c0.29-0.08,0.18-0.64,0.18-0.92c-0.05-0.87,0.14-1.74,0.53-2.52c0.33-0.8,0.83-1.52,1.46-2.12c0.54-0.42,1.32-0.73,1.41-1.61C11.58,308.89,10.45,309.23,9.56,308.81z"
    />
    <path
      class="bone"
      disabled
      d="M19,301.53c-1.22-0.27-2.21-0.17-2.45,1c-0.03,0.48-0.02,0.97,0.05,1.45c0.08,1.32-0.08,2.64-0.45,3.91c-0.3,1.32-0.34,2.72-0.73,4s-1.4,2.28-1.92,3.55c-0.16,0.35-0.18,0.75-0.06,1.12c0.11,0.3,0.37,0.53,0.69,0.59c0.74,0.18,1.51,0.26,2.27,0.25c0.28,0,0.54-0.13,0.72-0.34c0.21-0.27,0.35-0.59,0.38-0.93c0.04-0.69,0.02-1.38-0.07-2.06c-0.06-0.84-0.06-1.68,0-2.52c0.13-1.75,0.62-3.45,1.45-5c0.3-0.65,0.63-1.27,1-1.88c0.37-0.43,0.63-0.94,0.78-1.49C20.88,302.05,19.98,301.74,19,301.53z"
    />
    <path
      class="bone"
      disabled
      d="M28.12,316c0.31-0.26,0.44-0.69,0.31-1.08c-0.2-0.47-0.43-0.92-0.69-1.36c-0.34-1.01-0.5-2.07-0.46-3.13c-0.06-0.8-0.28-2.67-0.29-3.45c0-1,0.55-2.34,0.21-3.34s-2-1-2.72-0.5c-0.92,0.66-0.13,1.67,0.19,2.5c0.13,0.52,0.22,1.04,0.29,1.57c0.41,1.98,0.44,4.01,0.1,6c-0.09,0.51-0.1,1.03-0.05,1.54c0.06,0.53,0.39,0.98,0.86,1.22c0.46,0.26,0.99,0.37,1.51,0.32C27.65,316.26,27.9,316.16,28.12,316z"
    />
    <path
      class="bone"
      disabled
      d="M33.26,321.57c-0.72,0.36-1.54,0.46-2.32,0.29c-0.2-0.07-0.32-0.28-0.28-0.49c0.1-0.45,0.41-0.94,0.45-1.36c0.02-0.69-0.14-1.38-0.45-2c-0.34-0.6-0.65-1.22-0.93-1.85c-0.12-0.39-0.14-0.78,0.1-0.75c0.46,0.19,0.94,0.33,1.43,0.4l0,0c0.42-0.1,0.83-0.24,1.22-0.43c0.17,0,0.11,0.6,0.07,0.84c-0.08,0.39-0.12,0.78-0.1,1.18c0.02,0.51,0.08,1.02,0.17,1.53c0.06,0.3,0.17,0.59,0.32,0.86C33.27,320.37,33.75,321.4,33.26,321.57z"
    />
    <path
      class="bone"
      disabled
      d="M33.33,326.61c0.42-0.18,0-0.81-0.14-1.09c-0.27-0.32-0.44-0.72-0.47-1.14c0-0.44,0.29-0.83,0.21-1.28s-0.55-0.52-0.92-0.38c-0.37,0.14-1.13-0.17-1.34,0s0.2,0.86,0.34,1.13c0.18,0.39,0.28,0.82,0.28,1.26c-0.03,0.41-0.03,0.83,0,1.24c0.01,0.07,0.04,0.14,0.09,0.19C31.98,326.88,32.71,326.91,33.33,326.61z"
    />
    <path
      class="bone"
      disabled
      d="M28.33,326.16c0.18-0.09,0.29-0.27,0.28-0.47c-0.11-0.57-0.29-1.13-0.54-1.65c-0.28-1.03-0.41-2.09-0.39-3.16c0.17-0.9,0.38-1.79,0.64-2.67c0.16-0.9-0.42-1-1.19-1h-0.8c-0.62,0-1.53-0.25-1.74,0.58c-0.04,0.97,0.21,1.93,0.72,2.76c0.47,0.82,0.65,1.78,0.51,2.71c-0.3,0.84-0.51,1.72-0.62,2.61c0.01,0.19,0.15,0.35,0.33,0.39C26.45,326.52,27.43,326.49,28.33,326.16z"
    />
    <path
      class="bone"
      disabled
      d="M27.94,327.49c-0.17,0-0.6,0.19-0.92,0.2h-0.09c-0.44-0.03-0.87-0.1-1.29-0.22c-0.09-0.01-0.17,0.02-0.24,0.07c-0.69,0.42-0.15,1.09,0.2,1.76c0.36,0.77,0.47,1.64,0.3,2.48c-0.2,0.72-0.26,1.48-0.17,2.22c0.19,0.61,1.07,0.5,1.55,0.56s1.12,0.33,1.2-0.32s-0.55-1.43-0.56-2.11s-0.18-1.29-0.21-2s0.51-1.18,0.52-1.81C28.24,327.92,28.12,327.54,27.94,327.49z"
    />
    <path
      class="bone"
      disabled
      d="M15.94,327.28c0.21-0.24,0.34-0.53,0.39-0.84c0.18-0.9-0.42-1.79-0.53-2.7c-0.13-0.84,0-1.7,0.37-2.46c0.34-0.72,1.23-1.5,0.87-2.25c-0.21-0.59-0.84-0.91-1.44-0.73c-1.42,0.2-2.32-0.51-2.39,0.5c0.02,0.94,0.18,1.87,0.46,2.77c0.23,0.86,0.3,1.76,0.21,2.65c-0.07,0.5-0.19,0.99-0.36,1.46c-0.12,0.38-0.42,0.8-0.32,1.19c0.04,0.12,0.09,0.23,0.17,0.33C14.16,327.65,15.12,327.68,15.94,327.28z"
    />
    <path
      class="bone"
      disabled
      d="M15.6,335.2c-0.39,0.2-0.82,0.32-1.26,0.34c-0.18,0.01-0.36-0.01-0.54-0.06c-0.13,0-0.28-0.13-0.33-0.14c-0.05-0.02-0.1,0.01-0.12,0.06c0,0,0,0.01,0,0.01c-0.39,0.6,0.61,1.2,0.55,1.93s-0.08,1.87,0.84,1.82c0.38-0.05,0.7-0.31,0.82-0.68c0.11-0.42,0.01-0.88-0.27-1.21c-0.19-0.32-0.35-0.54-0.12-0.88c0.28-0.27,0.49-0.59,0.63-0.95C15.85,335.09,15.6,335.2,15.6,335.2z"
    />
    <path
      class="bone"
      disabled
      d="M14,334.76c0.61,0.05,1.22-0.13,1.7-0.51c0.05-0.39-0.03-0.79-0.21-1.14c-0.26-0.59-0.33-1.25-0.22-1.89c0.12-0.77,1.52-2.79,0.51-3c-0.65,0.06-1.29,0.15-1.92,0.29c-0.6,0-0.8,0.35-0.75,1s0.47,0.91,0.57,1.6c0.08,0.64,0.02,1.29-0.17,1.91l-0.07,0.22c-0.04,0.36-0.04,0.72,0,1.08l0,0C13.55,334.54,13.76,334.7,14,334.76z"
    />
    <path
      class="bone"
      disabled
      d="M20.11,335.73c0.67,0,1.34-0.03,2-0.11c0.1-0.05,0.18-0.13,0.24-0.23c0.25-0.52-0.1-1.52-0.17-2.06c-0.13-0.7-0.23-1.4-0.28-2.11c0-0.7,0.43-1.11,0.58-1.74s-0.06-0.92-0.7-0.83c-0.35,0.11-0.71,0.2-1.07,0.27c-0.39,0-0.7-0.23-1-0.15c-0.81,0.19-0.57,1-0.23,1.55c0.44,0.73,0.93,1.19,0.89,2.12c-0.02,0.77-0.2,1.52-0.54,2.21C19.83,334.65,19.24,335.64,20.11,335.73z"
    />
    <path
      class="bone"
      disabled
      d="M41.33,217.7c0.66-3.54-3.71-6.66-4.06-11.65s2.2-67.68,4.37-71.72c0.67-1.37,1.65-2.57,2.86-3.49c3.08-2.44,4.39-6.5,3.32-10.29c-1.16-4.36-4.21-6-7.59-6c-1.7-0.02-3.24,0.99-3.9,2.55c-1.17-0.33-3.45-0.2-3.8,2c-0.45,4.66-0.4,9.35,0.16,14c0.68,4.75-1.27,42.89-1.68,53.24c-0.36,9.16-1.48,17.08-4.08,20.65s-5.76,4.75-5.56,8.11c0.18,3.15,3.54,6.27,6.31,5.21c1.67-0.63,2-1.2,2.57-1.33c0.29-0.06,0.56-0.58,1.27,0.13c0.69,0.7,1.53,1.23,2.46,1.56C36.33,221.47,40.51,222.18,41.33,217.7z"
    />
    <path
      class="bone"
      disabled
      d="M22.17,337.68c0.16-0.37,0.55-0.81,0.18-1.19s-0.73,0-1.11,0h-0.28c-0.33,0-1,0-1.1,0.47s0.38,0.73,0.55,1c0.25,0.41,0.4,0.87,0.43,1.35c-0.06,0.47,0,0.96,0.18,1.4c0.23,0.35,0.53,0.69,1,0.58c0.43-0.14,0.7-0.55,0.68-1C22.63,339.42,21.79,338.57,22.17,337.68z"
    />
    <path
      class="bone"
      disabled
      d="M28.15,336.58c0.16-0.34,0.22-0.31,0.16-0.75s-0.62-0.44-1-0.23l-0.35-0.05c-0.3,0-0.85-0.06-1,0.34s0.34,0.67,0.49,0.94c0.23,0.37,0.36,0.79,0.38,1.23c-0.07,0.43-0.02,0.87,0.15,1.27c0.24,0.36,0.47,0.63,0.87,0.54c0.4-0.13,0.67-0.51,0.65-0.93C28.56,338.16,27.79,337.37,28.15,336.58z"
    />
    <path
      class="bone"
      disabled
      d="M33.64,327.39c-0.35-0.13-0.76,0.32-1,0.25l-0.42-0.2c-0.32-0.06-0.77-0.25-0.91,0.08s0.27,0.6,0.39,0.85c0.18,0.34,0.27,0.71,0.26,1.09c0,0.37-0.16,0.77,0,1.09c0.11,0.33,0.42,0.55,0.77,0.54c0.37-0.06,0.65-0.37,0.68-0.75c0-0.67-0.6-1.41-0.2-2.06C33.41,328,34.02,327.54,33.64,327.39z"
    />
    <path
      class="bone"
      disabled
      d="M22.71,319.85c0.1-0.8-0.35-1.15-1.14-1.39c-0.61-0.23-1.29-0.15-1.83,0.22c-0.73,0.44-0.35,1.2-0.16,1.84c0.27,0.84,0.38,1.72,0.34,2.6c-0.07,0.89-0.14,1.77-0.15,2.67c-0.03,0.24-0.09,0.47-0.16,0.7c0,0.68-0.12,1.4,0.7,1.53c0.79,0.11,1.59-0.17,2.13-0.75c0.42-0.64-0.11-1.32-0.25-2c-0.17-0.89-0.2-1.81-0.07-2.71C22.22,321.64,22.6,320.78,22.71,319.85z"
    />
    <path
      class="bone"
      disabled
      d="M32.39,314.47c0.67-0.86,0.09-2-0.33-2.81c-0.48-0.91-0.8-1.91-0.93-2.93c-0.2-1.15-0.31-2.31-0.32-3.47c0.02-0.52,0.08-1.04,0.17-1.56c0.1-0.39,0.08-0.81-0.06-1.19c-0.44-0.85-1.86-0.61-2.52-0.28c-1.06,0.54-0.44,1.39,0,2.23c0.97,2.2,1.36,4.61,1.12,7c-0.17,1-0.39,2.17,0.31,3c0.61,0.71,1.67,0.79,2.38,0.19c0,0,0,0,0,0C32.28,314.59,32.34,314.53,32.39,314.47z"
    />
    <path
      class="bone"
      disabled
      d="M32.19,223.46c1.08,0.71,2.43,0.85,3.63,0.39c1.1-0.42,1.9-0.8,1.95,0.55c0.09,2.3-1.49,2.17-2,8.84s-1.57,20.13-1.34,25.18c0.23,5.05-1.48,15.91-2.16,20.63c-0.68,4.72-1.33,5.71-1.27,7.86c0,0.94,0.15,3.34-0.35,4.48c-0.16,0.34-0.55,0.52-0.91,0.41c-0.29-0.08-0.65-0.18-1.08-0.28c-1.29-0.69-2.45-2-1.64-5.48c1.13-5.65,1.95-11.36,2.46-17.1c0.34-4-0.33-16.9-0.67-21.13l-0.68-13.42c-0.61,3.55-1.87,10.43-3.18,17.43s0,32.36,1,37.27c0.12,0.46,0.18,0.93,0.18,1.4c-0.02,0.3-0.28,0.53-0.58,0.51h-0.04c-0.84-0.1-1.68-0.1-2.52,0c-1.43,0.24-2.83,0.65-4.17,1.23c-0.54,0.22-1.15-0.04-1.37-0.58c0,0,0,0,0,0c-0.03-0.07-0.05-0.15-0.06-0.23c0-1.29,0.12-2.58,0.36-3.85c0.26-2.8,1.71-8.55,1.91-15.28s0.19-19.76,2.69-30.74c2-8.64,2.46-13.78,1-15.89s-1.08-3.21,1.28-2.78c0.91,0.4,1.94,0.4,2.85,0c0.8-0.39,1.67-0.63,2.56-0.7C30.82,222.49,31.55,222.92,32.19,223.46z"
    />
    <path
      class="bone"
      disabled
      d="M30.72,295.42c-0.09-0.49-0.38-0.93-0.8-1.2c-1.94-0.62-3.97-0.92-6-0.87c-1.23,0.17-2.43,0.48-3.58,0.93l-1,0.57c-0.72,0.58-1.53,1.06-2.39,1.41c-0.57,0.23-1.02,0.68-1.25,1.25c0,0.14,0.02,0.29,0.05,0.43V298c0.36,0.8,0.84,1.53,1.44,2.16c0.42,0.09,0.85,0.14,1.28,0.14c0.92-0.06,1.83,0.14,2.64,0.58c0.13,0.1,0.25,0.21,0.36,0.33c0.52,0.61,1.31,0.91,2.1,0.8c0.74-0.07,1.46-0.27,2.12-0.6c0.72-0.34,1.48-0.56,2.27-0.68c1-0.12,1.39,0.06,2.38-0.06s0.53-4.51,0.53-4.51C30.81,295.9,30.76,295.66,30.72,295.42z"
    />
    <path
      class="bone"
      disabled
      d="M87.23,571c-1.09-0.39-2.69-0.45-3.42,0.39c-0.14,0.25-0.21,0.53-0.2,0.82c0,0.58,0.73,0.83,0.86,1.36c0.18,0.77-0.67,1.18-0.79,1.86c-0.24,1.38,1.77,1.62,2.53,1.14c0.56-0.37,0.47-1,0.73-1.54s0.65-0.63,1-1.11c0.63-0.9,0.42-2.15-0.49-2.79c0,0,0,0,0,0C87.38,571.09,87.31,571.04,87.23,571z"
    />
    <path
      class="bone"
      disabled
      d="M79.26,548.15c-0.71,0.4-0.43,1.17-0.51,1.9c-0.23,1.73-0.59,3.43-1.09,5.1c-0.09,0.29-0.2,0.57-0.33,0.85c-0.34,0.62-0.12,1.4,0.5,1.74c0.21,0.11,0.44,0.17,0.68,0.16c0.39,0,0.77-0.11,1.09-0.32c0.6-0.33,0.66-0.7,0.57-1.36c-0.41-3.21,1.4-6.73,1-7.4c-0.28-0.69-1.07-1.02-1.76-0.74C79.36,548.1,79.31,548.12,79.26,548.15z"
    />
    <path
      class="bone"
      disabled
      d="M71.04,564.15c-0.06-0.07-0.27-0.19-0.31-0.1c-0.42,0.81,0.09,1.55-0.41,2.41c-0.28,0.64-0.6,1.26-0.95,1.86c-0.22,0.29-0.46,0.35-0.53,0.77s0.08,0.8,0,1.19s-0.3,0.68-0.07,1c0.11,0.2,0.36,0.28,0.56,0.17c0.07-0.04,0.13-0.1,0.17-0.17c0.5-0.63,0.09-1.36,1.06-1.63c0.04-0.39,0.04-0.79,0-1.18c0.14-0.32,0.3-0.62,0.49-0.91c0.28-0.55,0.39-1.23,1-1.45c0.41-0.15,0.67,0,0.95-0.4s0.1-0.57-0.21-0.88c-0.23-0.15-0.49-0.23-0.76-0.24c-0.5,0-0.77,0.06-0.88-0.19S71.17,564.31,71.04,564.15z"
    />
    <path
      class="bone"
      disabled
      d="M68.8,563.15c-0.37-0.57-0.64,0-1.25-0.27c0,0,0-0.17-0.06-0.22s-0.31-0.3-0.39-0.27c-0.85,0.26,0.18,1.37-0.31,2.16c-0.3,0.57-0.63,1.11-1,1.64c-0.21,0.26-0.43,0.3-0.51,0.67c-0.04,0.36-0.04,0.73,0,1.09c0,0.36-0.3,0.6-0.1,0.93s0.46,0.26,0.66,0c0.48-0.56,0.14-1.24,1-1.43c0.1-0.37,0-0.73,0.1-1.08c0.14-0.28,0.3-0.55,0.49-0.8c0.27-0.49,0.41-1.11,1-1.28c0.37-0.12,0.38,0.14,0.54-0.31C69.07,563.69,69.01,563.37,68.8,563.15z"
    />
    <path
      class="bone"
      disabled
      d="M65.42,562.8c-0.37,0.1-0.47,0.51-0.67,0.84c-0.13,0.16-0.25,0.34-0.35,0.53c-0.08,0.23,0,0.47-0.09,0.71c-0.6,0.11-0.39,0.58-0.73,1c-0.14,0.15-0.31,0.19-0.44,0s0-0.43,0.09-0.63c0.05-0.24,0.05-0.49,0-0.73c0-0.23,0.21-0.27,0.36-0.44c0.25-0.35,0.47-0.71,0.68-1.08c0.35-0.52-0.35-1.23,0.22-1.39c0.09,0.01,0.18,0.05,0.24,0.12c0.04,0.09,0.09,0.17,0.15,0.25c0.32,0.25,0.67-0.06,1,0.28C65.96,562.18,66.22,562.6,65.42,562.8z"
    />
    <path
      class="bone"
      disabled
      d="M74.7,571.63c0.2-0.86,0.25-1.75,0.14-2.63c0.02-0.32,0.19-0.62,0.46-0.79c0.37-0.27,0.81-0.42,1.27-0.44c0.3,0.07,0.58,0.2,0.82,0.4c0.3,0.24,0.44,0.63,0.36,1c-0.08,0.29-0.18,0.57-0.3,0.84c-0.46,1.16-0.58,2.42-1,3.61c-0.2,0.55-1.75,1.14-2.17,0.14C73.91,572.91,74.33,572.34,74.7,571.63z"
    />
    <path
      class="bone"
      disabled
      d="M85.33,536.23c1.59,0.13,3.33,1.07,3.53,2.69c0.28,1.46,1.08,2.77,2.26,3.68c0.79,0.7,1.23,1.71,1.21,2.77c0.06,1.81,0.09,5.29-1.69,5.23c-1.1-0.15-2.1-0.75-2.74-1.66c-0.93-1.05-2.66-1.35-4.89-1.19c-1.64,0.11-3.14-1.35-5.06-1.19s-2.39,1-3.72,1.41s-1.86-1.05-0.86-2c0.93-0.71,1.92-1.33,2.96-1.88c2.81-1.58,2-4.63,2.41-5.76C79.26,536.74,83.43,536.08,85.33,536.23z"
    />
    <path
      class="bone"
      disabled
      d="M88.61,563.65c0.74,1.13,1.55,2.89,0.15,2.81c-0.59-0.86-1.34-1.6-2.21-2.17c-0.94-0.43-2,0.51-3,1.63c-0.29,0.1-0.35-0.08-0.46-0.36c-0.43-1.12,0.36-2.78,0.45-3.91c0.12-1.51-0.54-2.54-1-3.92c-0.46-1.54,0.09-2.1,0.09-2.1s1.88-2,3.66-1.63c0.44,0.1,0.84,0.34,1.14,0.68c0.59,0.59,0.94,1.37,1,2.2c0.05,1.01-0.03,2.01-0.23,3C87.96,561.37,87.79,562.4,88.61,563.65z"
    />
    <path
      class="bone"
      disabled
      d="M82.38,554.35c0.05,0.07,0.15,0.09,0.22,0.04c0.01-0.01,0.03-0.02,0.04-0.04c0.68-0.83,1.63-1.38,2.69-1.55c1.28-0.15,3.24,1.3,3.53,1.67s0.43-0.44,0.37-0.9c-0.21-1.5-1.22-3.51-2.35-4.09c-1.17-0.54-2.51-0.6-3.72-0.15c-0.59,0.25-1.07,0.71-1.33,1.3c-0.3,0.62-0.37,1.33-0.19,2C81.79,553.24,82.04,553.82,82.38,554.35z"
    />
    <path
      class="bone"
      disabled
      d="M74.33,556.18c-0.32-0.23,2-7.83,2-7.83c0.13-0.17,0.32-0.28,0.53-0.32c1.48-0.39,1.21,0.1,1.21,0.1c-1.29,2.44-1.53,7.33-1.87,7.89C76.25,556,75.72,557.13,74.33,556.18z"
    />
    <path
      class="bone"
      disabled
      d="M71.25,552.31c0.29-0.81,0.64-1.57,0.94-2.38l0.13-0.13c0.11,0,0.74-0.32,0.61,0.07s-0.88,2.5-0.88,2.5c-0.37,0.88-0.66,1.68-0.76,1.79s-0.59,0.28-0.7,0C70.33,553.53,71.06,552.84,71.25,552.31z"
    />
    <path
      class="bone"
      disabled
      d="M74.97,549.58c-0.14,0.36-1.79,5.79-1.86,6s-0.54,0-0.74-0.24c-0.6-0.66,0.21-1.43,0.33-2.15c0-0.05,0-0.11,0-0.16c0,0,1-3.17,1-3.37S75.11,549.21,74.97,549.58z"
    />
    <path
      class="bone"
      disabled
      d="M76.8,564.52c-0.31,0.04-0.62,0.11-0.91,0.21c-0.1,0.04-0.21-0.01-0.24-0.11l-0.01-0.02c-0.28-1.08,0.87-2,1-3.25s-0.45-2.77,1.33-2.38c0.41-0.01,0.82,0.01,1.23,0.06c0.36,0.13,0.58,0.26,0.55,0.65l-0.42,5.24c0,0-0.06,0.38-0.78,0.07l-0.54-0.25C77.64,564.55,77.22,564.48,76.8,564.52z"
    />
    <path
      class="bone"
      disabled
      d="M71.74,562.6c0.09-0.41,0.25-0.81,0.46-1.17c0.1-0.4,0.29-0.77,0.57-1.08c0.27-0.39,0.51-0.81,0.71-1.24c0.21-0.42,0.09-1.19,0.51-1.36c0.49-0.09,1-0.01,1.45,0.22c0.13,0.33-0.24,0.85-0.45,1.32c-0.42,1-1,1.91-1.41,2.89s-0.39,1.43-0.78,1.44l-0.82-0.46C71.85,563,71.77,562.8,71.74,562.6z"
    />
    <path
      class="bone"
      disabled
      d="M75.08,566.21c0,0-0.41,0.35-0.35,0.61s0.45,0.31,0.45,0.31c0.45-0.27,0.98-0.39,1.5-0.36c0.57,0.16,1.1,0.43,1.55,0.81c0.34,0.23,0.52-0.27,0.51-0.81c-0.01-0.43-0.26-0.82-0.65-1c-0.21-0.1-0.44-0.17-0.67-0.21c-0.83,0-1.64,0.24-2.34,0.69"
    />
    <path
      class="bone"
      disabled
      d="M72.38,557.33c-0.32,0.93-1,1.36-1.55,2.12c-0.28,0.39-0.51,0.81-0.67,1.26c-0.15,0.43-0.43,1.28-0.68,1.34s-1.49-0.13-1.5-0.38s3.18-5,3.45-5.31S72.62,556.61,72.38,557.33z"
    />
    <path
      class="bone"
      disabled
      d="M66.69,561.21c-0.2,0-1.48-0.21-1.55-0.53s1.49-2.06,2.5-2.86s1.12-2,2.13-2.48c0.42-0.2,1.12,0.07,0.83,0.54s-3.51,5-3.51,5C66.97,561,66.84,561.11,66.69,561.21z"
    />
    <path
      class="bone"
      disabled
      d="M87.14,569.82h0.26c0.04,0,1.59-0.49,1.28-1.63s-2.06-2.77-2.57-2.64c0,0-0.66-0.15-1.83,1.3c-0.35,0.42-0.58,0.93-0.66,1.47c-0.05,0.41,0.17,0.81,0.54,1c0.39-0.06,0.78-0.09,1.17-0.1c0.54,0.11,1.05,0.33,1.5,0.66C86.94,569.9,87.05,569.88,87.14,569.82z"
    />
    <path
      class="bone"
      disabled
      d="M187.26,316.19c0.23-0.25,0.27,0.18,0.34,0.4c0.07,0.46,0.11,0.92,0.1,1.39c0.06,0.43,0.23,0.84,0.49,1.19c0.29,0.32,0.46,0.74,0.46,1.18c0,0.4-0.31,0.73-0.67,0.48c-0.28-0.25-0.5-0.55-0.65-0.89c-0.22-0.39-0.39-0.83-0.62-1.21s-0.57-0.44-0.91-0.67s-0.62-0.51-0.38-0.63C186.13,317.18,186.77,316.76,187.26,316.19z"
    />
    <path
      class="bone"
      disabled
      d="M170.45,317.35c-0.22-0.09-0.39-0.27-0.45-0.5c-0.1-0.55-0.07-1.12,0.08-1.66c0.66-2.67,0.51-5.47-0.43-8.06c-0.24-0.63-0.32-1.12-0.53-1.76c-0.16-0.4-0.16-0.84,0-1.24c0.4-0.83,1.14-0.73,1.76-0.5c0.31,0.14,0.58,0.34,0.79,0.6c0.51,0.81,0.64,1.8,0.35,2.71c-0.19,1.2-0.14,2.42,0.14,3.6c0.15,1.13,0.38,2.25,0.67,3.35c0.29,0.9,1,2.1,0.55,3.05l0,0C172.57,317.63,171.42,317.79,170.45,317.35z"
    />
    <path
      class="bone"
      disabled
      d="M177.02,300c0.29-0.35,0.53-0.78,0.83-1.13c0.52-0.61,0.93-1.05,1.44-0.25c0.42,0.93,0.79,1.88,1.09,2.85c0.41,0.96,0.95,1.85,1.61,2.66c0.55,0.64,1.42,1,1.76,1.83c0.08,0.17,0.14,0.36,0.17,0.55c0.01,0.07,0.01,0.15,0,0.22c-0.39,0.67-0.97,1.21-1.67,1.55c-0.67,0.35-1.46,0.35-2.13,0c-0.06-0.08-0.1-0.16-0.14-0.25c-0.11-0.47-0.16-0.95-0.15-1.43c-0.05-0.55-0.18-1.09-0.39-1.6c-0.35-1.05-0.94-2.01-1.72-2.79c-0.4-0.33-1.56-0.47-1.44-1.18C176.33,300.59,176.79,300.23,177.02,300z"
    />
    <path
      class="bone"
      disabled
      d="M183.12,308.81c0.7-0.33,0.79-0.78,1.22-1.15s0.51,0.48,0.55,0.71c0.18,1.66,0.52,3.31,1,4.91c0.25,0.51,1.43,1.45,1.33,1.87s-2,1.77-2.5,1.63c-0.29-0.08-0.19-0.64-0.18-0.92c0.04-0.87-0.14-1.74-0.54-2.52c-0.33-0.8-0.82-1.52-1.45-2.12c-0.54-0.42-1.32-0.73-1.41-1.61C181.09,308.89,182.23,309.23,183.12,308.81z"
    />
    <path
      class="bone"
      disabled
      d="M173.67,301.53c1.23-0.27,2.21-0.17,2.46,1c0.03,0.48,0.02,0.97-0.05,1.45c-0.08,1.32,0.08,2.64,0.45,3.91c0.29,1.32,0.33,2.72,0.73,4s1.4,2.28,1.92,3.55c0.16,0.35,0.18,0.75,0.06,1.12c-0.11,0.31-0.38,0.53-0.7,0.59c-0.74,0.18-1.5,0.26-2.26,0.25c-0.28-0.01-0.55-0.13-0.73-0.34c-0.21-0.27-0.34-0.59-0.37-0.93c-0.05-0.69-0.02-1.38,0.06-2.06c0.07-0.84,0.07-1.68,0-2.52c-0.12-1.75-0.61-3.45-1.44-5c-0.3-0.64-0.63-1.27-1-1.88c-0.37-0.43-0.64-0.94-0.79-1.49C171.8,302.05,172.7,301.74,173.67,301.53z"
    />
    <path
      class="bone"
      disabled
      d="M164.56,316c-0.31-0.26-0.44-0.69-0.31-1.08c0.2-0.47,0.42-0.92,0.68-1.36c0.35-1.01,0.5-2.07,0.46-3.13c0.07-0.8,0.29-2.67,0.29-3.45c0-1-0.55-2.34-0.2-3.34s2-1,2.71-0.5c0.93,0.66,0.14,1.67-0.19,2.5c-0.12,0.52-0.22,1.04-0.28,1.57c-0.42,1.98-0.45,4.01-0.1,6c0.08,0.51,0.1,1.03,0.05,1.54c-0.07,0.52-0.39,0.98-0.86,1.22c-0.46,0.26-0.99,0.37-1.51,0.32C165.03,316.26,164.78,316.16,164.56,316z"
    />
    <path
      class="bone"
      disabled
      d="M159.42,321.57c0.72,0.36,1.54,0.46,2.32,0.29c0.2-0.07,0.32-0.28,0.28-0.49c-0.1-0.45-0.41-0.94-0.46-1.36c-0.01-0.69,0.14-1.38,0.45-2c0.35-0.6,0.66-1.21,0.94-1.85c0.11-0.39,0.14-0.78-0.1-0.75c-0.46,0.2-0.94,0.33-1.44,0.4l0,0c-0.42-0.09-0.83-0.24-1.22-0.43c-0.17,0-0.11,0.6-0.07,0.84c0.08,0.39,0.11,0.78,0.1,1.18c-0.03,0.51-0.09,1.02-0.18,1.53c-0.06,0.3-0.16,0.59-0.31,0.86C159.4,320.37,158.93,321.4,159.42,321.57z"
    />
    <path
      class="bone"
      disabled
      d="M159.33,326.61c-0.41-0.18-0.05-0.81,0.15-1.09c0.27-0.32,0.44-0.72,0.47-1.14c0-0.44-0.29-0.83-0.21-1.28s0.54-0.52,0.92-0.38s1.12-0.17,1.34,0s-0.2,0.86-0.35,1.13c-0.18,0.4-0.27,0.83-0.27,1.26c0.04,0.41,0.04,0.83,0,1.24c-0.02,0.07-0.05,0.13-0.09,0.19C160.69,326.88,159.96,326.91,159.33,326.61z"
    />
    <path
      class="bone"
      disabled
      d="M164.33,326.16c-0.18-0.09-0.29-0.27-0.28-0.47c0.1-0.57,0.28-1.13,0.54-1.65c0.28-1.03,0.4-2.09,0.38-3.16c-0.16-0.9-0.37-1.79-0.63-2.67c-0.16-0.9,0.42-1,1.19-1h0.8c0.62,0,1.52-0.25,1.74,0.58c0.05,0.97-0.21,1.93-0.72,2.76c-0.47,0.82-0.65,1.77-0.51,2.71c0.3,0.84,0.51,1.72,0.62,2.61c-0.01,0.19-0.15,0.35-0.33,0.39C166.21,326.52,165.23,326.49,164.33,326.16z"
    />
    <path
      class="bone"
      disabled
      d="M164.73,327.49c0.18,0,0.61,0.19,0.93,0.2h0.08c0.44-0.02,0.87-0.1,1.29-0.22c0.09-0.01,0.18,0.02,0.25,0.07c0.69,0.42,0.15,1.09-0.21,1.76c-0.35,0.78-0.45,1.64-0.29,2.48c0.19,0.72,0.25,1.48,0.17,2.22c-0.19,0.61-1.08,0.5-1.55,0.56s-1.12,0.33-1.2-0.32s0.55-1.43,0.56-2.11s0.18-1.29,0.2-2s-0.5-1.18-0.51-1.81C164.44,327.92,164.56,327.54,164.73,327.49z"
    />
    <path
      class="bone"
      disabled
      d="M176.74,327.28c-0.21-0.24-0.34-0.53-0.39-0.84c-0.18-0.9,0.41-1.79,0.53-2.7c0.12-0.84-0.01-1.69-0.37-2.46c-0.34-0.72-1.24-1.5-0.87-2.25c0.21-0.58,0.84-0.9,1.43-0.73c1.43,0.2,2.33-0.51,2.4,0.5c-0.02,0.94-0.18,1.87-0.46,2.77c-0.23,0.86-0.3,1.76-0.21,2.65c0.07,0.5,0.19,0.99,0.35,1.46c0.13,0.38,0.43,0.8,0.33,1.19c-0.04,0.12-0.09,0.23-0.17,0.33C178.52,327.65,177.56,327.68,176.74,327.28z"
    />
    <path
      class="bone"
      disabled
      d="M177.08,335.2c0.39,0.2,0.82,0.32,1.26,0.34c0.18,0.01,0.36-0.01,0.54-0.06c0.13,0,0.27-0.13,0.33-0.14s0.09,0,0.12,0.07c0.39,0.6-0.61,1.2-0.55,1.93s0.08,1.87-0.84,1.82c-0.38-0.05-0.7-0.31-0.82-0.68c-0.11-0.42-0.02-0.87,0.26-1.21c0.19-0.32,0.36-0.54,0.13-0.88c-0.28-0.27-0.49-0.59-0.63-0.95C176.82,335.09,177.08,335.2,177.08,335.2z"
    />
    <path
      class="bone"
      disabled
      d="M178.68,334.76c-0.61,0.06-1.22-0.13-1.7-0.51c-0.05-0.39,0.03-0.79,0.21-1.14c0.25-0.6,0.33-1.25,0.22-1.89c-0.12-0.77-1.53-2.79-0.51-3c0.65,0.06,1.29,0.15,1.92,0.29c0.6,0,0.79,0.35,0.75,1s-0.48,0.91-0.58,1.6c-0.07,0.64-0.01,1.29,0.18,1.91l0.07,0.22c0.04,0.36,0.04,0.72,0,1.08l0,0C179.13,334.54,178.92,334.7,178.68,334.76z"
    />
    <path
      class="bone"
      disabled
      d="M172.57,335.73c-0.67,0-1.34-0.03-2-0.11c-0.1-0.05-0.18-0.13-0.24-0.23c-0.26-0.52,0.1-1.52,0.17-2.06c0.13-0.7,0.23-1.4,0.28-2.11c0-0.7-0.44-1.11-0.58-1.74s0.06-0.92,0.7-0.83c0.35,0.11,0.7,0.2,1.06,0.27c0.4,0,0.71-0.23,1-0.15c0.81,0.19,0.57,1,0.22,1.55c-0.44,0.73-0.92,1.19-0.88,2.12c0.01,0.77,0.2,1.52,0.54,2.21C172.84,334.65,173.44,335.64,172.57,335.73z"
    />
    <path
      class="bone"
      disabled
      d="M170.51,337.68c-0.16-0.37-0.55-0.81-0.19-1.19s0.73,0,1.12,0h0.28c0.33,0,1,0,1.1,0.47s-0.39,0.73-0.55,1c-0.25,0.41-0.4,0.87-0.44,1.35c0.06,0.47,0.01,0.96-0.17,1.4c-0.23,0.35-0.53,0.69-1,0.58c-0.43-0.14-0.7-0.55-0.68-1C170.05,339.42,170.89,338.57,170.51,337.68z"
    />
    <path
      class="bone"
      disabled
      d="M164.52,336.58c-0.15-0.34-0.21-0.31-0.16-0.75s0.62-0.44,1-0.23l0.35-0.05c0.3,0,0.84-0.06,1,0.34s-0.34,0.67-0.49,0.94c-0.23,0.37-0.36,0.79-0.39,1.23c0.07,0.43,0.02,0.87-0.14,1.27c-0.2,0.31-0.47,0.63-0.88,0.54c-0.4-0.13-0.66-0.51-0.64-0.93C164.12,338.16,164.89,337.37,164.52,336.58z"
    />
    <path
      class="bone"
      disabled
      d="M159.04,327.39c0.35-0.13,0.76,0.32,1,0.25l0.42-0.2c0.32-0.06,0.77-0.25,0.91,0.08s-0.27,0.6-0.39,0.85c-0.18,0.33-0.27,0.71-0.26,1.09c0,0.37,0.16,0.77,0,1.09c-0.11,0.33-0.43,0.55-0.78,0.54c-0.37-0.06-0.65-0.37-0.67-0.75c0-0.67,0.6-1.41,0.2-2.06C159.27,328,158.65,327.54,159.04,327.39z"
    />
    <path
      class="bone"
      disabled
      d="M169.96,319.85c-0.09-0.8,0.36-1.15,1.15-1.39c0.61-0.23,1.29-0.15,1.83,0.22c0.72,0.44,0.34,1.2,0.16,1.84c-0.27,0.84-0.39,1.72-0.34,2.6c0.07,0.89,0.14,1.77,0.15,2.67c0.03,0.24,0.08,0.47,0.15,0.7c0,0.68,0.13,1.4-0.7,1.53c-0.79,0.11-1.58-0.17-2.12-0.75c-0.42-0.64,0.1-1.32,0.25-2c0.17-0.89,0.2-1.81,0.07-2.71C170.45,321.64,170.07,320.78,169.96,319.85z"
    />
    <path
      class="bone"
      disabled
      d="M160.33,314.47c-0.66-0.86-0.08-2,0.34-2.81c0.48-0.91,0.8-1.91,0.93-2.93c0.2-1.15,0.3-2.31,0.31-3.47c-0.02-0.52-0.08-1.04-0.16-1.56c-0.1-0.39-0.08-0.81,0.06-1.19c0.43-0.85,1.86-0.61,2.52-0.28c1.06,0.54,0.44,1.39,0,2.23c-0.97,2.2-1.36,4.61-1.13,7c0.18,1,0.4,2.17-0.31,3c-0.61,0.71-1.67,0.79-2.38,0.19c0,0,0,0,0,0C160.44,314.59,160.39,314.53,160.33,314.47z"
    />
    <path
      class="bone"
      disabled
      d="M160.49,223.46c-1.08,0.71-2.43,0.86-3.64,0.39c-1.09-0.42-1.89-0.8-1.94,0.55c-0.09,2.3,1.49,2.17,2,8.84s1.57,20.13,1.34,25.18c-0.23,5.05,1.48,15.91,2.16,20.63s1.33,5.71,1.26,7.86c0,0.94-0.15,3.34,0.36,4.48c0.16,0.34,0.55,0.52,0.91,0.41c0.28-0.08,0.65-0.18,1.08-0.28c1.29-0.69,2.45-2,1.64-5.48c-1.13-5.65-1.95-11.36-2.46-17.1c-0.35-4,0.32-16.9,0.66-21.13l0.68-13.42c0.62,3.55,1.88,10.43,3.19,17.43s0,32.36-1,37.27c-0.12,0.46-0.18,0.93-0.18,1.4c0.01,0.3,0.27,0.53,0.56,0.51c0,0,0,0,0,0h0.04c0.84-0.1,1.68-0.1,2.52,0c1.43,0.24,2.83,0.65,4.17,1.23c0.5,0.24,1.1,0.03,1.33-0.47c0.05-0.11,0.08-0.22,0.1-0.34c0-1.29-0.12-2.58-0.35-3.85c-0.26-2.8-1.72-8.55-1.91-15.28s-0.19-19.76-2.69-30.74c-2-8.64-2.46-13.78-1-15.89s1.08-3.21-1.28-2.78c-0.91,0.4-1.94,0.4-2.85,0c-0.8-0.39-1.67-0.63-2.56-0.7C161.86,222.49,161.13,222.92,160.49,223.46z"
    />
    <path
      class="bone"
      disabled
      d="M161.96,295.42c0.09-0.49,0.38-0.93,0.8-1.2c1.94-0.63,3.97-0.92,6-0.87c1.23,0.17,2.43,0.48,3.58,0.93l1,0.57c0.72,0.59,1.53,1.06,2.39,1.41c0.57,0.23,1.02,0.68,1.24,1.25c0.01,0.14,0.01,0.29,0,0.43V298c-0.36,0.8-0.84,1.53-1.44,2.16c-0.42,0.09-0.86,0.14-1.29,0.14c-0.92-0.06-1.83,0.14-2.64,0.58l-0.36,0.33c-0.51,0.61-1.3,0.91-2.09,0.8c-0.74-0.07-1.46-0.27-2.13-0.6c-0.72-0.34-1.48-0.56-2.26-0.68c-1-0.12-1.39,0.06-2.38-0.06s-0.53-4.51-0.53-4.51C161.87,295.91,161.91,295.66,161.96,295.42z"
    />
    <path
      class="bone"
      disabled
      d="M103.15,96.39c-0.78,0.17-2.09,0.82-2.11,0c0-0.49,1.07-1.44-0.9-1.61h-7.63c-2,0.17-0.88,1.12-0.89,1.61c0,0.83-1.33,0.18-2.12,0s-1.57,1.17,0,1.34s2.71,0.34,2.64,1.11c-0.08,1,1.94,1.21,4.19,1.21s4.26-0.24,4.18-1.21c-0.06-0.77,1.07-0.94,2.64-1.11S103.94,96.23,103.15,96.39z"
    />
    <path
      class="bone"
      disabled
      d="M103.67,184.82c-0.84,0.23-2.26,1.11-2.28,0c0-0.67,1.15-2-1-2.19c0,0-1.76-0.08-4.1-0.08s-4.11,0.08-4.11,0.08c-2.11,0.23-0.94,1.52-1,2.19c0,1.13-1.43,0.25-2.27,0c-0.5,0-0.91,0.41-0.91,0.91s0.41,0.91,0.91,0.91c1.68,0.23,2.91,0.46,2.84,1.52c-0.09,1.32,2.08,1.65,4.5,1.65s4.59-0.33,4.5-1.65c-0.07-1.06,1.15-1.29,2.84-1.52c0.5,0.03,0.93-0.35,0.96-0.85c0.03-0.5-0.35-0.93-0.85-0.96C103.69,184.82,103.68,184.82,103.67,184.82z"
    />
    <path
      class="bone"
      disabled
      d="M102.94,177.12c-0.76,0.21-2,1-2,0c0-0.6,1-1.76-0.87-2c0,0-1.58-0.07-3.69-0.07s-3.7,0.07-3.7,0.07c-1.9,0.21-0.85,1.37-0.86,2c0,1-1.29,0.23-2,0c-0.45,0-0.82,0.37-0.82,0.82c0,0.45,0.37,0.82,0.82,0.82c0,0,0,0,0,0l0,0c1.52,0.21,2.62,0.41,2.56,1.37c-0.08,1.18,1.87,1.48,4,1.48s4.13-0.3,4-1.48c-0.06-1,1-1.16,2.56-1.37c0.45,0,0.82-0.37,0.82-0.82C103.76,177.49,103.39,177.12,102.94,177.12C102.94,177.12,102.94,177.12,102.94,177.12z"
    />
    <path
      class="bone"
      disabled
      d="M102.11,85.6c-0.67,0.13-1.78,0.65-1.79,0c0-0.39,0.9-1.14-0.76-1.27H93.1c-1.67,0.13-0.75,0.88-0.76,1.27c0,0.66-1.13,0.14-1.79,0s-1.34,0.93,0,1.06s2.29,0.27,2.23,0.88s1.64,1,3.55,1s3.61-0.2,3.54-1s0.91-0.75,2.24-0.88S102.78,85.47,102.11,85.6z"
    />
    <path
      class="bone"
      disabled
      d="M102.11,80.55c-0.67,0.13-1.78,0.64-1.79,0c0-0.39,0.9-1.14-0.76-1.27H93.1c-1.67,0.13-0.75,0.88-0.76,1.27c0,0.65-1.13,0.14-1.79,0s-1.34,0.93,0,1.06s2.29,0.26,2.23,0.88s1.64,1,3.55,1s3.61-0.19,3.54-1s0.91-0.75,2.24-0.88S102.78,80.42,102.11,80.55z"
    />
    <path
      class="bone"
      disabled
      d="M102.11,90.76c-0.67,0.14-1.78,0.69-1.79,0c0-0.42,0.9-1.23-0.76-1.38c0,0-1.39,0-3.23-0.05s-3.23,0.05-3.23,0.05c-1.67,0.15-0.75,1-0.76,1.38c0,0.7-1.13,0.15-1.79,0s-1.34,1,0,1.14s2.29,0.29,2.23,1c-0.07,0.82,1.64,1,3.55,1s3.61-0.21,3.54-1c-0.05-0.67,0.91-0.81,2.24-1S102.78,90.62,102.11,90.76z"
    />
    <path
      class="bone"
      disabled
      d="M105.62,193.3c-0.93,0.26-3.7,1.22-3.72,0c0-0.74,1.26-2.16-1.06-2.41c0,0-1.93-0.08-4.51-0.08s-4.52,0.08-4.52,0.08c-2.32,0.25-1,1.67-1,2.41c0,1.24-2.79,0.28-3.72,0c-0.55,0-1,0.45-1,1s0.45,1,1,1c1.86,0.25,4.41,0.5,4.34,1.67c-0.1,1.45,2.29,1.81,5,1.81s5-0.36,5-1.81c-0.08-1.17,2.48-1.42,4.34-1.67c0.55-0.04,0.97-0.52,0.92-1.07C106.65,193.67,106.17,193.26,105.62,193.3z"
    />
    <path
      class="bone"
      disabled
      d="M108.99,233.21c-1.26,0.35-5,1.67-5.07,0c0-1,1.73-2.94-1.44-3.29c0,0-2.63-0.11-6.15-0.11s-6.16,0.11-6.16,0.11c-3.17,0.35-1.42,2.28-1.44,3.29c0,1.7-3.8,0.38-5.07,0c-0.76,0-1.37,0.61-1.37,1.37c0,0.76,0.61,1.37,1.37,1.37c2.54,0.34,6,0.68,5.92,2.28c-0.13,2,3.12,2.46,6.75,2.46s6.88-0.49,6.75-2.46c-0.11-1.6,3.38-1.94,5.91-2.28c0.76,0,1.37-0.61,1.37-1.37C110.36,233.82,109.75,233.21,108.99,233.21L108.99,233.21z"
    />
    <path
      class="bone"
      disabled
      d="M106.46,212.23c-1,0.27-4,1.33-4,0c0-0.81,1.38-2.36-1.16-2.64c0,0-2.11-0.09-4.92-0.09s-4.93,0.09-4.93,0.09c-2.53,0.28-1.13,1.83-1.15,2.64c0,1.35-3,0.29-4.06,0c-0.6-0.06-1.14,0.38-1.21,0.98c-0.06,0.6,0.38,1.14,0.98,1.21c0,0,0.01,0,0.01,0c0.07,0.01,0.14,0.01,0.21,0c2,0.27,4.82,0.55,4.74,1.82c-0.11,1.58,2.5,2,5.4,2s5.5-0.39,5.4-2c-0.09-1.27,2.7-1.55,4.73-1.82c0.61,0.04,1.13-0.41,1.17-1.02c0.04-0.61-0.41-1.13-1.02-1.17C106.6,212.22,106.53,212.22,106.46,212.23z"
    />
    <path
      class="bone"
      disabled
      d="M107.47,222.22c-1.11,0.3-4.43,1.46-4.46,0c0-0.89,1.52-2.59-1.27-2.89c0,0-2.32-0.11-5.41-0.11s-5.42,0.11-5.42,0.11c-2.79,0.3-1.25,2-1.27,2.89c0,1.49-3.34,0.33-4.46,0c-0.66,0-1.2,0.53-1.2,1.2s0.53,1.2,1.2,1.2c0,0,0,0,0.01,0l0,0c2.23,0.3,5.3,0.61,5.21,2c-0.12,1.73,2.75,2.17,5.94,2.17s6-0.44,5.94-2.17c-0.09-1.4,3-1.71,5.2-2c0.65,0.29,1.42,0.07,1.8-0.53c0.37-0.55,0.22-1.3-0.33-1.66c0,0,0,0,0,0C108.49,222.18,107.97,222.11,107.47,222.22z"
    />
    <path
      class="bone"
      disabled
      d="M106.46,202.52c-1,0.27-4,1.33-4,0c0-0.8,1.38-2.35-1.16-2.63c0,0-2.11-0.09-4.92-0.09s-4.93,0.09-4.93,0.09c-2.53,0.28-1.13,1.83-1.15,2.63c0,1.36-3,0.3-4.06,0c-0.6-0.06-1.14,0.38-1.21,0.98c-0.06,0.6,0.38,1.14,0.98,1.21c0,0,0.01,0,0.01,0c0.07,0.01,0.14,0.01,0.21,0c2,0.27,4.82,0.54,4.74,1.82c-0.11,1.58,2.5,2,5.4,2s5.5-0.39,5.4-2c-0.09-1.28,2.7-1.55,4.73-1.82c0.61,0.04,1.13-0.42,1.18-1.02s-0.42-1.13-1.02-1.18C106.6,202.51,106.53,202.51,106.46,202.52z"
    />
    <path
      class="bone"
      disabled
      d="M113.98,54.62c0-0.37-0.23-0.36-0.55-0.36c-1.92,0-4.56,0.18-4.74,0.8c-0.11,0.38-0.21,0.82-0.32,1.28c-0.36,1.56-0.87,5.17-2,6.43c0,0-3.25,3.49-10,3.49l0,0c-6.72,0-10-3.49-10-3.49c-1.16-1.26-1.67-4.87-2-6.43c-0.11-0.46-0.21-0.9-0.32-1.28c-0.18-0.62-2.82-0.79-4.74-0.8c-0.32,0-0.53,0-0.56,0.36c0,0.14-0.58,4.19,0.86,5s0.67,8.9,3.52,10.37c4.16,2.15,4.64,8.26,13.26,8.27l0,0c8.62,0,9.09-6.12,13.26-8.27c2.85-1.47,2.06-9.56,3.51-10.37S113.99,54.76,113.98,54.62z"
    />
    <path
      class="bone"
      disabled
      d="M115.05,13.58c-4.26-6.14-11.24-9.83-18.72-9.89l0,0c-7.47,0.06-14.44,3.75-18.7,9.89c-3.49,4.84-4.54,12.77-4.3,17.42c0.27,5.72,2.94,21.82,5.41,22.24c1.83,0.32,5.66,0.08,6.2,1.55c0.14,0.39,1.08,4.58,2.06,5.64c1.33,1.41,5.53,2.57,9.33,2.57l0,0c3.8,0,8-1.18,9.34-2.61c1-1.06,1.93-5.25,2.07-5.64c0.54-1.47,4.36-1.23,6.2-1.55c2.48-0.4,5.16-16.5,5.39-22.2C119.59,26.35,118.54,18.42,115.05,13.58z M84.05,45.88c-2.34-0.16-3.2-1.89-3.21-7.09c0-4.06,2.84-4.51,7.44-5.4c1-0.18,3.1-0.75,4.2,1.26c0.92,1.7,0.61,4.52-0.4,6.5S86.38,46,84.05,45.88z M97.12,54.12c-0.24-0.11-0.5-0.17-0.77-0.2l0,0c-0.27,0.03-0.53,0.09-0.77,0.2c-3.8,1.66-3.34-1.85-2.72-5.08c0.53-2.8,1.29-5,2-5.85s1,0,1.48,0l0,0c0.53,0,0.86-0.65,1.47,0s1.49,3.05,2,5.85C100.46,52.27,100.91,55.78,97.12,54.12z M108.63,45.88c-2.34,0.15-7-2.73-8-4.73s-1.33-4.8-0.4-6.5c1.1-2,3.25-1.44,4.2-1.26c4.6,0.89,7.44,1.34,7.44,5.4C111.83,44,110.96,45.72,108.63,45.88z"
    />
    <path
      class="bone"
      disabled
      d="M114,240.28c-1.62-5.39-5.29-2-8,1.33c-1.37,1.67-3.07,3.03-5,4c-2.87,1.45-6.27,1.45-9.14,0c-1.93-0.97-3.63-2.33-5-4c-2.73-3.37-6.41-6.72-8-1.33c-1.9,6.35-0.8,10.6,2.93,13.06c2.71,1.78-0.5,5.71,2.75,8.75c3.07,2.87,1.67,5.05,4.71,6.32c1.93,0.8,1.2,5,3,6.16c1,0.69-0.08,3.48,1.22,4.08c0.78,0.36,1.31,2,3,2s2.21-1.65,3-2c1.31-0.6,0.19-3.39,1.22-4.08c1.76-1.16,1-5.36,3-6.16c3-1.27,1.64-3.45,4.7-6.32c3.25-3,0-7,2.75-8.75C114.81,250.88,115.91,246.63,114,240.28z"
    />
    <path
      class="bone"
      disabled
      d="M136.84,275.39c-2.89,0.14-2.09,2.69-3.56,2s-0.26-2.57,0.24-3.91s0.07-3.93-1.74-4.58c-3.33-1.19-6.28,1.75-7.47,4.1c-1.22,2.48-1.77,5.24-1.58,8c0.39,2.67,3.43,1.57,5.58,2.18c2.15,0.61,2.41,5.46,1.23,8.35s-1.87,3.83-0.86,7.38s-3,27.23-5.87,46.86c-1.94,13.38-5.89,34.63-9,47.32c-1.33,5.36-4.67,15.14-6,16.66c-3.74,4.24-4.64,8.37-3,14.39c1.07,4,3.5,4.82,5.43,4.49c1.84-0.6,1.45-2.09,1.09-3.1s-1.81-4.28-1.28-7.29c0.71-3.85,4.4-6.4,8.25-5.7c1.25,0.23,2.42,0.79,3.38,1.63c2.18,1.94,3,5.45,2.19,8.63c-0.54,2.11-1.46,2.85-1,4.16c0.59,1.56,2.88,1.12,5.12-0.91c0.76-0.68,2-2.09,1.09-8.65c-0.77-5.73-4-6.19-4.55-12.15s5.87-46.77,7.2-54.63c1.19-7,6.4-45.14,6.58-46.77c0.39-3.53,4.06-7.68,5.17-13C146.25,277.56,139.73,275.26,136.84,275.39z"
    />
    <path
      class="bone"
      disabled
      d="M151.33,217.7c-0.67-3.54,3.71-6.66,4.06-11.65s-2.21-67.68-4.37-71.72c-0.67-1.37-1.65-2.57-2.87-3.49c-3.08-2.45-4.39-6.5-3.32-10.29c1.16-4.36,4.21-6,7.6-6c1.7-0.02,3.23,0.99,3.9,2.55c1.17-0.33,3.45-0.2,3.79,2c0.46,4.66,0.41,9.35-0.15,14c-0.69,4.75,1.27,42.89,1.67,53.24c0.36,9.16,1.49,17.08,4.08,20.65s5.77,4.75,5.57,8.11c-0.18,3.15-3.54,6.27-6.31,5.21c-1.68-0.63-2-1.2-2.58-1.33c-0.29-0.06-0.55-0.58-1.26,0.13c-0.69,0.7-1.54,1.23-2.47,1.56C156.33,221.47,152.16,222.18,151.33,217.7z"
    />
    <path
      class="bone"
      disabled
      d="M105.44,571c1.08-0.39,2.68-0.45,3.42,0.39c0.13,0.25,0.2,0.54,0.19,0.82c0,0.58-0.72,0.83-0.85,1.36c-0.19,0.77,0.67,1.18,0.78,1.86c0.25,1.38-1.76,1.62-2.52,1.14c-0.57-0.37-0.48-1-0.73-1.54s-0.65-0.63-1-1.11c-0.63-0.9-0.42-2.15,0.49-2.79c0,0,0,0,0,0C105.29,571.09,105.36,571.04,105.44,571z"
    />
    <path
      class="bone"
      disabled
      d="M113.4,548.15c0.71,0.4,0.43,1.17,0.51,1.9c0.23,1.73,0.6,3.43,1.1,5.1c0.09,0.29,0.21,0.58,0.34,0.85c0.34,0.62,0.12,1.4-0.5,1.74c-0.21,0.12-0.45,0.17-0.69,0.16c-0.39,0-0.77-0.11-1.09-0.32c-0.59-0.33-0.65-0.7-0.57-1.36c0.42-3.21-1.4-6.73-1-7.4c0.29-0.69,1.09-1.02,1.78-0.73C113.32,548.11,113.36,548.13,113.4,548.15z"
    />
    <path
      class="bone"
      disabled
      d="M121.62,564.15c0.07-0.07,0.27-0.19,0.31-0.1c0.42,0.81-0.09,1.55,0.41,2.41c0.3,0.64,0.63,1.26,1,1.86c0.22,0.29,0.46,0.35,0.53,0.77s-0.08,0.8,0,1.19s0.3,0.68,0.06,1s-0.51,0.26-0.73,0c-0.49-0.63-0.09-1.36-1-1.63c-0.04-0.39-0.05-0.79-0.05-1.18c-0.14-0.32-0.31-0.62-0.5-0.91c-0.27-0.55-0.38-1.23-1-1.45c-0.41-0.15-0.67,0-0.94-0.4s-0.11-0.57,0.21-0.88c0.22-0.15,0.48-0.24,0.75-0.24c0.5,0,0.78,0.06,0.89-0.19S121.49,564.31,121.62,564.15z"
    />
    <path
      class="bone"
      disabled
      d="M123.87,563.15c0.37-0.57,0.64,0,1.24-0.27c0.06,0,0-0.17,0.06-0.22s0.32-0.3,0.4-0.27c0.84,0.26-0.18,1.37,0.31,2.16c0.28,0.56,0.6,1.11,0.95,1.64c0.21,0.26,0.44,0.3,0.52,0.67c0.04,0.36,0.04,0.73,0,1.09c0,0.36,0.3,0.6,0.11,0.93s-0.46,0.26-0.67,0c-0.47-0.56-0.14-1.24-1-1.43c-0.09-0.37,0-0.73-0.1-1.08c-0.13-0.28-0.3-0.55-0.49-0.8c-0.27-0.49-0.4-1.11-0.94-1.28c-0.38-0.12-0.39,0.14-0.54-0.31C123.61,563.7,123.67,563.38,123.87,563.15z"
    />
    <path
      class="bone"
      disabled
      d="M127.25,562.8c0.37,0.1,0.47,0.51,0.67,0.84c0.13,0.16,0.25,0.34,0.34,0.53c0.08,0.23,0,0.47,0.1,0.71c0.6,0.11,0.39,0.58,0.72,1c0.15,0.15,0.32,0.19,0.45,0s0-0.43-0.09-0.63s0-0.5-0.05-0.73s-0.22-0.27-0.36-0.44c-0.25-0.34-0.48-0.71-0.69-1.08c-0.35-0.52,0.36-1.23-0.22-1.39c-0.09,0.01-0.18,0.06-0.24,0.12c-0.04,0.09-0.09,0.17-0.15,0.25c-0.31,0.25-0.66-0.06-1,0.28C126.71,562.18,126.45,562.6,127.25,562.8z"
    />
    <path
      class="bone"
      disabled
      d="M117.97,571.63c-0.21-0.86-0.26-1.75-0.15-2.63c-0.01-0.32-0.18-0.61-0.45-0.79c-0.37-0.27-0.82-0.42-1.28-0.44c-0.3,0.07-0.57,0.21-0.81,0.4c-0.3,0.24-0.44,0.63-0.36,1c0.08,0.29,0.18,0.57,0.29,0.84c0.47,1.16,0.58,2.42,1,3.61c0.2,0.55,1.76,1.14,2.17,0.14C118.75,572.91,118.33,572.34,117.97,571.63z"
    />
    <path
      class="bone"
      disabled
      d="M107.33,536.23c-1.58,0.13-3.32,1.07-3.53,2.69c-0.27,1.46-1.08,2.78-2.26,3.68c-0.81,0.69-1.26,1.71-1.25,2.77c0,1.81-0.08,5.29,1.69,5.23c1.1-0.15,2.1-0.75,2.74-1.66c0.94-1.05,2.67-1.35,4.89-1.19c1.64,0.11,3.14-1.35,5.06-1.19s2.39,1,3.73,1.41s1.86-1.05,0.86-2c-0.92-0.72-1.9-1.36-2.93-1.92c-2.81-1.58-2-4.63-2.4-5.76C113.4,536.74,109.23,536.08,107.33,536.23z"
    />
    <path
      class="bone"
      disabled
      d="M127.96,430.82c0.39-1.3-0.46-2.53-1.09-2.27c-2.63,1.07-3.3,1.13-5,0.34c-1.11-0.52-2.94,1.23-4.92,1.33c-2.14,0.12-3-2-4.18-1.25c-1.54,0.94-4.19,1.71-6.08,0.79c-0.36-0.17-0.79-0.12-1.11,0.13c-0.65,0.3-1.09,0.93-1.15,1.65c-0.11,0.86,0.34,2.18,1.79,4.63c6.44,10.88,3.53,31,2.46,45.41c-3,39.51-6.32,39.6-7.26,52.23c-0.07,1,0.62,2.54,1.42,2.61s3-1.24,5.25-1.36c2.21,0.11,4.4,0.5,6.51,1.18c2,0.71,0.44-3.65,0-7.32c-1.16-9,3.6-48.92,4.41-55.22c0.69-5.37,2.64-26.1,3.42-30C123.5,438.26,126.79,434.78,127.96,430.82z"
    />
    <path
      class="bone"
      disabled
      d="M104.05,563.65c-0.74,1.13-1.54,2.89-0.14,2.81c0.59-0.86,1.34-1.6,2.21-2.17c0.94-0.43,2,0.51,3,1.63c0.28,0.1,0.35-0.08,0.45-0.36c0.43-1.12-0.36-2.78-0.44-3.91c-0.12-1.51,0.54-2.54,0.95-3.92c0.46-1.54-0.1-2.1-0.1-2.1s-1.87-2-3.66-1.63c-0.44,0.11-0.83,0.34-1.13,0.68c-0.59,0.59-0.94,1.37-1,2.2c-0.05,1.01,0.02,2.01,0.22,3C104.71,561.37,104.88,562.4,104.05,563.65z"
    />
    <path
      class="bone"
      disabled
      d="M110.33,554.35c-0.05,0.07-0.15,0.09-0.22,0.04c-0.01-0.01-0.03-0.02-0.04-0.04c-0.69-0.84-1.67-1.39-2.74-1.55c-1.27-0.15-3.23,1.3-3.52,1.67s-0.44-0.44-0.37-0.9c0.21-1.5,1.21-3.51,2.35-4.09c1.17-0.54,2.5-0.6,3.71-0.15c0.6,0.24,1.07,0.71,1.33,1.3c0.3,0.62,0.37,1.33,0.19,2C110.89,553.24,110.65,553.82,110.33,554.35z"
    />
    <path
      class="bone"
      disabled
      d="M118.33,556.18c0.33-0.23-2-7.83-2-7.83c-0.13-0.17-0.31-0.28-0.52-0.32c-1.49-0.39-1.21,0.1-1.21,0.1c1.29,2.44,1.53,7.33,1.86,7.89C116.41,556,116.95,557.13,118.33,556.18z"
    />
    <path
      class="bone"
      disabled
      d="M121.42,552.31c-0.29-0.81-0.65-1.57-0.94-2.38l-0.13-0.13c-0.11,0-0.74-0.32-0.62,0.07s0.88,2.5,0.88,2.5c0.37,0.88,0.66,1.68,0.76,1.79s0.59,0.28,0.71,0C122.33,553.53,121.61,552.84,121.42,552.31z"
    />
    <path
      class="bone"
      disabled
      d="M117.7,549.58c0.14,0.36,1.79,5.79,1.86,6s0.53,0,0.74-0.24c0.6-0.66-0.21-1.43-0.34-2.15c0.01-0.05,0.01-0.11,0-0.16c0,0-0.95-3.17-1-3.37S117.56,549.21,117.7,549.58z"
    />
    <path
      class="bone"
      disabled
      d="M115.86,564.52c0.31,0.03,0.62,0.1,0.91,0.21c0.1,0.04,0.22-0.02,0.26-0.12v-0.01c0.27-1.08-0.87-2-1-3.25s0.44-2.77-1.34-2.38c-0.41-0.01-0.82,0.01-1.23,0.06c-0.36,0.13-0.57,0.26-0.54,0.65l0.42,5.24c0,0,0.06,0.38,0.77,0.07l0.55-0.25C115.03,564.55,115.45,564.48,115.86,564.52z"
    />
    <path
      class="bone"
      disabled
      d="M120.92,562.6c-0.09-0.41-0.25-0.81-0.46-1.17c-0.09-0.4-0.28-0.78-0.56-1.08c-0.28-0.39-0.51-0.8-0.71-1.24c-0.21-0.42-0.09-1.19-0.52-1.36c-0.49-0.09-1-0.01-1.45,0.22c-0.13,0.33,0.25,0.85,0.45,1.32c0.42,1,1,1.91,1.42,2.89s0.38,1.43,0.77,1.44l0.83-0.46C120.82,563,120.9,562.81,120.92,562.6z"
    />
    <path
      class="bone"
      disabled
      d="M117.58,566.21c0,0,0.42,0.35,0.35,0.61s-0.44,0.31-0.44,0.31c-0.45-0.27-0.98-0.39-1.5-0.36c-0.57,0.16-1.1,0.43-1.56,0.81c-0.33,0.23-0.51-0.27-0.51-0.81c0.01-0.43,0.27-0.82,0.66-1c0.21-0.1,0.44-0.17,0.67-0.21c0.83,0,1.64,0.24,2.33,0.69"
    />
    <path
      class="bone"
      disabled
      d="M120.33,557.33c0.31,0.93,1,1.36,1.54,2.12c0.29,0.38,0.52,0.81,0.67,1.26c0.15,0.43,0.44,1.28,0.69,1.34s1.48-0.13,1.5-0.38c-1.06-1.83-2.22-3.6-3.46-5.31C120.99,556.05,120.04,556.61,120.33,557.33z"
    />
    <path
      class="bone"
      disabled
      d="M125.98,561.21c0.19,0,1.48-0.21,1.55-0.53s-1.49-2.06-2.5-2.86s-1.12-2-2.13-2.48c-0.43-0.2-1.13,0.07-0.84,0.54s3.51,5,3.51,5C125.7,561,125.83,561.11,125.98,561.21z"
    />
    <path
      class="bone"
      disabled
      d="M105.52,569.82h-0.26c-0.05,0-1.58-0.49-1.28-1.63s2.07-2.77,2.57-2.64c0,0,0.67-0.15,1.83,1.3c0.35,0.42,0.59,0.93,0.67,1.47c0.04,0.42-0.18,0.81-0.55,1c-0.39-0.06-0.78-0.09-1.17-0.1c-0.54,0.11-1.05,0.34-1.5,0.66C105.72,569.9,105.61,569.88,105.52,569.82z"
    />
    <path
      class="bone"
      disabled
      d="M130.4,230.55c-9.66-1.78-14.75,2.59-15.08,7.08c-0.51,7,4,18.87,1.21,24.81c-2.69,5.71-6.83,10.62-12,14.24c-1.9,1.34-4.12,2.74-5.35,4.88c-1.89,0.31-3.81,0.31-5.7,0c-1.24-2.14-3.46-3.54-5.36-4.88c-5.17-3.62-9.31-8.53-12-14.24c-2.79-5.94,1.72-17.82,1.21-24.81c-0.33-4.49-5.41-8.86-15.07-7.08c-6.2,1.14-11.39,5.28-11.4,12.54c0,6.89,1.53,18.69,12.11,23.53c4.38,2,7.11,4.3,8,8.55c1.29,6.31-0.54,12.7,0.5,16.7c1.67,6.45,5.85,8.7,11.64,8.64c5.6-0.05,8.82-5.26,10.41-10.21c0.02-0.15,0.07-0.29,0.13-0.42c0.73,0.7,1.68,1.11,2.69,1.18l0,0c1.01-0.07,1.96-0.49,2.69-1.18l0.12,0.42c1.59,4.95,4.81,10.16,10.41,10.21c5.79,0.06,10-2.19,11.65-8.64c1-4-0.8-10.39,0.5-16.7c0.86-4.25,3.59-6.54,8-8.55c10.58-4.84,12.11-16.64,12.1-23.53C141.78,235.83,136.59,231.69,130.4,230.55z M84.18,293.86c-2.57,1.31-3.73-3.11-4.79-4.76c-1.37-2.14-3.34-4.26-2.51-7.07s4-2.24,6.24-1.2c2.24,1.23,3.84,3.36,4.4,5.85C87.78,289,86.44,292.71,84.18,293.86z M113.27,289.1c-1.07,1.65-2.23,6.07-4.8,4.76c-2.25-1.15-3.6-4.84-3.33-7.18c0.56-2.49,2.15-4.62,4.39-5.85c2.21-1,5.38-1.75,6.25,1.2S114.63,287,113.27,289.1L113.27,289.1z"
    />
    <path
      class="bone"
      disabled
      d="M100.64,100.94c0,0-1.85-0.06-4.31-0.06s-4.31,0.06-4.31,0.06c-2.22,0.18-0.69,3.61-0.4,4.49s2.17,1.23,4.71,1.23s4.37-0.22,4.71-1.23S102.86,101.12,100.64,100.94z"
    />
    <path
      class="bone"
      disabled
      d="M111.45,418.29c0.77-3.91,6-4,7.74-3.34c1.43,0.57,3.66,3.85,3.53,6.24s-2.33,7.39-5.89,7.19C113.44,428.18,110.45,423.36,111.45,418.29z"
    />
    <path
      class="bone"
      disabled
      d="M55.82,275.39c2.89,0.14,2.09,2.69,3.55,2s0.27-2.57-0.24-3.91s-0.07-3.93,1.75-4.58c3.33-1.19,6.27,1.75,7.46,4.1c1.23,2.48,1.78,5.24,1.58,8c-0.38,2.67-3.42,1.57-5.57,2.18s-2.42,5.46-1.24,8.35s1.88,3.83,0.86,7.38s3,27.23,5.88,46.86c1.94,13.38,5.89,34.63,9,47.32c1.32,5.36,4.67,15.14,6,16.66c3.75,4.24,4.65,8.37,3,14.39c-1.07,4-3.51,4.82-5.43,4.49c-1.84-0.6-1.46-2.09-1.1-3.1s1.81-4.28,1.29-7.29c-0.71-3.86-4.41-6.41-8.27-5.69c-1.25,0.23-2.41,0.79-3.37,1.62c-2.17,1.94-3,5.45-2.19,8.63c0.54,2.11,1.46,2.85,1,4.16c-0.6,1.56-2.88,1.12-5.12-0.91c-0.76-0.68-2-2.09-1.1-8.65c0.77-5.73,4-6.19,4.56-12.15s-5.88-46.77-7.2-54.63c-1.2-7-6.41-45.14-6.59-46.77c-0.39-3.53-4.06-7.68-5.17-13C46.41,277.56,52.92,275.26,55.82,275.39z"
    />
    <path
      class="bone"
      disabled
      d="M64.69,430.82c-0.38-1.3,0.47-2.53,1.09-2.27c2.63,1.07,3.3,1.13,5,0.34c1.11-0.52,2.94,1.23,4.91,1.33c2.14,0.12,3-2,4.18-1.25c1.55,0.94,4.2,1.71,6.08,0.79c0.37-0.17,0.8-0.12,1.12,0.13c0.65,0.31,1.08,0.94,1.14,1.65c0.11,0.86-0.34,2.18-1.79,4.63c-6.43,10.88-3.53,31-2.45,45.41c2.94,39.51,6.32,39.6,7.25,52.23c0.08,1-0.61,2.54-1.41,2.61s-3-1.24-5.25-1.36c-2.21,0.11-4.4,0.5-6.51,1.18c-2,0.71-0.44-3.65,0-7.32c1.16-9-3.6-48.92-4.4-55.22c-0.69-5.37-2.65-26.1-3.43-30C69.16,438.26,65.87,434.78,64.69,430.82z"
    />
    <path
      class="bone"
      disabled
      d="M81.21,418.29c-0.78-3.91-6-4-7.75-3.34c-1.43,0.57-3.65,3.85-3.53,6.24s2.33,7.39,5.9,7.19C79.22,428.18,82.21,423.36,81.21,418.29z"
    />
    <path
      class="bone"
      disabled
      d="M156.02,109.82c-1.83-1.07-3.73-2.01-5.69-2.82c-1.28-0.46-2.35-0.5-3.09,0.2s-0.69,2.09-0.4,3.35s-3.15,2.12-4.16,2s-2.68-2.2-4.37-2.74s-4.07,0.75-5.39,0.88c-0.73,0.08-2.59-0.08-4.64-0.18v1c2.54,1.13,6.89,3.51,8,7c0.55,1.59,0.21,3.35-0.89,4.62c1.54,1.43,3.25,3.52,3.33,5.81c0.08,1.26-0.25,2.52-0.94,3.58c1.53,1.28,3.06,3.17,2.82,5.5c-0.14,1.58-0.85,3.05-2,4.14c0.64,0.43,1.25,0.9,1.83,1.41c3.46-7.13,5.46-12.69,4.29-13.76c-1.03-1.18-1.72-2.62-2-4.16c-0.28-3.06,0.47-6.13,2.12-8.72c1.4-2.21,4.83-4.62,10.94-3.27C158.15,114.12,157.71,110.88,156.02,109.82z"
    />
    <path
      class="bone"
      disabled
      d="M47.98,129.74c-1.17,1.07,0.83,6.63,4.28,13.76c0.58-0.51,1.19-0.98,1.83-1.41c-1.14-1.09-1.85-2.56-2-4.14c-0.24-2.33,1.3-4.22,2.83-5.5c-0.69-1.07-1.02-2.32-0.95-3.59c0.09-2.28,1.79-4.37,3.34-5.8c-1.1-1.27-1.44-3.02-0.9-4.61c1.16-3.45,5.51-5.83,8.06-7v-1c-2,0.1-3.91,0.26-4.65,0.18c-1.31-0.13-3.64-1.43-5.38-0.88s-3.34,2.62-4.37,2.74s-4.44-0.72-4.16-2s0.32-2.65-0.4-3.35s-1.82-0.66-3.09-0.2c-1.98,0.8-3.89,1.73-5.74,2.79c-1.68,1.06-2.12,4.3,0.29,3.77c6.12-1.35,9.54,1.06,10.95,3.27c1.65,2.59,2.4,5.66,2.12,8.72C49.75,127.07,49.04,128.54,47.98,129.74z"
    />
    <path
      class="bone"
      disabled
      d="M103.74,170.19c-0.14-0.35-0.47-0.63-0.8-0.54c-0.76,0.21-2,1-2,0c0-0.61,1-1.77-0.87-2c0,0-1.58-0.07-3.69-0.07s-3.7,0.07-3.7,0.07c-1.9,0.21-0.85,1.37-0.86,2c0,1-1.29,0.22-2,0c-0.36-0.04-0.7,0.19-0.8,0.54c0.01,0.15-0.01,0.3-0.07,0.44c0,0.31,0.3,0.59,0.87,0.66c1.52,0.21,2.62,0.42,2.56,1.37c-0.08,1.18,1.87,1.48,4,1.48s4.13-0.3,4-1.48c-0.06-0.95,1-1.16,2.56-1.37c0.56-0.07,0.81-0.35,0.86-0.66L103.74,170.19z"
    />
    <path
      class="bone"
      disabled
      d="M140.48,156.23c-0.17-1.82-3.86-3.44-3.86-3.44s4.53-1.69,4.47-4.14c-0.09-3.47-7-6.53-7-6.53s4-0.87,4.33-4.4c0.28-2.73-4.29-5.05-4.29-5.05c1.54-0.56,2.52-2.08,2.39-3.72c-0.1-2.87-4.7-5.92-4.7-5.92s3.22-1.36,2.38-3.88c-1.28-3.78-8.49-6.3-8.49-6.3c0.33-0.96,0.44-1.99,0.32-3c-1.71,0.02-3.42,0.13-5.12,0.34c0,1.36-0.43,2.94-3.21,3.25c-0.76,0.09-10.41,0.33-11.67,0.38c-0.3,0.02-0.6,0.06-0.89,0.13c-0.88-0.48-1.67-1.11-2.34-1.86c-0.86-1.12-0.79-3.22-2-3.6c-0.7-0.22-2.12,0.2-4.41,0.2s-3.72-0.42-4.42-0.2c-1.23,0.38-1.16,2.48-2,3.6c-0.67,0.74-1.46,1.37-2.34,1.86c-0.3-0.07-0.6-0.11-0.9-0.13c-1.26,0-10.9-0.29-11.67-0.38c-2.77-0.31-3.24-1.89-3.2-3.25c-1.57-0.17-3.29-0.29-5.12-0.34c-0.12,1.01-0.02,2.04,0.32,3c0,0-7.22,2.52-8.49,6.3c-0.84,2.52,2.38,3.88,2.38,3.88s-4.62,3.05-4.78,5.97c-0.13,1.64,0.85,3.16,2.39,3.72c0,0-4.56,2.28-4.23,5c0.36,3.53,4.33,4.4,4.33,4.4s-7,3.06-7.05,6.53c-0.06,2.45,4.47,4.14,4.47,4.14s-3.68,1.62-3.85,3.44c-0.35,3.81,3.77,5.27,3.77,5.27s-4,2.24-3.55,5.29c0.24,1.54,2.57,3.52,2.57,3.52s-2.82,2.77-2.33,6c0.35,1.64,1.27,3.11,2.6,4.14c0,0-2.73,2.77-2,6s4.42,3.78,4.42,3.78c-0.07,0.21-1.62,4.11-1.29,5.93c0.91,4.89,6.14,4.24,7.63,4.12c2.79-0.41,5.37-1.69,7.39-3.66c0.84-0.85,1.9-2.06,3.05-3.47c2.4-1.1,4.69-2.44,6.83-4c1.91-1.73,3.71-3.57,5.39-5.52c1.57-1.73,2.31-3,1.35-3.77s-2.83,0.67-4,1.53c-0.62,0.46-1.79,1.58-3.13,2.8c0.42-0.68,0.8-1.34,1.16-2c2.31-4.21,5.21-5,6.59-10.4c0.5-2,0.42-6.31,3.6-11c0.84,3.52,2.08,6.55,3.75,6.71h0.68c1.67-0.16,2.9-3.19,3.74-6.72c3.18,4.69,3.11,9,3.61,11c1.37,5.44,4.27,6.19,6.59,10.4c0.27,0.49,0.56,1,0.86,1.49c-1.11-1-2.06-1.91-2.59-2.31c-1.18-0.86-3-2.3-4-1.53s-0.22,2,1.35,3.77c1.69,1.94,3.49,3.79,5.39,5.52c2.01,1.49,4.16,2.77,6.43,3.83c1.21,1.5,2.34,2.79,3.22,3.68c2.01,1.97,4.6,3.25,7.39,3.66c1.48,0.12,6.71,0.77,7.62-4.12c0.33-1.82-1.21-5.72-1.28-5.93c0,0,3.68-0.58,4.41-3.78s-2-6-2-6c1.32-1.03,2.25-2.5,2.6-4.14c0.48-3.27-2.33-6-2.33-6s2.33-2,2.57-3.52c0.48-3-3.55-5.29-3.55-5.29S140.83,160,140.48,156.23z M69.83,115.68c2.2,0.8,4.5,1.32,6.84,1.52c1.89,0.15,6.55,0.41,9.16,0.48c0.23,1.6,1.02,3.06,2.23,4.13c0.08,0.09,0.16,0.2,0.25,0.32c-5.68,0.05-11.35-0.23-17-0.82C62.93,120,69.83,115.68,69.83,115.68z M66.76,124.55c4.01,0.81,8.06,1.38,12.14,1.69c3.41,0.22,8.31,0.19,10.8,0.2c0.27,1.55,0.48,3.36,0.64,5.28c-4.92-0.12-15.92-0.54-20-1.15C59.33,128.91,66.76,124.55,66.76,124.55z M64.91,134.68c0,0,5.63,1,8.59,1.25c2.79,0.24,13.52,0.56,17.1,0.14c0.07,1.57,0.12,3.15,0.15,4.66h-0.42c-4.34,0.33-17.65,0.81-21.61,0.13C56.04,138.68,64.91,134.68,64.91,134.68L64.91,134.68z M64.62,144.18c0,0,4.71,1,7.62,1.3c6.2,0.29,12.41,0.03,18.56-0.79v3.51c-6.51,3.43-16.92,4.45-23.41,3.13C52.69,148.34,64.62,144.18,64.62,144.18L64.62,144.18z M58.49,172.87c0,0,1.39,0.31,2.61,0.67c1.64,0.42,3.31,0.73,5,0.91c2.49,0.21,4.99,0.09,7.44-0.38c2.23-0.38,3-0.79,5.36-1.07s1.3,1.27-0.93,3.18s-10.41,4.28-18,2.3C54.86,177.15,58.49,172.87,58.49,172.87L58.49,172.87z M58.01,185.64c-0.87-1,0-2.75,0-2.75c2.42,0.64,4.91,1.01,7.42,1.11c5.87,0,7.69-0.91,10.57-1.66s1.46,0.63,0.75,1.23c-1.28,1.09-4.66,4.07-11.86,4.27C62.59,187.88,58.93,186.75,58.01,185.64L58.01,185.64z M65.55,195.57c-2.56,0.79-4.25-0.59-4.06-1.53c0.12-0.57,0.31-1.11,0.59-1.62c2.18,0.67,4.47,0.89,6.73,0.63C70.7,192.73,68.17,194.76,65.55,195.57z M82.55,165.45c-2.42,2.9-10.46,6.19-19.88,4.32c-7.76-1.53-1.9-5.82-1.9-5.82c3.07,0.94,6.28,1.38,9.49,1.31c4.78-0.12,8.74-0.93,11.26-2.24s2.39,0.74,0.99,2.43L82.55,165.45z M82.61,157.95c-5.4,3.2-12.65,3.34-16,2.87c-11.46-1.62-6.51-6.18-6.51-6.18c2.99,0.8,6.02,1.4,9.09,1.82c3,0.32,10.48,0.23,13.77-0.86c1.37-0.45,0.95,1.55-0.39,2.4L82.61,157.95z M90.55,156.88c-1.25,0.59-4.05,0.59-2.7-1c0.98-1.08,2.04-2.09,3.18-3c0.09,1,0.22,2.17,0.41,3.4c-0.29,0.23-0.6,0.43-0.93,0.6H90.55z M104.64,121.81c1.2-1.07,1.99-2.53,2.23-4.13c2.6-0.07,7.26-0.33,9.15-0.48c2.34-0.2,4.64-0.71,6.84-1.52c0,0,6.9,4.36-1.44,5.63c-4.55,0.68-13.36,0.78-17,0.82c0.05-0.11,0.11-0.22,0.18-0.32H104.64z M103,126.44c2.48,0,7.38,0,10.8-0.2c4.07-0.31,8.13-0.88,12.13-1.69c0,0,7.41,4.36-3.58,6c-4.07,0.61-15.08,1-20,1.15c0.1-1.76,0.31-3.52,0.61-5.26L103,126.44z M102.09,136.07c3.58,0.42,14.32,0.1,17.1-0.14c3-0.25,8.6-1.25,8.6-1.25s8.86,4-3.82,6.19c-4,0.68-17.27,0.2-21.61-0.13h-0.41c-0.01-1.52,0.03-3.1,0.1-4.67H102.09zM101.89,144.69c6.15,0.82,12.37,1.08,18.57,0.79c2.91-0.27,7.62-1.3,7.62-1.3s11.93,4.16-2.79,7.15c-6.5,1.32-16.91,0.3-23.42-3.13c-0.03-1.01-0.03-2.2-0.02-3.51L101.89,144.69z M102.18,156.88c-0.31-0.15-0.61-0.34-0.88-0.55c0.18-1.23,0.31-2.4,0.41-3.4c1.14,0.91,2.2,1.92,3.18,3c1.3,1.54-1.5,1.54-2.75,0.95H102.18z M109.78,155.6c3.28,1.09,10.76,1.18,13.77,0.86c3.06-0.42,6.09-1.02,9.08-1.82c0,0,5,4.56-6.51,6.18c-3.35,0.47-10.59,0.33-16-2.87c-1.38-0.8-1.79-2.8-0.38-2.35L109.78,155.6zM110.19,165.45c-1.4-1.69-1.5-3.75,1-2.43s6.47,2.12,11.26,2.24c3.21,0.08,6.41-0.34,9.48-1.26c0,0,5.85,4.29-1.91,5.82c-9.41,1.82-17.45-1.47-19.87-4.37L110.19,165.45z M127.19,195.57c-2.61-0.81-5.14-2.84-3.25-2.52c2.26,0.26,4.55,0.04,6.72-0.63c0.28,0.51,0.48,1.05,0.6,1.62c0.07,0.96-1.59,2.32-4.16,1.53L127.19,195.57z M134.73,185.64c-0.91,1.11-4.57,2.24-6.88,2.18c-7.19-0.2-10.58-3.18-11.85-4.27c-0.72-0.6-2-2,0.75-1.23c3.36,1.2,6.91,1.77,10.47,1.68c2.49-0.09,4.96-0.46,7.37-1.09c0,0,0.93,1.68,0.05,2.73L134.73,185.64z M132.73,178.48c-7.62,2-15.71-0.3-18-2.3s-3.25-3.47-0.93-3.18s3.13,0.69,5.37,1.07c2.45,0.47,4.95,0.59,7.43,0.38c1.69-0.18,3.36-0.49,5-0.91c1.23-0.36,2.61-0.67,2.61-0.67s3.58,4.28-1.53,5.61L132.73,178.48z"
    />
    <path
      class="outline"
      d="M105.11,580c-1.35,0.05-2.65-0.49-3.58-1.47c-2.74-2.94-2.27-9.67-1.9-15.08c0.12-1.64,0.22-3.18,0.22-4.4c0-3.15-0.46-7.49-0.9-11.7s-0.92-8.61-0.92-11.81c0.13-3.57,0.49-7.13,1.06-10.65c0.85-5.42,1.34-10.9,1.47-16.39c0-0.22-3.5-28.91-3.5-44.6c-0.07-7.84,0.83-15.67,2.68-23.29c0.69-2.53,1.09-5.12,1.21-7.74c0-0.83-3.29-68.52-4.62-112.75C95.01,364.35,91.75,432,91.71,432.9c0.12,2.61,0.53,5.19,1.21,7.71c1.85,7.62,2.75,15.45,2.68,23.29c0,15.69-3.47,44.38-3.5,44.67c0.13,5.47,0.62,10.92,1.47,16.32c0.57,3.52,0.93,7.08,1.06,10.65c0,3.2-0.47,7.58-0.91,11.81s-0.91,8.55-0.91,11.7c0,1.22,0.1,2.76,0.22,4.4c0.37,5.41,0.84,12.14-1.89,15.08c-0.93,0.98-2.24,1.52-3.59,1.47c-8,0-27.59-5.28-27.59-15.07c0-2.92,2.54-6.59,5.49-10.85c3.94-5.71,8.85-12.81,8.85-20.19c0-5.2-2.62-14.69-5.66-25.68c-4.6-16.65-10.31-37.37-10.31-54.73c0-7.25,0.36-14.5,1.09-21.72c0.42-4.66,0.79-8.69,0.79-13.78c0-4.05-1.58-10.28-3.76-18.9C51.09,377.83,42.1,342.26,42.1,284.9c0-6.93,2.3-19.06,4.73-31.9c2.79-14.7,5.94-31.35,5.94-42.21c0-7.53-4.15-34.59-6.09-46.82c-0.24,8-0.79,20.4-1.23,30.06c-0.33,7.43-0.59,13.31-0.59,14.46c0,1.38-0.09,4.19-0.19,7.44c-0.13,4.3-0.28,9.18-0.28,12.31c0,3.63-1.5,10.44-3.23,18.33c-0.93,4.23-1.89,8.61-2.68,12.79c-0.07,0.4-0.26,1.34-0.52,2.65c-1.4,7-5.13,25.68-5,28.51c0.14,2.44,2,25.68,2.24,28.48c0.52,5.14,0.47,14-1.27,17.72c-2.73,5.73-12.43,8.39-16.78,8.48c-1.46,0.04-2.85-0.62-3.74-1.77c-4.27-5.06-3.21-20.36-2.32-27.54c-1.6,3.18-3.46,6.23-5.56,9.11c-0.85,1.26-2.51,1.69-3.86,1c-1.52-0.97-2.09-2.92-1.34-4.56c0.13-0.36,0.36-1,0.66-1.94c1.88-5.64,6.87-20.61,11.45-25c2.54-2.45,5.29-11.59,4-41.21c0-0.94-0.07-1.57-0.07-1.82c0.07-7.28,0.51-14.55,1.31-21.79c0.47-5,0.88-9.23,0.88-13v-2.55c-0.51-41.6,1.09-93.55,11.63-104.84c1.3-1.37,2.72-2.61,4.25-3.71c10.15-7.41,26-10.78,36.43-13c4.85-1,9-1.93,9.84-2.71c2.1-2.06-0.3-15.8-1.18-19.6c-1.36-3.21-2.43-6.54-3.2-9.95c-0.23-1.08-0.39-2-0.49-2.64c-0.67,0.27-1.43,0.16-2-0.29c-0.97-0.74-1.73-1.71-2.22-2.83c-0.97-1.88-1.72-3.88-2.22-5.94l-0.23-0.88c-0.44-1.71-0.78-3.45-1-5.2c-0.3-1.81-0.37-3.65-0.21-5.48c0.04-0.74,0.27-1.47,0.66-2.1c0-0.27-0.11-0.75-0.18-1.32c-0.36-2.97-0.39-5.97-0.11-8.95c0.24-2.97,0.87-5.89,1.88-8.69c0.78-2.11,1.83-4.11,3.12-5.95c1.92-2.67,4.4-4.89,7.27-6.5C84.93,1.13,89.95,0,96.33,0s11.4,1.13,15.78,3.55c2.87,1.61,5.35,3.83,7.27,6.5c1.27,1.84,2.3,3.84,3.07,5.95c1.01,2.8,1.64,5.72,1.88,8.69c0.28,3,0.24,6.01-0.12,9c-0.07,0.57-0.14,1-0.18,1.32c0.39,0.64,0.61,1.36,0.66,2.1c0.16,1.83,0.09,3.67-0.21,5.48c-0.22,1.75-0.56,3.48-1,5.19l-0.23,0.89c-0.5,2.06-1.25,4.06-2.22,5.94c-0.49,1.12-1.25,2.09-2.22,2.83c-0.57,0.45-1.33,0.56-2,0.29c-0.1,0.64-0.26,1.56-0.49,2.64c-0.76,3.42-1.84,6.77-3.2,10c-0.84,3.64-3.28,17.48-1.16,19.55c0.81,0.78,5,1.68,9.84,2.71c10.46,2.23,26.28,5.6,36.43,13c1.53,1.1,2.95,2.34,4.25,3.71c10.54,11.29,12.15,63.24,11.63,104.84v2.55c0,3.78,0.41,8.06,0.89,13c0.61,6.38,1.3,13.6,1.3,21.79c0,0.25,0,0.88-0.07,1.82c-1.3,29.62,1.45,38.76,4,41.21c4.58,4.42,9.57,19.39,11.45,25c0.3,0.9,0.53,1.58,0.66,1.94c0.71,1.61,0.15,3.5-1.31,4.47c-1.35,0.69-3.01,0.26-3.86-1c-2.11-2.86-3.97-5.89-5.59-9.06c0.89,7.18,1.95,22.48-2.32,27.54c-0.87,1.12-2.21,1.77-3.63,1.77h-0.1c-4.36-0.09-14.06-2.75-16.79-8.48c-1.74-3.69-1.79-12.58-1.27-17.72c0.29-2.82,2.1-26.05,2.24-28.48c0.17-2.84-3.56-21.51-5-28.53c-0.26-1.3-0.45-2.23-0.52-2.63c-0.79-4.18-1.75-8.56-2.68-12.79c-1.73-7.89-3.23-14.7-3.23-18.33c0-3.13-0.15-8-0.28-12.31c-0.1-3.25-0.19-6.06-0.19-7.44c0-1.15-0.26-7-0.59-14.46c-0.43-9.66-1-22-1.23-30.06c-1.94,12.23-6.09,39.29-6.09,46.82c0,10.86,3.15,27.51,5.94,42.21c2.43,12.84,4.73,25,4.73,31.9c0,57.36-9,92.93-14.35,114.18c-2.18,8.62-3.76,14.85-3.76,18.9c0,5.09,0.37,9.12,0.79,13.78c0.73,7.21,1.09,14.46,1.08,21.71c0,17.36-5.72,38.08-10.32,54.73c-3,11-5.66,20.48-5.66,25.68c0,7.38,4.91,14.48,8.85,20.19c3,4.26,5.49,7.93,5.49,10.85C132.7,574.72,113.12,580,105.11,580z M96.33,291.71c0.3,0,0.55,0.25,0.55,0.55v0.01c0,33,5.12,139.5,5.17,140.57c-0.11,2.7-0.52,5.39-1.23,8c-1.83,7.53-2.72,15.25-2.65,23c0,15.62,3.45,44.25,3.49,44.53c-0.12,5.57-0.62,11.13-1.48,16.63c-0.55,3.48-0.88,6.98-1,10.5c0,3.14,0.46,7.49,0.9,11.69s0.92,8.62,0.92,11.82c0,1.26-0.11,2.82-0.23,4.47c-0.36,5.2-0.8,11.67,1.6,14.25c0.72,0.76,1.73,1.18,2.78,1.13c8.09,0,26.48-5.28,26.48-14c0-2.57-2.45-6.12-5.29-10.23c-4-5.83-9-13.09-9-20.81c0-5.35,2.64-14.91,5.7-26c4.59-16.58,10.29-37.22,10.29-54.43c0-7.22-0.36-14.44-1.09-21.62c-0.4-4.49-0.79-8.74-0.79-13.88c0-4.19,1.59-10.48,3.78-19.17c5.36-21.2,14.32-56.69,14.32-113.91c0-6.82-2.28-18.91-4.71-31.7c-2.93-15.46-5.95-31.45-5.95-42.41c0-9.86,6.78-51.29,7.07-53c0.02-0.3,0.28-0.54,0.58-0.52c0.3,0.02,0.54,0.28,0.52,0.58c0,0.01,0,0.02,0,0.03c0,5.93,0.78,23.4,1.35,36.15c0.34,7.45,0.6,13.33,0.6,14.51c0,1.36,0.09,4.16,0.19,7.41c0.13,4.31,0.28,9.19,0.28,12.34c0,3.51,1.55,10.59,3.2,18.09c0.93,4.24,1.89,8.63,2.68,12.83c0.08,0.39,0.26,1.32,0.52,2.61c2.4,12,5.14,26.17,5,28.81c-0.14,2.44-1.95,25.7-2.24,28.53c-0.5,4.87-0.47,13.68,1.17,17.13c2.4,5.06,11.43,7.76,15.81,7.85c1.12,0.02,2.18-0.48,2.87-1.37c4.87-5.78,2.16-26.91,1.59-29.9c-0.06-0.27,0.1-0.54,0.36-0.63c0.26-0.08,0.55,0.03,0.67,0.28c0,0.09,4.3,8.55,7,11.77c0.51,0.84,1.58,1.15,2.46,0.71c1-0.71,1.34-2.03,0.82-3.13c-0.13-0.37-0.36-1.05-0.67-2c-1.85-5.56-6.78-20.34-11.17-24.58c-3.92-3.79-5.38-17.94-4.32-42.05c0-0.91,0.07-1.53,0.07-1.77c-0.07-7.24-0.51-14.48-1.31-21.68c-0.47-5-0.89-9.28-0.89-13.12v-2.57c0.72-58.51-3.31-95.47-11.34-104.06c-1.25-1.32-2.62-2.52-4.09-3.58c-10-7.27-25.64-10.61-36-12.82c-6.14-1.31-9.39-2-10.38-3c-3-3,0.86-20.67,0.94-20.82c1.33-3.13,2.37-6.38,3.11-9.7c0.42-2,0.6-3.43,0.6-3.45c0.03-0.21,0.17-0.39,0.38-0.46c0.2-0.06,0.42,0,0.57,0.15c0.3,0.42,0.88,0.52,1.3,0.22c0,0,0,0,0,0c0.03-0.02,0.06-0.05,0.09-0.08c0.82-0.63,1.46-1.46,1.85-2.42c0.93-1.81,1.65-3.72,2.13-5.7l0.23-0.89c0.45-1.67,0.78-3.37,1-5.08c0.28-1.71,0.35-3.45,0.21-5.18c-0.17-1.27-0.45-1.59-0.55-1.7c-0.11-0.13-0.16-0.3-0.15-0.47c0,0,0.1-0.65,0.21-1.52c0.36-2.89,0.4-5.82,0.12-8.72c-0.23-2.89-0.85-5.73-1.83-8.45c-0.73-2-1.72-3.9-2.93-5.65c-1.82-2.54-4.18-4.64-6.9-6.17c-4.34-2.27-9.15-3.36-15.34-3.36s-11,1.09-15.25,3.42c-2.72,1.53-5.08,3.63-6.9,6.17c-1.21,1.75-2.2,3.65-2.93,5.65c-0.99,2.72-1.6,5.56-1.82,8.45c-0.28,2.9-0.25,5.83,0.11,8.72c0.11,0.87,0.2,1.52,0.21,1.52c0.02,0.16-0.03,0.32-0.13,0.44c-0.12,0.14-0.4,0.46-0.57,1.73c-0.14,1.73-0.07,3.47,0.21,5.18c0.22,1.71,0.56,3.41,1,5.08l0.23,0.89c0.48,1.98,1.2,3.89,2.13,5.7c0.39,0.96,1.03,1.79,1.85,2.42c0.38,0.35,0.96,0.33,1.31-0.05c0.03-0.03,0.05-0.06,0.08-0.09c0.15-0.15,0.37-0.21,0.57-0.15c0.21,0.07,0.35,0.25,0.38,0.46c0,0,0.18,1.49,0.6,3.45c0.75,3.33,1.79,6.59,3.13,9.73c0.06,0.13,3.94,17.84,0.92,20.79c-1,1-4.24,1.69-10.38,3c-10.37,2.21-26,5.55-36,12.82c-1.47,1.06-2.84,2.25-4.08,3.57c-8,8.59-12.06,45.55-11.34,104.06v2.57c0,3.84-0.42,8.14-0.89,13.12c-0.61,6.35-1.31,13.54-1.31,21.68c0,0.24,0,0.86,0.07,1.77c1.06,24.11-0.39,38.26-4.32,42.05c-4.39,4.24-9.32,19-11.17,24.59c-0.31,0.92-0.54,1.61-0.67,2c-0.53,1.12-0.17,2.46,0.85,3.16c0.88,0.44,1.95,0.13,2.46-0.71c2.68-3.22,6.94-11.68,7-11.77c0.12-0.25,0.41-0.36,0.67-0.28c0.26,0.09,0.42,0.36,0.36,0.63c-0.57,3-3.28,24.12,1.59,29.9c0.67,0.9,1.75,1.41,2.87,1.37c4.38-0.09,13.41-2.79,15.81-7.85c1.64-3.45,1.67-12.26,1.17-17.13c-0.3-2.95-2.09-26-2.24-28.53c-0.15-2.53,2.58-16.77,5-28.79c0.26-1.3,0.44-2.23,0.52-2.63c0.79-4.2,1.75-8.59,2.68-12.83c1.65-7.5,3.2-14.58,3.2-18.09c0-3.15,0.15-8,0.28-12.34c0.1-3.25,0.19-6.05,0.19-7.41c0-1.18,0.27-7.06,0.6-14.51c0.57-12.75,1.35-30.22,1.35-36.15c0-0.29,0.22-0.53,0.51-0.55c0.29-0.02,0.54,0.18,0.59,0.46c0.29,1.76,7.08,43.19,7.08,53c0,11-3,27-6,42.41c-2.42,12.79-4.71,24.88-4.71,31.7c0,57.22,9,92.71,14.32,113.91c2.19,8.69,3.81,14.98,3.81,19.19c0,5.14-0.39,9.39-0.79,13.88c-0.73,7.18-1.09,14.4-1.09,21.62c0,17.21,5.7,37.85,10.29,54.43c3.06,11.07,5.7,20.63,5.7,26c0,7.72-5,15-9,20.81c-2.84,4.11-5.29,7.66-5.29,10.23c0,8.69,18.39,14,26.48,14c1.03,0.01,2.01-0.43,2.7-1.2c2.41-2.58,2-9,1.6-14.25c-0.12-1.65-0.23-3.21-0.23-4.47c0-3.2,0.47-7.58,0.92-11.82s0.9-8.55,0.9-11.69c-0.12-3.52-0.45-7.02-1-10.5c-0.86-5.47-1.36-11-1.48-16.54c0-0.35,3.49-29,3.49-44.6c0.07-7.75-0.82-15.47-2.64-23c-0.71-2.61-1.13-5.3-1.24-8c0-1.1,5.17-107.61,5.17-140.6C95.8,292,96.03,291.74,96.33,291.71z"
    />
    <path
      class="region"
      index="1"
      d="M115.23,60.07c0.42-2,0.6-3.43,0.6-3.45c0.03-0.21,0.17-0.39,0.38-0.46c0.2-0.06,0.42,0,0.57,0.15c0.3,0.42,0.88,0.52,1.3,0.22c0,0,0,0,0,0c0.03-0.02,0.06-0.05,0.09-0.08c0.82-0.63,1.46-1.46,1.85-2.42c0.93-1.81,1.65-3.72,2.13-5.7l0.23-0.89c0.45-1.67,0.78-3.37,1-5.08c0.28-1.71,0.35-3.45,0.21-5.18c-0.17-1.27-0.45-1.59-0.55-1.7c-0.11-0.13-0.16-0.3-0.15-0.47c0,0,0.1-0.65,0.21-1.52c0.36-2.89,0.4-5.82,0.12-8.72c-0.23-2.89-0.85-5.73-1.83-8.45c-0.73-2-1.72-3.9-2.93-5.65c-1.82-2.54-4.18-4.64-6.9-6.17c-4.23-2.31-9.04-3.4-15.23-3.4s-11,1.09-15.25,3.42c-2.72,1.53-5.08,3.63-6.9,6.17c-1.21,1.75-2.2,3.65-2.93,5.65c-0.99,2.72-1.6,5.56-1.82,8.45c-0.28,2.9-0.25,5.83,0.11,8.72c0.11,0.87,0.21,1.52,0.21,1.52c0.02,0.16-0.03,0.32-0.13,0.44c-0.12,0.14-0.4,0.46-0.57,1.73c-0.14,1.73-0.07,3.47,0.21,5.18c0.22,1.71,0.56,3.41,1,5.08l0.23,0.89c0.48,1.98,1.2,3.89,2.13,5.7c0.39,0.96,1.03,1.79,1.85,2.42c0.38,0.35,0.96,0.33,1.31-0.05c0.03-0.03,0.05-0.06,0.08-0.09c0.15-0.15,0.37-0.21,0.57-0.15c0.21,0.07,0.35,0.25,0.38,0.46c0,0,0.18,1.49,0.6,3.45c0.75,3.33,1.79,6.59,3.13,9.73c0.03,0.06,0.9,3.99,1.5,8.44h28.57c0.6-4.47,1.48-8.42,1.51-8.49C113.45,66.64,114.49,63.39,115.23,60.07z"
    />
    <path
      class="region"
      index="2"
      d="M110.48,79.26H82.17c0.59,4.78,0.79,9.89-0.71,11.35c-0.63,0.5-1.36,0.86-2.14,1.05v188.99h34v-189c-0.78-0.19-1.52-0.55-2.14-1.06C109.7,89.11,109.89,84.03,110.48,79.26z"
    />
    <path
      class="region"
      index="3"
      d="M53.94,117.76h24.38v-25.8c-1.71,0.47-4.09,0.98-7.24,1.65c-10.37,2.21-26,5.55-36,12.82c-1.47,1.06-2.84,2.25-4.08,3.57c-3.48,3.74-6.22,12.86-8.14,26.8h27.2l3.72-18.24L53.94,117.76z"
    />
    <path
      class="region"
      index="3"
      d="M157.56,106.41c-10-7.27-25.64-10.61-36-12.82c-3.14-0.67-5.52-1.18-7.24-1.65v25.82h24.51l0.16,0.8l3.72,18.24h27.09c-1.92-13.94-4.66-23.07-8.15-26.81C160.4,108.67,159.03,107.47,157.56,106.41z"
    />
    <path
      class="region"
      index="4"
      d="M53.05,200.38h25.27v-81.63H54.76l-7.95,38.99c0,0.02,0.01,0.03,0.02,0.04C47.06,159.16,51.22,184.57,53.05,200.38z"
    />
    <path
      class="region"
      index="4"
      d="M139.73,200.38c1.82-15.8,5.98-41.24,6.23-42.67l-7.94-38.96h-23.69v81.63H139.73z"
    />
    <path
      class="region"
      index="5"
      d="M19.66,214.06v2.57c0,3.84-0.42,8.14-0.89,13.12c-0.61,6.35-1.31,13.54-1.31,21.68c0,0.24,0,0.86,0.07,1.77c1.06,24.11-0.39,38.26-4.32,42.05c-4.39,4.24-9.32,19-11.17,24.59c-0.31,0.92-0.54,1.61-0.67,2c-0.53,1.12-0.17,2.46,0.85,3.16c0.88,0.44,1.95,0.13,2.46-0.71c2.68-3.22,6.94-11.68,7-11.77c0.12-0.25,0.41-0.36,0.67-0.28c0.26,0.09,0.42,0.36,0.36,0.63c-0.57,3-3.28,24.12,1.59,29.9c0.67,0.9,1.75,1.41,2.87,1.37c4.38-0.09,13.41-2.79,15.81-7.85c1.64-3.45,1.67-12.26,1.17-17.13c-0.3-2.95-2.09-26-2.24-28.53c-0.15-2.53,2.58-16.77,5-28.79c0.26-1.3,0.44-2.23,0.52-2.63c0.79-4.2,1.75-8.59,2.68-12.83c1.65-7.5,3.2-14.58,3.2-18.09c0-3.15,0.15-8,0.28-12.34c0.1-3.25,0.19-6.05,0.19-7.41c0-1.18,0.27-7.06,0.6-14.51c0.57-12.75,1.35-30.22,1.35-36.15c0-0.1,0.04-0.21,0.09-0.29l4.08-20.04H22.76C20.34,155.59,19.26,181.48,19.66,214.06z"
    />
    <path
      class="region"
      index="5"
      d="M191.28,321.82c-0.13-0.37-0.36-1.05-0.67-2c-1.85-5.56-6.78-20.34-11.17-24.58c-3.92-3.79-5.38-17.94-4.32-42.05c0-0.91,0.07-1.53,0.07-1.77c-0.07-7.24-0.51-14.48-1.31-21.68c-0.47-5-0.89-9.28-0.89-13.12v-2.57c0.4-32.58-0.67-58.46-3.09-76.5h-27.04l4.04,19.82c0.11,0.11,0.16,0.26,0.15,0.42c0,5.93,0.78,23.4,1.35,36.15c0.34,7.45,0.6,13.33,0.6,14.51c0,1.36,0.09,4.16,0.19,7.41c0.13,4.31,0.28,9.19,0.28,12.34c0,3.51,1.55,10.59,3.2,18.09c0.93,4.24,1.89,8.63,2.68,12.83c0.08,0.39,0.26,1.32,0.52,2.61c2.4,12,5.14,26.17,5,28.81c-0.14,2.44-1.95,25.7-2.24,28.53c-0.5,4.87-0.47,13.68,1.17,17.13c2.4,5.06,11.43,7.76,15.81,7.85c1.12,0.02,2.18-0.48,2.87-1.37c4.87-5.78,2.16-26.91,1.59-29.9c-0.05-0.23,0.05-0.47,0.25-0.59c0.26-0.08,0.55,0.03,0.67,0.28c0,0.09,4.3,8.55,7,11.77c0.51,0.84,1.58,1.15,2.46,0.71C191.46,324.24,191.8,322.92,191.28,321.82z"
    />
    <path
      class="region"
      index="6"
      d="M53.17,201.38c0.46,4.05,0.74,7.39,0.74,9.4c0,6.47-1.04,14.67-2.5,23.46h26.91v-32.87H53.17z"
    />
    <path
      class="region"
      index="6"
      d="M141.41,234.25c-1.47-8.84-2.52-17.07-2.52-23.55c0-2,0.28-5.31,0.73-9.32h-25.3v32.87H141.41z"
    />
    <path
      class="region"
      index="7"
      d="M95.82,292.3c0-0.31,0.24-0.55,0.55-0.56c0.3,0,0.55,0.25,0.55,0.55v0.01c0,2.38,0.03,5.14,0.08,8.21h52.32c0.15-5.04,0.23-10.28,0.23-15.7c0-6.82-2.28-18.91-4.71-31.7c-1.13-5.98-2.28-12.04-3.26-17.86h-27.26v46.4h-36v-46.4H51.24c-0.99,5.85-2.16,11.95-3.33,17.95c-2.42,12.79-4.71,24.88-4.71,31.7c0,5.4,0.08,10.6,0.23,15.61h52.31C95.79,297.44,95.82,294.67,95.82,292.3z"
    />
    <path
      class="region"
      index="8"
      d="M57.52,398.81c2.19,8.69,3.81,14.98,3.81,19.19c0,5.14-0.39,9.39-0.79,13.88c-0.73,7.18-1.09,14.4-1.09,21.62c0,17.21,5.7,37.85,10.29,54.43c3.06,11.07,5.7,20.63,5.7,26c0,7.72-5,15-9,20.81c-2.84,4.11-5.29,7.66-5.29,10.23c0,8.69,18.39,14,26.48,14c1.03,0.01,2.01-0.43,2.7-1.2c2.41-2.58,2-9,1.6-14.25c-0.12-1.65-0.23-3.21-0.23-4.47c0-3.2,0.47-7.58,0.92-11.82s0.9-8.55,0.9-11.69c-0.12-3.52-0.45-7.02-1-10.5c-0.86-5.47-1.36-11-1.48-16.54c0-0.35,3.49-29,3.49-44.6c0.07-7.75-0.82-15.47-2.64-23c-0.71-2.61-1.13-5.3-1.24-8c0-1.01,4.38-91.29,5.08-131.39H43.46C44.98,349.11,52.74,379.74,57.52,398.81z"
    />
    <path
      class="region"
      index="8"
      d="M102.09,432.87c-0.11,2.7-0.52,5.39-1.23,8c-1.83,7.53-2.72,15.25-2.65,23c0,15.62,3.45,44.25,3.49,44.53c-0.14,5.56-0.64,11.11-1.52,16.6c-0.55,3.48-0.88,6.98-1,10.5c0,3.14,0.46,7.49,0.9,11.69s0.92,8.62,0.92,11.82c0,1.26-0.11,2.82-0.23,4.47c-0.36,5.2-0.8,11.67,1.6,14.25c0.72,0.76,1.73,1.18,2.78,1.13c8.09,0,26.48-5.28,26.48-14c0-2.57-2.45-6.12-5.29-10.23c-4-5.83-9-13.09-9-20.81c0-5.35,2.64-14.91,5.7-26c4.59-16.58,10.29-37.22,10.29-54.43c0-7.22-0.36-14.44-1.09-21.62c-0.4-4.49-0.79-8.74-0.79-13.88c0-4.19,1.59-10.48,3.78-19.17c8.47-31.74,13.19-64.37,14.05-97.21H97.01C97.71,341.62,102.04,431.89,102.09,432.87z"
    />
  </svg>`;case"xp_lower-leg":return V` <svg
    id="xp_lower-leg"
    hidden
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0"
    y="0"
    style="width:12rem; height:55rem;"
    viewBox="0 0 192 580"
    style="enable-background:new 0 0 192 580;"
    xml:space="preserve"
  >
    <path
      class="region"
      index="1"
      d="M147.06,265.64H45.6c-1.39,7.85-2.4,14.72-2.4,19.26c0,53.39,7.8,87.85,13.2,109.45h35.93c1.5-34.24,3.42-81.91,3.42-102.08c0-0.3,0.25-0.55,0.55-0.55c0.3,0,0.55,0.25,0.55,0.55c0,0,0,0,0,0c0,20.17,1.92,67.84,3.42,102.08h36c5.4-21.6,13.2-56.06,13.2-109.45C149.46,280.36,148.45,273.49,147.06,265.64z"
    />
    <path
      class="region"
      index="2"
      d="M131.33,418c0-4.19,1.59-10.48,3.78-19.17c0.28-1.08,0.56-2.2,0.85-3.36h-35.63c0.93,21.19,1.68,37,1.7,37.39c-0.11,2.7-0.52,5.39-1.23,8c-0.59,2.6-1.29,5.73-1.83,9.74h34.23c-0.1-8.07-0.61-13.71-1.07-18.74C131.74,427.37,131.33,423.12,131.33,418z"
    />
    <path
      class="region"
      index="2"
      d="M57.52,398.81c2.19,8.69,3.81,14.98,3.81,19.19c0,5.14-0.38,9.39-0.79,13.88c-0.46,5-1,10.67-1.07,18.74h34.2c-0.54-4-1.24-7.14-1.83-9.74c-0.7-2.61-1.12-5.3-1.23-8c0-0.42,0.77-16.22,1.71-37.42H56.67C56.96,396.61,57.24,397.73,57.52,398.81z"
    />
    <path
      class="region"
      index="3"
      d="M98.17,463.91c0,7.81,0.86,18.89,1.73,28h27.33c3.23-12.8,6-26.47,6-38.47c0-0.6,0-1.2,0-1.78H98.85C98.38,455.73,98.15,459.82,98.17,463.91z"
    />
    <path
      class="region"
      index="3"
      d="M59.42,453.48c0,12,2.78,25.67,6,38.47h27.34c0.87-9.16,1.73-20.23,1.73-28c0.01-4.08-0.21-8.16-0.68-12.21H59.43C59.42,452.28,59.42,452.88,59.42,453.48z"
    />
    <path
      class="region"
      index="4"
      d="M117.25,533.89c0-5.35,2.64-14.91,5.7-26c1.3-4.68,2.68-9.69,4-14.86h-26.94c0.83,8.6,1.63,15.25,1.65,15.38c-0.12,5.56-0.62,11.1-1.48,16.59c-0.55,3.48-0.88,6.98-1,10.5c0,1.63,0.12,3.58,0.3,5.66h19.15C117.76,538.83,117.29,536.37,117.25,533.89z"
    />
    <path
      class="region"
      index="4"
      d="M92.48,525c-0.86-5.47-1.35-11-1.48-16.54c0-0.17,0.82-6.84,1.65-15.45H65.71c1.32,5.17,2.7,10.18,4,14.86c3.06,11.07,5.7,20.63,5.7,26c-0.03,2.5-0.5,4.97-1.38,7.31h19.19c0.18-2.08,0.3-4,0.3-5.66C93.39,532,93.04,528.48,92.48,525z"
    />
    <path
      class="region"
      index="5"
      d="M102.33,577.77c0.72,0.76,1.73,1.18,2.78,1.13c8.09,0,26.48-5.28,26.48-14c0-2.57-2.45-6.12-5.29-10.22c-2.52-3.66-5.43-7.87-7.26-12.41h-19.5c0.15,1.62,0.33,3.29,0.5,4.94c0.45,4.23,0.92,8.61,0.92,11.81c0,1.26-0.11,2.82-0.23,4.47C100.33,568.72,99.93,575.19,102.33,577.77z"
    />
    <path
      class="region"
      index="5"
      d="M73.62,542.3c-1.83,4.54-4.74,8.75-7.26,12.41c-2.84,4.1-5.29,7.65-5.29,10.22c0,8.69,18.39,14,26.48,14c1.05,0.04,2.07-0.38,2.78-1.16c2.4-2.58,2-9,1.6-14.25c-0.12-1.65-0.23-3.21-0.23-4.47c0-3.2,0.47-7.58,0.92-11.81c0.17-1.65,0.35-3.32,0.5-4.94L73.62,542.3z"
    />

    <path
      class="outline"
      d="M105.11,580c-1.35,0.05-2.65-0.49-3.58-1.47c-2.74-2.94-2.27-9.67-1.9-15.08c0.12-1.64,0.22-3.18,0.22-4.4c0-3.15-0.46-7.49-0.91-11.7s-0.91-8.61-0.91-11.81c0.13-3.57,0.49-7.13,1.06-10.65c0.85-5.42,1.34-10.9,1.47-16.39c0-0.22-3.5-28.91-3.5-44.6c-0.07-7.84,0.83-15.67,2.68-23.29c0.68-2.53,1.09-5.12,1.21-7.74c0-0.83-3.29-68.52-4.62-112.75C95,364.35,91.75,432,91.71,432.9c0.12,2.61,0.53,5.19,1.21,7.71c1.85,7.62,2.75,15.45,2.68,23.29c0,15.69-3.47,44.38-3.5,44.67c0.13,5.47,0.62,10.92,1.47,16.32c0.57,3.52,0.93,7.08,1.06,10.65c0,3.2-0.47,7.58-0.91,11.81s-0.91,8.55-0.91,11.7c0,1.22,0.1,2.76,0.22,4.4c0.37,5.41,0.84,12.14-1.9,15.08c-0.93,0.98-2.23,1.52-3.58,1.47c-8,0-27.59-5.28-27.59-15.07c0-2.92,2.54-6.59,5.49-10.85c3.94-5.71,8.85-12.81,8.85-20.19c0-5.2-2.62-14.69-5.66-25.68c-4.6-16.65-10.31-37.37-10.31-54.73c0-7.25,0.36-14.5,1.09-21.72c0.42-4.66,0.79-8.69,0.79-13.78c0-4.05-1.58-10.28-3.75-18.9C51.09,377.83,42.1,342.26,42.1,284.9c0-6.93,2.3-19.06,4.73-31.9c2.79-14.7,5.94-31.35,5.94-42.21c0-7.53-4.15-34.59-6.09-46.82c-0.24,8-0.79,20.4-1.23,30.06c-0.33,7.43-0.59,13.31-0.59,14.46c0,1.38-0.09,4.19-0.19,7.44c-0.13,4.3-0.28,9.18-0.28,12.31c0,3.63-1.5,10.44-3.23,18.33c-0.93,4.23-1.89,8.61-2.68,12.79c-0.07,0.4-0.26,1.33-0.52,2.62c-1.4,7-5.13,25.7-5,28.54c0.14,2.43,2,25.66,2.24,28.48c0.52,5.14,0.47,14-1.27,17.72c-2.73,5.73-12.43,8.39-16.78,8.48c-1.46,0.03-2.85-0.62-3.75-1.77c-4.26-5.06-3.2-20.36-2.31-27.54c-1.6,3.18-3.46,6.23-5.56,9.11c-0.85,1.26-2.51,1.69-3.86,1c-1.52-0.97-2.09-2.92-1.34-4.56c0.13-0.36,0.36-1,0.66-1.94c1.88-5.64,6.87-20.61,11.45-25c2.54-2.45,5.29-11.59,4-41.21c0-0.94-0.07-1.57-0.07-1.82c0.07-7.28,0.51-14.55,1.31-21.79c0.47-5,0.88-9.23,0.88-13c0-0.47,0-1.34,0-2.55c-0.51-41.6,1.09-93.55,11.63-104.84c1.3-1.37,2.72-2.61,4.25-3.71c10.15-7.41,26-10.78,36.43-13c4.85-1,9-1.93,9.84-2.71c2.11-2.07-0.3-15.81-1.18-19.6c-1.37-3.21-2.44-6.54-3.2-9.95c-0.23-1.08-0.39-2-0.49-2.64c-0.67,0.27-1.43,0.16-2-0.29c-0.97-0.74-1.73-1.71-2.22-2.83c-0.97-1.88-1.72-3.88-2.22-5.94l-0.23-0.88c-0.44-1.71-0.78-3.45-1-5.2c-0.3-1.81-0.37-3.65-0.21-5.48c0.04-0.74,0.27-1.47,0.66-2.1c0-0.27-0.11-0.75-0.18-1.32c-0.36-2.97-0.39-5.97-0.11-8.95c0.24-2.97,0.87-5.89,1.88-8.69c0.78-2.11,1.83-4.11,3.12-5.95c1.92-2.67,4.4-4.89,7.27-6.5C84.93,1.13,89.95,0,96.33,0s11.41,1.13,15.79,3.55c2.87,1.61,5.35,3.83,7.27,6.5c1.27,1.85,2.3,3.84,3.06,5.95c1.01,2.8,1.64,5.72,1.88,8.69c0.28,3,0.24,6.01-0.12,9c-0.07,0.57-0.14,1-0.18,1.32c0.39,0.64,0.61,1.36,0.66,2.1c0.16,1.83,0.09,3.67-0.21,5.48c-0.22,1.75-0.56,3.49-1,5.2l-0.23,0.88c-0.5,2.06-1.25,4.06-2.22,5.94c-0.49,1.12-1.25,2.09-2.22,2.83c-0.57,0.45-1.33,0.56-2,0.29c-0.1,0.64-0.26,1.56-0.49,2.64c-0.76,3.42-1.84,6.77-3.2,10c-0.84,3.64-3.28,17.48-1.16,19.55c0.81,0.78,5,1.68,9.84,2.71c10.46,2.23,26.28,5.6,36.43,13c1.53,1.1,2.95,2.34,4.25,3.71c10.54,11.29,12.14,63.24,11.63,104.84c0,1.21,0,2.08,0,2.55c0,3.78,0.41,8.06,0.88,13c0.8,7.24,1.24,14.51,1.31,21.79c0,0.25,0,0.88-0.07,1.82c-1.3,29.62,1.45,38.76,4,41.21c4.58,4.42,9.57,19.39,11.45,25c0.3,0.91,0.53,1.58,0.66,1.94l0,0c0.71,1.61,0.15,3.5-1.31,4.47c-1.35,0.69-3.01,0.26-3.86-1c-2.11-2.86-3.98-5.89-5.59-9.06c0.89,7.18,1.95,22.48-2.31,27.54c-0.9,1.14-2.29,1.8-3.75,1.77c-4.35-0.09-14.05-2.75-16.78-8.48c-1.74-3.69-1.79-12.58-1.27-17.72c0.29-2.82,2.1-26.05,2.24-28.48c0.17-2.84-3.56-21.51-5-28.54c-0.26-1.29-0.45-2.22-0.52-2.62c-0.79-4.18-1.75-8.56-2.68-12.79c-1.73-7.89-3.23-14.7-3.23-18.33c0-3.13-0.15-8-0.28-12.31c-0.1-3.25-0.19-6.06-0.19-7.44c0-1.15-0.26-7-0.59-14.46c-0.43-9.66-1-22-1.23-30.06c-1.94,12.23-6.09,39.29-6.09,46.82c0,10.86,3.15,27.51,5.94,42.21c2.43,12.84,4.73,25,4.73,31.9c0,57.36-9,92.93-14.35,114.18c-2.18,8.62-3.76,14.85-3.76,18.9c0,5.09,0.37,9.12,0.79,13.78c0.72,7.21,1.08,14.46,1.08,21.71c0,17.36-5.72,38.08-10.32,54.73c-3,11-5.66,20.48-5.66,25.68c0,7.38,4.91,14.48,8.85,20.19c3,4.26,5.49,7.93,5.49,10.85C132.7,574.72,113.12,580,105.11,580zM96.33,291.71c0.3,0,0.55,0.25,0.55,0.55c0,0,0,0.01,0,0.01c0,33,5.12,139.5,5.17,140.57c-0.11,2.7-0.53,5.39-1.23,8c-1.83,7.53-2.72,15.25-2.65,23c0,15.62,3.45,44.25,3.49,44.53c-0.12,5.57-0.62,11.13-1.48,16.63c-0.55,3.48-0.88,6.98-1,10.5c0,3.14,0.46,7.49,0.9,11.69s0.92,8.62,0.92,11.82c0,1.26-0.11,2.82-0.23,4.47c-0.36,5.2-0.8,11.67,1.6,14.25c0.72,0.77,1.73,1.18,2.78,1.13c8.09,0,26.48-5.28,26.48-14c0-2.57-2.45-6.12-5.29-10.23c-4-5.83-9-13.09-9-20.81c0-5.35,2.64-14.91,5.7-26c4.59-16.58,10.29-37.22,10.29-54.43c0-7.22-0.36-14.44-1.09-21.62c-0.4-4.49-0.79-8.74-0.79-13.88c0-4.19,1.59-10.48,3.78-19.17c5.36-21.2,14.32-56.69,14.32-113.91c0-6.82-2.28-18.91-4.71-31.7c-2.93-15.46-5.95-31.45-5.95-42.41c0-9.86,6.78-51.29,7.07-53c0.02-0.3,0.29-0.53,0.6-0.51s0.53,0.29,0.51,0.6c0,5.93,0.78,23.4,1.35,36.15c0.33,7.45,0.6,13.33,0.6,14.51c0,1.36,0.09,4.16,0.19,7.41c0.13,4.31,0.28,9.19,0.28,12.34c0,3.51,1.55,10.59,3.2,18.09c0.93,4.24,1.89,8.63,2.68,12.83c0.08,0.39,0.26,1.32,0.52,2.61c2.4,12,5.14,26.17,5,28.81c-0.14,2.44-1.95,25.7-2.24,28.53c-0.5,4.87-0.47,13.68,1.17,17.13c2.4,5.06,11.43,7.76,15.81,7.85c1.12,0.04,2.2-0.47,2.87-1.37c4.87-5.78,2.16-26.91,1.59-29.9c-0.06-0.27,0.1-0.54,0.36-0.63c0.26-0.08,0.55,0.03,0.67,0.28c0.05,0.09,4.3,8.55,7,11.77c0.51,0.84,1.58,1.15,2.46,0.71c1-0.71,1.34-2.03,0.82-3.13l0,0c-0.13-0.36-0.36-1.05-0.67-2c-1.85-5.57-6.78-20.35-11.17-24.59c-3.93-3.79-5.38-17.94-4.32-42.05c0-0.91,0.07-1.53,0.07-1.77c0-8.14-0.7-15.33-1.31-21.68c-0.47-5-0.89-9.28-0.89-13.12c0-0.47,0-1.34,0-2.57c0.72-58.51-3.31-95.47-11.34-104.06c-1.25-1.32-2.62-2.52-4.09-3.58c-10-7.27-25.64-10.61-36-12.82c-6.14-1.31-9.39-2-10.38-3c-3-3,0.86-20.67,0.94-20.82c1.33-3.13,2.37-6.38,3.11-9.7c0.42-2,0.6-3.43,0.6-3.45c0.03-0.21,0.17-0.39,0.38-0.46c0.2-0.06,0.42,0,0.57,0.15c0.3,0.42,0.88,0.51,1.3,0.22c0.03-0.02,0.06-0.05,0.09-0.08c0.82-0.63,1.46-1.46,1.85-2.42c0.93-1.81,1.65-3.72,2.13-5.7l0.23-0.89c0.44-1.67,0.77-3.37,1-5.08c0.28-1.71,0.35-3.45,0.21-5.18c-0.17-1.27-0.45-1.59-0.55-1.7c-0.11-0.13-0.16-0.3-0.15-0.47c0,0,0.1-0.65,0.21-1.52c0.36-2.89,0.4-5.82,0.12-8.72c-0.23-2.89-0.85-5.73-1.83-8.45c-0.73-2-1.72-3.9-2.93-5.65c-1.82-2.54-4.18-4.64-6.9-6.17c-4.34-2.26-9.15-3.35-15.34-3.35s-11,1.09-15.25,3.42c-2.72,1.53-5.08,3.63-6.9,6.17c-1.21,1.75-2.2,3.65-2.93,5.65c-0.98,2.72-1.6,5.56-1.83,8.45c-0.28,2.9-0.24,5.83,0.12,8.72c0.11,0.87,0.2,1.52,0.21,1.52c0.02,0.16-0.03,0.32-0.13,0.44c-0.12,0.14-0.4,0.46-0.57,1.73c-0.14,1.73-0.07,3.47,0.21,5.18c0.23,1.71,0.56,3.41,1,5.08l0.23,0.89c0.48,1.98,1.2,3.89,2.13,5.7c0.39,0.96,1.03,1.79,1.85,2.42c0.38,0.35,0.96,0.33,1.31-0.05c0.03-0.03,0.05-0.06,0.08-0.09c0.15-0.15,0.37-0.21,0.57-0.15c0.21,0.07,0.35,0.25,0.38,0.46c0,0,0.18,1.49,0.6,3.45c0.75,3.33,1.79,6.59,3.13,9.73c0.06,0.12,4,17.82,0.92,20.79c-1,1-4.24,1.69-10.38,3c-10.37,2.21-26,5.55-36,12.82c-1.47,1.06-2.84,2.25-4.08,3.57c-8,8.59-12.06,45.55-11.34,104.06c0,1.23,0,2.1,0,2.57c0,3.84-0.42,8.14-0.89,13.12c-0.61,6.35-1.31,13.54-1.31,21.68c0,0.24,0,0.86,0.07,1.77c1.06,24.11-0.39,38.26-4.32,42.05c-4.39,4.24-9.32,19-11.17,24.59c-0.31,0.92-0.54,1.61-0.67,2c-0.53,1.12-0.17,2.46,0.85,3.16c0.88,0.44,1.95,0.13,2.46-0.71c2.68-3.22,6.94-11.68,7-11.77c0.12-0.25,0.41-0.36,0.67-0.28c0.26,0.09,0.42,0.36,0.36,0.63c-0.57,3-3.28,24.12,1.59,29.9c0.68,0.9,1.75,1.41,2.87,1.37c4.38-0.09,13.41-2.79,15.81-7.85c1.64-3.45,1.67-12.26,1.17-17.13c-0.29-2.83-2.1-26.09-2.24-28.53c-0.16-2.64,2.58-16.78,5-28.81c0.26-1.29,0.44-2.22,0.52-2.61c0.79-4.2,1.75-8.59,2.68-12.83c1.65-7.5,3.2-14.58,3.2-18.09c0-3.15,0.15-8,0.28-12.34c0.11-3.25,0.19-6.05,0.19-7.41c0-1.18,0.27-7.06,0.6-14.51c0.57-12.75,1.35-30.22,1.35-36.15c-0.02-0.3,0.2-0.57,0.51-0.6c0.3-0.02,0.57,0.2,0.59,0.51c0.29,1.76,7.07,43.19,7.07,53c0,11-3,27-6,42.41c-2.43,12.79-4.71,24.88-4.71,31.7c0,57.22,9,92.71,14.32,113.91c2.2,8.69,3.82,14.98,3.82,19.19c0,5.14-0.39,9.39-0.79,13.88c-0.73,7.18-1.09,14.4-1.09,21.62c0,17.21,5.7,37.85,10.29,54.43c3.06,11.07,5.7,20.63,5.7,26c0,7.72-5,15-9,20.81c-2.84,4.11-5.29,7.66-5.29,10.23c0,8.69,18.39,14,26.48,14c1.03,0.01,2.01-0.43,2.7-1.2c2.4-2.58,2-9,1.6-14.25c-0.12-1.65-0.23-3.21-0.23-4.47c0-3.2,0.47-7.58,0.92-11.82s0.9-8.55,0.9-11.69c-0.12-3.52-0.45-7.02-1-10.5c-0.86-5.47-1.36-11-1.48-16.54c0-0.35,3.49-29,3.49-44.6c0.07-7.75-0.82-15.47-2.65-23c-0.7-2.61-1.12-5.3-1.23-8c0-1.1,5.17-107.61,5.17-140.6C95.8,292,96.02,291.73,96.33,291.71C96.33,291.71,96.33,291.71,96.33,291.71z"
    />
    <path
      class="bone"
      disabled
      d="M71.65,205c2.93-2.09,8-5.4,9.94-7.62c1.64-1.98,3.16-4.07,4.54-6.24c1.3-1.93,1.85-3.3,0.79-3.92s-2.7,1.07-3.74,2.1s-3.66,4.67-5.93,6.82c-2.06,2-7.07,5.12-10.46,8s-5.87,5.67-5.33,7.36C62.27,214,68.75,207.07,71.65,205z"
    />
    <path
      class="bone"
      disabled
      d="M121.25,205c-2.93-2.09-8-5.4-10-7.62c-1.64-1.98-3.15-4.07-4.53-6.24c-1.31-1.93-1.86-3.3-0.8-3.92s2.71,1.07,3.74,2.1s3.67,4.67,5.93,6.82c2.06,2,7.08,5.12,10.46,8c3.38,2.88,5.87,5.67,5.34,7.36C130.62,214,124.14,207.07,121.25,205z"
    />
    <path
      class="bone"
      disabled
      d="M82.56,111.91c1.73,1.94,6,0.39,6.64-2.07c0.4-1.65-0.17-2.51-1.9-3.21c-15-6-22.78-5.63-35.38-3.5c-4.05,0.69-5.87,1.41-6.1,2.08s0.78,0.88,1.32,2c0.41,0.82-0.25,1.76,0.2,2.3s4.12-0.89,7.65-1.36C63.84,106.91,78.33,107.15,82.56,111.91z"
    />
    <path
      class="bone"
      disabled
      d="M110.09,111.91c-1.72,1.94-6,0.39-6.64-2.07c-0.4-1.65,0.18-2.51,1.9-3.21c15-6,22.78-5.63,35.38-3.5c4.06,0.69,5.87,1.41,6.1,2.08s-0.77,0.88-1.31,2c-0.41,0.82,0.24,1.76-0.21,2.3s-4.12-0.89-7.65-1.36C128.81,106.91,114.33,107.15,110.09,111.91z"
    />
    <path
      class="bone"
      disabled
      d="M86.05,104.07c1.3-0.06,2.42-2.73,0-3.32c-3.44,0-6.88,0.28-10.27,0.86c3.24,0.63,6.44,1.46,9.58,2.49L86.05,104.07z"
    />
    <path
      class="bone"
      disabled
      d="M106.6,104.07h0.66c3.14-1.03,6.34-1.86,9.58-2.49c-3.39-0.58-6.82-0.86-10.26-0.86C104.18,101.34,105.33,104,106.6,104.07z"
    />
    <path
      class="bone"
      disabled
      d="M5.42,316.19c-0.23-0.25-0.27,0.18-0.34,0.4C5,317.06,4.96,317.53,4.97,318c-0.06,0.43-0.22,0.84-0.48,1.19c-0.29,0.32-0.46,0.74-0.47,1.18c0,0.4,0.32,0.73,0.68,0.48c0.28-0.25,0.5-0.55,0.65-0.89c0.22-0.39,0.38-0.83,0.62-1.21s0.57-0.44,0.9-0.67s0.63-0.51,0.39-0.63C6.55,317.2,5.91,316.77,5.42,316.19z"
    />
    <path
      class="bone"
      disabled
      d="M22.23,317.35c0.22-0.09,0.38-0.27,0.44-0.5c0.11-0.55,0.09-1.12-0.07-1.66c-0.66-2.67-0.51-5.47,0.43-8.06c0.23-0.63,0.31-1.12,0.52-1.76c0.15-0.4,0.15-0.84,0-1.24c-0.4-0.83-1.14-0.73-1.77-0.5c-0.3,0.14-0.57,0.34-0.78,0.6c-0.51,0.81-0.64,1.8-0.36,2.71c0.2,1.2,0.15,2.42-0.13,3.6c-0.15,1.13-0.38,2.25-0.67,3.35c-0.29,0.9-1,2.1-0.55,3.05l0,0C20.11,317.63,21.25,317.79,22.23,317.35z"
    />
    <path
      class="bone"
      disabled
      d="M15.66,300c-0.29-0.35-0.53-0.78-0.83-1.13c-0.52-0.61-0.93-1.05-1.44-0.25c-0.42,0.91-0.77,1.84-1.06,2.8c-0.42,0.95-0.96,1.85-1.61,2.66c-0.56,0.64-1.42,1-1.76,1.83c-0.08,0.18-0.14,0.36-0.17,0.55c-0.01,0.07-0.01,0.15,0,0.22c0.39,0.67,0.97,1.21,1.67,1.55c0.67,0.35,1.47,0.35,2.14,0c0.06-0.08,0.1-0.16,0.13-0.25c0.12-0.47,0.17-0.95,0.16-1.43c0.05-0.55,0.18-1.1,0.39-1.61c0.35-1.05,0.94-2,1.72-2.78c0.4-0.33,1.56-0.47,1.43-1.18C16.33,300.59,15.89,300.23,15.66,300z"
    />
    <path
      class="bone"
      disabled
      d="M9.56,308.81c-0.7-0.33-0.79-0.78-1.23-1.15c-0.44-0.37-0.51,0.48-0.55,0.7c-0.18,1.67-0.52,3.31-1,4.92c-0.25,0.51-1.43,1.45-1.33,1.87s2,1.77,2.5,1.63c0.29-0.08,0.18-0.64,0.18-0.92c-0.05-0.87,0.13-1.74,0.53-2.52c0.33-0.8,0.83-1.52,1.46-2.12c0.54-0.42,1.32-0.73,1.41-1.61C11.58,308.89,10.45,309.23,9.56,308.81z"
    />
    <path
      class="bone"
      disabled
      d="M19,301.53c-1.22-0.27-2.21-0.17-2.45,1c-0.03,0.48-0.02,0.97,0.05,1.45c0.08,1.32-0.08,2.64-0.45,3.91c-0.3,1.32-0.34,2.72-0.73,4s-1.4,2.28-1.92,3.55c-0.16,0.35-0.18,0.75-0.06,1.12c0.11,0.3,0.37,0.53,0.69,0.59c0.74,0.18,1.51,0.26,2.27,0.25c0.28-0.01,0.54-0.13,0.72-0.34c0.21-0.27,0.35-0.59,0.38-0.93c0.04-0.69,0.02-1.38-0.07-2.06c-0.06-0.84-0.06-1.68,0-2.52c0.12-1.75,0.61-3.46,1.45-5c0.29-0.65,0.63-1.28,1-1.88c0.37-0.43,0.63-0.94,0.78-1.49C20.88,302.05,19.97,301.74,19,301.53z"
    />
    <path
      class="bone"
      disabled
      d="M28.12,316c0.31-0.26,0.43-0.68,0.31-1.07c-0.2-0.47-0.43-0.92-0.69-1.36c-0.34-1.01-0.5-2.07-0.46-3.13c-0.06-0.8-0.28-2.67-0.29-3.45c0-1,0.55-2.34,0.21-3.34s-2-1-2.72-0.5c-0.93,0.66-0.13,1.67,0.19,2.5c0.13,0.52,0.22,1.04,0.29,1.57c0.41,1.98,0.44,4.01,0.1,6c-0.09,0.51-0.1,1.03-0.05,1.54c0.06,0.52,0.39,0.98,0.86,1.22c0.46,0.26,0.99,0.37,1.51,0.32C27.65,316.27,27.9,316.16,28.12,316z"
    />
    <path
      class="bone"
      disabled
      d="M33.26,321.56c-0.72,0.37-1.54,0.47-2.32,0.3c-0.2-0.07-0.32-0.28-0.28-0.49c0.1-0.45,0.41-0.94,0.45-1.36c0.02-0.69-0.14-1.38-0.45-2c-0.34-0.6-0.65-1.22-0.93-1.85c-0.12-0.39-0.14-0.78,0.1-0.75c0.46,0.19,0.94,0.33,1.43,0.4l0,0c0.42-0.1,0.83-0.24,1.22-0.43c0.17,0,0.11,0.6,0.07,0.84c-0.09,0.39-0.12,0.78-0.1,1.18c0.03,0.51,0.08,1.02,0.17,1.53c0.06,0.3,0.17,0.59,0.32,0.86C33.27,320.37,33.75,321.4,33.26,321.56z"
    />
    <path
      class="bone"
      disabled
      d="M33.33,326.61c0.42-0.18,0-0.81-0.14-1.09c-0.27-0.32-0.44-0.72-0.47-1.14c0-0.44,0.29-0.83,0.21-1.28s-0.55-0.52-0.92-0.38c-0.37,0.14-1.13-0.17-1.34,0s0.2,0.85,0.34,1.13c0.18,0.39,0.28,0.82,0.28,1.26c-0.04,0.41-0.04,0.83,0,1.24c0.01,0.07,0.04,0.14,0.09,0.19C31.98,326.88,32.71,326.91,33.33,326.61z"
    />
    <path
      class="bone"
      disabled
      d="M28.33,326.16c0.18-0.09,0.29-0.27,0.28-0.47c-0.11-0.57-0.29-1.13-0.54-1.65c-0.28-1.03-0.42-2.09-0.39-3.16c0.17-0.9,0.38-1.79,0.64-2.67c0.16-0.9-0.42-1-1.19-1h-0.8c-0.62,0-1.53-0.25-1.74,0.58s0.36,2,0.72,2.76c0.47,0.82,0.65,1.78,0.51,2.71c-0.31,0.84-0.51,1.72-0.62,2.61c0.01,0.19,0.15,0.35,0.33,0.39C26.45,326.52,27.43,326.49,28.33,326.16z"
    />
    <path
      class="bone"
      disabled
      d="M27.94,327.49c-0.17,0-0.6,0.19-0.92,0.2h-0.09c-0.44-0.02-0.87-0.1-1.29-0.22c-0.09-0.01-0.17,0.02-0.24,0.07c-0.69,0.42-0.15,1.09,0.2,1.76c0.36,0.77,0.47,1.64,0.3,2.47c-0.2,0.73-0.26,1.48-0.17,2.23c0.19,0.61,1.07,0.5,1.55,0.56s1.12,0.33,1.2-0.32s-0.55-1.43-0.56-2.11s-0.18-1.29-0.21-2s0.51-1.18,0.52-1.81C28.24,327.92,28.12,327.54,27.94,327.49z"
    />
    <path
      class="bone"
      disabled
      d="M15.94,327.28c0.21-0.24,0.34-0.53,0.39-0.84c0.18-0.9-0.42-1.79-0.53-2.7c-0.13-0.84,0-1.7,0.37-2.46c0.34-0.72,1.23-1.5,0.87-2.25c-0.21-0.59-0.84-0.91-1.44-0.73c-1.43,0.2-2.32-0.51-2.39,0.5c0.02,0.94,0.18,1.87,0.46,2.77c0.23,0.86,0.3,1.76,0.21,2.65c-0.07,0.5-0.19,0.99-0.36,1.46c-0.12,0.38-0.42,0.8-0.32,1.19c0.04,0.12,0.09,0.23,0.17,0.33C14.16,327.65,15.12,327.68,15.94,327.28z"
    />
    <path
      class="bone"
      disabled
      d="M15.6,335.2c-0.39,0.2-0.82,0.32-1.26,0.34c-0.18,0.01-0.36-0.01-0.54-0.06c-0.13,0-0.28-0.13-0.33-0.14s-0.1,0-0.12,0.07c-0.39,0.6,0.61,1.2,0.55,1.93s-0.08,1.87,0.84,1.82c0.38-0.06,0.69-0.32,0.82-0.68c0.11-0.42,0.01-0.88-0.27-1.21c-0.19-0.32-0.35-0.54-0.12-0.88c0.28-0.27,0.49-0.59,0.63-0.95C15.85,335.09,15.6,335.2,15.6,335.2z"
    />
    <path
      class="bone"
      disabled
      d="M14,334.76c0.61,0.05,1.22-0.13,1.7-0.51c0.05-0.39-0.02-0.79-0.21-1.14c-0.26-0.59-0.33-1.25-0.22-1.89c0.12-0.77,1.52-2.79,0.51-3c-0.65,0.05-1.29,0.15-1.92,0.29c-0.6,0-0.8,0.35-0.75,1s0.47,0.91,0.57,1.6c0.08,0.64,0.02,1.29-0.17,1.91l-0.07,0.22c-0.04,0.36-0.04,0.72,0,1.08l0,0C13.56,334.54,13.76,334.69,14,334.76z"
    />
    <path
      class="bone"
      disabled
      d="M20.11,335.73c0.67,0,1.34-0.03,2-0.11c0.1-0.05,0.18-0.13,0.24-0.23c0.25-0.52-0.1-1.52-0.17-2.06c-0.13-0.7-0.23-1.4-0.28-2.11c0-0.7,0.43-1.11,0.58-1.74s-0.06-0.92-0.7-0.83c-0.35,0.11-0.71,0.2-1.07,0.27c-0.39,0-0.7-0.23-1-0.15c-0.81,0.19-0.57,1-0.23,1.55c0.44,0.73,0.93,1.19,0.89,2.12c-0.02,0.77-0.2,1.52-0.54,2.21C19.83,334.65,19.24,335.64,20.11,335.73z"
    />
    <path
      class="bone"
      disabled
      d="M41.33,217.7c0.66-3.54-3.71-6.66-4.06-11.65s2.2-67.68,4.37-71.72c0.67-1.37,1.65-2.57,2.86-3.49c3.08-2.44,4.39-6.5,3.32-10.29c-1.16-4.36-4.21-6-7.59-6c-1.7-0.02-3.24,0.99-3.9,2.55c-1.17-0.33-3.46-0.2-3.8,2c-0.46,4.66-0.4,9.35,0.16,14c0.68,4.75-1.27,42.89-1.68,53.24c-0.36,9.16-1.48,17.08-4.08,20.65s-5.76,4.75-5.56,8.11c0.18,3.15,3.54,6.27,6.31,5.21c1.67-0.63,2-1.2,2.57-1.33c0.29-0.06,0.56-0.58,1.27,0.13c0.69,0.7,1.53,1.23,2.46,1.56C36.33,221.47,40.51,222.18,41.33,217.7z"
    />
    <path
      class="bone"
      disabled
      d="M22.17,337.68c0.16-0.37,0.55-0.81,0.18-1.19s-0.73,0-1.11,0h-0.28c-0.33,0-1,0-1.1,0.47s0.38,0.73,0.55,1c0.25,0.41,0.4,0.87,0.43,1.35c-0.06,0.47,0,0.96,0.18,1.4c0.23,0.35,0.53,0.69,0.95,0.58c0.43-0.14,0.71-0.55,0.69-1C22.63,339.42,21.79,338.57,22.17,337.68z"
    />
    <path
      class="bone"
      disabled
      d="M28.15,336.58c0.16-0.34,0.21-0.31,0.16-0.75s-0.62-0.44-1-0.23l-0.35-0.05c-0.3,0-0.85-0.06-1,0.34s0.34,0.67,0.49,0.94c0.23,0.37,0.36,0.79,0.38,1.23c-0.07,0.43-0.02,0.87,0.15,1.27c0.2,0.31,0.47,0.63,0.87,0.54c0.4-0.13,0.67-0.51,0.65-0.93C28.56,338.16,27.79,337.37,28.15,336.58z"
    />
    <path
      class="bone"
      disabled
      d="M33.63,327.39c-0.34-0.13-0.75,0.32-1,0.25l-0.42-0.2c-0.32-0.06-0.77-0.25-0.91,0.08s0.27,0.6,0.39,0.85c0.18,0.34,0.27,0.71,0.26,1.09c0,0.37-0.16,0.77,0,1.09c0.16,0.32,0.4,0.58,0.77,0.54c0.37-0.06,0.65-0.37,0.68-0.75c0-0.67-0.6-1.41-0.2-2.06C33.41,328,34.02,327.54,33.63,327.39z"
    />
    <path
      class="bone"
      disabled
      d="M22.71,319.85c0.1-0.8-0.35-1.15-1.14-1.39c-0.61-0.22-1.29-0.15-1.83,0.21c-0.73,0.45-0.35,1.21-0.16,1.85c0.26,0.84,0.38,1.72,0.34,2.6c-0.07,0.89-0.14,1.77-0.15,2.67c-0.03,0.24-0.09,0.47-0.16,0.7c0,0.68-0.12,1.4,0.7,1.53c0.79,0.11,1.59-0.17,2.13-0.75c0.42-0.64-0.11-1.32-0.25-2c-0.17-0.89-0.2-1.81-0.08-2.71C22.22,321.64,22.6,320.78,22.71,319.85z"
    />
    <path
      class="bone"
      disabled
      d="M32.39,314.47c0.67-0.86,0.09-2-0.33-2.81c-0.48-0.91-0.8-1.91-0.93-2.93c-0.2-1.15-0.31-2.31-0.32-3.47c0.03-0.52,0.08-1.04,0.17-1.56c0.1-0.39,0.08-0.81-0.06-1.19c-0.44-0.85-1.86-0.61-2.52-0.28c-1.06,0.54-0.44,1.39,0,2.23c0.97,2.2,1.36,4.61,1.12,7c-0.17,1-0.39,2.17,0.31,3c0.61,0.71,1.67,0.79,2.38,0.19C32.28,314.59,32.34,314.53,32.39,314.47z"
    />
    <path
      class="bone"
      disabled
      d="M32.19,223.46c1.08,0.71,2.43,0.85,3.63,0.39c1.1-0.42,1.9-0.8,1.95,0.55c0.09,2.3-1.49,2.17-2,8.84s-1.57,20.13-1.34,25.18s-1.49,15.91-2.16,20.63c-0.67,4.72-1.33,5.71-1.27,7.86c0,0.94,0.15,3.34-0.35,4.48c-0.16,0.35-0.55,0.52-0.92,0.41c-0.28-0.08-0.64-0.18-1.07-0.28c-1.29-0.69-2.45-2-1.64-5.48c1.13-5.65,1.95-11.36,2.46-17.1c0.34-4-0.33-16.9-0.67-21.13l-0.68-13.42c-0.61,3.55-1.87,10.43-3.18,17.43s0,32.36,1,37.27c0.12,0.46,0.18,0.93,0.18,1.4c-0.02,0.3-0.28,0.53-0.58,0.51c-0.01,0-0.02,0-0.04,0c-0.84-0.1-1.68-0.1-2.52,0c-1.43,0.24-2.83,0.65-4.17,1.23c-0.54,0.22-1.15-0.04-1.37-0.58c-0.03-0.07-0.05-0.15-0.06-0.23c0-1.29,0.12-2.58,0.36-3.85c0.26-2.8,1.71-8.55,1.91-15.28s0.19-19.76,2.69-30.74c2-8.64,2.46-13.78,1-15.89s-1.08-3.21,1.28-2.78c0.91,0.4,1.94,0.4,2.85,0c0.8-0.39,1.67-0.63,2.56-0.7C30.67,222.28,31.33,222.92,32.19,223.46z"
    />
    <path
      class="bone"
      disabled
      d="M30.72,295.42c-0.09-0.49-0.38-0.93-0.8-1.2c-1.94-0.62-3.97-0.92-6-0.87c-1.23,0.17-2.43,0.48-3.58,0.93l-1,0.57c-0.72,0.58-1.53,1.06-2.39,1.41c-0.57,0.23-1.02,0.68-1.25,1.25c0,0.14,0.02,0.29,0.05,0.43c0,0,0,0,0,0.06c0.36,0.8,0.84,1.53,1.44,2.16c0.42,0.09,0.85,0.14,1.28,0.14c0.92-0.06,1.83,0.14,2.64,0.58c0.13,0.1,0.25,0.21,0.36,0.33c0.52,0.61,1.31,0.91,2.1,0.8c0.74-0.07,1.46-0.27,2.12-0.6c0.72-0.34,1.48-0.57,2.27-0.68c1-0.12,1.39,0.06,2.38-0.06s0.53-4.51,0.53-4.51C30.81,295.9,30.76,295.66,30.72,295.42z"
    />
    <path
      class="bone"
      d="M87.23,571c-1.09-0.39-2.69-0.45-3.42,0.39c-0.14,0.25-0.21,0.53-0.2,0.82c0,0.58,0.73,0.83,0.86,1.36c0.18,0.77-0.67,1.18-0.79,1.86c-0.24,1.38,1.77,1.62,2.53,1.14c0.56-0.37,0.47-1,0.73-1.54s0.65-0.63,1-1.11c0.63-0.9,0.41-2.15-0.49-2.79C87.38,571.08,87.31,571.04,87.23,571z"
    />
    <path
      class="bone"
      d="M79.26,548.15c-0.71,0.4-0.43,1.17-0.51,1.9c-0.23,1.72-0.59,3.42-1.09,5.09c-0.09,0.29-0.2,0.58-0.33,0.86c-0.34,0.62-0.12,1.4,0.5,1.74c0.21,0.12,0.44,0.17,0.68,0.16c0.39,0,0.77-0.11,1.09-0.32c0.6-0.33,0.66-0.7,0.57-1.37c-0.42-3.2,1.4-6.72,1-7.39c-0.28-0.69-1.07-1.02-1.76-0.74C79.36,548.1,79.31,548.12,79.26,548.15z"
    />
    <path
      class="bone"
      d="M71.04,564.15c-0.06-0.07-0.27-0.19-0.31-0.1c-0.42,0.81,0.09,1.55-0.41,2.41c-0.28,0.64-0.6,1.26-0.95,1.86c-0.22,0.29-0.46,0.35-0.53,0.77s0.08,0.8,0,1.19s-0.3,0.68-0.07,1s0.52,0.26,0.73,0c0.5-0.63,0.09-1.36,1.06-1.63c0.08-0.4,0-0.79,0-1.18c0.14-0.32,0.3-0.62,0.49-0.91c0.28-0.55,0.39-1.23,1-1.45c0.41-0.15,0.67,0,0.95-0.4s0.1-0.57-0.21-0.88c-0.22-0.15-0.49-0.23-0.76-0.24c-0.5,0-0.77,0.06-0.88-0.19S71.17,564.31,71.04,564.15z"
    />
    <path
      class="bone"
      d="M68.8,563.15c-0.37-0.57-0.64,0-1.25-0.27c0,0,0-0.17-0.06-0.22s-0.31-0.3-0.39-0.27c-0.85,0.26,0.18,1.37-0.31,2.16c-0.3,0.57-0.63,1.11-1,1.64c-0.21,0.26-0.43,0.3-0.51,0.67s0,0.73,0,1.09s-0.3,0.6-0.1,0.93s0.46,0.26,0.66,0c0.48-0.56,0.14-1.24,1-1.43c0.1-0.37,0-0.73,0.1-1.08c0.14-0.28,0.3-0.55,0.49-0.8c0.27-0.49,0.41-1.11,1-1.28c0.37-0.12,0.38,0.14,0.54-0.31C69.07,563.69,69.01,563.37,68.8,563.15z"
    />
    <path
      class="bone"
      d="M65.42,562.8c-0.37,0.1-0.47,0.51-0.67,0.84c-0.13,0.16-0.25,0.34-0.35,0.52c-0.08,0.24,0,0.48-0.09,0.72c-0.6,0.11-0.39,0.58-0.73,1c-0.14,0.15-0.31,0.19-0.44,0s0-0.43,0.09-0.63s0-0.5,0-0.73s0.21-0.27,0.36-0.44c0.25-0.35,0.47-0.71,0.68-1.08c0.35-0.52-0.35-1.23,0.22-1.39c0.09,0,0.18,0.05,0.24,0.12c0.04,0.09,0.09,0.17,0.15,0.25c0.32,0.25,0.67-0.06,1,0.28C65.96,562.18,66.22,562.6,65.42,562.8z"
    />
    <path
      class="bone"
      d="M74.7,571.63c0.2-0.86,0.25-1.75,0.14-2.63c0.02-0.32,0.19-0.62,0.46-0.79c0.37-0.27,0.81-0.42,1.27-0.44c0.3,0.07,0.58,0.21,0.82,0.4c0.3,0.24,0.44,0.63,0.36,1c-0.08,0.29-0.18,0.57-0.3,0.84c-0.46,1.16-0.58,2.42-1,3.61c-0.2,0.55-1.75,1.14-2.17,0.14C73.91,572.91,74.33,572.34,74.7,571.63z"
    />
    <path
      class="bone"
      d="M85.33,536.23c1.59,0.13,3.33,1.07,3.53,2.69c0.28,1.46,1.08,2.77,2.26,3.68c0.79,0.7,1.23,1.71,1.21,2.77c0.06,1.81,0.09,5.29-1.69,5.23c-1.1-0.15-2.1-0.75-2.74-1.66c-0.93-1.05-2.66-1.35-4.89-1.19c-1.64,0.11-3.14-1.35-5.06-1.19s-2.39,1-3.72,1.41s-1.86-1.05-0.86-2c0.93-0.71,1.92-1.33,2.96-1.88c2.81-1.58,2-4.63,2.4-5.76C79.26,536.74,83.43,536.08,85.33,536.23z"
    />
    <path
      class="bone"
      d="M88.61,563.65c0.74,1.13,1.55,2.89,0.15,2.81c-0.59-0.86-1.34-1.6-2.21-2.17c-1-0.43-2,0.51-3,1.63c-0.29,0.1-0.35-0.08-0.46-0.36c-0.43-1.12,0.36-2.78,0.45-3.91c0.12-1.51-0.54-2.54-1-3.92c-0.46-1.54,0.09-2.1,0.09-2.1s1.88-2,3.66-1.63c0.44,0.1,0.84,0.34,1.14,0.68c0.59,0.59,0.94,1.37,1,2.2c0.05,1.01-0.03,2.01-0.23,3C87.96,561.37,87.79,562.4,88.61,563.65z"
    />
    <path
      class="bone"
      d="M82.38,554.35c0.05,0.07,0.15,0.09,0.22,0.04c0.01-0.01,0.03-0.02,0.04-0.04c0.68-0.83,1.63-1.38,2.69-1.55c1.28-0.15,3.24,1.3,3.53,1.67s0.43-0.44,0.37-0.9c-0.21-1.5-1.22-3.51-2.35-4.09c-1.17-0.54-2.51-0.6-3.72-0.15c-0.59,0.25-1.07,0.71-1.33,1.3c-0.3,0.62-0.37,1.33-0.19,2C81.79,553.24,82.04,553.82,82.38,554.35z"
    />
    <path
      class="bone"
      d="M74.33,556.18c-0.32-0.23,2-7.83,2-7.83c0.13-0.17,0.32-0.28,0.53-0.32c1.48-0.39,1.21,0.1,1.21,0.1c-1.29,2.44-1.53,7.33-1.87,7.89C76.25,556,75.72,557.13,74.33,556.18z"
    />
    <path
      class="bone"
      d="M71.25,552.31c0.29-0.81,0.64-1.57,0.94-2.38l0.13-0.13c0.11,0,0.74-0.32,0.61,0.07s-0.88,2.5-0.88,2.5c-0.37,0.88-0.66,1.68-0.76,1.79s-0.59,0.28-0.7,0C70.33,553.53,71.06,552.84,71.25,552.31z"
    />
    <path
      class="bone"
      d="M74.97,549.58c-0.15,0.36-1.79,5.79-1.86,6s-0.54,0-0.74-0.24c-0.6-0.66,0.21-1.43,0.33-2.15v-0.16c0,0,1-3.17,1-3.37S75.11,549.21,74.97,549.58z"
    />
    <path
      class="bone"
      d="M76.8,564.52c-0.31,0.04-0.62,0.11-0.91,0.21c-0.1,0.04-0.21-0.01-0.24-0.11c0-0.01,0-0.01-0.01-0.02c-0.28-1.08,0.87-2,1-3.25s-0.45-2.77,1.33-2.38c0.41-0.01,0.82,0.01,1.23,0.06c0.36,0.13,0.58,0.26,0.55,0.65l-0.42,5.24c0,0-0.06,0.38-0.78,0.07l-0.54-0.25C77.64,564.55,77.22,564.48,76.8,564.52z"
    />
    <path
      class="bone"
      d="M71.74,562.6c0.09-0.41,0.25-0.8,0.46-1.17c0.1-0.4,0.29-0.77,0.57-1.08c0.27-0.39,0.51-0.81,0.71-1.24c0.2-0.42,0.09-1.19,0.51-1.36c0.49-0.09,1-0.01,1.45,0.22c0.13,0.33-0.24,0.85-0.45,1.32c-0.42,1-1,1.91-1.41,2.89s-0.39,1.43-0.78,1.44l-0.82-0.46C71.85,563,71.76,562.81,71.74,562.6z"
    />
    <path
      class="bone"
      d="M75.08,566.21c0,0-0.41,0.35-0.35,0.61s0.45,0.31,0.45,0.31c0.45-0.27,0.98-0.39,1.5-0.36c0.57,0.16,1.1,0.43,1.55,0.81c0.34,0.23,0.52-0.27,0.51-0.81c-0.01-0.43-0.26-0.82-0.65-1c-0.21-0.1-0.44-0.17-0.67-0.21c-0.83,0-1.64,0.24-2.34,0.69"
    />
    <path
      class="bone"
      d="M72.38,557.33c-0.32,0.93-1,1.36-1.55,2.12c-0.28,0.39-0.51,0.81-0.67,1.26c-0.15,0.43-0.43,1.28-0.68,1.34s-1.49-0.13-1.5-0.38s3.18-5,3.45-5.31S72.62,556.61,72.38,557.33z"
    />
    <path
      class="bone"
      d="M66.69,561.21c-0.2,0-1.48-0.21-1.55-0.53s1.49-2.06,2.5-2.86s1.12-2,2.13-2.48c0.42-0.2,1.12,0.07,0.83,0.54s-3.51,5-3.51,5C66.97,561,66.83,561.11,66.69,561.21z"
    />
    <path
      class="bone"
      d="M87.14,569.82c0,0,0.22,0,0.26,0s1.59-0.49,1.28-1.63s-2.06-2.77-2.57-2.64c0,0-0.66-0.15-1.83,1.3c-0.35,0.42-0.58,0.93-0.66,1.47c-0.05,0.41,0.17,0.81,0.54,1c0.39-0.06,0.78-0.09,1.17-0.1c0.54,0.11,1.05,0.33,1.5,0.66C86.94,569.9,87.05,569.88,87.14,569.82z"
    />
    <path
      class="bone"
      disabled
      d="M187.26,316.19c0.23-0.25,0.27,0.18,0.34,0.4c0.07,0.46,0.11,0.92,0.1,1.39c0.06,0.43,0.23,0.84,0.49,1.19c0.29,0.32,0.46,0.74,0.46,1.18c0,0.4-0.31,0.73-0.67,0.48c-0.28-0.25-0.5-0.55-0.65-0.89c-0.22-0.39-0.39-0.83-0.62-1.21s-0.57-0.44-0.91-0.67s-0.62-0.51-0.38-0.63C186.13,317.18,186.77,316.76,187.26,316.19z"
    />
    <path
      class="bone"
      disabled
      d="M170.44,317.35c-0.22-0.09-0.38-0.27-0.44-0.5c-0.1-0.55-0.08-1.12,0.08-1.66c0.65-2.67,0.5-5.47-0.43-8.06c-0.24-0.63-0.32-1.12-0.53-1.76c-0.16-0.4-0.16-0.84,0-1.24c0.4-0.83,1.14-0.73,1.76-0.5c0.31,0.14,0.58,0.34,0.79,0.6c0.51,0.81,0.64,1.8,0.35,2.71c-0.19,1.2-0.14,2.42,0.14,3.6c0.15,1.13,0.38,2.25,0.67,3.35c0.29,0.9,1,2.1,0.55,3.05l0,0C172.56,317.63,171.42,317.79,170.44,317.35z"
    />
    <path
      class="bone"
      disabled
      d="M177.02,300c0.29-0.35,0.53-0.78,0.83-1.13c0.52-0.61,0.93-1.05,1.44-0.25c0.42,0.93,0.79,1.88,1.09,2.85c0.41,0.96,0.95,1.85,1.61,2.66c0.55,0.64,1.42,1,1.76,1.83c0.08,0.18,0.14,0.36,0.17,0.55c0.01,0.07,0.01,0.15,0,0.22c-0.39,0.67-0.97,1.21-1.67,1.55c-0.67,0.35-1.46,0.35-2.13,0c-0.06-0.08-0.1-0.16-0.14-0.25c-0.11-0.47-0.16-0.95-0.15-1.43c-0.05-0.55-0.18-1.1-0.39-1.61c-0.35-1.05-0.94-2-1.72-2.78c-0.4-0.33-1.56-0.47-1.44-1.18C176.33,300.59,176.79,300.23,177.02,300z"
    />
    <path
      class="bone"
      disabled
      d="M183.12,308.81c0.7-0.33,0.79-0.78,1.22-1.15s0.51,0.48,0.55,0.7c0.18,1.67,0.52,3.31,1,4.92c0.25,0.51,1.43,1.45,1.33,1.87s-2,1.77-2.5,1.63c-0.29-0.08-0.19-0.64-0.19-0.92c0.06-0.87-0.13-1.74-0.53-2.52c-0.33-0.8-0.82-1.52-1.45-2.12c-0.54-0.42-1.32-0.73-1.41-1.61C181.09,308.89,182.23,309.23,183.12,308.81z"
    />
    <path
      class="bone"
      disabled
      d="M173.67,301.53c1.23-0.27,2.21-0.17,2.46,1c0.03,0.48,0.02,0.97-0.05,1.45c-0.08,1.32,0.08,2.64,0.45,3.91c0.29,1.32,0.33,2.72,0.73,4s1.4,2.28,1.91,3.55c0.16,0.35,0.19,0.75,0.07,1.12c-0.11,0.31-0.38,0.53-0.7,0.59c-0.74,0.18-1.5,0.26-2.26,0.25c-0.28-0.01-0.55-0.13-0.73-0.34c-0.21-0.27-0.34-0.59-0.37-0.93c-0.04-0.69-0.02-1.38,0.06-2.06c0.07-0.84,0.07-1.68,0-2.52c-0.12-1.75-0.61-3.45-1.44-5c-0.3-0.64-0.63-1.27-1-1.88c-0.37-0.43-0.64-0.94-0.79-1.49C171.8,302.05,172.7,301.74,173.67,301.53z"
    />
    <path
      class="bone"
      disabled
      d="M164.56,316c-0.31-0.26-0.43-0.68-0.31-1.07c0.2-0.47,0.42-0.92,0.68-1.36c0.35-1.01,0.5-2.07,0.46-3.13c0.07-0.8,0.29-2.67,0.29-3.45c0-1-0.55-2.34-0.2-3.34s2-1,2.71-0.5c0.93,0.66,0.14,1.67-0.19,2.5c-0.12,0.52-0.22,1.04-0.28,1.57c-0.42,1.98-0.45,4.01-0.1,6c0.08,0.51,0.09,1.03,0.05,1.54c-0.07,0.52-0.39,0.98-0.86,1.22c-0.46,0.26-0.99,0.37-1.51,0.32C165.03,316.27,164.78,316.16,164.56,316z"
    />
    <path
      class="bone"
      disabled
      d="M159.42,321.56c0.72,0.37,1.54,0.47,2.32,0.3c0.2-0.07,0.32-0.28,0.28-0.49c-0.1-0.45-0.41-0.94-0.46-1.36c-0.01-0.69,0.14-1.38,0.45-2c0.35-0.6,0.66-1.21,0.94-1.85c0.11-0.39,0.14-0.78-0.1-0.75c-0.46,0.2-0.94,0.33-1.44,0.4l0,0c-0.42-0.09-0.83-0.24-1.22-0.43c-0.17,0-0.11,0.6-0.07,0.84c0.08,0.39,0.11,0.78,0.1,1.18c-0.03,0.51-0.09,1.02-0.18,1.53c-0.06,0.3-0.16,0.59-0.31,0.86C159.4,320.37,158.93,321.4,159.42,321.56z"
    />
    <path
      class="bone"
      disabled
      d="M159.33,326.61c-0.42-0.18-0.05-0.81,0.15-1.09c0.27-0.32,0.44-0.72,0.47-1.14c0-0.44-0.29-0.83-0.21-1.28s0.54-0.52,0.92-0.38s1.12-0.17,1.34,0s-0.2,0.85-0.35,1.13c-0.18,0.4-0.27,0.83-0.27,1.26c0.04,0.41,0.04,0.83,0,1.24c-0.02,0.07-0.05,0.13-0.09,0.19C160.69,326.88,159.96,326.91,159.33,326.61z"
    />
    <path
      class="bone"
      disabled
      d="M164.33,326.16c-0.18-0.09-0.29-0.27-0.28-0.47c0.1-0.57,0.28-1.13,0.53-1.65c0.28-1.03,0.42-2.09,0.39-3.16c-0.16-0.9-0.37-1.79-0.63-2.67c-0.16-0.9,0.42-1,1.19-1h0.8c0.62,0,1.52-0.25,1.74,0.58s-0.36,2-0.72,2.76c-0.47,0.82-0.65,1.77-0.51,2.71c0.31,0.84,0.51,1.72,0.62,2.61c-0.01,0.19-0.15,0.35-0.33,0.39C166.21,326.52,165.23,326.49,164.33,326.16z"
    />
    <path
      class="bone"
      disabled
      d="M164.73,327.49c0.18,0,0.61,0.19,0.93,0.2h0.08c0.44-0.02,0.87-0.1,1.29-0.22c0.09-0.01,0.18,0.02,0.25,0.07c0.69,0.42,0.15,1.09-0.21,1.76c-0.35,0.77-0.45,1.64-0.29,2.47c0.19,0.73,0.25,1.48,0.17,2.23c-0.19,0.61-1.08,0.5-1.55,0.56s-1.12,0.33-1.2-0.32s0.55-1.43,0.56-2.11s0.18-1.29,0.2-2s-0.5-1.18-0.51-1.81C164.44,327.92,164.56,327.54,164.73,327.49z"
    />
    <path
      class="bone"
      disabled
      d="M176.74,327.28c-0.21-0.24-0.34-0.53-0.39-0.84c-0.18-0.9,0.41-1.79,0.53-2.7c0.12-0.84-0.01-1.69-0.37-2.46c-0.34-0.72-1.24-1.5-0.87-2.25c0.21-0.58,0.84-0.9,1.43-0.73c1.43,0.2,2.33-0.51,2.4,0.5c-0.02,0.94-0.18,1.87-0.46,2.77c-0.23,0.86-0.3,1.76-0.21,2.65c0.06,0.5,0.18,0.99,0.35,1.46c0.13,0.38,0.43,0.8,0.32,1.19c-0.03,0.12-0.08,0.23-0.16,0.33C178.52,327.65,177.56,327.68,176.74,327.28z"
    />
    <path
      class="bone"
      disabled
      d="M177.08,335.2c0.39,0.2,0.82,0.32,1.26,0.34c0.18,0.01,0.36-0.01,0.54-0.06c0.13,0,0.27-0.13,0.33-0.14s0.09,0,0.12,0.07c0.39,0.6-0.61,1.2-0.56,1.93s0.09,1.87-0.83,1.82c-0.38-0.06-0.69-0.32-0.82-0.68c-0.11-0.42-0.02-0.87,0.26-1.21c0.19-0.32,0.36-0.54,0.13-0.88c-0.28-0.27-0.49-0.59-0.63-0.95C176.82,335.09,177.08,335.2,177.08,335.2z"
    />
    <path
      class="bone"
      disabled
      d="M178.68,334.76c-0.61,0.06-1.22-0.13-1.7-0.51c-0.05-0.39,0.02-0.79,0.21-1.14c0.25-0.6,0.33-1.25,0.22-1.89c-0.12-0.77-1.53-2.79-0.51-3c0.65,0.06,1.29,0.15,1.92,0.29c0.6,0,0.79,0.35,0.75,1s-0.48,0.91-0.58,1.6c-0.07,0.64-0.01,1.29,0.18,1.91l0.07,0.22c0.04,0.36,0.04,0.72,0,1.08l0,0C179.13,334.54,178.92,334.7,178.68,334.76z"
    />
    <path
      class="bone"
      disabled
      d="M172.57,335.73c-0.67,0-1.34-0.03-2-0.11c-0.1-0.05-0.18-0.13-0.24-0.23c-0.26-0.52,0.1-1.52,0.17-2.06c0.13-0.7,0.23-1.4,0.28-2.11c0-0.7-0.44-1.11-0.58-1.74s0.06-0.92,0.7-0.83c0.35,0.11,0.7,0.2,1.06,0.27c0.4,0,0.71-0.23,1-0.15c0.81,0.19,0.57,1,0.22,1.55c-0.44,0.73-0.92,1.19-0.88,2.12c0.01,0.77,0.2,1.52,0.54,2.21C172.84,334.65,173.44,335.64,172.57,335.73z"
    />
    <path
      class="bone"
      disabled
      d="M170.51,337.68c-0.16-0.37-0.55-0.81-0.19-1.19s0.73,0,1.12,0h0.28c0.33,0,1,0,1.1,0.47s-0.39,0.73-0.55,1c-0.25,0.41-0.4,0.87-0.44,1.35c0.06,0.47,0.01,0.96-0.17,1.4c-0.23,0.35-0.53,0.69-1,0.58c-0.43-0.14-0.7-0.55-0.68-1C170.05,339.42,170.89,338.57,170.51,337.68z"
    />
    <path
      class="bone"
      disabled
      d="M164.52,336.58c-0.15-0.34-0.21-0.31-0.16-0.75s0.62-0.44,1-0.23l0.35-0.05c0.3,0,0.84-0.06,1,0.34s-0.34,0.67-0.49,0.94c-0.23,0.37-0.36,0.79-0.39,1.23c0.07,0.43,0.02,0.87-0.14,1.27c-0.2,0.31-0.48,0.63-0.88,0.54c-0.4-0.13-0.66-0.51-0.64-0.93C164.12,338.16,164.89,337.37,164.52,336.58z"
    />
    <path
      class="bone"
      disabled
      d="M159.04,327.39c0.35-0.13,0.76,0.32,1,0.25l0.42-0.2c0.32-0.06,0.77-0.25,0.91,0.08s-0.27,0.6-0.39,0.85c-0.18,0.33-0.27,0.71-0.26,1.09c0,0.37,0.15,0.77,0,1.09s-0.4,0.58-0.78,0.54c-0.37-0.06-0.65-0.37-0.67-0.75c0-0.67,0.6-1.41,0.2-2.06C159.27,328,158.65,327.54,159.04,327.39z"
    />
    <path
      class="bone"
      disabled
      d="M169.96,319.85c-0.09-0.8,0.36-1.15,1.15-1.39c0.61-0.22,1.29-0.14,1.83,0.21c0.72,0.45,0.34,1.21,0.16,1.85c-0.27,0.84-0.39,1.72-0.34,2.6c0.07,0.89,0.13,1.77,0.15,2.67c0.03,0.24,0.08,0.47,0.15,0.7c0,0.68,0.13,1.4-0.7,1.53c-0.79,0.11-1.58-0.17-2.12-0.75c-0.42-0.64,0.1-1.32,0.25-2c0.17-0.89,0.2-1.81,0.07-2.71C170.45,321.64,170.07,320.78,169.96,319.85z"
    />
    <path
      class="bone"
      disabled
      d="M160.33,314.47c-0.66-0.86-0.08-2,0.34-2.81c0.48-0.91,0.8-1.91,0.93-2.93c0.2-1.15,0.3-2.31,0.31-3.47c-0.02-0.52-0.08-1.04-0.16-1.56c-0.1-0.39-0.08-0.81,0.06-1.19c0.43-0.85,1.86-0.61,2.52-0.28c1.06,0.54,0.44,1.39,0,2.23c-0.97,2.2-1.36,4.61-1.13,7c0.18,1,0.4,2.17-0.31,3c-0.61,0.71-1.67,0.79-2.38,0.19C160.44,314.59,160.39,314.53,160.33,314.47z"
    />
    <path
      class="bone"
      disabled
      d="M160.49,223.46c-1.08,0.71-2.43,0.86-3.64,0.39c-1.09-0.42-1.89-0.8-1.94,0.55c-0.09,2.3,1.49,2.17,2,8.84s1.57,20.13,1.34,25.18s1.48,15.91,2.16,20.63s1.33,5.71,1.26,7.86c0,0.94-0.15,3.34,0.36,4.48c0.16,0.34,0.55,0.52,0.91,0.41c0.28-0.08,0.65-0.18,1.08-0.28c1.29-0.69,2.45-2,1.64-5.48c-1.13-5.65-1.95-11.36-2.46-17.1c-0.35-4,0.32-16.9,0.66-21.13l0.68-13.42c0.62,3.55,1.88,10.43,3.19,17.43s0,32.36-1,37.27c-0.12,0.46-0.18,0.93-0.18,1.4c0.01,0.3,0.27,0.53,0.56,0.51c0.02,0,0.03,0,0.05,0c0.84-0.1,1.68-0.1,2.52,0c1.43,0.24,2.83,0.65,4.17,1.23c0.5,0.24,1.1,0.03,1.33-0.47c0.05-0.11,0.08-0.22,0.1-0.34c0-1.29-0.12-2.58-0.35-3.85c-0.26-2.8-1.72-8.55-1.91-15.28s-0.19-19.76-2.7-30.74c-2-8.64-2.45-13.78-1-15.89s1.08-3.21-1.28-2.78c-0.91,0.4-1.94,0.4-2.85,0c-0.8-0.39-1.67-0.63-2.56-0.7C162.01,222.28,161.33,222.92,160.49,223.46z"
    />
    <path
      class="bone"
      disabled
      d="M161.96,295.42c0.09-0.49,0.38-0.93,0.8-1.2c1.94-0.63,3.97-0.92,6-0.87c1.23,0.17,2.43,0.48,3.58,0.93l1,0.57c0.72,0.59,1.53,1.06,2.39,1.41c0.57,0.23,1.02,0.68,1.24,1.25c0.02,0.14,0.02,0.29,0,0.43c0,0,0,0,0,0.06c-0.36,0.8-0.84,1.53-1.44,2.16c-0.42,0.09-0.86,0.14-1.29,0.14c-0.92-0.06-1.83,0.14-2.64,0.58l-0.36,0.33c-0.51,0.61-1.3,0.91-2.09,0.8c-0.74-0.07-1.46-0.27-2.13-0.6c-0.71-0.34-1.48-0.57-2.26-0.68c-1-0.12-1.39,0.06-2.38-0.06s-0.53-4.51-0.53-4.51C161.87,295.9,161.91,295.66,161.96,295.42z"
    />
    <path
      class="bone"
      disabled
      d="M103.15,96.39c-0.78,0.17-2.09,0.82-2.11,0c0-0.49,1.07-1.44-0.9-1.61c0,0-1.63,0-3.81,0s-3.82,0-3.82,0c-2,0.17-0.88,1.12-0.89,1.61c0,0.83-1.33,0.18-2.12,0s-1.57,1.17,0,1.34s2.71,0.34,2.64,1.11c-0.08,1,1.94,1.21,4.19,1.21s4.26-0.24,4.18-1.21c-0.06-0.77,1.07-0.94,2.64-1.11S103.94,96.23,103.15,96.39z"
    />
    <path
      class="bone"
      disabled
      d="M103.67,184.82c-0.85,0.23-2.26,1.11-2.28,0c0-0.67,1.15-2-1-2.19c0,0-1.76-0.08-4.1-0.08s-4.11,0.08-4.11,0.08c-2.11,0.23-0.94,1.52-1,2.19c0,1.13-1.43,0.25-2.28,0c-0.5,0-0.91,0.41-0.91,0.91s0.41,0.91,0.91,0.91c1.69,0.23,2.92,0.46,2.85,1.52c-0.09,1.32,2.08,1.65,4.5,1.65s4.59-0.33,4.5-1.65c-0.07-1.06,1.15-1.29,2.84-1.52c0.5,0.02,0.93-0.37,0.95-0.87C104.56,185.27,104.17,184.84,103.67,184.82z"
    />
    <path
      class="bone"
      disabled
      d="M102.94,177.12c-0.76,0.21-2,1-2,0c0-0.6,1-1.76-0.87-2c0,0-1.58-0.07-3.69-0.07s-3.7,0.07-3.7,0.07c-1.9,0.21-0.85,1.37-0.86,2c0,1-1.29,0.23-2,0c-0.45,0-0.82,0.37-0.82,0.82c0,0.45,0.37,0.82,0.82,0.82c0,0,0,0,0,0c1.52,0.21,2.62,0.41,2.56,1.37c-0.08,1.18,1.87,1.48,4,1.48s4.13-0.3,4-1.48c-0.06-1,1-1.16,2.56-1.37c0.45,0,0.82-0.37,0.82-0.82C103.76,177.49,103.39,177.12,102.94,177.12z"
    />
    <path
      class="bone"
      disabled
      d="M102.11,85.6c-0.67,0.13-1.78,0.65-1.79,0c0-0.39,0.9-1.14-0.76-1.27c0,0-1.39,0-3.23,0s-3.23,0-3.23,0c-1.67,0.13-0.75,0.88-0.76,1.27c0,0.66-1.13,0.14-1.79,0s-1.34,0.93,0,1.06s2.29,0.27,2.23,0.88s1.64,1,3.55,1s3.61-0.2,3.54-1s0.91-0.75,2.24-0.88S102.77,85.47,102.11,85.6z"
    />
    <path
      class="bone"
      disabled
      d="M102.11,80.55c-0.67,0.13-1.78,0.64-1.79,0c0-0.39,0.9-1.14-0.76-1.27c0,0-1.39,0-3.23,0s-3.23,0-3.23,0c-1.67,0.13-0.75,0.88-0.76,1.27c0,0.65-1.13,0.14-1.79,0s-1.34,0.93,0,1.06s2.29,0.26,2.23,0.88s1.64,1,3.55,1s3.61-0.19,3.54-1s0.91-0.75,2.24-0.88S102.77,80.42,102.11,80.55z"
    />
    <path
      class="bone"
      disabled
      d="M102.11,90.76c-0.67,0.14-1.78,0.69-1.79,0c0-0.42,0.9-1.23-0.76-1.38c0,0-1.39,0-3.23-0.05s-3.23,0.05-3.23,0.05c-1.67,0.15-0.75,1-0.76,1.38c0,0.7-1.13,0.15-1.79,0s-1.34,1,0,1.14s2.29,0.29,2.23,1c-0.07,0.82,1.64,1,3.55,1s3.61-0.21,3.54-1c-0.05-0.67,0.91-0.81,2.24-1S102.77,90.62,102.11,90.76z"
    />
    <path
      class="bone"
      disabled
      d="M105.62,193.3c-0.93,0.26-3.7,1.22-3.72,0c0-0.74,1.26-2.16-1.06-2.41c0,0-1.93-0.08-4.51-0.08s-4.52,0.08-4.52,0.08c-2.32,0.25-1,1.67-1,2.41c0,1.24-2.79,0.28-3.72,0c-0.55,0-1,0.45-1,1s0.45,1,1,1c1.86,0.25,4.41,0.5,4.34,1.67c-0.1,1.45,2.29,1.81,5,1.81s5-0.36,5-1.81c-0.08-1.17,2.48-1.42,4.34-1.67c0.55-0.04,0.97-0.52,0.92-1.07C106.65,193.67,106.17,193.26,105.62,193.3L105.62,193.3z"
    />
    <path
      class="bone"
      disabled
      d="M108.99,233.21c-1.26,0.35-5,1.67-5.07,0c0-1,1.73-2.94-1.44-3.29c0,0-2.63-0.11-6.15-0.11s-6.16,0.11-6.16,0.11c-3.17,0.35-1.42,2.28-1.44,3.29c0,1.7-3.8,0.38-5.07,0c-0.76,0-1.37,0.61-1.37,1.37c0,0.76,0.61,1.37,1.37,1.37c2.54,0.34,6,0.68,5.92,2.28c-0.13,2,3.12,2.46,6.75,2.46s6.88-0.49,6.75-2.46c-0.11-1.6,3.38-1.94,5.91-2.28c0.76,0,1.37-0.61,1.37-1.37C110.36,233.82,109.75,233.21,108.99,233.21z"
    />
    <path
      class="bone"
      disabled
      d="M106.46,212.23c-1,0.27-4,1.33-4.06,0c0-0.81,1.39-2.36-1.15-2.64c0,0-2.11-0.09-4.92-0.09s-4.93,0.09-4.93,0.09c-2.53,0.28-1.14,1.83-1.15,2.64c0,1.35-3,0.29-4.06,0c-0.6-0.06-1.14,0.39-1.2,0.99c-0.06,0.6,0.39,1.14,0.99,1.2c0.07,0.01,0.14,0.01,0.21,0c2,0.27,4.82,0.55,4.74,1.82c-0.11,1.58,2.5,2,5.4,2s5.5-0.39,5.4-2c-0.09-1.27,2.7-1.55,4.73-1.82c0.84,0,1.53-0.25,1.53-1.1C107.99,212.48,107.3,211.8,106.46,212.23z"
    />
    <path
      class="bone"
      disabled
      d="M107.47,222.22c-1.11,0.3-4.43,1.46-4.46,0c0-0.89,1.52-2.59-1.27-2.89c0,0-2.32-0.11-5.41-0.11s-5.42,0.11-5.42,0.11c-2.79,0.3-1.25,2-1.27,2.89c0,1.49-3.34,0.33-4.46,0c-0.66,0-1.2,0.53-1.2,1.2s0.53,1.2,1.2,1.2c0,0,0,0,0.01,0c2.23,0.3,5.3,0.61,5.21,2c-0.12,1.73,2.75,2.17,5.94,2.17s6-0.44,5.94-2.17c-0.09-1.4,3-1.71,5.2-2c0.55,0.37,1.43,0.02,1.8-0.53c0.37-0.55,0.22-1.3-0.33-1.66C108.54,222.15,108.01,222.15,107.47,222.22z"
    />
    <path
      class="bone"
      disabled
      d="M106.46,202.52c-1,0.27-4,1.33-4.06,0c0-0.8,1.39-2.35-1.15-2.63c0,0-2.11-0.09-4.92-0.09s-4.93,0.09-4.93,0.09c-2.53,0.28-1.14,1.83-1.15,2.63c0,1.36-3,0.3-4.06,0c-0.6-0.06-1.14,0.39-1.2,0.99c-0.06,0.6,0.39,1.14,0.99,1.2c0.07,0.01,0.14,0.01,0.21,0c2,0.27,4.82,0.54,4.74,1.82c-0.11,1.58,2.5,2,5.4,2s5.5-0.39,5.4-2c-0.09-1.28,2.7-1.55,4.73-1.82c0.61,0,1.1-0.49,1.1-1.1C107.56,203.01,107.07,202.51,106.46,202.52C106.46,202.51,106.46,202.51,106.46,202.52z"
    />
    <path
      class="bone"
      disabled
      d="M113.98,54.62c0-0.37-0.23-0.36-0.55-0.36c-1.92,0-4.56,0.18-4.74,0.8c-0.11,0.38-0.21,0.82-0.32,1.28c-0.36,1.56-0.87,5.17-2,6.43c0,0-3.25,3.49-10,3.49l0,0c-6.72,0-10-3.49-10-3.49c-1.17-1.26-1.67-4.87-2-6.43c-0.11-0.46-0.21-0.9-0.32-1.28c-0.18-0.62-2.83-0.79-4.74-0.8c-0.32,0-0.53,0-0.56,0.36c0,0.14-0.58,4.19,0.86,5s0.67,8.9,3.52,10.37c4.16,2.15,4.64,8.26,13.26,8.27l0,0c8.62,0,9.09-6.12,13.26-8.27c2.85-1.47,2.06-9.56,3.51-10.37S113.99,54.76,113.98,54.62z"
    />
    <path
      class="bone"
      disabled
      d="M115.05,13.58c-4.26-6.14-11.24-9.83-18.72-9.89l0,0c-7.47,0.06-14.44,3.75-18.7,9.89c-3.49,4.84-4.54,12.77-4.3,17.42c0.27,5.72,2.94,21.82,5.41,22.24c1.83,0.32,5.66,0.08,6.2,1.55c0.14,0.39,1.08,4.58,2.06,5.64c1.33,1.41,5.53,2.57,9.33,2.57l0,0c3.8,0,8-1.18,9.34-2.61c1-1.06,1.93-5.25,2.07-5.64c0.54-1.47,4.36-1.23,6.2-1.55c2.48-0.4,5.16-16.5,5.39-22.2C119.59,26.35,118.54,18.42,115.05,13.58z M84.05,45.88c-2.34-0.16-3.2-1.89-3.21-7.09c0-4.06,2.84-4.51,7.44-5.4c1-0.18,3.1-0.75,4.2,1.26c0.92,1.7,0.61,4.52-0.4,6.5S86.38,46,84.05,45.88z M97.12,54.12c-0.24-0.11-0.5-0.17-0.77-0.2l0,0c-0.27,0.03-0.53,0.09-0.78,0.2c-3.79,1.66-3.33-1.85-2.71-5.08c0.53-2.8,1.29-5,2-5.85s1,0,1.48,0l0,0c0.53,0,0.86-0.65,1.47,0s1.49,3.05,2,5.85C100.46,52.27,100.91,55.78,97.12,54.12z M108.63,45.88c-2.34,0.15-7-2.73-8-4.73s-1.33-4.8-0.4-6.5c1.1-2,3.25-1.44,4.2-1.26c4.6,0.89,7.44,1.34,7.44,5.4C111.83,44,110.96,45.72,108.63,45.88z"
    />
    <path
      class="bone"
      disabled
      d="M114,240.28c-1.62-5.39-5.29-2-8,1.33c-1.37,1.67-3.07,3.03-5,4c-2.87,1.45-6.27,1.45-9.14,0c-1.93-0.97-3.63-2.33-5-4c-2.73-3.37-6.41-6.72-8-1.33c-1.9,6.35-0.8,10.6,2.93,13.06c2.71,1.78-0.5,5.71,2.75,8.75c3.07,2.87,1.67,5.05,4.71,6.32c1.93,0.8,1.2,5,3,6.16c1,0.69-0.09,3.48,1.22,4.08c0.78,0.36,1.31,2,3,2s2.21-1.65,3-2c1.31-0.6,0.19-3.39,1.22-4.08c1.76-1.16,1-5.36,3-6.16c3-1.27,1.64-3.45,4.7-6.32c3.25-3,0-7,2.75-8.75C114.81,250.88,115.91,246.63,114,240.28z"
    />
    <path
      class="bone"
      d="M136.84,275.39c-2.89,0.14-2.09,2.69-3.56,2s-0.26-2.57,0.24-3.91s0.07-3.93-1.74-4.58c-3.33-1.19-6.28,1.75-7.47,4.1c-1.22,2.48-1.77,5.24-1.58,8c0.39,2.67,3.43,1.57,5.58,2.18c2.15,0.61,2.41,5.46,1.23,8.35s-1.87,3.83-0.86,7.38c1.01,3.55-3,27.23-5.88,46.86c-1.93,13.38-5.88,34.63-9,47.32c-1.33,5.36-4.67,15.14-6,16.66c-3.74,4.24-4.64,8.37-3,14.39c1.07,4,3.5,4.82,5.43,4.49c1.84-0.6,1.45-2.09,1.09-3.1s-1.81-4.28-1.28-7.29c0.71-3.85,4.4-6.4,8.25-5.7c1.25,0.23,2.42,0.79,3.38,1.63c2.18,1.94,3,5.45,2.19,8.63c-0.54,2.11-1.46,2.85-1,4.16c0.59,1.56,2.88,1.12,5.12-0.91c0.76-0.68,2-2.09,1.09-8.65c-0.77-5.73-4-6.19-4.55-12.15s5.87-46.77,7.2-54.63c1.19-7,6.4-45.14,6.58-46.77c0.39-3.53,4.06-7.68,5.17-13C146.25,277.56,139.73,275.26,136.84,275.39z"
    />
    <path
      class="bone"
      disabled
      d="M151.33,217.7c-0.67-3.54,3.71-6.66,4.06-11.65s-2.21-67.68-4.37-71.72c-0.67-1.37-1.65-2.57-2.87-3.49c-3.08-2.45-4.39-6.5-3.32-10.29c1.16-4.36,4.21-6,7.59-6c1.7-0.02,3.24,0.99,3.91,2.55c1.17-0.33,3.45-0.2,3.79,2c0.46,4.66,0.41,9.35-0.15,14c-0.69,4.75,1.27,42.89,1.67,53.24c0.36,9.16,1.49,17.08,4.08,20.65s5.77,4.75,5.57,8.11c-0.18,3.15-3.54,6.27-6.31,5.21c-1.68-0.63-2-1.2-2.58-1.33c-0.29-0.06-0.55-0.58-1.26,0.13c-0.69,0.7-1.54,1.23-2.47,1.56C156.33,221.47,152.16,222.18,151.33,217.7z"
    />
    <path
      class="bone"
      d="M105.44,571c1.08-0.39,2.68-0.45,3.42,0.39c0.13,0.25,0.2,0.54,0.19,0.82c0,0.58-0.72,0.83-0.85,1.36c-0.19,0.77,0.67,1.18,0.78,1.86c0.25,1.38-1.76,1.62-2.52,1.14c-0.57-0.37-0.48-1-0.73-1.54s-0.65-0.63-1-1.11c-0.63-0.9-0.41-2.15,0.49-2.79C105.29,571.08,105.36,571.04,105.44,571z"
    />
    <path
      class="bone"
      d="M113.4,548.15c0.71,0.4,0.43,1.17,0.51,1.9c0.23,1.72,0.6,3.42,1.1,5.09c0.09,0.3,0.2,0.58,0.34,0.86c0.34,0.62,0.12,1.4-0.5,1.74c-0.21,0.12-0.45,0.17-0.69,0.16c-0.39,0-0.77-0.11-1.09-0.32c-0.59-0.33-0.65-0.7-0.57-1.37c0.42-3.2-1.4-6.72-1-7.39c0.29-0.69,1.09-1.02,1.78-0.73C113.32,548.11,113.36,548.13,113.4,548.15z"
    />
    <path
      class="bone"
      d="M121.62,564.15c0.07-0.07,0.27-0.19,0.31-0.1c0.42,0.81-0.09,1.55,0.41,2.41c0.3,0.64,0.63,1.26,1,1.86c0.22,0.29,0.46,0.35,0.53,0.77s-0.08,0.8,0,1.19s0.3,0.68,0.06,1s-0.51,0.26-0.73,0c-0.49-0.63-0.09-1.36-1-1.63c-0.09-0.4,0-0.79-0.05-1.18c-0.14-0.32-0.31-0.62-0.5-0.91c-0.27-0.55-0.38-1.23-1-1.45c-0.41-0.15-0.67,0-0.94-0.4s-0.11-0.57,0.21-0.88c0.22-0.15,0.48-0.24,0.75-0.24c0.5,0,0.78,0.06,0.89-0.19S121.49,564.31,121.62,564.15z"
    />
    <path
      class="bone"
      d="M123.87,563.15c0.37-0.57,0.64,0,1.24-0.27c0.06,0,0-0.17,0.06-0.22s0.32-0.3,0.4-0.27c0.84,0.26-0.18,1.37,0.31,2.16c0.28,0.56,0.6,1.11,0.95,1.64c0.21,0.26,0.44,0.3,0.52,0.67s0,0.73,0,1.09s0.3,0.6,0.11,0.93s-0.46,0.26-0.67,0c-0.47-0.56-0.14-1.24-1-1.43c-0.09-0.37,0-0.73-0.1-1.08c-0.13-0.28-0.3-0.55-0.49-0.8c-0.27-0.49-0.4-1.11-0.94-1.28c-0.38-0.12-0.39,0.14-0.54-0.31C123.61,563.7,123.67,563.38,123.87,563.15z"
    />
    <path
      class="bone"
      d="M127.25,562.8c0.37,0.1,0.47,0.51,0.67,0.84c0.13,0.16,0.25,0.34,0.34,0.52c0.08,0.24,0,0.48,0.1,0.72c0.6,0.11,0.39,0.58,0.72,1c0.15,0.15,0.32,0.19,0.45,0s0-0.43-0.09-0.63s0-0.5-0.05-0.73s-0.22-0.27-0.36-0.44c-0.25-0.34-0.48-0.71-0.69-1.08c-0.35-0.52,0.36-1.23-0.22-1.39c-0.09,0.01-0.18,0.05-0.24,0.12c-0.04,0.09-0.09,0.17-0.15,0.25c-0.31,0.25-0.66-0.06-1,0.28C126.71,562.18,126.45,562.6,127.25,562.8z"
    />
    <path
      class="bone"
      d="M117.97,571.63c-0.21-0.86-0.26-1.75-0.15-2.63c-0.01-0.32-0.18-0.61-0.45-0.79c-0.37-0.27-0.82-0.42-1.28-0.44c-0.3,0.07-0.57,0.21-0.81,0.4c-0.3,0.24-0.44,0.63-0.36,1c0.08,0.29,0.18,0.57,0.29,0.84c0.47,1.16,0.58,2.42,1,3.61c0.2,0.55,1.76,1.14,2.17,0.14C118.75,572.91,118.33,572.34,117.97,571.63z"
    />
    <path
      class="bone"
      d="M107.33,536.23c-1.58,0.13-3.32,1.07-3.53,2.69c-0.27,1.46-1.08,2.78-2.26,3.68c-0.81,0.69-1.26,1.71-1.25,2.77c0,1.81-0.08,5.29,1.69,5.23c1.1-0.15,2.1-0.75,2.74-1.66c0.93-1.05,2.67-1.35,4.89-1.19c1.64,0.11,3.14-1.35,5.06-1.19s2.39,1,3.72,1.41s1.87-1.05,0.86-2c-0.92-0.72-1.89-1.36-2.92-1.92c-2.81-1.58-2-4.63-2.4-5.76C113.4,536.74,109.23,536.08,107.33,536.23z"
    />
    <path
      class="bone"
      d="M127.96,430.82c0.39-1.3-0.46-2.53-1.09-2.27c-2.63,1.07-3.3,1.13-5,0.34c-1.11-0.52-2.94,1.23-4.92,1.33c-2.14,0.12-3-2-4.18-1.25c-1.54,0.94-4.19,1.71-6.08,0.79c-0.36-0.17-0.79-0.12-1.11,0.13c-0.65,0.3-1.09,0.93-1.15,1.65c-0.11,0.86,0.34,2.18,1.79,4.63c6.44,10.88,3.53,31,2.46,45.41c-3,39.51-6.32,39.6-7.26,52.23c-0.07,1,0.62,2.54,1.42,2.61s3-1.24,5.25-1.36c2.21,0.11,4.4,0.5,6.51,1.18c2,0.71,0.44-3.65,0-7.32c-1.16-9,3.6-48.92,4.41-55.22c0.69-5.37,2.64-26.1,3.42-30C123.5,438.26,126.79,434.78,127.96,430.82z"
    />
    <path
      class="bone"
      d="M104.05,563.65c-0.74,1.13-1.54,2.89-0.14,2.81c0.58-0.86,1.33-1.6,2.21-2.17c0.94-0.43,2,0.51,3,1.63c0.28,0.1,0.35-0.08,0.45-0.36c0.43-1.12-0.36-2.78-0.45-3.91c-0.11-1.51,0.55-2.54,1-3.92c0.46-1.54-0.1-2.1-0.1-2.1s-1.87-2-3.66-1.63c-0.44,0.11-0.83,0.34-1.13,0.68c-0.59,0.59-0.94,1.37-1,2.2c-0.05,1.01,0.02,2.01,0.22,3C104.7,561.37,104.88,562.4,104.05,563.65z"
    />
    <path
      class="bone"
      d="M110.33,554.35c-0.05,0.07-0.15,0.09-0.22,0.04c-0.01-0.01-0.03-0.02-0.04-0.04c-0.69-0.84-1.67-1.39-2.74-1.55c-1.27-0.15-3.23,1.3-3.52,1.67s-0.44-0.44-0.37-0.9c0.21-1.5,1.21-3.51,2.35-4.09c1.17-0.54,2.5-0.6,3.71-0.15c0.6,0.24,1.07,0.71,1.33,1.3c0.3,0.62,0.37,1.33,0.19,2C110.89,553.24,110.65,553.82,110.33,554.35z"
    />
    <path
      class="bone"
      d="M118.33,556.18c0.33-0.23-2-7.83-2-7.83c-0.13-0.17-0.31-0.28-0.52-0.32c-1.49-0.39-1.21,0.1-1.21,0.1c1.29,2.44,1.53,7.33,1.86,7.89C116.41,556,116.95,557.13,118.33,556.18z"
    />
    <path
      class="bone"
      d="M121.42,552.31c-0.29-0.81-0.65-1.57-0.94-2.38l-0.13-0.13c-0.11,0-0.74-0.32-0.62,0.07s0.88,2.5,0.88,2.5c0.37,0.88,0.66,1.68,0.76,1.79s0.59,0.28,0.71,0C122.33,553.53,121.61,552.84,121.42,552.31z"
    />
    <path
      class="bone"
      d="M117.7,549.58c0.14,0.36,1.79,5.79,1.86,6s0.53,0,0.74-0.24c0.6-0.66-0.21-1.43-0.34-2.15v-0.16c0,0-0.95-3.17-1-3.37S117.56,549.21,117.7,549.58z"
    />
    <path
      class="bone"
      d="M115.86,564.52c0.31,0.03,0.62,0.1,0.91,0.21c0.1,0.04,0.22-0.02,0.26-0.12c0,0,0-0.01,0-0.01c0.27-1.08-0.87-2-1-3.25s0.44-2.77-1.34-2.38c-0.41-0.01-0.82,0.01-1.23,0.06c-0.36,0.13-0.58,0.26-0.54,0.65l0.42,5.24c0,0,0.06,0.38,0.77,0.07l0.55-0.25C115.03,564.55,115.45,564.48,115.86,564.52z"
    />
    <path
      class="bone"
      d="M120.92,562.6c-0.09-0.41-0.25-0.81-0.46-1.17c-0.09-0.4-0.28-0.78-0.56-1.08c-0.28-0.39-0.51-0.8-0.71-1.24c-0.21-0.42-0.09-1.19-0.52-1.36c-0.49-0.09-1-0.01-1.45,0.22c-0.13,0.33,0.25,0.85,0.45,1.32c0.42,1,1,1.91,1.42,2.89s0.38,1.43,0.77,1.44l0.83-0.46C120.82,563,120.9,562.81,120.92,562.6z"
    />
    <path
      class="bone"
      d="M117.58,566.21c0,0,0.42,0.35,0.35,0.61s-0.44,0.31-0.44,0.31c-0.45-0.27-0.98-0.39-1.5-0.36c-0.57,0.16-1.1,0.43-1.56,0.81c-0.33,0.23-0.51-0.27-0.51-0.81c0.01-0.43,0.27-0.82,0.66-1c0.21-0.1,0.44-0.17,0.67-0.21c0.83,0,1.64,0.24,2.33,0.69"
    />
    <path
      class="bone"
      d="M120.33,557.33c0.31,0.93,1,1.36,1.54,2.12c0.29,0.38,0.52,0.81,0.67,1.26c0.15,0.43,0.44,1.28,0.69,1.34s1.48-0.13,1.5-0.38s-3.18-5-3.46-5.31S120.04,556.61,120.33,557.33z"
    />
    <path
      class="bone"
      d="M125.98,561.21c0.19,0,1.48-0.21,1.55-0.53s-1.49-2.06-2.5-2.86s-1.12-2-2.13-2.48c-0.43-0.2-1.13,0.07-0.84,0.54s3.51,5,3.51,5C125.7,561,125.84,561.11,125.98,561.21z"
    />
    <path
      class="bone"
      d="M105.52,569.82c0,0-0.21,0-0.26,0s-1.58-0.49-1.28-1.63s2.07-2.77,2.57-2.64c0,0,0.67-0.15,1.83,1.3c0.35,0.42,0.59,0.93,0.67,1.47c0.04,0.42-0.18,0.81-0.55,1c-0.39-0.06-0.78-0.09-1.17-0.1c-0.54,0.11-1.05,0.34-1.5,0.66C105.72,569.9,105.61,569.88,105.52,569.82z"
    />
    <path
      class="bone"
      disabled
      d="M130.4,230.55c-9.66-1.78-14.75,2.58-15.08,7.08c-0.51,7,4,18.87,1.21,24.81c-2.7,5.71-6.83,10.62-12,14.24c-1.9,1.34-4.12,2.74-5.35,4.88c-1.89,0.31-3.81,0.31-5.7,0c-1.24-2.14-3.46-3.54-5.36-4.88c-5.17-3.62-9.3-8.53-12-14.24c-2.79-5.94,1.72-17.82,1.21-24.81c-0.33-4.5-5.41-8.86-15.07-7.08c-6.2,1.14-11.39,5.28-11.4,12.54c0,6.89,1.53,18.69,12.11,23.53c4.38,2,7.11,4.3,8,8.54c1.29,6.32-0.54,12.71,0.5,16.71c1.67,6.45,5.85,8.7,11.64,8.64c5.6-0.05,8.82-5.26,10.41-10.21c0-0.14,0.08-0.28,0.13-0.42c0.73,0.7,1.68,1.11,2.69,1.18l0,0c1.01-0.07,1.96-0.49,2.69-1.18l0.12,0.42c1.59,4.95,4.81,10.16,10.41,10.21c5.79,0.06,10-2.19,11.65-8.64c1-4-0.8-10.39,0.5-16.71c0.86-4.24,3.59-6.53,8-8.54c10.58-4.84,12.11-16.64,12.1-23.53C141.78,235.83,136.59,231.69,130.4,230.55z M84.18,293.86c-2.57,1.31-3.73-3.11-4.79-4.76c-1.37-2.14-3.34-4.26-2.51-7.07s4-2.24,6.24-1.2c2.24,1.23,3.84,3.36,4.4,5.85C87.78,289,86.44,292.71,84.18,293.86z M113.27,289.1c-1.07,1.65-2.23,6.07-4.8,4.76c-2.25-1.15-3.6-4.84-3.33-7.18c0.56-2.49,2.15-4.62,4.39-5.85c2.21-1,5.38-1.75,6.25,1.2S114.63,287,113.27,289.1L113.27,289.1z"
    />
    <path
      class="bone"
      disabled
      d="M100.64,100.94c0,0-1.85-0.06-4.31-0.06s-4.31,0.06-4.31,0.06c-2.22,0.18-0.69,3.61-0.4,4.49s2.17,1.23,4.71,1.23s4.37-0.22,4.71-1.23S102.86,101.12,100.64,100.94z"
    />
    <path
      class="bone"
      d="M111.45,418.29c0.77-3.91,6-4,7.74-3.34c1.43,0.57,3.66,3.85,3.53,6.24s-2.33,7.39-5.89,7.19C113.44,428.18,110.45,423.36,111.45,418.29z"
    />
    <path
      class="bone"
      d="M55.82,275.39c2.89,0.14,2.09,2.69,3.55,2s0.27-2.57-0.24-3.91s-0.07-3.93,1.75-4.58c3.33-1.19,6.27,1.75,7.46,4.1c1.23,2.48,1.78,5.24,1.58,8c-0.38,2.67-3.42,1.57-5.57,2.18s-2.42,5.46-1.24,8.35s1.88,3.83,0.86,7.38s3,27.23,5.88,46.86c1.94,13.38,5.89,34.63,9,47.32c1.32,5.36,4.67,15.14,6,16.66c3.75,4.24,4.65,8.37,3,14.39c-1.07,4-3.51,4.82-5.43,4.49c-1.84-0.6-1.46-2.09-1.1-3.1s1.81-4.28,1.29-7.29c-0.71-3.86-4.41-6.41-8.27-5.69c-1.25,0.23-2.41,0.79-3.37,1.62c-2.17,1.94-3,5.45-2.19,8.63c0.54,2.11,1.46,2.85,1,4.16c-0.6,1.56-2.88,1.12-5.12-0.91c-0.76-0.68-2-2.09-1.1-8.65c0.77-5.73,4-6.19,4.56-12.15s-5.88-46.77-7.2-54.63c-1.2-7-6.41-45.14-6.59-46.77c-0.39-3.53-4.06-7.68-5.17-13C46.41,277.56,52.92,275.26,55.82,275.39z"
    />
    <path
      class="bone"
      d="M64.69,430.82c-0.38-1.3,0.47-2.53,1.09-2.27c2.63,1.07,3.3,1.13,5,0.34c1.11-0.52,2.94,1.23,4.91,1.33c2.14,0.12,3-2,4.18-1.25c1.55,0.94,4.2,1.71,6.08,0.79c0.37-0.17,0.8-0.12,1.12,0.13c0.65,0.31,1.08,0.94,1.14,1.65c0.11,0.86-0.34,2.18-1.79,4.63c-6.43,10.88-3.53,31-2.45,45.41c2.94,39.51,6.32,39.6,7.25,52.23c0.08,1-0.62,2.54-1.41,2.61s-3-1.24-5.25-1.36c-2.21,0.11-4.4,0.5-6.51,1.18c-2,0.71-0.44-3.65,0-7.32c1.16-9-3.6-48.92-4.4-55.22c-0.69-5.37-2.65-26.1-3.43-30C69.16,438.26,65.87,434.78,64.69,430.82z"
    />
    <path
      class="bone"
      d="M81.21,418.29c-0.78-3.91-6-4-7.75-3.34c-1.43,0.57-3.65,3.85-3.53,6.24s2.33,7.39,5.89,7.19C79.22,428.18,82.21,423.36,81.21,418.29z"
    />
    <path
      class="bone"
      disabled
      d="M156.02,109.82c-1.83-1.07-3.73-2.01-5.69-2.82c-1.28-0.46-2.35-0.5-3.09,0.2s-0.69,2.09-0.4,3.35s-3.15,2.12-4.16,2s-2.68-2.2-4.37-2.74s-4.07,0.75-5.39,0.88c-0.73,0.08-2.59-0.08-4.65-0.18c0.02,0.33,0.02,0.67,0,1c2.54,1.13,6.89,3.51,8,7c0.55,1.59,0.21,3.35-0.89,4.62c1.54,1.43,3.25,3.52,3.33,5.81c0.07,1.26-0.26,2.52-0.94,3.58c1.53,1.28,3.06,3.17,2.82,5.5c-0.14,1.58-0.85,3.05-2,4.14c0.64,0.43,1.25,0.9,1.83,1.41c3.46-7.13,5.46-12.69,4.29-13.76c-1.03-1.18-1.72-2.62-2-4.16c-0.28-3.06,0.47-6.13,2.12-8.72c1.4-2.21,4.83-4.62,10.94-3.27C158.15,114.12,157.71,110.88,156.02,109.82z"
    />
    <path
      class="bone"
      disabled
      d="M47.98,129.74c-1.17,1.07,0.83,6.63,4.28,13.76c0.58-0.51,1.19-0.98,1.83-1.41c-1.14-1.09-1.85-2.56-2-4.14c-0.24-2.33,1.3-4.22,2.83-5.5c-0.69-1.07-1.02-2.32-0.95-3.59c0.09-2.28,1.79-4.37,3.34-5.8c-1.1-1.27-1.44-3.02-0.9-4.61c1.16-3.45,5.51-5.83,8.06-7c0-0.3,0-0.62,0-1c-2,0.1-3.91,0.26-4.65,0.18c-1.31-0.13-3.64-1.43-5.38-0.88s-3.34,2.62-4.37,2.74s-4.44-0.72-4.16-2s0.32-2.65-0.4-3.35s-1.82-0.66-3.09-0.2c-1.98,0.8-3.89,1.73-5.74,2.79c-1.68,1.06-2.12,4.3,0.29,3.77c6.12-1.35,9.54,1.06,10.95,3.27c1.65,2.59,2.4,5.66,2.12,8.72C49.75,127.07,49.04,128.54,47.98,129.74z"
    />
    <path
      class="bone"
      disabled
      d="M103.74,170.19c-0.14-0.35-0.47-0.63-0.8-0.54c-0.76,0.21-2,1-2,0c0-0.61,1-1.77-0.87-2c0,0-1.58-0.07-3.69-0.07s-3.7,0.07-3.7,0.07c-1.9,0.21-0.85,1.37-0.86,2c0,1-1.29,0.22-2,0c-0.36-0.04-0.7,0.19-0.8,0.54c0,0.15,0,0.3-0.07,0.44c0,0.31,0.3,0.59,0.87,0.66c1.52,0.21,2.62,0.42,2.56,1.37c-0.08,1.18,1.87,1.48,4,1.48s4.13-0.3,4-1.48c-0.06-0.95,1-1.16,2.56-1.37c0.56-0.07,0.81-0.35,0.86-0.66L103.74,170.19z"
    />
    <path
      class="bone"
      disabled
      d="M140.48,156.23c-0.17-1.82-3.86-3.44-3.86-3.44s4.53-1.69,4.47-4.14c-0.09-3.47-7-6.53-7-6.53s4-0.87,4.33-4.4c0.28-2.73-4.29-5.05-4.29-5.05c1.54-0.56,2.52-2.08,2.39-3.72c-0.1-2.87-4.7-5.92-4.7-5.92s3.22-1.36,2.38-3.88c-1.28-3.78-8.49-6.3-8.49-6.3c0.33-0.96,0.44-1.99,0.32-3c-1.84,0-3.55,0.17-5.12,0.34c0,1.36-0.43,2.94-3.21,3.25c-0.76,0.09-10.41,0.33-11.67,0.38c-0.3,0.02-0.6,0.06-0.89,0.13c-0.88-0.48-1.67-1.11-2.34-1.86c-0.86-1.12-0.79-3.22-2-3.6c-0.7-0.22-2.12,0.2-4.41,0.2s-3.72-0.42-4.42-0.2c-1.23,0.38-1.16,2.48-2,3.6c-0.67,0.74-1.46,1.37-2.34,1.86c-0.3-0.07-0.6-0.11-0.9-0.13c-1.26,0-10.9-0.29-11.67-0.38c-2.78-0.31-3.24-1.89-3.2-3.25c-1.57-0.17-3.29-0.29-5.12-0.34c-0.12,1.01-0.02,2.04,0.32,3c0,0-7.22,2.52-8.49,6.3c-0.84,2.52,2.38,3.88,2.38,3.88s-4.62,3.05-4.78,5.97c-0.13,1.64,0.85,3.16,2.39,3.72c0,0-4.56,2.28-4.23,5c0.36,3.53,4.33,4.4,4.33,4.4s-7,3.06-7.05,6.53c-0.06,2.45,4.47,4.14,4.47,4.14s-3.68,1.62-3.85,3.44c-0.35,3.81,3.77,5.27,3.77,5.27s-4,2.24-3.55,5.29c0.24,1.54,2.57,3.52,2.57,3.52s-2.82,2.77-2.33,6c0.35,1.64,1.27,3.11,2.6,4.14c0,0-2.73,2.77-2,6s4.42,3.78,4.42,3.78c-0.07,0.21-1.62,4.11-1.29,5.93c0.91,4.89,6.14,4.24,7.63,4.12c2.79-0.41,5.37-1.69,7.39-3.66c0.84-0.85,1.9-2.06,3.05-3.47c2.4-1.1,4.69-2.44,6.83-4c1.91-1.73,3.71-3.57,5.39-5.52c1.57-1.73,2.31-3,1.35-3.77s-2.83,0.67-4,1.53c-0.62,0.46-1.79,1.58-3.13,2.8c0.42-0.68,0.8-1.34,1.15-2c2.32-4.21,5.22-5,6.6-10.4c0.5-2,0.42-6.31,3.6-11c0.84,3.52,2.08,6.55,3.75,6.71h0.34h0.34c1.67-0.16,2.9-3.19,3.74-6.72c3.18,4.69,3.11,9,3.61,11c1.37,5.44,4.27,6.19,6.59,10.4c0.27,0.49,0.56,1,0.86,1.49c-1.11-1-2.06-1.91-2.59-2.31c-1.18-0.86-3-2.3-4-1.53s-0.22,2,1.35,3.77c1.69,1.94,3.49,3.79,5.39,5.52c2.01,1.49,4.16,2.77,6.43,3.83c1.21,1.5,2.34,2.79,3.22,3.68c2.01,1.97,4.6,3.25,7.39,3.66c1.48,0.12,6.71,0.77,7.62-4.12c0.33-1.82-1.21-5.72-1.28-5.93c0,0,3.67-0.58,4.41-3.78s-2-6-2-6c1.32-1.03,2.25-2.5,2.6-4.14c0.48-3.27-2.33-6-2.33-6s2.32-2,2.57-3.52c0.48-3-3.55-5.29-3.55-5.29S140.83,160,140.48,156.23z M69.83,115.68c2.2,0.8,4.5,1.32,6.84,1.52c1.89,0.15,6.55,0.41,9.16,0.48c0.23,1.6,1.02,3.06,2.23,4.13c0.09,0.1,0.17,0.21,0.24,0.32c-3.67,0-12.48-0.14-17-0.82C62.93,120,69.83,115.68,69.83,115.68z M66.76,124.55c4.01,0.81,8.06,1.38,12.14,1.69c3.41,0.21,8.31,0.19,10.8,0.2c0.27,1.55,0.48,3.36,0.64,5.28c-4.92-0.12-15.92-0.54-20-1.15C59.33,128.91,66.76,124.55,66.76,124.55z M64.91,134.68c0,0,5.63,1,8.59,1.25c2.79,0.24,13.52,0.55,17.1,0.14c0.07,1.57,0.11,3.15,0.15,4.66h-0.42c-4.34,0.33-17.65,0.81-21.61,0.13C56.04,138.68,64.91,134.68,64.91,134.68L64.91,134.68z M64.61,144.18c0,0,4.72,1,7.63,1.3c6.2,0.29,12.41,0.03,18.56-0.79c0,1.31,0,2.5,0,3.51c-6.51,3.43-16.92,4.45-23.41,3.13C52.69,148.34,64.61,144.18,64.61,144.18L64.61,144.18z M58.49,172.87c0,0,1.39,0.31,2.61,0.67c1.64,0.42,3.31,0.73,5,0.91c2.49,0.21,4.99,0.09,7.44-0.38c2.23-0.38,3-0.79,5.36-1.07s1.3,1.27-0.93,3.18s-10.41,4.28-18,2.3C54.86,177.15,58.49,172.87,58.49,172.87L58.49,172.87z M58.01,185.64c-0.87-1,0-2.75,0-2.75c2.42,0.64,4.91,1.01,7.42,1.11c5.87,0,7.69-0.91,10.57-1.66s1.46,0.63,0.75,1.23c-1.28,1.09-4.66,4.07-11.86,4.27C62.59,187.88,58.93,186.75,58.01,185.64L58.01,185.64z M65.55,195.57c-2.56,0.79-4.25-0.59-4.06-1.53c0.12-0.57,0.31-1.11,0.59-1.62c2.18,0.67,4.47,0.89,6.73,0.63C70.7,192.73,68.17,194.76,65.55,195.57z M82.55,165.45c-2.43,2.9-10.46,6.19-19.88,4.32c-7.76-1.53-1.9-5.82-1.9-5.82c3.07,0.94,6.28,1.38,9.49,1.31c4.78-0.12,8.74-0.93,11.26-2.24s2.39,0.74,0.99,2.43L82.55,165.45z M82.61,157.95c-5.4,3.2-12.65,3.34-16,2.87c-11.46-1.62-6.51-6.18-6.51-6.18c2.99,0.8,6.02,1.4,9.09,1.82c3,0.32,10.48,0.23,13.77-0.86c1.37-0.45,0.95,1.55-0.39,2.4L82.61,157.95z M90.55,156.88c-1.25,0.59-4.05,0.59-2.7-1c0.98-1.08,2.04-2.09,3.18-3c0.09,1,0.22,2.17,0.41,3.4c-0.29,0.23-0.6,0.43-0.93,0.6H90.55zM104.64,121.81c1.2-1.07,1.99-2.53,2.23-4.13c2.6-0.07,7.26-0.33,9.15-0.48c2.34-0.2,4.64-0.71,6.84-1.52c0,0,6.9,4.36-1.44,5.63c-4.55,0.68-13.36,0.78-17,0.82c0.05-0.11,0.11-0.22,0.18-0.32L104.64,121.81z M103,126.44c2.48,0,7.38,0,10.8-0.2c4.07-0.31,8.13-0.88,12.13-1.69c0,0,7.41,4.36-3.58,6c-4.07,0.61-15.08,1-20,1.15c0.12-1.9,0.33-3.7,0.61-5.26H103z M102.09,136.07c3.58,0.42,14.32,0.1,17.1-0.14c3-0.25,8.6-1.25,8.6-1.25s8.86,4-3.82,6.19c-4,0.68-17.27,0.2-21.61-0.13h-0.41c-0.01-1.52,0.03-3.1,0.1-4.67H102.09z M101.89,144.69c6.15,0.82,12.37,1.08,18.57,0.79c2.91-0.27,7.62-1.3,7.62-1.3s11.93,4.16-2.79,7.15c-6.5,1.32-16.91,0.3-23.42-3.13c-0.03-1.01-0.03-2.2-0.02-3.51H101.89z M102.18,156.88c-0.31-0.15-0.61-0.34-0.88-0.55c0.18-1.23,0.31-2.4,0.41-3.4c1.14,0.91,2.2,1.92,3.18,3c1.3,1.54-1.5,1.54-2.75,0.95H102.18zM109.78,155.6c3.28,1.09,10.76,1.18,13.77,0.86c3.06-0.42,6.09-1.02,9.08-1.82c0,0,5,4.56-6.51,6.18c-3.35,0.47-10.59,0.33-16-2.87c-1.38-0.8-1.79-2.8-0.38-2.35H109.78z M110.19,165.45c-1.4-1.69-1.5-3.75,1-2.43s6.47,2.12,11.26,2.24c3.21,0.08,6.41-0.34,9.48-1.26c0,0,5.85,4.29-1.91,5.82c-9.41,1.82-17.45-1.47-19.87-4.37L110.19,165.45z M127.19,195.57c-2.61-0.81-5.14-2.84-3.25-2.52c2.26,0.26,4.55,0.04,6.72-0.63c0.28,0.51,0.48,1.05,0.6,1.62c0.07,0.96-1.59,2.32-4.16,1.53H127.19z M134.73,185.64c-0.91,1.11-4.57,2.24-6.88,2.18c-7.19-0.2-10.58-3.18-11.86-4.27c-0.71-0.6-2-2,0.76-1.23s4.58,1.68,10.47,1.68c2.49-0.09,4.96-0.46,7.37-1.09c0,0,0.93,1.68,0.05,2.73L134.73,185.64z M132.73,178.48c-7.62,2-15.71-0.3-18-2.3s-3.25-3.47-0.93-3.18s3.13,0.69,5.37,1.07c2.45,0.47,4.95,0.59,7.43,0.38c1.69-0.18,3.36-0.49,5-0.91c1.23-0.36,2.61-0.67,2.61-0.67s3.58,4.28-1.53,5.61L132.73,178.48z"
    />
  </svg>`;case"xp_pelvis":return V` <svg
    id="xp_pelvis"
    hidden
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0"
    y="0"
    style="width:12rem; height:55rem;"
    viewBox="0 0 192 580"
    style="enable-background:new 0 0 192 580;"
    xml:space="preserve"
  >
    <path
      class="region"
      index="1"
      d="M46.54,260.5c-1.85,10-3.34,18.89-3.34,24.4c0,6.53,0.12,12.76,0.33,18.73h52.12c0.08-4.36,0.13-8.2,0.13-11.36c0-0.31,0.24-0.55,0.55-0.56c0.3,0,0.55,0.25,0.55,0.55c0,0,0,0.01,0,0.01c0,3.16,0,7,0.14,11.36h52.11c0.21-6,0.33-12.2,0.33-18.73c0-5.51-1.49-14.44-3.34-24.4H46.54z"
    />
    <path
      class="region"
      index="2"
      d="M144.75,253.21c-1.56-8.23-3.14-16.59-4.28-24.27H52.19c-1.14,7.68-2.73,16-4.28,24.27c-0.4,2.09-0.79,4.16-1.17,6.19h99.18C145.53,257.36,145.14,255.3,144.75,253.21z"
    />

    <path
      class="outline"
      d="M105.11,580c-1.35,0.05-2.65-0.49-3.58-1.47c-2.74-2.94-2.27-9.67-1.9-15.08c0.12-1.64,0.22-3.18,0.22-4.4c0-3.15-0.46-7.49-0.91-11.7s-0.91-8.61-0.91-11.81c0.13-3.57,0.49-7.13,1.06-10.65c0.85-5.42,1.34-10.9,1.47-16.39c0-0.22-3.5-28.91-3.5-44.6c-0.07-7.84,0.83-15.67,2.68-23.29c0.68-2.53,1.09-5.12,1.21-7.74c0-0.83-3.29-68.52-4.62-112.75C95,364.35,91.75,432,91.71,432.9c0.12,2.61,0.53,5.19,1.21,7.71c1.85,7.62,2.75,15.45,2.68,23.29c0,15.69-3.47,44.38-3.5,44.67c0.13,5.47,0.62,10.92,1.47,16.32c0.57,3.52,0.93,7.08,1.06,10.65c0,3.2-0.47,7.58-0.91,11.81s-0.91,8.55-0.91,11.7c0,1.22,0.1,2.76,0.22,4.4c0.37,5.41,0.84,12.14-1.9,15.08c-0.93,0.98-2.23,1.52-3.58,1.47c-8,0-27.59-5.28-27.59-15.07c0-2.92,2.54-6.59,5.49-10.85c3.94-5.71,8.85-12.81,8.85-20.19c0-5.2-2.62-14.69-5.66-25.68c-4.6-16.65-10.31-37.37-10.31-54.73c0-7.25,0.36-14.5,1.09-21.72c0.42-4.66,0.79-8.69,0.79-13.78c0-4.05-1.58-10.28-3.75-18.9C51.09,377.83,42.1,342.26,42.1,284.9c0-6.93,2.3-19.06,4.73-31.9c2.79-14.7,5.94-31.35,5.94-42.21c0-7.53-4.15-34.59-6.09-46.82c-0.24,8-0.79,20.4-1.23,30.06c-0.33,7.43-0.59,13.31-0.59,14.46c0,1.38-0.09,4.19-0.19,7.44c-0.13,4.3-0.28,9.18-0.28,12.31c0,3.63-1.5,10.44-3.23,18.33c-0.93,4.23-1.89,8.61-2.68,12.79c-0.07,0.4-0.26,1.33-0.52,2.62c-1.4,7-5.13,25.7-5,28.54c0.14,2.43,2,25.66,2.24,28.48c0.52,5.14,0.47,14-1.27,17.72c-2.73,5.73-12.43,8.39-16.78,8.48c-1.46,0.03-2.85-0.62-3.75-1.77c-4.26-5.06-3.2-20.36-2.31-27.54c-1.6,3.18-3.46,6.23-5.56,9.11c-0.85,1.26-2.51,1.69-3.86,1c-1.52-0.97-2.09-2.92-1.34-4.56c0.13-0.36,0.36-1,0.66-1.94c1.88-5.64,6.87-20.61,11.45-25c2.54-2.45,5.29-11.59,4-41.21c0-0.94-0.07-1.57-0.07-1.82c0.07-7.28,0.51-14.55,1.31-21.79c0.47-5,0.88-9.23,0.88-13c0-0.47,0-1.34,0-2.55c-0.51-41.6,1.09-93.55,11.63-104.84c1.3-1.37,2.72-2.61,4.25-3.71c10.15-7.41,26-10.78,36.43-13c4.85-1,9-1.93,9.84-2.71c2.11-2.07-0.3-15.81-1.18-19.6c-1.37-3.21-2.44-6.54-3.2-9.95c-0.23-1.08-0.39-2-0.49-2.64c-0.67,0.27-1.43,0.16-2-0.29c-0.97-0.74-1.73-1.71-2.22-2.83c-0.97-1.88-1.72-3.88-2.22-5.94l-0.23-0.88c-0.44-1.71-0.78-3.45-1-5.2c-0.3-1.81-0.37-3.65-0.21-5.48c0.04-0.74,0.27-1.47,0.66-2.1c0-0.27-0.11-0.75-0.18-1.32c-0.36-2.97-0.39-5.97-0.11-8.95c0.24-2.97,0.87-5.89,1.88-8.69c0.78-2.11,1.83-4.11,3.12-5.95c1.92-2.67,4.4-4.89,7.27-6.5C84.93,1.13,89.95,0,96.33,0s11.41,1.13,15.79,3.55c2.87,1.61,5.35,3.83,7.27,6.5c1.27,1.85,2.3,3.84,3.06,5.95c1.01,2.8,1.64,5.72,1.88,8.69c0.28,3,0.24,6.01-0.12,9c-0.07,0.57-0.14,1-0.18,1.32c0.39,0.64,0.61,1.36,0.66,2.1c0.16,1.83,0.09,3.67-0.21,5.48c-0.22,1.75-0.56,3.49-1,5.2l-0.23,0.88c-0.5,2.06-1.25,4.06-2.22,5.94c-0.49,1.12-1.25,2.09-2.22,2.83c-0.57,0.45-1.33,0.56-2,0.29c-0.1,0.64-0.26,1.56-0.49,2.64c-0.76,3.42-1.84,6.77-3.2,10c-0.84,3.64-3.28,17.48-1.16,19.55c0.81,0.78,5,1.68,9.84,2.71c10.46,2.23,26.28,5.6,36.43,13c1.53,1.1,2.95,2.34,4.25,3.71c10.54,11.29,12.14,63.24,11.63,104.84c0,1.21,0,2.08,0,2.55c0,3.78,0.41,8.06,0.88,13c0.8,7.24,1.24,14.51,1.31,21.79c0,0.25,0,0.88-0.07,1.82c-1.3,29.62,1.45,38.76,4,41.21c4.58,4.42,9.57,19.39,11.45,25c0.3,0.91,0.53,1.58,0.66,1.94l0,0c0.71,1.61,0.15,3.5-1.31,4.47c-1.35,0.69-3.01,0.26-3.86-1c-2.11-2.86-3.98-5.89-5.59-9.06c0.89,7.18,1.95,22.48-2.31,27.54c-0.9,1.14-2.29,1.8-3.75,1.77c-4.35-0.09-14.05-2.75-16.78-8.48c-1.74-3.69-1.79-12.58-1.27-17.72c0.29-2.82,2.1-26.05,2.24-28.48c0.17-2.84-3.56-21.51-5-28.54c-0.26-1.29-0.45-2.22-0.52-2.62c-0.79-4.18-1.75-8.56-2.68-12.79c-1.73-7.89-3.23-14.7-3.23-18.33c0-3.13-0.15-8-0.28-12.31c-0.1-3.25-0.19-6.06-0.19-7.44c0-1.15-0.26-7-0.59-14.46c-0.43-9.66-1-22-1.23-30.06c-1.94,12.23-6.09,39.29-6.09,46.82c0,10.86,3.15,27.51,5.94,42.21c2.43,12.84,4.73,25,4.73,31.9c0,57.36-9,92.93-14.35,114.18c-2.18,8.62-3.76,14.85-3.76,18.9c0,5.09,0.37,9.12,0.79,13.78c0.72,7.21,1.08,14.46,1.08,21.71c0,17.36-5.72,38.08-10.32,54.73c-3,11-5.66,20.48-5.66,25.68c0,7.38,4.91,14.48,8.85,20.19c3,4.26,5.49,7.93,5.49,10.85C132.7,574.72,113.12,580,105.11,580zM96.33,291.71c0.3,0,0.55,0.25,0.55,0.55c0,0,0,0.01,0,0.01c0,33,5.12,139.5,5.17,140.57c-0.11,2.7-0.53,5.39-1.23,8c-1.83,7.53-2.72,15.25-2.65,23c0,15.62,3.45,44.25,3.49,44.53c-0.12,5.57-0.62,11.13-1.48,16.63c-0.55,3.48-0.88,6.98-1,10.5c0,3.14,0.46,7.49,0.9,11.69s0.92,8.62,0.92,11.82c0,1.26-0.11,2.82-0.23,4.47c-0.36,5.2-0.8,11.67,1.6,14.25c0.72,0.77,1.73,1.18,2.78,1.13c8.09,0,26.48-5.28,26.48-14c0-2.57-2.45-6.12-5.29-10.23c-4-5.83-9-13.09-9-20.81c0-5.35,2.64-14.91,5.7-26c4.59-16.58,10.29-37.22,10.29-54.43c0-7.22-0.36-14.44-1.09-21.62c-0.4-4.49-0.79-8.74-0.79-13.88c0-4.19,1.59-10.48,3.78-19.17c5.36-21.2,14.32-56.69,14.32-113.91c0-6.82-2.28-18.91-4.71-31.7c-2.93-15.46-5.95-31.45-5.95-42.41c0-9.86,6.78-51.29,7.07-53c0.02-0.3,0.29-0.53,0.6-0.51s0.53,0.29,0.51,0.6c0,5.93,0.78,23.4,1.35,36.15c0.33,7.45,0.6,13.33,0.6,14.51c0,1.36,0.09,4.16,0.19,7.41c0.13,4.31,0.28,9.19,0.28,12.34c0,3.51,1.55,10.59,3.2,18.09c0.93,4.24,1.89,8.63,2.68,12.83c0.08,0.39,0.26,1.32,0.52,2.61c2.4,12,5.14,26.17,5,28.81c-0.14,2.44-1.95,25.7-2.24,28.53c-0.5,4.87-0.47,13.68,1.17,17.13c2.4,5.06,11.43,7.76,15.81,7.85c1.12,0.04,2.2-0.47,2.87-1.37c4.87-5.78,2.16-26.91,1.59-29.9c-0.06-0.27,0.1-0.54,0.36-0.63c0.26-0.08,0.55,0.03,0.67,0.28c0.05,0.09,4.3,8.55,7,11.77c0.51,0.84,1.58,1.15,2.46,0.71c1-0.71,1.34-2.03,0.82-3.13l0,0c-0.13-0.36-0.36-1.05-0.67-2c-1.85-5.57-6.78-20.35-11.17-24.59c-3.93-3.79-5.38-17.94-4.32-42.05c0-0.91,0.07-1.53,0.07-1.77c0-8.14-0.7-15.33-1.31-21.68c-0.47-5-0.89-9.28-0.89-13.12c0-0.47,0-1.34,0-2.57c0.72-58.51-3.31-95.47-11.34-104.06c-1.25-1.32-2.62-2.52-4.09-3.58c-10-7.27-25.64-10.61-36-12.82c-6.14-1.31-9.39-2-10.38-3c-3-3,0.86-20.67,0.94-20.82c1.33-3.13,2.37-6.38,3.11-9.7c0.42-2,0.6-3.43,0.6-3.45c0.03-0.21,0.17-0.39,0.38-0.46c0.2-0.06,0.42,0,0.57,0.15c0.3,0.42,0.88,0.51,1.3,0.22c0.03-0.02,0.06-0.05,0.09-0.08c0.82-0.63,1.46-1.46,1.85-2.42c0.93-1.81,1.65-3.72,2.13-5.7l0.23-0.89c0.44-1.67,0.77-3.37,1-5.08c0.28-1.71,0.35-3.45,0.21-5.18c-0.17-1.27-0.45-1.59-0.55-1.7c-0.11-0.13-0.16-0.3-0.15-0.47c0,0,0.1-0.65,0.21-1.52c0.36-2.89,0.4-5.82,0.12-8.72c-0.23-2.89-0.85-5.73-1.83-8.45c-0.73-2-1.72-3.9-2.93-5.65c-1.82-2.54-4.18-4.64-6.9-6.17c-4.34-2.26-9.15-3.35-15.34-3.35s-11,1.09-15.25,3.42c-2.72,1.53-5.08,3.63-6.9,6.17c-1.21,1.75-2.2,3.65-2.93,5.65c-0.98,2.72-1.6,5.56-1.83,8.45c-0.28,2.9-0.24,5.83,0.12,8.72c0.11,0.87,0.2,1.52,0.21,1.52c0.02,0.16-0.03,0.32-0.13,0.44c-0.12,0.14-0.4,0.46-0.57,1.73c-0.14,1.73-0.07,3.47,0.21,5.18c0.23,1.71,0.56,3.41,1,5.08l0.23,0.89c0.48,1.98,1.2,3.89,2.13,5.7c0.39,0.96,1.03,1.79,1.85,2.42c0.38,0.35,0.96,0.33,1.31-0.05c0.03-0.03,0.05-0.06,0.08-0.09c0.15-0.15,0.37-0.21,0.57-0.15c0.21,0.07,0.35,0.25,0.38,0.46c0,0,0.18,1.49,0.6,3.45c0.75,3.33,1.79,6.59,3.13,9.73c0.06,0.12,4,17.82,0.92,20.79c-1,1-4.24,1.69-10.38,3c-10.37,2.21-26,5.55-36,12.82c-1.47,1.06-2.84,2.25-4.08,3.57c-8,8.59-12.06,45.55-11.34,104.06c0,1.23,0,2.1,0,2.57c0,3.84-0.42,8.14-0.89,13.12c-0.61,6.35-1.31,13.54-1.31,21.68c0,0.24,0,0.86,0.07,1.77c1.06,24.11-0.39,38.26-4.32,42.05c-4.39,4.24-9.32,19-11.17,24.59c-0.31,0.92-0.54,1.61-0.67,2c-0.53,1.12-0.17,2.46,0.85,3.16c0.88,0.44,1.95,0.13,2.46-0.71c2.68-3.22,6.94-11.68,7-11.77c0.12-0.25,0.41-0.36,0.67-0.28c0.26,0.09,0.42,0.36,0.36,0.63c-0.57,3-3.28,24.12,1.59,29.9c0.68,0.9,1.75,1.41,2.87,1.37c4.38-0.09,13.41-2.79,15.81-7.85c1.64-3.45,1.67-12.26,1.17-17.13c-0.29-2.83-2.1-26.09-2.24-28.53c-0.16-2.64,2.58-16.78,5-28.81c0.26-1.29,0.44-2.22,0.52-2.61c0.79-4.2,1.75-8.59,2.68-12.83c1.65-7.5,3.2-14.58,3.2-18.09c0-3.15,0.15-8,0.28-12.34c0.11-3.25,0.19-6.05,0.19-7.41c0-1.18,0.27-7.06,0.6-14.51c0.57-12.75,1.35-30.22,1.35-36.15c-0.02-0.3,0.2-0.57,0.51-0.6c0.3-0.02,0.57,0.2,0.59,0.51c0.29,1.76,7.07,43.19,7.07,53c0,11-3,27-6,42.41c-2.43,12.79-4.71,24.88-4.71,31.7c0,57.22,9,92.71,14.32,113.91c2.2,8.69,3.82,14.98,3.82,19.19c0,5.14-0.39,9.39-0.79,13.88c-0.73,7.18-1.09,14.4-1.09,21.62c0,17.21,5.7,37.85,10.29,54.43c3.06,11.07,5.7,20.63,5.7,26c0,7.72-5,15-9,20.81c-2.84,4.11-5.29,7.66-5.29,10.23c0,8.69,18.39,14,26.48,14c1.03,0.01,2.01-0.43,2.7-1.2c2.4-2.58,2-9,1.6-14.25c-0.12-1.65-0.23-3.21-0.23-4.47c0-3.2,0.47-7.58,0.92-11.82s0.9-8.55,0.9-11.69c-0.12-3.52-0.45-7.02-1-10.5c-0.86-5.47-1.36-11-1.48-16.54c0-0.35,3.49-29,3.49-44.6c0.07-7.75-0.82-15.47-2.65-23c-0.7-2.61-1.12-5.3-1.23-8c0-1.1,5.17-107.61,5.17-140.6C95.8,292,96.02,291.73,96.33,291.71C96.33,291.71,96.33,291.71,96.33,291.71z"
    />
    <path
      class="bone"
      disabled
      d="M71.65,205c2.93-2.09,8-5.4,9.94-7.62c1.64-1.98,3.16-4.07,4.54-6.24c1.3-1.93,1.85-3.3,0.79-3.92s-2.7,1.07-3.74,2.1s-3.66,4.67-5.93,6.82c-2.06,2-7.07,5.12-10.46,8s-5.87,5.67-5.33,7.36C62.27,214,68.75,207.07,71.65,205z"
    />
    <path
      class="bone"
      disabled
      d="M121.25,205c-2.93-2.09-8-5.4-10-7.62c-1.64-1.98-3.15-4.07-4.53-6.24c-1.31-1.93-1.86-3.3-0.8-3.92s2.71,1.07,3.74,2.1s3.67,4.67,5.93,6.82c2.06,2,7.08,5.12,10.46,8c3.38,2.88,5.87,5.67,5.34,7.36C130.62,214,124.14,207.07,121.25,205z"
    />
    <path
      class="bone"
      disabled
      d="M82.56,111.91c1.73,1.94,6,0.39,6.64-2.07c0.4-1.65-0.17-2.51-1.9-3.21c-15-6-22.78-5.63-35.38-3.5c-4.05,0.69-5.87,1.41-6.1,2.08s0.78,0.88,1.32,2c0.41,0.82-0.25,1.76,0.2,2.3s4.12-0.89,7.65-1.36C63.84,106.91,78.33,107.15,82.56,111.91z"
    />
    <path
      class="bone"
      disabled
      d="M110.09,111.91c-1.72,1.94-6,0.39-6.64-2.07c-0.4-1.65,0.18-2.51,1.9-3.21c15-6,22.78-5.63,35.38-3.5c4.06,0.69,5.87,1.41,6.1,2.08s-0.77,0.88-1.31,2c-0.41,0.82,0.24,1.76-0.21,2.3s-4.12-0.89-7.65-1.36C128.81,106.91,114.33,107.15,110.09,111.91z"
    />
    <path
      class="bone"
      disabled
      d="M86.05,104.07c1.3-0.06,2.42-2.73,0-3.32c-3.44,0-6.88,0.28-10.27,0.86c3.24,0.63,6.44,1.46,9.58,2.49L86.05,104.07z"
    />
    <path
      class="bone"
      disabled
      d="M106.6,104.07h0.66c3.14-1.03,6.34-1.86,9.58-2.49c-3.39-0.58-6.82-0.86-10.26-0.86C104.18,101.34,105.33,104,106.6,104.07z"
    />
    <path
      class="bone"
      disabled
      d="M5.42,316.19c-0.23-0.25-0.27,0.18-0.34,0.4C5,317.06,4.96,317.53,4.97,318c-0.06,0.43-0.22,0.84-0.48,1.19c-0.29,0.32-0.46,0.74-0.47,1.18c0,0.4,0.32,0.73,0.68,0.48c0.28-0.25,0.5-0.55,0.65-0.89c0.22-0.39,0.38-0.83,0.62-1.21s0.57-0.44,0.9-0.67s0.63-0.51,0.39-0.63C6.55,317.2,5.91,316.77,5.42,316.19z"
    />
    <path
      class="bone"
      disabled
      d="M22.23,317.35c0.22-0.09,0.38-0.27,0.44-0.5c0.11-0.55,0.09-1.12-0.07-1.66c-0.66-2.67-0.51-5.47,0.43-8.06c0.23-0.63,0.31-1.12,0.52-1.76c0.15-0.4,0.15-0.84,0-1.24c-0.4-0.83-1.14-0.73-1.77-0.5c-0.3,0.14-0.57,0.34-0.78,0.6c-0.51,0.81-0.64,1.8-0.36,2.71c0.2,1.2,0.15,2.42-0.13,3.6c-0.15,1.13-0.38,2.25-0.67,3.35c-0.29,0.9-1,2.1-0.55,3.05l0,0C20.11,317.63,21.25,317.79,22.23,317.35z"
    />
    <path
      class="bone"
      disabled
      d="M15.66,300c-0.29-0.35-0.53-0.78-0.83-1.13c-0.52-0.61-0.93-1.05-1.44-0.25c-0.42,0.91-0.77,1.84-1.06,2.8c-0.42,0.95-0.96,1.85-1.61,2.66c-0.56,0.64-1.42,1-1.76,1.83c-0.08,0.18-0.14,0.36-0.17,0.55c-0.01,0.07-0.01,0.15,0,0.22c0.39,0.67,0.97,1.21,1.67,1.55c0.67,0.35,1.47,0.35,2.14,0c0.06-0.08,0.1-0.16,0.13-0.25c0.12-0.47,0.17-0.95,0.16-1.43c0.05-0.55,0.18-1.1,0.39-1.61c0.35-1.05,0.94-2,1.72-2.78c0.4-0.33,1.56-0.47,1.43-1.18C16.33,300.59,15.89,300.23,15.66,300z"
    />
    <path
      class="bone"
      disabled
      d="M9.56,308.81c-0.7-0.33-0.79-0.78-1.23-1.15c-0.44-0.37-0.51,0.48-0.55,0.7c-0.18,1.67-0.52,3.31-1,4.92c-0.25,0.51-1.43,1.45-1.33,1.87s2,1.77,2.5,1.63c0.29-0.08,0.18-0.64,0.18-0.92c-0.05-0.87,0.13-1.74,0.53-2.52c0.33-0.8,0.83-1.52,1.46-2.12c0.54-0.42,1.32-0.73,1.41-1.61C11.58,308.89,10.45,309.23,9.56,308.81z"
    />
    <path
      class="bone"
      disabled
      d="M19,301.53c-1.22-0.27-2.21-0.17-2.45,1c-0.03,0.48-0.02,0.97,0.05,1.45c0.08,1.32-0.08,2.64-0.45,3.91c-0.3,1.32-0.34,2.72-0.73,4s-1.4,2.28-1.92,3.55c-0.16,0.35-0.18,0.75-0.06,1.12c0.11,0.3,0.37,0.53,0.69,0.59c0.74,0.18,1.51,0.26,2.27,0.25c0.28-0.01,0.54-0.13,0.72-0.34c0.21-0.27,0.35-0.59,0.38-0.93c0.04-0.69,0.02-1.38-0.07-2.06c-0.06-0.84-0.06-1.68,0-2.52c0.12-1.75,0.61-3.46,1.45-5c0.29-0.65,0.63-1.28,1-1.88c0.37-0.43,0.63-0.94,0.78-1.49C20.88,302.05,19.97,301.74,19,301.53z"
    />
    <path
      class="bone"
      disabled
      d="M28.12,316c0.31-0.26,0.43-0.68,0.31-1.07c-0.2-0.47-0.43-0.92-0.69-1.36c-0.34-1.01-0.5-2.07-0.46-3.13c-0.06-0.8-0.28-2.67-0.29-3.45c0-1,0.55-2.34,0.21-3.34s-2-1-2.72-0.5c-0.93,0.66-0.13,1.67,0.19,2.5c0.13,0.52,0.22,1.04,0.29,1.57c0.41,1.98,0.44,4.01,0.1,6c-0.09,0.51-0.1,1.03-0.05,1.54c0.06,0.52,0.39,0.98,0.86,1.22c0.46,0.26,0.99,0.37,1.51,0.32C27.65,316.27,27.9,316.16,28.12,316z"
    />
    <path
      class="bone"
      disabled
      d="M33.26,321.56c-0.72,0.37-1.54,0.47-2.32,0.3c-0.2-0.07-0.32-0.28-0.28-0.49c0.1-0.45,0.41-0.94,0.45-1.36c0.02-0.69-0.14-1.38-0.45-2c-0.34-0.6-0.65-1.22-0.93-1.85c-0.12-0.39-0.14-0.78,0.1-0.75c0.46,0.19,0.94,0.33,1.43,0.4l0,0c0.42-0.1,0.83-0.24,1.22-0.43c0.17,0,0.11,0.6,0.07,0.84c-0.09,0.39-0.12,0.78-0.1,1.18c0.03,0.51,0.08,1.02,0.17,1.53c0.06,0.3,0.17,0.59,0.32,0.86C33.27,320.37,33.75,321.4,33.26,321.56z"
    />
    <path
      class="bone"
      disabled
      d="M33.33,326.61c0.42-0.18,0-0.81-0.14-1.09c-0.27-0.32-0.44-0.72-0.47-1.14c0-0.44,0.29-0.83,0.21-1.28s-0.55-0.52-0.92-0.38c-0.37,0.14-1.13-0.17-1.34,0s0.2,0.85,0.34,1.13c0.18,0.39,0.28,0.82,0.28,1.26c-0.04,0.41-0.04,0.83,0,1.24c0.01,0.07,0.04,0.14,0.09,0.19C31.98,326.88,32.71,326.91,33.33,326.61z"
    />
    <path
      class="bone"
      disabled
      d="M28.33,326.16c0.18-0.09,0.29-0.27,0.28-0.47c-0.11-0.57-0.29-1.13-0.54-1.65c-0.28-1.03-0.42-2.09-0.39-3.16c0.17-0.9,0.38-1.79,0.64-2.67c0.16-0.9-0.42-1-1.19-1h-0.8c-0.62,0-1.53-0.25-1.74,0.58s0.36,2,0.72,2.76c0.47,0.82,0.65,1.78,0.51,2.71c-0.31,0.84-0.51,1.72-0.62,2.61c0.01,0.19,0.15,0.35,0.33,0.39C26.45,326.52,27.43,326.49,28.33,326.16z"
    />
    <path
      class="bone"
      disabled
      d="M27.94,327.49c-0.17,0-0.6,0.19-0.92,0.2h-0.09c-0.44-0.02-0.87-0.1-1.29-0.22c-0.09-0.01-0.17,0.02-0.24,0.07c-0.69,0.42-0.15,1.09,0.2,1.76c0.36,0.77,0.47,1.64,0.3,2.47c-0.2,0.73-0.26,1.48-0.17,2.23c0.19,0.61,1.07,0.5,1.55,0.56s1.12,0.33,1.2-0.32s-0.55-1.43-0.56-2.11s-0.18-1.29-0.21-2s0.51-1.18,0.52-1.81C28.24,327.92,28.12,327.54,27.94,327.49z"
    />
    <path
      class="bone"
      disabled
      d="M15.94,327.28c0.21-0.24,0.34-0.53,0.39-0.84c0.18-0.9-0.42-1.79-0.53-2.7c-0.13-0.84,0-1.7,0.37-2.46c0.34-0.72,1.23-1.5,0.87-2.25c-0.21-0.59-0.84-0.91-1.44-0.73c-1.43,0.2-2.32-0.51-2.39,0.5c0.02,0.94,0.18,1.87,0.46,2.77c0.23,0.86,0.3,1.76,0.21,2.65c-0.07,0.5-0.19,0.99-0.36,1.46c-0.12,0.38-0.42,0.8-0.32,1.19c0.04,0.12,0.09,0.23,0.17,0.33C14.16,327.65,15.12,327.68,15.94,327.28z"
    />
    <path
      class="bone"
      disabled
      d="M15.6,335.2c-0.39,0.2-0.82,0.32-1.26,0.34c-0.18,0.01-0.36-0.01-0.54-0.06c-0.13,0-0.28-0.13-0.33-0.14s-0.1,0-0.12,0.07c-0.39,0.6,0.61,1.2,0.55,1.93s-0.08,1.87,0.84,1.82c0.38-0.06,0.69-0.32,0.82-0.68c0.11-0.42,0.01-0.88-0.27-1.21c-0.19-0.32-0.35-0.54-0.12-0.88c0.28-0.27,0.49-0.59,0.63-0.95C15.85,335.09,15.6,335.2,15.6,335.2z"
    />
    <path
      class="bone"
      disabled
      d="M14,334.76c0.61,0.05,1.22-0.13,1.7-0.51c0.05-0.39-0.02-0.79-0.21-1.14c-0.26-0.59-0.33-1.25-0.22-1.89c0.12-0.77,1.52-2.79,0.51-3c-0.65,0.05-1.29,0.15-1.92,0.29c-0.6,0-0.8,0.35-0.75,1s0.47,0.91,0.57,1.6c0.08,0.64,0.02,1.29-0.17,1.91l-0.07,0.22c-0.04,0.36-0.04,0.72,0,1.08l0,0C13.56,334.54,13.76,334.69,14,334.76z"
    />
    <path
      class="bone"
      disabled
      d="M20.11,335.73c0.67,0,1.34-0.03,2-0.11c0.1-0.05,0.18-0.13,0.24-0.23c0.25-0.52-0.1-1.52-0.17-2.06c-0.13-0.7-0.23-1.4-0.28-2.11c0-0.7,0.43-1.11,0.58-1.74s-0.06-0.92-0.7-0.83c-0.35,0.11-0.71,0.2-1.07,0.27c-0.39,0-0.7-0.23-1-0.15c-0.81,0.19-0.57,1-0.23,1.55c0.44,0.73,0.93,1.19,0.89,2.12c-0.02,0.77-0.2,1.52-0.54,2.21C19.83,334.65,19.24,335.64,20.11,335.73z"
    />
    <path
      class="bone"
      disabled
      d="M41.33,217.7c0.66-3.54-3.71-6.66-4.06-11.65s2.2-67.68,4.37-71.72c0.67-1.37,1.65-2.57,2.86-3.49c3.08-2.44,4.39-6.5,3.32-10.29c-1.16-4.36-4.21-6-7.59-6c-1.7-0.02-3.24,0.99-3.9,2.55c-1.17-0.33-3.46-0.2-3.8,2c-0.46,4.66-0.4,9.35,0.16,14c0.68,4.75-1.27,42.89-1.68,53.24c-0.36,9.16-1.48,17.08-4.08,20.65s-5.76,4.75-5.56,8.11c0.18,3.15,3.54,6.27,6.31,5.21c1.67-0.63,2-1.2,2.57-1.33c0.29-0.06,0.56-0.58,1.27,0.13c0.69,0.7,1.53,1.23,2.46,1.56C36.33,221.47,40.51,222.18,41.33,217.7z"
    />
    <path
      class="bone"
      disabled
      d="M22.17,337.68c0.16-0.37,0.55-0.81,0.18-1.19s-0.73,0-1.11,0h-0.28c-0.33,0-1,0-1.1,0.47s0.38,0.73,0.55,1c0.25,0.41,0.4,0.87,0.43,1.35c-0.06,0.47,0,0.96,0.18,1.4c0.23,0.35,0.53,0.69,0.95,0.58c0.43-0.14,0.71-0.55,0.69-1C22.63,339.42,21.79,338.57,22.17,337.68z"
    />
    <path
      class="bone"
      disabled
      d="M28.15,336.58c0.16-0.34,0.21-0.31,0.16-0.75s-0.62-0.44-1-0.23l-0.35-0.05c-0.3,0-0.85-0.06-1,0.34s0.34,0.67,0.49,0.94c0.23,0.37,0.36,0.79,0.38,1.23c-0.07,0.43-0.02,0.87,0.15,1.27c0.2,0.31,0.47,0.63,0.87,0.54c0.4-0.13,0.67-0.51,0.65-0.93C28.56,338.16,27.79,337.37,28.15,336.58z"
    />
    <path
      class="bone"
      disabled
      d="M33.63,327.39c-0.34-0.13-0.75,0.32-1,0.25l-0.42-0.2c-0.32-0.06-0.77-0.25-0.91,0.08s0.27,0.6,0.39,0.85c0.18,0.34,0.27,0.71,0.26,1.09c0,0.37-0.16,0.77,0,1.09c0.16,0.32,0.4,0.58,0.77,0.54c0.37-0.06,0.65-0.37,0.68-0.75c0-0.67-0.6-1.41-0.2-2.06C33.41,328,34.02,327.54,33.63,327.39z"
    />
    <path
      class="bone"
      disabled
      d="M22.71,319.85c0.1-0.8-0.35-1.15-1.14-1.39c-0.61-0.22-1.29-0.15-1.83,0.21c-0.73,0.45-0.35,1.21-0.16,1.85c0.26,0.84,0.38,1.72,0.34,2.6c-0.07,0.89-0.14,1.77-0.15,2.67c-0.03,0.24-0.09,0.47-0.16,0.7c0,0.68-0.12,1.4,0.7,1.53c0.79,0.11,1.59-0.17,2.13-0.75c0.42-0.64-0.11-1.32-0.25-2c-0.17-0.89-0.2-1.81-0.08-2.71C22.22,321.64,22.6,320.78,22.71,319.85z"
    />
    <path
      class="bone"
      disabled
      d="M32.39,314.47c0.67-0.86,0.09-2-0.33-2.81c-0.48-0.91-0.8-1.91-0.93-2.93c-0.2-1.15-0.31-2.31-0.32-3.47c0.03-0.52,0.08-1.04,0.17-1.56c0.1-0.39,0.08-0.81-0.06-1.19c-0.44-0.85-1.86-0.61-2.52-0.28c-1.06,0.54-0.44,1.39,0,2.23c0.97,2.2,1.36,4.61,1.12,7c-0.17,1-0.39,2.17,0.31,3c0.61,0.71,1.67,0.79,2.38,0.19C32.28,314.59,32.34,314.53,32.39,314.47z"
    />
    <path
      class="bone"
      disabled
      d="M32.19,223.46c1.08,0.71,2.43,0.85,3.63,0.39c1.1-0.42,1.9-0.8,1.95,0.55c0.09,2.3-1.49,2.17-2,8.84s-1.57,20.13-1.34,25.18s-1.49,15.91-2.16,20.63c-0.67,4.72-1.33,5.71-1.27,7.86c0,0.94,0.15,3.34-0.35,4.48c-0.16,0.35-0.55,0.52-0.92,0.41c-0.28-0.08-0.64-0.18-1.07-0.28c-1.29-0.69-2.45-2-1.64-5.48c1.13-5.65,1.95-11.36,2.46-17.1c0.34-4-0.33-16.9-0.67-21.13l-0.68-13.42c-0.61,3.55-1.87,10.43-3.18,17.43s0,32.36,1,37.27c0.12,0.46,0.18,0.93,0.18,1.4c-0.02,0.3-0.28,0.53-0.58,0.51c-0.01,0-0.02,0-0.04,0c-0.84-0.1-1.68-0.1-2.52,0c-1.43,0.24-2.83,0.65-4.17,1.23c-0.54,0.22-1.15-0.04-1.37-0.58c-0.03-0.07-0.05-0.15-0.06-0.23c0-1.29,0.12-2.58,0.36-3.85c0.26-2.8,1.71-8.55,1.91-15.28s0.19-19.76,2.69-30.74c2-8.64,2.46-13.78,1-15.89s-1.08-3.21,1.28-2.78c0.91,0.4,1.94,0.4,2.85,0c0.8-0.39,1.67-0.63,2.56-0.7C30.67,222.28,31.33,222.92,32.19,223.46z"
    />
    <path
      class="bone"
      disabled
      d="M30.72,295.42c-0.09-0.49-0.38-0.93-0.8-1.2c-1.94-0.62-3.97-0.92-6-0.87c-1.23,0.17-2.43,0.48-3.58,0.93l-1,0.57c-0.72,0.58-1.53,1.06-2.39,1.41c-0.57,0.23-1.02,0.68-1.25,1.25c0,0.14,0.02,0.29,0.05,0.43c0,0,0,0,0,0.06c0.36,0.8,0.84,1.53,1.44,2.16c0.42,0.09,0.85,0.14,1.28,0.14c0.92-0.06,1.83,0.14,2.64,0.58c0.13,0.1,0.25,0.21,0.36,0.33c0.52,0.61,1.31,0.91,2.1,0.8c0.74-0.07,1.46-0.27,2.12-0.6c0.72-0.34,1.48-0.57,2.27-0.68c1-0.12,1.39,0.06,2.38-0.06s0.53-4.51,0.53-4.51C30.81,295.9,30.76,295.66,30.72,295.42z"
    />
    <path
      class="bone"
      disabled
      d="M87.23,571c-1.09-0.39-2.69-0.45-3.42,0.39c-0.14,0.25-0.21,0.53-0.2,0.82c0,0.58,0.73,0.83,0.86,1.36c0.18,0.77-0.67,1.18-0.79,1.86c-0.24,1.38,1.77,1.62,2.53,1.14c0.56-0.37,0.47-1,0.73-1.54s0.65-0.63,1-1.11c0.63-0.9,0.41-2.15-0.49-2.79C87.38,571.08,87.31,571.04,87.23,571z"
    />
    <path
      class="bone"
      disabled
      d="M79.26,548.15c-0.71,0.4-0.43,1.17-0.51,1.9c-0.23,1.72-0.59,3.42-1.09,5.09c-0.09,0.29-0.2,0.58-0.33,0.86c-0.34,0.62-0.12,1.4,0.5,1.74c0.21,0.12,0.44,0.17,0.68,0.16c0.39,0,0.77-0.11,1.09-0.32c0.6-0.33,0.66-0.7,0.57-1.37c-0.42-3.2,1.4-6.72,1-7.39c-0.28-0.69-1.07-1.02-1.76-0.74C79.36,548.1,79.31,548.12,79.26,548.15z"
    />
    <path
      class="bone"
      disabled
      d="M71.04,564.15c-0.06-0.07-0.27-0.19-0.31-0.1c-0.42,0.81,0.09,1.55-0.41,2.41c-0.28,0.64-0.6,1.26-0.95,1.86c-0.22,0.29-0.46,0.35-0.53,0.77s0.08,0.8,0,1.19s-0.3,0.68-0.07,1s0.52,0.26,0.73,0c0.5-0.63,0.09-1.36,1.06-1.63c0.08-0.4,0-0.79,0-1.18c0.14-0.32,0.3-0.62,0.49-0.91c0.28-0.55,0.39-1.23,1-1.45c0.41-0.15,0.67,0,0.95-0.4s0.1-0.57-0.21-0.88c-0.22-0.15-0.49-0.23-0.76-0.24c-0.5,0-0.77,0.06-0.88-0.19S71.17,564.31,71.04,564.15z"
    />
    <path
      class="bone"
      disabled
      d="M68.8,563.15c-0.37-0.57-0.64,0-1.25-0.27c0,0,0-0.17-0.06-0.22s-0.31-0.3-0.39-0.27c-0.85,0.26,0.18,1.37-0.31,2.16c-0.3,0.57-0.63,1.11-1,1.64c-0.21,0.26-0.43,0.3-0.51,0.67s0,0.73,0,1.09s-0.3,0.6-0.1,0.93s0.46,0.26,0.66,0c0.48-0.56,0.14-1.24,1-1.43c0.1-0.37,0-0.73,0.1-1.08c0.14-0.28,0.3-0.55,0.49-0.8c0.27-0.49,0.41-1.11,1-1.28c0.37-0.12,0.38,0.14,0.54-0.31C69.07,563.69,69.01,563.37,68.8,563.15z"
    />
    <path
      class="bone"
      disabled
      d="M65.42,562.8c-0.37,0.1-0.47,0.51-0.67,0.84c-0.13,0.16-0.25,0.34-0.35,0.52c-0.08,0.24,0,0.48-0.09,0.72c-0.6,0.11-0.39,0.58-0.73,1c-0.14,0.15-0.31,0.19-0.44,0s0-0.43,0.09-0.63s0-0.5,0-0.73s0.21-0.27,0.36-0.44c0.25-0.35,0.47-0.71,0.68-1.08c0.35-0.52-0.35-1.23,0.22-1.39c0.09,0,0.18,0.05,0.24,0.12c0.04,0.09,0.09,0.17,0.15,0.25c0.32,0.25,0.67-0.06,1,0.28C65.96,562.18,66.22,562.6,65.42,562.8z"
    />
    <path
      class="bone"
      disabled
      d="M74.7,571.63c0.2-0.86,0.25-1.75,0.14-2.63c0.02-0.32,0.19-0.62,0.46-0.79c0.37-0.27,0.81-0.42,1.27-0.44c0.3,0.07,0.58,0.21,0.82,0.4c0.3,0.24,0.44,0.63,0.36,1c-0.08,0.29-0.18,0.57-0.3,0.84c-0.46,1.16-0.58,2.42-1,3.61c-0.2,0.55-1.75,1.14-2.17,0.14C73.91,572.91,74.33,572.34,74.7,571.63z"
    />
    <path
      class="bone"
      disabled
      d="M85.33,536.23c1.59,0.13,3.33,1.07,3.53,2.69c0.28,1.46,1.08,2.77,2.26,3.68c0.79,0.7,1.23,1.71,1.21,2.77c0.06,1.81,0.09,5.29-1.69,5.23c-1.1-0.15-2.1-0.75-2.74-1.66c-0.93-1.05-2.66-1.35-4.89-1.19c-1.64,0.11-3.14-1.35-5.06-1.19s-2.39,1-3.72,1.41s-1.86-1.05-0.86-2c0.93-0.71,1.92-1.33,2.96-1.88c2.81-1.58,2-4.63,2.4-5.76C79.26,536.74,83.43,536.08,85.33,536.23z"
    />
    <path
      class="bone"
      disabled
      d="M88.61,563.65c0.74,1.13,1.55,2.89,0.15,2.81c-0.59-0.86-1.34-1.6-2.21-2.17c-1-0.43-2,0.51-3,1.63c-0.29,0.1-0.35-0.08-0.46-0.36c-0.43-1.12,0.36-2.78,0.45-3.91c0.12-1.51-0.54-2.54-1-3.92c-0.46-1.54,0.09-2.1,0.09-2.1s1.88-2,3.66-1.63c0.44,0.1,0.84,0.34,1.14,0.68c0.59,0.59,0.94,1.37,1,2.2c0.05,1.01-0.03,2.01-0.23,3C87.96,561.37,87.79,562.4,88.61,563.65z"
    />
    <path
      class="bone"
      disabled
      d="M82.38,554.35c0.05,0.07,0.15,0.09,0.22,0.04c0.01-0.01,0.03-0.02,0.04-0.04c0.68-0.83,1.63-1.38,2.69-1.55c1.28-0.15,3.24,1.3,3.53,1.67s0.43-0.44,0.37-0.9c-0.21-1.5-1.22-3.51-2.35-4.09c-1.17-0.54-2.51-0.6-3.72-0.15c-0.59,0.25-1.07,0.71-1.33,1.3c-0.3,0.62-0.37,1.33-0.19,2C81.79,553.24,82.04,553.82,82.38,554.35z"
    />
    <path
      class="bone"
      disabled
      d="M74.33,556.18c-0.32-0.23,2-7.83,2-7.83c0.13-0.17,0.32-0.28,0.53-0.32c1.48-0.39,1.21,0.1,1.21,0.1c-1.29,2.44-1.53,7.33-1.87,7.89C76.25,556,75.72,557.13,74.33,556.18z"
    />
    <path
      class="bone"
      disabled
      d="M71.25,552.31c0.29-0.81,0.64-1.57,0.94-2.38l0.13-0.13c0.11,0,0.74-0.32,0.61,0.07s-0.88,2.5-0.88,2.5c-0.37,0.88-0.66,1.68-0.76,1.79s-0.59,0.28-0.7,0C70.33,553.53,71.06,552.84,71.25,552.31z"
    />
    <path
      class="bone"
      disabled
      d="M74.97,549.58c-0.15,0.36-1.79,5.79-1.86,6s-0.54,0-0.74-0.24c-0.6-0.66,0.21-1.43,0.33-2.15v-0.16c0,0,1-3.17,1-3.37S75.11,549.21,74.97,549.58z"
    />
    <path
      class="bone"
      disabled
      d="M76.8,564.52c-0.31,0.04-0.62,0.11-0.91,0.21c-0.1,0.04-0.21-0.01-0.24-0.11c0-0.01,0-0.01-0.01-0.02c-0.28-1.08,0.87-2,1-3.25s-0.45-2.77,1.33-2.38c0.41-0.01,0.82,0.01,1.23,0.06c0.36,0.13,0.58,0.26,0.55,0.65l-0.42,5.24c0,0-0.06,0.38-0.78,0.07l-0.54-0.25C77.64,564.55,77.22,564.48,76.8,564.52z"
    />
    <path
      class="bone"
      disabled
      d="M71.74,562.6c0.09-0.41,0.25-0.8,0.46-1.17c0.1-0.4,0.29-0.77,0.57-1.08c0.27-0.39,0.51-0.81,0.71-1.24c0.2-0.42,0.09-1.19,0.51-1.36c0.49-0.09,1-0.01,1.45,0.22c0.13,0.33-0.24,0.85-0.45,1.32c-0.42,1-1,1.91-1.41,2.89s-0.39,1.43-0.78,1.44l-0.82-0.46C71.85,563,71.76,562.81,71.74,562.6z"
    />
    <path
      class="bone"
      disabled
      d="M75.08,566.21c0,0-0.41,0.35-0.35,0.61s0.45,0.31,0.45,0.31c0.45-0.27,0.98-0.39,1.5-0.36c0.57,0.16,1.1,0.43,1.55,0.81c0.34,0.23,0.52-0.27,0.51-0.81c-0.01-0.43-0.26-0.82-0.65-1c-0.21-0.1-0.44-0.17-0.67-0.21c-0.83,0-1.64,0.24-2.34,0.69"
    />
    <path
      class="bone"
      disabled
      d="M72.38,557.33c-0.32,0.93-1,1.36-1.55,2.12c-0.28,0.39-0.51,0.81-0.67,1.26c-0.15,0.43-0.43,1.28-0.68,1.34s-1.49-0.13-1.5-0.38s3.18-5,3.45-5.31S72.62,556.61,72.38,557.33z"
    />
    <path
      class="bone"
      disabled
      d="M66.69,561.21c-0.2,0-1.48-0.21-1.55-0.53s1.49-2.06,2.5-2.86s1.12-2,2.13-2.48c0.42-0.2,1.12,0.07,0.83,0.54s-3.51,5-3.51,5C66.97,561,66.83,561.11,66.69,561.21z"
    />
    <path
      class="bone"
      disabled
      d="M87.14,569.82c0,0,0.22,0,0.26,0s1.59-0.49,1.28-1.63s-2.06-2.77-2.57-2.64c0,0-0.66-0.15-1.83,1.3c-0.35,0.42-0.58,0.93-0.66,1.47c-0.05,0.41,0.17,0.81,0.54,1c0.39-0.06,0.78-0.09,1.17-0.1c0.54,0.11,1.05,0.33,1.5,0.66C86.94,569.9,87.05,569.88,87.14,569.82z"
    />
    <path
      class="bone"
      disabled
      d="M187.26,316.19c0.23-0.25,0.27,0.18,0.34,0.4c0.07,0.46,0.11,0.92,0.1,1.39c0.06,0.43,0.23,0.84,0.49,1.19c0.29,0.32,0.46,0.74,0.46,1.18c0,0.4-0.31,0.73-0.67,0.48c-0.28-0.25-0.5-0.55-0.65-0.89c-0.22-0.39-0.39-0.83-0.62-1.21s-0.57-0.44-0.91-0.67s-0.62-0.51-0.38-0.63C186.13,317.18,186.77,316.76,187.26,316.19z"
    />
    <path
      class="bone"
      disabled
      d="M170.44,317.35c-0.22-0.09-0.38-0.27-0.44-0.5c-0.1-0.55-0.08-1.12,0.08-1.66c0.65-2.67,0.5-5.47-0.43-8.06c-0.24-0.63-0.32-1.12-0.53-1.76c-0.16-0.4-0.16-0.84,0-1.24c0.4-0.83,1.14-0.73,1.76-0.5c0.31,0.14,0.58,0.34,0.79,0.6c0.51,0.81,0.64,1.8,0.35,2.71c-0.19,1.2-0.14,2.42,0.14,3.6c0.15,1.13,0.38,2.25,0.67,3.35c0.29,0.9,1,2.1,0.55,3.05l0,0C172.56,317.63,171.42,317.79,170.44,317.35z"
    />
    <path
      class="bone"
      disabled
      d="M177.02,300c0.29-0.35,0.53-0.78,0.83-1.13c0.52-0.61,0.93-1.05,1.44-0.25c0.42,0.93,0.79,1.88,1.09,2.85c0.41,0.96,0.95,1.85,1.61,2.66c0.55,0.64,1.42,1,1.76,1.83c0.08,0.18,0.14,0.36,0.17,0.55c0.01,0.07,0.01,0.15,0,0.22c-0.39,0.67-0.97,1.21-1.67,1.55c-0.67,0.35-1.46,0.35-2.13,0c-0.06-0.08-0.1-0.16-0.14-0.25c-0.11-0.47-0.16-0.95-0.15-1.43c-0.05-0.55-0.18-1.1-0.39-1.61c-0.35-1.05-0.94-2-1.72-2.78c-0.4-0.33-1.56-0.47-1.44-1.18C176.33,300.59,176.79,300.23,177.02,300z"
    />
    <path
      class="bone"
      disabled
      d="M183.12,308.81c0.7-0.33,0.79-0.78,1.22-1.15s0.51,0.48,0.55,0.7c0.18,1.67,0.52,3.31,1,4.92c0.25,0.51,1.43,1.45,1.33,1.87s-2,1.77-2.5,1.63c-0.29-0.08-0.19-0.64-0.19-0.92c0.06-0.87-0.13-1.74-0.53-2.52c-0.33-0.8-0.82-1.52-1.45-2.12c-0.54-0.42-1.32-0.73-1.41-1.61C181.09,308.89,182.23,309.23,183.12,308.81z"
    />
    <path
      class="bone"
      disabled
      d="M173.67,301.53c1.23-0.27,2.21-0.17,2.46,1c0.03,0.48,0.02,0.97-0.05,1.45c-0.08,1.32,0.08,2.64,0.45,3.91c0.29,1.32,0.33,2.72,0.73,4s1.4,2.28,1.91,3.55c0.16,0.35,0.19,0.75,0.07,1.12c-0.11,0.31-0.38,0.53-0.7,0.59c-0.74,0.18-1.5,0.26-2.26,0.25c-0.28-0.01-0.55-0.13-0.73-0.34c-0.21-0.27-0.34-0.59-0.37-0.93c-0.04-0.69-0.02-1.38,0.06-2.06c0.07-0.84,0.07-1.68,0-2.52c-0.12-1.75-0.61-3.45-1.44-5c-0.3-0.64-0.63-1.27-1-1.88c-0.37-0.43-0.64-0.94-0.79-1.49C171.8,302.05,172.7,301.74,173.67,301.53z"
    />
    <path
      class="bone"
      disabled
      d="M164.56,316c-0.31-0.26-0.43-0.68-0.31-1.07c0.2-0.47,0.42-0.92,0.68-1.36c0.35-1.01,0.5-2.07,0.46-3.13c0.07-0.8,0.29-2.67,0.29-3.45c0-1-0.55-2.34-0.2-3.34s2-1,2.71-0.5c0.93,0.66,0.14,1.67-0.19,2.5c-0.12,0.52-0.22,1.04-0.28,1.57c-0.42,1.98-0.45,4.01-0.1,6c0.08,0.51,0.09,1.03,0.05,1.54c-0.07,0.52-0.39,0.98-0.86,1.22c-0.46,0.26-0.99,0.37-1.51,0.32C165.03,316.27,164.78,316.16,164.56,316z"
    />
    <path
      class="bone"
      disabled
      d="M159.42,321.56c0.72,0.37,1.54,0.47,2.32,0.3c0.2-0.07,0.32-0.28,0.28-0.49c-0.1-0.45-0.41-0.94-0.46-1.36c-0.01-0.69,0.14-1.38,0.45-2c0.35-0.6,0.66-1.21,0.94-1.85c0.11-0.39,0.14-0.78-0.1-0.75c-0.46,0.2-0.94,0.33-1.44,0.4l0,0c-0.42-0.09-0.83-0.24-1.22-0.43c-0.17,0-0.11,0.6-0.07,0.84c0.08,0.39,0.11,0.78,0.1,1.18c-0.03,0.51-0.09,1.02-0.18,1.53c-0.06,0.3-0.16,0.59-0.31,0.86C159.4,320.37,158.93,321.4,159.42,321.56z"
    />
    <path
      class="bone"
      disabled
      d="M159.33,326.61c-0.42-0.18-0.05-0.81,0.15-1.09c0.27-0.32,0.44-0.72,0.47-1.14c0-0.44-0.29-0.83-0.21-1.28s0.54-0.52,0.92-0.38s1.12-0.17,1.34,0s-0.2,0.85-0.35,1.13c-0.18,0.4-0.27,0.83-0.27,1.26c0.04,0.41,0.04,0.83,0,1.24c-0.02,0.07-0.05,0.13-0.09,0.19C160.69,326.88,159.96,326.91,159.33,326.61z"
    />
    <path
      class="bone"
      disabled
      d="M164.33,326.16c-0.18-0.09-0.29-0.27-0.28-0.47c0.1-0.57,0.28-1.13,0.53-1.65c0.28-1.03,0.42-2.09,0.39-3.16c-0.16-0.9-0.37-1.79-0.63-2.67c-0.16-0.9,0.42-1,1.19-1h0.8c0.62,0,1.52-0.25,1.74,0.58s-0.36,2-0.72,2.76c-0.47,0.82-0.65,1.77-0.51,2.71c0.31,0.84,0.51,1.72,0.62,2.61c-0.01,0.19-0.15,0.35-0.33,0.39C166.21,326.52,165.23,326.49,164.33,326.16z"
    />
    <path
      class="bone"
      disabled
      d="M164.73,327.49c0.18,0,0.61,0.19,0.93,0.2h0.08c0.44-0.02,0.87-0.1,1.29-0.22c0.09-0.01,0.18,0.02,0.25,0.07c0.69,0.42,0.15,1.09-0.21,1.76c-0.35,0.77-0.45,1.64-0.29,2.47c0.19,0.73,0.25,1.48,0.17,2.23c-0.19,0.61-1.08,0.5-1.55,0.56s-1.12,0.33-1.2-0.32s0.55-1.43,0.56-2.11s0.18-1.29,0.2-2s-0.5-1.18-0.51-1.81C164.44,327.92,164.56,327.54,164.73,327.49z"
    />
    <path
      class="bone"
      disabled
      d="M176.74,327.28c-0.21-0.24-0.34-0.53-0.39-0.84c-0.18-0.9,0.41-1.79,0.53-2.7c0.12-0.84-0.01-1.69-0.37-2.46c-0.34-0.72-1.24-1.5-0.87-2.25c0.21-0.58,0.84-0.9,1.43-0.73c1.43,0.2,2.33-0.51,2.4,0.5c-0.02,0.94-0.18,1.87-0.46,2.77c-0.23,0.86-0.3,1.76-0.21,2.65c0.06,0.5,0.18,0.99,0.35,1.46c0.13,0.38,0.43,0.8,0.32,1.19c-0.03,0.12-0.08,0.23-0.16,0.33C178.52,327.65,177.56,327.68,176.74,327.28z"
    />
    <path
      class="bone"
      disabled
      d="M177.08,335.2c0.39,0.2,0.82,0.32,1.26,0.34c0.18,0.01,0.36-0.01,0.54-0.06c0.13,0,0.27-0.13,0.33-0.14s0.09,0,0.12,0.07c0.39,0.6-0.61,1.2-0.56,1.93s0.09,1.87-0.83,1.82c-0.38-0.06-0.69-0.32-0.82-0.68c-0.11-0.42-0.02-0.87,0.26-1.21c0.19-0.32,0.36-0.54,0.13-0.88c-0.28-0.27-0.49-0.59-0.63-0.95C176.82,335.09,177.08,335.2,177.08,335.2z"
    />
    <path
      class="bone"
      disabled
      d="M178.68,334.76c-0.61,0.06-1.22-0.13-1.7-0.51c-0.05-0.39,0.02-0.79,0.21-1.14c0.25-0.6,0.33-1.25,0.22-1.89c-0.12-0.77-1.53-2.79-0.51-3c0.65,0.06,1.29,0.15,1.92,0.29c0.6,0,0.79,0.35,0.75,1s-0.48,0.91-0.58,1.6c-0.07,0.64-0.01,1.29,0.18,1.91l0.07,0.22c0.04,0.36,0.04,0.72,0,1.08l0,0C179.13,334.54,178.92,334.7,178.68,334.76z"
    />
    <path
      class="bone"
      disabled
      d="M172.57,335.73c-0.67,0-1.34-0.03-2-0.11c-0.1-0.05-0.18-0.13-0.24-0.23c-0.26-0.52,0.1-1.52,0.17-2.06c0.13-0.7,0.23-1.4,0.28-2.11c0-0.7-0.44-1.11-0.58-1.74s0.06-0.92,0.7-0.83c0.35,0.11,0.7,0.2,1.06,0.27c0.4,0,0.71-0.23,1-0.15c0.81,0.19,0.57,1,0.22,1.55c-0.44,0.73-0.92,1.19-0.88,2.12c0.01,0.77,0.2,1.52,0.54,2.21C172.84,334.65,173.44,335.64,172.57,335.73z"
    />
    <path
      class="bone"
      disabled
      d="M170.51,337.68c-0.16-0.37-0.55-0.81-0.19-1.19s0.73,0,1.12,0h0.28c0.33,0,1,0,1.1,0.47s-0.39,0.73-0.55,1c-0.25,0.41-0.4,0.87-0.44,1.35c0.06,0.47,0.01,0.96-0.17,1.4c-0.23,0.35-0.53,0.69-1,0.58c-0.43-0.14-0.7-0.55-0.68-1C170.05,339.42,170.89,338.57,170.51,337.68z"
    />
    <path
      class="bone"
      disabled
      d="M164.52,336.58c-0.15-0.34-0.21-0.31-0.16-0.75s0.62-0.44,1-0.23l0.35-0.05c0.3,0,0.84-0.06,1,0.34s-0.34,0.67-0.49,0.94c-0.23,0.37-0.36,0.79-0.39,1.23c0.07,0.43,0.02,0.87-0.14,1.27c-0.2,0.31-0.48,0.63-0.88,0.54c-0.4-0.13-0.66-0.51-0.64-0.93C164.12,338.16,164.89,337.37,164.52,336.58z"
    />
    <path
      class="bone"
      disabled
      d="M159.04,327.39c0.35-0.13,0.76,0.32,1,0.25l0.42-0.2c0.32-0.06,0.77-0.25,0.91,0.08s-0.27,0.6-0.39,0.85c-0.18,0.33-0.27,0.71-0.26,1.09c0,0.37,0.15,0.77,0,1.09s-0.4,0.58-0.78,0.54c-0.37-0.06-0.65-0.37-0.67-0.75c0-0.67,0.6-1.41,0.2-2.06C159.27,328,158.65,327.54,159.04,327.39z"
    />
    <path
      class="bone"
      disabled
      d="M169.96,319.85c-0.09-0.8,0.36-1.15,1.15-1.39c0.61-0.22,1.29-0.14,1.83,0.21c0.72,0.45,0.34,1.21,0.16,1.85c-0.27,0.84-0.39,1.72-0.34,2.6c0.07,0.89,0.13,1.77,0.15,2.67c0.03,0.24,0.08,0.47,0.15,0.7c0,0.68,0.13,1.4-0.7,1.53c-0.79,0.11-1.58-0.17-2.12-0.75c-0.42-0.64,0.1-1.32,0.25-2c0.17-0.89,0.2-1.81,0.07-2.71C170.45,321.64,170.07,320.78,169.96,319.85z"
    />
    <path
      class="bone"
      disabled
      d="M160.33,314.47c-0.66-0.86-0.08-2,0.34-2.81c0.48-0.91,0.8-1.91,0.93-2.93c0.2-1.15,0.3-2.31,0.31-3.47c-0.02-0.52-0.08-1.04-0.16-1.56c-0.1-0.39-0.08-0.81,0.06-1.19c0.43-0.85,1.86-0.61,2.52-0.28c1.06,0.54,0.44,1.39,0,2.23c-0.97,2.2-1.36,4.61-1.13,7c0.18,1,0.4,2.17-0.31,3c-0.61,0.71-1.67,0.79-2.38,0.19C160.44,314.59,160.39,314.53,160.33,314.47z"
    />
    <path
      class="bone"
      disabled
      d="M160.49,223.46c-1.08,0.71-2.43,0.86-3.64,0.39c-1.09-0.42-1.89-0.8-1.94,0.55c-0.09,2.3,1.49,2.17,2,8.84s1.57,20.13,1.34,25.18s1.48,15.91,2.16,20.63s1.33,5.71,1.26,7.86c0,0.94-0.15,3.34,0.36,4.48c0.16,0.34,0.55,0.52,0.91,0.41c0.28-0.08,0.65-0.18,1.08-0.28c1.29-0.69,2.45-2,1.64-5.48c-1.13-5.65-1.95-11.36-2.46-17.1c-0.35-4,0.32-16.9,0.66-21.13l0.68-13.42c0.62,3.55,1.88,10.43,3.19,17.43s0,32.36-1,37.27c-0.12,0.46-0.18,0.93-0.18,1.4c0.01,0.3,0.27,0.53,0.56,0.51c0.02,0,0.03,0,0.05,0c0.84-0.1,1.68-0.1,2.52,0c1.43,0.24,2.83,0.65,4.17,1.23c0.5,0.24,1.1,0.03,1.33-0.47c0.05-0.11,0.08-0.22,0.1-0.34c0-1.29-0.12-2.58-0.35-3.85c-0.26-2.8-1.72-8.55-1.91-15.28s-0.19-19.76-2.7-30.74c-2-8.64-2.45-13.78-1-15.89s1.08-3.21-1.28-2.78c-0.91,0.4-1.94,0.4-2.85,0c-0.8-0.39-1.67-0.63-2.56-0.7C162.01,222.28,161.33,222.92,160.49,223.46z"
    />
    <path
      class="bone"
      disabled
      d="M161.96,295.42c0.09-0.49,0.38-0.93,0.8-1.2c1.94-0.63,3.97-0.92,6-0.87c1.23,0.17,2.43,0.48,3.58,0.93l1,0.57c0.72,0.59,1.53,1.06,2.39,1.41c0.57,0.23,1.02,0.68,1.24,1.25c0.02,0.14,0.02,0.29,0,0.43c0,0,0,0,0,0.06c-0.36,0.8-0.84,1.53-1.44,2.16c-0.42,0.09-0.86,0.14-1.29,0.14c-0.92-0.06-1.83,0.14-2.64,0.58l-0.36,0.33c-0.51,0.61-1.3,0.91-2.09,0.8c-0.74-0.07-1.46-0.27-2.13-0.6c-0.71-0.34-1.48-0.57-2.26-0.68c-1-0.12-1.39,0.06-2.38-0.06s-0.53-4.51-0.53-4.51C161.87,295.9,161.91,295.66,161.96,295.42z"
    />
    <path
      class="bone"
      disabled
      d="M103.15,96.39c-0.78,0.17-2.09,0.82-2.11,0c0-0.49,1.07-1.44-0.9-1.61c0,0-1.63,0-3.81,0s-3.82,0-3.82,0c-2,0.17-0.88,1.12-0.89,1.61c0,0.83-1.33,0.18-2.12,0s-1.57,1.17,0,1.34s2.71,0.34,2.64,1.11c-0.08,1,1.94,1.21,4.19,1.21s4.26-0.24,4.18-1.21c-0.06-0.77,1.07-0.94,2.64-1.11S103.94,96.23,103.15,96.39z"
    />
    <path
      class="bone"
      disabled
      d="M103.67,184.82c-0.85,0.23-2.26,1.11-2.28,0c0-0.67,1.15-2-1-2.19c0,0-1.76-0.08-4.1-0.08s-4.11,0.08-4.11,0.08c-2.11,0.23-0.94,1.52-1,2.19c0,1.13-1.43,0.25-2.28,0c-0.5,0-0.91,0.41-0.91,0.91s0.41,0.91,0.91,0.91c1.69,0.23,2.92,0.46,2.85,1.52c-0.09,1.32,2.08,1.65,4.5,1.65s4.59-0.33,4.5-1.65c-0.07-1.06,1.15-1.29,2.84-1.52c0.5,0.02,0.93-0.37,0.95-0.87C104.56,185.27,104.17,184.84,103.67,184.82z"
    />
    <path
      class="bone"
      disabled
      d="M102.94,177.12c-0.76,0.21-2,1-2,0c0-0.6,1-1.76-0.87-2c0,0-1.58-0.07-3.69-0.07s-3.7,0.07-3.7,0.07c-1.9,0.21-0.85,1.37-0.86,2c0,1-1.29,0.23-2,0c-0.45,0-0.82,0.37-0.82,0.82c0,0.45,0.37,0.82,0.82,0.82c0,0,0,0,0,0c1.52,0.21,2.62,0.41,2.56,1.37c-0.08,1.18,1.87,1.48,4,1.48s4.13-0.3,4-1.48c-0.06-1,1-1.16,2.56-1.37c0.45,0,0.82-0.37,0.82-0.82C103.76,177.49,103.39,177.12,102.94,177.12z"
    />
    <path
      class="bone"
      disabled
      d="M102.11,85.6c-0.67,0.13-1.78,0.65-1.79,0c0-0.39,0.9-1.14-0.76-1.27c0,0-1.39,0-3.23,0s-3.23,0-3.23,0c-1.67,0.13-0.75,0.88-0.76,1.27c0,0.66-1.13,0.14-1.79,0s-1.34,0.93,0,1.06s2.29,0.27,2.23,0.88s1.64,1,3.55,1s3.61-0.2,3.54-1s0.91-0.75,2.24-0.88S102.77,85.47,102.11,85.6z"
    />
    <path
      class="bone"
      disabled
      d="M102.11,80.55c-0.67,0.13-1.78,0.64-1.79,0c0-0.39,0.9-1.14-0.76-1.27c0,0-1.39,0-3.23,0s-3.23,0-3.23,0c-1.67,0.13-0.75,0.88-0.76,1.27c0,0.65-1.13,0.14-1.79,0s-1.34,0.93,0,1.06s2.29,0.26,2.23,0.88s1.64,1,3.55,1s3.61-0.19,3.54-1s0.91-0.75,2.24-0.88S102.77,80.42,102.11,80.55z"
    />
    <path
      class="bone"
      disabled
      d="M102.11,90.76c-0.67,0.14-1.78,0.69-1.79,0c0-0.42,0.9-1.23-0.76-1.38c0,0-1.39,0-3.23-0.05s-3.23,0.05-3.23,0.05c-1.67,0.15-0.75,1-0.76,1.38c0,0.7-1.13,0.15-1.79,0s-1.34,1,0,1.14s2.29,0.29,2.23,1c-0.07,0.82,1.64,1,3.55,1s3.61-0.21,3.54-1c-0.05-0.67,0.91-0.81,2.24-1S102.77,90.62,102.11,90.76z"
    />
    <path
      class="bone"
      disabled
      d="M105.62,193.3c-0.93,0.26-3.7,1.22-3.72,0c0-0.74,1.26-2.16-1.06-2.41c0,0-1.93-0.08-4.51-0.08s-4.52,0.08-4.52,0.08c-2.32,0.25-1,1.67-1,2.41c0,1.24-2.79,0.28-3.72,0c-0.55,0-1,0.45-1,1s0.45,1,1,1c1.86,0.25,4.41,0.5,4.34,1.67c-0.1,1.45,2.29,1.81,5,1.81s5-0.36,5-1.81c-0.08-1.17,2.48-1.42,4.34-1.67c0.55-0.04,0.97-0.52,0.92-1.07C106.65,193.67,106.17,193.26,105.62,193.3L105.62,193.3z"
    />
    <path
      class="bone"
      disabled
      d="M108.99,233.21c-1.26,0.35-5,1.67-5.07,0c0-1,1.73-2.94-1.44-3.29c0,0-2.63-0.11-6.15-0.11s-6.16,0.11-6.16,0.11c-3.17,0.35-1.42,2.28-1.44,3.29c0,1.7-3.8,0.38-5.07,0c-0.76,0-1.37,0.61-1.37,1.37c0,0.76,0.61,1.37,1.37,1.37c2.54,0.34,6,0.68,5.92,2.28c-0.13,2,3.12,2.46,6.75,2.46s6.88-0.49,6.75-2.46c-0.11-1.6,3.38-1.94,5.91-2.28c0.76,0,1.37-0.61,1.37-1.37C110.36,233.82,109.75,233.21,108.99,233.21z"
    />
    <path
      class="bone"
      disabled
      d="M106.46,212.23c-1,0.27-4,1.33-4.06,0c0-0.81,1.39-2.36-1.15-2.64c0,0-2.11-0.09-4.92-0.09s-4.93,0.09-4.93,0.09c-2.53,0.28-1.14,1.83-1.15,2.64c0,1.35-3,0.29-4.06,0c-0.6-0.06-1.14,0.39-1.2,0.99c-0.06,0.6,0.39,1.14,0.99,1.2c0.07,0.01,0.14,0.01,0.21,0c2,0.27,4.82,0.55,4.74,1.82c-0.11,1.58,2.5,2,5.4,2s5.5-0.39,5.4-2c-0.09-1.27,2.7-1.55,4.73-1.82c0.84,0,1.53-0.25,1.53-1.1C107.99,212.48,107.3,211.8,106.46,212.23z"
    />
    <path
      class="bone"
      disabled
      d="M107.47,222.22c-1.11,0.3-4.43,1.46-4.46,0c0-0.89,1.52-2.59-1.27-2.89c0,0-2.32-0.11-5.41-0.11s-5.42,0.11-5.42,0.11c-2.79,0.3-1.25,2-1.27,2.89c0,1.49-3.34,0.33-4.46,0c-0.66,0-1.2,0.53-1.2,1.2s0.53,1.2,1.2,1.2c0,0,0,0,0.01,0c2.23,0.3,5.3,0.61,5.21,2c-0.12,1.73,2.75,2.17,5.94,2.17s6-0.44,5.94-2.17c-0.09-1.4,3-1.71,5.2-2c0.55,0.37,1.43,0.02,1.8-0.53c0.37-0.55,0.22-1.3-0.33-1.66C108.54,222.15,108.01,222.15,107.47,222.22z"
    />
    <path
      class="bone"
      disabled
      d="M106.46,202.52c-1,0.27-4,1.33-4.06,0c0-0.8,1.39-2.35-1.15-2.63c0,0-2.11-0.09-4.92-0.09s-4.93,0.09-4.93,0.09c-2.53,0.28-1.14,1.83-1.15,2.63c0,1.36-3,0.3-4.06,0c-0.6-0.06-1.14,0.39-1.2,0.99c-0.06,0.6,0.39,1.14,0.99,1.2c0.07,0.01,0.14,0.01,0.21,0c2,0.27,4.82,0.54,4.74,1.82c-0.11,1.58,2.5,2,5.4,2s5.5-0.39,5.4-2c-0.09-1.28,2.7-1.55,4.73-1.82c0.61,0,1.1-0.49,1.1-1.1C107.56,203.01,107.07,202.51,106.46,202.52C106.46,202.51,106.46,202.51,106.46,202.52z"
    />
    <path
      class="bone"
      disabled
      d="M113.98,54.62c0-0.37-0.23-0.36-0.55-0.36c-1.92,0-4.56,0.18-4.74,0.8c-0.11,0.38-0.21,0.82-0.32,1.28c-0.36,1.56-0.87,5.17-2,6.43c0,0-3.25,3.49-10,3.49l0,0c-6.72,0-10-3.49-10-3.49c-1.17-1.26-1.67-4.87-2-6.43c-0.11-0.46-0.21-0.9-0.32-1.28c-0.18-0.62-2.83-0.79-4.74-0.8c-0.32,0-0.53,0-0.56,0.36c0,0.14-0.58,4.19,0.86,5s0.67,8.9,3.52,10.37c4.16,2.15,4.64,8.26,13.26,8.27l0,0c8.62,0,9.09-6.12,13.26-8.27c2.85-1.47,2.06-9.56,3.51-10.37S113.99,54.76,113.98,54.62z"
    />
    <path
      class="bone"
      disabled
      d="M115.05,13.58c-4.26-6.14-11.24-9.83-18.72-9.89l0,0c-7.47,0.06-14.44,3.75-18.7,9.89c-3.49,4.84-4.54,12.77-4.3,17.42c0.27,5.72,2.94,21.82,5.41,22.24c1.83,0.32,5.66,0.08,6.2,1.55c0.14,0.39,1.08,4.58,2.06,5.64c1.33,1.41,5.53,2.57,9.33,2.57l0,0c3.8,0,8-1.18,9.34-2.61c1-1.06,1.93-5.25,2.07-5.64c0.54-1.47,4.36-1.23,6.2-1.55c2.48-0.4,5.16-16.5,5.39-22.2C119.59,26.35,118.54,18.42,115.05,13.58z M84.05,45.88c-2.34-0.16-3.2-1.89-3.21-7.09c0-4.06,2.84-4.51,7.44-5.4c1-0.18,3.1-0.75,4.2,1.26c0.92,1.7,0.61,4.52-0.4,6.5S86.38,46,84.05,45.88z M97.12,54.12c-0.24-0.11-0.5-0.17-0.77-0.2l0,0c-0.27,0.03-0.53,0.09-0.78,0.2c-3.79,1.66-3.33-1.85-2.71-5.08c0.53-2.8,1.29-5,2-5.85s1,0,1.48,0l0,0c0.53,0,0.86-0.65,1.47,0s1.49,3.05,2,5.85C100.46,52.27,100.91,55.78,97.12,54.12z M108.63,45.88c-2.34,0.15-7-2.73-8-4.73s-1.33-4.8-0.4-6.5c1.1-2,3.25-1.44,4.2-1.26c4.6,0.89,7.44,1.34,7.44,5.4C111.83,44,110.96,45.72,108.63,45.88z"
    />
    <path
      class="bone"
      disabled
      d="M114,240.28c-1.62-5.39-5.29-2-8,1.33c-1.37,1.67-3.07,3.03-5,4c-2.87,1.45-6.27,1.45-9.14,0c-1.93-0.97-3.63-2.33-5-4c-2.73-3.37-6.41-6.72-8-1.33c-1.9,6.35-0.8,10.6,2.93,13.06c2.71,1.78-0.5,5.71,2.75,8.75c3.07,2.87,1.67,5.05,4.71,6.32c1.93,0.8,1.2,5,3,6.16c1,0.69-0.09,3.48,1.22,4.08c0.78,0.36,1.31,2,3,2s2.21-1.65,3-2c1.31-0.6,0.19-3.39,1.22-4.08c1.76-1.16,1-5.36,3-6.16c3-1.27,1.64-3.45,4.7-6.32c3.25-3,0-7,2.75-8.75C114.81,250.88,115.91,246.63,114,240.28z"
    />
    <path
      class="bone"
      disabled
      d="M136.84,275.39c-2.89,0.14-2.09,2.69-3.56,2s-0.26-2.57,0.24-3.91s0.07-3.93-1.74-4.58c-3.33-1.19-6.28,1.75-7.47,4.1c-1.22,2.48-1.77,5.24-1.58,8c0.39,2.67,3.43,1.57,5.58,2.18c2.15,0.61,2.41,5.46,1.23,8.35s-1.87,3.83-0.86,7.38c1.01,3.55-3,27.23-5.88,46.86c-1.93,13.38-5.88,34.63-9,47.32c-1.33,5.36-4.67,15.14-6,16.66c-3.74,4.24-4.64,8.37-3,14.39c1.07,4,3.5,4.82,5.43,4.49c1.84-0.6,1.45-2.09,1.09-3.1s-1.81-4.28-1.28-7.29c0.71-3.85,4.4-6.4,8.25-5.7c1.25,0.23,2.42,0.79,3.38,1.63c2.18,1.94,3,5.45,2.19,8.63c-0.54,2.11-1.46,2.85-1,4.16c0.59,1.56,2.88,1.12,5.12-0.91c0.76-0.68,2-2.09,1.09-8.65c-0.77-5.73-4-6.19-4.55-12.15s5.87-46.77,7.2-54.63c1.19-7,6.4-45.14,6.58-46.77c0.39-3.53,4.06-7.68,5.17-13C146.25,277.56,139.73,275.26,136.84,275.39z"
    />
    <path
      class="bone"
      disabled
      d="M151.33,217.7c-0.67-3.54,3.71-6.66,4.06-11.65s-2.21-67.68-4.37-71.72c-0.67-1.37-1.65-2.57-2.87-3.49c-3.08-2.45-4.39-6.5-3.32-10.29c1.16-4.36,4.21-6,7.59-6c1.7-0.02,3.24,0.99,3.91,2.55c1.17-0.33,3.45-0.2,3.79,2c0.46,4.66,0.41,9.35-0.15,14c-0.69,4.75,1.27,42.89,1.67,53.24c0.36,9.16,1.49,17.08,4.08,20.65s5.77,4.75,5.57,8.11c-0.18,3.15-3.54,6.27-6.31,5.21c-1.68-0.63-2-1.2-2.58-1.33c-0.29-0.06-0.55-0.58-1.26,0.13c-0.69,0.7-1.54,1.23-2.47,1.56C156.33,221.47,152.16,222.18,151.33,217.7z"
    />
    <path
      class="bone"
      disabled
      d="M105.44,571c1.08-0.39,2.68-0.45,3.42,0.39c0.13,0.25,0.2,0.54,0.19,0.82c0,0.58-0.72,0.83-0.85,1.36c-0.19,0.77,0.67,1.18,0.78,1.86c0.25,1.38-1.76,1.62-2.52,1.14c-0.57-0.37-0.48-1-0.73-1.54s-0.65-0.63-1-1.11c-0.63-0.9-0.41-2.15,0.49-2.79C105.29,571.08,105.36,571.04,105.44,571z"
    />
    <path
      class="bone"
      disabled
      d="M113.4,548.15c0.71,0.4,0.43,1.17,0.51,1.9c0.23,1.72,0.6,3.42,1.1,5.09c0.09,0.3,0.2,0.58,0.34,0.86c0.34,0.62,0.12,1.4-0.5,1.74c-0.21,0.12-0.45,0.17-0.69,0.16c-0.39,0-0.77-0.11-1.09-0.32c-0.59-0.33-0.65-0.7-0.57-1.37c0.42-3.2-1.4-6.72-1-7.39c0.29-0.69,1.09-1.02,1.78-0.73C113.32,548.11,113.36,548.13,113.4,548.15z"
    />
    <path
      class="bone"
      disabled
      d="M121.62,564.15c0.07-0.07,0.27-0.19,0.31-0.1c0.42,0.81-0.09,1.55,0.41,2.41c0.3,0.64,0.63,1.26,1,1.86c0.22,0.29,0.46,0.35,0.53,0.77s-0.08,0.8,0,1.19s0.3,0.68,0.06,1s-0.51,0.26-0.73,0c-0.49-0.63-0.09-1.36-1-1.63c-0.09-0.4,0-0.79-0.05-1.18c-0.14-0.32-0.31-0.62-0.5-0.91c-0.27-0.55-0.38-1.23-1-1.45c-0.41-0.15-0.67,0-0.94-0.4s-0.11-0.57,0.21-0.88c0.22-0.15,0.48-0.24,0.75-0.24c0.5,0,0.78,0.06,0.89-0.19S121.49,564.31,121.62,564.15z"
    />
    <path
      class="bone"
      disabled
      d="M123.87,563.15c0.37-0.57,0.64,0,1.24-0.27c0.06,0,0-0.17,0.06-0.22s0.32-0.3,0.4-0.27c0.84,0.26-0.18,1.37,0.31,2.16c0.28,0.56,0.6,1.11,0.95,1.64c0.21,0.26,0.44,0.3,0.52,0.67s0,0.73,0,1.09s0.3,0.6,0.11,0.93s-0.46,0.26-0.67,0c-0.47-0.56-0.14-1.24-1-1.43c-0.09-0.37,0-0.73-0.1-1.08c-0.13-0.28-0.3-0.55-0.49-0.8c-0.27-0.49-0.4-1.11-0.94-1.28c-0.38-0.12-0.39,0.14-0.54-0.31C123.61,563.7,123.67,563.38,123.87,563.15z"
    />
    <path
      class="bone"
      disabled
      d="M127.25,562.8c0.37,0.1,0.47,0.51,0.67,0.84c0.13,0.16,0.25,0.34,0.34,0.52c0.08,0.24,0,0.48,0.1,0.72c0.6,0.11,0.39,0.58,0.72,1c0.15,0.15,0.32,0.19,0.45,0s0-0.43-0.09-0.63s0-0.5-0.05-0.73s-0.22-0.27-0.36-0.44c-0.25-0.34-0.48-0.71-0.69-1.08c-0.35-0.52,0.36-1.23-0.22-1.39c-0.09,0.01-0.18,0.05-0.24,0.12c-0.04,0.09-0.09,0.17-0.15,0.25c-0.31,0.25-0.66-0.06-1,0.28C126.71,562.18,126.45,562.6,127.25,562.8z"
    />
    <path
      class="bone"
      disabled
      d="M117.97,571.63c-0.21-0.86-0.26-1.75-0.15-2.63c-0.01-0.32-0.18-0.61-0.45-0.79c-0.37-0.27-0.82-0.42-1.28-0.44c-0.3,0.07-0.57,0.21-0.81,0.4c-0.3,0.24-0.44,0.63-0.36,1c0.08,0.29,0.18,0.57,0.29,0.84c0.47,1.16,0.58,2.42,1,3.61c0.2,0.55,1.76,1.14,2.17,0.14C118.75,572.91,118.33,572.34,117.97,571.63z"
    />
    <path
      class="bone"
      disabled
      d="M107.33,536.23c-1.58,0.13-3.32,1.07-3.53,2.69c-0.27,1.46-1.08,2.78-2.26,3.68c-0.81,0.69-1.26,1.71-1.25,2.77c0,1.81-0.08,5.29,1.69,5.23c1.1-0.15,2.1-0.75,2.74-1.66c0.93-1.05,2.67-1.35,4.89-1.19c1.64,0.11,3.14-1.35,5.06-1.19s2.39,1,3.72,1.41s1.87-1.05,0.86-2c-0.92-0.72-1.89-1.36-2.92-1.92c-2.81-1.58-2-4.63-2.4-5.76C113.4,536.74,109.23,536.08,107.33,536.23z"
    />
    <path
      class="bone"
      disabled
      d="M127.96,430.82c0.39-1.3-0.46-2.53-1.09-2.27c-2.63,1.07-3.3,1.13-5,0.34c-1.11-0.52-2.94,1.23-4.92,1.33c-2.14,0.12-3-2-4.18-1.25c-1.54,0.94-4.19,1.71-6.08,0.79c-0.36-0.17-0.79-0.12-1.11,0.13c-0.65,0.3-1.09,0.93-1.15,1.65c-0.11,0.86,0.34,2.18,1.79,4.63c6.44,10.88,3.53,31,2.46,45.41c-3,39.51-6.32,39.6-7.26,52.23c-0.07,1,0.62,2.54,1.42,2.61s3-1.24,5.25-1.36c2.21,0.11,4.4,0.5,6.51,1.18c2,0.71,0.44-3.65,0-7.32c-1.16-9,3.6-48.92,4.41-55.22c0.69-5.37,2.64-26.1,3.42-30C123.5,438.26,126.79,434.78,127.96,430.82z"
    />
    <path
      class="bone"
      disabled
      d="M104.05,563.65c-0.74,1.13-1.54,2.89-0.14,2.81c0.58-0.86,1.33-1.6,2.21-2.17c0.94-0.43,2,0.51,3,1.63c0.28,0.1,0.35-0.08,0.45-0.36c0.43-1.12-0.36-2.78-0.45-3.91c-0.11-1.51,0.55-2.54,1-3.92c0.46-1.54-0.1-2.1-0.1-2.1s-1.87-2-3.66-1.63c-0.44,0.11-0.83,0.34-1.13,0.68c-0.59,0.59-0.94,1.37-1,2.2c-0.05,1.01,0.02,2.01,0.22,3C104.7,561.37,104.88,562.4,104.05,563.65z"
    />
    <path
      class="bone"
      disabled
      d="M110.33,554.35c-0.05,0.07-0.15,0.09-0.22,0.04c-0.01-0.01-0.03-0.02-0.04-0.04c-0.69-0.84-1.67-1.39-2.74-1.55c-1.27-0.15-3.23,1.3-3.52,1.67s-0.44-0.44-0.37-0.9c0.21-1.5,1.21-3.51,2.35-4.09c1.17-0.54,2.5-0.6,3.71-0.15c0.6,0.24,1.07,0.71,1.33,1.3c0.3,0.62,0.37,1.33,0.19,2C110.89,553.24,110.65,553.82,110.33,554.35z"
    />
    <path
      class="bone"
      disabled
      d="M118.33,556.18c0.33-0.23-2-7.83-2-7.83c-0.13-0.17-0.31-0.28-0.52-0.32c-1.49-0.39-1.21,0.1-1.21,0.1c1.29,2.44,1.53,7.33,1.86,7.89C116.41,556,116.95,557.13,118.33,556.18z"
    />
    <path
      class="bone"
      disabled
      d="M121.42,552.31c-0.29-0.81-0.65-1.57-0.94-2.38l-0.13-0.13c-0.11,0-0.74-0.32-0.62,0.07s0.88,2.5,0.88,2.5c0.37,0.88,0.66,1.68,0.76,1.79s0.59,0.28,0.71,0C122.33,553.53,121.61,552.84,121.42,552.31z"
    />
    <path
      class="bone"
      disabled
      d="M117.7,549.58c0.14,0.36,1.79,5.79,1.86,6s0.53,0,0.74-0.24c0.6-0.66-0.21-1.43-0.34-2.15v-0.16c0,0-0.95-3.17-1-3.37S117.56,549.21,117.7,549.58z"
    />
    <path
      class="bone"
      disabled
      d="M115.86,564.52c0.31,0.03,0.62,0.1,0.91,0.21c0.1,0.04,0.22-0.02,0.26-0.12c0,0,0-0.01,0-0.01c0.27-1.08-0.87-2-1-3.25s0.44-2.77-1.34-2.38c-0.41-0.01-0.82,0.01-1.23,0.06c-0.36,0.13-0.58,0.26-0.54,0.65l0.42,5.24c0,0,0.06,0.38,0.77,0.07l0.55-0.25C115.03,564.55,115.45,564.48,115.86,564.52z"
    />
    <path
      class="bone"
      disabled
      d="M120.92,562.6c-0.09-0.41-0.25-0.81-0.46-1.17c-0.09-0.4-0.28-0.78-0.56-1.08c-0.28-0.39-0.51-0.8-0.71-1.24c-0.21-0.42-0.09-1.19-0.52-1.36c-0.49-0.09-1-0.01-1.45,0.22c-0.13,0.33,0.25,0.85,0.45,1.32c0.42,1,1,1.91,1.42,2.89s0.38,1.43,0.77,1.44l0.83-0.46C120.82,563,120.9,562.81,120.92,562.6z"
    />
    <path
      class="bone"
      disabled
      d="M117.58,566.21c0,0,0.42,0.35,0.35,0.61s-0.44,0.31-0.44,0.31c-0.45-0.27-0.98-0.39-1.5-0.36c-0.57,0.16-1.1,0.43-1.56,0.81c-0.33,0.23-0.51-0.27-0.51-0.81c0.01-0.43,0.27-0.82,0.66-1c0.21-0.1,0.44-0.17,0.67-0.21c0.83,0,1.64,0.24,2.33,0.69"
    />
    <path
      class="bone"
      disabled
      d="M120.33,557.33c0.31,0.93,1,1.36,1.54,2.12c0.29,0.38,0.52,0.81,0.67,1.26c0.15,0.43,0.44,1.28,0.69,1.34s1.48-0.13,1.5-0.38s-3.18-5-3.46-5.31S120.04,556.61,120.33,557.33z"
    />
    <path
      class="bone"
      disabled
      d="M125.98,561.21c0.19,0,1.48-0.21,1.55-0.53s-1.49-2.06-2.5-2.86s-1.12-2-2.13-2.48c-0.43-0.2-1.13,0.07-0.84,0.54s3.51,5,3.51,5C125.7,561,125.84,561.11,125.98,561.21z"
    />
    <path
      class="bone"
      disabled
      d="M105.52,569.82c0,0-0.21,0-0.26,0s-1.58-0.49-1.28-1.63s2.07-2.77,2.57-2.64c0,0,0.67-0.15,1.83,1.3c0.35,0.42,0.59,0.93,0.67,1.47c0.04,0.42-0.18,0.81-0.55,1c-0.39-0.06-0.78-0.09-1.17-0.1c-0.54,0.11-1.05,0.34-1.5,0.66C105.72,569.9,105.61,569.88,105.52,569.82z"
    />
    <path
      class="bone"
      d="M130.4,230.55c-9.66-1.78-14.75,2.58-15.08,7.08c-0.51,7,4,18.87,1.21,24.81c-2.7,5.71-6.83,10.62-12,14.24c-1.9,1.34-4.12,2.74-5.35,4.88c-1.89,0.31-3.81,0.31-5.7,0c-1.24-2.14-3.46-3.54-5.36-4.88c-5.17-3.62-9.3-8.53-12-14.24c-2.79-5.94,1.72-17.82,1.21-24.81c-0.33-4.5-5.41-8.86-15.07-7.08c-6.2,1.14-11.39,5.28-11.4,12.54c0,6.89,1.53,18.69,12.11,23.53c4.38,2,7.11,4.3,8,8.54c1.29,6.32-0.54,12.71,0.5,16.71c1.67,6.45,5.85,8.7,11.64,8.64c5.6-0.05,8.82-5.26,10.41-10.21c0-0.14,0.08-0.28,0.13-0.42c0.73,0.7,1.68,1.11,2.69,1.18l0,0c1.01-0.07,1.96-0.49,2.69-1.18l0.12,0.42c1.59,4.95,4.81,10.16,10.41,10.21c5.79,0.06,10-2.19,11.65-8.64c1-4-0.8-10.39,0.5-16.71c0.86-4.24,3.59-6.53,8-8.54c10.58-4.84,12.11-16.64,12.1-23.53C141.78,235.83,136.59,231.69,130.4,230.55z M84.18,293.86c-2.57,1.31-3.73-3.11-4.79-4.76c-1.37-2.14-3.34-4.26-2.51-7.07s4-2.24,6.24-1.2c2.24,1.23,3.84,3.36,4.4,5.85C87.78,289,86.44,292.71,84.18,293.86z M113.27,289.1c-1.07,1.65-2.23,6.07-4.8,4.76c-2.25-1.15-3.6-4.84-3.33-7.18c0.56-2.49,2.15-4.62,4.39-5.85c2.21-1,5.38-1.75,6.25,1.2S114.63,287,113.27,289.1L113.27,289.1z"
    />
    <path
      class="bone"
      disabled
      d="M100.64,100.94c0,0-1.85-0.06-4.31-0.06s-4.31,0.06-4.31,0.06c-2.22,0.18-0.69,3.61-0.4,4.49s2.17,1.23,4.71,1.23s4.37-0.22,4.71-1.23S102.86,101.12,100.64,100.94z"
    />
    <path
      class="bone"
      disabled
      d="M111.45,418.29c0.77-3.91,6-4,7.74-3.34c1.43,0.57,3.66,3.85,3.53,6.24s-2.33,7.39-5.89,7.19C113.44,428.18,110.45,423.36,111.45,418.29z"
    />
    <path
      class="bone"
      disabled
      d="M55.82,275.39c2.89,0.14,2.09,2.69,3.55,2s0.27-2.57-0.24-3.91s-0.07-3.93,1.75-4.58c3.33-1.19,6.27,1.75,7.46,4.1c1.23,2.48,1.78,5.24,1.58,8c-0.38,2.67-3.42,1.57-5.57,2.18s-2.42,5.46-1.24,8.35s1.88,3.83,0.86,7.38s3,27.23,5.88,46.86c1.94,13.38,5.89,34.63,9,47.32c1.32,5.36,4.67,15.14,6,16.66c3.75,4.24,4.65,8.37,3,14.39c-1.07,4-3.51,4.82-5.43,4.49c-1.84-0.6-1.46-2.09-1.1-3.1s1.81-4.28,1.29-7.29c-0.71-3.86-4.41-6.41-8.27-5.69c-1.25,0.23-2.41,0.79-3.37,1.62c-2.17,1.94-3,5.45-2.19,8.63c0.54,2.11,1.46,2.85,1,4.16c-0.6,1.56-2.88,1.12-5.12-0.91c-0.76-0.68-2-2.09-1.1-8.65c0.77-5.73,4-6.19,4.56-12.15s-5.88-46.77-7.2-54.63c-1.2-7-6.41-45.14-6.59-46.77c-0.39-3.53-4.06-7.68-5.17-13C46.41,277.56,52.92,275.26,55.82,275.39z"
    />
    <path
      class="bone"
      disabled
      d="M64.69,430.82c-0.38-1.3,0.47-2.53,1.09-2.27c2.63,1.07,3.3,1.13,5,0.34c1.11-0.52,2.94,1.23,4.91,1.33c2.14,0.12,3-2,4.18-1.25c1.55,0.94,4.2,1.71,6.08,0.79c0.37-0.17,0.8-0.12,1.12,0.13c0.65,0.31,1.08,0.94,1.14,1.65c0.11,0.86-0.34,2.18-1.79,4.63c-6.43,10.88-3.53,31-2.45,45.41c2.94,39.51,6.32,39.6,7.25,52.23c0.08,1-0.62,2.54-1.41,2.61s-3-1.24-5.25-1.36c-2.21,0.11-4.4,0.5-6.51,1.18c-2,0.71-0.44-3.65,0-7.32c1.16-9-3.6-48.92-4.4-55.22c-0.69-5.37-2.65-26.1-3.43-30C69.16,438.26,65.87,434.78,64.69,430.82z"
    />
    <path
      class="bone"
      disabled
      d="M81.21,418.29c-0.78-3.91-6-4-7.75-3.34c-1.43,0.57-3.65,3.85-3.53,6.24s2.33,7.39,5.89,7.19C79.22,428.18,82.21,423.36,81.21,418.29z"
    />
    <path
      class="bone"
      disabled
      d="M156.02,109.82c-1.83-1.07-3.73-2.01-5.69-2.82c-1.28-0.46-2.35-0.5-3.09,0.2s-0.69,2.09-0.4,3.35s-3.15,2.12-4.16,2s-2.68-2.2-4.37-2.74s-4.07,0.75-5.39,0.88c-0.73,0.08-2.59-0.08-4.65-0.18c0.02,0.33,0.02,0.67,0,1c2.54,1.13,6.89,3.51,8,7c0.55,1.59,0.21,3.35-0.89,4.62c1.54,1.43,3.25,3.52,3.33,5.81c0.07,1.26-0.26,2.52-0.94,3.58c1.53,1.28,3.06,3.17,2.82,5.5c-0.14,1.58-0.85,3.05-2,4.14c0.64,0.43,1.25,0.9,1.83,1.41c3.46-7.13,5.46-12.69,4.29-13.76c-1.03-1.18-1.72-2.62-2-4.16c-0.28-3.06,0.47-6.13,2.12-8.72c1.4-2.21,4.83-4.62,10.94-3.27C158.15,114.12,157.71,110.88,156.02,109.82z"
    />
    <path
      class="bone"
      disabled
      d="M47.98,129.74c-1.17,1.07,0.83,6.63,4.28,13.76c0.58-0.51,1.19-0.98,1.83-1.41c-1.14-1.09-1.85-2.56-2-4.14c-0.24-2.33,1.3-4.22,2.83-5.5c-0.69-1.07-1.02-2.32-0.95-3.59c0.09-2.28,1.79-4.37,3.34-5.8c-1.1-1.27-1.44-3.02-0.9-4.61c1.16-3.45,5.51-5.83,8.06-7c0-0.3,0-0.62,0-1c-2,0.1-3.91,0.26-4.65,0.18c-1.31-0.13-3.64-1.43-5.38-0.88s-3.34,2.62-4.37,2.74s-4.44-0.72-4.16-2s0.32-2.65-0.4-3.35s-1.82-0.66-3.09-0.2c-1.98,0.8-3.89,1.73-5.74,2.79c-1.68,1.06-2.12,4.3,0.29,3.77c6.12-1.35,9.54,1.06,10.95,3.27c1.65,2.59,2.4,5.66,2.12,8.72C49.75,127.07,49.04,128.54,47.98,129.74z"
    />
    <path
      class="bone"
      disabled
      d="M103.74,170.19c-0.14-0.35-0.47-0.63-0.8-0.54c-0.76,0.21-2,1-2,0c0-0.61,1-1.77-0.87-2c0,0-1.58-0.07-3.69-0.07s-3.7,0.07-3.7,0.07c-1.9,0.21-0.85,1.37-0.86,2c0,1-1.29,0.22-2,0c-0.36-0.04-0.7,0.19-0.8,0.54c0,0.15,0,0.3-0.07,0.44c0,0.31,0.3,0.59,0.87,0.66c1.52,0.21,2.62,0.42,2.56,1.37c-0.08,1.18,1.87,1.48,4,1.48s4.13-0.3,4-1.48c-0.06-0.95,1-1.16,2.56-1.37c0.56-0.07,0.81-0.35,0.86-0.66L103.74,170.19z"
    />
    <path
      class="bone"
      disabled
      d="M140.48,156.23c-0.17-1.82-3.86-3.44-3.86-3.44s4.53-1.69,4.47-4.14c-0.09-3.47-7-6.53-7-6.53s4-0.87,4.33-4.4c0.28-2.73-4.29-5.05-4.29-5.05c1.54-0.56,2.52-2.08,2.39-3.72c-0.1-2.87-4.7-5.92-4.7-5.92s3.22-1.36,2.38-3.88c-1.28-3.78-8.49-6.3-8.49-6.3c0.33-0.96,0.44-1.99,0.32-3c-1.84,0-3.55,0.17-5.12,0.34c0,1.36-0.43,2.94-3.21,3.25c-0.76,0.09-10.41,0.33-11.67,0.38c-0.3,0.02-0.6,0.06-0.89,0.13c-0.88-0.48-1.67-1.11-2.34-1.86c-0.86-1.12-0.79-3.22-2-3.6c-0.7-0.22-2.12,0.2-4.41,0.2s-3.72-0.42-4.42-0.2c-1.23,0.38-1.16,2.48-2,3.6c-0.67,0.74-1.46,1.37-2.34,1.86c-0.3-0.07-0.6-0.11-0.9-0.13c-1.26,0-10.9-0.29-11.67-0.38c-2.78-0.31-3.24-1.89-3.2-3.25c-1.57-0.17-3.29-0.29-5.12-0.34c-0.12,1.01-0.02,2.04,0.32,3c0,0-7.22,2.52-8.49,6.3c-0.84,2.52,2.38,3.88,2.38,3.88s-4.62,3.05-4.78,5.97c-0.13,1.64,0.85,3.16,2.39,3.72c0,0-4.56,2.28-4.23,5c0.36,3.53,4.33,4.4,4.33,4.4s-7,3.06-7.05,6.53c-0.06,2.45,4.47,4.14,4.47,4.14s-3.68,1.62-3.85,3.44c-0.35,3.81,3.77,5.27,3.77,5.27s-4,2.24-3.55,5.29c0.24,1.54,2.57,3.52,2.57,3.52s-2.82,2.77-2.33,6c0.35,1.64,1.27,3.11,2.6,4.14c0,0-2.73,2.77-2,6s4.42,3.78,4.42,3.78c-0.07,0.21-1.62,4.11-1.29,5.93c0.91,4.89,6.14,4.24,7.63,4.12c2.79-0.41,5.37-1.69,7.39-3.66c0.84-0.85,1.9-2.06,3.05-3.47c2.4-1.1,4.69-2.44,6.83-4c1.91-1.73,3.71-3.57,5.39-5.52c1.57-1.73,2.31-3,1.35-3.77s-2.83,0.67-4,1.53c-0.62,0.46-1.79,1.58-3.13,2.8c0.42-0.68,0.8-1.34,1.15-2c2.32-4.21,5.22-5,6.6-10.4c0.5-2,0.42-6.31,3.6-11c0.84,3.52,2.08,6.55,3.75,6.71h0.34h0.34c1.67-0.16,2.9-3.19,3.74-6.72c3.18,4.69,3.11,9,3.61,11c1.37,5.44,4.27,6.19,6.59,10.4c0.27,0.49,0.56,1,0.86,1.49c-1.11-1-2.06-1.91-2.59-2.31c-1.18-0.86-3-2.3-4-1.53s-0.22,2,1.35,3.77c1.69,1.94,3.49,3.79,5.39,5.52c2.01,1.49,4.16,2.77,6.43,3.83c1.21,1.5,2.34,2.79,3.22,3.68c2.01,1.97,4.6,3.25,7.39,3.66c1.48,0.12,6.71,0.77,7.62-4.12c0.33-1.82-1.21-5.72-1.28-5.93c0,0,3.67-0.58,4.41-3.78s-2-6-2-6c1.32-1.03,2.25-2.5,2.6-4.14c0.48-3.27-2.33-6-2.33-6s2.32-2,2.57-3.52c0.48-3-3.55-5.29-3.55-5.29S140.83,160,140.48,156.23z M69.83,115.68c2.2,0.8,4.5,1.32,6.84,1.52c1.89,0.15,6.55,0.41,9.16,0.48c0.23,1.6,1.02,3.06,2.23,4.13c0.09,0.1,0.17,0.21,0.24,0.32c-3.67,0-12.48-0.14-17-0.82C62.93,120,69.83,115.68,69.83,115.68z M66.76,124.55c4.01,0.81,8.06,1.38,12.14,1.69c3.41,0.21,8.31,0.19,10.8,0.2c0.27,1.55,0.48,3.36,0.64,5.28c-4.92-0.12-15.92-0.54-20-1.15C59.33,128.91,66.76,124.55,66.76,124.55z M64.91,134.68c0,0,5.63,1,8.59,1.25c2.79,0.24,13.52,0.55,17.1,0.14c0.07,1.57,0.11,3.15,0.15,4.66h-0.42c-4.34,0.33-17.65,0.81-21.61,0.13C56.04,138.68,64.91,134.68,64.91,134.68L64.91,134.68z M64.61,144.18c0,0,4.72,1,7.63,1.3c6.2,0.29,12.41,0.03,18.56-0.79c0,1.31,0,2.5,0,3.51c-6.51,3.43-16.92,4.45-23.41,3.13C52.69,148.34,64.61,144.18,64.61,144.18L64.61,144.18z M58.49,172.87c0,0,1.39,0.31,2.61,0.67c1.64,0.42,3.31,0.73,5,0.91c2.49,0.21,4.99,0.09,7.44-0.38c2.23-0.38,3-0.79,5.36-1.07s1.3,1.27-0.93,3.18s-10.41,4.28-18,2.3C54.86,177.15,58.49,172.87,58.49,172.87L58.49,172.87z M58.01,185.64c-0.87-1,0-2.75,0-2.75c2.42,0.64,4.91,1.01,7.42,1.11c5.87,0,7.69-0.91,10.57-1.66s1.46,0.63,0.75,1.23c-1.28,1.09-4.66,4.07-11.86,4.27C62.59,187.88,58.93,186.75,58.01,185.64L58.01,185.64z M65.55,195.57c-2.56,0.79-4.25-0.59-4.06-1.53c0.12-0.57,0.31-1.11,0.59-1.62c2.18,0.67,4.47,0.89,6.73,0.63C70.7,192.73,68.17,194.76,65.55,195.57z M82.55,165.45c-2.43,2.9-10.46,6.19-19.88,4.32c-7.76-1.53-1.9-5.82-1.9-5.82c3.07,0.94,6.28,1.38,9.49,1.31c4.78-0.12,8.74-0.93,11.26-2.24s2.39,0.74,0.99,2.43L82.55,165.45z M82.61,157.95c-5.4,3.2-12.65,3.34-16,2.87c-11.46-1.62-6.51-6.18-6.51-6.18c2.99,0.8,6.02,1.4,9.09,1.82c3,0.32,10.48,0.23,13.77-0.86c1.37-0.45,0.95,1.55-0.39,2.4L82.61,157.95z M90.55,156.88c-1.25,0.59-4.05,0.59-2.7-1c0.98-1.08,2.04-2.09,3.18-3c0.09,1,0.22,2.17,0.41,3.4c-0.29,0.23-0.6,0.43-0.93,0.6H90.55zM104.64,121.81c1.2-1.07,1.99-2.53,2.23-4.13c2.6-0.07,7.26-0.33,9.15-0.48c2.34-0.2,4.64-0.71,6.84-1.52c0,0,6.9,4.36-1.44,5.63c-4.55,0.68-13.36,0.78-17,0.82c0.05-0.11,0.11-0.22,0.18-0.32L104.64,121.81z M103,126.44c2.48,0,7.38,0,10.8-0.2c4.07-0.31,8.13-0.88,12.13-1.69c0,0,7.41,4.36-3.58,6c-4.07,0.61-15.08,1-20,1.15c0.12-1.9,0.33-3.7,0.61-5.26H103z M102.09,136.07c3.58,0.42,14.32,0.1,17.1-0.14c3-0.25,8.6-1.25,8.6-1.25s8.86,4-3.82,6.19c-4,0.68-17.27,0.2-21.61-0.13h-0.41c-0.01-1.52,0.03-3.1,0.1-4.67H102.09z M101.89,144.69c6.15,0.82,12.37,1.08,18.57,0.79c2.91-0.27,7.62-1.3,7.62-1.3s11.93,4.16-2.79,7.15c-6.5,1.32-16.91,0.3-23.42-3.13c-0.03-1.01-0.03-2.2-0.02-3.51H101.89z M102.18,156.88c-0.31-0.15-0.61-0.34-0.88-0.55c0.18-1.23,0.31-2.4,0.41-3.4c1.14,0.91,2.2,1.92,3.18,3c1.3,1.54-1.5,1.54-2.75,0.95H102.18zM109.78,155.6c3.28,1.09,10.76,1.18,13.77,0.86c3.06-0.42,6.09-1.02,9.08-1.82c0,0,5,4.56-6.51,6.18c-3.35,0.47-10.59,0.33-16-2.87c-1.38-0.8-1.79-2.8-0.38-2.35H109.78z M110.19,165.45c-1.4-1.69-1.5-3.75,1-2.43s6.47,2.12,11.26,2.24c3.21,0.08,6.41-0.34,9.48-1.26c0,0,5.85,4.29-1.91,5.82c-9.41,1.82-17.45-1.47-19.87-4.37L110.19,165.45z M127.19,195.57c-2.61-0.81-5.14-2.84-3.25-2.52c2.26,0.26,4.55,0.04,6.72-0.63c0.28,0.51,0.48,1.05,0.6,1.62c0.07,0.96-1.59,2.32-4.16,1.53H127.19z M134.73,185.64c-0.91,1.11-4.57,2.24-6.88,2.18c-7.19-0.2-10.58-3.18-11.86-4.27c-0.71-0.6-2-2,0.76-1.23s4.58,1.68,10.47,1.68c2.49-0.09,4.96-0.46,7.37-1.09c0,0,0.93,1.68,0.05,2.73L134.73,185.64z M132.73,178.48c-7.62,2-15.71-0.3-18-2.3s-3.25-3.47-0.93-3.18s3.13,0.69,5.37,1.07c2.45,0.47,4.95,0.59,7.43,0.38c1.69-0.18,3.36-0.49,5-0.91c1.23-0.36,2.61-0.67,2.61-0.67s3.58,4.28-1.53,5.61L132.73,178.48z"
    />
  </svg>`;case"xp_shoulder-girdle":return xp_shoulder_girdle();case"xp_skull":return xp_skull();case"xp_thorax":return xp_thorax();case"xp_upper-extremities":return V`
    <svg
      id="xp_upper-extremities"
      hidden
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0"
      y="0"
      style="width:12rem; height:55rem;"
      viewBox="0 0 192 580"
      style="enable-background:new 0 0 192 580;"
      xml:space="preserve"
    >
      <path
        class="region"
        index="3"
        d="M17.56,253.21c0.52,9.1,0.46,18.22-0.17,27.31h15.88c1-5.51,2.34-12.42,3.6-18.75c0.26-1.29,0.44-2.22,0.52-2.61c0.79-4.2,1.75-8.59,2.68-12.83c0.69-3.11,1.35-6.14,1.9-8.89H18.1c-0.34,4.33-0.61,9-0.61,14C17.49,251.68,17.52,252.3,17.56,253.21z"
      />
      <path
        class="region"
        index="2"
        d="M173.87,229.76c-0.48-5-0.9-9.28-0.9-13.12c0-0.47,0-1.34,0-2.57c0.06-5.33,0.09-10.49,0.08-15.47h-24.52c0.23,5.17,0.39,9,0.39,9.89c0,1.36,0.09,4.16,0.19,7.41c0.13,4.31,0.28,9.19,0.28,12.34c0.14,2.72,0.5,5.42,1.08,8.08h24C174.27,234.04,174.07,231.85,173.87,229.76z"
      />
      <path
        class="region"
        index="2"
        d="M43.55,215.9c0.1-3.25,0.19-6.05,0.19-7.41c0-0.92,0.16-4.72,0.39-9.89H19.58c0,4.98,0.03,10.14,0.08,15.47c0,1.23,0,2.1,0,2.57c0,3.84-0.42,8.14-0.89,13.12c-0.21,2.09-0.41,4.27-0.6,6.56h24c0.58-2.66,0.94-5.36,1.08-8.08C43.27,225.09,43.42,220.21,43.55,215.9z"
      />
      <path
        class="region"
        index="3"
        d="M152.59,246.33c0.93,4.24,1.89,8.63,2.68,12.83c0.08,0.39,0.26,1.32,0.52,2.61c1.26,6.33,2.62,13.24,3.6,18.75h15.88c-0.63-9.09-0.69-18.21-0.17-27.31c0-0.91,0.07-1.53,0.07-1.77c0-5-0.27-9.67-0.61-14h-23.87C151.24,240.19,151.91,243.22,152.59,246.33z"
      />
      <path
        class="region"
        index="4"
        d="M180.33,312.2c0.26-0.09,0.55,0.02,0.67,0.27c0.05,0.09,4.3,8.55,7,11.77c0.51,0.84,1.58,1.15,2.46,0.71c1-0.71,1.34-2.03,0.82-3.13c-0.13-0.36-0.36-1.05-0.67-2c-1.85-5.57-6.78-20.35-11.17-24.58c-2-1.91-3.32-6.45-4-13.54H159.6c0.6,2.92,1,5.88,1.17,8.86c-0.14,2.43-1.95,25.69-2.24,28.52c-0.5,4.87-0.47,13.68,1.17,17.13c2.4,5.06,11.43,7.76,15.81,7.85c1.12,0.04,2.2-0.47,2.87-1.37c4.87-5.78,2.16-26.91,1.59-29.9C179.93,312.53,180.08,312.28,180.33,312.2z"
      />
      <path
        class="region"
        index="4"
        d="M13.24,295.27c-4.39,4.23-9.32,19-11.17,24.58c-0.31,0.92-0.54,1.61-0.67,2c-0.53,1.11-0.19,2.44,0.82,3.15c0.88,0.44,1.95,0.13,2.46-0.71c2.68-3.22,6.93-11.68,7-11.77c0.12-0.25,0.41-0.36,0.67-0.27c0.26,0.09,0.41,0.35,0.36,0.62c-0.57,3-3.28,24.12,1.59,29.9c0.67,0.9,1.75,1.41,2.87,1.37c4.38-0.09,13.41-2.79,15.81-7.85c1.64-3.45,1.67-12.26,1.17-17.13c-0.28-2.83-2.1-26.09-2.24-28.52c0.17-2.98,0.57-5.94,1.17-8.86H17.33C16.56,288.82,15.21,293.36,13.24,295.27z"
      />
      <path
        class="region"
        index="1"
        d="M31,110c-7.25,7.75-11.23,38.59-11.41,87.49h24.59c0-1.12,0.1-2.3,0.16-3.52c0.51-11.41,1.19-28.83,1.33-36.15c-0.15-1.93,11.36-33.43-4.29-55.17c-2.2,1.08-4.3,2.34-6.29,3.77C33.62,107.48,32.25,108.68,31,110z"
      />
      <path
        class="region"
        index="1"
        d="M161.67,110c7.24,7.75,11.23,38.59,11.41,87.49h-24.59c-0.06-1.12-0.11-2.3-0.16-3.52c-0.51-11.41-1.19-28.83-1.33-36.15c0.15-1.93-11.36-33.43,4.28-55.17c2.2,1.08,4.31,2.34,6.3,3.77C159.05,107.48,160.42,108.68,161.67,110z"
      />

      <path
        class="outline"
        d="M105.11,580c-1.35,0.05-2.65-0.49-3.58-1.47c-2.74-2.94-2.27-9.67-1.9-15.08c0.12-1.64,0.22-3.18,0.22-4.4c0-3.15-0.46-7.49-0.91-11.7s-0.91-8.61-0.91-11.81c0.13-3.57,0.49-7.13,1.06-10.65c0.85-5.42,1.34-10.9,1.47-16.39c0-0.22-3.5-28.91-3.5-44.6c-0.07-7.84,0.83-15.67,2.68-23.29c0.68-2.53,1.09-5.12,1.21-7.74c0-0.83-3.29-68.52-4.62-112.75C95,364.35,91.75,432,91.71,432.9c0.12,2.61,0.53,5.19,1.21,7.71c1.85,7.62,2.75,15.45,2.68,23.29c0,15.69-3.47,44.38-3.5,44.67c0.13,5.47,0.62,10.92,1.47,16.32c0.57,3.52,0.93,7.08,1.06,10.65c0,3.2-0.47,7.58-0.91,11.81s-0.91,8.55-0.91,11.7c0,1.22,0.1,2.76,0.22,4.4c0.37,5.41,0.84,12.14-1.9,15.08c-0.93,0.98-2.23,1.52-3.58,1.47c-8,0-27.59-5.28-27.59-15.07c0-2.92,2.54-6.59,5.49-10.85c3.94-5.71,8.85-12.81,8.85-20.19c0-5.2-2.62-14.69-5.66-25.68c-4.6-16.65-10.31-37.37-10.31-54.73c0-7.25,0.36-14.5,1.09-21.72c0.42-4.66,0.79-8.69,0.79-13.78c0-4.05-1.58-10.28-3.75-18.9C51.09,377.83,42.1,342.26,42.1,284.9c0-6.93,2.3-19.06,4.73-31.9c2.79-14.7,5.94-31.35,5.94-42.21c0-7.53-4.15-34.59-6.09-46.82c-0.24,8-0.79,20.4-1.23,30.06c-0.33,7.43-0.59,13.31-0.59,14.46c0,1.38-0.09,4.19-0.19,7.44c-0.13,4.3-0.28,9.18-0.28,12.31c0,3.63-1.5,10.44-3.23,18.33c-0.93,4.23-1.89,8.61-2.68,12.79c-0.07,0.4-0.26,1.33-0.52,2.62c-1.4,7-5.13,25.7-5,28.54c0.14,2.43,2,25.66,2.24,28.48c0.52,5.14,0.47,14-1.27,17.72c-2.73,5.73-12.43,8.39-16.78,8.48c-1.46,0.03-2.85-0.62-3.75-1.77c-4.26-5.06-3.2-20.36-2.31-27.54c-1.6,3.18-3.46,6.23-5.56,9.11c-0.85,1.26-2.51,1.69-3.86,1c-1.52-0.97-2.09-2.92-1.34-4.56c0.13-0.36,0.36-1,0.66-1.94c1.88-5.64,6.87-20.61,11.45-25c2.54-2.45,5.29-11.59,4-41.21c0-0.94-0.07-1.57-0.07-1.82c0.07-7.28,0.51-14.55,1.31-21.79c0.47-5,0.88-9.23,0.88-13c0-0.47,0-1.34,0-2.55c-0.51-41.6,1.09-93.55,11.63-104.84c1.3-1.37,2.72-2.61,4.25-3.71c10.15-7.41,26-10.78,36.43-13c4.85-1,9-1.93,9.84-2.71c2.11-2.07-0.3-15.81-1.18-19.6c-1.37-3.21-2.44-6.54-3.2-9.95c-0.23-1.08-0.39-2-0.49-2.64c-0.67,0.27-1.43,0.16-2-0.29c-0.97-0.74-1.73-1.71-2.22-2.83c-0.97-1.88-1.72-3.88-2.22-5.94l-0.23-0.88c-0.44-1.71-0.78-3.45-1-5.2c-0.3-1.81-0.37-3.65-0.21-5.48c0.04-0.74,0.27-1.47,0.66-2.1c0-0.27-0.11-0.75-0.18-1.32c-0.36-2.97-0.39-5.97-0.11-8.95c0.24-2.97,0.87-5.89,1.88-8.69c0.78-2.11,1.83-4.11,3.12-5.95c1.92-2.67,4.4-4.89,7.27-6.5C84.93,1.13,89.95,0,96.33,0s11.41,1.13,15.79,3.55c2.87,1.61,5.35,3.83,7.27,6.5c1.27,1.85,2.3,3.84,3.06,5.95c1.01,2.8,1.64,5.72,1.88,8.69c0.28,3,0.24,6.01-0.12,9c-0.07,0.57-0.14,1-0.18,1.32c0.39,0.64,0.61,1.36,0.66,2.1c0.16,1.83,0.09,3.67-0.21,5.48c-0.22,1.75-0.56,3.49-1,5.2l-0.23,0.88c-0.5,2.06-1.25,4.06-2.22,5.94c-0.49,1.12-1.25,2.09-2.22,2.83c-0.57,0.45-1.33,0.56-2,0.29c-0.1,0.64-0.26,1.56-0.49,2.64c-0.76,3.42-1.84,6.77-3.2,10c-0.84,3.64-3.28,17.48-1.16,19.55c0.81,0.78,5,1.68,9.84,2.71c10.46,2.23,26.28,5.6,36.43,13c1.53,1.1,2.95,2.34,4.25,3.71c10.54,11.29,12.14,63.24,11.63,104.84c0,1.21,0,2.08,0,2.55c0,3.78,0.41,8.06,0.88,13c0.8,7.24,1.24,14.51,1.31,21.79c0,0.25,0,0.88-0.07,1.82c-1.3,29.62,1.45,38.76,4,41.21c4.58,4.42,9.57,19.39,11.45,25c0.3,0.91,0.53,1.58,0.66,1.94l0,0c0.71,1.61,0.15,3.5-1.31,4.47c-1.35,0.69-3.01,0.26-3.86-1c-2.11-2.86-3.98-5.89-5.59-9.06c0.89,7.18,1.95,22.48-2.31,27.54c-0.9,1.14-2.29,1.8-3.75,1.77c-4.35-0.09-14.05-2.75-16.78-8.48c-1.74-3.69-1.79-12.58-1.27-17.72c0.29-2.82,2.1-26.05,2.24-28.48c0.17-2.84-3.56-21.51-5-28.54c-0.26-1.29-0.45-2.22-0.52-2.62c-0.79-4.18-1.75-8.56-2.68-12.79c-1.73-7.89-3.23-14.7-3.23-18.33c0-3.13-0.15-8-0.28-12.31c-0.1-3.25-0.19-6.06-0.19-7.44c0-1.15-0.26-7-0.59-14.46c-0.43-9.66-1-22-1.23-30.06c-1.94,12.23-6.09,39.29-6.09,46.82c0,10.86,3.15,27.51,5.94,42.21c2.43,12.84,4.73,25,4.73,31.9c0,57.36-9,92.93-14.35,114.18c-2.18,8.62-3.76,14.85-3.76,18.9c0,5.09,0.37,9.12,0.79,13.78c0.72,7.21,1.08,14.46,1.08,21.71c0,17.36-5.72,38.08-10.32,54.73c-3,11-5.66,20.48-5.66,25.68c0,7.38,4.91,14.48,8.85,20.19c3,4.26,5.49,7.93,5.49,10.85C132.7,574.72,113.12,580,105.11,580zM96.33,291.71c0.3,0,0.55,0.25,0.55,0.55c0,0,0,0.01,0,0.01c0,33,5.12,139.5,5.17,140.57c-0.11,2.7-0.53,5.39-1.23,8c-1.83,7.53-2.72,15.25-2.65,23c0,15.62,3.45,44.25,3.49,44.53c-0.12,5.57-0.62,11.13-1.48,16.63c-0.55,3.48-0.88,6.98-1,10.5c0,3.14,0.46,7.49,0.9,11.69s0.92,8.62,0.92,11.82c0,1.26-0.11,2.82-0.23,4.47c-0.36,5.2-0.8,11.67,1.6,14.25c0.72,0.77,1.73,1.18,2.78,1.13c8.09,0,26.48-5.28,26.48-14c0-2.57-2.45-6.12-5.29-10.23c-4-5.83-9-13.09-9-20.81c0-5.35,2.64-14.91,5.7-26c4.59-16.58,10.29-37.22,10.29-54.43c0-7.22-0.36-14.44-1.09-21.62c-0.4-4.49-0.79-8.74-0.79-13.88c0-4.19,1.59-10.48,3.78-19.17c5.36-21.2,14.32-56.69,14.32-113.91c0-6.82-2.28-18.91-4.71-31.7c-2.93-15.46-5.95-31.45-5.95-42.41c0-9.86,6.78-51.29,7.07-53c0.02-0.3,0.29-0.53,0.6-0.51s0.53,0.29,0.51,0.6c0,5.93,0.78,23.4,1.35,36.15c0.33,7.45,0.6,13.33,0.6,14.51c0,1.36,0.09,4.16,0.19,7.41c0.13,4.31,0.28,9.19,0.28,12.34c0,3.51,1.55,10.59,3.2,18.09c0.93,4.24,1.89,8.63,2.68,12.83c0.08,0.39,0.26,1.32,0.52,2.61c2.4,12,5.14,26.17,5,28.81c-0.14,2.44-1.95,25.7-2.24,28.53c-0.5,4.87-0.47,13.68,1.17,17.13c2.4,5.06,11.43,7.76,15.81,7.85c1.12,0.04,2.2-0.47,2.87-1.37c4.87-5.78,2.16-26.91,1.59-29.9c-0.06-0.27,0.1-0.54,0.36-0.63c0.26-0.08,0.55,0.03,0.67,0.28c0.05,0.09,4.3,8.55,7,11.77c0.51,0.84,1.58,1.15,2.46,0.71c1-0.71,1.34-2.03,0.82-3.13l0,0c-0.13-0.36-0.36-1.05-0.67-2c-1.85-5.57-6.78-20.35-11.17-24.59c-3.93-3.79-5.38-17.94-4.32-42.05c0-0.91,0.07-1.53,0.07-1.77c0-8.14-0.7-15.33-1.31-21.68c-0.47-5-0.89-9.28-0.89-13.12c0-0.47,0-1.34,0-2.57c0.72-58.51-3.31-95.47-11.34-104.06c-1.25-1.32-2.62-2.52-4.09-3.58c-10-7.27-25.64-10.61-36-12.82c-6.14-1.31-9.39-2-10.38-3c-3-3,0.86-20.67,0.94-20.82c1.33-3.13,2.37-6.38,3.11-9.7c0.42-2,0.6-3.43,0.6-3.45c0.03-0.21,0.17-0.39,0.38-0.46c0.2-0.06,0.42,0,0.57,0.15c0.3,0.42,0.88,0.51,1.3,0.22c0.03-0.02,0.06-0.05,0.09-0.08c0.82-0.63,1.46-1.46,1.85-2.42c0.93-1.81,1.65-3.72,2.13-5.7l0.23-0.89c0.44-1.67,0.77-3.37,1-5.08c0.28-1.71,0.35-3.45,0.21-5.18c-0.17-1.27-0.45-1.59-0.55-1.7c-0.11-0.13-0.16-0.3-0.15-0.47c0,0,0.1-0.65,0.21-1.52c0.36-2.89,0.4-5.82,0.12-8.72c-0.23-2.89-0.85-5.73-1.83-8.45c-0.73-2-1.72-3.9-2.93-5.65c-1.82-2.54-4.18-4.64-6.9-6.17c-4.34-2.26-9.15-3.35-15.34-3.35s-11,1.09-15.25,3.42c-2.72,1.53-5.08,3.63-6.9,6.17c-1.21,1.75-2.2,3.65-2.93,5.65c-0.98,2.72-1.6,5.56-1.83,8.45c-0.28,2.9-0.24,5.83,0.12,8.72c0.11,0.87,0.2,1.52,0.21,1.52c0.02,0.16-0.03,0.32-0.13,0.44c-0.12,0.14-0.4,0.46-0.57,1.73c-0.14,1.73-0.07,3.47,0.21,5.18c0.23,1.71,0.56,3.41,1,5.08l0.23,0.89c0.48,1.98,1.2,3.89,2.13,5.7c0.39,0.96,1.03,1.79,1.85,2.42c0.38,0.35,0.96,0.33,1.31-0.05c0.03-0.03,0.05-0.06,0.08-0.09c0.15-0.15,0.37-0.21,0.57-0.15c0.21,0.07,0.35,0.25,0.38,0.46c0,0,0.18,1.49,0.6,3.45c0.75,3.33,1.79,6.59,3.13,9.73c0.06,0.12,4,17.82,0.92,20.79c-1,1-4.24,1.69-10.38,3c-10.37,2.21-26,5.55-36,12.82c-1.47,1.06-2.84,2.25-4.08,3.57c-8,8.59-12.06,45.55-11.34,104.06c0,1.23,0,2.1,0,2.57c0,3.84-0.42,8.14-0.89,13.12c-0.61,6.35-1.31,13.54-1.31,21.68c0,0.24,0,0.86,0.07,1.77c1.06,24.11-0.39,38.26-4.32,42.05c-4.39,4.24-9.32,19-11.17,24.59c-0.31,0.92-0.54,1.61-0.67,2c-0.53,1.12-0.17,2.46,0.85,3.16c0.88,0.44,1.95,0.13,2.46-0.71c2.68-3.22,6.94-11.68,7-11.77c0.12-0.25,0.41-0.36,0.67-0.28c0.26,0.09,0.42,0.36,0.36,0.63c-0.57,3-3.28,24.12,1.59,29.9c0.68,0.9,1.75,1.41,2.87,1.37c4.38-0.09,13.41-2.79,15.81-7.85c1.64-3.45,1.67-12.26,1.17-17.13c-0.29-2.83-2.1-26.09-2.24-28.53c-0.16-2.64,2.58-16.78,5-28.81c0.26-1.29,0.44-2.22,0.52-2.61c0.79-4.2,1.75-8.59,2.68-12.83c1.65-7.5,3.2-14.58,3.2-18.09c0-3.15,0.15-8,0.28-12.34c0.11-3.25,0.19-6.05,0.19-7.41c0-1.18,0.27-7.06,0.6-14.51c0.57-12.75,1.35-30.22,1.35-36.15c-0.02-0.3,0.2-0.57,0.51-0.6c0.3-0.02,0.57,0.2,0.59,0.51c0.29,1.76,7.07,43.19,7.07,53c0,11-3,27-6,42.41c-2.43,12.79-4.71,24.88-4.71,31.7c0,57.22,9,92.71,14.32,113.91c2.2,8.69,3.82,14.98,3.82,19.19c0,5.14-0.39,9.39-0.79,13.88c-0.73,7.18-1.09,14.4-1.09,21.62c0,17.21,5.7,37.85,10.29,54.43c3.06,11.07,5.7,20.63,5.7,26c0,7.72-5,15-9,20.81c-2.84,4.11-5.29,7.66-5.29,10.23c0,8.69,18.39,14,26.48,14c1.03,0.01,2.01-0.43,2.7-1.2c2.4-2.58,2-9,1.6-14.25c-0.12-1.65-0.23-3.21-0.23-4.47c0-3.2,0.47-7.58,0.92-11.82s0.9-8.55,0.9-11.69c-0.12-3.52-0.45-7.02-1-10.5c-0.86-5.47-1.36-11-1.48-16.54c0-0.35,3.49-29,3.49-44.6c0.07-7.75-0.82-15.47-2.65-23c-0.7-2.61-1.12-5.3-1.23-8c0-1.1,5.17-107.61,5.17-140.6C95.8,292,96.02,291.73,96.33,291.71C96.33,291.71,96.33,291.71,96.33,291.71z"
      />
      <path
        class="bone"
        disabled
        d="M71.65,205c2.93-2.09,8-5.4,9.94-7.62c1.64-1.98,3.16-4.07,4.54-6.24c1.3-1.93,1.85-3.3,0.79-3.92s-2.7,1.07-3.74,2.1s-3.66,4.67-5.93,6.82c-2.06,2-7.07,5.12-10.46,8s-5.87,5.67-5.33,7.36C62.27,214,68.75,207.07,71.65,205z"
      />
      <path
        class="bone"
        disabled
        d="M121.25,205c-2.93-2.09-8-5.4-10-7.62c-1.64-1.98-3.15-4.07-4.53-6.24c-1.31-1.93-1.86-3.3-0.8-3.92s2.71,1.07,3.74,2.1s3.67,4.67,5.93,6.82c2.06,2,7.08,5.12,10.46,8c3.38,2.88,5.87,5.67,5.34,7.36C130.62,214,124.14,207.07,121.25,205z"
      />
      <path
        class="bone"
        disabled
        d="M82.56,111.91c1.73,1.94,6,0.39,6.64-2.07c0.4-1.65-0.17-2.51-1.9-3.21c-15-6-22.78-5.63-35.38-3.5c-4.05,0.69-5.87,1.41-6.1,2.08s0.78,0.88,1.32,2c0.41,0.82-0.25,1.76,0.2,2.3s4.12-0.89,7.65-1.36C63.84,106.91,78.33,107.15,82.56,111.91z"
      />
      <path
        class="bone"
        disabled
        d="M110.09,111.91c-1.72,1.94-6,0.39-6.64-2.07c-0.4-1.65,0.18-2.51,1.9-3.21c15-6,22.78-5.63,35.38-3.5c4.06,0.69,5.87,1.41,6.1,2.08s-0.77,0.88-1.31,2c-0.41,0.82,0.24,1.76-0.21,2.3s-4.12-0.89-7.65-1.36C128.81,106.91,114.33,107.15,110.09,111.91z"
      />
      <path
        class="bone"
        disabled
        d="M86.05,104.07c1.3-0.06,2.42-2.73,0-3.32c-3.44,0-6.88,0.28-10.27,0.86c3.24,0.63,6.44,1.46,9.58,2.49L86.05,104.07z"
      />
      <path
        class="bone"
        disabled
        d="M106.6,104.07h0.66c3.14-1.03,6.34-1.86,9.58-2.49c-3.39-0.58-6.82-0.86-10.26-0.86C104.18,101.34,105.33,104,106.6,104.07z"
      />
      <path
        class="bone"
        d="M5.42,316.19c-0.23-0.25-0.27,0.18-0.34,0.4C5,317.06,4.96,317.53,4.97,318c-0.06,0.43-0.22,0.84-0.48,1.19c-0.29,0.32-0.46,0.74-0.47,1.18c0,0.4,0.32,0.73,0.68,0.48c0.28-0.25,0.5-0.55,0.65-0.89c0.22-0.39,0.38-0.83,0.62-1.21s0.57-0.44,0.9-0.67s0.63-0.51,0.39-0.63C6.55,317.2,5.91,316.77,5.42,316.19z"
      />
      <path
        class="bone"
        d="M22.23,317.35c0.22-0.09,0.38-0.27,0.44-0.5c0.11-0.55,0.09-1.12-0.07-1.66c-0.66-2.67-0.51-5.47,0.43-8.06c0.23-0.63,0.31-1.12,0.52-1.76c0.15-0.4,0.15-0.84,0-1.24c-0.4-0.83-1.14-0.73-1.77-0.5c-0.3,0.14-0.57,0.34-0.78,0.6c-0.51,0.81-0.64,1.8-0.36,2.71c0.2,1.2,0.15,2.42-0.13,3.6c-0.15,1.13-0.38,2.25-0.67,3.35c-0.29,0.9-1,2.1-0.55,3.05l0,0C20.11,317.63,21.25,317.79,22.23,317.35z"
      />
      <path
        class="bone"
        d="M15.66,300c-0.29-0.35-0.53-0.78-0.83-1.13c-0.52-0.61-0.93-1.05-1.44-0.25c-0.42,0.91-0.77,1.84-1.06,2.8c-0.42,0.95-0.96,1.85-1.61,2.66c-0.56,0.64-1.42,1-1.76,1.83c-0.08,0.18-0.14,0.36-0.17,0.55c-0.01,0.07-0.01,0.15,0,0.22c0.39,0.67,0.97,1.21,1.67,1.55c0.67,0.35,1.47,0.35,2.14,0c0.06-0.08,0.1-0.16,0.13-0.25c0.12-0.47,0.17-0.95,0.16-1.43c0.05-0.55,0.18-1.1,0.39-1.61c0.35-1.05,0.94-2,1.72-2.78c0.4-0.33,1.56-0.47,1.43-1.18C16.33,300.59,15.89,300.23,15.66,300z"
      />
      <path
        class="bone"
        d="M9.56,308.81c-0.7-0.33-0.79-0.78-1.23-1.15c-0.44-0.37-0.51,0.48-0.55,0.7c-0.18,1.67-0.52,3.31-1,4.92c-0.25,0.51-1.43,1.45-1.33,1.87s2,1.77,2.5,1.63c0.29-0.08,0.18-0.64,0.18-0.92c-0.05-0.87,0.13-1.74,0.53-2.52c0.33-0.8,0.83-1.52,1.46-2.12c0.54-0.42,1.32-0.73,1.41-1.61C11.58,308.89,10.45,309.23,9.56,308.81z"
      />
      <path
        class="bone"
        d="M19,301.53c-1.22-0.27-2.21-0.17-2.45,1c-0.03,0.48-0.02,0.97,0.05,1.45c0.08,1.32-0.08,2.64-0.45,3.91c-0.3,1.32-0.34,2.72-0.73,4s-1.4,2.28-1.92,3.55c-0.16,0.35-0.18,0.75-0.06,1.12c0.11,0.3,0.37,0.53,0.69,0.59c0.74,0.18,1.51,0.26,2.27,0.25c0.28-0.01,0.54-0.13,0.72-0.34c0.21-0.27,0.35-0.59,0.38-0.93c0.04-0.69,0.02-1.38-0.07-2.06c-0.06-0.84-0.06-1.68,0-2.52c0.12-1.75,0.61-3.46,1.45-5c0.29-0.65,0.63-1.28,1-1.88c0.37-0.43,0.63-0.94,0.78-1.49C20.88,302.05,19.97,301.74,19,301.53z"
      />
      <path
        class="bone"
        d="M28.12,316c0.31-0.26,0.43-0.68,0.31-1.07c-0.2-0.47-0.43-0.92-0.69-1.36c-0.34-1.01-0.5-2.07-0.46-3.13c-0.06-0.8-0.28-2.67-0.29-3.45c0-1,0.55-2.34,0.21-3.34s-2-1-2.72-0.5c-0.93,0.66-0.13,1.67,0.19,2.5c0.13,0.52,0.22,1.04,0.29,1.57c0.41,1.98,0.44,4.01,0.1,6c-0.09,0.51-0.1,1.03-0.05,1.54c0.06,0.52,0.39,0.98,0.86,1.22c0.46,0.26,0.99,0.37,1.51,0.32C27.65,316.27,27.9,316.16,28.12,316z"
      />
      <path
        class="bone"
        d="M33.26,321.56c-0.72,0.37-1.54,0.47-2.32,0.3c-0.2-0.07-0.32-0.28-0.28-0.49c0.1-0.45,0.41-0.94,0.45-1.36c0.02-0.69-0.14-1.38-0.45-2c-0.34-0.6-0.65-1.22-0.93-1.85c-0.12-0.39-0.14-0.78,0.1-0.75c0.46,0.19,0.94,0.33,1.43,0.4l0,0c0.42-0.1,0.83-0.24,1.22-0.43c0.17,0,0.11,0.6,0.07,0.84c-0.09,0.39-0.12,0.78-0.1,1.18c0.03,0.51,0.08,1.02,0.17,1.53c0.06,0.3,0.17,0.59,0.32,0.86C33.27,320.37,33.75,321.4,33.26,321.56z"
      />
      <path
        class="bone"
        d="M33.33,326.61c0.42-0.18,0-0.81-0.14-1.09c-0.27-0.32-0.44-0.72-0.47-1.14c0-0.44,0.29-0.83,0.21-1.28s-0.55-0.52-0.92-0.38c-0.37,0.14-1.13-0.17-1.34,0s0.2,0.85,0.34,1.13c0.18,0.39,0.28,0.82,0.28,1.26c-0.04,0.41-0.04,0.83,0,1.24c0.01,0.07,0.04,0.14,0.09,0.19C31.98,326.88,32.71,326.91,33.33,326.61z"
      />
      <path
        class="bone"
        d="M28.33,326.16c0.18-0.09,0.29-0.27,0.28-0.47c-0.11-0.57-0.29-1.13-0.54-1.65c-0.28-1.03-0.42-2.09-0.39-3.16c0.17-0.9,0.38-1.79,0.64-2.67c0.16-0.9-0.42-1-1.19-1h-0.8c-0.62,0-1.53-0.25-1.74,0.58s0.36,2,0.72,2.76c0.47,0.82,0.65,1.78,0.51,2.71c-0.31,0.84-0.51,1.72-0.62,2.61c0.01,0.19,0.15,0.35,0.33,0.39C26.45,326.52,27.43,326.49,28.33,326.16z"
      />
      <path
        class="bone"
        d="M27.94,327.49c-0.17,0-0.6,0.19-0.92,0.2h-0.09c-0.44-0.02-0.87-0.1-1.29-0.22c-0.09-0.01-0.17,0.02-0.24,0.07c-0.69,0.42-0.15,1.09,0.2,1.76c0.36,0.77,0.47,1.64,0.3,2.47c-0.2,0.73-0.26,1.48-0.17,2.23c0.19,0.61,1.07,0.5,1.55,0.56s1.12,0.33,1.2-0.32s-0.55-1.43-0.56-2.11s-0.18-1.29-0.21-2s0.51-1.18,0.52-1.81C28.24,327.92,28.12,327.54,27.94,327.49z"
      />
      <path
        class="bone"
        d="M15.94,327.28c0.21-0.24,0.34-0.53,0.39-0.84c0.18-0.9-0.42-1.79-0.53-2.7c-0.13-0.84,0-1.7,0.37-2.46c0.34-0.72,1.23-1.5,0.87-2.25c-0.21-0.59-0.84-0.91-1.44-0.73c-1.43,0.2-2.32-0.51-2.39,0.5c0.02,0.94,0.18,1.87,0.46,2.77c0.23,0.86,0.3,1.76,0.21,2.65c-0.07,0.5-0.19,0.99-0.36,1.46c-0.12,0.38-0.42,0.8-0.32,1.19c0.04,0.12,0.09,0.23,0.17,0.33C14.16,327.65,15.12,327.68,15.94,327.28z"
      />
      <path
        class="bone"
        d="M15.6,335.2c-0.39,0.2-0.82,0.32-1.26,0.34c-0.18,0.01-0.36-0.01-0.54-0.06c-0.13,0-0.28-0.13-0.33-0.14s-0.1,0-0.12,0.07c-0.39,0.6,0.61,1.2,0.55,1.93s-0.08,1.87,0.84,1.82c0.38-0.06,0.69-0.32,0.82-0.68c0.11-0.42,0.01-0.88-0.27-1.21c-0.19-0.32-0.35-0.54-0.12-0.88c0.28-0.27,0.49-0.59,0.63-0.95C15.85,335.09,15.6,335.2,15.6,335.2z"
      />
      <path
        class="bone"
        d="M14,334.76c0.61,0.05,1.22-0.13,1.7-0.51c0.05-0.39-0.02-0.79-0.21-1.14c-0.26-0.59-0.33-1.25-0.22-1.89c0.12-0.77,1.52-2.79,0.51-3c-0.65,0.05-1.29,0.15-1.92,0.29c-0.6,0-0.8,0.35-0.75,1s0.47,0.91,0.57,1.6c0.08,0.64,0.02,1.29-0.17,1.91l-0.07,0.22c-0.04,0.36-0.04,0.72,0,1.08l0,0C13.56,334.54,13.76,334.69,14,334.76z"
      />
      <path
        class="bone"
        d="M20.11,335.73c0.67,0,1.34-0.03,2-0.11c0.1-0.05,0.18-0.13,0.24-0.23c0.25-0.52-0.1-1.52-0.17-2.06c-0.13-0.7-0.23-1.4-0.28-2.11c0-0.7,0.43-1.11,0.58-1.74s-0.06-0.92-0.7-0.83c-0.35,0.11-0.71,0.2-1.07,0.27c-0.39,0-0.7-0.23-1-0.15c-0.81,0.19-0.57,1-0.23,1.55c0.44,0.73,0.93,1.19,0.89,2.12c-0.02,0.77-0.2,1.52-0.54,2.21C19.83,334.65,19.24,335.64,20.11,335.73z"
      />
      <path
        class="bone"
        d="M41.33,217.7c0.66-3.54-3.71-6.66-4.06-11.65s2.2-67.68,4.37-71.72c0.67-1.37,1.65-2.57,2.86-3.49c3.08-2.44,4.39-6.5,3.32-10.29c-1.16-4.36-4.21-6-7.59-6c-1.7-0.02-3.24,0.99-3.9,2.55c-1.17-0.33-3.46-0.2-3.8,2c-0.46,4.66-0.4,9.35,0.16,14c0.68,4.75-1.27,42.89-1.68,53.24c-0.36,9.16-1.48,17.08-4.08,20.65s-5.76,4.75-5.56,8.11c0.18,3.15,3.54,6.27,6.31,5.21c1.67-0.63,2-1.2,2.57-1.33c0.29-0.06,0.56-0.58,1.27,0.13c0.69,0.7,1.53,1.23,2.46,1.56C36.33,221.47,40.51,222.18,41.33,217.7z"
      />
      <path
        class="bone"
        d="M22.17,337.68c0.16-0.37,0.55-0.81,0.18-1.19s-0.73,0-1.11,0h-0.28c-0.33,0-1,0-1.1,0.47s0.38,0.73,0.55,1c0.25,0.41,0.4,0.87,0.43,1.35c-0.06,0.47,0,0.96,0.18,1.4c0.23,0.35,0.53,0.69,0.95,0.58c0.43-0.14,0.71-0.55,0.69-1C22.63,339.42,21.79,338.57,22.17,337.68z"
      />
      <path
        class="bone"
        d="M28.15,336.58c0.16-0.34,0.21-0.31,0.16-0.75s-0.62-0.44-1-0.23l-0.35-0.05c-0.3,0-0.85-0.06-1,0.34s0.34,0.67,0.49,0.94c0.23,0.37,0.36,0.79,0.38,1.23c-0.07,0.43-0.02,0.87,0.15,1.27c0.2,0.31,0.47,0.63,0.87,0.54c0.4-0.13,0.67-0.51,0.65-0.93C28.56,338.16,27.79,337.37,28.15,336.58z"
      />
      <path
        class="bone"
        d="M33.63,327.39c-0.34-0.13-0.75,0.32-1,0.25l-0.42-0.2c-0.32-0.06-0.77-0.25-0.91,0.08s0.27,0.6,0.39,0.85c0.18,0.34,0.27,0.71,0.26,1.09c0,0.37-0.16,0.77,0,1.09c0.16,0.32,0.4,0.58,0.77,0.54c0.37-0.06,0.65-0.37,0.68-0.75c0-0.67-0.6-1.41-0.2-2.06C33.41,328,34.02,327.54,33.63,327.39z"
      />
      <path
        class="bone"
        d="M22.71,319.85c0.1-0.8-0.35-1.15-1.14-1.39c-0.61-0.22-1.29-0.15-1.83,0.21c-0.73,0.45-0.35,1.21-0.16,1.85c0.26,0.84,0.38,1.72,0.34,2.6c-0.07,0.89-0.14,1.77-0.15,2.67c-0.03,0.24-0.09,0.47-0.16,0.7c0,0.68-0.12,1.4,0.7,1.53c0.79,0.11,1.59-0.17,2.13-0.75c0.42-0.64-0.11-1.32-0.25-2c-0.17-0.89-0.2-1.81-0.08-2.71C22.22,321.64,22.6,320.78,22.71,319.85z"
      />
      <path
        class="bone"
        d="M32.39,314.47c0.67-0.86,0.09-2-0.33-2.81c-0.48-0.91-0.8-1.91-0.93-2.93c-0.2-1.15-0.31-2.31-0.32-3.47c0.03-0.52,0.08-1.04,0.17-1.56c0.1-0.39,0.08-0.81-0.06-1.19c-0.44-0.85-1.86-0.61-2.52-0.28c-1.06,0.54-0.44,1.39,0,2.23c0.97,2.2,1.36,4.61,1.12,7c-0.17,1-0.39,2.17,0.31,3c0.61,0.71,1.67,0.79,2.38,0.19C32.28,314.59,32.34,314.53,32.39,314.47z"
      />
      <path
        class="bone"
        d="M32.19,223.46c1.08,0.71,2.43,0.85,3.63,0.39c1.1-0.42,1.9-0.8,1.95,0.55c0.09,2.3-1.49,2.17-2,8.84s-1.57,20.13-1.34,25.18s-1.49,15.91-2.16,20.63c-0.67,4.72-1.33,5.71-1.27,7.86c0,0.94,0.15,3.34-0.35,4.48c-0.16,0.35-0.55,0.52-0.92,0.41c-0.28-0.08-0.64-0.18-1.07-0.28c-1.29-0.69-2.45-2-1.64-5.48c1.13-5.65,1.95-11.36,2.46-17.1c0.34-4-0.33-16.9-0.67-21.13l-0.68-13.42c-0.61,3.55-1.87,10.43-3.18,17.43s0,32.36,1,37.27c0.12,0.46,0.18,0.93,0.18,1.4c-0.02,0.3-0.28,0.53-0.58,0.51c-0.01,0-0.02,0-0.04,0c-0.84-0.1-1.68-0.1-2.52,0c-1.43,0.24-2.83,0.65-4.17,1.23c-0.54,0.22-1.15-0.04-1.37-0.58c-0.03-0.07-0.05-0.15-0.06-0.23c0-1.29,0.12-2.58,0.36-3.85c0.26-2.8,1.71-8.55,1.91-15.28s0.19-19.76,2.69-30.74c2-8.64,2.46-13.78,1-15.89s-1.08-3.21,1.28-2.78c0.91,0.4,1.94,0.4,2.85,0c0.8-0.39,1.67-0.63,2.56-0.7C30.67,222.28,31.33,222.92,32.19,223.46z"
      />
      <path
        class="bone"
        d="M30.72,295.42c-0.09-0.49-0.38-0.93-0.8-1.2c-1.94-0.62-3.97-0.92-6-0.87c-1.23,0.17-2.43,0.48-3.58,0.93l-1,0.57c-0.72,0.58-1.53,1.06-2.39,1.41c-0.57,0.23-1.02,0.68-1.25,1.25c0,0.14,0.02,0.29,0.05,0.43c0,0,0,0,0,0.06c0.36,0.8,0.84,1.53,1.44,2.16c0.42,0.09,0.85,0.14,1.28,0.14c0.92-0.06,1.83,0.14,2.64,0.58c0.13,0.1,0.25,0.21,0.36,0.33c0.52,0.61,1.31,0.91,2.1,0.8c0.74-0.07,1.46-0.27,2.12-0.6c0.72-0.34,1.48-0.57,2.27-0.68c1-0.12,1.39,0.06,2.38-0.06s0.53-4.51,0.53-4.51C30.81,295.9,30.76,295.66,30.72,295.42z"
      />
      <path
        class="bone"
        disabled
        d="M87.23,571c-1.09-0.39-2.69-0.45-3.42,0.39c-0.14,0.25-0.21,0.53-0.2,0.82c0,0.58,0.73,0.83,0.86,1.36c0.18,0.77-0.67,1.18-0.79,1.86c-0.24,1.38,1.77,1.62,2.53,1.14c0.56-0.37,0.47-1,0.73-1.54s0.65-0.63,1-1.11c0.63-0.9,0.41-2.15-0.49-2.79C87.38,571.08,87.31,571.04,87.23,571z"
      />
      <path
        class="bone"
        disabled
        d="M79.26,548.15c-0.71,0.4-0.43,1.17-0.51,1.9c-0.23,1.72-0.59,3.42-1.09,5.09c-0.09,0.29-0.2,0.58-0.33,0.86c-0.34,0.62-0.12,1.4,0.5,1.74c0.21,0.12,0.44,0.17,0.68,0.16c0.39,0,0.77-0.11,1.09-0.32c0.6-0.33,0.66-0.7,0.57-1.37c-0.42-3.2,1.4-6.72,1-7.39c-0.28-0.69-1.07-1.02-1.76-0.74C79.36,548.1,79.31,548.12,79.26,548.15z"
      />
      <path
        class="bone"
        disabled
        d="M71.04,564.15c-0.06-0.07-0.27-0.19-0.31-0.1c-0.42,0.81,0.09,1.55-0.41,2.41c-0.28,0.64-0.6,1.26-0.95,1.86c-0.22,0.29-0.46,0.35-0.53,0.77s0.08,0.8,0,1.19s-0.3,0.68-0.07,1s0.52,0.26,0.73,0c0.5-0.63,0.09-1.36,1.06-1.63c0.08-0.4,0-0.79,0-1.18c0.14-0.32,0.3-0.62,0.49-0.91c0.28-0.55,0.39-1.23,1-1.45c0.41-0.15,0.67,0,0.95-0.4s0.1-0.57-0.21-0.88c-0.22-0.15-0.49-0.23-0.76-0.24c-0.5,0-0.77,0.06-0.88-0.19S71.17,564.31,71.04,564.15z"
      />
      <path
        class="bone"
        disabled
        d="M68.8,563.15c-0.37-0.57-0.64,0-1.25-0.27c0,0,0-0.17-0.06-0.22s-0.31-0.3-0.39-0.27c-0.85,0.26,0.18,1.37-0.31,2.16c-0.3,0.57-0.63,1.11-1,1.64c-0.21,0.26-0.43,0.3-0.51,0.67s0,0.73,0,1.09s-0.3,0.6-0.1,0.93s0.46,0.26,0.66,0c0.48-0.56,0.14-1.24,1-1.43c0.1-0.37,0-0.73,0.1-1.08c0.14-0.28,0.3-0.55,0.49-0.8c0.27-0.49,0.41-1.11,1-1.28c0.37-0.12,0.38,0.14,0.54-0.31C69.07,563.69,69.01,563.37,68.8,563.15z"
      />
      <path
        class="bone"
        disabled
        d="M65.42,562.8c-0.37,0.1-0.47,0.51-0.67,0.84c-0.13,0.16-0.25,0.34-0.35,0.52c-0.08,0.24,0,0.48-0.09,0.72c-0.6,0.11-0.39,0.58-0.73,1c-0.14,0.15-0.31,0.19-0.44,0s0-0.43,0.09-0.63s0-0.5,0-0.73s0.21-0.27,0.36-0.44c0.25-0.35,0.47-0.71,0.68-1.08c0.35-0.52-0.35-1.23,0.22-1.39c0.09,0,0.18,0.05,0.24,0.12c0.04,0.09,0.09,0.17,0.15,0.25c0.32,0.25,0.67-0.06,1,0.28C65.96,562.18,66.22,562.6,65.42,562.8z"
      />
      <path
        class="bone"
        disabled
        d="M74.7,571.63c0.2-0.86,0.25-1.75,0.14-2.63c0.02-0.32,0.19-0.62,0.46-0.79c0.37-0.27,0.81-0.42,1.27-0.44c0.3,0.07,0.58,0.21,0.82,0.4c0.3,0.24,0.44,0.63,0.36,1c-0.08,0.29-0.18,0.57-0.3,0.84c-0.46,1.16-0.58,2.42-1,3.61c-0.2,0.55-1.75,1.14-2.17,0.14C73.91,572.91,74.33,572.34,74.7,571.63z"
      />
      <path
        class="bone"
        disabled
        d="M85.33,536.23c1.59,0.13,3.33,1.07,3.53,2.69c0.28,1.46,1.08,2.77,2.26,3.68c0.79,0.7,1.23,1.71,1.21,2.77c0.06,1.81,0.09,5.29-1.69,5.23c-1.1-0.15-2.1-0.75-2.74-1.66c-0.93-1.05-2.66-1.35-4.89-1.19c-1.64,0.11-3.14-1.35-5.06-1.19s-2.39,1-3.72,1.41s-1.86-1.05-0.86-2c0.93-0.71,1.92-1.33,2.96-1.88c2.81-1.58,2-4.63,2.4-5.76C79.26,536.74,83.43,536.08,85.33,536.23z"
      />
      <path
        class="bone"
        disabled
        d="M88.61,563.65c0.74,1.13,1.55,2.89,0.15,2.81c-0.59-0.86-1.34-1.6-2.21-2.17c-1-0.43-2,0.51-3,1.63c-0.29,0.1-0.35-0.08-0.46-0.36c-0.43-1.12,0.36-2.78,0.45-3.91c0.12-1.51-0.54-2.54-1-3.92c-0.46-1.54,0.09-2.1,0.09-2.1s1.88-2,3.66-1.63c0.44,0.1,0.84,0.34,1.14,0.68c0.59,0.59,0.94,1.37,1,2.2c0.05,1.01-0.03,2.01-0.23,3C87.96,561.37,87.79,562.4,88.61,563.65z"
      />
      <path
        class="bone"
        disabled
        d="M82.38,554.35c0.05,0.07,0.15,0.09,0.22,0.04c0.01-0.01,0.03-0.02,0.04-0.04c0.68-0.83,1.63-1.38,2.69-1.55c1.28-0.15,3.24,1.3,3.53,1.67s0.43-0.44,0.37-0.9c-0.21-1.5-1.22-3.51-2.35-4.09c-1.17-0.54-2.51-0.6-3.72-0.15c-0.59,0.25-1.07,0.71-1.33,1.3c-0.3,0.62-0.37,1.33-0.19,2C81.79,553.24,82.04,553.82,82.38,554.35z"
      />
      <path
        class="bone"
        disabled
        d="M74.33,556.18c-0.32-0.23,2-7.83,2-7.83c0.13-0.17,0.32-0.28,0.53-0.32c1.48-0.39,1.21,0.1,1.21,0.1c-1.29,2.44-1.53,7.33-1.87,7.89C76.25,556,75.72,557.13,74.33,556.18z"
      />
      <path
        class="bone"
        disabled
        d="M71.25,552.31c0.29-0.81,0.64-1.57,0.94-2.38l0.13-0.13c0.11,0,0.74-0.32,0.61,0.07s-0.88,2.5-0.88,2.5c-0.37,0.88-0.66,1.68-0.76,1.79s-0.59,0.28-0.7,0C70.33,553.53,71.06,552.84,71.25,552.31z"
      />
      <path
        class="bone"
        disabled
        d="M74.97,549.58c-0.15,0.36-1.79,5.79-1.86,6s-0.54,0-0.74-0.24c-0.6-0.66,0.21-1.43,0.33-2.15v-0.16c0,0,1-3.17,1-3.37S75.11,549.21,74.97,549.58z"
      />
      <path
        class="bone"
        disabled
        d="M76.8,564.52c-0.31,0.04-0.62,0.11-0.91,0.21c-0.1,0.04-0.21-0.01-0.24-0.11c0-0.01,0-0.01-0.01-0.02c-0.28-1.08,0.87-2,1-3.25s-0.45-2.77,1.33-2.38c0.41-0.01,0.82,0.01,1.23,0.06c0.36,0.13,0.58,0.26,0.55,0.65l-0.42,5.24c0,0-0.06,0.38-0.78,0.07l-0.54-0.25C77.64,564.55,77.22,564.48,76.8,564.52z"
      />
      <path
        class="bone"
        disabled
        d="M71.74,562.6c0.09-0.41,0.25-0.8,0.46-1.17c0.1-0.4,0.29-0.77,0.57-1.08c0.27-0.39,0.51-0.81,0.71-1.24c0.2-0.42,0.09-1.19,0.51-1.36c0.49-0.09,1-0.01,1.45,0.22c0.13,0.33-0.24,0.85-0.45,1.32c-0.42,1-1,1.91-1.41,2.89s-0.39,1.43-0.78,1.44l-0.82-0.46C71.85,563,71.76,562.81,71.74,562.6z"
      />
      <path
        class="bone"
        disabled
        d="M75.08,566.21c0,0-0.41,0.35-0.35,0.61s0.45,0.31,0.45,0.31c0.45-0.27,0.98-0.39,1.5-0.36c0.57,0.16,1.1,0.43,1.55,0.81c0.34,0.23,0.52-0.27,0.51-0.81c-0.01-0.43-0.26-0.82-0.65-1c-0.21-0.1-0.44-0.17-0.67-0.21c-0.83,0-1.64,0.24-2.34,0.69"
      />
      <path
        class="bone"
        disabled
        d="M72.38,557.33c-0.32,0.93-1,1.36-1.55,2.12c-0.28,0.39-0.51,0.81-0.67,1.26c-0.15,0.43-0.43,1.28-0.68,1.34s-1.49-0.13-1.5-0.38s3.18-5,3.45-5.31S72.62,556.61,72.38,557.33z"
      />
      <path
        class="bone"
        disabled
        d="M66.69,561.21c-0.2,0-1.48-0.21-1.55-0.53s1.49-2.06,2.5-2.86s1.12-2,2.13-2.48c0.42-0.2,1.12,0.07,0.83,0.54s-3.51,5-3.51,5C66.97,561,66.83,561.11,66.69,561.21z"
      />
      <path
        class="bone"
        disabled
        d="M87.14,569.82c0,0,0.22,0,0.26,0s1.59-0.49,1.28-1.63s-2.06-2.77-2.57-2.64c0,0-0.66-0.15-1.83,1.3c-0.35,0.42-0.58,0.93-0.66,1.47c-0.05,0.41,0.17,0.81,0.54,1c0.39-0.06,0.78-0.09,1.17-0.1c0.54,0.11,1.05,0.33,1.5,0.66C86.94,569.9,87.05,569.88,87.14,569.82z"
      />
      <path
        class="bone"
        d="M187.26,316.19c0.23-0.25,0.27,0.18,0.34,0.4c0.07,0.46,0.11,0.92,0.1,1.39c0.06,0.43,0.23,0.84,0.49,1.19c0.29,0.32,0.46,0.74,0.46,1.18c0,0.4-0.31,0.73-0.67,0.48c-0.28-0.25-0.5-0.55-0.65-0.89c-0.22-0.39-0.39-0.83-0.62-1.21s-0.57-0.44-0.91-0.67s-0.62-0.51-0.38-0.63C186.13,317.18,186.77,316.76,187.26,316.19z"
      />
      <path
        class="bone"
        d="M170.44,317.35c-0.22-0.09-0.38-0.27-0.44-0.5c-0.1-0.55-0.08-1.12,0.08-1.66c0.65-2.67,0.5-5.47-0.43-8.06c-0.24-0.63-0.32-1.12-0.53-1.76c-0.16-0.4-0.16-0.84,0-1.24c0.4-0.83,1.14-0.73,1.76-0.5c0.31,0.14,0.58,0.34,0.79,0.6c0.51,0.81,0.64,1.8,0.35,2.71c-0.19,1.2-0.14,2.42,0.14,3.6c0.15,1.13,0.38,2.25,0.67,3.35c0.29,0.9,1,2.1,0.55,3.05l0,0C172.56,317.63,171.42,317.79,170.44,317.35z"
      />
      <path
        class="bone"
        d="M177.02,300c0.29-0.35,0.53-0.78,0.83-1.13c0.52-0.61,0.93-1.05,1.44-0.25c0.42,0.93,0.79,1.88,1.09,2.85c0.41,0.96,0.95,1.85,1.61,2.66c0.55,0.64,1.42,1,1.76,1.83c0.08,0.18,0.14,0.36,0.17,0.55c0.01,0.07,0.01,0.15,0,0.22c-0.39,0.67-0.97,1.21-1.67,1.55c-0.67,0.35-1.46,0.35-2.13,0c-0.06-0.08-0.1-0.16-0.14-0.25c-0.11-0.47-0.16-0.95-0.15-1.43c-0.05-0.55-0.18-1.1-0.39-1.61c-0.35-1.05-0.94-2-1.72-2.78c-0.4-0.33-1.56-0.47-1.44-1.18C176.33,300.59,176.79,300.23,177.02,300z"
      />
      <path
        class="bone"
        d="M183.12,308.81c0.7-0.33,0.79-0.78,1.22-1.15s0.51,0.48,0.55,0.7c0.18,1.67,0.52,3.31,1,4.92c0.25,0.51,1.43,1.45,1.33,1.87s-2,1.77-2.5,1.63c-0.29-0.08-0.19-0.64-0.19-0.92c0.06-0.87-0.13-1.74-0.53-2.52c-0.33-0.8-0.82-1.52-1.45-2.12c-0.54-0.42-1.32-0.73-1.41-1.61C181.09,308.89,182.23,309.23,183.12,308.81z"
      />
      <path
        class="bone"
        d="M173.67,301.53c1.23-0.27,2.21-0.17,2.46,1c0.03,0.48,0.02,0.97-0.05,1.45c-0.08,1.32,0.08,2.64,0.45,3.91c0.29,1.32,0.33,2.72,0.73,4s1.4,2.28,1.91,3.55c0.16,0.35,0.19,0.75,0.07,1.12c-0.11,0.31-0.38,0.53-0.7,0.59c-0.74,0.18-1.5,0.26-2.26,0.25c-0.28-0.01-0.55-0.13-0.73-0.34c-0.21-0.27-0.34-0.59-0.37-0.93c-0.04-0.69-0.02-1.38,0.06-2.06c0.07-0.84,0.07-1.68,0-2.52c-0.12-1.75-0.61-3.45-1.44-5c-0.3-0.64-0.63-1.27-1-1.88c-0.37-0.43-0.64-0.94-0.79-1.49C171.8,302.05,172.7,301.74,173.67,301.53z"
      />
      <path
        class="bone"
        d="M164.56,316c-0.31-0.26-0.43-0.68-0.31-1.07c0.2-0.47,0.42-0.92,0.68-1.36c0.35-1.01,0.5-2.07,0.46-3.13c0.07-0.8,0.29-2.67,0.29-3.45c0-1-0.55-2.34-0.2-3.34s2-1,2.71-0.5c0.93,0.66,0.14,1.67-0.19,2.5c-0.12,0.52-0.22,1.04-0.28,1.57c-0.42,1.98-0.45,4.01-0.1,6c0.08,0.51,0.09,1.03,0.05,1.54c-0.07,0.52-0.39,0.98-0.86,1.22c-0.46,0.26-0.99,0.37-1.51,0.32C165.03,316.27,164.78,316.16,164.56,316z"
      />
      <path
        class="bone"
        d="M159.42,321.56c0.72,0.37,1.54,0.47,2.32,0.3c0.2-0.07,0.32-0.28,0.28-0.49c-0.1-0.45-0.41-0.94-0.46-1.36c-0.01-0.69,0.14-1.38,0.45-2c0.35-0.6,0.66-1.21,0.94-1.85c0.11-0.39,0.14-0.78-0.1-0.75c-0.46,0.2-0.94,0.33-1.44,0.4l0,0c-0.42-0.09-0.83-0.24-1.22-0.43c-0.17,0-0.11,0.6-0.07,0.84c0.08,0.39,0.11,0.78,0.1,1.18c-0.03,0.51-0.09,1.02-0.18,1.53c-0.06,0.3-0.16,0.59-0.31,0.86C159.4,320.37,158.93,321.4,159.42,321.56z"
      />
      <path
        class="bone"
        d="M159.33,326.61c-0.42-0.18-0.05-0.81,0.15-1.09c0.27-0.32,0.44-0.72,0.47-1.14c0-0.44-0.29-0.83-0.21-1.28s0.54-0.52,0.92-0.38s1.12-0.17,1.34,0s-0.2,0.85-0.35,1.13c-0.18,0.4-0.27,0.83-0.27,1.26c0.04,0.41,0.04,0.83,0,1.24c-0.02,0.07-0.05,0.13-0.09,0.19C160.69,326.88,159.96,326.91,159.33,326.61z"
      />
      <path
        class="bone"
        d="M164.33,326.16c-0.18-0.09-0.29-0.27-0.28-0.47c0.1-0.57,0.28-1.13,0.53-1.65c0.28-1.03,0.42-2.09,0.39-3.16c-0.16-0.9-0.37-1.79-0.63-2.67c-0.16-0.9,0.42-1,1.19-1h0.8c0.62,0,1.52-0.25,1.74,0.58s-0.36,2-0.72,2.76c-0.47,0.82-0.65,1.77-0.51,2.71c0.31,0.84,0.51,1.72,0.62,2.61c-0.01,0.19-0.15,0.35-0.33,0.39C166.21,326.52,165.23,326.49,164.33,326.16z"
      />
      <path
        class="bone"
        d="M164.73,327.49c0.18,0,0.61,0.19,0.93,0.2h0.08c0.44-0.02,0.87-0.1,1.29-0.22c0.09-0.01,0.18,0.02,0.25,0.07c0.69,0.42,0.15,1.09-0.21,1.76c-0.35,0.77-0.45,1.64-0.29,2.47c0.19,0.73,0.25,1.48,0.17,2.23c-0.19,0.61-1.08,0.5-1.55,0.56s-1.12,0.33-1.2-0.32s0.55-1.43,0.56-2.11s0.18-1.29,0.2-2s-0.5-1.18-0.51-1.81C164.44,327.92,164.56,327.54,164.73,327.49z"
      />
      <path
        class="bone"
        d="M176.74,327.28c-0.21-0.24-0.34-0.53-0.39-0.84c-0.18-0.9,0.41-1.79,0.53-2.7c0.12-0.84-0.01-1.69-0.37-2.46c-0.34-0.72-1.24-1.5-0.87-2.25c0.21-0.58,0.84-0.9,1.43-0.73c1.43,0.2,2.33-0.51,2.4,0.5c-0.02,0.94-0.18,1.87-0.46,2.77c-0.23,0.86-0.3,1.76-0.21,2.65c0.06,0.5,0.18,0.99,0.35,1.46c0.13,0.38,0.43,0.8,0.32,1.19c-0.03,0.12-0.08,0.23-0.16,0.33C178.52,327.65,177.56,327.68,176.74,327.28z"
      />
      <path
        class="bone"
        d="M177.08,335.2c0.39,0.2,0.82,0.32,1.26,0.34c0.18,0.01,0.36-0.01,0.54-0.06c0.13,0,0.27-0.13,0.33-0.14s0.09,0,0.12,0.07c0.39,0.6-0.61,1.2-0.56,1.93s0.09,1.87-0.83,1.82c-0.38-0.06-0.69-0.32-0.82-0.68c-0.11-0.42-0.02-0.87,0.26-1.21c0.19-0.32,0.36-0.54,0.13-0.88c-0.28-0.27-0.49-0.59-0.63-0.95C176.82,335.09,177.08,335.2,177.08,335.2z"
      />
      <path
        class="bone"
        d="M178.68,334.76c-0.61,0.06-1.22-0.13-1.7-0.51c-0.05-0.39,0.02-0.79,0.21-1.14c0.25-0.6,0.33-1.25,0.22-1.89c-0.12-0.77-1.53-2.79-0.51-3c0.65,0.06,1.29,0.15,1.92,0.29c0.6,0,0.79,0.35,0.75,1s-0.48,0.91-0.58,1.6c-0.07,0.64-0.01,1.29,0.18,1.91l0.07,0.22c0.04,0.36,0.04,0.72,0,1.08l0,0C179.13,334.54,178.92,334.7,178.68,334.76z"
      />
      <path
        class="bone"
        d="M172.57,335.73c-0.67,0-1.34-0.03-2-0.11c-0.1-0.05-0.18-0.13-0.24-0.23c-0.26-0.52,0.1-1.52,0.17-2.06c0.13-0.7,0.23-1.4,0.28-2.11c0-0.7-0.44-1.11-0.58-1.74s0.06-0.92,0.7-0.83c0.35,0.11,0.7,0.2,1.06,0.27c0.4,0,0.71-0.23,1-0.15c0.81,0.19,0.57,1,0.22,1.55c-0.44,0.73-0.92,1.19-0.88,2.12c0.01,0.77,0.2,1.52,0.54,2.21C172.84,334.65,173.44,335.64,172.57,335.73z"
      />
      <path
        class="bone"
        d="M170.51,337.68c-0.16-0.37-0.55-0.81-0.19-1.19s0.73,0,1.12,0h0.28c0.33,0,1,0,1.1,0.47s-0.39,0.73-0.55,1c-0.25,0.41-0.4,0.87-0.44,1.35c0.06,0.47,0.01,0.96-0.17,1.4c-0.23,0.35-0.53,0.69-1,0.58c-0.43-0.14-0.7-0.55-0.68-1C170.05,339.42,170.89,338.57,170.51,337.68z"
      />
      <path
        class="bone"
        d="M164.52,336.58c-0.15-0.34-0.21-0.31-0.16-0.75s0.62-0.44,1-0.23l0.35-0.05c0.3,0,0.84-0.06,1,0.34s-0.34,0.67-0.49,0.94c-0.23,0.37-0.36,0.79-0.39,1.23c0.07,0.43,0.02,0.87-0.14,1.27c-0.2,0.31-0.48,0.63-0.88,0.54c-0.4-0.13-0.66-0.51-0.64-0.93C164.12,338.16,164.89,337.37,164.52,336.58z"
      />
      <path
        class="bone"
        d="M159.04,327.39c0.35-0.13,0.76,0.32,1,0.25l0.42-0.2c0.32-0.06,0.77-0.25,0.91,0.08s-0.27,0.6-0.39,0.85c-0.18,0.33-0.27,0.71-0.26,1.09c0,0.37,0.15,0.77,0,1.09s-0.4,0.58-0.78,0.54c-0.37-0.06-0.65-0.37-0.67-0.75c0-0.67,0.6-1.41,0.2-2.06C159.27,328,158.65,327.54,159.04,327.39z"
      />
      <path
        class="bone"
        d="M169.96,319.85c-0.09-0.8,0.36-1.15,1.15-1.39c0.61-0.22,1.29-0.14,1.83,0.21c0.72,0.45,0.34,1.21,0.16,1.85c-0.27,0.84-0.39,1.72-0.34,2.6c0.07,0.89,0.13,1.77,0.15,2.67c0.03,0.24,0.08,0.47,0.15,0.7c0,0.68,0.13,1.4-0.7,1.53c-0.79,0.11-1.58-0.17-2.12-0.75c-0.42-0.64,0.1-1.32,0.25-2c0.17-0.89,0.2-1.81,0.07-2.71C170.45,321.64,170.07,320.78,169.96,319.85z"
      />
      <path
        class="bone"
        d="M160.33,314.47c-0.66-0.86-0.08-2,0.34-2.81c0.48-0.91,0.8-1.91,0.93-2.93c0.2-1.15,0.3-2.31,0.31-3.47c-0.02-0.52-0.08-1.04-0.16-1.56c-0.1-0.39-0.08-0.81,0.06-1.19c0.43-0.85,1.86-0.61,2.52-0.28c1.06,0.54,0.44,1.39,0,2.23c-0.97,2.2-1.36,4.61-1.13,7c0.18,1,0.4,2.17-0.31,3c-0.61,0.71-1.67,0.79-2.38,0.19C160.44,314.59,160.39,314.53,160.33,314.47z"
      />
      <path
        class="bone"
        d="M160.49,223.46c-1.08,0.71-2.43,0.86-3.64,0.39c-1.09-0.42-1.89-0.8-1.94,0.55c-0.09,2.3,1.49,2.17,2,8.84s1.57,20.13,1.34,25.18s1.48,15.91,2.16,20.63s1.33,5.71,1.26,7.86c0,0.94-0.15,3.34,0.36,4.48c0.16,0.34,0.55,0.52,0.91,0.41c0.28-0.08,0.65-0.18,1.08-0.28c1.29-0.69,2.45-2,1.64-5.48c-1.13-5.65-1.95-11.36-2.46-17.1c-0.35-4,0.32-16.9,0.66-21.13l0.68-13.42c0.62,3.55,1.88,10.43,3.19,17.43s0,32.36-1,37.27c-0.12,0.46-0.18,0.93-0.18,1.4c0.01,0.3,0.27,0.53,0.56,0.51c0.02,0,0.03,0,0.05,0c0.84-0.1,1.68-0.1,2.52,0c1.43,0.24,2.83,0.65,4.17,1.23c0.5,0.24,1.1,0.03,1.33-0.47c0.05-0.11,0.08-0.22,0.1-0.34c0-1.29-0.12-2.58-0.35-3.85c-0.26-2.8-1.72-8.55-1.91-15.28s-0.19-19.76-2.7-30.74c-2-8.64-2.45-13.78-1-15.89s1.08-3.21-1.28-2.78c-0.91,0.4-1.94,0.4-2.85,0c-0.8-0.39-1.67-0.63-2.56-0.7C162.01,222.28,161.33,222.92,160.49,223.46z"
      />
      <path
        class="bone"
        d="M161.96,295.42c0.09-0.49,0.38-0.93,0.8-1.2c1.94-0.63,3.97-0.92,6-0.87c1.23,0.17,2.43,0.48,3.58,0.93l1,0.57c0.72,0.59,1.53,1.06,2.39,1.41c0.57,0.23,1.02,0.68,1.24,1.25c0.02,0.14,0.02,0.29,0,0.43c0,0,0,0,0,0.06c-0.36,0.8-0.84,1.53-1.44,2.16c-0.42,0.09-0.86,0.14-1.29,0.14c-0.92-0.06-1.83,0.14-2.64,0.58l-0.36,0.33c-0.51,0.61-1.3,0.91-2.09,0.8c-0.74-0.07-1.46-0.27-2.13-0.6c-0.71-0.34-1.48-0.57-2.26-0.68c-1-0.12-1.39,0.06-2.38-0.06s-0.53-4.51-0.53-4.51C161.87,295.9,161.91,295.66,161.96,295.42z"
      />
      <path
        class="bone"
        disabled
        d="M103.15,96.39c-0.78,0.17-2.09,0.82-2.11,0c0-0.49,1.07-1.44-0.9-1.61c0,0-1.63,0-3.81,0s-3.82,0-3.82,0c-2,0.17-0.88,1.12-0.89,1.61c0,0.83-1.33,0.18-2.12,0s-1.57,1.17,0,1.34s2.71,0.34,2.64,1.11c-0.08,1,1.94,1.21,4.19,1.21s4.26-0.24,4.18-1.21c-0.06-0.77,1.07-0.94,2.64-1.11S103.94,96.23,103.15,96.39z"
      />
      <path
        class="bone"
        disabled
        d="M103.67,184.82c-0.85,0.23-2.26,1.11-2.28,0c0-0.67,1.15-2-1-2.19c0,0-1.76-0.08-4.1-0.08s-4.11,0.08-4.11,0.08c-2.11,0.23-0.94,1.52-1,2.19c0,1.13-1.43,0.25-2.28,0c-0.5,0-0.91,0.41-0.91,0.91s0.41,0.91,0.91,0.91c1.69,0.23,2.92,0.46,2.85,1.52c-0.09,1.32,2.08,1.65,4.5,1.65s4.59-0.33,4.5-1.65c-0.07-1.06,1.15-1.29,2.84-1.52c0.5,0.02,0.93-0.37,0.95-0.87C104.56,185.27,104.17,184.84,103.67,184.82z"
      />
      <path
        class="bone"
        disabled
        d="M102.94,177.12c-0.76,0.21-2,1-2,0c0-0.6,1-1.76-0.87-2c0,0-1.58-0.07-3.69-0.07s-3.7,0.07-3.7,0.07c-1.9,0.21-0.85,1.37-0.86,2c0,1-1.29,0.23-2,0c-0.45,0-0.82,0.37-0.82,0.82c0,0.45,0.37,0.82,0.82,0.82c0,0,0,0,0,0c1.52,0.21,2.62,0.41,2.56,1.37c-0.08,1.18,1.87,1.48,4,1.48s4.13-0.3,4-1.48c-0.06-1,1-1.16,2.56-1.37c0.45,0,0.82-0.37,0.82-0.82C103.76,177.49,103.39,177.12,102.94,177.12z"
      />
      <path
        class="bone"
        disabled
        d="M102.11,85.6c-0.67,0.13-1.78,0.65-1.79,0c0-0.39,0.9-1.14-0.76-1.27c0,0-1.39,0-3.23,0s-3.23,0-3.23,0c-1.67,0.13-0.75,0.88-0.76,1.27c0,0.66-1.13,0.14-1.79,0s-1.34,0.93,0,1.06s2.29,0.27,2.23,0.88s1.64,1,3.55,1s3.61-0.2,3.54-1s0.91-0.75,2.24-0.88S102.77,85.47,102.11,85.6z"
      />
      <path
        class="bone"
        disabled
        d="M102.11,80.55c-0.67,0.13-1.78,0.64-1.79,0c0-0.39,0.9-1.14-0.76-1.27c0,0-1.39,0-3.23,0s-3.23,0-3.23,0c-1.67,0.13-0.75,0.88-0.76,1.27c0,0.65-1.13,0.14-1.79,0s-1.34,0.93,0,1.06s2.29,0.26,2.23,0.88s1.64,1,3.55,1s3.61-0.19,3.54-1s0.91-0.75,2.24-0.88S102.77,80.42,102.11,80.55z"
      />
      <path
        class="bone"
        disabled
        d="M102.11,90.76c-0.67,0.14-1.78,0.69-1.79,0c0-0.42,0.9-1.23-0.76-1.38c0,0-1.39,0-3.23-0.05s-3.23,0.05-3.23,0.05c-1.67,0.15-0.75,1-0.76,1.38c0,0.7-1.13,0.15-1.79,0s-1.34,1,0,1.14s2.29,0.29,2.23,1c-0.07,0.82,1.64,1,3.55,1s3.61-0.21,3.54-1c-0.05-0.67,0.91-0.81,2.24-1S102.77,90.62,102.11,90.76z"
      />
      <path
        class="bone"
        disabled
        d="M105.62,193.3c-0.93,0.26-3.7,1.22-3.72,0c0-0.74,1.26-2.16-1.06-2.41c0,0-1.93-0.08-4.51-0.08s-4.52,0.08-4.52,0.08c-2.32,0.25-1,1.67-1,2.41c0,1.24-2.79,0.28-3.72,0c-0.55,0-1,0.45-1,1s0.45,1,1,1c1.86,0.25,4.41,0.5,4.34,1.67c-0.1,1.45,2.29,1.81,5,1.81s5-0.36,5-1.81c-0.08-1.17,2.48-1.42,4.34-1.67c0.55-0.04,0.97-0.52,0.92-1.07C106.65,193.67,106.17,193.26,105.62,193.3L105.62,193.3z"
      />
      <path
        class="bone"
        disabled
        d="M108.99,233.21c-1.26,0.35-5,1.67-5.07,0c0-1,1.73-2.94-1.44-3.29c0,0-2.63-0.11-6.15-0.11s-6.16,0.11-6.16,0.11c-3.17,0.35-1.42,2.28-1.44,3.29c0,1.7-3.8,0.38-5.07,0c-0.76,0-1.37,0.61-1.37,1.37c0,0.76,0.61,1.37,1.37,1.37c2.54,0.34,6,0.68,5.92,2.28c-0.13,2,3.12,2.46,6.75,2.46s6.88-0.49,6.75-2.46c-0.11-1.6,3.38-1.94,5.91-2.28c0.76,0,1.37-0.61,1.37-1.37C110.36,233.82,109.75,233.21,108.99,233.21z"
      />
      <path
        class="bone"
        disabled
        d="M106.46,212.23c-1,0.27-4,1.33-4.06,0c0-0.81,1.39-2.36-1.15-2.64c0,0-2.11-0.09-4.92-0.09s-4.93,0.09-4.93,0.09c-2.53,0.28-1.14,1.83-1.15,2.64c0,1.35-3,0.29-4.06,0c-0.6-0.06-1.14,0.39-1.2,0.99c-0.06,0.6,0.39,1.14,0.99,1.2c0.07,0.01,0.14,0.01,0.21,0c2,0.27,4.82,0.55,4.74,1.82c-0.11,1.58,2.5,2,5.4,2s5.5-0.39,5.4-2c-0.09-1.27,2.7-1.55,4.73-1.82c0.84,0,1.53-0.25,1.53-1.1C107.99,212.48,107.3,211.8,106.46,212.23z"
      />
      <path
        class="bone"
        disabled
        d="M107.47,222.22c-1.11,0.3-4.43,1.46-4.46,0c0-0.89,1.52-2.59-1.27-2.89c0,0-2.32-0.11-5.41-0.11s-5.42,0.11-5.42,0.11c-2.79,0.3-1.25,2-1.27,2.89c0,1.49-3.34,0.33-4.46,0c-0.66,0-1.2,0.53-1.2,1.2s0.53,1.2,1.2,1.2c0,0,0,0,0.01,0c2.23,0.3,5.3,0.61,5.21,2c-0.12,1.73,2.75,2.17,5.94,2.17s6-0.44,5.94-2.17c-0.09-1.4,3-1.71,5.2-2c0.55,0.37,1.43,0.02,1.8-0.53c0.37-0.55,0.22-1.3-0.33-1.66C108.54,222.15,108.01,222.15,107.47,222.22z"
      />
      <path
        class="bone"
        disabled
        d="M106.46,202.52c-1,0.27-4,1.33-4.06,0c0-0.8,1.39-2.35-1.15-2.63c0,0-2.11-0.09-4.92-0.09s-4.93,0.09-4.93,0.09c-2.53,0.28-1.14,1.83-1.15,2.63c0,1.36-3,0.3-4.06,0c-0.6-0.06-1.14,0.39-1.2,0.99c-0.06,0.6,0.39,1.14,0.99,1.2c0.07,0.01,0.14,0.01,0.21,0c2,0.27,4.82,0.54,4.74,1.82c-0.11,1.58,2.5,2,5.4,2s5.5-0.39,5.4-2c-0.09-1.28,2.7-1.55,4.73-1.82c0.61,0,1.1-0.49,1.1-1.1C107.56,203.01,107.07,202.51,106.46,202.52C106.46,202.51,106.46,202.51,106.46,202.52z"
      />
      <path
        class="bone"
        disabled
        d="M113.98,54.62c0-0.37-0.23-0.36-0.55-0.36c-1.92,0-4.56,0.18-4.74,0.8c-0.11,0.38-0.21,0.82-0.32,1.28c-0.36,1.56-0.87,5.17-2,6.43c0,0-3.25,3.49-10,3.49l0,0c-6.72,0-10-3.49-10-3.49c-1.17-1.26-1.67-4.87-2-6.43c-0.11-0.46-0.21-0.9-0.32-1.28c-0.18-0.62-2.83-0.79-4.74-0.8c-0.32,0-0.53,0-0.56,0.36c0,0.14-0.58,4.19,0.86,5s0.67,8.9,3.52,10.37c4.16,2.15,4.64,8.26,13.26,8.27l0,0c8.62,0,9.09-6.12,13.26-8.27c2.85-1.47,2.06-9.56,3.51-10.37S113.99,54.76,113.98,54.62z"
      />
      <path
        class="bone"
        disabled
        d="M115.05,13.58c-4.26-6.14-11.24-9.83-18.72-9.89l0,0c-7.47,0.06-14.44,3.75-18.7,9.89c-3.49,4.84-4.54,12.77-4.3,17.42c0.27,5.72,2.94,21.82,5.41,22.24c1.83,0.32,5.66,0.08,6.2,1.55c0.14,0.39,1.08,4.58,2.06,5.64c1.33,1.41,5.53,2.57,9.33,2.57l0,0c3.8,0,8-1.18,9.34-2.61c1-1.06,1.93-5.25,2.07-5.64c0.54-1.47,4.36-1.23,6.2-1.55c2.48-0.4,5.16-16.5,5.39-22.2C119.59,26.35,118.54,18.42,115.05,13.58z M84.05,45.88c-2.34-0.16-3.2-1.89-3.21-7.09c0-4.06,2.84-4.51,7.44-5.4c1-0.18,3.1-0.75,4.2,1.26c0.92,1.7,0.61,4.52-0.4,6.5S86.38,46,84.05,45.88z M97.12,54.12c-0.24-0.11-0.5-0.17-0.77-0.2l0,0c-0.27,0.03-0.53,0.09-0.78,0.2c-3.79,1.66-3.33-1.85-2.71-5.08c0.53-2.8,1.29-5,2-5.85s1,0,1.48,0l0,0c0.53,0,0.86-0.65,1.47,0s1.49,3.05,2,5.85C100.46,52.27,100.91,55.78,97.12,54.12z M108.63,45.88c-2.34,0.15-7-2.73-8-4.73s-1.33-4.8-0.4-6.5c1.1-2,3.25-1.44,4.2-1.26c4.6,0.89,7.44,1.34,7.44,5.4C111.83,44,110.96,45.72,108.63,45.88z"
      />
      <path
        class="bone"
        disabled
        d="M114,240.28c-1.62-5.39-5.29-2-8,1.33c-1.37,1.67-3.07,3.03-5,4c-2.87,1.45-6.27,1.45-9.14,0c-1.93-0.97-3.63-2.33-5-4c-2.73-3.37-6.41-6.72-8-1.33c-1.9,6.35-0.8,10.6,2.93,13.06c2.71,1.78-0.5,5.71,2.75,8.75c3.07,2.87,1.67,5.05,4.71,6.32c1.93,0.8,1.2,5,3,6.16c1,0.69-0.09,3.48,1.22,4.08c0.78,0.36,1.31,2,3,2s2.21-1.65,3-2c1.31-0.6,0.19-3.39,1.22-4.08c1.76-1.16,1-5.36,3-6.16c3-1.27,1.64-3.45,4.7-6.32c3.25-3,0-7,2.75-8.75C114.81,250.88,115.91,246.63,114,240.28z"
      />
      <path
        class="bone"
        disabled
        d="M136.84,275.39c-2.89,0.14-2.09,2.69-3.56,2s-0.26-2.57,0.24-3.91s0.07-3.93-1.74-4.58c-3.33-1.19-6.28,1.75-7.47,4.1c-1.22,2.48-1.77,5.24-1.58,8c0.39,2.67,3.43,1.57,5.58,2.18c2.15,0.61,2.41,5.46,1.23,8.35s-1.87,3.83-0.86,7.38c1.01,3.55-3,27.23-5.88,46.86c-1.93,13.38-5.88,34.63-9,47.32c-1.33,5.36-4.67,15.14-6,16.66c-3.74,4.24-4.64,8.37-3,14.39c1.07,4,3.5,4.82,5.43,4.49c1.84-0.6,1.45-2.09,1.09-3.1s-1.81-4.28-1.28-7.29c0.71-3.85,4.4-6.4,8.25-5.7c1.25,0.23,2.42,0.79,3.38,1.63c2.18,1.94,3,5.45,2.19,8.63c-0.54,2.11-1.46,2.85-1,4.16c0.59,1.56,2.88,1.12,5.12-0.91c0.76-0.68,2-2.09,1.09-8.65c-0.77-5.73-4-6.19-4.55-12.15s5.87-46.77,7.2-54.63c1.19-7,6.4-45.14,6.58-46.77c0.39-3.53,4.06-7.68,5.17-13C146.25,277.56,139.73,275.26,136.84,275.39z"
      />
      <path
        class="bone"
        d="M151.33,217.7c-0.67-3.54,3.71-6.66,4.06-11.65s-2.21-67.68-4.37-71.72c-0.67-1.37-1.65-2.57-2.87-3.49c-3.08-2.45-4.39-6.5-3.32-10.29c1.16-4.36,4.21-6,7.59-6c1.7-0.02,3.24,0.99,3.91,2.55c1.17-0.33,3.45-0.2,3.79,2c0.46,4.66,0.41,9.35-0.15,14c-0.69,4.75,1.27,42.89,1.67,53.24c0.36,9.16,1.49,17.08,4.08,20.65s5.77,4.75,5.57,8.11c-0.18,3.15-3.54,6.27-6.31,5.21c-1.68-0.63-2-1.2-2.58-1.33c-0.29-0.06-0.55-0.58-1.26,0.13c-0.69,0.7-1.54,1.23-2.47,1.56C156.33,221.47,152.16,222.18,151.33,217.7z"
      />
      <path
        class="bone"
        disabled
        d="M105.44,571c1.08-0.39,2.68-0.45,3.42,0.39c0.13,0.25,0.2,0.54,0.19,0.82c0,0.58-0.72,0.83-0.85,1.36c-0.19,0.77,0.67,1.18,0.78,1.86c0.25,1.38-1.76,1.62-2.52,1.14c-0.57-0.37-0.48-1-0.73-1.54s-0.65-0.63-1-1.11c-0.63-0.9-0.41-2.15,0.49-2.79C105.29,571.08,105.36,571.04,105.44,571z"
      />
      <path
        class="bone"
        disabled
        d="M113.4,548.15c0.71,0.4,0.43,1.17,0.51,1.9c0.23,1.72,0.6,3.42,1.1,5.09c0.09,0.3,0.2,0.58,0.34,0.86c0.34,0.62,0.12,1.4-0.5,1.74c-0.21,0.12-0.45,0.17-0.69,0.16c-0.39,0-0.77-0.11-1.09-0.32c-0.59-0.33-0.65-0.7-0.57-1.37c0.42-3.2-1.4-6.72-1-7.39c0.29-0.69,1.09-1.02,1.78-0.73C113.32,548.11,113.36,548.13,113.4,548.15z"
      />
      <path
        class="bone"
        disabled
        d="M121.62,564.15c0.07-0.07,0.27-0.19,0.31-0.1c0.42,0.81-0.09,1.55,0.41,2.41c0.3,0.64,0.63,1.26,1,1.86c0.22,0.29,0.46,0.35,0.53,0.77s-0.08,0.8,0,1.19s0.3,0.68,0.06,1s-0.51,0.26-0.73,0c-0.49-0.63-0.09-1.36-1-1.63c-0.09-0.4,0-0.79-0.05-1.18c-0.14-0.32-0.31-0.62-0.5-0.91c-0.27-0.55-0.38-1.23-1-1.45c-0.41-0.15-0.67,0-0.94-0.4s-0.11-0.57,0.21-0.88c0.22-0.15,0.48-0.24,0.75-0.24c0.5,0,0.78,0.06,0.89-0.19S121.49,564.31,121.62,564.15z"
      />
      <path
        class="bone"
        disabled
        d="M123.87,563.15c0.37-0.57,0.64,0,1.24-0.27c0.06,0,0-0.17,0.06-0.22s0.32-0.3,0.4-0.27c0.84,0.26-0.18,1.37,0.31,2.16c0.28,0.56,0.6,1.11,0.95,1.64c0.21,0.26,0.44,0.3,0.52,0.67s0,0.73,0,1.09s0.3,0.6,0.11,0.93s-0.46,0.26-0.67,0c-0.47-0.56-0.14-1.24-1-1.43c-0.09-0.37,0-0.73-0.1-1.08c-0.13-0.28-0.3-0.55-0.49-0.8c-0.27-0.49-0.4-1.11-0.94-1.28c-0.38-0.12-0.39,0.14-0.54-0.31C123.61,563.7,123.67,563.38,123.87,563.15z"
      />
      <path
        class="bone"
        disabled
        d="M127.25,562.8c0.37,0.1,0.47,0.51,0.67,0.84c0.13,0.16,0.25,0.34,0.34,0.52c0.08,0.24,0,0.48,0.1,0.72c0.6,0.11,0.39,0.58,0.72,1c0.15,0.15,0.32,0.19,0.45,0s0-0.43-0.09-0.63s0-0.5-0.05-0.73s-0.22-0.27-0.36-0.44c-0.25-0.34-0.48-0.71-0.69-1.08c-0.35-0.52,0.36-1.23-0.22-1.39c-0.09,0.01-0.18,0.05-0.24,0.12c-0.04,0.09-0.09,0.17-0.15,0.25c-0.31,0.25-0.66-0.06-1,0.28C126.71,562.18,126.45,562.6,127.25,562.8z"
      />
      <path
        class="bone"
        disabled
        d="M117.97,571.63c-0.21-0.86-0.26-1.75-0.15-2.63c-0.01-0.32-0.18-0.61-0.45-0.79c-0.37-0.27-0.82-0.42-1.28-0.44c-0.3,0.07-0.57,0.21-0.81,0.4c-0.3,0.24-0.44,0.63-0.36,1c0.08,0.29,0.18,0.57,0.29,0.84c0.47,1.16,0.58,2.42,1,3.61c0.2,0.55,1.76,1.14,2.17,0.14C118.75,572.91,118.33,572.34,117.97,571.63z"
      />
      <path
        class="bone"
        disabled
        d="M107.33,536.23c-1.58,0.13-3.32,1.07-3.53,2.69c-0.27,1.46-1.08,2.78-2.26,3.68c-0.81,0.69-1.26,1.71-1.25,2.77c0,1.81-0.08,5.29,1.69,5.23c1.1-0.15,2.1-0.75,2.74-1.66c0.93-1.05,2.67-1.35,4.89-1.19c1.64,0.11,3.14-1.35,5.06-1.19s2.39,1,3.72,1.41s1.87-1.05,0.86-2c-0.92-0.72-1.89-1.36-2.92-1.92c-2.81-1.58-2-4.63-2.4-5.76C113.4,536.74,109.23,536.08,107.33,536.23z"
      />
      <path
        class="bone"
        disabled
        d="M127.96,430.82c0.39-1.3-0.46-2.53-1.09-2.27c-2.63,1.07-3.3,1.13-5,0.34c-1.11-0.52-2.94,1.23-4.92,1.33c-2.14,0.12-3-2-4.18-1.25c-1.54,0.94-4.19,1.71-6.08,0.79c-0.36-0.17-0.79-0.12-1.11,0.13c-0.65,0.3-1.09,0.93-1.15,1.65c-0.11,0.86,0.34,2.18,1.79,4.63c6.44,10.88,3.53,31,2.46,45.41c-3,39.51-6.32,39.6-7.26,52.23c-0.07,1,0.62,2.54,1.42,2.61s3-1.24,5.25-1.36c2.21,0.11,4.4,0.5,6.51,1.18c2,0.71,0.44-3.65,0-7.32c-1.16-9,3.6-48.92,4.41-55.22c0.69-5.37,2.64-26.1,3.42-30C123.5,438.26,126.79,434.78,127.96,430.82z"
      />
      <path
        class="bone"
        disabled
        d="M104.05,563.65c-0.74,1.13-1.54,2.89-0.14,2.81c0.58-0.86,1.33-1.6,2.21-2.17c0.94-0.43,2,0.51,3,1.63c0.28,0.1,0.35-0.08,0.45-0.36c0.43-1.12-0.36-2.78-0.45-3.91c-0.11-1.51,0.55-2.54,1-3.92c0.46-1.54-0.1-2.1-0.1-2.1s-1.87-2-3.66-1.63c-0.44,0.11-0.83,0.34-1.13,0.68c-0.59,0.59-0.94,1.37-1,2.2c-0.05,1.01,0.02,2.01,0.22,3C104.7,561.37,104.88,562.4,104.05,563.65z"
      />
      <path
        class="bone"
        disabled
        d="M110.33,554.35c-0.05,0.07-0.15,0.09-0.22,0.04c-0.01-0.01-0.03-0.02-0.04-0.04c-0.69-0.84-1.67-1.39-2.74-1.55c-1.27-0.15-3.23,1.3-3.52,1.67s-0.44-0.44-0.37-0.9c0.21-1.5,1.21-3.51,2.35-4.09c1.17-0.54,2.5-0.6,3.71-0.15c0.6,0.24,1.07,0.71,1.33,1.3c0.3,0.62,0.37,1.33,0.19,2C110.89,553.24,110.65,553.82,110.33,554.35z"
      />
      <path
        class="bone"
        disabled
        d="M118.33,556.18c0.33-0.23-2-7.83-2-7.83c-0.13-0.17-0.31-0.28-0.52-0.32c-1.49-0.39-1.21,0.1-1.21,0.1c1.29,2.44,1.53,7.33,1.86,7.89C116.41,556,116.95,557.13,118.33,556.18z"
      />
      <path
        class="bone"
        disabled
        d="M121.42,552.31c-0.29-0.81-0.65-1.57-0.94-2.38l-0.13-0.13c-0.11,0-0.74-0.32-0.62,0.07s0.88,2.5,0.88,2.5c0.37,0.88,0.66,1.68,0.76,1.79s0.59,0.28,0.71,0C122.33,553.53,121.61,552.84,121.42,552.31z"
      />
      <path
        class="bone"
        disabled
        d="M117.7,549.58c0.14,0.36,1.79,5.79,1.86,6s0.53,0,0.74-0.24c0.6-0.66-0.21-1.43-0.34-2.15v-0.16c0,0-0.95-3.17-1-3.37S117.56,549.21,117.7,549.58z"
      />
      <path
        class="bone"
        disabled
        d="M115.86,564.52c0.31,0.03,0.62,0.1,0.91,0.21c0.1,0.04,0.22-0.02,0.26-0.12c0,0,0-0.01,0-0.01c0.27-1.08-0.87-2-1-3.25s0.44-2.77-1.34-2.38c-0.41-0.01-0.82,0.01-1.23,0.06c-0.36,0.13-0.58,0.26-0.54,0.65l0.42,5.24c0,0,0.06,0.38,0.77,0.07l0.55-0.25C115.03,564.55,115.45,564.48,115.86,564.52z"
      />
      <path
        class="bone"
        disabled
        d="M120.92,562.6c-0.09-0.41-0.25-0.81-0.46-1.17c-0.09-0.4-0.28-0.78-0.56-1.08c-0.28-0.39-0.51-0.8-0.71-1.24c-0.21-0.42-0.09-1.19-0.52-1.36c-0.49-0.09-1-0.01-1.45,0.22c-0.13,0.33,0.25,0.85,0.45,1.32c0.42,1,1,1.91,1.42,2.89s0.38,1.43,0.77,1.44l0.83-0.46C120.82,563,120.9,562.81,120.92,562.6z"
      />
      <path
        class="bone"
        disabled
        d="M117.58,566.21c0,0,0.42,0.35,0.35,0.61s-0.44,0.31-0.44,0.31c-0.45-0.27-0.98-0.39-1.5-0.36c-0.57,0.16-1.1,0.43-1.56,0.81c-0.33,0.23-0.51-0.27-0.51-0.81c0.01-0.43,0.27-0.82,0.66-1c0.21-0.1,0.44-0.17,0.67-0.21c0.83,0,1.64,0.24,2.33,0.69"
      />
      <path
        class="bone"
        disabled
        d="M120.33,557.33c0.31,0.93,1,1.36,1.54,2.12c0.29,0.38,0.52,0.81,0.67,1.26c0.15,0.43,0.44,1.28,0.69,1.34s1.48-0.13,1.5-0.38s-3.18-5-3.46-5.31S120.04,556.61,120.33,557.33z"
      />
      <path
        class="bone"
        disabled
        d="M125.98,561.21c0.19,0,1.48-0.21,1.55-0.53s-1.49-2.06-2.5-2.86s-1.12-2-2.13-2.48c-0.43-0.2-1.13,0.07-0.84,0.54s3.51,5,3.51,5C125.7,561,125.84,561.11,125.98,561.21z"
      />
      <path
        class="bone"
        disabled
        d="M105.52,569.82c0,0-0.21,0-0.26,0s-1.58-0.49-1.28-1.63s2.07-2.77,2.57-2.64c0,0,0.67-0.15,1.83,1.3c0.35,0.42,0.59,0.93,0.67,1.47c0.04,0.42-0.18,0.81-0.55,1c-0.39-0.06-0.78-0.09-1.17-0.1c-0.54,0.11-1.05,0.34-1.5,0.66C105.72,569.9,105.61,569.88,105.52,569.82z"
      />
      <path
        class="bone"
        disabled
        d="M130.4,230.55c-9.66-1.78-14.75,2.58-15.08,7.08c-0.51,7,4,18.87,1.21,24.81c-2.7,5.71-6.83,10.62-12,14.24c-1.9,1.34-4.12,2.74-5.35,4.88c-1.89,0.31-3.81,0.31-5.7,0c-1.24-2.14-3.46-3.54-5.36-4.88c-5.17-3.62-9.3-8.53-12-14.24c-2.79-5.94,1.72-17.82,1.21-24.81c-0.33-4.5-5.41-8.86-15.07-7.08c-6.2,1.14-11.39,5.28-11.4,12.54c0,6.89,1.53,18.69,12.11,23.53c4.38,2,7.11,4.3,8,8.54c1.29,6.32-0.54,12.71,0.5,16.71c1.67,6.45,5.85,8.7,11.64,8.64c5.6-0.05,8.82-5.26,10.41-10.21c0-0.14,0.08-0.28,0.13-0.42c0.73,0.7,1.68,1.11,2.69,1.18l0,0c1.01-0.07,1.96-0.49,2.69-1.18l0.12,0.42c1.59,4.95,4.81,10.16,10.41,10.21c5.79,0.06,10-2.19,11.65-8.64c1-4-0.8-10.39,0.5-16.71c0.86-4.24,3.59-6.53,8-8.54c10.58-4.84,12.11-16.64,12.1-23.53C141.78,235.83,136.59,231.69,130.4,230.55z M84.18,293.86c-2.57,1.31-3.73-3.11-4.79-4.76c-1.37-2.14-3.34-4.26-2.51-7.07s4-2.24,6.24-1.2c2.24,1.23,3.84,3.36,4.4,5.85C87.78,289,86.44,292.71,84.18,293.86z M113.27,289.1c-1.07,1.65-2.23,6.07-4.8,4.76c-2.25-1.15-3.6-4.84-3.33-7.18c0.56-2.49,2.15-4.62,4.39-5.85c2.21-1,5.38-1.75,6.25,1.2S114.63,287,113.27,289.1L113.27,289.1z"
      />
      <path
        class="bone"
        disabled
        d="M100.64,100.94c0,0-1.85-0.06-4.31-0.06s-4.31,0.06-4.31,0.06c-2.22,0.18-0.69,3.61-0.4,4.49s2.17,1.23,4.71,1.23s4.37-0.22,4.71-1.23S102.86,101.12,100.64,100.94z"
      />
      <path
        class="bone"
        disabled
        d="M111.45,418.29c0.77-3.91,6-4,7.74-3.34c1.43,0.57,3.66,3.85,3.53,6.24s-2.33,7.39-5.89,7.19C113.44,428.18,110.45,423.36,111.45,418.29z"
      />
      <path
        class="bone"
        disabled
        d="M55.82,275.39c2.89,0.14,2.09,2.69,3.55,2s0.27-2.57-0.24-3.91s-0.07-3.93,1.75-4.58c3.33-1.19,6.27,1.75,7.46,4.1c1.23,2.48,1.78,5.24,1.58,8c-0.38,2.67-3.42,1.57-5.57,2.18s-2.42,5.46-1.24,8.35s1.88,3.83,0.86,7.38s3,27.23,5.88,46.86c1.94,13.38,5.89,34.63,9,47.32c1.32,5.36,4.67,15.14,6,16.66c3.75,4.24,4.65,8.37,3,14.39c-1.07,4-3.51,4.82-5.43,4.49c-1.84-0.6-1.46-2.09-1.1-3.1s1.81-4.28,1.29-7.29c-0.71-3.86-4.41-6.41-8.27-5.69c-1.25,0.23-2.41,0.79-3.37,1.62c-2.17,1.94-3,5.45-2.19,8.63c0.54,2.11,1.46,2.85,1,4.16c-0.6,1.56-2.88,1.12-5.12-0.91c-0.76-0.68-2-2.09-1.1-8.65c0.77-5.73,4-6.19,4.56-12.15s-5.88-46.77-7.2-54.63c-1.2-7-6.41-45.14-6.59-46.77c-0.39-3.53-4.06-7.68-5.17-13C46.41,277.56,52.92,275.26,55.82,275.39z"
      />
      <path
        class="bone"
        disabled
        d="M64.69,430.82c-0.38-1.3,0.47-2.53,1.09-2.27c2.63,1.07,3.3,1.13,5,0.34c1.11-0.52,2.94,1.23,4.91,1.33c2.14,0.12,3-2,4.18-1.25c1.55,0.94,4.2,1.71,6.08,0.79c0.37-0.17,0.8-0.12,1.12,0.13c0.65,0.31,1.08,0.94,1.14,1.65c0.11,0.86-0.34,2.18-1.79,4.63c-6.43,10.88-3.53,31-2.45,45.41c2.94,39.51,6.32,39.6,7.25,52.23c0.08,1-0.62,2.54-1.41,2.61s-3-1.24-5.25-1.36c-2.21,0.11-4.4,0.5-6.51,1.18c-2,0.71-0.44-3.65,0-7.32c1.16-9-3.6-48.92-4.4-55.22c-0.69-5.37-2.65-26.1-3.43-30C69.16,438.26,65.87,434.78,64.69,430.82z"
      />
      <path
        class="bone"
        disabled
        d="M81.21,418.29c-0.78-3.91-6-4-7.75-3.34c-1.43,0.57-3.65,3.85-3.53,6.24s2.33,7.39,5.89,7.19C79.22,428.18,82.21,423.36,81.21,418.29z"
      />
      <path
        class="bone"
        disabled
        d="M156.02,109.82c-1.83-1.07-3.73-2.01-5.69-2.82c-1.28-0.46-2.35-0.5-3.09,0.2s-0.69,2.09-0.4,3.35s-3.15,2.12-4.16,2s-2.68-2.2-4.37-2.74s-4.07,0.75-5.39,0.88c-0.73,0.08-2.59-0.08-4.65-0.18c0.02,0.33,0.02,0.67,0,1c2.54,1.13,6.89,3.51,8,7c0.55,1.59,0.21,3.35-0.89,4.62c1.54,1.43,3.25,3.52,3.33,5.81c0.07,1.26-0.26,2.52-0.94,3.58c1.53,1.28,3.06,3.17,2.82,5.5c-0.14,1.58-0.85,3.05-2,4.14c0.64,0.43,1.25,0.9,1.83,1.41c3.46-7.13,5.46-12.69,4.29-13.76c-1.03-1.18-1.72-2.62-2-4.16c-0.28-3.06,0.47-6.13,2.12-8.72c1.4-2.21,4.83-4.62,10.94-3.27C158.15,114.12,157.71,110.88,156.02,109.82z"
      />
      <path
        class="bone"
        disabled
        d="M47.98,129.74c-1.17,1.07,0.83,6.63,4.28,13.76c0.58-0.51,1.19-0.98,1.83-1.41c-1.14-1.09-1.85-2.56-2-4.14c-0.24-2.33,1.3-4.22,2.83-5.5c-0.69-1.07-1.02-2.32-0.95-3.59c0.09-2.28,1.79-4.37,3.34-5.8c-1.1-1.27-1.44-3.02-0.9-4.61c1.16-3.45,5.51-5.83,8.06-7c0-0.3,0-0.62,0-1c-2,0.1-3.91,0.26-4.65,0.18c-1.31-0.13-3.64-1.43-5.38-0.88s-3.34,2.62-4.37,2.74s-4.44-0.72-4.16-2s0.32-2.65-0.4-3.35s-1.82-0.66-3.09-0.2c-1.98,0.8-3.89,1.73-5.74,2.79c-1.68,1.06-2.12,4.3,0.29,3.77c6.12-1.35,9.54,1.06,10.95,3.27c1.65,2.59,2.4,5.66,2.12,8.72C49.75,127.07,49.04,128.54,47.98,129.74z"
      />
      <path
        class="bone"
        disabled
        d="M103.74,170.19c-0.14-0.35-0.47-0.63-0.8-0.54c-0.76,0.21-2,1-2,0c0-0.61,1-1.77-0.87-2c0,0-1.58-0.07-3.69-0.07s-3.7,0.07-3.7,0.07c-1.9,0.21-0.85,1.37-0.86,2c0,1-1.29,0.22-2,0c-0.36-0.04-0.7,0.19-0.8,0.54c0,0.15,0,0.3-0.07,0.44c0,0.31,0.3,0.59,0.87,0.66c1.52,0.21,2.62,0.42,2.56,1.37c-0.08,1.18,1.87,1.48,4,1.48s4.13-0.3,4-1.48c-0.06-0.95,1-1.16,2.56-1.37c0.56-0.07,0.81-0.35,0.86-0.66L103.74,170.19z"
      />
      <path
        class="bone"
        disabled
        d="M140.48,156.23c-0.17-1.82-3.86-3.44-3.86-3.44s4.53-1.69,4.47-4.14c-0.09-3.47-7-6.53-7-6.53s4-0.87,4.33-4.4c0.28-2.73-4.29-5.05-4.29-5.05c1.54-0.56,2.52-2.08,2.39-3.72c-0.1-2.87-4.7-5.92-4.7-5.92s3.22-1.36,2.38-3.88c-1.28-3.78-8.49-6.3-8.49-6.3c0.33-0.96,0.44-1.99,0.32-3c-1.84,0-3.55,0.17-5.12,0.34c0,1.36-0.43,2.94-3.21,3.25c-0.76,0.09-10.41,0.33-11.67,0.38c-0.3,0.02-0.6,0.06-0.89,0.13c-0.88-0.48-1.67-1.11-2.34-1.86c-0.86-1.12-0.79-3.22-2-3.6c-0.7-0.22-2.12,0.2-4.41,0.2s-3.72-0.42-4.42-0.2c-1.23,0.38-1.16,2.48-2,3.6c-0.67,0.74-1.46,1.37-2.34,1.86c-0.3-0.07-0.6-0.11-0.9-0.13c-1.26,0-10.9-0.29-11.67-0.38c-2.78-0.31-3.24-1.89-3.2-3.25c-1.57-0.17-3.29-0.29-5.12-0.34c-0.12,1.01-0.02,2.04,0.32,3c0,0-7.22,2.52-8.49,6.3c-0.84,2.52,2.38,3.88,2.38,3.88s-4.62,3.05-4.78,5.97c-0.13,1.64,0.85,3.16,2.39,3.72c0,0-4.56,2.28-4.23,5c0.36,3.53,4.33,4.4,4.33,4.4s-7,3.06-7.05,6.53c-0.06,2.45,4.47,4.14,4.47,4.14s-3.68,1.62-3.85,3.44c-0.35,3.81,3.77,5.27,3.77,5.27s-4,2.24-3.55,5.29c0.24,1.54,2.57,3.52,2.57,3.52s-2.82,2.77-2.33,6c0.35,1.64,1.27,3.11,2.6,4.14c0,0-2.73,2.77-2,6s4.42,3.78,4.42,3.78c-0.07,0.21-1.62,4.11-1.29,5.93c0.91,4.89,6.14,4.24,7.63,4.12c2.79-0.41,5.37-1.69,7.39-3.66c0.84-0.85,1.9-2.06,3.05-3.47c2.4-1.1,4.69-2.44,6.83-4c1.91-1.73,3.71-3.57,5.39-5.52c1.57-1.73,2.31-3,1.35-3.77s-2.83,0.67-4,1.53c-0.62,0.46-1.79,1.58-3.13,2.8c0.42-0.68,0.8-1.34,1.15-2c2.32-4.21,5.22-5,6.6-10.4c0.5-2,0.42-6.31,3.6-11c0.84,3.52,2.08,6.55,3.75,6.71h0.34h0.34c1.67-0.16,2.9-3.19,3.74-6.72c3.18,4.69,3.11,9,3.61,11c1.37,5.44,4.27,6.19,6.59,10.4c0.27,0.49,0.56,1,0.86,1.49c-1.11-1-2.06-1.91-2.59-2.31c-1.18-0.86-3-2.3-4-1.53s-0.22,2,1.35,3.77c1.69,1.94,3.49,3.79,5.39,5.52c2.01,1.49,4.16,2.77,6.43,3.83c1.21,1.5,2.34,2.79,3.22,3.68c2.01,1.97,4.6,3.25,7.39,3.66c1.48,0.12,6.71,0.77,7.62-4.12c0.33-1.82-1.21-5.72-1.28-5.93c0,0,3.67-0.58,4.41-3.78s-2-6-2-6c1.32-1.03,2.25-2.5,2.6-4.14c0.48-3.27-2.33-6-2.33-6s2.32-2,2.57-3.52c0.48-3-3.55-5.29-3.55-5.29S140.83,160,140.48,156.23z M69.83,115.68c2.2,0.8,4.5,1.32,6.84,1.52c1.89,0.15,6.55,0.41,9.16,0.48c0.23,1.6,1.02,3.06,2.23,4.13c0.09,0.1,0.17,0.21,0.24,0.32c-3.67,0-12.48-0.14-17-0.82C62.93,120,69.83,115.68,69.83,115.68z M66.76,124.55c4.01,0.81,8.06,1.38,12.14,1.69c3.41,0.21,8.31,0.19,10.8,0.2c0.27,1.55,0.48,3.36,0.64,5.28c-4.92-0.12-15.92-0.54-20-1.15C59.33,128.91,66.76,124.55,66.76,124.55z M64.91,134.68c0,0,5.63,1,8.59,1.25c2.79,0.24,13.52,0.55,17.1,0.14c0.07,1.57,0.11,3.15,0.15,4.66h-0.42c-4.34,0.33-17.65,0.81-21.61,0.13C56.04,138.68,64.91,134.68,64.91,134.68L64.91,134.68z M64.61,144.18c0,0,4.72,1,7.63,1.3c6.2,0.29,12.41,0.03,18.56-0.79c0,1.31,0,2.5,0,3.51c-6.51,3.43-16.92,4.45-23.41,3.13C52.69,148.34,64.61,144.18,64.61,144.18L64.61,144.18z M58.49,172.87c0,0,1.39,0.31,2.61,0.67c1.64,0.42,3.31,0.73,5,0.91c2.49,0.21,4.99,0.09,7.44-0.38c2.23-0.38,3-0.79,5.36-1.07s1.3,1.27-0.93,3.18s-10.41,4.28-18,2.3C54.86,177.15,58.49,172.87,58.49,172.87L58.49,172.87z M58.01,185.64c-0.87-1,0-2.75,0-2.75c2.42,0.64,4.91,1.01,7.42,1.11c5.87,0,7.69-0.91,10.57-1.66s1.46,0.63,0.75,1.23c-1.28,1.09-4.66,4.07-11.86,4.27C62.59,187.88,58.93,186.75,58.01,185.64L58.01,185.64z M65.55,195.57c-2.56,0.79-4.25-0.59-4.06-1.53c0.12-0.57,0.31-1.11,0.59-1.62c2.18,0.67,4.47,0.89,6.73,0.63C70.7,192.73,68.17,194.76,65.55,195.57z M82.55,165.45c-2.43,2.9-10.46,6.19-19.88,4.32c-7.76-1.53-1.9-5.82-1.9-5.82c3.07,0.94,6.28,1.38,9.49,1.31c4.78-0.12,8.74-0.93,11.26-2.24s2.39,0.74,0.99,2.43L82.55,165.45z M82.61,157.95c-5.4,3.2-12.65,3.34-16,2.87c-11.46-1.62-6.51-6.18-6.51-6.18c2.99,0.8,6.02,1.4,9.09,1.82c3,0.32,10.48,0.23,13.77-0.86c1.37-0.45,0.95,1.55-0.39,2.4L82.61,157.95z M90.55,156.88c-1.25,0.59-4.05,0.59-2.7-1c0.98-1.08,2.04-2.09,3.18-3c0.09,1,0.22,2.17,0.41,3.4c-0.29,0.23-0.6,0.43-0.93,0.6H90.55zM104.64,121.81c1.2-1.07,1.99-2.53,2.23-4.13c2.6-0.07,7.26-0.33,9.15-0.48c2.34-0.2,4.64-0.71,6.84-1.52c0,0,6.9,4.36-1.44,5.63c-4.55,0.68-13.36,0.78-17,0.82c0.05-0.11,0.11-0.22,0.18-0.32L104.64,121.81z M103,126.44c2.48,0,7.38,0,10.8-0.2c4.07-0.31,8.13-0.88,12.13-1.69c0,0,7.41,4.36-3.58,6c-4.07,0.61-15.08,1-20,1.15c0.12-1.9,0.33-3.7,0.61-5.26H103z M102.09,136.07c3.58,0.42,14.32,0.1,17.1-0.14c3-0.25,8.6-1.25,8.6-1.25s8.86,4-3.82,6.19c-4,0.68-17.27,0.2-21.61-0.13h-0.41c-0.01-1.52,0.03-3.1,0.1-4.67H102.09z M101.89,144.69c6.15,0.82,12.37,1.08,18.57,0.79c2.91-0.27,7.62-1.3,7.62-1.3s11.93,4.16-2.79,7.15c-6.5,1.32-16.91,0.3-23.42-3.13c-0.03-1.01-0.03-2.2-0.02-3.51H101.89z M102.18,156.88c-0.31-0.15-0.61-0.34-0.88-0.55c0.18-1.23,0.31-2.4,0.41-3.4c1.14,0.91,2.2,1.92,3.18,3c1.3,1.54-1.5,1.54-2.75,0.95H102.18zM109.78,155.6c3.28,1.09,10.76,1.18,13.77,0.86c3.06-0.42,6.09-1.02,9.08-1.82c0,0,5,4.56-6.51,6.18c-3.35,0.47-10.59,0.33-16-2.87c-1.38-0.8-1.79-2.8-0.38-2.35H109.78z M110.19,165.45c-1.4-1.69-1.5-3.75,1-2.43s6.47,2.12,11.26,2.24c3.21,0.08,6.41-0.34,9.48-1.26c0,0,5.85,4.29-1.91,5.82c-9.41,1.82-17.45-1.47-19.87-4.37L110.19,165.45z M127.19,195.57c-2.61-0.81-5.14-2.84-3.25-2.52c2.26,0.26,4.55,0.04,6.72-0.63c0.28,0.51,0.48,1.05,0.6,1.62c0.07,0.96-1.59,2.32-4.16,1.53H127.19z M134.73,185.64c-0.91,1.11-4.57,2.24-6.88,2.18c-7.19-0.2-10.58-3.18-11.86-4.27c-0.71-0.6-2-2,0.76-1.23s4.58,1.68,10.47,1.68c2.49-0.09,4.96-0.46,7.37-1.09c0,0,0.93,1.68,0.05,2.73L134.73,185.64z M132.73,178.48c-7.62,2-15.71-0.3-18-2.3s-3.25-3.47-0.93-3.18s3.13,0.69,5.37,1.07c2.45,0.47,4.95,0.59,7.43,0.38c1.69-0.18,3.36-0.49,5-0.91c1.23-0.36,2.61-0.67,2.61-0.67s3.58,4.28-1.53,5.61L132.73,178.48z"
      />
    </svg>
  `;case"xp_vertebral-column":return V` <svg
    id="xp_vertebral-column"
    hidden
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0"
    y="0"
    style="width:12rem; height:55rem;"
    viewBox="0 0 192 580"
    style="enable-background:new 0 0 192 580;"
    xml:space="preserve"
  >
    <rect
      class="region"
      index="3v"
      x="76.29"
      y="191"
      class="region"
      index="1"
      width="40.09"
      height="51"
    />
    <rect
      class="region"
      index="2v"
      x="76.29"
      y="104"
      class="region"
      index="1"
      width="40.09"
      height="85"
    />
    <rect
      class="region"
      index="4v"
      x="76.29"
      y="244"
      class="region"
      index="1"
      width="40.09"
      height="38"
    />
    <path
      class="region"
      index="1v"
      d="M116.33,92.47c-2.86-0.68-4.53-1.22-5.19-1.86c-1.49-1.46-1.31-6.49-0.72-11.25H82.21c0.58,4.75,0.76,9.79-0.73,11.25c-0.66,0.64-2.33,1.18-5.19,1.86v8.79h40.04V92.47z"
    />

    <path
      class="outline"
      d="M105.11,580c-1.35,0.05-2.65-0.49-3.58-1.47c-2.74-2.94-2.27-9.67-1.9-15.08c0.12-1.64,0.22-3.18,0.22-4.4c0-3.15-0.46-7.49-0.91-11.7s-0.91-8.61-0.91-11.81c0.13-3.57,0.49-7.13,1.06-10.65c0.85-5.42,1.34-10.9,1.47-16.39c0-0.22-3.5-28.91-3.5-44.6c-0.07-7.84,0.83-15.67,2.68-23.29c0.68-2.53,1.09-5.12,1.21-7.74c0-0.83-3.29-68.52-4.62-112.75C95,364.35,91.75,432,91.71,432.9c0.12,2.61,0.53,5.19,1.21,7.71c1.85,7.62,2.75,15.45,2.68,23.29c0,15.69-3.47,44.38-3.5,44.67c0.13,5.47,0.62,10.92,1.47,16.32c0.57,3.52,0.93,7.08,1.06,10.65c0,3.2-0.47,7.58-0.91,11.81s-0.91,8.55-0.91,11.7c0,1.22,0.1,2.76,0.22,4.4c0.37,5.41,0.84,12.14-1.9,15.08c-0.93,0.98-2.23,1.52-3.58,1.47c-8,0-27.59-5.28-27.59-15.07c0-2.92,2.54-6.59,5.49-10.85c3.94-5.71,8.85-12.81,8.85-20.19c0-5.2-2.62-14.69-5.66-25.68c-4.6-16.65-10.31-37.37-10.31-54.73c0-7.25,0.36-14.5,1.09-21.72c0.42-4.66,0.79-8.69,0.79-13.78c0-4.05-1.58-10.28-3.75-18.9C51.09,377.83,42.1,342.26,42.1,284.9c0-6.93,2.3-19.06,4.73-31.9c2.79-14.7,5.94-31.35,5.94-42.21c0-7.53-4.15-34.59-6.09-46.82c-0.24,8-0.79,20.4-1.23,30.06c-0.33,7.43-0.59,13.31-0.59,14.46c0,1.38-0.09,4.19-0.19,7.44c-0.13,4.3-0.28,9.18-0.28,12.31c0,3.63-1.5,10.44-3.23,18.33c-0.93,4.23-1.89,8.61-2.68,12.79c-0.07,0.4-0.26,1.33-0.52,2.62c-1.4,7-5.13,25.7-5,28.54c0.14,2.43,2,25.66,2.24,28.48c0.52,5.14,0.47,14-1.27,17.72c-2.73,5.73-12.43,8.39-16.78,8.48c-1.46,0.03-2.85-0.62-3.75-1.77c-4.26-5.06-3.2-20.36-2.31-27.54c-1.6,3.18-3.46,6.23-5.56,9.11c-0.85,1.26-2.51,1.69-3.86,1c-1.52-0.97-2.09-2.92-1.34-4.56c0.13-0.36,0.36-1,0.66-1.94c1.88-5.64,6.87-20.61,11.45-25c2.54-2.45,5.29-11.59,4-41.21c0-0.94-0.07-1.57-0.07-1.82c0.07-7.28,0.51-14.55,1.31-21.79c0.47-5,0.88-9.23,0.88-13c0-0.47,0-1.34,0-2.55c-0.51-41.6,1.09-93.55,11.63-104.84c1.3-1.37,2.72-2.61,4.25-3.71c10.15-7.41,26-10.78,36.43-13c4.85-1,9-1.93,9.84-2.71c2.11-2.07-0.3-15.81-1.18-19.6c-1.37-3.21-2.44-6.54-3.2-9.95c-0.23-1.08-0.39-2-0.49-2.64c-0.67,0.27-1.43,0.16-2-0.29c-0.97-0.74-1.73-1.71-2.22-2.83c-0.97-1.88-1.72-3.88-2.22-5.94l-0.23-0.88c-0.44-1.71-0.78-3.45-1-5.2c-0.3-1.81-0.37-3.65-0.21-5.48c0.04-0.74,0.27-1.47,0.66-2.1c0-0.27-0.11-0.75-0.18-1.32c-0.36-2.97-0.39-5.97-0.11-8.95c0.24-2.97,0.87-5.89,1.88-8.69c0.78-2.11,1.83-4.11,3.12-5.95c1.92-2.67,4.4-4.89,7.27-6.5C84.93,1.13,89.95,0,96.33,0s11.41,1.13,15.79,3.55c2.87,1.61,5.35,3.83,7.27,6.5c1.27,1.85,2.3,3.84,3.06,5.95c1.01,2.8,1.64,5.72,1.88,8.69c0.28,3,0.24,6.01-0.12,9c-0.07,0.57-0.14,1-0.18,1.32c0.39,0.64,0.61,1.36,0.66,2.1c0.16,1.83,0.09,3.67-0.21,5.48c-0.22,1.75-0.56,3.49-1,5.2l-0.23,0.88c-0.5,2.06-1.25,4.06-2.22,5.94c-0.49,1.12-1.25,2.09-2.22,2.83c-0.57,0.45-1.33,0.56-2,0.29c-0.1,0.64-0.26,1.56-0.49,2.64c-0.76,3.42-1.84,6.77-3.2,10c-0.84,3.64-3.28,17.48-1.16,19.55c0.81,0.78,5,1.68,9.84,2.71c10.46,2.23,26.28,5.6,36.43,13c1.53,1.1,2.95,2.34,4.25,3.71c10.54,11.29,12.14,63.24,11.63,104.84c0,1.21,0,2.08,0,2.55c0,3.78,0.41,8.06,0.88,13c0.8,7.24,1.24,14.51,1.31,21.79c0,0.25,0,0.88-0.07,1.82c-1.3,29.62,1.45,38.76,4,41.21c4.58,4.42,9.57,19.39,11.45,25c0.3,0.91,0.53,1.58,0.66,1.94l0,0c0.71,1.61,0.15,3.5-1.31,4.47c-1.35,0.69-3.01,0.26-3.86-1c-2.11-2.86-3.98-5.89-5.59-9.06c0.89,7.18,1.95,22.48-2.31,27.54c-0.9,1.14-2.29,1.8-3.75,1.77c-4.35-0.09-14.05-2.75-16.78-8.48c-1.74-3.69-1.79-12.58-1.27-17.72c0.29-2.82,2.1-26.05,2.24-28.48c0.17-2.84-3.56-21.51-5-28.54c-0.26-1.29-0.45-2.22-0.52-2.62c-0.79-4.18-1.75-8.56-2.68-12.79c-1.73-7.89-3.23-14.7-3.23-18.33c0-3.13-0.15-8-0.28-12.31c-0.1-3.25-0.19-6.06-0.19-7.44c0-1.15-0.26-7-0.59-14.46c-0.43-9.66-1-22-1.23-30.06c-1.94,12.23-6.09,39.29-6.09,46.82c0,10.86,3.15,27.51,5.94,42.21c2.43,12.84,4.73,25,4.73,31.9c0,57.36-9,92.93-14.35,114.18c-2.18,8.62-3.76,14.85-3.76,18.9c0,5.09,0.37,9.12,0.79,13.78c0.72,7.21,1.08,14.46,1.08,21.71c0,17.36-5.72,38.08-10.32,54.73c-3,11-5.66,20.48-5.66,25.68c0,7.38,4.91,14.48,8.85,20.19c3,4.26,5.49,7.93,5.49,10.85C132.7,574.72,113.12,580,105.11,580zM96.33,291.71c0.3,0,0.55,0.25,0.55,0.55c0,0,0,0.01,0,0.01c0,33,5.12,139.5,5.17,140.57c-0.11,2.7-0.53,5.39-1.23,8c-1.83,7.53-2.72,15.25-2.65,23c0,15.62,3.45,44.25,3.49,44.53c-0.12,5.57-0.62,11.13-1.48,16.63c-0.55,3.48-0.88,6.98-1,10.5c0,3.14,0.46,7.49,0.9,11.69s0.92,8.62,0.92,11.82c0,1.26-0.11,2.82-0.23,4.47c-0.36,5.2-0.8,11.67,1.6,14.25c0.72,0.77,1.73,1.18,2.78,1.13c8.09,0,26.48-5.28,26.48-14c0-2.57-2.45-6.12-5.29-10.23c-4-5.83-9-13.09-9-20.81c0-5.35,2.64-14.91,5.7-26c4.59-16.58,10.29-37.22,10.29-54.43c0-7.22-0.36-14.44-1.09-21.62c-0.4-4.49-0.79-8.74-0.79-13.88c0-4.19,1.59-10.48,3.78-19.17c5.36-21.2,14.32-56.69,14.32-113.91c0-6.82-2.28-18.91-4.71-31.7c-2.93-15.46-5.95-31.45-5.95-42.41c0-9.86,6.78-51.29,7.07-53c0.02-0.3,0.29-0.53,0.6-0.51s0.53,0.29,0.51,0.6c0,5.93,0.78,23.4,1.35,36.15c0.33,7.45,0.6,13.33,0.6,14.51c0,1.36,0.09,4.16,0.19,7.41c0.13,4.31,0.28,9.19,0.28,12.34c0,3.51,1.55,10.59,3.2,18.09c0.93,4.24,1.89,8.63,2.68,12.83c0.08,0.39,0.26,1.32,0.52,2.61c2.4,12,5.14,26.17,5,28.81c-0.14,2.44-1.95,25.7-2.24,28.53c-0.5,4.87-0.47,13.68,1.17,17.13c2.4,5.06,11.43,7.76,15.81,7.85c1.12,0.04,2.2-0.47,2.87-1.37c4.87-5.78,2.16-26.91,1.59-29.9c-0.06-0.27,0.1-0.54,0.36-0.63c0.26-0.08,0.55,0.03,0.67,0.28c0.05,0.09,4.3,8.55,7,11.77c0.51,0.84,1.58,1.15,2.46,0.71c1-0.71,1.34-2.03,0.82-3.13l0,0c-0.13-0.36-0.36-1.05-0.67-2c-1.85-5.57-6.78-20.35-11.17-24.59c-3.93-3.79-5.38-17.94-4.32-42.05c0-0.91,0.07-1.53,0.07-1.77c0-8.14-0.7-15.33-1.31-21.68c-0.47-5-0.89-9.28-0.89-13.12c0-0.47,0-1.34,0-2.57c0.72-58.51-3.31-95.47-11.34-104.06c-1.25-1.32-2.62-2.52-4.09-3.58c-10-7.27-25.64-10.61-36-12.82c-6.14-1.31-9.39-2-10.38-3c-3-3,0.86-20.67,0.94-20.82c1.33-3.13,2.37-6.38,3.11-9.7c0.42-2,0.6-3.43,0.6-3.45c0.03-0.21,0.17-0.39,0.38-0.46c0.2-0.06,0.42,0,0.57,0.15c0.3,0.42,0.88,0.51,1.3,0.22c0.03-0.02,0.06-0.05,0.09-0.08c0.82-0.63,1.46-1.46,1.85-2.42c0.93-1.81,1.65-3.72,2.13-5.7l0.23-0.89c0.44-1.67,0.77-3.37,1-5.08c0.28-1.71,0.35-3.45,0.21-5.18c-0.17-1.27-0.45-1.59-0.55-1.7c-0.11-0.13-0.16-0.3-0.15-0.47c0,0,0.1-0.65,0.21-1.52c0.36-2.89,0.4-5.82,0.12-8.72c-0.23-2.89-0.85-5.73-1.83-8.45c-0.73-2-1.72-3.9-2.93-5.65c-1.82-2.54-4.18-4.64-6.9-6.17c-4.34-2.26-9.15-3.35-15.34-3.35s-11,1.09-15.25,3.42c-2.72,1.53-5.08,3.63-6.9,6.17c-1.21,1.75-2.2,3.65-2.93,5.65c-0.98,2.72-1.6,5.56-1.83,8.45c-0.28,2.9-0.24,5.83,0.12,8.72c0.11,0.87,0.2,1.52,0.21,1.52c0.02,0.16-0.03,0.32-0.13,0.44c-0.12,0.14-0.4,0.46-0.57,1.73c-0.14,1.73-0.07,3.47,0.21,5.18c0.23,1.71,0.56,3.41,1,5.08l0.23,0.89c0.48,1.98,1.2,3.89,2.13,5.7c0.39,0.96,1.03,1.79,1.85,2.42c0.38,0.35,0.96,0.33,1.31-0.05c0.03-0.03,0.05-0.06,0.08-0.09c0.15-0.15,0.37-0.21,0.57-0.15c0.21,0.07,0.35,0.25,0.38,0.46c0,0,0.18,1.49,0.6,3.45c0.75,3.33,1.79,6.59,3.13,9.73c0.06,0.12,4,17.82,0.92,20.79c-1,1-4.24,1.69-10.38,3c-10.37,2.21-26,5.55-36,12.82c-1.47,1.06-2.84,2.25-4.08,3.57c-8,8.59-12.06,45.55-11.34,104.06c0,1.23,0,2.1,0,2.57c0,3.84-0.42,8.14-0.89,13.12c-0.61,6.35-1.31,13.54-1.31,21.68c0,0.24,0,0.86,0.07,1.77c1.06,24.11-0.39,38.26-4.32,42.05c-4.39,4.24-9.32,19-11.17,24.59c-0.31,0.92-0.54,1.61-0.67,2c-0.53,1.12-0.17,2.46,0.85,3.16c0.88,0.44,1.95,0.13,2.46-0.71c2.68-3.22,6.94-11.68,7-11.77c0.12-0.25,0.41-0.36,0.67-0.28c0.26,0.09,0.42,0.36,0.36,0.63c-0.57,3-3.28,24.12,1.59,29.9c0.68,0.9,1.75,1.41,2.87,1.37c4.38-0.09,13.41-2.79,15.81-7.85c1.64-3.45,1.67-12.26,1.17-17.13c-0.29-2.83-2.1-26.09-2.24-28.53c-0.16-2.64,2.58-16.78,5-28.81c0.26-1.29,0.44-2.22,0.52-2.61c0.79-4.2,1.75-8.59,2.68-12.83c1.65-7.5,3.2-14.58,3.2-18.09c0-3.15,0.15-8,0.28-12.34c0.11-3.25,0.19-6.05,0.19-7.41c0-1.18,0.27-7.06,0.6-14.51c0.57-12.75,1.35-30.22,1.35-36.15c-0.02-0.3,0.2-0.57,0.51-0.6c0.3-0.02,0.57,0.2,0.59,0.51c0.29,1.76,7.07,43.19,7.07,53c0,11-3,27-6,42.41c-2.43,12.79-4.71,24.88-4.71,31.7c0,57.22,9,92.71,14.32,113.91c2.2,8.69,3.82,14.98,3.82,19.19c0,5.14-0.39,9.39-0.79,13.88c-0.73,7.18-1.09,14.4-1.09,21.62c0,17.21,5.7,37.85,10.29,54.43c3.06,11.07,5.7,20.63,5.7,26c0,7.72-5,15-9,20.81c-2.84,4.11-5.29,7.66-5.29,10.23c0,8.69,18.39,14,26.48,14c1.03,0.01,2.01-0.43,2.7-1.2c2.4-2.58,2-9,1.6-14.25c-0.12-1.65-0.23-3.21-0.23-4.47c0-3.2,0.47-7.58,0.92-11.82s0.9-8.55,0.9-11.69c-0.12-3.52-0.45-7.02-1-10.5c-0.86-5.47-1.36-11-1.48-16.54c0-0.35,3.49-29,3.49-44.6c0.07-7.75-0.82-15.47-2.65-23c-0.7-2.61-1.12-5.3-1.23-8c0-1.1,5.17-107.61,5.17-140.6C95.8,292,96.02,291.73,96.33,291.71C96.33,291.71,96.33,291.71,96.33,291.71z"
    />
    <path
      class="bone"
      disabled
      d="M71.65,205c2.93-2.09,8-5.4,9.94-7.62c1.64-1.98,3.16-4.07,4.54-6.24c1.3-1.93,1.85-3.3,0.79-3.92s-2.7,1.07-3.74,2.1s-3.66,4.67-5.93,6.82c-2.06,2-7.07,5.12-10.46,8s-5.87,5.67-5.33,7.36C62.27,214,68.75,207.07,71.65,205z"
    />
    <path
      class="bone"
      disabled
      d="M121.25,205c-2.93-2.09-8-5.4-10-7.62c-1.64-1.98-3.15-4.07-4.53-6.24c-1.31-1.93-1.86-3.3-0.8-3.92s2.71,1.07,3.74,2.1s3.67,4.67,5.93,6.82c2.06,2,7.08,5.12,10.46,8c3.38,2.88,5.87,5.67,5.34,7.36C130.62,214,124.14,207.07,121.25,205z"
    />
    <path
      class="bone"
      disabled
      d="M82.56,111.91c1.73,1.94,6,0.39,6.64-2.07c0.4-1.65-0.17-2.51-1.9-3.21c-15-6-22.78-5.63-35.38-3.5c-4.05,0.69-5.87,1.41-6.1,2.08s0.78,0.88,1.32,2c0.41,0.82-0.25,1.76,0.2,2.3s4.12-0.89,7.65-1.36C63.84,106.91,78.33,107.15,82.56,111.91z"
    />
    <path
      class="bone"
      disabled
      d="M110.09,111.91c-1.72,1.94-6,0.39-6.64-2.07c-0.4-1.65,0.18-2.51,1.9-3.21c15-6,22.78-5.63,35.38-3.5c4.06,0.69,5.87,1.41,6.1,2.08s-0.77,0.88-1.31,2c-0.41,0.82,0.24,1.76-0.21,2.3s-4.12-0.89-7.65-1.36C128.81,106.91,114.33,107.15,110.09,111.91z"
    />
    <path
      class="bone"
      disabled
      d="M86.05,104.07c1.3-0.06,2.42-2.73,0-3.32c-3.44,0-6.88,0.28-10.27,0.86c3.24,0.63,6.44,1.46,9.58,2.49L86.05,104.07z"
    />
    <path
      class="bone"
      disabled
      d="M106.6,104.07h0.66c3.14-1.03,6.34-1.86,9.58-2.49c-3.39-0.58-6.82-0.86-10.26-0.86C104.18,101.34,105.33,104,106.6,104.07z"
    />
    <path
      class="bone"
      disabled
      d="M5.42,316.19c-0.23-0.25-0.27,0.18-0.34,0.4C5,317.06,4.96,317.53,4.97,318c-0.06,0.43-0.22,0.84-0.48,1.19c-0.29,0.32-0.46,0.74-0.47,1.18c0,0.4,0.32,0.73,0.68,0.48c0.28-0.25,0.5-0.55,0.65-0.89c0.22-0.39,0.38-0.83,0.62-1.21s0.57-0.44,0.9-0.67s0.63-0.51,0.39-0.63C6.55,317.2,5.91,316.77,5.42,316.19z"
    />
    <path
      class="bone"
      disabled
      d="M22.23,317.35c0.22-0.09,0.38-0.27,0.44-0.5c0.11-0.55,0.09-1.12-0.07-1.66c-0.66-2.67-0.51-5.47,0.43-8.06c0.23-0.63,0.31-1.12,0.52-1.76c0.15-0.4,0.15-0.84,0-1.24c-0.4-0.83-1.14-0.73-1.77-0.5c-0.3,0.14-0.57,0.34-0.78,0.6c-0.51,0.81-0.64,1.8-0.36,2.71c0.2,1.2,0.15,2.42-0.13,3.6c-0.15,1.13-0.38,2.25-0.67,3.35c-0.29,0.9-1,2.1-0.55,3.05l0,0C20.11,317.63,21.25,317.79,22.23,317.35z"
    />
    <path
      class="bone"
      disabled
      d="M15.66,300c-0.29-0.35-0.53-0.78-0.83-1.13c-0.52-0.61-0.93-1.05-1.44-0.25c-0.42,0.91-0.77,1.84-1.06,2.8c-0.42,0.95-0.96,1.85-1.61,2.66c-0.56,0.64-1.42,1-1.76,1.83c-0.08,0.18-0.14,0.36-0.17,0.55c-0.01,0.07-0.01,0.15,0,0.22c0.39,0.67,0.97,1.21,1.67,1.55c0.67,0.35,1.47,0.35,2.14,0c0.06-0.08,0.1-0.16,0.13-0.25c0.12-0.47,0.17-0.95,0.16-1.43c0.05-0.55,0.18-1.1,0.39-1.61c0.35-1.05,0.94-2,1.72-2.78c0.4-0.33,1.56-0.47,1.43-1.18C16.33,300.59,15.89,300.23,15.66,300z"
    />
    <path
      class="bone"
      disabled
      d="M9.56,308.81c-0.7-0.33-0.79-0.78-1.23-1.15c-0.44-0.37-0.51,0.48-0.55,0.7c-0.18,1.67-0.52,3.31-1,4.92c-0.25,0.51-1.43,1.45-1.33,1.87s2,1.77,2.5,1.63c0.29-0.08,0.18-0.64,0.18-0.92c-0.05-0.87,0.13-1.74,0.53-2.52c0.33-0.8,0.83-1.52,1.46-2.12c0.54-0.42,1.32-0.73,1.41-1.61C11.58,308.89,10.45,309.23,9.56,308.81z"
    />
    <path
      class="bone"
      disabled
      d="M19,301.53c-1.22-0.27-2.21-0.17-2.45,1c-0.03,0.48-0.02,0.97,0.05,1.45c0.08,1.32-0.08,2.64-0.45,3.91c-0.3,1.32-0.34,2.72-0.73,4s-1.4,2.28-1.92,3.55c-0.16,0.35-0.18,0.75-0.06,1.12c0.11,0.3,0.37,0.53,0.69,0.59c0.74,0.18,1.51,0.26,2.27,0.25c0.28-0.01,0.54-0.13,0.72-0.34c0.21-0.27,0.35-0.59,0.38-0.93c0.04-0.69,0.02-1.38-0.07-2.06c-0.06-0.84-0.06-1.68,0-2.52c0.12-1.75,0.61-3.46,1.45-5c0.29-0.65,0.63-1.28,1-1.88c0.37-0.43,0.63-0.94,0.78-1.49C20.88,302.05,19.97,301.74,19,301.53z"
    />
    <path
      class="bone"
      disabled
      d="M28.12,316c0.31-0.26,0.43-0.68,0.31-1.07c-0.2-0.47-0.43-0.92-0.69-1.36c-0.34-1.01-0.5-2.07-0.46-3.13c-0.06-0.8-0.28-2.67-0.29-3.45c0-1,0.55-2.34,0.21-3.34s-2-1-2.72-0.5c-0.93,0.66-0.13,1.67,0.19,2.5c0.13,0.52,0.22,1.04,0.29,1.57c0.41,1.98,0.44,4.01,0.1,6c-0.09,0.51-0.1,1.03-0.05,1.54c0.06,0.52,0.39,0.98,0.86,1.22c0.46,0.26,0.99,0.37,1.51,0.32C27.65,316.27,27.9,316.16,28.12,316z"
    />
    <path
      class="bone"
      disabled
      d="M33.26,321.56c-0.72,0.37-1.54,0.47-2.32,0.3c-0.2-0.07-0.32-0.28-0.28-0.49c0.1-0.45,0.41-0.94,0.45-1.36c0.02-0.69-0.14-1.38-0.45-2c-0.34-0.6-0.65-1.22-0.93-1.85c-0.12-0.39-0.14-0.78,0.1-0.75c0.46,0.19,0.94,0.33,1.43,0.4l0,0c0.42-0.1,0.83-0.24,1.22-0.43c0.17,0,0.11,0.6,0.07,0.84c-0.09,0.39-0.12,0.78-0.1,1.18c0.03,0.51,0.08,1.02,0.17,1.53c0.06,0.3,0.17,0.59,0.32,0.86C33.27,320.37,33.75,321.4,33.26,321.56z"
    />
    <path
      class="bone"
      disabled
      d="M33.33,326.61c0.42-0.18,0-0.81-0.14-1.09c-0.27-0.32-0.44-0.72-0.47-1.14c0-0.44,0.29-0.83,0.21-1.28s-0.55-0.52-0.92-0.38c-0.37,0.14-1.13-0.17-1.34,0s0.2,0.85,0.34,1.13c0.18,0.39,0.28,0.82,0.28,1.26c-0.04,0.41-0.04,0.83,0,1.24c0.01,0.07,0.04,0.14,0.09,0.19C31.98,326.88,32.71,326.91,33.33,326.61z"
    />
    <path
      class="bone"
      disabled
      d="M28.33,326.16c0.18-0.09,0.29-0.27,0.28-0.47c-0.11-0.57-0.29-1.13-0.54-1.65c-0.28-1.03-0.42-2.09-0.39-3.16c0.17-0.9,0.38-1.79,0.64-2.67c0.16-0.9-0.42-1-1.19-1h-0.8c-0.62,0-1.53-0.25-1.74,0.58s0.36,2,0.72,2.76c0.47,0.82,0.65,1.78,0.51,2.71c-0.31,0.84-0.51,1.72-0.62,2.61c0.01,0.19,0.15,0.35,0.33,0.39C26.45,326.52,27.43,326.49,28.33,326.16z"
    />
    <path
      class="bone"
      disabled
      d="M27.94,327.49c-0.17,0-0.6,0.19-0.92,0.2h-0.09c-0.44-0.02-0.87-0.1-1.29-0.22c-0.09-0.01-0.17,0.02-0.24,0.07c-0.69,0.42-0.15,1.09,0.2,1.76c0.36,0.77,0.47,1.64,0.3,2.47c-0.2,0.73-0.26,1.48-0.17,2.23c0.19,0.61,1.07,0.5,1.55,0.56s1.12,0.33,1.2-0.32s-0.55-1.43-0.56-2.11s-0.18-1.29-0.21-2s0.51-1.18,0.52-1.81C28.24,327.92,28.12,327.54,27.94,327.49z"
    />
    <path
      class="bone"
      disabled
      d="M15.94,327.28c0.21-0.24,0.34-0.53,0.39-0.84c0.18-0.9-0.42-1.79-0.53-2.7c-0.13-0.84,0-1.7,0.37-2.46c0.34-0.72,1.23-1.5,0.87-2.25c-0.21-0.59-0.84-0.91-1.44-0.73c-1.43,0.2-2.32-0.51-2.39,0.5c0.02,0.94,0.18,1.87,0.46,2.77c0.23,0.86,0.3,1.76,0.21,2.65c-0.07,0.5-0.19,0.99-0.36,1.46c-0.12,0.38-0.42,0.8-0.32,1.19c0.04,0.12,0.09,0.23,0.17,0.33C14.16,327.65,15.12,327.68,15.94,327.28z"
    />
    <path
      class="bone"
      disabled
      d="M15.6,335.2c-0.39,0.2-0.82,0.32-1.26,0.34c-0.18,0.01-0.36-0.01-0.54-0.06c-0.13,0-0.28-0.13-0.33-0.14s-0.1,0-0.12,0.07c-0.39,0.6,0.61,1.2,0.55,1.93s-0.08,1.87,0.84,1.82c0.38-0.06,0.69-0.32,0.82-0.68c0.11-0.42,0.01-0.88-0.27-1.21c-0.19-0.32-0.35-0.54-0.12-0.88c0.28-0.27,0.49-0.59,0.63-0.95C15.85,335.09,15.6,335.2,15.6,335.2z"
    />
    <path
      class="bone"
      disabled
      d="M14,334.76c0.61,0.05,1.22-0.13,1.7-0.51c0.05-0.39-0.02-0.79-0.21-1.14c-0.26-0.59-0.33-1.25-0.22-1.89c0.12-0.77,1.52-2.79,0.51-3c-0.65,0.05-1.29,0.15-1.92,0.29c-0.6,0-0.8,0.35-0.75,1s0.47,0.91,0.57,1.6c0.08,0.64,0.02,1.29-0.17,1.91l-0.07,0.22c-0.04,0.36-0.04,0.72,0,1.08l0,0C13.56,334.54,13.76,334.69,14,334.76z"
    />
    <path
      class="bone"
      disabled
      d="M20.11,335.73c0.67,0,1.34-0.03,2-0.11c0.1-0.05,0.18-0.13,0.24-0.23c0.25-0.52-0.1-1.52-0.17-2.06c-0.13-0.7-0.23-1.4-0.28-2.11c0-0.7,0.43-1.11,0.58-1.74s-0.06-0.92-0.7-0.83c-0.35,0.11-0.71,0.2-1.07,0.27c-0.39,0-0.7-0.23-1-0.15c-0.81,0.19-0.57,1-0.23,1.55c0.44,0.73,0.93,1.19,0.89,2.12c-0.02,0.77-0.2,1.52-0.54,2.21C19.83,334.65,19.24,335.64,20.11,335.73z"
    />
    <path
      class="bone"
      disabled
      d="M41.33,217.7c0.66-3.54-3.71-6.66-4.06-11.65s2.2-67.68,4.37-71.72c0.67-1.37,1.65-2.57,2.86-3.49c3.08-2.44,4.39-6.5,3.32-10.29c-1.16-4.36-4.21-6-7.59-6c-1.7-0.02-3.24,0.99-3.9,2.55c-1.17-0.33-3.46-0.2-3.8,2c-0.46,4.66-0.4,9.35,0.16,14c0.68,4.75-1.27,42.89-1.68,53.24c-0.36,9.16-1.48,17.08-4.08,20.65s-5.76,4.75-5.56,8.11c0.18,3.15,3.54,6.27,6.31,5.21c1.67-0.63,2-1.2,2.57-1.33c0.29-0.06,0.56-0.58,1.27,0.13c0.69,0.7,1.53,1.23,2.46,1.56C36.33,221.47,40.51,222.18,41.33,217.7z"
    />
    <path
      class="bone"
      disabled
      d="M22.17,337.68c0.16-0.37,0.55-0.81,0.18-1.19s-0.73,0-1.11,0h-0.28c-0.33,0-1,0-1.1,0.47s0.38,0.73,0.55,1c0.25,0.41,0.4,0.87,0.43,1.35c-0.06,0.47,0,0.96,0.18,1.4c0.23,0.35,0.53,0.69,0.95,0.58c0.43-0.14,0.71-0.55,0.69-1C22.63,339.42,21.79,338.57,22.17,337.68z"
    />
    <path
      class="bone"
      disabled
      d="M28.15,336.58c0.16-0.34,0.21-0.31,0.16-0.75s-0.62-0.44-1-0.23l-0.35-0.05c-0.3,0-0.85-0.06-1,0.34s0.34,0.67,0.49,0.94c0.23,0.37,0.36,0.79,0.38,1.23c-0.07,0.43-0.02,0.87,0.15,1.27c0.2,0.31,0.47,0.63,0.87,0.54c0.4-0.13,0.67-0.51,0.65-0.93C28.56,338.16,27.79,337.37,28.15,336.58z"
    />
    <path
      class="bone"
      disabled
      d="M33.63,327.39c-0.34-0.13-0.75,0.32-1,0.25l-0.42-0.2c-0.32-0.06-0.77-0.25-0.91,0.08s0.27,0.6,0.39,0.85c0.18,0.34,0.27,0.71,0.26,1.09c0,0.37-0.16,0.77,0,1.09c0.16,0.32,0.4,0.58,0.77,0.54c0.37-0.06,0.65-0.37,0.68-0.75c0-0.67-0.6-1.41-0.2-2.06C33.41,328,34.02,327.54,33.63,327.39z"
    />
    <path
      class="bone"
      disabled
      d="M22.71,319.85c0.1-0.8-0.35-1.15-1.14-1.39c-0.61-0.22-1.29-0.15-1.83,0.21c-0.73,0.45-0.35,1.21-0.16,1.85c0.26,0.84,0.38,1.72,0.34,2.6c-0.07,0.89-0.14,1.77-0.15,2.67c-0.03,0.24-0.09,0.47-0.16,0.7c0,0.68-0.12,1.4,0.7,1.53c0.79,0.11,1.59-0.17,2.13-0.75c0.42-0.64-0.11-1.32-0.25-2c-0.17-0.89-0.2-1.81-0.08-2.71C22.22,321.64,22.6,320.78,22.71,319.85z"
    />
    <path
      class="bone"
      disabled
      d="M32.39,314.47c0.67-0.86,0.09-2-0.33-2.81c-0.48-0.91-0.8-1.91-0.93-2.93c-0.2-1.15-0.31-2.31-0.32-3.47c0.03-0.52,0.08-1.04,0.17-1.56c0.1-0.39,0.08-0.81-0.06-1.19c-0.44-0.85-1.86-0.61-2.52-0.28c-1.06,0.54-0.44,1.39,0,2.23c0.97,2.2,1.36,4.61,1.12,7c-0.17,1-0.39,2.17,0.31,3c0.61,0.71,1.67,0.79,2.38,0.19C32.28,314.59,32.34,314.53,32.39,314.47z"
    />
    <path
      class="bone"
      disabled
      d="M32.19,223.46c1.08,0.71,2.43,0.85,3.63,0.39c1.1-0.42,1.9-0.8,1.95,0.55c0.09,2.3-1.49,2.17-2,8.84s-1.57,20.13-1.34,25.18s-1.49,15.91-2.16,20.63c-0.67,4.72-1.33,5.71-1.27,7.86c0,0.94,0.15,3.34-0.35,4.48c-0.16,0.35-0.55,0.52-0.92,0.41c-0.28-0.08-0.64-0.18-1.07-0.28c-1.29-0.69-2.45-2-1.64-5.48c1.13-5.65,1.95-11.36,2.46-17.1c0.34-4-0.33-16.9-0.67-21.13l-0.68-13.42c-0.61,3.55-1.87,10.43-3.18,17.43s0,32.36,1,37.27c0.12,0.46,0.18,0.93,0.18,1.4c-0.02,0.3-0.28,0.53-0.58,0.51c-0.01,0-0.02,0-0.04,0c-0.84-0.1-1.68-0.1-2.52,0c-1.43,0.24-2.83,0.65-4.17,1.23c-0.54,0.22-1.15-0.04-1.37-0.58c-0.03-0.07-0.05-0.15-0.06-0.23c0-1.29,0.12-2.58,0.36-3.85c0.26-2.8,1.71-8.55,1.91-15.28s0.19-19.76,2.69-30.74c2-8.64,2.46-13.78,1-15.89s-1.08-3.21,1.28-2.78c0.91,0.4,1.94,0.4,2.85,0c0.8-0.39,1.67-0.63,2.56-0.7C30.67,222.28,31.33,222.92,32.19,223.46z"
    />
    <path
      class="bone"
      disabled
      d="M30.72,295.42c-0.09-0.49-0.38-0.93-0.8-1.2c-1.94-0.62-3.97-0.92-6-0.87c-1.23,0.17-2.43,0.48-3.58,0.93l-1,0.57c-0.72,0.58-1.53,1.06-2.39,1.41c-0.57,0.23-1.02,0.68-1.25,1.25c0,0.14,0.02,0.29,0.05,0.43c0,0,0,0,0,0.06c0.36,0.8,0.84,1.53,1.44,2.16c0.42,0.09,0.85,0.14,1.28,0.14c0.92-0.06,1.83,0.14,2.64,0.58c0.13,0.1,0.25,0.21,0.36,0.33c0.52,0.61,1.31,0.91,2.1,0.8c0.74-0.07,1.46-0.27,2.12-0.6c0.72-0.34,1.48-0.57,2.27-0.68c1-0.12,1.39,0.06,2.38-0.06s0.53-4.51,0.53-4.51C30.81,295.9,30.76,295.66,30.72,295.42z"
    />
    <path
      class="bone"
      disabled
      d="M87.23,571c-1.09-0.39-2.69-0.45-3.42,0.39c-0.14,0.25-0.21,0.53-0.2,0.82c0,0.58,0.73,0.83,0.86,1.36c0.18,0.77-0.67,1.18-0.79,1.86c-0.24,1.38,1.77,1.62,2.53,1.14c0.56-0.37,0.47-1,0.73-1.54s0.65-0.63,1-1.11c0.63-0.9,0.41-2.15-0.49-2.79C87.38,571.08,87.31,571.04,87.23,571z"
    />
    <path
      class="bone"
      disabled
      d="M79.26,548.15c-0.71,0.4-0.43,1.17-0.51,1.9c-0.23,1.72-0.59,3.42-1.09,5.09c-0.09,0.29-0.2,0.58-0.33,0.86c-0.34,0.62-0.12,1.4,0.5,1.74c0.21,0.12,0.44,0.17,0.68,0.16c0.39,0,0.77-0.11,1.09-0.32c0.6-0.33,0.66-0.7,0.57-1.37c-0.42-3.2,1.4-6.72,1-7.39c-0.28-0.69-1.07-1.02-1.76-0.74C79.36,548.1,79.31,548.12,79.26,548.15z"
    />
    <path
      class="bone"
      disabled
      d="M71.04,564.15c-0.06-0.07-0.27-0.19-0.31-0.1c-0.42,0.81,0.09,1.55-0.41,2.41c-0.28,0.64-0.6,1.26-0.95,1.86c-0.22,0.29-0.46,0.35-0.53,0.77s0.08,0.8,0,1.19s-0.3,0.68-0.07,1s0.52,0.26,0.73,0c0.5-0.63,0.09-1.36,1.06-1.63c0.08-0.4,0-0.79,0-1.18c0.14-0.32,0.3-0.62,0.49-0.91c0.28-0.55,0.39-1.23,1-1.45c0.41-0.15,0.67,0,0.95-0.4s0.1-0.57-0.21-0.88c-0.22-0.15-0.49-0.23-0.76-0.24c-0.5,0-0.77,0.06-0.88-0.19S71.17,564.31,71.04,564.15z"
    />
    <path
      class="bone"
      disabled
      d="M68.8,563.15c-0.37-0.57-0.64,0-1.25-0.27c0,0,0-0.17-0.06-0.22s-0.31-0.3-0.39-0.27c-0.85,0.26,0.18,1.37-0.31,2.16c-0.3,0.57-0.63,1.11-1,1.64c-0.21,0.26-0.43,0.3-0.51,0.67s0,0.73,0,1.09s-0.3,0.6-0.1,0.93s0.46,0.26,0.66,0c0.48-0.56,0.14-1.24,1-1.43c0.1-0.37,0-0.73,0.1-1.08c0.14-0.28,0.3-0.55,0.49-0.8c0.27-0.49,0.41-1.11,1-1.28c0.37-0.12,0.38,0.14,0.54-0.31C69.07,563.69,69.01,563.37,68.8,563.15z"
    />
    <path
      class="bone"
      disabled
      d="M65.42,562.8c-0.37,0.1-0.47,0.51-0.67,0.84c-0.13,0.16-0.25,0.34-0.35,0.52c-0.08,0.24,0,0.48-0.09,0.72c-0.6,0.11-0.39,0.58-0.73,1c-0.14,0.15-0.31,0.19-0.44,0s0-0.43,0.09-0.63s0-0.5,0-0.73s0.21-0.27,0.36-0.44c0.25-0.35,0.47-0.71,0.68-1.08c0.35-0.52-0.35-1.23,0.22-1.39c0.09,0,0.18,0.05,0.24,0.12c0.04,0.09,0.09,0.17,0.15,0.25c0.32,0.25,0.67-0.06,1,0.28C65.96,562.18,66.22,562.6,65.42,562.8z"
    />
    <path
      class="bone"
      disabled
      d="M74.7,571.63c0.2-0.86,0.25-1.75,0.14-2.63c0.02-0.32,0.19-0.62,0.46-0.79c0.37-0.27,0.81-0.42,1.27-0.44c0.3,0.07,0.58,0.21,0.82,0.4c0.3,0.24,0.44,0.63,0.36,1c-0.08,0.29-0.18,0.57-0.3,0.84c-0.46,1.16-0.58,2.42-1,3.61c-0.2,0.55-1.75,1.14-2.17,0.14C73.91,572.91,74.33,572.34,74.7,571.63z"
    />
    <path
      class="bone"
      disabled
      d="M85.33,536.23c1.59,0.13,3.33,1.07,3.53,2.69c0.28,1.46,1.08,2.77,2.26,3.68c0.79,0.7,1.23,1.71,1.21,2.77c0.06,1.81,0.09,5.29-1.69,5.23c-1.1-0.15-2.1-0.75-2.74-1.66c-0.93-1.05-2.66-1.35-4.89-1.19c-1.64,0.11-3.14-1.35-5.06-1.19s-2.39,1-3.72,1.41s-1.86-1.05-0.86-2c0.93-0.71,1.92-1.33,2.96-1.88c2.81-1.58,2-4.63,2.4-5.76C79.26,536.74,83.43,536.08,85.33,536.23z"
    />
    <path
      class="bone"
      disabled
      d="M88.61,563.65c0.74,1.13,1.55,2.89,0.15,2.81c-0.59-0.86-1.34-1.6-2.21-2.17c-1-0.43-2,0.51-3,1.63c-0.29,0.1-0.35-0.08-0.46-0.36c-0.43-1.12,0.36-2.78,0.45-3.91c0.12-1.51-0.54-2.54-1-3.92c-0.46-1.54,0.09-2.1,0.09-2.1s1.88-2,3.66-1.63c0.44,0.1,0.84,0.34,1.14,0.68c0.59,0.59,0.94,1.37,1,2.2c0.05,1.01-0.03,2.01-0.23,3C87.96,561.37,87.79,562.4,88.61,563.65z"
    />
    <path
      class="bone"
      disabled
      d="M82.38,554.35c0.05,0.07,0.15,0.09,0.22,0.04c0.01-0.01,0.03-0.02,0.04-0.04c0.68-0.83,1.63-1.38,2.69-1.55c1.28-0.15,3.24,1.3,3.53,1.67s0.43-0.44,0.37-0.9c-0.21-1.5-1.22-3.51-2.35-4.09c-1.17-0.54-2.51-0.6-3.72-0.15c-0.59,0.25-1.07,0.71-1.33,1.3c-0.3,0.62-0.37,1.33-0.19,2C81.79,553.24,82.04,553.82,82.38,554.35z"
    />
    <path
      class="bone"
      disabled
      d="M74.33,556.18c-0.32-0.23,2-7.83,2-7.83c0.13-0.17,0.32-0.28,0.53-0.32c1.48-0.39,1.21,0.1,1.21,0.1c-1.29,2.44-1.53,7.33-1.87,7.89C76.25,556,75.72,557.13,74.33,556.18z"
    />
    <path
      class="bone"
      disabled
      d="M71.25,552.31c0.29-0.81,0.64-1.57,0.94-2.38l0.13-0.13c0.11,0,0.74-0.32,0.61,0.07s-0.88,2.5-0.88,2.5c-0.37,0.88-0.66,1.68-0.76,1.79s-0.59,0.28-0.7,0C70.33,553.53,71.06,552.84,71.25,552.31z"
    />
    <path
      class="bone"
      disabled
      d="M74.97,549.58c-0.15,0.36-1.79,5.79-1.86,6s-0.54,0-0.74-0.24c-0.6-0.66,0.21-1.43,0.33-2.15v-0.16c0,0,1-3.17,1-3.37S75.11,549.21,74.97,549.58z"
    />
    <path
      class="bone"
      disabled
      d="M76.8,564.52c-0.31,0.04-0.62,0.11-0.91,0.21c-0.1,0.04-0.21-0.01-0.24-0.11c0-0.01,0-0.01-0.01-0.02c-0.28-1.08,0.87-2,1-3.25s-0.45-2.77,1.33-2.38c0.41-0.01,0.82,0.01,1.23,0.06c0.36,0.13,0.58,0.26,0.55,0.65l-0.42,5.24c0,0-0.06,0.38-0.78,0.07l-0.54-0.25C77.64,564.55,77.22,564.48,76.8,564.52z"
    />
    <path
      class="bone"
      disabled
      d="M71.74,562.6c0.09-0.41,0.25-0.8,0.46-1.17c0.1-0.4,0.29-0.77,0.57-1.08c0.27-0.39,0.51-0.81,0.71-1.24c0.2-0.42,0.09-1.19,0.51-1.36c0.49-0.09,1-0.01,1.45,0.22c0.13,0.33-0.24,0.85-0.45,1.32c-0.42,1-1,1.91-1.41,2.89s-0.39,1.43-0.78,1.44l-0.82-0.46C71.85,563,71.76,562.81,71.74,562.6z"
    />
    <path
      class="bone"
      disabled
      d="M75.08,566.21c0,0-0.41,0.35-0.35,0.61s0.45,0.31,0.45,0.31c0.45-0.27,0.98-0.39,1.5-0.36c0.57,0.16,1.1,0.43,1.55,0.81c0.34,0.23,0.52-0.27,0.51-0.81c-0.01-0.43-0.26-0.82-0.65-1c-0.21-0.1-0.44-0.17-0.67-0.21c-0.83,0-1.64,0.24-2.34,0.69"
    />
    <path
      class="bone"
      disabled
      d="M72.38,557.33c-0.32,0.93-1,1.36-1.55,2.12c-0.28,0.39-0.51,0.81-0.67,1.26c-0.15,0.43-0.43,1.28-0.68,1.34s-1.49-0.13-1.5-0.38s3.18-5,3.45-5.31S72.62,556.61,72.38,557.33z"
    />
    <path
      class="bone"
      disabled
      d="M66.69,561.21c-0.2,0-1.48-0.21-1.55-0.53s1.49-2.06,2.5-2.86s1.12-2,2.13-2.48c0.42-0.2,1.12,0.07,0.83,0.54s-3.51,5-3.51,5C66.97,561,66.83,561.11,66.69,561.21z"
    />
    <path
      class="bone"
      disabled
      d="M87.14,569.82c0,0,0.22,0,0.26,0s1.59-0.49,1.28-1.63s-2.06-2.77-2.57-2.64c0,0-0.66-0.15-1.83,1.3c-0.35,0.42-0.58,0.93-0.66,1.47c-0.05,0.41,0.17,0.81,0.54,1c0.39-0.06,0.78-0.09,1.17-0.1c0.54,0.11,1.05,0.33,1.5,0.66C86.94,569.9,87.05,569.88,87.14,569.82z"
    />
    <path
      class="bone"
      disabled
      d="M187.26,316.19c0.23-0.25,0.27,0.18,0.34,0.4c0.07,0.46,0.11,0.92,0.1,1.39c0.06,0.43,0.23,0.84,0.49,1.19c0.29,0.32,0.46,0.74,0.46,1.18c0,0.4-0.31,0.73-0.67,0.48c-0.28-0.25-0.5-0.55-0.65-0.89c-0.22-0.39-0.39-0.83-0.62-1.21s-0.57-0.44-0.91-0.67s-0.62-0.51-0.38-0.63C186.13,317.18,186.77,316.76,187.26,316.19z"
    />
    <path
      class="bone"
      disabled
      d="M170.44,317.35c-0.22-0.09-0.38-0.27-0.44-0.5c-0.1-0.55-0.08-1.12,0.08-1.66c0.65-2.67,0.5-5.47-0.43-8.06c-0.24-0.63-0.32-1.12-0.53-1.76c-0.16-0.4-0.16-0.84,0-1.24c0.4-0.83,1.14-0.73,1.76-0.5c0.31,0.14,0.58,0.34,0.79,0.6c0.51,0.81,0.64,1.8,0.35,2.71c-0.19,1.2-0.14,2.42,0.14,3.6c0.15,1.13,0.38,2.25,0.67,3.35c0.29,0.9,1,2.1,0.55,3.05l0,0C172.56,317.63,171.42,317.79,170.44,317.35z"
    />
    <path
      class="bone"
      disabled
      d="M177.02,300c0.29-0.35,0.53-0.78,0.83-1.13c0.52-0.61,0.93-1.05,1.44-0.25c0.42,0.93,0.79,1.88,1.09,2.85c0.41,0.96,0.95,1.85,1.61,2.66c0.55,0.64,1.42,1,1.76,1.83c0.08,0.18,0.14,0.36,0.17,0.55c0.01,0.07,0.01,0.15,0,0.22c-0.39,0.67-0.97,1.21-1.67,1.55c-0.67,0.35-1.46,0.35-2.13,0c-0.06-0.08-0.1-0.16-0.14-0.25c-0.11-0.47-0.16-0.95-0.15-1.43c-0.05-0.55-0.18-1.1-0.39-1.61c-0.35-1.05-0.94-2-1.72-2.78c-0.4-0.33-1.56-0.47-1.44-1.18C176.33,300.59,176.79,300.23,177.02,300z"
    />
    <path
      class="bone"
      disabled
      d="M183.12,308.81c0.7-0.33,0.79-0.78,1.22-1.15s0.51,0.48,0.55,0.7c0.18,1.67,0.52,3.31,1,4.92c0.25,0.51,1.43,1.45,1.33,1.87s-2,1.77-2.5,1.63c-0.29-0.08-0.19-0.64-0.19-0.92c0.06-0.87-0.13-1.74-0.53-2.52c-0.33-0.8-0.82-1.52-1.45-2.12c-0.54-0.42-1.32-0.73-1.41-1.61C181.09,308.89,182.23,309.23,183.12,308.81z"
    />
    <path
      class="bone"
      disabled
      d="M173.67,301.53c1.23-0.27,2.21-0.17,2.46,1c0.03,0.48,0.02,0.97-0.05,1.45c-0.08,1.32,0.08,2.64,0.45,3.91c0.29,1.32,0.33,2.72,0.73,4s1.4,2.28,1.91,3.55c0.16,0.35,0.19,0.75,0.07,1.12c-0.11,0.31-0.38,0.53-0.7,0.59c-0.74,0.18-1.5,0.26-2.26,0.25c-0.28-0.01-0.55-0.13-0.73-0.34c-0.21-0.27-0.34-0.59-0.37-0.93c-0.04-0.69-0.02-1.38,0.06-2.06c0.07-0.84,0.07-1.68,0-2.52c-0.12-1.75-0.61-3.45-1.44-5c-0.3-0.64-0.63-1.27-1-1.88c-0.37-0.43-0.64-0.94-0.79-1.49C171.8,302.05,172.7,301.74,173.67,301.53z"
    />
    <path
      class="bone"
      disabled
      d="M164.56,316c-0.31-0.26-0.43-0.68-0.31-1.07c0.2-0.47,0.42-0.92,0.68-1.36c0.35-1.01,0.5-2.07,0.46-3.13c0.07-0.8,0.29-2.67,0.29-3.45c0-1-0.55-2.34-0.2-3.34s2-1,2.71-0.5c0.93,0.66,0.14,1.67-0.19,2.5c-0.12,0.52-0.22,1.04-0.28,1.57c-0.42,1.98-0.45,4.01-0.1,6c0.08,0.51,0.09,1.03,0.05,1.54c-0.07,0.52-0.39,0.98-0.86,1.22c-0.46,0.26-0.99,0.37-1.51,0.32C165.03,316.27,164.78,316.16,164.56,316z"
    />
    <path
      class="bone"
      disabled
      d="M159.42,321.56c0.72,0.37,1.54,0.47,2.32,0.3c0.2-0.07,0.32-0.28,0.28-0.49c-0.1-0.45-0.41-0.94-0.46-1.36c-0.01-0.69,0.14-1.38,0.45-2c0.35-0.6,0.66-1.21,0.94-1.85c0.11-0.39,0.14-0.78-0.1-0.75c-0.46,0.2-0.94,0.33-1.44,0.4l0,0c-0.42-0.09-0.83-0.24-1.22-0.43c-0.17,0-0.11,0.6-0.07,0.84c0.08,0.39,0.11,0.78,0.1,1.18c-0.03,0.51-0.09,1.02-0.18,1.53c-0.06,0.3-0.16,0.59-0.31,0.86C159.4,320.37,158.93,321.4,159.42,321.56z"
    />
    <path
      class="bone"
      disabled
      d="M159.33,326.61c-0.42-0.18-0.05-0.81,0.15-1.09c0.27-0.32,0.44-0.72,0.47-1.14c0-0.44-0.29-0.83-0.21-1.28s0.54-0.52,0.92-0.38s1.12-0.17,1.34,0s-0.2,0.85-0.35,1.13c-0.18,0.4-0.27,0.83-0.27,1.26c0.04,0.41,0.04,0.83,0,1.24c-0.02,0.07-0.05,0.13-0.09,0.19C160.69,326.88,159.96,326.91,159.33,326.61z"
    />
    <path
      class="bone"
      disabled
      d="M164.33,326.16c-0.18-0.09-0.29-0.27-0.28-0.47c0.1-0.57,0.28-1.13,0.53-1.65c0.28-1.03,0.42-2.09,0.39-3.16c-0.16-0.9-0.37-1.79-0.63-2.67c-0.16-0.9,0.42-1,1.19-1h0.8c0.62,0,1.52-0.25,1.74,0.58s-0.36,2-0.72,2.76c-0.47,0.82-0.65,1.77-0.51,2.71c0.31,0.84,0.51,1.72,0.62,2.61c-0.01,0.19-0.15,0.35-0.33,0.39C166.21,326.52,165.23,326.49,164.33,326.16z"
    />
    <path
      class="bone"
      disabled
      d="M164.73,327.49c0.18,0,0.61,0.19,0.93,0.2h0.08c0.44-0.02,0.87-0.1,1.29-0.22c0.09-0.01,0.18,0.02,0.25,0.07c0.69,0.42,0.15,1.09-0.21,1.76c-0.35,0.77-0.45,1.64-0.29,2.47c0.19,0.73,0.25,1.48,0.17,2.23c-0.19,0.61-1.08,0.5-1.55,0.56s-1.12,0.33-1.2-0.32s0.55-1.43,0.56-2.11s0.18-1.29,0.2-2s-0.5-1.18-0.51-1.81C164.44,327.92,164.56,327.54,164.73,327.49z"
    />
    <path
      class="bone"
      disabled
      d="M176.74,327.28c-0.21-0.24-0.34-0.53-0.39-0.84c-0.18-0.9,0.41-1.79,0.53-2.7c0.12-0.84-0.01-1.69-0.37-2.46c-0.34-0.72-1.24-1.5-0.87-2.25c0.21-0.58,0.84-0.9,1.43-0.73c1.43,0.2,2.33-0.51,2.4,0.5c-0.02,0.94-0.18,1.87-0.46,2.77c-0.23,0.86-0.3,1.76-0.21,2.65c0.06,0.5,0.18,0.99,0.35,1.46c0.13,0.38,0.43,0.8,0.32,1.19c-0.03,0.12-0.08,0.23-0.16,0.33C178.52,327.65,177.56,327.68,176.74,327.28z"
    />
    <path
      class="bone"
      disabled
      d="M177.08,335.2c0.39,0.2,0.82,0.32,1.26,0.34c0.18,0.01,0.36-0.01,0.54-0.06c0.13,0,0.27-0.13,0.33-0.14s0.09,0,0.12,0.07c0.39,0.6-0.61,1.2-0.56,1.93s0.09,1.87-0.83,1.82c-0.38-0.06-0.69-0.32-0.82-0.68c-0.11-0.42-0.02-0.87,0.26-1.21c0.19-0.32,0.36-0.54,0.13-0.88c-0.28-0.27-0.49-0.59-0.63-0.95C176.82,335.09,177.08,335.2,177.08,335.2z"
    />
    <path
      class="bone"
      disabled
      d="M178.68,334.76c-0.61,0.06-1.22-0.13-1.7-0.51c-0.05-0.39,0.02-0.79,0.21-1.14c0.25-0.6,0.33-1.25,0.22-1.89c-0.12-0.77-1.53-2.79-0.51-3c0.65,0.06,1.29,0.15,1.92,0.29c0.6,0,0.79,0.35,0.75,1s-0.48,0.91-0.58,1.6c-0.07,0.64-0.01,1.29,0.18,1.91l0.07,0.22c0.04,0.36,0.04,0.72,0,1.08l0,0C179.13,334.54,178.92,334.7,178.68,334.76z"
    />
    <path
      class="bone"
      disabled
      d="M172.57,335.73c-0.67,0-1.34-0.03-2-0.11c-0.1-0.05-0.18-0.13-0.24-0.23c-0.26-0.52,0.1-1.52,0.17-2.06c0.13-0.7,0.23-1.4,0.28-2.11c0-0.7-0.44-1.11-0.58-1.74s0.06-0.92,0.7-0.83c0.35,0.11,0.7,0.2,1.06,0.27c0.4,0,0.71-0.23,1-0.15c0.81,0.19,0.57,1,0.22,1.55c-0.44,0.73-0.92,1.19-0.88,2.12c0.01,0.77,0.2,1.52,0.54,2.21C172.84,334.65,173.44,335.64,172.57,335.73z"
    />
    <path
      class="bone"
      disabled
      d="M170.51,337.68c-0.16-0.37-0.55-0.81-0.19-1.19s0.73,0,1.12,0h0.28c0.33,0,1,0,1.1,0.47s-0.39,0.73-0.55,1c-0.25,0.41-0.4,0.87-0.44,1.35c0.06,0.47,0.01,0.96-0.17,1.4c-0.23,0.35-0.53,0.69-1,0.58c-0.43-0.14-0.7-0.55-0.68-1C170.05,339.42,170.89,338.57,170.51,337.68z"
    />
    <path
      class="bone"
      disabled
      d="M164.52,336.58c-0.15-0.34-0.21-0.31-0.16-0.75s0.62-0.44,1-0.23l0.35-0.05c0.3,0,0.84-0.06,1,0.34s-0.34,0.67-0.49,0.94c-0.23,0.37-0.36,0.79-0.39,1.23c0.07,0.43,0.02,0.87-0.14,1.27c-0.2,0.31-0.48,0.63-0.88,0.54c-0.4-0.13-0.66-0.51-0.64-0.93C164.12,338.16,164.89,337.37,164.52,336.58z"
    />
    <path
      class="bone"
      disabled
      d="M159.04,327.39c0.35-0.13,0.76,0.32,1,0.25l0.42-0.2c0.32-0.06,0.77-0.25,0.91,0.08s-0.27,0.6-0.39,0.85c-0.18,0.33-0.27,0.71-0.26,1.09c0,0.37,0.15,0.77,0,1.09s-0.4,0.58-0.78,0.54c-0.37-0.06-0.65-0.37-0.67-0.75c0-0.67,0.6-1.41,0.2-2.06C159.27,328,158.65,327.54,159.04,327.39z"
    />
    <path
      class="bone"
      disabled
      d="M169.96,319.85c-0.09-0.8,0.36-1.15,1.15-1.39c0.61-0.22,1.29-0.14,1.83,0.21c0.72,0.45,0.34,1.21,0.16,1.85c-0.27,0.84-0.39,1.72-0.34,2.6c0.07,0.89,0.13,1.77,0.15,2.67c0.03,0.24,0.08,0.47,0.15,0.7c0,0.68,0.13,1.4-0.7,1.53c-0.79,0.11-1.58-0.17-2.12-0.75c-0.42-0.64,0.1-1.32,0.25-2c0.17-0.89,0.2-1.81,0.07-2.71C170.45,321.64,170.07,320.78,169.96,319.85z"
    />
    <path
      class="bone"
      disabled
      d="M160.33,314.47c-0.66-0.86-0.08-2,0.34-2.81c0.48-0.91,0.8-1.91,0.93-2.93c0.2-1.15,0.3-2.31,0.31-3.47c-0.02-0.52-0.08-1.04-0.16-1.56c-0.1-0.39-0.08-0.81,0.06-1.19c0.43-0.85,1.86-0.61,2.52-0.28c1.06,0.54,0.44,1.39,0,2.23c-0.97,2.2-1.36,4.61-1.13,7c0.18,1,0.4,2.17-0.31,3c-0.61,0.71-1.67,0.79-2.38,0.19C160.44,314.59,160.39,314.53,160.33,314.47z"
    />
    <path
      class="bone"
      disabled
      d="M160.49,223.46c-1.08,0.71-2.43,0.86-3.64,0.39c-1.09-0.42-1.89-0.8-1.94,0.55c-0.09,2.3,1.49,2.17,2,8.84s1.57,20.13,1.34,25.18s1.48,15.91,2.16,20.63s1.33,5.71,1.26,7.86c0,0.94-0.15,3.34,0.36,4.48c0.16,0.34,0.55,0.52,0.91,0.41c0.28-0.08,0.65-0.18,1.08-0.28c1.29-0.69,2.45-2,1.64-5.48c-1.13-5.65-1.95-11.36-2.46-17.1c-0.35-4,0.32-16.9,0.66-21.13l0.68-13.42c0.62,3.55,1.88,10.43,3.19,17.43s0,32.36-1,37.27c-0.12,0.46-0.18,0.93-0.18,1.4c0.01,0.3,0.27,0.53,0.56,0.51c0.02,0,0.03,0,0.05,0c0.84-0.1,1.68-0.1,2.52,0c1.43,0.24,2.83,0.65,4.17,1.23c0.5,0.24,1.1,0.03,1.33-0.47c0.05-0.11,0.08-0.22,0.1-0.34c0-1.29-0.12-2.58-0.35-3.85c-0.26-2.8-1.72-8.55-1.91-15.28s-0.19-19.76-2.7-30.74c-2-8.64-2.45-13.78-1-15.89s1.08-3.21-1.28-2.78c-0.91,0.4-1.94,0.4-2.85,0c-0.8-0.39-1.67-0.63-2.56-0.7C162.01,222.28,161.33,222.92,160.49,223.46z"
    />
    <path
      class="bone"
      disabled
      d="M161.96,295.42c0.09-0.49,0.38-0.93,0.8-1.2c1.94-0.63,3.97-0.92,6-0.87c1.23,0.17,2.43,0.48,3.58,0.93l1,0.57c0.72,0.59,1.53,1.06,2.39,1.41c0.57,0.23,1.02,0.68,1.24,1.25c0.02,0.14,0.02,0.29,0,0.43c0,0,0,0,0,0.06c-0.36,0.8-0.84,1.53-1.44,2.16c-0.42,0.09-0.86,0.14-1.29,0.14c-0.92-0.06-1.83,0.14-2.64,0.58l-0.36,0.33c-0.51,0.61-1.3,0.91-2.09,0.8c-0.74-0.07-1.46-0.27-2.13-0.6c-0.71-0.34-1.48-0.57-2.26-0.68c-1-0.12-1.39,0.06-2.38-0.06s-0.53-4.51-0.53-4.51C161.87,295.9,161.91,295.66,161.96,295.42z"
    />
    <path
      class="bone"
      d="M102.33,146c-0.67,0.18-1.8,0.89-1.82,0c0-0.54,0.92-1.57-0.77-1.75c0,0-1.4-0.06-3.28-0.06s-3.28,0.06-3.28,0.06c-1.69,0.18-0.76,1.21-0.77,1.75c0,0.91-1.15,0.2-1.82,0c-0.4,0-0.73,0.33-0.73,0.73c0,0.4,0.33,0.73,0.73,0.73c1.35,0.18,2.32,0.36,2.27,1.21c-0.07,1,1.66,1.32,3.6,1.32s3.67-0.27,3.6-1.32c-0.06-0.85,0.92-1,2.27-1.21c0.4,0,0.73-0.33,0.73-0.73C103.06,146.33,102.73,146,102.33,146z"
    />
    <path
      class="bone"
      d="M102.2,153c-0.67,0.19-1.8,0.89-1.82,0c0-0.54,0.92-1.57-0.77-1.76c0,0-1.41-0.06-3.28-0.06s-3.28,0.06-3.28,0.06c-1.72,0.21-0.72,1.24-0.72,1.76c0,0.9-1.15,0.2-1.83,0c-0.4,0-0.73,0.33-0.73,0.73c0,0.4,0.33,0.73,0.73,0.73c1.36,0.19,2.33,0.37,2.28,1.22c-0.07,1,1.66,1.31,3.6,1.31s3.67-0.26,3.6-1.31c-0.06-0.85,0.92-1,2.27-1.22c0.4-0.01,0.72-0.35,0.71-0.75C102.94,153.3,102.6,152.99,102.2,153z"
    />
    <path
      class="bone"
      d="M102.57,160.21c-0.72,0.19-1.92,0.94-1.94,0c0-0.57,1-1.67-0.81-1.86c0,0-1.5-0.07-3.49-0.07s-3.49,0.07-3.49,0.07c-1.8,0.19-0.81,1.29-0.82,1.86c0,1-1.22,0.21-1.93,0c-0.43-0.05-0.81,0.26-0.86,0.69s0.26,0.81,0.69,0.86c0.06,0.01,0.12,0.01,0.18,0c1.43,0.19,2.47,0.38,2.41,1.29c-0.07,1.11,1.77,1.4,3.83,1.4s3.9-0.29,3.82-1.4c-0.06-0.91,1-1.1,2.42-1.29c0.48,0,0.87-0.29,0.87-0.78C103.44,160.5,103.05,160.11,102.57,160.21z"
    />
    <path
      class="bone"
      d="M102.57,119.25c-0.72,0.19-1.92,0.94-1.94,0c0-0.57,1-1.67-0.81-1.86c0,0-1.5-0.07-3.49-0.07s-3.49,0.07-3.49,0.07c-1.8,0.19-0.81,1.29-0.82,1.86c0,1-1.22,0.21-1.93,0c-0.43-0.05-0.81,0.26-0.86,0.69c-0.05,0.43,0.26,0.81,0.69,0.86c0.06,0.01,0.12,0.01,0.18,0c1.43,0.19,2.47,0.39,2.41,1.29c-0.07,1.12,1.77,1.4,3.83,1.4s3.9-0.28,3.82-1.4c-0.06-0.9,1-1.1,2.42-1.29c0.4,0.16,0.87-0.09,1.03-0.49c0.16-0.4-0.04-0.85-0.44-1.01C102.98,119.23,102.78,119.23,102.57,119.25z"
    />
    <path
      class="bone"
      d="M102.94,111.58c-0.76,0.2-2,1-2,0c0-0.6,1-1.77-0.87-2c0,0-1.58-0.07-3.69-0.07s-3.7,0.07-3.7,0.07c-1.9,0.2-0.85,1.37-0.86,2c0,1-1.29,0.22-2,0c-0.45,0-0.82,0.37-0.82,0.82c0,0.45,0.37,0.82,0.82,0.82c0,0,0,0,0,0c1.52,0.21,2.62,0.41,2.56,1.37c-0.08,1.18,1.87,1.48,4,1.48s4.13-0.3,4-1.48c-0.06-1,1-1.16,2.56-1.37c0.49,0,0.89-0.33,0.89-0.82C103.83,111.91,103.43,111.51,102.94,111.58z"
    />
    <path
      class="bone"
      d="M102.94,104.18c-0.76,0.2-2,1-2,0c0-0.61,1-1.77-0.87-2c0,0-1.58-0.07-3.69-0.07s-3.7,0.07-3.7,0.07c-1.9,0.2-0.85,1.36-0.86,2c0,1-1.29,0.22-2,0c-0.45,0-0.82,0.37-0.82,0.82c0,0.45,0.37,0.82,0.82,0.82c0,0,0,0,0,0c1.52,0.2,2.62,0.41,2.56,1.37c-0.08,1.18,1.87,1.48,4,1.48s4.13-0.3,4-1.48c-0.06-1,1-1.17,2.56-1.37c0.46,0,0.83-0.36,0.83-0.82C103.77,104.54,103.4,104.17,102.94,104.18z"
    />
    <path
      class="bone"
      d="M102.94,167.74c-0.76,0.21-2,1-2,0c0-0.6,1-1.76-0.87-2c0,0-1.58-0.07-3.69-0.07s-3.7,0.07-3.7,0.07c-1.9,0.21-0.85,1.37-0.86,2c0,1-1.29,0.23-2,0c-0.45,0-0.82,0.37-0.82,0.82c0,0.45,0.37,0.82,0.82,0.82c0,0,0,0,0,0c1.52,0.21,2.62,0.41,2.56,1.37c-0.08,1.18,1.87,1.48,4,1.48s4.13-0.3,4-1.48c-0.06-1,1-1.16,2.56-1.37c0.53,0,0.95-0.29,0.95-0.82C103.89,168.03,103.47,167.61,102.94,167.74z"
    />
    <path
      class="bone"
      d="M101.61,139.32c-0.6,0.16-1.62,0.8-1.64,0c0-0.49,0.83-1.42-0.69-1.58c0,0-1.26-0.06-3-0.06s-3,0.06-3,0.06c-1.52,0.16-0.68,1.09-0.69,1.58c0,0.81-1,0.17-1.64,0c-0.36-0.04-0.69,0.21-0.74,0.57c-0.04,0.36,0.21,0.69,0.57,0.74c0.05,0.01,0.11,0.01,0.16,0c1.22,0.17,2.1,0.33,2.05,1.1c-0.07,0.94,1.5,1.18,3.24,1.18s3.3-0.24,3.24-1.18c0-0.77,0.83-0.93,2-1.1c0.36,0.06,0.7-0.18,0.76-0.54s-0.18-0.7-0.54-0.76C101.68,139.32,101.64,139.32,101.61,139.32z"
    />
    <path
      class="bone"
      d="M101.61,132.85c-0.6,0.16-1.62,0.79-1.64,0c0-0.48,0.83-1.41-0.69-1.58c0,0-1.26-0.05-3-0.05s-3,0.05-3,0.05c-1.52,0.17-0.68,1.1-0.69,1.58c0,0.81-1,0.18-1.64,0c-0.36-0.04-0.69,0.21-0.74,0.57c-0.04,0.36,0.21,0.69,0.57,0.74c0.05,0.01,0.11,0.01,0.16,0c1.22,0.16,2.1,0.33,2.05,1.09c-0.07,0.95,1.5,1.19,3.24,1.19s3.3-0.24,3.24-1.19c0-0.76,0.83-0.93,2-1.09c0.36,0.06,0.7-0.18,0.76-0.54s-0.18-0.7-0.54-0.76C101.68,132.85,101.64,132.85,101.61,132.85z"
    />
    <path
      class="bone"
      d="M101.61,126.37c-0.6,0.17-1.62,0.8-1.64,0c0-0.49,0.83-1.42-0.69-1.58c0,0-1.26-0.06-3-0.06s-3,0.06-3,0.06c-1.52,0.16-0.68,1.09-0.69,1.58c0,0.81-1,0.18-1.64,0c-0.36,0-0.66,0.3-0.66,0.66s0.3,0.66,0.66,0.66c1.22,0.16,2.1,0.32,2.05,1.09c-0.07,0.95,1.5,1.18,3.24,1.18s3.3-0.23,3.24-1.18c0-0.77,0.83-0.93,2-1.09c0.36,0.04,0.69-0.23,0.73-0.6S101.97,126.41,101.61,126.37L101.61,126.37z"
    />
    <path
      class="bone"
      disabled
      d="M140.6,156.23c-0.17-1.82-3.86-3.44-3.86-3.44s4.53-1.69,4.47-4.14c-0.09-3.47-7-6.53-7-6.53s4-0.87,4.33-4.4c0.28-2.73-4.29-5.05-4.29-5.05c1.54-0.56,2.52-2.08,2.39-3.72c-0.11-2.87-4.7-5.92-4.7-5.92s3.21-1.36,2.38-3.88c-1.28-3.78-8.49-6.3-8.49-6.3c0.33-0.96,0.43-1.99,0.31-3c-1.83,0-3.54,0.17-5.11,0.34c0,1.36-0.43,2.94-3.21,3.26c-0.59,0.06-6.38,0.22-9.63,0.31c0.47,1.24,0.74,2.54,0.81,3.86c2.54-0.11,5.68-0.3,7.14-0.41c2.34-0.2,4.64-0.71,6.84-1.52c0,0,6.9,4.37-1.44,5.63c-4.65,0.51-9.32,0.77-14,0.78c-0.74,1.4-1.39,2.85-1.93,4.34c2.55,0,5.8,0,8.28-0.18c4.07-0.32,8.12-0.89,12.13-1.7c0,0,7.41,4.36-3.58,6c-3.58,0.54-12.51,0.92-18,1.09c-0.06,0.68-0.11,1.39-0.12,2.15c0,0.59,0,1.41,0,2.4c4.6,0.18,12.59-0.07,14.94-0.28c3-0.25,8.6-1.25,8.6-1.25s8.86,4-3.82,6.19c-3.49,0.6-14.26,0.3-19.73,0c0,1.28,0,2.66,0,4.13c5.38,0.6,10.8,0.76,16.21,0.49c2.91-0.27,7.62-1.3,7.62-1.3s11.93,4.16-2.79,7.15c-7.06,1.14-14.29,0.45-21-2c0,1.93,0,3.95,0.06,6l0.56,0.6c0.72,0.83,0.25,1.22-0.54,1.31c0.08,5.61,0.2,11.43,0.38,16.6c1.52,3.67,3.93,4.74,5.92,8.35c0.35,0.64,0.74,1.3,1.15,2c-1.34-1.22-2.5-2.34-3.12-2.8c-1.18-0.86-3-2.3-4-1.53s-0.22,2,1.35,3.77c1.69,1.94,3.49,3.78,5.39,5.52c2.14,1.56,4.43,2.9,6.83,4c1.16,1.41,2.22,2.62,3.06,3.47c2.01,1.97,4.59,3.25,7.38,3.66c1.49,0.12,6.72,0.77,7.63-4.12c0.33-1.81-1.22-5.72-1.28-5.93c0,0,3.67-0.58,4.41-3.78s-2-6-2-6c1.32-1.03,2.24-2.49,2.6-4.13c0.48-3.28-2.33-6.05-2.33-6.05s2.32-2,2.57-3.52c0.48-3-3.55-5.29-3.55-5.29S140.95,160,140.6,156.23z M109.86,155.6c3.28,1.09,10.76,1.18,13.77,0.86c3.06-0.42,6.09-1.02,9.08-1.81c0,0,5,4.55-6.51,6.17c-3.35,0.47-10.59,0.33-16-2.87C108.86,157.15,108.48,155.15,109.86,155.6L109.86,155.6z M110.27,165.45c-1.4-1.69-1.5-3.74,1-2.43s6.47,2.12,11.25,2.24c3.22,0.07,6.42-0.37,9.5-1.31c0,0,5.85,4.29-1.91,5.82C120.72,171.64,112.69,168.35,110.27,165.45z M127.22,195.57c-2.61-0.81-5.14-2.84-3.25-2.51c2.26,0.24,4.55,0.03,6.72-0.64c0.29,0.49,0.51,1.02,0.64,1.58C131.47,195,129.79,196.37,127.22,195.57L127.22,195.57zM134.76,185.64c-0.91,1.11-4.57,2.24-6.88,2.18c-7.19-0.2-10.58-3.18-11.86-4.27c-0.71-0.6-2-2,0.76-1.23s4.69,1.68,10.55,1.68c2.49-0.1,4.96-0.46,7.37-1.08C134.7,182.92,135.64,184.59,134.76,185.64L134.76,185.64z M132.76,178.48c-7.63,2-15.71-0.3-18-2.3s-3.25-3.47-0.93-3.18s3.13,0.69,5.37,1.07c2.45,0.47,4.95,0.59,7.43,0.38c1.69-0.18,3.36-0.49,5-0.91c1.23-0.36,2.61-0.66,2.61-0.66s3.67,4.27-1.44,5.6L132.76,178.48z"
    />
    <path
      class="bone"
      disabled
      d="M68.84,140.87c-12.68-2.19-3.82-6.19-3.82-6.19s5.64,1,8.6,1.25c2.31,0.2,10.07,0.45,14.7,0.29c0-1,0-1.82,0-2.41c0-0.76,0-1.48-0.12-2.15c-5.47-0.18-14.19-0.56-17.72-1.09c-11-1.66-3.58-6-3.58-6c4.01,0.81,8.06,1.38,12.14,1.7c2.39,0.14,5.52,0.17,8,0.18c-0.55-1.49-1.19-2.94-1.94-4.34c-4.58-0.02-9.16-0.28-13.72-0.78c-8.35-1.26-1.45-5.63-1.45-5.63c2.2,0.8,4.5,1.32,6.84,1.52c1.42,0.11,4.4,0.29,6.91,0.4c0.07-1.32,0.34-2.62,0.8-3.85c-3.28-0.1-8.82-0.25-9.39-0.31c-2.78-0.32-3.24-1.9-3.2-3.26c-1.57-0.17-3.29-0.29-5.12-0.34c-0.12,1.01-0.02,2.04,0.32,3c0,0-7.22,2.52-8.5,6.3c-0.83,2.52,2.39,3.88,2.39,3.88s-4.58,3.04-4.65,5.96c-0.13,1.64,0.85,3.16,2.39,3.72c0,0-4.56,2.32-4.28,5.05c0.36,3.53,4.33,4.4,4.33,4.4s-7,3.06-7,6.53c-0.06,2.45,4.47,4.14,4.47,4.14s-3.69,1.62-3.85,3.44c-0.35,3.81,3.76,5.27,3.76,5.27s-4,2.24-3.55,5.29c0.25,1.54,2.58,3.52,2.58,3.52s-2.82,2.77-2.33,6.05c0.35,1.64,1.27,3.1,2.6,4.13c0,0-2.73,2.77-2,6s4.42,3.78,4.42,3.78c-0.07,0.21-1.62,4.12-1.29,5.93c0.91,4.89,6.14,4.24,7.63,4.12c2.79-0.41,5.37-1.69,7.39-3.66c0.87-0.89,2-2.18,3.22-3.68c2.26-1.06,4.42-2.34,6.42-3.83c1.91-1.73,3.71-3.57,5.39-5.52c1.58-1.73,2.31-3,1.35-3.77s-2.83,0.67-4,1.53c-0.54,0.4-1.49,1.29-2.6,2.32c0.3-0.51,0.6-1,0.86-1.5c1.88-3.41,4.14-4.55,5.66-7.75c0.2-5.33,0.32-11.4,0.4-17.24c-0.63-0.14-0.94-0.52-0.29-1.27l0.31-0.34c0-2.12,0-4.2,0.06-6.18c-6.65,2.39-13.79,3.06-20.77,1.94c-14.72-3-2.8-7.15-2.8-7.15s4.72,1,7.63,1.3c5.3,0.23,10.62,0.04,15.89-0.57c0-1.48,0-2.86,0-4.14C82.8,141.18,72.33,141.46,68.84,140.87z M58.61,172.87c0,0,1.39,0.3,2.61,0.66c1.64,0.42,3.31,0.73,5,0.91c2.48,0.21,4.98,0.09,7.43-0.38c2.24-0.38,3-0.79,5.37-1.07s1.3,1.27-0.93,3.18s-10.41,4.28-18,2.3c-5.11-1.32-1.48-5.59-1.48-5.59L58.61,172.87z M58.13,185.63c-0.87-1,0.05-2.74,0.05-2.74c2.41,0.63,4.88,1,7.37,1.11c5.87,0,7.69-0.91,10.56-1.66s1.47,0.63,0.76,1.23c-1.28,1.09-4.66,4.07-11.86,4.27c-2.31,0.04-5.96-1.09-6.88-2.2L58.13,185.63z M65.67,195.56c-2.57,0.8-4.25-0.59-4.06-1.53c0.12-0.57,0.31-1.11,0.59-1.62c2.17,0.67,4.46,0.88,6.72,0.64c1.9-0.32-0.59,1.71-3.25,2.52L65.67,195.56z M82.67,165.44c-2.42,2.9-10.45,6.19-19.87,4.32c-7.76-1.53-1.9-5.82-1.9-5.82c3.05,0.93,6.24,1.38,9.43,1.32c4.78-0.12,8.74-0.93,11.26-2.24s2.44,0.74,1.03,2.43L82.67,165.44z M60.23,154.64c2.99,0.79,6.02,1.39,9.08,1.81c3,0.32,10.49,0.23,13.78-0.86c1.37-0.45,1,1.55-0.35,2.35c-5.41,3.2-12.65,3.34-16,2.87c-11.51-1.61-6.56-6.16-6.56-6.16L60.23,154.64z"
    />
    <path
      class="bone"
      d="M103.15,96.39c-0.78,0.17-2.09,0.82-2.11,0c0-0.49,1.07-1.44-0.9-1.61c0,0-1.63,0-3.81,0s-3.82,0-3.82,0c-2,0.17-0.88,1.12-0.89,1.61c0,0.83-1.33,0.18-2.12,0s-1.57,1.17,0,1.34s2.71,0.34,2.64,1.11c-0.08,1,1.94,1.21,4.19,1.21s4.26-0.24,4.18-1.21c-0.06-0.77,1.07-0.94,2.64-1.11S103.94,96.23,103.15,96.39z"
    />
    <path
      class="bone"
      d="M103.67,184.82c-0.85,0.23-2.26,1.11-2.28,0c0-0.67,1.15-2-1-2.19c0,0-1.76-0.08-4.1-0.08s-4.11,0.08-4.11,0.08c-2.11,0.23-0.94,1.52-1,2.19c0,1.13-1.43,0.25-2.28,0c-0.5,0-0.91,0.41-0.91,0.91s0.41,0.91,0.91,0.91c1.69,0.23,2.92,0.46,2.85,1.52c-0.09,1.32,2.08,1.65,4.5,1.65s4.59-0.33,4.5-1.65c-0.07-1.06,1.15-1.29,2.84-1.52c0.5,0.02,0.93-0.37,0.95-0.87C104.56,185.27,104.17,184.84,103.67,184.82z"
    />
    <path
      class="bone"
      d="M102.94,177.12c-0.76,0.21-2,1-2,0c0-0.6,1-1.76-0.87-2c0,0-1.58-0.07-3.69-0.07s-3.7,0.07-3.7,0.07c-1.9,0.21-0.85,1.37-0.86,2c0,1-1.29,0.23-2,0c-0.45,0-0.82,0.37-0.82,0.82c0,0.45,0.37,0.82,0.82,0.82c0,0,0,0,0,0c1.52,0.21,2.62,0.41,2.56,1.37c-0.08,1.18,1.87,1.48,4,1.48s4.13-0.3,4-1.48c-0.06-1,1-1.16,2.56-1.37c0.45,0,0.82-0.37,0.82-0.82C103.76,177.49,103.39,177.12,102.94,177.12z"
    />
    <path
      class="bone"
      d="M102.11,85.6c-0.67,0.13-1.78,0.65-1.79,0c0-0.39,0.9-1.14-0.76-1.27c0,0-1.39,0-3.23,0s-3.23,0-3.23,0c-1.67,0.13-0.75,0.88-0.76,1.27c0,0.66-1.13,0.14-1.79,0s-1.34,0.93,0,1.06s2.29,0.27,2.23,0.88s1.64,1,3.55,1s3.61-0.2,3.54-1s0.91-0.75,2.24-0.88S102.77,85.47,102.11,85.6z"
    />
    <path
      class="bone"
      d="M102.11,80.55c-0.67,0.13-1.78,0.64-1.79,0c0-0.39,0.9-1.14-0.76-1.27c0,0-1.39,0-3.23,0s-3.23,0-3.23,0c-1.67,0.13-0.75,0.88-0.76,1.27c0,0.65-1.13,0.14-1.79,0s-1.34,0.93,0,1.06s2.29,0.26,2.23,0.88s1.64,1,3.55,1s3.61-0.19,3.54-1s0.91-0.75,2.24-0.88S102.77,80.42,102.11,80.55z"
    />
    <path
      class="bone"
      d="M102.11,90.76c-0.67,0.14-1.78,0.69-1.79,0c0-0.42,0.9-1.23-0.76-1.38c0,0-1.39,0-3.23-0.05s-3.23,0.05-3.23,0.05c-1.67,0.15-0.75,1-0.76,1.38c0,0.7-1.13,0.15-1.79,0s-1.34,1,0,1.14s2.29,0.29,2.23,1c-0.07,0.82,1.64,1,3.55,1s3.61-0.21,3.54-1c-0.05-0.67,0.91-0.81,2.24-1S102.77,90.62,102.11,90.76z"
    />
    <path
      class="bone"
      d="M105.62,193.3c-0.93,0.26-3.7,1.22-3.72,0c0-0.74,1.26-2.16-1.06-2.41c0,0-1.93-0.08-4.51-0.08s-4.52,0.08-4.52,0.08c-2.32,0.25-1,1.67-1,2.41c0,1.24-2.79,0.28-3.72,0c-0.55,0-1,0.45-1,1s0.45,1,1,1c1.86,0.25,4.41,0.5,4.34,1.67c-0.1,1.45,2.29,1.81,5,1.81s5-0.36,5-1.81c-0.08-1.17,2.48-1.42,4.34-1.67c0.55-0.04,0.97-0.52,0.92-1.07C106.65,193.67,106.17,193.26,105.62,193.3L105.62,193.3z"
    />
    <path
      class="bone"
      d="M108.99,233.21c-1.26,0.35-5,1.67-5.07,0c0-1,1.73-2.94-1.44-3.29c0,0-2.63-0.11-6.15-0.11s-6.16,0.11-6.16,0.11c-3.17,0.35-1.42,2.28-1.44,3.29c0,1.7-3.8,0.38-5.07,0c-0.76,0-1.37,0.61-1.37,1.37c0,0.76,0.61,1.37,1.37,1.37c2.54,0.34,6,0.68,5.92,2.28c-0.13,2,3.12,2.46,6.75,2.46s6.88-0.49,6.75-2.46c-0.11-1.6,3.38-1.94,5.91-2.28c0.76,0,1.37-0.61,1.37-1.37C110.36,233.82,109.75,233.21,108.99,233.21z"
    />
    <path
      class="bone"
      d="M106.46,212.23c-1,0.27-4,1.33-4.06,0c0-0.81,1.39-2.36-1.15-2.64c0,0-2.11-0.09-4.92-0.09s-4.93,0.09-4.93,0.09c-2.53,0.28-1.14,1.83-1.15,2.64c0,1.35-3,0.29-4.06,0c-0.6-0.06-1.14,0.39-1.2,0.99c-0.06,0.6,0.39,1.14,0.99,1.2c0.07,0.01,0.14,0.01,0.21,0c2,0.27,4.82,0.55,4.74,1.82c-0.11,1.58,2.5,2,5.4,2s5.5-0.39,5.4-2c-0.09-1.27,2.7-1.55,4.73-1.82c0.84,0,1.53-0.25,1.53-1.1C107.99,212.48,107.3,211.8,106.46,212.23z"
    />
    <path
      class="bone"
      d="M107.47,222.22c-1.11,0.3-4.43,1.46-4.46,0c0-0.89,1.52-2.59-1.27-2.89c0,0-2.32-0.11-5.41-0.11s-5.42,0.11-5.42,0.11c-2.79,0.3-1.25,2-1.27,2.89c0,1.49-3.34,0.33-4.46,0c-0.66,0-1.2,0.53-1.2,1.2s0.53,1.2,1.2,1.2c0,0,0,0,0.01,0c2.23,0.3,5.3,0.61,5.21,2c-0.12,1.73,2.75,2.17,5.94,2.17s6-0.44,5.94-2.17c-0.09-1.4,3-1.71,5.2-2c0.55,0.37,1.43,0.02,1.8-0.53c0.37-0.55,0.22-1.3-0.33-1.66C108.54,222.15,108.01,222.15,107.47,222.22z"
    />
    <path
      class="bone"
      d="M106.46,202.52c-1,0.27-4,1.33-4.06,0c0-0.8,1.39-2.35-1.15-2.63c0,0-2.11-0.09-4.92-0.09s-4.93,0.09-4.93,0.09c-2.53,0.28-1.14,1.83-1.15,2.63c0,1.36-3,0.3-4.06,0c-0.6-0.06-1.14,0.39-1.2,0.99c-0.06,0.6,0.39,1.14,0.99,1.2c0.07,0.01,0.14,0.01,0.21,0c2,0.27,4.82,0.54,4.74,1.82c-0.11,1.58,2.5,2,5.4,2s5.5-0.39,5.4-2c-0.09-1.28,2.7-1.55,4.73-1.82c0.61,0,1.1-0.49,1.1-1.1C107.56,203.01,107.07,202.51,106.46,202.52C106.46,202.51,106.46,202.51,106.46,202.52z"
    />
    <path
      class="bone"
      disabled
      d="M113.98,54.62c0-0.37-0.23-0.36-0.55-0.36c-1.92,0-4.56,0.18-4.74,0.8c-0.11,0.38-0.21,0.82-0.32,1.28c-0.36,1.56-0.87,5.17-2,6.43c0,0-3.25,3.49-10,3.49l0,0c-6.72,0-10-3.49-10-3.49c-1.17-1.26-1.67-4.87-2-6.43c-0.11-0.46-0.21-0.9-0.32-1.28c-0.18-0.62-2.83-0.79-4.74-0.8c-0.32,0-0.53,0-0.56,0.36c0,0.14-0.58,4.19,0.86,5s0.67,8.9,3.52,10.37c4.16,2.15,4.64,8.26,13.26,8.27l0,0c8.62,0,9.09-6.12,13.26-8.27c2.85-1.47,2.06-9.56,3.51-10.37S113.99,54.76,113.98,54.62z"
    />
    <path
      class="bone"
      disabled
      d="M115.05,13.58c-4.26-6.14-11.24-9.83-18.72-9.89l0,0c-7.47,0.06-14.44,3.75-18.7,9.89c-3.49,4.84-4.54,12.77-4.3,17.42c0.27,5.72,2.94,21.82,5.41,22.24c1.83,0.32,5.66,0.08,6.2,1.55c0.14,0.39,1.08,4.58,2.06,5.64c1.33,1.41,5.53,2.57,9.33,2.57l0,0c3.8,0,8-1.18,9.34-2.61c1-1.06,1.93-5.25,2.07-5.64c0.54-1.47,4.36-1.23,6.2-1.55c2.48-0.4,5.16-16.5,5.39-22.2C119.59,26.35,118.54,18.42,115.05,13.58z M84.05,45.88c-2.34-0.16-3.2-1.89-3.21-7.09c0-4.06,2.84-4.51,7.44-5.4c1-0.18,3.1-0.75,4.2,1.26c0.92,1.7,0.61,4.52-0.4,6.5S86.38,46,84.05,45.88z M97.12,54.12c-0.24-0.11-0.5-0.17-0.77-0.2l0,0c-0.27,0.03-0.53,0.09-0.78,0.2c-3.79,1.66-3.33-1.85-2.71-5.08c0.53-2.8,1.29-5,2-5.85s1,0,1.48,0l0,0c0.53,0,0.86-0.65,1.47,0s1.49,3.05,2,5.85C100.46,52.27,100.91,55.78,97.12,54.12z M108.63,45.88c-2.34,0.15-7-2.73-8-4.73s-1.33-4.8-0.4-6.5c1.1-2,3.25-1.44,4.2-1.26c4.6,0.89,7.44,1.34,7.44,5.4C111.83,44,110.96,45.72,108.63,45.88z"
    />
    <path
      class="bone"
      d="M114,240.28c-1.62-5.39-5.29-2-8,1.33c-1.37,1.67-3.07,3.03-5,4c-2.87,1.45-6.27,1.45-9.14,0c-1.93-0.97-3.63-2.33-5-4c-2.73-3.37-6.41-6.72-8-1.33c-1.9,6.35-0.8,10.6,2.93,13.06c2.71,1.78-0.5,5.71,2.75,8.75c3.07,2.87,1.67,5.05,4.71,6.32c1.93,0.8,1.2,5,3,6.16c1,0.69-0.09,3.48,1.22,4.08c0.78,0.36,1.31,2,3,2s2.21-1.65,3-2c1.31-0.6,0.19-3.39,1.22-4.08c1.76-1.16,1-5.36,3-6.16c3-1.27,1.64-3.45,4.7-6.32c3.25-3,0-7,2.75-8.75C114.81,250.88,115.91,246.63,114,240.28z"
    />
    <path
      class="bone"
      disabled
      d="M136.84,275.39c-2.89,0.14-2.09,2.69-3.56,2s-0.26-2.57,0.24-3.91s0.07-3.93-1.74-4.58c-3.33-1.19-6.28,1.75-7.47,4.1c-1.22,2.48-1.77,5.24-1.58,8c0.39,2.67,3.43,1.57,5.58,2.18c2.15,0.61,2.41,5.46,1.23,8.35s-1.87,3.83-0.86,7.38c1.01,3.55-3,27.23-5.88,46.86c-1.93,13.38-5.88,34.63-9,47.32c-1.33,5.36-4.67,15.14-6,16.66c-3.74,4.24-4.64,8.37-3,14.39c1.07,4,3.5,4.82,5.43,4.49c1.84-0.6,1.45-2.09,1.09-3.1s-1.81-4.28-1.28-7.29c0.71-3.85,4.4-6.4,8.25-5.7c1.25,0.23,2.42,0.79,3.38,1.63c2.18,1.94,3,5.45,2.19,8.63c-0.54,2.11-1.46,2.85-1,4.16c0.59,1.56,2.88,1.12,5.12-0.91c0.76-0.68,2-2.09,1.09-8.65c-0.77-5.73-4-6.19-4.55-12.15s5.87-46.77,7.2-54.63c1.19-7,6.4-45.14,6.58-46.77c0.39-3.53,4.06-7.68,5.17-13C146.25,277.56,139.73,275.26,136.84,275.39z"
    />
    <path
      class="bone"
      disabled
      d="M151.33,217.7c-0.67-3.54,3.71-6.66,4.06-11.65s-2.21-67.68-4.37-71.72c-0.67-1.37-1.65-2.57-2.87-3.49c-3.08-2.45-4.39-6.5-3.32-10.29c1.16-4.36,4.21-6,7.59-6c1.7-0.02,3.24,0.99,3.91,2.55c1.17-0.33,3.45-0.2,3.79,2c0.46,4.66,0.41,9.35-0.15,14c-0.69,4.75,1.27,42.89,1.67,53.24c0.36,9.16,1.49,17.08,4.08,20.65s5.77,4.75,5.57,8.11c-0.18,3.15-3.54,6.27-6.31,5.21c-1.68-0.63-2-1.2-2.58-1.33c-0.29-0.06-0.55-0.58-1.26,0.13c-0.69,0.7-1.54,1.23-2.47,1.56C156.33,221.47,152.16,222.18,151.33,217.7z"
    />
    <path
      class="bone"
      disabled
      d="M105.44,571c1.08-0.39,2.68-0.45,3.42,0.39c0.13,0.25,0.2,0.54,0.19,0.82c0,0.58-0.72,0.83-0.85,1.36c-0.19,0.77,0.67,1.18,0.78,1.86c0.25,1.38-1.76,1.62-2.52,1.14c-0.57-0.37-0.48-1-0.73-1.54s-0.65-0.63-1-1.11c-0.63-0.9-0.41-2.15,0.49-2.79C105.29,571.08,105.36,571.04,105.44,571z"
    />
    <path
      class="bone"
      disabled
      d="M113.4,548.15c0.71,0.4,0.43,1.17,0.51,1.9c0.23,1.72,0.6,3.42,1.1,5.09c0.09,0.3,0.2,0.58,0.34,0.86c0.34,0.62,0.12,1.4-0.5,1.74c-0.21,0.12-0.45,0.17-0.69,0.16c-0.39,0-0.77-0.11-1.09-0.32c-0.59-0.33-0.65-0.7-0.57-1.37c0.42-3.2-1.4-6.72-1-7.39c0.29-0.69,1.09-1.02,1.78-0.73C113.32,548.11,113.36,548.13,113.4,548.15z"
    />
    <path
      class="bone"
      disabled
      d="M121.62,564.15c0.07-0.07,0.27-0.19,0.31-0.1c0.42,0.81-0.09,1.55,0.41,2.41c0.3,0.64,0.63,1.26,1,1.86c0.22,0.29,0.46,0.35,0.53,0.77s-0.08,0.8,0,1.19s0.3,0.68,0.06,1s-0.51,0.26-0.73,0c-0.49-0.63-0.09-1.36-1-1.63c-0.09-0.4,0-0.79-0.05-1.18c-0.14-0.32-0.31-0.62-0.5-0.91c-0.27-0.55-0.38-1.23-1-1.45c-0.41-0.15-0.67,0-0.94-0.4s-0.11-0.57,0.21-0.88c0.22-0.15,0.48-0.24,0.75-0.24c0.5,0,0.78,0.06,0.89-0.19S121.49,564.31,121.62,564.15z"
    />
    <path
      class="bone"
      disabled
      d="M123.87,563.15c0.37-0.57,0.64,0,1.24-0.27c0.06,0,0-0.17,0.06-0.22s0.32-0.3,0.4-0.27c0.84,0.26-0.18,1.37,0.31,2.16c0.28,0.56,0.6,1.11,0.95,1.64c0.21,0.26,0.44,0.3,0.52,0.67s0,0.73,0,1.09s0.3,0.6,0.11,0.93s-0.46,0.26-0.67,0c-0.47-0.56-0.14-1.24-1-1.43c-0.09-0.37,0-0.73-0.1-1.08c-0.13-0.28-0.3-0.55-0.49-0.8c-0.27-0.49-0.4-1.11-0.94-1.28c-0.38-0.12-0.39,0.14-0.54-0.31C123.61,563.7,123.67,563.38,123.87,563.15z"
    />
    <path
      class="bone"
      disabled
      d="M127.25,562.8c0.37,0.1,0.47,0.51,0.67,0.84c0.13,0.16,0.25,0.34,0.34,0.52c0.08,0.24,0,0.48,0.1,0.72c0.6,0.11,0.39,0.58,0.72,1c0.15,0.15,0.32,0.19,0.45,0s0-0.43-0.09-0.63s0-0.5-0.05-0.73s-0.22-0.27-0.36-0.44c-0.25-0.34-0.48-0.71-0.69-1.08c-0.35-0.52,0.36-1.23-0.22-1.39c-0.09,0.01-0.18,0.05-0.24,0.12c-0.04,0.09-0.09,0.17-0.15,0.25c-0.31,0.25-0.66-0.06-1,0.28C126.71,562.18,126.45,562.6,127.25,562.8z"
    />
    <path
      class="bone"
      disabled
      d="M117.97,571.63c-0.21-0.86-0.26-1.75-0.15-2.63c-0.01-0.32-0.18-0.61-0.45-0.79c-0.37-0.27-0.82-0.42-1.28-0.44c-0.3,0.07-0.57,0.21-0.81,0.4c-0.3,0.24-0.44,0.63-0.36,1c0.08,0.29,0.18,0.57,0.29,0.84c0.47,1.16,0.58,2.42,1,3.61c0.2,0.55,1.76,1.14,2.17,0.14C118.75,572.91,118.33,572.34,117.97,571.63z"
    />
    <path
      class="bone"
      disabled
      d="M107.33,536.23c-1.58,0.13-3.32,1.07-3.53,2.69c-0.27,1.46-1.08,2.78-2.26,3.68c-0.81,0.69-1.26,1.71-1.25,2.77c0,1.81-0.08,5.29,1.69,5.23c1.1-0.15,2.1-0.75,2.74-1.66c0.93-1.05,2.67-1.35,4.89-1.19c1.64,0.11,3.14-1.35,5.06-1.19s2.39,1,3.72,1.41s1.87-1.05,0.86-2c-0.92-0.72-1.89-1.36-2.92-1.92c-2.81-1.58-2-4.63-2.4-5.76C113.4,536.74,109.23,536.08,107.33,536.23z"
    />
    <path
      class="bone"
      disabled
      d="M127.96,430.82c0.39-1.3-0.46-2.53-1.09-2.27c-2.63,1.07-3.3,1.13-5,0.34c-1.11-0.52-2.94,1.23-4.92,1.33c-2.14,0.12-3-2-4.18-1.25c-1.54,0.94-4.19,1.71-6.08,0.79c-0.36-0.17-0.79-0.12-1.11,0.13c-0.65,0.3-1.09,0.93-1.15,1.65c-0.11,0.86,0.34,2.18,1.79,4.63c6.44,10.88,3.53,31,2.46,45.41c-3,39.51-6.32,39.6-7.26,52.23c-0.07,1,0.62,2.54,1.42,2.61s3-1.24,5.25-1.36c2.21,0.11,4.4,0.5,6.51,1.18c2,0.71,0.44-3.65,0-7.32c-1.16-9,3.6-48.92,4.41-55.22c0.69-5.37,2.64-26.1,3.42-30C123.5,438.26,126.79,434.78,127.96,430.82z"
    />
    <path
      class="bone"
      disabled
      d="M104.05,563.65c-0.74,1.13-1.54,2.89-0.14,2.81c0.58-0.86,1.33-1.6,2.21-2.17c0.94-0.43,2,0.51,3,1.63c0.28,0.1,0.35-0.08,0.45-0.36c0.43-1.12-0.36-2.78-0.45-3.91c-0.11-1.51,0.55-2.54,1-3.92c0.46-1.54-0.1-2.1-0.1-2.1s-1.87-2-3.66-1.63c-0.44,0.11-0.83,0.34-1.13,0.68c-0.59,0.59-0.94,1.37-1,2.2c-0.05,1.01,0.02,2.01,0.22,3C104.7,561.37,104.88,562.4,104.05,563.65z"
    />
    <path
      class="bone"
      disabled
      d="M110.33,554.35c-0.05,0.07-0.15,0.09-0.22,0.04c-0.01-0.01-0.03-0.02-0.04-0.04c-0.69-0.84-1.67-1.39-2.74-1.55c-1.27-0.15-3.23,1.3-3.52,1.67s-0.44-0.44-0.37-0.9c0.21-1.5,1.21-3.51,2.35-4.09c1.17-0.54,2.5-0.6,3.71-0.15c0.6,0.24,1.07,0.71,1.33,1.3c0.3,0.62,0.37,1.33,0.19,2C110.89,553.24,110.65,553.82,110.33,554.35z"
    />
    <path
      class="bone"
      disabled
      d="M118.33,556.18c0.33-0.23-2-7.83-2-7.83c-0.13-0.17-0.31-0.28-0.52-0.32c-1.49-0.39-1.21,0.1-1.21,0.1c1.29,2.44,1.53,7.33,1.86,7.89C116.41,556,116.95,557.13,118.33,556.18z"
    />
    <path
      class="bone"
      disabled
      d="M121.42,552.31c-0.29-0.81-0.65-1.57-0.94-2.38l-0.13-0.13c-0.11,0-0.74-0.32-0.62,0.07s0.88,2.5,0.88,2.5c0.37,0.88,0.66,1.68,0.76,1.79s0.59,0.28,0.71,0C122.33,553.53,121.61,552.84,121.42,552.31z"
    />
    <path
      class="bone"
      disabled
      d="M117.7,549.58c0.14,0.36,1.79,5.79,1.86,6s0.53,0,0.74-0.24c0.6-0.66-0.21-1.43-0.34-2.15v-0.16c0,0-0.95-3.17-1-3.37S117.56,549.21,117.7,549.58z"
    />
    <path
      class="bone"
      disabled
      d="M115.86,564.52c0.31,0.03,0.62,0.1,0.91,0.21c0.1,0.04,0.22-0.02,0.26-0.12c0,0,0-0.01,0-0.01c0.27-1.08-0.87-2-1-3.25s0.44-2.77-1.34-2.38c-0.41-0.01-0.82,0.01-1.23,0.06c-0.36,0.13-0.58,0.26-0.54,0.65l0.42,5.24c0,0,0.06,0.38,0.77,0.07l0.55-0.25C115.03,564.55,115.45,564.48,115.86,564.52z"
    />
    <path
      class="bone"
      disabled
      d="M120.92,562.6c-0.09-0.41-0.25-0.81-0.46-1.17c-0.09-0.4-0.28-0.78-0.56-1.08c-0.28-0.39-0.51-0.8-0.71-1.24c-0.21-0.42-0.09-1.19-0.52-1.36c-0.49-0.09-1-0.01-1.45,0.22c-0.13,0.33,0.25,0.85,0.45,1.32c0.42,1,1,1.91,1.42,2.89s0.38,1.43,0.77,1.44l0.83-0.46C120.82,563,120.9,562.81,120.92,562.6z"
    />
    <path
      class="bone"
      disabled
      d="M117.58,566.21c0,0,0.42,0.35,0.35,0.61s-0.44,0.31-0.44,0.31c-0.45-0.27-0.98-0.39-1.5-0.36c-0.57,0.16-1.1,0.43-1.56,0.81c-0.33,0.23-0.51-0.27-0.51-0.81c0.01-0.43,0.27-0.82,0.66-1c0.21-0.1,0.44-0.17,0.67-0.21c0.83,0,1.64,0.24,2.33,0.69"
    />
    <path
      class="bone"
      disabled
      d="M120.33,557.33c0.31,0.93,1,1.36,1.54,2.12c0.29,0.38,0.52,0.81,0.67,1.26c0.15,0.43,0.44,1.28,0.69,1.34s1.48-0.13,1.5-0.38s-3.18-5-3.46-5.31S120.04,556.61,120.33,557.33z"
    />
    <path
      class="bone"
      disabled
      d="M125.98,561.21c0.19,0,1.48-0.21,1.55-0.53s-1.49-2.06-2.5-2.86s-1.12-2-2.13-2.48c-0.43-0.2-1.13,0.07-0.84,0.54s3.51,5,3.51,5C125.7,561,125.84,561.11,125.98,561.21z"
    />
    <path
      class="bone"
      disabled
      d="M105.52,569.82c0,0-0.21,0-0.26,0s-1.58-0.49-1.28-1.63s2.07-2.77,2.57-2.64c0,0,0.67-0.15,1.83,1.3c0.35,0.42,0.59,0.93,0.67,1.47c0.04,0.42-0.18,0.81-0.55,1c-0.39-0.06-0.78-0.09-1.17-0.1c-0.54,0.11-1.05,0.34-1.5,0.66C105.72,569.9,105.61,569.88,105.52,569.82z"
    />
    <path
      class="bone"
      disabled
      d="M130.4,230.55c-9.66-1.78-14.75,2.58-15.08,7.08c-0.51,7,4,18.87,1.21,24.81c-2.7,5.71-6.83,10.62-12,14.24c-1.9,1.34-4.12,2.74-5.35,4.88c-1.89,0.31-3.81,0.31-5.7,0c-1.24-2.14-3.46-3.54-5.36-4.88c-5.17-3.62-9.3-8.53-12-14.24c-2.79-5.94,1.72-17.82,1.21-24.81c-0.33-4.5-5.41-8.86-15.07-7.08c-6.2,1.14-11.39,5.28-11.4,12.54c0,6.89,1.53,18.69,12.11,23.53c4.38,2,7.11,4.3,8,8.54c1.29,6.32-0.54,12.71,0.5,16.71c1.67,6.45,5.85,8.7,11.64,8.64c5.6-0.05,8.82-5.26,10.41-10.21c0-0.14,0.08-0.28,0.13-0.42c0.73,0.7,1.68,1.11,2.69,1.18l0,0c1.01-0.07,1.96-0.49,2.69-1.18l0.12,0.42c1.59,4.95,4.81,10.16,10.41,10.21c5.79,0.06,10-2.19,11.65-8.64c1-4-0.8-10.39,0.5-16.71c0.86-4.24,3.59-6.53,8-8.54c10.58-4.84,12.11-16.64,12.1-23.53C141.78,235.83,136.59,231.69,130.4,230.55z M84.18,293.86c-2.57,1.31-3.73-3.11-4.79-4.76c-1.37-2.14-3.34-4.26-2.51-7.07s4-2.24,6.24-1.2c2.24,1.23,3.84,3.36,4.4,5.85C87.78,289,86.44,292.71,84.18,293.86z M113.27,289.1c-1.07,1.65-2.23,6.07-4.8,4.76c-2.25-1.15-3.6-4.84-3.33-7.18c0.56-2.49,2.15-4.62,4.39-5.85c2.21-1,5.38-1.75,6.25,1.2S114.63,287,113.27,289.1L113.27,289.1z"
    />
    <path
      class="bone"
      disabled
      d="M100.64,100.94c0,0-1.85-0.06-4.31-0.06s-4.31,0.06-4.31,0.06c-2.22,0.18-0.69,3.61-0.4,4.49s2.17,1.23,4.71,1.23s4.37-0.22,4.71-1.23S102.86,101.12,100.64,100.94z"
    />
    <path
      class="bone"
      disabled
      d="M111.45,418.29c0.77-3.91,6-4,7.74-3.34c1.43,0.57,3.66,3.85,3.53,6.24s-2.33,7.39-5.89,7.19C113.44,428.18,110.45,423.36,111.45,418.29z"
    />
    <path
      class="bone"
      disabled
      d="M55.82,275.39c2.89,0.14,2.09,2.69,3.55,2s0.27-2.57-0.24-3.91s-0.07-3.93,1.75-4.58c3.33-1.19,6.27,1.75,7.46,4.1c1.23,2.48,1.78,5.24,1.58,8c-0.38,2.67-3.42,1.57-5.57,2.18s-2.42,5.46-1.24,8.35s1.88,3.83,0.86,7.38s3,27.23,5.88,46.86c1.94,13.38,5.89,34.63,9,47.32c1.32,5.36,4.67,15.14,6,16.66c3.75,4.24,4.65,8.37,3,14.39c-1.07,4-3.51,4.82-5.43,4.49c-1.84-0.6-1.46-2.09-1.1-3.1s1.81-4.28,1.29-7.29c-0.71-3.86-4.41-6.41-8.27-5.69c-1.25,0.23-2.41,0.79-3.37,1.62c-2.17,1.94-3,5.45-2.19,8.63c0.54,2.11,1.46,2.85,1,4.16c-0.6,1.56-2.88,1.12-5.12-0.91c-0.76-0.68-2-2.09-1.1-8.65c0.77-5.73,4-6.19,4.56-12.15s-5.88-46.77-7.2-54.63c-1.2-7-6.41-45.14-6.59-46.77c-0.39-3.53-4.06-7.68-5.17-13C46.41,277.56,52.92,275.26,55.82,275.39z"
    />
    <path
      class="bone"
      disabled
      d="M64.69,430.82c-0.38-1.3,0.47-2.53,1.09-2.27c2.63,1.07,3.3,1.13,5,0.34c1.11-0.52,2.94,1.23,4.91,1.33c2.14,0.12,3-2,4.18-1.25c1.55,0.94,4.2,1.71,6.08,0.79c0.37-0.17,0.8-0.12,1.12,0.13c0.65,0.31,1.08,0.94,1.14,1.65c0.11,0.86-0.34,2.18-1.79,4.63c-6.43,10.88-3.53,31-2.45,45.41c2.94,39.51,6.32,39.6,7.25,52.23c0.08,1-0.62,2.54-1.41,2.61s-3-1.24-5.25-1.36c-2.21,0.11-4.4,0.5-6.51,1.18c-2,0.71-0.44-3.65,0-7.32c1.16-9-3.6-48.92-4.4-55.22c-0.69-5.37-2.65-26.1-3.43-30C69.16,438.26,65.87,434.78,64.69,430.82z"
    />
    <path
      class="bone"
      disabled
      d="M81.21,418.29c-0.78-3.91-6-4-7.75-3.34c-1.43,0.57-3.65,3.85-3.53,6.24s2.33,7.39,5.89,7.19C79.22,428.18,82.21,423.36,81.21,418.29z"
    />
    <path
      class="bone"
      disabled
      d="M156.02,109.82c-1.83-1.07-3.73-2.01-5.69-2.82c-1.28-0.46-2.35-0.5-3.09,0.2s-0.69,2.09-0.4,3.35s-3.15,2.12-4.16,2s-2.68-2.2-4.37-2.74s-4.07,0.75-5.39,0.88c-0.73,0.08-2.59-0.08-4.65-0.18c0.02,0.33,0.02,0.67,0,1c2.54,1.13,6.89,3.51,8,7c0.55,1.59,0.21,3.35-0.89,4.62c1.54,1.43,3.25,3.52,3.33,5.81c0.07,1.26-0.26,2.52-0.94,3.58c1.53,1.28,3.06,3.17,2.82,5.5c-0.14,1.58-0.85,3.05-2,4.14c0.64,0.43,1.25,0.9,1.83,1.41c3.46-7.13,5.46-12.69,4.29-13.76c-1.03-1.18-1.72-2.62-2-4.16c-0.28-3.06,0.47-6.13,2.12-8.72c1.4-2.21,4.83-4.62,10.94-3.27C158.15,114.12,157.71,110.88,156.02,109.82z"
    />
    <path
      class="bone"
      disabled
      d="M47.98,129.74c-1.17,1.07,0.83,6.63,4.28,13.76c0.58-0.51,1.19-0.98,1.83-1.41c-1.14-1.09-1.85-2.56-2-4.14c-0.24-2.33,1.3-4.22,2.83-5.5c-0.69-1.07-1.02-2.32-0.95-3.59c0.09-2.28,1.79-4.37,3.34-5.8c-1.1-1.27-1.44-3.02-0.9-4.61c1.16-3.45,5.51-5.83,8.06-7c0-0.3,0-0.62,0-1c-2,0.1-3.91,0.26-4.65,0.18c-1.31-0.13-3.64-1.43-5.38-0.88s-3.34,2.62-4.37,2.74s-4.44-0.72-4.16-2s0.32-2.65-0.4-3.35s-1.82-0.66-3.09-0.2c-1.98,0.8-3.89,1.73-5.74,2.79c-1.68,1.06-2.12,4.3,0.29,3.77c6.12-1.35,9.54,1.06,10.95,3.27c1.65,2.59,2.4,5.66,2.12,8.72C49.75,127.07,49.04,128.54,47.98,129.74z"
    />
    <path
      class="bone"
      disabled
      d="M103.74,170.19c-0.14-0.35-0.47-0.63-0.8-0.54c-0.76,0.21-2,1-2,0c0-0.61,1-1.77-0.87-2c0,0-1.58-0.07-3.69-0.07s-3.7,0.07-3.7,0.07c-1.9,0.21-0.85,1.37-0.86,2c0,1-1.29,0.22-2,0c-0.36-0.04-0.7,0.19-0.8,0.54c0,0.15,0,0.3-0.07,0.44c0,0.31,0.3,0.59,0.87,0.66c1.52,0.21,2.62,0.42,2.56,1.37c-0.08,1.18,1.87,1.48,4,1.48s4.13-0.3,4-1.48c-0.06-0.95,1-1.16,2.56-1.37c0.56-0.07,0.81-0.35,0.86-0.66L103.74,170.19z"
    />
  </svg>`;default:return V`<svg
    id="ct_adult_anatomical"
    hidden
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    style="width:10rem; height:36.25rem;"
    viewBox="0 0 160 580"
    xml:space="preserve"
  >
    <path
      index="1"
      class="region"
      d="M57.873,10.693a24.7,24.7,0,0,0-2.932,5.65,32.341,32.341,0,0,0-1.824,8.447,40.015,40.015,0,0,0,.114,8.718c.107.876.2,1.519.206,1.522a.552.552,0,0,1-.127.445c-.116.131-.4.457-.566,1.728a20.906,20.906,0,0,0,.209,5.177,39.509,39.509,0,0,0,1.024,5.085l.224.883a25.6,25.6,0,0,0,2.132,5.7c.206.4.4.73.573,1.008a4.375,4.375,0,0,0,1.276,1.411,1.672,1.672,0,0,0,.388.2.834.834,0,0,0,.35.045,1.04,1.04,0,0,0,.65-.383.556.556,0,0,1,.237-.142.674.674,0,0,1,.078-.016.526.526,0,0,1,.639.467l.009.072c.041.319.225,1.661.586,3.376a57.194,57.194,0,0,0,3.13,9.73c3.635,8.143,8.94,12.272,15.768,12.272S92.16,77.963,95.8,69.82a57.557,57.557,0,0,0,2.864-8.584c.1-.409.193-.8.266-1.146.36-1.715.544-3.057.585-3.376l.009-.072a.553.553,0,0,1,.954-.309,1.476,1.476,0,0,0,.322.271.925.925,0,0,0,1.067-.133,5.828,5.828,0,0,0,1.848-2.419,25.533,25.533,0,0,0,2.133-5.7l.225-.887c.149-.583.28-1.092.4-1.632.206-.9.394-1.887.62-3.449A20.961,20.961,0,0,0,107.3,37.2h0a3.8,3.8,0,0,0-.443-1.571,1.148,1.148,0,0,0-.1-.133.612.612,0,0,1-.149-.469s.1-.646.206-1.522a40.016,40.016,0,0,0,.115-8.718,32.373,32.373,0,0,0-1.825-8.447,25.164,25.164,0,0,0-2.931-5.65,21.4,21.4,0,0,0-6.9-6.178c-4.219-2.327-9.063-3.41-15.245-3.41S68.991,2.188,64.772,4.515A21.383,21.383,0,0,0,57.873,10.693Z"
    />
    <path
      index="2"
      class="region"
      d="M70.7,121.021a4.674,4.674,0,0,0,0-5.625,4.2,4.2,0,0,1-1.06-2.812c0-4.81,4.661-8.724,10.39-8.724s10.391,3.914,10.391,8.724a4.208,4.208,0,0,1-1.06,2.812,4.67,4.67,0,0,0,0,5.625,4.208,4.208,0,0,1,1.06,2.812,4.4,4.4,0,0,1-.09.9h30.433l6.659-25.251a170.273,170.273,0,0,0-22.168-5.876c-6.141-1.308-9.392-2.036-10.379-3-2.125-2.076-.838-11.442.138-16.874C91.292,80.01,86.267,83.2,80.027,83.2s-11.273-3.184-14.993-9.457c.974,5.426,2.262,14.794.136,16.87-.988.965-4.238,1.693-10.379,3a170.189,170.189,0,0,0-22.158,5.873l6.659,25.254H69.727a4.4,4.4,0,0,1-.09-.9A4.2,4.2,0,0,1,70.7,121.021Z"
    />
    <path
      index="3"
      class="region"
      d="M80.027,104.86c-5.186,0-9.39,3.458-9.39,7.724,0,2.368,2,2.157,2,5.625s-2,3.256-2,5.624,2,2.157,2,5.625-2,3.257-2,5.625,2,2.157,2,5.625-2,3.256-2,5.624,2,2.157,2,5.625-2,3.257-2,5.625,2,2.157,2,5.625-2,3.256-2,5.624,2,2.157,2,5.625-2,3.257-2,5.625,2,2.157,2,5.625-2,3.256-2,5.624,2,2.157,2,5.625-2,3.257-2,5.625,2,2.157,2,5.625-2,3.256-2,5.624,2,2.157,2,5.625-2,3.257-2,5.625,2,2.157,2,5.625-2,3.256-2,5.624,2,2.157,2,5.625-2,3.257-2,5.625,2,2.157,2,5.625-2,3.256-2,5.624,2,2.157,2,5.625-2,3.256-2,5.625c0,4.266,4.2,7.724,9.39,7.724s9.391-3.458,9.391-7.724c0-2.369-2-2.157-2-5.625s2-3.256,2-5.625-2-2.157-2-5.624,2-3.257,2-5.625-2-2.157-2-5.625,2-3.256,2-5.625-2-2.156-2-5.624,2-3.257,2-5.625-2-2.157-2-5.625,2-3.256,2-5.625-2-2.156-2-5.624,2-3.257,2-5.625-2-2.157-2-5.625,2-3.256,2-5.625-2-2.156-2-5.624,2-3.257,2-5.625-2-2.157-2-5.625,2-3.256,2-5.625-2-2.156-2-5.624,2-3.257,2-5.625-2-2.157-2-5.625,2-3.256,2-5.625-2-2.156-2-5.624,2-3.257,2-5.625-2-2.157-2-5.625,2-3.256,2-5.625-2-2.156-2-5.624,2-3.257,2-5.625C89.418,108.318,85.213,104.86,80.027,104.86Z"
    />
    <path
      index="4"
      class="region"
      d="M155.375,156.748c-1.67-25.312-5.069-41.437-10.027-46.745-4.111-4.4-10.285-7.656-16.887-10.132l-6.7,25.416,8.628,31.461h24.989Z"
    />
    <path
      index="4"
      class="region"
      d="M29.667,156.748,38.3,125.287l-6.7-25.42C24.986,102.344,18.807,105.6,14.7,110c-4.958,5.308-8.357,21.433-10.027,46.745h25Z"
    />
    <path
      index="5"
      class="region"
      d="M157.242,301.323c-.107-.508-.213-.993-.318-1.452-.262-1.149-.514-2.14-.731-2.941-.086-.32-.168-.61-.241-.868-.184-.644-.322-1.086-.389-1.294l-.031-.1-.013-.039a.544.544,0,0,1-.029-.175c0-1.306.043-2.708.119-4.188.228-4.439.752-9.579,1.3-14.943.847-8.307,1.722-16.9,1.722-24.6,0-3.052-.1-5.971-.252-8.762-.1-1.86-.231-3.664-.372-5.413-.212-2.623-.453-5.121-.683-7.5-.481-4.985-.9-9.29-.9-13.129,0-.5.013-1.46.032-2.81.25-17.55.059-33.129-.547-46.579-.145-3-.313-5.923-.508-8.786H130.645a.537.537,0,0,1,.015.08c0,5.933.689,23.114,1.193,35.659.293,7.329.525,13.118.525,14.3,0,.68.022,1.72.057,3,.025.957.058,2.046.095,3.216.012.39.024.789.037,1.194.05,1.615.1,3.311.149,4.966s.086,3.269.11,4.72c.017.968.026,1.863.026,2.65,0,4.395,2.129,14.713,6.328,30.664.285,1.087.526,2.275.73,3.535.135.841.254,1.714.358,2.611.258,2.242.421,4.637.515,7.055.038.967.064,1.938.082,2.905q.012.724.018,1.445c.016,1.921,0,3.807-.042,5.595-.019.893-.044,1.762-.073,2.6-.043,1.254-.094,2.433-.147,3.51s-.11,2.054-.163,2.9c-.035.564-.069,1.07-.1,1.511-.046.661-.085,1.175-.112,1.512-.018.225-.031.373-.036.433a.549.549,0,0,1-.03.138,58.689,58.689,0,0,0-1.755,6.467c-.18.837-.354,1.73-.511,2.662a45.59,45.59,0,0,0-.677,7.466,52.411,52.411,0,0,0,1.064,11.51,17.843,17.843,0,0,0,.512,1.784c.09.258.183.5.278.713.475,1.086,1,1.658,1.516,1.658a1.642,1.642,0,0,0,1.432-.735,3.761,3.761,0,0,0,.516-1.963.553.553,0,1,1,1.1,0c0,2.031.045,3.872.126,5.541a54.457,54.457,0,0,0,1.072,9.087,22.636,22.636,0,0,0,.7,2.506q.125.359.255.679a11.36,11.36,0,0,0,.532,1.148q.137.254.275.477a6.806,6.806,0,0,0,.56.779,4.634,4.634,0,0,0,.845.792,3.756,3.756,0,0,0,2.377.661c2.022,0,8.537-15.328,8.537-28.215A77.7,77.7,0,0,0,157.242,301.323Z"
    />
    <path
      index="5"
      class="region"
      d="M3.583,213.049v.065c.019,1.349.033,2.307.033,2.809,0,.96-.026,1.949-.072,2.97-.117,2.553-.361,5.31-.648,8.321q-.086.9-.177,1.838c-.459,4.759-.965,9.994-1.189,15.748-.074,1.918-.118,3.893-.118,5.928,0,7.7.876,16.291,1.723,24.6.456,4.47.895,8.785,1.161,12.668.16,2.329.256,4.5.256,6.463a.518.518,0,0,1-.029.175l-.044.136c-.026.083-.065.2-.112.36s-.106.347-.172.572c-.165.562-.38,1.333-.621,2.28-.048.19-.1.387-.148.59-.35,1.424-.739,3.183-1.1,5.19a75.96,75.96,0,0,0-1.224,13.194c0,8.86,3.079,18.873,5.66,24.267A22.447,22.447,0,0,0,8.1,343.669a6.591,6.591,0,0,0,.861,1.11,1.567,1.567,0,0,0,.475.345.531.531,0,0,0,.2.045,3.74,3.74,0,0,0,3.221-1.453,6.686,6.686,0,0,0,.56-.779,10.453,10.453,0,0,0,.808-1.625,18.54,18.54,0,0,0,.733-2.268c.152-.583.295-1.222.428-1.921a50.067,50.067,0,0,0,.659-4.971q.063-.723.115-1.5.1-1.554.16-3.338t.057-3.814a.553.553,0,1,1,1.105,0c0,.451.094,2.7,1.948,2.7,1.657,0,3.37-5.86,3.37-15.665a57.577,57.577,0,0,0-2.942-16.595.549.549,0,0,1-.03-.138c-.016-.182-.1-1.141-.2-2.654-.15-2.27-.346-5.789-.435-9.81-.039-1.788-.058-3.674-.042-5.595.021-2.4.094-4.854.248-7.232.061-.952.135-1.891.224-2.81a48.727,48.727,0,0,1,1.232-7.508q1.18-4.486,2.143-8.376t1.7-7.176c1.649-7.3,2.48-12.364,2.48-15.113,0-1.181.022-2.605.055-4.151.023-1.031.051-2.116.082-3.219.046-1.655.1-3.351.149-4.966.038-1.217.074-2.371.1-3.411.02-.693.038-1.335.052-1.911.02-.862.033-1.575.033-2.085,0-.147,0-.367.01-.652s.017-.636.03-1.048c.02-.617.046-1.369.078-2.236.022-.578.046-1.207.071-1.881s.054-1.394.084-2.152.062-1.556.095-2.386q.024-.622.05-1.27c.035-.862.071-1.754.107-2.67.017-.413.034-.833.051-1.256.5-12.41,1.142-28.666,1.142-34.4a.537.537,0,0,1,.015-.08H4.6C3.632,173.021,3.279,191.565,3.583,213.049Z"
    />
    <path
      index="6"
      class="region"
      d="M120.845,125.737H90.078a6.626,6.626,0,0,1-.637.972,4.569,4.569,0,0,0,0,5.5,4.364,4.364,0,0,1,0,5.75,4.569,4.569,0,0,0,0,5.5,4.365,4.365,0,0,1,0,5.751,3.8,3.8,0,0,0-.92,2.749,4.772,4.772,0,0,0,.195,1.47h-.289c.191.443,2.095,3.476,2.095,4.156a4.344,4.344,0,0,1-1.081,2.875,4.569,4.569,0,0,0,0,5.5,4.365,4.365,0,0,1,0,5.751,4.569,4.569,0,0,0,0,5.5,4.364,4.364,0,0,1,0,5.75,4.569,4.569,0,0,0,0,5.5,4.365,4.365,0,0,1,0,5.751,4.569,4.569,0,0,0,0,5.5,4.34,4.34,0,0,1,1.081,2.875,4.018,4.018,0,0,1-.663,2.286h33c1.427-14.926,6.459-45.619,6.707-47.128v0l.024-.121Z"
    />
    <path
      index="6"
      class="region"
      d="M39.292,125.737h-.083l-8.748,31.9.019.1v0c.248,1.509,5.279,32.2,6.706,47.128H70.2a4.018,4.018,0,0,1-.664-2.286,4.342,4.342,0,0,1,1.081-2.875,4.569,4.569,0,0,0,0-5.5,4.365,4.365,0,0,1,0-5.751,4.569,4.569,0,0,0,0-5.5,4.364,4.364,0,0,1,0-5.75,4.569,4.569,0,0,0,0-5.5,4.365,4.365,0,0,1,0-5.751,4.569,4.569,0,0,0,0-5.5,4.344,4.344,0,0,1-1.081-2.875,13.768,13.768,0,0,1,1.272-3.133,3.712,3.712,0,0,0,.729-2.492,3.79,3.79,0,0,0-.92-2.749,4.365,4.365,0,0,1,0-5.751,4.569,4.569,0,0,0,0-5.5,4.364,4.364,0,0,1,0-5.75,4.569,4.569,0,0,0,0-5.5,6.708,6.708,0,0,1-.637-.972H39.292Z"
    />
    <path
      index="7"
      class="region"
      d="M122.481,210.79c0-1.188.1-2.839.274-4.819H89.074a4.662,4.662,0,0,0,.367,4.983,4.365,4.365,0,0,1,0,5.751,4.569,4.569,0,0,0,0,5.5,4.364,4.364,0,0,1,0,5.75,4.569,4.569,0,0,0,0,5.5,4.365,4.365,0,0,1,0,5.751,4.569,4.569,0,0,0,0,5.5,4.364,4.364,0,0,1,0,5.75c-.052.069-.1.137-.152.2h38.673C125.19,236,122.481,221.151,122.481,210.79Z"
    />
    <path
      index="7"
      class="region"
      d="M71.533,208.205a3.8,3.8,0,0,0-.553-2.234H37.289c.174,1.98.273,3.631.273,4.819,0,10.361-2.709,25.214-5.48,39.868H70.766l-.153-.2a4.364,4.364,0,0,1,0-5.75,4.569,4.569,0,0,0,0-5.5,4.365,4.365,0,0,1,0-5.751,4.569,4.569,0,0,0,0-5.5,4.364,4.364,0,0,1,0-5.75,4.569,4.569,0,0,0,0-5.5,4.365,4.365,0,0,1,0-5.751A3.79,3.79,0,0,0,71.533,208.205Z"
    />
    <path
      index="8"
      class="region"
      d="M128.442,253.2q-.135-.715-.271-1.433H88.706a4.839,4.839,0,0,0-.185,1.44,3.8,3.8,0,0,0,.92,2.749,4.365,4.365,0,0,1,0,5.751,4.569,4.569,0,0,0,0,5.5,4.34,4.34,0,0,1,1.081,2.875c0,4.868-4.708,8.828-10.5,8.828s-10.5-3.96-10.5-8.828a4.34,4.34,0,0,1,1.081-2.875,4.569,4.569,0,0,0,0-5.5,4.365,4.365,0,0,1,0-5.751,3.79,3.79,0,0,0,.92-2.749,4.839,4.839,0,0,0-.185-1.44H31.873q-.137.717-.272,1.433c-2.425,12.791-4.715,24.872-4.715,31.7,0,6.159.109,12.05.3,17.714H79.356c.072-3.857.112-7.293.114-10.169a.552.552,0,0,1,1.1,0c0,2.876.042,6.312.114,10.169h52.168c.192-5.664.3-11.555.3-17.714C133.157,278.068,130.867,265.987,128.442,253.2Z"
    />
    <path
      index="9"
      class="region"
      d="M118.839,398.807c4.742-18.771,12.306-48.752,13.979-95.1H80.709c.807,41.117,4.995,128.165,5.042,129.131a36.382,36.382,0,0,1-1.238,8.009,94.1,94.1,0,0,0-2.65,23.055c0,15.619,3.454,44.234,3.489,44.521a125.2,125.2,0,0,1-1.476,16.609,87.029,87.029,0,0,0-1.044,10.5c0,3.149.461,7.5.906,11.7.449,4.233.912,8.611.912,11.82,0,1.257-.108,2.816-.222,4.467-.36,5.2-.809,11.671,1.6,14.252A3.586,3.586,0,0,0,88.8,578.9c8.09,0,26.485-5.277,26.485-13.968,0-2.572-2.453-6.119-5.293-10.228-4.033-5.831-9.052-13.088-9.052-20.809,0-5.351,2.643-14.915,5.7-25.989,4.582-16.581,10.283-37.215,10.283-54.417a216.147,216.147,0,0,0-1.082-21.62c-.406-4.5-.79-8.741-.79-13.89C115.056,413.786,116.643,407.5,118.839,398.807Z"
    />
    <path
      index="9"
      class="region"
      d="M27.225,303.712c1.673,46.343,9.238,76.324,13.979,95.1,2.2,8.7,3.784,14.979,3.784,19.167,0,5.149-.384,9.394-.791,13.89a216.147,216.147,0,0,0-1.082,21.62c0,17.2,5.7,37.836,10.284,54.417,3.06,11.074,5.7,20.638,5.7,25.989,0,7.721-5.019,14.978-9.052,20.809-2.84,4.109-5.294,7.656-5.294,10.228,0,8.691,18.4,13.968,26.485,13.968a3.586,3.586,0,0,0,2.775-1.122c2.408-2.58,1.96-9.052,1.6-14.251-.114-1.651-.222-3.21-.222-4.467,0-3.209.464-7.587.912-11.82.445-4.206.906-8.554.906-11.7a87,87,0,0,0-1.043-10.5,125.523,125.523,0,0,1-1.48-16.542c.039-.354,3.493-28.97,3.493-44.588a94.1,94.1,0,0,0-2.65-23.055,36.467,36.467,0,0,1-1.239-7.982c.047-.991,4.236-88.041,5.043-129.158Z"
    />
    <path
      class="outline"
      d="M88.8,580a4.688,4.688,0,0,1-3.581-1.473c-2.737-2.931-2.27-9.668-1.9-15.081.113-1.631.22-3.173.22-4.391,0-3.15-.461-7.5-.906-11.7-.449-4.233-.912-8.611-.912-11.819a87.688,87.688,0,0,1,1.053-10.644,124.693,124.693,0,0,0,1.47-16.393c-.031-.222-3.493-28.9-3.493-44.588a95.079,95.079,0,0,1,2.677-23.3,35.706,35.706,0,0,0,1.212-7.738c-.04-.831-3.3-68.542-4.625-112.768C78.695,364.33,75.437,432.045,75.4,432.9a35.734,35.734,0,0,0,1.212,7.711,95.016,95.016,0,0,1,2.678,23.3c0,15.685-3.462,44.366-3.5,44.655a125.393,125.393,0,0,0,1.473,16.326,87.514,87.514,0,0,1,1.054,10.644c0,3.208-.464,7.586-.912,11.819-.445,4.206-.906,8.554-.906,11.7,0,1.218.107,2.76.219,4.391.375,5.413.842,12.149-1.894,15.081A4.69,4.69,0,0,1,71.241,580c-8.007,0-27.589-5.282-27.589-15.073,0-2.916,2.544-6.6,5.489-10.855C53.087,548.366,58,541.265,58,533.89c0-5.2-2.625-14.7-5.663-25.695-4.6-16.645-10.324-37.359-10.324-54.711A216.881,216.881,0,0,1,43.1,431.763c.421-4.663.786-8.69.786-13.789,0-4.05-1.573-10.277-3.75-18.9-5.368-21.251-14.352-56.818-14.352-114.185,0-6.928,2.3-19.059,4.734-31.9,2.785-14.692,5.942-31.344,5.942-42.2,0-7.514-4.138-34.494-6.081-46.746-.216,7.936-.7,20.028-1.08,29.487-.294,7.317-.526,13.1-.526,14.251,0,1.376-.087,4.187-.189,7.441-.133,4.3-.285,9.171-.285,12.3,0,4.493-2.141,14.905-6.364,30.946-2.913,11.105-1.12,33.75-1,35.166a58.671,58.671,0,0,1,2.982,16.895c0,2.8-.216,16.77-4.475,16.77a2.664,2.664,0,0,1-1.983-.788c-.411,17.434-4.354,19.76-7.811,19.76C6.236,346.274,0,329.036,0,316.954a80.153,80.153,0,0,1,3.449-22.585c-.008-5.157-.69-11.848-1.412-18.931C1.187,267.1.309,258.484.309,250.728c0-8.192.7-15.412,1.311-21.782.479-4.956.892-9.237.892-13.023,0-.5-.013-1.452-.033-2.794-.84-59.069,3.1-94.99,11.409-103.88C23.276,99.2,42.86,95.023,54.561,92.529,59.408,91.5,63.594,90.6,64.4,89.818c2.1-2.054-.3-15.8-1.18-19.6a58.64,58.64,0,0,1-3.181-9.9c-.227-1.078-.384-2-.482-2.634a2.041,2.041,0,0,1-1.989-.295,7.106,7.106,0,0,1-2.216-2.829,26.71,26.71,0,0,1-2.221-5.942l-.223-.878a40.4,40.4,0,0,1-1.047-5.2,21.962,21.962,0,0,1-.212-5.477,4.522,4.522,0,0,1,.662-2.1c-.04-.27-.106-.745-.176-1.318a41.115,41.115,0,0,1-.118-8.948A33.469,33.469,0,0,1,53.9,15.964a25.867,25.867,0,0,1,3.071-5.915,22.531,22.531,0,0,1,7.263-6.5C68.627,1.127,73.64,0,80.017,0s11.4,1.127,15.788,3.547a22.549,22.549,0,0,1,7.263,6.5,25.85,25.85,0,0,1,3.072,5.915,33.532,33.532,0,0,1,1.888,8.728,41.181,41.181,0,0,1-.119,8.948c-.07.574-.136,1.051-.175,1.32a4.541,4.541,0,0,1,.662,2.1,22.066,22.066,0,0,1-.212,5.477,40.357,40.357,0,0,1-1.046,5.2l-.224.883a26.529,26.529,0,0,1-2.223,5.942,7.087,7.087,0,0,1-2.215,2.829,2.038,2.038,0,0,1-1.988.295c-.1.634-.256,1.556-.482,2.634a58.43,58.43,0,0,1-3.2,9.952c-.846,3.637-3.28,17.476-1.158,19.548.805.786,4.991,1.678,9.838,2.711,11.7,2.494,31.285,6.669,40.673,16.72,8.3,8.89,12.248,44.811,11.408,103.88-.019,1.342-.033,2.3-.033,2.794,0,3.786.413,8.067.892,13.023.615,6.37,1.312,13.59,1.312,21.782,0,7.756-.879,16.375-1.729,24.71-.721,7.083-1.4,13.774-1.411,18.93a80.213,80.213,0,0,1,3.448,22.586c0,12.082-6.236,29.32-9.641,29.32-3.458,0-7.4-2.326-7.811-19.76a2.668,2.668,0,0,1-1.984.788c-4.259,0-4.475-13.97-4.475-16.77a58.632,58.632,0,0,1,2.983-16.895c.116-1.419,1.91-24.062-1-35.167-4.224-16.043-6.365-26.455-6.365-30.945,0-3.131-.151-8-.285-12.3-.1-3.254-.188-6.065-.188-7.441,0-1.155-.232-6.934-.526-14.251-.379-9.459-.864-21.552-1.08-29.487-1.943,12.252-6.082,39.232-6.082,46.746,0,10.856,3.157,27.508,5.942,42.2,2.435,12.844,4.734,24.975,4.734,31.9,0,57.367-8.984,92.934-14.351,114.185-2.178,8.619-3.751,14.846-3.751,18.9,0,5.1.364,9.126.787,13.789a217.24,217.24,0,0,1,1.086,21.721c0,17.352-5.724,38.066-10.323,54.711-3.039,11-5.663,20.494-5.663,25.695,0,7.375,4.91,14.476,8.855,20.182,2.946,4.26,5.49,7.939,5.49,10.855C116.392,574.718,96.809,580,88.8,580Zm-8.78-288.114a.552.552,0,0,1,.552.552c.018,33.176,5.126,139.337,5.177,140.405a36.382,36.382,0,0,1-1.238,8.009,94.1,94.1,0,0,0-2.65,23.055c0,15.619,3.454,44.234,3.489,44.521a125.2,125.2,0,0,1-1.476,16.609,87.029,87.029,0,0,0-1.044,10.5c0,3.149.461,7.5.906,11.7.449,4.233.912,8.611.912,11.82,0,1.257-.108,2.816-.222,4.467-.36,5.2-.809,11.671,1.6,14.252A3.586,3.586,0,0,0,88.8,578.9c8.09,0,26.485-5.277,26.485-13.968,0-2.572-2.453-6.119-5.293-10.228-4.033-5.831-9.052-13.088-9.052-20.809,0-5.351,2.643-14.915,5.7-25.989,4.582-16.581,10.284-37.215,10.284-54.417a216.092,216.092,0,0,0-1.083-21.62c-.406-4.5-.79-8.741-.79-13.89,0-4.188,1.587-10.47,3.783-19.167,5.356-21.2,14.318-56.685,14.318-113.914,0-6.824-2.29-18.906-4.715-31.7-2.93-15.46-5.961-31.446-5.961-42.406,0-9.859,6.792-51.293,7.082-53.052a.552.552,0,0,1,1.1.09c0,5.933.689,23.114,1.193,35.659.293,7.329.525,13.118.525,14.3,0,1.36.087,4.162.189,7.407.134,4.307.285,9.188.285,12.336,0,4.395,2.129,14.713,6.328,30.664,3.042,11.595,1.114,34.635,1.03,35.611a.551.551,0,0,1-.03.137,57.56,57.56,0,0,0-2.943,16.595c0,9.806,1.713,15.665,3.37,15.665,1.855,0,1.948-2.247,1.948-2.7a.553.553,0,1,1,1.1,0c.012,21.67,4.9,21.67,6.742,21.67,2.022,0,8.537-15.328,8.537-28.215a78.769,78.769,0,0,0-3.42-22.322.544.544,0,0,1-.029-.175c0-5.224.688-11.979,1.418-19.131.847-8.307,1.722-16.9,1.722-24.6,0-8.139-.694-15.33-1.307-21.676-.481-4.985-.9-9.29-.9-13.129,0-.5.014-1.46.033-2.81.824-57.938-3.121-94.557-11.11-103.11-9.151-9.8-28.522-13.926-40.1-16.393-6.14-1.309-9.391-2.037-10.379-3-3.035-2.963.86-20.67.934-20.815a57.151,57.151,0,0,0,3.118-9.7c.412-1.96.593-3.433.594-3.448a.553.553,0,0,1,.954-.309.925.925,0,0,0,1.389.138,5.828,5.828,0,0,0,1.848-2.419,25.533,25.533,0,0,0,2.133-5.7l.225-.887a39.75,39.75,0,0,0,1.023-5.08A20.97,20.97,0,0,0,107.3,37.2c-.164-1.271-.451-1.6-.545-1.7a.612.612,0,0,1-.149-.469s.1-.646.206-1.522a40.016,40.016,0,0,0,.115-8.718,32.414,32.414,0,0,0-1.825-8.447,25.164,25.164,0,0,0-2.931-5.65,21.4,21.4,0,0,0-6.9-6.178c-4.219-2.327-9.063-3.41-15.245-3.41S68.991,2.188,64.772,4.515a21.383,21.383,0,0,0-6.9,6.178,24.7,24.7,0,0,0-2.932,5.65,32.341,32.341,0,0,0-1.824,8.447,40.015,40.015,0,0,0,.114,8.718c.107.876.2,1.519.206,1.522a.552.552,0,0,1-.127.445c-.116.131-.4.457-.566,1.728a20.906,20.906,0,0,0,.209,5.177,39.509,39.509,0,0,0,1.024,5.085l.224.883a25.6,25.6,0,0,0,2.132,5.7,5.837,5.837,0,0,0,1.848,2.419.926.926,0,0,0,1.389-.138.553.553,0,0,1,.954.309c0,.015.182,1.488.595,3.448a57.194,57.194,0,0,0,3.13,9.73c.064.13,3.944,17.838.922,20.788-.988.965-4.239,1.693-10.379,3C43.217,96.077,23.846,100.205,14.7,110,6.706,118.556,2.76,155.175,3.584,213.114c.019,1.349.033,2.307.033,2.809,0,3.839-.415,8.144-.9,13.129-.612,6.346-1.307,13.537-1.307,21.676,0,7.7.876,16.291,1.723,24.6.729,7.152,1.417,13.907,1.417,19.131a.518.518,0,0,1-.029.175,78.79,78.79,0,0,0-3.419,22.322c0,12.887,6.514,28.215,8.537,28.215,1.84,0,6.73,0,6.741-21.67a.553.553,0,0,1,.553-.553h0a.552.552,0,0,1,.552.553c0,.451.094,2.7,1.948,2.7,1.657,0,3.37-5.859,3.37-15.665a57.577,57.577,0,0,0-2.942-16.595.551.551,0,0,1-.03-.137c-.084-.976-2.012-24.016,1.03-35.61,4.2-15.95,6.327-26.266,6.327-30.665,0-3.148.152-8.029.286-12.336.1-3.245.188-6.047.188-7.407,0-1.177.232-6.966.526-14.3.5-12.545,1.193-29.726,1.193-35.659a.552.552,0,0,1,1.1-.09c.289,1.759,7.081,43.193,7.081,53.052,0,10.96-3.031,26.946-5.961,42.406-2.425,12.791-4.715,24.873-4.715,31.7,0,57.229,8.963,92.713,14.318,113.914,2.2,8.7,3.784,14.979,3.784,19.167,0,5.149-.384,9.394-.791,13.89a216.147,216.147,0,0,0-1.082,21.62c0,17.2,5.7,37.836,10.284,54.417,3.06,11.074,5.7,20.638,5.7,25.989,0,7.721-5.019,14.978-9.052,20.809-2.84,4.109-5.294,7.656-5.294,10.228,0,8.691,18.4,13.968,26.485,13.968a3.586,3.586,0,0,0,2.775-1.122c2.408-2.58,1.96-9.052,1.6-14.251-.114-1.651-.222-3.21-.222-4.467,0-3.209.464-7.587.912-11.82.445-4.206.906-8.554.906-11.7a87,87,0,0,0-1.043-10.5,125.523,125.523,0,0,1-1.48-16.542c.039-.354,3.493-28.97,3.493-44.588a94.1,94.1,0,0,0-2.65-23.055,36.467,36.467,0,0,1-1.239-7.982c.052-1.1,5.16-107.256,5.178-140.432A.552.552,0,0,1,80.022,291.886Z"
    />
  </svg>`}})(this.image)}`}connectedCallback(){super.connectedCallback(),this._clickListener=this._clickHandler.bind(this),this._mouseEnterListener=this._mouseEnterHandler.bind(this),this._mouseLeaveListener=this._mouseLeaveHandler.bind(this),this._xpclickListener=this._xpclickHandler.bind(this)}firstUpdated(){ue.isTouchDevice()&&this.classList.add("touch-device")}updated(e){super.updated(e),e.has("image")&&(this._handleImageChanged(),le(this,"image-changed")),e.has("active")&&(this._handleactiveChanged(),le(this,"active-changed")),e.has("currentSelected")&&"xp_all_in_one"===this.image&&(this._resetState(),this._lastSelected=this.currentSelected,this._handlecurrentSelectedChanged()),e.has("disabled")&&(this._handledisabledChanged(),le(this,"disabled-changed")),(e.has("activeRegions")||e.has("multiSelect"))&&this.multiSelect&&this._handlemultiActiveChanged()}disconnectedCallback(){this.removeEventListener("click",this._xpclickListener),this.removeEventListener("touchend",this._xpclickListener);let e=this.shadowRoot.querySelectorAll(".region");for(let t=0;t<e.length;t++)"xp_all_in_one"!==this.image&&e[t].removeEventListener("click",this._clickListener),ue.isTouchDevice()||(e[t].removeEventListener("mouseenter",this._mouseEnterListener),e[t].removeEventListener("mouseleave",this._mouseLeaveListener));super.disconnectedCallback()}_handleImageChanged(){this.shadowRoot.querySelector("svg").removeAttribute("hidden");let e=this.shadowRoot.querySelectorAll(".region");for(let t=0;t<e.length;t++)"xp_all_in_one"!==this.image&&e[t].addEventListener("click",this._clickListener),ue.isTouchDevice()||(e[t].addEventListener("mouseenter",this._mouseEnterListener),e[t].addEventListener("mouseleave",this._mouseLeaveListener));this.addEventListener("click",this._xpclickListener),this._handleactiveChanged(),this._handledisabledChanged()}_mouseEnterHandler(e){let t=this.shadowRoot.querySelectorAll(".region");for(let o=0;o<t.length;o++)t[o].getAttribute("index")==e.target.getAttribute("index")&&t[o].setAttribute("hover",!0)}_mouseLeaveHandler(e){let t=this.shadowRoot.querySelectorAll(".region");for(let o=0;o<t.length;o++)t[o].getAttribute("index")==e.target.getAttribute("index")&&t[o].removeAttribute("hover")}_handledisabledChanged(){if(this.disabled){let e=this.shadowRoot.querySelectorAll(".region");for(let t=0;t<e.length;t++)this.disabled.indexOf(e[t].getAttribute("index"))>=0?e[t].setAttribute("disabled",!0):e[t].removeAttribute("disabled")}}_handleactiveChanged(){if("xp_all_in_one"==this.image)return;let e;e=this.shadowRoot.querySelectorAll(".region");for(let t=0;t<e.length;t++)this.multiSelect||(e[t].getAttribute("index")==this.active?e[t].setAttribute("active",!0):e[t].removeAttribute("active"))}_handlecurrentSelectedChanged(){if("xp_all_in_one"===this.image&&(this.shadowRoot.querySelectorAll(".region").forEach((e=>e.removeAttribute("active"))),this._illustrationLevel=0,this.currentSelected)){this._illustrationLevel=1;let e=this._areaStates[this.currentSelected];this._setStates(e,!1),this.shadowRoot.querySelector("#default").style.opacity="0"}}_clickHandler(e){e.preventDefault(),this.multiSelect?-1==this.activeRegions.findIndex((t=>t==e.target.getAttribute("index")))?(this.activeRegions=this.activeRegions.concat(e.target.getAttribute("index")),this._handlemultiActiveChanged()):(this.activeRegions=this.activeRegions.filter((t=>t!==e.target.getAttribute("index"))),this._handlemultiActiveChanged()):this.active!=e.target.getAttribute("index")?this.active=e.target.getAttribute("index"):(this.removeAttribute("active"),this.active=void 0)}_handlemultiActiveChanged(){"xp_all_in_one"!=this.image&&this.shadowRoot.querySelectorAll(".region").forEach((e=>{this.activeRegions.includes(e.getAttribute("index"))?e.setAttribute("active",!0):e.getAttribute("active")&&e.removeAttribute("active")}))}_xpclickHandler(e){e.preventDefault();let t=e.path||e.composedPath&&e.composedPath();if("outline"!==t[0].id){if("back-to-default"===t[1].id)this._backToDefault();else if(1===this._illustrationLevel)t[1].id===this.currentSelected+"_selection"?(this.shadowRoot.querySelector("#"+t[0].id).setAttribute("active",!0),this._currentActive=t[0].id,this._illustrationLevel=2):t[2].id===this.currentSelected+"_selection"?(this.shadowRoot.querySelector("#"+t[1].id).setAttribute("active",!0),this._currentActive=t[1].id,this._illustrationLevel=2):"path"===t[0].tagName&&""===t[0].id?this._selectArea(t,1):"path"===t[0].tagName&&""!==t[0].id&&this._selectArea(t,0);else if(2===this._illustrationLevel)if(this.currentSelected+"_selection"===t[1].id&&this._currentActive!==t[0].id)this.shadowRoot.querySelector("#"+this._currentActive).removeAttribute("active"),this.shadowRoot.querySelector("#"+t[0].id).setAttribute("active",!0),this._currentActive=t[0].id,this._illustrationLevel=2;else if(this.currentSelected+"_selection"===t[2].id&&this._currentActive!==t[1].id)this.shadowRoot.querySelector("#"+this._currentActive).removeAttribute("active"),this.shadowRoot.querySelector("#"+t[1].id).setAttribute("active",!0),this._currentActive=t[1].id,this._illustrationLevel=2;else{if(this._currentActive===t[0].id||this._currentActive===t[1].id)return;this._illustrationLevel=1,this._lastSelected=this.currentSelected,this._illustrationLevel=0,this.currentSelected=""}0===this._illustrationLevel&&"path"===t[0].tagName&&"back-to-default"!==t[1].id&&(""===t[0].id?this._selectArea(t,1):this._selectArea(t,0))}}_backToDefault(){this._lastSelected=this.currentSelected,this._illustrationLevel=0,this.currentSelected=""}_resetState(){if(null!=this._lastSelected){if(this._lastSelected){let e=this._areaStates[this._lastSelected];this._setStates(e,!0),this._currentActive&&this._illustrationLevel<2&&(this.shadowRoot.querySelector("#"+this._currentActive).removeAttribute("active"),this._currentActive="")}0===this._illustrationLevel&&(this.shadowRoot.querySelector("#default").style.opacity="1")}}_setStates(e,t){let o=e.hidden,i=e.disabled,r=e.active;o&&o.forEach((e=>{this._setState(e,"hidden")})),i&&i.forEach((e=>{this._setState(e,"disabled")})),r&&(r.forEach((e=>{this._setState(e,"active"),t||(this._currentActive=e)})),t||(this._illustrationLevel=2))}_selectArea(e,t){0===this._illustrationLevel?this.currentSelected=e[t].id:1===this._illustrationLevel&&(this._lastSelected=this.currentSelected,this.currentSelected=e[t].id)}_setState(e,t){let o=this.shadowRoot.querySelector("#"+e);o.hasAttribute(t)?o.removeAttribute(t):o.setAttribute(t,!0)}});const _i=e=>class extends e{static get properties(){return{_invokerNode:{type:Object},_attachNode:{type:Object},trackTargetOn:{type:String,reflect:!0,attribute:"track-target-on"}}}constructor(){super(),this._rootNodes=[],this.trackTargetOn="scrolling"}connectedCallback(){super.connectedCallback(),this._onParentScroll=this._parentScrollActions.bind(this),this._windowResizeListener=this._windowResizeActions.bind(this),this._resizeObserverCallback=this._resizeObserverActions.bind(this),this._resizeObserver=new ResizeObserver(this._resizeObserverCallback),this._additionalStopCheckTime=1e3,this._defaultAdditionalStopCheckDecrementNumber=this._additionalStopCheckTime/16,this._currentStopCheckDecrementNumber=this._defaultAdditionalStopCheckDecrementNumber}updated(e){if(super.updated(e),e.has("_invokerNode")){const t=e.get("_invokerNode");Boolean(t)&&this._doSomethingWithOldInvokerNode(t),this._invokerNode&&this._doSomethingWithNewInvokerNode(this._invokerNode)}(e.has("_attachNode")||e.has("visible"))&&(this._removeScrollResizeObservers(),this.visible&&this._attachNode&&this._setTargetPositionTrackers())}_setTargetPositionTrackers(){this._addResizeObservers(),"scrolling"===this.trackTargetOn?this._addScrollListeners():this._trackTargetUsingRAF(),this._canPositionOverlay()&&this._setOverlayPlacement(this._targetEl)}_addResizeObservers(){window.addEventListener("resize",this._windowResizeListener),this._resizeObserver.observe(this._attachNode),this._resizeObserver.observe(this)}_removeScrollResizeObservers(){window.removeEventListener("resize",this._windowResizeListener),this._removeScrollListeners(),this._resizeObserver.disconnect(),this._stopRafTimers(),this._resetRafTrackSettings()}_stopRafTimers(){cancelAnimationFrame(this._motionDetectTimer),cancelAnimationFrame(this._stopDetectTimer)}_resetRafTrackSettings(){this._currentStopCheckDecrementNumber=this._defaultAdditionalStopCheckDecrementNumber,this._targetLeft=null,this._targetTop=null}disconnectedCallback(){this._removeScrollResizeObservers(),this._invokerNode&&this._doSomethingWithOldInvokerNode(this._invokerNode),super.disconnectedCallback()}_resizeObserverActions(){this._positionOverlayIfPossible()}_windowResizeActions(){this._positionOverlayIfPossible()}_addScrollListeners(){if(0===this._rootNodes.length){this._rootNodes=[];let e=this._attachNode;for(;e;)e.nodeType===Node.DOCUMENT_FRAGMENT_NODE&&e.host&&this._rootNodes.push(e),e=e.host||e.assignedSlot||e.parentNode;this._rootNodes.push(document),this._rootNodes.forEach((e=>{e.addEventListener("scroll",this._onParentScroll,{capture:!0,passive:!0})}))}}_parentScrollActions(){"refit"===this.scrollAction&&this.visible?this._positionOverlayIfPossible():"cancel"!==this.scrollAction&&"hide"!==this.scrollAction||!this.visible||this.manualControlled||(this.visible=!1,le(this,"overlay-closed"))}_removeScrollListeners(){this._rootNodes.forEach((e=>{e.removeEventListener("scroll",this._onParentScroll,{capture:!0,passive:!0})})),this._rootNodes=[]}_setOverlayPlacement(e){console.log(`Please use this function in the implementing components with ${e}`)}_canPositionOverlay(){return this.visible&&this._attachNode&&!this.mobile}_positionOverlayIfPossible(){this._canPositionOverlay()&&this._setOverlayPlacement(this._attachNode)}_doSomethingWithNewInvokerNode(e){console.log(`Please use this function in the implementing components with ${e}`)}_doSomethingWithOldInvokerNode(e){console.log(`Please use this function in the implementing components with ${e}`)}_trackTargetUsingRAF(){this._motionDetectTimer=requestAnimationFrame(this.motionDetect.bind(this))}motionDetect(){if(cancelAnimationFrame(this._stopDetectTimer),cancelAnimationFrame(this._motionDetectTimer),"any"===this.trackTargetOn&&this.visible){const e=setTimeout((()=>{clearTimeout(e);const t=this._attachNode.getBoundingClientRect(),{left:o,top:i}=t;o!==this._targetLeft||i!==this._targetTop?(this._currentStopCheckDecrementNumber=this._defaultAdditionalStopCheckDecrementNumber,this._stopDetectTimer=requestAnimationFrame(this.stopDetect.bind(this))):this._motionDetectTimer=requestAnimationFrame(this.motionDetect.bind(this))}),1e3)}}stopDetect(){if(cancelAnimationFrame(this._stopDetectTimer),cancelAnimationFrame(this._motionDetectTimer),"any"===this.trackTargetOn&&this.visible){const e=this._attachNode.getBoundingClientRect(),{left:t,top:o}=e;t!==this._targetLeft||o!==this._targetTop?(this._targetLeft=t,this._targetTop=o,this._parentScrollActions(),this._currentStopCheckDecrementNumber=this._defaultAdditionalStopCheckDecrementNumber,this._stopDetectTimer=requestAnimationFrame(this.stopDetect.bind(this))):this._currentStopCheckDecrementNumber>0?(--this._currentStopCheckDecrementNumber,this._stopDetectTimer=requestAnimationFrame(this.stopDetect.bind(this))):this._motionDetectTimer=requestAnimationFrame(this.motionDetect.bind(this))}}},ki=e=>e/Number(getComputedStyle(document.documentElement)["font-size"].split("px")[0]);class Ci{constructor(e,t=0){this.x=e[0],this.y=e[1],this.rotation=t}}class Ei{constructor(e,t){this.arrowPositionX=0,this.arrowPositionY=0,this.arrowRotation=0,this.setArrowPosition(e,t)}setArrowPosition(e,t){if(this.arrowX0=-.375,this.arrowY0=-.875,this.arrowRotation0=-270,"SH-WORKLINE-ITEM"===e.tagName&&"information"===e.type&&(e=e.shadowRoot.querySelector("sh-icon")),this.targetRect=e.getBoundingClientRect(),this.popoverRect=t.getBoundingClientRect(),this.arrowBaseHalfWidth=Te(.375),this.arrowPopoverEdgeBoundaryDistance=Te(.5),this.targetLeft=this.targetRect.left,this.targetRight=this.targetRect.right,this.targetTop=this.targetRect.top,this.targetBottom=this.targetRect.bottom,this.popoverLeft=this.popoverRect.left,this.popoverRight=this.popoverRect.right,this.popoverTop=this.popoverRect.top,this.popoverBottom=this.popoverRect.bottom,this.rangeCorrectedPopoverLeft=this.popoverLeft+(this.arrowBaseHalfWidth+this.arrowPopoverEdgeBoundaryDistance),this.rangeCorrectedPopoverRight=this.popoverRight-(this.arrowBaseHalfWidth+this.arrowPopoverEdgeBoundaryDistance),this.rangeCorrectedPopoverTop=this.popoverTop+(this.arrowBaseHalfWidth+this.arrowPopoverEdgeBoundaryDistance),this.rangeCorrectedPopoverBottom=this.popoverBottom-(this.arrowBaseHalfWidth+this.arrowPopoverEdgeBoundaryDistance),this.yIntersection=this.getIntersectionExtremes(this.targetLeft,this.targetRight,this.popoverLeft,this.popoverRight),this.xIntersection=this.getIntersectionExtremes(this.targetTop,this.targetBottom,this.popoverTop,this.popoverBottom),this.yIntersection.length>0){let e,t,o=(this.yIntersection[0]+this.yIntersection[this.yIntersection.length-1])/2;o=o>this.rangeCorrectedPopoverRight?this.rangeCorrectedPopoverRight:o<this.rangeCorrectedPopoverLeft?this.rangeCorrectedPopoverLeft:o,this.targetTop<this.popoverTop?(e=this.popoverTop,t=90):this.targetBottom>this.popoverBottom&&(e=this.popoverBottom,t=270),this.setArrowParameters(t,o,e)}else if(this.xIntersection.length>0){let e,t,o=(this.xIntersection[0]+this.xIntersection[this.xIntersection.length-1])/2;o=o>this.rangeCorrectedPopoverBottom?this.rangeCorrectedPopoverBottom:o<this.rangeCorrectedPopoverTop?this.rangeCorrectedPopoverTop:o,this.targetLeft<this.popoverLeft?(e=this.popoverLeft,t=180):this.targetRight>this.popoverRight&&(e=this.popoverRight,t=0),this.setArrowParameters(t,e,o)}else if(0===this.xIntersection.length&&0===this.yIntersection.length){let e;this.targetLeft>this.popoverRight?this.targetTop>this.popoverBottom?e=this.getSpecialPoint("right-down"):this.targetBottom<this.popoverTop&&(e=this.getSpecialPoint("right-up")):this.targetRight<this.popoverLeft&&(this.targetTop>this.popoverBottom?e=this.getSpecialPoint("left-down"):this.targetBottom<this.popoverTop&&(e=this.getSpecialPoint("left-up"))),this.setArrowParameters(e.rotation,e.x,e.y)}}convertAbsoluteValuesToRelativeValues(e,t,o){return{rotation:e=this.arrowRotation0-e,x:t=ki(t-this.popoverRect.left)+this.arrowX0,y:o=ki(o-this.popoverRect.top)+this.arrowY0}}setArrowParameters(e,t,o){const i=this.convertAbsoluteValuesToRelativeValues(e,t,o);this.arrowPositionX=i.x,this.arrowPositionY=i.y,this.arrowRotation=i.rotation}getSpecialPoint(e){return{"left-up":new Ci([this.popoverLeft,this.rangeCorrectedPopoverTop],180),"left-down":new Ci([this.popoverLeft,this.rangeCorrectedPopoverBottom],180),"right-up":new Ci([this.popoverRight,this.rangeCorrectedPopoverTop],0),"right-down":new Ci([this.popoverRight,this.rangeCorrectedPopoverBottom],0)}[e]}getIntersectionExtremes(e,t,o,i){const r=[];for(let s=e;s<=t;s++)s>=o&&s<=i&&r.push(s);return r}}class zi extends(_i(se)){static get properties(){return{label:{type:String,reflect:!0},target:{type:String,reflect:!0},visible:{type:Boolean,reflect:!0},sticky:{type:Boolean,reflect:!0},subMenu:{type:Boolean,reflect:!0,attribute:"sub-menu"},position:{type:String,reflect:!0},type:{type:String,reflect:!0},passive:{type:Boolean,reflect:!0},mobile:{type:Boolean,reflect:!0},scrollAction:{type:String,reflect:!0,attribute:"scroll-action"},blurBackground:{type:Boolean,reflect:!0,attribute:"blur-background"},manualControlled:{type:Boolean,reflect:!0,attribute:"manual-controlled"},_emptyFunction:{type:Boolean},_emptyFooter:{type:Boolean},customPlacementLogic:{type:Object,reflect:!0,attribute:"custom-placement-logic"},suppressPlacementWarning:{type:Boolean,reflect:!0,attribute:"suppress-placement-warning"},alwaysStayWithin:{type:Boolean,reflect:!0,attribute:"always-stay-within"},_targetEl:{type:Object},viewport:{type:Object,reflect:!0},viewportPadding:{type:Number,reflect:!0,attribute:"viewport-padding"},overlayTargetDistance:{type:Number,reflect:!0,attribute:"overlay-target-distance"},trackTargetOn:{type:String,reflect:!0,attribute:"track-target-on"},_arrowX:{type:Number},_arrowY:{type:Number},_arrowRotation:{type:Number}}}static get styles(){return[ae,ie`
        :host {
          font: var(--body-1);
          color: var(--text-primary);
          display: block;
          position: fixed;
          opacity: 0;
          visibility: hidden;
          background-color: var(--base-4);
          min-width: 12.5rem;
          width: 15.5rem;
          min-height: auto;
          min-height: -ms-fit-content;
          min-height: -moz-fit-content;
          box-sizing: border-box;
          border-radius: 0.125rem;
          margin-top: 0rem !important;
          box-shadow: var(--shadow-overlay);
          transition: var(--transition-time) all ease-in-out, 0s top, 0s left, 0s width,
            0s min-width;
          -webkit-font-smoothing: antialiased;
          text-rendering: optimizeLegibility;
          -moz-osx-font-smoothing: grayscale;
          padding: 1rem;
          z-index: 999;
          pointer-events: none;
          overflow-wrap: break-word;
        }
        :host(:not([mobile])[blur-background]) {
          background-color: rgba(var(--blur-background-1), var(--opacity-3));
          backdrop-filter: blur(var(--blur-1));
          -webkit-backdrop-filter: blur(var(--blur-1));
        }
        :host([label]) {
          padding-top: 1rem;
        }

        :host(:not([mobile])) .popover-wrapper {
          position: relative;
          height: 100%;
          display: flex;
          flex-direction: column;
        }
        :host(:not([passive])) .arrow {
          display: none;
        }
        :host([passive]) .arrow {
          position: absolute;
          border-width: 0.375rem;
          border-style: solid;
          border-color: transparent transparent var(--base-4) transparent;
          border-bottom-width: 0.5rem;
          transform-origin: 0.375rem 0.875rem;
        }
        :host(:not([mobile])[passive][blur-background]) .arrow {
          border-color: transparent transparent rgba(var(--blur-background-1), var(--opacity-3))
            transparent;
        }
        @-moz-document url-prefix() {
          :host(:not([mobile])[blur-background]) {
            background-color: rgba(var(--blur-background-1), var(--opacity-2));
          }
          :host(:not([mobile])[passive][blur-background]) .arrow {
            border-color: transparent transparent rgba(var(--blur-background-1), var(--opacity-2))
              transparent;
          }
        }
        .header-wrapper {
          display: flex;
          margin-bottom: 1rem;
        }
        .footer-wrapper {
          display: flex;
          justify-content: flex-end;
          margin-top: 1rem;
        }
        .header-wrapper > ::slotted(*),
        .footer-wrapper > ::slotted(*) {
          margin-left: 0.5rem;
        }
        :host(:not([label])) .header-wrapper {
          display: none;
        }
        .popover-label {
          font: var(--header-2);
          color: var(--text-primary);
          display: block;
          line-height: 1.5rem;
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        :host([visible]) {
          visibility: visible;
          opacity: 1;
          pointer-events: all;
        }
        :host([sub-menu]) {
          transform: translateY(-0.5rem);
        }
        .header-wrapper sh-icon {
          margin-right: 0.5rem;
        }
        :host([mobile]) {
          position: fixed;
          top: 0rem !important;
          left: 0rem !important;
          height: 100%;
          background: rgba(0, 0, 0, var(--opacity-4));
          z-index: 999;
          width: 100vw;
          padding: 0;
          transition: var(--transition-time) all ease-in-out,
            0s height ease-in-out var(--transition-time),
            0s max-height ease-in-out var(--transition-time);
        }
        :host([mobile]) .popover-wrapper {
          position: absolute;
          width: calc(100vw - 2rem);
          padding: 1rem;
          background: var(--base-4);
          bottom: 0rem;
          max-height: calc(100% - 6.5rem);
          overflow: auto;
        }
        /* slot styles */
        :host(:not([label]):not([type])) .popover-wrapper[empty-function] .header-wrapper,
        .popover-wrapper[empty-footer] .footer-wrapper {
          display: none;
        }
        slot:not([name]) {
          flex: 1;
          line-height: 1.25rem;
        }
      `]}render(){return V`
      <div
        class="popover-wrapper"
        ?empty-function="${this._emptyFunction}"
        ?empty-footer="${this._emptyFooter}"
      >
        <div class="header-wrapper">
          ${"error"===this.type?V` <sh-icon icon="error" size="s"></sh-icon>`:""}
          ${"alert"===this.type||"warning"===this.type?V` <sh-icon icon="warning" size="s"></sh-icon>`:""}
          ${"confirmation"===this.type||"success"===this.type?V` <sh-icon icon="success" size="s"></sh-icon>`:""}
          ${this.label||""===this.label?V` <div class="popover-label">${this.label}</div>`:""}
          <slot
            name="functions"
            @slotchange="${e=>this._updateSlotFlag(e.target,"_emptyFunction")}"
          ></slot>
        </div>
        <slot></slot>
        <div class="footer-wrapper">
          <slot
            name="footer"
            id="footer"
            @slotchange="${e=>this._updateSlotFlag(e.target,"_emptyFooter")}"
          ></slot>
        </div>
      </div>
      <div class="arrow" style="${He(this._getArrowDimensions())}"></div>
    `}constructor(){super(),this._emptyFooter=!0,this._emptyFunction=!0,this.position="top",this.scrollAction="refit",this.overlayTargetDistance=.5,this.viewportPadding=.5,this.viewport=document.body}_updateSlotFlag(e,t){const o=e.assignedNodes({flatten:!0}).length;this[t]=0===o}connectedCallback(){super.connectedCallback(),this.documentClickListener=this.documentClickActions.bind(this),this.documentKeydownListener=this.documentKeyDownEventActions.bind(this),this._subMenuTargetMouseOverListener=this.show.bind(this),this._subMenuTargetMouseOutListener=this.hide.bind(this),this._mouseOverListener=this._mouseOverActions.bind(this),this._mouseOutListener=this._mouseOutActions.bind(this),this.manualControlled||document.body.addEventListener("click",this.documentClickListener),"hide"!==this.scrollAction||this.manualControlled||document.body.addEventListener("keydown",this.documentKeydownListener),this.manualControlled||(this.onkeyup=e=>{e.keyCode!==me.SPACE&&e.keyCode!==me.ENTER&&e.keyCode!==me.ESCAPE||!this.visible||this.sticky||this.hide()}),this.mobile||(this.resizeListener=this.handleMobile.bind(this),this.resizeListener()),window.addEventListener("resize",this.resizeListener)}updated(e){super.updated(e),e.has("target")&&(this._invokerNode=this._targetEl,this._attachNode=this._targetEl),(e.has("position")||e.has("passive"))&&this._canPositionOverlay()&&this._setOverlayPlacement(this._targetEl),e.has("visible")&&this.visible&&this.manualControlled&&(this._invokerNode=this._targetEl,this._attachNode=this._targetEl),he(this,e,["label","target","visible","sticky","subMenu","position","type","passive","mobile"])}handleMobile(){this.mobile=document.documentElement.clientWidth<640}documentClickActions(e){let t=this._targetEl;-1===e.composedPath().indexOf(t)?!this.sticky&&this.visible&&this.hide():this.visible?this.hide():this.show()}get _targetEl(){const e=this.target;if(e){if("string"==typeof e)return this.parentElement&&this.parentElement.querySelector(`[id="${e}"]`)||document.getElementById(e);if(e instanceof HTMLElement)return e;throw new Error('\n\nThe "target" property is not of valid type.\nThe "target" property can take string value corresponding to the id of the target.\nIt can also have its value equal to a DOM Node reference (instance of HTMLElement)\n')}}documentKeyDownEventActions(e){"hide"!==this.scrollAction||this.sticky||e.keyCode!==me.ARROW_UP&&e.keyCode!==me.ARROW_DOWN&&e.keyCode!==me.SPACE||this.hide()}_mouseOverActions(){const e=this._targetEl.parentElement;e.subMenu&&e.show(),this.show()}_mouseOutActions(){const e=this._targetEl.parentElement;e.subMenu&&e.hide(),this.hide()}_addHoverEvents(e){e.addEventListener("mouseover",this._subMenuTargetMouseOverListener),e.addEventListener("mouseout",this._subMenuTargetMouseOutListener),this.addEventListener("mouseover",this._mouseOverListener),this.addEventListener("mouseout",this._mouseOutListener)}_removeHoverEvents(e){e.removeEventListener("mouseover",this._subMenuTargetMouseOverListener),e.removeEventListener("mouseout",this._subMenuTargetMouseOutListener),this.removeEventListener("mouseover",this._mouseOverListener),this.removeEventListener("mouseout",this._mouseOutListener)}show(){this._invokerNode=this._targetEl,this._attachNode=this._targetEl,this.visible=!0}hide(){this.visible=!1,le(this,"overlay-closed")}disconnectedCallback(){window.cancelAnimationFrame(this.scrollHandler),document.body.removeEventListener("click",this.documentClickListener),document.body.removeEventListener("keydown",this.documentKeydownListener),window.removeEventListener("resize",this.resizeListener),super.disconnectedCallback()}_setOverlayPlacement(e){if(this.customPlacementLogic)this.customPlacementLogic();else{const t="SH-WORKLINE-ITEM"===e.tagName,o=this.passive?this.viewportPadding>=1?this.viewportPadding:1:this.viewportPadding,i=this.passive?this.overlayTargetDistance>=1?this.overlayTargetDistance:1:this.overlayTargetDistance;let r={top:[{from:"top",to:"top-diag-left",increment:"overlayRight",incrementBy:-1},{from:"top",to:"top-diag-right",increment:"overlayLeft",incrementBy:1}]};const s=t?e.closest("sh-workline").shadowRoot.querySelector(".workline-wrapper"):this.viewport,n=this.viewport.getBoundingClientRect(),a=JSON.parse(JSON.stringify(n));a.left=s.getBoundingClientRect().left,a.width=s.getBoundingClientRect().width,a.right=s.getBoundingClientRect().right;const c=t?r:null,l=!!t||this.suppressPlacementWarning,h=!!t||this.alwaysStayWithin,d=Re(this.position,this.getBoundingClientRect(),e.getBoundingClientRect(),a,i,o,c,c,l);d.targetIsOutsideViewport&&!h?(this.visible=!1,l||console.warn("Since the effective target is outside the effective viewport, the popover is hidden"),le(this,"overlay-closed")):(this.style.left=d.requiredLeft+"px",this.style.top=d.requiredTop+"px")}if(this.passive){const t=new Ei(e,this);this._arrowX=t.arrowPositionX,this._arrowY=t.arrowPositionY,this._arrowRotation=t.arrowRotation}}_canPositionOverlay(){return this.position&&this.visible&&!this.mobile&&this._targetEl}_doSomethingWithOldInvokerNode(e){this.manualControlled||this._removeHoverEvents(e)}_doSomethingWithNewInvokerNode(e){this.subMenu&&!this.manualControlled&&this._addHoverEvents(e)}_getArrowDimensions(){return{left:`${this._arrowX}rem`,top:`${this._arrowY}rem`,transform:`rotate(${this._arrowRotation}deg)`}}}customElements.define("sh-popover",zi),customElements.define("sh-progress-radial",class extends se{static get properties(){return{header:{type:String,reflect:!0},label:{type:String,reflect:!0},info:{type:String,reflect:!0},color:{type:String,reflect:!0},size:{type:String,reflect:!0},value:{type:Number,reflect:!0},indeterminate:{type:Boolean,reflect:!0}}}static get styles(){return[ae,ie``]}render(){return V`
      <sh-progress
        radial
        .header="${this.header}"
        .label="${this.label}"
        .info="${this.info}"
        .color="${this.color}"
        .size="${this.size}"
        .value="${this.value}"
        .indeterminate="${this.indeterminate}"
      ></sh-progress>
    `}updated(e){he(this,e,["header","label","info","color","size","value"])}constructor(){super(),this.value=0,this.size="m"}connectedCallback(){super.connectedCallback(),this.hasAttribute("role")||this.setAttribute("role","progressbar")}});var Ai=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-progress-header-line-height=1.25rem] - line-height of header
   */
  --sh-progress-header-line-height: 1.25rem;
  /* 
   * @cssprop [--sh-progress-progress-bar-height=0.5rem] - height of the progress bar
   */
  --sh-progress-progress-bar-height: 0.5rem;
  /* 
   * @cssprop [--sh-progress-indeterminate-bar-length=7.5rem] - the length of the inner bar of the indeterminate progress bar
   */
  --sh-progress-indeterminate-bar-length: 7.5rem;
  /* 
   * @cssprop [--sh-progress-info-line-height=1rem] - line height of info text
   */
  --sh-progress-info-line-height: 1rem;
  /* 
   * @cssprop [--sh-progress-header-margin-bottom=0.5rem] - margin bottom of header
   */
  --sh-progress-header-margin-bottom: 0.5rem;
  /* 
   * @cssprop [--sh-progress-footer-margin-top=0.5rem] - margin-top of footer of linear-progress (the radial-progress footer has same margin-top as radial-progress header margin-bottom)
   */
  --sh-progress-footer-margin-top: 0.5rem;
  /* 
   * @cssprop [--sh-progress-footer-height=1rem] - the height of the footer of linear-progress
   */
  --sh-progress-footer-height: 1rem;
  /* 
   * @cssprop [--sh-progress-radial-header-margin-bottom=var(--sh-progress-header-margin-bottom)] - margin-bottom of header for radial progress
   */
  --sh-progress-radial-header-margin-bottom: var(--sh-progress-header-margin-bottom);
  /* 
   * @cssprop [--sh-progress-radial-progress-height-xs=1rem] - height of radial progress of size xs
   */
  --sh-progress-radial-progress-height-xs: 1rem;
  /* 
   * @cssprop [--sh-progress-radial-progress-ring-width-xs=0.25rem] - ring width of radial progress of size xs
   */
  --sh-progress-radial-progress-ring-width-xs: 0.25rem;
  /* 
   * @cssprop [--sh-progress-radial-progress-height-s=2rem] - height of radial progress of size s
   */
  --sh-progress-radial-progress-height-s: 2rem;
  /* 
   * @cssprop [--sh-progress-radial-progress-ring-width-s=0.375rem] - ring width of radial progress of size s
   */
  --sh-progress-radial-progress-ring-width-s: 0.375rem;
  /* 
   * @cssprop [--sh-progress-radial-progress-height-m=4rem] - height of radial progress of size m
   */
  --sh-progress-radial-progress-height-m: 4rem;
  /* 
   * @cssprop [--sh-progress-radial-progress-ring-width-m=0.5rem] - ring width of radial progress of size m
   */
  --sh-progress-radial-progress-ring-width-m: 0.5rem;
  /* 
   * @cssprop [--sh-progress-radial-progress-height-l=8rem] - height of radial progress of size l
   */
  --sh-progress-radial-progress-height-l: 8rem;
  /* 
   * @cssprop [--sh-progress-radial-progress-ring-width-l=0.625rem] - ring width of radial progress of size l
   */
  --sh-progress-radial-progress-ring-width-l: 0.625rem;
  /* 
   * @cssprop [--sh-progress-radial-progress-height-xl=16rem] - height of radial progress of size xl
   */
  --sh-progress-radial-progress-height-xl: 16rem;
  /* 
   * @cssprop [--sh-progress-radial-progress-ring-width-xl=0.75rem] - ring width of radial progress of size xl
   */
  --sh-progress-radial-progress-ring-width-xl: 0.75rem;
  /* 
   * @cssprop [--sh-progress-radial-progress-label-width-m=2.5rem] - width of the radial progress label when progress size is m
   */
  --sh-progress-radial-progress-label-width-m: 2.5rem;
  /* 
   * @cssprop [--sh-progress-radial-progress-label-width-l=5.5rem] - width of the radial progress label when progress size is l
   */
  --sh-progress-radial-progress-label-width-l: 5.5rem;
  /* 
   * @cssprop [--sh-progress-radial-progress-label-width-xl=10.25rem] - width of the radial progress label when progress size is xl
   */
  --sh-progress-radial-progress-label-width-xl: 10.25rem;
}

:host {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.header-wrapper,
.footer {
  display: flex;
  align-items: center;
}

.info {
  line-height: var(--sh-progress-info-line-height);
}

:host(:not([radial])) .header,
:host(:not([radial])) .info {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header,
.label {
  line-height: var(--sh-progress-header-line-height);
}

.label {
  width: auto;
}

.header + .label {
  margin-left: 0.5rem;
}

:host(:not([header])) .label {
  flex: 1;
  text-align: center;
}

.footer {
  width: 100%;
}

:host(:not([radial])) .header-wrapper {
  margin-bottom: var(--sh-progress-header-margin-bottom);
}

:host(:not([radial])) .footer {
  margin-top: var(--sh-progress-footer-margin-top);
  height: fit-content;
}

:host(:not([radial])) .footer:not(.has-function-icons) {
  margin-top: var(--sh-progress-header-margin-bottom);
}

.linear-progress {
  width: 100%;
  height: var(--sh-progress-progress-bar-height);
  border-radius: calc(var(--sh-progress-progress-bar-height) / 2);
  overflow: hidden;
  position: relative;
  max-width: 100%;
}

.linear-progress:not(.indeterminate) {
  background: linear-gradient(to right, var(--progress-color) var(--progress-value), rgba(var(--ui-1), var(--opacity-6)) 0%);
}

/* radial */
:host([radial]) {
  align-items: center;
  justify-content: center;
}

:host([radial]) .info,
:host([radial]) .header {
  text-align: center;
}

:host([radial]) .header-wrapper {
  margin-bottom: var(--sh-progress-radial-header-margin-bottom);
}

:host([radial]) .footer {
  margin-top: var(--sh-progress-radial-header-margin-bottom);
}

.radial-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: absolute;
  width: 100%;
  text-align: center;
}

:host([size=xs]) .radial-wrapper {
  --radial-height: var(--sh-progress-radial-progress-height-xs);
  --ring-width: var(--sh-progress-radial-progress-ring-width-xs);
}

:host([size=s]) .radial-wrapper {
  --radial-height: var(--sh-progress-radial-progress-height-s);
  --ring-width: var(--sh-progress-radial-progress-ring-width-s);
}

:host([size=m]) .radial-wrapper {
  --radial-height: var(--sh-progress-radial-progress-height-m);
  --ring-width: var(--sh-progress-radial-progress-ring-width-m);
}

:host([size=l]) .radial-wrapper {
  --radial-height: var(--sh-progress-radial-progress-height-l);
  --ring-width: var(--sh-progress-radial-progress-ring-width-l);
}

:host([size=xl]) .radial-wrapper {
  --radial-height: var(--sh-progress-radial-progress-height-xl);
  --ring-width: var(--sh-progress-radial-progress-ring-width-xl);
}

.radial-wrapper {
  height: var(--radial-height);
  width: var(--radial-height);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border-radius: 50%;
  box-shadow: inset 0 0 0 var(--ring-width) rgba(var(--ui-1), var(--opacity-6));
}

.radial-wrapper::before {
  position: absolute;
  content: "";
  width: calc(var(--radial-height) / 2 - var(--ring-width) / 2);
  z-index: -1;
  visibility: hidden;
  opacity: 0;
  left: 0;
  top: 0;
}

.radial-progress {
  width: 100%;
  height: 100%;
  position: relative;
  transform-origin: 50% 50%;
  transform: rotate(-90deg);
}

.radial-wrapper.hundred-value {
  box-shadow: inset 0 0 0 var(--ring-width) var(--progress-color);
}

.radial-progress-indicator {
  r: calc(var(--radial-height) / 2 - var(--ring-width) / 2);
  cx: calc(var(--radial-height) / 2);
  cy: calc(var(--radial-height) / 2);
  stroke-width: calc(var(--ring-width));
  fill: transparent;
  stroke: var(--progress-color);
  stroke-dasharray: calc(var(--progress-value) / 100 * var(--circle-circumference)) calc((100 - var(--progress-value)) / 100 * var(--circle-circumference));
}

.radial-wrapper.indeterminate .radial-progress {
  animation: radial-indeterminate 2s linear infinite;
  transform-origin: 50% 50%;
}

:host([radial][size=m]) .radial-label {
  width: var(--sh-progress-radial-progress-label-width-m);
}

:host([radial][size=l]) .radial-label {
  width: var(--sh-progress-radial-progress-label-width-l);
  font-size: calc(var(--font-size-title-1) * 2);
  line-height: calc(var(--sh-text-title1-line-height) * 2);
}

:host([radial][size=xl]) .radial-label {
  width: var(--sh-progress-radial-progress-label-width-xl);
  font-size: calc(var(--font-size-title-1) * 4);
  line-height: calc(var(--sh-text-title1-line-height) * 4);
}

/* status */
.status-icon {
  margin-right: 0.5rem;
}

.status-icon[icon=cancel] {
  color: rgb(var(--functional-red));
}

.status-icon[icon=error] {
  color: rgb(var(--functional-yellow));
}

.status-icon[icon=check_circle] {
  color: rgb(var(--functional-green));
}

/* functions slot */
slot[name=functions]::slotted(*) {
  margin-left: 0.5rem;
}

/* indeterminate */
.linear-progress.indeterminate {
  background: rgba(var(--ui-1), var(--opacity-6));
}

.indeterminate-bar {
  width: var(--sh-progress-indeterminate-bar-length);
  background: var(--progress-color);
  animation: indeterminate 2s linear infinite;
  position: absolute;
  height: 100%;
}

@keyframes indeterminate {
  from {
    left: calc(0rem - var(--sh-progress-indeterminate-bar-length));
  }
  to {
    left: 100%;
  }
}
@keyframes radial-indeterminate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`;customElements.define("sh-progress",class extends se{static get properties(){return{header:{type:String,reflect:!0},label:{type:String,reflect:!0},info:{type:String,reflect:!0},status:{type:String,reflect:!0},color:{type:String,reflect:!0},size:{type:String,reflect:!0},value:{type:Number,reflect:!0},indeterminate:{type:Boolean,reflect:!0},paused:{type:Boolean,reflect:!0},radial:{type:Boolean,reflect:!0},type:{type:String,reflect:!0},_circleCircumference:{type:Number},_hasFunctionIcons:{type:Boolean}}}static get styles(){return[Ai,ae]}render(){return V`
      <!-- header -->
      ${(this.header||this.label)&&"xs"!==this.size?V`
            <div class="header-wrapper">
              ${this.header&&"xs"!==this.size?V` <sh-text size="header-2" class="header">${this.header}</sh-text> `:""}
              ${this.label&&!this.radial?V` <sh-text size="title-1" class="label">${this.label}</sh-text> `:""}
            </div>
          `:""}
      ${this.radial?V`
            <!-- radial -->
            <div
              class="radial-wrapper ${this.indeterminate?"indeterminate":""} ${this.value>=100?"hundred-value":""}"
              style="
                --progress-color: ${this.color?this.color:"rgb(var(--ui-2))"};
                --progress-value: ${this.indeterminate?25:this.value<=0?0:this.value};
                --circle-circumference : ${this._circleCircumference}"
            >
              ${this.value>0&&this.value<100?H`
              <svg class="radial-progress">
                <circle class="radial-progress-indicator" />
              </svg>
              `:""}
              ${this.label&&"s"!==this.size&&"xs"!==this.size?V` <sh-text size="title-1" class="radial-label">${this.label}</sh-text> `:""}
            </div>
          `:V`
            <!-- linear -->
            <div
              class="linear-progress ${this.indeterminate?"indeterminate":""}"
              style="
                --progress-color: ${this.paused?"rgba(var(--ui-1), var(--opacity-3))":this.color?this.color:"rgb(var(--ui-2))"};
                  --progress-value: ${this.value}%;"
            >
              ${this.indeterminate?V`<div class="indeterminate-bar"></div>`:""}
            </div>
          `}
      ${(this.info||this.status)&&"xs"!==this.size?V`
            <div class="footer${this._hasFunctionIcons?" has-function-icons":""}">
              <!-- status -->
              ${this.status&&!this.radial?V` <sh-icon size="xs" class="status-icon" icon="${this.status}"></sh-icon> `:""}
              <!-- info -->
              ${this.info&&"xs"!==this.size?V`
                    <sh-text size="body-1" color="secondary" class="info">${this.info}</sh-text>
                  `:""}
              ${this.radial?"":V`<slot
                    name="functions"
                    @slotchange="${e=>{this._hasFunctionIcons=e.target.assignedElements({flatten:!0}).length}}"
                  ></slot>`}
            </div>
          `:""}
    `}attributeChangedCallback(e,t,o){super.attributeChangedCallback(e,t,o),"type"===e&&this.type&&(this.status=this.type,console.warn("You are using a legacy property ('type') of sh-progress component. Please use the new 'status' property instead."))}constructor(){super(),this.value=0,this.size="m",this.radial=!1}updated(e){super.updated(e),he(this,e,["header","label","info","status","color","size","value","indeterminate","paused","radial","type"]),!this._resizeObserver&&this.radial&&(this._resizeObserver=new ResizeObserver((e=>{this.radial?this._circleCircumference=2*parseFloat(getComputedStyle(e[0].target,":before").width)*Math.PI+"px":(this._resizeObserver.disconnect(),this._resizeObserver=null)})),this._resizeObserver.observe(this.shadowRoot.querySelector(".radial-wrapper")))}connectedCallback(){super.connectedCallback(),this.hasAttribute("role")||this.setAttribute("role","progressbar")}disconnectedCallback(){this._resizeObserver&&this._resizeObserver.disconnect(),super.disconnectedCallback()}});var Si=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-radio-button-container-margin=0] - margin of the container(XL)
   */
  --sh-radio-button-container-margin: 0;
  /* 
   * @cssprop [--sh-radio-button-label-line-height=1.25rem] - line height of the label
   */
  --sh-radio-button-label-line-height: 1.25rem;
  /* 
   * @cssprop [--sh-radio-button-label-padding=0.25rem] - left padding of the label
   */
  --sh-radio-button-label-padding: 0.25rem;
  /* 
   * @cssprop [--sh-radio-button-label-margin=0.375rem 0] - top and bottom margins of the label
   */
  --sh-radio-button-label-margin: 0.375rem 0;
  /* 
   * @cssprop [--sh-radio-button-width=2rem] - width of the radio-button
   */
  --sh-radio-button-width: 2rem;
  /* 
   * @cssprop [--sh-radio-button-height=2rem] - height of radio-button
   */
  --sh-radio-button-height: 2rem;
  /* 
   * @cssprop [--sh-radio-button-pseudo-width=1rem] - width of the pseudo radio-button
   */
  --sh-radio-button-pseudo-width: 1rem;
  /* 
   * @cssprop [--sh-radio-button-pseudo-height=1rem] - height of the pseudo radio-button
   */
  --sh-radio-button-pseudo-height: 1rem;
  /* 
   * @cssprop [--sh-radio-button-pseudo-margin=0.5rem] - margin of the pseudo radio-button
   */
  --sh-radio-button-pseudo-margin: 0.5rem;
  /* 
   * @cssprop [--sh-radio-button-pseudo-border-width=0.125rem] - border-width of the pseudo radio-button
   */
  --sh-radio-button-pseudo-border-width: 0.125rem;
  /* 
   * @cssprop [--sh-radio-button-pseudo-border-width-active=0.3125rem] - border-width of the pseudo radio-button when active
   */
  --sh-radio-button-pseudo-border-width-active: 0.3125rem;
}

:host {
  outline: none;
  display: flex;
  flex-direction: row;
  width: 100%;
  position: relative;
  font: var(--body-1);
  color: var(--text-primary);
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
}

:host([disabled]) {
  pointer-events: none;
  color: var(--text-disabled) !important;
}

:host(:not([disabled])) * {
  cursor: pointer;
}

:host .radio-container {
  display: flex;
  align-items: center;
  height: fit-content;
  width: 100%;
  position: relative;
  margin: var(--sh-radio-button-container-margin);
}

:host .radioBtn {
  opacity: 0;
  position: absolute;
  margin: 0;
  width: var(--sh-radio-button-width);
  height: var(--sh-radio-button-height);
  align-self: flex-start;
}

:host .pseudo-radio {
  border-radius: 50%;
  border-width: var(--sh-radio-button-pseudo-border-width);
  border-style: solid;
  border-color: rgba(var(--ui-1), var(--opacity-4));
  transition: var(--transition-time) all ease-in-out, var(--hover-transition-time) border-color;
  margin: var(--sh-radio-button-pseudo-margin);
  box-sizing: border-box;
  height: var(--sh-radio-button-pseudo-height);
  width: var(--sh-radio-button-pseudo-width);
  align-self: flex-start;
}

:host label {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  padding-left: var(--sh-radio-button-label-padding);
  margin: var(--sh-radio-button-label-margin);
  flex: 1;
  font: var(--body-1);
  line-height: var(--sh-radio-button-label-line-height);
  text-overflow: ellipsis;
  overflow: hidden;
}

/* Component State Styles */
:host([active]) .pseudo-radio {
  background: transparent;
  height: var(--sh-radio-button-pseudo-height);
  width: var(--sh-radio-button-pseudo-width);
  border-width: var(--sh-radio-button-pseudo-border-width-active) !important;
  box-sizing: border-box;
  border-style: solid;
  transition: var(--transition-time) all ease-in-out, var(--hover-transition-time) border-color;
  border-color: rgba(var(--ui-2), var(--opacity-1));
}

/* Neutral */
:host([neutral][active]:not([disabled])) .pseudo-radio {
  border-color: rgba(var(--ui-1), var(--opacity-3));
}

:host([disabled]) .pseudo-radio,
:host([neutral][disabled][active]) .pseudo-radio {
  border-color: rgba(var(--ui-1), var(--opacity-5));
}

:host([disabled][active]:not([neutral])) .pseudo-radio {
  border-color: rgba(var(--ui-2), var(--opacity-5));
}

/* hover */
:host(:hover:not(.no-hovermq)) .pseudo-radio {
  border-color: rgba(var(--ui-1), var(--opacity-3));
}

:host([active]:hover:not(.no-hovermq)) .pseudo-radio {
  border-color: rgba(var(--ui-3), var(--opacity-1));
}

:host([neutral][active]:hover:not(.no-hovermq)) .pseudo-radio {
  border-color: rgba(var(--ui-1), var(--opacity-2));
}

.focus {
  outline: var(--focus-outline);
}`;customElements.define("sh-radio-button",class extends se{static get properties(){return{label:{type:String,reflect:!0},active:{type:Boolean,reflect:!0},disabled:{type:Boolean,reflect:!0},neutral:{type:Boolean,reflect:!0},role:{type:String,reflect:!0}}}static get styles(){return[be(),Si]}render(){return V`
      <div class="radio-container">
        <input
          class="radioBtn"
          type="radio"
          name="${this.label?this.label:""}"
          ?checked="${this.active}"
          ?active="${this.active}"
          tabindex="-1"
        />
        <span class="pseudo-radio"></span>
        ${this.label?V` <label>${this.label}</label>`:""}
      </div>
    `}constructor(){super(),this.label="label"}attributeChangedCallback(e,t,o){super.attributeChangedCallback(e,t,o);const i=null!==o;"active"===e&&this.setAttribute("aria-checked",i)}connectedCallback(){super.connectedCallback(),Modernizr.hovermq||this.classList.add("no-hovermq"),this.hasAttribute("role")||this.setAttribute("role","radio")}updated(e){e.has("active")&&this.dispatchEvent(new Event("active-changed")),this.active?this.setAttribute("tabindex","0"):this.setAttribute("tabindex","-1")}firstUpdated(){this.addEventListener("click",(function(){this.handleActive()})),this.addEventListener("focus",(function(){this.handleFocus()})),this.addEventListener("blur",(function(){this.handleBlur()}))}handleFocus(){const e=this.shadowRoot.querySelector(".pseudo-radio");this.disabled||(this.onkeyup=function(t){t.keyCode===me.TAB&&e.classList.add("focus")},this.onkeydown=function(e){let t,o=this.parentElement.querySelectorAll("SH-RADIO-BUTTON:not([disabled])");if(e.keyCode===me.ARROW_RIGHT||e.keyCode===me.ARROW_DOWN){let i=Array.from(o).indexOf(this);t=i===o.length-1?o[0]:o[i+1],this.handleArrowInput(e,[me.ARROW_RIGHT,me.ARROW_DOWN],t)}else if(e.keyCode===me.ARROW_LEFT||e.keyCode===me.ARROW_UP){let i=Array.from(o).indexOf(this);t=0===i?o[o.length-1]:o[i-1],this.handleArrowInput(e,[me.ARROW_LEFT,me.ARROW_UP],t)}})}handleArrowInput(e,t,o){t.includes(e.keyCode)&&o&&(e.preventDefault(),this.active=!1,o.active=!0,o.focus())}handleBlur(){this.shadowRoot.querySelector(".pseudo-radio").classList.remove("focus")}handleActive(){this.active=!0,this.dispatchEvent(new CustomEvent("clicked",{bubbles:!0,detail:this}))}});var Mi=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-radio-group-margin=0] - margin for the radio-button
   */
  --sh-radio-group-margin: 0;
}

:host {
  width: 100%;
  outline: 0;
  display: block;
}

.radio-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}

#grouped {
  flex: 1;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.radio-wrapper > ::slotted(*) {
  margin-top: var(--sh-radio-group-margin);
}

.radio-wrapper > ::slotted(:first-child) {
  margin-top: 0;
}`;customElements.define("sh-radio-group",class extends se{static get properties(){return{role:{type:String,reflect:!0}}}static get styles(){return[Mi]}render(){return V` <div class="radio-wrapper">
      <slot id="grouped"></slot>
    </div>`}connectedCallback(){super.connectedCallback(),this.hasAttribute("role")||this.setAttribute("role","radiogroup")}firstUpdated(){this.addEventListener("click",(function(e){this.handleClick(e)}))}handleClick(e){const t=e.target;if(!t.disabled&&"SH-RADIO-GROUP"!==t.tagName&&"SH-RADIO-BUTTON"===t.tagName){const e=this.querySelectorAll("[active]");for(let t=0;t<e.length;t++)e[t].active=!1;t.active=!0}}}),customElements.define("sh-risk-score",class extends se{static get properties(){return{label:{type:String,reflect:!0},value:{type:String,reflect:!0},segments:{type:Number,reflect:!0},size:{type:String,reflect:!0},segmentValue:{type:Array,reflect:!0,attribute:"segment-value"},segmentColor:{type:Array,reflect:!0,attribute:"segment-color"},radial:{type:Boolean,reflect:!0},disabled:{type:Boolean,reflect:!0},_currentAngle:{type:Number,reflect:!1},_emptyFooter:{type:Boolean,reflect:!0,attribute:"empty-footer"}}}static get styles(){return[ae,ie`
        :host {
            width: 100%;
            display: block;
        }
        .linear-wrapper{
            display: flex;
            height: 0.25rem;
            margin-bottom: 0.5rem;
            width: 100%;
            min-width: 7rem;
        }
        .footer-wrapper {
            display: flex;
            align-items: center;
            margin: 0rem 0rem 0.5rem 0rem;
          }
        .riskbar {
            margin-left: 0.25rem;
            width: 100%;
            background-color: rgba(var(--ui-1), var(--opacity-5));
            overflow: hidden;
            position: relative;
        }
        .value {
            margin-left: 0.25rem;
        } 
        .riskbar:first-child {
          margin-left: 0rem;
        }
        .header-wrapper {
          display: flex;
          align-items: center;
          margin-bottom: 0.75rem;
        }
        :host(:not([radial])) .label {    
          flex: 1;
          width: auto;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .label,
        .value {
          line-height: 1.25rem;
        }
        .value {         
          width: auto;
          text-align: right;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        :host([disabled]) .value {
          color: var(--text-disabled);
        }
        :host([disabled]) .riskbar ,
        :host([disabled]) .bar-value {
          background-color: rgba(var(--ui-1), var(--opacity-6));
        }
        :host([disabled]) .radial-segment , 
        :host([disabled]) .radial-background {
          stroke: rgba(var(--ui-1), var(--opacity-6));
        }
        .label + .value {
          margin-left: 0.5rem;
        }
        :host(:not([label])) .value {
          flex: 1;
          text-align: center;
        } 
        .bar-value {
          height: 0.25rem;
          position:absolute;
          max-width: 100%;
        }
        .footer {
          height: fit-content;
        }
        :host([empty-footer]) .footer-wrapper {
          display: none;
        }

        /*radial*/ 
        :host([radial]) {
          text-align: center;    
          width: 12rem; 
        }
        :host([radial]) .label {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        :host([disabled][radial]) .radial-label {
          color: var(--text-disabled);
        }
        .radial-wrapper {
          margin-bottom: 0.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }
        .radial {
          transform: rotate(-90deg);
          overflow: visible;
        }
        .radial-label {
          position: absolute;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          word-break: break-all;
          -webkit-box-orient: vertical;
          max-height: 4rem;
          width: 2.5rem;
        }
        :host([size='s']) .radial-background ,
        :host([size='s']) .radial-segment {
          stroke-width: 0.25rem;
        }
        :host([size='l']) .radial-background ,
        :host([size='l']) .radial-segment {
          stroke-width: 0.5rem;
        }
        :host([radial][size='s']) .radial-label {
          width: 2.5rem;
          line-height: 1rem;
        }
        :host([radial][size='l']) .radial-label {
          font-size: 1.75rem;
          width: 5.625rem;
          line-height: 2rem;
        }
        :host([radial]) .header-wrapper{
          margin-bottom: 0.5rem;
        }
        :host([radial]) .footer-wrapper {
          display: block;
          margin: 0rem auto 0.5rem auto;

        }
        :
      `]}render(){return V`
      <div class="risk-wrapper" empty-footer=${this._emptyFooter}>
        <div class="header-wrapper">
          <sh-text size="title-1" class="label">${this.label}</sh-text>
          ${this.value&&!this.radial?V` <sh-text size="title-1" class="value">${this.value}</sh-text> `:""}
        </div>
        ${this.radial?V`
              <div class="radial-wrapper">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="radial"
                  viewBox="${"s"===this.size?0:-2} 
                  ${"s"===this.size?0:-2} 
                  ${this._convertRadialSize()+("s"===this.size?0:4)} 
                  ${this._convertRadialSize()+("s"===this.size?0:4)}"
                  preserveAspectRatio="xMidYMid meet"
                  style="width: ${this._convertRadialSize()/16}rem; height: ${this._convertRadialSize()/16}rem"
                >
                  ${this._createRadialSegments()}
                </svg>
                ${this.value?V` <sh-text size="title-1" class="radial-label">${this.value}</sh-text> `:""}
              </div>
            `:V` <div class="linear-wrapper">${this._createLinearSegments()}</div> `}
        <div class="footer-wrapper">
          <slot
            class="footer"
            id="footer"
            name="footer"
            @slotchange="${()=>this._footerSlotObserver()}"
          ></slot>
        </div>
      </div>
    `}constructor(){super(),this.size="s",this.segments=1,this.label="Label",this.segmentColor=this.segmentColor?this.segmentColor:["default"],this.segmentValue=this.segmentValue?this.segmentValue:[""],this._currentAngle=90}updated(e){he(this,e,["value"]),this._footerSlotObserver()}_createLinearSegments(){let e=[];for(let t=0;t<Math.round(this.segments);t++)e.push(V`
        <div class="riskbar" style="width: 100%">
          <div
            class="bar-value"
            style="width: ${this._getSegmentValue(t)}% ;
        background-color: ${this._getSegmentColor(t)}"
          ></div>
        </div>
      `);return e}_createRadialSegments(){const e=[];for(let t=0;t<Math.round(this.segments);t++)e.push(H`
                    <path class="radial-background" 
                      fill=none
                      stroke= 'rgba(var(--ui-1), var(--opacity-5))'
                      d= "${this._calculateRadialSegmentPath(t,this._convertRadialSize(),!0)+" "+(1===this.segments?"Z":"")}"/>
                    
                    <path
                      class="radial-segment" 
                      fill=none 
                      stroke="${this._getSegmentColor(t)}"
                      d = "${this._calculateRadialSegmentPath(t,this._convertRadialSize(),!1)+" "+(1===this.segments&&100===this._getSegmentValue(0)?"Z":"")}"
                     />
                  `);return e}_getSegmentColor(e){return this._calculateSegmentContent(e),this.disabled?"rgba(var(--ui-1), var(--opacity-6))":this.segmentColor[e]}_getSegmentValue(e){return this._calculateSegmentContent(e),this.disabled?0:this.segmentValue[e]}_calculateSegmentContent(e){const t="rgba(var(--ui-1), var(--opacity-5))";let o=this.segmentColor[e],i=this.segmentValue[e];o&&"default"!==o&&o!==t||i&&0!==i?(!o||"default"===o||"active"===o||o===t)&&i>0?(this.segmentColor[e]="rgba(var(--ui-1), var(--opacity-3))",i||0===i||(this.segmentValue[e]=100)):i||0===i||(this.segmentValue[e]=100):(this.segmentColor[e]=t,this.segmentValue[e]=0)}_calculateRadialSegmentPath(e,t,o){let i,r;i=r=t/2;let s,n=t/2-4,a=this._currentAngle+4,c=this._getSegmentValue(e),l=360/Math.round(this.segments)-8;return o?s=a+l:(s=0===c?a:a+l/(100/c),this._currentAngle+=360/Math.round(this.segments)),this._getArcPath(i,r,n,a,s)}_polarToCartesian(e,t,o,i){let r=(i-90)*Math.PI/180;return{x:e+o*Math.cos(r),y:t+o*Math.sin(r)}}_getArcPath(e,t,o,i,r){let s=this._polarToCartesian(e,t,o,r),n=this._polarToCartesian(e,t,o,i),a=r-i<=180?"0":"1";return["M",s.x,s.y,"A",o,o,0,a,0,n.x,n.y].join(" ")}_footerSlotObserver(){const e=this.shadowRoot.querySelector("#footer").assignedNodes({flatten:!0}).length;this._emptyFooter=0===e}_convertRadialSize(){let e;switch(this.size){case"s":e=64;break;case"l":e=128}return e}});var Di=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-search-icon-top=0.5rem] - top margin of search icon
   */
  --sh-search-icon-top: 0.5rem;
  /* 
   * @cssprop [--sh-search-icon-left=0.5rem] - left margin of search icon
   */
  --sh-search-icon-left: 0.5rem;
  /* 
   * @cssprop [--sh-search-input-height=2.5rem] - height of search input
   */
  --sh-search-input-height: 2.5rem;
  /* 
   * @cssprop [--sh-search-value-line-height=0.5rem] - line-height of value
   */
  --sh-search-value-line-height: 0.5rem;
  /* 
   * @cssprop [--sh-search-input-padding=0.5rem 2.5rem] - padding of input
   */
  --sh-search-input-padding: 0.5rem 2.5rem;
  /* 
   * @cssprop [--sh-search-border-radius=0.125rem 0.125rem 0rem 0rem] - border-radius of input
   */
  --sh-search-border-radius: 0.125rem 0.125rem 0rem 0rem;
  /* 
   * @cssprop [--sh-search-border-bottom-thickness=0.0625rem] - border-bottom of input
   */
  --sh-search-border-bottom-thickness: 0.0625rem;
  /* 
   * @cssprop [--sh-search-list-item-height=2.5rem] - list-item-height
   */
  --sh-search-list-item-height: 2.5rem;
  /* 
   * @cssprop [--sh-search-single-line-list-item-padding=0.5rem] - list-item-padding
   */
  --sh-search-single-line-list-item-padding: 0.5rem;
  /* 
   * @cssprop [--sh-search-list-item-line-height=1.5rem] - line-height of list item
   */
  --sh-search-list-item-line-height: 1.5rem;
  /* 
   * @cssprop [--sh-search-close-icon-right=0.5rem] - distance between right of close icon and right of search input
   */
  --sh-search-close-icon-right: 0.5rem;
  /* 
   * @cssprop [--sh-search-multi-line-list-item-padding=0.25rem 0.5rem] - multi-line list-item padding
   */
  --sh-search-multi-line-list-item-padding: 0.25rem 0.5rem;
  /* 
   * @cssprop [--sh-search-multi-line-list-item-height=2.5rem] - multi-line list-item height
   */
  --sh-search-multi-line-list-item-height: 2.5rem;
  /* 
   * @cssprop [--sh-search-multi-line-single-item-height=1rem] - multi-line single-item height
   */
  --sh-search-multi-line-single-item-height: 1rem;
  /* 
   * @cssprop [--sh-search-empty-wrapper-padding=1rem 0.5rem] - padding of empty wrapper
   */
  --sh-search-empty-wrapper-padding: 1rem 0.5rem;
  /* 
   * @cssprop [--sh-search-list-view-max-height=13.75rem] - max-height of list-view
   */
  --sh-search-list-view-max-height: 13.75rem;
  /* 
   * @cssprop [--sh-search-empty-slot-item-gap=1rem] - the gap between the items in empty slot
   */
  --sh-search-empty-slot-item-gap: 1rem;
}

:host {
  width: 100%;
  display: block;
  height: var(--sh-search-input-height);
  position: relative;
}

input,
:host([readonly]) input:focus {
  line-height: var(--sh-search-value-line-height) !important;
  padding: var(--sh-search-input-padding);
  border-radius: var(--sh-search-border-radius);
  background: rgba(var(--ui-1), var(--opacity-7));
  height: var(--sh-search-input-height);
  color: var(--text-primary);
  font: var(--body-1);
  border: none;
  outline: none;
  box-sizing: border-box;
  width: 100%;
  text-overflow: ellipsis;
  transition: var(--transition-time) all ease-in-out, var(--hover-transition-time) background;
  border-bottom: var(--sh-search-border-bottom-thickness) solid transparent;
  border-color: rgba(var(--ui-1), var(--opacity-4));
}

input::-ms-clear {
  display: none;
}

:host([disabled]) input {
  color: var(--text-disabled);
  background: rgba(var(--ui-1), var(--opacity-7));
}

sh-icon {
  position: absolute;
  top: var(--sh-search-icon-top);
  left: var(--sh-search-icon-left);
  cursor: pointer;
}

#showSearch {
  max-height: var(--sh-search-list-view-max-height) !important;
}

.empty-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--sh-search-empty-slot-item-gap);
}

#showSearch,
.empty-wrapper {
  overflow: auto;
  background: var(--base-4);
  z-index: 1;
  box-shadow: var(--shadow-overlay);
  box-sizing: border-box;
}

.name {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

#showSearch .itemList {
  height: var(--sh-search-list-item-height);
  padding: var(--sh-search-single-line-list-item-padding);
  font: var(--body-1);
  color: var(--text-primary);
  line-height: var(--sh-search-list-item-line-height);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  box-sizing: border-box;
  transition: var(--hover-transition-time) background;
}

.closeIcon {
  position: absolute;
  left: auto;
  right: var(--sh-search-close-icon-right);
  cursor: pointer;
  color: rgba(var(--ui-1), var(--opacity-4));
  background: transparent !important;
}

:host([disabled]) input::-moz-placeholder {
  color: var(--text-disabled);
  opacity: unset;
}

:host([disabled]) input::-webkit-input-placeholder,
:host([disabled]) input::placeholder {
  color: var(--text-disabled);
}

input::-webkit-input-placeholder,
input::placeholder,
input::-moz-placeholder {
  font: var(--body-1);
  color: var(--text-secondary);
}

.searchText {
  white-space: pre;
  color: var(--text-primary);
  font: var(--title-1);
}

/* hover */
input:hover {
  background: rgba(var(--ui-1), var(--opacity-6));
}

input:focus {
  border-color: rgba(var(--ui-1), var(--opacity-2));
}

:host(:not(.no-hovermq)) #showSearch .itemList:hover,
#showSearch .itemList.hover {
  cursor: pointer;
  background: rgba(var(--ui-1), var(--opacity-7));
}

:host(:not(.no-hovermq)) .closeIcon:hover,
.closeIcon.hover {
  color: rgba(var(--ui-1), var(--opacity-3));
}

:host(:not(.no-hovermq)) ::-webkit-input-placeholder:hover {
  font: var(--body-1);
  color: var(--text-secondary);
}

.itemList.active {
  background: rgba(var(--ui-1), var(--opacity-7));
}

/*multiline suggestions */
:host([multiline]) #showSearch .itemList {
  padding: var(--sh-search-multi-line-list-item-padding);
  height: var(--sh-search-multi-line-list-item-height);
}

:host([multiline]) #showSearch .itemList div {
  height: var(--sh-search-multi-line-single-item-height);
  line-height: var(--sh-search-multi-line-single-item-height);
}

:host([multiline]) #showSearch .firstItem {
  font: var(--body-1);
  color: var(--text-primary);
}

:host([multiline]) #showSearch .secondItem {
  font: var(--body-2);
  color: var(--text-secondary);
}

.secondItem .searchText {
  font: var(--title-2);
}

.firstItem,
.secondItem {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.empty-wrapper {
  padding: var(--sh-search-empty-wrapper-padding);
}

input::-moz-placeholder {
  font: var(--body-1);
  color: var(--text-secondary);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  word-break: break-all;
}

input::placeholder {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  word-break: break-all;
  font: var(--body-1);
  color: var(--text-secondary);
}

:host([value=""]) #showSearch,
:host([value=""]) .empty-wrapper {
  display: none;
}`;function Bi(e){const t=new Map;return class extends e{constructor(){super(),this._readOnlyPropertyInitializedMap=new Map}static createProperty(e,o){let i=o;if(o.readOnly){const r=Symbol(e);t.set(e,r),Object.defineProperty(this.prototype,e,{get(){return this[r]},set(t){this._readOnlyPropertyInitializedMap.get(e)||(this[r]=t,this._readOnlyPropertyInitializedMap.set(e,!0))}}),i={...o,noAccessor:!0}}super.createProperty(e,i)}async setReadOnlyProperties(e){await Promise.all(Object.entries(e).map((([e,o])=>{const i=t.get(e),r=this[i];return this[i]=o,this.requestUpdate(e,r)})))}}}customElements.define("sh-search",class extends se{static get properties(){return{label:{type:String,reflect:!0},disabled:{type:Boolean,reflect:!0},searchArray:{type:Array,reflect:!0,attribute:"search-array"},multiline:{type:Boolean,reflect:!0},_currentFocus:{type:Number},_emptyResult:{type:Boolean},value:{type:String,reflect:!0},fields:{type:Array,reflect:!0},wholeString:{type:Boolean,reflect:!0,attribute:"whole-string"},noClear:{type:Boolean,reflect:!0,attribute:"no-clear"},maxlength:{type:String,reflect:!0}}}static get styles(){return[Di,ae]}render(){return V`
      <input
        type="text"
        .value="${this.value}"
        maxlength="${this.maxlength}"
        @input="${e=>this.onInput(e)}"
        @keyup="${()=>this.changeInput(this.value)}"
        @keydown="${e=>this.keyEvents(e)}"
        id="searchBox"
        ?disabled="${this.disabled}"
        placeholder="${this.label}"
      />
      <sh-icon
        size="s"
        icon="search"
        ?disabled="${this.disabled}"
        button
        @click="${()=>this._search()}"
      ></sh-icon>
      ${!this.value||this.disabled||this.noClear?"":V`
            <sh-icon
              icon="cancel"
              size="s"
              button
              class="closeIcon"
              id="close"
              ?disabled="${this.disabled}"
              @click="${()=>this.clearInput()}"
            ></sh-icon>
          `}
      <sh-overlay
        id="showSearch"
        class="showSearch"
        style="width:${getComputedStyle(this).width};"
        scroll-action="refit"
        @focus="${e=>this.overlayFocusHandler(e)}"
        no-overlap
        horizontal-align="left"
        no-cancel-on-outside-click
      >
        ${this.multiline?"":V`
              ${this.searchArray.map((e=>V`
                  ${this.computeSingleFilter(e)?V`
                        <div
                          @click="${e=>this.selectItem(e)}"
                          class="itemList"
                          data-item="${e}"
                        >
                          <span class="name" data-item="${e}">${e}</span>
                        </div>
                      `:""}
                `))}
            `}
        ${this.multiline?V`
              ${this.searchArray.map((e=>V`
                  ${this.computeFilter(e)?V`
                        <div
                          @click="${e=>this.selectItem(e)}"
                          class="itemList"
                          data-item="${e[this.fields[0]]}"
                        >
                          <div class="firstItem" data-item="${e[this.fields[0]]}">
                            <span class="name" data-item="${e[this.fields[0]]}"
                              >${e[this.fields[0]]}</span
                            >
                          </div>
                          <div
                            class="secondItem"
                            data-item="${e[this.fields[0]]}"
                            data-second-item="${e[this.fields[1]]}"
                          >
                            <span class="name" data-item="${e[this.fields[0]]}"
                              >${e[this.fields[1]]}</span
                            >
                          </div>
                        </div>
                      `:""}
                `))}
            `:""}
      </sh-overlay>
      ${this._emptyResult&&this.children.length>0?V`
            <sh-overlay
              opened
              class="empty-wrapper"
              style="width:${getComputedStyle(this).width}"
              scroll-action="refit"
              no-overlap
              horizontal-align="left"
              no-cancel-on-outside-click
            >
              <slot name="empty"></slot>
            </sh-overlay>
          `:""}
    `}constructor(){super(),this.searchArray=[],this.wholeString=!1,this.value="",this.label="Search",this._currentFocus=-1,this.fields=[]}connectedCallback(){super.connectedCallback(),this.clickListener=this.closeSearch.bind(this),document.body.addEventListener("click",this.clickListener),this.multiline&&0===this.fields.length&&this.searchArray.length>0&&(this.fields[0]=Object.keys(this.searchArray[0])[0],this.fields[1]=Object.keys(this.searchArray[0])[1])}firstUpdated(){this._overlay=this.shadowRoot.querySelector("#showSearch"),this.shadowRoot.querySelector("input").addEventListener("focus",(()=>{this.value?(this._overlay.open(),0===this._overlay.querySelectorAll(".itemList").length&&(this._emptyResult=!0)):(this._overlay.close(),this._emptyResult=!1)})),this.shadowRoot.querySelector("input").addEventListener("keydown",(e=>{"Enter"===e.key&&this._search()}))}updated(e){he(this,e,["label","disabled","value","multiline","fields"])}disconnectedCallback(){document.body.removeEventListener("click",this.clickListener),super.disconnectedCallback()}closeSearch(e){e.target!==this&&(this._overlay.close(),this._emptyResult=!1)}overlayFocusHandler(e){e.preventDefault(),this.shadowRoot.querySelector("input").focus()}onInput(e){this.value=e.target.value}changeInput(e){if(this.value?this._overlay.open():this._overlay.close(),!this.multiline&&this.value){const t=this.shadowRoot.querySelectorAll("#showSearch .itemList");for(let o=0;o<t.length;o++){const i=t[o].dataset.item;t[o].innerHTML=this.searchHighlight(i,e)}}else this.value&&this.multilineSearch();if(0===this._overlay.querySelectorAll(".itemList").length){if(""===this.value)return;le(this,"noresult"),this._emptyResult=!0}else this._emptyResult=!1}multilineSearch(){const e=this._overlay.querySelectorAll(".itemList .firstItem"),t=this._overlay.querySelectorAll(".itemList .secondItem");for(let t=0;t<e.length;t++)this.findSearchedStr(e[t],e[t].dataset.item);for(let e=0;e<t.length;e++)this.findSearchedStr(t[e],t[e].dataset.secondItem)}findSearchedStr(e,t){const o=t;this.wholeString||-1===o.toLowerCase().indexOf(this.value.toLowerCase())?this.wholeString&&-1!==o.toLowerCase().indexOf(this.value.toLowerCase())?e.innerHTML=this.searchHighlight(o,this.value):e.innerHTML=`<span class="name">${o}</span>`:e.innerHTML=this.searchHighlight(o,this.value)}searchHighlight(e,t){let o;if(t){const i=e.toLowerCase().indexOf(t.toLowerCase()),r=i+t.length-1;o=`${e.slice(0,i)}<span class="searchText">${e.slice(i,r+1)}</span>${e.slice(r+1)}`}return o}computeSingleFilter(e){let t;return t=this.wholeString?-1!==e.toLowerCase().indexOf(this.value.toLowerCase()):0===e.toLowerCase().indexOf(this.value.toLowerCase()),t}computeFilter(e){let t;return t=this.wholeString?-1!==e[this.fields[0]].toLowerCase().indexOf(this.value.toLowerCase())||-1!==e[this.fields[1]].toLowerCase().indexOf(this.value.toLowerCase()):0===e[this.fields[0]].toLowerCase().indexOf(this.value.toLowerCase())||0===e[this.fields[1]].toLowerCase().indexOf(this.value.toLowerCase()),t}clearInput(){this.value="",this._emptyResult=!1,le(this,"clearsearch"),this._overlay.close()}selectItem(e){this.value=e.target.dataset.item,"SPAN"===e.target.tagName?this.value=e.target.parentNode.dataset.item:this.value=e.target.dataset.item,this.shadowRoot.querySelector("input").value=this.value,this.changeInput(this.value),this._overlay.close(),this.shadowRoot.querySelector("input").blur(),this.clearActive(),this._search()}clearActive(){const e=this._overlay.getElementsByClassName("active");if(e)for(let t=0;t<e.length;t++)e[t].classList.remove("active");this._currentFocus=-1}keyEvents(e){let t;t=this.shadowRoot.querySelector("#showSearch"),t&&(t=t.querySelectorAll(".itemList")),40===e.keyCode&&(e.preventDefault(),this._currentFocus++,this.addActive(t)),38===e.keyCode&&(e.preventDefault(),this._currentFocus--,this.addActive(t)),13===e.keyCode&&(e.preventDefault(),this._currentFocus>-1&&t.length>0&&("INPUT"===e.target.tagName&&e.stopImmediatePropagation(),t[this._currentFocus].click(),this.blur()))}addActive(e){e&&!this._emptyResult&&(this.removeActive(e),this._currentFocus>=e.length&&(this._currentFocus=0),this._currentFocus<0&&(this._currentFocus=e.length-1),e[this._currentFocus].classList.add("active"))}removeActive(e){for(let t=0;t<e.length;t++)e[t].classList.remove("active")}_search(){le(this,"search")}});const Ti=e=>class extends e{setTooltip(e,t){"verticalTooltip"===t.id?t.style.left=`calc(${e}% + (${(-12-.15*e)/16}rem))`:t.style.left=`calc(${e}% + (${(8-.15*e)/16}rem))`}setTooltipRange(e,t){t.style.left=`calc(${e}%)`}},Ri=e=>class extends e{constructor(){super(),this._stableValue=this._lowStable=this._highStable=0}getLowerValue(e,t,o,i,r){return this._lowStable=t,(e=""===e?this.min:Number(e))>=i&&e<=r&&e>o&&(e=void 0!==this._lowStable?this._lowStable:i),(e<i||e>r)&&(e=void 0!==this._lowStable?this._lowStable:i),e<=o&&e>=i&&e<=r&&(this._lowStable=e),Number.isNaN(e)?i:this._lowStable}getUpperValue(e,t,o,i,r){return this._highStable=o,(e=""===e?r:Number(e))>=i&&e<=r&&e<t&&(e=void 0!==this._highStable?this._highStable:r),(e>r||e<i)&&(e=void 0!==this._highStable?this._highStable:r),e>=t&&e>=i&&e<=r&&(this._highStable=e),Number.isNaN(e)?r:this._highStable}getValue(e,t,o,i){return this._stableValue=t,((e=""===e?this.min:Number(e))<o||e>i)&&(e=void 0!==this._stableValue?this._stableValue:o),e>=o&&e<=i&&(this._stableValue=e),Number.isNaN(e)?o:this._stableValue}},Li=.5/wi,Pi=e=>class extends e{constructor(){super(),this.min=0,this.max=100,this.step=1}getCalculatedStepDistance(e,t,o,i){let r;return this.min=t,this.max=o,this.step=i,r=this.step/(this.max-this.min),r=r*e-Li,{distance:r}}calculatePoints(e){let t,o=[];const i=Math.floor((this.max-this.min)/this.step);if(this.min<0&&this.min/this.step!=0){o=[0],t=0;let e=Math.floor((0-this.min)/this.step),i=Math.floor((this.max-0)/this.step);for(let i=0;i<e;++i)t-=this.step,o.push(t);t=0;for(let e=0;e<i;++e)t+=this.step,o.push(t)}else{o=[this.min],t=this.min;for(let e=0;e<i;++e)t+=this.step,o.push(t)}this._calculateStepTicks(o,e)}_calculateStepTicks(e,t){let o,i;const r=e.map((e=>(o=(e-this.min)/(this.max-this.min),o=2*Math.round(o*t/2)/wi,o-=Li,i=`left: ${o}rem`,{style:i,position:e})));this.setReadOnlyProperties({stepMarkers:r})}};var Oi=function(e){let t;return t=0,t=e.split(".")[1].length,t};customElements.define("arrow-controls",class extends se{static get properties(){return{parentElement:{type:String},value:{type:Number},min:{type:Number},max:{type:Number},step:{type:Number},horizontal:{type:Boolean},disabled:{type:Boolean}}}static get styles(){return[ie`
        :host {
          display: flex;
        }
        :host([disabled]) #plus,
        :host([disabled]) #minus {
          color: rgb(var(--ui-1));
        }
      `]}render(){return V`
      <span>
        <sh-icon
          id="minus"
          button
          icon="${this.horizontal?"left-s":"up-s"}"
          ?disabled="${this.disabled}"
          @mousedown="${this._startCounter}"
          @mousemove="${this._releaseCounter}"
          @mouseup="${this._releaseCounter}"
          @touchstart="${this._startCounter}"
          @touchend="${this._releaseCounter}"
        ></sh-icon>
      </span>
      <span>
        <sh-icon
          id="plus"
          button
          icon="${this.horizontal?"right-s":"down-s"}"
          ?disabled="${this.disabled}"
          @mousedown="${this._startCounter}"
          @mousemove="${this._releaseCounter}"
          @mouseup="${this._releaseCounter}"
          @touchstart="${this._startCounter}"
          @touchend="${this._releaseCounter}"
        ></sh-icon>
      </span>
    `}constructor(){super(),this.min=0,this.max=100,this.step=1}_startCounter(e){e.touches&&(this.skipMouseMove=!0),e.target.style.transition="0s all linear",this._releaseCounter(),this._setFlags(e),this.clock=window.requestAnimationFrame(this._clockControl.bind(this))}_handleOnClick(){this._mouseDownAddition?this._mouseDownAddition=!1:this._clickedOnPlusIcon?this._handlePlusCalc():this._clickedOnMinusIcon&&this._handleMinusCalc()}_clockControl(){this.timer=setTimeout(this._handleOnMouseDown.bind(this),100)}_handleOnMouseDown(){this._clickedOnPlusIcon?this._handlePlusCalc():this._clickedOnMinusIcon&&this._handleMinusCalc(),this._mouseDownAddition=!0,this.clock=window.requestAnimationFrame(this._clockControl.bind(this))}_handleMinusCalc(){const e=this.decimalNumberPrecision();let t=0;this.value!==this.min&&(t=parseFloat(this.value)-parseFloat(this.step),t=Number(t).toFixed(e),t>=this.min&&(this.value=Number(t),le(this,"control-value-change")))}_handlePlusCalc(){const e=this.decimalNumberPrecision();let t=0;this.value!==this.max&&(t=parseFloat(this.value)+parseFloat(this.step),t=Number(t).toFixed(e),t<=this.max&&(this.value=Number(t),le(this,"control-value-change")))}decimalNumberPrecision(){let e,t,o;return e=this.step.toString(),t=this.min.toString(),o=0,e.includes(".")?o=Oi(e):t.includes(".")&&(o=Oi(t)),o}_releaseCounter(e=null){e&&"mousemove"===e.type&&this.skipMouseMove?this.skipMouseMove=!1:(window.cancelAnimationFrame(this.clock),clearTimeout(this.timer),!e||"mouseup"!==e.type&&"touchend"!==e.type||le(this,"control-value-change-end"),e&&"mousemove"!==e.type&&(this._setFlags(e),this._handleOnClick()),e&&e.touches&&e.preventDefault(),this._clickedOnPlusIcon=!1,this._clickedOnMinusIcon=!1)}_setFlags(e){"plus"===e.target.id?this._clickedOnPlusIcon=!0:"minus"===e.target.id&&(this._clickedOnMinusIcon=!0)}disconnectedCallback(){window.cancelAnimationFrame(this.clock),clearTimeout(this.timer),super.disconnectedCallback()}});class Ni extends(Ti(Pi(Ri(Bi(se))))){static get properties(){return{label:{type:String,reflect:!0},min:{type:Number,reflect:!0},max:{type:Number,reflect:!0},step:{type:Number,reflect:!0},showValue:{type:Boolean,reflect:!0,attribute:"show-value"},disabled:{type:Boolean,reflect:!0},lowerValue:{type:Number,reflect:!0,attribute:"lower-value"},upperValue:{type:Number,reflect:!0,attribute:"upper-value"},stepMarkers:{type:Array,readOnly:!0},_selectedThumb:{type:String},_isDrag:{type:Boolean,reflect:!0}}}static get styles(){return[ie`
        :host {
          width: 100%;
          outline: 0;
          display: block;
        }
        .range-wrapper {
          position: relative;
          height: 2rem;
          outline: none;
          display: flex;
          width: calc(100% - 1rem);
          margin: 0 0.5rem;
        }
        input[type='range']::-webkit-slider-thumb {
          box-shadow: none;
        }
        #lower::-webkit-slider-thumb,
        #upper::-webkit-slider-thumb {
          appearance: none;
          position: relative;
          width: 0.875rem;
          height: 0.875rem;
          cursor: pointer;
          border-radius: 50%;
          border: none;
          outline: 0;
          z-index: 1;
          background: rgba(var(--ui-5), var(--opacity-1));
          -webkit-appearance: none;
          user-select: none;
          -webkit-user-select: none;
          transition: var(--hover-transition-time) background;
        }
        #lower::-moz-range-thumb,
        #upper::-moz-range-thumb {
          position: relative;
          width: 0.875rem;
          height: 0.875rem;
          cursor: pointer;
          border-radius: 50%;
          border: none;
          z-index: 1;
          background: rgba(var(--ui-5), var(--opacity-1));
          transition: var(--hover-transition-time) background;
        }
        :host(.touch-device) #lower::-webkit-slider-thumb,
        :host(.touch-device) #upper::-webkit-slider-thumb {
          background-clip: padding-box;
          border: 0.8125rem solid rgba(0, 0, 0, 0);
          box-sizing: unset;
        }
        :host(.touch-device) #handleTrackWrapper {
          height: 2.5rem;
        }
        :host(.touch-device) #rangeTrack,
        :host(.touch-device) #lower,
        :host(.touch-device) #upper,
        :host(.touch-device) #handleTrack {
          margin-top: 1.15rem;
        }
        :host(.touch-device) #rangeTrack {
          border-top: 1.1875rem solid rgba(0, 0, 0, 0);
          border-bottom: 1.1875rem solid rgba(0, 0, 0, 0);
          background-clip: padding-box;
          margin-top: 0;
        }
        :host(.touch-device) .range-wrapper {
          height: 2.5rem;
        }
        :host(:not(.touch-device)) #rangeTrack {
          border-top: 0.375rem solid rgba(0, 0, 0, 0);
          border-bottom: 0.375rem solid rgba(0, 0, 0, 0);
          background-clip: padding-box;
          margin-top: 0.5625rem;
        }
        :host(:not(.touch-device)) #lower::-webkit-slider-thumb:hover,
        :host(:not(.touch-device)) #upper::-webkit-slider-thumb:hover {
          background: rgba(var(--ui-2), var(--opacity-1));
        }
        :host(:not(.touch-device)) #lower::-moz-range-thumb:hover,
        :host(:not(.touch-device)) #upper::-moz-range-thumb:hover {
          background: rgba(var(--ui-2), var(--opacity-1));
        }
        :host(.touch-device) .thumbActive#lower::-webkit-slider-thumb,
        :host(.touch-device) .thumbActive#upper::-webkit-slider-thumb {
          border: 0.8125rem solid rgba(var(--ui-3), var(--opacity-5));
          background-color: rgba(var(--ui-3), var(--opacity-1));
        }
        #lower::-webkit-slider-thumb:active,
        #upper::-webkit-slider-thumb:active {
          background: rgba(var(--ui-3), var(--opacity-1));
        }
        #lower::-moz-range-thumb:active,
        #upper::-moz-range-thumb:active {
          background: rgba(var(--ui-3), var(--opacity-1));
        }
        :host(.touch-device) #lower::-webkit-slider-runnable-track,
        :host(.touch-device) #upper::-webkit-slider-runnable-track {
          margin-left: -0.8125rem;
          margin-right: -0.8125rem;
        }
        .range-track {
          width: calc(100% + 1rem);
          height: 0.125rem;
          outline: 0;
          background-color: rgba(var(--ui-1), var(--opacity-6));
          cursor: pointer;
          position: absolute;
          -moz-appearance: none;
          -webkit-appearance: none;
          margin-left: -0.5rem;
          margin-top: 0.9375rem;
        }
        .handle-track {
          height: 0.125rem;
          background: rgba(var(--ui-5), var(--opacity-1));
          cursor: pointer;
          margin-top: 0.9375rem;
        }
        .handle-track-wrapper {
          height: 2rem;
          position: absolute;
          transition: var(--hover-transition-time) background;
        }
        #handleTrackWrapper {
          cursor: pointer;
          outline: 0;
        }
        #lower,
        #upper {
          background-color: transparent;
          opacity: unset;
          pointer-events: none;
        }
        #lower::-webkit-slider-thumb,
        #upper::-webkit-slider-thumb {
          position: relative;
          pointer-events: all;
        }
        #lower::-moz-range-thumb,
        #upper::-moz-range-thumb {
          position: relative;
          pointer-events: all;
        }
        :host(:not(.touch-device)) .handle-track-wrapper:hover .handle-track,
        .focus#lower::-webkit-slider-thumb,
        .focus#upper::-webkit-slider-thumb {
          background: rgba(var(--ui-2), var(--opacity-1));
        }
        .active#lower::-webkit-slider-thumb,
        .active#upper::-webkit-slider-thumb,
        .active#handleTrack {
          background: rgba(var(--ui-3), var(--opacity-1));
        }
        .focus#lower::-moz-range-thumb,
        .focus#upper::-moz-range-thumb {
          background: rgba(var(--ui-2), var(--opacity-1));
        }
        .active#lower::-moz-range-thumb,
        .active#upper::-moz-range-thumb {
          background: rgba(var(--ui-3), var(--opacity-1));
        }
        /* disabled styles */
        :host([disabled]) #upper::-webkit-slider-thumb,
        :host([disabled]) #lower::-webkit-slider-thumb,
        :host([disabled]) #handleTrack {
          background-color: rgba(var(--ui-6), var(--opacity-1));
          pointer-events: none;
        }
        :host([disabled]) #upper::-moz-range-thumb,
        :host([disabled]) #lower::-moz-range-thumb {
          background: rgba(var(--ui-6), var(--opacity-1));
          pointer-events: none;
        }
        :host([disabled]) #rangeTrack {
          background-color: rgb(var(--ui-1), var(--opacity-7));
        }

        .label-wrapper {
          display: flex;
          justify-content: space-between;
        }
        .slider-label {
          flex: 1 1 auto;
          min-width: 3.375rem;
          font: var(--body-1);
          line-height: 1.5rem;
          font-weight: normal;
          color: var(--text-secondary);
          padding-right: 0.5rem;
          -webkit-font-smoothing: antialiased !important;
          text-rendering: optimizeLegibility !important;
          -moz-osx-font-smoothing: grayscale !important;
          user-select: none;
          -moz-user-select: none;
          -webkit-user-select: none;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          transition: 0.2s all ease-in-out;
        }

        .label-wrapper input {
          outline: 0;
          border: none;
          width: 2.5rem;
          height: 1.5rem;
          font: var(--body-1);
          line-height: 1.5rem;
          color: var(--text-secondary);
          background: rgba(var(--ui-1), var(--opacity-7));
          border-radius: 0.125rem;
          box-sizing: border-box;
          padding: 0.25rem;
          transition: 0.2s all ease-in-out;
          text-align: center;
          -moz-appearance: textfield;
        }
        .value-separator {
          height: 1.5rem;
          width: 0.75rem;
          text-align: center;
          line-height: 1.5rem;
          color: rgba(var(--ui-5), var(--opacity-1));
        }
        :host([disabled]) .value-separator {
          color: rgba(var(--ui-6), var(--opacity-1));
        }
        input::-webkit-inner-spin-button {
          display: none;
        }

        :host(:not([label])) .label-wrapper {
          display: none;
        }

        :host([show-value]) .label-wrapper input {
          display: inline-flex;
        }

        :host([disabled]) .slider-label,
        :host([disabled]) .label-wrapper input {
          color: var(--text-disabled);
          opacity: unset;
        }

        /* stepTicks */
        .step_ticks {
          position: absolute;
          padding: 0;
          margin: 0 auto;
          top: 0;
          bottom: -0.03125rem;
          display: none;
          flex-direction: row;
          align-items: center;
        }

        .step_ticks li {
          height: 0.5rem;
          width: 0.0625rem;
          -moz-user-select: none;
          -webkit-user-select: none;
          list-style: none;
          position: absolute;
        }

        :host .sh-step-thumb-item {
          cursor: pointer;
          outline: 0;
          background: rgba(var(--ui-1), var(--opacity-6));
          -moz-appearance: none;
          -webkit-appearance: none;
          user-select: none;
          -moz-user-select: none;
          -webkit-user-select: none;
        }

        :host([disabled]) .sh-step-thumb-item {
          background: rgba(var(--ui-1), var(--opacity-7));
        }
        /* Tooltip styles */
        #lowerRangeTooltip,
        #upperRangeTooltip {
          display: none;
          position: absolute;
          pointer-events: none;
          outline: 0;
          width: 2.5rem;
          height: 1.5rem;
          font: var(--body-1);
          text-align: center;
          color: var(--text-secondary);
          background: var(--base-3);
          box-shadow: var(--shadow-raised);
          border-radius: 0.125rem;
          box-sizing: border-box;
          padding: 0.25rem;
          z-index: 5;
          margin: -1.375rem;
        }
        :host(:not([show-value]):hover:not(.touch-device)) #lowerRangeTooltip,
        :host(:not([show-value]):hover:not(.touch-device)) #upperRangeTooltip {
          display: block;
        }
        :host .markers.step_ticks {
          display: flex;
        }
        /* tab-outline */
        :host .tab_outline.handle-track-wrapper {
          outline: var(--focus-outline) !important;
        }
        :host .tab_outline.handle-track {
          background: rgba(var(--ui-2), var(--opacity-1));
        }
        :host(:not([show-value])) .tab_tooltip#lowerRangeTooltip,
        :host(:not([show-value])) .tab_tooltip#upperRangeTooltip {
          display: block;
        }
        :host .tab_outline#lower::-webkit-slider-thumb,
        :host .tab_outline#upper::-webkit-slider-thumb {
          outline: var(--focus-outline);
          background: rgba(var(--ui-2), var(--opacity-1));
        }

        :host .tab_outline#lower::-moz-range-thumb,
        :host .tab_outline#upper::-moz-range-thumb {
          outline: var(--focus-outline);
          background: rgba(var(--ui-2), var(--opacity-1));
        }
      `]}render(){return V`
      ${this.label?V` <div class="label-wrapper">
            <div class="slider-label">${this.label}</div>
            ${this.showValue?V` <input
                    id="lowerInputText"
                    type="number"
                    min="${this.min}"
                    max="${this.max}"
                    step="${this.step}"
                    .value="${this.lowerValue}"
                    maxlength="4"
                    ?disabled="${this.disabled}"
                    @keyup="${this._onKeyPress}"
                    @blur="${this._handleOnBlur}"
                  />
                  <span class="value-separator"> - </span>
                  <input
                    id="upperInputText"
                    type="number"
                    min="${this.min}"
                    max="${this.max}"
                    step="${this.step}"
                    .value="${this.upperValue}"
                    maxlength="4"
                    ?disabled="${this.disabled}"
                    @keyup="${this._onKeyPress}"
                    @blur="${this._handleOnBlur}"
                  />`:""}
          </div>`:""}
      <div id="rangeWrapper" class="range-wrapper">
        <div
          id="rangeTrack"
          class="range-track"
          @click="${e=>this._moveThumbOnRangeTrack(e)}"
          @touchstart="${e=>this._moveThumbOnRangeTrack(e)}"
        >
          <ul id="range_step_ticks" class="step_ticks">
            ${this.stepMarkers.map((e=>V` <li
                class="sh-step-thumb-item"
                @click="${e=>this._onTickClick(e)}"
                data-value="${e.position}"
                style="${e.style}"
              ></li>`))}
          </ul>
        </div>
        <div
          id="handleTrackWrapper"
          class="handle-track-wrapper"
          tabindex="${this.disabled?"-1":"0"}"
          @mousedown="${e=>this._thumbDown(e)}"
          @touchstart="${e=>this._thumbDown(e)}"
        >
          <div
            id="handleTrack"
            class="handle-track"
            @mousedown="${e=>this._thumbDown(e)}"
            @touchstart="${e=>this._thumbDown(e)}"
          ></div>
        </div>
        <input
          type="range"
          id="lower"
          class="range-track"
          min="${this.min}"
          max="${this.max}"
          label="${this.label}"
          step="${this.step}"
          .value="${this.lowerValue}"
          ?disabled="${this.disabled}"
          @mousedown="${e=>this._thumbDown(e)}"
          @touchstart="${e=>this._thumbDown(e)}"
          @input="${e=>this._thumbOverlapValueCheckRange(e)}"
        />
        <div id="lowerRangeTooltip">${this.lowerValue}</div>
        <input
          type="range"
          id="upper"
          class="range-track"
          min="${this.min}"
          max="${this.max}"
          label="${this.label}"
          step="${this.step}"
          .value="${this.upperValue}"
          ?disabled="${this.disabled}"
          @mousedown="${e=>this._thumbDown(e)}"
          @touchstart="${e=>this._thumbDown(e)}"
          @input="${e=>this._thumbOverlapValueCheckRange(e)}"
        />
        <div id="upperRangeTooltip">${this.upperValue}</div>
      </div>
    `}constructor(){super(),this.lowerValue=this.upperValue=0,this.min=0,this.max=100,this.step=1,this.label="Label",this.stepMarkers=[]}updated(e){e.has("step")&&(this._renderStepMarkersRange(),this._thumbOverlapLowerValueCheckRange(),this._thumbOverlapUpperValueCheckRange(),this._generateHandleTrack()),e.has("lowerValue")&&(this._thumbOverlapLowerValueCheckRange(),this._tooltipSelection(),this._generateHandleTrack()),e.has("upperValue")&&(this._thumbOverlapUpperValueCheckRange(),this._tooltipSelection(),this._generateHandleTrack()),(e.has("min")||e.has("max"))&&(this._renderStepMarkersRange(),this._thumbOverlapLowerValueCheckRange(),this._thumbOverlapUpperValueCheckRange(),this._tooltipSelection(),this._generateHandleTrack()),e.has("_isDrag")&&this._isDragObserver(),he(this,e,["lowerValue","upperValue"])}connectedCallback(){super.connectedCallback(),this.boundMove=this._thumbMove.bind(this),this.boundUp=this._thumbUp.bind(this),window.addEventListener("mousemove",this.boundMove),window.addEventListener("mouseup",this.boundUp),this.addEventListener("touchmove",this.boundMove),this.addEventListener("touchend",this.boundUp)}firstUpdated(){ue.isTouchDevice()&&this.classList.add("touch-device");const e=this.shadowRoot.querySelector("#lower"),t=this.shadowRoot.querySelector("#upper"),o=this.shadowRoot.querySelector("#handleTrackWrapper"),i=this.shadowRoot.querySelector("#handleTrack"),r=this.shadowRoot.querySelector("#lowerRangeTooltip"),s=this.shadowRoot.querySelector("#upperRangeTooltip");e.addEventListener("focus",(()=>this._handleFocus(e,r))),e.addEventListener("blur",(()=>this._handleBlur(e,r))),t.addEventListener("focus",(()=>this._handleFocus(t,s))),t.addEventListener("blur",(()=>this._handleBlur(t,s))),o.addEventListener("focus",(()=>this._handleFocusRangeTrack(o,i,s,r,e,t))),o.addEventListener("blur",(()=>this._handleBlurRangeTrack(o,i,s,r,e,t))),o.addEventListener("mouseover",(()=>this._addElementFocus(e,t))),o.addEventListener("mouseout",(()=>this._removeElementFocus(e,t)))}_handleFocus(e,t){e.onkeyup=o=>{t.classList.add("tab_tooltip"),o.keyCode===me.TAB&&e.classList.add("tab_outline"),o.keyCode!==me.ARROW_RIGHT&&o.keyCode!==me.ARROW_UP||this._eventTargetSelect(o),o.keyCode!==me.ARROW_LEFT&&o.keyCode!==me.ARROW_DOWN||this._eventTargetSelect(o)}}_handleBlur(e,t){e.classList.remove("tab_outline"),t.classList.remove("tab_tooltip")}_handleFocusRangeTrack(e,t,o,i,r,s){e.onkeyup=n=>{n.keyCode===me.TAB&&(e.classList.add("tab_outline"),t.classList.add("tab_outline"),o.classList.add("tab_tooltip"),i.classList.add("tab_tooltip"),r.classList.add("tab_outline"),s.classList.add("tab_outline")),n.keyCode!==me.ARROW_RIGHT&&n.keyCode!==me.ARROW_UP||s.value<this.max&&(r.value=parseFloat(r.value)+parseFloat(this.step),s.value=parseFloat(s.value)+parseFloat(this.step),this.lowerValue=Number(r.value),this.upperValue=Number(s.value),this._eventTargetSelect(n)),n.keyCode!==me.ARROW_LEFT&&n.keyCode!==me.ARROW_DOWN||this.lowerValue>this.min&&(r.value=parseFloat(r.value)-parseFloat(this.step),s.value=parseFloat(s.value)-parseFloat(this.step),this.lowerValue=Number(r.value),this.upperValue=Number(s.value),this._eventTargetSelect(n))}}_handleBlurRangeTrack(e,t,o,i,r,s){e.classList.remove("tab_outline"),t.classList.remove("tab_outline"),o.classList.remove("tab_tooltip"),i.classList.remove("tab_tooltip"),r.classList.remove("tab_outline"),s.classList.remove("tab_outline")}_eventTargetSelect(e){this._selectedThumb=e.target.id,this._dispatchValueChangeEndEvent()}_addElementFocus(e,t){e.classList.add("focus"),t.classList.add("focus")}_removeElementFocus(e,t){e.classList.remove("focus"),t.classList.remove("focus")}_renderStepMarkersRange(){if(0===this.step)return;let e,t,o;e=this.shadowRoot.querySelector(".range-track"),t=this.shadowRoot.querySelector("#range_step_ticks"),o=e.offsetWidth,this.getCalculatedStepDistance(o,this.min,this.max,this.step).distance>=32?(t.classList.add("markers"),this.calculatePoints(o)):t.classList.remove("markers")}_onTickClick(e){e.stopPropagation();const t=parseFloat(this.shadowRoot.querySelector("#upper").value),o=parseFloat(this.shadowRoot.querySelector("#lower").value),i=Number(e.target.dataset.value);i>t?this.upperValue=i:i<o&&(this.lowerValue=i)}_thumbOverlapValueCheckRange(e){"lower"===e.target.id?this._thumbOverlapLowerValueCheckRange():this._thumbOverlapUpperValueCheckRange()}_thumbOverlapLowerValueCheckRange(){const e=this.shadowRoot.querySelector("#lower"),t=this.shadowRoot.querySelector("#upper");e.value=Math.min(e.value,t.value),this._updateLowerValue()}_thumbOverlapUpperValueCheckRange(){const e=this.shadowRoot.querySelector("#lower"),t=this.shadowRoot.querySelector("#upper");t.value=Math.max(t.value,e.value),this._updateUpperValue()}_tooltipSelection(){const e=this.shadowRoot.querySelector("#lower"),t=this.shadowRoot.querySelector("#upper"),o=this.shadowRoot.querySelector("#lowerRangeTooltip"),i=this.shadowRoot.querySelector("#upperRangeTooltip");this._tooltipCalulations(e,o),this._tooltipCalulations(t,i)}_tooltipCalulations(e,t){let o=Number(100*(e.value-e.min)/(e.max-e.min));Number.isNaN(o)&&(o=0),this.setTooltipRange(o,t)}_generateHandleTrack(){const e=this.shadowRoot.querySelector("#handleTrackWrapper"),t=this.shadowRoot.querySelector("#lower"),o=this.shadowRoot.querySelector("#upper");let i,r,s,n,a;i=100*(t.value-this.min)/(this.max-this.min),r=100*(o.value-this.min)/(this.max-this.min),s=this.shadowRoot.querySelector("#rangeWrapper").getBoundingClientRect().width/wi,n=i/100*parseFloat(s),a=r/100*parseFloat(s),e.style.left=parseFloat(n)+"rem",this.upperValue===this.lowerValue?e.style.width="0rem":e.style.width=parseFloat(a)-parseFloat(n)+"rem"}_thumbDown(e){if(this._isDrag=!0,this._selectedThumb=e.target.id,"handleTrackWrapper"===this._selectedThumb||"handleTrack"===this._selectedThumb){e.preventDefault();const t=this.shadowRoot.querySelector("#handleTrackWrapper").getBoundingClientRect();e.touches?this.initialX=(e.touches[0].clientX-t.left)/wi:this.initialX=(e.clientX-t.left)/wi,this.shadowRoot.querySelector("#handleTrack").classList.add("active"),this.shadowRoot.querySelector("#upper").classList.add("active"),this.shadowRoot.querySelector("#lower").classList.add("active")}else"lower"===this._selectedThumb?this.shadowRoot.querySelector("#lower").classList.add("thumbActive"):"upper"===this._selectedThumb&&this.shadowRoot.querySelector("#upper").classList.add("thumbActive")}_thumbMove(e){this._isDrag&&("handleTrackWrapper"!==this._selectedThumb&&"handleTrack"!==this._selectedThumb||this._moveThumbOnTrack(e),this.showValue||(this.shadowRoot.querySelector("#lowerRangeTooltip").style.display="block",this.shadowRoot.querySelector("#upperRangeTooltip").style.display="block"))}_thumbUp(){this._isDrag&&(this._isDrag=!1,this.shadowRoot.querySelector("#handleTrack").classList.remove("active"),this.shadowRoot.querySelector("#lower").classList.remove("active"),this.shadowRoot.querySelector("#upper").classList.remove("active"),this.shadowRoot.querySelector("#lower").classList.remove("thumbActive"),this.shadowRoot.querySelector("#upper").classList.remove("thumbActive"),this.shadowRoot.querySelector("#lowerRangeTooltip").style.display="",this.shadowRoot.querySelector("#upperRangeTooltip").style.display="")}_isDragObserver(){this._isDrag||this._dispatchValueChangeEndEvent()}_moveThumbOnTrack(e){e.touches&&e.preventDefault(),this._calculatePositionInTrack(e),this._adjustThumbPositionToHandle()}_calculatePositionInTrack(e){const t=this.decimalNumberPrecision(),o=this.shadowRoot.querySelector("#rangeWrapper"),i=this.shadowRoot.querySelector("#handleTrackWrapper");let r,s,n,a,c,l;r=o.getBoundingClientRect(),s=window.getComputedStyle(o).width.split("p")[0]/wi,n=(e.clientX-r.left)/wi,void 0!==e.touches&&(n=(e.touches[0].clientX-r.left)/wi),a=i.style.width.split("r")[0],c=i.style.left.split("r")[0];let h=parseFloat(s);s-=a,n-=this.initialX,n=this._calcPositionForRangeJump(n,t);let d=parseFloat(c)+parseFloat(a);switch(l=parseFloat(d)/h*100*(this.max-this.min)/100+this.min,l=this._refineValueBasedOnStep(l,t),null!=n){case n<0:this._setThumbToPosition(0);break;case n>s:l+this.step<=this.max&&this._setThumbToPosition(s);break;case n>=0&&n<=s:this._setThumbToPosition(n);break;default:console.log("error adjusting thumb")}}_adjustThumbPositionToHandle(){const e=this.shadowRoot.querySelector("#handleTrackWrapper");let t,o,i,r;t=Number(e.style.left.split("r")[0]),o=Number(e.style.width.split("r")[0]),i=this._thumbPosition(t),r=this._thumbPosition(t+o),this.shadowRoot.querySelector("#lower").value=i,this.shadowRoot.querySelector("#upper").value=r,this._updateLowerValue(),this._updateUpperValue()}_thumbPosition(e){const t=this.decimalNumberPrecision();let o=this._calcThumbPosition(e);return o=this._refineValueBasedOnStep(o,t),o}_calcThumbPosition(e){let t,o,i;const r=this.shadowRoot.querySelector("#rangeWrapper");return t=window.getComputedStyle(r).width.split("p")[0]/wi,o=e/t*100,i=o*(this.max-this.min)/100+this.min,i}_calcPositionForRangeJump(e,t){const o=this.shadowRoot.querySelector("#rangeWrapper");let i,r,s,n;return i=window.getComputedStyle(o).width.split("p")[0]/wi,r=this._calcThumbPosition(e),s=this._refineValueBasedOnStep(r,t),n=100*(s-this.min)/(this.max-this.min),n*i/100}_refineValueBasedOnStep(e,t){let o,i,r,s,n=Number(e.toFixed(t))-this.min;return r=Math.round(n/this.step),s=this.step*r,o=n-s,o=Number(o.toFixed(t)),i=e-o,i=Number(i.toFixed(t)),i}decimalNumberPrecision(){let e,t,o;return e=this.step.toString(),t=this.min.toString(),o=0,e.includes(".")?o=Oi(e):t.includes(".")&&(o=Oi(t)),o}_setThumbToPosition(e){let t,o;t=this._selectedThumb,"handleTrack"===t&&(t="handleTrackWrapper"),o=this.shadowRoot.querySelector("#"+t),o.style.left=e+"rem"}_moveThumbOnRangeTrack(e){if(e.touches&&e.preventDefault(),!this._isDrag){let t,o,i,r;t=this.shadowRoot.querySelector("#rangeWrapper").getBoundingClientRect(),o=(e.clientX-t.left)/wi,void 0!==e.touches&&(o=(e.touches[0].clientX-t.left)/wi),r=this._thumbPosition(o),r<this.min&&(r=this.min),r>this.max&&(r=this.max),i=parseFloat(this.shadowRoot.querySelector("#upper").value),r>i?(this.shadowRoot.querySelector("#upper").value=r,this.upperValue=r,this._selectedThumb="upper"):(this.shadowRoot.querySelector("#lower").value=r,this.lowerValue=r,this._selectedThumb="upper"),this._dispatchValueChangeEndEvent()}}_updateLowerValue(){this.lowerValue=Number(this.shadowRoot.querySelector("#lower").value)}_updateUpperValue(){this.upperValue=Number(this.shadowRoot.querySelector("#upper").value)}_onKeyPress(e){if(e.keyCode!==me.ARROW_UP&&e.keyCode!==me.ARROW_DOWN&&e.keyCode!==me.ENTER)return;let t=e.target;this._updateSelectedThumbForValidation(e),e.keyCode===me.ARROW_UP&&(this._valueValidation(t),t.focus()),e.keyCode===me.ARROW_DOWN&&(this._valueValidation(t),t.focus()),e.keyCode===me.ENTER&&this._valueValidation(t)}_handleOnBlur(e){this._updateSelectedThumbForValidation(e),this._valueValidation(e.target)}_updateSelectedThumbForValidation(e){"lowerInputText"===e.target.id?this._selectedThumb="lower":this._selectedThumb="upper"}_valueValidation(e){let t=e.value;"lower"===this._selectedThumb?(e.value=this.getLowerValue(t,this.lowerValue,this.upperValue,this.min,this.max),this.lowerValue=Number(e.value)):(e.value=this.getUpperValue(t,this.lowerValue,this.upperValue,this.min,this.max),this.upperValue=Number(e.value)),this._dispatchValueChangeEndEvent()}disconnectedCallback(){window.removeEventListener("mousemove",this.boundMove),window.removeEventListener("mouseup",this.boundUp),super.disconnectedCallback()}_dispatchValueChangeEndEvent(){"handleTrackWrapper"===this._selectedThumb||"handleTrack"===this._selectedThumb?le(this,"range-value-change-end",{lowerValue:this.lowerValue,upperValue:this.upperValue}):"lower"===this._selectedThumb?le(this,"value-change-end",{lowerValue:this.lowerValue}):le(this,"value-change-end",{upperValue:this.upperValue})}}customElements.define("range-slider",Ni);const Fi=ie`
  :host {
    width: 100%;
    outline: 0;
    display: block;
  }
  :host([vertical]) {
    width: fit-content;
    width: -moz-fit-content;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  :host([vertical][right]) {
    float: right;
  }

  :host([show-range]) #inputText {
    display: none;
  }

  :host([vertical][show-controls]) .vertical-slider-wrapper {
    height: calc(100% - 4rem);
  }

  :host([vertical][direction-toggle]) .vertical-slider-wrapper,
  :host([vertical][direction-toggle][show-controls]) arrow-controls {
    transform: rotate(180deg);
  }

  :host([vertical][direction-toggle][show-controls]) arrow-controls {
    transform-style: preserve-3d;
  }

  :host([vertical][show-controls][show-value]) .vertical-slider-wrapper {
    height: calc(100% - 7.5rem);
  }

  :host([vertical][show-value]) .vertical-slider-wrapper {
    height: calc(100% - 4rem);
  }

  :host .outer-wrapper {
    position: relative;
    display: flex;
  }

  :host .sliderWrapper {
    position: relative;
    width: 100%;
    height: 2rem;
    outline: none;
    display: flex;
  }

  :host([show-controls]) .sliderWrapper {
    width: calc(100% - 4rem);
  }

  :host([vertical]) .verticalTrack {
    height: 0.125rem;
    width: 100%;
    position: relative;
    display: flex;
    outline: none;
    margin: 0;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-color: rgba(var(--ui-1), var(--opacity-6));
    opacity: unset;
    left: 0;
    right: 0;
    border: 0;
  }

  :host(.touch-device[vertical]) .verticalTrack {
    transform: rotate(0deg);
  }

  :host([vertical]) #inputLabel input {
    width: 50%;
    background: transparent;
    border: none;
    text-align: right;
    font: var(--body-1);
    line-height: 1rem;
    height: 1rem;
    padding: 0;
    outline: none;
    color: var(--text-secondary);
    -moz-appearance: textfield;
  }

  :host([vertical]) #inputLabel input:focus {
    width: 100% !important;
  }

  input[type='range']::-webkit-slider-thumb {
    box-shadow: none;
  }

  .sliderTrack::-webkit-slider-thumb,
  .verticalTrack::-webkit-slider-thumb {
    appearance: none;
    position: relative;
    width: 0.875rem;
    height: 0.875rem;
    cursor: pointer;
    border-radius: 50%;
    border: none;
    outline: 0;
    z-index: 1;
    background: rgba(var(--ui-5), var(--opacity-1));
    -webkit-appearance: none;
    user-select: none;
    -webkit-user-select: none;
    transition: var(--hover-transition-time) background;
  }

  :host(.touch-device) .sliderTrack::-webkit-slider-thumb,
  :host(.touch-device) .verticalTrack::-webkit-slider-thumb {
    background-clip: padding-box;
    border: 0.8125rem solid rgba(0, 0, 0, 0);
    box-sizing: unset;
  }

  :host(.touch-device) .sliderTrack::-webkit-slider-runnable-track,
  :host(.touch-device) .verticalTrack::-webkit-slider-runnable-track {
    margin-left: -0.8125rem;
    margin-right: -0.8125rem;
  }

  .sliderTrack::-webkit-slider-runnable-track,
  .verticalTrack::-webkit-slider-runnable-track {
    cursor: pointer;
  }

  .sliderTrack::-moz-range-track,
  .verticalTrack::-moz-range-track {
    cursor: pointer;
  }

  .sliderTrack::-moz-range-progress,
  .verticalTrack::-moz-range-progress {
    cursor: pointer;
  }

  .sliderTrack::-moz-range-thumb,
  .verticalTrack::-moz-range-thumb {
    position: relative;
    width: 0.875rem;
    height: 0.875rem;
    cursor: pointer;
    border-radius: 50%;
    border: none;
    z-index: 1;
    background: rgba(var(--ui-5), var(--opacity-1));
    transition: var(--hover-transition-time) background;
  }

  .sliderTrack::-moz-range-thumb,
  .verticalTrack::-moz-range-thumb {
    transform: translateZ(0);
  }

  :host(:not(.touch-device)) .sliderTrack::-webkit-slider-thumb:hover,
  :host(:not(.touch-device)) .verticalTrack::-webkit-slider-thumb:hover {
    background: rgba(var(--ui-2), var(--opacity-1));
  }

  :host(:not(.touch-device)) .active.sliderTrack::-webkit-slider-thumb,
  :host(:not(.touch-device)) .active.verticalTrack::-webkit-slider-thumb,
  :host .active.sliderTrack::-webkit-slider-thumb,
  :host .active.verticalTrack::-webkit-slider-thumb {
    background-color: rgba(var(--ui-3), var(--opacity-1));
  }

  :host(.touch-device) .active.sliderTrack::-webkit-slider-thumb,
  :host(.touch-device) .active.verticalTrack::-webkit-slider-thumb {
    border: 0.8125rem solid rgba(var(--ui-3), var(--opacity-5));
  }

  :host(:not(.touch-device)) .sliderTrack::-moz-range-thumb:hover,
  :host(:not(.touch-device)) .verticalTrack::-moz-range-thumb:hover {
    background: rgba(var(--ui-2), var(--opacity-1));
  }

  .sliderTrack::-moz-range-thumb:active,
  .verticalTrack::-moz-range-thumb:active {
    background: rgba(var(--ui-3), var(--opacity-1));
  }

  .sliderTrack::-webkit-slider-thumb:active,
  .verticalTrack::-webkit-slider-thumb:active {
    background: rgba(var(--ui-3), var(--opacity-1));
  }
  :host(:not(.touch-device)) .active.sliderTrack::-moz-range-thumb,
  :host(:not(.touch-device)) .active.verticalTrack::-moz-range-thumb,
  :host .active.sliderTrack::-moz-range-thumb,
  :host .active.verticalTrack::-moz-range-thumb {
    background: rgba(var(--ui-3), var(--opacity-1));
  }

  :host([vertical]) #inputLabel span {
    width: 50%;
    font: var(--body-1);
    line-height: 1rem;
    height: 1rem;
    color: rgba(var(--ui-1), var(--opacity-5));
    margin-left: 0.125rem;
  }

  :host .sliderTrack {
    width: 100%;
    height: 0.125rem;
    outline: 0;
    background-color: rgba(var(--ui-1), var(--opacity-6));
    position: absolute;
    -moz-appearance: none;
    -webkit-appearance: none;
    margin: 0.9375rem 0 0 0;
    opacity: unset;
    border: 0;
  }

  /* common styles */
  .label-wrapper {
    display: flex;
    justify-content: space-between;
  }

  .slider-label {
    flex: 1 1 auto;
    min-width: 3.375rem;
    font: var(--body-1);
    line-height: 1.5rem;
    font-weight: normal;
    color: var(--text-secondary);
    -webkit-font-smoothing: antialiased !important;
    text-rendering: optimizeLegibility !important;
    -moz-osx-font-smoothing: grayscale !important;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: 0.2s all ease-in-out;
  }

  :host(:not([vertical])) .slider-label {
    padding-right: 0.5rem;
  }

  :host([vertical]) .slider-label {
    text-align: center;
  }

  .label-wrapper input {
    display: none;
    outline: 0;
    border: none;
    width: 2.5rem;
    height: 1.5rem;
    font: var(--body-1);
    line-height: 1.5rem;
    color: var(--text-secondary);
    background: rgba(var(--ui-1), var(--opacity-7));
    border-radius: 0.125rem;
    box-sizing: border-box;
    padding: 0.25rem;
    transition: 0.2s all ease-in-out;
    text-align: center;
    -moz-appearance: textfield;
  }

  input::-webkit-inner-spin-button {
    display: none;
  }

  :host(:not([label])) .label-wrapper {
    display: none;
  }

  :host([show-value]) .label-wrapper input {
    display: inline-flex;
  }

  :host([show-value][vertical]) .label-wrapper input {
    display: none;
  }

  :host(:not([show-value])[vertical]) .label-wrapper {
    padding-bottom: 1rem;
  }

  /* Disabled Styles */
  :host([disabled]) {
    pointer-events: none;
  }

  :host([disabled]) ::-webkit-slider-thumb {
    background: rgba(var(--ui-6), var(--opacity-1));
  }

  :host([disabled]) ::-moz-range-thumb {
    background: rgba(var(--ui-6), var(--opacity-1));
  }

  :host([disabled]) #verticalSlider,
  :host([disabled]) #horizontalSlider {
    background: rgb(var(--ui-1), var(--opacity-7));
  }

  :host([disabled]) .slider-label,
  :host([disabled]) .label-wrapper input {
    color: var(--text-disabled);
    opacity: unset;
  }

  :host([disabled]) .tick-item,
  :host(.touch-device[vertical][disabled]) .tick-item:after {
    background: rgba(var(--ui-1), var(--opacity-4));
  }

  :host([disabled]) #verticalInput {
    color: var(--text-disabled) !important;
    opacity: unset;
  }

  /* Adjustment controls styles */
  :host([show-controls]:not([vertical])) arrow-controls {
    position: absolute;
    right: 0;
    top: -0.0625rem;
  }

  :host([show-controls][vertical]) arrow-controls {
    flex-direction: column;
    min-height: 4rem;
  }

  /* Tooltip styles */
  #verticalTooltip,
  #sliderTooltip {
    display: none;
    position: absolute;
    pointer-events: none;
    outline: 0;
    width: 2.5rem;
    height: 1.5rem;
    font: var(--body-1);
    text-align: center;
    color: var(--text-secondary);
    background: var(--base-3);
    box-shadow: var(--shadow-raised);
    border-radius: 0.125rem;
    box-sizing: border-box;
    padding: 0.25rem;
    z-index: 5;
  }

  :host .tick-item {
    cursor: pointer;
    border-radius: 50%;
    outline: 0;
    background: rgba(var(--ui-1), var(--opacity-1));
    margin-top: 0.625rem;
    -moz-appearance: none;
    -webkit-appearance: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
  }

  :host(.touch-device[vertical]) .tick-item {
    background: transparent;
  }

  .ticks-list {
    position: absolute;
    height: fit-content;
    height: -moz-fit-content;
    margin: 0;
    padding: 0;
    margin: 0 auto;
    top: 1rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    transition: var(--hover-transition-time) all;
  }

  :host([vertical]) .ticks-list {
    top: unset;
  }

  .ticks-list li {
    height: 0.375rem;
    width: 0.375rem;
    -moz-user-select: none;
    -webkit-user-select: none;
    list-style: none;
    position: absolute;
    margin: 0 !important;
  }

  :host(.touch-device[vertical]) .ticks-list li:after {
    content: '';
    position: absolute;
    height: 0.375rem;
    width: 0.375rem;
    z-index: -1;
    outline: 0;
    border-radius: 50%;
    margin: 0 !important;
    background: rgba(var(--ui-1), var(--opacity-1));
    margin-top: 0.625rem;
  }

  :host(:not(.touch-device)) .ticks-list li:hover {
    height: 0.5rem;
    width: 0.5rem;
    background: rgba(var(--ui-0), var(--opacity-1));
    -moz-user-select: none;
    -webkit-user-select: none;
    list-style: none;
    position: absolute;
  }

  .ticks-list li:active {
    -moz-user-select: none;
    -webkit-user-select: none;
  }

  :host(:not([show-value])) #inputLabel {
    display: none;
  }

  #inputLabel {
    background-color: rgba(var(--ui-1), var(--opacity-7));
    border-radius: 0.125rem;
    margin: auto;
    margin-bottom: 1rem;
    max-width: 4.5rem;
    min-width: 3.5rem;
    display: inline-flex;
    padding: 0.25rem;
    box-sizing: border-box;
    vertical-align: middle;
  }

  :host(:not([vertical])) #inputLabel {
    display: none;
  }

  #verticalTooltip {
    top: -0.5rem;
    left: 1.5rem;
    transform: rotate(-90deg);
    margin-top: -2.1875rem;
  }

  #sliderTooltip {
    margin: -1.375rem;
  }

  :host([vertical][right]) #verticalTooltip {
    top: 3.5rem;
  }

  :host([vertical][direction-toggle]) #verticalTooltip {
    top: 3.5rem;
    transform: rotate(90deg);
  }

  :host([vertical][right][direction-toggle]) #verticalTooltip {
    bottom: 3.5rem;
    top: -0.5rem;
  }

  :host(:not([show-value]):hover:not(.touch-device)) #sliderTooltip,
  :host(:not([show-value]):hover:not(.touch-device)) #verticalTooltip,
  #label-wrapper.hover #sliderTooltip {
    display: block;
  }

  :host .ticks_collision::-webkit-slider-thumb {
    background-color: rgba(var(--ui-0), var(--opacity-1)) !important;
  }

  :host(:not(.touch-device)) .ticks_collision::-webkit-slider-thumb:hover {
    background-color: rgba(var(--ui-2), var(--opacity-1)) !important;
  }

  :host(:not(.touch-device)) .active.ticks_collision::-webkit-slider-thumb {
    background-color: rgba(var(--ui-0), var(--opacity-1)) !important;
  }

  :host .ticks_collision::-moz-range-thumb {
    background-color: rgba(var(--ui-0), var(--opacity-1)) !important;
  }

  :host(:not(.touch-device)) .ticks_collision::-moz-range-thumb:hover {
    background-color: rgba(var(--ui-2), var(--opacity-1)) !important;
  }

  :host .sh-step-thumb-item {
    cursor: pointer;
    outline: 0;
    background: rgba(var(--ui-1), var(--opacity-6));
    -moz-appearance: none;
    -webkit-appearance: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
  }

  :host(.touch-device[vertical]) .tick_collision_z,
  :host(.touch-device[vertical]) .sh-step-thumb-item {
    z-index: -1;
  }

  :host([vertical]) .step_ticks {
    top: unset;
  }

  .step_ticks {
    position: absolute;
    padding: 0;
    margin: 0 auto;
    top: 1.03125rem;
    display: none;
    flex-direction: row;
    align-items: center;
  }

  .step_ticks li {
    height: 0.5rem;
    width: 0.0625rem;
    -moz-user-select: none;
    -webkit-user-select: none;
    list-style: none;
    position: absolute;
  }

  :host([disabled]) .sh-step-thumb-item {
    background: rgba(var(--ui-1), var(--opacity-7));
  }

  :host .markers.step_ticks {
    display: flex;
  }

  :host(:not([show-range])) .markers.step_ticks {
    height: fit-content;
  }

  /* vertical slider */
  :host([vertical]) .vertical-slider-wrapper {
    width: 2rem;
    height: calc(100% - 1.5rem);
    box-sizing: border-box;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  :host([vertical]) .vertical-wrapper {
    transform: rotate(90deg);
    display: flex;
    width: fit-content;
    align-items: center;
  }

  /* tab-outline */
  :host .tab_outline::-webkit-slider-thumb {
    outline: var(--focus-outline);
    background: rgba(var(--ui-2), var(--opacity-1));
  }

  :host .tab_outline::-moz-range-thumb {
    outline: var(--focus-outline);
    background: rgba(var(--ui-2), var(--opacity-1));
  }

  :host(:not([show-value])) .tab_tooltip#sliderTooltip,
  :host(:not([show-value])) .tab_tooltip#verticalTooltip {
    display: block;
  }

  :host([vertical]) .textbox_click#verticalMax {
    visibility: hidden;
    width: 0%;
  }

  :host([vertical]) .text_align#verticalInput {
    text-align: center;
  }

  :host([vertical][hide-max]) #verticalMax {
    display: none;
  }
  :host([vertical][hide-max]) #verticalInput {
    width: 100%;
    text-align: center;
  }
  :host(.touch-device) input[type='range'],
  :host(.touch-device) input[type='range']:focus {
    user-select: none;
    -webkit-user-select: none;
  }
`,$i=3/wi;class Ii extends(Ti(Pi(Ri(Bi(se))))){static get properties(){return{label:{type:String,reflect:!0},value:{type:Number,reflect:!0},min:{type:Number,reflect:!0},max:{type:Number,reflect:!0},step:{type:Number,reflect:!0},showValue:{type:Boolean,reflect:!0,attribute:"show-value"},disabled:{type:Boolean,reflect:!0},showControls:{type:Boolean,reflect:!0,attribute:"show-controls"},showRange:{type:Boolean,reflect:!0,attribute:"show-range"},upperValue:{type:Number,reflect:!0,attribute:"upper-value"},lowerValue:{type:Number,reflect:!0,attribute:"lower-value"},hideMax:{type:Boolean,reflect:!0,attribute:"hide-max"},ticks:{type:Array,reflect:!0},vertical:{type:Boolean,reflect:!0},directionToggle:{type:Boolean,reflect:!0,attribute:"direction-toggle"},right:{type:Boolean,reflect:!0},_renderedTicks:{type:Array,readOnly:!0},stepMarkers:{type:Array,readOnly:!0},_selectedThumb:{type:String},_isDrag:{type:Boolean,reflect:!0},_ticksRendered:{type:Boolean,reflect:!0}}}static get styles(){return Fi}render(){return V`
      ${this.label&&!this.showRange?V` <div class="label-wrapper">
            <div class="slider-label">${this.label}</div>
            ${this.vertical?"":V` <input
                  id="inputText"
                  type="number"
                  min="${this.min}"
                  max="${this.max}"
                  step="${this.step}"
                  .value="${this.value}"
                  ?disabled="${this.disabled}"
                  @keyup="${this._onKeyPress}"
                  @blur="${this._handleOnBlur}"
                />`}
          </div>`:""}
      ${this.showRange?V`
            <range-slider
              .label="${this.label}"
              .min="${this.min}"
              .max="${this.max}"
              .step="${this.step}"
              .lowerValue="${this.lowerValue}"
              .upperValue="${this.upperValue}"
              .showValue="${this.showValue}"
              ?disabled="${this.disabled}"
            ></range-slider>
          `:V` ${this.vertical?V` <div id="inputLabel">
                  <input
                    type="number"
                    id="verticalInput"
                    min="${this.min}"
                    max="${this.max}"
                    step="${this.step}"
                    .value="${this.value}"
                    ?disabled="${this.disabled}"
                    @keyup="${this._onKeyPress}"
                    @blur="${this._handleOnBlur}"
                    @focus="${this._verticalInputClickActions}"
                    @focusout="${this._verticalInputFousOutActions}"
                  />
                  <span
                    id="verticalMax"
                    @click="${this._verticalInputClickActions}"
                    @focusout="${this._verticalInputFousOutActions}"
                    >/${this.max}</span
                  >
                </div>
                <div class="vertical-slider-wrapper">
                  <div class="vertical-wrapper">
                    <input
                      type="range"
                      id="verticalSlider"
                      class="verticalTrack"
                      min="${this.min}"
                      max="${this.max}"
                      label="${this.label}"
                      step="${this.step}"
                      .value="${this.value}"
                      ?disabled="${this.disabled}"
                      @mousedown="${this._thumbDown}"
                      @mousemove="${this._thumbMove}"
                      @mouseup="${this._thumbUp}"
                      @touchstart="${this._thumbDown}"
                      @touchmove="${this._thumbMove}"
                      @touchend="${this._thumbUp}"
                      @click="${this._updateValue}"
                    />
                    <div id="verticalTooltip">${this.value}</div>
                    <ul id="vertical_step_ticks" class="step_ticks">
                      ${this.stepMarkers.map((e=>V` <li
                          class="sh-step-thumb-item"
                          @click="${e=>this._onTickClick(e)}"
                          data-value="${e.position}"
                          style="${e.style}"
                        ></li>`))}
                    </ul>
                    ${this.ticks?V` <ul id="ticks_list" class="ticks-list">
                          ${this._renderedTicks.map((e=>V` <li
                              class="tick-item"
                              data-value="${e.position}"
                              style="${e.style}"
                              @click="${e=>this._onTickClick(e)}"
                            ></li>`))}
                        </ul>`:""}
                  </div>
                </div>
                ${this.showControls?V` <arrow-controls
                      .parentElement="${this}"
                      .min="${this.min}"
                      .max="${this.max}"
                      .step="${this.step}"
                      .value="${this.value}"
                      ?disabled="${this.disabled}"
                    ></arrow-controls>`:""}`:V` <div class="outer-wrapper">
                <div class="sliderWrapper">
                  <input
                    type="range"
                    id="horizontalSlider"
                    class="sliderTrack"
                    min="${this.min}"
                    max="${this.max}"
                    label="${this.label}"
                    step="${this.step}"
                    .value="${this.value}"
                    ?disabled="${this.disabled}"
                    @mousedown="${this._thumbDown}"
                    @mousemove="${this._thumbMove}"
                    @mouseup="${this._thumbUp}"
                    @touchstart="${this._thumbDown}"
                    @touchmove="${this._thumbMove}"
                    @touchend="${this._thumbUp}"
                    @click="${this._updateValue}"
                  />
                  <div id="sliderTooltip">${this.value}</div>
                  <ul id="step_ticks" class="step_ticks">
                    ${this.stepMarkers.map((e=>V` <li
                        class="sh-step-thumb-item"
                        @click="${e=>this._onTickClick(e)}"
                        data-value="${e.position}"
                        style="${e.style}"
                      ></li>`))}
                  </ul>
                  ${this.ticks?V` <ul id="ticks_list" class="ticks-list">
                        ${this._renderedTicks.map((e=>V` <li
                            class="tick-item"
                            data-value="${e.position}"
                            style="${e.style}"
                            @click="${e=>this._onTickClick(e)}"
                          ></li>`))}
                      </ul>`:""}
                </div>
                ${this.showControls?V` <arrow-controls
                      horizontal
                      .parentElement="${this}"
                      .min="${this.min}"
                      .max="${this.max}"
                      .step="${this.step}"
                      .value="${this.value}"
                      ?disabled="${this.disabled}"
                    ></arrow-controls>`:""}
              </div>`}`}
    `}constructor(){super(),this.value=this.lowerValue=this.upperValue=0,this.min=0,this.max=100,this.step=1,this.label="Label",this.ticks=this.stepMarkers=this._renderedTicks=[]}updated(e){e.has("value")&&(this._updateValue(),this._tooltipSelection()),e.has("ticks")&&(this._thumbTickCollisionCheck=!0,this._renderTicks()),e.has("step")&&(this.showRange||this._renderStepMarkers(),this._updateValue()),(e.has("min")||e.has("max"))&&(this._renderTicks(),this.showRange||this._renderStepMarkers(),this._updateValue(),this._tooltipSelection()),e.has("disabled")&&!this.showRange&&this._checkTickThumbCollision(),e.has("_isDrag")&&this._isDragObserver(),e.has("_ticksRendered")&&this._ticksRendered&&(!this.showRange&&this._thumbTickCollisionCheck&&(this._checkTickThumbCollision(),this._thumbTickCollisionCheck=!1),this._ticksRendered=!1),he(this,e,["value","min","max","step","label","showControls","showRange","disabled"])}connectedCallback(){super.connectedCallback(),this.browserResize=new ResizeObserver((()=>{if(this.vertical){const e=this.shadowRoot.querySelector(".vertical-slider-wrapper"),t=this.shadowRoot.querySelector(".verticalTrack"),o=e.getBoundingClientRect().height/wi;t.style.setProperty("width",`${o}rem`),this.classList.contains("touch-device")&&this.verticalTickCollisionForTouchCheck()}this._renderTicks(),this.showRange?(this.shadowRoot.querySelector("range-slider")._generateHandleTrack(),this.shadowRoot.querySelector("range-slider")._renderStepMarkersRange()):this._renderStepMarkers()})),this.browserResize.observe(this)}firstUpdated(){if(ue.isTouchDevice()&&this.classList.add("touch-device"),this.showRange)this.shadowRoot.querySelector("range-slider").addEventListener("lower-value-changed",(e=>{this.lowerValue=e.target.lowerValue})),this.shadowRoot.querySelector("range-slider").addEventListener("upper-value-changed",(e=>{this.upperValue=e.target.upperValue}));else{let e,t;this.showControls&&(this.shadowRoot.querySelector("arrow-controls").addEventListener("control-value-change",(e=>{e.stopPropagation(),this.value=e.target.value})),this.shadowRoot.querySelector("arrow-controls").addEventListener("control-value-change-end",(e=>{e.stopPropagation(),this._dispatchValueChangeEndEvent()}))),this.vertical?(e=this.shadowRoot.querySelector(".verticalTrack"),t=this.shadowRoot.querySelector("#verticalTooltip")):(e=this.shadowRoot.querySelector(".sliderTrack"),t=this.shadowRoot.querySelector("#sliderTooltip")),e.addEventListener("input",(()=>{this._tooltipSelection(),this._updateValue()})),e.addEventListener("focus",(()=>this._handleFocus(e,t))),e.addEventListener("blur",(()=>this._handleBlur(e,t)))}}_handleFocus(e,t){e.onkeyup=o=>{t.classList.add("tab_tooltip"),o.keyCode===me.TAB&&e.classList.add("tab_outline"),o.keyCode!==me.ARROW_RIGHT&&o.keyCode!==me.ARROW_UP||(this._updateValue(),this._dispatchValueChangeEndEvent()),o.keyCode!==me.ARROW_LEFT&&o.keyCode!==me.ARROW_DOWN||(this._updateValue(),this._dispatchValueChangeEndEvent())}}_handleBlur(e,t){e.classList.remove("tab_outline"),t.classList.remove("tab_tooltip")}_renderTicks(){if(this.showRange)return;let e,t;e=this.vertical?this.shadowRoot.querySelector("#verticalSlider"):this.shadowRoot.querySelector("#horizontalSlider"),t=e.offsetWidth/wi-2*$i;const o=this.ticks.map((e=>{let o,i=(e-this.min)/(this.max-this.min);return i*=t,o=`left: ${i}rem`,{style:o,position:e}}));this.setReadOnlyProperties({_renderedTicks:o}),this._ticksRendered=!0}_renderStepMarkers(){if(0===this.step)return;let e,t,o;this.vertical?(e=this.shadowRoot.querySelector(".verticalTrack"),t=this.shadowRoot.querySelector("#vertical_step_ticks")):(e=this.shadowRoot.querySelector(".sliderTrack"),t=this.shadowRoot.querySelector("#step_ticks")),o=e.offsetWidth,this.getCalculatedStepDistance(o,this.min,this.max,this.step).distance>=32?(t.classList.add("markers"),this.calculatePoints(o)):t.classList.remove("markers")}_onTickClick(e){this.value=Number(e.target.dataset.value)}_updateValue(){let e;this.showRange||(e=this.vertical?this.shadowRoot.querySelector(".verticalTrack"):this.shadowRoot.querySelector(".sliderTrack"),this.value=Number(e.value))}_verticalInputClickActions(){this.shadowRoot.querySelector("#verticalMax").classList.add("textbox_click"),this.shadowRoot.querySelector("#verticalInput").classList.add("text_align"),this.shadowRoot.querySelector("#verticalInput").focus()}_verticalInputFousOutActions(){this.shadowRoot.querySelector("#verticalMax").classList.remove("textbox_click"),this.shadowRoot.querySelector("#verticalInput").classList.remove("text_align")}_tooltipSelection(){if(!this.showRange){let e,t;this.vertical?(e=this.shadowRoot.querySelector(".verticalTrack"),t=this.shadowRoot.querySelector("#verticalTooltip")):(e=this.shadowRoot.querySelector(".sliderTrack"),t=this.shadowRoot.querySelector("#sliderTooltip"));let o=Number(100*(e.value-e.min)/(e.max-e.min));Number.isNaN(o)&&(o=0),this.setTooltip(o,t),this._checkTickThumbCollision()}}_thumbDown(){this._isDrag=!0,this.vertical?this.shadowRoot.querySelector(".verticalTrack").classList.add("active"):this.shadowRoot.querySelector(".sliderTrack").classList.add("active")}_thumbMove(){this._isDrag&&(this.showValue||(this.vertical?this.shadowRoot.querySelector("#verticalTooltip").style.display="block":this.shadowRoot.querySelector("#sliderTooltip").style.display="block"),this._updateValue())}_thumbUp(){this._isDrag&&(this._isDrag=!1,this.vertical?(this.shadowRoot.querySelector("#verticalTooltip").style.display="",this.shadowRoot.querySelector(".verticalTrack").classList.remove("active")):(this.shadowRoot.querySelector("#sliderTooltip").style.display="",this.shadowRoot.querySelector(".sliderTrack").classList.remove("active")))}_isDragObserver(){this._isDrag||this._dispatchValueChangeEndEvent()}_onKeyPress(e){if(e.keyCode!==me.ARROW_UP&&e.keyCode!==me.ARROW_DOWN&&e.keyCode!==me.ENTER)return;let t=e.target;e.keyCode===me.ARROW_UP&&(this._valueValidation(t),t.focus()),e.keyCode===me.ARROW_DOWN&&(this._valueValidation(t),t.focus()),e.keyCode===me.ENTER&&this._valueValidation(t)}_handleOnBlur(e){this._valueValidation(e.target)}_valueValidation(e){let t=e.value;e.value=this.getValue(t,this.value,this.min,this.max),this.value=Number(e.value),this._dispatchValueChangeEndEvent()}verticalTickCollisionForTouchCheck(){const e=this.shadowRoot.querySelector(".verticalTrack"),t=Te(.4375);let o=e.offsetWidth-2*t,i=(Number(e.value)-this.min)/(this.max-this.min);i*=o;const r=i-Te(.8125),s=r+Te(2.5),n=Te(.1875);o=e.offsetWidth-2*n;const a=[];this.ticks.map((e=>{let t=(e-this.min)/(this.max-this.min);t*=o,a.push(this.detectCollision(r,s,t,t+2*n))}));const c=this.shadowRoot.querySelectorAll(".tick-item");for(let e=0;e<c.length;++e)a[e]?c[e].classList.add("tick_collision_z"):c[e].classList.remove("tick_collision_z")}detectCollision(e,t,o,i){return!(e<o&&t<o||e>i&&t>i)}_checkTickThumbCollision(){let e;const t=this.shadowRoot.querySelectorAll(".tick-item");e=this.vertical?this.shadowRoot.querySelector(".verticalTrack"):this.shadowRoot.querySelector(".sliderTrack"),e.classList.remove("ticks_collision");for(let e=0;e<t.length;e++)t[e].classList.remove("tick_collision_z");for(let o=0;o<t.length;o++)if(this.value===this.ticks[o]&&!this.disabled){t[o].classList.add("tick_collision_z"),e.classList.add("ticks_collision");break}this.classList.contains("touch-device")&&this.vertical&&this.verticalTickCollisionForTouchCheck()}_dispatchValueChangeEndEvent(){setTimeout((()=>{le(this,"value-change-end",{value:this.value})}),0)}}customElements.define("sh-slider",Ii);var Vi=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-spinner-width-s=2rem] - spinner width of s size
   */
  --sh-spinner-width-s: 2rem;
  /* 
   * @cssprop [--sh-spinner-height-s=2rem] - spinner height of s size
   */
  --sh-spinner-height-s: 2rem;
  /* 
   * @cssprop [--sh-spinner-width-m=3rem] - spinner width of m size
   */
  --sh-spinner-width-m: 3rem;
  /* 
   * @cssprop [--sh-spinner-height-m=3rem] - spinner height of m size
   */
  --sh-spinner-height-m: 3rem;
  /* 
   * @cssprop [--sh-spinner-border-width=0.25rem] - border width of s size
   */
  --sh-spinner-border-width: 0.25rem;
  /* 
   * @cssprop [--sh-spinner-label-height=1rem] - label height
   */
  --sh-spinner-label-height: 1rem;
  /* 
   * @cssprop [--sh-spinner-label-line-height=1.125rem] - label line height
   */
  --sh-spinner-label-line-height: 1.125rem;
  /* 
   * @cssprop [--sh-spinner-margin-top=0.5rem] - label margin top
   */
  --sh-spinner-margin-top: 0.5rem;
}

:host {
  transition: var(--transition-time) all ease-in-out;
  width: 100% !important;
  display: block;
}

:host([size=s]) .loader {
  width: var(--sh-spinner-width-s);
  height: var(--sh-spinner-height-s);
}

:host([size=m]) .loader {
  height: var(--sh-spinner-width-m);
  width: var(--sh-spinner-width-m);
}

:host([overlay]) {
  position: fixed;
  top: 0rem;
  left: 0rem;
  width: 100%;
  height: 100%;
  background-color: rgba(var(--ui-7), var(--opacity-4));
  z-index: 999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

:host([overlay]) .loader {
  margin: 0;
}

.loader {
  margin: auto;
  border-radius: 50%;
  box-sizing: border-box;
  border-width: var(--sh-spinner-border-width);
  border-style: solid;
  border-left-color: rgba(var(--ui-1), var(--opacity-6));
  border-right-color: rgba(var(--ui-1), var(--opacity-6));
  border-bottom-color: rgba(var(--ui-1), var(--opacity-6));
  border-top-color: rgba(var(--ui-2), var(--opacity-1));
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: rotate 1s infinite linear;
  animation: rotate 1s infinite linear;
}

@-webkit-keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.spinner-label {
  font: var(--body-1);
  color: var(--text-secondary);
  text-align: center;
  margin-top: var(--sh-spinner-margin-top);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  line-height: var(--sh-spinner-label-height);
  height: var(--sh-spinner-label-line-height);
}`;customElements.define("sh-spinner",class extends se{static get properties(){return{label:{type:String,reflect:!0},size:{type:String,reflect:!0},overlay:{type:Boolean,reflect:!0}}}static get styles(){return[Vi]}render(){return V`
      <div class="loader"></div>
      ${this.label?V` <div class="spinner-label">${this.label}</div> `:""}
    `}constructor(){super(),this.size="m"}}),customElements.define("sh-splash-screen",class extends se{static get properties(){return{modal:{type:Boolean,reflect:!0},label:{type:String,reflect:!0},image:{type:String,reflect:!0},version:{type:String,reflect:!0},info:{type:String,reflect:!0},progress:{type:Number,reflect:!0},logo:{type:String,reflect:!0},_emptyInfo:{type:Boolean,reflect:!0,attribute:"empty-info"}}}static get styles(){return[ae,ie`
        :host {
          position: absolute;
          top: 0rem;
          left: 0rem;
          height: 100%;
          width: 100%;
          z-index: 5;
          align-items: center;
          justify-content: center;
          display: flex;
          background-color: rgba(0, 0, 0, 0.6);
        }

        sh-card {
          height: 100%;
          width: 100%;
        }

        :host([modal]) sh-card {
          height: fit-content;
          height: -moz-fit-content;
          height: -ms-fit-content;
          min-height: 35rem;
          width: 50rem;
          max-width: calc(100% - 1rem);
        }

        .logo {
          padding: 1rem;
          height: 3rem;
          width: fit-content;
          width: -moz-fit-content;
          width: -ms-fit-content;
        }
        :host([logo]) .logo {
          width: 8.125rem;
        }
        .logo img {
          height: 100%;
        }
        .siemens {
          fill: var(--logo-2);
        }

        .healthineers {
          fill: var(--logo-1);
        }

        /* progress bar */
        :host(:not([progress])) sh-progress,
        :host([progress]) .data-wrapper ::slotted(*) {
          display: none;
        }

        .data-wrapper > ::slotted(*) {
          margin-bottom: 0.5rem;
        }

        .data-wrapper {
          width: 30rem;
          max-width: 100%;
          min-height: 23.8125rem;
          margin: 1rem auto 0rem;
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        :host(:not([label])) .label {
          display: none;
        }

        .label {
          text-align: center;
          font-size: 1.875rem;
          margin-top: 1rem;
          word-break: break-word;
        }

        :host(:not([version])) .label {
          margin-bottom: 2rem;
        }

        sh-text[header-2] {
          margin-top: 0.5rem;
          margin-bottom: 2rem;
          max-height: 1.5rem;
          min-height: 1.5rem;
          overflow: hidden;
          text-align: center;
          font: var(--header-2);
          line-height: 1.5rem;
        }

        .content-wrapper {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
        }

        :host([image]) .content-wrapper {
          width: calc(50% - 0.5rem);
        }

        /* footer */
        .footer-wrapper {
          width: 100%;
          display: flex;
          margin-top: 1.5rem;
          margin-bottom: 1rem;
          justify-content: flex-end;
          align-items: center;
        }

        .footer-wrapper > ::slotted(*) {
          margin-left: 0.5rem;
        }

        .info {
          display: none;
        }

        .footer-text {
          display: inline-grid;
          align-items: self-end;
          margin-top: 1rem;
          max-height: 2rem;
          height: 2rem;
          overflow: hidden;
        }

        :host([empty-info]) .info {
          display: inline-grid;
          align-items: self-end;
          margin-top: 1rem;
          max-height: 2rem;
          height: 2rem;
          overflow: hidden;
        }

        :host(:not([info])) .info {
          display: none;
        }

        :host([info][empty-info]) .footer-text {
          display: none;
        }

        /* image */
        :host([image]) .image {
          flex: 1;
          margin: -1rem -1rem -1rem 1rem;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
        }

        /* small screens */
        @media only screen and (max-width: 30rem) {
          .logo {
            margin: auto;
          }
        }

        @media only screen and (max-width: 47.9375rem) {
          sh-card {
            height: 100% !important;
            width: 100% !important;
            max-height: unset !important;
            max-width: unset !important;
          }
          .info {
            text-align: center;
          }
          .image {
            display: none;
          }
          .content-wrapper {
            width: 100% !important;
          }
        }
      `]}render(){return V`
      <sh-card class="card">
        <div style="display: flex; height: 100%;" ?empty-info=${this._emptyInfo}>
          <div class="content-wrapper">
            <div class="logo">
              ${this.logo?V` <img .src="${this.logo}" /> `:V` <svg
                    xmlns:svg="http://www.w3.org/2000/svg"
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    style="height:3rem"
                    viewBox="-1.24339497 -1.24339497 179.20878994 43.93328894"
                  >
                    <path
                      class="healthineers"
                      d="m 146.66688,22.51125 c 0.23875,0.23875 0.55125,0.35875 0.865,0.35875 0.3125,0 0.62625,-0.12 0.86375,-0.35875 0.24,-0.23875 0.35875,-0.55125 0.35875,-0.865 0,-0.3125 -0.11875,-0.625 -0.35875,-0.865 -0.2375,-0.23875 -0.55125,-0.3575 -0.86375,-0.3575 -0.31375,0 -0.62625,0.11875 -0.865,0.3575 -0.23875,0.24 -0.35875,0.5525 -0.35875,0.865 0,0.31375 0.12,0.62625 0.35875,0.865 m 6.16875,-6.16863 c 0.31,0.31 0.71625,0.465 1.12375,0.465 0.40625,0 0.81374,-0.155 1.12375,-0.465 0.31125,-0.31 0.46499,-0.7175 0.46499,-1.12375 0,-0.4075 -0.15375,-0.81375 -0.46499,-1.12375 -0.31001,-0.31 -0.7175,-0.46625 -1.12375,-0.46625 -0.4075,0 -0.81375,0.15625 -1.12375,0.46625 -0.31001,0.31 -0.465,0.71625 -0.465,1.12375 0,0.40625 0.155,0.81375 0.465,1.12375 m -0.008,12.84888 c 0.31,0.31 0.71625,0.465 1.12375,0.465 0.40625,0 0.81375,-0.155 1.12375,-0.465 0.31125,-0.31 0.465,-0.7175 0.465,-1.12375 0,-0.4075 -0.15376,-0.81375 -0.465,-1.12375 -0.31,-0.31 -0.7175,-0.46625 -1.12375,-0.46625 -0.4075,0 -0.81375,0.15625 -1.12375,0.46625 -0.31,0.31 -0.465,0.71625 -0.465,1.12375 0,0.40625 0.155,0.81375 0.465,1.12375 m 6.09812,-18.93988 c 0.40375,0.40375 0.9325,0.605 1.46125,0.605 0.52875,0 1.0575,-0.20125 1.46125,-0.605 0.40375,-0.40375 0.605,-0.9325 0.605,-1.46125 0,-0.52875 -0.20125,-1.0575 -0.605,-1.46125 -0.40375,-0.40375 -0.9325,-0.605 -1.46125,-0.605 -0.52875,0 -1.0575,0.20125 -1.46125,0.605 -0.40375,0.40375 -0.605,0.9325 -0.605,1.46125 0,0.52875 0.20125,1.0575 0.605,1.46125 m -0.008,12.84875 c 0.40375,0.40375 0.9325,0.605 1.46125,0.605 0.52875,0 1.0575,-0.20125 1.46125,-0.605 0.40375,-0.40375 0.605,-0.9325 0.605,-1.46125 0,-0.52875 -0.20125,-1.0575 -0.605,-1.46125 -0.40375,-0.40375 -0.9325,-0.605 -1.46125,-0.605 -0.52875,0 -1.0575,0.20125 -1.46125,0.605 -0.40375,0.40375 -0.605,0.9325 -0.605,1.46125 0,0.52875 0.20125,1.0575 0.605,1.46125 m -0.007,12.84925 c 0.40375,0.40375 0.9325,0.605 1.46125,0.605 0.52875,0 1.0575,-0.20125 1.46125,-0.605 0.40375,-0.40375 0.605,-0.9325 0.605,-1.46125 0,-0.52875 -0.20125,-1.0575 -0.605,-1.46125 -0.40375,-0.40375 -0.9325,-0.605 -1.46125,-0.605 -0.52875,0 -1.0575,0.20125 -1.46125,0.605 -0.40375,0.40375 -0.605,0.9325 -0.605,1.46125 0,0.52875 0.20125,1.0575 0.605,1.46125 m 5.99688,-18.839 c 0.52375,0.525 1.21125,0.78625 1.89875,0.78625 0.68875,0 1.37625,-0.26125 1.90125,-0.78625 0.52375,-0.52375 0.78625,-1.21125 0.78625,-1.89875 0,-0.6875 -0.2625,-1.375 -0.7875,-1.9 -0.525,-0.525 -1.2125,-0.7875 -1.9,-0.7875 -0.6875,0 -1.375,0.2625 -1.89875,0.78625 -0.525,0.525 -0.7875,1.2125 -0.7875,1.9 0,0.68875 0.2625,1.37625 0.7875,1.9 m -0.006,12.84925 c 0.52375,0.525 1.21125,0.78625 1.89875,0.78625 0.68875,0 1.37625,-0.26125 1.90125,-0.78625 0.52375,-0.525 0.78625,-1.21125 0.78625,-1.89875 0,-0.6875 -0.2625,-1.375 -0.7875,-1.9 -0.525,-0.525 -1.2125,-0.7875 -1.9,-0.7875 -0.6875,0 -1.375,0.26125 -1.89875,0.78625 -0.525,0.525 -0.7875,1.2125 -0.7875,1.9 0,0.68875 0.2625,1.375 0.7875,1.9 m 5.85787,-5.858 c 0.6825,0.6825 1.575,1.02375 2.47,1.02375 0.89375,0 1.78625,-0.34125 2.46875,-1.02375 0.6825,-0.6825 1.02375,-1.57625 1.02375,-2.47 0,-0.89375 -0.34125,-1.78625 -1.02375,-2.46875 -0.6825,-0.6825 -1.575,-1.02375 -2.46875,-1.02375 -0.895,0 -1.7875,0.34125 -2.47,1.02375 -0.6825,0.6825 -1.02375,1.575 -1.02375,2.46875 0,0.89375 0.34125,1.7875 1.02375,2.47"
                      style="fill-opacity:1;fill-rule:nonzero;stroke:none"
                    ></path>
                    <path
                      class="siemens"
                      d="m 132.43,15.29 0,-3.0175 c 1.70125,0.54125 3.22125,0.81125 4.5575,0.81125 1.82375,0 2.73625,-0.48125 2.73625,-1.445 0,-0.36 -0.13,-0.66125 -0.3875,-0.90625 -0.2725,-0.26 -0.9725,-0.61875 -2.1,-1.07875 -2.0025,-0.82 -3.31625,-1.525 -3.93,-2.11375 -0.79,-0.76375 -1.18625,-1.7375 -1.18625,-2.92375 0,-1.5025 0.57375,-2.65 1.7275,-3.44 C 134.9825,0.3925 136.46625,0 138.295,0 c 1.02625,0 2.3575,0.16375 3.99,0.49125 l 0.3775,0.065 0,2.90125 c -1.41875,-0.56625 -2.7375,-0.84875 -3.96125,-0.84875 -1.705,0 -2.5575,0.47 -2.5575,1.41375 0,0.35125 0.1725,0.63875 0.51625,0.8625 0.27375,0.17125 1.07,0.5525 2.38375,1.14375 1.85,0.82625 3.08875,1.545 3.71125,2.1575 0.735,0.72625 1.1025,1.665 1.1025,2.8175 0,1.65375 -0.7175,2.91625 -2.1475,3.78625 -1.1725,0.70375 -2.68875,1.05625 -4.5425,1.05625 -1.56875,0 -3.14875,-0.185 -4.7375,-0.55625 m -6.0335,-15.02513 0,10.22375 -5.24375,-10.22375 -4.945,0 0,15.2725 3.005,0 0,-10.36 5.385,10.36 4.80375,0 0,-15.2725 -3.005,0 z m -24.11275,0 0,15.2725 11.1175,0 0,-2.91875 -7.00625,0 0,-3.62375 5.945,0 0,-2.51875 -5.945,0 0,-3.4475 6.82875,0 0,-2.76375 -10.94,0 z m -9.16475,0 -3.94,9.7575 -3.84125,-9.7575 -5.53125,0 0,15.2725 3.005,0 0,-10.8125 4.3925,10.96625 2.645,0 4.47875,-10.96625 0,10.8125 4.04375,0 0,-15.2725 -5.2525,0 z m -27.214,0 0,15.2725 11.11625,0 0,-2.91875 -7.005,0 0,-3.62375 5.94375,0 0,-2.51875 -5.94375,0 0,-3.4475 6.82875,0 0,-2.76375 -10.94,0 z m -8.1775,15.27163 2.1325,0 2.13375,0 0,-7.63625 0,-7.63625 -2.13375,0 -2.1325,0 0,7.63625 0,7.63625 z M 43.89188,15.29 l 0,-3.0175 c 1.71624,0.54125 3.23499,0.81125 4.55749,0.81125 1.82375,0 2.73626,-0.48125 2.73626,-1.445 0,-0.36 -0.13376,-0.66125 -0.39875,-0.90625 -0.27376,-0.26 -0.96875,-0.61875 -2.09001,-1.07875 C 46.68813,8.8275 45.37563,8.1225 44.76562,7.54 43.97812,6.77 43.58187,5.8 43.58187,4.62625 c 0,-1.50875 0.57625,-2.66 1.7275,-3.45 C 46.44563,0.3925 47.92813,0 49.75437,0 c 1.00751,0 2.46501,0.185 4.37,0.55625 l 0,2.90125 c -1.41749,-0.56625 -2.735,-0.84875 -3.95,-0.84875 -1.71375,0 -2.56999,0.47 -2.56999,1.41375 0,0.35125 0.17374,0.63875 0.51875,0.8625 0.28749,0.17875 1.07874,0.56 2.3725,1.14375 1.86249,0.82625 3.10499,1.545 3.72125,2.1575 0.73374,0.72625 1.10249,1.665 1.10249,2.8175 0,1.65375 -0.71999,2.91625 -2.15999,3.78625 -1.16375,0.70375 -2.67626,1.05625 -4.53125,1.05625 -1.5675,0 -3.14626,-0.185 -4.73625,-0.55625"
                      style="fill-opacity:1;fill-rule:nonzero;stroke:none"
                    ></path>
                    <path
                      class="healthineers"
                      d="m 56.56775,30.56875 3.44875,0 0,-2.87 -3.44875,0 0,-4.15875 -3.65875,0 0,4.16 -2.03,0 0,2.87 2.03,0 0,6.5 c 0,2.2125 0.21,4.37 4.00125,4.37 1.15875,0 2.5525,-0.34125 3.34375,-0.84125 l -0.79125,-2.45 c -0.5775,0.2375 -1.13125,0.4225 -1.60625,0.4225 -0.97375,0 -1.28875,-0.58 -1.28875,-2.0275 l 0,-5.975 z m 86.37162,-2.10438 0.01,-0.0312 c -1.165,-0.7625 -2.6925,-1.2225 -4.35875,-1.135 -2.705,0.14125 -4.83125,1.75375 -4.68375,4.54 0.14625,2.78875 2.17875,3.44625 4.17875,3.92125 1.14875,0.2825 2.10875,0.4975 2.1625,1.5225 0.0525,1 -0.6375,1.43125 -1.60875,1.4825 -1.19,0.0612 -2.695,-0.4675 -3.665,-0.96625 l -1.09126,2.51 c 0.76876,0.51375 2.74875,1.24625 5.08,1.125 3.04625,-0.16 5.04,-1.76375 4.885,-4.73625 -0.14375,-2.735 -2.33125,-3.3325 -4.28124,-3.8375 -1.20125,-0.305 -2.08625,-0.6025 -2.14125,-1.6275 -0.045,-0.86875 0.6475,-1.2475 1.515,-1.29375 0.89875,-0.0462 1.86625,0.3475 2.89375,1.0675 l 1.105,-2.54125 z m -14.82687,4.289 c 0.0525,-1.39375 0.895,-2.29 2.21125,-2.29 0.68375,0 1.3175,0.18375 1.8675,0.47375 L 132.85,27.77837 c -0.63125,-0.3425 -1.44625,-0.47375 -2.185,-0.47375 -1.23625,0 -2.52625,0.73625 -3.1575,2.29 l -0.3425,-1.89625 -2.975,0 0.26375,2.3175 0,11.02875 3.65875,0 0,-8.29125 z m -40.03688,8.29188 0,-8.555 c 0,-1.26375 0.89626,-2.36875 2.29001,-2.36875 1.39625,0 1.63124,1.07875 1.63124,2.52625 l 0,8.3975 3.65875,0 0,-9.10875 c 0,-3.1575 -1.57875,-4.6325 -4.18374,-4.6325 -1.76376,0 -3.08,0.73875 -3.97501,1.975 l -0.26375,-1.58 -3.05375,0 0.23751,2.475 0,10.87125 3.65874,0 z M 77.35125,23.52912 c 0,0.555 0.19375,1.025 0.53875,1.3575 0.345,0.33125 0.84125,0.525 1.4475,0.525 0.5925,0 1.09625,-0.19375 1.45,-0.525 0.355,-0.3325 0.56125,-0.8025 0.56125,-1.3575 0,-0.51625 -0.20625,-0.98625 -0.56125,-1.32875 -0.35375,-0.34125 -0.8575,-0.55375 -1.45,-0.55375 -0.59375,0 -1.09,0.2125 -1.4375,0.55375 -0.34875,0.3425 -0.54875,0.8125 -0.54875,1.32875 m 0.16812,17.5165 1.83001,0 1.82875,0 0,-6.6725 0,-6.67375 -1.82875,0 -1.83001,0 0,6.67375 0,6.6725 z m -10.8175,-3.7e-4 0,-8.6075 c 0,-1.2375 0.89501,-2.31625 2.2375,-2.31625 1.39501,0 1.68376,1.0525 1.68376,2.42125 l 0,8.5025 3.65875,0 0,-9.05375 c 0,-3.13375 -1.5,-4.6875 -4.26376,-4.6875 -1.29,0 -2.47375,0.47375 -3.31625,1.36875 l 0,-5.1325 -3.65874,0 0,17.505 3.65874,0 z m -22.82162,-17.4785 0,13.50375 c 0,2.21125 0.21,4.37 4.00125,4.37 1.15875,0 2.5525,-0.34125 3.3425,-0.8425 l -0.79,-2.44875 c -0.57875,0.2375 -1.13125,0.4225 -1.60375,0.4225 -0.97625,0 -1.29125,-0.58 -1.29125,-2.0275 l 0,-12.9775 -3.65875,0 z m -3.05338,17.4785 -0.26374,-2.6575 0,-10.11 c -2,-0.73625 -3.94876,-0.97375 -4.84375,-0.97375 -4.65751,0 -6.97501,3.0275 -6.97501,7.66125 0,3.5525 1.29001,6.44875 5.10625,6.44875 1.4225,0 2.7375,-0.52625 3.52751,-1.7375 l 0.1325,0.0275 0.18374,1.34125 3.1325,0 z M 36.93063,36.7815 c 0,0.97375 -0.78875,1.97375 -2.15751,1.97375 -1.94874,0 -2.39625,-1.86875 -2.39625,-4.00125 0,-2.58 0.7375,-4.7375 2.89625,-4.7375 0.68376,0 1.315,0.13125 1.65751,0.28875 l 0,6.47625 z M 9.13375,23.54075 l 0,6.975 -5.37,0 0,-6.975 -3.76375,0 0,17.505 3.76375,0 0,-7.23875 5.37,0 0,7.23875 3.765,0 0,-17.505 -3.765,0 z m 17.50512,7.60712 c 0,-2.5 -1.71125,-3.84375 -4.37,-3.84375 -4.31624,0 -6.55375,3.52875 -6.55375,7.3975 0,3.94875 1.79001,6.73875 6.26376,6.73875 2.65999,0 4.5025,-1.21125 4.8175,-1.47375 l -1.0525,-2.4475 c -0.73625,0.49875 -1.86875,1.13125 -3.29001,1.13125 -2.00124,0 -2.84375,-1.34375 -3.02749,-2.60625 3.185,-0.13125 7.21249,-0.9225 7.21249,-4.89625 m -3.21125,0.0275 c 0,1.815 -2.44874,2.23625 -4.15875,2.29 0.0775,-1.8175 1.02625,-3.58125 2.81626,-3.58125 0.815,0 1.34249,0.5 1.34249,1.29125 m 98.18325,-0.0275 c 0,-2.5 -1.71125,-3.84375 -4.37,-3.84375 -4.31624,0 -6.55375,3.52875 -6.55375,7.3975 0,3.94875 1.79,6.73875 6.26375,6.73875 2.66,0 4.5025,-1.21125 4.8175,-1.47375 l -1.05375,-2.4475 c -0.73625,0.49875 -1.8675,1.13125 -3.28874,1.13125 -2.00125,0 -2.8425,-1.34375 -3.02751,-2.60625 3.18625,-0.13125 7.2125,-0.9225 7.2125,-4.89625 m -3.21124,0.0275 c 0,1.815 -2.44875,2.23625 -4.15875,2.29 0.0775,-1.8175 1.02625,-3.58125 2.81625,-3.58125 0.815,0 1.3425,0.5 1.3425,1.29125 m -9.55525,-0.0275 c 0,-2.5 -1.71125,-3.84375 -4.37,-3.84375 -4.31625,0 -6.55376,3.52875 -6.55376,7.3975 0,3.94875 1.79,6.73875 6.26376,6.73875 2.66,0 4.5025,-1.21125 4.8175,-1.47375 l -1.0525,-2.4475 c -0.7375,0.49875 -1.86875,1.13125 -3.29,1.13125 -2.00125,0 -2.84375,-1.34375 -3.0275,-2.60625 3.18625,-0.13125 7.2125,-0.9225 7.2125,-4.89625 m -3.21125,0.0275 c 0,1.815 -2.44875,2.23625 -4.15875,2.29 0.0775,-1.8175 1.02625,-3.58125 2.81625,-3.58125 0.815,0 1.3425,0.5 1.3425,1.29125"
                      style="fill-opacity:1;fill-rule:nonzero;stroke:none"
                    ></path>
                  </svg>`}
            </div>
            <div class="data-wrapper">
              <sh-text class="label" size="super-header" color="primary">${this.label}</sh-text>
              ${this.version?V` <sh-text class="version" header-2>${this.version}</sh-text> `:""}
              <slot></slot>
              ${this.progress?V`
                    <sh-progress
                      class="progress"
                      show-progress
                      value="${this.progress}"
                    ></sh-progress>
                  `:""}
              <div class="footer-wrapper">
                <slot name="footer" class="footer"></slot>
              </div>
            </div>
            ${this.info?V` <sh-text class="info" size="body-2" color="secondary">${this.info}</sh-text> `:""}
            <div class="footer-text">
              <slot
                name="info"
                id="info"
                class="info_slot"
                @slotchange="${()=>this._handleSlotNodes()}"
              ></slot>
            </div>
          </div>
          ${this.image?V` <div class="image" style="background-image: ${this.image}"></div> `:""}
        </div>
      </sh-card>
    `}constructor(){super(),this.label="Product Name",this.modal=!1}updated(e){he(this,e,["label","modal","info","version","progress","image"])}firstUpdated(){this._handleSlotNodes()}_handleSlotNodes(){const e=this.shadowRoot.querySelector("#info").assignedNodes({flatten:!0}).length;this._emptyInfo=0===e}});var Hi=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-split-button-icon-wrapper-width=2rem] - width of icon wrapper
   */
  --sh-split-button-icon-wrapper-width: 2rem;
  /* 
   * @cssprop [--sh-split-button-current-scale=s] - the current scale of split-button used to set overlayTargetDistance for popover
   */
  --sh-split-button-current-scale: s;
}

:host {
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
  height: var(--sh-button-button-height);
  width: fit-content;
  width: -moz-fit-content;
  --current-scale: var(--sh-split-button-current-scale);
  position: relative;
}

.popup-menu {
  outline: none;
}

.main-btn {
  border-top-right-radius: 0rem;
  border-bottom-right-radius: 0rem;
}

.icon-wrapper {
  box-sizing: border-box;
  height: 100%;
  border-top-right-radius: var(--sh-button-button-border-radius);
  border-bottom-right-radius: var(--sh-button-button-border-radius);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--sh-split-button-icon-wrapper-width);
}

/* color='primary' */
:host([color=primary]) .icon-wrapper {
  background-color: rgba(var(--ui-3), var(--opacity-1));
  border-left: 0.0625rem solid rgba(var(--ui-7), var(--opacity-5));
}

:host([color=primary]) .icon-wrapper[active] {
  background-color: rgba(var(--ui-4), var(--opacity-1));
}

:host([color=primary]) .split-button-icon {
  color: white;
}

:host([color=primary]:not(.touch-device):not([arrow-disabled])) .icon-wrapper:hover:not([active]) {
  background-color: rgba(var(--ui-2), var(--opacity-1));
}

/* color='secondary' */
:host([color=secondary]) .icon-wrapper {
  background-color: rgba(var(--ui-1), var(--opacity-6));
  border-left: 0.0625rem solid rgba(var(--ui-7), var(--opacity-4));
}

:host([color=secondary]) .icon-wrapper[active] {
  background-color: rgba(var(--ui-1), var(--opacity-7));
}

:host([color=secondary]) .split-button-icon {
  color: rgba(var(--ui-1), var(--opacity-2));
}

:host([color=secondary]:not(.touch-device):not([arrow-disabled])) .icon-wrapper:hover:not([active]) {
  background-color: rgba(var(--ui-1), var(--opacity-5));
}

/* color='tertiary' */
:host([color=tertiary]) .icon-wrapper {
  background-color: transparent;
  border: 0.0625rem solid rgba(var(--ui-1), var(--opacity-6));
  border-left: none;
}

:host([color=tertiary]) .icon-wrapper[active] {
  background-color: rgba(var(--ui-1), var(--opacity-7));
}

:host([color=tertiary]) .split-button-icon {
  color: rgba(var(--ui-1), var(--opacity-2));
}

:host([color=tertiary]:not(.touch-device):not([arrow-disabled])) .icon-wrapper:hover:not([active]) {
  background-color: rgba(var(--ui-1), var(--opacity-5));
}

/* disabled */
:host([disabled]) {
  pointer-events: none;
  cursor: default;
}

:host([arrow-disabled]) .icon-wrapper {
  cursor: default;
}

:host([color=primary][disabled]) .icon-wrapper {
  background-color: rgba(var(--ui-2), var(--opacity-5));
}

:host([color=secondary][disabled]) .icon-wrapper {
  background-color: rgba(var(--ui-1), var(--opacity-7));
}

:host([color=tertiary][disabled]) .icon-wrapper {
  border: 0.0625rem solid rgba(var(--ui-1), var(--opacity-7));
  border-left: none;
}

.split-button-icon {
  margin-left: -0.125rem;
}`;customElements.define("sh-split-button",class extends se{static get properties(){return{label:{type:String,reflect:!0},size:{type:String,reflect:!0},color:{type:String,reflect:!0},tooltip:{type:String,reflect:!0},href:{type:String,reflect:!0},disabled:{type:Boolean,reflect:!0},role:{type:String,reflect:!0},arrowDisabled:{type:Boolean,reflect:!0,attribute:"arrow-disabled"},_active:{type:Boolean},_popoverButtonDistance:{type:Number}}}static get styles(){return[be(),ae,Hi]}render(){return V`
      <sh-button
        class="main-btn"
        label="${this.label}"
        size="${this.size}"
        color="${this.color}"
        .tooltip="${this.tooltip}"
        .href="${this.href}"
        ?disabled="${this.disabled}"
        role="${this.role}"
      >
      </sh-button>
      <div class="icon-wrapper" ?active="${this._active}" @click="${this._toggleOverlay}">
        <sh-icon
          class="split-button-icon"
          icon="down-s"
          tabindex="0"
          ?disabled="${this.disabled||this.arrowDisabled}"
        >
        </sh-icon>
      </div>
      <sh-popover
        class="popup-menu"
        tabindex="0"
        .visible="${this._active}"
        .target="${this}"
        manual-controlled
        position="bottom-left"
        .overlayTargetDistance=${this._popoverButtonDistance}
        @visible-changed="${e=>{this._active&&e.target.focus()}}"
        @clicked="${()=>{this._active=!1}}"
        suppress-placement-warning
        @keyup="${e=>{e.keyCode===me.ESCAPE&&(this._active=!1)}}"
      >
        <slot
          @slotchange="${e=>{this._hasSubElements=e.target.assignedElements({flatten:!0}).length}}"
        ></slot>
      </sh-popover>
    `}constructor(){super(),this.label="Label",this.size="s",this.color="primary",this.role="button",this._popoverButtonDistance=.5}connectedCallback(){super.connectedCallback(),ue.isTouchDevice()&&this.classList.add("touch-device"),this.documentClick=this._handleDocumentClick.bind(this)}disconnectedCallback(){document.body.removeEventListener("click",this.documentClick),super.disconnectedCallback()}_getTargetDistance(){const e=getComputedStyle(this).getPropertyValue("--current-scale").trim();return"xl"===e||"l"===e?.75:.5}_toggleOverlay(e){this.arrowDisabled?e.stopPropagation():this._hasSubElements&&(e.stopPropagation(),this._active=!this._active,this._active&&(this._popoverButtonDistance=this._getTargetDistance(),document.body.removeEventListener("click",this.documentClick),document.body.addEventListener("click",this.documentClick)))}_handleDocumentClick(e){-1===e.composedPath().indexOf(this)&&(this._active=!1,document.body.removeEventListener("click",this.documentClick))}});var Wi=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-stepper-circle-dimension=2rem] - stepper circle width
   */
  --sh-stepper-circle-dimension: 2rem;
  /* 
   * @cssprop [--sh-stepper-circle-line-height=2rem] - stepper circle line height
   */
  --sh-stepper-circle-line-height: 2rem;
  /* 
   * @cssprop [--sh-stepper-margin-bottom=0.5rem] - stepper circle height
   */
  --sh-stepper-margin-bottom: 0.5rem;
  /* 
   * @cssprop [--sh-stepper-border-width=0.0625rem] - circle border width
   */
  --sh-stepper-border-width: 0.0625rem;
  /* 
   * @cssprop [--sh-stepper-line-top=0.9375rem] - stepper line top
   */
  --sh-stepper-line-top: 0.9375rem;
  /* 
   * @cssprop [--sh-stepper-label-padding=0 0.5rem] - label text padding
   */
  --sh-stepper-label-padding: 0 0.5rem;
  /* 
   * @cssprop [--sh-stepper-label-line-height=1.5rem] - label line height
   */
  --sh-stepper-label-line-height: 1.5rem;
  /* 
   * @cssprop [--sh-stepper-info-line-height=1rem] - info line height
   */
  --sh-stepper-info-line-height: 1rem;
  /* 
   * @cssprop [--sh-stepper-badge-top=-0.25rem] - badge top
   */
  --sh-stepper-badge-top: -0.25rem;
  /* 
   * @cssprop [--sh-stepper-badge-right=-0.375rem] - badge top
   */
  --sh-stepper-badge-right: -0.375rem;
  /* 
   * @cssprop [--sh-stepper-condensed-circle-dimension=0.875rem] - condensed circle width
   */
  --sh-stepper-condensed-circle-dimension: 0.875rem;
  /* 
   * @cssprop [--sh-stepper-condensed-border-width=0.125rem] - condensed border width
   */
  --sh-stepper-condensed-border-width: 0.125rem;
  /* 
   * @cssprop [--sh-stepper-condensed-badge-top=-0.1875rem] - condensed badge top
   */
  --sh-stepper-condensed-badge-top: -0.1875rem;
  /* 
   * @cssprop [--sh-stepper-condensed-badge-right=-0.1875rem] - condensed badge top
   */
  --sh-stepper-condensed-badge-right: -0.1875rem;
  /* 
   * @cssprop [--sh-stepper-line-border-width=0.125rem] - line border width
   */
  --sh-stepper-line-border-width: 0.125rem;
  /* 
   * @cssprop [--sh-stepper-line-width=1.5rem] - line  width
   */
  --sh-stepper-line-width: 1.5rem;
  /* 
   * @cssprop [--sh-stepper-condensed-line-top=0.4375rem] - condensed stepper line top
   */
  --sh-stepper-condensed-line-top: 0.4375rem;
  /* 
   * @cssprop [--sh-stepper-condensed-line-width=0.625rem] - line border width
   */
  --sh-stepper-condensed-line-width: 0.625rem;
  /* 
   * @cssprop [--sh-stepper-icon-size=1rem] - Size of the  icon
   */
  --sh-stepper-icon-size: 1rem;
  /* 
   * @cssprop [--sh-stepper-font-size=1rem] - font Size of the icon
   */
  --sh-stepper-font-size: 1rem;
}

:host {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  position: relative;
  outline: 0;
}

sh-text {
  text-align: center;
  padding: var(--sh-stepper-label-padding);
  box-sizing: border-box;
  color: var(--text-secondary);
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.info {
  line-height: var(--sh-stepper-info-line-height);
}

.circle {
  height: var(--sh-stepper-circle-dimension);
  width: var(--sh-stepper-circle-dimension);
  margin-bottom: var(--sh-stepper-margin-bottom);
  border-radius: 50%;
  text-align: center;
  font: var(--header-2);
  color: var(--text-secondary);
  line-height: var(--sh-stepper-circle-line-height);
  transition: var(--transition-time) all ease-in-out, var(--hover-transition-time) color;
  background: rgba(var(--ui-1), var(--opacity-6));
  border: var(--sh-stepper-border-width) solid transparent;
  position: relative;
  box-sizing: border-box;
}

:host(:hover) .circle,
:host(.hover) .circle,
:host(:hover) .label {
  color: var(--text-primary);
}

:host(:hover) .info {
  color: var(--text-secondary);
}

.line-left,
.line-right {
  position: absolute;
  top: var(--sh-stepper-line-top);
  width: calc(50% - var(--sh-stepper-line-width));
  border-bottom: var(--sh-stepper-line-border-width) solid rgba(var(--ui-1), var(--opacity-6));
}

.line-left {
  left: 0rem;
}

.line-right {
  right: 0rem;
}

:host(:first-of-type) .line-left,
:host(:last-of-type) .line-right {
  display: none;
}

:host([active]) .circle {
  color: rgba(var(--ui-7), var(--opacity-1));
  background: rgba(var(--ui-1), var(--opacity-3));
}

:host([color=primary][active]) .circle {
  color: var(--text-white);
  background: rgba(var(--ui-3), var(--opacity-1));
}

sh-text[size=title-1] {
  line-height: var(--sh-stepper-label-line-height);
  transition: var(--hover-transition-time) color;
}

:host([active]) sh-text[size=title-1] {
  color: var(--text-primary);
}

:host([half]) .circle {
  background: linear-gradient(90deg, rgba(var(--ui-1), var(--opacity-5)) 50%, transparent 50%);
  background-size: calc(100% + 0.25rem);
  background-position: -0.125rem;
  border-color: var(--text-disabled);
}

:host([disabled]) {
  cursor: default;
  pointer-events: none;
}

:host([disabled]) .circle {
  color: var(--text-disabled);
  background: transparent;
  border-color: var(--text-disabled);
}

:host([disabled]) sh-text {
  color: var(--text-disabled);
}

.stepper-type {
  position: absolute;
  top: var(--sh-stepper-badge-top);
  right: var(--sh-stepper-badge-right);
  --sh-icon-size-xs: var(--sh-stepper-icon-size);
  --sh-icon-font-size-xs: var(--sh-stepper-font-size);
}

:host([condensed]) .circle {
  border-width: var(--sh-stepper-condensed-border-width);
  color: transparent;
  height: var(--sh-stepper-condensed-circle-dimension);
  width: var(--sh-stepper-condensed-circle-dimension);
  margin: 0.0625rem 0.125rem;
}

:host([condensed][active]:not([disabled]):not([type])) .circle {
  background: rgba(var(--ui-1), var(--opacity-3));
}

:host([condensed]:not([disabled]):not([type])) .circle {
  background: rgba(var(--ui-1), var(--opacity-5));
}

:host([color=primary][condensed][active]:not([disabled]):not([type])) .circle {
  background: rgba(var(--ui-3), var(--opacity-1));
}

:host([condensed]) .line-left,
:host([condensed]) .line-right {
  top: var(--sh-stepper-condensed-line-top);
  width: calc(50% - var(--sh-stepper-condensed-line-width));
  border-bottom: var(--sh-stepper-condensed-border-width) solid rgba(var(--ui-1), var(--opacity-6));
}

:host #stepperCircle.item-focused {
  border: var(--focus-outline);
}

:host([condensed]) .stepper-type {
  top: var(--sh-stepper-condensed-badge-top);
  right: var(--sh-stepper-condensed-badge-right);
  line-height: var(--sh-stepper-font-size);
}

:host([type][condensed]) .circle {
  background: transparent;
  border-color: transparent;
}`;class qi extends(de(fe(se))){static get properties(){return{label:{type:String,reflect:!0},info:{type:String,reflect:!0},number:{type:String,reflect:!0},type:{type:String,reflect:!0},active:{type:Boolean,reflect:!0},disabled:{type:Boolean,reflect:!0},condensed:{type:Boolean,reflect:!0},color:{type:String,reflect:!0}}}static get styles(){return[Wi]}render(){return V`
      <div class="line-left"></div>
      <div class="line-right"></div>
      <div class="circle focus-item" id="stepperCircle">
        ${this.number&&!this.condensed?V` <div class="number">${this.number}</div>`:""}
        ${this.type?V` <sh-icon .icon="${this.type}" class="stepper-type" size="xs"></sh-icon>`:""}
      </div>
      ${this.label&&!this.condensed?V`<sh-text class="label" size="title-1">${this.label}</sh-text>`:""}
      ${this.info?V`<sh-text class="info" size="body-2">${this.info}</sh-text>`:""}
    `}firstUpdated(){super.firstUpdated()}updated(e){super.updated(e),e.has("active")&&this._handleActiveChange(),he(this,e,["label","info","number","type","active","condensed","color"])}constructor(){super(),this.color="neutral"}_spaceKeyAction(){super._spaceKeyAction(),this.click()}_handleActiveChange(){this.disabled&&(this.disabled=!1)}}customElements.define("sh-stepper-item",qi),customElements.define("sh-stepper",class extends se{static get properties(){return{value:{type:String,reflect:!0},condensed:{type:Boolean,reflect:!0},readonly:{type:Boolean,reflect:!0},color:{type:String,reflect:!0}}}static get styles(){return[ie`
        :host {
          width: 100%;
          height: auto;
          display: flex;
        }
        :host([readonly]) {
          pointer-events: none;
        }
      `]}render(){return V`<slot @slotchange=${this.slotChange} @click=${this.clickFromSlot}></slot>`}constructor(){super(),this.color="neutral"}connectedCallback(){super.connectedCallback();for(let e=0;e<this.children.length;e++)this.children[e].disabled||this.hasAttribute("tabindex")||this.children[e].setAttribute("tabindex","0")}clickFromSlot(e){e.target&&"SH-STEPPER-ITEM"===e.target.tagName&&(this.value=e.target.number,this._updateItems())}slotChange(){const e=this.querySelectorAll("sh-stepper-item");for(let t=0;t<e.length;t++)e[t].number=t+1,e[t].hasAttribute("active")&&(this.value=e[t].number);this._updateItems(),this._handleCondensedChange(),this._handleColorChange()}updated(e){e.has("condensed")&&this._handleCondensedChange(),e.has("value")&&this._updateItems(),e.has("color")&&this._handleColorChange(),he(this,e,["value","condensed","readonly","color"])}async _updateItems(){const e=this.querySelectorAll("sh-stepper-item");for(let t=0;t<e.length;t++)e[t].number>this.value?(e[t].active=!1,await this.updateComplete,e[t].setAttribute("disabled","")):e[t].number===parseInt(this.value)?e[t].active=!0:(e[t].active=!1,e[t].disabled=!1),this.value>Math.floor(this.value)&&t===Math.ceil(this.value-1)?e[t].setAttribute("half",""):e[t].removeAttribute("half")}_handleCondensedChange(){const e=this.querySelectorAll("sh-stepper-item");for(let t=0;t<e.length;t++)e[t].condensed=this.condensed}_handleColorChange(){const e=this.querySelectorAll("sh-stepper-item");for(let t=0;t<e.length;t++)e[t].color=this.color}});var Yi=ie`[sh-scale=s] {
  /* 
   * @cssprop [--sh-switch-item-width=5.5rem] - switch item width
   */
  --sh-switch-item-width: 5.5rem;
  /* 
   * @cssprop [--sh-switch-item-height=2.5rem] - switch height
   */
  --sh-switch-item-height: 2.5rem;
  /* 
   * @cssprop [--sh-switch-item-padding=0.75rem] - switch item padding
   */
  --sh-switch-item-padding: 0.75rem;
  /* 
   * @cssprop [--sh-switch-item-label-alignment=center] - label alignment
   */
  --sh-switch-item-label-alignment: center;
  /* 
   * @cssprop [--sh-switch-item-border-radius=1.25rem] - switch  border radius
   */
  --sh-switch-item-border-radius: 1.25rem;
  /* 
   * @cssprop [--sh-switch-item-condensed-height=2rem] - switch  item condensed height
   */
  --sh-switch-item-condensed-height: 2rem;
  /* 
   * @cssprop [--sh-switch-item-condensed-border-radius=1rem] - switch  item condensed height
   */
  --sh-switch-item-condensed-border-radius: 1rem;
  /* 
   * @cssprop [--sh-switch-item-condensed-padding=0.5rem 0.75rem] - switch  item condensed height
   */
  --sh-switch-item-condensed-padding: 0.5rem 0.75rem;
  /* 
   * @cssprop [--sh-switch-item-icon-height=2rem] - switch  item icon height
   */
  --sh-switch-item-icon-height: 2rem;
  /* 
   * @cssprop [--sh-switch-item-icon-width=2rem] - switch  item icon width
   */
  --sh-switch-item-icon-width: 2rem;
  /* 
   * @cssprop [--sh-switch-item-icon-margin=0.25rem 1.75rem] - switch  item icon margin
   */
  --sh-switch-item-icon-margin: 0.25rem 1.75rem;
  /* 
   * @cssprop [--sh-switch-item-label-height=1rem] - switch  item icon margin
   */
  --sh-switch-item-label-height: 1rem;
}

:host {
  transition: var(--transition-time) all ease-in-out, var(--hover-transition-time) color;
  border-radius: var(--sh-switch-item-border-radius);
  padding: var(--sh-switch-item-padding);
  line-height: var(--sh-switch-item-height);
  font: var(--body-1);
  color: var(--text-secondary);
  cursor: pointer;
  min-width: var(--sh-switch-item-width);
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  outline: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.label {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  max-width: 100%;
  height: var(--sh-switch-item-label-height);
  line-height: var(--sh-switch-item-label-height);
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

:host(:hover),
:host([active]) {
  color: var(--text-primary);
}

:host([active]) {
  background-color: rgba(var(--ui-1), var(--opacity-6));
}

:host([icon]) {
  padding: 0rem;
}

:host([icon]) .label,
.switch-icon {
  display: none;
}

:host([icon]) .switch-icon {
  display: flex;
  margin: var(--sh-switch-item-icon-margin);
  color: rgba(var(--ui-1), var(--opacity-3));
  height: var(--sh-switch-item-icon-height);
  width: var(--sh-switch-item-icon-width);
}

:host([icon][active]) .switch-icon {
  color: rgba(var(--ui-1), var(--opacity-2));
}

:host([icon][disabled]) .switch-icon,
:host([disabled]) {
  pointer-events: none;
  color: var(--text-disabled);
}

:host([icon][disabled][icon-color]) .switch-icon {
  pointer-events: none;
  opacity: var(--opacity-5);
}

:host([active][disabled]) {
  background-color: rgba(var(--ui-1), var(--opacity-7));
}

:host([condensed]) {
  padding: var(--sh-switch-item-condensed-padding);
  height: var(--sh-switch-item-condensed-height);
  border-radius: var(--sh-switch-item-condensed-border-radius);
}

:host([blue-outline]) {
  box-shadow: inset 0rem 0rem 0rem 0.125rem var(--focus-color);
}`;class ji extends(de(se)){static get properties(){return{label:{type:String,reflect:!0},active:{type:Boolean,reflect:!0},condensed:{type:Boolean,reflect:!0},icon:{type:String,reflect:!0},iconColor:{type:String,reflect:!0,attribute:"icon-color"}}}static get styles(){return[Yi,be()]}render(){return V`
      ${this.label&&!this.icon?V` <span class="label"> ${this.label} </span>`:""}
      ${this.icon&&!this.label?V` <sh-icon
            icon="${this.icon}"
            .color="${this.iconColor}"
            class="switch-icon"
          ></sh-icon>`:""}
    `}updated(e){super.updated(e),e.has("active")&&this.active&&this.handleActiveChange(),he(this,e,["label","active","condensed","icon"])}firstUpdated(){super.firstUpdated(),this.addEventListener("click",(()=>this.handleClick())),this.addEventListener("focus",(()=>this.handleFocus())),this.addEventListener("blur",(()=>this.handleBlur()))}handleClick(){this.active=!0}handleFocus(){this.addEventListener("keyup",this.handleKeyup)}handleBlur(){this.removeEventListener("keyup",this.handleKeyup),this.removeAttribute("blue-outline")}handleKeyup(e){9===e.keyCode&&this.setAttribute("blue-outline",""),32!==e.keyCode&&13!==e.keyCode||this.click()}handleActiveChange(){const e=this.parentNode.children,t=e.length;for(let o=0;o<t;o++){const t=e[o];t.hasAttribute("active")&&t!==this&&(t.active=!1)}}}customElements.define("sh-switch-item",ji);var Ui=ie`:host {
  display: flex;
  flex-direction: row;
  border-radius: var(--sh-switch-border-radius);
  background-color: rgba(var(--ui-1), var(--opacity-7));
  width: -webkit-fit-content;
  width: fit-content;
  width: -ms-fit-content;
  width: -moz-fit-content;
  max-width: 100%;
  overflow: hidden;
}

:host([stretch]) {
  width: 100%;
}

:host([stretch]) > ::slotted(sh-switch-item) {
  flex: 1;
}

:host([disabled]) {
  pointer-events: auto;
  background-color: rgba(var(--ui-1), var(--opacity-7));
}

:host([condensed]) {
  border-radius: var(--sh-switch-condensed-border-radius);
}

:host > ::slotted(sh-switch-item) {
  flex: 1;
}`;customElements.define("sh-switch",class extends se{static get properties(){return{stretch:{type:Boolean,reflect:!0},disabled:{type:Boolean,reflect:!0},condensed:{type:Boolean,reflect:!0}}}static get styles(){return[Ui]}render(){return V` <slot></slot> `}updated(e){e.has("disabled")&&this.handleDisabledChange(),e.has("condensed")&&this.handleCondensedChange(),he(this,e,["stretch","disabled","condensed"])}handleDisabledChange(){const e=this.children;for(let t=0;t<e.length;t++)e[t].disabled=this.disabled}handleCondensedChange(){const e=this.querySelector('sh-switch-item[icon]:not([icon=""])');if(!e){const e=this.querySelectorAll("sh-switch-item");for(let t=0;t<e.length;t++)e[t].condensed=this.condensed}e&&this.condensed&&console.warn("Condensed style will not be applied to switch and condensed property will not be applied to switch-items , if any switch-item has icon")}}),customElements.define("sh-table-cell",class extends se{static get properties(){return{number:{type:Boolean,reflect:!0},icon:{type:Boolean,reflect:!0},condensed:{type:Boolean,reflect:!0},minWidth:{type:String,reflect:!0,attribute:"min-width"},columns:{type:String,reflect:!0},colS:{type:String,reflect:!0,attribute:"col-s"},colM:{type:String,reflect:!0,attribute:"col-m"},checkbox:{type:Boolean,reflect:!0}}}static get styles(){return[ie`
        :host {
          display: inline-flex;
          box-sizing: border-box;
          height: fit-content;
          height: -ms-fit-content;
          height: -moz-fit-content;
          align-items: center;
        }
        * {
          box-sizing: border-box;
        }
        .cell-wrapper {
          width: 100%;
          display: flex;
          flex-direction: column;
          font: var(--body-1);
          margin: 0.5rem 0.75rem;
          line-height: 2rem;
          color: var(--text-primary);
          word-wrap: break-word;
          cursor: default;
          width: calc(100% - 1.5rem);
          height: fit-content;
          height: -ms-fit-content;
          height: -moz-fit-content;
          font-weight: normal;
          -webkit-font-smoothing: antialiased !important;
          text-rendering: optimizeLegibility !important;
          -moz-osx-font-smoothing: grayscale !important;
        }
        /* number cells */
        :host([number]) .cell-wrapper {
          text-align: end;
          word-break: break-word;
        }
        /* icon cells */
        :host([icon]),
        :host([checkbox]) {
          flex: 0;
          min-width: 3.5rem !important;
        }
        :host([checkbox]) {
          margin-top: 0.2rem;
        }
        /* medium screens */
        @media only screen and (max-width: 64.0625rem) {
          :host([icon]),
          :host([checkbox]) {
            min-width: 3rem !important;
          }
          .cell-wrapper {
            margin: 0.5rem 0.5rem;
            width: calc(100% - 1rem);
          }
        }
        /* condensed */
        :host([condensed]) .cell-wrapper {
          margin: 0.25rem 0.75rem;
        }
      `]}render(){return V`
      <div class="cell-wrapper">
        <slot></slot>
      </div>
    `}constructor(){super(),this.minWidth="2.5rem"}connectedCallback(){super.connectedCallback();const e=this.querySelectorAll("sh-icon");if(e)for(let t=0;t<e.length;t++)e[t].button&&!e[t].hasAttribute("tabindex")&&e[t].setAttribute("tabindex",0)}updated(e){e.has("minWidth")&&(this.style.minWidth=this.minWidth)}}),customElements.define("sh-table-head",class extends se{static get properties(){return{minWidth:{type:String,reflect:!0,attribute:"min-width"},sortDescending:{type:Boolean,reflect:!0,attribute:"sort-descending"},icon:{type:Boolean,reflect:!0},number:{type:Boolean,reflect:!0},columns:{type:String,reflect:!0},condensed:{type:Boolean,reflect:!0},unsortable:{type:Boolean,reflect:!0},colS:{type:String,reflect:!0,attribute:"col-s"},colM:{type:String,reflect:!0,attribute:"col-m"},sorted:{type:Boolean,reflect:!0},checkbox:{type:Boolean,reflect:!0}}}static get styles(){return[ie`
        :host {
          display: inline-flex;
          box-sizing: border-box;
          width: -ms-fit-content;
          width: -moz-fit-content;
          outline: 0;
          align-items: center;
        }
        :host([unsortable][number]) {
          justify-content: flex-end;
        }
        :host * {
          box-sizing: border-box;
        }
        .head-wrapper {
          display: flex;
          color: var(--text-primary);
          font: var(--title-1);
          line-height: 2rem;
          margin: 0.5rem 0.75rem;
          height: calc(100% - 1rem);
          width: calc(100% - 1.5rem);
          -webkit-font-smoothing: antialiased !important;
          text-rendering: optimizeLegibility !important;
          -moz-osx-font-smoothing: grayscale !important;
        }
        :host(:not([icon]):not([checkbox])) .head-wrapper-text {
          width: fit-content;
          max-width: calc(100% - 2rem);
          white-space: nowrap;
          display: block;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        :host(:not([checkbox])[unsortable]) .head-wrapper-text {
          max-width: 100%;
        }
        :host([active]) {
          background: transparent;
        }
        .sort-icon {
          display: inline-block;
          visibility: hidden;
          position: relative;
          color: rgba(var(--ui-1), var(--opacity-4));
        }
        .alwaysStay {
          visibility: visible;
        }
        /* number heads */
        :host([number]) .head-wrapper {
          display: flex;
          justify-content: flex-end;
        }
        /* icon heads */
        :host([icon]),
        :host([checkbox]) {
          flex: 0;
          min-width: 3.5rem !important;
        }
        :host([checkbox]) {
          margin-top: 0.2rem;
        }
        :host([icon]) .sort-icon,
        :host([checkbox]) .sort-icon {
          display: none;
        }
        /* medium screens */
        @media only screen and (max-width: 64rem) {
          :host([icon]),
          :host([checkbox]) {
            min-width: 3rem !important;
          }
          .head-wrapper {
            margin: 0.5rem;
            width: calc(100% - 1rem);
          }
        }
        /* hover */
        :host([unsortable]:hover:not(.no-hovermq)),
        :host([unsortable]:hover) *,
        :host([unsortable].no-hovermq):hover,
        :host([unsortable]):hover * {
          cursor: default;
        }
        :host([unsortable]:hover:not(.no-hovermq)) .head-wrapper,
        :host([unsortable].no-hovermq):hover .head-wrapper {
          cursor: default;
        }
        :host(:not(.no-hovermq):hover) .sort-icon,
        :host(.no-hovermq:hover) .sort-icon,
        :host(:not(.no-hovermq)) .head-wrapper.hover .sort-icon,
        :host(.no-hovermq) .head-wrapper.hover .sort-icon {
          visibility: visible;
          color: rgba(var(--ui-1), var(--opacity-3));
        }
        :host(:not(.no-hovermq)) .head-wrapper:hover,
        :host(.no-hovermq) .head-wrapper:hover,
        :host(:not(.no-hovermq)) .head-wrapper.hover,
        :host(.no-hovermq) .head-wrapper.hover,
        :host(:not(.no-hovermq):not([unsortable]):hover) {
          cursor: pointer;
        }
        /* Condensed Table */
        :host([condensed]) .head-wrapper {
          margin: 0.25rem 0.75rem;
          height: calc(100% - 0.5rem);
        }
        /* focus */
        .focus {
          outline: var(--focus-outline);
        }
      `]}render(){return V`
      <div class="head-wrapper">
        ${!this.unsortable&&this.number?V` <sh-icon
              icon="${this.sortDescending?"up-s":"down-s"}"
              class="sort-icon"
            ></sh-icon>`:""}
        <div class="head-wrapper-text">
          <slot></slot>
        </div>
        ${this.unsortable||this.number?"":V` <sh-icon
              icon="${this.sortDescending?"up-s":"down-s"}"
              class="sort-icon"
            ></sh-icon>`}
      </div>
    `}updated(e){e.has("sorted")&&this.toggleArrowVisibility(),e.has("unsortable")&&this.unsortableChanged(),e.has("minWidth")&&this.adjustMinWidth()}unsortableChanged(){this.unsortable?(this.sorted=!1,this.sortDescending=!1,this.tabindex=this.getAttribute("tabindex"),this.removeAttribute("tabindex")):this.tabindex?this.setAttribute("tabindex",this.tabindex):this.setAttribute("tabindex","0")}constructor(){super(),this.minWidth="2.5rem",this.sorted=!1}connectedCallback(){super.connectedCallback(),this.icon||this.hasAttribute("tabindex")||this.unsortable||this.setAttribute("tabindex","0")}firstUpdated(){this.addEventListener("click",(()=>this.handleClick())),this.addEventListener("focus",(()=>this.handleFocus())),this.addEventListener("blur",(()=>this.handleBlur())),this.dispatchEvent(new CustomEvent("head-ready",{detail:this,bubbles:!0}))}adjustMinWidth(){void 0!==this.minWidth&&(this.style.minWidth=this.minWidth)}handleClick(){this.toggleIcon(),this.unsortable||(this.sortDescending=!this.sortDescending,this.sorted=!0)}handleFocus(){this.onkeyup=function(e){if(9!==e.keyCode||this.unsortable)13!==e.keyCode&&32!==e.keyCode||(this.handleClick(),this.toggleIcon());else{const e=this.shadowRoot.querySelector(".head-wrapper"),t=this.shadowRoot.querySelector(".sort-icon");e.classList.add("focus"),t.style.visibility="visible"}}}handleBlur(){if(!this.unsortable){const e=this.shadowRoot.querySelector(".head-wrapper"),t=this.shadowRoot.querySelector(".sort-icon");e.classList.remove("focus"),t.style.visibility=""}}toggleArrowVisibility(){this.sorted?(this.dispatchEvent(new CustomEvent("showarrow",{detail:this,bubbles:!0,composed:!0})),this.shadowRoot.querySelector(".sort-icon").classList.add("alwaysStay")):this.unsortable||(this.sortDescending=!1,this.shadowRoot.querySelector(".sort-icon").classList.remove("alwaysStay"))}toggleIcon(){this.unsortable||this.dispatchEvent(new CustomEvent("toggle",{detail:this,bubbles:!0}))}}),customElements.define("sh-table-row",class extends se{static get properties(){return{lwidth:{type:String,reflect:!0},rwidth:{type:String,reflect:!0},mwidth:{type:String,reflect:!0},scrollLeft:{type:Number},active:{type:Boolean,reflect:!0},freeze:{type:Boolean,reflect:!0},condensed:{type:Boolean,reflect:!0},chapter:{type:Boolean,reflect:!0},expanded:{type:Boolean,reflect:!0},readonly:{type:Boolean,reflect:!0},_hasChapter:{type:Boolean,reflect:!1}}}static get styles(){return[ae,ie`
        :host {
          outline: 0;
          display: block;
        }

        :host > div {
          border-bottom: 0.0625rem solid rgba(var(--ui-1), var(--opacity-6));
          display: flex;
          flex-direction: row;
          transition: var(--transition-time) all ease-in-out, 0.1s background ease;
          min-height: fit-content;
          min-height: -ms-fit-content;
          min-height: -moz-fit-content;
        }

        :host([slot='header']) > div {
          border-bottom: 0.0625rem solid rgba(var(--ui-1), var(--opacity-4));
        }

        /* column assignment */

        #wrapper > ::slotted([columns='24']),
        #wrapper > div > ::slotted([columns='24']) {
          width: 100%;
        }

        #wrapper > ::slotted([columns='23']),
        #wrapper > div > ::slotted([columns='23']) {
          width: calc((100% / 24) * 23);
        }

        #wrapper > ::slotted([columns='22']),
        #wrapper > div > ::slotted([columns='22']) {
          width: calc((100% / 24) * 22);
        }

        #wrapper > ::slotted([columns='21']),
        #wrapper > div > ::slotted([columns='21']) {
          width: calc((100% / 24) * 21);
        }

        #wrapper > ::slotted([columns='20']),
        #wrapper > div > ::slotted([columns='20']) {
          width: calc((100% / 24) * 20);
        }

        #wrapper > ::slotted([columns='19']),
        #wrapper > div > ::slotted([columns='19']) {
          width: calc((100% / 24) * 19);
        }

        #wrapper > ::slotted([columns='18']),
        #wrapper > div > ::slotted([columns='18']) {
          width: calc((100% / 24) * 18);
        }

        #wrapper > ::slotted([columns='17']),
        #wrapper > div > ::slotted([columns='17']) {
          width: calc((100% / 24) * 17);
        }

        #wrapper > ::slotted([columns='16']),
        #wrapper > div > ::slotted([columns='16']) {
          width: calc((100% / 24) * 16);
        }

        #wrapper > ::slotted([columns='15']),
        #wrapper > div > ::slotted([columns='15']) {
          width: calc((100% / 24) * 15);
        }

        #wrapper > ::slotted([columns='14']),
        #wrapper > div > ::slotted([columns='14']) {
          width: calc((100% / 24) * 14);
        }

        #wrapper > ::slotted([columns='13']),
        #wrapper > div > ::slotted([columns='13']) {
          width: calc((100% / 24) * 13);
        }

        #wrapper > ::slotted([columns='12']),
        #wrapper > div > ::slotted([columns='12']) {
          width: calc((100% / 24) * 12);
        }

        #wrapper > ::slotted([columns='11']),
        #wrapper > div > ::slotted([columns='11']) {
          width: calc((100% / 24) * 11);
        }

        #wrapper > ::slotted([columns='10']),
        #wrapper > div > ::slotted([columns='10']) {
          width: calc((100% / 24) * 10);
        }

        #wrapper > ::slotted([columns='9']),
        #wrapper > div > ::slotted([columns='9']) {
          width: calc((100% / 24) * 9);
        }

        #wrapper > ::slotted([columns='8']),
        #wrapper > div > ::slotted([columns='8']) {
          width: calc((100% / 24) * 8);
        }

        #wrapper > ::slotted([columns='7']),
        #wrapper > div > ::slotted([columns='7']) {
          width: calc((100% / 24) * 7);
        }

        #wrapper > ::slotted([columns='6']),
        #wrapper > div > ::slotted([columns='6']) {
          width: calc((100% / 24) * 6);
        }

        #wrapper > ::slotted([columns='5']),
        #wrapper > div > ::slotted([columns='5']) {
          width: calc((100% / 24) * 5);
        }

        #wrapper > ::slotted([columns='4']),
        #wrapper > div > ::slotted([columns='4']) {
          width: calc((100% / 24) * 4);
        }

        #wrapper > ::slotted([columns='3']),
        #wrapper > div > ::slotted([columns='3']) {
          width: calc((100% / 24) * 3);
        }

        #wrapper > ::slotted([columns='2']),
        #wrapper > div > ::slotted([columns='2']) {
          width: calc((100% / 24) * 2);
        }

        #wrapper > ::slotted([columns='1']),
        #wrapper > div > ::slotted([columns='1']) {
          width: calc((100% / 24) * 1);
        }

        #wrapper > ::slotted([columns='0']),
        #wrapper > div > ::slotted([columns='0']) {
          display: none;
        }

        /* column assignment for medium breakpoint */

        @media only screen and (max-width: 64.0625rem) {
          #wrapper > ::slotted([col-m='24']) {
            width: 100%;
          }
          #wrapper > ::slotted([col-m='23']) {
            width: calc((100% / 24) * 23);
          }
          #wrapper > ::slotted([col-m='22']) {
            width: calc((100% / 24) * 22);
          }
          #wrapper > ::slotted([col-m='21']) {
            width: calc((100% / 24) * 21);
          }
          #wrapper > ::slotted([col-m='20']) {
            width: calc((100% / 24) * 20);
          }
          #wrapper > ::slotted([col-m='19']) {
            width: calc((100% / 24) * 19);
          }
          #wrapper > ::slotted([col-m='18']) {
            width: calc((100% / 24) * 18);
          }
          #wrapper > ::slotted([col-m='17']) {
            width: calc((100% / 24) * 17);
          }
          #wrapper > ::slotted([col-m='16']) {
            width: calc((100% / 24) * 16);
          }
          #wrapper > ::slotted([col-m='15']) {
            width: calc((100% / 24) * 15);
          }
          #wrapper > ::slotted([col-m='14']) {
            width: calc((100% / 24) * 14);
          }
          #wrapper > ::slotted([col-m='13']) {
            width: calc((100% / 24) * 13);
          }
          #wrapper > ::slotted([col-m='12']) {
            width: calc((100% / 24) * 12);
          }
          #wrapper > ::slotted([col-m='11']) {
            width: calc((100% / 24) * 11);
          }
          #wrapper > ::slotted([col-m='10']) {
            width: calc((100% / 24) * 10);
          }
          #wrapper > ::slotted([col-m='9']) {
            width: calc((100% / 24) * 9);
          }
          #wrapper > ::slotted([col-m='8']) {
            width: calc((100% / 24) * 8);
          }
          #wrapper > ::slotted([col-m='7']) {
            width: calc((100% / 24) * 7);
          }
          #wrapper > ::slotted([col-m='6']) {
            width: calc((100% / 24) * 6);
          }
          #wrapper > ::slotted([col-m='5']) {
            width: calc((100% / 24) * 5);
          }
          #wrapper > ::slotted([col-m='4']) {
            width: calc((100% / 24) * 4);
          }
          #wrapper > ::slotted([col-m='3']) {
            width: calc((100% / 24) * 3);
          }
          #wrapper > ::slotted([col-m='2']) {
            width: calc((100% / 24) * 2);
          }
          #wrapper > ::slotted([col-m='1']) {
            width: calc((100% / 24) * 1);
          }
          #wrapper > ::slotted([col-m='0']) {
            display: none;
          }
        }

        /* column assignment for small breakpoint */

        @media only screen and (max-width: 47.9375rem) {
          #wrapper > ::slotted([col-s='24']) {
            width: 100%;
          }
          #wrapper > ::slotted([col-s='23']) {
            width: calc((100% / 24) * 23);
          }
          #wrapper > ::slotted([col-s='22']) {
            width: calc((100% / 24) * 22);
          }
          #wrapper > ::slotted([col-s='21']) {
            width: calc((100% / 24) * 21);
          }
          #wrapper > ::slotted([col-s='20']) {
            width: calc((100% / 24) * 20);
          }
          #wrapper > ::slotted([col-s='19']) {
            width: calc((100% / 24) * 19);
          }
          #wrapper > ::slotted([col-s='18']) {
            width: calc((100% / 24) * 18);
          }
          #wrapper > ::slotted([col-s='17']) {
            width: calc((100% / 24) * 17);
          }
          #wrapper > ::slotted([col-s='16']) {
            width: calc((100% / 24) * 16);
          }
          #wrapper > ::slotted([col-s='15']) {
            width: calc((100% / 24) * 15);
          }
          #wrapper > ::slotted([col-s='14']) {
            width: calc((100% / 24) * 14);
          }
          #wrapper > ::slotted([col-s='13']) {
            width: calc((100% / 24) * 13);
          }
          #wrapper > ::slotted([col-s='12']) {
            width: calc((100% / 24) * 12);
          }
          #wrapper > ::slotted([col-s='11']) {
            width: calc((100% / 24) * 11);
          }
          #wrapper > ::slotted([col-s='10']) {
            width: calc((100% / 24) * 10);
          }
          #wrapper > ::slotted([col-s='9']) {
            width: calc((100% / 24) * 9);
          }
          #wrapper > ::slotted([col-s='8']) {
            width: calc((100% / 24) * 8);
          }
          #wrapper > ::slotted([col-s='7']) {
            width: calc((100% / 24) * 7);
          }
          #wrapper > ::slotted([col-s='6']) {
            width: calc((100% / 24) * 6);
          }
          #wrapper > ::slotted([col-s='5']) {
            width: calc((100% / 24) * 5);
          }
          #wrapper > ::slotted([col-s='4']) {
            width: calc((100% / 24) * 4);
          }
          #wrapper > ::slotted([col-s='3']) {
            width: calc((100% / 24) * 3);
          }
          #wrapper > ::slotted([col-s='2']) {
            width: calc((100% / 24) * 2);
          }
          #wrapper > ::slotted([col-s='1']) {
            width: calc((100% / 24) * 1);
          }
          #wrapper > ::slotted([col-s='0']) {
            display: none;
          }
        }

        /* chapter menu */

        .chapter-wrapper {
          transition: 0.1s all ease-in-out;
        }

        :host(:not([expanded])) > .chapter-wrapper {
          max-height: 0rem;
          overflow: hidden;
          pointer-events: none;
          transform: translateY(-0.5rem);
          opacity: 0;
          display: none;
        }

        :host([chapter]) > .chapter-wrapper {
          flex-direction: column;
          border: none;
        }

        :host(:not([chapter])) > #wrapper > .arrow-icon {
          display: none;
        }

        :host([chapter]) > #wrapper > .arrow-icon {
          display: block;
          margin-top: 0.5rem;
        }

        :host([chapter][expanded]) > #wrapper > .arrow-icon {
          transform: rotate(90deg);
        }

        :host(:not([chapter]).chapter-sibling) > #wrapper > .menu-item-wrapper {
          margin-left: 2rem;
        }

        /* hover */
        :host(:not(.no-hovermq):not([slot='header']):not([readonly])) > #wrapper:hover {
          background: rgba(var(--ui-1), var(--opacity-7));
        }
        :host([slot='header']:not(.no-hovermq)) > div:hover {
          background: transparent;
        }
        :host(:not([readonly])[active]) #wrapper {
          background: rgba(var(--ui-1), var(--opacity-6)) !important;
        }
        :host(:not([freeze])) .frozen-left,
        :host(:not([freeze])) .scrollable,
        :host(:not([freeze])) .frozen-right {
          display: none !important;
        }
        .frozen-left,
        .frozen-right,
        .scrollable {
          display: flex;
          align-items: center;
        }
        .frozen-left {
          box-shadow: inset -0.125rem 0rem 0rem 0rem rgba(var(--ui-1), var(--opacity-6));
        }
        .frozen-right {
          box-shadow: inset 0.125rem 0rem 0rem 0rem rgba(var(--ui-1), var(--opacity-6));
        }
        .scrollable {
          overflow-x: hidden;
          overflow-y: hidden;
        }
        /* menu Expand Icon */
        :host #wrapper {
          position: relative;
        }
        :host #wrapper #tableExpandIcon {
          position: absolute;
          left: 0.75rem;
        }
        :host([condensed]) #tableExpandIcon {
          margin-top: 0.25rem !important;
        }
      `]}render(){return V`
      <div
        id="wrapper"
        class="${this.active?"active":""}"
        @click="${e=>this.handleClick(e)}"
      >
        ${this.chapter?V`
              <sh-icon
                id="tableExpandIcon"
                button
                icon="arrow-right-s"
                size="m"
                class="arrow-icon"
                @click="${()=>{this.handleExpanded()}}"
              ></sh-icon>
            `:""}
        <slot id="mainBody" @slotchange="${()=>this.mainBodyObserver()}"></slot>
        ${this.freeze?V` <div
                class="frozen-left"
                style="display: flex; max-width: ${this.lwidth}; width: ${this.lwidth}; min-width: ${this.lwidth}"
              >
                <slot name="frozen-left" id="frozenLeftSlot"></slot>
              </div>
              <div
                class="scrollable"
                style="display: flex; max-width: ${this.mwidth}; width: ${this.mwidth}; min-width:${this.mwidth}"
                @scroll="${e=>this.dispatchCustomScrollEvent(e)}"
              >
                <slot name="scrollable" id="scrollableSlot"></slot>
              </div>
              <div
                class="frozen-right"
                style="display: flex; max-width: ${this.rwidth};  width: ${this.rwidth}; min-width: ${this.rwidth}"
              >
                <slot name="frozen-right" id="frozenRightSlot"></slot>
              </div>`:""}
      </div>
      ${this.chapter?V` <div class="chapter-wrapper">
            <slot name="chapterSlot"></slot>
          </div>`:""}
    `}attributeChangedCallback(e,t,o){super.attributeChangedCallback(e,t,o),"condensed"===e?this.condensedObserver():"readonly"===e&&this.readonlyObserver()}updated(e){if(e.has("active")){this.dispatchEvent(new Event("active-changed"));const e=this.closest("sh-table");this.active?e.selectedRows.push(this):e.selectedRows.includes(this)&&e.selectedRows.splice(e.selectedRows.indexOf(this),1)}e.has("scrollLeft")&&this.scrollLeftChanged(),e.has("chapter")&&this.setExpandIconPosition()}condensedObserver(){const e=this.children;for(let t=0;t<e.length;t++)e[t].condensed=this.condensed}readonlyObserver(){const e=this.children.length;for(let t=0;t<e;t++)"SH-TABLE-ROW"===this.children[t].tagName&&(this.children[t].readonly=this.readonly)}scrollLeftChanged(){this.shadowRoot.querySelector(".scrollable").scrollLeft=this.scrollLeft}constructor(){super(),this.lwidth="33.3%",this.rwidth="33.3%",this.mwidth="33.3%"}connectedCallback(){super.connectedCallback();const e=this.children;let t,o=0;if("header"===this.slot){for(let i=0;i<e.length;i++)e[i].sorted&&(o++,t=i);if(o>1){let e;switch(t+1){case 2:e="nd";break;case 3:e="rd";break;default:e="th"}console.warn(`%c\t${o} table-head have sorted property.\n`,"color:white;font-weight:900;text-align:center"),console.warn("%c\tOnly one table-head with the sorted property is allowed.\n","color:white;font-weight:900;text-align:center"),console.warn(`%c\t${t+1}${e} table-head with the sorted property is given the arrow.\n`,"color:white;font-weight:900;text-align:center"),this.removeDuplicateSortedProperty(t)}this.addEventListener("showarrow",(function(o){for(let i=0;i<e.length;i++)if(e[i]===o.target){t=i;break}this.removeDuplicateSortedProperty(t)}))}}removeDuplicateSortedProperty(e){for(let t=0;t<this.children.length;t++)e!==t&&(this.children[t].sorted=!1)}firstUpdated(){Modernizr.hovermq||this.classList.add("no-hovermq"),this.freeze&&(this.shadowRoot.querySelector("#scrollableSlot").addEventListener("slotchange",(()=>this.dispatchSlotModifiedEventWithData())),this.shadowRoot.querySelector("#frozenLeftSlot").addEventListener("slotchange",(()=>this.dispatchSlotModifiedEventWithData())),this.shadowRoot.querySelector("#frozenRightSlot").addEventListener("slotchange",(()=>this.dispatchSlotModifiedEventWithData())))}handleClick(e){"header"===this.getAttribute("slot")||"tableExpandIcon"===e.target.id||this.readonly||(this.dispatchEvent(new CustomEvent("clicked",{bubbles:!0,composed:!0})),"metakey"===this.closest("sh-table").selectionMode?this._onMultiSelectKeyPress(e):this.closest("sh-table").multiselect||(this.active=!0))}_onMultiSelectKeyPress(e){let t=this.closest("sh-table").querySelectorAll("sh-table-row");if(e.ctrlKey||e.metaKey)this.active=!this.active;else if(e.shiftKey)this._onShiftKeyPress(t);else if(!e.ctrlKey&&!e.metaKey&&!e.shiftKey){for(let e=0;e<t.length;e++)t[e].removeAttribute("active");this.active=!0,this.closest("sh-table").selectedRows=[]}}_onShiftKeyPress(e){let t,o;const i=this.closest("sh-table").selectedRows,r=i[i.length-1];let s=Array.prototype.slice.call(e);s.includes(r)&&(t=s.indexOf(r)),s.includes(this)&&(o=s.indexOf(this)),t>=0&&o>=0?e[o].active?this._selectDeselectRows(e,t,o,!1):this._selectDeselectRows(e,t,o,!0):(t&&!o||o&&!t)&&(e[o||t].active=!0)}_selectDeselectRows(e,t,o,i){const r=t,s=Math.abs(o-t);for(let r=0;r<=s;r++)t<o?(e[t].active=i,t++):t>o&&(e[t].active=i,t--);i?e[o].active=i:r===o&&(e[o].active=!e[o].active)}dispatchCustomScrollEvent(e){const t=e.target.scrollLeft;this.dispatchEvent(new CustomEvent("middle-scrolled",{bubbles:!0,composed:!0,detail:{event:e,scrollLeft:t}}))}handleExpanded(){!0===this.expanded?(this.expanded=!1,this.dispatchEvent(new CustomEvent("collapse",{detail:this,composed:!0,bubbles:!0}))):(this.expanded=!0,this.dispatchEvent(new CustomEvent("expand",{detail:this,composed:!0,bubbles:!0})))}mainBodyObserver(){const e=this.parentNode.children;if(e.length>0)for(let t=0;t<e.length;t++)if(Array.from(e[t].children).filter((e=>"SH-TABLE-ROW"==e.tagName)).length>0){this._hasChapter=!0;break}this.nestRows();const t=this.children.length;for(let e=0;e<t;e++)"SH-TABLE-ROW"===this.children[e].tagName&&(this.children[e].readonly=this.readonly)}dispatchSlotModifiedEventWithData(){if(this.shadowRoot.querySelector(".scrollable")||this.shadowRoot.querySelector(".frozen-left")){const e=this.shadowRoot.querySelector(".scrollable").scrollWidth,t=this.shadowRoot.querySelector(".scrollable").getBoundingClientRect().width,o=this.shadowRoot.querySelector(".frozen-left").getBoundingClientRect().width;this.dispatchEvent(new CustomEvent("slots-modified",{bubbles:!0,composed:!0,detail:{innerWidth:e,width:t,leftPosition:o}}))}}getParents(e){const t=[];for(;e&&e!==document&&"SH-TABLE-ROW"===e.tagName;e=e.parentNode)t.push(e);return t}nestRows(){if("header"!==this.slot){const e=Array.prototype.slice.call(this.childNodes).filter((function(e){if("SH-TABLE-ROW"===e.tagName)return e}));e.length>0&&(this.chapter=!0,e.forEach((e=>{e.setAttribute("slot","chapterSlot")})))}if(this.chapter||this._hasChapter){const e=this.parentNode.children;if("SH-TABLE-ROW"!==this.parentNode.tagName)for(let t=0;t<e.length;t++)e[t].classList.add("chapter-sibling")}var e=this.shadowRoot.querySelector("#mainBody").assignedElements()[0];let t;if(e&&(t=e.hasAttribute("checkbox")),(this.chapter||this.classList.contains("chapter-sibling")||"chapterSlot"===this.slot||t)&&this._setCellPosition(t),!this.chapter&&!this.classList.contains("chapter-sibling")&&"chapterSlot"!==this.slot){const e=this.querySelector("sh-table-cell:not([checkbox])");let o=("header"===this.slot?this.querySelector("sh-table-head:not([checkbox])"):"")||e;o&&(o.style.paddingLeft=t?"calc(2.5rem)":"calc(0rem)")}}_setCellPosition(e){const t=this.getParents(this).length,o=e?"4.5rem":"3.5rem",i=this.querySelector("sh-table-cell:not([checkbox])"),r="header"===this.slot?this.querySelector("sh-table-head:not([checkbox])"):"";if(i){i.style.paddingLeft=1===t?o:`calc(${o} + ${t-1} * 2.75rem)`;const r=this.querySelector("sh-table-cell[checkbox]");r&&this._setCheckboxPostion(e,t,r)}if(r){const i=this.querySelector("sh-table-head[checkbox]");i&&this._setCheckboxPostion(e,t,i),r.style.paddingLeft=e?`calc(${o} + ${t-1} * 2.75rem)`:"calc(0rem)"}}_setCheckboxPostion(e,t,o){if(e){var i=2.5*(t-1);o.style.position="absolute",o.style.left=`calc(${i+"rem"})`}else o&&(o.style.position="unset",o.style.left="0rem")}setExpandIconPosition(){if(!this.chapter)return;const e=this.shadowRoot.querySelector("#tableExpandIcon"),t=this.getParents(this).length;let o,i,r=this.querySelector("sh-table-cell[checkbox]"),s=this.shadowRoot.querySelector("#mainBody");if(s.assignedElements()[0]&&(o=s.assignedElements()[0].hasAttribute("checkbox")),r&&o){let e=r.style.left.split("(")[1].split(")")[0].split("rem")[0];i=Number(e)+3}e.style.left=o?`calc(${i+"rem"})`:`calc(3.5rem + ${t-2} * 2.75rem)`}}),customElements.define("sh-table",class extends se{static get properties(){return{lwidth:{type:String,reflect:!0},rwidth:{type:String,reflect:!0},mwidth:{type:String,reflect:!0},freeze:{type:Boolean,reflect:!0},scrolledLeft:{type:Number},condensed:{type:Boolean,reflect:!0},readonly:{type:Boolean,reflect:!0},multiselect:{type:Boolean,reflect:!0},selectionMode:{type:String,reflect:!0,attribute:"selection-mode"},selectedRows:{type:Array,reflect:!1}}}static get styles(){return[ae,ie`
        :host {
          width: 100%;
          height: 100%;
          overflow-y: hidden;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-orient: vertical;
          -webkit-box-direction: normal;
          -ms-flex-direction: column;
          flex-direction: column;
          --scrollbar-width: 0rem;
        }
        :host([multiselect][selection-mode='metakey']) {
          user-select: none;
        }
        :host([fit-content]) {
          min-height: fit-content;
          min-height: -ms-fit-content;
          min-height: -moz-fit-content;
          max-height: fit-content;
          max-height: -ms-fit-content;
          max-height: -moz-fit-content;
        }

        .table-wrapper {
          -webkit-box-flex: 1;
          -ms-flex: 1;
          flex: 1;
          overflow-y: auto;
          overflow-x: hidden;
          width: 100%;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
        }
        .table-wrapper {
          max-height: -webkit-fit-content;
          max-height: -moz-fit-content;
          max-height: fit-content;
        }
        :host([freeze]) .floating-scrollbar {
          position: relative;
          margin-top: 0.5rem;
          overflow-x: auto;
        }
        :host([freeze]) .scrollThumb {
          height: 0.5rem;
        }
        .header-wrapper {
          overflow-x: hidden;
          width: 100%;
          max-height: -webkit-fit-content;
          max-height: -moz-fit-content;
          max-height: fit-content;
          overflow-y: hidden;
          padding-right: var(--scrollbar-width);
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
        }
      `]}constructor(){super(),this.lwidth="33.3%",this.rwidth="33.3%",this.mwidth="33.3%",this.selectedRows=[]}render(){return V`
      <div class="header-wrapper">
        <slot name="header" id="header-slot"></slot>
      </div>
      <div class="table-wrapper" @scroll="${()=>this.contentScrolled()}" id="tableContent">
        <div class="content">
          <slot id="tableBodySlot"></slot>
        </div>
      </div>
      ${this.freeze?V`
            <div class="floating-scrollbar" @scroll="${e=>this.adjustScrollLeft(e)}">
              <div class="scrollThumb"></div>
            </div>
          `:""}
    `}attributeChangedCallback(e,t,o){super.attributeChangedCallback(e,t,o),"condensed"===e?this.condensedObserver():"lwidth"===e||"rwidth"===e||"mwidth"===e?this.widthObserver():"readonly"===e&&this.slotObserver()}updated(e){e.has("scrolledLeft")&&this.scrolledLeftChanged()}connectedCallback(){super.connectedCallback(),this.resizeListener=this.windowResizeListener.bind(this),this.addEventListener("clicked",(function(){if(!this.multiselect){const e=this.querySelectorAll("sh-table-row[active]");for(let t=0;t<e.length;t++)e[t].removeAttribute("active")}})),this.freeze&&window.addEventListener("resize",this.resizeListener),this._resizeObserver=new ResizeObserver((()=>{this.windowResizeListener()}))}firstUpdated(){this.shadowRoot.querySelector("#tableBodySlot").addEventListener("slotchange",(()=>this.slotObserver()));const e=parseFloat(window.getComputedStyle(document.querySelector("html"),null).getPropertyValue("font-size"));if(this.freeze){const t=this.shadowRoot.querySelector(".floating-scrollbar"),o=this.shadowRoot.querySelector(".scrollThumb");this.addEventListener("slots-modified",(function(i){if(o.style.width=i.detail.innerWidth/e+"rem",t.style.width=i.detail.width/e+"rem",t.style.left=i.detail.leftPosition/e+"rem",void 0!==this.scrolledLeft){t.scrollLeft=this.scrolledLeft;let e=this.querySelectorAll("sh-table-row");for(let t=0;t<e.length;t++)e[t].freeze&&(e[t].shadowRoot.querySelector(".scrollable").scrollLeft=this.scrolledLeft)}this.widthObserver()})),this.addEventListener("touchstart",(e=>{if(!this._hasAllFrozenRows())return;let t=e.composedPath(),o=!1;for(let e=0;e<t.length;e++)if(t[e].tagName&&t[e].classList.contains("scrollable")&&"DIV"===t[e].tagName){o=!0;break}o?(this.touchStartPos=e.changedTouches[0].pageX,this.touchstartedOnScrollable=!0):this.touchstartedOnScrollable=!1})),this.addEventListener("touchmove",(e=>{if(!this._hasAllFrozenRows())return void(this._issuedFrozenTableWarning||(console.warn("All table rows in a frozen table must have freeze property."),this._issuedFrozenTableWarning=!0));let o=e.composedPath();if(this.touchstartedOnScrollable){let i=!1;for(let e=0;e<o.length;e++)if(o[e].tagName&&o[e].classList.contains("scrollable")&&"DIV"===o[e].tagName){i=!0;break}i&&(e.changedTouches[0].pageX-this.touchStartPos<0?t.scrollLeft+=Math.abs(e.changedTouches[0].pageX-this.touchStartPos):t.scrollLeft-=Math.abs(e.changedTouches[0].pageX-this.touchStartPos),this.touchStartPos=e.changedTouches[0].pageX)}}))}this._issuedFrozenTableWarning=!1,this._resizeObserver.observe(this)}setHeaderPadding(){const e=this.getScrollBarWidth(),t="number"==typeof e?ki(e):null;Boolean(this.shadowRoot.querySelector(".header-wrapper"))&&"number"==typeof t&&this.shadowRoot.querySelector(".header-wrapper").style.setProperty("--scrollbar-width",`${t}rem`)}getScrollBarWidth(){return Boolean(this.shadowRoot.querySelector(".table-wrapper"))?this.shadowRoot.querySelector(".table-wrapper").getBoundingClientRect().width-this.shadowRoot.querySelector(".table-wrapper .content").getBoundingClientRect().width:null}windowResizeListener(){this.setHeaderPadding(),this.forceStyleUpdate(),setTimeout((()=>{if(this.setHeaderPadding(),this.forceStyleUpdate(),this.freeze){const e=this.shadowRoot.querySelector(".floating-scrollbar"),t=this.shadowRoot.querySelector(".scrollThumb");let o=this.querySelector("sh-table-row[freeze]");const i=parseFloat(window.getComputedStyle(document.querySelector("html"),null).getPropertyValue("font-size"));if(!o)return;const r=o.shadowRoot.querySelector(".frozen-left"),s=o.shadowRoot.querySelector(".scrollable");e.style.left=r.getBoundingClientRect().width/i+"rem",e.style.width=s.getBoundingClientRect().width/i+"rem",t.style.width=s.scrollWidth/i+"rem"}}),500)}forceStyleUpdate(){getComputedStyle(document.documentElement)}widthObserver(){let e=this.querySelectorAll("sh-table-row");for(let t=0;t<e.length;t++)e[t].freeze&&(e[t].lwidth=this.lwidth,e[t].mwidth=this.mwidth,e[t].rwidth=this.rwidth);this.windowResizeListener()}condensedObserver(){let e=this.querySelectorAll("sh-table-row");for(let t=0;t<e.length;t++)e[t].condensed=this.condensed}contentScrolled(){const e=this.shadowRoot.querySelector("#tableContent"),t=e.scrollTop+e.clientHeight,o=e.scrollHeight;Math.ceil(t)>=o&&this.dispatchEvent(new CustomEvent("scroll-end",{detail:this,composed:!0,bubbles:!0}))}slotObserver(){let e=this.querySelectorAll("sh-table-row");for(let t=0;t<e.length;t++)e[t].readonly=this.readonly;this.windowResizeListener()}adjustScrollLeft(e){let t=this.querySelectorAll("sh-table-row");if(this._hasAllFrozenRows()){for(let o=0;o<t.length;o++)t[o].freeze&&(t[o].shadowRoot.querySelector(".scrollable").scrollLeft=e.target.scrollLeft);this.scrolledLeft=e.target.scrollLeft}else this._issuedFrozenTableWarning||(console.warn("All table rows in a frozen table must have freeze property."),this._issuedFrozenTableWarning=!0)}scrolledLeftChanged(){let e=this.querySelectorAll("sh-table-row");if(this._hasAllFrozenRows())for(let t=0;t<e.length;t++)e[t].freeze&&(e[t].scrollLeft=this.scrolledLeft,e[t].shadowRoot.querySelector(".scrollable").scrollLeft=this.scrolledLeft)}_hasAllFrozenRows(){return!this.querySelector("sh-table-row:not([freeze])")}disconnectedCallback(){this.freeze&&window.removeEventListener("resize",this.resizeListener),this._resizeObserver.disconnect(),super.disconnectedCallback()}});class Zi extends(fe(de(se))){static get properties(){return{label:{type:String,reflect:!0},name:{type:String,reflect:!0},info:{type:String,reflect:!0},href:{type:String,reflect:!0},patient:{type:Boolean,reflect:!0},active:{type:Boolean,reflect:!0},disabled:{type:Boolean,reflect:!0},role:{type:String,reflect:!0},icon:{type:String,reflect:!0},size:{type:String,reflect:!0},collapsed:{type:Boolean,reflect:!0},condensed:{type:Boolean,reflect:!0},sticky:{type:Boolean,reflect:!0},_accessContext:{type:Boolean,reflect:!0,attribute:"access-context"},_footerContext:{type:Boolean,reflect:!0,attribute:"footer-context"},badge:{type:String,reflect:!0},closable:{type:Boolean,reflect:!0}}}static get styles(){return[ae,ie`
        :host {
          font: var(--title-1);
          color: var(--text-secondary);
          position: relative;
          overflow: hidden;
          outline: 0;
          max-width: 11.5rem;
          min-width: 3.5rem;
          height: 3.5rem;
          box-sizing: border-box;
          padding: 1rem 1rem 0.875rem 1rem;
          line-height: 1.5rem;
          border-bottom: 0.125rem solid transparent;
          transition: var(--transition-time) border ease-in-out;
          text-align: center;
          cursor: pointer;
          -webkit-font-smoothing: antialiased;
          text-rendering: optimizeLegibility;
          -moz-osx-font-smoothing: grayscale;
          user-select: none;
          -moz-user-select: none;
          -webkit-user-select: none;
          display: flex;
        }

        :host(:not([label])) {
          min-width: 4rem;
        }
        :host([disabled]) {
          background: transparent;
          color: var(--text-disabled);
          pointer-events: none;
        }
        .text {
          overflow: hidden;
          font-size: 0.875rem;
        }
        :host([href]) .href-wrapper {
          margin: 1rem;
        }
        :host([patient][href]) .href-wrapper,
        :host([href][badge]:not([icon])) .href-wrapper {
          display: flex;
        }
        :host([icon][href][access-context]:not([label]):not([condensed])) .href-wrapper {
          margin: 1.25rem 1rem;
        }
        :host([access-context][patient][href]) .href-wrapper {
          margin: 1.25rem 0.5rem;
        }
        :host([access-context][href]) .href-wrapper {
          margin: 1.5rem 1rem;
        }
        :host([condensed][href]) .href-wrapper {
          margin: 0.5rem 1rem;
        }
        :host([condensed][href][patient]) .href-wrapper {
          margin: 0.25rem 0.5rem;
        }
        :host([icon][access-context][href]) .href-wrapper,
        :host([icon][href]:not([label]):not([condensed])) .href-wrapper {
          margin: 0.75rem 1rem;
        }
        :host([icon][href]) .href-wrapper,
        :host([icon][access-context][href][condensed]) .href-wrapper {
          margin: 0.25rem 1rem 0.125rem;
        }
        :host([icon][access-context][href][condensed]),
        :host([icon][href][label]),
        :host([icon][href][access-context]),
        :host([icon]:not([label])[href]) {
          padding: 0rem;
        }
        :host a {
          color: currentColor;
          text-decoration: none;
          height: 3.5rem;
          margin: -1rem;
          width: calc(100% + 2rem);
        }
        :host([access-context][href]) a {
          height: 4.5rem;
          margin: -1.5rem -1rem;
        }
        :host([access-context][patient][href]) a {
          margin: -1.5rem -0.5rem;
          width: calc(100% + 1rem);
        }
        :host([condensed][href]) a {
          height: 2.5rem;
          margin: -0.5rem -1rem;
        }
        :host([condensed][patient]) a {
          margin: -0.25rem -0.5rem;
        }
        :host([icon][href]) a {
          margin: 0rem;
        }

        .label,
        .info,
        .name {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          transition: var(--transition-time) all ease-in-out;
        }

        :host([active]) #tab-item-icon {
          color: var(--text-primary);
        }
        :host([disabled]) #tab-item-icon {
          color: var(--text-disabled);
        }
        :host([patient][disabled]) #close {
          display: none;
        }

        :host([icon]) #tab-item:not([collapsed]) {
          padding: 0.25rem 1rem 0.125rem 1rem;
          line-height: 1rem;
          font-size: 0.75rem;
        }
        :host([icon]:not([label])) {
          padding: 0.75rem 1rem 0.625rem 1rem;
        }
        :host([active]) {
          color: var(--text-primary);
          border-bottom: 0.125rem solid rgba(var(--ui-2), var(--opacity-1));
        }
        #tab-item-icon {
          color: var(--text-secondary);
        }
        :host([patient]) #tab-item-icon {
          margin-right: 0.5rem;
          margin-left: 0rem;
        }

        /* functions slot */
        :host([href]:not([active])) slot[name='functions']::slotted(*) {
          display: none;
        }
        :host([href][patient]) slot[name='functions']::slotted(*),
        :host([patient]) > ::slotted(*[slot='functions']) {
          width: 2rem;
          margin-right: 1.5rem;
          margin-left: -0.5rem;
        }
        :host(:not([active])) > ::slotted(*[slot='functions']) {
          width: 0rem;
          display: none;
          min-width: unset;
          margin: 0rem;
          opacity: 0;
        }

        /* patient tab */
        sh-icon#close {
          opacity: 0;
          position: absolute;
          top: 0rem;
          right: 0.5rem;
        }
        :host([patient]) .text {
          margin-right: 1.5rem;
        }
        sh-icon[icon='patient'] {
          margin-right: 0.5rem;
        }
        :host([patient]) sh-icon[icon='patient'] {
          display: flex;
          color: var(--text-secondary);
        }
        :host([patient][active]) sh-icon[icon='patient'] {
          color: var(--text-primary);
        }
        :host([patient]) {
          display: flex;
          padding: 1.25rem 0.5rem 1.125rem 0.5rem !important;
          line-height: 1rem;
          text-align: left;
          align-items: center;
          width: fit-content;
          min-width: 11.5rem;
          max-width: 11.5rem;
        }
        :host([patient][active]) {
          max-width: 17.5rem;
        }
        :host([patient]) .label {
          font: var(--title-1);
        }
        :host([patient]) .info {
          display: block;
          font: var(--body-2);
          line-height: 1rem;
        }

        :host([disabled]) .info {
          color: var(--text-disabled);
        }
        :host([disabled]) sh-icon[icon='patient'] {
          color: var(--text-disabled);
        }
        :host([patient][condensed]) {
          padding: 0.25rem 0.5rem 0.125rem 0.5rem !important;
        }
        :host([icon][label]) {
          padding: 0.25rem 1rem 0.125rem 1rem;
          line-height: 1rem;
        }
        :host([icon][label]) #tab-item-icon {
          display: block;
        }
        :host([patient][active][size='l']),
        :host([size='l']:not([patient])) {
          max-width: 23.5rem;
        }
        /* access bar */
        :host([icon][label][access-context]) #tab-item-icon,
        :host([icon][label][footer-context]) #tab-item-icon {
          display: block;
        }
        :host([access-context]) {
          padding: 1.5rem 1rem 1.375rem;
          height: 4.5rem;
        }
        :host([icon][label][access-context]:not([href])) {
          padding: 0.75rem 1rem 0.625rem;
        }
        :host([icon][access-context]:not([label]):not([href])) {
          padding: 1.25rem 1rem 1.125rem;
        }
        :host([condensed]) {
          padding: 0.5rem 1rem 0.375rem 1rem;
          height: 2.5rem;
          display: flex;
        }
        :host([icon][label][condensed]) {
          line-height: 1.5rem;
        }
        :host([icon][condensed]),
        :host([icon][condensed]:not([label]):not([href])),
        :host([icon][label][condensed][access-context]:not([href])) {
          padding: 0.25rem 1rem 0.125rem;
        }

        /* collapsed */
        :host([collapsed]) {
          height: 2.5rem;
          padding: 0.5rem;
          width: 100%;
          max-width: none;
          text-align: left;
          font-weight: 500;
          border: 0rem transparent;
          display: flex;
        }
        :host([patient][collapsed]) {
          height: 3.5rem;
        }
        :host([icon][collapsed]),
        :host([patient][collapsed]:not([info])) {
          height: 3rem;
        }
        :host([patient][collapsed]:hover:not(.touch-device)) #close {
          display: block;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 0.5rem;
          background: transparent;
        }
        :host([active][collapsed]) {
          background: rgba(var(--ui-1), var(--opacity-6));
        }
        :host([collapsed]:not([label])) .name {
          display: flex;
          font: var(--body-1);
        }
        :host([collapsed]:not([label])) {
          padding: 0.5rem !important;
        }
        :host([collapsed]:not([patient])) .name,
        :host([collapsed]:not([patient])) .label {
          color: var(--text-primary);
          line-height: 1.5rem;
        }
        :host([icon][collapsed]) .name,
        :host([icon][collapsed]) .label {
          line-height: 2rem;
        }
        :host([collapsed]) #tab-item-icon {
          margin: 0 0.5rem 0 0;
        }

        /* hover */
        :host(:hover:not(.touch-device)) #tab-item-icon,
        :host(.touch-device):hover #tab-item-icon {
          color: var(--text-primary);
        }
        :host(:hover:not(.touch-device)) .label,
        :host(.touch-device):hover .label {
          color: var(--text-primary);
        }
        :host([patient]:hover:not(.touch-device)) #close,
        :host([patient][active].touch-device) #close,
        :host([patient].touch-device) #close,
        #close:focus {
          opacity: 1;
          top: 0.5rem;
        }
        #close.item-focused {
          outline: var(--focus-outline);
        }
        :host([patient]:hover:not(.touch-device)) sh-icon[icon='patient'],
        :host([patient].touch-device):hover sh-icon[icon='patient'] {
          color: var(--text-primary);
        }
        :host([icon]:not([patient])) {
          display: block;
        }
        :host([icon][label]:not([patient])) #tab-item-icon {
          margin: auto;
        }
        :host([icon][access-context]) sh-badge {
          position: absolute;
          right: 0.375rem;
          top: 0.375rem;
          margin: 0rem;
        }
        :host([icon][access-context][badge='']) sh-badge {
          position: absolute;
          right: 0.5rem;
          top: 0.5rem;
          margin: 0rem;
        }
        :host([icon][badge='']) sh-badge,
        :host([icon]) sh-badge {
          position: absolute;
          right: 0.25rem;
          top: 0.25rem;
          margin: 0rem;
        }
        sh-icon:not(#close) {
          transition: 0s color;
        }
        :host([access-context]) sh-badge {
          margin-top: -1.125rem;
        }
        :host([access-context][badge='']) sh-badge {
          margin-top: -1rem;
        }
        :host(:not([patient]):not([icon])) {
          overflow: unset;
        }
        sh-badge {
          margin: -0.625rem -0.625rem 0rem 0.375rem;
          transition: var(--transition-time) all ease-in-out;
        }
        :host([badge='']) sh-badge {
          margin: -0.5rem -0.5rem 0rem 0.5rem;
        }
        :host([condensed]) sh-badge {
          margin-top: -0.125rem;
        }
        :host([condensed][badge='']) sh-badge {
          margin-top: 0rem;
        }
        :host([active].item-focused) {
          box-shadow: var(--focus-color) 0px 0.125rem 0px 0px inset,
            var(--focus-color) 0.125rem 0px 0px 0px inset,
            var(--focus-color) -0.125rem 0px 0px 0px inset;
          outline: none;
        }
        :host(.item-focused) {
          box-shadow: none;
          outline: var(--focus-outline);
          outline-offset: -0.125rem;
        }
        .tab-close,
        :host([access-context][closable][disabled][condensed]) sh-badge {
          margin-left: 0.5rem;
        }
        :host([closable]:not([disabled])) {
          padding-right: 0.5rem;
        }
        :host([access-context][closable]:not([disabled])) {
          padding-right: 2rem;
        }
        :host([access-context][closable]:not([disabled])) .tab-close {
          margin: 0rem;
          position: absolute;
          top: 0.5rem;
          right: 0.5rem;
        }
        :host([access-context][closable]:not([disabled])) .label {
          margin-right: 0.5rem;
        }

        :host([access-context][closable][condensed]) sh-badge,
        :host([access-context][closable][condensed]) sh-badge {
          margin: -0.125rem 0 0 0;
        }
        :host([access-context][closable]) sh-badge {
          margin: -1.125rem 0 0 0;
        }
      `]}constructor(){super(),this.size="m"}render(){return V`
      ${this.href?V`<a href="${this.href}">
            <div class="href-wrapper">${this._getTabItemTemplate()}</div>
          </a>`:this._getTabItemTemplate()}
      ${!this.sticky&&this.patient?V` <sh-icon
            icon="cancel"
            button
            size="s"
            @click="${e=>this._removeTab(e)}"
            id="close"
            tabindex="0"
          ></sh-icon>`:""}
    `}_getTabItemTemplate(){return V`${this.patient&&!this.icon?V` <sh-icon icon="patient"></sh-icon>`:this.icon?V` <sh-icon icon="${this.icon}" id="tab-item-icon"></sh-icon>`:""}
    ${this.label||this.name||this.info?V` <div class="text">
          ${this.label?V` <div class="label" @mouseenter="${e=>this._showTooltip(e,this.label)}">
                ${this.label}
              </div>`:""}
          ${this.collapsed&&!this.label&&this.name?V` <div class="name">${this.name}</div>`:""}
          ${this.patient&&this.info?V` <div class="info" @mouseenter="${e=>this._showTooltip(e,this.info)}">
                ${this.info}
              </div>`:""}
          <sh-tooltip placement="bottom-left"></sh-tooltip>
        </div>`:""}
    ${this.patient?V` <slot name="functions"></slot>`:""}
    ${this.patient||null===this.badge||"error"!==this.badge&&"success"!==this.badge&&"warning"!==this.badge?"":V` <sh-badge type="${this.badge}" ?disabled="${this.disabled}"></sh-badge>`}
    ${this.patient||null===this.badge||isNaN(this.badge)||""===this.badge?"":V` <sh-badge label="${this.badge}" ?disabled="${this.disabled}"></sh-badge>`}
    ${!this.patient&&null!==this.badge&&""===this.badge&&this.closable?V` <sh-badge ?disabled="${this.disabled}"></sh-badge>`:""}
    ${this.patient||!this.closable||this.disabled?"":V` <sh-icon
          icon="cancel"
          size="s"
          button
          ?disabled="${this.disabled}"
          class="tab-close"
          @click="${e=>this._removeTab(e)}"
        ></sh-icon>`}
    ${this.patient||null===this.badge||""!==this.badge||this.closable?"":V` <sh-badge ?disabled="${this.disabled}"></sh-badge>`} `}connectedCallback(){super.connectedCallback(),this.hasAttribute("role")||(this.role="tab"),ue.isTouchDevice()&&this.classList.add("touch-device")}firstUpdated(){super.firstUpdated(),this._setContext(),this.addEventListener("click",this._clickEventListener),this.active?this.setAttribute("tabindex","0"):this.setAttribute("tabindex","-1")}updated(e){super.updated(e),e.has("active")&&(this.active?this.setAttribute("tabindex","0"):this.setAttribute("tabindex","-1")),he(this,e,["label","name","info","href","patient","active","disabled","role","icon","size","collapsed","condensed","sticky","badge"])}_showTooltip(e,t){const o=this.shadowRoot.querySelector("sh-tooltip");Se(e,t,o)}_setContext(){const e=this.closest("sh-tabs");e&&(this._accessContext=e._accessContext,this._footerContext=e._footerContext)}_clickEventListener(){this._dispatchClickedEvent(),void 0!==this.href&&null!==this.href&&(window.location.href=this.href)}_removeTab(e){e.stopPropagation(),le(this,"closed")}_dispatchClickedEvent(){le(this,"clicked"),this.active=!0}handleKeyup(e){let t,o=this.parentElement.querySelectorAll("SH-TAB-ITEM:not([disabled])");if(e.keyCode!==me.TAB||this.disabled||(document.activeElement!==this||this.shadowRoot.activeElement?this.classList.remove("item-focused"):this.classList.add("item-focused")),e.keyCode!==me.SPACE&&e.keyCode!==me.ENTER||document.activeElement!==this||this.shadowRoot.activeElement){if(e.keyCode===me.ARROW_RIGHT||e.keyCode===me.ARROW_DOWN){let i=Array.from(o).indexOf(this);t=i===o.length-1?o[0]:o[i+1],this.handleArrowInput(e,t)}else if(e.keyCode===me.ARROW_LEFT||e.keyCode===me.ARROW_UP){let i=Array.from(o).indexOf(this);t=0===i?o[o.length-1]:o[i-1],this.handleArrowInput(e,t)}}else this._dispatchClickedEvent()}handleArrowInput(e,t){t&&(e.preventDefault(),t.focus(),t.classList.add("item-focused"))}}customElements.define("sh-tab-item",Zi);class Ki extends(fe(se)){static get properties(){return{role:{type:String,reflect:!0},collapsed:{type:Boolean,reflect:!0},active:{type:Boolean,reflect:!0},label:{type:String,reflect:!0},icon:{type:String,reflect:!0},info:{type:String,reflect:!0},_accessContext:{type:Boolean,reflect:!0,attribute:"access-context"},_navContext:{type:Boolean,reflect:!0,attribute:"nav-context"},_footerContext:{type:Boolean,reflect:!0,attribute:"footer-context"},condensed:{type:Boolean,reflect:!0},fixed:{type:Boolean,reflect:!0},scrollable:{type:Boolean,reflect:!0},noArrows:{type:Boolean,reflect:!0,attribute:"no-arrows"},noScroll:{type:Boolean,reflect:!0,attribute:"no-scroll"}}}static get styles(){return[ae,ie`
        :host {
          position: relative;
          display: flex;
          flex-direction: row;
          overflow: hidden;
          border-bottom: 0.0625rem solid rgba(var(--ui-1), var(--opacity-7));
        }
        :host(.item-focused) {
          outline: var(--focus-outline);
          outline-offset: -0.125rem;
        }
        :host([access-context]),
        :host([nav-context]),
        :host([footer-context]) {
          border-bottom: none;
        }

        /* collapsed */

        .collapsed-popover {
          position: absolute;
          top: 100%;
          left: 0rem;
          background: var(--base-3);
          box-shadow: var(--shadow-overlay);
          border-radius: 0.125rem;
          min-width: 100%;
          max-width: 15rem;
          max-height: 0rem;
          opacity: 0;
          transform: translateY(-1.5rem);
          overflow: hidden;
          display: none;
          transition: var(--transition-time) all ease-in-out;
        }
        :host([collapsed][active]) .collapsed-popover {
          overflow: auto;
          max-height: 12.5rem;
          opacity: 1;
          transform: none;
          display: block;
        }
        :host([collapsed][active]) #expand-icon {
          transform: rotate(180deg);
        }
        :host([collapsed]) {
          overflow: visible;
        }
        :host([collapsed]) .collapsed-input {
          cursor: pointer;
          display: inline-flex;
          height: 4.5rem;
          min-width: 6.25rem;
          max-width: 25.5rem;
          padding: 1.25rem 0.5rem;
          box-sizing: border-box;
          font: var(--body-1);
          color: var(--text-primary);
          line-height: 2rem;
        }

        :host([collapsed][condensed]) .collapsed-input {
          height: 2.5rem;
          padding: 0.25rem 0.5rem;
        }

        :host([collapsed][condensed]) .text {
          line-height: 2rem;
        }

        :host([collapsed][condensed]) .info {
          display: none;
        }

        #expand-icon {
          transition: 0s transform, var(--transition-time) color ease-in-out;
          margin-left: 0.5rem;
          color: rgba(var(--ui-1), var(--opacity-4));
        }

        #tab-icon {
          color: rgba(var(--ui-1), var(--opacity-2));
          margin-right: 0.5rem;
        }

        :host([info]) .text {
          font: var(--title-1);
          line-height: 1rem;
        }

        .text {
          color: var(--text-primary);
          flex-direction: column;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .info {
          font: var(--body-2);
          color: var(--text-secondary);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .items-scroll-wrapper {
          display: flex;
          width: fit-content;
          width: -moz-fit-content;
        }
        .items-wrapper {
          overflow-x: scroll;
          overflow-y: hidden;
          scrollbar-width: none;
          scroll-behavior: smooth;
          scroll-snap-type: x proximity;
        }
        .arrow-icons {
          padding: 0.75rem 0.5rem;
        }
        :host([condensed]) .arrow-icons {
          padding: 0.25rem 0;
        }
        :host([access-context]:not([condensed])) .arrow-icons {
          padding: 1.25rem 0;
        }
        ::-webkit-scrollbar {
          height: 0rem;
        }
        .hidden,
        :host([no-arrows]) .arrow-icons {
          display: none;
        }
        /* hover */
        :host([collapsed]:not(.no-hovermq)) .collapsed-input:hover #expand-icon {
          color: rgba(var(--ui-1), var(--opacity-3));
        }
      `]}render(){return V`
      ${this.collapsed?V` <div class="collapsed-input" @click="${()=>this._show()}">
              <sh-icon icon="${this.icon}" id="tab-icon"></sh-icon>
              <div class="text">
                ${this.label}
                <div class="info">${this.info}</div>
              </div>
              <div class="info"></div>
              <sh-icon icon="down-s" id="expand-icon"></sh-icon>
            </div>
            <div class="collapsed-popover">
              <slot id="collapsed-slot" @slotchange="${this._handleTabsSlotChange}"></slot>
            </div>`:V` ${this.scrollable&&!this.noScroll?V`<sh-icon
                icon="arrow-line-left-s"
                button
                @click="${()=>this.scrollTabs("left")}"
                class="arrow-icons left hidden"
              ></sh-icon>`:""}
          ${this.noScroll?V` <slot id="main-slot" @slotchange="${this._handleTabsSlotChange}"></slot>`:V` <div class="items-wrapper" @scroll="${this._handleArrows.bind(this)}">
                <div class="items-scroll-wrapper">
                  <slot id="main-slot" @slotchange="${this._handleTabsSlotChange}"></slot>
                </div>
              </div>`}
          ${this.scrollable&&!this.noScroll?V`<sh-icon
                icon="arrow-line-right-s"
                button
                @click="${()=>this.scrollTabs("right")}"
                class="arrow-icons right"
              ></sh-icon>`:""}`}
    `}constructor(){super(),this.fixed=!1}connectedCallback(){super.connectedCallback(),this.hasAttribute("role")||(this.role="navigation"),Modernizr.hovermq||this.classList.add("no-hovermq"),this.resizeObserver=new ResizeObserver((()=>{if(this.collapsed)return;const e=this.shadowRoot.querySelector(".items-scroll-wrapper");e&&(e.getBoundingClientRect().width>this.getBoundingClientRect().width?this._handleOverflow(!0):this._handleOverflow(!1))})),this.resizeObserver.observe(this),this.addEventListener("clicked",(function(e){this.label=e.target.label,this.icon=e.target.icon,!0===e.target.patient?(this.icon="patient",this.info=e.target.info):this.info=null,void 0===e.target.label&&(this.label=e.target.name),this._makeTabItemsInactive(),this._hide()}))}disconnectedCallback(){this.resizeObserver.disconnect(),super.disconnectedCallback()}firstUpdated(){super.firstUpdated(),this.condensed?this.setAttribute("tabindex","0"):this.removeAttribute("tabindex"),this.addEventListener("focusout",(function(e){this.contains(e.relatedTarget)||(this.active=!1)}))}updated(e){e.has("collapsed")&&this._collapsedChanged(),e.has("condensed")&&this._condensedChanged(),he(this,e,["role","collapsed","active","label","icon","info","condensed","fixed"])}scrollTabs(e){const t=this.shadowRoot.querySelector(".items-wrapper");"left"===e?t.scrollLeft-=100:t.scrollLeft+=100}_handleOverflow(e){this.scrollable=e}_handleArrows(){const e=this.shadowRoot.querySelector(".items-wrapper");if(!e)return;const t=this.shadowRoot.querySelector("sh-icon.left"),o=this.shadowRoot.querySelector("sh-icon.right");t&&(0==e.scrollLeft?t.classList.add("hidden"):t.classList.remove("hidden")),o&&(Math.ceil(e.scrollLeft+e.offsetWidth)>=e.scrollWidth?o.classList.add("hidden"):o.classList.remove("hidden"))}_makeTabItemsInactive(){const e=this.querySelectorAll("sh-tab-item[active]");for(let t=0;t<e.length;t++)e[t].active=!1}_setTabsProperties(){const e=this.querySelector("[active]");null!==e&&(void 0!==e.attributes.name?this.label=e.attributes.name.value:void 0!==e.attributes.label&&(this.label=e.attributes.label.value),void 0!==e.attributes.patient?(this.icon="patient",void 0!==e.attributes.info&&(this.info=e.attributes.info.value)):void 0!==e.attributes.icon&&(this.icon=e.attributes.icon.value))}_condensedChanged(){const e=this.querySelectorAll("sh-tab-item");for(let t=0;t<e.length;t++)e[t].condensed=this.condensed}_collapsedChanged(){const e=this.querySelectorAll("sh-tab-item");for(let t=0;t<e.length;t++)e[t].collapsed=this.collapsed;this.collapsed?this.setAttribute("tabindex","1"):this.removeAttribute("tabindex")}_show(){!0!==this.active?this.active=!0:this._hide()}_hide(){this.active=!1}_handleTabsSlotChange(){const e=this.querySelectorAll("sh-tab-item");this._accessContext&&e.forEach((e=>{e._accessContext=!0})),this._setTabsProperties(),this._collapsedChanged(),this._condensedChanged()}handleKeyup(e){if(super.handleKeyup(e),e.keyCode!==me.SPACE&&e.keyCode!==me.ENTER||this.toggleAttribute("active"),e.keyCode===me.ARROW_DOWN&&this.collapsed&&this.active){let e=this.querySelector("SH-TAB-ITEM:not([disabled])");e.focus(),e.classList.add("item-focused")}if(e.keyCode===me.ARROW_UP&&this.collapsed&&this.active){let e=this.querySelectorAll("SH-TAB-ITEM:not([disabled])"),t=e[e.length-1];t.focus(),t.classList.add("item-focused")}}}customElements.define("sh-tabs",Ki);var Gi=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-tag-container-height=2rem] - height of container
   */
  --sh-tag-container-height: 2rem;
  /* 
   * @cssprop [--sh-tag-wrapper-border=0.0625rem] - border of tag wrapper
   */
  --sh-tag-wrapper-border: 0.0625rem;
  /* 
   * @cssprop [--sh-tag-padding=0 0.5rem] - left and right padding of tag
   */
  --sh-tag-padding: 0 0.5rem;
  /* 
   * @cssprop [--sh-tag-label-line-height=2rem] - line height of tag label
   */
  --sh-tag-label-line-height: 2rem;
  /* 
   * @cssprop [--sh-tag-icon-padding=0.5rem] - padding of the icon
   */
  --sh-tag-icon-padding: 0.5rem;
  /* 
   * @cssprop [--sh-tag-border-radius=0.125rem] - border radius
   */
  --sh-tag-border-radius: 0.125rem;
}

:host {
  height: var(--sh-tag-container-height);
  overflow-y: hidden;
  flex-direction: row;
  cursor: pointer;
  outline: 0;
  display: block;
  flex-shrink: 0;
}

.tag-wrapper {
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  width: -ms-fit-content;
  width: -moz-fit-content;
  height: 100%;
  border: var(--sh-tag-wrapper-border) solid rgba(var(--ui-1), var(--opacity-5));
  box-sizing: border-box;
  border-radius: var(--sh-tag-border-radius);
  padding: var(--sh-tag-padding);
  transition: var(--transition-time) all ease-in-out, var(--hover-transition-time) border-color;
}

:host([removable]) .tag-wrapper {
  padding-right: 0;
  justify-content: flex-end;
}

:host([selectable][active]) .tag-wrapper {
  background-color: rgba(var(--ui-1), var(--opacity-7));
}

:host(:hover) .tag-wrapper,
:host(.hover) .tag-wrapper {
  border-color: rgba(var(--ui-1), var(--opacity-4));
}

.tag-wrapper .tag-label {
  font: var(--body-1);
  color: var(--text-primary);
  line-height: var(--sh-tag-label-line-height);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: -webkit-fill-available;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
}

.tag-wrapper sh-icon {
  padding: var(--sh-tag-icon-padding);
}

:host([removable]) .tag-wrapper .tag-label {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

:host([disabled]) {
  pointer-events: none;
}

:host([disabled]) .tag-wrapper {
  border-color: rgba(var(--ui-1), var(--opacity-7));
}

:host([disabled]) .tag-wrapper .tag-label {
  color: rgba(var(--ui-1), var(--opacity-5));
}

:host([disabled]) sh-icon {
  color: rgba(var(--ui-1), var(--opacity-6));
}`;customElements.define("sh-tag",class extends se{static get properties(){return{label:{type:String,reflect:!0},selectable:{type:Boolean,reflect:!0},active:{type:Boolean,reflect:!0},removable:{type:Boolean,reflect:!0},disabled:{type:Boolean,reflect:!0}}}static get styles(){return[ae,Gi]}render(){return V`
      <div class="tag-wrapper" ?disabled="${this.disabled}" @click="${this._onClickTag}">
        <span class="tag-label">${this.label}</span>
        ${this.removable?V`<sh-icon
              id="clear"
              button=""
              icon="cancel"
              size="xs"
              @click="${this._onRemoveTag}"
              tabindex="${this.disabled?"-1":"0"}"
            ></sh-icon>`:""}
      </div>
    `}constructor(){super(),this.label="Label"}_onRemoveTag(){this.disabled||le(this,"closed")}_onClickTag(){this.selectable&&(this.active=!this.active)}}),customElements.define("sh-thumbnail",class extends se{static get properties(){return{label:{type:String,reflect:!0},src:{type:String,reflect:!0},number:{type:Number,reflect:!0},active:{type:Boolean,reflect:!0},focus:{type:Boolean,reflect:!0},selectable:{type:Boolean,reflect:!0},new:{type:Boolean,reflect:!0},badge:{type:String,reflect:!0},checked:{type:Boolean,reflect:!0},indeterminate:{type:Boolean,reflect:!0},options:{type:Boolean,reflect:!0},condensed:{type:Boolean,reflect:!0},icon:{type:String,reflect:!0},aspectRatio:{type:String,reflect:!0,attribute:"aspect-ratio"},show:{type:Boolean,reflect:!0},discard:{type:String,reflect:!0},loading:{type:Boolean,reflect:!0},_emptyInfo:{type:Boolean},_emptyDataTypeIcons:{type:Boolean},_emptyIndications:{type:Boolean}}}static get styles(){return[ie`
        :host {
          display: block;
          height: fit-content;
          transition: var(--transition-time) all ease-in-out,
            var(--hover-transition-time) background;
          position: relative;
          border-radius: 0.125rem;
          border: 0.0625rem solid transparent;
        }

        :host([selectable]:not([checked]):not(:hover)) .thumbnail-checkbox,
        .thumbnail-wrapper:not([empty-data-type]) .thumbnail-icon {
          display: none;
        }
        .thumbnail-wrapper {
          display: block;
          cursor: pointer;
          color: rgba(var(--ui-1), var(--opacity-3));
          position: relative;
        }
        .image-wrapper {
          display: flex;
          flex-direction: column;
          padding: 0.5rem 0.5rem 0.5rem 0.5rem;
        }
        :host([condensed]) .image-wrapper {
          padding: 0.25rem 0.25rem 0.25rem 0.25rem;
        }
        .image {
          background-size: contain;
          background-color: black;
          background-position: center;
          background-repeat: no-repeat;
          width: 100%;
          padding-top: 100%;
          box-sizing: border-box;
          transition: var(--transition-time) all ease-in-out;
          border-radius: 0.125rem;
        }
        .label {
          position: relative;
          overflow: hidden;

          text-overflow: ellipsis;
          word-break: break-all;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          flex: 1;
          height: 2rem;
          line-height: 1rem;
        }
        .label-wrapper {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: auto;
          color: rgba(var(--ui-1), var(--opacity-3));
          margin: -0.25rem 0.5rem 0.25rem 0.5rem;
        }
        :host([condensed]) .label-wrapper {
          margin: 0rem 0.25rem 0.25rem 0.25rem;
        }
        :host([selectable].touch-deviceq) .thumbnail-checkbox,
        :host([selectable].touch-device:not([checked]):not(:hover)) .thumbnail-checkbox,
        :host([selectable]:hover) .thumbnail-checkbox,
        :host([checked]) .thumbnail-checkbox {
          display: inline-block;
          position: absolute;
          top: 0.625rem;
          left: 0.625rem;
          width: 1.5rem;
          padding: 0.25rem;
        }
        :host([selectable][condensed].touch-device) .thumbnail-checkbox,
        :host([selectable][condensed].touch-device:not([checked]):not(:hover)) .thumbnail-checkbox,
        :host([selectable][condensed]:hover) .thumbnail-checkbox,
        :host([checked][condensed]) .thumbnail-checkbox {
          top: 0.375rem;
          left: 0.375rem;
        }
        :host([selectable][discard]) .thumbnail-checkbox {
          z-index: 1;
        }
        .thumbnail-checkbox::before,
        .thumbnail-icon::before {
          height: 2rem;
          width: 2rem;
          top: 0rem;
          left: 0rem;
          content: '';
          background: var(--base-2);
          opacity: var(--opacity-2);
          position: absolute;
          border-radius: 0.0625rem;
        }
        .thumbnail-icon::before {
          background: rgba(0, 0, 0, var(--opacity-3));
        }
        :host(:not([loading]):hover) {
          background: rgba(var(--ui-1), var(--opacity-7));
        }
        :host(:not([loading])[active]) {
          background: rgba(var(--ui-1), var(--opacity-6));
        }
        :host([active]) .label,
        :host([focus]) .label {
          color: rgba(var(--ui-1), var(--opacity-2));
        }
        :host(:not([loading])[focus]) {
          border-color: rgb(var(--ui-0));
        }

        /* badge slot */
        :host([badge]) .thumbnail-badge {
          display: block;
          width: 1rem;
          margin: 0.5rem;
        }
        :host([badge='new']) .thumbnail-badge {
          width: 0.5rem;
          height: 0.5rem;
          border-radius: 0.5rem;
          background-color: rgb(var(--ui-0));
        }
        :host([badge='warning']) .thumbnail-badge {
          margin: 0.25rem;
        }

        .thumbnail-icon {
          display: block;
          position: absolute;
          bottom: 0.625rem;
          right: 0.625rem;
          color: rgba(255, 255, 255, var(--opacity-3));
        }
        :host([condensed]) .thumbnail-icon {
          bottom: 0.375rem;
          right: 0.375rem;
        }

        /* icons slot */
        .icons-wrapper {
          display: flex;
        }

        .icons-wrapper ::slotted(*) {
          margin-left: 0.25rem;
          margin-bottom: 0.25rem;
          color: var(--text-secondary);
        }

        :host(:not([condensed])) .icons-wrapper ::slotted(*:first-child) {
          margin-left: 0.5rem;
        }

        /* badge */
        .new-icon {
          position: absolute;
          top: 0.625rem;
          right: 0.625rem;
          width: 0.5rem;
          margin: 0.5rem;
          height: 0.5rem;
          border-radius: 0.5rem;
          background-color: rgb(var(--ui-0));
        }
        :host([condensed]) .new-icon {
          top: 0.375rem;
          right: 0.375rem;
        }

        /* info slot */
        .info-slot-wrapper {
          display: flex;
          flex-direction: rows;
          display: block;
          position: absolute;
          bottom: 0.625rem;
          left: 0.625rem;
          background: var(--base-2);
          opacity: var(--opacity-3);
          padding: 0.25rem;
          border-radius: 0.125rem;
        }
        :host([condensed]) .info-slot-wrapper {
          bottom: 0.375rem;
          left: 0.375rem;
        }

        .thumbnail-wrapper[empty-info] .info-slot-wrapper {
          display: none;
        }

        :host([active]) .icons-wrapper ::slotted(*) {
          color: var(--text-primary);
        }

        /* data-type slot */
        .data-type-wrapper {
          display: flex;
          bottom: 0.5rem;
          right: 0.5rem;
          margin: 0 0.125rem 0.125rem 0;
          position: absolute;
        }

        .thumbnail-wrapper[empty-data-type] .data-type-wrapper {
          display: none;
        }

        .data-type-wrapper ::slotted(*),
        .indications-wrapper ::slotted(*) {
          background: rgb(0, 0, 0);
          color: rgb(255, 255, 255);
          opacity: var(--opacity-3);
          margin-left: 0.25rem;
          border-radius: 0.125rem;
          line-height: 1.75rem;
        }

        :host([condensed]) .data-type-wrapper {
          bottom: 0.25rem;
          right: 0.25rem;
        }

        /* indications slot */
        .indications-wrapper {
          display: flex;
          top: 0.5rem;
          right: 0.5rem;
          margin: 0.125rem 0.125rem 0 0;
          position: absolute;
        }

        :host([condensed]) .indications-wrapper {
          top: 0.25rem;
          right: 0.25rem;
        }
        sh-tooltip {
          max-width: 25rem;
          overflow-wrap: break-word;
        }
        sh-popover {
          pointer-events: all;
        }
        sh-popover:not([mobile]) {
          position: static;
        }
        :host(:not([show])) .options-popover {
          height: 0px;
        }
        sh-overlay {
          background: transparent;
        }
        .discard-icon {
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: rgba(255, 255, 255, var(--opacity-3));
        }
        :host([discard]) .label {
          color: var(--text-disabled);
        }
        :host([discard]) .id-number,
        :host([discard]) .icons-wrapper ::slotted(*),
        :host([discard]) .data-type-wrapper ::slotted(*),
        :host([discard]) .indications-wrapper ::slotted(*) {
          opacity: var(--opacity-4);
        }
        .discard-wrapper {
          position: absolute;
          width: calc(100% - 1rem);
          height: calc(100% - 1rem);
          background-color: rgba(0, 0, 0, var(--opacity-2));
          z-index: 1;
          display: flex;
        }
        .loading-wrapper {
          margin: 0.5rem;
          max-height: 100%;
        }
        .loading-image {
          border-radius: 0.125rem;
          margin-bottom: 0.25rem;
        }
        .loading-text {
          height: 1.5rem;
          width: 80%;
        }
        .loading {
          opacity: var(--opacity-5);
          background: linear-gradient(
              -70deg,
              rgba(var(--ui-1), var(--opacity-6)) 0%,
              rgba(var(--ui-1), var(--opacity-6)) 20%,
              rgba(var(--ui-1), var(--opacity-5)) 40%,
              rgba(var(--ui-1), var(--opacity-5)) 50%,
              rgba(var(--ui-1), var(--opacity-5)) 60%,
              rgba(var(--ui-1), var(--opacity-6)) 80%,
              rgba(var(--ui-1), var(--opacity-6)) 100%
            )
            repeat;
          background-size: 600% 200%;
          animation: gradient var(--animation-duration-thumbnail, 2s) ease-in-out infinite;
        }
        @keyframes gradient {
          0% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0% 50%;
          }
        }
      `]}render(){return V`
      ${this.loading?V`
            <div class="loading-wrapper">
              <div
                class="loading-image loading"
                style="padding-top: calc(100% / (${this.aspectRatio}));"
              ></div>
              ${this.label||this.number?this._getLabelOrNumber():V` <div class="loading-text loading"></div>`}
            </div>
          `:V`
            <div
              class="thumbnail-wrapper"
              id="thumbnailWrapper"
              ?empty-info="${this._emptyInfo}"
              ?empty-data-type="${this._emptyDataTypeIcons}"
              ?empty-indications="${this._emptyIndications}"
            >
              <div class="image-wrapper">
                <div
                  class="image"
                  style='background-image:url("${this.src?this.src:""}"); padding-top: calc(100% / (${this.aspectRatio}))'
                ></div>
                ${""===this.discard||this.discard?V` <div class="discard-wrapper">
                      ${0===this.discard.length?"":V` <sh-icon class="discard-icon" icon=${this.discard}></sh-icon>`}
                    </div>`:""}
                ${this.icon?V`<sh-icon class="thumbnail-icon" icon="${this.icon}"></sh-icon>`:""}
                <div class="data-type-wrapper">
                  <slot
                    name="data-type"
                    class="data-type"
                    @slotchange="${this._dataTypeSlotObserver}"
                  ></slot>
                </div>
                ${this.selectable?V` <sh-checkbox
                      label=""
                      class="thumbnail-checkbox"
                      ?active="${this.checked}"
                      @active-changed="${e=>{this.checked=e.target.active}}"
                      ?indeterminate="${this.indeterminate}"
                    ></sh-checkbox>`:""}
                ${this.new?V`<div class="new-icon"></div>`:""}
                <div class="indications-wrapper">
                  ${this.badge?V`<sh-badge class="thumbnail-badge" type="${this.badge}"></sh-badge>`:""}
                  <slot
                    name="indications"
                    class="indications"
                    @slotchange="${this._indicationsSlotObserver}"
                  ></slot>
                </div>
                <div class="info-slot-wrapper">
                  <slot name="info" class="info" @slotchange="${this._infoSlotObserver}"></slot>
                </div>
              </div>
            </div>
            <div class="label-wrapper">
              ${this.label||this.number?this._getLabelOrNumber():""}
              <div>
                ${this.options?V` <sh-icon
                      button
                      icon="more"
                      class="options-icon"
                      id="optionsIcon"
                      @click="${this._showOptions}"
                    ></sh-icon>`:""}
                <sh-overlay
                  no-overlap
                  horizontal-align="auto"
                  scroll-action="refit"
                  autoFitOnAttach
                  vertical-align="auto"
                >
                  <sh-popover
                    id="popover"
                    class="options-popover"
                    @click="${this._handleMenuItemClick}"
                    @keyup="${this._handleMenuItemKeyup}"
                  >
                    <slot id="mainSlot" @slotchange="${this._mainSlotObserver}"></slot>
                  </sh-popover>
                </sh-overlay>
              </div>
            </div>
            <div class="icons-wrapper">
              <slot name="icons" id="icons"></slot>
            </div>
          `}
    `}constructor(){super(),this.src="",this.value="",this.aspectRatio="1/1",this._emptyInfo=!0,this._emptyIndications=!0,this._emptyDataTypeIcons=!0}connectedCallback(){super.connectedCallback(),ue.isTouchDevice()&&this.classList.add("touch-device"),this.documentClickListener=this.documentClickActions.bind(this)}updated(e){e.has("show")&&(this.show?this._showPopover():this._hidePopover()),he(this,e,["label","src","number","active","focus","selectable","new","badge","checked","indeterminate","options","condensed","icon","aspectRatio","show"])}_getLabelOrNumber(){return V`
      <sh-text
        size="body-2"
        color="secondary"
        class="label"
        id="sh-thumbnail-text"
        @mouseenter="${e=>this._showTooltip(e,this.label)}"
        @mouseleave="${()=>this._hideTooltip()}"
      >
        ${this.number?V`<b class="id-number"
              >${this.number} ${this.label&&this.number?V`•`:""}
            </b>`:""}
        ${this.label?this.label:""}
      </sh-text>
      ${this.label?V`<sh-tooltip
            .label="${this.label}"
            delay
            placement="bottom-left"
            target="sh-thumbnail-text"
          ></sh-tooltip>`:""}
    `}documentClickActions(e){const t=this.shadowRoot.querySelector(".options-icon"),o=e.target!==this,i=this.shadowRoot.querySelector(".options-popover").mobile,r=-1===e.composedPath().indexOf(t);(o||i)&&r&&(this.show=!1)}_handleMenuItemClick(e){const t=e.target;"sh-menu-item"===t.tagName.toString().toLowerCase()&&t.removeAttribute("active")}_handleMenuItemKeyup(e){const t=e.target,o=e.keyCode===me.ENTER,i=e.keyCode===me.SPACE;"sh-menu-item"===t.tagName.toString().toLowerCase()&&(o||i)&&t.click()}_dataTypeSlotObserver(e){const t=e.target.assignedNodes({flatten:!0}).length;this._emptyDataTypeIcons=0===t}_infoSlotObserver(e){const t=e.target.assignedNodes({flatten:!0}).length;this._emptyInfo=0===t}_indicationsSlotObserver(e){const t=e.target.assignedNodes({flatten:!0}).length;this._emptyIndications=0===t}_mainSlotObserver(){const e=this.querySelectorAll("sh-menu-item").length;this.options=e>0,this.options||(this.show=!1)}_showPopover(){const e=this.shadowRoot.querySelector("sh-popover"),t=this.shadowRoot.querySelector("sh-overlay");e.style.visibility="visible",t.open(),e.style.opacity=1,document.body.addEventListener("click",this.documentClickListener)}_hidePopover(){const e=this.shadowRoot.querySelector("sh-popover"),t=this.shadowRoot.querySelector("sh-overlay");e.style.visibility="hidden",e.style.opacity=0,t.close(),document.body.removeEventListener("click",this.documentClickListener)}_showOptions(){this.show=!this.show,le(this,"menu-clicked",this)}_showTooltip(e,t){const o=this.shadowRoot.querySelector("sh-tooltip");Se(e,t,o)}_hideTooltip(){this.shadowRoot.querySelector("sh-tooltip").visible=!1}disconnectedCallback(){document.body.removeEventListener("click",this.documentClickListener),super.disconnectedCallback()}});const Xi=e=>{const t=2-e.toString().length;return`${"0".repeat(t)}${e}`},Ji=ie`
  :host {
    outline: 0;
    width: 100%;
    height: 2.5rem;
    position: relative;
    display: flex;
    flex-direction: column;
  }
  /*--Idle state styles--*/
  .timepicker-wrapper {
    width: 100%;
    height: 2.5rem;
    box-sizing: border-box;
    background-color: rgba(var(--ui-1), var(--opacity-7));
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-direction: column;
    border-radius: 0.125rem 0.125rem 0rem 0rem;
    position: relative;
    transition: var(--transition-time) all ease-in-out;
    border-bottom: 0.0625rem solid transparent;
    border-color: rgba(var(--ui-1), var(--opacity-4));
  }
  .timepicker-input {
    display: -webkit-box;
    display: flex;
    flex-direction: row;
    position: relative;
  }
  .timepicker-panel {
    background: var(--base-4);
    min-height: 6.25rem;
    height: 8.5rem;
    position: absolute;
    width: 100%;
    box-sizing: border-box;
    box-shadow: 0.0625rem 0.125rem 0.0625rem var(--shadow-strong),
      -0.0625rem -0.0625rem 0.0625rem var(--shadow-light);
    padding: 1rem 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    border-radius: 0.125rem;
  }

  .timepicker-controls-wrapper {
    flex-direction: row;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .timepicker-controls-wrapper .seperator {
    width: 1.5rem;
  }
  .timepicker-controls {
    text-align: center;
  }
  .control-value {
    margin: 1rem 0;
  }
  :host([error]) .timepicker-wrapper {
    border-color: rgb(var(--functional-red));
  }
  :host([safety]) .timepicker-wrapper {
    border-color: rgb(var(--functional-yellow));
  }
  :host([success]) .timepicker-wrapper {
    border-color: rgb(var(--functional-green));
  }
  .label-area {
    max-width: calc(100% - 2rem);
    margin: 0.5rem 0.5rem 0 0.5rem;
    transition: var(--transition-time) all ease-in-out;
    flex: 1 1 auto;
    height: 2rem;
    display: flex;
    flex-direction: column;
    position: relative;
  }
  .label {
    white-space: nowrap;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    max-width: calc(100% - 0.625rem);
  }
  .label-slot {
    color: var(--text-secondary);
    font: var(--body-1);
    line-height: 1.5rem;
    -webkit-transition: var(--transition-time) all ease-in-out, 0s line-height ease-in-out,
      0s height ease-in-out;
    -o-transition: var(--transition-time) all ease-in-out, 0s line-height ease-in-out,
      0s height ease-in-out;
    transition: var(--transition-time) all ease-in-out, 0s line-height ease-in-out,
      0s height ease-in-out, 0s width ease-in-out;
    transform-origin: left;
    transform: scale(1);
    position: absolute;
    width: 100%;
    display: flex;
  }
  .close-button {
    opacity: 0;
    height: 1.5rem;
    width: 1.5rem;
    margin: 0.5rem 0.5rem 0.5rem 0rem;
    transition: var(--transition-time) opacity ease-in-out;
    pointer-events: none;
  }
  :host([error]:not([h=''])) .close-button,
  :host([error]:not([m=''])) .close-button,
  :host([error]:not([s=''])) .close-button,
  :host(:hover:not([h=''])) .close-button,
  :host(:hover:not([m=''])) .close-button,
  :host(:hover:not([s=''])) .close-button {
    opacity: 1;
    pointer-events: all;
  }
  .schedule-button {
    margin: 0.5rem 0.5rem 0.5rem 0rem;
    cursor: pointer;
  }
  #dropdown-icon {
    height: 1.5rem;
    width: 1.5rem;
  }
  #closeIcon {
    position: relative;
  }
  /*--Hover styles--*/
  #closeIcon.item-focused {
    opacity: 1;
  }
  :host([active][responsive]:not([error]):not([safety]):not([success])) .timepicker-wrapper,
  :host(:not([responsive]).hasCursor:not([error]):not([safety]):not([success]))
    .timepicker-wrapper {
    border-color: rgba(var(--ui-1), var(--opacity-2));
  }
  :host(:hover) .timepicker-wrapper {
    background: rgba(var(--ui-1), var(--opacity-6));
  }
  :host(.hasCursor) .timepicker-wrapper {
    background-color: rgba(var(--ui-1), var(--opacity-7));
  }
  :host(.hasCursor) .timepicker-wrapper {
    background: rgba(var(--ui-1), var(--opacity-7));
  }
  /*--Focus Styles--*/
  .input-slot {
    opacity: 0;
    position: relative;
    z-index: 2;
    line-height: 1rem;
    height: 1rem;
    display: flex;
    flex-direction: row;
    background: transparent;
    font: var(--body-1);
    color: var(--text-primary);
  }
  .timepicker-panel input::placeholder,
  .time-input-wrapper input::placeholder {
    color: var(--text-disabled);
  }
  .input-slot input {
    height: 1rem;
    width: 1rem;
  }
  :host(.hasCursor) .input-slot,
  :host(.hasValue) .input-slot {
    opacity: 1;
    margin-top: 1rem;
  }
  :host(.hasCursor) .label-area,
  :host(.hasValue) .label-area {
    margin-top: 0.25rem;
  }
  :host(.hasCursor) .label-slot,
  :host(.hasValue) .label-slot {
    font: var(--body-2);
    line-height: normal;
  }
  #h,
  #m,
  #s,
  #h-label,
  #m-label,
  #s-label {
    width: 2ch;
    height: 1rem;
    background: transparent;
    outline: none;
    border: none;
    padding: 0rem;
    font: var(--body-1);
    color: var(--text-primary);
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    -webkit-transition: all 0.01s ease-in-out;
    -o-transition: all 0.01s ease-in-out;
    transition: all 0.01s ease-in-out;
    overscroll-behavior: contain;
  }
  #m {
    width: 1.5rem;
    text-align: center;
  }
  #h-label {
    padding-right: 0.125rem;
  }
  #s-label {
    padding-left: 0.125rem;
  }
  :host([responsive]) .input-slot input {
    pointer-events: none;
  }
  #amOrPm,
  #ap-label {
    width: 1.25rem;
    height: 1rem;
    background: transparent;
    outline: none;
    padding: 0rem 0.125rem;
    border: none;
    font: var(--body-1);
    color: var(--text-primary);
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    -webkit-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    overscroll-behavior: contain;
  }
  #m-label:not(:placeholder-shown) {
    width: 2ch;
    padding: 0 0.125rem;
    text-align: center;
  }
  #s-label:not(:placeholder-shown) {
    text-align: center;
  }
  #m-label:placeholder-shown {
    width: 3ch;
    padding: 0 0.125rem;
  }
  .seperator {
    width: 0.25rem;
    height: 1rem;
    line-height: 1rem;
    text-align: center;
    color: var(--text-disabled);
  }
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .input-slot {
      position: relative;
      top: -0.9375rem;
      left: -0.0625rem;
    }
    * {
      -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
      -moz-box-sizing: border-box; /* Firefox, other Gecko */
      box-sizing: border-box;
    }
    #h,
    #m,
    #s,
    #amOrPm,
    #h-label,
    #m-label,
    #s-label {
      padding: 0;
    }
    #amOrPm,
    #ap-label {
      width: 1.375rem;
    }
    :host(.hasValue) .input-slot {
      opacity: 1;
      margin-top: 1.875rem;
    }
  }
  #mandatoryStarSymbol {
    color: rgba(var(--ui-2), var(--opacity-1));
  }
  .seperator.colon-active {
    color: var(--text-primary);
  }
  :host([disabled]) .timepicker-wrapper {
    background-color: rgba(var(--ui-1), var(--opacity-7));
    pointer-events: none;
  }
  :host([disabled]) *,
  :host([disabled]) #h-label,
  :host([disabled]) #m-label,
  :host([disabled]) #s-label,
  :host([disabled]) #ap-label,
  :host([disabled]) input {
    pointer-events: none;
    color: var(--text-disabled);
  }
  :host([disabled]),
  :host([disabled]) .label-slot,
  :host([disabled]) .close-button {
    pointer-events: none;
  }
  :host([disabled]) #mandatoryStarSymbol {
    color: rgba(var(--ui-2), var(--opacity-5)) !important;
  }

  /*Condensed Styles*/
  :host([condensed]) {
    height: 2rem;
  }
  :host([condensed]) .timepicker-wrapper {
    height: 2rem;
  }
  :host([condensed]) .label-area {
    margin: 0.25rem 0.5rem 0.25rem 0.5rem;
    height: auto;
  }
  :host([condensed]) .timepicker-input {
    height: 2rem;
  }
  :host([condensed]) .input-slot {
    margin: 0rem;
    height: 100%;
  }
  :host([error][error-message]),
  :host([hint]) {
    height: auto;
  }
  #time-input-field {
    height: 1rem;
  }
  .time-input-wrapper {
    display: flex;
  }
  :host([condensed]) #time-input-field {
    justify-content: center;
    height: 1.5rem;
  }
  #time-panel {
    height: 0rem;
  }
  :host([condensed]) .input-slot input {
    height: 1rem;
    width: 1rem;
    margin-top: 0.25rem;
  }
  :host([condensed]) .seperator {
    margin-top: 0.1875rem;
  }
  :host([condensed]) .close-button,
  :host([condensed]) .schedule-button {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }
  /* helper text */
  .helper-text {
    padding: 0.25rem 0.5rem 0rem 0.5rem;
    box-sizing: border-box;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  :host([disabled]) .helper-text {
    color: var(--text-disabled);
  }
  :host([condensed].hasValue) .label-slot,
  :host([condensed].hasCursor) .label-slot,
  :host([disabled]) .close-button,
  :host([active='false']) .timepicker-panel,
  :host([error][error-message]) .hint {
    display: none;
  }
  :host([error]) .icon-wrapper,
  :host([success]) .icon-wrapper {
    margin: 0.5rem 0.5rem 0.5rem 0rem;
  }
  :host([condensed][error]) .icon-wrapper,
  :host([condensed][success]) .icon-wrapper {
    margin: 0.25rem 0.5rem 0.25rem 0rem;
  }
  :host([no-border]) .timepicker-wrapper {
    border-bottom: none;
  }
  .overlay {
    box-shadow: var(--shadow-overlay);
  }
`,Qi=Object.freeze({hasCursor:"hasCursor",hasValue:"hasValue",noValue:"noValue"}),er=e=>class extends e{static get properties(){return{timeInputState:{type:String}}}connectedCallback(){super.connectedCallback(),this.addEventListener("focus",this._updateInputFieldStateIfFocused.bind(this)),this.addEventListener("blur",this._updateInputFieldStateBasedOnInputValue.bind(this))}_updateInputFieldStateIfFocused(e){let t=e.currentTarget;t.disabled||t.timeInputState===Qi.hasCursor?e.stopPropagation():(t.timeInputState=Qi.hasCursor,this.classList.remove("noValue"),this.classList.remove("hasValue"),this.classList.add(Qi.hasCursor))}_updateInputFieldStateBasedOnInputValue(e){let t=e?e.currentTarget:this;t?(t.responsive||(t.active=!1),t.timeInputState=String(this.h).length>0||String(this.m).length>0||String(this.s).length>0||String(this.amPm).length>0?Qi.hasValue:Qi.noValue,t.timeInputState===Qi.hasValue?(this.classList.remove("noValue"),this.classList.remove("hasCursor"),this.classList.add("hasValue")):(this.classList.remove("hasValue"),this.classList.remove("hasCursor"),this.classList.add("noValue"))):e&&e.stopPropagation()}},tr=e=>class extends e{onKeyupValidateTimeInput(e){let t=this.shadowRoot.querySelector("#h-label");e.keyCode>=me.NUM_0&&e.keyCode<=me.NUM_9||e.keyCode>=me.NUMPAD_0&&e.keyCode<=me.NUMPAD_9?(parseInt(e.target.value,10)>Number(e.target.max)&&(e.target.value=e.target==t?this.getHourValueIfClockFormat24():"00"),"00"==e.target.value&&e.target==t&&"12-hour"===this.clockFormat&&(e.target.value="01"),e.target.value.length===parseInt(e.target.maxLength,10)&&("24-hour"===this.clockFormat&&null==e.target.nextElementSibling.nextElementSibling?this.mini?this.m=e.target.value:this.s=e.target.value:(e.target.nextElementSibling.nextElementSibling.focus(),e.target.nextElementSibling.nextElementSibling.setSelectionRange(0,2)))):e.target.value=this._isNonDigit(e.target.value)?"00":e.target.value,le(this,"time-value-changed")}onKeyupValidateAmPm(e){let t=!1;t=" "===e.key||"Backspace"===e.key||"Tab"===e.key||"Up"===e.key||"ArrowUp"===e.key||"ArrowDown"===e.key||"Down"===e.key,t||(this.amPm=this._validateAmPmBasedOnInput(e.target.value),e.target.value=this.amPm),le(this,"time-value-changed")}validateTime(){this._validateTimeInputModified(),this.amPm=this.amPm?this._validateAmPmBasedOnInput(this.amPm):""}getHourValueIfClockFormat24(){return"24-hour"===this.clockFormat?"00":"01"}_validateTimeInputModified(){this.h=this.h?this._isNonDigit(this.h)?this.getHourValueIfClockFormat24():this.h:"",this.m=this.m?this._isNonDigit(this.m)||this.m>59?"00":this.m:"",this.s=this.s?this._isNonDigit(this.s)||this.s>59?"00":this.s:"",this.h=this.h>12&&"12-hour"===this.clockFormat?"01":this.h>23&&"24-hour"===this.clockFormat?"00":this.h}_isNonDigit(e){return null!==e.toString().match(/\D/i)}_validateAmPmBasedOnInput(e){let t=e.toString().toLowerCase();return 2===t.length?"am"!=t&&"pm"!=t?"AM":"pm"===t||"am"===t?t.toUpperCase():"":1===t.length?"p"!==t?"AM":"PM":t.length>2?"AM":void 0}},or=e=>class extends e{incrementTime(e){if(this.previousHourValue=Number(this.h),""===this.h||""===this.m||""===this.s&&!this.mini)this.updateWithSystemTime();else{switch(e.dataset.id){case"s":case"s-ip":this.s=parseInt(this.s,10)+parseInt(this.step,10),this.s>59&&(this.m=parseInt(this.m,10)+1,this.s=this.s-60),this.s<10&&(this.s=`0${this.s}`);case"m":case"m-ip":"m"!==e.dataset.id&&"m-ip"!==e.dataset.id||(this.m=parseInt(this.m,10)+parseInt(this.step,10)),this.m>59&&(this.h=parseInt(this.h,10)+1,this.m=this.m-60),Number(this.m)<10&&(this.m=`0${Number(this.m)}`);case"h":case"h-ip":"h"!==e.dataset.id&&"h-ip"!==e.dataset.id||(this.h=parseInt(this.h,10)+1),"12-hour"===this.clockFormat?(12===this.h&&11===this.previousHourValue&&(this.amPm="PM"===this.amPm?"AM":"PM"),13===this.h&&12===this.previousHourValue&&(this.h=1)):24===this.h&&23===this.previousHourValue&&(this.h=0),Number(this.h)<10&&(this.h=`0${Number(this.h)}`);default:"ap"!==e.dataset.id&&"ap-ip"!==e.dataset.id||(this.amPm="PM"===this.amPm?"AM":"PM")}le(this,"time-value-changed")}}decrementTime(e){if(this.previousHourValue=Number(this.h),""===this.h||""===this.m||""===this.s&&!this.mini)this.updateWithSystemTime(this);else{switch(e.dataset.id){case"s":case"s-ip":this.s=parseInt(this.s,10)-parseInt(this.step,10);let t=this.s%this.step==0?this.step:this.s%this.step;this.s<0&&(this.m=parseInt(this.m,10)-1,this.s=60-Math.abs(parseInt(t))),this.s<10&&(this.s=`0${this.s}`);case"m":case"m-ip":"m"!==e.dataset.id&&"m-ip"!==e.dataset.id||(this.m=parseInt(this.m,10)-parseInt(this.step,10));let o=this.m%this.step==0?this.step:this.m%this.step;this.m<0&&(this.h=parseInt(this.h,10)-1,this.m=60-Math.abs(parseInt(o))),Number(this.m)<10&&(this.m=`0${Number(this.m)}`);case"h":case"h-ip":this.h=parseInt(this.h,10),"h"!==e.dataset.id&&"h-ip"!==e.dataset.id||(this.h=parseInt(this.h,10)-1),"12-hour"===this.clockFormat?(11===this.h&&12===this.previousHourValue&&(this.amPm="PM"===this.amPm?"AM":"PM"),(0===this.h&&1===this.previousHourValue||-1===this.h&&0===this.previousHourValue)&&(this.h=12)):"24-hour"===this.clockFormat&&-1===this.h&&0===this.previousHourValue&&(this.h=23),Number(this.h)<10&&(this.h=`0${Number(this.h)}`);break;default:"ap"!==e.dataset.id&&"ap-ip"!==e.dataset.id||(this.amPm="PM"===this.amPm?"AM":"PM")}le(this,"time-value-changed")}}updateWithSystemTime(){const e=new Date;let t=e.getHours();"12-hour"===this.clockFormat?(this.amPm=t>11&&12!==t||12===t?"PM":"AM",t=t>11&&12!==t?t-12:12===t||0===t?12:t):"24-hour"===this.clockFormat&&(this.amPm=""),this.h=t<10?`0${t}`:t,this.m=e.getMinutes()<10?`0${e.getMinutes()}`:e.getMinutes(),this.s=e.getSeconds()<10?`0${e.getSeconds()}`:e.getSeconds(),le(this,"time-value-changed")}incrementOrDecrementOnKeyDown(e){let t;t=e.composedPath()?e.composedPath()[0]:e.srcElement,e.keyCode!==me.ARROW_UP&&"Up"!==e.key||(e.preventDefault(),this.incrementTime(t)),e.keyCode!==me.ARROW_DOWN&&"Down"!==e.key||(e.preventDefault(),this.decrementTime(t)),le(this,"time-value-changed")}};class ir extends(tr(or(er(se)))){static get properties(){return{h:{type:String,reflect:!0},m:{type:String,reflect:!0},s:{type:String,reflect:!0},amPm:{type:String,reflect:!0,attribute:"am-pm"},mini:{type:Boolean,reflect:!0},step:{type:String,reflect:!0},clockFormat:{type:String,reflect:!0,attribute:"clock-format"},disabled:{type:String,reflect:!0}}}static get styles(){return[Ji,ae]}render(){return V`
      <div class="time-input-wrapper">
        <input
          type="text"
          placeholder="hh"
          data-id="h-ip"
          id="h-label"
          min="1"
          max="${"12-hour"===this.clockFormat?12:23}"
          @keyup=${this.onKeyupValidateTimeInput}
          maxlength="2"
          .value="${this.h}"
          @keydown=${this._onArrowKeyUpOrDownPressUpdateTime}
          size="2"
          ?disabled="${this.disabled}"
          @blur="${this._appendZeroAndUpdateTimeValue}"
        />
        <div
          class="seperator  ${""!==this.h||""!==this.m||""!==this.s||""!==this.amPm?"colon-active":""}"
        >
          :
        </div>
        <input
          type="text"
          placeholder="mm"
          data-id="m-ip"
          id="m-label"
          min="0"
          max="59"
          @keyup=${this.onKeyupValidateTimeInput}
          maxlength="2"
          .value="${this.m}"
          @keydown=${this._onArrowKeyUpOrDownPressUpdateTime}
          size="2"
          ?disabled="${this.disabled}"
          @blur="${this._appendZeroAndUpdateTimeValue}"
        />
        ${this.mini?"":V`
              <div
                class="seperator ${""!==this.h||""!==this.m||""!==this.s||""!==this.amPm?"colon-active":""} full"
              >
                :
              </div>
              <input
                type="text"
                placeholder="ss"
                data-id="s-ip"
                class="full"
                id="s-label"
                min="0"
                max="59"
                @keyup=${this.onKeyupValidateTimeInput}
                maxlength="2"
                .value="${this.s}"
                @keydown=${this._onArrowKeyUpOrDownPressUpdateTime}
                size="2"
                ?disabled="${this.disabled}"
                @blur="${this._appendZeroAndUpdateTimeValue}"
              />
            `}
        <div
          class="seperator ${""!==this.h||""!==this.m||""!==this.s||""!==this.amPm?"colon-active":""}"
        ></div>
        ${"12-hour"===this.clockFormat?V` <input
              type="text"
              data-id="ap-ip"
              id="ap-label"
              placeholder="AM"
              .value="${this.amPm}"
              size="2"
              maxlength="2"
              @keydown=${this._onArrowKeyUpOrDownPressUpdateTime}
              @keyup=${this.onKeyupValidateAmPm}
              ?disabled="${this.disabled}"
              @blur=${this._appendZeroAndUpdateTimeValue}
            />`:""}
      </div>
    `}constructor(){super(),this.h=this.m=this.s=this.amPm="",this.clockFormat="12-hour",this.mini=!1,this.step=1}firstUpdated(){(this.h>0||this.m>0||this.s>0||this.amPm>0)&&this._updateTimeWhenInputFieldHasValue()}updated(e){e.has("timeInputState")&&this._handleInputFieldChanged()}_handleInputFieldChanged(){"hasValue"===this.timeInputState&&this._updateTimeWhenInputFieldHasValue()}_onArrowKeyUpOrDownPressUpdateTime(e){this.incrementOrDecrementOnKeyDown(e)}_appendZeroAndUpdateTimeValue(e){const t=e.target,o=e.target.id;if(""!==t.value)switch(t.value=Xi(t.value),o){case"h-label":this.h=t.value;break;case"m-label":this.m=t.value;break;case"s-label":this.s=t.value;break;default:this.amPm=t.value}}_updateTimeWhenInputFieldHasValue(){const e=this.shadowRoot.querySelector("#h-label"),t=this.shadowRoot.querySelector("#m-label");if(this._convertValueToZeroZeroIfValueIsEmptyForInput(e),this._convertValueToZeroZeroIfValueIsEmptyForInput(t),"12-hour"===this.clockFormat){const e=this.shadowRoot.querySelector("#ap-label");this._convertValueToAMIfValueIsEmptyForInput(e),this.amPm=e.value}if(this.h=e.value,this.m=t.value,this.mini)this.s="00";else{const e=this.shadowRoot.querySelector("#s-label");this._convertValueToZeroZeroIfValueIsEmptyForInput(e),this.s=e.value}le(this,"time-value-changed")}_convertValueToZeroZeroIfValueIsEmptyForInput(e){""===e.value&&("h-label"===e.id?e.value=this.getHourValueIfClockFormat24():e.value="00")}_convertValueToAMIfValueIsEmptyForInput(e){""===e.value&&(e.value="AM")}}customElements.define("sh-timepicker-input",ir);class rr extends(or(se)){static get properties(){return{h:{type:String,reflect:!0},m:{type:String,reflect:!0},s:{type:String,reflect:!0},amPm:{type:String,reflect:!0,attribute:"am-pm"},mini:{type:Boolean,reflect:!0},step:{type:String,reflect:!0},clockFormat:{type:String,reflect:!0,attribute:"clock-format"},active:{type:Boolean,reflect:!0}}}static get styles(){return[Ji,ae]}render(){return V`
      <div class="timepicker-panel-wrapper">
        <div class="timepicker-panel">
          <div class="timepicker-controls-wrapper">
            <div class="timepicker-controls hour-control">
              <sh-icon
                icon="up-s"
                id="dropdown-icon"
                data-id="h"
                button=""
                size="s"
                @click=${this._incrementWithButton}
              ></sh-icon>
              <div class="control-value">
                <input
                  type="text"
                  readonly
                  placeholder="hh"
                  data-id="h-ip"
                  id="h"
                  min="1"
                  max="${"12-hour"===this.clockFormat?12:23}"
                  .value="${this.h}"
                  @keydown=${this._onArrowKeyUpOrDownPressUpdateTime}
                  size="2"
                />
              </div>
              <sh-icon
                icon="down-s"
                id="dropdown-icon"
                data-id="h"
                button=""
                size="s"
                @click=${this._decrementWithButton}
              ></sh-icon>
            </div>
            <div
              class="seperator ${""!==this.h||""!==this.m||""!==this.s||""!==this.amPm?"colon-active":""}"
            >
              :
            </div>
            <div class="timepicker-controls min-control">
              <sh-icon
                icon="up-s"
                id="dropdown-icon"
                data-id="m"
                button=""
                size="s"
                @click=${this._incrementWithButton}
              ></sh-icon>
              <div class="control-value">
                <input
                  type="text"
                  readonly
                  placeholder="mm"
                  data-id="m-ip"
                  id="m"
                  min="0"
                  max="59"
                  size="2"
                  maxlength="2"
                  .value="${this.m}"
                  @keydown=${this._onArrowKeyUpOrDownPressUpdateTime}
                  size="2"
                />
              </div>
              <sh-icon
                icon="down-s"
                id="dropdown-icon"
                data-id="m"
                button=""
                size="s"
                @click=${this._decrementWithButton}
              ></sh-icon>
            </div>
            ${this.mini?"":V` <div
                    class="seperator ${""!==this.h||""!==this.m||""!==this.s||""!==this.amPm?"colon-active":""} full"
                  >
                    :
                  </div>
                  <div class="timepicker-controls sec-control full">
                    <sh-icon
                      icon="up-s"
                      id="dropdown-icon"
                      data-id="s"
                      button=""
                      size="s"
                      @click=${this._incrementWithButton}
                    ></sh-icon>
                    <div class="control-value">
                      <input
                        type="text"
                        readonly
                        placeholder="ss"
                        data-id="s-ip"
                        class="full"
                        id="s"
                        min="0"
                        max="59"
                        maxlength="2"
                        .value="${this.s}"
                        @keydown=${this._onArrowKeyUpOrDownPressUpdateTime}
                        size="2"
                      />
                    </div>
                    <sh-icon
                      icon="down-s"
                      id="dropdown-icon"
                      data-id="s"
                      button=""
                      size="s"
                      @click=${this._decrementWithButton}
                    ></sh-icon>
                  </div>`}
            <div
              class="seperator ${""!==this.h||""!==this.m||""!==this.s||""!==this.amPm?"colon-active":""}"
            ></div>
            ${"12-hour"===this.clockFormat?V`
                    <div class="timepicker-controls ampm-control">
                      <sh-icon icon="up-s" id="dropdown-icon" button="" size="s" data-id="ap" @click=${this._incrementWithButton}"></sh-icon>
                      <div class="control-value"><input type="text" readonly placeholder="AM" readonly="true" data-id="ap-ip" id="amOrPm" .value="${this.amPm}" size="2" maxlength="2"
                             @keydown=${this._onArrowKeyUpOrDownPressUpdateTime}></div>
                      <sh-icon icon="down-s" id="dropdown-icon" button="" size="s" data-id="ap" @click=${this._decrementWithButton}></sh-icon>
                    </div>`:""}
          </div>
        </div>
      </div>
    `}constructor(){super(),this.h=this.m=this.s=this.amPm="",this.clockFormat="12-hour",this.mini=!1,this.step=1}_onArrowKeyUpOrDownPressUpdateTime(e){this.incrementOrDecrementOnKeyDown(e)}_incrementWithButton(e){e.stopPropagation(),this.incrementTime(e.target)}_decrementWithButton(e){e.stopPropagation(),this.decrementTime(e.target)}}customElements.define("sh-timepicker-panel",rr);class sr extends(tr(er(or(se)))){static get properties(){return{active:{type:Boolean,reflect:!0},mini:{type:Boolean,reflect:!0},step:{type:String,reflect:!0},responsive:{type:Boolean,reflect:!0},label:{type:String,reflect:!0},disabled:{type:Boolean,reflect:!0},h:{type:String,reflect:!0},m:{type:String,reflect:!0},s:{type:String,reflect:!0},amPm:{type:String,reflect:!0,attribute:"am-pm"},val:{type:String,reflect:!0},clockFormat:{type:String,reflect:!0,attribute:"clock-format"},error:{type:Boolean,reflect:!0},errorMessage:{type:String,reflect:!0,attribute:"error-message"},hint:{type:String,reflect:!0},success:{type:Boolean,reflect:!0},safety:{type:Boolean,reflect:!0},noBorder:{type:Boolean,reflect:!0},mandatory:{type:Boolean,reflect:!0},open:{type:Boolean,reflect:!0},close:{type:Boolean,reflect:!0},condensed:{type:Boolean,reflect:!0},_showDrawerDOM:{type:Boolean,reflect:!0}}}static get styles(){return[Ji,ae]}render(){return V`
    <div class="timepicker-wrapper" id="timepickerWrapper">
          <div class="timepicker-input"  @click=${this._makeMobileTimepickerActive}>
            <div class="label-area">
              <div class="label-slot"><div class="label">${this.label}</div>
              ${this.mandatory?V` <span id="mandatoryStarSymbol">*</span>`:""}
              </div>
                <div class="input-slot">
                  <sh-timepicker-input id="time-input-field"
                  @time-value-changed = ${e=>this._updateTimeBasedOnInputOrPanelValue(e)}
                  .h="${this.h}"
                  .m="${this.m}"
                  .s="${this.s}"
                  .amPm=${this.amPm}
                  .step =${this.step}
                  .mini=${this.mini}
                  ?disabled=${this.disabled}
                  clock-format="${this.clockFormat}" ></sh-timepicker-input>
                </div> 
              </div> 
              <sh-icon button tabindex="0" @click=${this._clearTimeInputField} 
              size="s" icon="cancel" class="close-button" id="closeIcon" ></sh-icon>
          <div class="icon-wrapper">
            ${this.error||this.success?V` <sh-icon
                    class="error-success-icon"
                    icon=${this.error?"error":"success"}
                    size="s"
                    ?disabled="${this.disabled}"
                  ></sh-icon>`:""}
          </div>
            <div class="schedule-button"> 
              <sh-icon button tabindex= ${this.disabled?-1:0}  @click=${this._makeTimepickerActive} size="s" icon="scheduled" 
    }" id="scheduledIcon"></sh-icon>
            </div>
          </div>
          ${this.responsive?this._showDrawerDOM?this._timepickerMobileTemplate():"":V`
                  <sh-overlay
                    class="overlay"
                    style="width:${getComputedStyle(this).width}; height: 136px; "
                    scroll-action="cancel"
                    no-overlap
                    horizontal-align="left"
                    @overlay-canceled=${e=>{this._overlayCancelledCallback(e)}}
                  >
                    <sh-timepicker-panel
                      id="time-panel"
                      @time-value-changed=${e=>this._updateTimeBasedOnInputOrPanelValue(e)}
                      .h="${this.h}"
                      .m="${this.m}"
                      .s="${this.s}"
                      .amPm=${this.amPm}
                      .step=${this.step}
                      .mini=${this.mini}
                      active=${this.active}
                      clock-format="${this.clockFormat}"
                    ></sh-timepicker-panel>
                  </sh-overlay>
                `} 
    </div>
        ${this.hint?V` <sh-text size="body-2" class="helper-text hint" color="secondary"
                >${this.hint}</sh-text
              >`:""}
        ${this.error&&this.errorMessage?V` <sh-text size="body-2" class="helper-text error-message" color="secondary"
                >${this.errorMessage}</sh-text
              >`:""}
    `}constructor(){super(),this.h=this.m=this.s=this.amPm="",this.clockFormat="12-hour",this.label="Time",this.mini=!1,this.step=1,this.error=this.safety=this.mandatory=this.noBorder=!1}connectedCallback(){super.connectedCallback(),this._updateInputFieldStateBasedOnInputValue(),this.hasAttribute("tabindex")||this.setAttribute("tabindex",0),this.addEventListener("keyup",this._toggleSubMenuIfPressedOnEnterAnywhereExceptScheduleIcon.bind(this))}updated(e){(e.has("h")||e.has("m")||e.has("s")||e.has("amPm"))&&this._updateTimeInValue(),e.has("active")&&this._handleActiveChanged(),e.has("disabled")&&(this.tabIndex=this.disabled?-1:0),he(this,e,["mini","condensed","h","m","s","amPm","step","clockFormat","val"])}_makeTimepickerActive(){this.responsive||(this.active=!this.active)}_overlayCancelledCallback(e){"scroll"===e.detail.type&&(this.active=!1)}_updateTimeBasedOnInputOrPanelValue(e){this.h=e.target.h,this.m=e.target.m,this.s=e.target.s,this.amPm=e.target.amPm,this.step=e.target.step,this.clockFormat=e.target.clockFormat,(this.h>0||this.m>0||this.s>0||this.amPm>0)&&(this.classList.remove("noValue"),this.classList.remove("hasCursor"),this.classList.add("hasValue"))}_toggleSubMenuIfPressedOnEnterAnywhereExceptScheduleIcon(e){let t=!1;const o=this.shadowRoot.querySelector("#scheduledIcon"),i=this.shadowRoot.querySelector("#closeIcon"),r=e.composedPath();for(let e=0;e<r.length;e++)if(r[e]===o||r[e]===i){t=!0;break}e.keyCode!==me.ENTER||t||o.click()}_updateTimeInValue(){this.validateTime(),this.val=`${this.h}:${this.m}:${this.s}${"12-hour"===this.clockFormat?":"+this.amPm:""}`}_handleOverlay(){this.active&&!this.responsive&&this.shadowRoot.querySelector(".overlay").open()}_clearTimeInputField(e){e.stopPropagation(),e.currentTarget===this.shadowRoot.querySelector(".close-button")&&(this.h=this.m=this.s=this.amPm=""),this._handleOverlay()}_handleActiveChanged(){if(this.responsive)this.active?this._openMobileDrawer():this._closeMobileDrawer();else{const e=this.shadowRoot.querySelector(".overlay");this.active?e.open():e.close()}}_timepickerMobileTemplate(){return V`<sh-scrollpicker
      @values-changed="${e=>{this._updateValueFromScrollPicker(e.target)}}"
      @visible-changed="${e=>{e.target.visible||(this.active=!1)}}"
    ></sh-scrollpicker>`}_makeMobileTimepickerActive(){this.responsive?this.active=!this.active:this._handleOverlay()}async _openMobileDrawer(){this._showDrawerDOM=!0,await(50,new Promise((e=>{setTimeout((()=>{e()}),50)}))),this._initialiseScrollpicker()}async _initialiseScrollpicker(){const e=this.shadowRoot.querySelector("sh-scrollpicker");let t=[];t="12-hour"===this.clockFormat?(()=>{let e=[];for(let t=1;t<=12;t++)e.push(Xi(parseInt(t,10)).toString());return e})():(()=>{let e=[];for(let t=0;t<24;t++)e.push(Xi(parseInt(t,10)).toString());return e})();let o=(()=>{let e=[];for(let t=0;t<60;t++)e.push(Xi(parseInt(t,10)).toString());return e})(),i=(()=>{let e=[];for(let t=0;t<60;t++)e.push(Xi(parseInt(t,10)).toString());return e})(),r=["AM","PM"];if("12-hour"===this.clockFormat?this.mini?e.items=[t,o,r]:e.items=[t,o,i,r]:this.mini?e.items=[t,o]:e.items=[t,o,i],e.visible=!0,this.h&&this.m&&(this.s||this.mini)&&(this.amPm||"12-hour"!==this.clockFormat)){let t=this._getSelectedValuesArray();e.scrollToValues(t)}else{this.updateWithSystemTime();let t=this._getSelectedValuesArray();e.scrollToValues(t)}}_getSelectedValuesArray(){return this.mini&&"12-hour"===this.clockFormat?[this.h.toString(),this.m.toString(),this.amPm]:this.mini||"24-hour"!==this.clockFormat?this.mini&&"24-hour"===this.clockFormat?[this.h.toString(),this.m.toString()]:this.mini||"12-hour"!==this.clockFormat?"":[this.h.toString(),this.m.toString(),this.s.toString(),this.amPm]:[this.h.toString(),this.m.toString(),this.s.toString()]}_updateValueFromScrollPicker(e){this.mini||(this.s=e.values[2]),this.m=e.values[1],this.h=e.values[0],"12-hour"===this.clockFormat&&(this.amPm=this.mini?e.values[2]:e.values[3])}_closeMobileDrawer(){this._showDrawerDOM=!1}}customElements.define("sh-timepicker",sr);var nr=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-toggle-height=1.25rem] - toggle height
   */
  --sh-toggle-height: 1.25rem;
  /* 
   * @cssprop [--sh-toggle-border-radius=0.625rem] - border radius
   */
  --sh-toggle-border-radius: 0.625rem;
  /* 
   * @cssprop [--sh-toggle-border-width=0.125rem] - border width
   */
  --sh-toggle-border-width: 0.125rem;
  /* 
   * @cssprop [--sh-toggle-circle-dimension=0.875rem] - toggle circle width and height
   */
  --sh-toggle-circle-dimension: 0.875rem;
  /* 
   * @cssprop [--sh-toggle-width=2.5rem] - toggle width
   */
  --sh-toggle-width: 2.5rem;
  /* 
   * @cssprop [--sh-toggle-margin=0.125rem 0.625rem 0.125rem 0.125rem] - toggle margin
   */
  --sh-toggle-margin: 0.125rem 0.625rem 0.125rem 0.125rem;
  /* 
   * @cssprop [--sh-toggle-circle-top=0.0625rem] - toggle circle top
   */
  --sh-toggle-circle-top: 0.0625rem;
  /* 
   * @cssprop [--sh-toggle-circle-left=0.0625rem] - toggle circle left
   */
  --sh-toggle-circle-left: 0.0625rem;
  /* 
   * @cssprop [--sh-toggle-active-left=1.25rem] - toggle circle left
   */
  --sh-toggle-active-left: 1.25rem;
  /* 
   * @cssprop [--sh-toggle-line-height=1.5rem] - toggle line height
   */
  --sh-toggle-line-height: 1.5rem;
  /* 
   * @cssprop [--sh-toggle-label-line-height=1.5rem] - label line height
   */
  --sh-toggle-label-line-height: 1.5rem;
  /* 
   * @cssprop [--sh-toggle-label-padding=0rem] - label padding
   */
  --sh-toggle-label-padding: 0rem;
}

:host {
  display: flex;
  flex-direction: row;
  width: 100%;
  min-height: fit-content;
  min-height: -ms-fit-content;
  min-height: -moz-fit-content;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  font: var(--body-1);
  color: var(--text-primary);
  line-height: var(--sh-toggle-line-height);
  outline: 0;
  cursor: pointer;
  height: fit-content;
  position: relative;
}

.toggle {
  height: var(--sh-toggle-height);
  min-width: var(--sh-toggle-width);
  border-radius: var(--sh-toggle-border-radius);
  margin: var(--sh-toggle-margin);
  border: var(--sh-toggle-border-width) solid rgba(var(--ui-1), var(--opacity-4));
  box-sizing: border-box;
  position: relative;
  transition: var(--transition-time) all ease-in-out, var(--hover-transition-time) background, var(--hover-transition-time) border-color;
  cursor: pointer;
}

:host([label=""]) .toggle,
:host(:not([label])) .toggle {
  margin-right: 0;
}

:host([label=""]),
:host(:not([label])) {
  width: fit-content;
  width: -moz-fit-content;
}

.toggle-label {
  display: block;
  width: calc(100% - var(--sh-toggle-width));
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  line-height: var(--sh-toggle-label-line-height);
  padding: var(--sh-toggle-label-padding);
}

.toggle::before {
  position: absolute;
  left: var(--sh-toggle-circle-left);
  top: var(--sh-toggle-circle-top);
  height: var(--sh-toggle-circle-dimension);
  width: var(--sh-toggle-circle-dimension);
  content: "";
  background: rgba(var(--ui-1), var(--opacity-3));
  border-radius: 50%;
  transition: var(--transition-time) all ease-in-out, var(--hover-transition-time) background;
}

:host([active]) .toggle {
  background-color: rgba(var(--ui-2), var(--opacity-1));
  border-color: transparent;
}

:host([active]) .toggle::before {
  background: white;
  left: var(--sh-toggle-active-left);
}

:host([active][disabled]) .toggle {
  opacity: 0.2;
}

:host([active][neutral]) .toggle {
  background-color: rgba(var(--ui-1), var(--opacity-4));
}

:host([disabled]) {
  cursor: default;
  pointer-events: none;
  color: rgba(var(--ui-1), var(--opacity-5));
}

:host([disabled]:not([active])) .toggle {
  border-color: rgba(var(--ui-1), var(--opacity-7));
}

:host([disabled]:not([active])) .toggle::before {
  background: rgba(var(--ui-1), var(--opacity-5));
}

/* hover */
:host(:not(.touch-device):not([active]):hover) .toggle {
  border-color: rgba(var(--ui-1), var(--opacity-3));
}

:host(:not(.touch-device)[active]:hover) .toggle {
  background: rgba(var(--ui-3), var(--opacity-1));
}

:host(:not(.touch-device)[active][neutral]:hover) .toggle {
  background: rgba(var(--ui-1), var(--opacity-3));
}

:host(:not(.touch-device):not([active]):hover) .toggle::before {
  background: rgba(var(--ui-1), var(--opacity-2));
}

/* focus */
.item-focused {
  outline: var(--focus-outline);
}`;class ar extends(Ce(de(fe(se)))){static get properties(){return{label:{type:String,reflect:!0},disabled:{type:Boolean,reflect:!0}}}static get styles(){return[ae,nr,be()]}render(){return V`
      <div class="toggle focus-item"></div>
      ${this.label?V` <span class="toggle-label">${this.label}</span> `:""}
    `}attributeChangedCallback(e,t,o){super.attributeChangedCallback(e,t,o);const i=null!==o;"active"===e&&this.setAttribute("aria-checked",i)}updated(e){super.updated(e),he(this,e,["label"])}connectedCallback(){super.connectedCallback(),this.hasAttribute("role")||this.setAttribute("role","switch"),ue.isTouchDevice()&&this.classList.add("touch-device")}firstUpdated(){super.firstUpdated()}_spaceKeyAction(){super._spaceKeyAction(),this.handleClick()}}customElements.define("sh-toggle",ar),customElements.define("sh-tool",class extends se{static get properties(){return{label:{type:String,reflect:!0},value:{type:String,reflect:!0},icon:{type:String,reflect:!0},active:{type:Boolean,reflect:!0},icononly:{type:Boolean,reflect:!0},select:{type:Boolean,reflect:!0},palette:{type:Boolean,reflect:!0},toggle:{type:Boolean,reflect:!0},expanded:{type:Boolean,reflect:!0},disabled:{type:Boolean,reflect:!0},condensed:{type:Boolean,reflect:!0},stretch:{type:Boolean,reflect:!0},flat:{type:Boolean,reflect:!0},iconColor:{type:String,reflect:!0,attribute:"icon-color"},popoverPosition:{type:String,reflect:!0,attribute:"popover-position"},popoverPassive:{type:Boolean,reflect:!0,attribute:"popover-passive"}}}static get styles(){return[ae,ie`
        :host {
          padding: 0.1875rem;
          border: 0.0625rem solid transparent;
          background: rgba(var(--ui-1), var(--opacity-7));
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          border-radius: 0.125rem;
          cursor: pointer;
          transition: var(--transition-time) all ease-in-out,
            var(--hover-transition-time) background;
          height: 4.25rem;
          min-height: 4.25rem;
          max-height: 4.25rem;
          flex: 1;
          position: relative;
          outline: 0rem;
        }

        :host([disabled]) {
          cursor: default;
          pointer-events: none;
        }
        :host(:not([active]):not([disabled]):not(.touch-device):hover),
        :host(:not([active]):not([disabled]):not(.touch-device):active) {
          background: rgba(var(--ui-1), var(--opacity-6));
        }
        :host([active]) {
          background: rgba(var(--ui-1), var(--opacity-5));
          border-color: rgba(var(--ui-1), var(--opacity-4));
        }
        :host(:not([stretch])) {
          width: 4.25rem;
          min-width: 4.25rem;
          max-width: 4.25rem;
          flex: 0;
        }
        :host([condensed]) {
          padding: 0.0625rem;
          height: 2.5rem;
          min-height: 2.5rem;
          max-height: 2.5rem;
        }
        :host([condensed]:not([stretch])) {
          min-width: 2.5rem;
          max-width: 2.5rem;
        }
        :host([select][value]) .tool-label,
        :host([palette][value]) .tool-label {
          font-size: 0.75rem;
          line-height: 1rem;
        }
        :host([icononly][icon]) .tool-label,
        :host(:not([label])) .tool-label,
        :host([condensed][icon]) .tool-label {
          display: none;
        }
        :host([flat]) {
          border-style: none;
          background: transparent;
          box-shadow: none;
        }
        :host([active][flat]) {
          background: rgba(var(--ui-1), var(--opacity-6));
          border: none;
        }
        :host(:not([active]):not([disabled]):not(.touch-device):hover[flat]),
        :host(:not([active]):not([disabled]):not(.touch-device):active[flat]) {
          background: rgba(var(--ui-1), var(--opacity-7));
        }
        .tool-label,
        .tool-value {
          height: auto;
          max-height: 2rem;
          text-align: center;
          color: var(--text-primary);
          line-height: 1rem;
          overflow: hidden;
          text-overflow: ellipsis;
          user-select: none;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          display: -webkit-box;
        }
        :host([icon]) .tool-label {
          height: 1.5rem;
          line-height: 0.75rem;
          font-size: 0.75rem;
          margin-top: 0.25rem;
        }
        :host([disabled]) .tool-label,
        :host([disabled]) .tool-value {
          color: var(--text-disabled);
        }

        :host(:not([select][value])) .tool-value {
          display: none;
        }
        .palette {
          box-sizing: border-box;
          height: 1.25rem;
          width: 1.25rem;
          position: absolute;
          top: -0.0625rem;
          right: -0.0625rem;
        }
        .arrow {
          box-sizing: border-box;
          height: 0.375rem;
          width: 0.375rem;
          border-top: solid 0.188rem rgba(var(--ui-1), var(--opacity-4));
          border-right: solid 0.188rem rgba(var(--ui-1), var(--opacity-4));
          border-left: solid 0.188rem transparent;
          border-bottom: solid 0.188rem transparent;
          position: absolute;
          top: 0.1875rem;
          right: 0.1875rem;
        }
        :host([condensed]) .palette {
          box-sizing: border-box;
          height: 0.75rem;
          width: 0.75rem;
          position: absolute;
          top: -0.0625rem;
          right: -0.0625rem;
        }
        :host([condensed]) .arrow {
          box-sizing: border-box;
          height: 0.375rem;
          width: 0.375rem;
          border-top: solid 0.188rem rgba(var(--ui-1), var(--opacity-4));
          border-right: solid 0.188rem rgba(var(--ui-1), var(--opacity-4));
          border-left: solid 0.188rem transparent;
          border-bottom: solid 0.188rem transparent;
          position: absolute;
          top: 0.1875rem;
          right: 0.1875rem;
        }

        :host(:not([palette]):not([select])) sh-popover {
          transition: none;
        }
        :host([disabled]) .arrow {
          opacity: 0.2;
        }
        :host([readonly]) .arrow {
          opacity: 0;
        }

        .submenu {
          background: rgba(var(--ui-8), var(--opacity-1));
          max-height: 12.5rem;
          overflow-y: auto;
          overflow-x: hidden;
          padding: 0.25rem 1rem 0.25rem 0.5rem;
          margin: -0.5rem;
          width: 100%;
        }
        :host([select][icononly][icon]) .tool-value {
          display: none;
        }
      `]}render(){return V`
      ${this.icon||this.icononly&&void 0!==this.icon?V`<sh-icon
            icon="${this.icon}"
            .color="${this.iconColor}"
            class="tool-icon"
            ?disabled="${this.disabled}"
          ></sh-icon>`:V``}
      ${this.label&&!this.icononly?V`<sh-text size="body-1" class="tool-label">${this.label}</sh-text>`:V``}
      ${!this.value&&this.icononly&&this.icon?V``:V`<sh-text size="body-1" class="tool-value">${this.value}</sh-text>`}
      ${this.palette||this.select?V`<div class="arrow"></div>`:V``}
      ${this.palette?V`<div class="palette" @click="${e=>this._expandPalette(e)}"></div>`:V``}
      ${this.palette||this.select?V`
            <sh-popover
              id="menu"
              manual-controlled
              .target=${this}
              position=${this.popoverPosition}
              ?passive="${this.popoverPassive}"
              ?visible="${this.expanded}"
              overlay-target-distance="0"
              suppress-placement-warning
            >
              <div class="submenu"><slot></slot></div>
            </sh-popover>
          `:V``}
    `}constructor(){super(),this.popoverPosition="right-up"}connectedCallback(){super.connectedCallback(),!this.hasAttribute("aria-labelledby")&&this.label&&this.setAttribute("aria-labelledby",this.label),this.addEventListener("click",(function(e){"SH-TOOL"===e.target.tagName&&(this.toggle&&"palette"!==e.composedPath()[0].className&&(this.active=!this.active),this.select&&(this.expanded=!0,this._setActiveState()))})),this._setInitialValuesOnLoad(),this.documentClick=this._closeTool.bind(this),document.body.addEventListener("click",this.documentClick,!0),document.body.addEventListener("touchstart",this.documentClick,!0)}firstUpdated(){ue.isTouchDevice()&&this.classList.add("touch-device"),this.addEventListener("menu-item-active",this._activeChanged),this.shadowRoot.querySelector("#menu")&&this.shadowRoot.querySelector("#menu").addEventListener("clicked",this._activeChanged),this.addEventListener("contextmenu",(function(e){e.preventDefault()})),this.addEventListener("touchstart",(function(){this.palette&&(this._delay=setTimeout((()=>{this._expandPalette()}),500))})),this.addEventListener("touchend",(function(){clearTimeout(this._delay)}))}updated(e){e.has("disabled")&&(this.expanded=!1),he(this,e,["label","value","active","icon","expanded","disabled","flat"])}disconnectedCallback(){document.body.removeEventListener("click",this.documentClick),document.body.removeEventListener("touchstart",this.documentClick),super.disconnectedCallback()}_closeTool(e){e.target===this||e.touches||(this.expanded=!1),e.touches&&-1===e.composedPath().indexOf(this)&&(this.expanded=!1)}_expandPalette(e){e&&e.stopPropagation(),this._setActiveState(),this.expanded=!0}_setActiveState(){for(let e=0;e<this.children.length;e++)if(this.label===this.children[e].label||this.value===this.children[e].label){this.children[e].active=!0;break}}_setInitialValuesOnLoad(){for(let e=0;e<this.childElementCount;e++)this.children[e].active&&this._setMenuItemLabelIcon(this.children[e])}_setMenuItemLabelIcon(e){this.select?e.icon?(this.icon=e.icon,this.label=e.label):this.value=e.label:(this.icon=e.icon?e.icon:e.parentNode.icon,this.palette&&(this.label=e.label))}_activeChanged(e){const t=e.target.parentElement;"clicked"===e.type&&"SH-MENU-ITEM"===e.target.tagName&&(e.stopPropagation(),t.expanded=!1);for(let e=0;e<this.children.length;e++)if(this.label===this.children[e].label){this.children[e].active=!0;break}t._unselectSiblings(e.target.label),t._setMenuItemLabelIcon(e.target)}_unselectSiblings(e){for(let t=0;t<this.children.length;t++)e!==this.children[t].label&&this.children[t].removeAttribute("active")}});var cr=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-user-identifier-margin-left=0.5rem] - info margin left
   */
  --sh-user-identifier-margin-left: 0.5rem;
  /* 
   * @cssprop [--sh-user-identifier-max-width=10rem] - max width of name and info
   */
  --sh-user-identifier-max-width: 10rem;
  /* 
   * @cssprop [--sh-user-identifier-height=1rem] - height of name and info
   */
  --sh-user-identifier-height: 1rem;
  /* 
   * @cssprop [--sh-user-identifier-circle-dimension=2rem] - height of name and info
   */
  --sh-user-identifier-circle-dimension: 2rem;
  /* 
   * @cssprop [--sh-user-identifier-image-circle=2rem] - width and height of image circle
   */
  --sh-user-identifier-image-circle: 2rem;
  /* 
   * @cssprop [--sh-user-identifier-margin=0rem] - width and height of image circle
   */
  --sh-user-identifier-margin: 0rem;
}

:host {
  display: flex;
  flex-direction: row;
  cursor: pointer;
  min-height: fit-content;
  min-height: -ms-fit-content;
  min-height: -moz-fit-content;
  outline: 0;
}

:host([access-context]) {
  width: fit-content;
  width: -ms-fit-content;
  width: -moz-fit-content;
}

.circle {
  width: var(--sh-user-identifier-circle-dimension);
  height: var(--sh-user-identifier-circle-dimension);
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(var(--ui-1), var(--opacity-6));
  border-radius: 50%;
  overflow: hidden;
  font: var(--title-1);
  transition: var(--transition-time) all ease-in-out, var(--hover-transition-time) color;
}

:host([image]) .circle {
  width: var(--sh-user-identifier-image-circle);
  height: var(--sh-user-identifier-image-circle);
}

:host([image]) sh-icon {
  --sh-icon-font-size-m: var(--sh-user-identifier-image-circle);
}

:host([unauthenticated]) .circle,
:host([initials]) .circle,
:host(:not([initials]):not([image]):not([unauthenticated])) .circle {
  width: var(--sh-user-identifier-circle-dimension);
  height: var(--sh-user-identifier-circle-dimension);
  margin: var(--sh-user-identifier-margin);
}

.info-wrapper {
  max-width: var(--sh-user-identifier-max-width);
  flex-direction: column;
  display: flex;
  margin-left: var(--sh-user-identifier-margin-left);
  justify-content: center;
  flex: 1;
  overflow: hidden;
}

:host([access-context]) .info-wrapper {
  max-width: var(--sh-user-identifier-max-width);
}

.name,
.info {
  max-width: var(--sh-user-identifier-max-width);
  line-height: var(--sh-user-identifier-height);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: siemens sans, sans-serif;
  -webkit-font-smoothing: antialiased !important;
  text-rendering: optimizeLegibility !important;
  -moz-osx-font-smoothing: grayscale !important;
  height: var(--sh-user-identifier-height);
  transition: var(--transition-time) all ease-in-out, var(--hover-transition-time) color;
}

:host .name,
:host .info,
:host .circle,
:host sh-icon[icon=user] {
  color: var(--text-secondary);
}

:host(:hover) .name,
:host(:hover) .info,
:host(:hover) .circle,
:host(:hover) sh-icon[icon=user],
:host(:hover) sh-icon[icon=user-avatar] {
  color: var(--text-primary);
}

.name {
  font-weight: bold;
  font: var(--title-1);
  line-height: var(--sh-user-identifier-height);
}

.info {
  font: var(--body-2);
}

/* unauthenticated */
:host([unauthenticated]:not([name])) .circle {
  border-radius: initial;
  background-color: unset;
}

/* condensed access-bar */
:host([access-context][condensed]) {
  margin: -0.25rem 0;
}

/* medium screens */
@media only screen and (max-width: 64.0625rem) {
  :host([access-context]) .info-wrapper {
    display: none;
  }
}
/* focus */
:host(.focus) {
  outline: var(--focus-outline);
}

:host sh-icon[icon=user-avatar] {
  color: var(--text-secondary);
}

:host sh-icon[icon=user-avatar]:hover {
  color: var(--text-primary);
}`;customElements.define("sh-user-identifier",class extends se{static get properties(){return{image:{type:String,reflect:!0},initials:{type:String,reflect:!0},name:{type:String,reflect:!0},info:{type:String,reflect:!0},condensed:{type:Boolean,reflect:!0},unauthenticated:{type:Boolean,reflect:!0},accessContext:{type:Boolean,reflect:!0,attribute:"access-context"}}}static get styles(){return[cr]}render(){return V`
      <div class="circle">
        ${this.unauthenticated?V`
              ${this.name?V` <sh-icon icon="user-avatar"></sh-icon> `:V` <sh-icon icon="user"></sh-icon> `}
            `:V`
              ${this.image?V` <sh-icon icon="${this.image}"></sh-icon> `:V`
                    ${this.initials?this.formatInitials(this.initials):this.name?this.getInitials(this.name):""}
                  `}
            `}
      </div>
      ${this.name?V`
            <div class="info-wrapper">
              <div class="name" @mouseenter="${e=>this._showTooltip(e,this.name)}">
                ${this.name}
              </div>
              ${this.info&&!this.unauthenticated?V`
                    <div class="info" @mouseenter="${e=>this._showTooltip(e,this.info)}">
                      ${this.info}
                    </div>
                  `:""}
            </div>
            <sh-tooltip placement="bottom-left"></sh-tooltip>
          `:""}
    `}attributeChangedCallback(e,t,o){super.attributeChangedCallback(e,t,o),this.dispatchEvent(new Event(`${e}-changed`))}connectedCallback(){super.connectedCallback(),this.hasAttribute("tabindex")||this.setAttribute("tabindex","0")}firstUpdated(){let e;e=this,this.addEventListener("focus",(function(){this.onkeyup=function(t){9===t.keyCode&&e.classList.add("focus")}})),this.addEventListener("blur",(function(){e.classList.remove("focus")}))}_showTooltip(e,t){const o=this.shadowRoot.querySelector("sh-tooltip");Se(e,t,o)}getInitials(e){const t=e.split(/\s/).reduce(((e,t)=>e+t.slice(0,1)),"")||[];return this.formatInitials(t)}formatInitials(e){return((e.length>0?e.charAt(0):"")+(e.length>1?e.charAt(e.length-1):"")).toUpperCase()}});var lr=ie`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-value-indicator-l-value-line-height=4rem] - line height of value for l size
   */
  --sh-value-indicator-l-value-line-height: 4rem;
  /* 
   * @cssprop [--sh-value-indicator-l-label-line-height=1.5rem] - line height of label for l size
   */
  --sh-value-indicator-l-label-line-height: 1.5rem;
  /* 
   * @cssprop [--sh-value-indicator-s-label-line-height=1rem] - line height of label for s size
   */
  --sh-value-indicator-s-label-line-height: 1rem;
  /* 
   * @cssprop [--sh-value-indicator-l-icon-size-m=4rem] - icon size for l size
   */
  --sh-value-indicator-l-icon-size-m: 4rem;
  /* 
   * @cssprop [--sh-value-indicator-s-icon-size-m=2rem] - icon size for s size
   */
  --sh-value-indicator-s-icon-size-m: 2rem;
  /* 
   * @cssprop [--sh-value-indicator-s-value-line-height=2rem] - line height of value for s size
   */
  --sh-value-indicator-s-value-line-height: 2rem;
  /* 
   * @cssprop [--sh-value-indicator-l-unit-line-height=2.5rem] - line height of unit for l size
   */
  --sh-value-indicator-l-unit-line-height: 2.5rem;
  /* 
   * @cssprop [--sh-value-indicator-s-unit-line-height=1.25rem] - line height of unit for s size
   */
  --sh-value-indicator-s-unit-line-height: 1.25rem;
  /* 
   * @cssprop [--sh-value-indicator-l-unit-font-size=1.75rem] - line height of unit for s size
   */
  --sh-value-indicator-l-unit-font-size: 1.75rem;
  /* 
   * @cssprop [--sh-value-indicator-s-unit-font-size=0.875rem] - line height of unit for s size
   */
  --sh-value-indicator-s-unit-font-size: 0.875rem;
  /* 
   * @cssprop [--sh-value-indicator-l-icon-font-size-m=4rem] - font size of icon for l size
   */
  --sh-value-indicator-l-icon-font-size-m: 4rem;
  /* 
   * @cssprop [--sh-value-indicator-s-icon-font-size-m=2rem] - font size of icon for s size
   */
  --sh-value-indicator-s-icon-font-size-m: 2rem;
  /* 
   * @cssprop [--sh-value-indicator-l-value-font-size=3.5rem] - font size of value for l size
   */
  --sh-value-indicator-l-value-font-size: 3.5rem;
  /* 
   * @cssprop [--sh-value-indicator-s-value-font-size=1.75rem] - font size of value for s size
   */
  --sh-value-indicator-s-value-font-size: 1.75rem;
  /* 
   * @cssprop [--sh-value-indicator-l-label-font-size=1rem] - font size of label for l size
   */
  --sh-value-indicator-l-label-font-size: 1rem;
  /* 
   * @cssprop [--sh-value-indicator-s-label-font-size=0.875rem] - font size of label for s size
   */
  --sh-value-indicator-s-label-font-size: 0.875rem;
  /* 
   * @cssprop [--sh-value-indicator-s-status-size-m=1.5rem] - size of status for s size
   */
  --sh-value-indicator-s-status-size-m: 1.5rem;
  /* 
   * @cssprop [--sh-value-indicator-s-status-font-size-m=1.5rem] - font size of status for s size
   */
  --sh-value-indicator-s-status-font-size-m: 1.5rem;
  /* 
   * @cssprop [--sh-value-indicator-s-icon-margin-right=0.25rem] - margin right of icon for s size
   */
  --sh-value-indicator-s-icon-margin-right: 0.25rem;
  /* 
   * @cssprop [--sh-value-indicator-l-icon-margin-right=0.5rem] - margin right of icon for l size
   */
  --sh-value-indicator-l-icon-margin-right: 0.5rem;
  /* 
   * @cssprop [--sh-value-indicator-s-unit-padding-top=0.625rem] - padding top of unit for s size
   */
  --sh-value-indicator-s-unit-padding-top: 0.625rem;
  /* 
   * @cssprop [--sh-value-indicator-l-unit-padding-top=1.23rem] - padding top of unit for l size
   */
  --sh-value-indicator-l-unit-padding-top: 1.23rem;
}

:host {
  display: flex;
  flex-direction: column;
}

:host > * + * {
  margin-top: 0.25rem;
}

.value-wrapper {
  display: flex;
  align-items: center;
}

.status,
.unit {
  margin-left: 0.25rem;
}

:host([size=s]) .unit {
  padding-top: var(--sh-value-indicator-s-unit-padding-top);
}

:host([size=l]) .unit {
  padding-top: var(--sh-value-indicator-l-unit-padding-top);
}

:host([size=s]) .icon {
  margin-right: var(--sh-value-indicator-s-icon-margin-right);
}

:host([size=l]) .icon {
  margin-right: var(--sh-value-indicator-l-icon-margin-right);
}

sh-text {
  width: auto;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* size */
:host([size=l]) {
  align-items: center;
  padding: 0.5rem;
}

:host([size=s]) {
  align-items: left;
}

.value,
.label {
  font: var(--body-1);
}

:host([size=l]) .value {
  line-height: var(--sh-value-indicator-l-value-line-height);
}

:host([size=l]) .label {
  font-size: var(--sh-value-indicator-l-label-font-size);
  line-height: var(--sh-value-indicator-l-label-line-height);
}

:host([size=s]) .label {
  line-height: var(--sh-value-indicator-s-label-line-height);
  font-size: var(--sh-value-indicator-s-label-font-size);
}

:host([size=l]) .value {
  font-size: var(--sh-value-indicator-l-value-font-size);
}

:host([size=l]) .unit {
  line-height: var(--sh-value-indicator-l-unit-line-height);
  font-size: var(--sh-value-indicator-l-unit-font-size);
}

:host([size=s]) .unit {
  line-height: var(--sh-value-indicator-s-unit-line-height);
  font-size: var(--sh-value-indicator-s-unit-font-size);
}

:host([size=l]) .icon {
  --sh-icon-size-m: var(--sh-value-indicator-l-icon-size-m);
  --sh-icon-font-size-m: var(--sh-value-indicator-l-icon-font-size-m);
}

:host([size=s]) .icon {
  --sh-icon-size-m: var(--sh-value-indicator-s-icon-size-m);
  --sh-icon-font-size-m: var(--sh-value-indicator-s-icon-font-size-m);
}

:host([size=s]) .value {
  line-height: var(--sh-value-indicator-s-value-line-height);
  font-size: var(--sh-value-indicator-s-value-font-size);
}

slot {
  display: flex;
}

:host([size=s]) .status {
  --sh-icon-size-m: var(--sh-value-indicator-s-status-size-m);
  --sh-icon-font-size-m: var(--sh-value-indicator-s-status-font-size-m);
}`;customElements.define("sh-value-indicator",class extends se{static get properties(){return{label:{type:String,reflect:!0},value:{type:String,reflect:!0},unit:{type:String,reflect:!0},icon:{type:String,reflect:!0},status:{type:String,reflect:!0},size:{type:String,reflect:!0},iconColor:{type:String,reflect:!0,attribute:"icon-color"}}}static get styles(){return[lr]}render(){return V`
      <div class="value-wrapper">
        ${this.icon?V` <sh-icon icon="${this.icon}" class="icon" .color="${this.iconColor}"></sh-icon> `:""}
        ${this.value?V` <sh-text class="value">${this.value}</sh-text> `:""}
        ${this.unit?V` <sh-text class="unit">${this.unit}</sh-text> `:""}
        ${this.status?V` <sh-icon icon="${this.status}" class="status"></sh-icon> `:""}
      </div>
      ${this.label?V` <sh-text class="label">${this.label}</sh-text> `:""}
      <slot name="footer"></slot>
    `}constructor(){super(),this.size="l"}}),customElements.define("sh-workline-group",class extends se{static get styles(){return[ie`
        :host {
          display: flex;
          border-radius: 5rem;
          background: rgba(var(--ui-1), var(--opacity-5));
          box-sizing: border-box;
          align-items: center;
          box-shadow: inset 0 0 0 0.0625rem rgba(var(--ui-1), var(--opacity-5));
          margin-left: 1rem;
        }
        :host > ::slotted(:last-child[type='information']) {
          margin-right: 1rem;
        }
        :host > ::slotted(*[type='information']),
        :host > ::slotted(*:not(sh-workline-item:first-of-type):not([slot='badge'])) {
          margin-left: 1rem;
        }
        :host > ::slotted(div) {
          margin-left: 0rem !important;
        }

        :host > ::slotted(.sentinel:first-child) {
          transform: translateX(-1rem);
        }
        :host > ::slotted(sh-workline-item:not([active])) {
          background: transparent;
        }
        :host > ::slotted(sh-workline-item[current]) {
          background: rgba(var(--ui-1), var(--opacity-6));
        }
        :host > ::slotted(sh-workline-item.leftfix),
        :host > ::slotted(sh-workline-item.rightfix),
        :host > ::slotted(sh-workline-item.leftfix[current]),
        :host > ::slotted(sh-workline-item.rightfix[current]),
        :host > ::slotted(sh-workline-item.rightfix:not(:first-child):not([slot='badge'])),
        :host > ::slotted(sh-workline-item.leftfix:not(:first-child):not([slot='badge'])),
        :host > ::slotted(sh-workline-item.leftfix[type='information']),
        :host > ::slotted(sh-workline-item.rightfix[type='information']) {
          z-index: 3;
          background-color: rgba(var(--ui-5), var(--opacity-1));
          box-shadow: var(--shadow-overlay);
          /* margin-right: 0; */
        }
        :host > ::slotted(*.rightfix) {
          background-color: rgba(var(--ui-5), var(--opacity-1));
          box-shadow: var(--shadow-overlay);
        }
        :host > ::slotted(*.rightfix[active]),
        :host > ::slotted(*.leftfix[active]),
        :host > ::slotted(sh-workline-item.leftfix[active]),
        :host > ::slotted(sh-workline-item.rightfix[active]),
        :host > ::slotted(sh-workline-item.rightfix:not(:first-child):not([slot='badge'])[active]),
        :host > ::slotted(sh-workline-item.leftfix:not(:first-child):not([slot='badge'])[active]),
        :host > ::slotted(sh-workline-item.leftfix[type='information'][active]),
        :host > ::slotted(sh-workline-item.rightfix[type='information'][active]) {
          box-shadow: var(--shadow-overlay),
            inset 0rem 0rem 0rem 0.0625rem rgba(var(--ui-1), var(--opacity-1));
        }
        :host > ::slotted(*.leftfix) {
          background-color: rgba(var(--ui-5), var(--opacity-1));
          box-shadow: var(--shadow-overlay);
        }
      `]}render(){return V`<slot></slot>`}}),customElements.define("sh-workline-item",class extends se{static get properties(){return{label:{type:String,reflect:!0},info:{type:String,reflect:!0},color:{type:String,reflect:!0},icon:{type:String,reflect:!0},progress:{type:Number,reflect:!0},indeterminate:{type:Boolean,reflect:!0},active:{type:Boolean,reflect:!0},current:{type:Boolean,reflect:!0},disabled:{type:Boolean,reflect:!0},readonly:{type:Boolean,reflect:!0},messageVisible:{type:Boolean,reflect:!0,attribute:"message-visible"},repeat:{type:Boolean,reflect:!0},float:{type:Boolean,reflect:!0},thumbnail:{type:String,reflect:!0},new:{type:Boolean,reflect:!0},type:{type:String,reflect:!0},badge:{type:String,reflect:!0},_emptyMessage:{type:Boolean,value:!0},_emptyinfo:{type:Boolean,reflect:!0,attribute:"empty-info"},_emptyinforight:{type:Boolean,reflect:!0,attribute:"empty-info-right"},iconColor:{type:String,reflect:!0,attribute:"icon-color"}}}static get styles(){return[ie`
        :host {
          z-index: 0;
          position: relative;
          position: -webkit-sticky;
          display: flex;
          /* flex-direction: column; */
          align-items: center;
          justify-content: center;
          height: fit-content;
          width: fit-content;
          background: rgba(var(--ui-1), var(--opacity-5));
          border-radius: 2.5rem;
          text-align: center;
          box-sizing: border-box;
          transition: var(--transition-time) all ease-in-out, left 0s linear, right 0s linear,
            top 0s linear, 'z-index' 0s linear, 'margin' 0s linear, 'background-image' 0s linear,
            'box-shadow' 0s linear;
          cursor: pointer;
        }
        :host([type='information']) {
          background: transparent;
        }
        :host([type='information']) .info-right-wrapper :host([type='information']) .info-wrapper,
        :host([type='information']) .progress-wrapper,
        :host([type='information']) .item-info,
        :host([type='information']) .thumbnail-wrapper,
        :host([type='information']) .badge-wrapper,
        :host([type='information']) .item-label {
          display: none;
        }
        :host([type='information']) .item-wrapper {
          margin: 0rem;
          background: transparent;
          height: 3rem;
          width: 3rem;
        }
        :host([type='information']) #itemIcon {
          line-height: 2.25rem;
          color: rgba(var(--ui-1), var(--opacity-3));
        }
        /* item wrapper */
        .item-wrapper {
          margin: 0.75rem;
          position: relative;
          background: rgba(var(--ui-6), var(--opacity-1));
          display: flex;
          align-items: center;
          justify-content: center;
          height: 3.5rem;
          width: 3.5rem;
          box-sizing: border-box;
          border-radius: 50%;
          transition: var(--transition-time) all ease-in-out;
        }
        /* icon */
        :host(:not([icon])) #itemIcon {
          display: none;
        }
        /* thumbnail */
        :host(:not([thumbnail])) .thumbnail-wrapper {
          display: none;
        }
        .thumbnail-wrapper {
          position: absolute;
          height: 3rem;
          width: 3rem;
          overflow: hidden;
          border-radius: 50%;
          display: block;
        }
        #itemThumbnail {
          position: relative;
          width: 100%;
          height: 100%;
          background-size: contain;
          opacity: var(--opacity-3);
          top: 50%;
          left: 50%;
          image-rendering: -webkit-optimize-contrast;
          -webkit-transform: translateY(-50%) translateX(-50%);
          -ms-transform: translateY(-50%) translateX(-50%);
          transform: translateY(-50%) translateX(-50%);
        }
        :host([active]) #itemThumbnail {
          opacity: var(--opacity-1);
        }
        /* label, info */
        .item-label {
          position: absolute;
          bottom: -2.5rem;
          height: 2rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          left: 0rem;
        }
        .item-label,
        .item-info {
          color: var(--text-secondary);
        }
        :host([active]) .item-label,
        :host([active]) .item-info {
          color: var(--text-primary);
        }
        .item-info,
        #itemIcon {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        :host([icon]) .item-info {
          display: none;
        }
        /* triangles */
        .triangles {
          width: 0;
          height: 4rem;
          position: absolute;
          border-left: 0.375rem solid transparent;
          border-right: 0.375rem solid transparent;
          border-bottom: 0.5rem solid rgba(var(--ui-1), var(--opacity-1));
          border-top: 0.5rem solid rgba(var(--ui-1), var(--opacity-1));
        }
        :host(:not([current])) .triangles {
          display: none;
        }
        /* color ring */
        .color-ring {
          position: absolute;
          top: 0rem;
          left: 0rem;
          border: 0.1875rem dotted transparent;
          border-radius: 50%;
          height: 3.5rem;
          width: 3.5rem;
          box-sizing: border-box;
          transition: var(--transition-time) all ease-in-out;
        }
        :host([progress='100']) .color-ring {
          border-color: transparent !important;
        }
        :host([progress='100'][new]) #progress-ring {
          stroke: rgba(var(--ui-0), var(--opacity-1));
        }
        /* progress ring */
        .progress-wrapper {
          height: 3.5rem;
          width: 3.5rem;
          position: absolute;
          transition: var(--transition-time) all ease-in-out;
          opacity: var(--opacity-3);
        }
        svg {
          stroke-width: 0.25rem;
          fill: transparent;
          cx: 50%;
          cy: 50%;
          transition: var(--transition-time) all ease-in-out;
          transform: rotate(-90deg);
        }
        :host([progress='100']) svg {
          stroke-width: 0.1875rem;
          r: 1.53125rem;
        }
        :host(:not([indeterminate])) .progress-wrapper > svg:nth-child(2) {
          animation: none;
        }
        /* badges */
        :host(:not([empty-info])[active]) .badge-wrapper,
        :host(:not([empty-info-right])[active]) .badge-wrapper {
          top: -0.3rem;
          right: -0.5rem;
        }
        :host(:not([empty-info-right])[current]) .info-right-wrapper,
        :host(:not([empty-info-right])[active]) .info-right-wrapper {
          margin-right: 0.5rem;
        }
        .badge-wrapper-current {
          display: flex;
          position: absolute;
          right: -0.25rem;
          top: -0.25rem;
          transition: var(--transition-time) all ease-in-out;
        }
        .badge-wrapper {
          display: flex;
          position: absolute;
          right: 0.5rem;
          top: 0.5rem;
          transition: var(--transition-time) all ease-in-out;
        }
        .badge-wrapper-current > ::slotted(sh-icon),
        .badge-wrapper > ::slotted(sh-icon) {
          transition: 0s all ease-in-out;
          --sh-icon-size-m: 1.5rem;
          --sh-icon-font-size-m: 1.5rem;
        }
        :host(:not([empty-info-right])[active]) .badge-wrapper > ::slotted(sh-icon),
        :host(:not([empty-info])[active]) .badge-wrapper > ::slotted(sh-icon) {
          line-height: 2rem;
          font-size: 2rem;
          max-height: 2rem;
          min-height: 2rem;
          min-width: 2rem;
        }
        /* info slot */
        .info-right-wrapper,
        .info-wrapper {
          opacity: 0;
          width: auto;
          display: flex;
          max-width: 0rem;
          overflow: hidden;
          align-items: center;
          transition: var(--transition-time) max-width ease-in-out;
        }
        :host([active]) .info-right-wrapper,
        :host([current]) .info-right-wrapper,
        :host([active]) .info-wrapper,
        :host([current]) .info-wrapper {
          opacity: 1;
          max-width: 12.5rem;
        }
        .info-wrapper > ::slotted(*:first-child) {
          margin-left: 1rem;
        }
        .info-wrapper > ::slotted(*:not(:first-child)) {
          margin-left: 0.5rem;
        }
        .info-right-wrapper > ::slotted(*) {
          margin-right: 0.5rem;
        }
        /* active */
        :host([active]) {
          background: rgba(var(--ui-1), var(--opacity-5));
          box-shadow: inset 0rem 0rem 0rem 0.0625rem rgba(var(--ui-1), var(--opacity-1));
        }
        :host([active][type='information']) {
          background: transparent;
          box-shadow: none;
        }
        :host([active]) .item-wrapper {
          background: rgba(var(--ui-7), var(--opacity-1));
        }
        :host([type='information'][active]) .item-wrapper {
          background: transparent;
        }
        :host([active]) .progress-wrapper {
          opacity: var(--opacity-1);
        }
        /* readonly */
        :host([disabled]),
        :host([readonly]) {
          pointer-events: none;
          cursor: default;
        }
        /* disabled */
        :host([disabled]) .item-label,
        :host([disabled]) .item-info {
          color: var(--text-disabled);
        }
        :host([disabled]) .progress-wrapper {
          opacity: var(--opacity-5);
        }
        :host([disabled]) {
          opacity: var(--opacity-4);
        }
        /* indeterminate */
        :host([indeterminate]) #progress-ring {
          stroke-dasharray: 41, 164;
        }
        :host([indeterminate]) .progress-wrapper > svg:nth-child(2) {
          animation: indeterminate 1.5s linear infinite;
        }
        @keyframes indeterminate {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
        /* message */
        sh-popover {
          width: fit-content;
          width: -moz-fit-content;
          height: auto;
          cursor: default;
          text-align: left;
          max-width: 75rem;
          max-height: 50rem;
          transition: 0s transform linear;
        }
        :host(.no-transitions),
        :host(.no-transitions) *,
        :host(.no-transitions) * > ::slotted(*) {
          transition: all 0s linear;
        }
        :host(:not([disabled]):not([readonly]).repeat-animate) {
          animation-name: repeat-animate;
          animation-duration: 0.6s;
          animation-timing-function: cubic-bezier(0, 0.5, 1, 0.5);
        }
        :host(:not([disabled]):not([readonly]).repeat-animate) .item-label {
          animation-name: fade-in;
          animation-duration: inherit;
          animation-timing-function: inherit;
        }
        :host(:not([disabled]):not([readonly]).repeat-animate) .item-wrapper {
          animation-name: shrink-expand-shrink;
          animation-duration: inherit;
          animation-timing-function: inherit;
        }

        @keyframes fade-in {
          0% {
            opacity: 0;
            visibility: hidden;
          }
          80% {
            opacity: 0;
            visibility: hidden;
          }
          100% {
            opacity: 1;
            visibility: visible;
          }
        }
        @keyframes shrink-expand-shrink {
          0% {
            transform: scale(0.7);
          }
          50% {
            transform: scale(1.2);
          }
          100% {
            transform: scale(1);
          }
        }
        @keyframes repeat-animate {
          0% {
            transform: translate(-2rem, 0.9375rem);
            height: calc(0.7 * 5rem);
            width: calc(0.7 * 5rem);
            margin-left: 0rem;
            margin-right: 0rem;
            border-radius: 50%;
          }
          50% {
            transform: translate(0rem, -0.5rem);
            height: calc(1.2 * 5rem);
            width: calc(1.2 * 5rem);
            margin-left: 0.5rem;
            margin-right: -0.5rem;
            border-radius: 50%;
          }
          100% {
            transform: translate(0rem, 0rem);
            height: calc(5rem);
            width: calc(5rem);
            border-radius: 50%;
          }
        }
        .progress-ring-svg {
          transform: rotate(-90deg);
          position: absolute;
          left: 0;
          top: 0;
        }
        :host([type='information']) sh-popover[position='top'] {
          transform: translateY(-1rem);
        }
        :host(.leftfix[float]) {
          position: absolute;
          z-index: 3;
          margin: 0;
          background-color: rgba(var(--ui-5), var(--opacity-1));
        }
        :host(.rightfix[float]) {
          position: absolute;
          z-index: 3;
          margin: 0;
          background-color: rgba(var(--ui-5), var(--opacity-1));
        }
        .item-info {
          line-height: 1.5rem;
        }
      `]}render(){return V`
      <div class="info-wrapper">
        <slot
          name="info"
          id="info"
          @slotchange=${e=>this._updateEmptySlotFlag(e.target,"_emptyinfo")}
        ></slot>
      </div>
      <!-- Adding on-click="stopEvent" as a fix for the bug 22078 in Azure Devops -->
      <!-- Bug link : https://dev.azure.com/shs-ti-ux/SHUI/_workitems/edit/22078 -->
      <sh-popover
        passive
        .visible="${this.messageVisible&&!this._emptyMessage}"
        @visible-changed=${e=>{e.target.visible=this.messageVisible&&!this._emptyMessage}}
        sticky
        @click="${this.stopEvent}"
        .target="${this._getPopoverTarget()}"
      >
        <slot
          name="message"
          id="messageSlot"
          @slotchange=${e=>this._updateEmptySlotFlag(e.target,"_emptyMessage")}
        ></slot>
      </sh-popover>
      <div class="item-wrapper">
        <div class="progress-wrapper">
          <svg style="height:3.5rem; width:3.5rem;" class="progress-ring-svg">
            <circle
              id="dash-ring"
              style="cx:1.75rem; cy:1.75rem; r:1.625rem;"
              stroke-dasharray="0, 5.83"
              stroke="${this.color}"
              fill="transparent"
              stroke-width="0.1875rem"
              stroke-linecap="round"
            />
          </svg>
          <svg style="height:3.5rem; width:3.5rem;" class="progress-ring-svg">
            <circle
              style="cx:1.75rem; cy:1.75rem; r:1.625rem;"
              id="progress-ring"
              stroke="${this.color}"
              fill="transparent"
            />
          </svg>
        </div>
        ${this.info?V` <sh-text size="body-1" class="item-info">${this.info}</sh-text>`:""}
        ${this.thumbnail?V` <div class="thumbnail-wrapper">
              <div id="itemThumbnail" style="background-image:url('${this.thumbnail}');"></div>
            </div>`:""}
        ${this.icon?V` <sh-icon id="itemIcon" .color="${this.iconColor}" icon=${this.icon}></sh-icon>`:""}
        ${this.current?V` <div class="triangles"></div>`:""}
      </div>
      <div class="info-right-wrapper">
        <slot
          name="info-right"
          id="infoRight"
          @slotchange=${e=>this._updateEmptySlotFlag(e.target,"_emptyinforight")}
        ></slot>
      </div>
      <div class="badge-wrapper">
        <slot name="badge" id="badgeSlot"></slot>
      </div>
      ${this.label?V`<sh-text size="body-2" class="item-label">${this.label}</sh-text>`:""}
    `}updated(e){super.updated(e),e.has("progress")&&this._progressChanged(),e.has("repeat")&&this._handleRepeatChange(),e.has("float")&&this._handleFloatChange(),he(this,e,["label","info","color","icon","indeterminate","active","current","disabled","readonly","messageVisible","thumbnail","new","type"])}constructor(){super(),this.new=!1,this.repeat=!1,this.progress="0",this.indeterminate=!1,this.messageVisible=!1,this._emptyMessage=!0,this.active=!1,this.readonly=!1,this.disabled=!1,this._emptyinfo=!0,this._emptyinforight=!0}firstUpdated(e){e.has("repeat")&&this._handleRepeatChange();const t=this.shadowRoot.querySelector(".info-wrapper");t.removeEventListener("transitionend",this._transitionendHandler),t.addEventListener("transitionend",this._transitionendHandler);const o=wi/16,i=this.shadowRoot.querySelector("#dash-ring");i&&i.setAttribute("stroke-dasharray","0, "+5.83*o)}connectedCallback(){super.connectedCallback(),this._transitionendListener=this._transitionendHandler.bind(this)}_transitionendHandler(){le(this,"workline-item-size-changed")}_updateEmptySlotFlag(e,t){this[t]=0===e.assignedNodes({flatten:!0}).length}switchOffTransitions(){this.classList.add("no-transitions")}resetTransitions(){this.classList.remove("no-transitions")}_handleFloatChange(){le(this,"workline-item-float-changed")}_handleRepeatChange(){this.repeat&&(this.classList.add("repeat-animate"),this.classList.add("no-transitions"),this.addEventListener("animationend",(function e(){this.classList.remove("repeat-animate"),this.classList.remove("no-transitions"),this.removeEventListener("animationend",e),le(this,"workline-animation-ended")})))}stopEvent(e){e.stopPropagation()}_progressChanged(){const e=wi/16,t=this.shadowRoot.querySelector("#progress-ring");t&&t.setAttribute("stroke-dasharray",`${1.64*this.progress*e}, ${164*e}`)}_getPopoverTarget(){return this}});const hr=wi,dr=e=>class extends e{static get properties(){return{_floatPositions:{type:Object,reflect:!1}}}calculateFloatPositions(){const e=this.shadowRoot.querySelector("#body").assignedNodes({flatten:!0});if(!e)return;const t=this.querySelectorAll("sh-workline-item[float]");if(0==t.length)return;let o=[];for(let t=0;t<e.length;t++)if("SH-WORKLINE-GROUP"==e[t].tagName){let i=e[t].childNodes;for(let e=0;e<i.length;e++)"SH-WORKLINE-ITEM"==i[e].tagName&&o.push(i[e])}else"SH-WORKLINE-ITEM"==e[t].tagName&&o.push(e[t]);const i=this.shadowRoot.querySelector(".workline-wrapper"),r=this.shadowRoot.querySelector(".total-wrapper");let s=i.getBoundingClientRect().x-r.getBoundingClientRect().x,n=s+i.getBoundingClientRect().width,a=this._getLeftPositionAfterfloat(t,s),c=this._getLeftPositionTostartfloat(o,t),l=this._getRightFixedElement(o,t),h=this._getRightPositionTostartfloat(t,l,s,n),d=[],p=ki(n-t[t.length-1].getBoundingClientRect().width-hr-hr);d=this._rightPositionAfterfloat(t,p),this._floatPositions={leftFloatPosLists:c,rightFloatPosLists:h,leftFloatMarginLists:a,rightFloatMarginLists:d}}fixFloatItems(){let e=this.querySelectorAll("sh-workline-item[float]");if(0==e.length)return;const t=this.shadowRoot.querySelector("#body").assignedNodes({flatten:!0});if(!t)return;let o=this.shadowRoot.querySelector(".workline-wrapper");for(let t=0;t<e.length;t++){const i=e[t],r=this._floatPositions.leftFloatPosLists[t],s=this._floatPositions.rightFloatPosLists[t];ki(o.scrollLeft)>r?(this._leftFloatFix(i,this._floatPositions.leftFloatMarginLists,t),this._updateFloatwrapper("leftfix",this.shadowRoot.querySelector(".left-float"))):ki(o.scrollLeft)<s?(this._rightFloatFix(i,this._floatPositions.rightFloatMarginLists,t),this._updateFloatwrapper("rightfix",this.shadowRoot.querySelector(".right-float"))):this._removeFloatFix(i)}}_rightFloatFix(e,t,o){let i=0;i=this.shadowRoot.querySelector("#body").assignedNodes({flatten:!0}).filter((e=>"SH-WORKLINE-ITEM"==e.tagName)).reverse()[0]===e?e.getBoundingClientRect().width+hr:e.getBoundingClientRect().width,e.previousElementSibling.style.minWidth=ki(i)+"rem",e.previousElementSibling.style.marginLeft="1rem",e.previousElementSibling.style.visibility="visible",e.classList.add("rightfix"),e.style.left=t[o]+"rem"}_leftFloatFix(e,t,o){e.previousElementSibling.style.marginLeft="1rem",e.previousElementSibling.style.minWidth=ki(e.getBoundingClientRect().width)+"rem",e.previousElementSibling.style.visibility="visible",e.classList.add("leftfix"),e.style.left=t[o]+"rem"}_updateFloatwrapper(e,t){let o=0;this.querySelectorAll("sh-workline-item[float]").forEach((t=>{t.classList.contains(e)&&(o+=t.getBoundingClientRect().width+hr)})),t.style.zIndex="2",t.style.minWidth=ki(o)+"rem"}_removeFloatFix(e){e.classList.contains("leftfix")?(e.classList.remove("leftfix"),e.style.left="unset",e.previousElementSibling.style.minWidth="0rem",e.previousElementSibling.style.marginLeft="0rem",e.previousElementSibling.style.visibility="collapse",this._updateFloatwrapper("leftfix",this.shadowRoot.querySelector(".left-float"))):e.classList.contains("rightfix")&&(e.classList.remove("rightfix"),e.style.left="unset",e.previousElementSibling.style.minWidth="0rem",e.previousElementSibling.style.marginLeft="0rem",e.previousElementSibling.style.visibility="collapse",this._updateFloatwrapper("rightfix",this.shadowRoot.querySelector(".right-float")))}_getLeftPositionAfterfloat(e,t){let o=t,i=[];for(let t=0;t<e.length;t++){const r=e[t];0===t?i[0]=ki(o):i[t]=ki(o),o+=r.getBoundingClientRect().width+hr}return i}_getLeftPositionTostartfloat(e,t){let o=0,i=[];for(let r=0;r<t.length;r++){let s=0;const n=t[r],a=Array.from(e).indexOf(n);for(let t=0;t<a;t++)s+=e[t].getBoundingClientRect().width+hr;i[r]=ki(0===r?s:s-o),o+=n.getBoundingClientRect().width+hr}return i}_getRightFixedElement(e,t){let o=[];for(let i=0;i<t.length;i++){let r=0;const s=t[i],n=Array.from(e).indexOf(s);for(let t=0;t<n;t++)r+=e[t].getBoundingClientRect().width+hr;o[i]=ki(0==i?r+s.getBoundingClientRect().width:r+s.getBoundingClientRect().width+hr)}return o}_getRightPositionTostartfloat(e,t,o,i){let r=[],s=0;for(let n=0;n<e.length;n++){let a=e.length-1-n;const c=e[a];a===e.length-1?r[a]=t[a]+ki(o)-ki(i)+ki(hr+1e-4):r[a]=t[a]+ki(o)-ki(i)+ki(s)+ki(hr),s+=c.getBoundingClientRect().width+hr}return r}_rightPositionAfterfloat(e,t){let o=[];for(let i=0;i<e.length;i++){if("SH-WORKLINE-GROUP"==e[i].parentNode.tagName){let o=e[i].parentNode.querySelectorAll("sh-workline-item")[0];e[i]==o&&(t+=ki(hr))}let r=e.length-1-i;if(r!==e.length-1){const t=e[r];o[r]=o[r+1]-ki(hr)-ki(t.getBoundingClientRect().width)}else o[r]=t}return o}};class pr extends(dr(se)){static get properties(){return{label:{type:String,reflect:!0},handleActive:{type:Boolean,reflect:!0,attribute:"handle-active"},noScrollbar:{type:Boolean,reflect:!1,attribute:"no-scrollbar"},_onlyleftslot:{type:Boolean,reflect:!0},_onlyrightslot:{type:Boolean,reflect:!0},_withoutanyslots:{type:Boolean,reflect:!0},_emptyleft:{type:Boolean,reflect:!0},_emptyright:{type:Boolean,reflect:!0}}}static get styles(){return[ae,ie`
        :host {
          display: -webkit-box;
          display: flex;
          -webkit-box-orient: vertical;
          -webkit-box-direction: normal;
          flex-direction: column;
          overflow: visible;
          position: relative;
          --workline-wrapper-after-width: 100%;
          width: 100%;
        }
        .workline-wrapper {
          -webkit-box-orient: horizontal;
          -webkit-box-direction: normal;
          flex-direction: row;
          height: 7.375rem;
          overflow-x: auto;
          overflow-y: hidden;
          padding-bottom: 0.75rem;
          width: 100%;
          padding-top: 0.5rem;
        }
        .workline-label {
          height: 2rem;
          position: relative;
        }
        :host(:not([label])) .workline-label {
          display: none;
        }
        .items-wrapper {
          -webkit-box-flex: 1;
          flex: 1;
          display: -webkit-box;
          display: flex;
          -webkit-box-pack: center;
          justify-content: center;
          height: 5rem;
          min-width: -webkit-fit-content;
          min-width: -moz-fit-content;
          min-width: fit-content;
          background: var(--base-2);
          align-items: center;
        }
        /* slots */
        .items-wrapper > ::slotted(sh-workline-item) {
          margin-left: 1rem;
        }
        .left-wrapper > ::slotted(*) {
          display: -webkit-box;
          margin-left: 0.5rem;
        }
        .right-wrapper > ::slotted(*) {
          margin-right: 1rem;
        }
        .right-wrapper {
          height: 5rem;
          padding-left: 1.5rem;
          display: -webkit-box;
          display: flex;
          -webkit-box-align: center;
          align-items: center;
          width: -webkit-fit-content;
          width: -moz-fit-content;
          width: fit-content;
          border-top-right-radius: 2.5rem;
          border-bottom-right-radius: 2.5rem;
          background: var(--base-2);
          position: relative;
          margin-top: 0.5rem;
        }
        .left-wrapper {
          width: -webkit-fit-content;
          width: -moz-fit-content;
          width: fit-content;
          display: -webkit-box;
          display: flex;
          border-top-left-radius: 2.5rem;
          border-bottom-left-radius: 2.5rem;
          background: var(--base-2);
          position: relative;
          height: 5rem;
          padding-right: 1.5rem;
          -webkit-box-align: center;
          align-items: center;
          margin-top: 0.5rem;
        }
        /* hide slots */
        :host([_emptyright]) .right-wrapper,
        :host([_emptyleft]) .left-wrapper {
          display: none;
        }
        .total-wrapper {
          display: -webkit-box;
          display: flex;
          height: -webkit-fit-content;
          height: -moz-fit-content;
          height: fit-content;
          width: 100%;
          -webkit-box-pack: justify;
          justify-content: space-between;
          position: relative;
        }
        .workline-wrapper.reset-alignment {
          top: -2.25rem;
        }
        :host([_withoutanyslots]) .items-wrapper {
          border-radius: 2.5rem;
        }
        :host([_onlyleftslot]) .items-wrapper {
          border-top-right-radius: 2.5rem;
          border-bottom-right-radius: 2.5rem;
        }
        :host([_onlyrightslot]) .items-wrapper {
          border-top-left-radius: 2.5rem;
          border-bottom-left-radius: 2.5rem;
        }
        .left-float,
        .right-float {
          position: absolute;
          height: 7.625rem;
          z-index: 1;
          margin-top: 0.5rem;
          display: flex;
        }
        .left-float > ::slotted(*),
        .right-float > ::slotted(*) {
          height: 5rem;
        }
        .left-float {
          left: 0rem;
        }
        .left-float > ::slotted(*) {
          margin-left: 1rem;
        }
        .right-float > ::slotted(*) {
          margin-right: 1rem;
        }
        .right-float {
          right: 0rem;
          flex-direction: row-reverse;
        }
        :host([no-scrollbar]) .workline-wrapper::-webkit-scrollbar {
          display: none;
        }
        :host([no-scrollbar]) .workline-wrapper {
          padding-bottom: 0rem;
        }
        .right-float {
          background-image: linear-gradient(
              to bottom,
              transparent,
              transparent 5rem,
              var(--base-1) 5rem,
              var(--base-1) 7.625rem
            ),
            linear-gradient(to right, transparent, transparent 3.5rem, var(--base-2) 3.5rem) !important;
        }
        .left-float {
          background-image: linear-gradient(
              to bottom,
              transparent,
              transparent 5rem,
              var(--base-1) 5rem,
              var(--base-1) 7.625rem
            ),
            linear-gradient(to left, transparent 3.5rem, var(--base-2) 3.5rem) !important;
        }

        .items-wrapper > ::slotted(*.stuck-right),
        .items-wrapper > ::slotted(*.stuck-left) {
          background-color: rgba(var(--ui-5), var(--opacity-1));
          box-shadow: var(--shadow-overlay);
        }
        .items-wrapper > ::slotted(*.stuck-right[active]),
        .items-wrapper > ::slotted(*.stuck-left[active]) {
          box-shadow: var(--shadow-overlay),
            inset 0rem 0rem 0rem 0.0625rem rgba(var(--ui-1), var(--opacity-1));
        }
      `]}render(){return V`
      <sh-text size="super-header" class="workline-label" style="line-height: 2rem"
        >${this.label}</sh-text
      >
      <div class="total-wrapper">
        <div class="left-float"></div>
        <div class="left-wrapper">
          <slot
            name="left"
            id="left"
            @slotchange="${e=>this._handleLeftSlotChanged(e.target)}"
          ></slot>
        </div>
        <div class="workline-wrapper" @scroll="${()=>this._handleScroll()}">
          <div class="items-wrapper">
            <slot id="body" @slotchange="${()=>this._handleBodySlotChanged()}"></slot>
          </div>
        </div>
        <div class="right-wrapper">
          <slot
            name="right"
            id="right"
            @slotchange="${e=>this._handleRightSlotChanged(e.target)}"
          ></slot>
        </div>
        <div class="right-float"></div>
      </div>
    `}constructor(){super(),this.handleActive=!1,this._emptyleft=!0,this._emptyright=!0,this._onlyleftslot=!1,this._onlyrightslot=!1,this._withoutanyslots=!0}firstUpdated(){super.firstUpdated()}connectedCallback(){super.connectedCallback(),this._worklineitemfloatchangedListener=e=>{this._handleFloatChange(e)},this.resizeObserver=new ResizeObserver((()=>{this._handleSizeFloatChange()})),this.resizeObserver.observe(this),this._worklineitemsizechangedListener=this._handleSizeFloatChange.bind(this),this._worklineclickListener=this._handleActive.bind(this),this.addEventListener("click",this._worklineclickListener),this.addEventListener("workline-item-float-changed",this._worklineitemfloatchangedListener)}disconnectedCallback(){this.removeEventListener("workline-item-float-changed",this._worklineitemfloatchangedListener),this.removeEventListener("workline-item-size-changed",this._worklineitemsizechangedListener),this.removeEventListener("click",this._worklineclickListener),this.resizeObserver&&this.resizeObserver.disconnect(),super.disconnectedCallback()}_handleFloatChange(e){const t=this.querySelectorAll("sh-workline-item[float]");e.target.tagName==="sh-workline-item".toUpperCase()&&e.target.hasAttribute("float")?this._addEmptySpace(t):this._removeFloatFix(e.target),this.calculateFloatPositions(),this.fixFloatItems()}_handleSizeFloatChange(){0!=this.querySelectorAll("sh-workline-item[float]").length&&(this.calculateFloatPositions(),this.fixFloatItems())}_addEmptySpace(e){e.forEach((e=>{if(e.previousElementSibling){if("DIV"!==e.previousElementSibling.tagName){let t=document.createElement("div");t.style.minWidth="0rem",e.parentNode.insertBefore(t,e)}}else{let t=document.createElement("div");t.style.minWidth="0rem",e.parentNode.insertBefore(t,e)}}))}_handleLeftSlotChanged(e){e.assignedNodes({flatten:!0}).length>0&&(this._emptyleft=!1,this._onlyleftslot=!0,this._withoutanyslots=!1),this._onlyrightslot&&this._onlyleftslot&&(this._onlyrightslot=!1,this._onlyleftslot=!1),this.leftSlotDelay=setTimeout((()=>{clearTimeout(this.leftSlotDelay),this.shadowRoot.querySelector(".left-float").style.left=this.shadowRoot.querySelector(".left-wrapper").getBoundingClientRect().width/wi+"rem",this.calculateFloatPositions(),this.fixFloatItems()}),400)}_handleRightSlotChanged(e){e.assignedNodes({flatten:!0}).length>0&&(this._emptyright=!1,this._onlyrightslot=!0,this._withoutanyslots=!1),this._onlyrightslot&&this._onlyleftslot&&(this._onlyrightslot=!1,this._onlyleftslot=!1),this.rightSlotDelay=setTimeout((()=>{clearTimeout(this.rightSlotDelay),this.shadowRoot.querySelector(".right-float").style.right=this.shadowRoot.querySelector(".right-wrapper").getBoundingClientRect().width/wi+"rem",this.calculateFloatPositions(),this.fixFloatItems()}),400)}_handleBodySlotChanged(){this._handleSizeFloatChange();const e=this.querySelectorAll("sh-workline-item[float]");this._addEmptySpace(e),this.addEventListener("workline-item-size-changed",this._worklineitemsizechangedListener)}_handleScroll(){0!==this.querySelectorAll("sh-workline-item[float]").length&&this.fixFloatItems()}_handleActive(e){const t=this.shadowRoot.querySelector("#body").assignedNodes({flatten:!0});let o=[];for(let e=0;e<t.length;e++)if("SH-WORKLINE-GROUP"==t[e].tagName){let i=t[e].childNodes;for(let e=0;e<i.length;e++)"SH-WORKLINE-ITEM"==i[e].tagName&&o.push(i[e])}else"SH-WORKLINE-ITEM"==t[e].tagName&&o.push(t[e]);if("SH-WORKLINE-ITEM"===e.target.tagName&&!0===this.handleActive){for(let e=0;e<o.length;e++)o[e].hasAttribute("active")&&(o[e].active=!1);e.target.active=!0}}}customElements.define("sh-workline",pr),customElements.define("sh-wrapper",class extends se{static get properties(){return{direction:{type:String,reflect:!0},spacing:{type:String,reflect:!0}}}static get styles(){return[ie`
        :host {
          display: flex;
          flex-wrap: wrap;
        }

        /* direction */
        :host([direction='row']) {
          flex-direction: row;
        }

        :host([direction='column']) {
          flex-direction: column;
        }

        /* spacing */
        /* none */
        :host([spacing='none']) {
          width: 100%;
        }

        /* xs */
        :host([spacing='xs']) {
          width: calc(100% + 0.125rem);
          margin: -0.0625rem;
        }

        :host([spacing='xs']) ::slotted(*) {
          margin: 0.0625rem;
        }

        /* s */
        :host([spacing='s']) {
          width: calc(100% + 0.25rem);
          margin: -0.125rem;
        }

        :host([spacing='s']) ::slotted(*) {
          margin: 0.125rem;
        }

        /* m */
        :host([spacing='m']) {
          width: calc(100% + 0.5rem);
          margin: -0.25rem;
        }

        :host([spacing='m']) ::slotted(*) {
          margin: 0.25rem;
        }

        /* l */
        :host([spacing='l']) {
          width: calc(100% + 1rem);
          margin: -0.5rem;
        }

        :host([spacing='l']) ::slotted(*) {
          margin: 0.5rem;
        }
      `]}render(){return V` <slot></slot> `}constructor(){super(),this.direction="row",this.spacing="s"}}),console.warn("The bundles at @shui/core/shui/shui(.min).js will be moved soon."),console.warn("Use this instead: @shui/core/bundle."),console.warn("For best performance, consider using specific es imports instead: import '@shui/core/sh-button';"),console.warn("If you KNOW you need all components, use this: '@shui/core';");const ur=new Proxy(pe,{get:function(e,t){return console.warn("Using the global ShuiEnvironment variable has been deprecated. It will be moved soon."),console.warn("Use this instead: import { ShuiEnvironment } from '@shui/core/environment';"),e[t]}})}(),ShuiEnvironment=t.ShuiEnvironmentLegacy}();
//# sourceMappingURL=shui.min.js.map